import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/** Date custom scalar type */
	DateTime: { input: Date | string; output: Date | string };
	/** Decimal custom scalar type */
	Decimal: { input: number; output: number };
	Json: { input: any; output: any };
	/** Long (long integer) variables are stored as signed 32-bit (4-byte) numbers ranging in value from -2,147,483,648 to 2,147,483,647. */
	Long: { input: number; output: number };
};

export type AccountCapabilities = {
	__typename?: 'AccountCapabilities';
	acss_debit_payments?: Maybe<Scalars['String']['output']>;
	card_issuing?: Maybe<Scalars['String']['output']>;
	card_payments?: Maybe<Scalars['String']['output']>;
	legacy_payments?: Maybe<Scalars['String']['output']>;
	transfers?: Maybe<Scalars['String']['output']>;
};

export type ActingUserForEvent = {
	__typename?: 'ActingUserForEvent';
	email: Scalars['String']['output'];
	id: Scalars['String']['output'];
	orgUser?: Maybe<OrgUserForActingUserOnEvent>;
};

export type ActivateContactCustomInput = {
	sendEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Address = {
	__typename?: 'Address';
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Country>;
	line1?: Maybe<Scalars['String']['output']>;
	line2?: Maybe<Scalars['String']['output']>;
	postal_code?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
	city?: InputMaybe<Scalars['String']['input']>;
	country?: InputMaybe<Country>;
	line1?: InputMaybe<Scalars['String']['input']>;
	line2?: InputMaybe<Scalars['String']['input']>;
	postal_code?: InputMaybe<Scalars['String']['input']>;
	state?: InputMaybe<State>;
};

export type ApiVersionResponse = {
	__typename?: 'ApiVersionResponse';
	branch?: Maybe<Scalars['String']['output']>;
	commitId?: Maybe<Scalars['String']['output']>;
	env?: Maybe<Scalars['String']['output']>;
	version?: Maybe<Scalars['String']['output']>;
};

export type AppSubscription = {
	__typename?: 'AppSubscription';
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	organization: Organization;
	status?: Maybe<SubscriptionStatus>;
	stripeSubscriptionID: Scalars['String']['output'];
	subscriptionPlan: Plan;
	updatedAt: Scalars['DateTime']['output'];
};

export type AppSubscriptionOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
	stripeSubscriptionID?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export type AppSubscriptionWhereInput = {
	AND?: InputMaybe<Array<AppSubscriptionWhereInput>>;
	NOT?: InputMaybe<Array<AppSubscriptionWhereInput>>;
	OR?: InputMaybe<Array<AppSubscriptionWhereInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	organization?: InputMaybe<OrganizationWhereInput>;
	status?: InputMaybe<SubscriptionStatus>;
	stripeSubscriptionID?: InputMaybe<Scalars['String']['input']>;
	subscriptionPlan?: InputMaybe<PlanWhereInput>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthPayload = {
	__typename?: 'AuthPayload';
	token: Scalars['String']['output'];
};

export type AuthedUser = {
	__typename?: 'AuthedUser';
	clientUser?: Maybe<ClientUser>;
	eventsLastViewedAt: Scalars['DateTime']['output'];
	groups: Array<TestingGroup>;
	id: Scalars['ID']['output'];
	impersonatingUser?: Maybe<ImpersonatingUser>;
	isVerified?: Maybe<Scalars['Boolean']['output']>;
	orgUser?: Maybe<CalculatedOrgUser>;
	superAdmin?: Maybe<SuperAdminUser>;
	userType: Scalars['String']['output'];
};

export enum BankAccountObject {
	bank_account = 'bank_account',
}

export type BaseUserForGetContractWhere = {
	__typename?: 'BaseUserForGetContractWhere';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	userType: UserType;
};

export type BillingDetails = {
	__typename?: 'BillingDetails';
	address?: Maybe<StripeAddress>;
	email?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
};

export type BlockUserWhereInputType = {
	email: Scalars['String']['input'];
	id: Scalars['ID']['input'];
};

export type BrandingSettings = {
	__typename?: 'BrandingSettings';
	icon?: Maybe<Scalars['String']['output']>;
	logo?: Maybe<Scalars['String']['output']>;
	primary_color?: Maybe<Scalars['String']['output']>;
};

export type BrandingSettingsInput = {
	icon?: InputMaybe<Scalars['String']['input']>;
	logo?: InputMaybe<Scalars['String']['input']>;
	primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type BulkImportContactsInput = {
	csv: Scalars['String']['input'];
};

export type BulkImportResult = {
	__typename?: 'BulkImportResult';
	created: Array<BulkImportResultCreated>;
	notCreated: Array<BulkImportResultNotCreated>;
};

export type BulkImportResultCreated = {
	__typename?: 'BulkImportResultCreated';
	email: Scalars['String']['output'];
	id: Scalars['String']['output'];
};

export type BulkImportResultNotCreated = {
	__typename?: 'BulkImportResultNotCreated';
	email: Scalars['String']['output'];
	reason: Scalars['String']['output'];
};

export type BundleInput = {
	contactID: Scalars['String']['input'];
	contractBundleStatus: BundleStatusEnum;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	invoiceBundleStatus: BundleStatusEnum;
	proposalBundleStatus: BundleStatusEnum;
};

export enum BundleStatusEnum {
	Awaiting = 'Awaiting',
	NotAwaiting = 'NotAwaiting',
	Sent = 'Sent',
}

export type BusinessProfile = {
	__typename?: 'BusinessProfile';
	mcc?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	product_description?: Maybe<Scalars['String']['output']>;
	support_address?: Maybe<Address>;
	support_email?: Maybe<Scalars['String']['output']>;
	support_phone?: Maybe<Scalars['String']['output']>;
	support_url?: Maybe<Scalars['String']['output']>;
	url?: Maybe<Scalars['String']['output']>;
};

export type BusinessProfileInput = {
	mcc?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	product_description?: InputMaybe<Scalars['String']['input']>;
	support_address?: InputMaybe<AddressInput>;
	support_email?: InputMaybe<Scalars['String']['input']>;
	support_phone?: InputMaybe<Scalars['String']['input']>;
	support_url?: InputMaybe<Scalars['String']['input']>;
	url?: InputMaybe<Scalars['String']['input']>;
};

export type CalculateQuickPaymentSubtotal = {
	__typename?: 'CalculateQuickPaymentSubtotal';
	payment: Scalars['Int']['output'];
	subtotal: Scalars['Int']['output'];
};

export type CalculateQuickPaymentSubtotalInput = {
	amount: Scalars['Int']['input'];
	isPayingByCard: Scalars['Boolean']['input'];
};

export type CalculatedOrgUser = {
	__typename?: 'CalculatedOrgUser';
	assignedClients?: Maybe<Array<ClientUser>>;
	contacts?: Maybe<Array<Contact>>;
	contractTemplates?: Maybe<Array<ContractTemplate>>;
	createdAt: Scalars['DateTime']['output'];
	events?: Maybe<Array<Event>>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	invitationID?: Maybe<Scalars['String']['output']>;
	isAdmin: Scalars['Boolean']['output'];
	isOwner: Scalars['Boolean']['output'];
	lastName: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	phone?: Maybe<Scalars['String']['output']>;
	plannerEvents?: Maybe<Array<Event>>;
	role: TeamMemberRole;
	updatedAt: Scalars['DateTime']['output'];
	user: User;
};

export type CalculatedOrgUserAssignedClientsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ClientUserOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ClientUserWhereInput>;
};

export type CalculatedOrgUserContactsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContactWhereInput>;
};

export type CalculatedOrgUserContractTemplatesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContractTemplateWhereInput>;
};

export type CalculatedOrgUserEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type CalculatedOrgUserPlannerEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type CalendarInviteCustomizedEmailInput = {
	intro: Scalars['String']['input'];
};

export type CalendarLinksPayload = {
	__typename?: 'CalendarLinksPayload';
	downloadUrl: Scalars['String']['output'];
	googleUrl: Scalars['String']['output'];
	outlookUrl: Scalars['String']['output'];
	webcalUrl: Scalars['String']['output'];
};

export enum CalendarSourceType {
	CONTACT = 'CONTACT',
	CONTRACT = 'CONTRACT',
	INVOICE = 'INVOICE',
	PROPOSAL = 'PROPOSAL',
}

export type CanAccessByFeatureFlagWhereInput = {
	category: FeatureCategory;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CanvaAuthorizationUrl = {
	__typename?: 'CanvaAuthorizationUrl';
	codeVerifier: Scalars['String']['output'];
	state: Scalars['String']['output'];
	url: Scalars['String']['output'];
};

export type CanvaDesign = {
	__typename?: 'CanvaDesign';
	created_at: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	owner: CanvaDesignOwner;
	page_count: Scalars['Int']['output'];
	thumbnail?: Maybe<CanvaDesignThumbnail>;
	title?: Maybe<Scalars['String']['output']>;
	updated_at: Scalars['String']['output'];
	urls: CanvaDesignUrls;
};

export type CanvaDesignForProposalTemplateInput = {
	asset_id?: InputMaybe<Scalars['String']['input']>;
	canvaDesignId?: InputMaybe<Scalars['String']['input']>;
	designType?: InputMaybe<CanvaDesignTypeInput>;
	proposalTemplateId: Scalars['ID']['input'];
	title?: InputMaybe<Scalars['String']['input']>;
};

export type CanvaDesignInput = {
	asset_id?: InputMaybe<Scalars['String']['input']>;
	canvaDesignId?: InputMaybe<Scalars['String']['input']>;
	designType?: InputMaybe<CanvaDesignTypeInput>;
	proposalId: Scalars['ID']['input'];
	title?: InputMaybe<Scalars['String']['input']>;
};

export type CanvaDesignList = {
	__typename?: 'CanvaDesignList';
	continuation?: Maybe<Scalars['String']['output']>;
	hasMore: Scalars['Boolean']['output'];
	items: Array<CanvaDesign>;
};

export enum CanvaDesignNameInput {
	doc = 'doc',
	presentation = 'presentation',
	whiteboard = 'whiteboard',
}

export type CanvaDesignOwner = {
	__typename?: 'CanvaDesignOwner';
	team_id: Scalars['String']['output'];
	user_id: Scalars['String']['output'];
};

export enum CanvaDesignOwnershipType {
	any = 'any',
	owned = 'owned',
	shared = 'shared',
}

export enum CanvaDesignSortByType {
	modified_ascending = 'modified_ascending',
	modified_descending = 'modified_descending',
	relevance = 'relevance',
	title_ascending = 'title_ascending',
	title_descending = 'title_descending',
}

export type CanvaDesignThumbnail = {
	__typename?: 'CanvaDesignThumbnail';
	height: Scalars['Int']['output'];
	url: Scalars['String']['output'];
	width: Scalars['Int']['output'];
};

export type CanvaDesignTypeInput = {
	height?: InputMaybe<Scalars['Int']['input']>;
	name: CanvaDesignNameInput;
	type: CanvaDesignTypeTypeInput;
	width?: InputMaybe<Scalars['Int']['input']>;
};

export enum CanvaDesignTypeTypeInput {
	custom = 'custom',
	preset = 'preset',
}

export type CanvaDesignUrls = {
	__typename?: 'CanvaDesignUrls';
	editUrl: Scalars['String']['output'];
	viewUrl: Scalars['String']['output'];
};

export type CanvaDesignViewFields = {
	__typename?: 'CanvaDesignViewFields';
	createdAt: Scalars['DateTime']['output'];
	designId: Scalars['String']['output'];
	editUrl: Scalars['String']['output'];
	exportedImageUrl?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	proposal?: Maybe<Proposal>;
	proposalTemplate?: Maybe<ProposalTemplate>;
	thumbnailUrl?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	viewUrl: Scalars['String']['output'];
};

export type CanvaDesignWhereInput = {
	continuation?: InputMaybe<Scalars['String']['input']>;
	ownership?: InputMaybe<CanvaDesignOwnershipType>;
	query?: InputMaybe<Scalars['String']['input']>;
	sort_by?: InputMaybe<CanvaDesignSortByType>;
	take?: InputMaybe<Scalars['Int']['input']>;
};

export type CanvaDesignWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type CanvaOAuthToken = {
	__typename?: 'CanvaOAuthToken';
	accessToken: Scalars['String']['output'];
	createdAt: Scalars['DateTime']['output'];
	expires: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	updatedAt: Scalars['DateTime']['output'];
	user: User;
};

export type CanvaTokenResponseInput = {
	code: Scalars['String']['input'];
	codeVerifier: Scalars['String']['input'];
};

export type CardPaymentsSettings = {
	__typename?: 'CardPaymentsSettings';
	decline_on?: Maybe<DeclineOnSettings>;
	statement_descriptor_prefix?: Maybe<Scalars['String']['output']>;
};

export type CardPaymentsSettingsInput = {
	decline_on?: InputMaybe<DeclineOnSettingsInput>;
	statement_descriptor_prefix?: InputMaybe<Scalars['String']['input']>;
};

export type ClientActionableItem = {
	__typename?: 'ClientActionableItem';
	amountDue?: Maybe<Scalars['Int']['output']>;
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	itemDescription?: Maybe<Scalars['String']['output']>;
	itemId: Scalars['ID']['output'];
	itemType: ClientActionableItemType;
	vendor: ClientActionableItemVendor;
};

export enum ClientActionableItemType {
	contract = 'contract',
	paymentInstallment = 'paymentInstallment',
	proposal = 'proposal',
}

export type ClientActionableItemVendor = {
	__typename?: 'ClientActionableItemVendor';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type ClientDashboardStats = {
	__typename?: 'ClientDashboardStats';
	activeContacts: Scalars['Int']['output'];
	daysToEvent?: Maybe<Scalars['Int']['output']>;
	documentsNeedingAttention: DocumentsNeedingAttention;
	nextDueInstallment?: Maybe<PaymentInstallment>;
	totalBilled: Scalars['Int']['output'];
	totalOutstanding: Scalars['Int']['output'];
	totalPaid: Scalars['Int']['output'];
	upcomingPayments: Scalars['Int']['output'];
};

export type ClientForOfflineHistory = {
	__typename?: 'ClientForOfflineHistory';
	firstNameOne?: Maybe<Scalars['String']['output']>;
	firstNameTwo?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastNameOne?: Maybe<Scalars['String']['output']>;
	lastNameTwo?: Maybe<Scalars['String']['output']>;
};

export type ClientUser = {
	__typename?: 'ClientUser';
	addressLine1: Scalars['String']['output'];
	addressLine2?: Maybe<Scalars['String']['output']>;
	assignedPlanner?: Maybe<OrgUser>;
	city: Scalars['String']['output'];
	country: Country;
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	documents?: Maybe<Array<Document>>;
	events: Array<Event>;
	facebook?: Maybe<Scalars['String']['output']>;
	firstNameOne: Scalars['String']['output'];
	firstNameTwo?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	instagram?: Maybe<Scalars['String']['output']>;
	lastNameOne?: Maybe<Scalars['String']['output']>;
	lastNameTwo?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	pinterest?: Maybe<Scalars['String']['output']>;
	plannerOrgCanPayInvoices: Scalars['Boolean']['output'];
	plannerOrgCanSignContracts: Scalars['Boolean']['output'];
	plannerOrgHasConnectionPermissions: Scalars['Boolean']['output'];
	plannerOrgHasDocumentsPermissions: Scalars['Boolean']['output'];
	postalCode?: Maybe<Scalars['String']['output']>;
	state: State;
	twitter?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	user: User;
	venue?: Maybe<Scalars['String']['output']>;
	weddingDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientUserDocumentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<DocumentWhereInput>;
};

export type ClientUserEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type ClientUserCreateInput = {
	acceptedTerms?: InputMaybe<Scalars['DateTime']['input']>;
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	city: Scalars['String']['input'];
	consentedToAgeAndMarketingEmails?: InputMaybe<Scalars['DateTime']['input']>;
	country: Country;
	description?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	facebook?: InputMaybe<Scalars['String']['input']>;
	firstNameOne: Scalars['String']['input'];
	firstNameTwo?: InputMaybe<Scalars['String']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Float']['input']>;
	imagePositionY?: InputMaybe<Scalars['Float']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	instagram?: InputMaybe<Scalars['String']['input']>;
	invitationID?: InputMaybe<Scalars['String']['input']>;
	lastNameOne?: InputMaybe<Scalars['String']['input']>;
	lastNameTwo?: InputMaybe<Scalars['String']['input']>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	password: Scalars['String']['input'];
	phone?: InputMaybe<Scalars['String']['input']>;
	pinterest?: InputMaybe<Scalars['String']['input']>;
	postalCode: Scalars['String']['input'];
	state: State;
	twitter?: InputMaybe<Scalars['String']['input']>;
	venue?: InputMaybe<Scalars['String']['input']>;
	verificationTokenID?: InputMaybe<Scalars['String']['input']>;
	weddingDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientUserForGetContractWhere = {
	__typename?: 'ClientUserForGetContractWhere';
	assignedPlanner?: Maybe<OrgUserForGetContractWhere>;
	id: Scalars['ID']['output'];
	plannerOrgCanPayInvoices: Scalars['Boolean']['output'];
	plannerOrgCanSignContracts: Scalars['Boolean']['output'];
	user: BaseUserForGetContractWhere;
};

export type ClientUserForSearchFilterInput = {
	OR?: InputMaybe<Array<ClientUserForSearchFilterInput>>;
	firstNameOne?: InputMaybe<Scalars['String']['input']>;
	firstNameOne_contains?: InputMaybe<Scalars['String']['input']>;
	firstNameTwo?: InputMaybe<Scalars['String']['input']>;
	firstNameTwo_contains?: InputMaybe<Scalars['String']['input']>;
	lastNameOne?: InputMaybe<Scalars['String']['input']>;
	lastNameOne_contains?: InputMaybe<Scalars['String']['input']>;
	lastNameTwo?: InputMaybe<Scalars['String']['input']>;
	lastNameTwo_contains?: InputMaybe<Scalars['String']['input']>;
};

export type ClientUserOrderByInput = {
	addressLine1?: InputMaybe<SortOrderType>;
	addressLine2?: InputMaybe<SortOrderType>;
	assignedPlanner?: InputMaybe<OrgUserOrderByInput>;
	city?: InputMaybe<SortOrderType>;
	country?: InputMaybe<SortOrderType>;
	createdAt?: InputMaybe<SortOrderType>;
	description?: InputMaybe<SortOrderType>;
	facebook?: InputMaybe<SortOrderType>;
	firstNameOne?: InputMaybe<SortOrderType>;
	firstNameTwo?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	image?: InputMaybe<SortOrderType>;
	imagePositionX?: InputMaybe<SortOrderType>;
	imagePositionY?: InputMaybe<SortOrderType>;
	imageRotation?: InputMaybe<SortOrderType>;
	imageScale?: InputMaybe<SortOrderType>;
	instagram?: InputMaybe<SortOrderType>;
	lastNameOne?: InputMaybe<SortOrderType>;
	lastNameTwo?: InputMaybe<SortOrderType>;
	originalImage?: InputMaybe<SortOrderType>;
	phone?: InputMaybe<SortOrderType>;
	pinterest?: InputMaybe<SortOrderType>;
	plannerOrgCanPayInvoices?: InputMaybe<SortOrderType>;
	plannerOrgCanSignContracts?: InputMaybe<SortOrderType>;
	plannerOrgHasConnectionPermissions?: InputMaybe<SortOrderType>;
	plannerOrgHasDocumentsPermissions?: InputMaybe<SortOrderType>;
	postalCode?: InputMaybe<SortOrderType>;
	state?: InputMaybe<SortOrderType>;
	twitter?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
	venue?: InputMaybe<SortOrderType>;
	weddingDate?: InputMaybe<SortOrderType>;
};

export type ClientUserUpdateCustomInput = {
	acceptedTerms?: InputMaybe<Scalars['DateTime']['input']>;
	addressLine1?: InputMaybe<Scalars['String']['input']>;
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	city?: InputMaybe<Scalars['String']['input']>;
	consentedToAgeAndMarketingEmails?: InputMaybe<Scalars['DateTime']['input']>;
	country?: InputMaybe<Country>;
	description?: InputMaybe<Scalars['String']['input']>;
	facebook?: InputMaybe<Scalars['String']['input']>;
	firstNameOne?: InputMaybe<Scalars['String']['input']>;
	firstNameTwo?: InputMaybe<Scalars['String']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Int']['input']>;
	imagePositionY?: InputMaybe<Scalars['Int']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	instagram?: InputMaybe<Scalars['String']['input']>;
	lastNameOne?: InputMaybe<Scalars['String']['input']>;
	lastNameTwo?: InputMaybe<Scalars['String']['input']>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	pinterest?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	state?: InputMaybe<State>;
	twitter?: InputMaybe<Scalars['String']['input']>;
	user?: InputMaybe<UserUpdateOneRequiredWithoutClientUserInput>;
	venue?: InputMaybe<Scalars['String']['input']>;
	weddingDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientUserWhereDocumentsWhereInput = {
	every?: InputMaybe<DocumentWhereInput>;
	none?: InputMaybe<DocumentWhereInput>;
	some?: InputMaybe<DocumentWhereInput>;
};

export type ClientUserWhereEventsWhereInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type ClientUserWhereInput = {
	AND?: InputMaybe<Array<ClientUserWhereInput>>;
	NOT?: InputMaybe<Array<ClientUserWhereInput>>;
	OR?: InputMaybe<Array<ClientUserWhereInput>>;
	addressLine1?: InputMaybe<Scalars['String']['input']>;
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	assignedPlanner?: InputMaybe<OrgUserWhereInput>;
	city?: InputMaybe<Scalars['String']['input']>;
	city_contains?: InputMaybe<Scalars['String']['input']>;
	country?: InputMaybe<Country>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	documents?: InputMaybe<ClientUserWhereDocumentsWhereInput>;
	events?: InputMaybe<ClientUserWhereEventsWhereInput>;
	facebook?: InputMaybe<Scalars['String']['input']>;
	facebook_contains?: InputMaybe<Scalars['String']['input']>;
	firstNameOne?: InputMaybe<Scalars['String']['input']>;
	firstNameOne_contains?: InputMaybe<Scalars['String']['input']>;
	firstNameTwo?: InputMaybe<Scalars['String']['input']>;
	firstNameTwo_contains?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Float']['input']>;
	imagePositionY?: InputMaybe<Scalars['Float']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	instagram?: InputMaybe<Scalars['String']['input']>;
	instagram_contains?: InputMaybe<Scalars['String']['input']>;
	is?: InputMaybe<ClientUserWhereInput>;
	lastNameOne?: InputMaybe<Scalars['String']['input']>;
	lastNameOne_contains?: InputMaybe<Scalars['String']['input']>;
	lastNameTwo?: InputMaybe<Scalars['String']['input']>;
	lastNameTwo_contains?: InputMaybe<Scalars['String']['input']>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	pinterest?: InputMaybe<Scalars['String']['input']>;
	pinterest_contains?: InputMaybe<Scalars['String']['input']>;
	plannerOrgCanPayInvoices?: InputMaybe<Scalars['Boolean']['input']>;
	plannerOrgCanSignContracts?: InputMaybe<Scalars['Boolean']['input']>;
	plannerOrgHasConnectionPermissions?: InputMaybe<Scalars['Boolean']['input']>;
	plannerOrgHasDocumentsPermissions?: InputMaybe<Scalars['Boolean']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	state?: InputMaybe<State>;
	twitter?: InputMaybe<Scalars['String']['input']>;
	twitter_contains?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	user?: InputMaybe<UserWhereUniqueInput>;
	venue?: InputMaybe<Scalars['String']['input']>;
	venue_contains?: InputMaybe<Scalars['String']['input']>;
	weddingDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientUserWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type CompanyDetails = {
	__typename?: 'CompanyDetails';
	address?: Maybe<Address>;
	directors_provided?: Maybe<Scalars['Boolean']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	owners_provided?: Maybe<Scalars['Boolean']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	tax_id_provided?: Maybe<Scalars['Boolean']['output']>;
	tax_id_registrar?: Maybe<Scalars['String']['output']>;
	vat_id_provided?: Maybe<Scalars['Boolean']['output']>;
	verification?: Maybe<CompanyVerification>;
};

export type CompanyDetailsInput = {
	address?: InputMaybe<AddressInput>;
	directors_provided?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	owners_provided?: InputMaybe<Scalars['Boolean']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	tax_id?: InputMaybe<Scalars['String']['input']>;
	tax_id_registrar?: InputMaybe<Scalars['String']['input']>;
	vat_id?: InputMaybe<Scalars['String']['input']>;
	verification?: InputMaybe<CompanyVerificationInput>;
};

export type CompanyVerification = {
	__typename?: 'CompanyVerification';
	document?: Maybe<VerificationDocument>;
};

export type CompanyVerificationInput = {
	document?: InputMaybe<VerificationDocumentInput>;
};

export type ConnectToUniqueContactInput = {
	connect?: InputMaybe<ContactWhereUniqueInput>;
};

export type Contact = {
	__typename?: 'Contact';
	_countOfDocuments?: Maybe<Scalars['Int']['output']>;
	assignedMember: OrgUser;
	companyName?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['DateTime']['output'];
	customer: User;
	customerSignatures?: Maybe<Array<CustomerSignature>>;
	documents?: Maybe<Array<Document>>;
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	events?: Maybe<Array<Event>>;
	firstName: Scalars['String']['output'];
	hasCustomerIntent: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	invitation?: Maybe<Invitation>;
	invoices?: Maybe<Array<Invoice>>;
	lastName: Scalars['String']['output'];
	note?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	proposals?: Maybe<Array<Proposal>>;
	source?: Maybe<Scalars['String']['output']>;
	status: ContactStatus;
	updatedAt: Scalars['DateTime']['output'];
	vendor: Organization;
	venue?: Maybe<Scalars['String']['output']>;
};

export type ContactDocumentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<DocumentWhereInput>;
};

export type ContactEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type ContactInvoicesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<InvoiceWhereInput>;
};

export type ContactContractsWhereInput = {
	every?: InputMaybe<ContractWhereInput>;
	none?: InputMaybe<ContractWhereInput>;
	some?: InputMaybe<ContractWhereInput>;
};

export type ContactCreateManyWithoutDocumentsInput = {
	connect?: InputMaybe<Array<ContactWhereUniqueInput>>;
};

export type ContactCreateOneWithoutProposalsInput = {
	connect: ContactWhereUniqueInput;
};

export type ContactCustomerForGetQuickPayment = {
	__typename?: 'ContactCustomerForGetQuickPayment';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	userType: UserType;
};

export type ContactDocumentsWhereInput = {
	every?: InputMaybe<DocumentWhereInput>;
	none?: InputMaybe<DocumentWhereInput>;
	some?: InputMaybe<DocumentWhereInput>;
};

export type ContactEventsWhereInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type ContactForGetContractWhere = {
	__typename?: 'ContactForGetContractWhere';
	assignedMember: OrgUserForGetContractWhere;
	companyName?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['DateTime']['output'];
	customer: CustomerForGetContractWhere;
	customerSignatures?: Maybe<Array<CustomerSignature>>;
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	hasCustomerIntent: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	invoices?: Maybe<Array<InvoiceForGetContractWhere>>;
	lastName: Scalars['String']['output'];
	phone?: Maybe<Scalars['String']['output']>;
	proposals?: Maybe<Array<Proposal>>;
	status: ContactStatus;
	updatedAt: Scalars['DateTime']['output'];
	vendor: OrganizationForGetContractWhere;
};

export type ContactForGetContractWhereInvoicesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<InvoiceWhereInputForGetContractWhere>;
};

export type ContactForGetQuickPayment = {
	__typename?: 'ContactForGetQuickPayment';
	customer: ContactCustomerForGetQuickPayment;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
};

export type ContactForSearchFilter = {
	customer?: InputMaybe<UserWhereInputForGetInvoicesForCustomer>;
};

export type ContactInputForGetInvoicesForCustomer = {
	customer: UserWhereUniqueInput;
	vendor?: InputMaybe<OrganizationWhereInput>;
};

export type ContactInputForProposalsForCustomer = {
	customer: CustomerInputForProposalsForCustomer;
	vendor?: InputMaybe<OrganizationWhereInput>;
};

export type ContactInquiriesWhereInput = {
	every?: InputMaybe<InquiryWhereInput>;
	none?: InputMaybe<InquiryWhereInput>;
	some?: InputMaybe<InquiryWhereInput>;
};

export type ContactInvoicesWhereInput = {
	every?: InputMaybe<InvoiceWhereInput>;
	none?: InputMaybe<InvoiceWhereInput>;
	some?: InputMaybe<InvoiceWhereInput>;
};

export type ContactOrLeadInput = {
	contact?: InputMaybe<ContactWhereUniqueInput>;
	lead?: InputMaybe<InquiryWhereUniqueInput>;
};

export type ContactOrderByInput = {
	_count?: InputMaybe<SortOrderType>;
	_countOfDocuments?: InputMaybe<SortOrderType>;
	assignedMember?: InputMaybe<OrgUserOrderByInput>;
	createdAt?: InputMaybe<SortOrderType>;
	customer?: InputMaybe<CustomerOrderByInput>;
	eventDate?: InputMaybe<SortOrderType>;
	firstName?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	lastName?: InputMaybe<SortOrderType>;
	note?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
	vendor?: InputMaybe<OrganizationOrderByInput>;
};

export type ContactSignature = {
	__typename?: 'ContactSignature';
	contract: ContractForSignature;
	id: Scalars['ID']['output'];
	signer?: Maybe<UserForSignature>;
	signingDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum ContactStatus {
	Active = 'Active',
	Budget = 'Budget',
	Cancelled = 'Cancelled',
	Completed = 'Completed',
	Duplicate = 'Duplicate',
	Inactive = 'Inactive',
	NotAvailable = 'NotAvailable',
	Other = 'Other',
	Pending = 'Pending',
	Spam = 'Spam',
	Unresponsive = 'Unresponsive',
}

export type ContactUpdateManyWithoutDocumentsInput = {
	connect?: InputMaybe<Array<ContactWhereUniqueInput>>;
	disconnect?: InputMaybe<Array<ContactWhereUniqueInput>>;
};

export type ContactWhereForInvoiceSearch = {
	OR?: InputMaybe<Array<ContactInputForGetInvoicesForCustomer>>;
	customer?: InputMaybe<UserWhereInputForGetInvoicesForCustomer>;
	firstName_contains?: InputMaybe<Scalars['String']['input']>;
	invitation?: InputMaybe<InvitationWhereForGetInvoicesForCustomer>;
	lastName_contains?: InputMaybe<Scalars['String']['input']>;
	vendor?: InputMaybe<OrganizationWhereInput>;
};

export type ContactWhereInput = {
	AND?: InputMaybe<Array<ContactWhereInput>>;
	NOT?: InputMaybe<Array<ContactWhereInput>>;
	OR?: InputMaybe<Array<ContactWhereInput>>;
	assignedMember?: InputMaybe<OrgUserWhereInput>;
	companyName?: InputMaybe<Scalars['String']['input']>;
	companyName_contains?: InputMaybe<Scalars['String']['input']>;
	contracts?: InputMaybe<ContactContractsWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	customer?: InputMaybe<UserWhereInput>;
	documents?: InputMaybe<ContactDocumentsWhereInput>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	events?: InputMaybe<ContactEventsWhereInput>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	firstName_contains?: InputMaybe<Scalars['String']['input']>;
	hasCustomerIntent?: InputMaybe<Scalars['Boolean']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	inquiries?: InputMaybe<ContactInquiriesWhereInput>;
	invitation?: InputMaybe<InvitationWhereInput>;
	invoices?: InputMaybe<ContactInvoicesWhereInput>;
	is?: InputMaybe<ContactWhereInput>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	lastName_contains?: InputMaybe<Scalars['String']['input']>;
	note?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	some?: InputMaybe<ContactWhereInput>;
	status?: InputMaybe<ContactStatus>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	vendor?: InputMaybe<OrganizationWhereInput>;
};

export type ContactWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type Contacts = {
	__typename?: 'Contacts';
	_count: Scalars['Int']['output'];
	contacts: Array<Contact>;
};

export type ContractCreateCustomInput = {
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	contractTemplate?: InputMaybe<ContractTemplateUpdateRelationshipInput>;
	dueDate: Scalars['DateTime']['input'];
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	notificationGroupMembers?: InputMaybe<Array<Scalars['String']['input']>>;
	signatures: SignaturesCreateManyInput;
	title: Scalars['String']['input'];
};

export type ContractEventsWhereInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type ContractForGetContractWhere = {
	__typename?: 'ContractForGetContractWhere';
	automatedRemindersEnabled: Scalars['Boolean']['output'];
	contractSourceFile?: Maybe<Scalars['String']['output']>;
	contractTemplate?: Maybe<ContractTemplateForGetContractWhere>;
	createdAt: Scalars['DateTime']['output'];
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	emailNotificationGroup?: Maybe<EmailNotificationGroup>;
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	executedContractUrl?: Maybe<Scalars['String']['output']>;
	filename?: Maybe<Scalars['String']['output']>;
	hsSignatureRequestId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isPastDue?: Maybe<Scalars['Boolean']['output']>;
	sentAt?: Maybe<Scalars['DateTime']['output']>;
	sentByUser?: Maybe<OrgUserForGetContractWhere>;
	signatures: Array<SignatureForGetContractWhere>;
	status: ContractStatus;
	title?: Maybe<Scalars['String']['output']>;
	unsignedContractFileUrl?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	vendor: OrganizationForGetContractWhere;
};

export type ContractForSignature = {
	__typename?: 'ContractForSignature';
	id: Scalars['ID']['output'];
	status: ContractStatus;
};

export enum ContractMetricType {
	AwaitingSignature = 'AwaitingSignature',
	Completed = 'Completed',
	Drafts = 'Drafts',
	Overdue = 'Overdue',
}

export type ContractOrderByInput = {
	contact?: InputMaybe<ContactOrderByInput>;
	contractSourceFile?: InputMaybe<SortOrderType>;
	createdAt?: InputMaybe<SortOrderType>;
	dueDate?: InputMaybe<SortOrderType>;
	eventDate?: InputMaybe<SortOrderType>;
	executedContractUrl?: InputMaybe<SortOrderType>;
	hsSignatureRequestId?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	isPastDue?: InputMaybe<SortOrderType>;
	sentAt?: InputMaybe<SortOrderType>;
	sentByUser?: InputMaybe<OrgUserOrderByInput>;
	status?: InputMaybe<SortOrderType>;
	title?: InputMaybe<SortOrderType>;
	type?: InputMaybe<SortOrderType>;
	unsignedContractFileUrl?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
	vendor?: InputMaybe<OrganizationOrderByInput>;
};

export type ContractResendInput = {
	customizedEmail?: InputMaybe<CustomizedEmailInput>;
};

export type ContractSharableLinkInput = {
	email: Scalars['String']['input'];
	id: Scalars['ID']['input'];
};

export enum ContractStatus {
	Complete = 'Complete',
	Deleted = 'Deleted',
	Draft = 'Draft',
	PartiallySigned = 'PartiallySigned',
	ReadyToBeCountersigned = 'ReadyToBeCountersigned',
	Sent = 'Sent',
	Void = 'Void',
}

export type ContractTemplate = {
	__typename?: 'ContractTemplate';
	contracts?: Maybe<Array<CustomContract>>;
	countOfCustomerSigners?: Maybe<Scalars['Int']['output']>;
	createdAt: Scalars['DateTime']['output'];
	createdBy: OrgUser;
	editUrl?: Maybe<Scalars['String']['output']>;
	events?: Maybe<Array<Event>>;
	helloSignTemplateID?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isLegacy?: Maybe<Scalars['Boolean']['output']>;
	organization: Organization;
	sourceFileUrl?: Maybe<Scalars['String']['output']>;
	status: ContractTemplateStatus;
	title?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	vendorWillSign: Scalars['Boolean']['output'];
};

export type ContractTemplateContractsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ContractOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContractWhereInput>;
};

export type ContractTemplateEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type ContractTemplateContractsWhereInput = {
	every?: InputMaybe<ContractWhereInput>;
	none?: InputMaybe<ContractWhereInput>;
	some?: InputMaybe<ContractWhereInput>;
};

export type ContractTemplateCreateInput = {
	countOfCustomerSigners: Scalars['Int']['input'];
	title: Scalars['String']['input'];
	vendorWillSign: Scalars['Boolean']['input'];
};

export type ContractTemplateCustomUpdateInput = {
	countOfCustomerSigners?: InputMaybe<Scalars['Int']['input']>;
	title?: InputMaybe<Scalars['String']['input']>;
	vendorWillSign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractTemplateEventsWhereInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type ContractTemplateForContractsForVendorInput = {
	id: Scalars['ID']['input'];
};

export type ContractTemplateForGetContractWhere = {
	__typename?: 'ContractTemplateForGetContractWhere';
	countOfCustomerSigners: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	sourceFileUrl?: Maybe<Scalars['String']['output']>;
	title: Scalars['String']['output'];
	vendorWillSign: Scalars['Boolean']['output'];
};

export type ContractTemplateOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	editUrl?: InputMaybe<SortOrderType>;
	helloSignTemplateID?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	sourceFileUrl?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
	title?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export enum ContractTemplateStatus {
	Complete = 'Complete',
	Draft = 'Draft',
}

export type ContractTemplateUpdateRelationshipInput = {
	connect?: InputMaybe<ContractTemplateWhereUniqueInput>;
	disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractTemplateWhereInput = {
	AND?: InputMaybe<Array<ContractTemplateWhereInput>>;
	NOT?: InputMaybe<Array<ContractTemplateWhereInput>>;
	OR?: InputMaybe<Array<ContractTemplateWhereInput>>;
	contracts?: InputMaybe<ContractTemplateContractsWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	createdBy?: InputMaybe<OrgUserWhereInput>;
	editUrl?: InputMaybe<Scalars['String']['input']>;
	events?: InputMaybe<ContractTemplateEventsWhereInput>;
	helloSignTemplateID?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	organization?: InputMaybe<OrganizationWhereInput>;
	sourceFileUrl?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<ContractTemplateStatus>;
	title?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	vendorWillSign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractTemplateWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type ContractTemplates = {
	__typename?: 'ContractTemplates';
	_count: Scalars['Int']['output'];
	contractTemplates: Array<ContractTemplate>;
};

export type ContractUpdateInput = {
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	contractSourceFile?: InputMaybe<Scalars['String']['input']>;
	contractTemplate?: InputMaybe<ContractTemplateUpdateRelationshipInput>;
	dueDate?: InputMaybe<Scalars['DateTime']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	filename?: InputMaybe<Scalars['String']['input']>;
	notificationGroupMembers?: InputMaybe<Array<Scalars['String']['input']>>;
	signatures?: InputMaybe<Array<ContractUpdateSignaturesCreateManyDataInput>>;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type ContractUpdateSignaturesCreateManyDataInput = {
	signerId: Scalars['String']['input'];
	type: SignatureType;
};

export type ContractWhereInput = {
	AND?: InputMaybe<Array<ContractWhereInput>>;
	NOT?: InputMaybe<Array<ContractWhereInput>>;
	OR?: InputMaybe<Array<ContractWhereInput>>;
	contractSourceFile?: InputMaybe<Scalars['String']['input']>;
	contractTemplate?: InputMaybe<ContractTemplateWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	dueDate?: InputMaybe<Scalars['DateTime']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	events?: InputMaybe<ContractEventsWhereInput>;
	executedContractUrl?: InputMaybe<Scalars['String']['input']>;
	hsSignatureRequestId?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
	sentAt?: InputMaybe<Scalars['DateTime']['input']>;
	sentByUser?: InputMaybe<OrgUserWhereInput>;
	signatures?: InputMaybe<SignaturesWhereInput>;
	status?: InputMaybe<ContractStatus>;
	title?: InputMaybe<Scalars['String']['input']>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	unsignedContractFileUrl?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	vendor?: InputMaybe<OrganizationWhereInput>;
};

export type ContractWhereInputWithMfaToken = {
	contract: ContractWhereUniqueInput;
	mfaToken?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type ContractsForCustomer = {
	__typename?: 'ContractsForCustomer';
	_count: Scalars['Int']['output'];
	contracts: Array<CustomContract>;
};

export type ContractsForCustomerInput = {
	AND?: InputMaybe<Array<ContractsForCustomerInput>>;
	NOT?: InputMaybe<Array<ContractsForCustomerInput>>;
	OR?: InputMaybe<Array<ContractsForCustomerInput>>;
	archivedByVendor?: InputMaybe<Scalars['Boolean']['input']>;
	isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
	sentByUser?: InputMaybe<SentByUserInputForContracts>;
	signatures?: InputMaybe<SignaturesWhereInput>;
	status?: InputMaybe<ContractStatus>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<SortOrderInequalityInput>;
	vendor?: InputMaybe<VendorInputForGetContractsForCustomer>;
};

export type ContractsForVendor = {
	__typename?: 'ContractsForVendor';
	_count: Scalars['Int']['output'];
	contracts: Array<CustomContract>;
};

export type ContractsForVendorInput = {
	AND?: InputMaybe<Array<ContractsForVendorInput>>;
	NOT?: InputMaybe<Array<ContractsForVendorInput>>;
	OR?: InputMaybe<Array<ContractsForVendorInput>>;
	archivedByVendor?: InputMaybe<Scalars['Boolean']['input']>;
	contractTemplate?: InputMaybe<ContractTemplateForContractsForVendorInput>;
	isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
	metricDateRange?: InputMaybe<DashboardWhereInput>;
	metricType?: InputMaybe<ContractMetricType>;
	sentByUser?: InputMaybe<SentByUserInputForContracts>;
	signatures?: InputMaybe<SignaturesWhereInput>;
	status?: InputMaybe<ContractStatus>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<SortOrderInequalityInput>;
	vendor?: InputMaybe<VendorInputForGetContractsForVendor>;
};

export type ContractsSummary = {
	__typename?: 'ContractsSummary';
	totalContractsAwaitingSignature: Scalars['String']['output'];
	totalContractsDrafts: Scalars['String']['output'];
	totalContractsOverdue: Scalars['String']['output'];
	totalContractsSigned: Scalars['String']['output'];
};

export enum Country {
	AD = 'AD',
	AE = 'AE',
	AF = 'AF',
	AG = 'AG',
	AI = 'AI',
	AL = 'AL',
	AM = 'AM',
	AO = 'AO',
	AQ = 'AQ',
	AR = 'AR',
	AS = 'AS',
	AT = 'AT',
	AU = 'AU',
	AW = 'AW',
	AZ = 'AZ',
	BA = 'BA',
	BB = 'BB',
	BD = 'BD',
	BE = 'BE',
	BF = 'BF',
	BG = 'BG',
	BH = 'BH',
	BI = 'BI',
	BJ = 'BJ',
	BM = 'BM',
	BN = 'BN',
	BO = 'BO',
	BR = 'BR',
	BS = 'BS',
	BT = 'BT',
	BV = 'BV',
	BW = 'BW',
	BY = 'BY',
	BZ = 'BZ',
	CA = 'CA',
	CC = 'CC',
	CD = 'CD',
	CF = 'CF',
	CG = 'CG',
	CH = 'CH',
	CI = 'CI',
	CK = 'CK',
	CL = 'CL',
	CM = 'CM',
	CN = 'CN',
	CO = 'CO',
	CR = 'CR',
	CU = 'CU',
	CV = 'CV',
	CX = 'CX',
	CY = 'CY',
	CZ = 'CZ',
	DE = 'DE',
	DJ = 'DJ',
	DK = 'DK',
	DM = 'DM',
	DO = 'DO',
	DZ = 'DZ',
	EC = 'EC',
	EE = 'EE',
	EG = 'EG',
	EH = 'EH',
	ER = 'ER',
	ES = 'ES',
	ET = 'ET',
	FI = 'FI',
	FJ = 'FJ',
	FK = 'FK',
	FM = 'FM',
	FO = 'FO',
	FR = 'FR',
	GA = 'GA',
	GB = 'GB',
	GD = 'GD',
	GE = 'GE',
	GF = 'GF',
	GH = 'GH',
	GI = 'GI',
	GL = 'GL',
	GM = 'GM',
	GN = 'GN',
	GP = 'GP',
	GQ = 'GQ',
	GR = 'GR',
	GS = 'GS',
	GT = 'GT',
	GU = 'GU',
	GW = 'GW',
	GY = 'GY',
	HK = 'HK',
	HM = 'HM',
	HN = 'HN',
	HR = 'HR',
	HT = 'HT',
	HU = 'HU',
	ID = 'ID',
	IE = 'IE',
	IL = 'IL',
	IN = 'IN',
	IO = 'IO',
	IQ = 'IQ',
	IR = 'IR',
	IS = 'IS',
	IT = 'IT',
	JM = 'JM',
	JO = 'JO',
	JP = 'JP',
	KE = 'KE',
	KG = 'KG',
	KH = 'KH',
	KI = 'KI',
	KM = 'KM',
	KN = 'KN',
	KP = 'KP',
	KR = 'KR',
	KW = 'KW',
	KY = 'KY',
	KZ = 'KZ',
	LA = 'LA',
	LB = 'LB',
	LC = 'LC',
	LI = 'LI',
	LK = 'LK',
	LR = 'LR',
	LS = 'LS',
	LT = 'LT',
	LU = 'LU',
	LV = 'LV',
	LY = 'LY',
	MA = 'MA',
	MC = 'MC',
	MD = 'MD',
	MG = 'MG',
	MH = 'MH',
	MK = 'MK',
	ML = 'ML',
	MM = 'MM',
	MN = 'MN',
	MO = 'MO',
	MP = 'MP',
	MQ = 'MQ',
	MR = 'MR',
	MS = 'MS',
	MT = 'MT',
	MU = 'MU',
	MV = 'MV',
	MW = 'MW',
	MX = 'MX',
	MY = 'MY',
	MZ = 'MZ',
	NA = 'NA',
	NC = 'NC',
	NE = 'NE',
	NF = 'NF',
	NG = 'NG',
	NI = 'NI',
	NL = 'NL',
	NO = 'NO',
	NP = 'NP',
	NR = 'NR',
	NU = 'NU',
	NZ = 'NZ',
	OM = 'OM',
	PA = 'PA',
	PE = 'PE',
	PF = 'PF',
	PG = 'PG',
	PH = 'PH',
	PK = 'PK',
	PL = 'PL',
	PM = 'PM',
	PN = 'PN',
	PR = 'PR',
	PS = 'PS',
	PT = 'PT',
	PW = 'PW',
	PY = 'PY',
	QA = 'QA',
	RE = 'RE',
	RO = 'RO',
	RU = 'RU',
	RW = 'RW',
	SA = 'SA',
	SB = 'SB',
	SC = 'SC',
	SD = 'SD',
	SE = 'SE',
	SG = 'SG',
	SH = 'SH',
	SI = 'SI',
	SJ = 'SJ',
	SK = 'SK',
	SL = 'SL',
	SM = 'SM',
	SN = 'SN',
	SO = 'SO',
	SR = 'SR',
	ST = 'ST',
	SV = 'SV',
	SY = 'SY',
	SZ = 'SZ',
	TC = 'TC',
	TD = 'TD',
	TF = 'TF',
	TG = 'TG',
	TH = 'TH',
	TJ = 'TJ',
	TK = 'TK',
	TL = 'TL',
	TM = 'TM',
	TN = 'TN',
	TO = 'TO',
	TR = 'TR',
	TT = 'TT',
	TV = 'TV',
	TW = 'TW',
	TZ = 'TZ',
	UA = 'UA',
	UG = 'UG',
	UM = 'UM',
	US = 'US',
	UY = 'UY',
	UZ = 'UZ',
	VA = 'VA',
	VC = 'VC',
	VE = 'VE',
	VG = 'VG',
	VI = 'VI',
	VN = 'VN',
	VU = 'VU',
	WF = 'WF',
	WS = 'WS',
	YE = 'YE',
	YT = 'YT',
	ZA = 'ZA',
	ZM = 'ZM',
	ZW = 'ZW',
}

export type Coupon = {
	__typename?: 'Coupon';
	active: Scalars['Boolean']['output'];
	businessName?: Maybe<Scalars['String']['output']>;
	couponInstances?: Maybe<Array<CouponInstance>>;
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	onboardedOrgs?: Maybe<Array<Organization>>;
	onboardingLink?: Maybe<Scalars['String']['output']>;
	organizations?: Maybe<Array<Organization>>;
	ownerOrganizationId?: Maybe<Scalars['String']['output']>;
	stripeID: Scalars['String']['output'];
};

export type CouponCouponInstancesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<CouponInstanceWhereInput>;
};

export type CouponOrganizationsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<OrganizationWhereInput>;
};

export type CouponByNameInput = {
	name: Scalars['String']['input'];
	organizationId: Scalars['ID']['input'];
	planId?: InputMaybe<Scalars['ID']['input']>;
	timeZone: Scalars['String']['input'];
};

export type CouponCreateReducedInput = {
	active?: InputMaybe<Scalars['Boolean']['input']>;
	businessName?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
	name: Scalars['String']['input'];
	stripeID: Scalars['String']['input'];
};

export type CouponInstance = {
	__typename?: 'CouponInstance';
	coupon: Coupon;
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	live: Scalars['Boolean']['output'];
	organization: Organization;
};

export type CouponInstanceWhereInput = {
	AND?: InputMaybe<Array<CouponInstanceWhereInput>>;
	NOT?: InputMaybe<Array<CouponInstanceWhereInput>>;
	OR?: InputMaybe<Array<CouponInstanceWhereInput>>;
	coupon?: InputMaybe<CouponWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	live?: InputMaybe<Scalars['Boolean']['input']>;
	organization?: InputMaybe<OrganizationWhereInput>;
};

export type CouponUpdateInput = {
	active?: InputMaybe<Scalars['Boolean']['input']>;
	businessName?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
};

export type CouponWhereCouponInstancesInput = {
	every?: InputMaybe<CouponInstanceWhereInput>;
	none?: InputMaybe<CouponInstanceWhereInput>;
	some?: InputMaybe<CouponInstanceWhereInput>;
};

export type CouponWhereInput = {
	AND?: InputMaybe<Array<CouponWhereInput>>;
	NOT?: InputMaybe<Array<CouponWhereInput>>;
	OR?: InputMaybe<Array<CouponWhereInput>>;
	active?: InputMaybe<Scalars['Boolean']['input']>;
	businessName?: InputMaybe<Scalars['String']['input']>;
	couponInstances?: InputMaybe<CouponWhereCouponInstancesInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizations?: InputMaybe<CouponWhereOrganizationsInput>;
	stripeID?: InputMaybe<Scalars['String']['input']>;
};

export type CouponWhereOrganizationsInput = {
	every?: InputMaybe<OrganizationWhereInput>;
	none?: InputMaybe<OrganizationWhereInput>;
	some?: InputMaybe<OrganizationWhereInput>;
};

export type CouponWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type CreateContactDataInput = {
	companyName?: InputMaybe<Scalars['String']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	phone?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
	venue?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractSigningUrlInput = {
	contract: EmbeddedSigningContract;
	mfaToken?: InputMaybe<Scalars['Int']['input']>;
	signingAs: Scalars['ID']['input'];
};

export type CreateContractTemplateMarkupUrlInput = {
	sourceFileUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIntentForInvoicePaymentInput = {
	gratuityAmount: Scalars['Int']['input'];
	paymentAttemptId: Scalars['String']['input'];
	paymentMethodType: PaymentMethodType;
	sessionPaymentInstallmentId: Scalars['String']['input'];
	token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIntentForQuickPaymentInput = {
	invoiceId: Scalars['String']['input'];
	paymentAttemptId: Scalars['String']['input'];
	paymentMethodType: PaymentMethodType;
	quickPayment: QuickPaymentForPaymentInput;
};

export type CreateOrUpdateContactForCustomerDataInput = {
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
};

export type CreateOrUpdateContactForCustomerWhereInput = {
	email: Scalars['String']['input'];
	vendorId: Scalars['ID']['input'];
};

export type CreateSecretsForInvoicePaymentInput = {
	sessionPaymentInstallmentId: Scalars['String']['input'];
	token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSecretsForQuickPaymentInput = {
	existingInvoiceId?: InputMaybe<Scalars['String']['input']>;
	quickPayment: QuickPaymentForPaymentInput;
};

export type CreateSetupIntentForPaymentMethodInput = {
	forOrganization: Scalars['Boolean']['input'];
	stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<PaymentMethodType>;
};

export type CreateSetupIntentForPaymentMethodResponse = {
	__typename?: 'CreateSetupIntentForPaymentMethodResponse';
	clientSecret: Scalars['String']['output'];
};

export type CreateVerificationTokenInput = {
	email: Scalars['String']['input'];
	promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreatedAtGreaterThan = {
	gt: Scalars['DateTime']['input'];
};

export type CustomContact = {
	__typename?: 'CustomContact';
	guestUser: JustUserWithEmail;
	id: Scalars['ID']['output'];
};

export type CustomContactInput = {
	AND?: InputMaybe<Array<CustomContactInput>>;
	NOT?: InputMaybe<Array<CustomContactInput>>;
	OR?: InputMaybe<Array<CustomContactInput>>;
	assignedMember?: InputMaybe<OrgUserWhereInput>;
	companyName_contains?: InputMaybe<Scalars['String']['input']>;
	customer?: InputMaybe<UserWhereInput>;
	firstName_contains?: InputMaybe<Scalars['String']['input']>;
	invitation?: InputMaybe<InvitationWhereInput>;
	invoices?: InputMaybe<InvoiceWhereInput>;
	lastName_contains?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<ContactStatus>;
	vendor?: InputMaybe<OrganizationWhereInput>;
};

export type CustomContactUpdateInput = {
	companyName?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	note?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
	venue?: InputMaybe<Scalars['String']['input']>;
};

export type CustomContract = {
	__typename?: 'CustomContract';
	automatedRemindersEnabled: Scalars['Boolean']['output'];
	contractSourceFile?: Maybe<Scalars['String']['output']>;
	contractTemplate?: Maybe<ContractTemplate>;
	createdAt: Scalars['DateTime']['output'];
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	emailNotificationGroup?: Maybe<EmailNotificationGroup>;
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	executedContractUrl?: Maybe<Scalars['String']['output']>;
	guestToken?: Maybe<Scalars['String']['output']>;
	hsSignatureRequestId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isPastDue?: Maybe<Scalars['Boolean']['output']>;
	sentAt?: Maybe<Scalars['DateTime']['output']>;
	sentByUser?: Maybe<OrgUser>;
	signatures: Array<Signature>;
	status?: Maybe<ContractStatus>;
	title?: Maybe<Scalars['String']['output']>;
	unsignedContractFileUrl?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	vendor: Organization;
};

export type CustomContractTemplateWhereWithoutOrganizationInput = {
	AND?: InputMaybe<Array<CustomContractTemplateWhereWithoutOrganizationInput>>;
	NOT?: InputMaybe<Array<CustomContractTemplateWhereWithoutOrganizationInput>>;
	OR?: InputMaybe<Array<CustomContractTemplateWhereWithoutOrganizationInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	createdBy?: InputMaybe<OrgUserWhereInput>;
	helloSignTemplateID?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
	sourceFileUrl?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<ContractTemplateStatus>;
	title?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomCustomerSignatureForContact = {
	__typename?: 'CustomCustomerSignatureForContact';
	id: Scalars['ID']['output'];
	signature: ContactSignature;
};

export type CustomDocumentWhereInput = {
	AND?: InputMaybe<Array<CustomDocumentWhereInput>>;
	NOT?: InputMaybe<Array<CustomDocumentWhereInput>>;
	OR?: InputMaybe<Array<CustomDocumentWhereInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	customer?: InputMaybe<UserWhereInput>;
	fileSize?: InputMaybe<Scalars['Int']['input']>;
	fileSource?: InputMaybe<FileSourceType>;
	fileSourceID?: InputMaybe<Scalars['String']['input']>;
	fileType?: InputMaybe<FileType>;
	fileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	name_contains?: InputMaybe<Scalars['String']['input']>;
	orgUser?: InputMaybe<OrgUserWhereInput>;
	organization?: InputMaybe<OrganizationWhereInput>;
	ownerType?: InputMaybe<DocumentOwnerType>;
	parentFolder?: InputMaybe<FolderWhereUniqueInput>;
	sharedWithContacts?: InputMaybe<ContactWhereInput>;
	sharedWithCustomer?: InputMaybe<Scalars['Boolean']['input']>;
	status?: InputMaybe<DocumentStatus>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomFolder = {
	__typename?: 'CustomFolder';
	_childFoldersCount: Scalars['Int']['output'];
	_count: FolderCount;
	_documentsCount: Scalars['Int']['output'];
	childFolders?: Maybe<Array<Maybe<CustomFolder>>>;
	createdAt: Scalars['DateTime']['output'];
	documents?: Maybe<Array<Maybe<Document>>>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['Json']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	parentFolder?: Maybe<CustomFolder>;
	status?: Maybe<FolderStatus>;
	updatedAt: Scalars['DateTime']['output'];
};

export type CustomResource = {
	__typename?: 'CustomResource';
	category: ResourceCategory;
	createdAt: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	downloadUrl?: Maybe<Scalars['String']['output']>;
	fileType: FileType;
	id: Scalars['ID']['output'];
	previewDownloadUrl?: Maybe<Scalars['String']['output']>;
	previewUploadUrl?: Maybe<Scalars['String']['output']>;
	sponsor: CustomSponsor;
	status: ResourceStatus;
	updatedAt: Scalars['DateTime']['output'];
	uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomResources = {
	__typename?: 'CustomResources';
	_count: Scalars['Int']['output'];
	resources: Array<CustomResource>;
};

export type CustomShareDocumentInput = {
	sharedWithContacts?: InputMaybe<ContactUpdateManyWithoutDocumentsInput>;
	sharedWithCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomSponsor = {
	__typename?: 'CustomSponsor';
	createdAt: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	logo?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	resources?: Maybe<Array<Resource>>;
	sponsorLink: Scalars['String']['output'];
	updatedAt: Scalars['DateTime']['output'];
	uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomSponsorResourcesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ResourceWhereInput>;
};

export type CustomerBankAccountVerificationInput = {
	amounts: Array<Scalars['Int']['input']>;
	bankAccountID: Scalars['String']['input'];
};

export type CustomerForGetContractWhere = {
	__typename?: 'CustomerForGetContractWhere';
	clientUser?: Maybe<ClientUserForGetContractWhere>;
	email: Scalars['String']['output'];
	guestUser?: Maybe<GuestUserForGetContractWhere>;
	id: Scalars['ID']['output'];
	stripeCustomerId?: Maybe<Scalars['String']['output']>;
	userType: UserType;
};

export type CustomerInputForProposalsForCustomer = {
	id: Scalars['ID']['input'];
};

export type CustomerOrderByInput = {
	clientUser?: InputMaybe<ClientUserOrderByInput>;
};

export type CustomerSignature = {
	__typename?: 'CustomerSignature';
	approved: Scalars['Boolean']['output'];
	archived: Scalars['Boolean']['output'];
	contact: CustomerSignatureContact;
	id: Scalars['ID']['output'];
	signature: Signature;
};

export type CustomerSignatureContact = {
	__typename?: 'CustomerSignatureContact';
	assignedMember: CustomerSignatureOrgUser;
	companyName?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['DateTime']['output'];
	customer: CustomerSignatureContactCustomer;
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	hasCustomerIntent: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	note?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	status: ContactStatus;
	updatedAt: Scalars['DateTime']['output'];
	vendor: CustomerSignatureContactOrganization;
	venue?: Maybe<Scalars['String']['output']>;
};

export type CustomerSignatureContactCustomer = {
	__typename?: 'CustomerSignatureContactCustomer';
	clientUser?: Maybe<CustomerSignatureContactCustomerClientUser>;
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	userType: UserType;
};

export type CustomerSignatureContactCustomerClientUser = {
	__typename?: 'CustomerSignatureContactCustomerClientUser';
	assignedPlanner?: Maybe<CustomerSignatureContactCustomerClientUserAssignedPlanner>;
	id: Scalars['ID']['output'];
	plannerOrgCanSignContracts: Scalars['Boolean']['output'];
};

export type CustomerSignatureContactCustomerClientUserAssignedPlanner = {
	__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
	id: Scalars['ID']['output'];
	organization: CustomerSignatureContactOrganization;
};

export type CustomerSignatureContactCustomerWhereInput = {
	email_contains?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerSignatureContactOrganization = {
	__typename?: 'CustomerSignatureContactOrganization';
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	imagePositionX?: Maybe<Scalars['Float']['output']>;
	imagePositionY?: Maybe<Scalars['Float']['output']>;
	imageRotation?: Maybe<Scalars['Int']['output']>;
	imageScale?: Maybe<Scalars['Int']['output']>;
	name: Scalars['String']['output'];
	updatedAt: Scalars['DateTime']['output'];
	users?: Maybe<Array<CustomerSignatureContactOrganizationUsers>>;
};

export type CustomerSignatureContactOrganizationUsers = {
	__typename?: 'CustomerSignatureContactOrganizationUsers';
	id: Scalars['ID']['output'];
	organization: CustomerSignatureContactOrganization;
	role: TeamMemberRole;
	user: CustomerSignatureOrgUserUser;
};

export type CustomerSignatureContactVendorWhereInput = {
	id: Scalars['ID']['input'];
};

export type CustomerSignatureContactWhereInput = {
	AND?: InputMaybe<Array<CustomerSignatureContactWhereInput>>;
	NOT?: InputMaybe<Array<CustomerSignatureContactWhereInput>>;
	OR?: InputMaybe<Array<CustomerSignatureContactWhereInput>>;
	companyName_contains?: InputMaybe<Scalars['String']['input']>;
	customer?: InputMaybe<CustomerSignatureContactCustomerWhereInput>;
	firstName_contains?: InputMaybe<Scalars['String']['input']>;
	lastName_contains?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<ContactStatus>;
	vendor?: InputMaybe<CustomerSignatureContactVendorWhereInput>;
};

export type CustomerSignatureForGetContractWhere = {
	__typename?: 'CustomerSignatureForGetContractWhere';
	approved: Scalars['Boolean']['output'];
	contact: ContactForGetContractWhere;
	id: Scalars['ID']['output'];
};

export type CustomerSignatureOrgUser = {
	__typename?: 'CustomerSignatureOrgUser';
	id: Scalars['ID']['output'];
	organization: CustomerSignatureContactOrganization;
	role: TeamMemberRole;
	user: CustomerSignatureOrgUserUser;
};

export type CustomerSignatureOrgUserUser = {
	__typename?: 'CustomerSignatureOrgUserUser';
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	imagePositionX?: Maybe<Scalars['Float']['output']>;
	imagePositionY?: Maybe<Scalars['Float']['output']>;
	imageRotation?: Maybe<Scalars['Int']['output']>;
	imageScale?: Maybe<Scalars['Int']['output']>;
	organization: CustomerSignatureContactOrganization;
};

export type CustomerSignatureOrganizationUsers = {
	id: Scalars['ID']['input'];
	role: TeamMemberRole;
};

export type CustomerSignatureOrganizationWhereInput = {
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Float']['input']>;
	imagePositionY?: InputMaybe<Scalars['Float']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	users?: InputMaybe<Array<CustomerSignatureOrganizationUsers>>;
};

export type CustomerSignatureWhereInput = {
	contact?: InputMaybe<CustomerSignatureContactWhereInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Float']['input']>;
	imagePositionY?: InputMaybe<Scalars['Float']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	organization?: InputMaybe<CustomerSignatureOrganizationWhereInput>;
};

export type CustomerStripeCardUpdateInput = {
	cardUpdates: StripeCardUpdateInfoInput;
	setToDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomizedEmailInput = {
	intro?: InputMaybe<Scalars['String']['input']>;
	outro?: InputMaybe<Scalars['String']['input']>;
};

export type Dob = {
	__typename?: 'DOB';
	day?: Maybe<Scalars['Int']['output']>;
	month?: Maybe<Scalars['Int']['output']>;
	year?: Maybe<Scalars['Int']['output']>;
};

export type DobInput = {
	day: Scalars['Int']['input'];
	month: Scalars['Int']['input'];
	year: Scalars['Int']['input'];
};

export type DashboardExportInput = {
	end: Scalars['DateTime']['input'];
	start: Scalars['DateTime']['input'];
	timezone: Scalars['String']['input'];
	widgets: Array<VendorDashboardItemType>;
};

export type DashboardSettings = {
	__typename?: 'DashboardSettings';
	display_name?: Maybe<Scalars['String']['output']>;
	timezone?: Maybe<Scalars['String']['output']>;
};

export type DashboardSettingsInput = {
	display_name?: InputMaybe<Scalars['String']['input']>;
	timezone?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardWhereInput = {
	currentEndDate: Scalars['DateTime']['input'];
	currentStartDate: Scalars['DateTime']['input'];
	previousEndDate: Scalars['DateTime']['input'];
	previousStartDate: Scalars['DateTime']['input'];
	timezone: Scalars['String']['input'];
};

export type DatePoint = {
	__typename?: 'DatePoint';
	x: Scalars['DateTime']['output'];
	y: Scalars['Float']['output'];
};

export type DatePointsComparison = {
	__typename?: 'DatePointsComparison';
	current: Array<DatePoint>;
	labels: Array<Scalars['String']['output']>;
	previous: Array<DatePoint>;
};

export type DateTimeFilter = {
	gt?: InputMaybe<Scalars['DateTime']['input']>;
	gte?: InputMaybe<Scalars['DateTime']['input']>;
	lt?: InputMaybe<Scalars['DateTime']['input']>;
	lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeclineOnSettings = {
	__typename?: 'DeclineOnSettings';
	avs_failure?: Maybe<Scalars['Boolean']['output']>;
	cvc_failure?: Maybe<Scalars['Boolean']['output']>;
};

export type DeclineOnSettingsInput = {
	avs_failure?: InputMaybe<Scalars['Boolean']['input']>;
	cvc_failure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Discount = {
	__typename?: 'Discount';
	coupon?: Maybe<StripeCoupon>;
	customer?: Maybe<Scalars['String']['output']>;
	end?: Maybe<Scalars['Int']['output']>;
	object?: Maybe<Scalars['String']['output']>;
	start?: Maybe<Scalars['Int']['output']>;
	subscription?: Maybe<Scalars['String']['output']>;
};

export type Document = {
	__typename?: 'Document';
	createdAt: Scalars['DateTime']['output'];
	customer?: Maybe<User>;
	deletionHash?: Maybe<Scalars['String']['output']>;
	downloadUrl?: Maybe<Scalars['String']['output']>;
	events?: Maybe<Array<Event>>;
	exportable: Scalars['Boolean']['output'];
	fileSize: Scalars['Int']['output'];
	fileSource: FileSourceType;
	fileSourceID?: Maybe<Scalars['String']['output']>;
	fileType: FileType;
	fileUpdatedAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	location: Scalars['String']['output'];
	name: Scalars['String']['output'];
	orgUser?: Maybe<OrgUser>;
	organization?: Maybe<Organization>;
	ownerType: DocumentOwnerType;
	parentFolder?: Maybe<Folder>;
	sharedWithContacts?: Maybe<Array<Contact>>;
	sharedWithCustomer: Scalars['Boolean']['output'];
	status: DocumentStatus;
	type: DocumentType;
	updatedAt: Scalars['DateTime']['output'];
	uploadURL?: Maybe<Scalars['String']['output']>;
};

export type DocumentEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type DocumentSharedWithContactsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ContactOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContactWhereInput>;
};

export enum DocumentAccessTokenDocumentType {
	Contract = 'Contract',
	Invoice = 'Invoice',
	Lead = 'Lead',
	Proposal = 'Proposal',
}

export type DocumentAccessTokenUniqueWhere = {
	documentId: Scalars['String']['input'];
	documentType: DocumentAccessTokenDocumentType;
	guestToken: Scalars['String']['input'];
};

export type DocumentCreateCustomInput = {
	contact?: InputMaybe<ContactWhereUniqueInput>;
	fileSize: Scalars['Int']['input'];
	fileSource: FileSourceType;
	fileSourceID?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	parentFolder?: InputMaybe<FolderCreateOneWithoutDocumentsInput>;
	sharedWithContacts?: InputMaybe<ContactCreateManyWithoutDocumentsInput>;
	sharedWithCustomer?: InputMaybe<Scalars['Boolean']['input']>;
	type: DocumentType;
};

export type DocumentEventsWhereInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type DocumentOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	deletionHash?: InputMaybe<SortOrderType>;
	fileSize?: InputMaybe<SortOrderType>;
	fileSource?: InputMaybe<SortOrderType>;
	fileSourceID?: InputMaybe<SortOrderType>;
	fileType?: InputMaybe<SortOrderType>;
	fileUpdatedAt?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	location?: InputMaybe<SortOrderType>;
	name?: InputMaybe<SortOrderType>;
	organization?: InputMaybe<OrganizationOrderByInput>;
	ownerName?: InputMaybe<SortOrderType>;
	ownerType?: InputMaybe<SortOrderType>;
	sharedWithContacts?: InputMaybe<ContactOrderByInput>;
	sharedWithCustomer?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
	type?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export enum DocumentOwnerType {
	Customer = 'Customer',
	Organization = 'Organization',
}

export type DocumentSharedWithContactsWhereInput = {
	every?: InputMaybe<ContactWhereInput>;
	none?: InputMaybe<ContactWhereInput>;
	some?: InputMaybe<ContactWhereInput>;
};

export enum DocumentStatus {
	Archived = 'Archived',
	Available = 'Available',
	Deleted = 'Deleted',
	Pending = 'Pending',
}

export enum DocumentType {
	Internal = 'Internal',
	Sharable = 'Sharable',
}

export type DocumentWhereInput = {
	AND?: InputMaybe<Array<DocumentWhereInput>>;
	NOT?: InputMaybe<Array<DocumentWhereInput>>;
	OR?: InputMaybe<Array<DocumentWhereInput>>;
	clientUser?: InputMaybe<ClientUserWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	deletionHash?: InputMaybe<Scalars['String']['input']>;
	events?: InputMaybe<DocumentEventsWhereInput>;
	fileSize?: InputMaybe<Scalars['Int']['input']>;
	fileSource?: InputMaybe<FileSourceType>;
	fileSourceID?: InputMaybe<Scalars['String']['input']>;
	fileType?: InputMaybe<FileType>;
	fileUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	location?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	name_contains?: InputMaybe<Scalars['String']['input']>;
	orgUser?: InputMaybe<OrgUserWhereInput>;
	organization?: InputMaybe<OrganizationWhereInput>;
	ownerType?: InputMaybe<DocumentOwnerType>;
	parentFolder?: InputMaybe<FolderWhereInput>;
	sharedWithContacts?: InputMaybe<DocumentSharedWithContactsWhereInput>;
	sharedWithCustomer?: InputMaybe<Scalars['Boolean']['input']>;
	status?: InputMaybe<DocumentStatus>;
	type?: InputMaybe<DocumentType>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type Documents = {
	__typename?: 'Documents';
	_count: Scalars['Int']['output'];
	documents: Array<Document>;
};

export type DocumentsNeedingAttention = {
	__typename?: 'DocumentsNeedingAttention';
	contracts: Scalars['Int']['output'];
	invoices: Scalars['Int']['output'];
	proposals: Scalars['Int']['output'];
	total: Scalars['Int']['output'];
};

export type DocumentsWhereCustomIdInput = {
	in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DocumentsWhereCustomInput = {
	OR?: InputMaybe<Array<DocumentWhereInput>>;
	id?: InputMaybe<DocumentsWhereCustomIdInput>;
};

export type EmailAddressInput = {
	currentEmailAddress: Scalars['String']['input'];
};

export type EmailAddressUpdateInput = {
	newEmailAddress: Scalars['String']['input'];
	password: Scalars['String']['input'];
};

export type EmailNotificationGroup = {
	__typename?: 'EmailNotificationGroup';
	createdAt: Scalars['DateTime']['output'];
	groupTitle: EmailNotificationGroupTitle;
	id: Scalars['ID']['output'];
	members: Array<ReducedUser>;
	updatedAt: Scalars['DateTime']['output'];
};

export type EmailNotificationGroupInput = {
	groupTitle: EmailNotificationGroupTitle;
	members: Array<Scalars['String']['input']>;
};

export enum EmailNotificationGroupTitle {
	ContractComplete = 'ContractComplete',
	ContractCopy = 'ContractCopy',
	ContractOverdue = 'ContractOverdue',
	InvoiceCopy = 'InvoiceCopy',
	InvoiceOverdue = 'InvoiceOverdue',
	InvoicePaid = 'InvoicePaid',
	NewLeadSubmission = 'NewLeadSubmission',
	ProposalAccepted = 'ProposalAccepted',
	ProposalCopy = 'ProposalCopy',
	ProposalOverdue = 'ProposalOverdue',
}

export type EmailNotificationGroupsInput = {
	groups: Array<EmailNotificationGroupInput>;
};

export type EmbeddedSigningContract = {
	id: Scalars['String']['input'];
};

export type Event = {
	__typename?: 'Event';
	actingUser?: Maybe<ActingUserForEvent>;
	category: EventCategory;
	clientUser?: Maybe<ClientUser>;
	clientUserEmailProcessed?: Maybe<Scalars['Boolean']['output']>;
	consumingUsers?: Maybe<Array<User>>;
	contact?: Maybe<Contact>;
	contacts?: Maybe<Array<Contact>>;
	contract?: Maybe<CustomContract>;
	contractTemplate?: Maybe<ContractTemplate>;
	createdAt: Scalars['DateTime']['output'];
	dismissingUsers?: Maybe<Array<User>>;
	document?: Maybe<Document>;
	emailNotificationGroup?: Maybe<EmailNotificationGroup>;
	guestUser?: Maybe<GuestUser>;
	id: Scalars['ID']['output'];
	inquiry?: Maybe<Inquiry>;
	invitation?: Maybe<Invitation>;
	invoice?: Maybe<Invoice>;
	message?: Maybe<Scalars['String']['output']>;
	metadata?: Maybe<Scalars['Json']['output']>;
	orgUser?: Maybe<OrgUser>;
	orgUserEmailProcessed?: Maybe<Scalars['Boolean']['output']>;
	organizationEmailProcessed?: Maybe<Scalars['Boolean']['output']>;
	paymentInstallment?: Maybe<PaymentInstallment>;
	paymentInstallments?: Maybe<Array<PaymentInstallment>>;
	plannerUser?: Maybe<OrgUser>;
	plannerUserEmailProcessed?: Maybe<Scalars['Boolean']['output']>;
	proposal?: Maybe<Proposal>;
	referenceID?: Maybe<Scalars['String']['output']>;
	resolvedAt?: Maybe<Scalars['DateTime']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	vendor?: Maybe<Organization>;
};

export type EventConsumingUsersArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<UserWhereInput>;
};

export type EventDismissingUsersArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<UserWhereInput>;
};

export type EventPaymentInstallmentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<PaymentInstallmentWhereInput>;
};

export enum EventCategory {
	AdminFinishedOnBoardingWithoutPayFrom = 'AdminFinishedOnBoardingWithoutPayFrom',
	AdminFinishedOnBoardingWithoutPayTo = 'AdminFinishedOnBoardingWithoutPayTo',
	BalanceAvailable = 'BalanceAvailable',
	CalendarInviteSent = 'CalendarInviteSent',
	ClientAddedNewPaymentMethod = 'ClientAddedNewPaymentMethod',
	ClientAssignedPlannerPermissions = 'ClientAssignedPlannerPermissions',
	ClientFinishedOnBoardingWithoutPaymentMethod = 'ClientFinishedOnBoardingWithoutPaymentMethod',
	ClientGrantedPlannerConnectionsPermission = 'ClientGrantedPlannerConnectionsPermission',
	ClientGrantedPlannerPayingPermission = 'ClientGrantedPlannerPayingPermission',
	ClientGrantedPlannerSigningPermission = 'ClientGrantedPlannerSigningPermission',
	ClientRemovedPlannerPermissions = 'ClientRemovedPlannerPermissions',
	ClientRevokedPlannerConnectionsPermission = 'ClientRevokedPlannerConnectionsPermission',
	ClientRevokedPlannerPayingPermission = 'ClientRevokedPlannerPayingPermission',
	ClientRevokedPlannerSigningPermission = 'ClientRevokedPlannerSigningPermission',
	ClientUpdatedPlannerPermissions = 'ClientUpdatedPlannerPermissions',
	ClientUserEventDateChangeRequested = 'ClientUserEventDateChangeRequested',
	ClientUserEventDateChanged = 'ClientUserEventDateChanged',
	ConnectAccountRequestsVerification = 'ConnectAccountRequestsVerification',
	ConnectAccountUpdated = 'ConnectAccountUpdated',
	ConnectionCancelledByClient = 'ConnectionCancelledByClient',
	ConnectionCancelledByVendor = 'ConnectionCancelledByVendor',
	ConnectionPendingFromInviteByClient = 'ConnectionPendingFromInviteByClient',
	ConnectionPendingFromInviteByVendor = 'ConnectionPendingFromInviteByVendor',
	ConnectionRequestApprovedByClient = 'ConnectionRequestApprovedByClient',
	ConnectionRequestApprovedByPlannerOnBehalfOfClient = 'ConnectionRequestApprovedByPlannerOnBehalfOfClient',
	ConnectionRequestApprovedByVendor = 'ConnectionRequestApprovedByVendor',
	ConnectionRequestCancelledByPlannerOnBehalfOfClient = 'ConnectionRequestCancelledByPlannerOnBehalfOfClient',
	ConnectionRequestDeclinedByClient = 'ConnectionRequestDeclinedByClient',
	ConnectionRequestDeclinedByPlannerOnBehalfOfClient = 'ConnectionRequestDeclinedByPlannerOnBehalfOfClient',
	ConnectionRequestDeclinedByVendor = 'ConnectionRequestDeclinedByVendor',
	ConnectionRequestedByClient = 'ConnectionRequestedByClient',
	ConnectionRequestedByPlannerOnBehalfOfClient = 'ConnectionRequestedByPlannerOnBehalfOfClient',
	ConnectionRequestedByVendor = 'ConnectionRequestedByVendor',
	ContactCreatedByClient = 'ContactCreatedByClient',
	ContactCreatedByPlannerOBOClient = 'ContactCreatedByPlannerOBOClient',
	ContactCreatedByVendor = 'ContactCreatedByVendor',
	ContactDeleted = 'ContactDeleted',
	ContractApproved = 'ContractApproved',
	ContractDeleted = 'ContractDeleted',
	ContractDownloadFailed = 'ContractDownloadFailed',
	ContractDueSoon = 'ContractDueSoon',
	ContractExecuted = 'ContractExecuted',
	ContractPastDue = 'ContractPastDue',
	ContractPastDueForCountersigning = 'ContractPastDueForCountersigning',
	ContractReadyForCountersigning = 'ContractReadyForCountersigning',
	ContractReadyForVendorSignature = 'ContractReadyForVendorSignature',
	ContractResent = 'ContractResent',
	ContractResentToCountersigner = 'ContractResentToCountersigner',
	ContractSent = 'ContractSent',
	ContractSentAwaiting = 'ContractSentAwaiting',
	ContractSignedByClient = 'ContractSignedByClient',
	ContractSignedByCountersigner = 'ContractSignedByCountersigner',
	ContractSignedByCustomer = 'ContractSignedByCustomer',
	ContractSignedByGuest = 'ContractSignedByGuest',
	ContractSignedByPlanner = 'ContractSignedByPlanner',
	ContractTemplateCompleted = 'ContractTemplateCompleted',
	ContractTokenRefreshed = 'ContractTokenRefreshed',
	ContractViewed = 'ContractViewed',
	ContractVoided = 'ContractVoided',
	CustomerAddedNewPaymentMethod = 'CustomerAddedNewPaymentMethod',
	DocumentAccessTokenRefreshed = 'DocumentAccessTokenRefreshed',
	DocumentAdded = 'DocumentAdded',
	DocumentDeleted = 'DocumentDeleted',
	DocumentFileReplaced = 'DocumentFileReplaced',
	DocumentRenamed = 'DocumentRenamed',
	DocumentSharedWithCustomer = 'DocumentSharedWithCustomer',
	DocumentSharedWithOrg = 'DocumentSharedWithOrg',
	DocumentSharedWithOrgByPlannerOBO = 'DocumentSharedWithOrgByPlannerOBO',
	DocumentUnsharedWithCustomer = 'DocumentUnsharedWithCustomer',
	DocumentUnsharedWithOrg = 'DocumentUnsharedWithOrg',
	DocumentUnsharedWithOrgByPlannerOBO = 'DocumentUnsharedWithOrgByPlannerOBO',
	DocumentViewed = 'DocumentViewed',
	EmailAddressUpdated = 'EmailAddressUpdated',
	EmailVerificationEmailCreated = 'EmailVerificationEmailCreated',
	EventResolvedBySuperAdmin = 'EventResolvedBySuperAdmin',
	FinancialConnectionsAccountAccountNumbersUpdated = 'FinancialConnectionsAccountAccountNumbersUpdated',
	InquiryArchived = 'InquiryArchived',
	InquiryConvertedToContact = 'InquiryConvertedToContact',
	InquiryCreated = 'InquiryCreated',
	InquiryDeleted = 'InquiryDeleted',
	InquiryReceived = 'InquiryReceived',
	InquiryUnArchived = 'InquiryUnArchived',
	InquiryUpdated = 'InquiryUpdated',
	InquiryViewed = 'InquiryViewed',
	InstallmentPaymentAutopaidInThreeDays = 'InstallmentPaymentAutopaidInThreeDays',
	InstallmentPaymentDueInThreeDays = 'InstallmentPaymentDueInThreeDays',
	InstallmentPaymentDueSoon = 'InstallmentPaymentDueSoon',
	InstallmentPaymentFailed = 'InstallmentPaymentFailed',
	InstallmentPaymentRecordedOfflineByVendor = 'InstallmentPaymentRecordedOfflineByVendor',
	InstallmentPaymentRequestedByClient = 'InstallmentPaymentRequestedByClient',
	InstallmentPaymentRequestedByGuest = 'InstallmentPaymentRequestedByGuest',
	InstallmentPaymentRequestedByPlanner = 'InstallmentPaymentRequestedByPlanner',
	InstallmentPaymentRequestedBySchedule = 'InstallmentPaymentRequestedBySchedule',
	InstallmentPaymentRescheduledByFailure = 'InstallmentPaymentRescheduledByFailure',
	InstallmentPaymentRescheduledByVendor = 'InstallmentPaymentRescheduledByVendor',
	InstallmentPaymentSucceeded = 'InstallmentPaymentSucceeded',
	InstallmentPaymentUpdatedOfflineByVendor = 'InstallmentPaymentUpdatedOfflineByVendor',
	InstallmentRefundAwaitingReversal = 'InstallmentRefundAwaitingReversal',
	InstallmentRefundCompleted = 'InstallmentRefundCompleted',
	InstallmentRefundFailed = 'InstallmentRefundFailed',
	InstallmentRefundRecordedOfflineByVendor = 'InstallmentRefundRecordedOfflineByVendor',
	InstallmentRefundRequested = 'InstallmentRefundRequested',
	InstallmentRefundReversalUnavailable = 'InstallmentRefundReversalUnavailable',
	InstallmentRefundUpdatedOfflineByVendor = 'InstallmentRefundUpdatedOfflineByVendor',
	InstallmentScheduledPaymentFailed = 'InstallmentScheduledPaymentFailed',
	InvitationSentByUser = 'InvitationSentByUser',
	InvoiceApproved = 'InvoiceApproved',
	InvoiceCourtesyEmailCreated = 'InvoiceCourtesyEmailCreated',
	InvoiceDeleted = 'InvoiceDeleted',
	InvoiceFullyPaid = 'InvoiceFullyPaid',
	InvoicePastDue = 'InvoicePastDue',
	InvoicePaymentsDescheduledByBlocked = 'InvoicePaymentsDescheduledByBlocked',
	InvoicePaymentsDescheduledByClient = 'InvoicePaymentsDescheduledByClient',
	InvoicePaymentsDescheduledByFailure = 'InvoicePaymentsDescheduledByFailure',
	InvoicePaymentsDescheduledByPlanner = 'InvoicePaymentsDescheduledByPlanner',
	InvoicePaymentsDescheduledByVendorAction = 'InvoicePaymentsDescheduledByVendorAction',
	InvoicePaymentsScheduledByClient = 'InvoicePaymentsScheduledByClient',
	InvoicePaymentsScheduledByPlanner = 'InvoicePaymentsScheduledByPlanner',
	InvoiceResent = 'InvoiceResent',
	InvoiceSent = 'InvoiceSent',
	InvoiceSentAwaiting = 'InvoiceSentAwaiting',
	InvoiceViewed = 'InvoiceViewed',
	InvoiceVoided = 'InvoiceVoided',
	MemberAssignedContact = 'MemberAssignedContact',
	MessageCustomer = 'MessageCustomer',
	NewGuestContractTokenRequested = 'NewGuestContractTokenRequested',
	OfflineInstallmentPaymentUnRecordedByVendor = 'OfflineInstallmentPaymentUnRecordedByVendor',
	OfflineInstallmentRefundUnRecordedByVendor = 'OfflineInstallmentRefundUnRecordedByVendor',
	OnboardingEmailVerificationEmailCreated = 'OnboardingEmailVerificationEmailCreated',
	OrgMemberDeactivated = 'OrgMemberDeactivated',
	OrgMemberReactivated = 'OrgMemberReactivated',
	OrganizationAddedNewPayFromAccount = 'OrganizationAddedNewPayFromAccount',
	OrganizationAddedNewPayToAccount = 'OrganizationAddedNewPayToAccount',
	OrganizationChangedPayToAccount = 'OrganizationChangedPayToAccount',
	OrganizationCreated = 'OrganizationCreated',
	PasswordResetEmailCreated = 'PasswordResetEmailCreated',
	PaymentBlockedByStripeRequirements = 'PaymentBlockedByStripeRequirements',
	PaymentMethodRequiresVerification = 'PaymentMethodRequiresVerification',
	PaymentMethodVerificationAvailable = 'PaymentMethodVerificationAvailable',
	PayoutFailed = 'PayoutFailed',
	PayoutWithdrawalFailed = 'PayoutWithdrawalFailed',
	PlannerUserUpdatesProfile = 'PlannerUserUpdatesProfile',
	ProposalAcceptedByCustomer = 'ProposalAcceptedByCustomer',
	ProposalAcceptedByPlanner = 'ProposalAcceptedByPlanner',
	ProposalCreated = 'ProposalCreated',
	ProposalDeleted = 'ProposalDeleted',
	ProposalDueSoon = 'ProposalDueSoon',
	ProposalPastDue = 'ProposalPastDue',
	ProposalResent = 'ProposalResent',
	ProposalSent = 'ProposalSent',
	ProposalSentAwaiting = 'ProposalSentAwaiting',
	ProposalViewed = 'ProposalViewed',
	ProposalVoided = 'ProposalVoided',
	QuickPaymentLinkCreatedOrCopied = 'QuickPaymentLinkCreatedOrCopied',
	QuickPaymentPaid = 'QuickPaymentPaid',
	SubscriptionActivated = 'SubscriptionActivated',
	SubscriptionCanceled = 'SubscriptionCanceled',
	SubscriptionChanged = 'SubscriptionChanged',
	SubscriptionPaymentFailed = 'SubscriptionPaymentFailed',
	SubscriptionPaymentSucceeded = 'SubscriptionPaymentSucceeded',
	SubscriptionRenewalFirstReminder = 'SubscriptionRenewalFirstReminder',
	SubscriptionRenewalPaid = 'SubscriptionRenewalPaid',
	SubscriptionRenewalSecondReminder = 'SubscriptionRenewalSecondReminder',
	SubscriptionTrialEnding = 'SubscriptionTrialEnding',
	UserAddedToNotificationGroup = 'UserAddedToNotificationGroup',
	UserEmailBlocked = 'UserEmailBlocked',
	UserEmailUnBlocked = 'UserEmailUnBlocked',
	UserInvitedAsClient = 'UserInvitedAsClient',
	UserInvitedAsOrgMember = 'UserInvitedAsOrgMember',
	UserInvitedAsOrganization = 'UserInvitedAsOrganization',
	UserInvitedAsOrganizationByPlannerOnBehalfOfClient = 'UserInvitedAsOrganizationByPlannerOnBehalfOfClient',
	UserJoinedOrganization = 'UserJoinedOrganization',
	UserRemovedFromNotificationGroup = 'UserRemovedFromNotificationGroup',
	UserRequestedMFAToken = 'UserRequestedMFAToken',
	VendorDisputeOpened = 'VendorDisputeOpened',
	VendorDisputeRefundCompleted = 'VendorDisputeRefundCompleted',
	VendorDisputeRefundFailed = 'VendorDisputeRefundFailed',
	VendorDisputeWonByClient = 'VendorDisputeWonByClient',
	VendorDisputeWonByVendor = 'VendorDisputeWonByVendor',
	VendorRequestedContactActivation = 'VendorRequestedContactActivation',
	VendorRequestedPlannerPermissions = 'VendorRequestedPlannerPermissions',
	WebhookEndpointPausedForFailures = 'WebhookEndpointPausedForFailures',
}

export type EventOrderByInput = {
	category?: InputMaybe<SortOrderType>;
	clientUserEmailProcessed?: InputMaybe<SortOrderType>;
	createdAt?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	message?: InputMaybe<SortOrderType>;
	metadata?: InputMaybe<SortOrderType>;
	orgUserEmailProcessed?: InputMaybe<SortOrderType>;
	organizationEmailProcessed?: InputMaybe<SortOrderType>;
	plannerUserEmailProcessed?: InputMaybe<SortOrderType>;
	referenceID?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export type EventWhereCategoryInput = {
	in?: InputMaybe<Array<EventCategory>>;
};

export type EventWhereConsumingUsersInput = {
	every?: InputMaybe<UserWhereInput>;
	none?: InputMaybe<UserWhereInput>;
	some?: InputMaybe<UserWhereInput>;
};

export type EventWhereInput = {
	AND?: InputMaybe<Array<EventWhereInput>>;
	NOT?: InputMaybe<Array<EventWhereInput>>;
	OR?: InputMaybe<Array<EventWhereInput>>;
	category?: InputMaybe<EventWhereCategoryInput>;
	clientUser?: InputMaybe<ClientUserWhereInput>;
	clientUserEmailProcessed?: InputMaybe<Scalars['Boolean']['input']>;
	consumingUsers?: InputMaybe<EventWhereConsumingUsersInput>;
	contact?: InputMaybe<ContactWhereInput>;
	contacts?: InputMaybe<ContactWhereInput>;
	contract?: InputMaybe<ContractWhereInput>;
	contractTemplate?: InputMaybe<ContractTemplateWhereInput>;
	createdAt?: InputMaybe<CreatedAtGreaterThan>;
	dismissingUsers?: InputMaybe<UserWhereInput>;
	document?: InputMaybe<DocumentWhereInput>;
	guestUser?: InputMaybe<GuestUserWhereInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	invitation?: InputMaybe<InvitationWhereInput>;
	invoice?: InputMaybe<InvoiceWhereInput>;
	message?: InputMaybe<Scalars['String']['input']>;
	orgUser?: InputMaybe<OrgUserWhereInput>;
	orgUserEmailProcessed?: InputMaybe<Scalars['Boolean']['input']>;
	organizationEmailProcessed?: InputMaybe<Scalars['Boolean']['input']>;
	paymentInstallment?: InputMaybe<PaymentInstallmentWhereInput>;
	paymentInstallments?: InputMaybe<EventWherePaymentInstallmentsInput>;
	plannerUser?: InputMaybe<OrgUserWhereInput>;
	plannerUserEmailProcessed?: InputMaybe<Scalars['Boolean']['input']>;
	proposal?: InputMaybe<ProposalWhereInput>;
	referenceID?: InputMaybe<Scalars['String']['input']>;
	resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	vendor?: InputMaybe<OrganizationWhereInput>;
};

export type EventWherePaymentInstallmentsInput = {
	every?: InputMaybe<PaymentInstallmentWhereInput>;
	none?: InputMaybe<PaymentInstallmentWhereInput>;
	some?: InputMaybe<PaymentInstallmentWhereInput>;
};

export type EventWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type ExportContactsDataWhereInput = {
	endDate: Scalars['DateTime']['input'];
	include: Scalars['String']['input'];
	startDate: Scalars['DateTime']['input'];
	timezone: Scalars['String']['input'];
};

export type ExportHistoryInput = {
	end: Scalars['DateTime']['input'];
	fileType: Scalars['String']['input'];
	paymentSourceID?: InputMaybe<Scalars['String']['input']>;
	start: Scalars['DateTime']['input'];
	timeZone: Scalars['String']['input'];
};

export type ExportInquiriesDataWhereInput = {
	endDate: Scalars['DateTime']['input'];
	include: Scalars['String']['input'];
	startDate: Scalars['DateTime']['input'];
	timezone: Scalars['String']['input'];
};

export type ExportInvoicesDataInput = {
	endDate: Scalars['DateTime']['input'];
	startDate: Scalars['DateTime']['input'];
};

export enum ExportTypeInput {
	csv = 'csv',
	pdf = 'pdf',
}

export type ExportWalletQuickPaymentsDataInput = {
	type: ExportTypeInput;
};

export type ExportWalletQuickPaymentsWhereInput = {
	end: Scalars['DateTime']['input'];
	start: Scalars['DateTime']['input'];
	timezone: Scalars['String']['input'];
};

export type FServiceWhereOrganizationsInput = {
	every?: InputMaybe<OrganizationWhereInput>;
	none?: InputMaybe<OrganizationWhereInput>;
	some?: InputMaybe<OrganizationWhereInput>;
};

export type FailedPayments = {
	__typename?: 'FailedPayments';
	invoices: Array<InvoiceForDashboardStats>;
	totalAmountFailed: Scalars['String']['output'];
};

export enum FeatureCategory {
	CRMBetaLeadTrackingV1 = 'CRMBetaLeadTrackingV1',
	DropboxSignApp = 'DropboxSignApp',
	GoogleDrive = 'GoogleDrive',
	GoogleRecaptcha = 'GoogleRecaptcha',
	InternationalPaymentSupport = 'InternationalPaymentSupport',
	MUIWallet = 'MUIWallet',
	QuickBooksIntegration = 'QuickBooksIntegration',
	StripeTaxForms = 'StripeTaxForms',
	TestFeature = 'TestFeature',
}

export type FeatureFlag = {
	__typename?: 'FeatureFlag';
	active: Scalars['Boolean']['output'];
	category: FeatureCategory;
	createdAt: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	testingGroups?: Maybe<Array<TestingGroup>>;
	type: FeatureFlagType;
	updatedAt: Scalars['DateTime']['output'];
};

export enum FeatureFlagType {
	Release = 'Release',
	TestingGroup = 'TestingGroup',
}

export type FeatureFlagWhereGroupsInput = {
	every?: InputMaybe<TestingGroupWhereInput>;
	none?: InputMaybe<TestingGroupWhereInput>;
	some?: InputMaybe<TestingGroupWhereInput>;
};

export type FeatureFlagWhereInput = {
	AND?: InputMaybe<Array<FeatureFlagWhereInput>>;
	NOT?: InputMaybe<Array<FeatureFlagWhereInput>>;
	OR?: InputMaybe<Array<FeatureFlagWhereInput>>;
	active?: InputMaybe<Scalars['Boolean']['input']>;
	category?: InputMaybe<FeatureCategory>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	groups?: InputMaybe<FeatureFlagWhereGroupsInput>;
	type?: InputMaybe<FeatureFlagType>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FileSourceType {
	Google = 'Google',
	LocalStorage = 'LocalStorage',
}

export enum FileType {
	AVI = 'AVI',
	BMP = 'BMP',
	CSV = 'CSV',
	DOC = 'DOC',
	DOCX = 'DOCX',
	GIF = 'GIF',
	JPEG = 'JPEG',
	JPG = 'JPG',
	MP3 = 'MP3',
	MP4 = 'MP4',
	MPEG = 'MPEG',
	ODP = 'ODP',
	ODS = 'ODS',
	PDF = 'PDF',
	PNG = 'PNG',
	PPT = 'PPT',
	PPTX = 'PPTX',
	SVG = 'SVG',
	TIF = 'TIF',
	WEBM = 'WEBM',
	XLS = 'XLS',
	XLSX = 'XLSX',
}

export type Folder = {
	__typename?: 'Folder';
	childFolders?: Maybe<Array<Folder>>;
	createdAt: Scalars['DateTime']['output'];
	deletionHash?: Maybe<Scalars['String']['output']>;
	documents?: Maybe<Array<Document>>;
	folderType: FolderType;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['Json']['output']>;
	name: Scalars['String']['output'];
	organization: Organization;
	parentFolder?: Maybe<Folder>;
	status: FolderStatus;
	updatedAt: Scalars['DateTime']['output'];
};

export type FolderChildFoldersArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<FolderOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<FolderWhereInput>;
};

export type FolderDocumentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<DocumentWhereInput>;
};

export type FolderContentsOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	name?: InputMaybe<SortOrderType>;
};

export type FolderCount = {
	__typename?: 'FolderCount';
	childFolders: Scalars['Int']['output'];
	documents: Scalars['Int']['output'];
};

export type FolderCreateCustomInput = {
	name: Scalars['String']['input'];
	parentFolder?: InputMaybe<FolderCreateOneWithoutParentFolderInput>;
};

export type FolderCreateOneWithoutDocumentsInput = {
	connect?: InputMaybe<FolderWhereUniqueInput>;
};

export type FolderCreateOneWithoutParentFolderInput = {
	connect?: InputMaybe<FolderWhereUniqueInput>;
};

export type FolderOrderByInput = {
	childFolders?: InputMaybe<FolderOrderByInput>;
	createdAt?: InputMaybe<SortOrderType>;
	deletionHash?: InputMaybe<SortOrderType>;
	documents?: InputMaybe<DocumentOrderByInput>;
	folderType?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	metadata?: InputMaybe<SortOrderType>;
	name?: InputMaybe<SortOrderType>;
	orderBy?: InputMaybe<FolderOrderByInput>;
	status?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export enum FolderStatus {
	Active = 'Active',
	Deleted = 'Deleted',
}

export enum FolderType {
	Internal = 'Internal',
}

export type FolderWhereChildFoldersInput = {
	every?: InputMaybe<FolderWhereInput>;
	none?: InputMaybe<FolderWhereInput>;
	some?: InputMaybe<FolderWhereInput>;
};

export type FolderWhereDocumentsInput = {
	every?: InputMaybe<DocumentWhereInput>;
	none?: InputMaybe<DocumentWhereInput>;
	some?: InputMaybe<DocumentWhereInput>;
};

export type FolderWhereInput = {
	AND?: InputMaybe<Array<FolderWhereInput>>;
	NOT?: InputMaybe<Array<FolderWhereInput>>;
	OR?: InputMaybe<Array<FolderWhereInput>>;
	childFolders?: InputMaybe<FolderWhereChildFoldersInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	deletionHash?: InputMaybe<Scalars['String']['input']>;
	documents?: InputMaybe<FolderWhereDocumentsInput>;
	folderType?: InputMaybe<FolderType>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organization?: InputMaybe<OrganizationWhereInput>;
	parentFolder?: InputMaybe<FolderWhereInput>;
	status?: InputMaybe<FolderStatus>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FolderWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type FoldersWhereCustomInput = {
	OR?: InputMaybe<Array<FoldersWhereCustomInput>>;
	id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormattedGlobalVariables = {
	__typename?: 'FormattedGlobalVariables';
	AutomatedNotificationsSupportUrl?: Maybe<Scalars['String']['output']>;
	CanadianFeeStructureAugmentation?: Maybe<Scalars['String']['output']>;
	CaptchaURL?: Maybe<Scalars['String']['output']>;
	ClientDemoVideoUrl?: Maybe<Scalars['String']['output']>;
	ClientHelpURL?: Maybe<Scalars['String']['output']>;
	ContractTokenExpirationLengthInMilliseconds?: Maybe<
		Scalars['String']['output']
	>;
	DemoCalendarUrl?: Maybe<Scalars['String']['output']>;
	DisputeRefundCustomerStripeAccount?: Maybe<Scalars['String']['output']>;
	HelpUrl?: Maybe<Scalars['String']['output']>;
	InquiryFormSupportUrl?: Maybe<Scalars['String']['output']>;
	JwtExpirationHours?: Maybe<Scalars['String']['output']>;
	JwtImpersonationExpirationHours?: Maybe<Scalars['String']['output']>;
	MaxFoldersPerLayer?: Maybe<Scalars['Int']['output']>;
	PlannerPermissionsHelpUrl?: Maybe<Scalars['String']['output']>;
	QuickBooksHelpUrl?: Maybe<Scalars['String']['output']>;
	QuickPaySupportUrl?: Maybe<Scalars['String']['output']>;
	RPCFAQURL?: Maybe<Scalars['String']['output']>;
	RPCZapierUrl?: Maybe<Scalars['String']['output']>;
	StripeLegalUrl?: Maybe<Scalars['String']['output']>;
	SubscriptionPlanUrl?: Maybe<Scalars['String']['output']>;
	TGIntegrationURL?: Maybe<Scalars['String']['output']>;
	TGLogo?: Maybe<Scalars['String']['output']>;
	TermsOfServiceUrl?: Maybe<Scalars['String']['output']>;
	WatchDemoUrl?: Maybe<Scalars['String']['output']>;
	WebhookHelpUrl?: Maybe<Scalars['String']['output']>;
	WebhookOpenApiUrl?: Maybe<Scalars['String']['output']>;
	WhiteGloveUrl?: Maybe<Scalars['String']['output']>;
};

export type GetInvoicesForCustomerInput = {
	OR?: InputMaybe<Array<InputMaybe<QueryFieldsForInvoiceSearch>>>;
	contact?: InputMaybe<ContactInputForGetInvoicesForCustomer>;
	isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
	status?: InputMaybe<InvoiceStatus>;
};

export type GetSendgridStatusByEmailInput = {
	email: Scalars['String']['input'];
};

export type GuestUser = {
	__typename?: 'GuestUser';
	createdAt: Scalars['DateTime']['output'];
	events?: Maybe<Array<Event>>;
	id: Scalars['ID']['output'];
	updatedAt: Scalars['DateTime']['output'];
	user: User;
};

export type GuestUserEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type GuestUserForGetContractWhere = {
	__typename?: 'GuestUserForGetContractWhere';
	id: Scalars['ID']['output'];
	user: BaseUserForGetContractWhere;
};

export type GuestUserWhereEventsInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type GuestUserWhereInput = {
	AND?: InputMaybe<Array<GuestUserWhereInput>>;
	NOT?: InputMaybe<Array<GuestUserWhereInput>>;
	OR?: InputMaybe<Array<GuestUserWhereInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	events?: InputMaybe<GuestUserWhereEventsInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	user?: InputMaybe<UserWhereInput>;
};

export type ImpersonatingUser = {
	__typename?: 'ImpersonatingUser';
	id: Scalars['ID']['output'];
	superAdminCapabilities?: Maybe<Array<Maybe<SuperAdminCapability>>>;
};

export type InquiriesForOrganization = {
	__typename?: 'InquiriesForOrganization';
	_count: Scalars['Int']['output'];
	inquiries: Array<Inquiry>;
};

export type InquiriesForOrganizationWhereInput = {
	AND?: InputMaybe<Array<InquiriesForOrganizationWhereInput>>;
	NOT?: InputMaybe<Array<InquiriesForOrganizationWhereInput>>;
	OR?: InputMaybe<Array<InquiriesForOrganizationWhereInput>>;
	archived?: InputMaybe<Scalars['Boolean']['input']>;
	companyName_contains?: InputMaybe<Scalars['String']['input']>;
	contact?: InputMaybe<ContactWhereUniqueInput>;
	createdAt?: InputMaybe<DateTimeFilter>;
	email?: InputMaybe<Scalars['String']['input']>;
	email_contains?: InputMaybe<Scalars['String']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	firstName_contains?: InputMaybe<Scalars['String']['input']>;
	ipAddress?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	lastName_contains?: InputMaybe<Scalars['String']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<InquiryStatusInput>;
	updatedAt?: InputMaybe<DateTimeFilter>;
	userAgent?: InputMaybe<Scalars['String']['input']>;
	viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Inquiry = {
	__typename?: 'Inquiry';
	companyName?: Maybe<Scalars['String']['output']>;
	contact?: Maybe<Contact>;
	createdAt: Scalars['DateTime']['output'];
	email: Scalars['String']['output'];
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	ipAddress?: Maybe<Scalars['String']['output']>;
	lastName: Scalars['String']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	organization: Organization;
	source?: Maybe<Scalars['String']['output']>;
	status: InquiryStatus;
	updatedAt: Scalars['DateTime']['output'];
	userAgent?: Maybe<Scalars['String']['output']>;
};

export type InquiryCreateInput = {
	companyName?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
};

export type InquiryDetailWhereInput = {
	guestToken?: InputMaybe<Scalars['String']['input']>;
	lead: InquiryWhereUniqueInput;
};

export type InquiryForm = {
	__typename?: 'InquiryForm';
	confirmationEmail?: Maybe<Scalars['String']['output']>;
	fields?: Maybe<Array<InquiryFormField>>;
	id: Scalars['ID']['output'];
	organization: Organization;
	redirectOnSuccessUrl?: Maybe<Scalars['String']['output']>;
	sendConfirmationEmail: Scalars['Boolean']['output'];
	styles?: Maybe<Array<InquiryFormStyle>>;
};

export type InquiryFormDataFieldInput = {
	id: Scalars['ID']['input'];
	label: Scalars['String']['input'];
	multiple?: InputMaybe<Scalars['Boolean']['input']>;
	options?: InputMaybe<Scalars['Json']['input']>;
	order: Scalars['Int']['input'];
	required: Scalars['Boolean']['input'];
	type: InquiryFormFieldType;
};

export type InquiryFormDataInput = {
	confirmationEmail?: InputMaybe<Scalars['String']['input']>;
	fields?: InputMaybe<Array<InquiryFormDataFieldInput>>;
	redirectOnSuccessUrl?: InputMaybe<Scalars['String']['input']>;
	sendConfirmationEmail: Scalars['Boolean']['input'];
	styles?: InputMaybe<Array<InquiryFormDataStyleInput>>;
};

export type InquiryFormDataStyleInput = {
	type: InquiryFormStyleType;
	value: Scalars['String']['input'];
};

export type InquiryFormField = {
	__typename?: 'InquiryFormField';
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	label: Scalars['String']['output'];
	multiple?: Maybe<Scalars['Boolean']['output']>;
	options?: Maybe<Scalars['Json']['output']>;
	order: Scalars['Int']['output'];
	required: Scalars['Boolean']['output'];
	type: InquiryFormFieldType;
	updatedAt: Scalars['DateTime']['output'];
};

export enum InquiryFormFieldType {
	email = 'email',
	eventDate = 'eventDate',
	firstNameOne = 'firstNameOne',
	firstNameTwo = 'firstNameTwo',
	instructions = 'instructions',
	lastNameOne = 'lastNameOne',
	lastNameTwo = 'lastNameTwo',
	multilineText = 'multilineText',
	multipleChoice = 'multipleChoice',
	phone = 'phone',
	singlelineText = 'singlelineText',
}

export type InquiryFormStyle = {
	__typename?: 'InquiryFormStyle';
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	type: InquiryFormStyleType;
	updatedAt: Scalars['DateTime']['output'];
	value: Scalars['String']['output'];
};

export enum InquiryFormStyleType {
	backgroundColor = 'backgroundColor',
	buttonFill = 'buttonFill',
	buttonText = 'buttonText',
	corners = 'corners',
	fieldInputText = 'fieldInputText',
	fieldLabelAndBorder = 'fieldLabelAndBorder',
	fieldLabelAndBorderFocus = 'fieldLabelAndBorderFocus',
	fontFamily = 'fontFamily',
	fontSize = 'fontSize',
	instructions = 'instructions',
}

export type InquiryMergeInput = {
	contactId: Scalars['String']['input'];
	inquiryId: Scalars['String']['input'];
};

export type InquiryOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	email?: InputMaybe<SortOrderType>;
	eventDate?: InputMaybe<SortOrderType>;
	firstName?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	lastName?: InputMaybe<SortOrderType>;
	notes?: InputMaybe<SortOrderType>;
	source?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
};

export enum InquiryStatus {
	Budget = 'Budget',
	Called = 'Called',
	Converted = 'Converted',
	Duplicate = 'Duplicate',
	NeedsFollowUp = 'NeedsFollowUp',
	New = 'New',
	NotAvailable = 'NotAvailable',
	Other = 'Other',
	SentMessage = 'SentMessage',
	Spam = 'Spam',
	Unresponsive = 'Unresponsive',
	Viewed = 'Viewed',
}

export type InquiryStatusInput = {
	in?: InputMaybe<Array<InquiryStatus>>;
};

export type InquirySubmissionInput = {
	email: Scalars['String']['input'];
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	token: Scalars['String']['input'];
};

export type InquiryUpdateDataInput = {
	archived?: InputMaybe<Scalars['Boolean']['input']>;
	companyName?: InputMaybe<Scalars['String']['input']>;
	email?: InputMaybe<Scalars['String']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<Scalars['String']['input']>;
};

export type InquiryWhereInput = {
	every?: InputMaybe<InquiryWhereInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	none?: InputMaybe<InquiryWhereInput>;
	some?: InputMaybe<InquiryWhereInput>;
};

export type InquiryWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type InstallmentAmountInput = {
	amountDue: Scalars['Int']['input'];
	convenienceFee: Scalars['Int']['input'];
	gratuity: Scalars['Int']['input'];
	id: Scalars['ID']['input'];
};

export enum InstallmentStatus {
	Disputed = 'Disputed',
	FullyPaid = 'FullyPaid',
	FullyPaidPartiallyRefunded = 'FullyPaidPartiallyRefunded',
	Pending = 'Pending',
	Refunded = 'Refunded',
	Refunding = 'Refunding',
	Unpaid = 'Unpaid',
}

export type Invitation = {
	__typename?: 'Invitation';
	contact?: Maybe<CustomContact>;
	createdAt: Scalars['DateTime']['output'];
	emailAddress: Scalars['String']['output'];
	events?: Maybe<Array<Event>>;
	id: Scalars['ID']['output'];
	invitationType: InviteEnum;
	organization?: Maybe<Organization>;
	recipientFirstName: Scalars['String']['output'];
	recipientLastName?: Maybe<Scalars['String']['output']>;
	sendWithContract: Scalars['Boolean']['output'];
	sendWithInvoice: Scalars['Boolean']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type InvitationEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type InvitationCustomCreateInput = {
	emailAddress: Scalars['String']['input'];
	invitationType: InviteEnum;
	onBehalfOfClient?: InputMaybe<ClientUserWhereUniqueInput>;
	recipientFirstName: Scalars['String']['input'];
	recipientLastName?: InputMaybe<Scalars['String']['input']>;
	sendWithContract: Scalars['Boolean']['input'];
	sendWithInvoice: Scalars['Boolean']['input'];
};

export type InvitationOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	emailAddress?: InputMaybe<SortOrderType>;
	recipientFirstName?: InputMaybe<SortOrderType>;
};

export type InvitationWhereCustomInput = {
	id: Scalars['ID']['input'];
};

export type InvitationWhereEventsInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type InvitationWhereForGetInvoicesForCustomer = {
	OR?: InputMaybe<Array<InputMaybe<InvitationWhereForGetInvoicesForCustomer>>>;
	contact?: InputMaybe<ContactForSearchFilter>;
	emailAddress?: InputMaybe<Scalars['String']['input']>;
	emailAddress_contains?: InputMaybe<Scalars['String']['input']>;
	recipientFirstName?: InputMaybe<Scalars['String']['input']>;
	recipientFirstName_contains?: InputMaybe<Scalars['String']['input']>;
	recipientLastName?: InputMaybe<Scalars['String']['input']>;
	recipientLastName_contains?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationWhereInput = {
	AND?: InputMaybe<Array<InvitationWhereInput>>;
	NOT?: InputMaybe<Array<InvitationWhereInput>>;
	OR?: InputMaybe<Array<InvitationWhereInput>>;
	contact?: InputMaybe<ContactWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	emailAddress?: InputMaybe<Scalars['String']['input']>;
	emailAddress_contains?: InputMaybe<Scalars['String']['input']>;
	events?: InputMaybe<InvitationWhereEventsInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	invitationType?: InputMaybe<InviteEnum>;
	organization?: InputMaybe<OrganizationWhereInput>;
	recipientFirstName?: InputMaybe<Scalars['String']['input']>;
	recipientFirstName_contains?: InputMaybe<Scalars['String']['input']>;
	recipientLastName?: InputMaybe<Scalars['String']['input']>;
	recipientLastName_contains?: InputMaybe<Scalars['String']['input']>;
	sendWithContract?: InputMaybe<Scalars['Boolean']['input']>;
	sendWithInvoice?: InputMaybe<Scalars['Boolean']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InvitationsWhereCustomInput = {
	invitationType?: InputMaybe<InviteEnum>;
	invitingUserId: Scalars['String']['input'];
	pendingInvitations?: InputMaybe<InvitationWhereInput>;
};

export enum InviteEnum {
	NewClient = 'NewClient',
	NewOrg = 'NewOrg',
	NewOrgMember = 'NewOrgMember',
}

export type InviteUser = InviteUserClientUser | InviteUserOrgUser;

export type InviteUserClientUser = {
	__typename?: 'InviteUserClientUser';
	firstNameOne: Scalars['String']['output'];
	firstNameTwo?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastNameOne: Scalars['String']['output'];
	lastNameTwo?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	user: InviteUserUser;
	weddingDate?: Maybe<Scalars['String']['output']>;
};

export type InviteUserOrgUser = {
	__typename?: 'InviteUserOrgUser';
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	organization: InviteUserOrganization;
	phone?: Maybe<Scalars['String']['output']>;
	user: InviteUserUser;
};

export type InviteUserOrganization = {
	__typename?: 'InviteUserOrganization';
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	services: Array<Maybe<InviteUserOrganizationService>>;
	updatedAt: Scalars['String']['output'];
};

export type InviteUserOrganizationService = {
	__typename?: 'InviteUserOrganizationService';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type InviteUserUser = {
	__typename?: 'InviteUserUser';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	userType: UserType;
};

export type Invoice = {
	__typename?: 'Invoice';
	allowsGratuity: Scalars['Boolean']['output'];
	amountOutstanding?: Maybe<Scalars['Int']['output']>;
	approvedByPlanner?: Maybe<Scalars['Boolean']['output']>;
	archivedByClient?: Maybe<Scalars['Boolean']['output']>;
	archivedByVendor?: Maybe<Scalars['Boolean']['output']>;
	attachmentUrl?: Maybe<Scalars['String']['output']>;
	automatedRemindersEnabled: Scalars['Boolean']['output'];
	contact?: Maybe<Contact>;
	createdAt: Scalars['DateTime']['output'];
	discountAmount?: Maybe<Scalars['Int']['output']>;
	discountIsPercentage?: Maybe<Scalars['Boolean']['output']>;
	discountPercentage?: Maybe<Scalars['Float']['output']>;
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	emailNotificationGroup?: Maybe<EmailNotificationGroup>;
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	events?: Maybe<Array<Event>>;
	gratuityAmount: Scalars['Int']['output'];
	guestToken?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	invoiceTemplate?: Maybe<InvoiceTemplate>;
	isPastDue: Scalars['Boolean']['output'];
	lineItems: Array<LineItem>;
	notes?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	paymentInstallments: Array<PaymentInstallment>;
	quickPayment?: Maybe<QuickPayment>;
	sentAt?: Maybe<Scalars['DateTime']['output']>;
	sentByUser?: Maybe<OrgUser>;
	status: InvoiceStatus;
	title: Scalars['String']['output'];
	totalAmount: Scalars['Int']['output'];
	updatedAt: Scalars['DateTime']['output'];
	uploadAttachment?: Maybe<Scalars['String']['output']>;
	viewedByClient?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoiceEventsArgs = {
	last?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type InvoiceLineItemsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<LineItemWhereInput>;
};

export type InvoicePaymentInstallmentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<PaymentInstallmentWhereInput>;
};

export type InvoiceAutoPayUpdateCustomInput = {
	autoPay: Scalars['Boolean']['input'];
	scheduledPaymentMethod?: InputMaybe<Scalars['String']['input']>;
	/** We can allow guest access to auto-pay via this token */
	token?: InputMaybe<DocumentAccessTokenUniqueWhere>;
};

export type InvoiceCreateInput = {
	allowsGratuity?: InputMaybe<Scalars['Boolean']['input']>;
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	contact?: InputMaybe<ContactWhereUniqueInput>;
	discountAmount?: InputMaybe<Scalars['Int']['input']>;
	discountIsPercentage?: InputMaybe<Scalars['Boolean']['input']>;
	discountPercentage?: InputMaybe<Scalars['Float']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	invoiceTemplate?: InputMaybe<InvoiceTemplateConnectOneInput>;
	lineItems?: InputMaybe<Array<LineItemDataInput>>;
	notes?: InputMaybe<Scalars['String']['input']>;
	notificationGroupMembers?: InputMaybe<Array<Scalars['String']['input']>>;
	paymentInstallments?: InputMaybe<Array<PaymentInstallmentDataInput>>;
	title: Scalars['String']['input'];
	uploadAttachment?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceExportInput = {
	timeZone: Scalars['String']['input'];
	token?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceForDashboardStats = {
	__typename?: 'InvoiceForDashboardStats';
	amount: Scalars['String']['output'];
	clientEmail: Scalars['String']['output'];
	clientName: Scalars['String']['output'];
	datapointDate: Scalars['String']['output'];
	eventDate: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	invoice: Scalars['String']['output'];
	title: Scalars['String']['output'];
};

export type InvoiceForGetContractWhere = {
	__typename?: 'InvoiceForGetContractWhere';
	amountOutstanding?: Maybe<Scalars['Int']['output']>;
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	guestToken?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	paymentInstallments?: Maybe<Array<PaymentInstallmentsForGetContractWhere>>;
	status: InvoiceStatus;
	title: Scalars['String']['output'];
};

export type InvoiceForGetContractWherePaymentInstallmentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<PaymentInstallmentOrderByInputForGetContractWhere>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<PaymentInstallmentWhereInputForGetContractWhere>;
};

export type InvoiceForOfflinePaymentHistory = {
	__typename?: 'InvoiceForOfflinePaymentHistory';
	clientUser?: Maybe<ClientForOfflineHistory>;
	gratuityAmount?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	organization: OrganizationForOfflinePaymentHistory;
	title?: Maybe<Scalars['String']['output']>;
};

export type InvoiceForPaymentHistoryItem = {
	__typename?: 'InvoiceForPaymentHistoryItem';
	id?: Maybe<Scalars['String']['output']>;
	title?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceMetricType {
	Drafts = 'Drafts',
	Overdue = 'Overdue',
	Paid = 'Paid',
	Refunded = 'Refunded',
	Upcoming = 'Upcoming',
}

export type InvoiceOrOrganizationInput = {
	invoice?: InputMaybe<InvoiceWhereUniqueInput>;
	organization?: InputMaybe<OrganizationWhereUniqueInput>;
};

export type InvoiceOrStripeUser = Invoice | StripeUser;

export type InvoiceOrderByInput = {
	approvedByPlanner?: InputMaybe<SortOrderType>;
	archivedByClient?: InputMaybe<SortOrderType>;
	archivedByVendor?: InputMaybe<SortOrderType>;
	contact?: InputMaybe<ContactOrderByInput>;
	createdAt?: InputMaybe<SortOrderType>;
	discountAmount?: InputMaybe<SortOrderType>;
	discountIsPercentage?: InputMaybe<SortOrderType>;
	discountPercentage?: InputMaybe<SortOrderType>;
	dueDate?: InputMaybe<SortOrderType>;
	eventDate?: InputMaybe<SortOrderType>;
	gratuityAmount?: InputMaybe<SortOrderType>;
	guestToken?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	isPastDue?: InputMaybe<SortOrderType>;
	quickPayment?: InputMaybe<QuickPaymentOrderByInput>;
	sentAt?: InputMaybe<SortOrderType>;
	sentByUser?: InputMaybe<OrgUserOrderByInput>;
	status?: InputMaybe<SortOrderType>;
	title?: InputMaybe<SortOrderType>;
	totalAmount?: InputMaybe<SortOrderType>;
	type?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
	uploadAttachment?: InputMaybe<SortOrderType>;
	viewedByClient?: InputMaybe<SortOrderType>;
};

export enum InvoiceStatus {
	Disputed = 'Disputed',
	Draft = 'Draft',
	FullyPaid = 'FullyPaid',
	FullyPaidPartiallyRefunded = 'FullyPaidPartiallyRefunded',
	FullyRefunded = 'FullyRefunded',
	Hidden = 'Hidden',
	PartiallyPaid = 'PartiallyPaid',
	Sent = 'Sent',
	Void = 'Void',
}

export type InvoiceTemplate = {
	__typename?: 'InvoiceTemplate';
	allowsGratuity: Scalars['Boolean']['output'];
	automatedRemindersEnabled: Scalars['Boolean']['output'];
	countOfConnectedInvoices: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	discountAmount: Scalars['Int']['output'];
	discountIsPercentage: Scalars['Boolean']['output'];
	discountPercentage: Scalars['Float']['output'];
	filename?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	invoices?: Maybe<Array<Invoice>>;
	lineItems: Array<InvoiceTemplateLineItem>;
	notes?: Maybe<Scalars['String']['output']>;
	organization: Organization;
	paymentInstallments: Array<InvoiceTemplatePaymentInstallment>;
	status: InvoiceTemplateStatus;
	title: Scalars['String']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceTemplateConnectOneInput = {
	connect: InvoiceTemplateWhereUniqueInput;
};

export type InvoiceTemplateCreateInput = {
	allowsGratuity: Scalars['Boolean']['input'];
	automatedRemindersEnabled: Scalars['Boolean']['input'];
	discountAmount: Scalars['Int']['input'];
	discountIsPercentage: Scalars['Boolean']['input'];
	discountPercentage: Scalars['Float']['input'];
	lineItems: Array<LineItemDataInput>;
	notes?: InputMaybe<Scalars['String']['input']>;
	paymentInstallments: Array<PaymentInstallmentDataInput>;
	title: Scalars['String']['input'];
};

export type InvoiceTemplateLineItem = {
	__typename?: 'InvoiceTemplateLineItem';
	amount: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	invoiceTemplate: InvoiceTemplate;
	name: Scalars['String']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	order: Scalars['Int']['output'];
	quantity: Scalars['Float']['output'];
	rate: Scalars['Int']['output'];
	taxPercentage: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceTemplateOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	title?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export type InvoiceTemplatePaymentInstallment = {
	__typename?: 'InvoiceTemplatePaymentInstallment';
	amountDue: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	enteredAsPercentageAmount: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	invoiceTemplate: InvoiceTemplate;
	name?: Maybe<Scalars['String']['output']>;
	percentageDue: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export enum InvoiceTemplateStatus {
	Active = 'Active',
	Deleted = 'Deleted',
}

export type InvoiceTemplateUpdateInput = {
	allowsGratuity: Scalars['Boolean']['input'];
	automatedRemindersEnabled: Scalars['Boolean']['input'];
	deleteAttachment?: InputMaybe<Scalars['Boolean']['input']>;
	discountAmount: Scalars['Int']['input'];
	discountIsPercentage: Scalars['Boolean']['input'];
	discountPercentage: Scalars['Float']['input'];
	lineItems: Array<LineItemDataInput>;
	notes?: InputMaybe<Scalars['String']['input']>;
	paymentInstallments: Array<PaymentInstallmentDataInput>;
	title: Scalars['String']['input'];
};

export type InvoiceTemplateWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type InvoiceTemplates = {
	__typename?: 'InvoiceTemplates';
	_count: Scalars['Int']['output'];
	invoiceTemplates: Array<InvoiceTemplate>;
};

export type InvoiceTemplatesWhereInput = {
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	createdBy?: InputMaybe<OrgUserWhereInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	organization?: InputMaybe<OrganizationWhereInput>;
	status?: InputMaybe<InvoiceTemplateStatus>;
	title?: InputMaybe<Scalars['String']['input']>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InvoiceTokenInput = {
	token: Scalars['String']['input'];
};

export type InvoiceUpdateInput = {
	allowsGratuity?: InputMaybe<Scalars['Boolean']['input']>;
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	contact?: InputMaybe<ContactWhereUniqueInput>;
	discountAmount?: InputMaybe<Scalars['Int']['input']>;
	discountIsPercentage?: InputMaybe<Scalars['Boolean']['input']>;
	discountPercentage?: InputMaybe<Scalars['Float']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	invoiceTemplate?: InputMaybe<InvoiceTemplateConnectOneInput>;
	lineItems?: InputMaybe<Array<LineItemDataInput>>;
	notes?: InputMaybe<Scalars['String']['input']>;
	notificationGroupMembers?: InputMaybe<Array<Scalars['String']['input']>>;
	paymentInstallments?: InputMaybe<Array<PaymentInstallmentDataInput>>;
	title?: InputMaybe<Scalars['String']['input']>;
	uploadAttachment?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceUrl = {
	__typename?: 'InvoiceUrl';
	url?: Maybe<Scalars['String']['output']>;
};

export type InvoiceWhereEventsInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type InvoiceWhereInput = {
	AND?: InputMaybe<Array<InvoiceWhereInput>>;
	NOT?: InputMaybe<Array<InvoiceWhereInput>>;
	OR?: InputMaybe<Array<InvoiceWhereInput>>;
	approvedByPlanner?: InputMaybe<Scalars['Boolean']['input']>;
	archivedByClient?: InputMaybe<Scalars['Boolean']['input']>;
	contact?: InputMaybe<ContactWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	discountAmount?: InputMaybe<Scalars['Int']['input']>;
	discountIsPercentage?: InputMaybe<Scalars['Boolean']['input']>;
	discountPercentage?: InputMaybe<Scalars['Float']['input']>;
	dueDate?: InputMaybe<Scalars['DateTime']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	events?: InputMaybe<InvoiceWhereEventsInput>;
	gratuityAmount?: InputMaybe<Scalars['Int']['input']>;
	guestToken?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
	lineItems?: InputMaybe<InvoiceWhereLineItemsInput>;
	metricDateRange?: InputMaybe<DashboardWhereInput>;
	metricType?: InputMaybe<InvoiceMetricType>;
	paymentInstallments?: InputMaybe<InvoiceWherePaymentInstallmentsInput>;
	sentAt?: InputMaybe<Scalars['DateTime']['input']>;
	sentByUser?: InputMaybe<OrgUserWhereInput>;
	some?: InputMaybe<InvoiceWhereInput>;
	status?: InputMaybe<InvoiceStatus>;
	title?: InputMaybe<Scalars['String']['input']>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	uploadAttachment?: InputMaybe<Scalars['String']['input']>;
	uploadAttachment_contains?: InputMaybe<Scalars['String']['input']>;
	viewedByClient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceWhereInputForGetContractWhere = {
	status?: InputMaybe<InvoiceStatus>;
};

export type InvoiceWhereInputWithGuestToken = {
	guestToken?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

export type InvoiceWhereLineItemsInput = {
	every?: InputMaybe<LineItemWhereInput>;
	none?: InputMaybe<LineItemWhereInput>;
	some?: InputMaybe<LineItemWhereInput>;
};

export type InvoiceWherePaymentInstallmentsInput = {
	every?: InputMaybe<PaymentInstallmentWhereInput>;
	none?: InputMaybe<PaymentInstallmentWhereInput>;
	some?: InputMaybe<PaymentInstallmentWhereInput>;
};

export type InvoiceWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type Invoices = {
	__typename?: 'Invoices';
	_count: Scalars['Int']['output'];
	invoices: Array<Invoice>;
};

export type InvoicesForCustomer = {
	__typename?: 'InvoicesForCustomer';
	_count: Scalars['Int']['output'];
	invoices: Array<Invoice>;
};

export type JustEmail = {
	__typename?: 'JustEmail';
	email: Scalars['String']['output'];
};

export type JustUserWithEmail = {
	__typename?: 'JustUserWithEmail';
	user: JustEmail;
};

export type LeadFormPresentationalData = {
	__typename?: 'LeadFormPresentationalData';
	apiKey: Scalars['String']['output'];
	organization: LeadFormPresentationalDataOrganization;
};

export type LeadFormPresentationalDataOrganization = {
	__typename?: 'LeadFormPresentationalDataOrganization';
	contactEmail?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	imagePositionX?: Maybe<Scalars['Float']['output']>;
	imagePositionY?: Maybe<Scalars['Float']['output']>;
	imageRotation?: Maybe<Scalars['Int']['output']>;
	imageScale?: Maybe<Scalars['Int']['output']>;
	name: Scalars['String']['output'];
	phone?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type LineItem = {
	__typename?: 'LineItem';
	amount: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	invoice: Invoice;
	name: Scalars['String']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	order: Scalars['Int']['output'];
	quantity: Scalars['Float']['output'];
	rate: Scalars['Int']['output'];
	taxPercentage: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type LineItemDataInput = {
	id?: InputMaybe<Scalars['ID']['input']>;
	name: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	order: Scalars['Int']['input'];
	quantity: Scalars['Float']['input'];
	rate: Scalars['Int']['input'];
	taxPercentage: Scalars['Float']['input'];
};

export type LineItemWhereInput = {
	AND?: InputMaybe<Array<LineItemWhereInput>>;
	NOT?: InputMaybe<Array<LineItemWhereInput>>;
	OR?: InputMaybe<Array<LineItemWhereInput>>;
	amount?: InputMaybe<Scalars['Int']['input']>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	invoice?: InputMaybe<InvoiceWhereInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	quantity?: InputMaybe<Scalars['Int']['input']>;
	rate?: InputMaybe<Scalars['Int']['input']>;
	taxPercentage?: InputMaybe<Scalars['Decimal']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarkupUrl = {
	__typename?: 'MarkupUrl';
	url: Scalars['String']['output'];
};

export type MessageContactOrgLeadInput = {
	message: Scalars['String']['input'];
};

export type MfaTokenInput = {
	contractId?: InputMaybe<Scalars['String']['input']>;
	email?: InputMaybe<Scalars['String']['input']>;
	mfaToken?: InputMaybe<Scalars['Int']['input']>;
	userId?: InputMaybe<Scalars['String']['input']>;
};

export type MoveFolderCustomInput = {
	parentFolder: FolderCreateOneWithoutParentFolderInput;
};

export type Mutation = {
	__typename?: 'Mutation';
	acceptProposal: Proposal;
	activateContact: Contact;
	activateProposalTemplate: ProposalTemplate;
	addOrganizationToGroup: TestingGroup;
	addUserToGroup: TestingGroup;
	approveContract: CustomContract;
	approveInvoice: Invoice;
	assignMemberToContact: Contact;
	assignPlannerPermissions: Contact;
	blockUser: Scalars['Boolean']['output'];
	bulkImportContacts: BulkImportResult;
	cancelContact: Contact;
	cancelVendorStripeSubscription: SubscriptionObject;
	changePassword: Scalars['Boolean']['output'];
	changeVendorSubscription: SubscriptionObjectOrRedirect;
	configureWebhookEndpoint: WebhookEndpointSecretResult;
	convertInquiry: Inquiry;
	copyDocumentFromCompanyFolderToCustomerFolder: Document;
	createCanvaDesignForProposal: Proposal;
	createCanvaDesignForProposalTemplate: ProposalTemplate;
	createClientUser: ClientUser;
	createContactAsClient: Contact;
	createContactAsVendor: Contact;
	createContract: CustomContract;
	createContractMarkupUrl: MarkupUrl;
	createContractSigningUrl: SigningUrl;
	createContractTemplate: ContractTemplate;
	createContractTemplateMarkupUrl: Scalars['String']['output'];
	createCoupon: Coupon;
	createCustomerStripeBankAccount: Source;
	createCustomerStripeCard: SourceOrRedirect;
	createDocument: Document;
	createDraftInvoice: Invoice;
	createExternalAccount?: Maybe<Source>;
	createFolder?: Maybe<CustomFolder>;
	createInquiry: Inquiry;
	createInquiryForm: InquiryForm;
	createIntentForInvoicePayment: PaymentIntent;
	createIntentForQuickPayment: PaymentIntent;
	createInvitation: Invitation;
	createInvoiceTemplate: InvoiceTemplate;
	createMfaToken: Scalars['Boolean']['output'];
	createOrGetQuickPaymentLink: QuickPaymentLink;
	createOrUpdateContactForCustomer: Contact;
	createOrgUser: OrgUser;
	createOrganization: Organization;
	createProposal: Proposal;
	createProposalTemplate: ProposalTemplate;
	createResource: CustomResource;
	createSecretsForInvoicePayment: PaymentSessionSecrets;
	createSecretsForQuickPayment: PaymentSessionSecrets;
	createService: Service;
	createSetupIntentForPaymentMethod: CreateSetupIntentForPaymentMethodResponse;
	createSponsor: CustomSponsor;
	createStripeAccountSession: Scalars['String']['output'];
	createStripeConnectAccount?: Maybe<StripeConnectAccount>;
	createStripeConnectAccountPerson: StripePerson;
	createStripePlan: StripePlan;
	createVendorStripeCard: SourceOrRedirect;
	createVendorStripeSubscription: SubscriptionObjectOrRedirect;
	createVerificationToken?: Maybe<Scalars['Boolean']['output']>;
	deactivateProposalTemplate: ProposalTemplate;
	declineContact: Contact;
	deleteContact: Scalars['Boolean']['output'];
	deleteContractTemplate: ContractTemplate;
	deleteCustomerStripePaymentSource: StripeUser;
	deleteDocument: Scalars['Boolean']['output'];
	deleteFolders: Scalars['Boolean']['output'];
	deleteInquiry: Scalars['Boolean']['output'];
	deleteInvitation: PendingInvitations;
	deleteInvoiceTemplate: InvoiceTemplate;
	deleteProposalTemplate: ProposalTemplate;
	deleteQuickPayment: QuickPayment;
	deleteResource: Scalars['Boolean']['output'];
	deleteService?: Maybe<Service>;
	deleteSponsor: Scalars['Boolean']['output'];
	deleteWebhookEndpoint: Scalars['Boolean']['output'];
	disableOrgMember: Organization;
	dismissAllEvents: Scalars['Boolean']['output'];
	dismissEvent: Scalars['Boolean']['output'];
	duplicateContractTemplate: ContractTemplate;
	forceEmailVerification?: Maybe<User>;
	logout: Scalars['Boolean']['output'];
	markInvoiceVoid: Invoice;
	markOrganizationFraudulent: Scalars['Boolean']['output'];
	markUserOnboardingComplete: Scalars['Boolean']['output'];
	mergeInquiryIntoContact: Contact;
	messageContactOrLead: Scalars['Boolean']['output'];
	moveDocuments: Array<Document>;
	moveFolders: Array<CustomFolder>;
	payOpenSubscriptionInvoices: Scalars['Boolean']['output'];
	privilegedAdvanceTimeForSubscriptionTesting: Scalars['Boolean']['output'];
	privilegedCancelVendorStripeSubscription: SubscriptionObject;
	privilegedChangeVendorStripeSubscription: SubscriptionObjectOrRedirect;
	privilegedCreateVendorStripeSubscription: SubscriptionObjectOrRedirect;
	privilegedMakeOrganizationPayable: Scalars['Boolean']['output'];
	privilegedPrepareOrganizationForSubscriptionTesting: Organization;
	privilegedUpdateOrganization?: Maybe<Scalars['Boolean']['output']>;
	privilegedUpdateOrganizationNotificationGroups: Array<EmailNotificationGroup>;
	privilegedUpdateWebhookEndpointEnabled: WebhookEndpoint;
	reactivateOrgMember: Organization;
	recordDocumentUploaded: Document;
	recordOfflinePayment: Invoice;
	refreshCanvaExportForProposal: Proposal;
	refreshCanvaExportForProposalTemplate: ProposalTemplate;
	refreshDocumentAccessToken: Scalars['String']['output'];
	refundInstallment: Invoice;
	refundOfflinePayment: Invoice;
	registerCouponUsage: Coupon;
	removeAllPlannerPermissions: Scalars['Boolean']['output'];
	removeOrganizationFromGroup: TestingGroup;
	removeUserFromGroup: TestingGroup;
	renameFolder?: Maybe<CustomFolder>;
	reportContractMarkup: ContractForGetContractWhere;
	reportContractSigning: ContractForGetContractWhere;
	reportQuickPaymentFromCustomerSession: Invoice;
	reportTemplateMarkup: ContractTemplate;
	requestClientEventDateChange: Scalars['Boolean']['output'];
	requestContactActivation: Contact;
	requestInvoiceTemplateAttachmentUploadUrl: UploadUrl;
	requestPlannerPermissions: Scalars['Boolean']['output'];
	requestProposalFileUploadUrl: UploadUrl;
	requestProposalTemplateFileUploadUrl: UploadUrl;
	requestReset: Scalars['Boolean']['output'];
	requestStripeCapabilities: Scalars['String']['output'];
	resendContract: Scalars['Boolean']['output'];
	resendVerificationEmail?: Maybe<Scalars['Boolean']['output']>;
	resendVerificationEmailToUser?: Maybe<Scalars['Boolean']['output']>;
	resendWebhookDelivery: Scalars['Boolean']['output'];
	resetPassword: Scalars['Boolean']['output'];
	revokeCanvaToken: Scalars['Boolean']['output'];
	rotateWebhookSecret: WebhookEndpointSecretResult;
	saveCanvaAuthorizationTokens: OAuthAccessToken;
	sendCalendarInvite: Scalars['Boolean']['output'];
	sendOrResendInvoice: Invoice;
	sendProposal: Proposal;
	setTeamMemberRole: Organization;
	shareDocument: Document;
	stripe3DSecureChallengeComplete: InvoiceOrStripeUser;
	submitInquiry: Scalars['Boolean']['output'];
	submitInquiryFromIntegration: Scalars['Boolean']['output'];
	toggleContractArchiveState: CustomContract;
	unblockUser: Scalars['Boolean']['output'];
	unblockUserEmailInSendgrid: Scalars['Boolean']['output'];
	unrecordOfflinePaymentOrRefund: Invoice;
	updateClientUser: ClientUser;
	updateContact: Contact;
	updateContactStatus: Contact;
	updateContract: ContractForGetContractWhere;
	updateContractTemplate: ContractTemplate;
	updateCoupon: Coupon;
	updateCustomerStripeBankAccount: StripeUser;
	updateCustomerStripeCard: StripeUser;
	updateDocument: Document;
	updateDocumentName?: Maybe<Document>;
	updateEmailAddress: Scalars['Boolean']['output'];
	updateEmailAddressForUser?: Maybe<User>;
	updateExternalAccount?: Maybe<Source>;
	updateInquiry: Inquiry;
	updateInquiryForm: InquiryForm;
	updateInvoice?: Maybe<Invoice>;
	updateInvoiceAutoPay: Invoice;
	updateInvoiceFromPaymentSession: Invoice;
	updateInvoiceTemplate: InvoiceTemplate;
	updateNoteOnContact?: Maybe<Contact>;
	updateOrgUser?: Maybe<OrgUser>;
	updateOrganization?: Maybe<Organization>;
	updateOrganizationNotificationGroups: Array<EmailNotificationGroup>;
	updateOrganizationPaymentCapacity?: Maybe<Organization>;
	updatePaidInstallment: Invoice;
	updateProposal: Proposal;
	updateProposalTemplate: ProposalTemplate;
	updateRefundedInstallment: Invoice;
	updateResource: CustomResource;
	updateSelf: User;
	updateSponsor: CustomSponsor;
	updateStripeConnectAccount?: Maybe<StripeConnectAccount>;
	updateStripeConnectAccountPerson: StripePerson;
	updateVendorDashboardConfiguration: User;
	updateVendorFeeStructure: Organization;
	updateVendorStripeCard: StripeUser;
	updateWebhookSubscriptions: Array<WebhookEventType>;
	validateRecaptcha: Scalars['Boolean']['output'];
	verifyCustomerStripeBankAccount: Scalars['Boolean']['output'];
	verifyEmailAccount: Scalars['Boolean']['output'];
	verifyResourcePreview: Resource;
	verifySponsorLogo: Sponsor;
	viewDocument: Document;
	voidAndPortContract: CustomContract;
	voidContract: CustomContract;
	voidProposal: Proposal;
};

export type MutationAcceptProposalArgs = {
	where: ProposalWhereInput;
};

export type MutationActivateContactArgs = {
	data?: InputMaybe<ActivateContactCustomInput>;
	where: ContactWhereUniqueInput;
};

export type MutationActivateProposalTemplateArgs = {
	where: ProposalTemplateWhereUniqueInput;
};

export type MutationAddOrganizationToGroupArgs = {
	data: OrganizationWhereUniqueInput;
	where: TestingGroupWhereUniqueInput;
};

export type MutationAddUserToGroupArgs = {
	data: UserWhereUniqueInput;
	where: TestingGroupWhereUniqueInput;
};

export type MutationApproveContractArgs = {
	where: ContractWhereUniqueInput;
};

export type MutationApproveInvoiceArgs = {
	where: InvoiceWhereInputWithGuestToken;
};

export type MutationAssignMemberToContactArgs = {
	data: OrgUserWhereUniqueInput;
	where: ContactWhereUniqueInput;
};

export type MutationAssignPlannerPermissionsArgs = {
	data: PermissionInput;
	where: ContactWhereUniqueInput;
};

export type MutationBlockUserArgs = {
	where: BlockUserWhereInputType;
};

export type MutationBulkImportContactsArgs = {
	data: BulkImportContactsInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationCancelContactArgs = {
	where: ContactWhereUniqueInput;
};

export type MutationChangePasswordArgs = {
	data: PasswordChangeInput;
};

export type MutationChangeVendorSubscriptionArgs = {
	data: StripeVendorSubscriptionChangeInput;
};

export type MutationConfigureWebhookEndpointArgs = {
	data: WebhookEndpointInput;
};

export type MutationConvertInquiryArgs = {
	where: InquiryWhereUniqueInput;
};

export type MutationCopyDocumentFromCompanyFolderToCustomerFolderArgs = {
	data: ContactWhereUniqueInput;
	where: DocumentWhereUniqueInput;
};

export type MutationCreateCanvaDesignForProposalArgs = {
	data: CanvaDesignInput;
};

export type MutationCreateCanvaDesignForProposalTemplateArgs = {
	data: CanvaDesignForProposalTemplateInput;
};

export type MutationCreateClientUserArgs = {
	data: ClientUserCreateInput;
};

export type MutationCreateContactAsClientArgs = {
	data: OrganizationWhereUniqueInput;
	where: UserByIdUniqueInput;
};

export type MutationCreateContactAsVendorArgs = {
	data: CreateContactDataInput;
	where: UserByEmailUniqueInput;
};

export type MutationCreateContractArgs = {
	data: ContractCreateCustomInput;
};

export type MutationCreateContractMarkupUrlArgs = {
	where: ContractWhereUniqueInput;
};

export type MutationCreateContractSigningUrlArgs = {
	where: CreateContractSigningUrlInput;
};

export type MutationCreateContractTemplateArgs = {
	data: ContractTemplateCreateInput;
};

export type MutationCreateContractTemplateMarkupUrlArgs = {
	data: CreateContractTemplateMarkupUrlInput;
	where: ContractTemplateWhereUniqueInput;
};

export type MutationCreateCouponArgs = {
	data: CouponCreateReducedInput;
};

export type MutationCreateCustomerStripeBankAccountArgs = {
	data: StripeBankAccountCreationInput;
	where: UserByIdUniqueInput;
};

export type MutationCreateCustomerStripeCardArgs = {
	data: StripeCardCreationInput;
};

export type MutationCreateDocumentArgs = {
	data: DocumentCreateCustomInput;
};

export type MutationCreateDraftInvoiceArgs = {
	data: InvoiceCreateInput;
};

export type MutationCreateExternalAccountArgs = {
	data: StripeBankAccountSourceInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationCreateFolderArgs = {
	data: FolderCreateCustomInput;
};

export type MutationCreateInquiryArgs = {
	data: InquiryCreateInput;
};

export type MutationCreateInquiryFormArgs = {
	data: InquiryFormDataInput;
};

export type MutationCreateIntentForInvoicePaymentArgs = {
	data: CreateIntentForInvoicePaymentInput;
};

export type MutationCreateIntentForQuickPaymentArgs = {
	data: CreateIntentForQuickPaymentInput;
};

export type MutationCreateInvitationArgs = {
	data: InvitationCustomCreateInput;
};

export type MutationCreateInvoiceTemplateArgs = {
	data: InvoiceTemplateCreateInput;
};

export type MutationCreateMfaTokenArgs = {
	data: MfaTokenInput;
};

export type MutationCreateOrGetQuickPaymentLinkArgs = {
	data: QuickPaymentLinkCreateInput;
};

export type MutationCreateOrUpdateContactForCustomerArgs = {
	data: CreateOrUpdateContactForCustomerDataInput;
	where: CreateOrUpdateContactForCustomerWhereInput;
};

export type MutationCreateOrgUserArgs = {
	data: OrgUserCreationInput;
};

export type MutationCreateOrganizationArgs = {
	data: OrganizationCustomCreateInput;
};

export type MutationCreateProposalArgs = {
	data: ProposalCreateInput;
};

export type MutationCreateProposalTemplateArgs = {
	data: ProposalTemplateCreateInput;
};

export type MutationCreateResourceArgs = {
	data: RetoolResourceCreateInput;
};

export type MutationCreateSecretsForInvoicePaymentArgs = {
	data: CreateSecretsForInvoicePaymentInput;
};

export type MutationCreateSecretsForQuickPaymentArgs = {
	data: CreateSecretsForQuickPaymentInput;
};

export type MutationCreateServiceArgs = {
	data: ServiceCreateInput;
};

export type MutationCreateSetupIntentForPaymentMethodArgs = {
	data: CreateSetupIntentForPaymentMethodInput;
};

export type MutationCreateSponsorArgs = {
	data: RetoolSponsorCreateInput;
};

export type MutationCreateStripeConnectAccountArgs = {
	data: StripeConnectAccountCreationInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationCreateStripeConnectAccountPersonArgs = {
	data: StripePersonInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationCreateStripePlanArgs = {
	data: StripePlanCreationInput;
};

export type MutationCreateVendorStripeCardArgs = {
	data: StripeVendorCardCreationInput;
};

export type MutationCreateVendorStripeSubscriptionArgs = {
	data: StripeVendorSubscriptionCreationInput;
};

export type MutationCreateVerificationTokenArgs = {
	data: CreateVerificationTokenInput;
};

export type MutationDeactivateProposalTemplateArgs = {
	where: ProposalTemplateWhereUniqueInput;
};

export type MutationDeclineContactArgs = {
	where: ContactWhereUniqueInput;
};

export type MutationDeleteContactArgs = {
	where: ContactWhereUniqueInput;
};

export type MutationDeleteContractTemplateArgs = {
	where: ContractTemplateWhereUniqueInput;
};

export type MutationDeleteCustomerStripePaymentSourceArgs = {
	where: StripeBankAccountDeletionInput;
};

export type MutationDeleteDocumentArgs = {
	where: DocumentWhereUniqueInput;
};

export type MutationDeleteFoldersArgs = {
	where: FoldersWhereCustomInput;
};

export type MutationDeleteInquiryArgs = {
	where: InquiryWhereUniqueInput;
};

export type MutationDeleteInvitationArgs = {
	where: InvitationWhereCustomInput;
};

export type MutationDeleteInvoiceTemplateArgs = {
	where: InvoiceTemplateWhereUniqueInput;
};

export type MutationDeleteProposalTemplateArgs = {
	where: ProposalTemplateWhereUniqueInput;
};

export type MutationDeleteQuickPaymentArgs = {
	where: QuickPaymentWhereUniqueInput;
};

export type MutationDeleteResourceArgs = {
	where: ResourceWhereUniqueInput;
};

export type MutationDeleteServiceArgs = {
	where: ServiceWhereUniqueInput;
};

export type MutationDeleteSponsorArgs = {
	where: SponsorWhereUniqueInput;
};

export type MutationDeleteWebhookEndpointArgs = {
	endpointId: Scalars['ID']['input'];
};

export type MutationDisableOrgMemberArgs = {
	where: OrgUserWhereUniqueInput;
};

export type MutationDismissEventArgs = {
	where: EventWhereUniqueInput;
};

export type MutationDuplicateContractTemplateArgs = {
	where: ContractTemplateWhereUniqueInput;
};

export type MutationForceEmailVerificationArgs = {
	email: Scalars['String']['input'];
};

export type MutationMarkInvoiceVoidArgs = {
	where: InvoiceWhereUniqueInput;
};

export type MutationMarkOrganizationFraudulentArgs = {
	where: OrganizationWhereUniqueInput;
};

export type MutationMergeInquiryIntoContactArgs = {
	where: InquiryMergeInput;
};

export type MutationMessageContactOrLeadArgs = {
	data: MessageContactOrgLeadInput;
	where: ContactOrLeadInput;
};

export type MutationMoveDocumentsArgs = {
	data: FolderWhereUniqueInput;
	where: DocumentsWhereCustomInput;
};

export type MutationMoveFoldersArgs = {
	data?: InputMaybe<MoveFolderCustomInput>;
	where: FoldersWhereCustomInput;
};

export type MutationPrivilegedAdvanceTimeForSubscriptionTestingArgs = {
	days: Scalars['Int']['input'];
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedCancelVendorStripeSubscriptionArgs = {
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedChangeVendorStripeSubscriptionArgs = {
	data: PrivilegedStripeVendorSubscriptionChangeInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedCreateVendorStripeSubscriptionArgs = {
	data: PrivilegedStripeVendorSubscriptionChangeInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedMakeOrganizationPayableArgs = {
	data: PrivilegedMakeOrganizationPayableDataInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedPrepareOrganizationForSubscriptionTestingArgs = {
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedUpdateOrganizationArgs = {
	data: OrganizationPrivilegedUpdateInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedUpdateOrganizationNotificationGroupsArgs = {
	data: EmailNotificationGroupsInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationPrivilegedUpdateWebhookEndpointEnabledArgs = {
	enabled: Scalars['Boolean']['input'];
	endpointId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationReactivateOrgMemberArgs = {
	where: OrgUserWhereUniqueInput;
};

export type MutationRecordDocumentUploadedArgs = {
	where: DocumentWhereUniqueInput;
};

export type MutationRecordOfflinePaymentArgs = {
	data: RecordOfflinePaymentInput;
	where: PaymentInstallmentWhereUniqueInput;
};

export type MutationRefreshCanvaExportForProposalArgs = {
	where: CanvaDesignWhereUniqueInput;
};

export type MutationRefreshCanvaExportForProposalTemplateArgs = {
	where: CanvaDesignWhereUniqueInput;
};

export type MutationRefreshDocumentAccessTokenArgs = {
	where: DocumentAccessTokenUniqueWhere;
};

export type MutationRefundInstallmentArgs = {
	data: RefundInstallmentInput;
};

export type MutationRefundOfflinePaymentArgs = {
	data: RecordOfflineRefundInput;
	where: PaymentInstallmentWhereUniqueInput;
};

export type MutationRegisterCouponUsageArgs = {
	data: RegisterCouponUsageWhere;
	where: OrganizationWhereUniqueInput;
};

export type MutationRemoveAllPlannerPermissionsArgs = {
	where: ClientUserWhereUniqueInput;
};

export type MutationRemoveOrganizationFromGroupArgs = {
	data: OrganizationWhereUniqueInput;
	where: TestingGroupWhereUniqueInput;
};

export type MutationRemoveUserFromGroupArgs = {
	data: UserWhereUniqueInput;
	where: TestingGroupWhereUniqueInput;
};

export type MutationRenameFolderArgs = {
	data: UpdateFolderNameInput;
	where: FolderWhereUniqueInput;
};

export type MutationReportContractMarkupArgs = {
	data: ReportInput;
	where: ContractWhereUniqueInput;
};

export type MutationReportContractSigningArgs = {
	data: ReportContractSigningInput;
	where: ContractWhereInputWithMfaToken;
};

export type MutationReportQuickPaymentFromCustomerSessionArgs = {
	data: ReportQuickPaymentFromCustomerSessionInput;
};

export type MutationReportTemplateMarkupArgs = {
	where: ContractTemplateWhereUniqueInput;
};

export type MutationRequestClientEventDateChangeArgs = {
	where: ClientUserWhereUniqueInput;
};

export type MutationRequestContactActivationArgs = {
	where: ContactWhereUniqueInput;
};

export type MutationRequestInvoiceTemplateAttachmentUploadUrlArgs = {
	data: RequestAttachmentUploadUrlInput;
	where: InvoiceTemplateWhereUniqueInput;
};

export type MutationRequestPlannerPermissionsArgs = {
	where: ContactWhereUniqueInput;
};

export type MutationRequestProposalFileUploadUrlArgs = {
	data: RequestAttachmentUploadUrlInput;
	where: ProposalWhereUniqueInput;
};

export type MutationRequestProposalTemplateFileUploadUrlArgs = {
	data: RequestAttachmentUploadUrlInput;
	where: ProposalTemplateWhereUniqueInput;
};

export type MutationRequestResetArgs = {
	data: PasswordResetRequestInput;
};

export type MutationRequestStripeCapabilitiesArgs = {
	where: OrganizationWhereUniqueInput;
};

export type MutationResendContractArgs = {
	data?: InputMaybe<ContractResendInput>;
	where: ContractWhereUniqueInput;
};

export type MutationResendVerificationEmailToUserArgs = {
	email: Scalars['String']['input'];
};

export type MutationResendWebhookDeliveryArgs = {
	deliveryId: Scalars['ID']['input'];
};

export type MutationResetPasswordArgs = {
	data: PasswordResetInput;
};

export type MutationRotateWebhookSecretArgs = {
	endpointId: Scalars['ID']['input'];
};

export type MutationSaveCanvaAuthorizationTokensArgs = {
	data: CanvaTokenResponseInput;
};

export type MutationSendCalendarInviteArgs = {
	customizedEmail?: InputMaybe<CalendarInviteCustomizedEmailInput>;
	recipientEmails: Array<Scalars['String']['input']>;
	sourceId: Scalars['String']['input'];
	sourceType: CalendarSourceType;
};

export type MutationSendOrResendInvoiceArgs = {
	data?: InputMaybe<SendOrResendInvoiceInput>;
	where: InvoiceWhereUniqueInput;
};

export type MutationSendProposalArgs = {
	data?: InputMaybe<SendProposalInput>;
	where: ProposalWhereUniqueInput;
};

export type MutationSetTeamMemberRoleArgs = {
	data: TeamMemberRole;
	where: OrgUserWhereUniqueInput;
};

export type MutationShareDocumentArgs = {
	data: CustomShareDocumentInput;
	where: DocumentWhereUniqueInput;
};

export type MutationStripe3DSecureChallengeCompleteArgs = {
	data: StripePaymentOrSetupIntentStatus;
	where?: InputMaybe<InvoiceOrOrganizationInput>;
};

export type MutationSubmitInquiryArgs = {
	data: InquirySubmissionInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationSubmitInquiryFromIntegrationArgs = {
	data: SubmitInquiryFromIntegrationInput;
};

export type MutationToggleContractArchiveStateArgs = {
	where: ContractWhereUniqueInput;
};

export type MutationUnblockUserArgs = {
	where: BlockUserWhereInputType;
};

export type MutationUnblockUserEmailInSendgridArgs = {
	where: UnblockUserEmailInSendgridInput;
};

export type MutationUnrecordOfflinePaymentOrRefundArgs = {
	data: RecordOfflinePaymentOrRefundInput;
	where: PaymentInstallmentWhereUniqueInput;
};

export type MutationUpdateClientUserArgs = {
	data: ClientUserUpdateCustomInput;
	where: ClientUserWhereUniqueInput;
};

export type MutationUpdateContactArgs = {
	data: CustomContactUpdateInput;
	where: ContactWhereUniqueInput;
};

export type MutationUpdateContactStatusArgs = {
	data: UpdateContactStatusDataInput;
	where: ContactWhereUniqueInput;
};

export type MutationUpdateContractArgs = {
	data: ContractUpdateInput;
	where: ContractWhereUniqueInput;
};

export type MutationUpdateContractTemplateArgs = {
	data: ContractTemplateCustomUpdateInput;
	where: ContractTemplateWhereUniqueInput;
};

export type MutationUpdateCouponArgs = {
	data: CouponUpdateInput;
	where: CouponWhereUniqueInput;
};

export type MutationUpdateCustomerStripeBankAccountArgs = {
	data: StripeBankAccountUpdateInput;
	where: StripeBankAccountDeletionInput;
};

export type MutationUpdateCustomerStripeCardArgs = {
	data: CustomerStripeCardUpdateInput;
	where: UpdateCustomerStripeCardWhereInput;
};

export type MutationUpdateDocumentArgs = {
	data: UpdateDocumentInput;
	where: DocumentWhereUniqueInput;
};

export type MutationUpdateDocumentNameArgs = {
	data: UpdateDocumentNameInput;
	where: DocumentWhereUniqueInput;
};

export type MutationUpdateEmailAddressArgs = {
	data: EmailAddressUpdateInput;
	where: EmailAddressInput;
};

export type MutationUpdateEmailAddressForUserArgs = {
	newEmail: Scalars['String']['input'];
	oldEmail: Scalars['String']['input'];
};

export type MutationUpdateExternalAccountArgs = {
	data: StripeExternalAccountUpdateInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationUpdateInquiryArgs = {
	data: InquiryUpdateDataInput;
	where: InquiryWhereUniqueInput;
};

export type MutationUpdateInquiryFormArgs = {
	data: InquiryFormDataInput;
};

export type MutationUpdateInvoiceArgs = {
	data: InvoiceUpdateInput;
	where: InvoiceWhereUniqueInput;
};

export type MutationUpdateInvoiceAutoPayArgs = {
	data: InvoiceAutoPayUpdateCustomInput;
	where: InvoiceWhereUniqueInput;
};

export type MutationUpdateInvoiceFromPaymentSessionArgs = {
	data: UpdateInvoiceFromPaymentSessionInput;
};

export type MutationUpdateInvoiceTemplateArgs = {
	data: InvoiceTemplateUpdateInput;
	where: InvoiceTemplateWhereUniqueInput;
};

export type MutationUpdateNoteOnContactArgs = {
	data: NoteInput;
	where: ContactWhereUniqueInput;
};

export type MutationUpdateOrgUserArgs = {
	data: OrgUserUpdateCustomInput;
	where: OrgUserWhereUniqueInput;
};

export type MutationUpdateOrganizationArgs = {
	data: OrganizationCustomUpdateInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationUpdateOrganizationNotificationGroupsArgs = {
	data: EmailNotificationGroupsInput;
};

export type MutationUpdateOrganizationPaymentCapacityArgs = {
	data: OrganizationPaymentCapacityUpdateInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationUpdatePaidInstallmentArgs = {
	data: UpdatePaidInstallmentInput;
	where: PaymentInstallmentWhereUniqueInput;
};

export type MutationUpdateProposalArgs = {
	data: ProposalUpdateInput;
	where: ProposalWhereUniqueInput;
};

export type MutationUpdateProposalTemplateArgs = {
	data: ProposalTemplateUpdateInput;
	where: ProposalTemplateWhereUniqueInput;
};

export type MutationUpdateRefundedInstallmentArgs = {
	data: UpdateRefundedInstallmentInput;
	where: PaymentInstallmentWhereUniqueInput;
};

export type MutationUpdateResourceArgs = {
	data: RetoolResourceUpdateInput;
	where: ResourceWhereUniqueInput;
};

export type MutationUpdateSelfArgs = {
	data: UserUpdateSelfInput;
};

export type MutationUpdateSponsorArgs = {
	data: RetoolSponsorUpdateInput;
	where: SponsorWhereUniqueInput;
};

export type MutationUpdateStripeConnectAccountArgs = {
	data: StripeConnectAccountUpdateInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationUpdateStripeConnectAccountPersonArgs = {
	data: StripePersonInput;
	where: OrganizationAndPersonInput;
};

export type MutationUpdateVendorDashboardConfigurationArgs = {
	data: VendorDashboardConfigurationInput;
};

export type MutationUpdateVendorFeeStructureArgs = {
	data: VendorFeeStructureInput;
	where: OrganizationWhereUniqueInput;
};

export type MutationUpdateVendorStripeCardArgs = {
	data: OrganizationStripeCardUpdateInput;
};

export type MutationUpdateWebhookSubscriptionsArgs = {
	data: UpdateWebhookSubscriptionsInput;
};

export type MutationValidateRecaptchaArgs = {
	token: Scalars['String']['input'];
};

export type MutationVerifyCustomerStripeBankAccountArgs = {
	data: CustomerBankAccountVerificationInput;
	where: UserWhereUniqueInput;
};

export type MutationVerifyEmailAccountArgs = {
	where: VerificationTokenWhereUniqueInput;
};

export type MutationVerifyResourcePreviewArgs = {
	update?: InputMaybe<Scalars['Boolean']['input']>;
	where: ResourceWhereUniqueInput;
};

export type MutationVerifySponsorLogoArgs = {
	update?: InputMaybe<Scalars['Boolean']['input']>;
	where: SponsorWhereUniqueInput;
};

export type MutationViewDocumentArgs = {
	where: DocumentWhereUniqueInput;
};

export type MutationVoidAndPortContractArgs = {
	where: ContractWhereUniqueInput;
};

export type MutationVoidContractArgs = {
	where: ContractWhereUniqueInput;
};

export type MutationVoidProposalArgs = {
	where: ProposalWhereUniqueInput;
};

export type NewExternalAccountUpdateInput = {
	account_number: Scalars['String']['input'];
	routing_number: Scalars['String']['input'];
};

export type NextCursor = {
	__typename?: 'NextCursor';
	paymentMethod?: Maybe<Scalars['String']['output']>;
	source?: Maybe<Scalars['String']['output']>;
};

export type NoteInput = {
	note: Scalars['String']['input'];
};

export type OAuthAccessToken = {
	__typename?: 'OAuthAccessToken';
	accessToken: Scalars['String']['output'];
	expires: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
};

export type OfflinePaymentHistory = {
	__typename?: 'OfflinePaymentHistory';
	offlinePaymentHistoryItems: Array<Maybe<OfflinePaymentHistoryItem>>;
};

export type OfflinePaymentHistoryAfterInput = {
	paymentAfter?: InputMaybe<Scalars['ID']['input']>;
	refundAfter?: InputMaybe<Scalars['ID']['input']>;
};

export type OfflinePaymentHistoryItem = {
	__typename?: 'OfflinePaymentHistoryItem';
	amount?: Maybe<Scalars['Int']['output']>;
	date?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	invoice: InvoiceForOfflinePaymentHistory;
	name?: Maybe<Scalars['String']['output']>;
	paymentType?: Maybe<PaymentType>;
	type: OfflinePaymentHistoryItemType;
};

export enum OfflinePaymentHistoryItemType {
	Payment = 'Payment',
	Refund = 'Refund',
}

export type OrgDashboardStats = {
	__typename?: 'OrgDashboardStats';
	clients: Array<Contact>;
	clientsGraph: DatePointsComparison;
	contractsCompleted: Array<CustomContract>;
	contractsCompletedGraph: DatePointsComparison;
	contractsOutstanding: Array<CustomContract>;
	contractsSummary: ContractsSummary;
	failedPayments: FailedPayments;
	leads: Array<Inquiry>;
	leadsGraph: DatePointsComparison;
	newClients: Array<Contact>;
	overduePayments: OverduePayments;
	paymentsReceived: PaymentsReceived;
	paymentsReceivedGraph: DatePointsComparison;
	paymentsSummary: PaymentsSummary;
	proposalsAccepted: Array<Proposal>;
	proposalsAcceptedGraph: DatePointsComparison;
	proposalsOutstanding: Array<Proposal>;
	proposalsStatusSummary: ProposalsStatusSummary;
	topCustomersBySpend: Array<TopCustomerBySpend>;
	upcomingPayments: UpcomingPayments;
};

export enum OrgType {
	Planner = 'Planner',
	Vendor = 'Vendor',
}

export type OrgUser = {
	__typename?: 'OrgUser';
	assignedClients?: Maybe<Array<ClientUser>>;
	contacts?: Maybe<Array<Contact>>;
	contractTemplates?: Maybe<Array<ContractTemplate>>;
	createdAt: Scalars['DateTime']['output'];
	documents?: Maybe<Array<Document>>;
	events?: Maybe<Array<Event>>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	invitationID?: Maybe<Scalars['String']['output']>;
	lastName: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	phone?: Maybe<Scalars['String']['output']>;
	plannerEvents?: Maybe<Array<Event>>;
	role: TeamMemberRole;
	updatedAt: Scalars['DateTime']['output'];
	user?: Maybe<User>;
};

export type OrgUserAssignedClientsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ClientUserOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ClientUserWhereInput>;
};

export type OrgUserContactsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ContactOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContactWhereInput>;
};

export type OrgUserContractTemplatesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContractTemplateWhereInput>;
};

export type OrgUserDocumentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<DocumentWhereInput>;
};

export type OrgUserEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type OrgUserPlannerEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type OrgUserCreationInput = {
	acceptedTerms?: InputMaybe<Scalars['DateTime']['input']>;
	consentedToAgeAndMarketingEmails?: InputMaybe<Scalars['DateTime']['input']>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	invitationID?: InputMaybe<Scalars['String']['input']>;
	lastName: Scalars['String']['input'];
	password: Scalars['String']['input'];
	phone?: InputMaybe<Scalars['String']['input']>;
	role: TeamMemberRole;
	verificationTokenID?: InputMaybe<Scalars['String']['input']>;
};

export type OrgUserForActingUserOnEvent = {
	__typename?: 'OrgUserForActingUserOnEvent';
	firstName: Scalars['String']['output'];
	id: Scalars['String']['output'];
	lastName: Scalars['String']['output'];
	organization?: Maybe<OrganizationForActingUser>;
	user?: Maybe<ActingUserForEvent>;
};

export type OrgUserForGetContractWhere = {
	__typename?: 'OrgUserForGetContractWhere';
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	imagePositionX?: Maybe<Scalars['Float']['output']>;
	imagePositionY?: Maybe<Scalars['Float']['output']>;
	imageRotation?: Maybe<Scalars['Int']['output']>;
	imageScale?: Maybe<Scalars['Int']['output']>;
	lastName: Scalars['String']['output'];
	organization?: Maybe<OrganizationForGetContractWhere>;
	originalImage?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	user: BaseUserForGetContractWhere;
};

export type OrgUserForGetQuickPayment = {
	__typename?: 'OrgUserForGetQuickPayment';
	id: Scalars['ID']['output'];
	user: UserForGetQuickPayment;
};

export type OrgUserOrderByInput = {
	contacts?: InputMaybe<ContactOrderByInput>;
	createdAt?: InputMaybe<SortOrderType>;
	firstName?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	image?: InputMaybe<SortOrderType>;
	imagePositionX?: InputMaybe<SortOrderType>;
	imagePositionY?: InputMaybe<SortOrderType>;
	imageRotation?: InputMaybe<SortOrderType>;
	imageScale?: InputMaybe<SortOrderType>;
	invitationID?: InputMaybe<SortOrderType>;
	lastName?: InputMaybe<SortOrderType>;
	orderBy?: InputMaybe<OrgUserOrderByInput>;
	organization?: InputMaybe<OrganizationOrderByInput>;
	originalImage?: InputMaybe<SortOrderType>;
	phone?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export type OrgUserSignerForGetContractWhere = {
	__typename?: 'OrgUserSignerForGetContractWhere';
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
};

export type OrgUserUpdateCustomInput = {
	acceptedTerms?: InputMaybe<Scalars['DateTime']['input']>;
	consentedToAgeAndMarketingEmails?: InputMaybe<Scalars['DateTime']['input']>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Int']['input']>;
	imagePositionY?: InputMaybe<Scalars['Int']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	organization?: InputMaybe<OrganizationUpdateOneWithoutUsersInput>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	referral?: InputMaybe<ReferralCreateWithoutUserInput>;
};

export type OrgUserWhereAssignedClientsInput = {
	every?: InputMaybe<ClientUserWhereInput>;
	none?: InputMaybe<ClientUserWhereInput>;
	some?: InputMaybe<ClientUserWhereInput>;
};

export type OrgUserWhereContactsInput = {
	every?: InputMaybe<ContactWhereInput>;
	none?: InputMaybe<ContactWhereInput>;
	some?: InputMaybe<ContactWhereInput>;
};

export type OrgUserWhereContractTemplates = {
	every?: InputMaybe<ContractTemplateWhereInput>;
	none?: InputMaybe<ContractTemplateWhereInput>;
	some?: InputMaybe<ContractTemplateWhereInput>;
};

export type OrgUserWhereDocumentsInput = {
	every?: InputMaybe<DocumentWhereInput>;
	none?: InputMaybe<DocumentWhereInput>;
	some?: InputMaybe<DocumentWhereInput>;
};

export type OrgUserWhereEventsInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type OrgUserWhereInput = {
	AND?: InputMaybe<Array<OrgUserWhereInput>>;
	NOT?: InputMaybe<Array<OrgUserWhereInput>>;
	OR?: InputMaybe<Array<OrgUserWhereInput>>;
	assignedClients?: InputMaybe<OrgUserWhereAssignedClientsInput>;
	contacts?: InputMaybe<OrgUserWhereContactsInput>;
	contractTemplates?: InputMaybe<OrgUserWhereContractTemplates>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	documents?: InputMaybe<OrgUserWhereDocumentsInput>;
	events?: InputMaybe<OrgUserWhereEventsInput>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	firstName_contains?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Float']['input']>;
	imagePositionY?: InputMaybe<Scalars['Float']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	invitationID?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	lastName_contains?: InputMaybe<Scalars['String']['input']>;
	organization?: InputMaybe<OrganizationWhereInput>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	plannerEvents?: InputMaybe<OrgUserWherePlannerEventsInput>;
	role?: InputMaybe<TeamMemberRole>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	user?: InputMaybe<UserWhereInput>;
};

export type OrgUserWherePlannerEventsInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type OrgUserWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type OrgUsers = {
	__typename?: 'OrgUsers';
	_count: Scalars['Int']['output'];
	orgUsers: Array<OrgUser>;
};

export type Organization = {
	__typename?: 'Organization';
	achAppFeePercentage: Scalars['Decimal']['output'];
	achConvenienceFeePercentage: Scalars['Decimal']['output'];
	achFeeCap?: Maybe<Scalars['Int']['output']>;
	addressLine1?: Maybe<Scalars['String']['output']>;
	addressLine2?: Maybe<Scalars['String']['output']>;
	appSubscriptions?: Maybe<Array<Maybe<AppSubscription>>>;
	automatedRemindersEnabled: Scalars['Boolean']['output'];
	brandedEmails?: Maybe<Scalars['Boolean']['output']>;
	canReceivePayments: Scalars['Boolean']['output'];
	cardAppFeePercentage: Scalars['Decimal']['output'];
	cardConvenienceFeePercentage: Scalars['Decimal']['output'];
	city?: Maybe<Scalars['String']['output']>;
	contactEmail?: Maybe<Scalars['String']['output']>;
	contacts?: Maybe<Array<Contact>>;
	contractNumber?: Maybe<Scalars['Int']['output']>;
	contractTemplates?: Maybe<Array<ContractTemplate>>;
	country?: Maybe<Country>;
	coupon?: Maybe<Coupon>;
	couponInstances?: Maybe<Array<Maybe<CouponInstance>>>;
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	documents?: Maybe<Array<Document>>;
	emailNotificationGroups?: Maybe<Array<EmailNotificationGroup>>;
	events?: Maybe<Array<Event>>;
	facebook?: Maybe<Scalars['String']['output']>;
	groups: Array<TestingGroup>;
	hasForeverCoupon: Scalars['Boolean']['output'];
	hasStripeVerificationNeeds: Scalars['Boolean']['output'];
	helloSignID?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	imagePositionX?: Maybe<Scalars['Float']['output']>;
	imagePositionY?: Maybe<Scalars['Float']['output']>;
	imageRotation?: Maybe<Scalars['Int']['output']>;
	imageScale?: Maybe<Scalars['Int']['output']>;
	inquiries: Array<Inquiry>;
	instagram?: Maybe<Scalars['String']['output']>;
	invoicesAllowGratuity: Scalars['Boolean']['output'];
	lastSuccessfulSettlement?: Maybe<Scalars['DateTime']['output']>;
	name: Scalars['String']['output'];
	orgType?: Maybe<OrgType>;
	originalImage?: Maybe<Scalars['String']['output']>;
	ownedCoupon?: Maybe<Coupon>;
	phone?: Maybe<Scalars['String']['output']>;
	pinterest?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	rootFolder?: Maybe<Folder>;
	services: Array<Service>;
	state?: Maybe<State>;
	stripeID?: Maybe<Scalars['String']['output']>;
	stripeSubscriptionCustomerID?: Maybe<Scalars['String']['output']>;
	subscription?: Maybe<AppSubscription>;
	twitter?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	users?: Maybe<Array<OrgUser>>;
	website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAppSubscriptionsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<AppSubscriptionOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<AppSubscriptionWhereInput>;
};

export type OrganizationContactsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ContactOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContactWhereInput>;
};

export type OrganizationContractTemplatesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContractTemplateWhereInput>;
};

export type OrganizationCouponInstancesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<CouponInstanceWhereInput>;
};

export type OrganizationDocumentsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<DocumentWhereInput>;
};

export type OrganizationEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type OrganizationServicesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ServiceWhereInput>;
};

export type OrganizationUsersArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<OrgUserOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<OrgUserWhereInput>;
};

export type OrganizationAndPersonInput = {
	organization: OrganizationWhereUniqueInput;
	person: PersonInput;
};

export type OrganizationConnectServicesInput = {
	connect?: InputMaybe<Array<InputMaybe<ServiceWhereUniqueInput>>>;
	disconnect?: InputMaybe<Array<InputMaybe<ServiceWhereUniqueInput>>>;
};

export type OrganizationCreateManyWithoutServicesInput = {
	connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
};

export type OrganizationCustomCreateInput = {
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	allowsGratuity?: InputMaybe<Scalars['Boolean']['input']>;
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	city: Scalars['String']['input'];
	contactEmail?: InputMaybe<Scalars['String']['input']>;
	country: Country;
	description?: InputMaybe<Scalars['String']['input']>;
	facebook?: InputMaybe<Scalars['String']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Int']['input']>;
	imagePositionY?: InputMaybe<Scalars['Int']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	instagram?: InputMaybe<Scalars['String']['input']>;
	invitationID?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	orgType?: InputMaybe<OrgType>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	pinterest?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	services: OrganizationConnectServicesInput;
	state?: InputMaybe<State>;
	twitter?: InputMaybe<Scalars['String']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCustomUpdateInput = {
	addressLine1?: InputMaybe<Scalars['String']['input']>;
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	brandedEmails?: InputMaybe<Scalars['Boolean']['input']>;
	city?: InputMaybe<Scalars['String']['input']>;
	contactEmail?: InputMaybe<Scalars['String']['input']>;
	country?: InputMaybe<Country>;
	description?: InputMaybe<Scalars['String']['input']>;
	facebook?: InputMaybe<Scalars['String']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Int']['input']>;
	imagePositionY?: InputMaybe<Scalars['Int']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	instagram?: InputMaybe<Scalars['String']['input']>;
	invoicesAllowGratuity?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	pinterest?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	services?: InputMaybe<OrganizationConnectServicesInput>;
	state?: InputMaybe<State>;
	twitter?: InputMaybe<Scalars['String']['input']>;
	updateStripe?: InputMaybe<Scalars['Boolean']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationForActingUser = {
	__typename?: 'OrganizationForActingUser';
	id?: Maybe<Scalars['ID']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	services?: Maybe<ServicesForActingUser>;
};

export type OrganizationForGetContractWhere = {
	__typename?: 'OrganizationForGetContractWhere';
	helloSignID?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	services: Array<Maybe<ServicesForGetContractWhere>>;
	updatedAt: Scalars['DateTime']['output'];
	users?: Maybe<Array<UsersForGetContractWhere>>;
};

export type OrganizationForGetQuickPayment = {
	__typename?: 'OrganizationForGetQuickPayment';
	achConvenienceFeePercentage: Scalars['Decimal']['output'];
	cardConvenienceFeePercentage: Scalars['Decimal']['output'];
	contactEmail?: Maybe<Scalars['String']['output']>;
	country: Country;
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	services: Array<Maybe<ServicesForGetQuickPayment>>;
	updatedAt: Scalars['DateTime']['output'];
	users: Array<Maybe<OrgUserForGetQuickPayment>>;
};

export type OrganizationForOfflinePaymentHistory = {
	__typename?: 'OrganizationForOfflinePaymentHistory';
	country: Country;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type OrganizationForPaymentHistoryItem = {
	__typename?: 'OrganizationForPaymentHistoryItem';
	id?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
};

export type OrganizationOrderByInput = {
	addressLine1?: InputMaybe<SortOrderType>;
	addressLine2?: InputMaybe<SortOrderType>;
	brandedEmails?: InputMaybe<SortOrderType>;
	city?: InputMaybe<SortOrderType>;
	contactEmail?: InputMaybe<SortOrderType>;
	contractNumber?: InputMaybe<SortOrderType>;
	country?: InputMaybe<SortOrderType>;
	createdAt?: InputMaybe<SortOrderType>;
	description?: InputMaybe<SortOrderType>;
	facebook?: InputMaybe<SortOrderType>;
	hasStripeVerificationNeeds?: InputMaybe<SortOrderType>;
	helloSignID?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	image?: InputMaybe<SortOrderType>;
	imagePositionX?: InputMaybe<SortOrderType>;
	imagePositionY?: InputMaybe<SortOrderType>;
	imageRotation?: InputMaybe<SortOrderType>;
	imageScale?: InputMaybe<SortOrderType>;
	instagram?: InputMaybe<SortOrderType>;
	lastSuccessfulSettlement?: InputMaybe<SortOrderType>;
	name?: InputMaybe<SortOrderType>;
	orgType?: InputMaybe<SortOrderType>;
	originalImage?: InputMaybe<SortOrderType>;
	phone?: InputMaybe<SortOrderType>;
	pinterest?: InputMaybe<SortOrderType>;
	postalCode?: InputMaybe<SortOrderType>;
	state?: InputMaybe<SortOrderType>;
	stripeID?: InputMaybe<SortOrderType>;
	stripeSubscriptionCustomerID?: InputMaybe<SortOrderType>;
	twitter?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
	website?: InputMaybe<SortOrderType>;
};

export type OrganizationPaymentCapacityUpdateInput = {
	canReceivePayments: Scalars['Boolean']['input'];
};

export type OrganizationPrivilegedUpdateInput = {
	achAppFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
	achConvenienceFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
	achFeeCap?: InputMaybe<Scalars['Int']['input']>;
	canReceivePayments?: InputMaybe<Scalars['Boolean']['input']>;
	cardAppFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
	cardConvenienceFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
	couponId?: InputMaybe<Scalars['String']['input']>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	fraudulent?: InputMaybe<Scalars['Boolean']['input']>;
	hasStripeVerificationNeeds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationSources = {
	__typename?: 'OrganizationSources';
	id: Scalars['ID']['output'];
	source: Array<Scalars['String']['output']>;
};

export type OrganizationStripeCardUpdateInput = {
	cardToBeUpdated: Scalars['String']['input'];
	cardUpdates: StripeCardUpdateInfoInput;
};

export type OrganizationUpdateOneWithoutUsersInput = {
	connect?: InputMaybe<OrganizationWhereUniqueInput>;
	delete?: InputMaybe<Scalars['Boolean']['input']>;
	disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationWhereAppSubscriptionsInput = {
	every?: InputMaybe<AppSubscriptionWhereInput>;
	none?: InputMaybe<AppSubscriptionWhereInput>;
	some?: InputMaybe<AppSubscriptionWhereInput>;
};

export type OrganizationWhereContactsInput = {
	every?: InputMaybe<ContactWhereInput>;
	none?: InputMaybe<ContactWhereInput>;
	some?: InputMaybe<ContactWhereInput>;
};

export type OrganizationWhereContractTemplateInput = {
	every?: InputMaybe<ContractTemplateWhereInput>;
	none?: InputMaybe<ContractTemplateWhereInput>;
	some?: InputMaybe<ContractTemplateWhereInput>;
};

export type OrganizationWhereCouponInstancesInput = {
	every?: InputMaybe<CouponInstanceWhereInput>;
	none?: InputMaybe<CouponInstanceWhereInput>;
	some?: InputMaybe<CouponInstanceWhereInput>;
};

export type OrganizationWhereDocumentsInput = {
	every?: InputMaybe<DocumentWhereInput>;
	none?: InputMaybe<DocumentWhereInput>;
	some?: InputMaybe<DocumentWhereInput>;
};

export type OrganizationWhereEventsInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type OrganizationWhereInput = {
	AND?: InputMaybe<Array<OrganizationWhereInput>>;
	NOT?: InputMaybe<Array<OrganizationWhereInput>>;
	OR?: InputMaybe<Array<OrganizationWhereInput>>;
	addressLine1?: InputMaybe<Scalars['String']['input']>;
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	appSubscriptions?: InputMaybe<OrganizationWhereAppSubscriptionsInput>;
	brandedEmails?: InputMaybe<Scalars['Boolean']['input']>;
	city?: InputMaybe<Scalars['String']['input']>;
	city_contains?: InputMaybe<Scalars['String']['input']>;
	contactEmail?: InputMaybe<Scalars['String']['input']>;
	contactEmail_contains?: InputMaybe<Scalars['String']['input']>;
	contacts?: InputMaybe<OrganizationWhereContactsInput>;
	contractTemplates?: InputMaybe<OrganizationWhereContractTemplateInput>;
	country?: InputMaybe<Country>;
	coupon?: InputMaybe<CouponWhereInput>;
	couponInstances?: InputMaybe<OrganizationWhereCouponInstancesInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	documents?: InputMaybe<OrganizationWhereDocumentsInput>;
	events?: InputMaybe<OrganizationWhereEventsInput>;
	facebook?: InputMaybe<Scalars['String']['input']>;
	hasStripeVerificationNeeds?: InputMaybe<Scalars['Boolean']['input']>;
	helloSignID?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	imagePositionX?: InputMaybe<Scalars['Float']['input']>;
	imagePositionY?: InputMaybe<Scalars['Float']['input']>;
	imageRotation?: InputMaybe<Scalars['Int']['input']>;
	imageScale?: InputMaybe<Scalars['Int']['input']>;
	instagram?: InputMaybe<Scalars['String']['input']>;
	lastSuccessfulSettlement?: InputMaybe<Scalars['DateTime']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	name_contains?: InputMaybe<Scalars['String']['input']>;
	orgType?: InputMaybe<OrgType>;
	originalImage?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	pinterest?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	rootFolder?: InputMaybe<FolderWhereInput>;
	services?: InputMaybe<OrganizationWhereServicesInput>;
	state?: InputMaybe<State>;
	stripeID?: InputMaybe<Scalars['String']['input']>;
	stripeSubscriptionCustomerID?: InputMaybe<Scalars['String']['input']>;
	subscription?: InputMaybe<AppSubscriptionWhereInput>;
	twitter?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	users?: InputMaybe<OrganizationWhereUsersInput>;
	website?: InputMaybe<Scalars['String']['input']>;
	website_contains?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationWhereServicesInput = {
	every?: InputMaybe<ServiceWhereInput>;
	none?: InputMaybe<ServiceWhereInput>;
	some?: InputMaybe<ServiceWhereInput>;
};

export type OrganizationWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type OrganizationWhereUsersInput = {
	every?: InputMaybe<OrgUserWhereInput>;
	none?: InputMaybe<OrgUserWhereInput>;
	some?: InputMaybe<OrgUserWhereInput>;
};

export type Organizations = {
	__typename?: 'Organizations';
	_count: Scalars['Int']['output'];
	organizations: Array<Organization>;
};

export type OverduePayments = {
	__typename?: 'OverduePayments';
	invoices: Array<InvoiceForDashboardStats>;
	totalAmountOverdue: Scalars['String']['output'];
};

export type PaginationCursor = {
	paymentMethod?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordChangeInput = {
	confirmedPassword: Scalars['String']['input'];
	currentPassword: Scalars['String']['input'];
	newPassword: Scalars['String']['input'];
};

export type PasswordResetInput = {
	confirmedPassword: Scalars['String']['input'];
	email: Scalars['String']['input'];
	password: Scalars['String']['input'];
	passwordResetToken: Scalars['String']['input'];
};

export type PasswordResetRequestInput = {
	email: Scalars['String']['input'];
};

export type PasswordResetToken = {
	__typename?: 'PasswordResetToken';
	passwordResetToken: Scalars['String']['output'];
};

export type PaymentHistoryItem = {
	__typename?: 'PaymentHistoryItem';
	amount: Scalars['Int']['output'];
	currency?: Maybe<Scalars['String']['output']>;
	date?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['ID']['output']>;
	invoice?: Maybe<InvoiceForPaymentHistoryItem>;
	organization?: Maybe<OrganizationForPaymentHistoryItem>;
	type?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistoryWithPagination = {
	__typename?: 'PaymentHistoryWithPagination';
	data: Array<PaymentHistoryItem>;
	hasMore: Scalars['Boolean']['output'];
	nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstallment = {
	__typename?: 'PaymentInstallment';
	amountDue?: Maybe<Scalars['Int']['output']>;
	amountPaid?: Maybe<Scalars['Int']['output']>;
	amountRefunded?: Maybe<Scalars['Int']['output']>;
	bookkeepingFeeStripeInvoiceID?: Maybe<Scalars['String']['output']>;
	convenienceFee?: Maybe<Scalars['Int']['output']>;
	createdAt: Scalars['DateTime']['output'];
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	enteredAsPercentageAmount?: Maybe<Scalars['Boolean']['output']>;
	events?: Maybe<Array<Event>>;
	gratuityPaid?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	invoice: Invoice;
	name?: Maybe<Scalars['String']['output']>;
	paymentDate?: Maybe<Scalars['DateTime']['output']>;
	paymentNote?: Maybe<Scalars['String']['output']>;
	paymentType?: Maybe<PaymentType>;
	percentageDue?: Maybe<Scalars['Float']['output']>;
	processor?: Maybe<PaymentProcessor>;
	receiptEmails: Array<Scalars['String']['output']>;
	refundDate?: Maybe<Scalars['DateTime']['output']>;
	refundNote?: Maybe<Scalars['String']['output']>;
	scheduledPaymentDate?: Maybe<Scalars['DateTime']['output']>;
	scheduledPaymentFailureCount?: Maybe<Scalars['Int']['output']>;
	scheduledPaymentMethod?: Maybe<Scalars['String']['output']>;
	status?: Maybe<InstallmentStatus>;
	stripeChargeID?: Maybe<Scalars['String']['output']>;
	stripePaymentMethod?: Maybe<Scalars['String']['output']>;
	stripeRefundID?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type PaymentInstallmentEventsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type PaymentInstallmentDataInput = {
	amountDue: Scalars['Long']['input'];
	dueDate?: InputMaybe<Scalars['DateTime']['input']>;
	enteredAsPercentageAmount: Scalars['Boolean']['input'];
	id?: InputMaybe<Scalars['ID']['input']>;
	name: Scalars['String']['input'];
	percentageDue: Scalars['Float']['input'];
};

export type PaymentInstallmentDetails = {
	__typename?: 'PaymentInstallmentDetails';
	last4?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstallmentEventsWhereInput = {
	every?: InputMaybe<EventWhereInput>;
	none?: InputMaybe<EventWhereInput>;
	some?: InputMaybe<EventWhereInput>;
};

export type PaymentInstallmentOrderByInputForGetContractWhere = {
	dueDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentInstallmentWhereInput = {
	AND?: InputMaybe<Array<PaymentInstallmentWhereInput>>;
	NOT?: InputMaybe<Array<PaymentInstallmentWhereInput>>;
	OR?: InputMaybe<Array<PaymentInstallmentWhereInput>>;
	amountDue?: InputMaybe<Scalars['Int']['input']>;
	amountPaid?: InputMaybe<Scalars['Int']['input']>;
	amountRefunded?: InputMaybe<Scalars['Int']['input']>;
	bookkeepingFeeStripeInvoiceID?: InputMaybe<Scalars['String']['input']>;
	convenienceFee?: InputMaybe<Scalars['Int']['input']>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	dueDate?: InputMaybe<Scalars['DateTime']['input']>;
	events?: InputMaybe<PaymentInstallmentEventsWhereInput>;
	gratuityPaid?: InputMaybe<Scalars['Int']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	invoice?: InputMaybe<InvoiceWhereInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
	paymentNote?: InputMaybe<Scalars['String']['input']>;
	paymentType?: InputMaybe<PaymentType>;
	processor?: InputMaybe<PaymentProcessor>;
	refundDate?: InputMaybe<Scalars['DateTime']['input']>;
	refundNote?: InputMaybe<Scalars['String']['input']>;
	scheduledPaymentDate?: InputMaybe<Scalars['DateTime']['input']>;
	scheduledPaymentFailureCount?: InputMaybe<Scalars['Int']['input']>;
	scheduledPaymentMethod?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<InstallmentStatus>;
	stripeChargeID?: InputMaybe<Scalars['String']['input']>;
	stripePaymentMethod?: InputMaybe<Scalars['String']['input']>;
	stripeRefundID?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentInstallmentWhereInputForGetContractWhere = {
	status?: InputMaybe<InstallmentStatus>;
};

export type PaymentInstallmentWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type PaymentInstallmentsForGetContractWhere = {
	__typename?: 'PaymentInstallmentsForGetContractWhere';
	amountDue?: Maybe<Scalars['Int']['output']>;
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	paymentDate?: Maybe<Scalars['DateTime']['output']>;
	status?: Maybe<InstallmentStatus>;
};

export type PaymentIntent = {
	__typename?: 'PaymentIntent';
	amount: Scalars['Int']['output'];
	clientSecret: Scalars['String']['output'];
	id: Scalars['String']['output'];
};

export type PaymentMethodSessionSecrets = {
	__typename?: 'PaymentMethodSessionSecrets';
	clientSecret?: Maybe<Scalars['String']['output']>;
	customerSessionClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodSessionSecretsInput = {
	/** The organization ID to get the payment method session secrets for, to optionally restrict the payment method types that are available */
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	/** We can supply this value to pre-select a saved payment method */
	paymentMethodId?: InputMaybe<Scalars['String']['input']>;
	/** in the case of OBO invoice payment we supply the customer's Stripe ID */
	stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
	/** We can allow guest access to auto-pay via this token */
	token?: InputMaybe<DocumentAccessTokenUniqueWhere>;
};

export enum PaymentMethodType {
	acss_debit = 'acss_debit',
	apple_pay = 'apple_pay',
	card = 'card',
	google_pay = 'google_pay',
	link = 'link',
	us_bank_account = 'us_bank_account',
}

export type PaymentMethodWhereInput = {
	stripePaymentMethod: Scalars['String']['input'];
};

export enum PaymentProcessor {
	Offline = 'Offline',
	Stripe = 'Stripe',
}

export type PaymentSessionSecrets = {
	__typename?: 'PaymentSessionSecrets';
	currency: Scalars['String']['output'];
	customerSecret?: Maybe<Scalars['String']['output']>;
	excludedPaymentMethodTypes: Array<Scalars['String']['output']>;
	invoiceId: Scalars['String']['output'];
	onBehalfOf?: Maybe<Scalars['String']['output']>;
};

export enum PaymentType {
	BankAccount = 'BankAccount',
	Card = 'Card',
	Cash = 'Cash',
	Check = 'Check',
	Other = 'Other',
}

export type PaymentsReceived = {
	__typename?: 'PaymentsReceived';
	invoices: Array<InvoiceForDashboardStats>;
	totalAmountReceived: Scalars['String']['output'];
};

export type PaymentsSettings = {
	__typename?: 'PaymentsSettings';
	statement_descriptor?: Maybe<Scalars['String']['output']>;
};

export type PaymentsSettingsInput = {
	statement_descriptor?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentsSummary = {
	__typename?: 'PaymentsSummary';
	totalAmountRefunded: Scalars['String']['output'];
	totalAmountUpcoming: Scalars['String']['output'];
	totalInvoicesDrafts: Scalars['String']['output'];
	totalInvoicesOverdue: Scalars['String']['output'];
	totalInvoicesPaid: Scalars['String']['output'];
};

export type PayoutsSchedule = {
	__typename?: 'PayoutsSchedule';
	delay_days?: Maybe<Scalars['Int']['output']>;
	interval?: Maybe<Scalars['String']['output']>;
	monthly_anchor?: Maybe<Scalars['Int']['output']>;
	weekly_anchor?: Maybe<Scalars['String']['output']>;
};

export type PayoutsScheduleInput = {
	delay_days?: InputMaybe<Scalars['Int']['input']>;
	interval?: InputMaybe<Scalars['String']['input']>;
	monthly_anchor?: InputMaybe<Scalars['Int']['input']>;
	weekly_anchor?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutsSettings = {
	__typename?: 'PayoutsSettings';
	debit_negative_balances?: Maybe<Scalars['Boolean']['output']>;
	schedule?: Maybe<PayoutsSchedule>;
	statement_descriptor?: Maybe<Scalars['String']['output']>;
};

export type PayoutsSettingsInput = {
	debit_negative_balances?: InputMaybe<Scalars['Boolean']['input']>;
	schedule?: InputMaybe<PayoutsScheduleInput>;
	statement_descriptor?: InputMaybe<Scalars['String']['input']>;
};

export type PendingInvitations = {
	__typename?: 'PendingInvitations';
	_count: Scalars['Int']['output'];
	pendingInvitations: Array<Invitation>;
};

export type PermissionInput = {
	plannerOrgCanPayInvoices: Scalars['Boolean']['input'];
	plannerOrgCanSignContracts: Scalars['Boolean']['input'];
	plannerOrgHasConnectionPermissions: Scalars['Boolean']['input'];
	plannerOrgHasDocumentsPermissions: Scalars['Boolean']['input'];
};

export type PersonInput = {
	id: Scalars['String']['input'];
};

export type PersonVerificationDetails = {
	__typename?: 'PersonVerificationDetails';
	additional_document?: Maybe<VerificationDocument>;
	details?: Maybe<Scalars['String']['output']>;
	details_code?: Maybe<Scalars['String']['output']>;
	document?: Maybe<VerificationDocument>;
	status?: Maybe<Scalars['String']['output']>;
};

export type PersonVerificationDetailsInput = {
	additional_document?: InputMaybe<VerificationDocumentInput>;
	document?: InputMaybe<VerificationDocumentInput>;
};

export type Plan = {
	__typename?: 'Plan';
	active: Scalars['Boolean']['output'];
	amountDue?: Maybe<Scalars['Int']['output']>;
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	organizations?: Maybe<Array<Organization>>;
	period: PlanPeriod;
	price: Scalars['Int']['output'];
	proration?: Maybe<Scalars['Int']['output']>;
	stripePlanID: Scalars['String']['output'];
	type: PlanType;
	updatedAt: Scalars['DateTime']['output'];
};

export type PlanOrganizationsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<OrganizationWhereInput>;
};

export type PlanCost = {
	__typename?: 'PlanCost';
	amountDue?: Maybe<Scalars['Int']['output']>;
	price?: Maybe<Scalars['Int']['output']>;
	proration?: Maybe<Scalars['Int']['output']>;
};

export enum PlanPeriod {
	Annual = 'Annual',
	Monthly = 'Monthly',
}

export type PlanProduct = {
	active?: InputMaybe<Scalars['Boolean']['input']>;
	metadata?: InputMaybe<Array<InputMaybe<StripeMetaData>>>;
	name: Scalars['String']['input'];
	statement_descriptor?: InputMaybe<Scalars['String']['input']>;
};

export enum PlanType {
	Premium = 'Premium',
	Professional = 'Professional',
}

export type PlanWhereInput = {
	AND?: InputMaybe<Array<PlanWhereInput>>;
	NOT?: InputMaybe<Array<PlanWhereInput>>;
	OR?: InputMaybe<Array<PlanWhereInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	organizations?: InputMaybe<PlanWhereOrganizationsInput>;
	period?: InputMaybe<PlanPeriod>;
	stripePlanID?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<PlanType>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PlanWhereOrganizationsInput = {
	every?: InputMaybe<OrganizationWhereInput>;
	none?: InputMaybe<OrganizationWhereInput>;
	some?: InputMaybe<OrganizationWhereInput>;
};

export type PreviewSubscriptionCostInput = {
	/** If supplied, the new subscription will be charged at the rate of this plan (price ID) */
	asStripePriceID?: InputMaybe<Scalars['String']['input']>;
	/** The billing cycle anchor to use for previewing the subscription cost. If not provided, the default is "unchanged". */
	billingCycleAnchor?: InputMaybe<PrivilegedStripeVendorSubscriptionChangeBillingAnchor>;
	couponID?: InputMaybe<Scalars['String']['input']>;
	stripePriceID: Scalars['String']['input'];
};

export enum PrivilegedGetDocumentReadOnlyTokenDocumentType {
	Contract = 'Contract',
	Invoice = 'Invoice',
	Lead = 'Lead',
	Proposal = 'Proposal',
}

export type PrivilegedGetDocumentReadOnlyTokenInput = {
	documentId: Scalars['ID']['input'];
	documentType: PrivilegedGetDocumentReadOnlyTokenDocumentType;
	email: Scalars['String']['input'];
	expired: Scalars['Boolean']['input'];
};

export type PrivilegedMakeOrganizationPayableDataInput = {
	planToPayInvoice: Scalars['Boolean']['input'];
};

export enum PrivilegedStripeVendorSubscriptionChangeBillingAnchor {
	now = 'now',
	unchanged = 'unchanged',
}

export type PrivilegedStripeVendorSubscriptionChangeInput = {
	/** If supplied, the new subscription will be charged at the rate of this plan (price ID) */
	asStripePriceID?: InputMaybe<Scalars['String']['input']>;
	/** The billing cycle anchor to use for changing the subscription. Not applicable to a new subscription, which always uses "now". If not provided, the default is "unchanged". */
	billingCycleAnchor?: InputMaybe<PrivilegedStripeVendorSubscriptionChangeBillingAnchor>;
	couponID?: InputMaybe<Scalars['String']['input']>;
	stripePriceID: Scalars['String']['input'];
};

export type Project = {
	__typename?: 'Project';
	id: Scalars['ID']['output'];
};

export type Proposal = {
	__typename?: 'Proposal';
	automatedRemindersEnabled: Scalars['Boolean']['output'];
	canvaDesign?: Maybe<CanvaDesignViewFields>;
	contact: Contact;
	createdAt: Scalars['DateTime']['output'];
	dueDate?: Maybe<Scalars['DateTime']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	emailNotificationGroup?: Maybe<EmailNotificationGroup>;
	eventDate?: Maybe<Scalars['DateTime']['output']>;
	filename?: Maybe<Scalars['String']['output']>;
	guestToken?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	imageUrl?: Maybe<Scalars['String']['output']>;
	isPastDue: Scalars['Boolean']['output'];
	isReadOnly: Scalars['Boolean']['output'];
	proposalTemplate?: Maybe<ProposalTemplate>;
	sentAt?: Maybe<Scalars['DateTime']['output']>;
	sentByUser?: Maybe<OrgUser>;
	sentByUsername?: Maybe<Scalars['String']['output']>;
	source?: Maybe<Scalars['Json']['output']>;
	status: ProposalStatus;
	thumbnail?: Maybe<Scalars['String']['output']>;
	title?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type ProposalCreateInput = {
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	contact: ContactCreateOneWithoutProposalsInput;
	dueDate: Scalars['DateTime']['input'];
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	notificationGroupMembers?: InputMaybe<Array<Scalars['String']['input']>>;
	proposalTemplate?: InputMaybe<ProposalTemplateCreateOneWithoutProposalsInput>;
	source?: InputMaybe<Scalars['Json']['input']>;
	thumbnail?: InputMaybe<Scalars['String']['input']>;
	title: Scalars['String']['input'];
};

export enum ProposalMetricType {
	Accepted = 'Accepted',
	Drafts = 'Drafts',
	Overdue = 'Overdue',
	Sent = 'Sent',
}

export enum ProposalStatus {
	Accepted = 'Accepted',
	Deleted = 'Deleted',
	Draft = 'Draft',
	Sent = 'Sent',
	Void = 'Void',
}

export type ProposalTemplate = {
	__typename?: 'ProposalTemplate';
	canvaDesign?: Maybe<CanvaDesignViewFields>;
	createdAt: Scalars['DateTime']['output'];
	createdBy: OrgUser;
	filename?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	imageUrl?: Maybe<Scalars['String']['output']>;
	organization: Organization;
	proposals?: Maybe<Array<Proposal>>;
	source?: Maybe<Scalars['Json']['output']>;
	status: ProposalTemplateStatus;
	thumbnail?: Maybe<Scalars['String']['output']>;
	title?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type ProposalTemplateProposalsArgs = {
	where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalTemplateCreateInput = {
	copyImageFrom?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['Json']['input']>;
	thumbnail?: InputMaybe<Scalars['String']['input']>;
	title: Scalars['String']['input'];
};

export type ProposalTemplateCreateOneWithoutProposalsInput = {
	connect: ProposalTemplateWhereUniqueInput;
};

export enum ProposalTemplateStatus {
	Active = 'Active',
	Deleted = 'Deleted',
	Inactive = 'Inactive',
}

export type ProposalTemplateUpdateInput = {
	copyImageFrom?: InputMaybe<Scalars['String']['input']>;
	deleteImage?: InputMaybe<Scalars['Boolean']['input']>;
	disconnectCanvaDesign?: InputMaybe<Scalars['Boolean']['input']>;
	source?: InputMaybe<Scalars['Json']['input']>;
	thumbnail?: InputMaybe<Scalars['String']['input']>;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalTemplateWhereOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
	title?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export type ProposalTemplateWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type ProposalTemplates = {
	__typename?: 'ProposalTemplates';
	_count: Scalars['Int']['output'];
	proposalTemplates: Array<ProposalTemplate>;
};

export type ProposalTemplatesWhereInput = {
	hasSource?: InputMaybe<Scalars['Boolean']['input']>;
	title?: InputMaybe<Scalars['String']['input']>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalUpdateInput = {
	automatedRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	contact?: InputMaybe<ContactCreateOneWithoutProposalsInput>;
	deleteImage?: InputMaybe<Scalars['Boolean']['input']>;
	disconnectCanvaDesign?: InputMaybe<Scalars['Boolean']['input']>;
	dueDate?: InputMaybe<Scalars['DateTime']['input']>;
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	notificationGroupMembers?: InputMaybe<Array<Scalars['String']['input']>>;
	proposalTemplate?: InputMaybe<ProposalTemplateCreateOneWithoutProposalsInput>;
	source?: InputMaybe<Scalars['Json']['input']>;
	thumbnail?: InputMaybe<Scalars['String']['input']>;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalWhereInput = {
	guestToken?: InputMaybe<Scalars['String']['input']>;
	proposal: ProposalWhereUniqueInput;
};

export type ProposalWhereUniqueInput = {
	id: Scalars['String']['input'];
};

export type Proposals = {
	__typename?: 'Proposals';
	_count: Scalars['Int']['output'];
	proposals: Array<Proposal>;
};

export type ProposalsForCustomerInput = {
	AND?: InputMaybe<Array<ProposalsForCustomerInput>>;
	NOT?: InputMaybe<Array<ProposalsForCustomerInput>>;
	OR?: InputMaybe<Array<ProposalsForCustomerInput>>;
	contact?: InputMaybe<ContactInputForProposalsForCustomer>;
	isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
	proposal?: InputMaybe<ProposalWhereUniqueInput>;
	status?: InputMaybe<ProposalStatus>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<SortOrderInequalityInput>;
};

export type ProposalsForOrganizationInput = {
	AND?: InputMaybe<Array<ProposalsForOrganizationInput>>;
	NOT?: InputMaybe<Array<ProposalsForOrganizationInput>>;
	OR?: InputMaybe<Array<ProposalsForOrganizationInput>>;
	contact?: InputMaybe<CustomContactInput>;
	isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
	metricDateRange?: InputMaybe<DashboardWhereInput>;
	metricType?: InputMaybe<ProposalMetricType>;
	proposal?: InputMaybe<ProposalWhereUniqueInput>;
	status?: InputMaybe<ProposalStatus>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<SortOrderInequalityInput>;
};

export type ProposalsOrderByInput = {
	contact?: InputMaybe<ContactOrderByInput>;
	createdAt?: InputMaybe<SortOrderType>;
	dueDate?: InputMaybe<SortOrderType>;
	eventDate?: InputMaybe<SortOrderType>;
	isPastDue?: InputMaybe<SortOrderType>;
	sentAt?: InputMaybe<SortOrderType>;
	sentByUser?: InputMaybe<OrgUserOrderByInput>;
	sentByUsername?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
	title?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export type ProposalsStatusSummary = {
	__typename?: 'ProposalsStatusSummary';
	totalProposalsAccepted: Scalars['String']['output'];
	totalProposalsDrafts: Scalars['String']['output'];
	totalProposalsOverdue: Scalars['String']['output'];
	totalProposalsSent: Scalars['String']['output'];
};

export type Query = {
	__typename?: 'Query';
	calculateQuickPaymentSubtotal: CalculateQuickPaymentSubtotal;
	canAccessByFeatureFlag: Scalars['Boolean']['output'];
	downloadResourceWhere: CustomResource;
	exportContactsData: Scalars['String']['output'];
	exportCustomerOfflineTransactionHistory: TransactionHistoryUrl;
	exportCustomerTransactionHistory: TransactionHistoryUrl;
	exportDashboardStatsForOrg?: Maybe<Scalars['String']['output']>;
	exportInquiryData: Scalars['String']['output'];
	exportInvoice?: Maybe<InvoiceUrl>;
	exportInvoices: Scalars['String']['output'];
	exportOrgOfflineTransactionHistory: TransactionHistoryUrl;
	exportOrgTransactionHistory: Scalars['Boolean']['output'];
	exportWalletQuickPayments: Scalars['String']['output'];
	getActionableItemsForClient: Array<ClientActionableItem>;
	getApiVersion: ApiVersionResponse;
	getApiVersions: Array<Scalars['String']['output']>;
	getAuthedUser?: Maybe<AuthedUser>;
	getCalendarLinks: CalendarLinksPayload;
	getCanvaAuthorizationUrl: CanvaAuthorizationUrl;
	getCanvaDesign: CanvaDesign;
	getClientUserByEmail?: Maybe<ClientUser>;
	getClientUserWhere?: Maybe<ClientUser>;
	getConnectOnboardingUrl?: Maybe<StripeOnboardingUrl>;
	getContactWhere?: Maybe<Contact>;
	getContactsWhere: Contacts;
	getContractWhere: ResponseObjectForGetContractWhere;
	getContractsForCustomer: ContractsForCustomer;
	getContractsForVendor: ContractsForVendor;
	getCouponDetails: ReducedCoupon;
	getCustomerOfflineTransactionHistory?: Maybe<OfflinePaymentHistory>;
	getDashboardStatsForClient?: Maybe<ClientDashboardStats>;
	getDashboardStatsForOrg?: Maybe<OrgDashboardStats>;
	getDocumentWhere: Document;
	getDocumentsWhere: Documents;
	getEventsForInquiry?: Maybe<Array<Event>>;
	getEventsWhere?: Maybe<Array<Event>>;
	getFeatureFlags: Array<ReducedFeatureFlag>;
	getFolderContents?: Maybe<CustomFolder>;
	getGlobalVariables: FormattedGlobalVariables;
	getGroupsForOrganization?: Maybe<Array<TestingGroup>>;
	getGroupsForUser?: Maybe<Array<TestingGroup>>;
	getHistoryForPaymentMethod: PaymentHistoryWithPagination;
	getInquiriesForOrganization: InquiriesForOrganization;
	getInquiryForm?: Maybe<InquiryForm>;
	getInquiryFormApiKey: Scalars['String']['output'];
	getInquiryWhere: Inquiry;
	getInvitationWhere?: Maybe<Invitation>;
	getInviteUser?: Maybe<InviteUser>;
	getInvoiceTemplateWhere?: Maybe<InvoiceTemplate>;
	getInvoiceTemplatesWhere?: Maybe<InvoiceTemplates>;
	getInvoiceWhere?: Maybe<ResponseObjectForGetInvoiceWhere>;
	getInvoicesForCustomer: InvoicesForCustomer;
	getInvoicesForOrganization: Invoices;
	getLeadFormApiKey?: Maybe<LeadFormPresentationalData>;
	getNextStripeInvoice?: Maybe<StripeInvoice>;
	getNotificationGroupsForOrganization?: Maybe<Array<EmailNotificationGroup>>;
	getOrgOfflineTransactionHistory?: Maybe<OfflinePaymentHistory>;
	getOrgTransactionHistory: TransactionHistory;
	getOrgUserByEmail?: Maybe<OrgUser>;
	getOrgUserWhere?: Maybe<OrgUser>;
	getOrgUsersWhere: OrgUsers;
	getOrganizationContractTemplate?: Maybe<ContractTemplate>;
	getOrganizationContractTemplates: ContractTemplates;
	getOrganizationFromInvitation?: Maybe<Organization>;
	getOrganizationReferralCode?: Maybe<Coupon>;
	getOrganizationSources?: Maybe<OrganizationSources>;
	getOrganizationWhere?: Maybe<Organization>;
	getOrganizationsForUser?: Maybe<Organizations>;
	getOrganizationsWhere: Organizations;
	getPasswordResetTokenByEmail: PasswordResetToken;
	getPaymentInstallmentDetails: PaymentInstallmentDetails;
	getPaymentMethodSessionSecrets: PaymentMethodSessionSecrets;
	getPaymentMethodsForVendorCustomer: SourcesWithDefaultSource;
	getPaymentSourcesForCustomer: SourcesWithDefaultSource;
	getPendingInvitations: PendingInvitations;
	getPlans: Array<Plan>;
	getProjectsForOrganization?: Maybe<Array<Project>>;
	getProposalTemplateWhere: ProposalTemplate;
	getProposalTemplatesWhere: ProposalTemplates;
	getProposalWhere: ResponseObjectForGetProposalWhere;
	getProposalsForCustomer: Proposals;
	getProposalsForOrganization: Proposals;
	getQuickPayment: QuickPaymentForGetQuickPayment;
	getQuickPayments: Array<Maybe<QuickPaymentForGetQuickPayment>>;
	getResourceWhere: CustomResource;
	getResourcesWhere: CustomResources;
	getSendgridStatusByEmail?: Maybe<SendgridStatus>;
	getServicesWhere: Array<Service>;
	getSharableContractLinkMfaToken: Scalars['Int']['output'];
	getSharableInvoiceLink: Scalars['String']['output'];
	getSharableProposalLink: Scalars['String']['output'];
	getStripeConnectAccount?: Maybe<StripeConnectAccount>;
	getStripeCustomer?: Maybe<StripeUser>;
	getStripeInvoicesForVendorCustomer: StripeInvoicesList;
	getStripePaymentCapabilities?: Maybe<AccountCapabilities>;
	getStripePlan: StripePlan;
	getStripePlans: Array<StripePlan>;
	getStripeVendorSubscription?: Maybe<SubscriptionObject>;
	getTestingGroups?: Maybe<Array<TestingGroup>>;
	getTotalForSource: Scalars['Int']['output'];
	getUserWhere?: Maybe<User>;
	getVerificationToken: VerificationToken;
	getVerificationTokenByEmail: VerificationToken;
	getWalletQuickPayments: Array<WalletQuickPayment>;
	getWebhookDeliveries: Array<WebhookDelivery>;
	getWebhookEndpoints: Array<WebhookEndpoint>;
	isEmailAvailable: Scalars['Boolean']['output'];
	listCanvaDesigns: CanvaDesignList;
	listResources: Array<Maybe<CustomResource>>;
	listSponsors: Array<Maybe<CustomSponsor>>;
	login?: Maybe<AuthPayload>;
	privilegedGetDocumentReadOnlyToken?: Maybe<Scalars['String']['output']>;
	privilegedGetNotificationGroupsForOrganization?: Maybe<
		Array<EmailNotificationGroup>
	>;
	privilegedGetStripeVendorSubscription?: Maybe<SubscriptionObject>;
	privilegedPreviewSubscriptionCost: SubscriptionCostPreview;
	requestContractFileImageUploadUrl: UploadUrl;
	requestContractTemplateFileImageUploadUrl: UploadUrl;
	requestInvoiceAttachmentUploadUrl: UploadUrl;
	requestOrgProfileImageUploadUrl: UploadUrl;
	sitewideSearch: Array<SearchResult>;
	validateAPIKey?: Maybe<ValidateApiKeyResult>;
	validatePayment: Array<PaymentInstallment>;
};

export type QueryCalculateQuickPaymentSubtotalArgs = {
	data: CalculateQuickPaymentSubtotalInput;
	where: QuickPaymentUniqueInput;
};

export type QueryCanAccessByFeatureFlagArgs = {
	where: CanAccessByFeatureFlagWhereInput;
};

export type QueryDownloadResourceWhereArgs = {
	where: ResourceWhereUniqueInput;
};

export type QueryExportContactsDataArgs = {
	where: ExportContactsDataWhereInput;
};

export type QueryExportCustomerOfflineTransactionHistoryArgs = {
	data: ExportHistoryInput;
	where: UserWhereUniqueInput;
};

export type QueryExportCustomerTransactionHistoryArgs = {
	data: ExportHistoryInput;
	where: UserByIdUniqueInput;
};

export type QueryExportDashboardStatsForOrgArgs = {
	where: DashboardExportInput;
};

export type QueryExportInquiryDataArgs = {
	where: ExportInquiriesDataWhereInput;
};

export type QueryExportInvoiceArgs = {
	data?: InputMaybe<InvoiceExportInput>;
	where: InvoiceWhereUniqueInput;
};

export type QueryExportInvoicesArgs = {
	data: ExportInvoicesDataInput;
	where?: InputMaybe<OrganizationWhereUniqueInput>;
};

export type QueryExportOrgOfflineTransactionHistoryArgs = {
	data: ExportHistoryInput;
	where: OrganizationWhereUniqueInput;
};

export type QueryExportOrgTransactionHistoryArgs = {
	data: ExportHistoryInput;
	where: OrganizationWhereUniqueInput;
};

export type QueryExportWalletQuickPaymentsArgs = {
	data: ExportWalletQuickPaymentsDataInput;
	where: ExportWalletQuickPaymentsWhereInput;
};

export type QueryGetAuthedUserArgs = {
	where: UserWhereUniqueInput;
};

export type QueryGetCalendarLinksArgs = {
	sourceId: Scalars['String']['input'];
	sourceType: CalendarSourceType;
};

export type QueryGetCanvaDesignArgs = {
	where: CanvaDesignWhereUniqueInput;
};

export type QueryGetClientUserByEmailArgs = {
	where: UserWhereUniqueInput;
};

export type QueryGetClientUserWhereArgs = {
	where: ClientUserWhereUniqueInput;
};

export type QueryGetConnectOnboardingUrlArgs = {
	data: StripeOnboardingInput;
};

export type QueryGetContactWhereArgs = {
	where: ContactWhereInput;
};

export type QueryGetContactsWhereArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<ContactOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContactWhereInput;
};

export type QueryGetContractWhereArgs = {
	where: ContractWhereInputWithMfaToken;
};

export type QueryGetContractsForCustomerArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ContractOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContractsForCustomerInput;
};

export type QueryGetContractsForVendorArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ContractOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContractsForVendorInput;
};

export type QueryGetCouponDetailsArgs = {
	where: CouponByNameInput;
};

export type QueryGetCustomerOfflineTransactionHistoryArgs = {
	after?: InputMaybe<OfflinePaymentHistoryAfterInput>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: UserWhereUniqueInput;
};

export type QueryGetDashboardStatsForClientArgs = {
	where: ClientUserWhereUniqueInput;
};

export type QueryGetDashboardStatsForOrgArgs = {
	where: DashboardWhereInput;
};

export type QueryGetDocumentWhereArgs = {
	where: DocumentWhereUniqueInput;
};

export type QueryGetDocumentsWhereArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<DocumentOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: CustomDocumentWhereInput;
};

export type QueryGetEventsForInquiryArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<EventOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: InquiryDetailWhereInput;
};

export type QueryGetEventsWhereArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<EventOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<EventWhereInput>;
};

export type QueryGetFolderContentsArgs = {
	orderBy?: InputMaybe<FolderContentsOrderByInput>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: FolderWhereUniqueInput;
};

export type QueryGetGroupsForOrganizationArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetGroupsForUserArgs = {
	where: UserWhereUniqueInput;
};

export type QueryGetHistoryForPaymentMethodArgs = {
	cursor?: InputMaybe<Scalars['String']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: PaymentMethodWhereInput;
};

export type QueryGetInquiriesForOrganizationArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<InquiryOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<InquiriesForOrganizationWhereInput>;
};

export type QueryGetInquiryFormArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetInquiryWhereArgs = {
	where: InquiryDetailWhereInput;
};

export type QueryGetInvitationWhereArgs = {
	where: InvitationWhereCustomInput;
};

export type QueryGetInviteUserArgs = {
	email: Scalars['String']['input'];
};

export type QueryGetInvoiceTemplateWhereArgs = {
	where: InvoiceTemplateWhereUniqueInput;
};

export type QueryGetInvoiceTemplatesWhereArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<InvoiceTemplateOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<InvoiceTemplatesWhereInput>;
};

export type QueryGetInvoiceWhereArgs = {
	data?: InputMaybe<InvoiceTokenInput>;
	where: InvoiceWhereUniqueInput;
};

export type QueryGetInvoicesForCustomerArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<InvoiceOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: GetInvoicesForCustomerInput;
};

export type QueryGetInvoicesForOrganizationArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<InvoiceOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<InvoiceWhereInput>;
};

export type QueryGetLeadFormApiKeyArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetOrgOfflineTransactionHistoryArgs = {
	after?: InputMaybe<OfflinePaymentHistoryAfterInput>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: OrganizationWhereUniqueInput;
};

export type QueryGetOrgTransactionHistoryArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	where: OrganizationWhereUniqueInput;
};

export type QueryGetOrgUserByEmailArgs = {
	where: UserWhereUniqueInput;
};

export type QueryGetOrgUserWhereArgs = {
	where: OrgUserWhereUniqueInput;
};

export type QueryGetOrgUsersWhereArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<OrgUserOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<OrgUserWhereInput>;
};

export type QueryGetOrganizationContractTemplateArgs = {
	where: ContractTemplateWhereUniqueInput;
};

export type QueryGetOrganizationContractTemplatesArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<ContractTemplateOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<CustomContractTemplateWhereWithoutOrganizationInput>;
};

export type QueryGetOrganizationFromInvitationArgs = {
	where: InvitationWhereCustomInput;
};

export type QueryGetOrganizationReferralCodeArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetOrganizationWhereArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetOrganizationsForUserArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: UserByIdUniqueInput;
};

export type QueryGetOrganizationsWhereArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<OrganizationWhereInput>;
};

export type QueryGetPasswordResetTokenByEmailArgs = {
	where: UserWhereUniqueInput;
};

export type QueryGetPaymentInstallmentDetailsArgs = {
	data?: InputMaybe<InvoiceTokenInput>;
	where: PaymentInstallmentWhereUniqueInput;
};

export type QueryGetPaymentMethodSessionSecretsArgs = {
	where?: InputMaybe<PaymentMethodSessionSecretsInput>;
};

export type QueryGetPaymentMethodsForVendorCustomerArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetPaymentSourcesForCustomerArgs = {
	cursor?: InputMaybe<PaginationCursor>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: UserByIdUniqueInput;
};

export type QueryGetPendingInvitationsArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<InvitationOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<InvitationsWhereCustomInput>;
};

export type QueryGetProposalTemplateWhereArgs = {
	where: ProposalTemplateWhereUniqueInput;
};

export type QueryGetProposalTemplatesWhereArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<ProposalTemplateWhereOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ProposalTemplatesWhereInput>;
};

export type QueryGetProposalWhereArgs = {
	where: ProposalWhereInput;
};

export type QueryGetProposalsForCustomerArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<ProposalsOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ProposalsForCustomerInput;
};

export type QueryGetProposalsForOrganizationArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<ProposalsOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ProposalsForOrganizationInput;
};

export type QueryGetQuickPaymentArgs = {
	where: QuickPaymentUniqueInput;
};

export type QueryGetQuickPaymentsArgs = {
	where: OrganizationWhereInput;
};

export type QueryGetResourceWhereArgs = {
	where: ResourceWhereUniqueInput;
};

export type QueryGetResourcesWhereArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ResourceOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ResourceWhereInput;
};

export type QueryGetSendgridStatusByEmailArgs = {
	where: GetSendgridStatusByEmailInput;
};

export type QueryGetServicesWhereArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ServiceOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ServiceWhereInput>;
};

export type QueryGetSharableContractLinkMfaTokenArgs = {
	where: ContractSharableLinkInput;
};

export type QueryGetSharableInvoiceLinkArgs = {
	where: InvoiceWhereUniqueInput;
};

export type QueryGetSharableProposalLinkArgs = {
	where: ProposalWhereUniqueInput;
};

export type QueryGetStripeConnectAccountArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetStripeCustomerArgs = {
	where: UserWhereUniqueInput;
};

export type QueryGetStripePaymentCapabilitiesArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryGetStripePlanArgs = {
	where: StripePlanRetrievalInput;
};

export type QueryGetTestingGroupsArgs = {
	where?: InputMaybe<TestingGroupWhereInput>;
};

export type QueryGetTotalForSourceArgs = {
	where: PaymentMethodWhereInput;
};

export type QueryGetUserWhereArgs = {
	where: UserWhereInput;
};

export type QueryGetVerificationTokenArgs = {
	where: VerificationTokenWhereUniqueInput;
};

export type QueryGetVerificationTokenByEmailArgs = {
	where: VerificationTokenWhereInput;
};

export type QueryGetWalletQuickPaymentsArgs = {
	orderBy?: InputMaybe<Array<InputMaybe<WalletQuickPaymentOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetWebhookDeliveriesArgs = {
	createdAt?: InputMaybe<DateTimeFilter>;
	endpointId?: InputMaybe<Scalars['ID']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryIsEmailAvailableArgs = {
	email: Scalars['String']['input'];
};

export type QueryListCanvaDesignsArgs = {
	where?: InputMaybe<CanvaDesignWhereInput>;
};

export type QueryListResourcesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ResourceOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ResourceWhereInput>;
};

export type QueryListSponsorsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<SponsorOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<SponsorWhereInput>;
};

export type QueryLoginArgs = {
	data: UserLoginInput;
};

export type QueryPrivilegedGetDocumentReadOnlyTokenArgs = {
	where: PrivilegedGetDocumentReadOnlyTokenInput;
};

export type QueryPrivilegedGetNotificationGroupsForOrganizationArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryPrivilegedGetStripeVendorSubscriptionArgs = {
	where: OrganizationWhereUniqueInput;
};

export type QueryPrivilegedPreviewSubscriptionCostArgs = {
	data: PreviewSubscriptionCostInput;
	where: OrganizationWhereUniqueInput;
};

export type QueryRequestContractFileImageUploadUrlArgs = {
	data: RequestImageUploadUrlInput;
	where: ContractWhereUniqueInput;
};

export type QueryRequestContractTemplateFileImageUploadUrlArgs = {
	data: RequestImageUploadUrlInput;
	where: ContractTemplateWhereUniqueInput;
};

export type QueryRequestInvoiceAttachmentUploadUrlArgs = {
	data: RequestAttachmentUploadUrlInput;
	where: InvoiceWhereUniqueInput;
};

export type QueryRequestOrgProfileImageUploadUrlArgs = {
	data: RequestImageUploadUrlInput;
};

export type QuerySitewideSearchArgs = {
	data: SearchDataInput;
	where: SearchWhereInput;
};

export type QueryValidatePaymentArgs = {
	where: ValidatePaymentInstallmentsInput;
};

export type QueryFieldsForInvoiceSearch = {
	OR?: InputMaybe<Array<InputMaybe<GetInvoicesForCustomerInput>>>;
	contact?: InputMaybe<ContactWhereForInvoiceSearch>;
	status?: InputMaybe<InvoiceStatus>;
	title?: InputMaybe<Scalars['String']['input']>;
	title_contains?: InputMaybe<Scalars['String']['input']>;
	uploadAttachment?: InputMaybe<Scalars['String']['input']>;
	uploadAttachment_contains?: InputMaybe<Scalars['String']['input']>;
};

export type QuickPayment = {
	__typename?: 'QuickPayment';
	id?: Maybe<Scalars['ID']['output']>;
};

export type QuickPaymentForGetQuickPayment = {
	__typename?: 'QuickPaymentForGetQuickPayment';
	amount?: Maybe<Scalars['Int']['output']>;
	contact?: Maybe<ContactForGetQuickPayment>;
	id: Scalars['ID']['output'];
	organization: OrganizationForGetQuickPayment;
	reason?: Maybe<Scalars['String']['output']>;
};

export type QuickPaymentForPaymentInput = {
	amount: Scalars['Int']['input'];
	contact: ContactWhereUniqueInput;
	id: Scalars['ID']['input'];
	reason: Scalars['String']['input'];
};

export type QuickPaymentLink = {
	__typename?: 'QuickPaymentLink';
	url?: Maybe<Scalars['String']['output']>;
};

export type QuickPaymentLinkCreateInput = {
	amount?: InputMaybe<Scalars['Int']['input']>;
	contact?: InputMaybe<ConnectToUniqueContactInput>;
	reason?: InputMaybe<Scalars['String']['input']>;
};

export type QuickPaymentOrderByInput = {
	id?: InputMaybe<SortOrderType>;
};

export type QuickPaymentUniqueInput = {
	id: Scalars['ID']['input'];
};

export type QuickPaymentWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type RecordOfflinePaymentInput = {
	paymentDate: Scalars['DateTime']['input'];
	paymentNote?: InputMaybe<Scalars['String']['input']>;
	paymentType: PaymentType;
};

export type RecordOfflinePaymentOrRefundInput = {
	type: RecordOfflinePaymentOrRefundType;
};

export enum RecordOfflinePaymentOrRefundType {
	Payment = 'Payment',
	Refund = 'Refund',
}

export type RecordOfflineRefundInput = {
	amountRefunded: Scalars['Int']['input'];
	refundDate: Scalars['DateTime']['input'];
	refundNote?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUrl = {
	__typename?: 'RedirectUrl';
	deletePaymentMethodWhenPaymentComplete?: Maybe<Scalars['Boolean']['output']>;
	guestToken?: Maybe<Scalars['String']['output']>;
	invoiceId?: Maybe<Scalars['String']['output']>;
	redirect: Scalars['String']['output'];
};

export type ReducedClientUser = {
	__typename?: 'ReducedClientUser';
	addressLine1?: Maybe<Scalars['String']['output']>;
	addressLine2?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Country>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	facebook?: Maybe<Scalars['String']['output']>;
	firstNameOne?: Maybe<Scalars['String']['output']>;
	firstNameTwo?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	instagram?: Maybe<Scalars['String']['output']>;
	lastNameOne?: Maybe<Scalars['String']['output']>;
	lastNameTwo?: Maybe<Scalars['String']['output']>;
	originalImage?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	pinterest?: Maybe<Scalars['String']['output']>;
	plannerOrgCanPayInvoices?: Maybe<Scalars['Boolean']['output']>;
	plannerOrgCanSignContracts?: Maybe<Scalars['Boolean']['output']>;
	plannerOrgHasConnectionPermissions?: Maybe<Scalars['Boolean']['output']>;
	plannerOrgHasDocumentsPermissions?: Maybe<Scalars['Boolean']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<State>;
	twitter?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user: ReducedUserWithEmail;
	venue?: Maybe<Scalars['String']['output']>;
	weddingDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ReducedContact = {
	__typename?: 'ReducedContact';
	customer: ReducedCustomer;
	firstName?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastName?: Maybe<Scalars['String']['output']>;
	status: ContactStatus;
};

export type ReducedCoupon = {
	__typename?: 'ReducedCoupon';
	active: Scalars['Boolean']['output'];
	amount_off?: Maybe<Scalars['Int']['output']>;
	createdAt: Scalars['DateTime']['output'];
	duration?: Maybe<StripeDuration>;
	duration_in_months?: Maybe<Scalars['Int']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	percent_off?: Maybe<Scalars['Int']['output']>;
	planCost?: Maybe<PlanCost>;
	stripeID: Scalars['String']['output'];
};

export type ReducedCustomer = {
	__typename?: 'ReducedCustomer';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
};

export type ReducedFeatureFlag = {
	__typename?: 'ReducedFeatureFlag';
	active: Scalars['Boolean']['output'];
	category: FeatureCategory;
	createdAt: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type ReducedGuestUser = {
	__typename?: 'ReducedGuestUser';
	id: Scalars['String']['output'];
	user: ReducedUserWithEmail;
};

export type ReducedInvoice = {
	__typename?: 'ReducedInvoice';
	gratuityAmount?: Maybe<Scalars['Int']['output']>;
	id: Scalars['String']['output'];
	title: Scalars['String']['output'];
};

export type ReducedOrgUser = {
	__typename?: 'ReducedOrgUser';
	createdAt: Scalars['DateTime']['output'];
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	image?: Maybe<Scalars['String']['output']>;
	invitationID?: Maybe<Scalars['String']['output']>;
	lastName: Scalars['String']['output'];
	organization?: Maybe<ReducedOrganization>;
	originalImage?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	role: TeamMemberRole;
	updatedAt: Scalars['DateTime']['output'];
};

export type ReducedOrganization = {
	__typename?: 'ReducedOrganization';
	addressLine1?: Maybe<Scalars['String']['output']>;
	addressLine2?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	contactEmail?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Country>;
	coupon?: Maybe<Coupon>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	facebook?: Maybe<Scalars['String']['output']>;
	hasStripeVerificationNeeds?: Maybe<Scalars['Boolean']['output']>;
	helloSignID?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['ID']['output']>;
	image?: Maybe<Scalars['String']['output']>;
	instagram?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	orgType?: Maybe<OrgType>;
	originalImage?: Maybe<Scalars['String']['output']>;
	phone?: Maybe<Scalars['String']['output']>;
	pinterest?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<State>;
	stripeID?: Maybe<Scalars['String']['output']>;
	stripeSubscriptionCustomerID?: Maybe<Scalars['String']['output']>;
	twitter?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	website?: Maybe<Scalars['String']['output']>;
};

export type ReducedPaymentInstallment = {
	__typename?: 'ReducedPaymentInstallment';
	amountDue: Scalars['Int']['output'];
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type ReducedUser = {
	__typename?: 'ReducedUser';
	acceptedTerms?: Maybe<Scalars['DateTime']['output']>;
	blocked: Scalars['Boolean']['output'];
	clientUser?: Maybe<ReducedClientUser>;
	createdAt: Scalars['DateTime']['output'];
	email: Scalars['String']['output'];
	id?: Maybe<Scalars['ID']['output']>;
	isVerified: Scalars['Boolean']['output'];
	lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
	onboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
	orgUser?: Maybe<ReducedOrgUser>;
	updatedAt: Scalars['DateTime']['output'];
	userType: UserType;
};

export type ReducedUserWithEmail = {
	__typename?: 'ReducedUserWithEmail';
	email: Scalars['String']['output'];
	id: Scalars['String']['output'];
};

export type Referral = {
	__typename?: 'Referral';
	category: ReferralCategory;
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	other?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	user: User;
};

export enum ReferralCategory {
	Blog = 'Blog',
	Colleague = 'Colleague',
	Conference = 'Conference',
	Facebook = 'Facebook',
	Google = 'Google',
	Instagram = 'Instagram',
	Other = 'Other',
}

export type ReferralCreateWithoutUserInput = {
	category: ReferralCategory;
	id?: InputMaybe<Scalars['ID']['input']>;
	other?: InputMaybe<Scalars['String']['input']>;
};

export type ReferralWhereInput = {
	AND?: InputMaybe<Array<ReferralWhereInput>>;
	NOT?: InputMaybe<Array<ReferralWhereInput>>;
	OR?: InputMaybe<Array<ReferralWhereInput>>;
	category?: InputMaybe<ReferralCategory>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	other?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	user?: InputMaybe<UserWhereInput>;
};

export type RefundInstallmentInput = {
	amount: Scalars['Int']['input'];
	installmentID: Scalars['String']['input'];
	refundNote?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterCouponUsageWhere = {
	applyToExistingSubscription: Scalars['Boolean']['input'];
	coupon: CouponWhereUniqueInput;
	timeZone: Scalars['String']['input'];
};

export type Relationship = {
	__typename?: 'Relationship';
	director?: Maybe<Scalars['Boolean']['output']>;
	executive?: Maybe<Scalars['Boolean']['output']>;
	owner?: Maybe<Scalars['Boolean']['output']>;
	percent_ownership?: Maybe<Scalars['String']['output']>;
	representative?: Maybe<Scalars['Boolean']['output']>;
	title?: Maybe<Scalars['String']['output']>;
};

export type RelationshipInput = {
	director?: InputMaybe<Scalars['Boolean']['input']>;
	executive?: InputMaybe<Scalars['Boolean']['input']>;
	owner?: InputMaybe<Scalars['Boolean']['input']>;
	percent_ownership?: InputMaybe<Scalars['String']['input']>;
	representative?: InputMaybe<Scalars['Boolean']['input']>;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportContractSigningInput = {
	signingAs: Scalars['ID']['input'];
};

export type ReportInput = {
	bundle?: InputMaybe<BundleInput>;
	customizedEmail?: InputMaybe<CustomizedEmailInput>;
	page: Scalars['String']['input'];
};

export type ReportQuickPaymentFromCustomerSessionInput = {
	invoiceId: Scalars['String']['input'];
	receiptEmails?: InputMaybe<Array<Scalars['String']['input']>>;
	token?: InputMaybe<Scalars['String']['input']>;
};

export type RequestAttachmentUploadUrlInput = {
	fileType: Scalars['String']['input'];
	filename: Scalars['String']['input'];
};

export type RequestImageUploadUrlInput = {
	fileType: Scalars['String']['input'];
};

export type RequirementError = {
	__typename?: 'RequirementError';
	code: Scalars['String']['output'];
	reason: Scalars['String']['output'];
	requirement: Scalars['String']['output'];
};

export type RequirementsDetails = {
	__typename?: 'RequirementsDetails';
	current_deadline?: Maybe<Scalars['Int']['output']>;
	currently_due: Array<Scalars['String']['output']>;
	disabled_reason?: Maybe<Scalars['String']['output']>;
	errors: Array<RequirementError>;
	eventually_due: Array<Scalars['String']['output']>;
	past_due: Array<Scalars['String']['output']>;
	pending_verification: Array<Scalars['String']['output']>;
};

export type Resource = {
	__typename?: 'Resource';
	category: ResourceCategory;
	categoryName: Scalars['String']['output'];
	createdAt: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	fileType: FileType;
	id: Scalars['ID']['output'];
	sponsor: Sponsor;
	sponsorName: Scalars['String']['output'];
	status: ResourceStatus;
	updatedAt: Scalars['DateTime']['output'];
	verifiedPreview: Scalars['Boolean']['output'];
};

export enum ResourceCategory {
	All = 'All',
	Catering = 'Catering',
	Contract = 'Contract',
	Entertainment = 'Entertainment',
	Florist = 'Florist',
	Music = 'Music',
	Other = 'Other',
	Photographer = 'Photographer',
	Planners = 'Planners',
	Stationery = 'Stationery',
	Venue = 'Venue',
	Videographer = 'Videographer',
}

export type ResourceOrderByInput = {
	category?: InputMaybe<SortOrderType>;
	categoryName?: InputMaybe<SortOrderType>;
	createdAt?: InputMaybe<SortOrderType>;
	description?: InputMaybe<SortOrderType>;
	fileType?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	sponsorName?: InputMaybe<SortOrderType>;
	status?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
	verifiedPreview?: InputMaybe<SortOrderType>;
};

export enum ResourceStatus {
	Active = 'Active',
	Deleted = 'Deleted',
}

export type ResourceWhereInput = {
	AND?: InputMaybe<Array<ResourceWhereInput>>;
	NOT?: InputMaybe<Array<ResourceWhereInput>>;
	OR?: InputMaybe<Array<ResourceWhereInput>>;
	category?: InputMaybe<ResourceCategory>;
	categoryName?: InputMaybe<Scalars['String']['input']>;
	categoryName_contains?: InputMaybe<Scalars['String']['input']>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	description_contains?: InputMaybe<Scalars['String']['input']>;
	fileType?: InputMaybe<FileType>;
	id?: InputMaybe<Scalars['ID']['input']>;
	sponsor?: InputMaybe<SponsorWhereInput>;
	sponsorName?: InputMaybe<Scalars['String']['input']>;
	sponsorName_contains?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<ResourceStatus>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	verifiedPreview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceWhereUniqueInput = {
	id?: InputMaybe<Scalars['ID']['input']>;
};

export type ResponseObjectForGetContractWhere = {
	__typename?: 'ResponseObjectForGetContractWhere';
	contract: ContractForGetContractWhere;
	requestingUserBaseId?: Maybe<Scalars['ID']['output']>;
	requestingUserIsGuest?: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseObjectForGetInvoiceWhere = {
	__typename?: 'ResponseObjectForGetInvoiceWhere';
	invoice: Invoice;
	requestingUserBaseId: Scalars['ID']['output'];
	requestingUserIsGuest: Scalars['Boolean']['output'];
};

export type ResponseObjectForGetProposalWhere = {
	__typename?: 'ResponseObjectForGetProposalWhere';
	proposal: Proposal;
	requestingUserBaseId: Scalars['ID']['output'];
	requestingUserIsGuest: Scalars['Boolean']['output'];
};

export type RetoolResourceCreateInput = {
	category: ResourceCategory;
	description: Scalars['String']['input'];
	fileType: FileType;
	previewFilename: Scalars['String']['input'];
	sponsor: RetoolSponsorConnectInput;
	status: ResourceStatus;
};

export type RetoolResourceUpdateInput = {
	category?: InputMaybe<ResourceCategory>;
	description?: InputMaybe<Scalars['String']['input']>;
	fileType?: InputMaybe<FileType>;
	previewFilename?: InputMaybe<Scalars['String']['input']>;
	sponsor?: InputMaybe<RetoolSponsorConnectInput>;
	status?: InputMaybe<ResourceStatus>;
};

export type RetoolSponsorConnectInput = {
	connect?: InputMaybe<SponsorWhereUniqueInput>;
};

export type RetoolSponsorCreateInput = {
	description: Scalars['String']['input'];
	logoFilename: Scalars['String']['input'];
	name: Scalars['String']['input'];
	sponsorLink: Scalars['String']['input'];
};

export type RetoolSponsorUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	logoFilename?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	sponsorLink?: InputMaybe<Scalars['String']['input']>;
};

export type ReturningMetaData = {
	__typename?: 'ReturningMetaData';
	key?: Maybe<Scalars['String']['output']>;
	value?: Maybe<Scalars['String']['output']>;
};

export type ReturningStripeMetadata = {
	__typename?: 'ReturningStripeMetadata';
	key: Scalars['String']['output'];
	value: Scalars['String']['output'];
};

export type SearchDataInput = {
	take: Scalars['Int']['input'];
	type: SearchDataType;
};

export enum SearchDataType {
	customer = 'customer',
	customerUnboundedByContact = 'customerUnboundedByContact',
	organization = 'organization',
}

export type SearchResult = {
	__typename?: 'SearchResult';
	path: Scalars['String']['output'];
	subtitle?: Maybe<Scalars['String']['output']>;
	title: Scalars['String']['output'];
	type: SearchResultType;
};

export enum SearchResultType {
	client = 'client',
	contract = 'contract',
	invoice = 'invoice',
	lead = 'lead',
	organization = 'organization',
	proposal = 'proposal',
}

export type SearchWhereInput = {
	term: Scalars['String']['input'];
};

export type SendOrResendInvoiceInput = {
	bundle?: InputMaybe<BundleInput>;
	customizedEmail?: InputMaybe<CustomizedEmailInput>;
};

export type SendProposalInput = {
	bundle?: InputMaybe<BundleInput>;
	customizedEmail?: InputMaybe<CustomizedEmailInput>;
};

export type SendgridStatus = {
	__typename?: 'SendgridStatus';
	blocked: Scalars['Boolean']['output'];
	bounced: Scalars['Boolean']['output'];
};

export type SentByUserInputForContracts = {
	AND?: InputMaybe<Array<SentByUserInputForContracts>>;
	NOT?: InputMaybe<Array<SentByUserInputForContracts>>;
	OR?: InputMaybe<Array<SentByUserInputForContracts>>;
	firstName_contains?: InputMaybe<Scalars['String']['input']>;
	lastName_contains?: InputMaybe<Scalars['String']['input']>;
};

export type Service = {
	__typename?: 'Service';
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	organizations?: Maybe<Array<Organization>>;
	updatedAt: Scalars['DateTime']['output'];
};

export type ServiceOrganizationsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<OrganizationOrderByInput>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<OrganizationWhereInput>;
};

export type ServiceCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name: Scalars['String']['input'];
	organizations?: InputMaybe<OrganizationCreateManyWithoutServicesInput>;
};

export type ServiceOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	description?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	name?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
};

export type ServiceWhereInput = {
	AND?: InputMaybe<Array<ServiceWhereInput>>;
	NOT?: InputMaybe<Array<ServiceWhereInput>>;
	OR?: InputMaybe<Array<ServiceWhereInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizations?: InputMaybe<FServiceWhereOrganizationsInput>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ServiceWhereUniqueInput = {
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesForActingUser = {
	__typename?: 'ServicesForActingUser';
	id?: Maybe<Scalars['ID']['output']>;
	name?: Maybe<Scalars['String']['output']>;
};

export type ServicesForGetContractWhere = {
	__typename?: 'ServicesForGetContractWhere';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['ID']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ServicesForGetQuickPayment = {
	__typename?: 'ServicesForGetQuickPayment';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['ID']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SettingsDetails = {
	__typename?: 'SettingsDetails';
	branding?: Maybe<BrandingSettings>;
	card_payments?: Maybe<CardPaymentsSettings>;
	dashboard?: Maybe<DashboardSettings>;
	payments?: Maybe<PaymentsSettings>;
	payouts?: Maybe<PayoutsSettings>;
};

export type SettingsDetailsInput = {
	branding?: InputMaybe<BrandingSettingsInput>;
	card_payments?: InputMaybe<CardPaymentsSettingsInput>;
	dashboard?: InputMaybe<DashboardSettingsInput>;
	payments?: InputMaybe<PaymentsSettingsInput>;
	payouts?: InputMaybe<PayoutsSettingsInput>;
};

export type Signature = {
	__typename?: 'Signature';
	contract?: Maybe<SignatureContract>;
	createdAt: Scalars['DateTime']['output'];
	customerSignature?: Maybe<CustomerSignature>;
	hellosignSignatureId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	signer?: Maybe<SignatureUser>;
	signingDate?: Maybe<Scalars['DateTime']['output']>;
	type?: Maybe<SignatureType>;
	updatedAt: Scalars['DateTime']['output'];
};

export type SignatureContract = {
	__typename?: 'SignatureContract';
	dueDate: Scalars['DateTime']['output'];
	guestToken?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	status: ContractStatus;
	title: Scalars['String']['output'];
};

export type SignatureContractWhereInput = {
	id: Scalars['ID']['input'];
};

export type SignatureCounterSigner = {
	__typename?: 'SignatureCounterSigner';
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	user: SignatureCounterSignerUser;
};

export type SignatureCounterSignerUser = {
	__typename?: 'SignatureCounterSignerUser';
	id: Scalars['ID']['output'];
};

export type SignatureCreateInput = {
	signerId: Scalars['String']['input'];
	type: SignatureType;
};

export type SignatureCreateManyDataInput = {
	data?: InputMaybe<Array<SignatureCreateInput>>;
};

export type SignatureForGetContractWhere = {
	__typename?: 'SignatureForGetContractWhere';
	contract?: Maybe<ContractForGetContractWhere>;
	createdAt: Scalars['DateTime']['output'];
	customerSignature?: Maybe<CustomerSignatureForGetContractWhere>;
	hellosignSignatureId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	signer?: Maybe<SignatureUserForGetContractWhere>;
	signingDate?: Maybe<Scalars['DateTime']['output']>;
	type?: Maybe<SignatureType>;
	updatedAt: Scalars['DateTime']['output'];
};

export enum SignatureType {
	CounterSigner = 'CounterSigner',
	Customer = 'Customer',
}

export type SignatureUser = {
	__typename?: 'SignatureUser';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	orgUser?: Maybe<SignatureCounterSigner>;
	userType: UserType;
};

export type SignatureUserForGetContractWhere = {
	__typename?: 'SignatureUserForGetContractWhere';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	orgUser?: Maybe<OrgUserSignerForGetContractWhere>;
	stripeID?: Maybe<Scalars['String']['output']>;
	userType: UserType;
};

export type SignatureUserWhereInput = {
	id: Scalars['ID']['input'];
};

export type SignaturesCreateManyInput = {
	createMany: SignatureCreateManyDataInput;
};

export type SignaturesWhereInput = {
	contract?: InputMaybe<SignatureContractWhereInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	customerSignature?: InputMaybe<CustomerSignatureWhereInput>;
	hellosignSignatureId?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	signer?: InputMaybe<SignatureUserWhereInput>;
	signingDate?: InputMaybe<Scalars['DateTime']['input']>;
	some?: InputMaybe<SignaturesWhereInput>;
	type?: InputMaybe<SignatureType>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SigningUrl = {
	__typename?: 'SigningUrl';
	url: Scalars['String']['output'];
};

export type SortOrderInequalityInput = {
	gt?: InputMaybe<Scalars['String']['input']>;
	gte?: InputMaybe<Scalars['String']['input']>;
	lt?: InputMaybe<Scalars['String']['input']>;
	lte?: InputMaybe<Scalars['String']['input']>;
};

export enum SortOrderType {
	asc = 'asc',
	desc = 'desc',
}

export type Source = {
	__typename?: 'Source';
	account_holder_name?: Maybe<Scalars['String']['output']>;
	account_holder_type?: Maybe<Scalars['String']['output']>;
	address_zip?: Maybe<Scalars['String']['output']>;
	address_zip_check?: Maybe<Scalars['String']['output']>;
	bank_name?: Maybe<Scalars['String']['output']>;
	billing_details?: Maybe<BillingDetails>;
	brand?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Country>;
	customer?: Maybe<Scalars['String']['output']>;
	cvc_check?: Maybe<Scalars['String']['output']>;
	dynamic_last4?: Maybe<Scalars['String']['output']>;
	exp_month?: Maybe<Scalars['Int']['output']>;
	exp_year?: Maybe<Scalars['Int']['output']>;
	fingerprint?: Maybe<Scalars['String']['output']>;
	funding?: Maybe<Scalars['String']['output']>;
	id: Scalars['String']['output'];
	last4?: Maybe<Scalars['String']['output']>;
	legacy?: Maybe<Scalars['Boolean']['output']>;
	metadata?: Maybe<Array<Maybe<ReturningMetaData>>>;
	name?: Maybe<Scalars['String']['output']>;
	object: Scalars['String']['output'];
	routing_number?: Maybe<Scalars['String']['output']>;
	status?: Maybe<Scalars['String']['output']>;
	tokenization_method?: Maybe<Scalars['String']['output']>;
};

export type SourceOrRedirect = RedirectUrl | Source;

export type Sources = {
	__typename?: 'Sources';
	data?: Maybe<Array<Maybe<Source>>>;
	has_more?: Maybe<Scalars['Boolean']['output']>;
	object?: Maybe<Scalars['String']['output']>;
	total_count?: Maybe<Scalars['Int']['output']>;
	url?: Maybe<Scalars['String']['output']>;
};

export type SourcesWithDefaultSource = {
	__typename?: 'SourcesWithDefaultSource';
	data?: Maybe<Array<Source>>;
	default_source?: Maybe<Scalars['String']['output']>;
	has_more?: Maybe<Scalars['Boolean']['output']>;
	next_cursor?: Maybe<NextCursor>;
	object?: Maybe<Scalars['String']['output']>;
	total_count?: Maybe<Scalars['Int']['output']>;
	url?: Maybe<Scalars['String']['output']>;
};

export type Sponsor = {
	__typename?: 'Sponsor';
	createdAt: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	resources?: Maybe<Array<Resource>>;
	sponsorLink: Scalars['String']['output'];
	updatedAt: Scalars['DateTime']['output'];
	verifiedLogo: Scalars['Boolean']['output'];
};

export type SponsorResourcesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ResourceWhereInput>;
};

export type SponsorOrderByInput = {
	createdAt?: InputMaybe<SortOrderType>;
	description?: InputMaybe<SortOrderType>;
	id?: InputMaybe<SortOrderType>;
	name?: InputMaybe<SortOrderType>;
	sponsorLink?: InputMaybe<SortOrderType>;
	updatedAt?: InputMaybe<SortOrderType>;
	verifiedLogo?: InputMaybe<SortOrderType>;
};

export type SponsorWhereInput = {
	AND?: InputMaybe<Array<SponsorWhereInput>>;
	NOT?: InputMaybe<Array<SponsorWhereInput>>;
	OR?: InputMaybe<Array<SponsorWhereInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	resources?: InputMaybe<SponsorWhereResourcesInput>;
	sponsorLink?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	verifiedLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SponsorWhereResourcesInput = {
	every?: InputMaybe<ResourceWhereInput>;
	none?: InputMaybe<ResourceWhereInput>;
	some?: InputMaybe<ResourceWhereInput>;
};

export type SponsorWhereUniqueInput = {
	id?: InputMaybe<Scalars['ID']['input']>;
};

export enum State {
	AB = 'AB',
	AK = 'AK',
	AL = 'AL',
	AR = 'AR',
	AZ = 'AZ',
	BC = 'BC',
	CA = 'CA',
	CO = 'CO',
	CT = 'CT',
	DC = 'DC',
	DE = 'DE',
	FL = 'FL',
	GA = 'GA',
	HI = 'HI',
	IA = 'IA',
	ID = 'ID',
	IL = 'IL',
	IN = 'IN',
	KS = 'KS',
	KY = 'KY',
	LA = 'LA',
	MA = 'MA',
	MB = 'MB',
	MD = 'MD',
	ME = 'ME',
	MI = 'MI',
	MN = 'MN',
	MO = 'MO',
	MP = 'MP',
	MS = 'MS',
	MT = 'MT',
	NB = 'NB',
	NC = 'NC',
	ND = 'ND',
	NE = 'NE',
	NH = 'NH',
	NJ = 'NJ',
	NL = 'NL',
	NM = 'NM',
	NS = 'NS',
	NT = 'NT',
	NU = 'NU',
	NV = 'NV',
	NY = 'NY',
	OH = 'OH',
	OK = 'OK',
	ON = 'ON',
	OR = 'OR',
	PA = 'PA',
	PE = 'PE',
	PR = 'PR',
	QC = 'QC',
	RI = 'RI',
	SC = 'SC',
	SD = 'SD',
	SK = 'SK',
	TN = 'TN',
	TX = 'TX',
	UT = 'UT',
	VA = 'VA',
	VT = 'VT',
	WA = 'WA',
	WI = 'WI',
	WV = 'WV',
	WY = 'WY',
	YT = 'YT',
}

export type StripeAddress = {
	__typename?: 'StripeAddress';
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	line1?: Maybe<Scalars['String']['output']>;
	line2?: Maybe<Scalars['String']['output']>;
	postal_code?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
};

export type StripeBankAccountCreationInput = {
	isDefault?: InputMaybe<Scalars['Boolean']['input']>;
	nickname?: InputMaybe<Scalars['String']['input']>;
	source: StripeBankAccountSourceInput;
};

export type StripeBankAccountDeletionInput = {
	source: Scalars['String']['input'];
};

export type StripeBankAccountSourceInput = {
	account_holder_name: Scalars['String']['input'];
	account_holder_type: Scalars['String']['input'];
	account_number: Scalars['String']['input'];
	nickname?: InputMaybe<Scalars['String']['input']>;
	object: BankAccountObject;
	routing_number: Scalars['String']['input'];
};

export type StripeBankAccountUpdateInput = {
	accountUpdates?: InputMaybe<StripeBankAccountUpdates>;
	isDefault?: InputMaybe<Scalars['Boolean']['input']>;
	nickname?: InputMaybe<Scalars['String']['input']>;
};

export type StripeBankAccountUpdates = {
	billing_details?: InputMaybe<Billing_Details>;
	us_bank_account?: InputMaybe<Us_Bank_Account>;
};

export type StripeCardCreationInput = {
	isDefault: Scalars['Boolean']['input'];
	nickname?: InputMaybe<Scalars['String']['input']>;
	token: Scalars['String']['input'];
};

export type StripeCardUpdateInfoInput = {
	exp_month: Scalars['Int']['input'];
	exp_year: Scalars['Int']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	nickname?: InputMaybe<Scalars['String']['input']>;
	postal_code?: InputMaybe<Scalars['String']['input']>;
};

export type StripeConnectAccount = {
	__typename?: 'StripeConnectAccount';
	business_profile?: Maybe<BusinessProfile>;
	business_type?: Maybe<Scalars['String']['output']>;
	capabilities?: Maybe<AccountCapabilities>;
	charges_enabled?: Maybe<Scalars['Boolean']['output']>;
	company?: Maybe<CompanyDetails>;
	country?: Maybe<Country>;
	created?: Maybe<Scalars['Int']['output']>;
	default_currency?: Maybe<Scalars['String']['output']>;
	details_submitted?: Maybe<Scalars['String']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	external_accounts?: Maybe<Sources>;
	future_requirements?: Maybe<RequirementsDetails>;
	id?: Maybe<Scalars['String']['output']>;
	individual?: Maybe<StripePerson>;
	metadata: Array<ReturningMetaData>;
	object?: Maybe<Scalars['String']['output']>;
	payouts_enabled?: Maybe<Scalars['Boolean']['output']>;
	product_description?: Maybe<Scalars['String']['output']>;
	requirements?: Maybe<RequirementsDetails>;
	settings?: Maybe<SettingsDetails>;
	statement_descriptor?: Maybe<Scalars['String']['output']>;
	support_address?: Maybe<Address>;
	support_email?: Maybe<Scalars['String']['output']>;
	support_phone?: Maybe<Scalars['String']['output']>;
	timezone?: Maybe<Scalars['String']['output']>;
	tos_acceptance?: Maybe<TosAcceptance>;
	type?: Maybe<Scalars['String']['output']>;
};

export type StripeConnectAccountCreationInput = {
	business_type: Scalars['String']['input'];
	company?: InputMaybe<CompanyDetailsInput>;
	country: Country;
	tos_acceptance: StripeTosAcceptanceInput;
};

export type StripeConnectAccountUpdateInput = {
	account_token?: InputMaybe<Scalars['String']['input']>;
	business_profile?: InputMaybe<BusinessProfileInput>;
	business_type?: InputMaybe<Scalars['String']['input']>;
	company?: InputMaybe<CompanyDetailsInput>;
	default_currency?: InputMaybe<Scalars['String']['input']>;
	email?: InputMaybe<Scalars['String']['input']>;
	external_account?: InputMaybe<StripeBankAccountSourceInput>;
	individual?: InputMaybe<StripePersonInput>;
	metadata?: InputMaybe<Array<StripeMetaData>>;
	settings?: InputMaybe<SettingsDetailsInput>;
	tos_acceptance?: InputMaybe<StripeTosAcceptanceInput>;
};

export type StripeCoupon = {
	__typename?: 'StripeCoupon';
	amount_off?: Maybe<Scalars['Int']['output']>;
	created?: Maybe<Scalars['Int']['output']>;
	currency?: Maybe<Scalars['String']['output']>;
	duration?: Maybe<Scalars['String']['output']>;
	duration_in_months?: Maybe<Scalars['Int']['output']>;
	id?: Maybe<Scalars['String']['output']>;
	livemode?: Maybe<Scalars['Boolean']['output']>;
	max_redemptions?: Maybe<Scalars['Int']['output']>;
	metadata?: Maybe<Array<Maybe<ReturningMetaData>>>;
	name?: Maybe<Scalars['String']['output']>;
	object?: Maybe<Scalars['String']['output']>;
	percent_off?: Maybe<Scalars['Int']['output']>;
	period?: Maybe<Scalars['String']['output']>;
	redeem_by?: Maybe<Scalars['Int']['output']>;
	times_redeemed?: Maybe<Scalars['Int']['output']>;
	valid?: Maybe<Scalars['Boolean']['output']>;
};

export enum StripeDuration {
	forever = 'forever',
	once = 'once',
	repeating = 'repeating',
}

export type StripeExternalAccountUpdateInput = {
	accountUpdates?: InputMaybe<StripeBankAccountUpdates>;
	newAccountUpdates?: InputMaybe<NewExternalAccountUpdateInput>;
	nickname?: InputMaybe<Scalars['String']['input']>;
};

export type StripeInvoice = {
	__typename?: 'StripeInvoice';
	amount_due: Scalars['Int']['output'];
	amount_paid?: Maybe<Scalars['Int']['output']>;
	amount_remaining?: Maybe<Scalars['Int']['output']>;
	application_fee?: Maybe<Scalars['String']['output']>;
	attempt_count?: Maybe<Scalars['Int']['output']>;
	attempted?: Maybe<Scalars['Boolean']['output']>;
	auto_advance?: Maybe<Scalars['Boolean']['output']>;
	billing?: Maybe<Scalars['String']['output']>;
	billing_reason?: Maybe<Scalars['String']['output']>;
	charge?: Maybe<Scalars['String']['output']>;
	customer?: Maybe<Scalars['String']['output']>;
	date?: Maybe<Scalars['Int']['output']>;
	default_source?: Maybe<Scalars['String']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	discount?: Maybe<Discount>;
	due_date?: Maybe<Scalars['Int']['output']>;
	finalized_at?: Maybe<Scalars['Int']['output']>;
	hosted_invoice_url?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['String']['output']>;
	invoice_pdf?: Maybe<Scalars['String']['output']>;
	lines?: Maybe<StripeInvoiceLines>;
	livemode?: Maybe<Scalars['Boolean']['output']>;
	metadata?: Maybe<Array<Maybe<ReturningMetaData>>>;
	next_payment_attempt?: Maybe<Scalars['Int']['output']>;
	number?: Maybe<Scalars['String']['output']>;
	object: Scalars['String']['output'];
	paid?: Maybe<Scalars['Boolean']['output']>;
	period_end?: Maybe<Scalars['Int']['output']>;
	period_start?: Maybe<Scalars['Int']['output']>;
	receipt_number?: Maybe<Scalars['String']['output']>;
	starting_balance?: Maybe<Scalars['Int']['output']>;
	statement_descriptor?: Maybe<Scalars['String']['output']>;
	status?: Maybe<Scalars['String']['output']>;
	subscription?: Maybe<Scalars['String']['output']>;
	subscription_proration_date?: Maybe<Scalars['Int']['output']>;
	subtotal?: Maybe<Scalars['Int']['output']>;
	tax?: Maybe<Scalars['Int']['output']>;
	total?: Maybe<Scalars['Int']['output']>;
	webhooks_delivered_at?: Maybe<Scalars['Int']['output']>;
};

export type StripeInvoiceLines = {
	__typename?: 'StripeInvoiceLines';
	data?: Maybe<Array<Maybe<StripeLineItem>>>;
	has_more?: Maybe<Scalars['Boolean']['output']>;
	object?: Maybe<Scalars['String']['output']>;
	url?: Maybe<Scalars['String']['output']>;
};

export type StripeInvoicesList = {
	__typename?: 'StripeInvoicesList';
	data: Array<Maybe<StripeInvoice>>;
	has_more: Scalars['Boolean']['output'];
	object: Scalars['String']['output'];
};

export type StripeLineItem = {
	__typename?: 'StripeLineItem';
	amount?: Maybe<Scalars['Int']['output']>;
	currency?: Maybe<Scalars['String']['output']>;
	customer: Scalars['String']['output'];
	date?: Maybe<Scalars['Int']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	discountable?: Maybe<Scalars['Boolean']['output']>;
	id: Scalars['String']['output'];
	invoice?: Maybe<Scalars['String']['output']>;
	livemode?: Maybe<Scalars['Boolean']['output']>;
	metadata?: Maybe<Array<Maybe<ReturningMetaData>>>;
	object?: Maybe<Scalars['String']['output']>;
};

export type StripeMetaData = {
	key: Scalars['String']['input'];
	value: Scalars['String']['input'];
};

export enum StripeOnboardingFormType {
	account_onboarding = 'account_onboarding',
	account_update = 'account_update',
}

export type StripeOnboardingInput = {
	return_url?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<StripeOnboardingFormType>;
};

export type StripeOnboardingUrl = {
	__typename?: 'StripeOnboardingURL';
	url: Scalars['String']['output'];
};

export type StripePaymentOrSetupIntentStatus = {
	autoPayRemainder?: InputMaybe<Scalars['Boolean']['input']>;
	deletePaymentMethodWhenPaymentComplete?: InputMaybe<
		Scalars['Boolean']['input']
	>;
	status: Scalars['String']['input'];
	stripePaymentIntentID?: InputMaybe<Scalars['String']['input']>;
	stripeSetupIntentID?: InputMaybe<Scalars['String']['input']>;
};

export type StripePerson = {
	__typename?: 'StripePerson';
	account?: Maybe<Scalars['String']['output']>;
	address?: Maybe<Address>;
	created?: Maybe<Scalars['Int']['output']>;
	dob?: Maybe<Dob>;
	first_name?: Maybe<Scalars['String']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['String']['output']>;
	id_number_provided?: Maybe<Scalars['String']['output']>;
	last_name?: Maybe<Scalars['String']['output']>;
	maiden_name?: Maybe<Scalars['String']['output']>;
	metadata: Array<ReturningMetaData>;
	object?: Maybe<Scalars['String']['output']>;
	relationship?: Maybe<Relationship>;
	requirements?: Maybe<RequirementsDetails>;
	ssn_last_4_provided?: Maybe<Scalars['Boolean']['output']>;
	verification?: Maybe<PersonVerificationDetails>;
};

export type StripePersonInput = {
	address?: InputMaybe<AddressInput>;
	dob?: InputMaybe<DobInput>;
	email?: InputMaybe<Scalars['String']['input']>;
	first_name?: InputMaybe<Scalars['String']['input']>;
	gender?: InputMaybe<Scalars['String']['input']>;
	id_number?: InputMaybe<Scalars['String']['input']>;
	last_name?: InputMaybe<Scalars['String']['input']>;
	maiden_name?: InputMaybe<Scalars['String']['input']>;
	metadata?: InputMaybe<Array<StripeMetaData>>;
	phone?: InputMaybe<Scalars['String']['input']>;
	relationship?: InputMaybe<RelationshipInput>;
	ssn_last_4?: InputMaybe<Scalars['String']['input']>;
	useOrgAddress?: InputMaybe<Scalars['Boolean']['input']>;
	useOrgPhone?: InputMaybe<Scalars['Boolean']['input']>;
	verification?: InputMaybe<PersonVerificationDetailsInput>;
};

export type StripePlan = {
	__typename?: 'StripePlan';
	active?: Maybe<Scalars['Boolean']['output']>;
	aggregate_usage?: Maybe<Scalars['String']['output']>;
	amount?: Maybe<Scalars['Int']['output']>;
	billing_scheme?: Maybe<Scalars['String']['output']>;
	created?: Maybe<Scalars['Int']['output']>;
	currency?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['String']['output']>;
	interval?: Maybe<StripePlanInterval>;
	interval_count?: Maybe<Scalars['String']['output']>;
	livemode?: Maybe<Scalars['Boolean']['output']>;
	metadata?: Maybe<Array<Maybe<ReturningMetaData>>>;
	nickname?: Maybe<Scalars['String']['output']>;
	object?: Maybe<Scalars['String']['output']>;
	product?: Maybe<Scalars['String']['output']>;
	stripePlanID?: Maybe<Scalars['String']['output']>;
	trial_period_days?: Maybe<Scalars['Int']['output']>;
	usage_type?: Maybe<Scalars['String']['output']>;
};

export type StripePlanCreationInput = {
	active?: InputMaybe<Scalars['Boolean']['input']>;
	amount: Scalars['Int']['input'];
	currency: Scalars['String']['input'];
	interval: Scalars['String']['input'];
	interval_count: Scalars['Int']['input'];
	metadata?: InputMaybe<Array<InputMaybe<StripeMetaData>>>;
	product?: InputMaybe<PlanProduct>;
	trial_period_days?: InputMaybe<Scalars['Int']['input']>;
};

export enum StripePlanInterval {
	day = 'day',
	month = 'month',
	week = 'week',
	year = 'year',
}

export type StripePlanRetrievalInput = {
	planID: Scalars['String']['input'];
};

export enum StripeSubscriptionStatus {
	active = 'active',
	canceled = 'canceled',
	incomplete = 'incomplete',
	incomplete_expired = 'incomplete_expired',
	past_due = 'past_due',
	trialing = 'trialing',
	unpaid = 'unpaid',
}

export type StripeTosAcceptanceInput = {
	date?: InputMaybe<Scalars['Int']['input']>;
};

export type StripeUser = {
	__typename?: 'StripeUser';
	account_balance?: Maybe<Scalars['Int']['output']>;
	created?: Maybe<Scalars['Int']['output']>;
	currency?: Maybe<Scalars['String']['output']>;
	default_source?: Maybe<Scalars['String']['output']>;
	delinquent?: Maybe<Scalars['Boolean']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	discount?: Maybe<Discount>;
	email?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['String']['output']>;
	invoice_prefix?: Maybe<Scalars['String']['output']>;
	livemode?: Maybe<Scalars['Boolean']['output']>;
	metadata: Array<ReturningMetaData>;
	object?: Maybe<Scalars['String']['output']>;
	sources?: Maybe<Sources>;
	subscriptions?: Maybe<SubscriptionsList>;
};

export type StripeVendorCardCreationInput = {
	isDefault: Scalars['Boolean']['input'];
	nickname?: InputMaybe<Scalars['String']['input']>;
	organizationID: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export type StripeVendorSubscriptionChangeInput = {
	period: PlanPeriod;
	type: PlanType;
};

export type StripeVendorSubscriptionCreationInput = {
	period: PlanPeriod;
	type: PlanType;
};

export type SubmitInquiryFromIntegrationInput = {
	companyName?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	eventDate?: InputMaybe<Scalars['DateTime']['input']>;
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
	__typename?: 'Subscription';
	eventCreated: Event;
	inquiryChanged: Inquiry;
};

export type SubscriptionCostPreview = {
	__typename?: 'SubscriptionCostPreview';
	amount: Scalars['Int']['output'];
	date?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionItems = {
	__typename?: 'SubscriptionItems';
	data?: Maybe<Array<Maybe<SubscriptionPlan>>>;
	object?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionObject = {
	__typename?: 'SubscriptionObject';
	amount?: Maybe<Scalars['Int']['output']>;
	application_fee_percent?: Maybe<Scalars['Int']['output']>;
	billing?: Maybe<Scalars['String']['output']>;
	billing_cycle_anchor?: Maybe<Scalars['Int']['output']>;
	cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
	cancelled_at?: Maybe<Scalars['Int']['output']>;
	customer?: Maybe<Scalars['String']['output']>;
	days_until_due?: Maybe<Scalars['Int']['output']>;
	default_source?: Maybe<Scalars['String']['output']>;
	discounts?: Maybe<Array<Maybe<Discount>>>;
	ended_at?: Maybe<Scalars['Int']['output']>;
	id: Scalars['String']['output'];
	items?: Maybe<SubscriptionItems>;
	livemode?: Maybe<Scalars['Boolean']['output']>;
	metadata: Array<ReturningMetaData>;
	object?: Maybe<Scalars['String']['output']>;
	plan?: Maybe<StripePlan>;
	quantity?: Maybe<Scalars['Int']['output']>;
	start?: Maybe<Scalars['Int']['output']>;
	status?: Maybe<StripeSubscriptionStatus>;
	subscriptionPlanID?: Maybe<Scalars['String']['output']>;
	trial_end?: Maybe<Scalars['Int']['output']>;
	trial_start?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionObjectOrRedirect = RedirectUrl | SubscriptionObject;

export type SubscriptionPlan = {
	__typename?: 'SubscriptionPlan';
	created?: Maybe<Scalars['Int']['output']>;
	current_period_end?: Maybe<Scalars['Int']['output']>;
	current_period_start?: Maybe<Scalars['Int']['output']>;
	id?: Maybe<Scalars['String']['output']>;
	metadata: Array<ReturningMetaData>;
	object?: Maybe<Scalars['String']['output']>;
	plan?: Maybe<StripePlan>;
	quantity?: Maybe<Scalars['Int']['output']>;
	subscription?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatus {
	Active = 'Active',
	Canceled = 'Canceled',
	Incomplete = 'Incomplete',
	IncompleteExpired = 'IncompleteExpired',
	PastDue = 'PastDue',
	Trialing = 'Trialing',
	Unpaid = 'Unpaid',
}

export type SubscriptionsList = {
	__typename?: 'SubscriptionsList';
	data: Array<SubscriptionObject>;
	has_more?: Maybe<Scalars['Boolean']['output']>;
	object: Scalars['String']['output'];
	url?: Maybe<Scalars['String']['output']>;
};

export type SuperAdminCapability = {
	__typename?: 'SuperAdminCapability';
	capabilities?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
};

export type SuperAdminUser = {
	__typename?: 'SuperAdminUser';
	createdAt: Scalars['DateTime']['output'];
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	updatedAt: Scalars['DateTime']['output'];
	user: User;
};

export type SuperAdminUserWhereInput = {
	AND?: InputMaybe<Array<SuperAdminUserWhereInput>>;
	NOT?: InputMaybe<Array<SuperAdminUserWhereInput>>;
	OR?: InputMaybe<Array<SuperAdminUserWhereInput>>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	user?: InputMaybe<UserWhereInput>;
};

export type TosAcceptance = {
	__typename?: 'TOSAcceptance';
	date: Scalars['Int']['output'];
	ip: Scalars['String']['output'];
	user_agent: Scalars['String']['output'];
};

export enum TeamMemberRole {
	Admin = 'Admin',
	Disabled = 'Disabled',
	Manager = 'Manager',
	Member = 'Member',
	Owner = 'Owner',
}

export type TestingGroup = {
	__typename?: 'TestingGroup';
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	featureFlags: Array<Maybe<FeatureFlag>>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	organizations: Array<Maybe<Organization>>;
	updatedAt: Scalars['DateTime']['output'];
	users: Array<Maybe<User>>;
};

export type TestingGroupWhereInput = {
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	featureFlags?: InputMaybe<FeatureFlagWhereInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizations?: InputMaybe<OrganizationWhereInput>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	users?: InputMaybe<UserWhereInput>;
};

export type TestingGroupWhereUniqueInput = {
	id: Scalars['ID']['input'];
};

export type TopCustomerBySpend = {
	__typename?: 'TopCustomerBySpend';
	contactEmail: Scalars['String']['output'];
	contactName: Scalars['String']['output'];
	customerId: Scalars['ID']['output'];
	totalLifetimeSpend: Scalars['String']['output'];
};

export type TransactionHistory = {
	__typename?: 'TransactionHistory';
	hasMore: Scalars['Boolean']['output'];
	transactionHistoryItems: Array<TransactionHistoryItem>;
};

export type TransactionHistoryChargeOrRefund = {
	__typename?: 'TransactionHistoryChargeOrRefund';
	amount: Scalars['Int']['output'];
	clientUser?: Maybe<ReducedClientUser>;
	contact?: Maybe<ReducedContact>;
	date: Scalars['Int']['output'];
	guestUser?: Maybe<ReducedGuestUser>;
	id: Scalars['String']['output'];
	invoice?: Maybe<ReducedInvoice>;
	metadata?: Maybe<Array<ReturningStripeMetadata>>;
	paymentInstallment?: Maybe<ReducedPaymentInstallment>;
	status: Scalars['String']['output'];
	type: Scalars['String']['output'];
};

export type TransactionHistoryItem = {
	__typename?: 'TransactionHistoryItem';
	payout: TransactionHistoryPayout;
	transactions: Array<Maybe<TransactionHistoryChargeOrRefund>>;
};

export type TransactionHistoryPayout = {
	__typename?: 'TransactionHistoryPayout';
	amount?: Maybe<Scalars['Int']['output']>;
	date?: Maybe<Scalars['Int']['output']>;
	id: Scalars['String']['output'];
	status: Scalars['String']['output'];
	type: Scalars['String']['output'];
};

export type TransactionHistoryUrl = {
	__typename?: 'TransactionHistoryUrl';
	url: Scalars['String']['output'];
};

export type UnblockUserEmailInSendgridInput = {
	email: Scalars['String']['input'];
};

export type UpcomingPayments = {
	__typename?: 'UpcomingPayments';
	invoices: Array<InvoiceForDashboardStats>;
	totalAmountUpcoming: Scalars['String']['output'];
};

export type UpdateContactStatusDataInput = {
	status: ContactStatus;
};

export type UpdateCustomerStripeCardWhereInput = {
	source: Scalars['String']['input'];
};

export type UpdateDocumentInput = {
	exportable: Scalars['Boolean']['input'];
	name: Scalars['String']['input'];
};

export type UpdateDocumentNameInput = {
	name: Scalars['String']['input'];
};

export type UpdateFolderNameInput = {
	name: Scalars['String']['input'];
};

export type UpdateInvoiceFromPaymentSessionInput = {
	activateAutoPay: Scalars['Boolean']['input'];
	gratuityAmount?: InputMaybe<Scalars['Float']['input']>;
	invoiceId: Scalars['String']['input'];
	paymentInstallmentIds: Array<Scalars['String']['input']>;
	paymentIntentId: Scalars['String']['input'];
	receiptEmails?: InputMaybe<Array<Scalars['String']['input']>>;
	sessionPaymentInstallmentId: Scalars['String']['input'];
	token?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaidInstallmentInput = {
	paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
	paymentNote?: InputMaybe<Scalars['String']['input']>;
	paymentType?: InputMaybe<PaymentType>;
};

export type UpdateRefundedInstallmentInput = {
	amountRefunded?: InputMaybe<Scalars['Int']['input']>;
	refundDate?: InputMaybe<Scalars['DateTime']['input']>;
	refundNote?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebhookSubscriptionsInput = {
	endpointId: Scalars['ID']['input'];
	eventTypes: Array<WebhookEventType>;
};

export type UploadUrl = {
	__typename?: 'UploadUrl';
	uploadURL?: Maybe<Scalars['String']['output']>;
};

export type User = {
	__typename?: 'User';
	AND?: Maybe<Array<User>>;
	NOT?: Maybe<Array<User>>;
	OR?: Maybe<Array<User>>;
	acceptedTerms?: Maybe<Scalars['DateTime']['output']>;
	blocked: Scalars['Boolean']['output'];
	canvaToken?: Maybe<CanvaOAuthToken>;
	clientUser?: Maybe<ClientUser>;
	consentedToAgeAndMarketingEmails?: Maybe<Scalars['DateTime']['output']>;
	contacts?: Maybe<Array<Maybe<Contact>>>;
	createdAt: Scalars['DateTime']['output'];
	email: Scalars['String']['output'];
	events?: Maybe<Array<Event>>;
	eventsLastViewedAt: Scalars['DateTime']['output'];
	groups?: Maybe<Array<TestingGroup>>;
	guestUser?: Maybe<GuestUser>;
	id: Scalars['ID']['output'];
	ipAddressWhereTermsAccepted?: Maybe<Scalars['String']['output']>;
	isVerified?: Maybe<Scalars['Boolean']['output']>;
	lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
	onboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
	orgUser?: Maybe<OrgUser>;
	referral?: Maybe<Referral>;
	seenOnboardingModalAt?: Maybe<Scalars['DateTime']['output']>;
	stripeCustomerId?: Maybe<Scalars['String']['output']>;
	superAdmin?: Maybe<SuperAdminUser>;
	updatedAt: Scalars['DateTime']['output'];
	userAgentWhereTermsAccepted?: Maybe<Scalars['String']['output']>;
	userType: UserType;
	vendorDashboardConfigurationItems?: Maybe<Array<VendorDashboardItem>>;
};

export type UserContactsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<Array<InputMaybe<ContactOrderByInput>>>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ContactWhereInput>;
};

export type UserByEmailUniqueInput = {
	email: Scalars['ID']['input'];
};

export type UserByIdUniqueInput = {
	id: Scalars['ID']['input'];
};

export type UserForGetQuickPayment = {
	__typename?: 'UserForGetQuickPayment';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
};

export type UserForSignature = {
	__typename?: 'UserForSignature';
	id: Scalars['ID']['output'];
};

export type UserLoginInput = {
	email: Scalars['String']['input'];
	mfaToken?: InputMaybe<Scalars['Int']['input']>;
	password: Scalars['String']['input'];
	targetUserEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UserTestingGroupWhereInput = {
	every?: InputMaybe<TestingGroupWhereInput>;
	none?: InputMaybe<TestingGroupWhereInput>;
	some?: InputMaybe<TestingGroupWhereInput>;
};

export enum UserType {
	ClientUser = 'ClientUser',
	GuestUser = 'GuestUser',
	OrgUser = 'OrgUser',
	SuperAdmin = 'SuperAdmin',
}

export type UserUpdateOneRequiredWithoutClientUserInput = {
	connect?: InputMaybe<UserWhereUniqueInput>;
};

export type UserUpdateSelfInput = {
	eventsLastViewedAt?: InputMaybe<Scalars['DateTime']['input']>;
	seenOnboardingModalAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserWhereContactsInput = {
	every?: InputMaybe<ContactWhereInput>;
	none?: InputMaybe<ContactWhereInput>;
	some?: InputMaybe<ContactWhereInput>;
};

export type UserWhereInput = {
	AND?: InputMaybe<Array<UserWhereInput>>;
	NOT?: InputMaybe<Array<UserWhereInput>>;
	OR?: InputMaybe<Array<UserWhereInput>>;
	acceptedTerms?: InputMaybe<Scalars['DateTime']['input']>;
	blocked?: InputMaybe<Scalars['Boolean']['input']>;
	clientUser?: InputMaybe<ClientUserWhereInput>;
	contacts?: InputMaybe<UserWhereContactsInput>;
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	email?: InputMaybe<Scalars['String']['input']>;
	email_contains?: InputMaybe<Scalars['String']['input']>;
	every?: InputMaybe<UserWhereInput>;
	groups?: InputMaybe<UserTestingGroupWhereInput>;
	guestUser?: InputMaybe<GuestUserWhereInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
	ipAddressWhereTermsAccepted?: InputMaybe<Scalars['String']['input']>;
	isVerified?: InputMaybe<Scalars['Boolean']['input']>;
	lastSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
	none?: InputMaybe<UserWhereInput>;
	onboardingCompleted?: InputMaybe<Scalars['Boolean']['input']>;
	orgUser?: InputMaybe<OrgUserWhereInput>;
	passWordLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
	passwordResetToken?: InputMaybe<Scalars['String']['input']>;
	passwordResetTokenExpiresAt?: InputMaybe<Scalars['String']['input']>;
	referral?: InputMaybe<ReferralWhereInput>;
	some?: InputMaybe<UserWhereInput>;
	superAdmin?: InputMaybe<SuperAdminUserWhereInput>;
	updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
	userAgentWhereTermsAccepted?: InputMaybe<Scalars['String']['input']>;
	userType?: InputMaybe<UserType>;
};

export type UserWhereInputForGetInvoicesForCustomer = {
	clientUser?: InputMaybe<ClientUserForSearchFilterInput>;
	email?: InputMaybe<Scalars['String']['input']>;
	email_contains?: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereUniqueInput = {
	email?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
};

export type UsersForGetContractWhere = {
	__typename?: 'UsersForGetContractWhere';
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	organization?: Maybe<OrganizationForGetContractWhere>;
	role: TeamMemberRole;
	user?: Maybe<BaseUserForGetContractWhere>;
};

export type ValidateApiKeyResult = {
	__typename?: 'ValidateAPIKeyResult';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type ValidatePaymentInstallmentsInput = {
	installments: Array<InstallmentAmountInput>;
	/** Whether the payment method is a card (for convenience fee calculation) */
	isPayingWithCard: Scalars['Boolean']['input'];
	/** The installment that has a Stripe payment intent created for the current payment session. Only this installment's intent is validated; subsequent installments' intents are created later in updateInvoiceFromPaymentSession. */
	sessionPaymentInstallmentId: Scalars['ID']['input'];
	/** Whether to skip throwing errors and return the updated payment installments with their statuses */
	skipThrowingErrors?: InputMaybe<Scalars['Boolean']['input']>;
	/** Optional guest token for unauthenticated users */
	token?: InputMaybe<Scalars['String']['input']>;
};

export type VendorDashboardConfigurationInput = {
	dashboardItems: Array<VendorDashboardItemInput>;
};

export type VendorDashboardItem = {
	__typename?: 'VendorDashboardItem';
	createdAt: Scalars['DateTime']['output'];
	enabled: Scalars['Boolean']['output'];
	id: Scalars['String']['output'];
	order: Scalars['Int']['output'];
	type: VendorDashboardItemType;
	updatedAt: Scalars['DateTime']['output'];
};

export type VendorDashboardItemInput = {
	enabled: Scalars['Boolean']['input'];
	id?: InputMaybe<Scalars['String']['input']>;
	order: Scalars['Int']['input'];
	type: VendorDashboardItemType;
};

export enum VendorDashboardItemType {
	Clients = 'Clients',
	ClientsGraph = 'ClientsGraph',
	ContractsCompleted = 'ContractsCompleted',
	ContractsCompletedGraph = 'ContractsCompletedGraph',
	ContractsOutstanding = 'ContractsOutstanding',
	ContractsSummary = 'ContractsSummary',
	FailedPayments = 'FailedPayments',
	Leads = 'Leads',
	LeadsGraph = 'LeadsGraph',
	NewClients = 'NewClients',
	OverduePayments = 'OverduePayments',
	PaymentsReceived = 'PaymentsReceived',
	PaymentsReceivedGraph = 'PaymentsReceivedGraph',
	PaymentsSummary = 'PaymentsSummary',
	ProposalsAccepted = 'ProposalsAccepted',
	ProposalsAcceptedGraph = 'ProposalsAcceptedGraph',
	ProposalsOutstanding = 'ProposalsOutstanding',
	ProposalsSummary = 'ProposalsSummary',
	TopCustomersBySpend = 'TopCustomersBySpend',
	UpcomingPayments = 'UpcomingPayments',
}

export type VendorFeeStructureInput = {
	achAppFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
	cardAppFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
	cardConvenienceFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type VendorInputForGetContractsForCustomer = {
	id?: InputMaybe<Scalars['ID']['input']>;
	name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type VendorInputForGetContractsForVendor = {
	name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type VerificationDocument = {
	__typename?: 'VerificationDocument';
	back?: Maybe<Scalars['String']['output']>;
	details?: Maybe<Scalars['String']['output']>;
	details_code?: Maybe<Scalars['String']['output']>;
	front?: Maybe<Scalars['String']['output']>;
};

export type VerificationDocumentInput = {
	back?: InputMaybe<Scalars['String']['input']>;
	front?: InputMaybe<Scalars['String']['input']>;
};

export type VerificationToken = {
	__typename?: 'VerificationToken';
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	user: User;
	verificationToken: Scalars['String']['output'];
};

export type VerificationTokenWhereInput = {
	AND?: InputMaybe<Array<VerificationTokenWhereInput>>;
	NOT?: InputMaybe<Array<VerificationTokenWhereInput>>;
	OR?: InputMaybe<Array<VerificationTokenWhereInput>>;
	id?: InputMaybe<Scalars['ID']['input']>;
	user?: InputMaybe<UserWhereInput>;
	verificationToken?: InputMaybe<Scalars['String']['input']>;
};

export type VerificationTokenWhereUniqueInput = {
	id?: InputMaybe<Scalars['ID']['input']>;
	verificationToken?: InputMaybe<Scalars['String']['input']>;
};

export type WalletQuickPayment = {
	__typename?: 'WalletQuickPayment';
	amount?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	invoices?: Maybe<Array<WalletQuickPaymentInvoice>>;
	link?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	payments: Scalars['Int']['output'];
	reason?: Maybe<Scalars['String']['output']>;
	total: Scalars['String']['output'];
};

export type WalletQuickPaymentInvoice = {
	__typename?: 'WalletQuickPaymentInvoice';
	amountPaid: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	paymentDate: Scalars['DateTime']['output'];
	title: Scalars['String']['output'];
};

export type WalletQuickPaymentOrderByInput = {
	contact?: InputMaybe<ContactOrderByInput>;
	createdAt?: InputMaybe<SortOrderType>;
};

export type WebhookDelivery = {
	__typename?: 'WebhookDelivery';
	apiVersion: Scalars['String']['output'];
	attemptCount: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	deliveredAt?: Maybe<Scalars['DateTime']['output']>;
	destinationUrl: Scalars['String']['output'];
	eventId: Scalars['ID']['output'];
	eventType: WebhookEventType;
	exhaustedAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	lastAttemptAt?: Maybe<Scalars['DateTime']['output']>;
	nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
	payload: Scalars['Json']['output'];
	responseStatus?: Maybe<Scalars['Int']['output']>;
	status: WebhookDeliveryStatus;
};

export enum WebhookDeliveryStatus {
	Delivered = 'Delivered',
	Delivering = 'Delivering',
	Exhausted = 'Exhausted',
	Failed = 'Failed',
	Pending = 'Pending',
}

export type WebhookEndpoint = {
	__typename?: 'WebhookEndpoint';
	apiVersion: Scalars['String']['output'];
	createdAt: Scalars['DateTime']['output'];
	description: Scalars['String']['output'];
	destinationUrl: Scalars['String']['output'];
	enabled: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	pausedAt?: Maybe<Scalars['DateTime']['output']>;
	previousSecretExpiresAt?: Maybe<Scalars['DateTime']['output']>;
	secretSuffix: Scalars['String']['output'];
	subscribedEventTypes: Array<WebhookEventType>;
	updatedAt: Scalars['DateTime']['output'];
};

export type WebhookEndpointInput = {
	apiVersion?: InputMaybe<Scalars['String']['input']>;
	description: Scalars['String']['input'];
	destinationUrl: Scalars['String']['input'];
	enabled?: InputMaybe<Scalars['Boolean']['input']>;
	eventTypes?: InputMaybe<Array<WebhookEventType>>;
	id?: InputMaybe<Scalars['ID']['input']>;
};

export type WebhookEndpointSecretResult = {
	__typename?: 'WebhookEndpointSecretResult';
	endpoint: WebhookEndpoint;
	signingSecret?: Maybe<Scalars['String']['output']>;
};

export enum WebhookEventType {
	InstallmentPaid = 'InstallmentPaid',
}

export type Billing_Details = {
	address?: InputMaybe<Scalars['String']['input']>;
	email?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
};

export type Us_Bank_Account = {
	account_holder_name?: InputMaybe<Scalars['String']['input']>;
	account_holder_type?: InputMaybe<Scalars['String']['input']>;
	nickname?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomerTypeContactFragment = {
	__typename?: 'Contact';
	customer: { __typename?: 'User'; userType: UserType };
};

export type GetCustomerNameContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	lastName: string;
	customer: { __typename?: 'User'; email: string };
};

export type IsAdminOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
	}> | null;
};

export type IsAdminOfVendorContactFragment = {
	__typename?: 'Contact';
	vendor: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type IsAdminOrManagerOfVendorContactFragment = {
	__typename?: 'Contact';
	vendor: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type IsAdminOrManagerOfCustomersPlannerOrgContactFragment = {
	__typename?: 'Contact';
	customer: {
		__typename?: 'User';
		clientUser?: {
			__typename?: 'ClientUser';
			assignedPlanner?: {
				__typename?: 'OrgUser';
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	};
};

export type IsAdminOrManagerOfCustomersPlannerOrgCustomerSignatureContactFragment =
	{
		__typename?: 'CustomerSignatureContact';
		customer: {
			__typename?: 'CustomerSignatureContactCustomer';
			clientUser?: {
				__typename?: 'CustomerSignatureContactCustomerClientUser';
				assignedPlanner?: {
					__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
					organization: {
						__typename?: 'CustomerSignatureContactOrganization';
						id: string;
					};
				} | null;
			} | null;
		};
	};

export type IsAssignedMemberContactFragment = {
	__typename?: 'Contact';
	assignedMember: { __typename?: 'OrgUser'; id: string };
};

export type IsAssignedPlannerContactFragment = {
	__typename?: 'Contact';
	customer: {
		__typename?: 'User';
		clientUser?: {
			__typename?: 'ClientUser';
			assignedPlanner?: { __typename?: 'OrgUser'; id: string } | null;
		} | null;
	};
};

export type IsAssignedPlannerCustomerSignatureContactFragment = {
	__typename?: 'CustomerSignatureContact';
	customer: {
		__typename?: 'CustomerSignatureContactCustomer';
		clientUser?: {
			__typename?: 'CustomerSignatureContactCustomerClientUser';
			assignedPlanner?: {
				__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
				id: string;
			} | null;
		} | null;
	};
};

export type IsCustomerContactFragment = {
	__typename?: 'Contact';
	customer: { __typename?: 'User'; id: string };
};

export type IsMemberOfVendorContactFragment = {
	__typename?: 'Contact';
	vendor: { __typename?: 'Organization'; id: string };
};

export type IsMemberOfVendorOrgUserFragment = {
	__typename?: 'OrgUser';
	organization?: { __typename?: 'Organization'; id: string } | null;
};

export type GetAppaOrgUserByBaseUserOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	role: TeamMemberRole;
	user?: { __typename?: 'User'; id: string } | null;
};

export type GetAppaOrgUserByBaseUserUsersForGetContractWhereFragment = {
	__typename?: 'UsersForGetContractWhere';
	id: string;
	role: TeamMemberRole;
	user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
};

export type GetAppaOrgUserByBaseUserCustomerSignatureContactOrganizationUsersFragment =
	{
		__typename?: 'CustomerSignatureContactOrganizationUsers';
		id: string;
		role: TeamMemberRole;
		user: { __typename?: 'CustomerSignatureOrgUserUser'; id: string };
	};

export type GetViewingUserDocumentRelationshipContactFragment = {
	__typename?: 'Contact';
	id: string;
	customer: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgCanSignContracts: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
						user?: { __typename?: 'User'; id: string } | null;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
								user?: { __typename?: 'User'; id: string } | null;
							}> | null;
						} | null;
					}> | null;
				} | null;
			} | null;
		} | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		user?: { __typename?: 'User'; id: string } | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	};
};

export type IsAdminOrganizationForGetContractWhereFragment = {
	__typename?: 'OrganizationForGetContractWhere';
	users?: Array<{
		__typename?: 'UsersForGetContractWhere';
		id: string;
		role: TeamMemberRole;
	}> | null;
};

export type IsAdminOfVendorContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type IsAdminOfVendorContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			contact: {
				__typename?: 'ContactForGetContractWhere';
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		} | null;
	}>;
};

export type IsAdminOrgUserFragment = { __typename?: 'OrgUser'; id: string };

export type IsAdminOfVendorOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAdminOfVendorContractOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAdminOrManagerOfVendorContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type IsAdminOrManagerOfVendorContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			contact: {
				__typename?: 'ContactForGetContractWhere';
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		} | null;
	}>;
};

export type IsAdminOrManagerOfVendorOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAdminOrManagerOfVendorContractOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAdminOrManagerOfCustomersPlannerOrgContactForGetContractWhereFragment =
	{
		__typename?: 'ContactForGetContractWhere';
		customer: {
			__typename?: 'CustomerForGetContractWhere';
			clientUser?: {
				__typename?: 'ClientUserForGetContractWhere';
				assignedPlanner?: {
					__typename?: 'OrgUserForGetContractWhere';
					organization?: {
						__typename?: 'OrganizationForGetContractWhere';
						id: string;
					} | null;
				} | null;
			} | null;
		};
	};

export type IsAdminOrManagerOfCustomersPlannerOrgContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			contact: {
				__typename?: 'ContactForGetContractWhere';
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
							} | null;
						} | null;
					} | null;
				};
			};
		} | null;
	}>;
};

export type IsAdminOrManagerOfCustomersPlannerOrgOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	organization?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type IsAdminOrManagerOfCustomersPlannerOrgContractOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	organization?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type IsAssignedMemberContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	assignedMember: { __typename?: 'OrgUserForGetContractWhere'; id: string };
};

export type IsAssignedMemberContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			contact: {
				__typename?: 'ContactForGetContractWhere';
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
				};
			};
		} | null;
	}>;
};

export type IsAssignedMemberOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAssignedMemberContractOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAssignedPlannerContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	customer: {
		__typename?: 'CustomerForGetContractWhere';
		clientUser?: {
			__typename?: 'ClientUserForGetContractWhere';
			assignedPlanner?: {
				__typename?: 'OrgUserForGetContractWhere';
				id: string;
			} | null;
		} | null;
	};
};

export type IsAssignedPlannerContractForGetContractWhereFragment = {
	__typename?: 'ContractForGetContractWhere';
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			contact: {
				__typename?: 'ContactForGetContractWhere';
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
						} | null;
					} | null;
				};
			};
		} | null;
	}>;
};

export type IsAssignedPlannerOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAssignedPlannerContractOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsSignerContractForGetContractWhereFragment = {
	__typename?: 'ContractForGetContractWhere';
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
	}>;
};

export type BasicCustomerSignatureForGetContractWhereFragment = {
	__typename?: 'CustomerSignatureForGetContractWhere';
	contact: {
		__typename?: 'ContactForGetContractWhere';
		customer: { __typename?: 'CustomerForGetContractWhere'; id: string };
	};
};

export type IsCustomerCustomerSignatureContactFragment = {
	__typename?: 'CustomerSignatureContact';
	customer: { __typename?: 'CustomerSignatureContactCustomer'; id: string };
};

export type BasicCustomerSignatureFragment = {
	__typename?: 'CustomerSignature';
	contact: {
		__typename?: 'CustomerSignatureContact';
		customer: { __typename?: 'CustomerSignatureContactCustomer'; id: string };
	};
};

export type SignatureWithContactPlannerFragment = {
	__typename?: 'SignatureForGetContractWhere';
	customerSignature?: {
		__typename?: 'CustomerSignatureForGetContractWhere';
		contact: {
			__typename?: 'ContactForGetContractWhere';
			customer: {
				__typename?: 'CustomerForGetContractWhere';
				clientUser?: {
					__typename?: 'ClientUserForGetContractWhere';
					plannerOrgCanSignContracts: boolean;
				} | null;
			};
		};
	} | null;
};

export type BasicSignatureFragment = {
	__typename?: 'SignatureForGetContractWhere';
	type?: SignatureType | null;
	signer?: {
		__typename?: 'SignatureUserForGetContractWhere';
		id: string;
	} | null;
};

export type CannotSignDueToOverdueContractForGetContractWhereFragment = {
	__typename?: 'ContractForGetContractWhere';
	dueDate?: Date | string | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		signingDate?: Date | string | null;
	}>;
};

export type GetSenderOrganizationFragment = {
	__typename?: 'Organization';
	name: string;
	brandedEmails?: boolean | null;
};

export type ConstructBundleEmailToCustomerContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructContractResentEmailToCustomerContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructContractSentEmailToCustomerContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructInvoiceResentEmailToCustomerContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructInvoiceSentEmailToCustomerContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructMessageCustomerEmailInquiryFragment = {
	__typename?: 'Inquiry';
	firstName: string;
	organization: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructMessageCustomerEmailContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructProposalResentEmailToCustomerContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type ConstructProposalSentEmailToCustomerContactFragment = {
	__typename?: 'Contact';
	firstName: string;
	vendor: {
		__typename?: 'Organization';
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type GetValidEmailRecipientsEmailNotificationGroupFragment = {
	__typename?: 'EmailNotificationGroup';
	members: Array<{
		__typename?: 'ReducedUser';
		email: string;
		blocked: boolean;
	}>;
};

export type SortPaymentInstallmentsPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	dueDate?: Date | string | null;
};

export type CalculateInstallmentTaxPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	amountDue?: number | null;
	dueDate?: Date | string | null;
};

export type CalculateInstallmentPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	name?: string | null;
	amountDue?: number | null;
	convenienceFee?: number | null;
	amountPaid?: number | null;
	gratuityPaid?: number | null;
	amountRefunded?: number | null;
	id: string;
	dueDate?: Date | string | null;
};

export type CalculateInstallmentPaymentInstallmentToStringFragment = {
	__typename?: 'PaymentInstallment';
	dueDate?: Date | string | null;
	paymentDate?: Date | string | null;
	refundDate?: Date | string | null;
	name?: string | null;
	amountDue?: number | null;
	convenienceFee?: number | null;
	amountPaid?: number | null;
	gratuityPaid?: number | null;
	amountRefunded?: number | null;
	id: string;
};

export type CalculateLineTotalLineItemFragment = {
	__typename?: 'LineItem';
	rate: number;
	quantity: number;
};

export type CalculateLineItemDiscountLineItemFragment = {
	__typename?: 'LineItem';
	rate: number;
	quantity: number;
};

export type CalculateLineItemTaxAmountLineItemFragment = {
	__typename?: 'LineItem';
	taxPercentage: number;
	rate: number;
	quantity: number;
};

export type CalculateInvoiceTaxTotalLineItemFragment = {
	__typename?: 'LineItem';
	taxPercentage: number;
	rate: number;
	quantity: number;
};

export type CalculateLineItemDiscountInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{ __typename?: 'LineItem'; rate: number; quantity: number }>;
};

export type CalculateLineItemTaxAmountInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateInvoiceTaxTotalInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateInvoiceSubtotalLineItemFragment = {
	__typename?: 'LineItem';
	rate: number;
	quantity: number;
};

export type CalculateInvoiceTotalInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateInstallmentTaxInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		amountDue?: number | null;
		dueDate?: Date | string | null;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateInstallmentInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		name?: string | null;
		amountDue?: number | null;
		convenienceFee?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		id: string;
		dueDate?: Date | string | null;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateInstallmentInvoiceToStringFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		dueDate?: Date | string | null;
		paymentDate?: Date | string | null;
		refundDate?: Date | string | null;
		name?: string | null;
		amountDue?: number | null;
		convenienceFee?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		id: string;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateInvoicePaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	name?: string | null;
	amountDue?: number | null;
	convenienceFee?: number | null;
	amountPaid?: number | null;
	gratuityPaid?: number | null;
	amountRefunded?: number | null;
	id: string;
	dueDate?: Date | string | null;
};

export type CalculateLineItemLineItemFragment = {
	__typename?: 'LineItem';
	name: string;
	rate: number;
	quantity: number;
	taxPercentage: number;
};

export type CalculateInvoiceLineItemFragment = {
	__typename?: 'LineItem';
	name: string;
	rate: number;
	quantity: number;
	taxPercentage: number;
};

export type InstallmentIsPaidInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	paymentDate?: Date | string | null;
	status?: InstallmentStatus | null;
};

export type CalculateTotalAmountPaidPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	amountPaid?: number | null;
	status?: InstallmentStatus | null;
	paymentDate?: Date | string | null;
};

export type CalculateTotalPaidOfDuePaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	amountDue?: number | null;
	status?: InstallmentStatus | null;
	paymentDate?: Date | string | null;
};

export type CalculateConvenienceChargeTotalPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	convenienceFee?: number | null;
	status?: InstallmentStatus | null;
	paymentDate?: Date | string | null;
};

export type CalculateGratuityPaidPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	gratuityPaid?: number | null;
	status?: InstallmentStatus | null;
	paymentDate?: Date | string | null;
};

export type CalculateUnpaidBalancePaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	amountDue?: number | null;
	status?: InstallmentStatus | null;
	paymentDate?: Date | string | null;
};

export type CalculateTotalRefundedPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	amountRefunded?: number | null;
};

export type CalculateTotalTaxPaidInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		paymentDate?: Date | string | null;
		status?: InstallmentStatus | null;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculatePaymentTotalsInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		amountPaid?: number | null;
		status?: InstallmentStatus | null;
		amountDue?: number | null;
		convenienceFee?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		paymentDate?: Date | string | null;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateLineItemInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
};

export type CalculateInvoiceInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	discountPercentage?: number | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		amountPaid?: number | null;
		status?: InstallmentStatus | null;
		amountDue?: number | null;
		convenienceFee?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		paymentDate?: Date | string | null;
		name?: string | null;
		id: string;
		dueDate?: Date | string | null;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
};

export type CalculateInvoiceDiscountToStringInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
};

export type CalculateConvenienceFeeOrganizationFragment = {
	__typename?: 'Organization';
	cardConvenienceFeePercentage: number;
	achConvenienceFeePercentage: number;
};

export type CalculateInvoicePaymentInvoiceFragment = {
	__typename?: 'Invoice';
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		amountDue?: number | null;
	}>;
	organization?: {
		__typename?: 'Organization';
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
	} | null;
};

export type CalculateInvoiceSubtotalToStringLineItemFragment = {
	__typename?: 'LineItem';
	rate: number;
	quantity: number;
};

export type CalculateInvoiceTaxTotalToStringInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateInvoiceTotalToStringInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateLineItemToStringInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type CalculateLineItemToStringLineItemFragment = {
	__typename?: 'LineItem';
	name: string;
	rate: number;
	quantity: number;
	taxPercentage: number;
};

export type CalculateMultipleInstallmentsAmountDueRegardlessOfStatusToStringFragment =
	{ __typename?: 'PaymentInstallment'; amountDue?: number | null };

export type CalculatePaymentTotalsCalculatePaymentTotalsToStringInvoiceFragment =
	{
		__typename?: 'Invoice';
		discountAmount?: number | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			amountPaid?: number | null;
			status?: InstallmentStatus | null;
			amountDue?: number | null;
			convenienceFee?: number | null;
			gratuityPaid?: number | null;
			amountRefunded?: number | null;
			paymentDate?: Date | string | null;
		}>;
		lineItems: Array<{
			__typename?: 'LineItem';
			taxPercentage: number;
			rate: number;
			quantity: number;
		}>;
	};

export type CalculateTotalAmountPaidLessCcPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	amountPaid?: number | null;
	status?: InstallmentStatus | null;
	convenienceFee?: number | null;
	paymentDate?: Date | string | null;
};

export type GetInvoiceDueDateInvoiceFragment = {
	__typename?: 'Invoice';
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
	}>;
};

export type GetUserFriendlyStatusInvoiceFragment = {
	__typename?: 'Invoice';
	status: InvoiceStatus;
	isPastDue: boolean;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		status?: InstallmentStatus | null;
	}>;
};

export type PaymentInstallmentAmountDueWithinRangePaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	amountDue?: number | null;
};

export type IsAdminOfVendorInvoiceFragment = {
	__typename?: 'Invoice';
	organization?: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type IsAdminOfVendorInvoiceOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsAdminOrManagerOfVendorInvoiceFragment = {
	__typename?: 'Invoice';
	organization?: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type IsAdminOrManagerOfVendorInvoiceOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsMemberOfVendorInvoiceFragment = {
	__typename?: 'Invoice';
	organization?: { __typename?: 'Organization'; id: string } | null;
};

export type IsMemberOfVendorInvoiceOrgUserFragment = {
	__typename?: 'OrgUser';
	organization?: { __typename?: 'Organization'; id: string } | null;
};

export type OwnerIsBlockedOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{
		__typename?: 'OrgUser';
		role: TeamMemberRole;
		user?: { __typename?: 'User'; blocked: boolean } | null;
	}> | null;
};

export type GetAdminOrgUsersOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{ __typename?: 'OrgUser'; role: TeamMemberRole }> | null;
};

export type IsAdminOrManagerOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
	}> | null;
};

export type IsAdminOrManagerOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
};

export type IsDisabledOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
	}> | null;
};

export type IsDisabledOrgUserFragment = { __typename?: 'OrgUser'; id: string };

export type IsOwnerOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
	}> | null;
};

export type IsOwnerOrgUserFragment = { __typename?: 'OrgUser'; id: string };

export type GetOwnerOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{ __typename?: 'OrgUser'; role: TeamMemberRole }> | null;
};

export type GetViewingUserDocumentRelationshipOrganizationFragment = {
	__typename?: 'Organization';
	users?: Array<{
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		user?: { __typename?: 'User'; id: string } | null;
	}> | null;
};

export type CanAccessPremiumOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	createdAt: Date | string;
	subscription?: {
		__typename?: 'AppSubscription';
		id: string;
		status?: SubscriptionStatus | null;
		subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
	} | null;
	groups: Array<{ __typename?: 'TestingGroup'; name: string }>;
};

export type CouponIsForeverFreeStripeCouponFragment = {
	__typename?: 'StripeCoupon';
	amount_off?: number | null;
	percent_off?: number | null;
	duration_in_months?: number | null;
	duration?: string | null;
};

export type CouponIsForeverFreePlanFragment = {
	__typename?: 'Plan';
	price: number;
};

export type CouponIsForeverFreeStripePlanFragment = {
	__typename?: 'StripePlan';
	amount?: number | null;
};

export type GetSubscriptionStatusSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	id: string;
	status?: StripeSubscriptionStatus | null;
	cancel_at_period_end?: boolean | null;
	items?: {
		__typename?: 'SubscriptionItems';
		data?: Array<{
			__typename?: 'SubscriptionPlan';
			current_period_start?: number | null;
			current_period_end?: number | null;
		} | null> | null;
	} | null;
};

export type GetSubscriptionStatusStripeInvoiceFragment = {
	__typename?: 'StripeInvoice';
	id?: string | null;
	period_start?: number | null;
	period_end?: number | null;
	next_payment_attempt?: number | null;
	amount_due: number;
};

export type SubscriptionHasActiveForeverFreeCouponSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	discounts?: Array<{
		__typename?: 'Discount';
		coupon?: {
			__typename?: 'StripeCoupon';
			duration?: string | null;
			duration_in_months?: number | null;
			percent_off?: number | null;
			amount_off?: number | null;
		} | null;
	} | null> | null;
};

export type SubscriptionHasActiveForeverFreeCouponStripeCouponFragment = {
	__typename?: 'StripeCoupon';
	amount_off?: number | null;
	percent_off?: number | null;
	duration_in_months?: number | null;
	duration?: string | null;
};

export type SubscriptionHasActiveForeverFreeCouponPlanFragment = {
	__typename?: 'Plan';
	price: number;
};

export type SubscriptionHasActiveForeverFreeCouponStripePlanFragment = {
	__typename?: 'StripePlan';
	amount?: number | null;
};

export type IsAdminOfOwnOrganizationFragment = {
	__typename?: 'User';
	orgUser?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type OrgMemberSignUpPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type OrgMemberSignUpPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		phone?: string | null;
		firstName: string;
		lastName: string;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			acceptedTerms?: Date | string | null;
		} | null;
	} | null;
};

export type SignUpPage_GetInvitationWhereQueryVariables = Exact<{
	where: InvitationWhereCustomInput;
}>;

export type SignUpPage_GetInvitationWhereQuery = {
	__typename?: 'Query';
	getInvitationWhere?: {
		__typename?: 'Invitation';
		createdAt: Date | string;
		id: string;
		recipientFirstName: string;
		recipientLastName?: string | null;
		emailAddress: string;
		invitationType: InviteEnum;
	} | null;
};

export type SignUpPage_GetVerificationTokenQueryVariables = Exact<{
	where: VerificationTokenWhereUniqueInput;
}>;

export type SignUpPage_GetVerificationTokenQuery = {
	__typename?: 'Query';
	getVerificationToken: {
		__typename?: 'VerificationToken';
		email: string;
		id: string;
	};
};

export type SignUpPage_IsEmailAvailableQueryVariables = Exact<{
	email: Scalars['String']['input'];
}>;

export type SignUpPage_IsEmailAvailableQuery = {
	__typename?: 'Query';
	isEmailAvailable: boolean;
};

export type SignUpPage_GetOrganizationFromInvitationQueryVariables = Exact<{
	where: InvitationWhereCustomInput;
}>;

export type SignUpPage_GetOrganizationFromInvitationQuery = {
	__typename?: 'Query';
	getOrganizationFromInvitation?: {
		__typename?: 'Organization';
		id: string;
		name: string;
	} | null;
};

export type AdminPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type AdminPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		user?: { __typename?: 'User'; id: string; blocked: boolean } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type ClientDetailPage_GetContactWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type ClientDetailPage_GetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type ContractViewPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ContractViewPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			helloSignID?: string | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
		} | null;
	} | null;
};

export type ContractViewPage_ContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		id: string;
		countOfCustomerSigners: number;
	} | null;
};

export type ContractViewPage_GetContractWhereQueryVariables = Exact<{
	where: ContractWhereInputWithMfaToken;
}>;

export type ContractViewPage_GetContractWhereQuery = {
	__typename?: 'Query';
	getContractWhere: {
		__typename?: 'ResponseObjectForGetContractWhere';
		requestingUserBaseId?: string | null;
		contract: {
			__typename?: 'ContractForGetContractWhere';
			id: string;
			title?: string | null;
			status: ContractStatus;
			signatures: Array<{
				__typename?: 'SignatureForGetContractWhere';
				id: string;
				customerSignature?: {
					__typename?: 'CustomerSignatureForGetContractWhere';
					id: string;
					contact: {
						__typename?: 'ContactForGetContractWhere';
						id: string;
						customer: {
							__typename?: 'CustomerForGetContractWhere';
							id: string;
						};
					};
				} | null;
			}>;
			vendor: {
				__typename?: 'OrganizationForGetContractWhere';
				id: string;
				helloSignID?: string | null;
			};
			contractTemplate?: {
				__typename?: 'ContractTemplateForGetContractWhere';
				id: string;
				countOfCustomerSigners: number;
			} | null;
		};
	};
};

export type ContractTemplateEditPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ContractTemplateEditPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		organization?: {
			__typename?: 'Organization';
			id: string;
			helloSignID?: string | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type ContractTemplateEditPage_GetOrganizationContractTemplateQueryVariables =
	Exact<{
		where: ContractTemplateWhereUniqueInput;
	}>;

export type ContractTemplateEditPage_GetOrganizationContractTemplateQuery = {
	__typename?: 'Query';
	getOrganizationContractTemplate?: {
		__typename?: 'ContractTemplate';
		id: string;
		title?: string | null;
	} | null;
};

export type DocumentDetailPage_GetDocumentWhereQueryVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type DocumentDetailPage_GetDocumentWhereQuery = {
	__typename?: 'Query';
	getDocumentWhere: {
		__typename?: 'Document';
		id: string;
		type: DocumentType;
		name: string;
		customer?: {
			__typename?: 'User';
			id: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				customer: { __typename?: 'User'; id: string; email: string };
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		} | null;
		parentFolder?: {
			__typename?: 'Folder';
			id: string;
			folderType: FolderType;
		} | null;
		organization?: { __typename?: 'Organization'; id: string } | null;
	};
};

export type DocumentDetailPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type DocumentDetailPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		user?: { __typename?: 'User'; id: string } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type DocumentDetailPage_ViewDocumentMutationVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type DocumentDetailPage_ViewDocumentMutation = {
	__typename?: 'Mutation';
	viewDocument: { __typename?: 'Document'; id: string };
};

export type DocumentDetailPage_GetFolderContentsQueryVariables = Exact<{
	where: FolderWhereUniqueInput;
}>;

export type DocumentDetailPage_GetFolderContentsQuery = {
	__typename?: 'Query';
	getFolderContents?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
		parentFolder?: { __typename?: 'CustomFolder'; id: string } | null;
	} | null;
};

export type InvoiceViewPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type InvoiceViewPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type InvoiceViewPage_InvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	organization?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type InvoiceViewPage_GetInvoiceWhereQueryVariables = Exact<{
	where: InvoiceWhereUniqueInput;
	data?: InputMaybe<InvoiceTokenInput>;
}>;

export type InvoiceViewPage_GetInvoiceWhereQuery = {
	__typename?: 'Query';
	getInvoiceWhere?: {
		__typename?: 'ResponseObjectForGetInvoiceWhere';
		requestingUserBaseId: string;
		requestingUserIsGuest: boolean;
		invoice: {
			__typename?: 'Invoice';
			id: string;
			title: string;
			status: InvoiceStatus;
			contact?: {
				__typename?: 'Contact';
				id: string;
				customer: { __typename?: 'User'; id: string };
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		};
	} | null;
};

export type InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryVariables =
	Exact<{
		where: InvoiceTemplateWhereUniqueInput;
	}>;

export type InvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery = {
	__typename?: 'Query';
	getInvoiceTemplateWhere?: {
		__typename?: 'InvoiceTemplate';
		id: string;
		title: string;
		organization: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
	} | null;
};

export type InvoiceTemplateEditPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type InvoiceTemplateEditPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		organization?: {
			__typename?: 'Organization';
			id: string;
			invoicesAllowGratuity: boolean;
			automatedRemindersEnabled: boolean;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type LeadDetailPage_GetInquiryWhereQueryVariables = Exact<{
	where: InquiryDetailWhereInput;
}>;

export type LeadDetailPage_GetInquiryWhereQuery = {
	__typename?: 'Query';
	getInquiryWhere: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		organization: { __typename?: 'Organization'; id: string };
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string };
			assignedMember: { __typename?: 'OrgUser'; id: string };
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
		} | null;
	};
};

export type InquiriesPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type InquiriesPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
		} | null;
	} | null;
};

export type LeadFormViewPage_GetLeadFormApiKeyQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type LeadFormViewPage_GetLeadFormApiKeyQuery = {
	__typename?: 'Query';
	getLeadFormApiKey?: {
		__typename?: 'LeadFormPresentationalData';
		apiKey: string;
		organization: {
			__typename?: 'LeadFormPresentationalDataOrganization';
			id: string;
			image?: string | null;
			name: string;
			phone?: string | null;
			contactEmail?: string | null;
			updatedAt: Date | string;
		};
	} | null;
};

export type MemberDetailPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type MemberDetailPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{ __typename?: 'OrgUser'; id: string }> | null;
		} | null;
	} | null;
};

export type OrganizationViewPage_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type OrganizationViewPage_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		name: string;
	} | null;
};

export type DashboardPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type DashboardPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
		} | null;
	} | null;
};

export type ProposalViewPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ProposalViewPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
		} | null;
	} | null;
};

export type ProposalViewPage_GetProposalWhereQueryVariables = Exact<{
	where: ProposalWhereInput;
}>;

export type ProposalViewPage_GetProposalWhereQuery = {
	__typename?: 'Query';
	getProposalWhere: {
		__typename?: 'ResponseObjectForGetProposalWhere';
		requestingUserBaseId: string;
		requestingUserIsGuest: boolean;
		proposal: {
			__typename?: 'Proposal';
			id: string;
			title?: string | null;
			status: ProposalStatus;
			contact: {
				__typename?: 'Contact';
				id: string;
				customer: {
					__typename?: 'User';
					id: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: { __typename?: 'Organization'; id: string } | null;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				};
				vendor: {
					__typename?: 'Organization';
					id: string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		};
	};
};

export type ProposalTemplateEditPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ProposalTemplateEditPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		user?: {
			__typename?: 'User';
			id: string;
			canvaToken?: {
				__typename?: 'CanvaOAuthToken';
				accessToken: string;
				expires: Date | string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type ProposalTemplateEditPage_GetProposalTemplateWhereQueryVariables =
	Exact<{
		where: ProposalTemplateWhereUniqueInput;
	}>;

export type ProposalTemplateEditPage_GetProposalTemplateWhereQuery = {
	__typename?: 'Query';
	getProposalTemplateWhere: {
		__typename?: 'ProposalTemplate';
		id: string;
		title?: string | null;
	};
};

export type QuickPaymentPage_GetQuickPaymentQueryVariables = Exact<{
	where: QuickPaymentUniqueInput;
}>;

export type QuickPaymentPage_GetQuickPaymentQuery = {
	__typename?: 'Query';
	getQuickPayment: {
		__typename?: 'QuickPaymentForGetQuickPayment';
		id: string;
		organization: {
			__typename?: 'OrganizationForGetQuickPayment';
			name?: string | null;
			id: string;
			image?: string | null;
			updatedAt: Date | string;
		};
	};
};

export type ResourceViewPage_GetResourceWhereQueryVariables = Exact<{
	where: ResourceWhereUniqueInput;
}>;

export type ResourceViewPage_GetResourceWhereQuery = {
	__typename?: 'Query';
	getResourceWhere: {
		__typename?: 'CustomResource';
		id: string;
		description: string;
	};
};

export type TimelineGeniusPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type TimelineGeniusPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: { __typename?: 'Organization'; id: string } | null;
	} | null;
};

export type TimelineGeniusPage_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type TimelineGeniusPage_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		TGIntegrationURL?: string | null;
	};
};

export type VersionPage_GetApiVersionQueryVariables = Exact<{
	[key: string]: never;
}>;

export type VersionPage_GetApiVersionQuery = {
	__typename?: 'Query';
	getApiVersion: {
		__typename?: 'ApiVersionResponse';
		version?: string | null;
		env?: string | null;
		commitId?: string | null;
		branch?: string | null;
	};
};

export type WalletPage_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type WalletPage_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type ActivateSubscriptionModal_GetCouponDetailsQueryVariables = Exact<{
	where: CouponByNameInput;
}>;

export type ActivateSubscriptionModal_GetCouponDetailsQuery = {
	__typename?: 'Query';
	getCouponDetails: {
		__typename?: 'ReducedCoupon';
		id: string;
		percent_off?: number | null;
		duration_in_months?: number | null;
	};
};

export type ActivateSubscriptionModal_OrganizationFragmentFragment = {
	__typename?: 'Organization';
	id: string;
	coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
};

export type ActivityTabContactFragment = {
	__typename?: 'Contact';
	id: string;
	customer: { __typename?: 'User'; id: string };
	vendor: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
	assignedMember: { __typename?: 'OrgUser'; id: string };
};

export type ActivityTabEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	createdAt: Date | string;
	message?: string | null;
	metadata?: any | null;
	resolvedAt?: Date | string | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
			user?: { __typename?: 'ActingUserForEvent'; id: string } | null;
			organization?: {
				__typename?: 'OrganizationForActingUser';
				id?: string | null;
				name?: string | null;
				services?: {
					__typename?: 'ServicesForActingUser';
					id?: string | null;
					name?: string | null;
				} | null;
			} | null;
		} | null;
	} | null;
	clientUser?: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		firstNameTwo?: string | null;
		lastNameTwo?: string | null;
		plannerOrgCanPayInvoices: boolean;
		plannerOrgCanSignContracts: boolean;
		plannerOrgHasConnectionPermissions: boolean;
		plannerOrgHasDocumentsPermissions: boolean;
		user: { __typename?: 'User'; id: string; email: string };
		assignedPlanner?: {
			__typename?: 'OrgUser';
			id: string;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
	} | null;
	guestUser?: {
		__typename?: 'GuestUser';
		id: string;
		user: { __typename?: 'User'; id: string; email: string };
	} | null;
	vendor?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
	orgUser?: {
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		firstName: string;
		lastName: string;
		user?: { __typename?: 'User'; id: string; email: string } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			orgType?: OrgType | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
	plannerUser?: {
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		firstName: string;
		lastName: string;
		user?: { __typename?: 'User'; id: string } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			orgType?: OrgType | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
	contacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		vendor: { __typename?: 'Organization'; id: string; name: string };
	}> | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		vendor: { __typename?: 'Organization'; id: string; name: string };
	} | null;
	invitation?: {
		__typename?: 'Invitation';
		id: string;
		emailAddress: string;
		recipientFirstName: string;
		recipientLastName?: string | null;
	} | null;
	contract?: {
		__typename?: 'CustomContract';
		id: string;
		title?: string | null;
		eventDate?: Date | string | null;
		automatedRemindersEnabled: boolean;
		sentByUser?: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		} | null;
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
		signatures: Array<{
			__typename?: 'Signature';
			id: string;
			type?: SignatureType | null;
			signer?: {
				__typename?: 'SignatureUser';
				id: string;
				orgUser?: {
					__typename?: 'SignatureCounterSigner';
					id: string;
					firstName: string;
					lastName: string;
					user: { __typename?: 'SignatureCounterSignerUser'; id: string };
				} | null;
			} | null;
			customerSignature?: {
				__typename?: 'CustomerSignature';
				id: string;
				contact: {
					__typename?: 'CustomerSignatureContact';
					id: string;
					vendor: {
						__typename?: 'CustomerSignatureContactOrganization';
						id: string;
						name: string;
						users?: Array<{
							__typename?: 'CustomerSignatureContactOrganizationUsers';
							id: string;
							role: TeamMemberRole;
						}> | null;
					};
					customer: {
						__typename?: 'CustomerSignatureContactCustomer';
						id: string;
						email: string;
						userType: UserType;
						clientUser?: {
							__typename?: 'CustomerSignatureContactCustomerClientUser';
							id: string;
							plannerOrgCanSignContracts: boolean;
							assignedPlanner?: {
								__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
								id: string;
								organization: {
									__typename?: 'CustomerSignatureContactOrganization';
									id: string;
									users?: Array<{
										__typename?: 'CustomerSignatureContactOrganizationUsers';
										id: string;
										role: TeamMemberRole;
									}> | null;
								};
							} | null;
						} | null;
					};
					assignedMember: {
						__typename?: 'CustomerSignatureOrgUser';
						id: string;
						user: { __typename?: 'CustomerSignatureOrgUserUser'; id: string };
					};
				};
			} | null;
		}>;
	} | null;
	invoice?: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		status: InvoiceStatus;
		gratuityAmount: number;
		automatedRemindersEnabled: boolean;
		eventDate?: Date | string | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			name?: string | null;
		}>;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						firstName: string;
						lastName: string;
						user?: { __typename?: 'User'; id: string } | null;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
								user?: { __typename?: 'User'; id: string } | null;
								organization?: {
									__typename?: 'Organization';
									id: string;
									users?: Array<{
										__typename?: 'OrgUser';
										id: string;
										role: TeamMemberRole;
										user?: { __typename?: 'User'; id: string } | null;
									}> | null;
								} | null;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			};
		} | null;
		organization?: { __typename?: 'Organization'; id: string } | null;
	} | null;
	document?: {
		__typename?: 'Document';
		id: string;
		name: string;
		fileSource: FileSourceType;
		fileType: FileType;
		customer?: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				firstNameOne: string;
				lastNameOne?: string | null;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						services: Array<{
							__typename?: 'Service';
							id: string;
							name: string;
						}>;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
	paymentInstallments?: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
	}> | null;
	proposal?: {
		__typename?: 'Proposal';
		id: string;
		title?: string | null;
		eventDate?: Date | string | null;
		automatedRemindersEnabled: boolean;
		proposalTemplate?: { __typename?: 'ProposalTemplate'; id: string } | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
			};
			vendor: { __typename?: 'Organization'; id: string; name: string };
		};
	} | null;
	inquiry?: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		organization: {
			__typename?: 'Organization';
			id: string;
			name: string;
			createdAt: Date | string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
	} | null;
};

export type ActivityTab_GetEventsWhereQueryVariables = Exact<{
	where: EventWhereInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<EventOrderByInput>> | InputMaybe<EventOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ActivityTab_GetEventsWhereQuery = {
	__typename?: 'Query';
	getEventsWhere?: Array<{
		__typename?: 'Event';
		id: string;
		category: EventCategory;
		createdAt: Date | string;
		message?: string | null;
		metadata?: any | null;
		resolvedAt?: Date | string | null;
		actingUser?: {
			__typename?: 'ActingUserForEvent';
			id: string;
			orgUser?: {
				__typename?: 'OrgUserForActingUserOnEvent';
				id: string;
				firstName: string;
				lastName: string;
				user?: { __typename?: 'ActingUserForEvent'; id: string } | null;
				organization?: {
					__typename?: 'OrganizationForActingUser';
					id?: string | null;
					name?: string | null;
					services?: {
						__typename?: 'ServicesForActingUser';
						id?: string | null;
						name?: string | null;
					} | null;
				} | null;
			} | null;
		} | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			user: { __typename?: 'User'; id: string; email: string };
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					orgType?: OrgType | null;
					services: Array<{ __typename?: 'Service'; id: string; name: string }>;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				} | null;
			} | null;
		} | null;
		guestUser?: {
			__typename?: 'GuestUser';
			id: string;
			user: { __typename?: 'User'; id: string; email: string };
		} | null;
		vendor?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			user?: { __typename?: 'User'; id: string; email: string } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
		plannerUser?: {
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			user?: { __typename?: 'User'; id: string } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
		contacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			companyName?: string | null;
			customer: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: { __typename?: 'Organization'; id: string; name: string };
		}> | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			companyName?: string | null;
			customer: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: { __typename?: 'Organization'; id: string; name: string };
		} | null;
		invitation?: {
			__typename?: 'Invitation';
			id: string;
			emailAddress: string;
			recipientFirstName: string;
			recipientLastName?: string | null;
		} | null;
		contract?: {
			__typename?: 'CustomContract';
			id: string;
			title?: string | null;
			eventDate?: Date | string | null;
			automatedRemindersEnabled: boolean;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
			signatures: Array<{
				__typename?: 'Signature';
				id: string;
				type?: SignatureType | null;
				signer?: {
					__typename?: 'SignatureUser';
					id: string;
					orgUser?: {
						__typename?: 'SignatureCounterSigner';
						id: string;
						firstName: string;
						lastName: string;
						user: { __typename?: 'SignatureCounterSignerUser'; id: string };
					} | null;
				} | null;
				customerSignature?: {
					__typename?: 'CustomerSignature';
					id: string;
					contact: {
						__typename?: 'CustomerSignatureContact';
						id: string;
						vendor: {
							__typename?: 'CustomerSignatureContactOrganization';
							id: string;
							name: string;
							users?: Array<{
								__typename?: 'CustomerSignatureContactOrganizationUsers';
								id: string;
								role: TeamMemberRole;
							}> | null;
						};
						customer: {
							__typename?: 'CustomerSignatureContactCustomer';
							id: string;
							email: string;
							userType: UserType;
							clientUser?: {
								__typename?: 'CustomerSignatureContactCustomerClientUser';
								id: string;
								plannerOrgCanSignContracts: boolean;
								assignedPlanner?: {
									__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
									id: string;
									organization: {
										__typename?: 'CustomerSignatureContactOrganization';
										id: string;
										users?: Array<{
											__typename?: 'CustomerSignatureContactOrganizationUsers';
											id: string;
											role: TeamMemberRole;
										}> | null;
									};
								} | null;
							} | null;
						};
						assignedMember: {
							__typename?: 'CustomerSignatureOrgUser';
							id: string;
							user: { __typename?: 'CustomerSignatureOrgUserUser'; id: string };
						};
					};
				} | null;
			}>;
		} | null;
		invoice?: {
			__typename?: 'Invoice';
			id: string;
			title: string;
			status: InvoiceStatus;
			gratuityAmount: number;
			automatedRemindersEnabled: boolean;
			eventDate?: Date | string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				name?: string | null;
			}>;
			contact?: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							firstName: string;
							lastName: string;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
									organization?: {
										__typename?: 'Organization';
										id: string;
										users?: Array<{
											__typename?: 'OrgUser';
											id: string;
											role: TeamMemberRole;
											user?: { __typename?: 'User'; id: string } | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				vendor: {
					__typename?: 'Organization';
					id: string;
					name: string;
					orgType?: OrgType | null;
					services: Array<{ __typename?: 'Service'; id: string; name: string }>;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
						user?: { __typename?: 'User'; id: string } | null;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
				};
			} | null;
			organization?: { __typename?: 'Organization'; id: string } | null;
		} | null;
		document?: {
			__typename?: 'Document';
			id: string;
			name: string;
			fileSource: FileSourceType;
			fileType: FileType;
			customer?: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					firstNameOne: string;
					lastNameOne?: string | null;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							services: Array<{
								__typename?: 'Service';
								id: string;
								name: string;
							}>;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
							}> | null;
						} | null;
					} | null;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
				} | null;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
		paymentInstallments?: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			name?: string | null;
		}> | null;
		proposal?: {
			__typename?: 'Proposal';
			id: string;
			title?: string | null;
			eventDate?: Date | string | null;
			automatedRemindersEnabled: boolean;
			proposalTemplate?: { __typename?: 'ProposalTemplate'; id: string } | null;
			contact: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: { __typename?: 'Organization'; id: string } | null;
						} | null;
					} | null;
				};
				vendor: { __typename?: 'Organization'; id: string; name: string };
			};
		} | null;
		inquiry?: {
			__typename?: 'Inquiry';
			id: string;
			firstName: string;
			lastName: string;
			organization: {
				__typename?: 'Organization';
				id: string;
				name: string;
				createdAt: Date | string;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
				} | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
		} | null;
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			groupTitle: EmailNotificationGroupTitle;
		} | null;
	}> | null;
};

export type MembersTableOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	role: TeamMemberRole;
	firstName: string;
	lastName: string;
	updatedAt: Date | string;
	contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
	user?: {
		__typename?: 'User';
		id: string;
		blocked: boolean;
		email: string;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type MembersTable_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<OrgUserOrderByInput>> | InputMaybe<OrgUserOrderByInput>
	>;
}>;

export type MembersTable_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
			user?: {
				__typename?: 'User';
				id: string;
				blocked: boolean;
				email: string;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		}> | null;
	} | null;
};

export type MembersTable_DisableOrgMemberMutationVariables = Exact<{
	where: OrgUserWhereUniqueInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<OrgUserOrderByInput>> | InputMaybe<OrgUserOrderByInput>
	>;
}>;

export type MembersTable_DisableOrgMemberMutation = {
	__typename?: 'Mutation';
	disableOrgMember: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
			user?: {
				__typename?: 'User';
				id: string;
				blocked: boolean;
				email: string;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		}> | null;
	};
};

export type MembersTable_ReactivateOrgMemberMutationVariables = Exact<{
	where: OrgUserWhereUniqueInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<OrgUserOrderByInput>> | InputMaybe<OrgUserOrderByInput>
	>;
}>;

export type MembersTable_ReactivateOrgMemberMutation = {
	__typename?: 'Mutation';
	reactivateOrgMember: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
			user?: {
				__typename?: 'User';
				id: string;
				blocked: boolean;
				email: string;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		}> | null;
	};
};

export type NotificationGroupEventFeedEventEventFragment = {
	__typename?: 'Event';
	id: string;
	createdAt: Date | string;
	category: EventCategory;
	clientUser?: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		};
	} | null;
	orgUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		organization?: { __typename?: 'Organization'; id: string } | null;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		} | null;
	} | null;
	guestUser?: {
		__typename?: 'GuestUser';
		id: string;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		};
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
	} | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
};

export type NotificationGroupEventFeedEventFragment = {
	__typename?: 'Event';
	id: string;
	createdAt: Date | string;
	category: EventCategory;
	clientUser?: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		};
	} | null;
	orgUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		organization?: { __typename?: 'Organization'; id: string } | null;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		} | null;
	} | null;
	guestUser?: {
		__typename?: 'GuestUser';
		id: string;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		};
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
	} | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
};

export type OrganizationNotificationPreferencesOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	firstName: string;
	lastName: string;
	role: TeamMemberRole;
	user?: { __typename?: 'User'; id: string; email: string } | null;
	organization?: { __typename?: 'Organization'; id: string } | null;
};

export type OrganizationNotificationPreferences_GetOrganizationWhereQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type OrganizationNotificationPreferences_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string; email: string } | null;
			organization?: { __typename?: 'Organization'; id: string } | null;
		}> | null;
	} | null;
};

export type OrganizationNotificationPreferencesReducedUserFragment = {
	__typename?: 'ReducedUser';
	id?: string | null;
	email: string;
	userType: UserType;
	orgUser?: {
		__typename?: 'ReducedOrgUser';
		id: string;
		firstName: string;
		lastName: string;
		role: TeamMemberRole;
		organization?: {
			__typename?: 'ReducedOrganization';
			id?: string | null;
		} | null;
	} | null;
};

export type OrganizationNotificationPreferencesEmailNotificationGroupFragment =
	{
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	};

export type OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryVariables =
	Exact<{ [key: string]: never }>;

export type OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery =
	{
		__typename?: 'Query';
		getNotificationGroupsForOrganization?: Array<{
			__typename?: 'EmailNotificationGroup';
			id: string;
			groupTitle: EmailNotificationGroupTitle;
			members: Array<{
				__typename?: 'ReducedUser';
				id?: string | null;
				email: string;
				userType: UserType;
				orgUser?: {
					__typename?: 'ReducedOrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					organization?: {
						__typename?: 'ReducedOrganization';
						id?: string | null;
					} | null;
				} | null;
			}>;
		}> | null;
	};

export type OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationVariables =
	Exact<{
		data: EmailNotificationGroupsInput;
	}>;

export type OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation =
	{
		__typename?: 'Mutation';
		updateOrganizationNotificationGroups: Array<{
			__typename?: 'EmailNotificationGroup';
			id: string;
			groupTitle: EmailNotificationGroupTitle;
			members: Array<{
				__typename?: 'ReducedUser';
				id?: string | null;
				email: string;
				userType: UserType;
				orgUser?: {
					__typename?: 'ReducedOrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					organization?: {
						__typename?: 'ReducedOrganization';
						id?: string | null;
					} | null;
				} | null;
			}>;
		}>;
	};

export type EmailNotificationGroupEventsEventFragment = {
	__typename?: 'Event';
	id: string;
	createdAt: Date | string;
	category: EventCategory;
	clientUser?: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		};
	} | null;
	orgUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		organization?: { __typename?: 'Organization'; id: string } | null;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		} | null;
	} | null;
	guestUser?: {
		__typename?: 'GuestUser';
		id: string;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				vendor: { __typename?: 'Organization'; id: string };
			} | null> | null;
		};
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
	} | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
};

export type EmailNotificationGroupEvents_GetEventsWhereQueryVariables = Exact<{
	where: EventWhereInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<EventOrderByInput>> | InputMaybe<EventOrderByInput>
	>;
	skip: Scalars['Int']['input'];
	take: Scalars['Int']['input'];
}>;

export type EmailNotificationGroupEvents_GetEventsWhereQuery = {
	__typename?: 'Query';
	getEventsWhere?: Array<{
		__typename?: 'Event';
		id: string;
		createdAt: Date | string;
		category: EventCategory;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			user: {
				__typename?: 'User';
				id: string;
				email: string;
				contacts?: Array<{
					__typename?: 'Contact';
					vendor: { __typename?: 'Organization'; id: string };
				} | null> | null;
			};
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			organization?: { __typename?: 'Organization'; id: string } | null;
			user?: {
				__typename?: 'User';
				id: string;
				email: string;
				contacts?: Array<{
					__typename?: 'Contact';
					id: string;
					vendor: { __typename?: 'Organization'; id: string };
				} | null> | null;
			} | null;
		} | null;
		guestUser?: {
			__typename?: 'GuestUser';
			id: string;
			user: {
				__typename?: 'User';
				id: string;
				email: string;
				contacts?: Array<{
					__typename?: 'Contact';
					id: string;
					vendor: { __typename?: 'Organization'; id: string };
				} | null> | null;
			};
		} | null;
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			groupTitle: EmailNotificationGroupTitle;
		} | null;
		actingUser?: {
			__typename?: 'ActingUserForEvent';
			id: string;
			orgUser?: {
				__typename?: 'OrgUserForActingUserOnEvent';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
	}> | null;
};

export type AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		data: OrganizationCustomUpdateInput;
	}>;

export type AutomatedNotificationsPreferencesForm_UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization?: {
		__typename?: 'Organization';
		id: string;
		automatedRemindersEnabled: boolean;
	} | null;
};

export type BrandedEmailPreferencesForm_UpdateOrganizationMutationVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		data: OrganizationCustomUpdateInput;
	}>;

export type BrandedEmailPreferencesForm_UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization?: {
		__typename?: 'Organization';
		id: string;
		brandedEmails?: boolean | null;
	} | null;
};

export type GratuityPreferencesForm_UpdateOrganizationMutationVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		data: OrganizationCustomUpdateInput;
	}>;

export type GratuityPreferencesForm_UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization?: {
		__typename?: 'Organization';
		id: string;
		invoicesAllowGratuity: boolean;
	} | null;
};

export type InternationalPaymentsPreferences_GetOrganizationWhereQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type InternationalPaymentsPreferences_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery =
	{
		__typename?: 'Query';
		getStripePaymentCapabilities?: {
			__typename?: 'AccountCapabilities';
			card_payments?: string | null;
			acss_debit_payments?: string | null;
		} | null;
	};

export type InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type InternationalPaymentsPreferences_RequestStripeCapabilitiesMutation =
	{ __typename?: 'Mutation'; requestStripeCapabilities: string };

export type LeadsConfiguration_GetInquiryFormApiKeyQueryVariables = Exact<{
	[key: string]: never;
}>;

export type LeadsConfiguration_GetInquiryFormApiKeyQuery = {
	__typename?: 'Query';
	getInquiryFormApiKey: string;
};

export type LeadsConfiguration_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type LeadsConfiguration_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; name: string }>;
		} | null;
	} | null;
};

export type ReferralCode_GetOrganizationReferralCodeQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type ReferralCode_GetOrganizationReferralCodeQuery = {
	__typename?: 'Query';
	getOrganizationReferralCode?: {
		__typename?: 'Coupon';
		id: string;
		name: string;
		onboardingLink?: string | null;
		onboardedOrgs?: Array<{
			__typename?: 'Organization';
			id: string;
			name: string;
			contactEmail?: string | null;
			createdAt: Date | string;
		}> | null;
	} | null;
};

export type UseUpdateOrganizationContactInfoOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	description?: string | null;
	contactEmail?: string | null;
	phone?: string | null;
	website?: string | null;
	addressLine1?: string | null;
	addressLine2?: string | null;
	city?: string | null;
	state?: State | null;
	country?: Country | null;
	postalCode?: string | null;
	facebook?: string | null;
	twitter?: string | null;
	instagram?: string | null;
	pinterest?: string | null;
	services: Array<{ __typename?: 'Service'; id: string; name: string }>;
};

export type UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type UseUpdateOrganizationContactInfo_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		description?: string | null;
		contactEmail?: string | null;
		phone?: string | null;
		website?: string | null;
		addressLine1?: string | null;
		addressLine2?: string | null;
		city?: string | null;
		state?: State | null;
		country?: Country | null;
		postalCode?: string | null;
		facebook?: string | null;
		twitter?: string | null;
		instagram?: string | null;
		pinterest?: string | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
};

export type UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		data: OrganizationCustomUpdateInput;
	}>;

export type UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		description?: string | null;
		contactEmail?: string | null;
		phone?: string | null;
		website?: string | null;
		addressLine1?: string | null;
		addressLine2?: string | null;
		city?: string | null;
		state?: State | null;
		country?: Country | null;
		postalCode?: string | null;
		facebook?: string | null;
		twitter?: string | null;
		instagram?: string | null;
		pinterest?: string | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
};

export type CurrentPlanPlanFragment = {
	__typename?: 'Plan';
	id: string;
	type: PlanType;
	period: PlanPeriod;
	price: number;
	stripePlanID: string;
};

export type CurrentPlanReducedCouponFragment = {
	__typename?: 'ReducedCoupon';
	percent_off?: number | null;
	amount_off?: number | null;
	duration?: StripeDuration | null;
	duration_in_months?: number | null;
};

export type CurrentPlanSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	plan?: {
		__typename?: 'StripePlan';
		id?: string | null;
		interval?: StripePlanInterval | null;
		amount?: number | null;
	} | null;
	discounts?: Array<{
		__typename?: 'Discount';
		coupon?: {
			__typename?: 'StripeCoupon';
			percent_off?: number | null;
			amount_off?: number | null;
			duration?: string | null;
			duration_in_months?: number | null;
		} | null;
	} | null> | null;
};

export type CurrentPlanSourceFragment = {
	__typename?: 'Source';
	id: string;
	last4?: string | null;
	exp_month?: number | null;
	exp_year?: number | null;
	address_zip?: string | null;
	name?: string | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type NextChargeReducedCouponFragment = {
	__typename?: 'ReducedCoupon';
	percent_off?: number | null;
	duration_in_months?: number | null;
};

export type NextChargeSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	id: string;
	status?: StripeSubscriptionStatus | null;
	plan?: {
		__typename?: 'StripePlan';
		amount?: number | null;
		interval?: StripePlanInterval | null;
	} | null;
	items?: {
		__typename?: 'SubscriptionItems';
		data?: Array<{
			__typename?: 'SubscriptionPlan';
			current_period_end?: number | null;
		} | null> | null;
	} | null;
	discounts?: Array<{
		__typename?: 'Discount';
		coupon?: {
			__typename?: 'StripeCoupon';
			percent_off?: number | null;
			duration_in_months?: number | null;
		} | null;
	} | null> | null;
};

export type NextChargeStripeInvoiceFragment = {
	__typename?: 'StripeInvoice';
	id?: string | null;
	amount_due: number;
	next_payment_attempt?: number | null;
};

export type NextChargeOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	createdAt: Date | string;
};

export type GetPlanStartDateSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	id: string;
	items?: {
		__typename?: 'SubscriptionItems';
		data?: Array<{
			__typename?: 'SubscriptionPlan';
			current_period_end?: number | null;
		} | null> | null;
	} | null;
};

export type GetPlanStartDateOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	createdAt: Date | string;
};

export type GetPlanStartDateStripeInvoiceFragment = {
	__typename?: 'StripeInvoice';
	id?: string | null;
	amount_due: number;
	next_payment_attempt?: number | null;
};

export type GetNextChargeAmountReducedCouponFragment = {
	__typename?: 'ReducedCoupon';
	percent_off?: number | null;
	duration_in_months?: number | null;
};

export type GetNextChargeAmountSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	id: string;
	status?: StripeSubscriptionStatus | null;
	items?: {
		__typename?: 'SubscriptionItems';
		data?: Array<{
			__typename?: 'SubscriptionPlan';
			current_period_end?: number | null;
		} | null> | null;
	} | null;
	plan?: {
		__typename?: 'StripePlan';
		amount?: number | null;
		interval?: StripePlanInterval | null;
	} | null;
	discounts?: Array<{
		__typename?: 'Discount';
		coupon?: {
			__typename?: 'StripeCoupon';
			percent_off?: number | null;
			duration_in_months?: number | null;
		} | null;
	} | null> | null;
};

export type GetNextChargeAmountStripeInvoiceFragment = {
	__typename?: 'StripeInvoice';
	id?: string | null;
	amount_due: number;
};

export type PaymentMethodModalSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	status?: StripeSubscriptionStatus | null;
};

export type PromotionalDiscountReducedCouponFragment = {
	__typename?: 'ReducedCoupon';
	id: string;
	percent_off?: number | null;
	amount_off?: number | null;
	duration?: StripeDuration | null;
	duration_in_months?: number | null;
};

export type PromotionalDiscountSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	discounts?: Array<{
		__typename?: 'Discount';
		coupon?: {
			__typename?: 'StripeCoupon';
			id?: string | null;
			percent_off?: number | null;
			amount_off?: number | null;
			duration?: string | null;
			duration_in_months?: number | null;
		} | null;
	} | null> | null;
};

export type SubscriptionCancellationModalSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	id: string;
	status?: StripeSubscriptionStatus | null;
	items?: {
		__typename?: 'SubscriptionItems';
		data?: Array<{
			__typename?: 'SubscriptionPlan';
			current_period_end?: number | null;
		} | null> | null;
	} | null;
	plan?: {
		__typename?: 'StripePlan';
		amount?: number | null;
		interval?: StripePlanInterval | null;
	} | null;
};

export type SubscriptionCancellationModalOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	createdAt: Date | string;
	subscription?: {
		__typename?: 'AppSubscription';
		id: string;
		status?: SubscriptionStatus | null;
	} | null;
};

export type SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationVariables =
	Exact<{ [key: string]: never }>;

export type SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation =
	{
		__typename?: 'Mutation';
		cancelVendorStripeSubscription: {
			__typename?: 'SubscriptionObject';
			id: string;
			status?: StripeSubscriptionStatus | null;
			items?: {
				__typename?: 'SubscriptionItems';
				data?: Array<{
					__typename?: 'SubscriptionPlan';
					current_period_end?: number | null;
				} | null> | null;
			} | null;
			plan?: {
				__typename?: 'StripePlan';
				amount?: number | null;
				interval?: StripePlanInterval | null;
			} | null;
		};
	};

export type PaidCopyPlanFragment = {
	__typename?: 'Plan';
	id: string;
	type: PlanType;
	period: PlanPeriod;
	proration?: number | null;
	price: number;
	amountDue?: number | null;
};

export type PaidCopyCouponFragment = {
	__typename?: 'ReducedCoupon';
	name: string;
	active: boolean;
	percent_off?: number | null;
	amount_off?: number | null;
	duration?: StripeDuration | null;
	duration_in_months?: number | null;
	id: string;
	planCost?: {
		__typename?: 'PlanCost';
		proration?: number | null;
		price?: number | null;
		amountDue?: number | null;
	} | null;
};

export type ConfirmSubscriptionSelectionPlanFragment = {
	__typename?: 'Plan';
	active: boolean;
	id: string;
	type: PlanType;
	period: PlanPeriod;
	proration?: number | null;
	price: number;
	amountDue?: number | null;
};

export type ConfirmSubscriptionSelectionSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	id: string;
	status?: StripeSubscriptionStatus | null;
	cancel_at_period_end?: boolean | null;
	discounts?: Array<{
		__typename?: 'Discount';
		coupon?: {
			__typename?: 'StripeCoupon';
			duration?: string | null;
			duration_in_months?: number | null;
			percent_off?: number | null;
			amount_off?: number | null;
		} | null;
	} | null> | null;
	items?: {
		__typename?: 'SubscriptionItems';
		data?: Array<{
			__typename?: 'SubscriptionPlan';
			current_period_start?: number | null;
			current_period_end?: number | null;
		} | null> | null;
	} | null;
};

export type ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationVariables =
	Exact<{
		data: StripeVendorSubscriptionChangeInput;
	}>;

export type ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation = {
	__typename?: 'Mutation';
	changeVendorSubscription:
		| { __typename?: 'RedirectUrl' }
		| {
				__typename?: 'SubscriptionObject';
				id: string;
				status?: StripeSubscriptionStatus | null;
				cancel_at_period_end?: boolean | null;
				discounts?: Array<{
					__typename?: 'Discount';
					coupon?: {
						__typename?: 'StripeCoupon';
						duration?: string | null;
						duration_in_months?: number | null;
						percent_off?: number | null;
						amount_off?: number | null;
					} | null;
				} | null> | null;
				items?: {
					__typename?: 'SubscriptionItems';
					data?: Array<{
						__typename?: 'SubscriptionPlan';
						current_period_start?: number | null;
						current_period_end?: number | null;
					} | null> | null;
				} | null;
		  };
};

export type ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationVariables =
	Exact<{
		data: StripeVendorSubscriptionCreationInput;
	}>;

export type ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation =
	{
		__typename?: 'Mutation';
		createVendorStripeSubscription:
			| { __typename?: 'RedirectUrl'; redirect: string }
			| {
					__typename?: 'SubscriptionObject';
					id: string;
					status?: StripeSubscriptionStatus | null;
					cancel_at_period_end?: boolean | null;
					discounts?: Array<{
						__typename?: 'Discount';
						coupon?: {
							__typename?: 'StripeCoupon';
							duration?: string | null;
							duration_in_months?: number | null;
							percent_off?: number | null;
							amount_off?: number | null;
						} | null;
					} | null> | null;
					items?: {
						__typename?: 'SubscriptionItems';
						data?: Array<{
							__typename?: 'SubscriptionPlan';
							current_period_start?: number | null;
							current_period_end?: number | null;
						} | null> | null;
					} | null;
			  };
	};

export type ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationVariables =
	Exact<{ [key: string]: never }>;

export type ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation =
	{
		__typename?: 'Mutation';
		cancelVendorStripeSubscription: {
			__typename?: 'SubscriptionObject';
			id: string;
			status?: StripeSubscriptionStatus | null;
			cancel_at_period_end?: boolean | null;
			discounts?: Array<{
				__typename?: 'Discount';
				coupon?: {
					__typename?: 'StripeCoupon';
					duration?: string | null;
					duration_in_months?: number | null;
					percent_off?: number | null;
					amount_off?: number | null;
				} | null;
			} | null> | null;
			items?: {
				__typename?: 'SubscriptionItems';
				data?: Array<{
					__typename?: 'SubscriptionPlan';
					current_period_start?: number | null;
					current_period_end?: number | null;
				} | null> | null;
			} | null;
		};
	};

export type ConfirmSubscriptionSelectionOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	createdAt: Date | string;
	hasForeverCoupon: boolean;
	subscription?: {
		__typename?: 'AppSubscription';
		id: string;
		status?: SubscriptionStatus | null;
		subscriptionPlan: {
			__typename?: 'Plan';
			id: string;
			type: PlanType;
			period: PlanPeriod;
		};
	} | null;
};

export type ConfirmSubscriptionSelection_RegisterCouponUsageMutationVariables =
	Exact<{
		data: RegisterCouponUsageWhere;
		where: OrganizationWhereUniqueInput;
	}>;

export type ConfirmSubscriptionSelection_RegisterCouponUsageMutation = {
	__typename?: 'Mutation';
	registerCouponUsage: { __typename?: 'Coupon'; id: string };
};

export type SubscriptionOptionButtonReducedCouponFragment = {
	__typename?: 'ReducedCoupon';
	name: string;
};

export type SubscriptionOptionButtonReducedCouponWithPlanDataFragment = {
	__typename?: 'ReducedCoupon';
	name: string;
	id: string;
	percent_off?: number | null;
	duration_in_months?: number | null;
	active: boolean;
	planCost?: {
		__typename?: 'PlanCost';
		price?: number | null;
		proration?: number | null;
		amountDue?: number | null;
	} | null;
};

export type SubscriptionOptionButtonPlanFragment = {
	__typename?: 'Plan';
	id: string;
	type: PlanType;
	period: PlanPeriod;
	price: number;
	proration?: number | null;
	amountDue?: number | null;
	active: boolean;
};

export type SubscriptionOptionButtonSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	status?: StripeSubscriptionStatus | null;
	cancel_at_period_end?: boolean | null;
};

export type SubscriptionOptionButton_GetCouponDetailsQueryVariables = Exact<{
	where: CouponByNameInput;
}>;

export type SubscriptionOptionButton_GetCouponDetailsQuery = {
	__typename?: 'Query';
	getCouponDetails: {
		__typename?: 'ReducedCoupon';
		name: string;
		id: string;
		percent_off?: number | null;
		duration_in_months?: number | null;
		active: boolean;
		planCost?: {
			__typename?: 'PlanCost';
			price?: number | null;
			proration?: number | null;
			amountDue?: number | null;
		} | null;
	};
};

export type SubscriptionSelectionModalReducedCouponFragment = {
	__typename?: 'ReducedCoupon';
	id: string;
	active: boolean;
	percent_off?: number | null;
	name: string;
};

export type SubscriptionSelectionModalSubscriptionObjectFragment = {
	__typename?: 'SubscriptionObject';
	amount?: number | null;
	status?: StripeSubscriptionStatus | null;
	cancel_at_period_end?: boolean | null;
	id: string;
	discounts?: Array<{
		__typename?: 'Discount';
		coupon?: {
			__typename?: 'StripeCoupon';
			duration?: string | null;
			duration_in_months?: number | null;
			percent_off?: number | null;
			amount_off?: number | null;
		} | null;
	} | null> | null;
	items?: {
		__typename?: 'SubscriptionItems';
		data?: Array<{
			__typename?: 'SubscriptionPlan';
			current_period_start?: number | null;
			current_period_end?: number | null;
		} | null> | null;
	} | null;
};

export type SubscriptionSelectionModalOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	createdAt: Date | string;
	hasForeverCoupon: boolean;
	subscription?: {
		__typename?: 'AppSubscription';
		id: string;
		status?: SubscriptionStatus | null;
		subscriptionPlan: {
			__typename?: 'Plan';
			id: string;
			type: PlanType;
			period: PlanPeriod;
		};
	} | null;
};

export type SubscriptionSelectionModal_GetGlobalVariablesQueryVariables =
	Exact<{ [key: string]: never }>;

export type SubscriptionSelectionModal_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		SubscriptionPlanUrl?: string | null;
	};
};

export type SubscriptionSelectionModalPlanFragment = {
	__typename?: 'Plan';
	id: string;
	type: PlanType;
	period: PlanPeriod;
	price: number;
	proration?: number | null;
	amountDue?: number | null;
	active: boolean;
};

export type UpdateVendorBillingSourceFragment = {
	__typename?: 'Source';
	object: string;
	id: string;
	last4?: string | null;
	exp_month?: number | null;
	exp_year?: number | null;
	address_zip?: string | null;
	name?: string | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type UpdateVendorBilling_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type UpdateVendorBilling_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		createdAt: Date | string;
		hasForeverCoupon: boolean;
		coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
		subscription?: {
			__typename?: 'AppSubscription';
			id: string;
			status?: SubscriptionStatus | null;
			subscriptionPlan: {
				__typename?: 'Plan';
				id: string;
				type: PlanType;
				period: PlanPeriod;
			};
		} | null;
	} | null;
};

export type UpdateVendorBilling_GetStripeSubscriptionQueryVariables = Exact<{
	[key: string]: never;
}>;

export type UpdateVendorBilling_GetStripeSubscriptionQuery = {
	__typename?: 'Query';
	getStripeVendorSubscription?: {
		__typename?: 'SubscriptionObject';
		id: string;
		amount?: number | null;
		status?: StripeSubscriptionStatus | null;
		cancel_at_period_end?: boolean | null;
		discounts?: Array<{
			__typename?: 'Discount';
			coupon?: {
				__typename?: 'StripeCoupon';
				id?: string | null;
				percent_off?: number | null;
				amount_off?: number | null;
				duration?: string | null;
				duration_in_months?: number | null;
			} | null;
		} | null> | null;
		plan?: {
			__typename?: 'StripePlan';
			id?: string | null;
			interval?: StripePlanInterval | null;
			amount?: number | null;
		} | null;
		items?: {
			__typename?: 'SubscriptionItems';
			data?: Array<{
				__typename?: 'SubscriptionPlan';
				current_period_end?: number | null;
				current_period_start?: number | null;
			} | null> | null;
		} | null;
	} | null;
	getNextStripeInvoice?: {
		__typename?: 'StripeInvoice';
		period_start?: number | null;
		period_end?: number | null;
		starting_balance?: number | null;
		id?: string | null;
		next_payment_attempt?: number | null;
		amount_due: number;
	} | null;
};

export type UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery = {
	__typename?: 'Query';
	getPaymentMethodsForVendorCustomer: {
		__typename?: 'SourcesWithDefaultSource';
		data?: Array<{
			__typename?: 'Source';
			object: string;
			id: string;
			last4?: string | null;
			exp_month?: number | null;
			exp_year?: number | null;
			address_zip?: string | null;
			name?: string | null;
			metadata?: Array<{
				__typename?: 'ReturningMetaData';
				key?: string | null;
				value?: string | null;
			} | null> | null;
		}> | null;
	};
};

export type UpdateVendorBilling_GetStripeConnectAccountQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type UpdateVendorBilling_GetStripeConnectAccountQuery = {
	__typename?: 'Query';
	getStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		external_accounts?: {
			__typename?: 'Sources';
			data?: Array<{ __typename?: 'Source'; id: string } | null> | null;
		} | null;
	} | null;
};

export type UpdateVendorBilling_GetCouponDetailsQueryVariables = Exact<{
	where: CouponByNameInput;
}>;

export type UpdateVendorBilling_GetCouponDetailsQuery = {
	__typename?: 'Query';
	getCouponDetails: {
		__typename?: 'ReducedCoupon';
		percent_off?: number | null;
		duration_in_months?: number | null;
		id: string;
		amount_off?: number | null;
		duration?: StripeDuration | null;
		active: boolean;
		name: string;
	};
};

export type CurrentPlan_GetPlansQueryVariables = Exact<{
	[key: string]: never;
}>;

export type CurrentPlan_GetPlansQuery = {
	__typename?: 'Query';
	getPlans: Array<{
		__typename?: 'Plan';
		id: string;
		type: PlanType;
		period: PlanPeriod;
		price: number;
		stripePlanID: string;
		proration?: number | null;
		amountDue?: number | null;
		active: boolean;
	}>;
};

export type UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationVariables =
	Exact<{ [key: string]: never }>;

export type UpdateVendorBilling_PayOpenSubscriptionInvoicesMutation = {
	__typename?: 'Mutation';
	payOpenSubscriptionInvoices: boolean;
};

export type Webhooks_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type Webhooks_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		WebhookHelpUrl?: string | null;
		WebhookOpenApiUrl?: string | null;
	};
};

export type AdminWebhookDeliveryHistory_WebhookDeliveryFragment = {
	__typename?: 'WebhookDelivery';
	id: string;
	eventId: string;
	eventType: WebhookEventType;
	status: WebhookDeliveryStatus;
	apiVersion: string;
	destinationUrl: string;
	payload: any;
	responseStatus?: number | null;
	attemptCount: number;
	lastAttemptAt?: Date | string | null;
	nextAttemptAt?: Date | string | null;
	deliveredAt?: Date | string | null;
	exhaustedAt?: Date | string | null;
	createdAt: Date | string;
};

export type AdminWebhookDeliveryHistory_GetDeliveriesQueryVariables = Exact<{
	endpointId: Scalars['ID']['input'];
	take: Scalars['Int']['input'];
	createdAt?: InputMaybe<DateTimeFilter>;
}>;

export type AdminWebhookDeliveryHistory_GetDeliveriesQuery = {
	__typename?: 'Query';
	getWebhookDeliveries: Array<{
		__typename?: 'WebhookDelivery';
		id: string;
		eventId: string;
		eventType: WebhookEventType;
		status: WebhookDeliveryStatus;
		apiVersion: string;
		destinationUrl: string;
		payload: any;
		responseStatus?: number | null;
		attemptCount: number;
		lastAttemptAt?: Date | string | null;
		nextAttemptAt?: Date | string | null;
		deliveredAt?: Date | string | null;
		exhaustedAt?: Date | string | null;
		createdAt: Date | string;
	}>;
};

export type AdminWebhookDeliveryHistory_ResendDeliveryMutationVariables =
	Exact<{
		deliveryId: Scalars['ID']['input'];
	}>;

export type AdminWebhookDeliveryHistory_ResendDeliveryMutation = {
	__typename?: 'Mutation';
	resendWebhookDelivery: boolean;
};

export type AdminWebhooks_WebhookEndpointFragment = {
	__typename?: 'WebhookEndpoint';
	id: string;
	description: string;
	destinationUrl: string;
	enabled: boolean;
	apiVersion: string;
	secretSuffix: string;
	subscribedEventTypes: Array<WebhookEventType>;
	previousSecretExpiresAt?: Date | string | null;
	pausedAt?: Date | string | null;
	createdAt: Date | string;
	updatedAt: Date | string;
};

export type AdminWebhooks_GetDataQueryVariables = Exact<{
	[key: string]: never;
}>;

export type AdminWebhooks_GetDataQuery = {
	__typename?: 'Query';
	getApiVersions: Array<string>;
	getWebhookEndpoints: Array<{
		__typename?: 'WebhookEndpoint';
		id: string;
		description: string;
		destinationUrl: string;
		enabled: boolean;
		apiVersion: string;
		secretSuffix: string;
		subscribedEventTypes: Array<WebhookEventType>;
		previousSecretExpiresAt?: Date | string | null;
		pausedAt?: Date | string | null;
		createdAt: Date | string;
		updatedAt: Date | string;
	}>;
};

export type AdminWebhooks_ConfigureWebhookEndpointMutationVariables = Exact<{
	data: WebhookEndpointInput;
}>;

export type AdminWebhooks_ConfigureWebhookEndpointMutation = {
	__typename?: 'Mutation';
	configureWebhookEndpoint: {
		__typename?: 'WebhookEndpointSecretResult';
		signingSecret?: string | null;
		endpoint: {
			__typename?: 'WebhookEndpoint';
			id: string;
			description: string;
			destinationUrl: string;
			enabled: boolean;
			apiVersion: string;
			secretSuffix: string;
			subscribedEventTypes: Array<WebhookEventType>;
			previousSecretExpiresAt?: Date | string | null;
			pausedAt?: Date | string | null;
			createdAt: Date | string;
			updatedAt: Date | string;
		};
	};
};

export type AdminWebhooks_RotateWebhookSecretMutationVariables = Exact<{
	endpointId: Scalars['ID']['input'];
}>;

export type AdminWebhooks_RotateWebhookSecretMutation = {
	__typename?: 'Mutation';
	rotateWebhookSecret: {
		__typename?: 'WebhookEndpointSecretResult';
		signingSecret?: string | null;
		endpoint: {
			__typename?: 'WebhookEndpoint';
			id: string;
			description: string;
			destinationUrl: string;
			enabled: boolean;
			apiVersion: string;
			secretSuffix: string;
			subscribedEventTypes: Array<WebhookEventType>;
			previousSecretExpiresAt?: Date | string | null;
			pausedAt?: Date | string | null;
			createdAt: Date | string;
			updatedAt: Date | string;
		};
	};
};

export type AdminWebhooks_DeleteWebhookEndpointMutationVariables = Exact<{
	endpointId: Scalars['ID']['input'];
}>;

export type AdminWebhooks_DeleteWebhookEndpointMutation = {
	__typename?: 'Mutation';
	deleteWebhookEndpoint: boolean;
};

export type Admin_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type Admin_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			description?: string | null;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			facebook?: string | null;
			instagram?: string | null;
			twitter?: string | null;
			pinterest?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					updatedAt: Date | string;
				} | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			role: TeamMemberRole;
			phone?: string | null;
			isAdmin: boolean;
			isOwner: boolean;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			organization?: {
				__typename?: 'Organization';
				id: string;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				country?: Country | null;
				postalCode?: string | null;
				createdAt: Date | string;
				name: string;
				website?: string | null;
				phone?: string | null;
				contactEmail?: string | null;
				description?: string | null;
				image?: string | null;
				imageScale?: number | null;
				imageRotation?: number | null;
				imagePositionX?: number | null;
				imagePositionY?: number | null;
				brandedEmails?: boolean | null;
				automatedRemindersEnabled: boolean;
				invoicesAllowGratuity: boolean;
				canReceivePayments: boolean;
				updatedAt: Date | string;
				facebook?: string | null;
				instagram?: string | null;
				twitter?: string | null;
				pinterest?: string | null;
				hasStripeVerificationNeeds: boolean;
				coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: {
						__typename?: 'Plan';
						id: string;
						period: PlanPeriod;
						type: PlanType;
					};
				} | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
				rootFolder?: { __typename?: 'Folder'; id: string } | null;
			} | null;
		} | null;
		superAdmin?: {
			__typename?: 'SuperAdminUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
			};
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type AutomatedNotificationsToggle_GetGlobalVariablesQueryVariables =
	Exact<{ [key: string]: never }>;

export type AutomatedNotificationsToggle_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		AutomatedNotificationsSupportUrl?: string | null;
	};
};

export type CalendarLinks_GetCalendarLinksQueryVariables = Exact<{
	sourceType: CalendarSourceType;
	sourceId: Scalars['String']['input'];
}>;

export type CalendarLinks_GetCalendarLinksQuery = {
	__typename?: 'Query';
	getCalendarLinks: {
		__typename?: 'CalendarLinksPayload';
		googleUrl: string;
		outlookUrl: string;
		webcalUrl: string;
		downloadUrl: string;
	};
};

export type CalendarLinks_SendCalendarInviteMutationVariables = Exact<{
	sourceType: CalendarSourceType;
	sourceId: Scalars['String']['input'];
	recipientEmails:
		| Array<Scalars['String']['input']>
		| Scalars['String']['input'];
	customizedEmail?: InputMaybe<CalendarInviteCustomizedEmailInput>;
}>;

export type CalendarLinks_SendCalendarInviteMutation = {
	__typename?: 'Mutation';
	sendCalendarInvite: boolean;
};

export type ConnectToCanva_SaveCanvaAuthorizationTokensMutationVariables =
	Exact<{
		data: CanvaTokenResponseInput;
	}>;

export type ConnectToCanva_SaveCanvaAuthorizationTokensMutation = {
	__typename?: 'Mutation';
	saveCanvaAuthorizationTokens: {
		__typename?: 'OAuthAccessToken';
		id: string;
		accessToken: string;
		expires: Date | string;
	};
};

export type CanvaEdit_RefreshCanvaExportMutationVariables = Exact<{
	where: CanvaDesignWhereUniqueInput;
}>;

export type CanvaEdit_RefreshCanvaExportMutation = {
	__typename?: 'Mutation';
	refreshCanvaExportForProposal: {
		__typename?: 'Proposal';
		id: string;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			designId: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
		} | null;
	};
};

export type CanvaEdit_RefreshCanvaExportForProposalTemplateMutationVariables =
	Exact<{
		where: CanvaDesignWhereUniqueInput;
	}>;

export type CanvaEdit_RefreshCanvaExportForProposalTemplateMutation = {
	__typename?: 'Mutation';
	refreshCanvaExportForProposalTemplate: {
		__typename?: 'ProposalTemplate';
		id: string;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			designId: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
		} | null;
	};
};

export type ClientDashboard_GetDashboardStatsForClientQueryVariables = Exact<{
	where: ClientUserWhereUniqueInput;
}>;

export type ClientDashboard_GetDashboardStatsForClientQuery = {
	__typename?: 'Query';
	getDashboardStatsForClient?: {
		__typename?: 'ClientDashboardStats';
		daysToEvent?: number | null;
		totalPaid: number;
		totalBilled: number;
		totalOutstanding: number;
		nextDueInstallment?: {
			__typename?: 'PaymentInstallment';
			id: string;
			amountDue?: number | null;
			dueDate?: Date | string | null;
		} | null;
		documentsNeedingAttention: {
			__typename?: 'DocumentsNeedingAttention';
			total: number;
			contracts: number;
			proposals: number;
			invoices: number;
		};
	} | null;
};

export type ClientDashboard_GetActionableItemsForClientQueryVariables = Exact<{
	[key: string]: never;
}>;

export type ClientDashboard_GetActionableItemsForClientQuery = {
	__typename?: 'Query';
	getActionableItemsForClient: Array<{
		__typename?: 'ClientActionableItem';
		itemId: string;
		itemType: ClientActionableItemType;
		itemDescription?: string | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		vendor: {
			__typename?: 'ClientActionableItemVendor';
			id: string;
			name: string;
		};
	}>;
};

export type ClientDashboard_UpdateClientUserMutationVariables = Exact<{
	where: ClientUserWhereUniqueInput;
	data: ClientUserUpdateCustomInput;
}>;

export type ClientDashboard_UpdateClientUserMutation = {
	__typename?: 'Mutation';
	updateClientUser: {
		__typename?: 'ClientUser';
		id: string;
		weddingDate?: Date | string | null;
	};
};

export type ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationVariables =
	Exact<{
		where: ContactWhereUniqueInput;
	}>;

export type ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation =
	{ __typename?: 'Mutation'; requestPlannerPermissions: boolean };

export type ActionMenuRequestPermissionsModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	customer: {
		__typename?: 'User';
		id: string;
		userType: UserType;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
};

export type ClientDetailActionMenuDateChangeModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	customer: {
		__typename?: 'User';
		id: string;
		userType: UserType;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	};
};

export type ClientActionMenu_RequestClientEventDateChangeMutationVariables =
	Exact<{
		where: ClientUserWhereUniqueInput;
	}>;

export type ClientActionMenu_RequestClientEventDateChangeMutation = {
	__typename?: 'Mutation';
	requestClientEventDateChange: boolean;
};

export type ClientActionButton_GetStripeConnectAccountQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type ClientActionButton_GetStripeConnectAccountQuery = {
	__typename?: 'Query';
	getStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		external_accounts?: {
			__typename?: 'Sources';
			data?: Array<{ __typename?: 'Source'; id: string } | null> | null;
		} | null;
	} | null;
};

export type ClientActionButton_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type ClientActionButton_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			isAdmin: boolean;
			isOwner: boolean;
			organization?: {
				__typename?: 'Organization';
				id: string;
				hasStripeVerificationNeeds: boolean;
			} | null;
		} | null;
	} | null;
};

export type ClientActionButtonContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	phone?: string | null;
	venue?: string | null;
	eventDate?: Date | string | null;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	companyName?: string | null;
	source?: string | null;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		updatedAt: Date | string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			phone?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			updatedAt: Date | string;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			phone?: string | null;
			updatedAt: Date | string;
		} | null;
		guestUser?: { __typename?: 'GuestUser'; id: string } | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
	};
	vendor: { __typename?: 'Organization'; id: string };
};

export type UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryVariables =
	Exact<{ [key: string]: never }>;

export type UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery =
	{
		__typename?: 'Query';
		getFeatureFlags: Array<{
			__typename?: 'ReducedFeatureFlag';
			category: FeatureCategory;
			active: boolean;
		}>;
	};

export type ClientDetailActionMenuContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		updatedAt: Date | string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			assignedPlanner?: { __typename?: 'OrgUser'; id: string } | null;
		} | null;
		guestUser?: { __typename?: 'GuestUser'; id: string } | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	};
	vendor: { __typename?: 'Organization'; id: string };
	assignedMember: { __typename?: 'OrgUser'; id: string };
};

export type ClientDetailActionMenu_RequestContactActivationMutationVariables =
	Exact<{
		where: ContactWhereUniqueInput;
	}>;

export type ClientDetailActionMenu_RequestContactActivationMutation = {
	__typename?: 'Mutation';
	requestContactActivation: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			updatedAt: Date | string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: { __typename?: 'OrgUser'; id: string } | null;
			} | null;
			guestUser?: { __typename?: 'GuestUser'; id: string } | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		};
		vendor: { __typename?: 'Organization'; id: string };
		assignedMember: { __typename?: 'OrgUser'; id: string };
	};
};

export type ClientContactInfoClientFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	phone?: string | null;
	firstName: string;
	hasCustomerIntent: boolean;
	lastName: string;
	venue?: string | null;
	eventDate?: Date | string | null;
	companyName?: string | null;
	source?: string | null;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		updatedAt: Date | string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			phone?: string | null;
			addressLine1: string;
			addressLine2?: string | null;
			city: string;
			state: State;
			postalCode?: string | null;
			twitter?: string | null;
			facebook?: string | null;
			pinterest?: string | null;
			instagram?: string | null;
			firstNameOne: string;
			lastNameOne?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			updatedAt: Date | string;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			phone?: string | null;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			organization?: {
				__typename?: 'Organization';
				id: string;
				website?: string | null;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				postalCode?: string | null;
				twitter?: string | null;
				facebook?: string | null;
				pinterest?: string | null;
				instagram?: string | null;
			} | null;
		} | null;
		guestUser?: { __typename?: 'GuestUser'; id: string } | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
	};
	vendor: { __typename?: 'Organization'; id: string };
};

export type AssignedToMembersFragment = {
	__typename?: 'OrgUser';
	id: string;
	firstName: string;
	lastName: string;
	updatedAt: Date | string;
	role: TeamMemberRole;
	user?: {
		__typename?: 'User';
		id: string;
		onboardingCompleted?: boolean | null;
	} | null;
};

export type ClientDetailAssignedToContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	customer: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				role: TeamMemberRole;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: {
					__typename?: 'User';
					id: string;
					onboardingCompleted?: boolean | null;
				} | null;
			} | null;
		} | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		role: TeamMemberRole;
		user?: {
			__typename?: 'User';
			id: string;
			onboardingCompleted?: boolean | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user?: {
				__typename?: 'User';
				id: string;
				onboardingCompleted?: boolean | null;
			} | null;
		}> | null;
	};
};

export type AssignedWidget_AssignMemberToContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data: OrgUserWhereUniqueInput;
}>;

export type AssignedWidget_AssignMemberToContactMutation = {
	__typename?: 'Mutation';
	assignMemberToContact: {
		__typename?: 'Contact';
		id: string;
		assignedMember: { __typename?: 'OrgUser'; id: string };
	};
};

export type UseClientDetailOverview_UpdateContactStatusMutationVariables =
	Exact<{
		data: UpdateContactStatusDataInput;
		where: ContactWhereUniqueInput;
	}>;

export type UseClientDetailOverview_UpdateContactStatusMutation = {
	__typename?: 'Mutation';
	updateContactStatus: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
	};
};

export type UseClientDetailOverviewTargetOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	organization?: {
		__typename?: 'Organization';
		id: string;
		updatedAt: Date | string;
		image?: string | null;
		name: string;
	} | null;
};

export type UseClientDetailOverviewContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	firstName: string;
	lastName: string;
	hasCustomerIntent: boolean;
	companyName?: string | null;
	source?: string | null;
	createdAt: Date | string;
	venue?: string | null;
	eventDate?: Date | string | null;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				role: TeamMemberRole;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: {
					__typename?: 'User';
					id: string;
					onboardingCompleted?: boolean | null;
				} | null;
			} | null;
		} | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		role: TeamMemberRole;
		user?: {
			__typename?: 'User';
			id: string;
			onboardingCompleted?: boolean | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user?: {
				__typename?: 'User';
				id: string;
				onboardingCompleted?: boolean | null;
			} | null;
		}> | null;
	};
};

export type ClientDetailHeaderTargetOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	updatedAt: Date | string;
	firstName: string;
	lastName: string;
	role: TeamMemberRole;
	organization?: {
		__typename?: 'Organization';
		id: string;
		updatedAt: Date | string;
		image?: string | null;
		name: string;
	} | null;
	user?: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
	} | null;
};

export type ClientDetailHeaderContactFragment = {
	__typename?: 'Contact';
	id: string;
	hasCustomerIntent: boolean;
	status: ContactStatus;
	phone?: string | null;
	firstName: string;
	lastName: string;
	companyName?: string | null;
	source?: string | null;
	createdAt: Date | string;
	venue?: string | null;
	eventDate?: Date | string | null;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		updatedAt: Date | string;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			phone?: string | null;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			role: TeamMemberRole;
			organization?: {
				__typename?: 'Organization';
				id: string;
				website?: string | null;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				postalCode?: string | null;
				twitter?: string | null;
				facebook?: string | null;
				pinterest?: string | null;
				instagram?: string | null;
				updatedAt: Date | string;
				image?: string | null;
				name: string;
			} | null;
			user?: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
			} | null;
		} | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			phone?: string | null;
			addressLine1: string;
			addressLine2?: string | null;
			city: string;
			state: State;
			postalCode?: string | null;
			twitter?: string | null;
			facebook?: string | null;
			pinterest?: string | null;
			instagram?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				role: TeamMemberRole;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: {
					__typename?: 'User';
					id: string;
					onboardingCompleted?: boolean | null;
				} | null;
			} | null;
		} | null;
		guestUser?: { __typename?: 'GuestUser'; id: string } | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		role: TeamMemberRole;
		user?: {
			__typename?: 'User';
			id: string;
			onboardingCompleted?: boolean | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user?: {
				__typename?: 'User';
				id: string;
				onboardingCompleted?: boolean | null;
			} | null;
		}> | null;
	};
};

export type NotesTabContactFragment = {
	__typename?: 'Contact';
	id: string;
	note?: string | null;
};

export type NotesTab_UpdateNoteOnContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data: NoteInput;
}>;

export type NotesTab_UpdateNoteOnContactMutation = {
	__typename?: 'Mutation';
	updateNoteOnContact?: {
		__typename?: 'Contact';
		id: string;
		note?: string | null;
	} | null;
};

export type ClientDetailTabsContactFragment = {
	__typename?: 'Contact';
	id: string;
	hasCustomerIntent: boolean;
	note?: string | null;
	customer: {
		__typename?: 'User';
		id: string;
		userType: UserType;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			user: { __typename?: 'User'; id: string };
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
			organization?: { __typename?: 'Organization'; id: string } | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
	assignedMember: { __typename?: 'OrgUser'; id: string };
};

export type UpdateContactModal_OrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	contacts?: Array<{
		__typename?: 'Contact';
		id: string;
		customer: { __typename?: 'User'; email: string; id: string };
	}> | null;
};

export type UpdateContactModal_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type UpdateContactModal_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		contacts?: Array<{
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; email: string; id: string };
		}> | null;
	} | null;
};

export type UpdateContactModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	phone?: string | null;
	venue?: string | null;
	eventDate?: Date | string | null;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	companyName?: string | null;
	source?: string | null;
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
	};
	vendor: { __typename?: 'Organization'; id: string };
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			phone?: string | null;
		} | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			phone?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		guestUser?: { __typename?: 'GuestUser'; id: string } | null;
	};
};

export type UpdateContactModal_UpdateContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data: CustomContactUpdateInput;
}>;

export type UpdateContactModal_UpdateContactMutation = {
	__typename?: 'Mutation';
	updateContact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		phone?: string | null;
		venue?: string | null;
		eventDate?: Date | string | null;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		companyName?: string | null;
		source?: string | null;
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
		};
		vendor: { __typename?: 'Organization'; id: string };
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				phone?: string | null;
			} | null;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				firstNameOne: string;
				lastNameOne?: string | null;
				phone?: string | null;
				weddingDate?: Date | string | null;
				venue?: string | null;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
				} | null;
			} | null;
			guestUser?: { __typename?: 'GuestUser'; id: string } | null;
		};
	};
};

export type UseClientDetailMembersFragment = {
	__typename?: 'OrgUser';
	id: string;
	firstName: string;
	lastName: string;
	updatedAt: Date | string;
	role: TeamMemberRole;
};

export type UseClientDetailTargetOrgUserFragment = {
	__typename?: 'OrgUser';
	id: string;
	phone?: string | null;
	firstName: string;
	lastName: string;
	role: TeamMemberRole;
	updatedAt: Date | string;
	user?: {
		__typename?: 'User';
		id: string;
		blocked: boolean;
		email: string;
		userType: UserType;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		updatedAt: Date | string;
		image?: string | null;
		name: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type UseClientDetailContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	firstName: string;
	lastName: string;
	phone?: string | null;
	eventDate?: Date | string | null;
	companyName?: string | null;
	hasCustomerIntent: boolean;
	source?: string | null;
	createdAt: Date | string;
	venue?: string | null;
	note?: string | null;
	customer: {
		__typename?: 'User';
		id: string;
		userType: UserType;
		email: string;
		updatedAt: Date | string;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			phone?: string | null;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			role: TeamMemberRole;
			user?: {
				__typename?: 'User';
				id: string;
				blocked: boolean;
				email: string;
				userType: UserType;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				website?: string | null;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				postalCode?: string | null;
				twitter?: string | null;
				facebook?: string | null;
				pinterest?: string | null;
				instagram?: string | null;
				updatedAt: Date | string;
				image?: string | null;
				name: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			phone?: string | null;
			weddingDate?: Date | string | null;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			addressLine1: string;
			addressLine2?: string | null;
			city: string;
			state: State;
			postalCode?: string | null;
			twitter?: string | null;
			facebook?: string | null;
			pinterest?: string | null;
			instagram?: string | null;
			venue?: string | null;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				role: TeamMemberRole;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: {
					__typename?: 'User';
					id: string;
					onboardingCompleted?: boolean | null;
				} | null;
			} | null;
			user: { __typename?: 'User'; id: string };
		} | null;
		guestUser?: {
			__typename?: 'GuestUser';
			id: string;
			user: { __typename?: 'User'; id: string; email: string };
		} | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		role: TeamMemberRole;
		user?: {
			__typename?: 'User';
			id: string;
			onboardingCompleted?: boolean | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user?: {
				__typename?: 'User';
				id: string;
				onboardingCompleted?: boolean | null;
			} | null;
		}> | null;
	};
};

export type ClientDetail_GetContactWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type ClientDetail_GetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		firstName: string;
		lastName: string;
		phone?: string | null;
		eventDate?: Date | string | null;
		companyName?: string | null;
		hasCustomerIntent: boolean;
		source?: string | null;
		createdAt: Date | string;
		venue?: string | null;
		note?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			email: string;
			updatedAt: Date | string;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				phone?: string | null;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				role: TeamMemberRole;
				user?: {
					__typename?: 'User';
					id: string;
					blocked: boolean;
					email: string;
					userType: UserType;
				} | null;
				organization?: {
					__typename?: 'Organization';
					id: string;
					website?: string | null;
					addressLine1?: string | null;
					addressLine2?: string | null;
					city?: string | null;
					state?: State | null;
					postalCode?: string | null;
					twitter?: string | null;
					facebook?: string | null;
					pinterest?: string | null;
					instagram?: string | null;
					updatedAt: Date | string;
					image?: string | null;
					name: string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				} | null;
			} | null;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				firstNameOne: string;
				lastNameOne?: string | null;
				phone?: string | null;
				weddingDate?: Date | string | null;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				firstNameTwo?: string | null;
				lastNameTwo?: string | null;
				updatedAt: Date | string;
				addressLine1: string;
				addressLine2?: string | null;
				city: string;
				state: State;
				postalCode?: string | null;
				twitter?: string | null;
				facebook?: string | null;
				pinterest?: string | null;
				instagram?: string | null;
				venue?: string | null;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
					updatedAt: Date | string;
					role: TeamMemberRole;
					organization?: { __typename?: 'Organization'; id: string } | null;
					user?: {
						__typename?: 'User';
						id: string;
						onboardingCompleted?: boolean | null;
					} | null;
				} | null;
				user: { __typename?: 'User'; id: string };
			} | null;
			guestUser?: {
				__typename?: 'GuestUser';
				id: string;
				user: { __typename?: 'User'; id: string; email: string };
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			role: TeamMemberRole;
			user?: {
				__typename?: 'User';
				id: string;
				onboardingCompleted?: boolean | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				user?: {
					__typename?: 'User';
					id: string;
					onboardingCompleted?: boolean | null;
				} | null;
			}> | null;
		};
	} | null;
};

export type ClientOnboardingFinishUpClientUserFragment = {
	__typename?: 'ClientUser';
	id: string;
	venue?: string | null;
	weddingDate?: Date | string | null;
	phone?: string | null;
};

export type ClientOnboardingUseFinishUp_GetClientUserWhereQueryVariables =
	Exact<{
		where: ClientUserWhereUniqueInput;
	}>;

export type ClientOnboardingUseFinishUp_GetClientUserWhereQuery = {
	__typename?: 'Query';
	getClientUserWhere?: {
		__typename?: 'ClientUser';
		id: string;
		venue?: string | null;
		weddingDate?: Date | string | null;
		phone?: string | null;
	} | null;
};

export type ClientOnboardingFinishUp_UpdateClientUserMutationVariables = Exact<{
	data: ClientUserUpdateCustomInput;
	where: ClientUserWhereUniqueInput;
}>;

export type ClientOnboardingFinishUp_UpdateClientUserMutation = {
	__typename?: 'Mutation';
	updateClientUser: {
		__typename?: 'ClientUser';
		id: string;
		venue?: string | null;
		weddingDate?: Date | string | null;
		phone?: string | null;
	};
};

export type ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationVariables =
	Exact<{ [key: string]: never }>;

export type ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation = {
	__typename?: 'Mutation';
	markUserOnboardingComplete: boolean;
};

export type ClientOnboardingYourInfoAddressClientUserFragment = {
	__typename?: 'ClientUser';
	addressLine1: string;
	addressLine2?: string | null;
	city: string;
	postalCode?: string | null;
	state: State;
	country: Country;
};

export type ClientOnboardingYourInfoClientUserFragment = {
	__typename?: 'ClientUser';
	id: string;
	firstNameOne: string;
	lastNameOne?: string | null;
	firstNameTwo?: string | null;
	lastNameTwo?: string | null;
	addressLine1: string;
	addressLine2?: string | null;
	city: string;
	postalCode?: string | null;
	state: State;
	country: Country;
	user: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		acceptedTerms?: Date | string | null;
		consentedToAgeAndMarketingEmails?: Date | string | null;
	};
};

export type ClientOnboardingYourInfo_GetClientUserQueryVariables = Exact<{
	where: ClientUserWhereUniqueInput;
}>;

export type ClientOnboardingYourInfo_GetClientUserQuery = {
	__typename?: 'Query';
	getClientUserWhere?: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		firstNameTwo?: string | null;
		lastNameTwo?: string | null;
		addressLine1: string;
		addressLine2?: string | null;
		city: string;
		postalCode?: string | null;
		state: State;
		country: Country;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			acceptedTerms?: Date | string | null;
			consentedToAgeAndMarketingEmails?: Date | string | null;
		};
	} | null;
};

export type ClientOnboardingYourInfo_CreateClientUserMutationVariables = Exact<{
	data: ClientUserCreateInput;
}>;

export type ClientOnboardingYourInfo_CreateClientUserMutation = {
	__typename?: 'Mutation';
	createClientUser: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		firstNameTwo?: string | null;
		lastNameTwo?: string | null;
		addressLine1: string;
		addressLine2?: string | null;
		city: string;
		postalCode?: string | null;
		state: State;
		country: Country;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			acceptedTerms?: Date | string | null;
			consentedToAgeAndMarketingEmails?: Date | string | null;
		};
	};
};

export type ClientOnboardingYourInfo_UpdateClientUserMutationVariables = Exact<{
	data: ClientUserUpdateCustomInput;
	where: ClientUserWhereUniqueInput;
}>;

export type ClientOnboardingYourInfo_UpdateClientUserMutation = {
	__typename?: 'Mutation';
	updateClientUser: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		firstNameTwo?: string | null;
		lastNameTwo?: string | null;
		addressLine1: string;
		addressLine2?: string | null;
		city: string;
		postalCode?: string | null;
		state: State;
		country: Country;
		user: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			acceptedTerms?: Date | string | null;
			consentedToAgeAndMarketingEmails?: Date | string | null;
		};
	};
};

export type ClientOnboardingYourInfo_LoginQueryVariables = Exact<{
	data: UserLoginInput;
}>;

export type ClientOnboardingYourInfo_LoginQuery = {
	__typename?: 'Query';
	login?: { __typename?: 'AuthPayload'; token: string } | null;
};

export type ClientOnboardingYourInfo_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type ClientOnboardingYourInfo_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			description?: string | null;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			facebook?: string | null;
			instagram?: string | null;
			twitter?: string | null;
			pinterest?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					updatedAt: Date | string;
				} | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			role: TeamMemberRole;
			phone?: string | null;
			isAdmin: boolean;
			isOwner: boolean;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			organization?: {
				__typename?: 'Organization';
				id: string;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				country?: Country | null;
				postalCode?: string | null;
				createdAt: Date | string;
				name: string;
				website?: string | null;
				phone?: string | null;
				contactEmail?: string | null;
				description?: string | null;
				image?: string | null;
				imageScale?: number | null;
				imageRotation?: number | null;
				imagePositionX?: number | null;
				imagePositionY?: number | null;
				brandedEmails?: boolean | null;
				automatedRemindersEnabled: boolean;
				invoicesAllowGratuity: boolean;
				canReceivePayments: boolean;
				updatedAt: Date | string;
				facebook?: string | null;
				instagram?: string | null;
				twitter?: string | null;
				pinterest?: string | null;
				hasStripeVerificationNeeds: boolean;
				coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: {
						__typename?: 'Plan';
						id: string;
						period: PlanPeriod;
						type: PlanType;
					};
				} | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
				rootFolder?: { __typename?: 'Folder'; id: string } | null;
			} | null;
		} | null;
		superAdmin?: {
			__typename?: 'SuperAdminUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
			};
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type ClientOnboardingModal_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type ClientOnboardingModal_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		ClientHelpURL?: string | null;
		ClientDemoVideoUrl?: string | null;
	};
};

export type ClientPermissionsTooltipClientUserFragment = {
	__typename?: 'ClientUser';
	id: string;
	plannerOrgHasConnectionPermissions: boolean;
	plannerOrgCanSignContracts: boolean;
	plannerOrgCanPayInvoices: boolean;
	plannerOrgHasDocumentsPermissions: boolean;
};

export type ExportContactsDataQueryVariables = Exact<{
	where: ExportContactsDataWhereInput;
}>;

export type ExportContactsDataQuery = {
	__typename?: 'Query';
	exportContactsData: string;
};

export type ClientsTable_AssignedToContactFragment = {
	__typename?: 'Contact';
	id: string;
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
	};
	vendor: { __typename?: 'Organization'; id: string };
};

export type ClientsTable_AssignedToMemberFragment = {
	__typename?: 'OrgUser';
	id: string;
	firstName: string;
	lastName: string;
	user?: {
		__typename?: 'User';
		id: string;
		onboardingCompleted?: boolean | null;
	} | null;
};

export type ClientsTable_NameContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	firstName: string;
	lastName: string;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		updatedAt: Date | string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
			weddingDate?: Date | string | null;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
};

export type DeleteContactConfirmationModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	customer: { __typename?: 'User'; id: string; email: string };
};

export type DeleteContactConfirmationModal_DeleteContactMutationVariables =
	Exact<{
		where: ContactWhereUniqueInput;
	}>;

export type DeleteContactConfirmationModal_DeleteContactMutation = {
	__typename?: 'Mutation';
	deleteContact: boolean;
};

export type DeleteContactConfirmationModal_UpdateContactStatusMutationVariables =
	Exact<{
		data: UpdateContactStatusDataInput;
		where: ContactWhereUniqueInput;
	}>;

export type DeleteContactConfirmationModal_UpdateContactStatusMutation = {
	__typename?: 'Mutation';
	updateContactStatus: { __typename?: 'Contact'; id: string };
};

export type ClientsTableUpdateContactStatusLinkFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	customer: { __typename?: 'User'; id: string };
};

export type ClientsTableSubMenuContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	customer: { __typename?: 'User'; id: string };
};

export type UseClientsTable_ContactFragment = {
	__typename?: 'Contact';
	id: string;
	createdAt: Date | string;
	eventDate?: Date | string | null;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	companyName?: string | null;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		updatedAt: Date | string;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			updatedAt: Date | string;
		} | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			weddingDate?: Date | string | null;
			updatedAt: Date | string;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
	};
};

export type UseClientsTable_GetContactsWhereQueryVariables = Exact<{
	orderBy?: InputMaybe<
		Array<InputMaybe<ContactOrderByInput>> | InputMaybe<ContactOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContactWhereInput;
}>;

export type UseClientsTable_GetContactsWhereQuery = {
	__typename?: 'Query';
	getContactsWhere: {
		__typename?: 'Contacts';
		_count: number;
		contacts: Array<{
			__typename?: 'Contact';
			id: string;
			createdAt: Date | string;
			eventDate?: Date | string | null;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			companyName?: string | null;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				updatedAt: Date | string;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					updatedAt: Date | string;
				} | null;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					weddingDate?: Date | string | null;
					updatedAt: Date | string;
					plannerOrgHasConnectionPermissions: boolean;
					plannerOrgCanSignContracts: boolean;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgHasDocumentsPermissions: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
			};
		}>;
	};
};

export type UseClientsTable_MemberFragment = {
	__typename?: 'OrgUser';
	id: string;
	firstName: string;
	lastName: string;
	role: TeamMemberRole;
	user?: {
		__typename?: 'User';
		id: string;
		onboardingCompleted?: boolean | null;
	} | null;
};

export type UseClientsTable_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type UseClientsTable_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			role: TeamMemberRole;
			user?: {
				__typename?: 'User';
				id: string;
				onboardingCompleted?: boolean | null;
			} | null;
		}> | null;
	} | null;
};

export type UseClientsTable_AssignMemberToContactMutationVariables = Exact<{
	data: OrgUserWhereUniqueInput;
	where: ContactWhereUniqueInput;
}>;

export type UseClientsTable_AssignMemberToContactMutation = {
	__typename?: 'Mutation';
	assignMemberToContact: {
		__typename?: 'Contact';
		id: string;
		createdAt: Date | string;
		eventDate?: Date | string | null;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			updatedAt: Date | string;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				updatedAt: Date | string;
			} | null;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				weddingDate?: Date | string | null;
				updatedAt: Date | string;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
		};
	};
};

export type UseClientsTable_UpdateContactStatusMutationVariables = Exact<{
	data: UpdateContactStatusDataInput;
	where: ContactWhereUniqueInput;
}>;

export type UseClientsTable_UpdateContactStatusMutation = {
	__typename?: 'Mutation';
	updateContactStatus: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
	};
};

export type UseCompanyFoldersTable_CustomFolderFragment = {
	__typename?: 'CustomFolder';
	id: string;
	name?: string | null;
	createdAt: Date | string;
	parentFolder?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
	} | null;
};

export type UseCompanyFoldersTable_CustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	type: DocumentType;
	fileType: FileType;
	name: string;
	createdAt: Date | string;
	updatedAt: Date | string;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		updatedAt: Date | string;
		image?: string | null;
	} | null;
	customer?: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			updatedAt: Date | string;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			organization?: { __typename?: 'Organization'; id: string } | null;
		} | null;
	} | null;
	sharedWithContacts?: Array<{
		__typename?: 'Contact';
		id: string;
		vendor: {
			__typename?: 'Organization';
			id: string;
			updatedAt: Date | string;
			image?: string | null;
		};
	}> | null;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
};

export type CompanyFoldersTable_GetFolderContentsQueryVariables = Exact<{
	where: FolderWhereUniqueInput;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<FolderContentsOrderByInput>;
}>;

export type CompanyFoldersTable_GetFolderContentsQuery = {
	__typename?: 'Query';
	getFolderContents?: {
		__typename?: 'CustomFolder';
		id: string;
		_count: {
			__typename?: 'FolderCount';
			documents: number;
			childFolders: number;
		};
		childFolders?: Array<{
			__typename?: 'CustomFolder';
			id: string;
			name?: string | null;
			createdAt: Date | string;
			parentFolder?: {
				__typename?: 'CustomFolder';
				id: string;
				name?: string | null;
			} | null;
		} | null> | null;
		documents?: Array<{
			__typename?: 'Document';
			id: string;
			type: DocumentType;
			fileType: FileType;
			name: string;
			createdAt: Date | string;
			updatedAt: Date | string;
			ownerType: DocumentOwnerType;
			sharedWithCustomer: boolean;
			orgUser?: { __typename?: 'OrgUser'; id: string } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				updatedAt: Date | string;
				image?: string | null;
			} | null;
			customer?: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					firstNameOne: string;
					lastNameOne?: string | null;
					updatedAt: Date | string;
					plannerOrgHasDocumentsPermissions: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			sharedWithContacts?: Array<{
				__typename?: 'Contact';
				id: string;
				vendor: {
					__typename?: 'Organization';
					id: string;
					updatedAt: Date | string;
					image?: string | null;
				};
			}> | null;
			parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
		} | null> | null;
	} | null;
};

export type CompanyFoldersTable_RenameFolderMutationVariables = Exact<{
	data: UpdateFolderNameInput;
	where: FolderWhereUniqueInput;
}>;

export type CompanyFoldersTable_RenameFolderMutation = {
	__typename?: 'Mutation';
	renameFolder?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
	} | null;
};

export type CompanyFoldersTable_DeleteDocumentMutationVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type CompanyFoldersTable_DeleteDocumentMutation = {
	__typename?: 'Mutation';
	deleteDocument: boolean;
};

export type CompanyFoldersTable_DeleteFoldersMutationVariables = Exact<{
	where: FoldersWhereCustomInput;
}>;

export type CompanyFoldersTable_DeleteFoldersMutation = {
	__typename?: 'Mutation';
	deleteFolders: boolean;
};

export type ContactCustomerAvatarContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
};

export type ContactSnippetContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	eventDate?: Date | string | null;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			weddingDate?: Date | string | null;
		} | null;
	};
	vendor: { __typename?: 'Organization'; id: string };
};

type ContactSnippetInviteUser_InviteUserClientUser_Fragment = {
	__typename: 'InviteUserClientUser';
	id: string;
	firstNameOne: string;
	firstNameTwo?: string | null;
	lastNameOne: string;
	lastNameTwo?: string | null;
	weddingDate?: string | null;
	phone?: string | null;
	user: {
		__typename?: 'InviteUserUser';
		id: string;
		email: string;
		userType: UserType;
	};
};

type ContactSnippetInviteUser_InviteUserOrgUser_Fragment = {
	__typename: 'InviteUserOrgUser';
	id: string;
	firstName: string;
	lastName: string;
	phone?: string | null;
	user: {
		__typename?: 'InviteUserUser';
		id: string;
		email: string;
		userType: UserType;
	};
	organization: {
		__typename?: 'InviteUserOrganization';
		id: string;
		name: string;
		image?: string | null;
		updatedAt: string;
		services: Array<{
			__typename?: 'InviteUserOrganizationService';
			id: string;
			name: string;
		} | null>;
	};
};

export type ContactSnippetInviteUserFragment =
	| ContactSnippetInviteUser_InviteUserClientUser_Fragment
	| ContactSnippetInviteUser_InviteUserOrgUser_Fragment;

export type UseContactSnippet_GetContactsWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type UseContactSnippet_GetContactsWhereQuery = {
	__typename?: 'Query';
	getContactsWhere: {
		__typename?: 'Contacts';
		contacts: Array<{
			__typename?: 'Contact';
			id: string;
			status: ContactStatus;
			eventDate?: Date | string | null;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					weddingDate?: Date | string | null;
				} | null;
			};
			vendor: { __typename?: 'Organization'; id: string };
		}>;
	};
};

export type UseContactSnippet_CreateContactAsVendorMutationVariables = Exact<{
	data: CreateContactDataInput;
	where: UserByEmailUniqueInput;
}>;

export type UseContactSnippet_CreateContactAsVendorMutation = {
	__typename?: 'Mutation';
	createContactAsVendor: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		eventDate?: Date | string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				weddingDate?: Date | string | null;
			} | null;
		};
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type UseContactSnippet_CreateContactAsClientMutationVariables = Exact<{
	where: UserByIdUniqueInput;
	data: OrganizationWhereUniqueInput;
}>;

export type UseContactSnippet_CreateContactAsClientMutation = {
	__typename?: 'Mutation';
	createContactAsClient: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		eventDate?: Date | string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				weddingDate?: Date | string | null;
			} | null;
		};
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type UseContactSnippet_ActivateContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data?: InputMaybe<ActivateContactCustomInput>;
}>;

export type UseContactSnippet_ActivateContactMutation = {
	__typename?: 'Mutation';
	activateContact: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		eventDate?: Date | string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				weddingDate?: Date | string | null;
			} | null;
		};
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type UseContactSnippet_RequestContactActivationMutationVariables =
	Exact<{
		where: ContactWhereUniqueInput;
	}>;

export type UseContactSnippet_RequestContactActivationMutation = {
	__typename?: 'Mutation';
	requestContactActivation: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		eventDate?: Date | string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				weddingDate?: Date | string | null;
			} | null;
		};
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type ContractDetailContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	title?: string | null;
	filename?: string | null;
	status: ContractStatus;
	automatedRemindersEnabled: boolean;
	hsSignatureRequestId?: string | null;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	sentAt?: Date | string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	isPastDue?: boolean | null;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		helloSignID?: string | null;
		image?: string | null;
		name?: string | null;
		updatedAt: Date | string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			user?: {
				__typename?: 'BaseUserForGetContractWhere';
				id: string;
				email: string;
				userType: UserType;
			} | null;
			organization?: {
				__typename?: 'OrganizationForGetContractWhere';
				id: string;
			} | null;
		}> | null;
		services: Array<{
			__typename?: 'ServicesForGetContractWhere';
			name?: string | null;
			id?: string | null;
		} | null>;
	};
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
			email: string;
			orgUser?: {
				__typename?: 'OrgUserSignerForGetContractWhere';
				firstName: string;
				lastName: string;
				id: string;
			} | null;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			approved: boolean;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				status: ContactStatus;
				hasCustomerIntent: boolean;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
					userType: UserType;
					stripeCustomerId?: string | null;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						plannerOrgCanSignContracts: boolean;
						plannerOrgCanPayInvoices: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
										users?: Array<{
											__typename?: 'UsersForGetContractWhere';
											id: string;
											role: TeamMemberRole;
											user?: {
												__typename?: 'BaseUserForGetContractWhere';
												id: string;
											} | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
					guestUser?: {
						__typename?: 'GuestUserForGetContractWhere';
						id: string;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					name?: string | null;
					image?: string | null;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
						user?: {
							__typename?: 'BaseUserForGetContractWhere';
							id: string;
						} | null;
					}> | null;
					services: Array<{
						__typename?: 'ServicesForGetContractWhere';
						name?: string | null;
						id?: string | null;
					} | null>;
				};
				invoices?: Array<{
					__typename?: 'InvoiceForGetContractWhere';
					id: string;
					status: InvoiceStatus;
					title: string;
					guestToken?: string | null;
					paymentInstallments?: Array<{
						__typename?: 'PaymentInstallmentsForGetContractWhere';
						id: string;
						status?: InstallmentStatus | null;
						dueDate?: Date | string | null;
						amountDue?: number | null;
						paymentDate?: Date | string | null;
					}> | null;
				}> | null;
				customerSignatures?: Array<{
					__typename?: 'CustomerSignature';
					id: string;
					signature: {
						__typename?: 'Signature';
						id: string;
						signingDate?: Date | string | null;
						signer?: { __typename?: 'SignatureUser'; id: string } | null;
						contract?: {
							__typename?: 'SignatureContract';
							id: string;
							status: ContractStatus;
							dueDate: Date | string;
							title: string;
							guestToken?: string | null;
						} | null;
					};
				}> | null;
				proposals?: Array<{
					__typename?: 'Proposal';
					id: string;
					status: ProposalStatus;
					title?: string | null;
					guestToken?: string | null;
					dueDate?: Date | string | null;
				}> | null;
			};
		} | null;
	}>;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		id: string;
		vendorWillSign: boolean;
		title: string;
		sourceFileUrl?: string | null;
		countOfCustomerSigners: number;
	} | null;
	sentByUser?: {
		__typename?: 'OrgUserForGetContractWhere';
		id: string;
		organization?: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
		} | null;
	} | null;
};

export type ContractDetail_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ContractDetail_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			name: string;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				firstName: string;
				lastName: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				} | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		} | null;
	} | null;
};

export type ContractDetail_GetContractWhereQueryVariables = Exact<{
	where: ContractWhereInputWithMfaToken;
}>;

export type ContractDetail_GetContractWhereQuery = {
	__typename?: 'Query';
	getContractWhere: {
		__typename?: 'ResponseObjectForGetContractWhere';
		requestingUserBaseId?: string | null;
		requestingUserIsGuest?: boolean | null;
		contract: {
			__typename?: 'ContractForGetContractWhere';
			id: string;
			title?: string | null;
			filename?: string | null;
			status: ContractStatus;
			automatedRemindersEnabled: boolean;
			hsSignatureRequestId?: string | null;
			contractSourceFile?: string | null;
			unsignedContractFileUrl?: string | null;
			executedContractUrl?: string | null;
			sentAt?: Date | string | null;
			eventDate?: Date | string | null;
			dueDate?: Date | string | null;
			isPastDue?: boolean | null;
			vendor: {
				__typename?: 'OrganizationForGetContractWhere';
				id: string;
				helloSignID?: string | null;
				image?: string | null;
				name?: string | null;
				updatedAt: Date | string;
				users?: Array<{
					__typename?: 'UsersForGetContractWhere';
					id: string;
					role: TeamMemberRole;
					firstName: string;
					lastName: string;
					user?: {
						__typename?: 'BaseUserForGetContractWhere';
						id: string;
						email: string;
						userType: UserType;
					} | null;
					organization?: {
						__typename?: 'OrganizationForGetContractWhere';
						id: string;
					} | null;
				}> | null;
				services: Array<{
					__typename?: 'ServicesForGetContractWhere';
					name?: string | null;
					id?: string | null;
				} | null>;
			};
			emailNotificationGroup?: {
				__typename?: 'EmailNotificationGroup';
				id: string;
				groupTitle: EmailNotificationGroupTitle;
				members: Array<{
					__typename?: 'ReducedUser';
					id?: string | null;
					email: string;
					userType: UserType;
					orgUser?: {
						__typename?: 'ReducedOrgUser';
						id: string;
						firstName: string;
						lastName: string;
						role: TeamMemberRole;
						organization?: {
							__typename?: 'ReducedOrganization';
							id?: string | null;
						} | null;
					} | null;
				}>;
			} | null;
			signatures: Array<{
				__typename?: 'SignatureForGetContractWhere';
				id: string;
				type?: SignatureType | null;
				signingDate?: Date | string | null;
				signer?: {
					__typename?: 'SignatureUserForGetContractWhere';
					id: string;
					email: string;
					orgUser?: {
						__typename?: 'OrgUserSignerForGetContractWhere';
						firstName: string;
						lastName: string;
						id: string;
					} | null;
				} | null;
				customerSignature?: {
					__typename?: 'CustomerSignatureForGetContractWhere';
					id: string;
					approved: boolean;
					contact: {
						__typename?: 'ContactForGetContractWhere';
						id: string;
						firstName: string;
						lastName: string;
						companyName?: string | null;
						status: ContactStatus;
						hasCustomerIntent: boolean;
						customer: {
							__typename?: 'CustomerForGetContractWhere';
							id: string;
							email: string;
							userType: UserType;
							stripeCustomerId?: string | null;
							clientUser?: {
								__typename?: 'ClientUserForGetContractWhere';
								id: string;
								plannerOrgCanSignContracts: boolean;
								plannerOrgCanPayInvoices: boolean;
								assignedPlanner?: {
									__typename?: 'OrgUserForGetContractWhere';
									id: string;
									user: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									};
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
										users?: Array<{
											__typename?: 'UsersForGetContractWhere';
											id: string;
											role: TeamMemberRole;
											user?: {
												__typename?: 'BaseUserForGetContractWhere';
												id: string;
											} | null;
											organization?: {
												__typename?: 'OrganizationForGetContractWhere';
												id: string;
												users?: Array<{
													__typename?: 'UsersForGetContractWhere';
													id: string;
													role: TeamMemberRole;
													user?: {
														__typename?: 'BaseUserForGetContractWhere';
														id: string;
													} | null;
												}> | null;
											} | null;
										}> | null;
									} | null;
								} | null;
							} | null;
							guestUser?: {
								__typename?: 'GuestUserForGetContractWhere';
								id: string;
							} | null;
						};
						assignedMember: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
						};
						vendor: {
							__typename?: 'OrganizationForGetContractWhere';
							id: string;
							name?: string | null;
							image?: string | null;
							users?: Array<{
								__typename?: 'UsersForGetContractWhere';
								id: string;
								role: TeamMemberRole;
								user?: {
									__typename?: 'BaseUserForGetContractWhere';
									id: string;
								} | null;
							}> | null;
							services: Array<{
								__typename?: 'ServicesForGetContractWhere';
								name?: string | null;
								id?: string | null;
							} | null>;
						};
						invoices?: Array<{
							__typename?: 'InvoiceForGetContractWhere';
							id: string;
							status: InvoiceStatus;
							title: string;
							guestToken?: string | null;
							paymentInstallments?: Array<{
								__typename?: 'PaymentInstallmentsForGetContractWhere';
								id: string;
								status?: InstallmentStatus | null;
								dueDate?: Date | string | null;
								amountDue?: number | null;
								paymentDate?: Date | string | null;
							}> | null;
						}> | null;
						customerSignatures?: Array<{
							__typename?: 'CustomerSignature';
							id: string;
							signature: {
								__typename?: 'Signature';
								id: string;
								signingDate?: Date | string | null;
								signer?: { __typename?: 'SignatureUser'; id: string } | null;
								contract?: {
									__typename?: 'SignatureContract';
									id: string;
									status: ContractStatus;
									dueDate: Date | string;
									title: string;
									guestToken?: string | null;
								} | null;
							};
						}> | null;
						proposals?: Array<{
							__typename?: 'Proposal';
							id: string;
							status: ProposalStatus;
							title?: string | null;
							guestToken?: string | null;
							dueDate?: Date | string | null;
						}> | null;
					};
				} | null;
			}>;
			contractTemplate?: {
				__typename?: 'ContractTemplateForGetContractWhere';
				id: string;
				vendorWillSign: boolean;
				title: string;
				sourceFileUrl?: string | null;
				countOfCustomerSigners: number;
			} | null;
			sentByUser?: {
				__typename?: 'OrgUserForGetContractWhere';
				id: string;
				organization?: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
				} | null;
			} | null;
		};
	};
};

export type ContractDetail_GetOrganizationContractTemplateQueryVariables =
	Exact<{
		where: ContractTemplateWhereUniqueInput;
	}>;

export type ContractDetail_GetOrganizationContractTemplateQuery = {
	__typename?: 'Query';
	getOrganizationContractTemplate?: {
		__typename?: 'ContractTemplate';
		id: string;
		title?: string | null;
		countOfCustomerSigners?: number | null;
		vendorWillSign: boolean;
		sourceFileUrl?: string | null;
	} | null;
};

export type ContractEditButtonBarContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	automatedRemindersEnabled: boolean;
	dueDate?: Date | string | null;
	isPastDue?: boolean | null;
	contractSourceFile?: string | null;
	sentByUser?: {
		__typename?: 'OrgUserForGetContractWhere';
		id: string;
		organization?: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
		} | null;
	} | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
			};
		} | null;
	}>;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
	};
};

export type UseContractEditButtonBarPrepareButtonContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
};

export type UseContractEditButtonBarSaveButtonContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	isPastDue?: boolean | null;
	contractSourceFile?: string | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
				};
			};
		} | null;
	}>;
};

export type ContractEditDatesContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
};

export type ContractEditFileOrTemplateSelectorDisplayTextButtonContractFragment =
	{ __typename?: 'ContractForGetContractWhere'; status: ContractStatus };

export type ContractEditFileOrTemplateSelectorTemplateButtonContactTemplateFragment =
	{
		__typename?: 'ContractTemplate';
		id: string;
		title?: string | null;
		countOfCustomerSigners?: number | null;
		vendorWillSign: boolean;
	};

export type ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryVariables =
	Exact<{
		where?: InputMaybe<CustomContractTemplateWhereWithoutOrganizationInput>;
		orderBy?: InputMaybe<
			| Array<InputMaybe<ContractTemplateOrderByInput>>
			| InputMaybe<ContractTemplateOrderByInput>
		>;
	}>;

export type ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery =
	{
		__typename?: 'Query';
		getOrganizationContractTemplates: {
			__typename?: 'ContractTemplates';
			contractTemplates: Array<{
				__typename?: 'ContractTemplate';
				id: string;
				title?: string | null;
				countOfCustomerSigners?: number | null;
				vendorWillSign: boolean;
			}>;
		};
	};

export type ContractEditFileOrTemplateSelectorContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
};

export type ContractEditFileOrTemplateSelector_VoidAndPortContractMutationVariables =
	Exact<{
		where: ContractWhereUniqueInput;
	}>;

export type ContractEditFileOrTemplateSelector_VoidAndPortContractMutation = {
	__typename?: 'Mutation';
	voidAndPortContract: {
		__typename?: 'CustomContract';
		id: string;
		status?: ContractStatus | null;
	};
};

export type ContractEditPresentationContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	title?: string | null;
	status: ContractStatus;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		id: string;
		vendorWillSign: boolean;
		countOfCustomerSigners: number;
	} | null;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		image?: string | null;
		name?: string | null;
		updatedAt: Date | string;
	};
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				status: ContactStatus;
				firstName: string;
				lastName: string;
				hasCustomerIntent: boolean;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
			};
		} | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
	}>;
};

export type ContractEditPresentationContractTemplateFragment = {
	__typename?: 'ContractTemplate';
	id: string;
	countOfCustomerSigners?: number | null;
	vendorWillSign: boolean;
};

export type ContractEditSignaturesFieldsFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		id: string;
		countOfCustomerSigners: number;
		vendorWillSign: boolean;
	} | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				status: ContactStatus;
				firstName: string;
				lastName: string;
				hasCustomerIntent: boolean;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
			};
		} | null;
	}>;
};

export type BuildMuiFriendlyOptionsOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	users?: Array<{
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		firstName: string;
		lastName: string;
		user?: { __typename?: 'User'; id: string; email: string } | null;
	}> | null;
};

export type CounterSignerWidget_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type CounterSignerWidget_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			user?: { __typename?: 'User'; id: string; email: string } | null;
		}> | null;
	} | null;
};

export type CounterSignerWidgetContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
	}>;
};

export type ContractEditSettingsContractForGetContractWhereFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
};

export type ContractEditSourceFileContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		sourceFileUrl?: string | null;
	} | null;
};

export type ContractEdit_CreateContractMutationVariables = Exact<{
	data: ContractCreateCustomInput;
}>;

export type ContractEdit_CreateContractMutation = {
	__typename?: 'Mutation';
	createContract: { __typename?: 'CustomContract'; id: string };
};

export type ContractEditContractForGetContractWhereFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	title?: string | null;
	filename?: string | null;
	status: ContractStatus;
	automatedRemindersEnabled: boolean;
	hsSignatureRequestId?: string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	isPastDue?: boolean | null;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		id: string;
		vendorWillSign: boolean;
		title: string;
		countOfCustomerSigners: number;
		sourceFileUrl?: string | null;
	} | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				status: ContactStatus;
				firstName: string;
				lastName: string;
				hasCustomerIntent: boolean;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
			};
		} | null;
	}>;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		image?: string | null;
		name?: string | null;
		updatedAt: Date | string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
	};
	sentByUser?: {
		__typename?: 'OrgUserForGetContractWhere';
		id: string;
		organization?: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
		} | null;
	} | null;
};

export type ContractEdit_UpdateContractMutationVariables = Exact<{
	data: ContractUpdateInput;
	where: ContractWhereUniqueInput;
}>;

export type ContractEdit_UpdateContractMutation = {
	__typename?: 'Mutation';
	updateContract: {
		__typename?: 'ContractForGetContractWhere';
		id: string;
		title?: string | null;
		filename?: string | null;
		status: ContractStatus;
		automatedRemindersEnabled: boolean;
		hsSignatureRequestId?: string | null;
		eventDate?: Date | string | null;
		dueDate?: Date | string | null;
		contractSourceFile?: string | null;
		unsignedContractFileUrl?: string | null;
		executedContractUrl?: string | null;
		isPastDue?: boolean | null;
		contractTemplate?: {
			__typename?: 'ContractTemplateForGetContractWhere';
			id: string;
			vendorWillSign: boolean;
			title: string;
			countOfCustomerSigners: number;
			sourceFileUrl?: string | null;
		} | null;
		signatures: Array<{
			__typename?: 'SignatureForGetContractWhere';
			id: string;
			type?: SignatureType | null;
			signingDate?: Date | string | null;
			signer?: {
				__typename?: 'SignatureUserForGetContractWhere';
				id: string;
			} | null;
			customerSignature?: {
				__typename?: 'CustomerSignatureForGetContractWhere';
				id: string;
				contact: {
					__typename?: 'ContactForGetContractWhere';
					id: string;
					status: ContactStatus;
					firstName: string;
					lastName: string;
					hasCustomerIntent: boolean;
					companyName?: string | null;
					customer: {
						__typename?: 'CustomerForGetContractWhere';
						id: string;
						email: string;
					};
					vendor: {
						__typename?: 'OrganizationForGetContractWhere';
						id: string;
						users?: Array<{
							__typename?: 'UsersForGetContractWhere';
							id: string;
							role: TeamMemberRole;
						}> | null;
					};
					assignedMember: {
						__typename?: 'OrgUserForGetContractWhere';
						id: string;
						user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
					};
				};
			} | null;
		}>;
		vendor: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
			image?: string | null;
			name?: string | null;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'UsersForGetContractWhere';
				id: string;
				role: TeamMemberRole;
				user?: {
					__typename?: 'BaseUserForGetContractWhere';
					id: string;
				} | null;
			}> | null;
		};
		sentByUser?: {
			__typename?: 'OrgUserForGetContractWhere';
			id: string;
			organization?: {
				__typename?: 'OrganizationForGetContractWhere';
				id: string;
			} | null;
		} | null;
	};
};

export type ContractEdit_CreateContractMarkupUrlMutationVariables = Exact<{
	where: ContractWhereUniqueInput;
}>;

export type ContractEdit_CreateContractMarkupUrlMutation = {
	__typename?: 'Mutation';
	createContractMarkupUrl: { __typename?: 'MarkupUrl'; url: string };
};

export type ContractEdit_ReportContractMarkupMutationVariables = Exact<{
	data: ReportInput;
	where: ContractWhereUniqueInput;
}>;

export type ContractEdit_ReportContractMarkupMutation = {
	__typename?: 'Mutation';
	reportContractMarkup: {
		__typename?: 'ContractForGetContractWhere';
		id: string;
		title?: string | null;
		sentAt?: Date | string | null;
		status: ContractStatus;
		eventDate?: Date | string | null;
		dueDate?: Date | string | null;
		contractSourceFile?: string | null;
	};
};

export type ContractEdit_GetInvoicesForOrganizationQueryVariables = Exact<{
	where?: InputMaybe<InvoiceWhereInput>;
}>;

export type ContractEdit_GetInvoicesForOrganizationQuery = {
	__typename?: 'Query';
	getInvoicesForOrganization: { __typename?: 'Invoices'; _count: number };
};

export type ContractEdit_GetFeatureFlagsQueryVariables = Exact<{
	[key: string]: never;
}>;

export type ContractEdit_GetFeatureFlagsQuery = {
	__typename?: 'Query';
	getFeatureFlags: Array<{
		__typename?: 'ReducedFeatureFlag';
		category: FeatureCategory;
		active: boolean;
	}>;
};

export type ContractEdit_RequestContractFileImageUploadUrlQueryVariables =
	Exact<{
		data: RequestImageUploadUrlInput;
		where: ContractWhereUniqueInput;
	}>;

export type ContractEdit_RequestContractFileImageUploadUrlQuery = {
	__typename?: 'Query';
	requestContractFileImageUploadUrl: {
		__typename?: 'UploadUrl';
		uploadURL?: string | null;
	};
};

export type ContractTemplateEditButtonBarFragment = {
	__typename?: 'ContractTemplate';
	id: string;
	status: ContractTemplateStatus;
};

export type UseContractTemplateEditButtonBarDeleteButtonContractTemplateFragment =
	{
		__typename?: 'ContractTemplate';
		id: string;
		status: ContractTemplateStatus;
	};

export type UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationVariables =
	Exact<{
		where: ContractTemplateWhereUniqueInput;
	}>;

export type UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation =
	{
		__typename?: 'Mutation';
		deleteContractTemplate: {
			__typename?: 'ContractTemplate';
			id: string;
			status: ContractTemplateStatus;
		};
	};

export type ContractTemplateCountersignerFragment = {
	__typename?: 'ContractTemplate';
	vendorWillSign: boolean;
};

export type ContractTemplateEditPresentationContractTemplateFragment = {
	__typename?: 'ContractTemplate';
	status: ContractTemplateStatus;
	vendorWillSign: boolean;
};

export type ContractTemplateEditFragment = {
	__typename?: 'ContractTemplate';
	id: string;
	title?: string | null;
	countOfCustomerSigners?: number | null;
	vendorWillSign: boolean;
	status: ContractTemplateStatus;
	sourceFileUrl?: string | null;
};

export type ContractTemplateEdit_GetOrganizationContractTemplateQueryVariables =
	Exact<{
		where: ContractTemplateWhereUniqueInput;
	}>;

export type ContractTemplateEdit_GetOrganizationContractTemplateQuery = {
	__typename?: 'Query';
	getOrganizationContractTemplate?: {
		__typename?: 'ContractTemplate';
		id: string;
		status: ContractTemplateStatus;
		sourceFileUrl?: string | null;
		title?: string | null;
		countOfCustomerSigners?: number | null;
		vendorWillSign: boolean;
	} | null;
};

export type ContractTemplateEdit_CreateContractTemplateMutationMutationVariables =
	Exact<{
		data: ContractTemplateCreateInput;
	}>;

export type ContractTemplateEdit_CreateContractTemplateMutationMutation = {
	__typename?: 'Mutation';
	createContractTemplate: {
		__typename?: 'ContractTemplate';
		id: string;
		title?: string | null;
		countOfCustomerSigners?: number | null;
		vendorWillSign: boolean;
		status: ContractTemplateStatus;
		sourceFileUrl?: string | null;
	};
};

export type ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationVariables =
	Exact<{
		data: CreateContractTemplateMarkupUrlInput;
		where: ContractTemplateWhereUniqueInput;
	}>;

export type ContractTemplateEdit_CreateContractTemplateMarkupUrlMutation = {
	__typename?: 'Mutation';
	createContractTemplateMarkupUrl: string;
};

export type ContractTemplateEdit_ReportTemplateMarkupMutationVariables = Exact<{
	where: ContractTemplateWhereUniqueInput;
}>;

export type ContractTemplateEdit_ReportTemplateMarkupMutation = {
	__typename?: 'Mutation';
	reportTemplateMarkup: {
		__typename?: 'ContractTemplate';
		id: string;
		title?: string | null;
		countOfCustomerSigners?: number | null;
		vendorWillSign: boolean;
		status: ContractTemplateStatus;
		sourceFileUrl?: string | null;
	};
};

export type ContractTemplateEdit_UpdateContractTemplateMutationVariables =
	Exact<{
		data: ContractTemplateCustomUpdateInput;
		where: ContractTemplateWhereUniqueInput;
	}>;

export type ContractTemplateEdit_UpdateContractTemplateMutation = {
	__typename?: 'Mutation';
	updateContractTemplate: { __typename?: 'ContractTemplate'; id: string };
};

export type ContractTemplateEdit_GetFeatureFlagsQueryVariables = Exact<{
	[key: string]: never;
}>;

export type ContractTemplateEdit_GetFeatureFlagsQuery = {
	__typename?: 'Query';
	getFeatureFlags: Array<{
		__typename?: 'ReducedFeatureFlag';
		category: FeatureCategory;
		active: boolean;
	}>;
};

export type ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryVariables =
	Exact<{
		data: RequestImageUploadUrlInput;
		where: ContractTemplateWhereUniqueInput;
	}>;

export type ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery =
	{
		__typename?: 'Query';
		requestContractTemplateFileImageUploadUrl: {
			__typename?: 'UploadUrl';
			uploadURL?: string | null;
		};
	};

export type UseContractTemplateEditContractTemplateFragment = {
	__typename?: 'ContractTemplate';
	id: string;
	title?: string | null;
	countOfCustomerSigners?: number | null;
	vendorWillSign: boolean;
	status: ContractTemplateStatus;
	sourceFileUrl?: string | null;
};

export type ContractMfaGuestModalContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
			};
		} | null;
	}>;
};

export type ContractMfaGuestModal_CreateMfaTokenMutationVariables = Exact<{
	data: MfaTokenInput;
}>;

export type ContractMfaGuestModal_CreateMfaTokenMutation = {
	__typename?: 'Mutation';
	createMfaToken: boolean;
};

export type ContractViewButtonBarContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	dueDate?: Date | string | null;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	automatedRemindersEnabled: boolean;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		signingDate?: Date | string | null;
		type?: SignatureType | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			approved: boolean;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						plannerOrgCanSignContracts: boolean;
						plannerOrgCanPayInvoices: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				invoices?: Array<{
					__typename?: 'InvoiceForGetContractWhere';
					id: string;
					status: InvoiceStatus;
					title: string;
					guestToken?: string | null;
					paymentInstallments?: Array<{
						__typename?: 'PaymentInstallmentsForGetContractWhere';
						id: string;
						status?: InstallmentStatus | null;
						dueDate?: Date | string | null;
						amountDue?: number | null;
						paymentDate?: Date | string | null;
					}> | null;
				}> | null;
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					name?: string | null;
					image?: string | null;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
					services: Array<{
						__typename?: 'ServicesForGetContractWhere';
						name?: string | null;
						id?: string | null;
					} | null>;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
				customerSignatures?: Array<{
					__typename?: 'CustomerSignature';
					id: string;
					signature: {
						__typename?: 'Signature';
						id: string;
						signingDate?: Date | string | null;
						signer?: { __typename?: 'SignatureUser'; id: string } | null;
						contract?: {
							__typename?: 'SignatureContract';
							id: string;
							status: ContractStatus;
							dueDate: Date | string;
							title: string;
							guestToken?: string | null;
						} | null;
					};
				}> | null;
				proposals?: Array<{
					__typename?: 'Proposal';
					id: string;
					status: ProposalStatus;
					title?: string | null;
					guestToken?: string | null;
					dueDate?: Date | string | null;
				}> | null;
			};
		} | null;
	}>;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		id: string;
		sourceFileUrl?: string | null;
	} | null;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		helloSignID?: string | null;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
	};
	sentByUser?: {
		__typename?: 'OrgUserForGetContractWhere';
		id: string;
		organization?: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
		} | null;
	} | null;
};

export type ContractViewButtonBarBaseUserIdFragment = {
	__typename?: 'ResponseObjectForGetContractWhere';
	requestingUserBaseId?: string | null;
	requestingUserIsGuest?: boolean | null;
};

export type ContractViewButtonBarApproveButtonContractHelperFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			approved: boolean;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		} | null;
	}>;
	vendor: { __typename?: 'OrganizationForGetContractWhere'; id: string };
};

export type ContractViewButtonBarApproveButtonCustomContractHelperFragment = {
	__typename?: 'CustomContract';
	id: string;
	status?: ContractStatus | null;
	signatures: Array<{
		__typename?: 'Signature';
		id: string;
		signingDate?: Date | string | null;
		signer?: { __typename?: 'SignatureUser'; id: string } | null;
		customerSignature?: {
			__typename?: 'CustomerSignature';
			id: string;
			approved: boolean;
			contact: {
				__typename?: 'CustomerSignatureContact';
				id: string;
				customer: {
					__typename?: 'CustomerSignatureContactCustomer';
					id: string;
					clientUser?: {
						__typename?: 'CustomerSignatureContactCustomerClientUser';
						id: string;
						assignedPlanner?: {
							__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
							id: string;
							organization: {
								__typename?: 'CustomerSignatureContactOrganization';
								id: string;
								users?: Array<{
									__typename?: 'CustomerSignatureContactOrganizationUsers';
									id: string;
									role: TeamMemberRole;
									user: {
										__typename?: 'CustomerSignatureOrgUserUser';
										id: string;
									};
									organization: {
										__typename?: 'CustomerSignatureContactOrganization';
										id: string;
									};
								}> | null;
							};
						} | null;
					} | null;
				};
				assignedMember: { __typename?: 'CustomerSignatureOrgUser'; id: string };
				vendor: {
					__typename?: 'CustomerSignatureContactOrganization';
					id: string;
					users?: Array<{
						__typename?: 'CustomerSignatureContactOrganizationUsers';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		} | null;
	}>;
	vendor: { __typename?: 'Organization'; id: string };
};

export type ContractViewButtonBarApproveButtonContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			approved: boolean;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		} | null;
	}>;
	vendor: { __typename?: 'OrganizationForGetContractWhere'; id: string };
};

export type UseContractViewButtonBarApproveButton_ApproveContractMutationVariables =
	Exact<{
		where: ContractWhereUniqueInput;
	}>;

export type UseContractViewButtonBarApproveButton_ApproveContractMutation = {
	__typename?: 'Mutation';
	approveContract: {
		__typename?: 'CustomContract';
		id: string;
		status?: ContractStatus | null;
		signatures: Array<{
			__typename?: 'Signature';
			id: string;
			signingDate?: Date | string | null;
			signer?: { __typename?: 'SignatureUser'; id: string } | null;
			customerSignature?: {
				__typename?: 'CustomerSignature';
				id: string;
				approved: boolean;
				contact: {
					__typename?: 'CustomerSignatureContact';
					id: string;
					customer: {
						__typename?: 'CustomerSignatureContactCustomer';
						id: string;
						clientUser?: {
							__typename?: 'CustomerSignatureContactCustomerClientUser';
							id: string;
							assignedPlanner?: {
								__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
								id: string;
								organization: {
									__typename?: 'CustomerSignatureContactOrganization';
									id: string;
									users?: Array<{
										__typename?: 'CustomerSignatureContactOrganizationUsers';
										id: string;
										role: TeamMemberRole;
										user: {
											__typename?: 'CustomerSignatureOrgUserUser';
											id: string;
										};
										organization: {
											__typename?: 'CustomerSignatureContactOrganization';
											id: string;
										};
									}> | null;
								};
							} | null;
						} | null;
					};
					assignedMember: {
						__typename?: 'CustomerSignatureOrgUser';
						id: string;
					};
					vendor: {
						__typename?: 'CustomerSignatureContactOrganization';
						id: string;
						users?: Array<{
							__typename?: 'CustomerSignatureContactOrganizationUsers';
							id: string;
							role: TeamMemberRole;
						}> | null;
					};
				};
			} | null;
		}>;
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type ContractViewButtonBarExportButtonContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	dueDate?: Date | string | null;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		signingDate?: Date | string | null;
	}>;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		id: string;
		sourceFileUrl?: string | null;
	} | null;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
	};
};

export type ContractViewButtonBarExportButtonRequestingUserBaseIdFragment = {
	__typename?: 'ResponseObjectForGetContractWhere';
	requestingUserBaseId?: string | null;
};

export type ContractViewButtonBar_GetContractWhereQueryVariables = Exact<{
	where: ContractWhereInputWithMfaToken;
}>;

export type ContractViewButtonBar_GetContractWhereQuery = {
	__typename?: 'Query';
	getContractWhere: {
		__typename?: 'ResponseObjectForGetContractWhere';
		contract: {
			__typename?: 'ContractForGetContractWhere';
			id: string;
			dueDate?: Date | string | null;
			contractSourceFile?: string | null;
			unsignedContractFileUrl?: string | null;
			executedContractUrl?: string | null;
			signatures: Array<{
				__typename?: 'SignatureForGetContractWhere';
				signingDate?: Date | string | null;
			}>;
			contractTemplate?: {
				__typename?: 'ContractTemplateForGetContractWhere';
				id: string;
				sourceFileUrl?: string | null;
			} | null;
			vendor: {
				__typename?: 'OrganizationForGetContractWhere';
				id: string;
				users?: Array<{
					__typename?: 'UsersForGetContractWhere';
					id: string;
					role: TeamMemberRole;
					user?: {
						__typename?: 'BaseUserForGetContractWhere';
						id: string;
					} | null;
				}> | null;
			};
		};
	};
};

export type AssignedPlannerSignsAsModalSignatureFragment = {
	__typename?: 'SignatureForGetContractWhere';
	id: string;
	signingDate?: Date | string | null;
	signer?: {
		__typename?: 'SignatureUserForGetContractWhere';
		id: string;
	} | null;
	customerSignature?: {
		__typename?: 'CustomerSignatureForGetContractWhere';
		id: string;
		contact: {
			__typename?: 'ContactForGetContractWhere';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'CustomerForGetContractWhere';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUserForGetContractWhere';
					id: string;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUserForGetContractWhere';
						id: string;
						organization?: {
							__typename?: 'OrganizationForGetContractWhere';
							id: string;
						} | null;
					} | null;
				} | null;
			};
		};
	} | null;
};

export type AssignedPlannerSignsAsModalSignatureSignatureFragment = {
	__typename?: 'SignatureForGetContractWhere';
	id: string;
	signingDate?: Date | string | null;
	signer?: {
		__typename?: 'SignatureUserForGetContractWhere';
		id: string;
	} | null;
	customerSignature?: {
		__typename?: 'CustomerSignatureForGetContractWhere';
		id: string;
		contact: {
			__typename?: 'ContactForGetContractWhere';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'CustomerForGetContractWhere';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUserForGetContractWhere';
					id: string;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUserForGetContractWhere';
						id: string;
						organization?: {
							__typename?: 'OrganizationForGetContractWhere';
							id: string;
						} | null;
					} | null;
				} | null;
			};
		};
	} | null;
};

export type AssignedPlannerSignsAsModalSignaturesSignatureFragment = {
	__typename?: 'SignatureForGetContractWhere';
	id: string;
	signingDate?: Date | string | null;
	signer?: {
		__typename?: 'SignatureUserForGetContractWhere';
		id: string;
	} | null;
	customerSignature?: {
		__typename?: 'CustomerSignatureForGetContractWhere';
		id: string;
		contact: {
			__typename?: 'ContactForGetContractWhere';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'CustomerForGetContractWhere';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUserForGetContractWhere';
					id: string;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUserForGetContractWhere';
						id: string;
						organization?: {
							__typename?: 'OrganizationForGetContractWhere';
							id: string;
						} | null;
					} | null;
				} | null;
			};
		};
	} | null;
};

export type ContractViewButtonBarViewAndSignButtonCustomContractCanSignFragment =
	{
		__typename?: 'CustomContract';
		id: string;
		status?: ContractStatus | null;
		signatures: Array<{
			__typename?: 'Signature';
			id: string;
			type?: SignatureType | null;
			signingDate?: Date | string | null;
			signer?: { __typename?: 'SignatureUser'; id: string } | null;
			customerSignature?: {
				__typename?: 'CustomerSignature';
				id: string;
				contact: {
					__typename?: 'CustomerSignatureContact';
					id: string;
					customer: {
						__typename?: 'CustomerSignatureContactCustomer';
						id: string;
						email: string;
						clientUser?: {
							__typename?: 'CustomerSignatureContactCustomerClientUser';
							id: string;
							plannerOrgCanSignContracts: boolean;
							assignedPlanner?: {
								__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
								id: string;
								organization: {
									__typename?: 'CustomerSignatureContactOrganization';
									id: string;
									users?: Array<{
										__typename?: 'CustomerSignatureContactOrganizationUsers';
										id: string;
										role: TeamMemberRole;
										user: {
											__typename?: 'CustomerSignatureOrgUserUser';
											id: string;
										};
									}> | null;
								};
							} | null;
						} | null;
					};
					vendor: {
						__typename?: 'CustomerSignatureContactOrganization';
						id: string;
						users?: Array<{
							__typename?: 'CustomerSignatureContactOrganizationUsers';
							id: string;
							role: TeamMemberRole;
						}> | null;
					};
					assignedMember: {
						__typename?: 'CustomerSignatureOrgUser';
						id: string;
					};
				};
			} | null;
		}>;
		vendor: { __typename?: 'Organization'; id: string };
	};

export type ContractViewButtonBarViewAndSignButtonContractCanSignFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
				};
			};
		} | null;
	}>;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		helloSignID?: string | null;
	};
};

export type ContractViewButtonBarViewAndSignButtonContractGetSignaturesForAssignedPlannerFragment =
	{
		__typename?: 'ContractForGetContractWhere';
		signatures: Array<{
			__typename?: 'SignatureForGetContractWhere';
			id: string;
			signingDate?: Date | string | null;
			signer?: {
				__typename?: 'SignatureUserForGetContractWhere';
				id: string;
			} | null;
			customerSignature?: {
				__typename?: 'CustomerSignatureForGetContractWhere';
				id: string;
				contact: {
					__typename?: 'ContactForGetContractWhere';
					id: string;
					firstName: string;
					lastName: string;
					customer: {
						__typename?: 'CustomerForGetContractWhere';
						id: string;
						email: string;
						clientUser?: {
							__typename?: 'ClientUserForGetContractWhere';
							id: string;
							plannerOrgCanSignContracts: boolean;
							assignedPlanner?: {
								__typename?: 'OrgUserForGetContractWhere';
								id: string;
								organization?: {
									__typename?: 'OrganizationForGetContractWhere';
									id: string;
								} | null;
							} | null;
						} | null;
					};
				};
			} | null;
		}>;
	};

export type ContractViewButtonBarViewAndSignButtonContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	dueDate?: Date | string | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		signingDate?: Date | string | null;
		type?: SignatureType | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						plannerOrgCanSignContracts: boolean;
						plannerOrgCanPayInvoices: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				invoices?: Array<{
					__typename?: 'InvoiceForGetContractWhere';
					id: string;
					status: InvoiceStatus;
					title: string;
					guestToken?: string | null;
					paymentInstallments?: Array<{
						__typename?: 'PaymentInstallmentsForGetContractWhere';
						id: string;
						status?: InstallmentStatus | null;
						dueDate?: Date | string | null;
						amountDue?: number | null;
						paymentDate?: Date | string | null;
					}> | null;
				}> | null;
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					name?: string | null;
					image?: string | null;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
					services: Array<{
						__typename?: 'ServicesForGetContractWhere';
						name?: string | null;
						id?: string | null;
					} | null>;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
				};
				customerSignatures?: Array<{
					__typename?: 'CustomerSignature';
					id: string;
					signature: {
						__typename?: 'Signature';
						id: string;
						signingDate?: Date | string | null;
						signer?: { __typename?: 'SignatureUser'; id: string } | null;
						contract?: {
							__typename?: 'SignatureContract';
							id: string;
							status: ContractStatus;
							dueDate: Date | string;
							title: string;
							guestToken?: string | null;
						} | null;
					};
				}> | null;
				proposals?: Array<{
					__typename?: 'Proposal';
					id: string;
					status: ProposalStatus;
					title?: string | null;
					guestToken?: string | null;
					dueDate?: Date | string | null;
				}> | null;
			};
		} | null;
	}>;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		helloSignID?: string | null;
	};
};

export type ContractViewButtonBarViewAndSignButtonRequestingUserBaseIdFragment =
	{
		__typename?: 'ResponseObjectForGetContractWhere';
		requestingUserBaseId?: string | null;
		requestingUserIsGuest?: boolean | null;
	};

export type UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationVariables =
	Exact<{
		where: CreateContractSigningUrlInput;
	}>;

export type UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation =
	{
		__typename?: 'Mutation';
		createContractSigningUrl: { __typename?: 'SigningUrl'; url: string };
	};

export type UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationVariables =
	Exact<{
		data: ReportContractSigningInput;
		where: ContractWhereInputWithMfaToken;
	}>;

export type UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation =
	{
		__typename?: 'Mutation';
		reportContractSigning: {
			__typename?: 'ContractForGetContractWhere';
			id: string;
			status: ContractStatus;
			signatures: Array<{
				__typename?: 'SignatureForGetContractWhere';
				id: string;
				type?: SignatureType | null;
				signingDate?: Date | string | null;
				signer?: {
					__typename?: 'SignatureUserForGetContractWhere';
					id: string;
				} | null;
				customerSignature?: {
					__typename?: 'CustomerSignatureForGetContractWhere';
					id: string;
					contact: {
						__typename?: 'ContactForGetContractWhere';
						id: string;
						customer: {
							__typename?: 'CustomerForGetContractWhere';
							id: string;
							email: string;
							clientUser?: {
								__typename?: 'ClientUserForGetContractWhere';
								id: string;
								plannerOrgCanSignContracts: boolean;
								assignedPlanner?: {
									__typename?: 'OrgUserForGetContractWhere';
									id: string;
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
										users?: Array<{
											__typename?: 'UsersForGetContractWhere';
											id: string;
											role: TeamMemberRole;
											user?: {
												__typename?: 'BaseUserForGetContractWhere';
												id: string;
											} | null;
										}> | null;
									} | null;
								} | null;
							} | null;
						};
						vendor: {
							__typename?: 'OrganizationForGetContractWhere';
							id: string;
							users?: Array<{
								__typename?: 'UsersForGetContractWhere';
								id: string;
								role: TeamMemberRole;
							}> | null;
						};
						assignedMember: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
						};
					};
				} | null;
			}>;
			vendor: {
				__typename?: 'OrganizationForGetContractWhere';
				id: string;
				helloSignID?: string | null;
			};
		};
	};

export type ContractViewPresentationContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	title?: string | null;
	status: ContractStatus;
	sentAt?: Date | string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	isPastDue?: boolean | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						plannerOrgCanSignContracts: boolean;
						plannerOrgCanPayInvoices: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
										users?: Array<{
											__typename?: 'UsersForGetContractWhere';
											id: string;
											role: TeamMemberRole;
											user?: {
												__typename?: 'BaseUserForGetContractWhere';
												id: string;
											} | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
						user?: {
							__typename?: 'BaseUserForGetContractWhere';
							id: string;
						} | null;
					}> | null;
				};
			};
		} | null;
	}>;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		image?: string | null;
		name?: string | null;
		updatedAt: Date | string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
	};
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type ContractViewPresentationOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	image?: string | null;
	name: string;
	updatedAt: Date | string;
};

export type ContractViewSignersAndCounterBaseUserFragment = {
	__typename?: 'ResponseObjectForGetContractWhere';
	requestingUserBaseId?: string | null;
};

export type ContractViewSignersAndCounterSignersFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			email: string;
			id: string;
			orgUser?: {
				__typename?: 'OrgUserSignerForGetContractWhere';
				firstName: string;
				lastName: string;
				id: string;
			} | null;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
			};
		} | null;
	}>;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
	};
};

export type ContractViewSourceFileContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	status: ContractStatus;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	id: string;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		sourceFileUrl?: string | null;
	} | null;
};

export type ContractViewContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	id: string;
	customer: {
		__typename?: 'CustomerForGetContractWhere';
		id: string;
		email: string;
		userType: UserType;
		stripeCustomerId?: string | null;
		clientUser?: {
			__typename?: 'ClientUserForGetContractWhere';
			id: string;
			assignedPlanner?: {
				__typename?: 'OrgUserForGetContractWhere';
				id: string;
				organization?: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				} | null;
			} | null;
		} | null;
		guestUser?: {
			__typename?: 'GuestUserForGetContractWhere';
			id: string;
		} | null;
	};
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type ContractViewContractForGetContractWhereFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	title?: string | null;
	sentAt?: Date | string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	isPastDue?: boolean | null;
	automatedRemindersEnabled: boolean;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		signer?: {
			__typename?: 'SignatureUserForGetContractWhere';
			id: string;
			email: string;
			orgUser?: {
				__typename?: 'OrgUserSignerForGetContractWhere';
				firstName: string;
				lastName: string;
				id: string;
			} | null;
		} | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			approved: boolean;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
					userType: UserType;
					stripeCustomerId?: string | null;
					clientUser?: {
						__typename?: 'ClientUserForGetContractWhere';
						id: string;
						plannerOrgCanSignContracts: boolean;
						plannerOrgCanPayInvoices: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUserForGetContractWhere';
							id: string;
							user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
							organization?: {
								__typename?: 'OrganizationForGetContractWhere';
								id: string;
								users?: Array<{
									__typename?: 'UsersForGetContractWhere';
									id: string;
									role: TeamMemberRole;
									user?: {
										__typename?: 'BaseUserForGetContractWhere';
										id: string;
									} | null;
									organization?: {
										__typename?: 'OrganizationForGetContractWhere';
										id: string;
										users?: Array<{
											__typename?: 'UsersForGetContractWhere';
											id: string;
											role: TeamMemberRole;
											user?: {
												__typename?: 'BaseUserForGetContractWhere';
												id: string;
											} | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
					guestUser?: {
						__typename?: 'GuestUserForGetContractWhere';
						id: string;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					name?: string | null;
					image?: string | null;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
						user?: {
							__typename?: 'BaseUserForGetContractWhere';
							id: string;
						} | null;
					}> | null;
					services: Array<{
						__typename?: 'ServicesForGetContractWhere';
						name?: string | null;
						id?: string | null;
					} | null>;
				};
				invoices?: Array<{
					__typename?: 'InvoiceForGetContractWhere';
					id: string;
					status: InvoiceStatus;
					title: string;
					guestToken?: string | null;
					paymentInstallments?: Array<{
						__typename?: 'PaymentInstallmentsForGetContractWhere';
						id: string;
						status?: InstallmentStatus | null;
						dueDate?: Date | string | null;
						amountDue?: number | null;
						paymentDate?: Date | string | null;
					}> | null;
				}> | null;
				customerSignatures?: Array<{
					__typename?: 'CustomerSignature';
					id: string;
					signature: {
						__typename?: 'Signature';
						id: string;
						signingDate?: Date | string | null;
						signer?: { __typename?: 'SignatureUser'; id: string } | null;
						contract?: {
							__typename?: 'SignatureContract';
							id: string;
							status: ContractStatus;
							dueDate: Date | string;
							title: string;
							guestToken?: string | null;
						} | null;
					};
				}> | null;
				proposals?: Array<{
					__typename?: 'Proposal';
					id: string;
					status: ProposalStatus;
					title?: string | null;
					guestToken?: string | null;
					dueDate?: Date | string | null;
				}> | null;
			};
		} | null;
	}>;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		helloSignID?: string | null;
		image?: string | null;
		name?: string | null;
		updatedAt: Date | string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
		services: Array<{
			__typename?: 'ServicesForGetContractWhere';
			name?: string | null;
			id?: string | null;
		} | null>;
	};
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		sourceFileUrl?: string | null;
		id: string;
	} | null;
	sentByUser?: {
		__typename?: 'OrgUserForGetContractWhere';
		id: string;
		organization?: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
		} | null;
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type ContractViewBaseUserIdFragment = {
	__typename?: 'ResponseObjectForGetContractWhere';
	requestingUserBaseId?: string | null;
	requestingUserIsGuest?: boolean | null;
};

export type ContractViewOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	image?: string | null;
	name: string;
	updatedAt: Date | string;
};

export type UseContractContactsCompareForDiffContractViewContractForGetContractWhereFragment =
	{
		__typename?: 'ContractForGetContractWhere';
		id: string;
		signatures: Array<{
			__typename?: 'SignatureForGetContractWhere';
			id: string;
			type?: SignatureType | null;
			customerSignature?: {
				__typename?: 'CustomerSignatureForGetContractWhere';
				contact: {
					__typename?: 'ContactForGetContractWhere';
					id: string;
					firstName: string;
					lastName: string;
					companyName?: string | null;
					customer: {
						__typename?: 'CustomerForGetContractWhere';
						id: string;
						email: string;
					};
				};
			} | null;
		}>;
	};

export type UseContractMetrics_GetDashboardStatsForOrgQueryVariables = Exact<{
	where: DashboardWhereInput;
}>;

export type UseContractMetrics_GetDashboardStatsForOrgQuery = {
	__typename?: 'Query';
	getDashboardStatsForOrg?: {
		__typename?: 'OrgDashboardStats';
		contractsSummary: {
			__typename?: 'ContractsSummary';
			totalContractsAwaitingSignature: string;
			totalContractsSigned: string;
			totalContractsOverdue: string;
		};
	} | null;
};

export type ContractSubMenuFragment = {
	__typename?: 'CustomContract';
	id: string;
	status?: ContractStatus | null;
	automatedRemindersEnabled: boolean;
	vendor: { __typename?: 'Organization'; id: string };
	signatures: Array<{
		__typename?: 'Signature';
		id: string;
		signingDate?: Date | string | null;
		type?: SignatureType | null;
		signer?: { __typename?: 'SignatureUser'; id: string } | null;
		customerSignature?: {
			__typename?: 'CustomerSignature';
			id: string;
			contact: {
				__typename?: 'CustomerSignatureContact';
				id: string;
				assignedMember: {
					__typename?: 'CustomerSignatureOrgUser';
					id: string;
					organization: {
						__typename?: 'CustomerSignatureContactOrganization';
						id: string;
					};
				};
				vendor: {
					__typename?: 'CustomerSignatureContactOrganization';
					id: string;
					users?: Array<{
						__typename?: 'CustomerSignatureContactOrganizationUsers';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
				customer: {
					__typename?: 'CustomerSignatureContactCustomer';
					id: string;
					clientUser?: {
						__typename?: 'CustomerSignatureContactCustomerClientUser';
						id: string;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
							id: string;
						} | null;
					} | null;
				};
			};
		} | null;
	}>;
};

export type ContractsTableFragment = {
	__typename?: 'CustomContract';
	id: string;
	title?: string | null;
	createdAt: Date | string;
	updatedAt: Date | string;
	sentAt?: Date | string | null;
	dueDate?: Date | string | null;
	status?: ContractStatus | null;
	isPastDue?: boolean | null;
	eventDate?: Date | string | null;
	automatedRemindersEnabled: boolean;
	signatures: Array<{
		__typename?: 'Signature';
		id: string;
		signingDate?: Date | string | null;
		type?: SignatureType | null;
		customerSignature?: {
			__typename?: 'CustomerSignature';
			id: string;
			contact: {
				__typename?: 'CustomerSignatureContact';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerSignatureContactCustomer';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'CustomerSignatureContactCustomerClientUser';
						id: string;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
							id: string;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'CustomerSignatureOrgUser';
					id: string;
					organization: {
						__typename?: 'CustomerSignatureContactOrganization';
						id: string;
					};
				};
				vendor: {
					__typename?: 'CustomerSignatureContactOrganization';
					id: string;
					users?: Array<{
						__typename?: 'CustomerSignatureContactOrganizationUsers';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		} | null;
		signer?: { __typename?: 'SignatureUser'; id: string } | null;
	}>;
	sentByUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
		user?: { __typename?: 'User'; id: string } | null;
	} | null;
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		updatedAt: Date | string;
	};
};

export type UseContractsTable_GetContractsForVendorQueryVariables = Exact<{
	where: ContractsForVendorInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<ContractOrderByInput>> | InputMaybe<ContractOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UseContractsTable_GetContractsForVendorQuery = {
	__typename?: 'Query';
	getContractsForVendor: {
		__typename?: 'ContractsForVendor';
		_count: number;
		contracts: Array<{
			__typename?: 'CustomContract';
			id: string;
			title?: string | null;
			createdAt: Date | string;
			updatedAt: Date | string;
			sentAt?: Date | string | null;
			dueDate?: Date | string | null;
			status?: ContractStatus | null;
			isPastDue?: boolean | null;
			eventDate?: Date | string | null;
			automatedRemindersEnabled: boolean;
			signatures: Array<{
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				type?: SignatureType | null;
				customerSignature?: {
					__typename?: 'CustomerSignature';
					id: string;
					contact: {
						__typename?: 'CustomerSignatureContact';
						id: string;
						firstName: string;
						lastName: string;
						companyName?: string | null;
						customer: {
							__typename?: 'CustomerSignatureContactCustomer';
							id: string;
							email: string;
							clientUser?: {
								__typename?: 'CustomerSignatureContactCustomerClientUser';
								id: string;
								plannerOrgCanSignContracts: boolean;
								assignedPlanner?: {
									__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
									id: string;
								} | null;
							} | null;
						};
						assignedMember: {
							__typename?: 'CustomerSignatureOrgUser';
							id: string;
							organization: {
								__typename?: 'CustomerSignatureContactOrganization';
								id: string;
							};
						};
						vendor: {
							__typename?: 'CustomerSignatureContactOrganization';
							id: string;
							users?: Array<{
								__typename?: 'CustomerSignatureContactOrganizationUsers';
								id: string;
								role: TeamMemberRole;
							}> | null;
						};
					};
				} | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
			}>;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
				} | null;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				image?: string | null;
				updatedAt: Date | string;
			};
		}>;
	};
};

export type UseContractsTable_GetContractsForCustomerQueryVariables = Exact<{
	where: ContractsForCustomerInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<ContractOrderByInput>> | InputMaybe<ContractOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UseContractsTable_GetContractsForCustomerQuery = {
	__typename?: 'Query';
	getContractsForCustomer: {
		__typename?: 'ContractsForCustomer';
		_count: number;
		contracts: Array<{
			__typename?: 'CustomContract';
			id: string;
			title?: string | null;
			createdAt: Date | string;
			updatedAt: Date | string;
			sentAt?: Date | string | null;
			dueDate?: Date | string | null;
			status?: ContractStatus | null;
			isPastDue?: boolean | null;
			eventDate?: Date | string | null;
			automatedRemindersEnabled: boolean;
			signatures: Array<{
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				type?: SignatureType | null;
				customerSignature?: {
					__typename?: 'CustomerSignature';
					id: string;
					contact: {
						__typename?: 'CustomerSignatureContact';
						id: string;
						firstName: string;
						lastName: string;
						companyName?: string | null;
						customer: {
							__typename?: 'CustomerSignatureContactCustomer';
							id: string;
							email: string;
							clientUser?: {
								__typename?: 'CustomerSignatureContactCustomerClientUser';
								id: string;
								plannerOrgCanSignContracts: boolean;
								assignedPlanner?: {
									__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
									id: string;
								} | null;
							} | null;
						};
						assignedMember: {
							__typename?: 'CustomerSignatureOrgUser';
							id: string;
							organization: {
								__typename?: 'CustomerSignatureContactOrganization';
								id: string;
							};
						};
						vendor: {
							__typename?: 'CustomerSignatureContactOrganization';
							id: string;
							users?: Array<{
								__typename?: 'CustomerSignatureContactOrganizationUsers';
								id: string;
								role: TeamMemberRole;
							}> | null;
						};
					};
				} | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
			}>;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
				} | null;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				image?: string | null;
				updatedAt: Date | string;
			};
		}>;
	};
};

export type UseContractsTable_ResendContractMutationVariables = Exact<{
	where: ContractWhereUniqueInput;
}>;

export type UseContractsTable_ResendContractMutation = {
	__typename?: 'Mutation';
	resendContract: boolean;
};

export type ContractTemplatesTableFragment = {
	__typename?: 'ContractTemplate';
	id: string;
	createdAt: Date | string;
	title?: string | null;
	status: ContractTemplateStatus;
	sourceFileUrl?: string | null;
	contracts?: Array<{ __typename?: 'CustomContract'; id: string }> | null;
};

export type UseContractsTable_GetOrganizationContractTemplatesQueryVariables =
	Exact<{
		skip?: InputMaybe<Scalars['Int']['input']>;
		take?: InputMaybe<Scalars['Int']['input']>;
		where?: InputMaybe<CustomContractTemplateWhereWithoutOrganizationInput>;
		orderBy?: InputMaybe<
			| Array<InputMaybe<ContractTemplateOrderByInput>>
			| InputMaybe<ContractTemplateOrderByInput>
		>;
	}>;

export type UseContractsTable_GetOrganizationContractTemplatesQuery = {
	__typename?: 'Query';
	getOrganizationContractTemplates: {
		__typename?: 'ContractTemplates';
		_count: number;
		contractTemplates: Array<{
			__typename?: 'ContractTemplate';
			id: string;
			createdAt: Date | string;
			title?: string | null;
			status: ContractTemplateStatus;
			sourceFileUrl?: string | null;
			contracts?: Array<{ __typename?: 'CustomContract'; id: string }> | null;
		}>;
	};
};

export type UseContractsTable_DeleteContractTemplateMutationVariables = Exact<{
	where: ContractTemplateWhereUniqueInput;
}>;

export type UseContractsTable_DeleteContractTemplateMutation = {
	__typename?: 'Mutation';
	deleteContractTemplate: { __typename?: 'ContractTemplate'; id: string };
};

export type UseContractsTable_DuplicateContractTemplateMutationVariables =
	Exact<{
		where: ContractTemplateWhereUniqueInput;
	}>;

export type UseContractsTable_DuplicateContractTemplateMutation = {
	__typename?: 'Mutation';
	duplicateContractTemplate: { __typename?: 'ContractTemplate'; id: string };
};

export type CreateBundleModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	eventDate?: Date | string | null;
	note?: string | null;
	companyName?: string | null;
	source?: string | null;
	venue?: string | null;
	phone?: string | null;
	customer: { __typename?: 'User'; id: string; email: string };
};

export type CreateBundleModal_CreateContactAsVendorMutationVariables = Exact<{
	data: CreateContactDataInput;
	where: UserByEmailUniqueInput;
}>;

export type CreateBundleModal_CreateContactAsVendorMutation = {
	__typename?: 'Mutation';
	createContactAsVendor: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		eventDate?: Date | string | null;
		note?: string | null;
		companyName?: string | null;
		source?: string | null;
		venue?: string | null;
		phone?: string | null;
		customer: { __typename?: 'User'; id: string; email: string };
	};
};

export type CreateBundleModal_UpdateContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data: CustomContactUpdateInput;
}>;

export type CreateBundleModal_UpdateContactMutation = {
	__typename?: 'Mutation';
	updateContact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		eventDate?: Date | string | null;
		note?: string | null;
		companyName?: string | null;
		source?: string | null;
		venue?: string | null;
		phone?: string | null;
		customer: { __typename?: 'User'; id: string; email: string };
	};
};

export type CreateBundleModalContactContactOnlyContactFragment = {
	__typename?: 'Contact';
	id: string;
	venue?: string | null;
	phone?: string | null;
};

export type CreateFolderModalCustomFolderFragment = {
	__typename?: 'CustomFolder';
	id: string;
	name?: string | null;
	parentFolder?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
	} | null;
};

export type CreateFolderModal_CreateFolderMutationVariables = Exact<{
	data: FolderCreateCustomInput;
}>;

export type CreateFolderModal_CreateFolderMutation = {
	__typename?: 'Mutation';
	createFolder?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
		parentFolder?: {
			__typename?: 'CustomFolder';
			id: string;
			name?: string | null;
		} | null;
	} | null;
};

export type CustomerFolderDocumentsTableContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			updatedAt: Date | string;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		updatedAt: Date | string;
		name: string;
	};
};

export type CustomerFolderDocumentsTable_GetContactWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type CustomerFolderDocumentsTable_GetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	} | null;
};

export type UseCustomerFolderDocumentsTableContactFragment = {
	__typename?: 'Contact';
	id: string;
	customer: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	};
	vendor: { __typename?: 'Organization'; id: string };
};

export type UseCustomerFolderDocumentsTable_DocumentFragment = {
	__typename?: 'Document';
	id: string;
	fileType: FileType;
	fileSource: FileSourceType;
	name: string;
	updatedAt: Date | string;
	ownerType: DocumentOwnerType;
	exportable: boolean;
	sharedWithCustomer: boolean;
	type: DocumentType;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		updatedAt: Date | string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; id: string }>;
	} | null;
	customer?: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			updatedAt: Date | string;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			organization?: { __typename?: 'Organization'; id: string } | null;
		} | null;
	} | null;
	sharedWithContacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		vendor: {
			__typename?: 'Organization';
			id: string;
			updatedAt: Date | string;
			image?: string | null;
			name: string;
		};
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
	}> | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
};

export type UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryVariables =
	Exact<{
		orderBy?: InputMaybe<
			Array<InputMaybe<DocumentOrderByInput>> | InputMaybe<DocumentOrderByInput>
		>;
		skip?: InputMaybe<Scalars['Int']['input']>;
		take?: InputMaybe<Scalars['Int']['input']>;
		where: CustomDocumentWhereInput;
	}>;

export type UseCustomerFolderDocumentsTable_GetDocumentsWhereQuery = {
	__typename?: 'Query';
	getDocumentsWhere: {
		__typename?: 'Documents';
		_count: number;
		documents: Array<{
			__typename?: 'Document';
			id: string;
			fileType: FileType;
			fileSource: FileSourceType;
			name: string;
			updatedAt: Date | string;
			ownerType: DocumentOwnerType;
			exportable: boolean;
			sharedWithCustomer: boolean;
			type: DocumentType;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				updatedAt: Date | string;
				image?: string | null;
				services: Array<{ __typename?: 'Service'; id: string }>;
			} | null;
			customer?: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					firstNameOne: string;
					lastNameOne?: string | null;
					updatedAt: Date | string;
					plannerOrgHasDocumentsPermissions: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
					updatedAt: Date | string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			sharedWithContacts?: Array<{
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				status: ContactStatus;
				hasCustomerIntent: boolean;
				vendor: {
					__typename?: 'Organization';
					id: string;
					updatedAt: Date | string;
					image?: string | null;
					name: string;
				};
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						updatedAt: Date | string;
					} | null;
					orgUser?: {
						__typename?: 'OrgUser';
						id: string;
						updatedAt: Date | string;
					} | null;
				};
			}> | null;
			orgUser?: { __typename?: 'OrgUser'; id: string } | null;
		}>;
	};
};

export type CustomerFolderDocumentsTable_DeleteDocumentMutationVariables =
	Exact<{
		where: DocumentWhereUniqueInput;
	}>;

export type CustomerFolderDocumentsTable_DeleteDocumentMutation = {
	__typename?: 'Mutation';
	deleteDocument: boolean;
};

export type UseCustomerFolderDocumentsTable_GetContactQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type UseCustomerFolderDocumentsTable_GetContactQuery = {
	__typename?: 'Query';
	getContactWhere?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
		};
	} | null;
};

export type CustomerFoldersTableNameContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
};

export type CustomerFoldersTableNumberOfFilesContactFragment = {
	__typename?: 'Contact';
	id: string;
	_countOfDocuments?: number | null;
};

export type CustomerFoldersTableUpdatedAtContactFragment = {
	__typename?: 'Contact';
	id: string;
	updatedAt: Date | string;
};

export type UseCustomerFoldersTableContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	_countOfDocuments?: number | null;
	updatedAt: Date | string;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
};

export type CustomerFoldersTable_GetContactsWhereQueryVariables = Exact<{
	orderBy?: InputMaybe<
		Array<InputMaybe<ContactOrderByInput>> | InputMaybe<ContactOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContactWhereInput;
}>;

export type CustomerFoldersTable_GetContactsWhereQuery = {
	__typename?: 'Query';
	getContactsWhere: {
		__typename?: 'Contacts';
		_count: number;
		contacts: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			_countOfDocuments?: number | null;
			updatedAt: Date | string;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
		}>;
	};
};

export type DeleteFolderModal_GetFolderContentsQueryVariables = Exact<{
	where: FolderWhereUniqueInput;
	take?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<FolderContentsOrderByInput>;
}>;

export type DeleteFolderModal_GetFolderContentsQuery = {
	__typename?: 'Query';
	getFolderContents?: {
		__typename?: 'CustomFolder';
		id: string;
		childFolders?: Array<{
			__typename?: 'CustomFolder';
			id: string;
		} | null> | null;
		documents?: Array<{ __typename?: 'Document'; id: string } | null> | null;
	} | null;
};

export type DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationVariables =
	Exact<{
		where: DocumentAccessTokenUniqueWhere;
	}>;

export type DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation = {
	__typename?: 'Mutation';
	refreshDocumentAccessToken: string;
};

export type DocumentDetailButtonBarCustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	exportable: boolean;
	type: DocumentType;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	name: string;
	fileType: FileType;
	customer?: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	} | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
	organization?: { __typename?: 'Organization'; id: string } | null;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
};

export type UseDeleteDocumentButtonCustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	type: DocumentType;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	customer?: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	} | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
	organization?: { __typename?: 'Organization'; id: string } | null;
};

export type DeleteDocumentButton_DeleteDocumentMutationVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type DeleteDocumentButton_DeleteDocumentMutation = {
	__typename?: 'Mutation';
	deleteDocument: boolean;
};

export type UseExportDocumentButtonCustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	exportable: boolean;
};

export type ExportDocumentButton_GetDocumentWhereQueryVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type ExportDocumentButton_GetDocumentWhereQuery = {
	__typename?: 'Query';
	getDocumentWhere: {
		__typename?: 'Document';
		id: string;
		downloadUrl?: string | null;
	};
};

export type UseMoveDocumentButtonCustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	type: DocumentType;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	name: string;
	fileType: FileType;
	customer?: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	} | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
	organization?: { __typename?: 'Organization'; id: string } | null;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
};

export type DocumentDetailPresentationContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		updatedAt: Date | string;
		name: string;
	};
};

export type DocumentDetailPresentationCustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	name: string;
	type: DocumentType;
	fileType: FileType;
	createdAt: Date | string;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	customer?: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			updatedAt: Date | string;
			firstNameOne: string;
			lastNameOne?: string | null;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		name: string;
		updatedAt: Date | string;
	} | null;
	sharedWithContacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	}> | null;
};

export type DocumentDetailPresentation_UpdateDocumentNameMutationVariables =
	Exact<{
		where: DocumentWhereUniqueInput;
		data: UpdateDocumentNameInput;
	}>;

export type DocumentDetailPresentation_UpdateDocumentNameMutation = {
	__typename?: 'Mutation';
	updateDocumentName?: {
		__typename?: 'Document';
		id: string;
		name: string;
	} | null;
};

export type DocumentDetailCustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	type: DocumentType;
	downloadUrl?: string | null;
	name: string;
	fileType: FileType;
	createdAt: Date | string;
	ownerType: DocumentOwnerType;
	exportable: boolean;
	sharedWithCustomer: boolean;
	customer?: {
		__typename?: 'User';
		id: string;
		contacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		} | null> | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			updatedAt: Date | string;
			firstNameOne: string;
			lastNameOne?: string | null;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		name: string;
		updatedAt: Date | string;
	} | null;
	parentFolder?: {
		__typename?: 'Folder';
		id: string;
		name: string;
		folderType: FolderType;
	} | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
	sharedWithContacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	}> | null;
};

export type DocumentDetail_GetDocumentWhereQueryVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type DocumentDetail_GetDocumentWhereQuery = {
	__typename?: 'Query';
	getDocumentWhere: {
		__typename?: 'Document';
		id: string;
		type: DocumentType;
		downloadUrl?: string | null;
		name: string;
		fileType: FileType;
		createdAt: Date | string;
		ownerType: DocumentOwnerType;
		exportable: boolean;
		sharedWithCustomer: boolean;
		customer?: {
			__typename?: 'User';
			id: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				status: ContactStatus;
				hasCustomerIntent: boolean;
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						updatedAt: Date | string;
					} | null;
					orgUser?: {
						__typename?: 'OrgUser';
						id: string;
						updatedAt: Date | string;
					} | null;
				};
				vendor: {
					__typename?: 'Organization';
					id: string;
					image?: string | null;
					updatedAt: Date | string;
					name: string;
				};
			} | null> | null;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgHasDocumentsPermissions: boolean;
				updatedAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			name: string;
			updatedAt: Date | string;
		} | null;
		parentFolder?: {
			__typename?: 'Folder';
			id: string;
			name: string;
			folderType: FolderType;
		} | null;
		orgUser?: { __typename?: 'OrgUser'; id: string } | null;
		sharedWithContacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		}> | null;
	};
};

export type AcceptProposalModalRowProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	title?: string | null;
	guestToken?: string | null;
	dueDate?: Date | string | null;
};

export type AcceptProposalsModalProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	title?: string | null;
	guestToken?: string | null;
	dueDate?: Date | string | null;
};

export type AcceptProposalsModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	customer: { __typename?: 'User'; id: string };
	proposals?: Array<{
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		title?: string | null;
		guestToken?: string | null;
		dueDate?: Date | string | null;
	}> | null;
};

export type AcceptProposalsModalContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	id: string;
	customer: { __typename?: 'CustomerForGetContractWhere'; id: string };
	proposals?: Array<{
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		title?: string | null;
		guestToken?: string | null;
		dueDate?: Date | string | null;
	}> | null;
};

export type PayInvoicesModalRowInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	title: string;
	guestToken?: string | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		paymentDate?: Date | string | null;
	}>;
};

export type PayInvoicesModalRowInvoiceForGetContractWhereFragment = {
	__typename?: 'InvoiceForGetContractWhere';
	id: string;
	title: string;
	guestToken?: string | null;
	paymentInstallments?: Array<{
		__typename?: 'PaymentInstallmentsForGetContractWhere';
		id: string;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		paymentDate?: Date | string | null;
	}> | null;
};

export type PayInvoicesModalInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	title: string;
	guestToken?: string | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
	}>;
};

export type PayInvoicesModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	invoices?: Array<{
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
		title: string;
		guestToken?: string | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			status?: InstallmentStatus | null;
			dueDate?: Date | string | null;
			amountDue?: number | null;
			paymentDate?: Date | string | null;
		}>;
	}> | null;
};

export type PayInvoicesModalInvoiceForGetContractWhereFragment = {
	__typename?: 'InvoiceForGetContractWhere';
	id: string;
	status: InvoiceStatus;
	title: string;
	guestToken?: string | null;
	paymentInstallments?: Array<{
		__typename?: 'PaymentInstallmentsForGetContractWhere';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
	}> | null;
};

export type PayInvoicesModalContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	id: string;
	invoices?: Array<{
		__typename?: 'InvoiceForGetContractWhere';
		id: string;
		status: InvoiceStatus;
		title: string;
		guestToken?: string | null;
		paymentInstallments?: Array<{
			__typename?: 'PaymentInstallmentsForGetContractWhere';
			id: string;
			status?: InstallmentStatus | null;
			dueDate?: Date | string | null;
			amountDue?: number | null;
			paymentDate?: Date | string | null;
		}> | null;
	}> | null;
};

export type SignContractsModalRowContractFragment = {
	__typename?: 'SignatureContract';
	id: string;
	title: string;
	guestToken?: string | null;
};

export type SignContractsModalContractFragment = {
	__typename?: 'SignatureContract';
	id: string;
	status: ContractStatus;
	title: string;
	guestToken?: string | null;
};

export type SignContractsModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	customerSignatures?: Array<{
		__typename?: 'CustomerSignature';
		id: string;
		signature: {
			__typename?: 'Signature';
			id: string;
			signingDate?: Date | string | null;
			contract?: {
				__typename?: 'SignatureContract';
				id: string;
				status: ContractStatus;
				title: string;
				guestToken?: string | null;
			} | null;
		};
	}> | null;
	vendor: { __typename?: 'Organization'; id: string; name: string };
};

export type SignContractsModalContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	id: string;
	customerSignatures?: Array<{
		__typename?: 'CustomerSignature';
		id: string;
		signature: {
			__typename?: 'Signature';
			id: string;
			signingDate?: Date | string | null;
			contract?: {
				__typename?: 'SignatureContract';
				id: string;
				status: ContractStatus;
				title: string;
				guestToken?: string | null;
			} | null;
		};
	}> | null;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		name?: string | null;
	};
};

export type DocumentFollowupActionsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	title: string;
	guestToken?: string | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
	}>;
};

export type DocumentFollowupActionsInvoiceForGetContractWhereFragment = {
	__typename?: 'InvoiceForGetContractWhere';
	id: string;
	status: InvoiceStatus;
	title: string;
	guestToken?: string | null;
	paymentInstallments?: Array<{
		__typename?: 'PaymentInstallmentsForGetContractWhere';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
	}> | null;
};

export type DocumentFollowupActionsContactFragment = {
	__typename?: 'Contact';
	id: string;
	customerSignatures?: Array<{
		__typename?: 'CustomerSignature';
		id: string;
		signature: {
			__typename?: 'Signature';
			id: string;
			signingDate?: Date | string | null;
			signer?: { __typename?: 'SignatureUser'; id: string } | null;
			contract?: {
				__typename?: 'SignatureContract';
				id: string;
				status: ContractStatus;
				dueDate: Date | string;
				title: string;
				guestToken?: string | null;
			} | null;
		};
	}> | null;
	invoices?: Array<{
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
		title: string;
		guestToken?: string | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			status?: InstallmentStatus | null;
			dueDate?: Date | string | null;
			amountDue?: number | null;
			paymentDate?: Date | string | null;
		}>;
	}> | null;
	customer: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgCanSignContracts: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				} | null;
			} | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; name: string; id: string }>;
	};
	proposals?: Array<{
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		title?: string | null;
		guestToken?: string | null;
		dueDate?: Date | string | null;
	}> | null;
};

export type DocumentFollowupActionsContactForGetContractWhereFragment = {
	__typename?: 'ContactForGetContractWhere';
	id: string;
	customerSignatures?: Array<{
		__typename?: 'CustomerSignature';
		id: string;
		signature: {
			__typename?: 'Signature';
			id: string;
			signingDate?: Date | string | null;
			signer?: { __typename?: 'SignatureUser'; id: string } | null;
			contract?: {
				__typename?: 'SignatureContract';
				id: string;
				status: ContractStatus;
				dueDate: Date | string;
				title: string;
				guestToken?: string | null;
			} | null;
		};
	}> | null;
	invoices?: Array<{
		__typename?: 'InvoiceForGetContractWhere';
		id: string;
		status: InvoiceStatus;
		title: string;
		guestToken?: string | null;
		paymentInstallments?: Array<{
			__typename?: 'PaymentInstallmentsForGetContractWhere';
			id: string;
			status?: InstallmentStatus | null;
			dueDate?: Date | string | null;
			amountDue?: number | null;
			paymentDate?: Date | string | null;
		}> | null;
	}> | null;
	customer: {
		__typename?: 'CustomerForGetContractWhere';
		id: string;
		clientUser?: {
			__typename?: 'ClientUserForGetContractWhere';
			id: string;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgCanSignContracts: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUserForGetContractWhere';
				id: string;
				organization?: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
						user?: {
							__typename?: 'BaseUserForGetContractWhere';
							id: string;
						} | null;
					}> | null;
				} | null;
			} | null;
		} | null;
	};
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		name?: string | null;
		image?: string | null;
		services: Array<{
			__typename?: 'ServicesForGetContractWhere';
			name?: string | null;
			id?: string | null;
		} | null>;
	};
	proposals?: Array<{
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		title?: string | null;
		guestToken?: string | null;
		dueDate?: Date | string | null;
	}> | null;
};

export type DocumentSettingsModalShareListContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		updatedAt: Date | string;
		name: string;
	};
};

export type DocumentSettingsModalShareListCustomDocumentWithDownloadUrlFragment =
	{
		__typename?: 'Document';
		id: string;
		type: DocumentType;
		ownerType: DocumentOwnerType;
		sharedWithCustomer: boolean;
		customer?: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
		sharedWithContacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		}> | null;
	};

export type DocumentSettingsModalShareListOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	contacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	}> | null;
};

export type DocumentSettingsModalShareList_GetOrganizationsForUserQueryVariables =
	Exact<{
		where: UserByIdUniqueInput;
		take?: InputMaybe<Scalars['Int']['input']>;
		contactWhere?: InputMaybe<ContactWhereInput>;
	}>;

export type DocumentSettingsModalShareList_GetOrganizationsForUserQuery = {
	__typename?: 'Query';
	getOrganizationsForUser?: {
		__typename?: 'Organizations';
		organizations: Array<{
			__typename?: 'Organization';
			id: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				status: ContactStatus;
				hasCustomerIntent: boolean;
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						updatedAt: Date | string;
					} | null;
					orgUser?: {
						__typename?: 'OrgUser';
						id: string;
						updatedAt: Date | string;
					} | null;
				};
				vendor: {
					__typename?: 'Organization';
					id: string;
					image?: string | null;
					updatedAt: Date | string;
					name: string;
				};
			}> | null;
		}>;
	} | null;
};

export type UseDocumentSettingsModalShareListContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		updatedAt: Date | string;
		name: string;
	};
};

export type UseDocumentSettingsModalShareListCustomDocumentWithDownloadUrlFragment =
	{
		__typename?: 'Document';
		id: string;
		type: DocumentType;
		ownerType: DocumentOwnerType;
		sharedWithCustomer: boolean;
		customer?: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
		sharedWithContacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		}> | null;
	};

export type UseDocumentSettingsModalShareListOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	contacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	}> | null;
};

export type DocumentSettingsModalDocumentFragment = {
	__typename?: 'Document';
	id: string;
	name: string;
	exportable: boolean;
	type: DocumentType;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	customer?: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
			firstNameOne: string;
			lastNameOne?: string | null;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
	} | null;
	sharedWithContacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	}> | null;
};

export type DocumentSettingsModal_GetDocumentWhereQueryVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type DocumentSettingsModal_GetDocumentWhereQuery = {
	__typename?: 'Query';
	getDocumentWhere: {
		__typename?: 'Document';
		id: string;
		name: string;
		exportable: boolean;
		type: DocumentType;
		ownerType: DocumentOwnerType;
		sharedWithCustomer: boolean;
		customer?: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
		sharedWithContacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		}> | null;
	};
};

export type DocumentSettingsModal_ShareDocumentMutationVariables = Exact<{
	where: DocumentWhereUniqueInput;
	data: CustomShareDocumentInput;
}>;

export type DocumentSettingsModal_ShareDocumentMutation = {
	__typename?: 'Mutation';
	shareDocument: {
		__typename?: 'Document';
		id: string;
		name: string;
		exportable: boolean;
		type: DocumentType;
		ownerType: DocumentOwnerType;
		sharedWithCustomer: boolean;
		customer?: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
		sharedWithContacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		}> | null;
	};
};

export type DocumentSettingsModal_UpdateDocumentMutationVariables = Exact<{
	where: DocumentWhereUniqueInput;
	data: UpdateDocumentInput;
}>;

export type DocumentSettingsModal_UpdateDocumentMutation = {
	__typename?: 'Mutation';
	updateDocument: {
		__typename?: 'Document';
		id: string;
		name: string;
		exportable: boolean;
		type: DocumentType;
		ownerType: DocumentOwnerType;
		sharedWithCustomer: boolean;
		customer?: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
		sharedWithContacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		}> | null;
	};
};

export type UseDocumentSettingsModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		updatedAt: Date | string;
		name: string;
	};
};

export type UseDocumentSettingsModalDocumentFragment = {
	__typename?: 'Document';
	id: string;
	name: string;
	exportable: boolean;
	type: DocumentType;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	customer?: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
			firstNameOne: string;
			lastNameOne?: string | null;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
	} | null;
	sharedWithContacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	}> | null;
};

export type DocumentViewEmailNotificationGroupContractForGetContractWhereFragment =
	{
		__typename?: 'ContractForGetContractWhere';
		id: string;
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			groupTitle: EmailNotificationGroupTitle;
			members: Array<{
				__typename?: 'ReducedUser';
				id?: string | null;
				email: string;
				userType: UserType;
				orgUser?: {
					__typename?: 'ReducedOrgUser';
					id: string;
					firstName: string;
					lastName: string;
					organization?: {
						__typename?: 'ReducedOrganization';
						id?: string | null;
					} | null;
				} | null;
			}>;
		} | null;
	};

export type DocumentViewEmailNotificationGroupInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type DocumentViewEmailNotificationGroupFragment = {
	__typename?: 'Proposal';
	id: string;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type DocumentsUploadButtonContactFragment = {
	__typename?: 'Contact';
	id: string;
};

export type DocumentsUploadButtonCustomFolderFragment = {
	__typename?: 'CustomFolder';
	id: string;
	name?: string | null;
	parentFolder?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
	} | null;
};

export type DocumentsUploadButtonCustomDocumentWithUploadUrlFragment = {
	__typename?: 'Document';
	id: string;
};

export type DocumentsUploadButton_CreateDocumentMutationVariables = Exact<{
	data: DocumentCreateCustomInput;
}>;

export type DocumentsUploadButton_CreateDocumentMutation = {
	__typename?: 'Mutation';
	createDocument: {
		__typename?: 'Document';
		id: string;
		status: DocumentStatus;
		uploadURL?: string | null;
	};
};

export type DocumentsUploadButton_RecordDocumentUploadedMutationVariables =
	Exact<{
		where: DocumentWhereUniqueInput;
	}>;

export type DocumentsUploadButton_RecordDocumentUploadedMutation = {
	__typename?: 'Mutation';
	recordDocumentUploaded: {
		__typename?: 'Document';
		id: string;
		status: DocumentStatus;
	};
};

export type DocumentsUploadButton_GetFeatureFlagsQueryVariables = Exact<{
	[key: string]: never;
}>;

export type DocumentsUploadButton_GetFeatureFlagsQuery = {
	__typename?: 'Query';
	getFeatureFlags: Array<{
		__typename?: 'ReducedFeatureFlag';
		category: FeatureCategory;
		active: boolean;
	}>;
};

export type DocumentsUploadButton_GetContactWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type DocumentsUploadButton_GetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: { __typename?: 'Contact'; id: string } | null;
};

export type UpdatePasswordForm_ChangePasswordMutationVariables = Exact<{
	data: PasswordChangeInput;
}>;

export type UpdatePasswordForm_ChangePasswordMutation = {
	__typename?: 'Mutation';
	changePassword: boolean;
};

export type UserInformationForm_UpdateClientUserMutationVariables = Exact<{
	data: ClientUserUpdateCustomInput;
	where: ClientUserWhereUniqueInput;
}>;

export type UserInformationForm_UpdateClientUserMutation = {
	__typename?: 'Mutation';
	updateClientUser: {
		__typename?: 'ClientUser';
		id: string;
		updatedAt: Date | string;
		phone?: string | null;
		addressLine1: string;
		addressLine2?: string | null;
		city: string;
		state: State;
		country: Country;
		postalCode?: string | null;
		facebook?: string | null;
		twitter?: string | null;
		instagram?: string | null;
		pinterest?: string | null;
	};
};

export type UserInformationForm_UpdateOrgUserMutationVariables = Exact<{
	data: OrgUserUpdateCustomInput;
	where: OrgUserWhereUniqueInput;
}>;

export type UserInformationForm_UpdateOrgUserMutation = {
	__typename?: 'Mutation';
	updateOrgUser?: {
		__typename?: 'OrgUser';
		id: string;
		updatedAt: Date | string;
		phone?: string | null;
	} | null;
};

export type UserInformationForm_UpdateEmailAddressMutationVariables = Exact<{
	data: EmailAddressUpdateInput;
	where: EmailAddressInput;
}>;

export type UserInformationForm_UpdateEmailAddressMutation = {
	__typename?: 'Mutation';
	updateEmailAddress: boolean;
};

export type UserInformationForm_GetFeatureFlagsQueryVariables = Exact<{
	[key: string]: never;
}>;

export type UserInformationForm_GetFeatureFlagsQuery = {
	__typename?: 'Query';
	getFeatureFlags: Array<{
		__typename?: 'ReducedFeatureFlag';
		category: FeatureCategory;
		active: boolean;
	}>;
};

export type UserInformationForm_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type UserInformationForm_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			description?: string | null;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			facebook?: string | null;
			instagram?: string | null;
			twitter?: string | null;
			pinterest?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					updatedAt: Date | string;
				} | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			role: TeamMemberRole;
			phone?: string | null;
			isAdmin: boolean;
			isOwner: boolean;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			organization?: {
				__typename?: 'Organization';
				id: string;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				country?: Country | null;
				postalCode?: string | null;
				createdAt: Date | string;
				name: string;
				website?: string | null;
				phone?: string | null;
				contactEmail?: string | null;
				description?: string | null;
				image?: string | null;
				imageScale?: number | null;
				imageRotation?: number | null;
				imagePositionX?: number | null;
				imagePositionY?: number | null;
				brandedEmails?: boolean | null;
				automatedRemindersEnabled: boolean;
				invoicesAllowGratuity: boolean;
				canReceivePayments: boolean;
				updatedAt: Date | string;
				facebook?: string | null;
				instagram?: string | null;
				twitter?: string | null;
				pinterest?: string | null;
				hasStripeVerificationNeeds: boolean;
				coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: {
						__typename?: 'Plan';
						id: string;
						period: PlanPeriod;
						type: PlanType;
					};
				} | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
				rootFolder?: { __typename?: 'Folder'; id: string } | null;
			} | null;
		} | null;
		superAdmin?: {
			__typename?: 'SuperAdminUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
			};
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type UserInformationForm_GetClientUserWhereQueryVariables = Exact<{
	where: ClientUserWhereUniqueInput;
}>;

export type UserInformationForm_GetClientUserWhereQuery = {
	__typename?: 'Query';
	getClientUserWhere?: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		firstNameTwo?: string | null;
		lastNameTwo?: string | null;
		weddingDate?: Date | string | null;
		venue?: string | null;
		description?: string | null;
		phone?: string | null;
		addressLine1: string;
		addressLine2?: string | null;
		city: string;
		state: State;
		country: Country;
		postalCode?: string | null;
		facebook?: string | null;
		twitter?: string | null;
		instagram?: string | null;
		pinterest?: string | null;
		user: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type UserInformationForm_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type UserInformationForm_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		phone?: string | null;
		role: TeamMemberRole;
		user?: { __typename?: 'User'; id: string; email: string } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			description?: string | null;
			country?: Country | null;
		} | null;
	} | null;
};

export type EmbeddedFileContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	contractSourceFile?: string | null;
	unsignedContractFileUrl?: string | null;
	executedContractUrl?: string | null;
	contractTemplate?: {
		__typename?: 'ContractTemplateForGetContractWhere';
		sourceFileUrl?: string | null;
	} | null;
};

export type EmbeddedFileContractTemplateFragment = {
	__typename?: 'ContractTemplate';
	id: string;
	sourceFileUrl?: string | null;
};

export type EmbeddedFileDocumentFragment = {
	__typename?: 'Document';
	id: string;
	downloadUrl?: string | null;
};

export type EmbeddedFileProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	imageUrl?: string | null;
	filename?: string | null;
};

export type EmbeddedFileProposalTemplateFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	imageUrl?: string | null;
	filename?: string | null;
};

export type EventsContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	firstName: string;
	lastName: string;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				} | null;
			} | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
	assignedMember: { __typename?: 'OrgUser'; id: string };
};

export type EventsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	createdAt: Date | string;
	message?: string | null;
	metadata?: any | null;
	resolvedAt?: Date | string | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
			user?: { __typename?: 'ActingUserForEvent'; id: string } | null;
			organization?: {
				__typename?: 'OrganizationForActingUser';
				id?: string | null;
				name?: string | null;
				services?: {
					__typename?: 'ServicesForActingUser';
					id?: string | null;
					name?: string | null;
				} | null;
			} | null;
		} | null;
	} | null;
	clientUser?: {
		__typename?: 'ClientUser';
		id: string;
		firstNameOne: string;
		lastNameOne?: string | null;
		firstNameTwo?: string | null;
		lastNameTwo?: string | null;
		plannerOrgCanPayInvoices: boolean;
		plannerOrgCanSignContracts: boolean;
		plannerOrgHasConnectionPermissions: boolean;
		plannerOrgHasDocumentsPermissions: boolean;
		user: { __typename?: 'User'; id: string; email: string };
		assignedPlanner?: {
			__typename?: 'OrgUser';
			id: string;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
	} | null;
	guestUser?: {
		__typename?: 'GuestUser';
		id: string;
		user: { __typename?: 'User'; id: string; email: string };
	} | null;
	vendor?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
	orgUser?: {
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		firstName: string;
		lastName: string;
		user?: { __typename?: 'User'; id: string; email: string } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			orgType?: OrgType | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
	plannerUser?: {
		__typename?: 'OrgUser';
		id: string;
		role: TeamMemberRole;
		firstName: string;
		lastName: string;
		user?: { __typename?: 'User'; id: string } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			orgType?: OrgType | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
	contacts?: Array<{
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	}> | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	} | null;
	invitation?: {
		__typename?: 'Invitation';
		id: string;
		emailAddress: string;
		recipientFirstName: string;
		recipientLastName?: string | null;
	} | null;
	contract?: {
		__typename?: 'CustomContract';
		id: string;
		title?: string | null;
		eventDate?: Date | string | null;
		automatedRemindersEnabled: boolean;
		sentByUser?: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		} | null;
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
		signatures: Array<{
			__typename?: 'Signature';
			id: string;
			type?: SignatureType | null;
			signer?: {
				__typename?: 'SignatureUser';
				id: string;
				orgUser?: {
					__typename?: 'SignatureCounterSigner';
					id: string;
					firstName: string;
					lastName: string;
					user: { __typename?: 'SignatureCounterSignerUser'; id: string };
				} | null;
			} | null;
			customerSignature?: {
				__typename?: 'CustomerSignature';
				id: string;
				contact: {
					__typename?: 'CustomerSignatureContact';
					id: string;
					vendor: {
						__typename?: 'CustomerSignatureContactOrganization';
						id: string;
						name: string;
						users?: Array<{
							__typename?: 'CustomerSignatureContactOrganizationUsers';
							id: string;
							role: TeamMemberRole;
						}> | null;
					};
					customer: {
						__typename?: 'CustomerSignatureContactCustomer';
						id: string;
						clientUser?: {
							__typename?: 'CustomerSignatureContactCustomerClientUser';
							id: string;
							plannerOrgCanSignContracts: boolean;
							assignedPlanner?: {
								__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
								id: string;
								organization: {
									__typename?: 'CustomerSignatureContactOrganization';
									id: string;
									users?: Array<{
										__typename?: 'CustomerSignatureContactOrganizationUsers';
										id: string;
										role: TeamMemberRole;
									}> | null;
								};
							} | null;
						} | null;
					};
					assignedMember: {
						__typename?: 'CustomerSignatureOrgUser';
						id: string;
					};
				};
			} | null;
		}>;
	} | null;
	invoice?: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		status: InvoiceStatus;
		gratuityAmount: number;
		automatedRemindersEnabled: boolean;
		eventDate?: Date | string | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			name?: string | null;
		}>;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			};
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						firstName: string;
						lastName: string;
						user?: { __typename?: 'User'; id: string } | null;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
								user?: { __typename?: 'User'; id: string } | null;
								organization?: {
									__typename?: 'Organization';
									id: string;
									users?: Array<{
										__typename?: 'OrgUser';
										id: string;
										role: TeamMemberRole;
										user?: { __typename?: 'User'; id: string } | null;
									}> | null;
								} | null;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
	} | null;
	document?: {
		__typename?: 'Document';
		id: string;
		name: string;
		fileSource: FileSourceType;
		fileType: FileType;
		customer?: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				firstNameOne: string;
				lastNameOne?: string | null;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						services: Array<{
							__typename?: 'Service';
							id: string;
							name: string;
						}>;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
	paymentInstallments?: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
	}> | null;
	proposal?: {
		__typename?: 'Proposal';
		id: string;
		title?: string | null;
		automatedRemindersEnabled: boolean;
		eventDate?: Date | string | null;
		proposalTemplate?: { __typename?: 'ProposalTemplate'; id: string } | null;
		contact: {
			__typename?: 'Contact';
			firstName: string;
			lastName: string;
			id: string;
			customer: {
				__typename?: 'User';
				email: string;
				id: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
								user?: { __typename?: 'User'; id: string } | null;
								organization?: {
									__typename?: 'Organization';
									id: string;
									users?: Array<{
										__typename?: 'OrgUser';
										id: string;
										role: TeamMemberRole;
										user?: { __typename?: 'User'; id: string } | null;
									}> | null;
								} | null;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				name: string;
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			};
		};
		sentByUser?: { __typename?: 'OrgUser'; id: string } | null;
	} | null;
	inquiry?: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		organization: {
			__typename?: 'Organization';
			id: string;
			name: string;
			createdAt: Date | string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
	} | null;
};

export type Events_GetEventsWhereQueryVariables = Exact<{
	where: EventWhereInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<EventOrderByInput>> | InputMaybe<EventOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type Events_GetEventsWhereQuery = {
	__typename?: 'Query';
	getEventsWhere?: Array<{
		__typename?: 'Event';
		id: string;
		category: EventCategory;
		createdAt: Date | string;
		message?: string | null;
		metadata?: any | null;
		resolvedAt?: Date | string | null;
		actingUser?: {
			__typename?: 'ActingUserForEvent';
			id: string;
			orgUser?: {
				__typename?: 'OrgUserForActingUserOnEvent';
				id: string;
				firstName: string;
				lastName: string;
				user?: { __typename?: 'ActingUserForEvent'; id: string } | null;
				organization?: {
					__typename?: 'OrganizationForActingUser';
					id?: string | null;
					name?: string | null;
					services?: {
						__typename?: 'ServicesForActingUser';
						id?: string | null;
						name?: string | null;
					} | null;
				} | null;
			} | null;
		} | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			user: { __typename?: 'User'; id: string; email: string };
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					orgType?: OrgType | null;
					services: Array<{ __typename?: 'Service'; id: string; name: string }>;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				} | null;
			} | null;
		} | null;
		guestUser?: {
			__typename?: 'GuestUser';
			id: string;
			user: { __typename?: 'User'; id: string; email: string };
		} | null;
		vendor?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			user?: { __typename?: 'User'; id: string; email: string } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
		plannerUser?: {
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			user?: { __typename?: 'User'; id: string } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				orgType?: OrgType | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
		contacts?: Array<{
			__typename?: 'Contact';
			id: string;
			status: ContactStatus;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
			assignedMember: { __typename?: 'OrgUser'; id: string };
		}> | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
			assignedMember: { __typename?: 'OrgUser'; id: string };
		} | null;
		invitation?: {
			__typename?: 'Invitation';
			id: string;
			emailAddress: string;
			recipientFirstName: string;
			recipientLastName?: string | null;
		} | null;
		contract?: {
			__typename?: 'CustomContract';
			id: string;
			title?: string | null;
			eventDate?: Date | string | null;
			automatedRemindersEnabled: boolean;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
			signatures: Array<{
				__typename?: 'Signature';
				id: string;
				type?: SignatureType | null;
				signer?: {
					__typename?: 'SignatureUser';
					id: string;
					orgUser?: {
						__typename?: 'SignatureCounterSigner';
						id: string;
						firstName: string;
						lastName: string;
						user: { __typename?: 'SignatureCounterSignerUser'; id: string };
					} | null;
				} | null;
				customerSignature?: {
					__typename?: 'CustomerSignature';
					id: string;
					contact: {
						__typename?: 'CustomerSignatureContact';
						id: string;
						vendor: {
							__typename?: 'CustomerSignatureContactOrganization';
							id: string;
							name: string;
							users?: Array<{
								__typename?: 'CustomerSignatureContactOrganizationUsers';
								id: string;
								role: TeamMemberRole;
							}> | null;
						};
						customer: {
							__typename?: 'CustomerSignatureContactCustomer';
							id: string;
							clientUser?: {
								__typename?: 'CustomerSignatureContactCustomerClientUser';
								id: string;
								plannerOrgCanSignContracts: boolean;
								assignedPlanner?: {
									__typename?: 'CustomerSignatureContactCustomerClientUserAssignedPlanner';
									id: string;
									organization: {
										__typename?: 'CustomerSignatureContactOrganization';
										id: string;
										users?: Array<{
											__typename?: 'CustomerSignatureContactOrganizationUsers';
											id: string;
											role: TeamMemberRole;
										}> | null;
									};
								} | null;
							} | null;
						};
						assignedMember: {
							__typename?: 'CustomerSignatureOrgUser';
							id: string;
						};
					};
				} | null;
			}>;
		} | null;
		invoice?: {
			__typename?: 'Invoice';
			id: string;
			title: string;
			status: InvoiceStatus;
			gratuityAmount: number;
			automatedRemindersEnabled: boolean;
			eventDate?: Date | string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				name?: string | null;
			}>;
			contact?: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				vendor: {
					__typename?: 'Organization';
					id: string;
					name: string;
					orgType?: OrgType | null;
					services: Array<{ __typename?: 'Service'; id: string; name: string }>;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
						user?: { __typename?: 'User'; id: string } | null;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
				};
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							firstName: string;
							lastName: string;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
									organization?: {
										__typename?: 'Organization';
										id: string;
										users?: Array<{
											__typename?: 'OrgUser';
											id: string;
											role: TeamMemberRole;
											user?: { __typename?: 'User'; id: string } | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
			} | null;
		} | null;
		document?: {
			__typename?: 'Document';
			id: string;
			name: string;
			fileSource: FileSourceType;
			fileType: FileType;
			customer?: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					firstNameOne: string;
					lastNameOne?: string | null;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							services: Array<{
								__typename?: 'Service';
								id: string;
								name: string;
							}>;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
							}> | null;
						} | null;
					} | null;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
				} | null;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		} | null;
		paymentInstallments?: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			name?: string | null;
		}> | null;
		proposal?: {
			__typename?: 'Proposal';
			id: string;
			title?: string | null;
			automatedRemindersEnabled: boolean;
			eventDate?: Date | string | null;
			proposalTemplate?: { __typename?: 'ProposalTemplate'; id: string } | null;
			contact: {
				__typename?: 'Contact';
				firstName: string;
				lastName: string;
				id: string;
				customer: {
					__typename?: 'User';
					email: string;
					id: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
									organization?: {
										__typename?: 'Organization';
										id: string;
										users?: Array<{
											__typename?: 'OrgUser';
											id: string;
											role: TeamMemberRole;
											user?: { __typename?: 'User'; id: string } | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				vendor: {
					__typename?: 'Organization';
					name: string;
					id: string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
						user?: { __typename?: 'User'; id: string } | null;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
				};
			};
			sentByUser?: { __typename?: 'OrgUser'; id: string } | null;
		} | null;
		inquiry?: {
			__typename?: 'Inquiry';
			id: string;
			firstName: string;
			lastName: string;
			organization: {
				__typename?: 'Organization';
				id: string;
				name: string;
				createdAt: Date | string;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
				} | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
		} | null;
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			groupTitle: EmailNotificationGroupTitle;
		} | null;
	}> | null;
};

export type InquiriesConfigurationFieldsInquiryFormFragment = {
	__typename?: 'InquiryForm';
	fields?: Array<{
		__typename?: 'InquiryFormField';
		order: number;
		type: InquiryFormFieldType;
		label: string;
		required: boolean;
		options?: any | null;
		multiple?: boolean | null;
	}> | null;
};

export type InquiriesPublishForm_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type InquiriesPublishForm_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		InquiryFormSupportUrl?: string | null;
	};
};

export type InquiriesPublish_GetInquiryFormApiKeyQueryVariables = Exact<{
	[key: string]: never;
}>;

export type InquiriesPublish_GetInquiryFormApiKeyQuery = {
	__typename?: 'Query';
	getInquiryFormApiKey: string;
};

export type InquiriesConfigurationInquiryFormFragment = {
	__typename?: 'InquiryForm';
	sendConfirmationEmail: boolean;
	confirmationEmail?: string | null;
	redirectOnSuccessUrl?: string | null;
	fields?: Array<{
		__typename?: 'InquiryFormField';
		id: string;
		order: number;
		type: InquiryFormFieldType;
		label: string;
		required: boolean;
		options?: any | null;
		multiple?: boolean | null;
	}> | null;
	styles?: Array<{
		__typename?: 'InquiryFormStyle';
		type: InquiryFormStyleType;
		value: string;
	}> | null;
};

export type InquiriesConfiguration_GetInquiryFormQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type InquiriesConfiguration_GetInquiryFormQuery = {
	__typename?: 'Query';
	getInquiryForm?: {
		__typename?: 'InquiryForm';
		sendConfirmationEmail: boolean;
		confirmationEmail?: string | null;
		redirectOnSuccessUrl?: string | null;
		fields?: Array<{
			__typename?: 'InquiryFormField';
			id: string;
			order: number;
			type: InquiryFormFieldType;
			label: string;
			required: boolean;
			options?: any | null;
			multiple?: boolean | null;
		}> | null;
		styles?: Array<{
			__typename?: 'InquiryFormStyle';
			type: InquiryFormStyleType;
			value: string;
		}> | null;
	} | null;
};

export type InquiriesConfiguration_CreateInquiryFormMutationVariables = Exact<{
	data: InquiryFormDataInput;
}>;

export type InquiriesConfiguration_CreateInquiryFormMutation = {
	__typename?: 'Mutation';
	createInquiryForm: {
		__typename?: 'InquiryForm';
		sendConfirmationEmail: boolean;
		confirmationEmail?: string | null;
		redirectOnSuccessUrl?: string | null;
		fields?: Array<{
			__typename?: 'InquiryFormField';
			id: string;
			order: number;
			type: InquiryFormFieldType;
			label: string;
			required: boolean;
			options?: any | null;
			multiple?: boolean | null;
		}> | null;
		styles?: Array<{
			__typename?: 'InquiryFormStyle';
			type: InquiryFormStyleType;
			value: string;
		}> | null;
	};
};

export type InquiriesConfiguration_UpdateInquiryFormMutationVariables = Exact<{
	data: InquiryFormDataInput;
}>;

export type InquiriesConfiguration_UpdateInquiryFormMutation = {
	__typename?: 'Mutation';
	updateInquiryForm: {
		__typename?: 'InquiryForm';
		sendConfirmationEmail: boolean;
		confirmationEmail?: string | null;
		redirectOnSuccessUrl?: string | null;
		fields?: Array<{
			__typename?: 'InquiryFormField';
			id: string;
			order: number;
			type: InquiryFormFieldType;
			label: string;
			required: boolean;
			options?: any | null;
			multiple?: boolean | null;
		}> | null;
		styles?: Array<{
			__typename?: 'InquiryFormStyle';
			type: InquiryFormStyleType;
			value: string;
		}> | null;
	};
};

export type CanvaSection_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type CanvaSection_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		user?: {
			__typename?: 'User';
			id: string;
			canvaToken?: {
				__typename?: 'CanvaOAuthToken';
				accessToken: string;
				expires: Date | string;
			} | null;
		} | null;
	} | null;
};

export type CanvaSection_RevokeCanvaTokenMutationVariables = Exact<{
	[key: string]: never;
}>;

export type CanvaSection_RevokeCanvaTokenMutation = {
	__typename?: 'Mutation';
	revokeCanvaToken: boolean;
};

export type CanvaSection_GetCanvaAuthorizationUrlQueryVariables = Exact<{
	[key: string]: never;
}>;

export type CanvaSection_GetCanvaAuthorizationUrlQuery = {
	__typename?: 'Query';
	getCanvaAuthorizationUrl: {
		__typename?: 'CanvaAuthorizationUrl';
		url: string;
		state: string;
		codeVerifier: string;
	};
};

export type ZapierSection_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type ZapierSection_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		RPCZapierUrl?: string | null;
	};
};

export type InviteModal_GetContactWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type InviteModal_GetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type InvoiceDetailInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	allowsGratuity: boolean;
	automatedRemindersEnabled: boolean;
	eventDate?: Date | string | null;
	uploadAttachment?: string | null;
	status: InvoiceStatus;
	isPastDue: boolean;
	title: string;
	sentAt?: Date | string | null;
	discountIsPercentage?: boolean | null;
	discountPercentage?: number | null;
	discountAmount?: number | null;
	gratuityAmount: number;
	approvedByPlanner?: boolean | null;
	notes?: string | null;
	attachmentUrl?: string | null;
	dueDate?: Date | string | null;
	totalAmount: number;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		status: ContactStatus;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			stripeCustomerId?: string | null;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
		name: string;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
		image?: string | null;
		updatedAt: Date | string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			role: TeamMemberRole;
			user?: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
			} | null;
			organization?: { __typename?: 'Organization'; id: string } | null;
		}> | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		dueDate?: Date | string | null;
		status?: InstallmentStatus | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
		scheduledPaymentDate?: Date | string | null;
		name?: string | null;
		refundDate?: Date | string | null;
		convenienceFee?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		scheduledPaymentMethod?: string | null;
		processor?: PaymentProcessor | null;
		percentageDue?: number | null;
		enteredAsPercentageAmount?: boolean | null;
		paymentNote?: string | null;
		refundNote?: string | null;
		paymentType?: PaymentType | null;
	}>;
	invoiceTemplate?: {
		__typename?: 'InvoiceTemplate';
		id: string;
		title: string;
		notes?: string | null;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		discountAmount: number;
		discountIsPercentage: boolean;
		discountPercentage: number;
		filename?: string | null;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	} | null;
};

export type InvoiceDetail_GetInvoiceWhereQueryVariables = Exact<{
	where: InvoiceWhereUniqueInput;
	data?: InputMaybe<InvoiceTokenInput>;
}>;

export type InvoiceDetail_GetInvoiceWhereQuery = {
	__typename?: 'Query';
	getInvoiceWhere?: {
		__typename?: 'ResponseObjectForGetInvoiceWhere';
		invoice: {
			__typename?: 'Invoice';
			id: string;
			allowsGratuity: boolean;
			automatedRemindersEnabled: boolean;
			eventDate?: Date | string | null;
			uploadAttachment?: string | null;
			status: InvoiceStatus;
			isPastDue: boolean;
			title: string;
			sentAt?: Date | string | null;
			discountIsPercentage?: boolean | null;
			discountPercentage?: number | null;
			discountAmount?: number | null;
			gratuityAmount: number;
			approvedByPlanner?: boolean | null;
			notes?: string | null;
			attachmentUrl?: string | null;
			dueDate?: Date | string | null;
			totalAmount: number;
			contact?: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				status: ContactStatus;
				vendor: {
					__typename?: 'Organization';
					id: string;
					name: string;
					image?: string | null;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
						user?: { __typename?: 'User'; id: string } | null;
					}> | null;
					services: Array<{ __typename?: 'Service'; name: string; id: string }>;
				};
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					stripeCustomerId?: string | null;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
									organization?: {
										__typename?: 'Organization';
										id: string;
										users?: Array<{
											__typename?: 'OrgUser';
											id: string;
											role: TeamMemberRole;
											user?: { __typename?: 'User'; id: string } | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
					organization?: {
						__typename?: 'Organization';
						id: string;
						services: Array<{
							__typename?: 'Service';
							id: string;
							name: string;
						}>;
					} | null;
				};
				customerSignatures?: Array<{
					__typename?: 'CustomerSignature';
					id: string;
					signature: {
						__typename?: 'Signature';
						id: string;
						signingDate?: Date | string | null;
						signer?: { __typename?: 'SignatureUser'; id: string } | null;
						contract?: {
							__typename?: 'SignatureContract';
							id: string;
							status: ContractStatus;
							dueDate: Date | string;
							title: string;
							guestToken?: string | null;
						} | null;
					};
				}> | null;
				invoices?: Array<{
					__typename?: 'Invoice';
					id: string;
					status: InvoiceStatus;
					title: string;
					guestToken?: string | null;
					paymentInstallments: Array<{
						__typename?: 'PaymentInstallment';
						id: string;
						status?: InstallmentStatus | null;
						dueDate?: Date | string | null;
						amountDue?: number | null;
						paymentDate?: Date | string | null;
					}>;
				}> | null;
				proposals?: Array<{
					__typename?: 'Proposal';
					id: string;
					status: ProposalStatus;
					title?: string | null;
					guestToken?: string | null;
					dueDate?: Date | string | null;
				}> | null;
			} | null;
			emailNotificationGroup?: {
				__typename?: 'EmailNotificationGroup';
				id: string;
				groupTitle: EmailNotificationGroupTitle;
				members: Array<{
					__typename?: 'ReducedUser';
					id?: string | null;
					email: string;
					userType: UserType;
					orgUser?: {
						__typename?: 'ReducedOrgUser';
						id: string;
						firstName: string;
						lastName: string;
						role: TeamMemberRole;
						organization?: {
							__typename?: 'ReducedOrganization';
							id?: string | null;
						} | null;
					} | null;
				}>;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				country?: Country | null;
				name: string;
				cardConvenienceFeePercentage: number;
				achConvenienceFeePercentage: number;
				image?: string | null;
				updatedAt: Date | string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					user?: {
						__typename?: 'User';
						id: string;
						email: string;
						userType: UserType;
					} | null;
					organization?: { __typename?: 'Organization'; id: string } | null;
				}> | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			} | null;
			lineItems: Array<{
				__typename?: 'LineItem';
				id: string;
				name: string;
				quantity: number;
				rate: number;
				taxPercentage: number;
				notes?: string | null;
			}>;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				dueDate?: Date | string | null;
				status?: InstallmentStatus | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
				scheduledPaymentDate?: Date | string | null;
				name?: string | null;
				refundDate?: Date | string | null;
				convenienceFee?: number | null;
				amountPaid?: number | null;
				gratuityPaid?: number | null;
				amountRefunded?: number | null;
				scheduledPaymentMethod?: string | null;
				processor?: PaymentProcessor | null;
				percentageDue?: number | null;
				enteredAsPercentageAmount?: boolean | null;
				paymentNote?: string | null;
				refundNote?: string | null;
				paymentType?: PaymentType | null;
			}>;
			invoiceTemplate?: {
				__typename?: 'InvoiceTemplate';
				id: string;
				title: string;
				notes?: string | null;
				allowsGratuity: boolean;
				automatedRemindersEnabled: boolean;
				discountAmount: number;
				discountIsPercentage: boolean;
				discountPercentage: number;
				filename?: string | null;
				lineItems: Array<{
					__typename?: 'InvoiceTemplateLineItem';
					id: string;
					order: number;
					name: string;
					rate: number;
					quantity: number;
					taxPercentage: number;
					notes?: string | null;
				}>;
				paymentInstallments: Array<{
					__typename?: 'InvoiceTemplatePaymentInstallment';
					id: string;
					name?: string | null;
					amountDue: number;
					enteredAsPercentageAmount: boolean;
					percentageDue: number;
				}>;
			} | null;
		};
	} | null;
};

export type InvoiceDetail_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type InvoiceDetail_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			country?: Country | null;
			automatedRemindersEnabled: boolean;
			cardConvenienceFeePercentage: number;
			achConvenienceFeePercentage: number;
			image?: string | null;
			name: string;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				firstName: string;
				lastName: string;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				} | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		} | null;
	} | null;
};

export type InvoiceEditButtonBarInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	automatedRemindersEnabled: boolean;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	title: string;
	totalAmount: number;
	discountAmount?: number | null;
	contact?: { __typename?: 'Contact'; id: string } | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		amountPaid?: number | null;
		amountDue?: number | null;
		gratuityPaid?: number | null;
		paymentDate?: Date | string | null;
		convenienceFee?: number | null;
	}>;
};

export type UseInvoiceEditButtonBarSaveButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	contact?: { __typename?: 'Contact'; id: string } | null;
};

export type UseInvoiceEditButtonBarSendButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	automatedRemindersEnabled: boolean;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	title: string;
	totalAmount: number;
	discountAmount?: number | null;
	contact?: { __typename?: 'Contact'; id: string } | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		amountPaid?: number | null;
		amountDue?: number | null;
		gratuityPaid?: number | null;
		paymentDate?: Date | string | null;
		convenienceFee?: number | null;
	}>;
};

export type InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationVariables =
	Exact<{
		data?: InputMaybe<SendOrResendInvoiceInput>;
		where: InvoiceWhereUniqueInput;
	}>;

export type InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation = {
	__typename?: 'Mutation';
	sendOrResendInvoice: {
		__typename?: 'Invoice';
		id: string;
		sentAt?: Date | string | null;
		status: InvoiceStatus;
		automatedRemindersEnabled: boolean;
		eventDate?: Date | string | null;
		dueDate?: Date | string | null;
		title: string;
		totalAmount: number;
		discountAmount?: number | null;
		contact?: { __typename?: 'Contact'; id: string } | null;
		lineItems: Array<{
			__typename?: 'LineItem';
			id: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
		}>;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			status?: InstallmentStatus | null;
			dueDate?: Date | string | null;
			amountPaid?: number | null;
			amountDue?: number | null;
			gratuityPaid?: number | null;
			paymentDate?: Date | string | null;
			convenienceFee?: number | null;
		}>;
	};
};

export type UseInvoiceEditButtonBarVoidButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
};

export type InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationVariables =
	Exact<{
		where: InvoiceWhereUniqueInput;
	}>;

export type InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation = {
	__typename?: 'Mutation';
	markInvoiceVoid: {
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
	};
};

export type InvoiceEditLineItemLineItemFragment = {
	__typename?: 'LineItem';
	id: string;
	name: string;
	rate: number;
	quantity: number;
	taxPercentage: number;
	notes?: string | null;
};

export type InvoiceEditLineItemInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	discountAmount?: number | null;
	discountPercentage?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
};

export type InvoiceEditLineItemsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	discountAmount?: number | null;
	discountPercentage?: number | null;
	organization?: {
		__typename?: 'Organization';
		country?: Country | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
};

export type InvoiceEditFileSelectorDisplayTextInvoiceFragment = {
	__typename?: 'Invoice';
	uploadAttachment?: string | null;
	status: InvoiceStatus;
};

export type InvoiceEditFileSelectorInvoiceFragment = {
	__typename?: 'Invoice';
	uploadAttachment?: string | null;
	status: InvoiceStatus;
};

export type InvoiceEditLineItemDiscountInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	discountPercentage?: number | null;
	discountIsPercentage?: boolean | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
};

export type InvoiceEditLineItemSummaryInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	discountAmount?: number | null;
	discountPercentage?: number | null;
	discountIsPercentage?: boolean | null;
	organization?: {
		__typename?: 'Organization';
		country?: Country | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
};

export type InvoiceEditNotesInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	notes?: string | null;
	status: InvoiceStatus;
};

export type InvoiceEditNotesAndLineItemSummaryInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	notes?: string | null;
	status: InvoiceStatus;
	discountAmount?: number | null;
	discountPercentage?: number | null;
	discountIsPercentage?: boolean | null;
	organization?: {
		__typename?: 'Organization';
		country?: Country | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
};

export type InvoiceEditPaymentInstallmentPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	status?: InstallmentStatus | null;
	name?: string | null;
	dueDate?: Date | string | null;
	amountDue?: number | null;
	percentageDue?: number | null;
	enteredAsPercentageAmount?: boolean | null;
};

export type InvoiceEditPaymentInstallmentInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		name?: string | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		percentageDue?: number | null;
		enteredAsPercentageAmount?: boolean | null;
	}>;
};

export type InvoiceEditRemainingBalanceInvoiceFragment = {
	__typename?: 'Invoice';
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		paymentDate?: Date | string | null;
	}>;
};

export type InvoiceEditPaymentInstallmentsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	discountAmount?: number | null;
	organization?: {
		__typename?: 'Organization';
		country?: Country | null;
	} | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		paymentDate?: Date | string | null;
		name?: string | null;
		percentageDue?: number | null;
		enteredAsPercentageAmount?: boolean | null;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
};

export type InvoiceEditApplyTemplateModalInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	invoiceTemplate?: {
		__typename?: 'InvoiceTemplate';
		id: string;
		title: string;
		notes?: string | null;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		discountAmount: number;
		discountIsPercentage: boolean;
		discountPercentage: number;
		filename?: string | null;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	} | null;
};

export type InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryVariables =
	Exact<{
		orderBy?: InputMaybe<
			| Array<InputMaybe<InvoiceTemplateOrderByInput>>
			| InputMaybe<InvoiceTemplateOrderByInput>
		>;
	}>;

export type InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery = {
	__typename?: 'Query';
	getInvoiceTemplatesWhere?: {
		__typename?: 'InvoiceTemplates';
		invoiceTemplates: Array<{
			__typename?: 'InvoiceTemplate';
			id: string;
			title: string;
			notes?: string | null;
			allowsGratuity: boolean;
			automatedRemindersEnabled: boolean;
			discountAmount: number;
			discountIsPercentage: boolean;
			discountPercentage: number;
			filename?: string | null;
			lineItems: Array<{
				__typename?: 'InvoiceTemplateLineItem';
				id: string;
				order: number;
				name: string;
				rate: number;
				quantity: number;
				taxPercentage: number;
				notes?: string | null;
			}>;
			paymentInstallments: Array<{
				__typename?: 'InvoiceTemplatePaymentInstallment';
				id: string;
				name?: string | null;
				amountDue: number;
				enteredAsPercentageAmount: boolean;
				percentageDue: number;
			}>;
		}>;
	} | null;
};

export type InvoiceEditApplyTemplateInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		processor?: PaymentProcessor | null;
		scheduledPaymentDate?: Date | string | null;
	}>;
	invoiceTemplate?: {
		__typename?: 'InvoiceTemplate';
		id: string;
		title: string;
		notes?: string | null;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		discountAmount: number;
		discountIsPercentage: boolean;
		discountPercentage: number;
		filename?: string | null;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	} | null;
};

export type InvoiceEditPresentationInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	title: string;
	eventDate?: Date | string | null;
	status: InvoiceStatus;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		processor?: PaymentProcessor | null;
		scheduledPaymentDate?: Date | string | null;
	}>;
	invoiceTemplate?: {
		__typename?: 'InvoiceTemplate';
		id: string;
		title: string;
		notes?: string | null;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		discountAmount: number;
		discountIsPercentage: boolean;
		discountPercentage: number;
		filename?: string | null;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	} | null;
};

export type InvoiceEditSettingsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	allowsGratuity: boolean;
	automatedRemindersEnabled: boolean;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
	}>;
};

export type InvoiceEditInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	allowsGratuity: boolean;
	automatedRemindersEnabled: boolean;
	eventDate?: Date | string | null;
	uploadAttachment?: string | null;
	status: InvoiceStatus;
	title: string;
	dueDate?: Date | string | null;
	totalAmount: number;
	discountAmount?: number | null;
	discountPercentage?: number | null;
	notes?: string | null;
	discountIsPercentage?: boolean | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
	organization?: {
		__typename?: 'Organization';
		country?: Country | null;
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			role: TeamMemberRole;
			organization?: { __typename?: 'Organization'; id: string } | null;
			user?: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
			} | null;
		}> | null;
	} | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		dueDate?: Date | string | null;
		status?: InstallmentStatus | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		convenienceFee?: number | null;
		processor?: PaymentProcessor | null;
		scheduledPaymentDate?: Date | string | null;
		name?: string | null;
		percentageDue?: number | null;
		enteredAsPercentageAmount?: boolean | null;
	}>;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
		name: string;
		notes?: string | null;
	}>;
	invoiceTemplate?: {
		__typename?: 'InvoiceTemplate';
		id: string;
		title: string;
		notes?: string | null;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		discountAmount: number;
		discountIsPercentage: boolean;
		discountPercentage: number;
		filename?: string | null;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	} | null;
};

export type InvoiceEdit_CreateDraftInvoiceMutationVariables = Exact<{
	data: InvoiceCreateInput;
}>;

export type InvoiceEdit_CreateDraftInvoiceMutation = {
	__typename?: 'Mutation';
	createDraftInvoice: {
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
		eventDate?: Date | string | null;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		uploadAttachment?: string | null;
		title: string;
		dueDate?: Date | string | null;
		totalAmount: number;
		discountAmount?: number | null;
		discountPercentage?: number | null;
		notes?: string | null;
		discountIsPercentage?: boolean | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			status: ContactStatus;
			firstName: string;
			lastName: string;
			companyName?: string | null;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			members: Array<{
				__typename?: 'ReducedUser';
				id?: string | null;
				email: string;
				userType: UserType;
				orgUser?: {
					__typename?: 'ReducedOrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					organization?: {
						__typename?: 'ReducedOrganization';
						id?: string | null;
					} | null;
				} | null;
			}>;
		} | null;
		organization?: {
			__typename?: 'Organization';
			country?: Country | null;
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				} | null;
			}> | null;
		} | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			dueDate?: Date | string | null;
			status?: InstallmentStatus | null;
			amountDue?: number | null;
			paymentDate?: Date | string | null;
			amountPaid?: number | null;
			gratuityPaid?: number | null;
			convenienceFee?: number | null;
			processor?: PaymentProcessor | null;
			scheduledPaymentDate?: Date | string | null;
			name?: string | null;
			percentageDue?: number | null;
			enteredAsPercentageAmount?: boolean | null;
		}>;
		lineItems: Array<{
			__typename?: 'LineItem';
			id: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
			name: string;
			notes?: string | null;
		}>;
		invoiceTemplate?: {
			__typename?: 'InvoiceTemplate';
			id: string;
			title: string;
			notes?: string | null;
			allowsGratuity: boolean;
			automatedRemindersEnabled: boolean;
			discountAmount: number;
			discountIsPercentage: boolean;
			discountPercentage: number;
			filename?: string | null;
			lineItems: Array<{
				__typename?: 'InvoiceTemplateLineItem';
				id: string;
				order: number;
				name: string;
				rate: number;
				quantity: number;
				taxPercentage: number;
				notes?: string | null;
			}>;
			paymentInstallments: Array<{
				__typename?: 'InvoiceTemplatePaymentInstallment';
				id: string;
				name?: string | null;
				amountDue: number;
				enteredAsPercentageAmount: boolean;
				percentageDue: number;
			}>;
		} | null;
	};
};

export type InvoiceEdit_UpdateInvoiceMutationVariables = Exact<{
	data: InvoiceUpdateInput;
	where: InvoiceWhereUniqueInput;
}>;

export type InvoiceEdit_UpdateInvoiceMutation = {
	__typename?: 'Mutation';
	updateInvoice?: {
		__typename?: 'Invoice';
		id: string;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		eventDate?: Date | string | null;
		uploadAttachment?: string | null;
		status: InvoiceStatus;
		title: string;
		dueDate?: Date | string | null;
		totalAmount: number;
		discountAmount?: number | null;
		discountPercentage?: number | null;
		notes?: string | null;
		discountIsPercentage?: boolean | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			status: ContactStatus;
			firstName: string;
			lastName: string;
			companyName?: string | null;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			members: Array<{
				__typename?: 'ReducedUser';
				id?: string | null;
				email: string;
				userType: UserType;
				orgUser?: {
					__typename?: 'ReducedOrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					organization?: {
						__typename?: 'ReducedOrganization';
						id?: string | null;
					} | null;
				} | null;
			}>;
		} | null;
		organization?: {
			__typename?: 'Organization';
			country?: Country | null;
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				} | null;
			}> | null;
		} | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			dueDate?: Date | string | null;
			status?: InstallmentStatus | null;
			amountDue?: number | null;
			paymentDate?: Date | string | null;
			amountPaid?: number | null;
			gratuityPaid?: number | null;
			convenienceFee?: number | null;
			processor?: PaymentProcessor | null;
			scheduledPaymentDate?: Date | string | null;
			name?: string | null;
			percentageDue?: number | null;
			enteredAsPercentageAmount?: boolean | null;
		}>;
		lineItems: Array<{
			__typename?: 'LineItem';
			id: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
			name: string;
			notes?: string | null;
		}>;
		invoiceTemplate?: {
			__typename?: 'InvoiceTemplate';
			id: string;
			title: string;
			notes?: string | null;
			allowsGratuity: boolean;
			automatedRemindersEnabled: boolean;
			discountAmount: number;
			discountIsPercentage: boolean;
			discountPercentage: number;
			filename?: string | null;
			lineItems: Array<{
				__typename?: 'InvoiceTemplateLineItem';
				id: string;
				order: number;
				name: string;
				rate: number;
				quantity: number;
				taxPercentage: number;
				notes?: string | null;
			}>;
			paymentInstallments: Array<{
				__typename?: 'InvoiceTemplatePaymentInstallment';
				id: string;
				name?: string | null;
				amountDue: number;
				enteredAsPercentageAmount: boolean;
				percentageDue: number;
			}>;
		} | null;
	} | null;
};

export type InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryVariables =
	Exact<{
		data: RequestAttachmentUploadUrlInput;
		where: InvoiceWhereUniqueInput;
	}>;

export type InvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery = {
	__typename?: 'Query';
	requestInvoiceAttachmentUploadUrl: {
		__typename?: 'UploadUrl';
		uploadURL?: string | null;
	};
};

export type InvoiceEditApplyTemplateModalInvoiceTemplateFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	title: string;
	notes?: string | null;
	allowsGratuity: boolean;
	automatedRemindersEnabled: boolean;
	discountAmount: number;
	discountIsPercentage: boolean;
	discountPercentage: number;
	filename?: string | null;
	lineItems: Array<{
		__typename?: 'InvoiceTemplateLineItem';
		id: string;
		order: number;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
	paymentInstallments: Array<{
		__typename?: 'InvoiceTemplatePaymentInstallment';
		id: string;
		name?: string | null;
		amountDue: number;
		enteredAsPercentageAmount: boolean;
		percentageDue: number;
	}>;
};

export type InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryVariables =
	Exact<{
		where: InvoiceTemplateWhereUniqueInput;
	}>;

export type InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery =
	{
		__typename?: 'Query';
		getInvoiceTemplateWhere?: {
			__typename?: 'InvoiceTemplate';
			id: string;
			title: string;
			notes?: string | null;
			allowsGratuity: boolean;
			automatedRemindersEnabled: boolean;
			discountAmount: number;
			discountIsPercentage: boolean;
			discountPercentage: number;
			filename?: string | null;
			lineItems: Array<{
				__typename?: 'InvoiceTemplateLineItem';
				id: string;
				order: number;
				name: string;
				rate: number;
				quantity: number;
				taxPercentage: number;
				notes?: string | null;
			}>;
			paymentInstallments: Array<{
				__typename?: 'InvoiceTemplatePaymentInstallment';
				id: string;
				name?: string | null;
				amountDue: number;
				enteredAsPercentageAmount: boolean;
				percentageDue: number;
			}>;
		} | null;
	};

export type UseLineItemsInvoiceEditLineItemFragment = {
	__typename?: 'LineItem';
	id: string;
	name: string;
	quantity: number;
	rate: number;
	taxPercentage: number;
	notes?: string | null;
};

export type UseLineItemsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
};

export type UsePaymentInstallmentsInvoiceEditLineItemFragment = {
	__typename?: 'LineItem';
	id: string;
	name: string;
	rate: number;
	quantity: number;
	taxPercentage: number;
};

export type UsePaymentInstallmentsInvoiceEditPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	name?: string | null;
	status?: InstallmentStatus | null;
	dueDate?: Date | string | null;
	amountDue?: number | null;
	enteredAsPercentageAmount?: boolean | null;
	percentageDue?: number | null;
};

export type UsePaymentInstallmentsInvoiceEditInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	discountAmount?: number | null;
	discountPercentage?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		enteredAsPercentageAmount?: boolean | null;
		percentageDue?: number | null;
	}>;
};

export type InvoiceTemplateEditButtonBarFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
};

export type UseInvoiceTemplateEditButtonBarDeleteButtonFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
};

export type InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationVariables =
	Exact<{
		where: InvoiceTemplateWhereUniqueInput;
	}>;

export type InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation =
	{
		__typename?: 'Mutation';
		deleteInvoiceTemplate: { __typename?: 'InvoiceTemplate'; id: string };
	};

export type UseInvoiceTemplateEditButtonBarSaveOrUseButtonFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
};

export type InvoiceTemplateEditDraggableLineItemInvoiceTemplateFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	discountAmount: number;
	lineItems: Array<{
		__typename?: 'InvoiceTemplateLineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
};

export type InvoiceTemplateEditLineItemFragment = {
	__typename?: 'InvoiceTemplateLineItem';
	id: string;
	name: string;
	rate: number;
	quantity: number;
	taxPercentage: number;
};

export type InvoiceTemplateEditLineItemInvoiceTemplateFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	discountAmount: number;
	lineItems: Array<{
		__typename?: 'InvoiceTemplateLineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
};

export type InvoiceTemplateEditLineItemsInvoiceTemplateFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	discountAmount: number;
	organization: { __typename?: 'Organization'; country?: Country | null };
	lineItems: Array<{
		__typename?: 'InvoiceTemplateLineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
};

export type InvoiceTemplateEditFileSelectorDisplayTextInvoiceFragment = {
	__typename?: 'InvoiceTemplate';
	filename?: string | null;
	status: InvoiceTemplateStatus;
};

export type InvoiceTemplateEditFileSelectorInvoiceFragment = {
	__typename?: 'InvoiceTemplate';
	filename?: string | null;
	status: InvoiceTemplateStatus;
};

export type InvoiceTemplateEditLineItemDiscountFragment = {
	__typename?: 'InvoiceTemplate';
	discountAmount: number;
	discountPercentage: number;
	discountIsPercentage: boolean;
};

export type InvoiceTemplateEditLineItemSummaryFragment = {
	__typename?: 'InvoiceTemplate';
	discountAmount: number;
	discountPercentage: number;
	discountIsPercentage: boolean;
};

export type InvoiceTemplateEditNotesAndLineItemSummaryFragment = {
	__typename?: 'InvoiceTemplate';
	notes?: string | null;
	discountAmount: number;
	discountPercentage: number;
	discountIsPercentage: boolean;
	filename?: string | null;
	status: InvoiceTemplateStatus;
};

export type CalculateInstallmentInvoiceTemplatePaymentInstallmentFragment = {
	__typename?: 'InvoiceTemplatePaymentInstallment';
	id: string;
	name?: string | null;
	amountDue: number;
};

export type InvoiceTemplateEditPaymentInstallmentInvoiceTemplateFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	paymentInstallments: Array<{
		__typename?: 'InvoiceTemplatePaymentInstallment';
		id: string;
		name?: string | null;
		amountDue: number;
	}>;
};

export type InvoiceTemplateEditRemainingBalanceFragment = {
	__typename?: 'InvoiceTemplatePaymentInstallment';
	amountDue: number;
};

export type InvoiceTemplateEditPaymentInstallmentsInvoiceTemplatePaymentInstallmentFragment =
	{
		__typename?: 'InvoiceTemplatePaymentInstallment';
		id: string;
		amountDue: number;
		name?: string | null;
	};

export type InvoiceTemplateEditPaymentInstallmentsFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	organization: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
	};
	paymentInstallments: Array<{
		__typename?: 'InvoiceTemplatePaymentInstallment';
		id: string;
		name?: string | null;
		amountDue: number;
	}>;
};

export type InvoiceTemplateEditPresentationFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	title: string;
};

export type InvoiceTemplateEditPresentation_GetGlobalVariablesQueryVariables =
	Exact<{ [key: string]: never }>;

export type InvoiceTemplateEditPresentation_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		AutomatedNotificationsSupportUrl?: string | null;
	};
};

export type InvoiceTemplateEditFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	allowsGratuity: boolean;
	automatedRemindersEnabled: boolean;
	notes?: string | null;
	filename?: string | null;
	title: string;
	discountAmount: number;
	discountPercentage: number;
	discountIsPercentage: boolean;
	status: InvoiceTemplateStatus;
	lineItems: Array<{
		__typename?: 'InvoiceTemplateLineItem';
		id: string;
		order: number;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
	organization: {
		__typename?: 'Organization';
		country?: Country | null;
		id: string;
	};
	paymentInstallments: Array<{
		__typename?: 'InvoiceTemplatePaymentInstallment';
		id: string;
		name?: string | null;
		amountDue: number;
		enteredAsPercentageAmount: boolean;
		percentageDue: number;
	}>;
};

export type InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryVariables = Exact<{
	where: InvoiceTemplateWhereUniqueInput;
}>;

export type InvoiceTemplateEdit_GetInvoiceTemplateWhereQuery = {
	__typename?: 'Query';
	getInvoiceTemplateWhere?: {
		__typename?: 'InvoiceTemplate';
		id: string;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		notes?: string | null;
		filename?: string | null;
		title: string;
		discountAmount: number;
		discountPercentage: number;
		discountIsPercentage: boolean;
		status: InvoiceTemplateStatus;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			quantity: number;
			rate: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		organization: {
			__typename?: 'Organization';
			country?: Country | null;
			id: string;
		};
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	} | null;
};

export type InvoiceTemplateEdit_CreateInvoiceTemplateMutationVariables = Exact<{
	data: InvoiceTemplateCreateInput;
}>;

export type InvoiceTemplateEdit_CreateInvoiceTemplateMutation = {
	__typename?: 'Mutation';
	createInvoiceTemplate: {
		__typename?: 'InvoiceTemplate';
		id: string;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		notes?: string | null;
		filename?: string | null;
		title: string;
		discountAmount: number;
		discountPercentage: number;
		discountIsPercentage: boolean;
		status: InvoiceTemplateStatus;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			quantity: number;
			rate: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		organization: {
			__typename?: 'Organization';
			country?: Country | null;
			id: string;
		};
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	};
};

export type InvoiceTemplateEdit_UpdateInvoiceTemplateMutationVariables = Exact<{
	data: InvoiceTemplateUpdateInput;
	where: InvoiceTemplateWhereUniqueInput;
}>;

export type InvoiceTemplateEdit_UpdateInvoiceTemplateMutation = {
	__typename?: 'Mutation';
	updateInvoiceTemplate: {
		__typename?: 'InvoiceTemplate';
		id: string;
		allowsGratuity: boolean;
		automatedRemindersEnabled: boolean;
		notes?: string | null;
		filename?: string | null;
		title: string;
		discountAmount: number;
		discountPercentage: number;
		discountIsPercentage: boolean;
		status: InvoiceTemplateStatus;
		lineItems: Array<{
			__typename?: 'InvoiceTemplateLineItem';
			id: string;
			order: number;
			name: string;
			quantity: number;
			rate: number;
			taxPercentage: number;
			notes?: string | null;
		}>;
		organization: {
			__typename?: 'Organization';
			country?: Country | null;
			id: string;
		};
		paymentInstallments: Array<{
			__typename?: 'InvoiceTemplatePaymentInstallment';
			id: string;
			name?: string | null;
			amountDue: number;
			enteredAsPercentageAmount: boolean;
			percentageDue: number;
		}>;
	};
};

export type InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationVariables =
	Exact<{
		data: RequestAttachmentUploadUrlInput;
		where: InvoiceTemplateWhereUniqueInput;
	}>;

export type InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation =
	{
		__typename?: 'Mutation';
		requestInvoiceTemplateAttachmentUploadUrl: {
			__typename?: 'UploadUrl';
			uploadURL?: string | null;
		};
	};

export type InvoiceTemplateEditUseLineItemsFragment = {
	__typename?: 'InvoiceTemplateLineItem';
	id: string;
	order: number;
	name: string;
	quantity: number;
	rate: number;
	taxPercentage: number;
	notes?: string | null;
};

export type InvoiceTemplateEditUseLineItemsInvoiceTemplateFragment = {
	__typename?: 'InvoiceTemplate';
	lineItems: Array<{
		__typename?: 'InvoiceTemplateLineItem';
		id: string;
		order: number;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
};

export type UseInvoiceTemplatePaymentInstallmentsFragment = {
	__typename?: 'InvoiceTemplatePaymentInstallment';
	id: string;
	name?: string | null;
	amountDue: number;
	enteredAsPercentageAmount: boolean;
	percentageDue: number;
};

export type UsePaymentInstallmentsInvoiceInvoiceTemplateFragment = {
	__typename?: 'InvoiceTemplate';
	discountAmount: number;
	discountPercentage: number;
	paymentInstallments: Array<{
		__typename?: 'InvoiceTemplatePaymentInstallment';
		id: string;
		name?: string | null;
		amountDue: number;
		enteredAsPercentageAmount: boolean;
		percentageDue: number;
	}>;
};

export type InvoiceViewInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	isPastDue: boolean;
	title: string;
	sentAt?: Date | string | null;
	eventDate?: Date | string | null;
	uploadAttachment?: string | null;
	discountIsPercentage?: boolean | null;
	discountPercentage?: number | null;
	discountAmount?: number | null;
	allowsGratuity: boolean;
	gratuityAmount: number;
	approvedByPlanner?: boolean | null;
	automatedRemindersEnabled: boolean;
	notes?: string | null;
	attachmentUrl?: string | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			stripeCustomerId?: string | null;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
		name: string;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
		image?: string | null;
		updatedAt: Date | string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		dueDate?: Date | string | null;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
		name?: string | null;
		amountDue?: number | null;
		paymentDate?: Date | string | null;
		refundDate?: Date | string | null;
		convenienceFee?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		scheduledPaymentMethod?: string | null;
		paymentNote?: string | null;
		refundNote?: string | null;
		processor?: PaymentProcessor | null;
		paymentType?: PaymentType | null;
	}>;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type InvoiceViewOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	image?: string | null;
	name: string;
	updatedAt: Date | string;
};

export type InvoiceViewPaymentModalContentInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	isPastDue: boolean;
	allowsGratuity: boolean;
	discountAmount?: number | null;
	gratuityAmount: number;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		country?: Country | null;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		amountDue?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		paymentDate?: Date | string | null;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
	}>;
};

export type UsePaymentSectionPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	amountDue?: number | null;
	amountPaid?: number | null;
	gratuityPaid?: number | null;
	paymentDate?: Date | string | null;
	status?: InstallmentStatus | null;
	scheduledPaymentDate?: Date | string | null;
};

export type UsePaymentSectionInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	isPastDue: boolean;
	allowsGratuity: boolean;
	discountAmount?: number | null;
	gratuityAmount: number;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		country?: Country | null;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		amountDue?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		paymentDate?: Date | string | null;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
	}>;
};

export type PaymentSection_CreateSecretsForInvoicePaymentMutationVariables =
	Exact<{
		data: CreateSecretsForInvoicePaymentInput;
	}>;

export type PaymentSection_CreateSecretsForInvoicePaymentMutation = {
	__typename?: 'Mutation';
	createSecretsForInvoicePayment: {
		__typename?: 'PaymentSessionSecrets';
		customerSecret?: string | null;
		invoiceId: string;
		currency: string;
		onBehalfOf?: string | null;
		excludedPaymentMethodTypes: Array<string>;
	};
};

export type PaymentSection_CreateIntentForInvoicePaymentMutationVariables =
	Exact<{
		data: CreateIntentForInvoicePaymentInput;
	}>;

export type PaymentSection_CreateIntentForInvoicePaymentMutation = {
	__typename?: 'Mutation';
	createIntentForInvoicePayment: {
		__typename?: 'PaymentIntent';
		id: string;
		clientSecret: string;
		amount: number;
	};
};

export type PaymentSection_GetPaymentSourcesForCustomerQueryVariables = Exact<{
	where: UserByIdUniqueInput;
}>;

export type PaymentSection_GetPaymentSourcesForCustomerQuery = {
	__typename?: 'Query';
	getPaymentSourcesForCustomer: {
		__typename?: 'SourcesWithDefaultSource';
		default_source?: string | null;
		data?: Array<{
			__typename?: 'Source';
			id: string;
			bank_name?: string | null;
			object: string;
			last4?: string | null;
			brand?: string | null;
			metadata?: Array<{
				__typename?: 'ReturningMetaData';
				key?: string | null;
				value?: string | null;
			} | null> | null;
		}> | null;
	};
};

export type PaymentSection_UpdateInvoiceFromPaymentSessionMutationVariables =
	Exact<{
		data: UpdateInvoiceFromPaymentSessionInput;
	}>;

export type PaymentSection_UpdateInvoiceFromPaymentSessionMutation = {
	__typename?: 'Mutation';
	updateInvoiceFromPaymentSession: {
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
		isPastDue: boolean;
		allowsGratuity: boolean;
		discountAmount?: number | null;
		gratuityAmount: number;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			country?: Country | null;
			cardConvenienceFeePercentage: number;
			achConvenienceFeePercentage: number;
		} | null;
		lineItems: Array<{
			__typename?: 'LineItem';
			id: string;
			name: string;
			taxPercentage: number;
			rate: number;
			quantity: number;
		}>;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			amountDue?: number | null;
			amountPaid?: number | null;
			gratuityPaid?: number | null;
			paymentDate?: Date | string | null;
			status?: InstallmentStatus | null;
			scheduledPaymentDate?: Date | string | null;
		}>;
	};
};

export type PaymentSection_UpdateInvoiceAutoPayMutationVariables = Exact<{
	where: InvoiceWhereUniqueInput;
	data: InvoiceAutoPayUpdateCustomInput;
}>;

export type PaymentSection_UpdateInvoiceAutoPayMutation = {
	__typename?: 'Mutation';
	updateInvoiceAutoPay: {
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
		isPastDue: boolean;
		allowsGratuity: boolean;
		discountAmount?: number | null;
		gratuityAmount: number;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			status?: InstallmentStatus | null;
			scheduledPaymentDate?: Date | string | null;
			amountDue?: number | null;
			amountPaid?: number | null;
			gratuityPaid?: number | null;
			paymentDate?: Date | string | null;
		}>;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			country?: Country | null;
			cardConvenienceFeePercentage: number;
			achConvenienceFeePercentage: number;
		} | null;
		lineItems: Array<{
			__typename?: 'LineItem';
			id: string;
			name: string;
			taxPercentage: number;
			rate: number;
			quantity: number;
		}>;
	};
};

export type InvoiceViewButtonBarInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	approvedByPlanner?: boolean | null;
	automatedRemindersEnabled: boolean;
	discountAmount?: number | null;
	isPastDue: boolean;
	allowsGratuity: boolean;
	gratuityAmount: number;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			organization?: {
				__typename?: 'Organization';
				id: string;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			} | null;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
		name: string;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		scheduledPaymentDate?: Date | string | null;
		amountDue?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		paymentDate?: Date | string | null;
	}>;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		country?: Country | null;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewButtonBarApproveButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	approvedByPlanner?: boolean | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
};

export type InvoiceViewButtonBar_ApproveInvoiceMutationVariables = Exact<{
	where: InvoiceWhereInputWithGuestToken;
}>;

export type InvoiceViewButtonBar_ApproveInvoiceMutation = {
	__typename?: 'Mutation';
	approveInvoice: {
		__typename?: 'Invoice';
		id: string;
		approvedByPlanner?: boolean | null;
	};
};

export type InvoiceViewButtonBarExportButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
};

export type InvoiceViewButtonBar_ExportInvoiceQueryVariables = Exact<{
	where: InvoiceWhereUniqueInput;
	data: InvoiceExportInput;
}>;

export type InvoiceViewButtonBar_ExportInvoiceQuery = {
	__typename?: 'Query';
	exportInvoice?: { __typename?: 'InvoiceUrl'; url?: string | null } | null;
};

export type InvoiceViewButtonBarPayButtonPaymentInstallmentsFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	status?: InstallmentStatus | null;
	scheduledPaymentDate?: Date | string | null;
	dueDate?: Date | string | null;
};

export type InvoiceViewButtonBarPayButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	isPastDue: boolean;
	allowsGratuity: boolean;
	discountAmount?: number | null;
	gratuityAmount: number;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
		dueDate?: Date | string | null;
		amountDue?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		paymentDate?: Date | string | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			organization?: {
				__typename?: 'Organization';
				id: string;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			} | null;
		};
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		country?: Country | null;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
};

export type InvoiceViewButtonBarSendResendButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	automatedRemindersEnabled: boolean;
	discountAmount?: number | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
	}>;
	organization?: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewButtonBar_SendOrResendInvoiceMutationVariables = Exact<{
	where: InvoiceWhereUniqueInput;
	data?: InputMaybe<SendOrResendInvoiceInput>;
}>;

export type InvoiceViewButtonBar_SendOrResendInvoiceMutation = {
	__typename?: 'Mutation';
	sendOrResendInvoice: {
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
		title: string;
		totalAmount: number;
		discountAmount?: number | null;
		lineItems: Array<{
			__typename?: 'LineItem';
			id: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
		}>;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			status?: InstallmentStatus | null;
			dueDate?: Date | string | null;
		}>;
	};
};

export type InvoiceViewButtonBarVoidButtonInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	organization?: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationVariables =
	Exact<{
		where: InvoiceWhereUniqueInput;
	}>;

export type InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation = {
	__typename?: 'Mutation';
	markInvoiceVoid: {
		__typename?: 'Invoice';
		id: string;
		status: InvoiceStatus;
	};
};

export type InvoiceViewHistoryItemInvoiceOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
};

export type InvoiceViewHistoryItemEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	message?: string | null;
	createdAt: Date | string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
			} | null;
		};
	} | null;
	plannerUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
	} | null;
	paymentInstallments?: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
		status?: InstallmentStatus | null;
		convenienceFee?: number | null;
		amountPaid?: number | null;
		amountDue?: number | null;
		gratuityPaid?: number | null;
		paymentDate?: Date | string | null;
	}> | null;
};

export type InvoiceViewHistoryItemInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							user?: { __typename?: 'User'; id: string } | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewInvoice_GetInvoiceHistoryQueryVariables = Exact<{
	where?: InputMaybe<EventWhereInput>;
	orderBy?: InputMaybe<
		Array<InputMaybe<EventOrderByInput>> | InputMaybe<EventOrderByInput>
	>;
}>;

export type InvoiceViewInvoice_GetInvoiceHistoryQuery = {
	__typename?: 'Query';
	getEventsWhere?: Array<{
		__typename?: 'Event';
		id: string;
		category: EventCategory;
		message?: string | null;
		createdAt: Date | string;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
				} | null;
			};
		} | null;
		plannerUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
		paymentInstallments?: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			name?: string | null;
			status?: InstallmentStatus | null;
			convenienceFee?: number | null;
			amountPaid?: number | null;
			amountDue?: number | null;
			gratuityPaid?: number | null;
			paymentDate?: Date | string | null;
		}> | null;
	}> | null;
};

export type InvoiceViewHistoryInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
};

export type InvoiceViewLineItemsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
		notes?: string | null;
	}>;
};

export type InvoiceViewPaymentInstallmentDetailsModalPaymentInstallmentFragment =
	{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		paymentDate?: Date | string | null;
		gratuityPaid?: number | null;
		paymentNote?: string | null;
		amountRefunded?: number | null;
		refundDate?: Date | string | null;
		refundNote?: string | null;
		paymentType?: PaymentType | null;
		processor?: PaymentProcessor | null;
		scheduledPaymentDate?: Date | string | null;
	};

export type InvoiceViewPaymentInstallmentDetailsModalInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		paymentDate?: Date | string | null;
		gratuityPaid?: number | null;
		paymentNote?: string | null;
		amountRefunded?: number | null;
		refundDate?: Date | string | null;
		refundNote?: string | null;
		paymentType?: PaymentType | null;
		processor?: PaymentProcessor | null;
		scheduledPaymentDate?: Date | string | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		country?: Country | null;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewPaymentInstallmentPaymentModalInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
		amountDue?: number | null;
		dueDate?: Date | string | null;
		paymentDate?: Date | string | null;
		refundDate?: Date | string | null;
		convenienceFee?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		status?: InstallmentStatus | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewPaymentInstallmentPaymentModalFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	name?: string | null;
	amountDue?: number | null;
	status?: InstallmentStatus | null;
	dueDate?: Date | string | null;
	processor?: PaymentProcessor | null;
	paymentDate?: Date | string | null;
	paymentType?: PaymentType | null;
	paymentNote?: string | null;
	scheduledPaymentDate?: Date | string | null;
};

export type InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationVariables =
	Exact<{
		data: UpdatePaidInstallmentInput;
		where: PaymentInstallmentWhereUniqueInput;
	}>;

export type InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation =
	{
		__typename?: 'Mutation';
		updatePaidInstallment: {
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				name?: string | null;
				amountDue?: number | null;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				processor?: PaymentProcessor | null;
				paymentDate?: Date | string | null;
				paymentType?: PaymentType | null;
				paymentNote?: string | null;
				scheduledPaymentDate?: Date | string | null;
			}>;
		};
	};

export type InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationVariables =
	Exact<{
		data: RecordOfflinePaymentInput;
		where: PaymentInstallmentWhereUniqueInput;
	}>;

export type InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation =
	{
		__typename?: 'Mutation';
		recordOfflinePayment: {
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			isPastDue: boolean;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				name?: string | null;
				amountDue?: number | null;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				processor?: PaymentProcessor | null;
				paymentDate?: Date | string | null;
				paymentType?: PaymentType | null;
				paymentNote?: string | null;
				scheduledPaymentDate?: Date | string | null;
			}>;
		};
	};

export type InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationVariables =
	Exact<{
		data: RecordOfflinePaymentOrRefundInput;
		where: PaymentInstallmentWhereUniqueInput;
	}>;

export type InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation =
	{
		__typename?: 'Mutation';
		unrecordOfflinePaymentOrRefund: {
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			isPastDue: boolean;
		};
	};

export type InvoiceViewPaymentInstallmentRefundModalPaymentInstallmentFragment =
	{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		paymentDate?: Date | string | null;
		processor?: PaymentProcessor | null;
		amountRefunded?: number | null;
		refundDate?: Date | string | null;
		refundNote?: string | null;
		paymentType?: PaymentType | null;
		scheduledPaymentDate?: Date | string | null;
	};

export type InvoiceViewPaymentInstallmentRefundModalInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
		amountDue?: number | null;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
		paymentDate?: Date | string | null;
		processor?: PaymentProcessor | null;
		amountRefunded?: number | null;
		refundDate?: Date | string | null;
		refundNote?: string | null;
		paymentType?: PaymentType | null;
		scheduledPaymentDate?: Date | string | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
	} | null;
};

export type InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationVariables =
	Exact<{
		data: RefundInstallmentInput;
	}>;

export type InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation =
	{
		__typename?: 'Mutation';
		refundInstallment: {
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				name?: string | null;
				amountDue?: number | null;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				paymentDate?: Date | string | null;
				processor?: PaymentProcessor | null;
				amountRefunded?: number | null;
				refundDate?: Date | string | null;
				refundNote?: string | null;
				paymentType?: PaymentType | null;
				scheduledPaymentDate?: Date | string | null;
			}>;
		};
	};

export type InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationVariables =
	Exact<{
		data: UpdateRefundedInstallmentInput;
		where: PaymentInstallmentWhereUniqueInput;
	}>;

export type InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation =
	{
		__typename?: 'Mutation';
		updateRefundedInstallment: {
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				name?: string | null;
				amountDue?: number | null;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				paymentDate?: Date | string | null;
				processor?: PaymentProcessor | null;
				amountRefunded?: number | null;
				refundDate?: Date | string | null;
				refundNote?: string | null;
				paymentType?: PaymentType | null;
				scheduledPaymentDate?: Date | string | null;
			}>;
		};
	};

export type InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationVariables =
	Exact<{
		data: RecordOfflineRefundInput;
		where: PaymentInstallmentWhereUniqueInput;
	}>;

export type InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation =
	{
		__typename?: 'Mutation';
		refundOfflinePayment: {
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				name?: string | null;
				amountDue?: number | null;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				paymentDate?: Date | string | null;
				processor?: PaymentProcessor | null;
				amountRefunded?: number | null;
				refundDate?: Date | string | null;
				refundNote?: string | null;
				paymentType?: PaymentType | null;
				scheduledPaymentDate?: Date | string | null;
			}>;
		};
	};

export type InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationVariables =
	Exact<{
		data: RecordOfflinePaymentOrRefundInput;
		where: PaymentInstallmentWhereUniqueInput;
	}>;

export type InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation =
	{
		__typename?: 'Mutation';
		unrecordOfflinePaymentOrRefund: {
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			isPastDue: boolean;
		};
	};

export type InvoiceViewPaymentInstallmentStatusFragment = {
	__typename?: 'PaymentInstallment';
	status?: InstallmentStatus | null;
	scheduledPaymentDate?: Date | string | null;
};

export type InvoiceViewPaymentInstallmentHeaderInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
	}>;
};

export type InvoiceViewPaymentMethodPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	status?: InstallmentStatus | null;
	paymentType?: PaymentType | null;
	processor?: PaymentProcessor | null;
};

export type InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryVariables =
	Exact<{
		where: PaymentInstallmentWhereUniqueInput;
		data?: InputMaybe<InvoiceTokenInput>;
	}>;

export type InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery = {
	__typename?: 'Query';
	getPaymentInstallmentDetails: {
		__typename?: 'PaymentInstallmentDetails';
		type?: string | null;
		last4?: string | null;
	};
};

export type InvoiceViewPaymentInstallmentsSubMenuPaymentInstallmentsFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	status?: InstallmentStatus | null;
};

export type InvoiceViewPaymentInstallmentsSubMenuInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	organization?: {
		__typename?: 'Organization';
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewPaymentInstallmentsLineItemsFragment = {
	__typename?: 'LineItem';
	id: string;
	name: string;
	rate: number;
	quantity: number;
	taxPercentage: number;
};

export type InvoiceViewPaymentInstallmentsInstallmentsFragment = {
	__typename?: 'PaymentInstallment';
	id: string;
	name?: string | null;
	convenienceFee?: number | null;
	amountPaid?: number | null;
	amountRefunded?: number | null;
	status?: InstallmentStatus | null;
	amountDue?: number | null;
	gratuityPaid?: number | null;
	dueDate?: Date | string | null;
	paymentDate?: Date | string | null;
	paymentNote?: string | null;
	refundDate?: Date | string | null;
	refundNote?: string | null;
	scheduledPaymentDate?: Date | string | null;
	processor?: PaymentProcessor | null;
	paymentType?: PaymentType | null;
};

export type InvoiceViewPaymentInstallmentsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	discountPercentage?: number | null;
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		taxPercentage: number;
		rate: number;
		quantity: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
		name?: string | null;
		amountDue?: number | null;
		dueDate?: Date | string | null;
		paymentDate?: Date | string | null;
		refundDate?: Date | string | null;
		convenienceFee?: number | null;
		amountPaid?: number | null;
		gratuityPaid?: number | null;
		amountRefunded?: number | null;
		paymentNote?: string | null;
		refundNote?: string | null;
		processor?: PaymentProcessor | null;
		paymentType?: PaymentType | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
};

export type InvoiceViewBillToInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: { __typename?: 'User'; id: string; email: string };
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
};

export type InvoiceAttachmentInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	uploadAttachment?: string | null;
	attachmentUrl?: string | null;
};

export type InvoiceAttachment_GetInvoiceWhereQueryVariables = Exact<{
	where: InvoiceWhereUniqueInput;
	data?: InputMaybe<InvoiceTokenInput>;
}>;

export type InvoiceAttachment_GetInvoiceWhereQuery = {
	__typename?: 'Query';
	getInvoiceWhere?: {
		__typename?: 'ResponseObjectForGetInvoiceWhere';
		invoice: {
			__typename?: 'Invoice';
			id: string;
			uploadAttachment?: string | null;
			attachmentUrl?: string | null;
		};
	} | null;
};

export type InvoiceViewLineItemSummaryInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	discountIsPercentage?: boolean | null;
	discountPercentage?: number | null;
	discountAmount?: number | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
	} | null;
};

export type InvoiceViewNotesInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	notes?: string | null;
};

export type InvoiceViewNotesAndLineItemSummaryInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	notes?: string | null;
	discountIsPercentage?: boolean | null;
	discountPercentage?: number | null;
	discountAmount?: number | null;
	uploadAttachment?: string | null;
	attachmentUrl?: string | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		name: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
	} | null;
};

export type InvoiceViewStatusInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	isPastDue: boolean;
	contact?: {
		__typename?: 'Contact';
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							user?: { __typename?: 'User'; id: string } | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
	} | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		dueDate?: Date | string | null;
		status?: InstallmentStatus | null;
	}>;
};

export type InvoiceViewPresentationInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	isPastDue: boolean;
	title: string;
	sentAt?: Date | string | null;
	eventDate?: Date | string | null;
	uploadAttachment?: string | null;
	discountIsPercentage?: boolean | null;
	discountPercentage?: number | null;
	discountAmount?: number | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		name: string;
		updatedAt: Date | string;
	} | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		dueDate?: Date | string | null;
		status?: InstallmentStatus | null;
	}>;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type InvoiceViewPresentationOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	image?: string | null;
	name: string;
	updatedAt: Date | string;
};

export type InvoiceViewPresentation_GetSharableInvoiceLinkQueryVariables =
	Exact<{
		where: InvoiceWhereUniqueInput;
	}>;

export type InvoiceViewPresentation_GetSharableInvoiceLinkQuery = {
	__typename?: 'Query';
	getSharableInvoiceLink: string;
};

export type InvoiceViewAutoPayFormInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
	} | null;
};

export type InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery = {
	__typename?: 'Query';
	getStripePaymentCapabilities?: {
		__typename?: 'AccountCapabilities';
		card_payments?: string | null;
		acss_debit_payments?: string | null;
	} | null;
};

export type InvoiceViewAutoPayFormOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	cardConvenienceFeePercentage: number;
	achConvenienceFeePercentage: number;
};

export type UseInvoiceAutoPayUpdateInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
	} | null;
};

export type InvoiceViewAutopayInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
		scheduledPaymentMethod?: string | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			stripeCustomerId?: string | null;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
		name: string;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
	} | null;
};

export type UseInvoiceAutopayInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			stripeCustomerId?: string | null;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							user?: { __typename?: 'User'; id: string } | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
	} | null;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
		scheduledPaymentMethod?: string | null;
	}>;
	organization?: { __typename?: 'Organization'; id: string } | null;
};

export type InvoiceAutopay_UpdateInvoiceAutopayMutationVariables = Exact<{
	where: InvoiceWhereUniqueInput;
	data: InvoiceAutoPayUpdateCustomInput;
}>;

export type InvoiceAutopay_UpdateInvoiceAutopayMutation = {
	__typename?: 'Mutation';
	updateInvoiceAutoPay: {
		__typename?: 'Invoice';
		id: string;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: {
				__typename?: 'User';
				id: string;
				stripeCustomerId?: string | null;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								user?: { __typename?: 'User'; id: string } | null;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
		} | null;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			status?: InstallmentStatus | null;
			scheduledPaymentDate?: Date | string | null;
			scheduledPaymentMethod?: string | null;
		}>;
		organization?: { __typename?: 'Organization'; id: string } | null;
	};
};

export type UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryVariables =
	Exact<{
		where?: InputMaybe<PaymentMethodSessionSecretsInput>;
	}>;

export type UseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery = {
	__typename?: 'Query';
	getPaymentMethodSessionSecrets: {
		__typename?: 'PaymentMethodSessionSecrets';
		clientSecret?: string | null;
		customerSessionClientSecret?: string | null;
	};
};

export type InvoiceViewInvoiceTotalsPaymentInstallmentFragment = {
	__typename?: 'PaymentInstallment';
	status?: InstallmentStatus | null;
	amountDue?: number | null;
	amountPaid?: number | null;
	convenienceFee?: number | null;
	amountRefunded?: number | null;
	paymentDate?: Date | string | null;
};

export type InvoiceViewTotalsInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							user?: { __typename?: 'User'; id: string } | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		status?: InstallmentStatus | null;
		amountDue?: number | null;
		amountPaid?: number | null;
		convenienceFee?: number | null;
		amountRefunded?: number | null;
		paymentDate?: Date | string | null;
	}>;
};

export type InvoiceViewTotalsAndAutopayInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	status: InvoiceStatus;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
		scheduledPaymentMethod?: string | null;
		amountDue?: number | null;
		amountPaid?: number | null;
		convenienceFee?: number | null;
		amountRefunded?: number | null;
		paymentDate?: Date | string | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			stripeCustomerId?: string | null;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		country?: Country | null;
		name: string;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		}> | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		quantity: number;
		rate: number;
		taxPercentage: number;
	}>;
};

export type UseInvoiceMetrics_PaymentsSummaryFragment = {
	__typename?: 'PaymentsSummary';
	totalInvoicesPaid: string;
	totalAmountUpcoming: string;
	totalInvoicesOverdue: string;
};

export type UseInvoiceMetrics_GetDashboardStatsForOrgQueryVariables = Exact<{
	where: DashboardWhereInput;
}>;

export type UseInvoiceMetrics_GetDashboardStatsForOrgQuery = {
	__typename?: 'Query';
	getDashboardStatsForOrg?: {
		__typename?: 'OrgDashboardStats';
		paymentsSummary: {
			__typename?: 'PaymentsSummary';
			totalInvoicesPaid: string;
			totalAmountUpcoming: string;
			totalInvoicesOverdue: string;
		};
	} | null;
};

export type InvoiceTableSubmenu_GetSharableInvoiceLinkQueryVariables = Exact<{
	where: InvoiceWhereUniqueInput;
}>;

export type InvoiceTableSubmenu_GetSharableInvoiceLinkQuery = {
	__typename?: 'Query';
	getSharableInvoiceLink: string;
};

export type UseMuiInvoicesTable_ExportInvoicesQueryVariables = Exact<{
	data: ExportInvoicesDataInput;
}>;

export type UseMuiInvoicesTable_ExportInvoicesQuery = {
	__typename?: 'Query';
	exportInvoices: string;
};

export type InvoicesTableFragment = {
	__typename?: 'Invoice';
	id: string;
	title: string;
	sentAt?: Date | string | null;
	status: InvoiceStatus;
	isPastDue: boolean;
	totalAmount: number;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	automatedRemindersEnabled: boolean;
	discountAmount?: number | null;
	sentByUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		user?: { __typename?: 'User'; id: string } | null;
	} | null;
	lineItems: Array<{
		__typename?: 'LineItem';
		id: string;
		rate: number;
		quantity: number;
		taxPercentage: number;
	}>;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		dueDate?: Date | string | null;
	}>;
	contact?: {
		__typename?: 'Contact';
		id: string;
		status: ContactStatus;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
		};
	} | null;
	quickPayment?: { __typename?: 'QuickPayment'; id?: string | null } | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		updatedAt: Date | string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	} | null;
};

export type UseMuiInvoicesTable_SendOrResendInvoiceMutationVariables = Exact<{
	where: InvoiceWhereUniqueInput;
}>;

export type UseMuiInvoicesTable_SendOrResendInvoiceMutation = {
	__typename?: 'Mutation';
	sendOrResendInvoice: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		sentAt?: Date | string | null;
		status: InvoiceStatus;
		isPastDue: boolean;
		totalAmount: number;
		eventDate?: Date | string | null;
		dueDate?: Date | string | null;
		automatedRemindersEnabled: boolean;
		discountAmount?: number | null;
		sentByUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user?: { __typename?: 'User'; id: string } | null;
		} | null;
		lineItems: Array<{
			__typename?: 'LineItem';
			id: string;
			rate: number;
			quantity: number;
			taxPercentage: number;
		}>;
		paymentInstallments: Array<{
			__typename?: 'PaymentInstallment';
			id: string;
			status?: InstallmentStatus | null;
			dueDate?: Date | string | null;
		}>;
		contact?: {
			__typename?: 'Contact';
			id: string;
			status: ContactStatus;
			firstName: string;
			lastName: string;
			companyName?: string | null;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
			};
		} | null;
		quickPayment?: { __typename?: 'QuickPayment'; id?: string | null } | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	};
};

export type UseMuiInvoicesTable_GetInvoicesForCustomerQueryVariables = Exact<{
	where: GetInvoicesForCustomerInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<InvoiceOrderByInput>> | InputMaybe<InvoiceOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UseMuiInvoicesTable_GetInvoicesForCustomerQuery = {
	__typename?: 'Query';
	getInvoicesForCustomer: {
		__typename?: 'InvoicesForCustomer';
		_count: number;
		invoices: Array<{
			__typename?: 'Invoice';
			id: string;
			title: string;
			sentAt?: Date | string | null;
			status: InvoiceStatus;
			isPastDue: boolean;
			totalAmount: number;
			eventDate?: Date | string | null;
			dueDate?: Date | string | null;
			automatedRemindersEnabled: boolean;
			discountAmount?: number | null;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			lineItems: Array<{
				__typename?: 'LineItem';
				id: string;
				rate: number;
				quantity: number;
				taxPercentage: number;
			}>;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
			}>;
			contact?: {
				__typename?: 'Contact';
				id: string;
				status: ContactStatus;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: { __typename?: 'Organization'; id: string } | null;
						} | null;
					} | null;
				};
			} | null;
			quickPayment?: { __typename?: 'QuickPayment'; id?: string | null } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				image?: string | null;
				updatedAt: Date | string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		}>;
	};
};

export type UseMuiInvoicesTable_GetInvoicesForVendorQueryVariables = Exact<{
	where: InvoiceWhereInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<InvoiceOrderByInput>> | InputMaybe<InvoiceOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UseMuiInvoicesTable_GetInvoicesForVendorQuery = {
	__typename?: 'Query';
	getInvoicesForOrganization: {
		__typename?: 'Invoices';
		_count: number;
		invoices: Array<{
			__typename?: 'Invoice';
			id: string;
			title: string;
			sentAt?: Date | string | null;
			status: InvoiceStatus;
			isPastDue: boolean;
			totalAmount: number;
			eventDate?: Date | string | null;
			dueDate?: Date | string | null;
			automatedRemindersEnabled: boolean;
			discountAmount?: number | null;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			lineItems: Array<{
				__typename?: 'LineItem';
				id: string;
				rate: number;
				quantity: number;
				taxPercentage: number;
			}>;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
			}>;
			contact?: {
				__typename?: 'Contact';
				id: string;
				status: ContactStatus;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: { __typename?: 'Organization'; id: string } | null;
						} | null;
					} | null;
				};
			} | null;
			quickPayment?: { __typename?: 'QuickPayment'; id?: string | null } | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				image?: string | null;
				updatedAt: Date | string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		}>;
	};
};

export type InvoiceTemplatesTableFragment = {
	__typename?: 'InvoiceTemplate';
	id: string;
	title: string;
	createdAt: Date | string;
	status: InvoiceTemplateStatus;
	countOfConnectedInvoices: number;
};

export type InvoiceTemplatesTable_GetInvoiceTemplatesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<
		| Array<InputMaybe<InvoiceTemplateOrderByInput>>
		| InputMaybe<InvoiceTemplateOrderByInput>
	>;
	where?: InputMaybe<InvoiceTemplatesWhereInput>;
}>;

export type InvoiceTemplatesTable_GetInvoiceTemplatesQuery = {
	__typename?: 'Query';
	getInvoiceTemplatesWhere?: {
		__typename?: 'InvoiceTemplates';
		_count: number;
		invoiceTemplates: Array<{
			__typename?: 'InvoiceTemplate';
			id: string;
			title: string;
			createdAt: Date | string;
			status: InvoiceTemplateStatus;
			countOfConnectedInvoices: number;
		}>;
	} | null;
};

export type InvoiceTemplatesTable_DeleteInvoiceTemplateMutationVariables =
	Exact<{
		id: Scalars['ID']['input'];
	}>;

export type InvoiceTemplatesTable_DeleteInvoiceTemplateMutation = {
	__typename?: 'Mutation';
	deleteInvoiceTemplate: { __typename?: 'InvoiceTemplate'; id: string };
};

export type ActionMenuInquiryFragment = {
	__typename?: 'Inquiry';
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	createdAt: Date | string;
	companyName?: string | null;
	eventDate?: Date | string | null;
	notes?: string | null;
	status: InquiryStatus;
	source?: string | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type ActionMenuGetContactWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type ActionMenuGetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: { __typename?: 'Contact'; id: string } | null;
};

export type ActionMenuConvertInquiryMutationVariables = Exact<{
	where: InquiryWhereUniqueInput;
}>;

export type ActionMenuConvertInquiryMutation = {
	__typename?: 'Mutation';
	convertInquiry: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		createdAt: Date | string;
		companyName?: string | null;
		eventDate?: Date | string | null;
		notes?: string | null;
		status: InquiryStatus;
		source?: string | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
	};
};

export type ActionMenuDeleteInquiryMutationVariables = Exact<{
	where: InquiryWhereUniqueInput;
}>;

export type ActionMenuDeleteInquiryMutation = {
	__typename?: 'Mutation';
	deleteInquiry: boolean;
};

export type ActivityHistoryItemFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	createdAt: Date | string;
	vendor?: { __typename?: 'Organization'; id: string; name: string } | null;
	inquiry?: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string };
		} | null;
	} | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
};

export type ActivityHistoryEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	createdAt: Date | string;
	vendor?: { __typename?: 'Organization'; id: string; name: string } | null;
	inquiry?: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string };
		} | null;
	} | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
};

export type ActivityHistoryGetEventsForInquiryQueryVariables = Exact<{
	where: InquiryDetailWhereInput;
}>;

export type ActivityHistoryGetEventsForInquiryQuery = {
	__typename?: 'Query';
	getEventsForInquiry?: Array<{
		__typename?: 'Event';
		id: string;
		category: EventCategory;
		createdAt: Date | string;
		vendor?: { __typename?: 'Organization'; id: string; name: string } | null;
		inquiry?: {
			__typename?: 'Inquiry';
			id: string;
			firstName: string;
			lastName: string;
			contact?: {
				__typename?: 'Contact';
				id: string;
				customer: { __typename?: 'User'; id: string };
			} | null;
		} | null;
		actingUser?: {
			__typename?: 'ActingUserForEvent';
			id: string;
			orgUser?: {
				__typename?: 'OrgUserForActingUserOnEvent';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
	}> | null;
};

export type LeadDetailHeaderFragmentFragment = {
	__typename?: 'Inquiry';
	id: string;
	status: InquiryStatus;
	firstName: string;
	lastName: string;
	companyName?: string | null;
	email: string;
	eventDate?: Date | string | null;
	createdAt: Date | string;
	source?: string | null;
	notes?: string | null;
	organization: {
		__typename?: 'Organization';
		id: string;
		name: string;
		users?: Array<{
			__typename?: 'OrgUser';
			role: TeamMemberRole;
			id: string;
		}> | null;
	};
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type UseLeadDetailHeader_UpdateInquiryStatusMutationVariables = Exact<{
	data: InquiryUpdateDataInput;
	where: InquiryWhereUniqueInput;
}>;

export type UseLeadDetailHeader_UpdateInquiryStatusMutation = {
	__typename?: 'Mutation';
	updateInquiry: { __typename?: 'Inquiry'; id: string; status: InquiryStatus };
};

export type NotesTabInquiryFragment = {
	__typename?: 'Inquiry';
	id: string;
	notes?: string | null;
};

export type NotesTab_UpdateInquiryNotesMutationVariables = Exact<{
	where: InquiryWhereUniqueInput;
	data: InquiryUpdateDataInput;
}>;

export type NotesTab_UpdateInquiryNotesMutation = {
	__typename?: 'Mutation';
	updateInquiry: { __typename?: 'Inquiry'; id: string; notes?: string | null };
};

export type LeadDetail_GetInquiryWhereQueryVariables = Exact<{
	where: InquiryDetailWhereInput;
}>;

export type LeadDetail_GetInquiryWhereQuery = {
	__typename?: 'Query';
	getInquiryWhere: {
		__typename?: 'Inquiry';
		id: string;
		status: InquiryStatus;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		email: string;
		eventDate?: Date | string | null;
		createdAt: Date | string;
		source?: string | null;
		notes?: string | null;
		organization: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			name: string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
			users?: Array<{
				__typename?: 'OrgUser';
				role: TeamMemberRole;
				id: string;
			}> | null;
		};
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
	};
};

export type LeadDetail_UpdateInquiryMutationVariables = Exact<{
	data: InquiryUpdateDataInput;
	where: InquiryWhereUniqueInput;
}>;

export type LeadDetail_UpdateInquiryMutation = {
	__typename?: 'Mutation';
	updateInquiry: { __typename?: 'Inquiry'; id: string; status: InquiryStatus };
};

export type LeadFormViewPageLeadFormPresentationalDataFragment = {
	__typename?: 'LeadFormPresentationalData';
	apiKey: string;
	organization: {
		__typename?: 'LeadFormPresentationalDataOrganization';
		id: string;
		image?: string | null;
		name: string;
		phone?: string | null;
		contactEmail?: string | null;
		updatedAt: Date | string;
	};
};

export type ExportLeadsDataQueryVariables = Exact<{
	where: ExportInquiriesDataWhereInput;
}>;

export type ExportLeadsDataQuery = {
	__typename?: 'Query';
	exportInquiryData: string;
};

export type LeadStatusInquiryFragment = {
	__typename?: 'Inquiry';
	id: string;
	status: InquiryStatus;
};

export type InquiriesTableSubMenu_DeleteInquiryMutationVariables = Exact<{
	where: InquiryWhereUniqueInput;
}>;

export type InquiriesTableSubMenu_DeleteInquiryMutation = {
	__typename?: 'Mutation';
	deleteInquiry: boolean;
};

export type LeadsTableUpdateLeadStatusLinkFragment = {
	__typename?: 'Inquiry';
	id: string;
	status: InquiryStatus;
};

export type GetCustomRendererInquiryFragment = {
	__typename?: 'Inquiry';
	id: string;
	status: InquiryStatus;
};

export type InquiriesTableFragment = {
	__typename?: 'Inquiry';
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	eventDate?: Date | string | null;
	createdAt: Date | string;
	status: InquiryStatus;
	source?: string | null;
	companyName?: string | null;
	notes?: string | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: { __typename?: 'User'; email: string; id: string };
	} | null;
};

export type UseInquiriesTable_GetInquiriesForOrganizationQueryVariables =
	Exact<{
		where?: InputMaybe<InquiriesForOrganizationWhereInput>;
		orderBy?: InputMaybe<Array<InquiryOrderByInput> | InquiryOrderByInput>;
		skip?: InputMaybe<Scalars['Int']['input']>;
		take?: InputMaybe<Scalars['Int']['input']>;
	}>;

export type UseInquiriesTable_GetInquiriesForOrganizationQuery = {
	__typename?: 'Query';
	getInquiriesForOrganization: {
		__typename?: 'InquiriesForOrganization';
		_count: number;
		inquiries: Array<{
			__typename?: 'Inquiry';
			id: string;
			firstName: string;
			lastName: string;
			email: string;
			eventDate?: Date | string | null;
			createdAt: Date | string;
			status: InquiryStatus;
			source?: string | null;
			companyName?: string | null;
			notes?: string | null;
			contact?: {
				__typename?: 'Contact';
				id: string;
				customer: { __typename?: 'User'; email: string; id: string };
			} | null;
		}>;
	};
};

export type UseLeadsTable_UpdateInquiryStatusMutationVariables = Exact<{
	where: InquiryWhereUniqueInput;
	data: InquiryUpdateDataInput;
}>;

export type UseLeadsTable_UpdateInquiryStatusMutation = {
	__typename?: 'Mutation';
	updateInquiry: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		eventDate?: Date | string | null;
		createdAt: Date | string;
		status: InquiryStatus;
		source?: string | null;
		companyName?: string | null;
		notes?: string | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; email: string; id: string };
		} | null;
	};
};

export type LeadCreateOrViewModalFormInquiryFragment = {
	__typename?: 'Inquiry';
	createdAt: Date | string;
	firstName: string;
	lastName: string;
	email: string;
	companyName?: string | null;
	eventDate?: Date | string | null;
	notes?: string | null;
	id: string;
	status: InquiryStatus;
	source?: string | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type UseLeadMetrics_GetInquiriesForOrganizationQueryVariables = Exact<{
	where?: InputMaybe<InquiriesForOrganizationWhereInput>;
}>;

export type UseLeadMetrics_GetInquiriesForOrganizationQuery = {
	__typename?: 'Query';
	getInquiriesForOrganization: {
		__typename?: 'InquiriesForOrganization';
		_count: number;
	};
};

export type LoginPage_LoginQueryVariables = Exact<{
	data: UserLoginInput;
}>;

export type LoginPage_LoginQuery = {
	__typename?: 'Query';
	login?: { __typename?: 'AuthPayload'; token: string } | null;
};

export type LoginPage_CreateMfaTokenMutationVariables = Exact<{
	data: MfaTokenInput;
}>;

export type LoginPage_CreateMfaTokenMutation = {
	__typename?: 'Mutation';
	createMfaToken: boolean;
};

export type LoginPage_RequestResetMutationVariables = Exact<{
	data: PasswordResetRequestInput;
}>;

export type LoginPage_RequestResetMutation = {
	__typename?: 'Mutation';
	requestReset: boolean;
};

export type MemberDetailAssignedClientsMemberFragment = {
	__typename?: 'OrgUser';
	id: string;
	firstName: string;
	lastName: string;
	contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
	user?: { __typename?: 'User'; id: string } | null;
};

export type MemberDetailHeaderMemberFragment = {
	__typename?: 'OrgUser';
	id: string;
	updatedAt: Date | string;
	firstName: string;
	lastName: string;
	phone?: string | null;
	role: TeamMemberRole;
	organization?: {
		__typename?: 'Organization';
		id: string;
		updatedAt: Date | string;
		image?: string | null;
		name: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
			user?: {
				__typename?: 'User';
				id: string;
				blocked: boolean;
				email: string;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		}> | null;
	} | null;
	user?: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
	} | null;
};

export type MemberDetailMemberFragment = {
	__typename?: 'OrgUser';
	id: string;
	phone?: string | null;
	firstName: string;
	lastName: string;
	role: TeamMemberRole;
	updatedAt: Date | string;
	user?: {
		__typename?: 'User';
		id: string;
		blocked: boolean;
		email: string;
		userType: UserType;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		updatedAt: Date | string;
		image?: string | null;
		name: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
			user?: {
				__typename?: 'User';
				id: string;
				blocked: boolean;
				email: string;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			} | null;
		}> | null;
	} | null;
	contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
};

export type MemberDetail_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type MemberDetail_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			phone?: string | null;
			firstName: string;
			lastName: string;
			role: TeamMemberRole;
			updatedAt: Date | string;
			user?: {
				__typename?: 'User';
				id: string;
				blocked: boolean;
				email: string;
				userType: UserType;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				updatedAt: Date | string;
				image?: string | null;
				name: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					firstName: string;
					lastName: string;
					updatedAt: Date | string;
					contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
					user?: {
						__typename?: 'User';
						id: string;
						blocked: boolean;
						email: string;
					} | null;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				}> | null;
			} | null;
			contacts?: Array<{ __typename?: 'Contact'; id: string }> | null;
		}> | null;
	} | null;
};

export type MessageCustomerModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	customer: { __typename?: 'User'; id: string; email: string };
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type MessageCustomerModalInquiryFragment = {
	__typename?: 'Inquiry';
	id: string;
	firstName: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		customer: { __typename?: 'User'; id: string; email: string };
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			brandedEmails?: boolean | null;
		};
	} | null;
	organization: {
		__typename?: 'Organization';
		id: string;
		name: string;
		brandedEmails?: boolean | null;
	};
};

export type MessageCustomerModal_GetInquiryWhereQueryVariables = Exact<{
	where: InquiryDetailWhereInput;
}>;

export type MessageCustomerModal_GetInquiryWhereQuery = {
	__typename?: 'Query';
	getInquiryWhere: {
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			customer: { __typename?: 'User'; id: string; email: string };
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				brandedEmails?: boolean | null;
			};
		} | null;
		organization: {
			__typename?: 'Organization';
			id: string;
			name: string;
			brandedEmails?: boolean | null;
		};
	};
};

export type MessageCustomerModal_GetContactWhereQueryVariables = Exact<{
	where: ContactWhereInput;
}>;

export type MessageCustomerModal_GetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		customer: { __typename?: 'User'; id: string; email: string };
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			brandedEmails?: boolean | null;
		};
	} | null;
};

export type MessageCustomerModal_UpdateContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data: CustomContactUpdateInput;
}>;

export type MessageCustomerModal_UpdateContactMutation = {
	__typename?: 'Mutation';
	updateContact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		customer: { __typename?: 'User'; id: string; email: string };
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			brandedEmails?: boolean | null;
		};
	};
};

export type MessageCustomerModal_MessageContactOrLeadMutationVariables = Exact<{
	where: ContactOrLeadInput;
	data: MessageContactOrgLeadInput;
}>;

export type MessageCustomerModal_MessageContactOrLeadMutation = {
	__typename?: 'Mutation';
	messageContactOrLead: boolean;
};

export type UseMoveFileModalCompanyFoldersFolderFragment = {
	__typename?: 'Folder';
	id: string;
	name: string;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
};

export type UseMoveFileModalCompanyFoldersCustomFolderFragment = {
	__typename?: 'CustomFolder';
	id: string;
	name?: string | null;
	parentFolder?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
	} | null;
};

export type UseMoveFileModalCompanyFoldersDocumentFragment = {
	__typename?: 'Document';
	id: string;
	name: string;
	type: DocumentType;
	fileType: FileType;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
	customer?: { __typename?: 'User'; id: string } | null;
};

export type MoveFileModalCompanyFolders_GetFolderContentsQueryVariables =
	Exact<{
		where: FolderWhereUniqueInput;
	}>;

export type MoveFileModalCompanyFolders_GetFolderContentsQuery = {
	__typename?: 'Query';
	getFolderContents?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
		parentFolder?: {
			__typename?: 'CustomFolder';
			id: string;
			name?: string | null;
		} | null;
		childFolders?: Array<{
			__typename?: 'CustomFolder';
			id: string;
			name?: string | null;
			parentFolder?: {
				__typename?: 'CustomFolder';
				id: string;
				name?: string | null;
			} | null;
		} | null> | null;
		documents?: Array<{
			__typename?: 'Document';
			id: string;
			name: string;
			type: DocumentType;
			fileType: FileType;
			parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
			customer?: { __typename?: 'User'; id: string } | null;
		} | null> | null;
	} | null;
};

export type MoveFileModalCompanyFolders_MoveFoldersMutationVariables = Exact<{
	where: FoldersWhereCustomInput;
	data: MoveFolderCustomInput;
}>;

export type MoveFileModalCompanyFolders_MoveFoldersMutation = {
	__typename?: 'Mutation';
	moveFolders: Array<{
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
		parentFolder?: {
			__typename?: 'CustomFolder';
			id: string;
			name?: string | null;
		} | null;
	}>;
};

export type MoveFileModalCompanyFolders_MoveDocumentsMutationVariables = Exact<{
	where: DocumentsWhereCustomInput;
	data: FolderWhereUniqueInput;
}>;

export type MoveFileModalCompanyFolders_MoveDocumentsMutation = {
	__typename?: 'Mutation';
	moveDocuments: Array<{
		__typename?: 'Document';
		id: string;
		name: string;
		type: DocumentType;
		fileType: FileType;
		parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
		customer?: { __typename?: 'User'; id: string } | null;
	}>;
};

export type MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationVariables =
	Exact<{
		where: DocumentWhereUniqueInput;
		data: ContactWhereUniqueInput;
	}>;

export type MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation =
	{
		__typename?: 'Mutation';
		copyDocumentFromCompanyFolderToCustomerFolder: {
			__typename?: 'Document';
			id: string;
			name: string;
			type: DocumentType;
			fileType: FileType;
			parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
			customer?: { __typename?: 'User'; id: string } | null;
		};
	};

export type UseMoveFileModalCustomerFoldersContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	};
};

export type MoveFileModalCustomerFolders_GetContactsWhereQueryVariables =
	Exact<{
		orderBy?: InputMaybe<
			Array<InputMaybe<ContactOrderByInput>> | InputMaybe<ContactOrderByInput>
		>;
		where: ContactWhereInput;
	}>;

export type MoveFileModalCustomerFolders_GetContactsWhereQuery = {
	__typename?: 'Query';
	getContactsWhere: {
		__typename?: 'Contacts';
		_count: number;
		contacts: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgHasDocumentsPermissions: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
			};
		}>;
	};
};

export type UseMoveFileModalCustomerFoldersDocumentFragment = {
	__typename?: 'Document';
	id: string;
	fileType: FileType;
	name: string;
};

export type MoveFileModalCustomerFolders_GetDocumentsWhereQueryVariables =
	Exact<{
		orderBy?: InputMaybe<
			Array<InputMaybe<DocumentOrderByInput>> | InputMaybe<DocumentOrderByInput>
		>;
		where: CustomDocumentWhereInput;
	}>;

export type MoveFileModalCustomerFolders_GetDocumentsWhereQuery = {
	__typename?: 'Query';
	getDocumentsWhere: {
		__typename?: 'Documents';
		_count: number;
		documents: Array<{
			__typename?: 'Document';
			id: string;
			fileType: FileType;
			name: string;
		}>;
	};
};

export type MoveFileModalFolderFragment = {
	__typename?: 'Folder';
	id: string;
	name: string;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
};

export type MoveFileModalCustomFolderFragment = {
	__typename?: 'CustomFolder';
	id: string;
	name?: string | null;
	parentFolder?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
	} | null;
};

export type MoveFileModalCustomDocumentWithDownloadUrlFragment = {
	__typename?: 'Document';
	id: string;
	name: string;
	type: DocumentType;
	fileType: FileType;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
	customer?: { __typename?: 'User'; id: string } | null;
};

export type MoveFileModalDocumentFragment = {
	__typename?: 'Document';
	id: string;
	name: string;
	type: DocumentType;
	fileType: FileType;
	parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
	customer?: { __typename?: 'User'; id: string } | null;
};

export type MoveFileModal_GetFolderContentsQueryVariables = Exact<{
	where: FolderWhereUniqueInput;
}>;

export type MoveFileModal_GetFolderContentsQuery = {
	__typename?: 'Query';
	getFolderContents?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
		parentFolder?: {
			__typename?: 'CustomFolder';
			id: string;
			name?: string | null;
		} | null;
		childFolders?: Array<{
			__typename?: 'CustomFolder';
			id: string;
			name?: string | null;
			parentFolder?: {
				__typename?: 'CustomFolder';
				id: string;
				name?: string | null;
			} | null;
		} | null> | null;
		documents?: Array<{
			__typename?: 'Document';
			id: string;
			name: string;
			type: DocumentType;
			fileType: FileType;
			parentFolder?: { __typename?: 'Folder'; id: string; name: string } | null;
			customer?: { __typename?: 'User'; id: string } | null;
		} | null> | null;
	} | null;
};

export type UseNotificationGroupEmailNotificationGroupFragment = {
	__typename?: 'EmailNotificationGroup';
	id: string;
	members: Array<{
		__typename?: 'ReducedUser';
		id?: string | null;
		email: string;
		userType: UserType;
		orgUser?: {
			__typename?: 'ReducedOrgUser';
			id: string;
			firstName: string;
			lastName: string;
			role: TeamMemberRole;
			organization?: {
				__typename?: 'ReducedOrganization';
				id?: string | null;
			} | null;
		} | null;
	}>;
};

export type UseNotificationGroupOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	users?: Array<{
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		role: TeamMemberRole;
		organization?: { __typename?: 'Organization'; id: string } | null;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
		} | null;
	}> | null;
};

export type UseNotificationGroupOrganizationForGetContractWhereFragment = {
	__typename?: 'OrganizationForGetContractWhere';
	id: string;
	users?: Array<{
		__typename?: 'UsersForGetContractWhere';
		id: string;
		firstName: string;
		lastName: string;
		role: TeamMemberRole;
		organization?: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
		} | null;
		user?: {
			__typename?: 'BaseUserForGetContractWhere';
			id: string;
			email: string;
			userType: UserType;
		} | null;
	}> | null;
};

export type OrgMemberSignUp_OrgUserFieldsFragment = {
	__typename?: 'OrgUser';
	id: string;
	firstName: string;
	lastName: string;
	phone?: string | null;
	user?: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
	} | null;
	organization?: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
};

export type OrgMemberSignUp_CreateOrgUserMutationVariables = Exact<{
	data: OrgUserCreationInput;
}>;

export type OrgMemberSignUp_CreateOrgUserMutation = {
	__typename?: 'Mutation';
	createOrgUser: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		phone?: string | null;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		} | null;
	};
};

export type OrgMemberSignUp_LoginQueryVariables = Exact<{
	data: UserLoginInput;
}>;

export type OrgMemberSignUp_LoginQuery = {
	__typename?: 'Query';
	login?: { __typename?: 'AuthPayload'; token: string } | null;
};

export type OrgMemberSignUp_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type OrgMemberSignUp_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			role: TeamMemberRole;
			phone?: string | null;
			isAdmin: boolean;
			isOwner: boolean;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			organization?: {
				__typename?: 'Organization';
				id: string;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				country?: Country | null;
				postalCode?: string | null;
				createdAt: Date | string;
				name: string;
				website?: string | null;
				phone?: string | null;
				contactEmail?: string | null;
				description?: string | null;
				image?: string | null;
				imageScale?: number | null;
				imageRotation?: number | null;
				imagePositionX?: number | null;
				imagePositionY?: number | null;
				brandedEmails?: boolean | null;
				automatedRemindersEnabled: boolean;
				invoicesAllowGratuity: boolean;
				canReceivePayments: boolean;
				updatedAt: Date | string;
				facebook?: string | null;
				instagram?: string | null;
				twitter?: string | null;
				pinterest?: string | null;
				hasStripeVerificationNeeds: boolean;
				coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: {
						__typename?: 'Plan';
						id: string;
						period: PlanPeriod;
						type: PlanType;
					};
				} | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
				rootFolder?: { __typename?: 'Folder'; id: string } | null;
			} | null;
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type OrgMemberSignUp_MarkUserOnboardingCompleteMutationVariables =
	Exact<{ [key: string]: never }>;

export type OrgMemberSignUp_MarkUserOnboardingCompleteMutation = {
	__typename?: 'Mutation';
	markUserOnboardingComplete: boolean;
};

export type OrgOnboarding_ReducedCouponFragment = {
	__typename?: 'ReducedCoupon';
	id: string;
	name: string;
	active: boolean;
	amount_off?: number | null;
	percent_off?: number | null;
	duration_in_months?: number | null;
	duration?: StripeDuration | null;
	planCost?: {
		__typename?: 'PlanCost';
		price?: number | null;
		proration?: number | null;
		amountDue?: number | null;
	} | null;
};

export type OrgOnboarding_GetCouponDetailsQueryVariables = Exact<{
	where: CouponByNameInput;
}>;

export type OrgOnboarding_GetCouponDetailsQuery = {
	__typename?: 'Query';
	getCouponDetails: {
		__typename?: 'ReducedCoupon';
		id: string;
		name: string;
		active: boolean;
		amount_off?: number | null;
		percent_off?: number | null;
		duration_in_months?: number | null;
		duration?: StripeDuration | null;
		planCost?: {
			__typename?: 'PlanCost';
			price?: number | null;
			proration?: number | null;
			amountDue?: number | null;
		} | null;
	};
};

export type OrgOnboarding_RegisterCouponUsageMutationVariables = Exact<{
	data: RegisterCouponUsageWhere;
	where: OrganizationWhereUniqueInput;
}>;

export type OrgOnboarding_RegisterCouponUsageMutation = {
	__typename?: 'Mutation';
	registerCouponUsage: { __typename?: 'Coupon'; id: string };
};

export type OrgOnboarding_UpdateOrgUserExposureMutationVariables = Exact<{
	data: OrgUserUpdateCustomInput;
	where: OrgUserWhereUniqueInput;
}>;

export type OrgOnboarding_UpdateOrgUserExposureMutation = {
	__typename?: 'Mutation';
	updateOrgUser?: { __typename?: 'OrgUser'; id: string } | null;
};

export type OrgOnboarding_MarkUserOnboardingCompleteMutationVariables = Exact<{
	[key: string]: never;
}>;

export type OrgOnboarding_MarkUserOnboardingCompleteMutation = {
	__typename?: 'Mutation';
	markUserOnboardingComplete: boolean;
};

export type OrgOnboarding_LoginQueryVariables = Exact<{
	data: UserLoginInput;
}>;

export type OrgOnboarding_LoginQuery = {
	__typename?: 'Query';
	login?: { __typename?: 'AuthPayload'; token: string } | null;
};

export type OrgOnboarding_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type OrgOnboarding_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			role: TeamMemberRole;
			phone?: string | null;
			isAdmin: boolean;
			isOwner: boolean;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			organization?: {
				__typename?: 'Organization';
				id: string;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				country?: Country | null;
				postalCode?: string | null;
				createdAt: Date | string;
				name: string;
				website?: string | null;
				phone?: string | null;
				contactEmail?: string | null;
				description?: string | null;
				image?: string | null;
				imageScale?: number | null;
				imageRotation?: number | null;
				imagePositionX?: number | null;
				imagePositionY?: number | null;
				brandedEmails?: boolean | null;
				automatedRemindersEnabled: boolean;
				invoicesAllowGratuity: boolean;
				canReceivePayments: boolean;
				updatedAt: Date | string;
				facebook?: string | null;
				instagram?: string | null;
				twitter?: string | null;
				pinterest?: string | null;
				hasStripeVerificationNeeds: boolean;
				coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: {
						__typename?: 'Plan';
						id: string;
						period: PlanPeriod;
						type: PlanType;
					};
				} | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
				rootFolder?: { __typename?: 'Folder'; id: string } | null;
			} | null;
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type OrgOnboarding_GetServicesWhereQueryVariables = Exact<{
	[key: string]: never;
}>;

export type OrgOnboarding_GetServicesWhereQuery = {
	__typename?: 'Query';
	getServicesWhere: Array<{ __typename?: 'Service'; id: string; name: string }>;
};

export type OrgOnboardingAddressOrganizationFragment = {
	__typename?: 'Organization';
	addressLine1?: string | null;
	addressLine2?: string | null;
	city?: string | null;
	state?: State | null;
	postalCode?: string | null;
	country?: Country | null;
};

export type OrgOnboardingOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	phone?: string | null;
	image?: string | null;
	imageScale?: number | null;
	imageRotation?: number | null;
	imagePositionX?: number | null;
	imagePositionY?: number | null;
	canReceivePayments: boolean;
	addressLine1?: string | null;
	addressLine2?: string | null;
	city?: string | null;
	state?: State | null;
	postalCode?: string | null;
	country?: Country | null;
	services: Array<{ __typename?: 'Service'; id: string; name: string }>;
};

export type OrgOnboarding_RequestOrgProfileImageUploadUrlQueryVariables =
	Exact<{
		data: RequestImageUploadUrlInput;
	}>;

export type OrgOnboarding_RequestOrgProfileImageUploadUrlQuery = {
	__typename?: 'Query';
	requestOrgProfileImageUploadUrl: {
		__typename?: 'UploadUrl';
		uploadURL?: string | null;
	};
};

export type OrgOnboarding_CreateOrganizationMutationVariables = Exact<{
	data: OrganizationCustomCreateInput;
}>;

export type OrgOnboarding_CreateOrganizationMutation = {
	__typename?: 'Mutation';
	createOrganization: {
		__typename?: 'Organization';
		id: string;
		name: string;
		phone?: string | null;
		image?: string | null;
		imageScale?: number | null;
		imageRotation?: number | null;
		imagePositionX?: number | null;
		imagePositionY?: number | null;
		canReceivePayments: boolean;
		addressLine1?: string | null;
		addressLine2?: string | null;
		city?: string | null;
		state?: State | null;
		postalCode?: string | null;
		country?: Country | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	};
};

export type OrgOnboarding_UpdateOrganizationMutationVariables = Exact<{
	data: OrganizationCustomUpdateInput;
	where: OrganizationWhereUniqueInput;
}>;

export type OrgOnboarding_UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		phone?: string | null;
		image?: string | null;
		imageScale?: number | null;
		imageRotation?: number | null;
		imagePositionX?: number | null;
		imagePositionY?: number | null;
		canReceivePayments: boolean;
		addressLine1?: string | null;
		addressLine2?: string | null;
		city?: string | null;
		state?: State | null;
		postalCode?: string | null;
		country?: Country | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
};

export type OrgOnboarding_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type OrgOnboarding_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			imageScale?: number | null;
			imageRotation?: number | null;
			imagePositionX?: number | null;
			imagePositionY?: number | null;
		} | null;
		user?: {
			__typename?: 'User';
			id: string;
			acceptedTerms?: Date | string | null;
			consentedToAgeAndMarketingEmails?: Date | string | null;
		} | null;
	} | null;
};

export type OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationVariables =
	Exact<{
		data: OrgUserUpdateCustomInput;
		where: OrgUserWhereUniqueInput;
	}>;

export type OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation = {
	__typename?: 'Mutation';
	updateOrgUser?: { __typename?: 'OrgUser'; id: string } | null;
};

export type OrgOnboarding_GetStripeConnectAccountQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type OrgOnboarding_GetStripeConnectAccountQuery = {
	__typename?: 'Query';
	getStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		id?: string | null;
	} | null;
};

export type OrgOnboarding_CreateStripeConnectAccountMutationVariables = Exact<{
	data: StripeConnectAccountCreationInput;
	where: OrganizationWhereUniqueInput;
}>;

export type OrgOnboarding_CreateStripeConnectAccountMutation = {
	__typename?: 'Mutation';
	createStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		id?: string | null;
	} | null;
};

export type OrgOnboarding_CreateOrgUserMutationVariables = Exact<{
	data: OrgUserCreationInput;
}>;

export type OrgOnboarding_CreateOrgUserMutation = {
	__typename?: 'Mutation';
	createOrgUser: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
		} | null;
	};
};

export type OrgOnboarding_UpdateOrgUserMutationVariables = Exact<{
	data: OrgUserUpdateCustomInput;
	where: OrgUserWhereUniqueInput;
}>;

export type OrgOnboarding_UpdateOrgUserMutation = {
	__typename?: 'Mutation';
	updateOrgUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
		} | null;
	} | null;
};

export type OrgOnboardingModal_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type OrgOnboardingModal_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		WhiteGloveUrl?: string | null;
		WatchDemoUrl?: string | null;
		DemoCalendarUrl?: string | null;
	};
};

export type OrgOnboardingModal_GetStripeConnectAccountQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type OrgOnboardingModal_GetStripeConnectAccountQuery = {
	__typename?: 'Query';
	getStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		external_accounts?: {
			__typename?: 'Sources';
			data?: Array<{ __typename?: 'Source'; id: string } | null> | null;
		} | null;
	} | null;
};

export type OrganizationAvatarOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	image?: string | null;
	name: string;
	updatedAt: Date | string;
};

export type OrganizationAvatarOrganizationForGetContractWhereFragment = {
	__typename?: 'OrganizationForGetContractWhere';
	id: string;
	image?: string | null;
	name?: string | null;
	updatedAt: Date | string;
};

export type OrganizationAvatarOnOrganizationForGetQuickPaymentWhereFragment = {
	__typename?: 'OrganizationForGetQuickPayment';
	id: string;
	image?: string | null;
	name?: string | null;
	updatedAt: Date | string;
};

export type OrganizationDetailHeaderContactActionButtonContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; name: string; id: string }>;
	};
	customer: {
		__typename?: 'User';
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	};
};

export type OrganizationDetailHeaderOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	description?: string | null;
	website?: string | null;
	phone?: string | null;
	contactEmail?: string | null;
	facebook?: string | null;
	twitter?: string | null;
	instagram?: string | null;
	pinterest?: string | null;
	updatedAt: Date | string;
	image?: string | null;
	services: Array<{ __typename?: 'Service'; id: string; name: string }>;
};

export type OrganizationDetailHeaderContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; name: string; id: string }>;
	};
	customer: {
		__typename?: 'User';
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	};
};

export type OrganizationDetailTabsContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	firstName: string;
	lastName: string;
	customer: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			user: { __typename?: 'User'; id: string };
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
			organization?: { __typename?: 'Organization'; id: string } | null;
		} | null;
	};
	vendor: { __typename?: 'Organization'; id: string };
	assignedMember: { __typename?: 'OrgUser'; id: string };
};

export type OrganizationDetailTabsClientPermissionsFragment = {
	__typename?: 'ClientUser';
	id: string;
	plannerOrgHasConnectionPermissions: boolean;
	plannerOrgCanSignContracts: boolean;
	plannerOrgCanPayInvoices: boolean;
	plannerOrgHasDocumentsPermissions: boolean;
};

export type OrganizationDetailContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			user: { __typename?: 'User'; id: string };
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
			organization?: { __typename?: 'Organization'; id: string } | null;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; name: string; id: string }>;
	};
	assignedMember: { __typename?: 'OrgUser'; id: string };
};

export type OrganizationDetail_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type OrganizationDetail_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		description?: string | null;
		website?: string | null;
		phone?: string | null;
		contactEmail?: string | null;
		facebook?: string | null;
		twitter?: string | null;
		instagram?: string | null;
		pinterest?: string | null;
		updatedAt: Date | string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
};

export type OrganizationDetail_GetContactWhereQueryVariables = Exact<{
	customerId: Scalars['ID']['input'];
	orgId: Scalars['ID']['input'];
}>;

export type OrganizationDetail_GetContactWhereQuery = {
	__typename?: 'Query';
	getContactWhere?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				user: { __typename?: 'User'; id: string };
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
					user?: { __typename?: 'User'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	} | null;
};

export type OrganizationDetail_ActivateContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data?: InputMaybe<ActivateContactCustomInput>;
}>;

export type OrganizationDetail_ActivateContactMutation = {
	__typename?: 'Mutation';
	activateContact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				user: { __typename?: 'User'; id: string };
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
					user?: { __typename?: 'User'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	};
};

export type OrganizationDetail_CreateContactAsClientMutationVariables = Exact<{
	where: UserByIdUniqueInput;
	data: OrganizationWhereUniqueInput;
}>;

export type OrganizationDetail_CreateContactAsClientMutation = {
	__typename?: 'Mutation';
	createContactAsClient: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				user: { __typename?: 'User'; id: string };
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
					user?: { __typename?: 'User'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	};
};

export type OrganizationDetail_DeclineContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
}>;

export type OrganizationDetail_DeclineContactMutation = {
	__typename?: 'Mutation';
	declineContact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				user: { __typename?: 'User'; id: string };
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
					user?: { __typename?: 'User'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	};
};

export type OrganizationDetail_CancelContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
}>;

export type OrganizationDetail_CancelContactMutation = {
	__typename?: 'Mutation';
	cancelContact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				user: { __typename?: 'User'; id: string };
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
					user?: { __typename?: 'User'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	};
};

export type EventNotifications_DismissAllEventsMutationVariables = Exact<{
	[key: string]: never;
}>;

export type EventNotifications_DismissAllEventsMutation = {
	__typename?: 'Mutation';
	dismissAllEvents: boolean;
};

export type MobileMenuHelpAccordion_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type MobileMenuHelpAccordion_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		HelpUrl?: string | null;
	};
};

export type ConfirmPermissionsChangeModalVendorFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	image?: string | null;
	services: Array<{ __typename?: 'Service'; name: string; id: string }>;
};

export type PermissionsTogglesPermissionsFragment = {
	__typename?: 'ClientUser';
	plannerOrgHasConnectionPermissions: boolean;
	plannerOrgCanSignContracts: boolean;
	plannerOrgCanPayInvoices: boolean;
	plannerOrgHasDocumentsPermissions: boolean;
};

export type SetPermissionsModal_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type SetPermissionsModal_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		PlannerPermissionsHelpUrl?: string | null;
	};
};

export type SetPermissionsModalPermissionsFragment = {
	__typename?: 'ClientUser';
	plannerOrgHasConnectionPermissions: boolean;
	plannerOrgCanSignContracts: boolean;
	plannerOrgCanPayInvoices: boolean;
	plannerOrgHasDocumentsPermissions: boolean;
};

export type SetPermissionsModalVendorFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	image?: string | null;
	services: Array<{ __typename?: 'Service'; name: string; id: string }>;
};

export type VendorProfileVendorFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	image?: string | null;
	services: Array<{ __typename?: 'Service'; name: string; id: string }>;
};

export type PermissionsModalOrganizationForGetContractWhereFragment = {
	__typename?: 'OrganizationForGetContractWhere';
	id: string;
	image?: string | null;
	name?: string | null;
	services: Array<{
		__typename?: 'ServicesForGetContractWhere';
		name?: string | null;
		id?: string | null;
	} | null>;
};

export type PermissionsModalOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	name: string;
	image?: string | null;
	services: Array<{ __typename?: 'Service'; name: string; id: string }>;
};

export type PermissionsModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		services: Array<{ __typename?: 'Service'; name: string; id: string }>;
	};
	customer: {
		__typename?: 'User';
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
	};
};

export type PermissionsModal_AssignPlannerPermissionsMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data: PermissionInput;
}>;

export type PermissionsModal_AssignPlannerPermissionsMutation = {
	__typename?: 'Mutation';
	assignPlannerPermissions: { __typename?: 'Contact'; id: string };
};

export type PermissionsModal_RemoveAllPlannerPermissionsMutationVariables =
	Exact<{
		where: ClientUserWhereUniqueInput;
	}>;

export type PermissionsModal_RemoveAllPlannerPermissionsMutation = {
	__typename?: 'Mutation';
	removeAllPlannerPermissions: boolean;
};

export type PermissionsModal_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type PermissionsModal_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			description?: string | null;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			facebook?: string | null;
			instagram?: string | null;
			twitter?: string | null;
			pinterest?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					updatedAt: Date | string;
				} | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			role: TeamMemberRole;
			phone?: string | null;
			isAdmin: boolean;
			isOwner: boolean;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			organization?: {
				__typename?: 'Organization';
				id: string;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				country?: Country | null;
				postalCode?: string | null;
				createdAt: Date | string;
				name: string;
				website?: string | null;
				phone?: string | null;
				contactEmail?: string | null;
				description?: string | null;
				image?: string | null;
				imageScale?: number | null;
				imageRotation?: number | null;
				imagePositionX?: number | null;
				imagePositionY?: number | null;
				brandedEmails?: boolean | null;
				automatedRemindersEnabled: boolean;
				invoicesAllowGratuity: boolean;
				canReceivePayments: boolean;
				updatedAt: Date | string;
				facebook?: string | null;
				instagram?: string | null;
				twitter?: string | null;
				pinterest?: string | null;
				hasStripeVerificationNeeds: boolean;
				coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: {
						__typename?: 'Plan';
						id: string;
						period: PlanPeriod;
						type: PlanType;
					};
				} | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
				rootFolder?: { __typename?: 'Folder'; id: string } | null;
			} | null;
		} | null;
		superAdmin?: {
			__typename?: 'SuperAdminUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
			};
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type ProposalDetailProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	eventDate?: Date | string | null;
	source?: any | null;
	isPastDue: boolean;
	automatedRemindersEnabled: boolean;
	status: ProposalStatus;
	title?: string | null;
	sentAt?: Date | string | null;
	dueDate?: Date | string | null;
	filename?: string | null;
	thumbnail?: string | null;
	imageUrl?: string | null;
	isReadOnly: boolean;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		status: ContactStatus;
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				firstName: string;
				lastName: string;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				} | null;
				organization?: { __typename?: 'Organization'; id: string } | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	};
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		designId: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
	} | null;
};

export type ProposalDetail_GetProposalWhereQueryVariables = Exact<{
	where: ProposalWhereInput;
}>;

export type ProposalDetail_GetProposalWhereQuery = {
	__typename?: 'Query';
	getProposalWhere: {
		__typename?: 'ResponseObjectForGetProposalWhere';
		proposal: {
			__typename?: 'Proposal';
			id: string;
			eventDate?: Date | string | null;
			source?: any | null;
			isPastDue: boolean;
			automatedRemindersEnabled: boolean;
			status: ProposalStatus;
			title?: string | null;
			sentAt?: Date | string | null;
			dueDate?: Date | string | null;
			filename?: string | null;
			thumbnail?: string | null;
			imageUrl?: string | null;
			isReadOnly: boolean;
			contact: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				status: ContactStatus;
				vendor: {
					__typename?: 'Organization';
					id: string;
					name: string;
					image?: string | null;
					updatedAt: Date | string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
						firstName: string;
						lastName: string;
						user?: {
							__typename?: 'User';
							id: string;
							email: string;
							userType: UserType;
						} | null;
						organization?: { __typename?: 'Organization'; id: string } | null;
					}> | null;
					services: Array<{ __typename?: 'Service'; name: string; id: string }>;
				};
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
									organization?: {
										__typename?: 'Organization';
										id: string;
										users?: Array<{
											__typename?: 'OrgUser';
											id: string;
											role: TeamMemberRole;
											user?: { __typename?: 'User'; id: string } | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
				};
				invoices?: Array<{
					__typename?: 'Invoice';
					id: string;
					status: InvoiceStatus;
					title: string;
					guestToken?: string | null;
					paymentInstallments: Array<{
						__typename?: 'PaymentInstallment';
						id: string;
						status?: InstallmentStatus | null;
						dueDate?: Date | string | null;
						amountDue?: number | null;
						paymentDate?: Date | string | null;
					}>;
				}> | null;
				customerSignatures?: Array<{
					__typename?: 'CustomerSignature';
					id: string;
					signature: {
						__typename?: 'Signature';
						id: string;
						signingDate?: Date | string | null;
						signer?: { __typename?: 'SignatureUser'; id: string } | null;
						contract?: {
							__typename?: 'SignatureContract';
							id: string;
							status: ContractStatus;
							dueDate: Date | string;
							title: string;
							guestToken?: string | null;
						} | null;
					};
				}> | null;
				proposals?: Array<{
					__typename?: 'Proposal';
					id: string;
					status: ProposalStatus;
					title?: string | null;
					guestToken?: string | null;
					dueDate?: Date | string | null;
				}> | null;
			};
			emailNotificationGroup?: {
				__typename?: 'EmailNotificationGroup';
				id: string;
				groupTitle: EmailNotificationGroupTitle;
				members: Array<{
					__typename?: 'ReducedUser';
					id?: string | null;
					email: string;
					userType: UserType;
					orgUser?: {
						__typename?: 'ReducedOrgUser';
						id: string;
						firstName: string;
						lastName: string;
						role: TeamMemberRole;
						organization?: {
							__typename?: 'ReducedOrganization';
							id?: string | null;
						} | null;
					} | null;
				}>;
			} | null;
			canvaDesign?: {
				__typename?: 'CanvaDesignViewFields';
				id: string;
				designId: string;
				editUrl: string;
				viewUrl: string;
				exportedImageUrl?: string | null;
			} | null;
		};
	};
};

export type ProposalDetail_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ProposalDetail_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		user?: {
			__typename?: 'User';
			id: string;
			canvaToken?: {
				__typename?: 'CanvaOAuthToken';
				accessToken: string;
				expires: Date | string;
			} | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			automatedRemindersEnabled: boolean;
			image?: string | null;
			name: string;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				firstName: string;
				lastName: string;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				} | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		} | null;
	} | null;
};

export type ProposalEditButtonBarFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	automatedRemindersEnabled: boolean;
	sentAt?: Date | string | null;
	source?: any | null;
	imageUrl?: string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	title?: string | null;
	contact: { __typename?: 'Contact'; id: string; firstName: string };
	canvaDesign?: { __typename?: 'CanvaDesignViewFields'; id: string } | null;
};

export type UseProposalEditButtonBarSaveButtonFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	contact: { __typename?: 'Contact'; id: string };
};

export type UseProposalEditButtonBarSendButtonFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	automatedRemindersEnabled: boolean;
	sentAt?: Date | string | null;
	source?: any | null;
	imageUrl?: string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	title?: string | null;
	canvaDesign?: { __typename?: 'CanvaDesignViewFields'; id: string } | null;
	contact: { __typename?: 'Contact'; id: string; firstName: string };
};

export type ProposalEditButtonBarSendButton_SendProposalMutationVariables =
	Exact<{
		data?: InputMaybe<SendProposalInput>;
		where: ProposalWhereUniqueInput;
	}>;

export type ProposalEditButtonBarSendButton_SendProposalMutation = {
	__typename?: 'Mutation';
	sendProposal: {
		__typename?: 'Proposal';
		id: string;
		eventDate?: Date | string | null;
		dueDate?: Date | string | null;
		title?: string | null;
		status: ProposalStatus;
		automatedRemindersEnabled: boolean;
		sentAt?: Date | string | null;
		source?: any | null;
		imageUrl?: string | null;
		canvaDesign?: { __typename?: 'CanvaDesignViewFields'; id: string } | null;
		contact: { __typename?: 'Contact'; id: string; firstName: string };
	};
};

export type UseProposalEditButtonBarVoidButtonFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
};

export type ProposalEditButtonBarVoidButton_VoidProposalMutationVariables =
	Exact<{
		where: ProposalWhereUniqueInput;
	}>;

export type ProposalEditButtonBarVoidButton_VoidProposalMutation = {
	__typename?: 'Mutation';
	voidProposal: { __typename?: 'Proposal'; id: string; status: ProposalStatus };
};

export type ProposalEditPresentationFragment = {
	__typename?: 'Proposal';
	id: string;
	title?: string | null;
	status: ProposalStatus;
	dueDate?: Date | string | null;
	eventDate?: Date | string | null;
};

export type ProposalEditPreviewOrCreateDesignProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	source?: any | null;
	imageUrl?: string | null;
	filename?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		designId: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
	} | null;
};

export type ProposalEditProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	eventDate?: Date | string | null;
	source?: any | null;
	isPastDue: boolean;
	automatedRemindersEnabled: boolean;
	title?: string | null;
	status: ProposalStatus;
	dueDate?: Date | string | null;
	filename?: string | null;
	thumbnail?: string | null;
	imageUrl?: string | null;
	sentAt?: Date | string | null;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		status: ContactStatus;
		lastName: string;
		companyName?: string | null;
		customer: { __typename?: 'User'; id: string; email: string };
	};
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		designId: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
	} | null;
};

export type ProposalEdit_CreateProposalMutationVariables = Exact<{
	data: ProposalCreateInput;
}>;

export type ProposalEdit_CreateProposalMutation = {
	__typename?: 'Mutation';
	createProposal: {
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		eventDate?: Date | string | null;
		source?: any | null;
		isPastDue: boolean;
		automatedRemindersEnabled: boolean;
		title?: string | null;
		dueDate?: Date | string | null;
		filename?: string | null;
		thumbnail?: string | null;
		imageUrl?: string | null;
		sentAt?: Date | string | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			status: ContactStatus;
			lastName: string;
			companyName?: string | null;
			customer: { __typename?: 'User'; id: string; email: string };
		};
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			members: Array<{
				__typename?: 'ReducedUser';
				id?: string | null;
				email: string;
				userType: UserType;
				orgUser?: {
					__typename?: 'ReducedOrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					organization?: {
						__typename?: 'ReducedOrganization';
						id?: string | null;
					} | null;
				} | null;
			}>;
		} | null;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			designId: string;
			editUrl: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
		} | null;
	};
};

export type ProposalEdit_UpdateProposalMutationVariables = Exact<{
	data: ProposalUpdateInput;
	where: ProposalWhereUniqueInput;
}>;

export type ProposalEdit_UpdateProposalMutation = {
	__typename?: 'Mutation';
	updateProposal: {
		__typename?: 'Proposal';
		source?: any | null;
		id: string;
		eventDate?: Date | string | null;
		isPastDue: boolean;
		automatedRemindersEnabled: boolean;
		title?: string | null;
		status: ProposalStatus;
		dueDate?: Date | string | null;
		filename?: string | null;
		thumbnail?: string | null;
		imageUrl?: string | null;
		sentAt?: Date | string | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			status: ContactStatus;
			lastName: string;
			companyName?: string | null;
			customer: { __typename?: 'User'; id: string; email: string };
		};
		emailNotificationGroup?: {
			__typename?: 'EmailNotificationGroup';
			id: string;
			members: Array<{
				__typename?: 'ReducedUser';
				id?: string | null;
				email: string;
				userType: UserType;
				orgUser?: {
					__typename?: 'ReducedOrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					organization?: {
						__typename?: 'ReducedOrganization';
						id?: string | null;
					} | null;
				} | null;
			}>;
		} | null;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			designId: string;
			editUrl: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
		} | null;
	};
};

export type ProposalEdit_RequestProposalFileUploadUrlMutationVariables = Exact<{
	data: RequestAttachmentUploadUrlInput;
	where: ProposalWhereUniqueInput;
}>;

export type ProposalEdit_RequestProposalFileUploadUrlMutation = {
	__typename?: 'Mutation';
	requestProposalFileUploadUrl: {
		__typename?: 'UploadUrl';
		uploadURL?: string | null;
	};
};

export type ProposalEdit_CreateCanvaDesignForProposalMutationVariables = Exact<{
	data: CanvaDesignInput;
}>;

export type ProposalEdit_CreateCanvaDesignForProposalMutation = {
	__typename?: 'Mutation';
	createCanvaDesignForProposal: {
		__typename?: 'Proposal';
		id: string;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			designId: string;
			editUrl: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
		} | null;
	};
};

export type UseProposalDesignProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	source?: any | null;
	filename?: string | null;
	thumbnail?: string | null;
	imageUrl?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
		designId: string;
	} | null;
};

export type CanvaDesignTitles_ListCanvaDesignsQueryVariables = Exact<{
	where?: InputMaybe<CanvaDesignWhereInput>;
}>;

export type CanvaDesignTitles_ListCanvaDesignsQuery = {
	__typename?: 'Query';
	listCanvaDesigns: {
		__typename?: 'CanvaDesignList';
		hasMore: boolean;
		items: Array<{
			__typename?: 'CanvaDesign';
			id: string;
			title?: string | null;
			thumbnail?: {
				__typename?: 'CanvaDesignThumbnail';
				url: string;
				width: number;
				height: number;
			} | null;
			urls: { __typename?: 'CanvaDesignUrls'; viewUrl: string };
		}>;
	};
};

export type ConnectToCanva_GetCanvaAuthorizationUrlQueryVariables = Exact<{
	[key: string]: never;
}>;

export type ConnectToCanva_GetCanvaAuthorizationUrlQuery = {
	__typename?: 'Query';
	getCanvaAuthorizationUrl: {
		__typename?: 'CanvaAuthorizationUrl';
		url: string;
		state: string;
		codeVerifier: string;
	};
};

export type RevokeCanvaToken_RevokeCanvaTokenMutationVariables = Exact<{
	[key: string]: never;
}>;

export type RevokeCanvaToken_RevokeCanvaTokenMutation = {
	__typename?: 'Mutation';
	revokeCanvaToken: boolean;
};

export type TemplateGridItemProposalTemplateFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	source?: any | null;
	thumbnail?: string | null;
	filename?: string | null;
	title?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		exportedImageUrl?: string | null;
		thumbnailUrl?: string | null;
	} | null;
};

export type TemplatesTabProposalTemplateFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	source?: any | null;
	thumbnail?: string | null;
	filename?: string | null;
	title?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		exportedImageUrl?: string | null;
		thumbnailUrl?: string | null;
	} | null;
};

export type YourDesignsGetProposalTemplatesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ProposalTemplatesWhereInput>;
	orderBy?: InputMaybe<
		| Array<InputMaybe<ProposalTemplateWhereOrderByInput>>
		| InputMaybe<ProposalTemplateWhereOrderByInput>
	>;
}>;

export type YourDesignsGetProposalTemplatesQuery = {
	__typename?: 'Query';
	getProposalTemplatesWhere: {
		__typename?: 'ProposalTemplates';
		_count: number;
		proposalTemplates: Array<{
			__typename?: 'ProposalTemplate';
			id: string;
			source?: any | null;
			thumbnail?: string | null;
			filename?: string | null;
			title?: string | null;
			canvaDesign?: {
				__typename?: 'CanvaDesignViewFields';
				id: string;
				exportedImageUrl?: string | null;
				thumbnailUrl?: string | null;
			} | null;
		}>;
	};
};

export type ProposalPreview_RefreshCanvaExportMutationVariables = Exact<{
	where: CanvaDesignWhereUniqueInput;
}>;

export type ProposalPreview_RefreshCanvaExportMutation = {
	__typename?: 'Mutation';
	refreshCanvaExportForProposal: {
		__typename?: 'Proposal';
		id: string;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			designId: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
		} | null;
	};
};

export type ProposalPreviewProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	source?: any | null;
	imageUrl?: string | null;
	filename?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		designId: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
	} | null;
};

export type ProposalPreviewProposalTemplateFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	source?: any | null;
	imageUrl?: string | null;
	filename?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		designId: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
	} | null;
};

export type ProposalTemplateEditButtonBarFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
};

export type UseProposalTemplateEditButtonBarDeleteButtonFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
};

export type ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationVariables =
	Exact<{
		where: ProposalTemplateWhereUniqueInput;
	}>;

export type ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation =
	{
		__typename?: 'Mutation';
		deleteProposalTemplate: { __typename?: 'ProposalTemplate'; id: string };
	};

export type ProposalTemplateEditPresentationFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	title?: string | null;
};

export type ProposalTemplateEditPreviewOrCreateDesignProposalTemplateFragment =
	{
		__typename?: 'ProposalTemplate';
		id: string;
		source?: any | null;
		imageUrl?: string | null;
		filename?: string | null;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			editUrl: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
			designId: string;
		} | null;
	};

export type ProposalTemplateEditFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	source?: any | null;
	thumbnail?: string | null;
	title?: string | null;
	filename?: string | null;
	imageUrl?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
		designId: string;
	} | null;
};

export type ProposalTemplateEdit_GetProposalTemplateWhereQueryVariables =
	Exact<{
		where: ProposalTemplateWhereUniqueInput;
	}>;

export type ProposalTemplateEdit_GetProposalTemplateWhereQuery = {
	__typename?: 'Query';
	getProposalTemplateWhere: {
		__typename?: 'ProposalTemplate';
		id: string;
		source?: any | null;
		thumbnail?: string | null;
		title?: string | null;
		filename?: string | null;
		imageUrl?: string | null;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			editUrl: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
			designId: string;
		} | null;
	};
};

export type ProposalTemplateEdit_CreateProposalTemplateMutationVariables =
	Exact<{
		data: ProposalTemplateCreateInput;
	}>;

export type ProposalTemplateEdit_CreateProposalTemplateMutation = {
	__typename?: 'Mutation';
	createProposalTemplate: {
		__typename?: 'ProposalTemplate';
		id: string;
		source?: any | null;
		thumbnail?: string | null;
		title?: string | null;
		filename?: string | null;
		imageUrl?: string | null;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			editUrl: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
			designId: string;
		} | null;
	};
};

export type ProposalTemplateEdit_UpdateProposalTemplateMutationVariables =
	Exact<{
		data: ProposalTemplateUpdateInput;
		where: ProposalTemplateWhereUniqueInput;
	}>;

export type ProposalTemplateEdit_UpdateProposalTemplateMutation = {
	__typename?: 'Mutation';
	updateProposalTemplate: {
		__typename?: 'ProposalTemplate';
		id: string;
		source?: any | null;
		thumbnail?: string | null;
		title?: string | null;
		filename?: string | null;
		imageUrl?: string | null;
		canvaDesign?: {
			__typename?: 'CanvaDesignViewFields';
			id: string;
			editUrl: string;
			viewUrl: string;
			exportedImageUrl?: string | null;
			designId: string;
		} | null;
	};
};

export type ProposalTemplateEdit_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ProposalTemplateEdit_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		user?: {
			__typename?: 'User';
			id: string;
			canvaToken?: {
				__typename?: 'CanvaOAuthToken';
				accessToken: string;
				expires: Date | string;
			} | null;
		} | null;
	} | null;
};

export type ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationVariables =
	Exact<{
		data: RequestAttachmentUploadUrlInput;
		where: ProposalTemplateWhereUniqueInput;
	}>;

export type ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation =
	{
		__typename?: 'Mutation';
		requestProposalTemplateFileUploadUrl: {
			__typename?: 'UploadUrl';
			uploadURL?: string | null;
		};
	};

export type ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationVariables =
	Exact<{
		data: CanvaDesignForProposalTemplateInput;
	}>;

export type ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation =
	{
		__typename?: 'Mutation';
		createCanvaDesignForProposalTemplate: {
			__typename?: 'ProposalTemplate';
			id: string;
			canvaDesign?: {
				__typename?: 'CanvaDesignViewFields';
				id: string;
				designId: string;
				editUrl: string;
				viewUrl: string;
				exportedImageUrl?: string | null;
			} | null;
		};
	};

export type UseProposalDesignProposalTemplateFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	source?: any | null;
	filename?: string | null;
	thumbnail?: string | null;
	imageUrl?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
		designId: string;
	} | null;
};

export type ProposalViewButtonBarProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	isPastDue: boolean;
	isReadOnly: boolean;
	automatedRemindersEnabled: boolean;
	sentAt?: Date | string | null;
	source?: any | null;
	imageUrl?: string | null;
	dueDate?: Date | string | null;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	};
	canvaDesign?: { __typename?: 'CanvaDesignViewFields'; id: string } | null;
};

export type ProposalViewButtonBarAcceptButtonProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	isPastDue: boolean;
	isReadOnly: boolean;
	contact: {
		__typename?: 'Contact';
		id: string;
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	};
};

export type ProposalViewButtonBar_AcceptProposalMutationVariables = Exact<{
	where: ProposalWhereInput;
}>;

export type ProposalViewButtonBar_AcceptProposalMutation = {
	__typename?: 'Mutation';
	acceptProposal: {
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		isPastDue: boolean;
		isReadOnly: boolean;
		contact: {
			__typename?: 'Contact';
			id: string;
			invoices?: Array<{
				__typename?: 'Invoice';
				id: string;
				status: InvoiceStatus;
				title: string;
				guestToken?: string | null;
				paymentInstallments: Array<{
					__typename?: 'PaymentInstallment';
					id: string;
					status?: InstallmentStatus | null;
					dueDate?: Date | string | null;
					amountDue?: number | null;
					paymentDate?: Date | string | null;
				}>;
			}> | null;
			customer: {
				__typename?: 'User';
				id: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
								user?: { __typename?: 'User'; id: string } | null;
								organization?: {
									__typename?: 'Organization';
									id: string;
									users?: Array<{
										__typename?: 'OrgUser';
										id: string;
										role: TeamMemberRole;
										user?: { __typename?: 'User'; id: string } | null;
									}> | null;
								} | null;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				image?: string | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
				services: Array<{ __typename?: 'Service'; name: string; id: string }>;
			};
			customerSignatures?: Array<{
				__typename?: 'CustomerSignature';
				id: string;
				signature: {
					__typename?: 'Signature';
					id: string;
					signingDate?: Date | string | null;
					signer?: { __typename?: 'SignatureUser'; id: string } | null;
					contract?: {
						__typename?: 'SignatureContract';
						id: string;
						status: ContractStatus;
						dueDate: Date | string;
						title: string;
						guestToken?: string | null;
					} | null;
				};
			}> | null;
			proposals?: Array<{
				__typename?: 'Proposal';
				id: string;
				status: ProposalStatus;
				title?: string | null;
				guestToken?: string | null;
				dueDate?: Date | string | null;
			}> | null;
		};
	};
};

export type ProposalViewButtonBarExportButtonFragment = {
	__typename?: 'Proposal';
	id: string;
	source?: any | null;
	imageUrl?: string | null;
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		exportedImageUrl?: string | null;
	} | null;
};

export type ProposalViewButtonBarExportButton_GetProposalWhereQueryVariables =
	Exact<{
		where: ProposalWhereInput;
	}>;

export type ProposalViewButtonBarExportButton_GetProposalWhereQuery = {
	__typename?: 'Query';
	getProposalWhere: {
		__typename?: 'ResponseObjectForGetProposalWhere';
		proposal: {
			__typename?: 'Proposal';
			id: string;
			source?: any | null;
			imageUrl?: string | null;
			canvaDesign?: {
				__typename?: 'CanvaDesignViewFields';
				id: string;
				exportedImageUrl?: string | null;
			} | null;
		};
	};
};

export type ProposalViewButtonBarSendButtonFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	automatedRemindersEnabled: boolean;
	sentAt?: Date | string | null;
	source?: any | null;
	imageUrl?: string | null;
	dueDate?: Date | string | null;
	canvaDesign?: { __typename?: 'CanvaDesignViewFields'; id: string } | null;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
		assignedMember: { __typename?: 'OrgUser'; id: string };
	};
};

export type ProposalViewButtonBar_SendProposalMutationVariables = Exact<{
	where: ProposalWhereUniqueInput;
	data?: InputMaybe<SendProposalInput>;
}>;

export type ProposalViewButtonBar_SendProposalMutation = {
	__typename?: 'Mutation';
	sendProposal: {
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		automatedRemindersEnabled: boolean;
		sentAt?: Date | string | null;
		source?: any | null;
		imageUrl?: string | null;
		dueDate?: Date | string | null;
		canvaDesign?: { __typename?: 'CanvaDesignViewFields'; id: string } | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
			assignedMember: { __typename?: 'OrgUser'; id: string };
		};
	};
};

export type UseProposalViewButtonBarVoidButtonFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	contact: {
		__typename?: 'Contact';
		id: string;
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type ProposalViewButtonBarVoidButton_VoidProposalMutationVariables =
	Exact<{
		where: ProposalWhereUniqueInput;
	}>;

export type ProposalViewButtonBarVoidButton_VoidProposalMutation = {
	__typename?: 'Mutation';
	voidProposal: {
		__typename?: 'Proposal';
		id: string;
		status: ProposalStatus;
		contact: {
			__typename?: 'Contact';
			id: string;
			vendor: { __typename?: 'Organization'; id: string };
		};
	};
};

export type ProposalViewSentToProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: { __typename?: 'User'; id: string; email: string };
		assignedMember: { __typename?: 'OrgUser'; id: string };
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	};
};

export type ProposalViewPresentationProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	isPastDue: boolean;
	title?: string | null;
	sentAt?: Date | string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			name: string;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
		};
	};
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type ProposalViewPresentationOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	image?: string | null;
	name: string;
	updatedAt: Date | string;
};

export type ProposalViewPresentation_GetSharableProposalLinkQueryVariables =
	Exact<{
		where: ProposalWhereUniqueInput;
	}>;

export type ProposalViewPresentation_GetSharableProposalLinkQuery = {
	__typename?: 'Query';
	getSharableProposalLink: string;
};

export type ProposalViewProposalFragment = {
	__typename?: 'Proposal';
	id: string;
	status: ProposalStatus;
	isPastDue: boolean;
	title?: string | null;
	sentAt?: Date | string | null;
	eventDate?: Date | string | null;
	dueDate?: Date | string | null;
	source?: any | null;
	isReadOnly: boolean;
	automatedRemindersEnabled: boolean;
	imageUrl?: string | null;
	filename?: string | null;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
							user?: { __typename?: 'User'; id: string } | null;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
								}> | null;
							} | null;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			user?: { __typename?: 'User'; id: string } | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
				user?: { __typename?: 'User'; id: string } | null;
			}> | null;
			services: Array<{ __typename?: 'Service'; name: string; id: string }>;
		};
		invoices?: Array<{
			__typename?: 'Invoice';
			id: string;
			status: InvoiceStatus;
			title: string;
			guestToken?: string | null;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				dueDate?: Date | string | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
			}>;
		}> | null;
		customerSignatures?: Array<{
			__typename?: 'CustomerSignature';
			id: string;
			signature: {
				__typename?: 'Signature';
				id: string;
				signingDate?: Date | string | null;
				signer?: { __typename?: 'SignatureUser'; id: string } | null;
				contract?: {
					__typename?: 'SignatureContract';
					id: string;
					status: ContractStatus;
					dueDate: Date | string;
					title: string;
					guestToken?: string | null;
				} | null;
			};
		}> | null;
		proposals?: Array<{
			__typename?: 'Proposal';
			id: string;
			status: ProposalStatus;
			title?: string | null;
			guestToken?: string | null;
			dueDate?: Date | string | null;
		}> | null;
	};
	canvaDesign?: {
		__typename?: 'CanvaDesignViewFields';
		id: string;
		designId: string;
		editUrl: string;
		viewUrl: string;
		exportedImageUrl?: string | null;
	} | null;
	emailNotificationGroup?: {
		__typename?: 'EmailNotificationGroup';
		id: string;
		groupTitle: EmailNotificationGroupTitle;
		members: Array<{
			__typename?: 'ReducedUser';
			id?: string | null;
			email: string;
			userType: UserType;
			orgUser?: {
				__typename?: 'ReducedOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'ReducedOrganization';
					id?: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export type ProposalViewOrganizationFragment = {
	__typename?: 'Organization';
	id: string;
	image?: string | null;
	name: string;
	updatedAt: Date | string;
};

export type UseProposalMetrics_GetDashboardStatsForOrgQueryVariables = Exact<{
	where: DashboardWhereInput;
}>;

export type UseProposalMetrics_GetDashboardStatsForOrgQuery = {
	__typename?: 'Query';
	getDashboardStatsForOrg?: {
		__typename?: 'OrgDashboardStats';
		proposalsStatusSummary: {
			__typename?: 'ProposalsStatusSummary';
			totalProposalsSent: string;
			totalProposalsAccepted: string;
			totalProposalsOverdue: string;
		};
	} | null;
};

export type ProposalsTableFragment = {
	__typename?: 'Proposal';
	id: string;
	createdAt: Date | string;
	updatedAt: Date | string;
	dueDate?: Date | string | null;
	eventDate?: Date | string | null;
	isPastDue: boolean;
	status: ProposalStatus;
	imageUrl?: string | null;
	source?: any | null;
	sentAt?: Date | string | null;
	automatedRemindersEnabled: boolean;
	thumbnail?: string | null;
	title?: string | null;
	sentByUser?: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		user?: { __typename?: 'User'; id: string } | null;
	} | null;
	contact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		eventDate?: Date | string | null;
		companyName?: string | null;
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			} | null;
		};
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			image?: string | null;
			updatedAt: Date | string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
	};
};

export type UseProposalsTable_GetProposalsForOrganizationQueryVariables =
	Exact<{
		where: ProposalsForOrganizationInput;
		orderBy?: InputMaybe<
			| Array<InputMaybe<ProposalsOrderByInput>>
			| InputMaybe<ProposalsOrderByInput>
		>;
		skip?: InputMaybe<Scalars['Int']['input']>;
		take?: InputMaybe<Scalars['Int']['input']>;
	}>;

export type UseProposalsTable_GetProposalsForOrganizationQuery = {
	__typename?: 'Query';
	getProposalsForOrganization: {
		__typename?: 'Proposals';
		_count: number;
		proposals: Array<{
			__typename?: 'Proposal';
			id: string;
			createdAt: Date | string;
			updatedAt: Date | string;
			dueDate?: Date | string | null;
			eventDate?: Date | string | null;
			isPastDue: boolean;
			status: ProposalStatus;
			imageUrl?: string | null;
			source?: any | null;
			sentAt?: Date | string | null;
			automatedRemindersEnabled: boolean;
			thumbnail?: string | null;
			title?: string | null;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			contact: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				eventDate?: Date | string | null;
				companyName?: string | null;
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						name: string;
						services: Array<{
							__typename?: 'Service';
							id: string;
							name: string;
						}>;
					} | null;
				};
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				vendor: {
					__typename?: 'Organization';
					id: string;
					name: string;
					image?: string | null;
					updatedAt: Date | string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		}>;
	};
};

export type UseProposalsTable_GetProposalsForCustomerQueryVariables = Exact<{
	where: ProposalsForCustomerInput;
	orderBy?: InputMaybe<
		Array<InputMaybe<ProposalsOrderByInput>> | InputMaybe<ProposalsOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UseProposalsTable_GetProposalsForCustomerQuery = {
	__typename?: 'Query';
	getProposalsForCustomer: {
		__typename?: 'Proposals';
		_count: number;
		proposals: Array<{
			__typename?: 'Proposal';
			id: string;
			createdAt: Date | string;
			updatedAt: Date | string;
			dueDate?: Date | string | null;
			eventDate?: Date | string | null;
			isPastDue: boolean;
			status: ProposalStatus;
			imageUrl?: string | null;
			source?: any | null;
			sentAt?: Date | string | null;
			automatedRemindersEnabled: boolean;
			thumbnail?: string | null;
			title?: string | null;
			sentByUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				user?: { __typename?: 'User'; id: string } | null;
			} | null;
			contact: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				eventDate?: Date | string | null;
				companyName?: string | null;
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						name: string;
						services: Array<{
							__typename?: 'Service';
							id: string;
							name: string;
						}>;
					} | null;
				};
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				vendor: {
					__typename?: 'Organization';
					id: string;
					name: string;
					image?: string | null;
					updatedAt: Date | string;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
			};
		}>;
	};
};

export type UseProposalsTable_SendProposalMutationVariables = Exact<{
	where: ProposalWhereUniqueInput;
	data?: InputMaybe<SendProposalInput>;
}>;

export type UseProposalsTable_SendProposalMutation = {
	__typename?: 'Mutation';
	sendProposal: {
		__typename?: 'Proposal';
		id: string;
		createdAt: Date | string;
		updatedAt: Date | string;
		dueDate?: Date | string | null;
		eventDate?: Date | string | null;
		isPastDue: boolean;
		status: ProposalStatus;
		imageUrl?: string | null;
		source?: any | null;
		sentAt?: Date | string | null;
		automatedRemindersEnabled: boolean;
		thumbnail?: string | null;
		title?: string | null;
		sentByUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user?: { __typename?: 'User'; id: string } | null;
		} | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			eventDate?: Date | string | null;
			companyName?: string | null;
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				} | null;
			};
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				image?: string | null;
				updatedAt: Date | string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
		};
	};
};

export type ProposalsTableProposalTemplatesFragment = {
	__typename?: 'ProposalTemplate';
	id: string;
	createdAt: Date | string;
	title?: string | null;
	status: ProposalTemplateStatus;
	thumbnail?: string | null;
	proposals?: Array<{ __typename?: 'Proposal'; id: string }> | null;
};

export type UseProposalsTable_GetProposalTemplatesWhereQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where?: InputMaybe<ProposalTemplatesWhereInput>;
	orderBy?: InputMaybe<
		| Array<InputMaybe<ProposalTemplateWhereOrderByInput>>
		| InputMaybe<ProposalTemplateWhereOrderByInput>
	>;
}>;

export type UseProposalsTable_GetProposalTemplatesWhereQuery = {
	__typename?: 'Query';
	getProposalTemplatesWhere: {
		__typename?: 'ProposalTemplates';
		_count: number;
		proposalTemplates: Array<{
			__typename?: 'ProposalTemplate';
			id: string;
			createdAt: Date | string;
			title?: string | null;
			status: ProposalTemplateStatus;
			thumbnail?: string | null;
			proposals?: Array<{ __typename?: 'Proposal'; id: string }> | null;
		}>;
	};
};

export type UseProposalsTable_DeleteProposalTemplateMutationVariables = Exact<{
	where: ProposalTemplateWhereUniqueInput;
}>;

export type UseProposalsTable_DeleteProposalTemplateMutation = {
	__typename?: 'Mutation';
	deleteProposalTemplate: { __typename?: 'ProposalTemplate'; id: string };
};

export type OrganizationAvatarOnGetQuickPaymentFragment = {
	__typename?: 'OrganizationForGetQuickPayment';
	id: string;
	image?: string | null;
	name?: string | null;
	phone?: string | null;
	contactEmail?: string | null;
	updatedAt: Date | string;
};

export type OrganizationLeadFormPresentationalDataOrganizationFragment = {
	__typename?: 'LeadFormPresentationalDataOrganization';
	id: string;
	image?: string | null;
	name: string;
	phone?: string | null;
	contactEmail?: string | null;
	updatedAt: Date | string;
};

export type PaymentSectionOnGetQuickPaymentFragment = {
	__typename?: 'QuickPaymentForGetQuickPayment';
	id: string;
	amount?: number | null;
	reason?: string | null;
	organization: {
		__typename?: 'OrganizationForGetQuickPayment';
		id: string;
		cardConvenienceFeePercentage: number;
		achConvenienceFeePercentage: number;
		name?: string | null;
		country: Country;
		users: Array<{
			__typename?: 'OrgUserForGetQuickPayment';
			id: string;
			user: {
				__typename?: 'UserForGetQuickPayment';
				id: string;
				email: string;
			};
		} | null>;
	};
	contact?: {
		__typename?: 'ContactForGetQuickPayment';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'ContactCustomerForGetQuickPayment';
			id: string;
			email: string;
			userType: UserType;
		};
	} | null;
};

export type UsePaymentSectionContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		userType: UserType;
	};
};

export type UsePaymentSectionQuickPaymentFragment = {
	__typename?: 'QuickPaymentForGetQuickPayment';
	id: string;
	amount?: number | null;
	reason?: string | null;
	contact?: {
		__typename?: 'ContactForGetQuickPayment';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'ContactCustomerForGetQuickPayment';
			id: string;
			email: string;
			userType: UserType;
		};
	} | null;
	organization: {
		__typename?: 'OrganizationForGetQuickPayment';
		id: string;
		country: Country;
		users: Array<{
			__typename?: 'OrgUserForGetQuickPayment';
			id: string;
			user: {
				__typename?: 'UserForGetQuickPayment';
				id: string;
				email: string;
			};
		} | null>;
	};
};

export type UsePaymentSection_CreateOrUpdateContactForCustomerMutationVariables =
	Exact<{
		data: CreateOrUpdateContactForCustomerDataInput;
		where: CreateOrUpdateContactForCustomerWhereInput;
	}>;

export type UsePaymentSection_CreateOrUpdateContactForCustomerMutation = {
	__typename?: 'Mutation';
	createOrUpdateContactForCustomer: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			userType: UserType;
		};
	};
};

export type PaymentSection_CreateSecretsForQuickPaymentMutationVariables =
	Exact<{
		data: CreateSecretsForQuickPaymentInput;
	}>;

export type PaymentSection_CreateSecretsForQuickPaymentMutation = {
	__typename?: 'Mutation';
	createSecretsForQuickPayment: {
		__typename?: 'PaymentSessionSecrets';
		customerSecret?: string | null;
		invoiceId: string;
		currency: string;
		onBehalfOf?: string | null;
		excludedPaymentMethodTypes: Array<string>;
	};
};

export type PaymentSection_CreateIntentForQuickPaymentMutationVariables =
	Exact<{
		data: CreateIntentForQuickPaymentInput;
	}>;

export type PaymentSection_CreateIntentForQuickPaymentMutation = {
	__typename?: 'Mutation';
	createIntentForQuickPayment: {
		__typename?: 'PaymentIntent';
		id: string;
		clientSecret: string;
		amount: number;
	};
};

export type UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationVariables =
	Exact<{
		data: ReportQuickPaymentFromCustomerSessionInput;
	}>;

export type UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation = {
	__typename?: 'Mutation';
	reportQuickPaymentFromCustomerSession: {
		__typename?: 'Invoice';
		id: string;
		guestToken?: string | null;
	};
};

export type QuickPaymentDetail_GetQuickPaymentQueryVariables = Exact<{
	where: QuickPaymentUniqueInput;
}>;

export type QuickPaymentDetail_GetQuickPaymentQuery = {
	__typename?: 'Query';
	getQuickPayment: {
		__typename?: 'QuickPaymentForGetQuickPayment';
		id: string;
		amount?: number | null;
		reason?: string | null;
		organization: {
			__typename?: 'OrganizationForGetQuickPayment';
			id: string;
			name?: string | null;
			cardConvenienceFeePercentage: number;
			achConvenienceFeePercentage: number;
			country: Country;
			image?: string | null;
			phone?: string | null;
			contactEmail?: string | null;
			updatedAt: Date | string;
			users: Array<{
				__typename?: 'OrgUserForGetQuickPayment';
				id: string;
				user: {
					__typename?: 'UserForGetQuickPayment';
					id: string;
					email: string;
				};
			} | null>;
		};
		contact?: {
			__typename?: 'ContactForGetQuickPayment';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'ContactCustomerForGetQuickPayment';
				id: string;
				email: string;
				userType: UserType;
			};
		} | null;
	};
};

export type UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationVariables =
	Exact<{
		data: QuickPaymentLinkCreateInput;
	}>;

export type UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation = {
	__typename?: 'Mutation';
	createOrGetQuickPaymentLink: {
		__typename?: 'QuickPaymentLink';
		url?: string | null;
	};
};

export type RecaptchaInterstitial_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type RecaptchaInterstitial_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		CaptchaURL?: string | null;
	};
};

export type RecaptchaInterstitial_ValidateRecaptchaMutationVariables = Exact<{
	token: Scalars['String']['input'];
}>;

export type RecaptchaInterstitial_ValidateRecaptchaMutation = {
	__typename?: 'Mutation';
	validateRecaptcha: boolean;
};

export type RecaptchaInterstitial_GetFeatureFlagsQueryVariables = Exact<{
	[key: string]: never;
}>;

export type RecaptchaInterstitial_GetFeatureFlagsQuery = {
	__typename?: 'Query';
	getFeatureFlags: Array<{
		__typename?: 'ReducedFeatureFlag';
		category: FeatureCategory;
		active: boolean;
	}>;
};

export type ReportsIndex_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type ReportsIndex_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
		} | null;
	} | null;
};

export type ReportsIndex_ExportInvoicesQueryVariables = Exact<{
	data: ExportInvoicesDataInput;
}>;

export type ReportsIndex_ExportInvoicesQuery = {
	__typename?: 'Query';
	exportInvoices: string;
};

export type ReportsIndex_ExportOrgOfflineTransactionHistoryQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		data: ExportHistoryInput;
	}>;

export type ReportsIndex_ExportOrgOfflineTransactionHistoryQuery = {
	__typename?: 'Query';
	exportOrgOfflineTransactionHistory: {
		__typename?: 'TransactionHistoryUrl';
		url: string;
	};
};

export type ReportsIndex_ExportOrgTransactionHistoryQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
	data: ExportHistoryInput;
}>;

export type ReportsIndex_ExportOrgTransactionHistoryQuery = {
	__typename?: 'Query';
	exportOrgTransactionHistory: boolean;
};

export type ReportsIndex_ExportWalletQuickPaymentsQueryVariables = Exact<{
	where: ExportWalletQuickPaymentsWhereInput;
	data: ExportWalletQuickPaymentsDataInput;
}>;

export type ReportsIndex_ExportWalletQuickPaymentsQuery = {
	__typename?: 'Query';
	exportWalletQuickPayments: string;
};

export type ReportsIndex_ExportDashboardStatsForOrgQueryVariables = Exact<{
	where: DashboardExportInput;
}>;

export type ReportsIndex_ExportDashboardStatsForOrgQuery = {
	__typename?: 'Query';
	exportDashboardStatsForOrg?: string | null;
};

export type ReportsIndex_GetStripeInvoicesForVendorCustomerQueryVariables =
	Exact<{ [key: string]: never }>;

export type ReportsIndex_GetStripeInvoicesForVendorCustomerQuery = {
	__typename?: 'Query';
	getStripeInvoicesForVendorCustomer: {
		__typename?: 'StripeInvoicesList';
		data: Array<{
			__typename?: 'StripeInvoice';
			id?: string | null;
			invoice_pdf?: string | null;
			date?: number | null;
			period_start?: number | null;
		} | null>;
	};
};

export type ResourceDetailButtonBarResourceFragment = {
	__typename?: 'CustomResource';
	id: string;
	description: string;
};

export type ResourceDetailButtonBarDownloadButtonResourceFragment = {
	__typename?: 'CustomResource';
	id: string;
	description: string;
};

export type ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryVariables =
	Exact<{
		where: ResourceWhereUniqueInput;
	}>;

export type ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery = {
	__typename?: 'Query';
	downloadResourceWhere: {
		__typename?: 'CustomResource';
		id: string;
		downloadUrl?: string | null;
	};
};

export type ResourceDetailFileViewerResourceFragment = {
	__typename?: 'CustomResource';
	id: string;
	previewDownloadUrl?: string | null;
};

export type ResourceDetailHeaderResourceFragment = {
	__typename?: 'CustomResource';
	id: string;
	description: string;
	category: ResourceCategory;
	sponsor: {
		__typename?: 'CustomSponsor';
		id: string;
		name: string;
		logo?: string | null;
		sponsorLink: string;
	};
};

export type ResourceDetailFragment = {
	__typename?: 'CustomResource';
	id: string;
	description: string;
	category: ResourceCategory;
	previewDownloadUrl?: string | null;
	sponsor: {
		__typename?: 'CustomSponsor';
		id: string;
		name: string;
		logo?: string | null;
		sponsorLink: string;
	};
};

export type ResourceDetail_GetResourceWhereQueryVariables = Exact<{
	where: ResourceWhereUniqueInput;
}>;

export type ResourceDetail_GetResourceWhereQuery = {
	__typename?: 'Query';
	getResourceWhere: {
		__typename?: 'CustomResource';
		id: string;
		description: string;
		category: ResourceCategory;
		previewDownloadUrl?: string | null;
		sponsor: {
			__typename?: 'CustomSponsor';
			id: string;
			name: string;
			logo?: string | null;
			sponsorLink: string;
		};
	};
};

export type ResourcesTable_DownloadResourceWhereQueryVariables = Exact<{
	where: ResourceWhereUniqueInput;
}>;

export type ResourcesTable_DownloadResourceWhereQuery = {
	__typename?: 'Query';
	downloadResourceWhere: {
		__typename?: 'CustomResource';
		id: string;
		downloadUrl?: string | null;
	};
};

export type ResourcesTableFragment = {
	__typename?: 'CustomResource';
	id: string;
	fileType: FileType;
	category: ResourceCategory;
	description: string;
	status: ResourceStatus;
	createdAt: Date | string;
	updatedAt: Date | string;
	sponsor: {
		__typename?: 'CustomSponsor';
		id: string;
		logo?: string | null;
		name: string;
		description: string;
		sponsorLink: string;
	};
};

export type ResourcesTable_GetResourcesWhereQueryVariables = Exact<{
	where: ResourceWhereInput;
	orderBy?: InputMaybe<Array<ResourceOrderByInput> | ResourceOrderByInput>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ResourcesTable_GetResourcesWhereQuery = {
	__typename?: 'Query';
	getResourcesWhere: {
		__typename?: 'CustomResources';
		_count: number;
		resources: Array<{
			__typename?: 'CustomResource';
			id: string;
			fileType: FileType;
			category: ResourceCategory;
			description: string;
			status: ResourceStatus;
			createdAt: Date | string;
			updatedAt: Date | string;
			sponsor: {
				__typename?: 'CustomSponsor';
				id: string;
				logo?: string | null;
				name: string;
				description: string;
				sponsorLink: string;
			};
		}>;
	};
};

export type Role_SetTeamMemberRoleMutationVariables = Exact<{
	where: OrgUserWhereUniqueInput;
	data: TeamMemberRole;
}>;

export type Role_SetTeamMemberRoleMutation = {
	__typename?: 'Mutation';
	setTeamMemberRole: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type Role_DisableOrgMemberMutationVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type Role_DisableOrgMemberMutation = {
	__typename?: 'Mutation';
	disableOrgMember: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type Role_ReactivateOrgMemberMutationVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type Role_ReactivateOrgMemberMutation = {
	__typename?: 'Mutation';
	reactivateOrgMember: {
		__typename?: 'Organization';
		id: string;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
	};
};

export type SelectServices_GetServicesWhereQueryVariables = Exact<{
	[key: string]: never;
}>;

export type SelectServices_GetServicesWhereQuery = {
	__typename?: 'Query';
	getServicesWhere: Array<{ __typename?: 'Service'; id: string; name: string }>;
};

export type SendDocumentsModalContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	eventDate?: Date | string | null;
	customer: { __typename?: 'User'; id: string };
};

export type ShareWidgetContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	status: ContactStatus;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		image?: string | null;
		updatedAt: Date | string;
		name: string;
	};
};

export type ShareWidgetDocumentFragment = {
	__typename?: 'Document';
	id: string;
	type: DocumentType;
	ownerType: DocumentOwnerType;
	sharedWithCustomer: boolean;
	sharedWithContacts?: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		status: ContactStatus;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			image?: string | null;
			updatedAt: Date | string;
			name: string;
		};
	}> | null;
	customer?: {
		__typename?: 'User';
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
			firstNameOne: string;
			lastNameOne?: string | null;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			updatedAt: Date | string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
	organization?: { __typename?: 'Organization'; id: string } | null;
};

export type ShareWidget_ShareDocumentMutationVariables = Exact<{
	where: DocumentWhereUniqueInput;
	data: CustomShareDocumentInput;
}>;

export type ShareWidget_ShareDocumentMutation = {
	__typename?: 'Mutation';
	shareDocument: {
		__typename?: 'Document';
		id: string;
		type: DocumentType;
		ownerType: DocumentOwnerType;
		sharedWithCustomer: boolean;
		sharedWithContacts?: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			status: ContactStatus;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					updatedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				image?: string | null;
				updatedAt: Date | string;
				name: string;
			};
		}> | null;
		customer?: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				updatedAt: Date | string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		orgUser?: { __typename?: 'OrgUser'; id: string } | null;
		organization?: { __typename?: 'Organization'; id: string } | null;
	};
};

export type RequestVerificationEmail_CreateVerificationTokenMutationVariables =
	Exact<{
		data: CreateVerificationTokenInput;
	}>;

export type RequestVerificationEmail_CreateVerificationTokenMutation = {
	__typename?: 'Mutation';
	createVerificationToken?: boolean | null;
};

export type SignUpPage_LogoutMutationVariables = Exact<{
	[key: string]: never;
}>;

export type SignUpPage_LogoutMutation = {
	__typename?: 'Mutation';
	logout: boolean;
};

export type SitewideSearch_SitewideSearchQueryVariables = Exact<{
	where: SearchWhereInput;
	data: SearchDataInput;
}>;

export type SitewideSearch_SitewideSearchQuery = {
	__typename?: 'Query';
	sitewideSearch: Array<{
		__typename?: 'SearchResult';
		title: string;
		path: string;
		subtitle?: string | null;
		type: SearchResultType;
	}>;
};

export type DocumentContactFragmentFragment = {
	__typename?: 'Contact';
	id: string;
	customer: { __typename?: 'User'; id: string };
};

export type SourceInput_GetOrganizationSourcesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type SourceInput_GetOrganizationSourcesQuery = {
	__typename?: 'Query';
	getOrganizationSources?: {
		__typename?: 'OrganizationSources';
		id: string;
		source: Array<string>;
	} | null;
};

export type SubscriptionTrialEnding_GetOrganizationWhereQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type SubscriptionTrialEnding_GetOrganizationWhereQuery = {
	__typename?: 'Query';
	getOrganizationWhere?: {
		__typename?: 'Organization';
		id: string;
		subscription?: {
			__typename?: 'AppSubscription';
			id: string;
			status?: SubscriptionStatus | null;
			subscriptionPlan: {
				__typename?: 'Plan';
				id: string;
				type: PlanType;
				period: PlanPeriod;
			};
		} | null;
	} | null;
};

export type SubscriptionTrialEnding_GetEventsWhereQueryVariables = Exact<{
	where: EventWhereInput;
}>;

export type SubscriptionTrialEnding_GetEventsWhereQuery = {
	__typename?: 'Query';
	getEventsWhere?: Array<{
		__typename?: 'Event';
		id: string;
		dismissingUsers?: Array<{ __typename?: 'User'; id: string }> | null;
	}> | null;
};

export type SubscriptionTrialEnding_DismissEventMutationVariables = Exact<{
	where: EventWhereUniqueInput;
}>;

export type SubscriptionTrialEnding_DismissEventMutation = {
	__typename?: 'Mutation';
	dismissEvent: boolean;
};

export type SubscriptionTrialEnding_EventCreatedSubscriptionVariables = Exact<{
	[key: string]: never;
}>;

export type SubscriptionTrialEnding_EventCreatedSubscription = {
	__typename?: 'Subscription';
	eventCreated: { __typename?: 'Event'; id: string; category: EventCategory };
};

export type TermsOfService_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type TermsOfService_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		StripeLegalUrl?: string | null;
		TermsOfServiceUrl?: string | null;
	};
};

export type UseVendorDashboard_DashboardStatsForOrgFragment = {
	__typename?: 'OrgDashboardStats';
	leads: Array<{
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		email: string;
	}>;
	clients: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	}>;
	newClients: Array<{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	}>;
	proposalsAccepted: Array<{
		__typename?: 'Proposal';
		id: string;
		title?: string | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string; email: string };
		};
	}>;
	proposalsOutstanding: Array<{
		__typename?: 'Proposal';
		id: string;
		title?: string | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string; email: string };
		};
	}>;
	paymentsReceived: {
		__typename?: 'PaymentsReceived';
		totalAmountReceived: string;
		invoices: Array<{
			__typename?: 'InvoiceForDashboardStats';
			id: string;
			title: string;
			amount: string;
			clientEmail: string;
		}>;
	};
	proposalsStatusSummary: {
		__typename?: 'ProposalsStatusSummary';
		totalProposalsAccepted: string;
		totalProposalsDrafts: string;
		totalProposalsOverdue: string;
		totalProposalsSent: string;
	};
	contractsOutstanding: Array<{
		__typename?: 'CustomContract';
		id: string;
		title?: string | null;
		signatures: Array<{
			__typename?: 'Signature';
			id: string;
			customerSignature?: {
				__typename?: 'CustomerSignature';
				id: string;
				contact: {
					__typename?: 'CustomerSignatureContact';
					id: string;
					customer: {
						__typename?: 'CustomerSignatureContactCustomer';
						id: string;
						email: string;
					};
				};
			} | null;
		}>;
	}>;
	contractsCompleted: Array<{
		__typename?: 'CustomContract';
		id: string;
		title?: string | null;
		signatures: Array<{
			__typename?: 'Signature';
			id: string;
			customerSignature?: {
				__typename?: 'CustomerSignature';
				id: string;
				contact: {
					__typename?: 'CustomerSignatureContact';
					id: string;
					customer: {
						__typename?: 'CustomerSignatureContactCustomer';
						id: string;
						email: string;
					};
				};
			} | null;
		}>;
	}>;
	contractsSummary: {
		__typename?: 'ContractsSummary';
		totalContractsSigned: string;
		totalContractsAwaitingSignature: string;
		totalContractsDrafts: string;
		totalContractsOverdue: string;
	};
	failedPayments: {
		__typename?: 'FailedPayments';
		totalAmountFailed: string;
		invoices: Array<{
			__typename?: 'InvoiceForDashboardStats';
			id: string;
			title: string;
			amount: string;
			clientEmail: string;
		}>;
	};
	paymentsSummary: {
		__typename?: 'PaymentsSummary';
		totalInvoicesPaid: string;
		totalAmountUpcoming: string;
		totalInvoicesDrafts: string;
		totalInvoicesOverdue: string;
		totalAmountRefunded: string;
	};
	upcomingPayments: {
		__typename?: 'UpcomingPayments';
		totalAmountUpcoming: string;
		invoices: Array<{
			__typename?: 'InvoiceForDashboardStats';
			id: string;
			title: string;
			amount: string;
			clientEmail: string;
		}>;
	};
	overduePayments: {
		__typename?: 'OverduePayments';
		totalAmountOverdue: string;
		invoices: Array<{
			__typename?: 'InvoiceForDashboardStats';
			id: string;
			title: string;
			amount: string;
			clientEmail: string;
		}>;
	};
	leadsGraph: {
		__typename?: 'DatePointsComparison';
		labels: Array<string>;
		current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
		previous: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
	};
	clientsGraph: {
		__typename?: 'DatePointsComparison';
		labels: Array<string>;
		current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
		previous: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
	};
	contractsCompletedGraph: {
		__typename?: 'DatePointsComparison';
		labels: Array<string>;
		current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
		previous: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
	};
	proposalsAcceptedGraph: {
		__typename?: 'DatePointsComparison';
		labels: Array<string>;
		current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
		previous: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
	};
	paymentsReceivedGraph: {
		__typename?: 'DatePointsComparison';
		labels: Array<string>;
		current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
		previous: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
	};
	topCustomersBySpend: Array<{
		__typename?: 'TopCustomerBySpend';
		contactEmail: string;
		contactName: string;
		customerId: string;
		totalLifetimeSpend: string;
	}>;
};

export type UseVendorDashboard_GetDashboardStatsForOrgQueryVariables = Exact<{
	where: DashboardWhereInput;
}>;

export type UseVendorDashboard_GetDashboardStatsForOrgQuery = {
	__typename?: 'Query';
	getDashboardStatsForOrg?: {
		__typename?: 'OrgDashboardStats';
		leads: Array<{
			__typename?: 'Inquiry';
			id: string;
			firstName: string;
			lastName: string;
			email: string;
		}>;
		clients: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: { __typename?: 'User'; id: string; email: string };
		}>;
		newClients: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: { __typename?: 'User'; id: string; email: string };
		}>;
		proposalsAccepted: Array<{
			__typename?: 'Proposal';
			id: string;
			title?: string | null;
			contact: {
				__typename?: 'Contact';
				id: string;
				customer: { __typename?: 'User'; id: string; email: string };
			};
		}>;
		proposalsOutstanding: Array<{
			__typename?: 'Proposal';
			id: string;
			title?: string | null;
			contact: {
				__typename?: 'Contact';
				id: string;
				customer: { __typename?: 'User'; id: string; email: string };
			};
		}>;
		paymentsReceived: {
			__typename?: 'PaymentsReceived';
			totalAmountReceived: string;
			invoices: Array<{
				__typename?: 'InvoiceForDashboardStats';
				id: string;
				title: string;
				amount: string;
				clientEmail: string;
			}>;
		};
		proposalsStatusSummary: {
			__typename?: 'ProposalsStatusSummary';
			totalProposalsAccepted: string;
			totalProposalsDrafts: string;
			totalProposalsOverdue: string;
			totalProposalsSent: string;
		};
		contractsOutstanding: Array<{
			__typename?: 'CustomContract';
			id: string;
			title?: string | null;
			signatures: Array<{
				__typename?: 'Signature';
				id: string;
				customerSignature?: {
					__typename?: 'CustomerSignature';
					id: string;
					contact: {
						__typename?: 'CustomerSignatureContact';
						id: string;
						customer: {
							__typename?: 'CustomerSignatureContactCustomer';
							id: string;
							email: string;
						};
					};
				} | null;
			}>;
		}>;
		contractsCompleted: Array<{
			__typename?: 'CustomContract';
			id: string;
			title?: string | null;
			signatures: Array<{
				__typename?: 'Signature';
				id: string;
				customerSignature?: {
					__typename?: 'CustomerSignature';
					id: string;
					contact: {
						__typename?: 'CustomerSignatureContact';
						id: string;
						customer: {
							__typename?: 'CustomerSignatureContactCustomer';
							id: string;
							email: string;
						};
					};
				} | null;
			}>;
		}>;
		contractsSummary: {
			__typename?: 'ContractsSummary';
			totalContractsSigned: string;
			totalContractsAwaitingSignature: string;
			totalContractsDrafts: string;
			totalContractsOverdue: string;
		};
		failedPayments: {
			__typename?: 'FailedPayments';
			totalAmountFailed: string;
			invoices: Array<{
				__typename?: 'InvoiceForDashboardStats';
				id: string;
				title: string;
				amount: string;
				clientEmail: string;
			}>;
		};
		paymentsSummary: {
			__typename?: 'PaymentsSummary';
			totalInvoicesPaid: string;
			totalAmountUpcoming: string;
			totalInvoicesDrafts: string;
			totalInvoicesOverdue: string;
			totalAmountRefunded: string;
		};
		upcomingPayments: {
			__typename?: 'UpcomingPayments';
			totalAmountUpcoming: string;
			invoices: Array<{
				__typename?: 'InvoiceForDashboardStats';
				id: string;
				title: string;
				amount: string;
				clientEmail: string;
			}>;
		};
		overduePayments: {
			__typename?: 'OverduePayments';
			totalAmountOverdue: string;
			invoices: Array<{
				__typename?: 'InvoiceForDashboardStats';
				id: string;
				title: string;
				amount: string;
				clientEmail: string;
			}>;
		};
		leadsGraph: {
			__typename?: 'DatePointsComparison';
			labels: Array<string>;
			current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
			previous: Array<{
				__typename?: 'DatePoint';
				x: Date | string;
				y: number;
			}>;
		};
		clientsGraph: {
			__typename?: 'DatePointsComparison';
			labels: Array<string>;
			current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
			previous: Array<{
				__typename?: 'DatePoint';
				x: Date | string;
				y: number;
			}>;
		};
		contractsCompletedGraph: {
			__typename?: 'DatePointsComparison';
			labels: Array<string>;
			current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
			previous: Array<{
				__typename?: 'DatePoint';
				x: Date | string;
				y: number;
			}>;
		};
		proposalsAcceptedGraph: {
			__typename?: 'DatePointsComparison';
			labels: Array<string>;
			current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
			previous: Array<{
				__typename?: 'DatePoint';
				x: Date | string;
				y: number;
			}>;
		};
		paymentsReceivedGraph: {
			__typename?: 'DatePointsComparison';
			labels: Array<string>;
			current: Array<{ __typename?: 'DatePoint'; x: Date | string; y: number }>;
			previous: Array<{
				__typename?: 'DatePoint';
				x: Date | string;
				y: number;
			}>;
		};
		topCustomersBySpend: Array<{
			__typename?: 'TopCustomerBySpend';
			contactEmail: string;
			contactName: string;
			customerId: string;
			totalLifetimeSpend: string;
		}>;
	} | null;
};

export type VendorDashboardConfiguration_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type VendorDashboardConfiguration_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		user?: {
			__typename?: 'User';
			id: string;
			vendorDashboardConfigurationItems?: Array<{
				__typename?: 'VendorDashboardItem';
				id: string;
				order: number;
				enabled: boolean;
				type: VendorDashboardItemType;
			}> | null;
		} | null;
	} | null;
};

export type UseDashboardConfigurationVendorDashboardItemFragment = {
	__typename?: 'VendorDashboardItem';
	id: string;
	order: number;
	enabled: boolean;
	type: VendorDashboardItemType;
};

export type UseDashboardConfigurationUserFragment = {
	__typename?: 'User';
	id: string;
	vendorDashboardConfigurationItems?: Array<{
		__typename?: 'VendorDashboardItem';
		id: string;
		order: number;
		enabled: boolean;
		type: VendorDashboardItemType;
	}> | null;
};

export type DashboardConfiguration_UpdateVendorDashboardConfigurationMutationVariables =
	Exact<{
		data: VendorDashboardConfigurationInput;
	}>;

export type DashboardConfiguration_UpdateVendorDashboardConfigurationMutation =
	{
		__typename?: 'Mutation';
		updateVendorDashboardConfiguration: {
			__typename?: 'User';
			id: string;
			vendorDashboardConfigurationItems?: Array<{
				__typename?: 'VendorDashboardItem';
				id: string;
				order: number;
				enabled: boolean;
				type: VendorDashboardItemType;
			}> | null;
		};
	};

export type InvitationSubMenuInvitationFragment = {
	__typename?: 'Invitation';
	id: string;
	createdAt: Date | string;
	recipientFirstName: string;
	recipientLastName?: string | null;
	emailAddress: string;
	invitationType: InviteEnum;
};

export type InvitationSubMenu_DeleteInvitationMutationVariables = Exact<{
	where: InvitationWhereCustomInput;
}>;

export type InvitationSubMenu_DeleteInvitationMutation = {
	__typename?: 'Mutation';
	deleteInvitation: {
		__typename?: 'PendingInvitations';
		_count: number;
		pendingInvitations: Array<{
			__typename?: 'Invitation';
			id: string;
			createdAt: Date | string;
			recipientFirstName: string;
			recipientLastName?: string | null;
			emailAddress: string;
			invitationType: InviteEnum;
		}>;
	};
};

export type UseVendorsTableContactFragment = {
	__typename?: 'Contact';
	id: string;
	createdAt: Date | string;
	eventDate?: Date | string | null;
	firstName: string;
	lastName: string;
	phone?: string | null;
	status: ContactStatus;
	updatedAt: Date | string;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'User';
		id: string;
		email: string;
		blocked: boolean;
		createdAt: Date | string;
		updatedAt: Date | string;
		userType: UserType;
		eventsLastViewedAt: Date | string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			updatedAt: Date | string;
			createdAt: Date | string;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			phone?: string | null;
			weddingDate?: Date | string | null;
			addressLine1: string;
			addressLine2?: string | null;
			city: string;
			country: Country;
			postalCode?: string | null;
			plannerOrgCanPayInvoices: boolean;
			plannerOrgCanSignContracts: boolean;
			plannerOrgHasConnectionPermissions: boolean;
			plannerOrgHasDocumentsPermissions: boolean;
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				organization?: { __typename?: 'Organization'; id: string } | null;
			} | null;
			user: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
			};
		} | null;
		orgUser?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			user?: {
				__typename?: 'User';
				id: string;
				email: string;
				userType: UserType;
			} | null;
		} | null;
		guestUser?: {
			__typename?: 'GuestUser';
			id: string;
			user: { __typename?: 'User'; id: string; email: string };
		} | null;
	};
	assignedMember: {
		__typename?: 'OrgUser';
		id: string;
		firstName: string;
		lastName: string;
		role: TeamMemberRole;
		createdAt: Date | string;
		updatedAt: Date | string;
		user?: {
			__typename?: 'User';
			id: string;
			email: string;
			blocked: boolean;
			createdAt: Date | string;
			updatedAt: Date | string;
			userType: UserType;
			eventsLastViewedAt: Date | string;
		} | null;
	};
	vendor: {
		__typename?: 'Organization';
		id: string;
		name: string;
		updatedAt: Date | string;
		image?: string | null;
		contactEmail?: string | null;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	};
};

export type VendorsTable_GetContactsWhereQueryVariables = Exact<{
	orderBy?: InputMaybe<
		Array<InputMaybe<ContactOrderByInput>> | InputMaybe<ContactOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContactWhereInput;
}>;

export type VendorsTable_GetContactsWhereQuery = {
	__typename?: 'Query';
	getContactsWhere: {
		__typename?: 'Contacts';
		_count: number;
		contacts: Array<{
			__typename?: 'Contact';
			id: string;
			createdAt: Date | string;
			eventDate?: Date | string | null;
			firstName: string;
			lastName: string;
			phone?: string | null;
			status: ContactStatus;
			updatedAt: Date | string;
			hasCustomerIntent: boolean;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				blocked: boolean;
				createdAt: Date | string;
				updatedAt: Date | string;
				userType: UserType;
				eventsLastViewedAt: Date | string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					updatedAt: Date | string;
					createdAt: Date | string;
					firstNameOne: string;
					lastNameOne?: string | null;
					firstNameTwo?: string | null;
					lastNameTwo?: string | null;
					phone?: string | null;
					weddingDate?: Date | string | null;
					addressLine1: string;
					addressLine2?: string | null;
					city: string;
					country: Country;
					postalCode?: string | null;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgCanSignContracts: boolean;
					plannerOrgHasConnectionPermissions: boolean;
					plannerOrgHasDocumentsPermissions: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
					user: {
						__typename?: 'User';
						id: string;
						email: string;
						userType: UserType;
					};
				} | null;
				orgUser?: {
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
					user?: {
						__typename?: 'User';
						id: string;
						email: string;
						userType: UserType;
					} | null;
				} | null;
				guestUser?: {
					__typename?: 'GuestUser';
					id: string;
					user: { __typename?: 'User'; id: string; email: string };
				} | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				role: TeamMemberRole;
				createdAt: Date | string;
				updatedAt: Date | string;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					blocked: boolean;
					createdAt: Date | string;
					updatedAt: Date | string;
					userType: UserType;
					eventsLastViewedAt: Date | string;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				updatedAt: Date | string;
				image?: string | null;
				contactEmail?: string | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			};
		}>;
	};
};

export type VendorsTable_ActivateContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data?: InputMaybe<ActivateContactCustomInput>;
}>;

export type VendorsTable_ActivateContactMutation = {
	__typename?: 'Mutation';
	activateContact: {
		__typename?: 'Contact';
		id: string;
		createdAt: Date | string;
		eventDate?: Date | string | null;
		firstName: string;
		lastName: string;
		phone?: string | null;
		status: ContactStatus;
		updatedAt: Date | string;
		hasCustomerIntent: boolean;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			blocked: boolean;
			createdAt: Date | string;
			updatedAt: Date | string;
			userType: UserType;
			eventsLastViewedAt: Date | string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				updatedAt: Date | string;
				createdAt: Date | string;
				firstNameOne: string;
				lastNameOne?: string | null;
				firstNameTwo?: string | null;
				lastNameTwo?: string | null;
				phone?: string | null;
				weddingDate?: Date | string | null;
				addressLine1: string;
				addressLine2?: string | null;
				city: string;
				country: Country;
				postalCode?: string | null;
				plannerOrgCanPayInvoices: boolean;
				plannerOrgCanSignContracts: boolean;
				plannerOrgHasConnectionPermissions: boolean;
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
				user: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				};
			} | null;
			orgUser?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				user?: {
					__typename?: 'User';
					id: string;
					email: string;
					userType: UserType;
				} | null;
			} | null;
			guestUser?: {
				__typename?: 'GuestUser';
				id: string;
				user: { __typename?: 'User'; id: string; email: string };
			} | null;
		};
		assignedMember: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			role: TeamMemberRole;
			createdAt: Date | string;
			updatedAt: Date | string;
			user?: {
				__typename?: 'User';
				id: string;
				email: string;
				blocked: boolean;
				createdAt: Date | string;
				updatedAt: Date | string;
				userType: UserType;
				eventsLastViewedAt: Date | string;
			} | null;
		};
		vendor: {
			__typename?: 'Organization';
			id: string;
			name: string;
			updatedAt: Date | string;
			image?: string | null;
			contactEmail?: string | null;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		};
	};
};

export type UseVendorsTableInvitationFragment = {
	__typename?: 'Invitation';
	id: string;
	createdAt: Date | string;
	recipientFirstName: string;
	recipientLastName?: string | null;
	emailAddress: string;
	invitationType: InviteEnum;
};

export type VendorsTable_GetPendingInvitationsQueryVariables = Exact<{
	where: InvitationsWhereCustomInput;
	take?: InputMaybe<Scalars['Int']['input']>;
	skip?: InputMaybe<Scalars['Int']['input']>;
}>;

export type VendorsTable_GetPendingInvitationsQuery = {
	__typename?: 'Query';
	getPendingInvitations: {
		__typename?: 'PendingInvitations';
		_count: number;
		pendingInvitations: Array<{
			__typename?: 'Invitation';
			id: string;
			createdAt: Date | string;
			recipientFirstName: string;
			recipientLastName?: string | null;
			emailAddress: string;
			invitationType: InviteEnum;
		}>;
	};
};

export type PaymentMethodHistoryTable_HistoryFragment = {
	__typename?: 'PaymentHistoryItem';
	amount: number;
	date?: string | null;
	type?: string | null;
	id?: string | null;
	currency?: string | null;
	organization?: {
		__typename?: 'OrganizationForPaymentHistoryItem';
		id?: string | null;
		name?: string | null;
	} | null;
	invoice?: {
		__typename?: 'InvoiceForPaymentHistoryItem';
		id?: string | null;
		title?: string | null;
	} | null;
};

export type PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryVariables =
	Exact<{
		where: PaymentMethodWhereInput;
		take?: InputMaybe<Scalars['Int']['input']>;
		cursor?: InputMaybe<Scalars['String']['input']>;
	}>;

export type PaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery = {
	__typename?: 'Query';
	getHistoryForPaymentMethod: {
		__typename?: 'PaymentHistoryWithPagination';
		hasMore: boolean;
		nextCursor?: string | null;
		data: Array<{
			__typename?: 'PaymentHistoryItem';
			amount: number;
			date?: string | null;
			type?: string | null;
			id?: string | null;
			currency?: string | null;
			organization?: {
				__typename?: 'OrganizationForPaymentHistoryItem';
				id?: string | null;
				name?: string | null;
			} | null;
			invoice?: {
				__typename?: 'InvoiceForPaymentHistoryItem';
				id?: string | null;
				title?: string | null;
			} | null;
		}>;
	};
};

export type SourceForCustomerWalletDrawerFragment = {
	__typename?: 'Source';
	id: string;
	object: string;
	name?: string | null;
	brand?: string | null;
	last4?: string | null;
	status?: string | null;
	exp_year?: number | null;
	exp_month?: number | null;
	fingerprint?: string | null;
	legacy?: boolean | null;
	account_holder_type?: string | null;
	address_zip?: string | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
	billing_details?: {
		__typename?: 'BillingDetails';
		name?: string | null;
		address?: {
			__typename?: 'StripeAddress';
			postal_code?: string | null;
		} | null;
	} | null;
};

export type GetPaymentSourcesForCustomerSourceFragment = {
	__typename?: 'Source';
	id: string;
	bank_name?: string | null;
	object: string;
	last4?: string | null;
	brand?: string | null;
	name?: string | null;
	status?: string | null;
	exp_year?: number | null;
	exp_month?: number | null;
	fingerprint?: string | null;
	legacy?: boolean | null;
	account_holder_type?: string | null;
	address_zip?: string | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
	billing_details?: {
		__typename?: 'BillingDetails';
		name?: string | null;
		address?: {
			__typename?: 'StripeAddress';
			postal_code?: string | null;
		} | null;
	} | null;
};

export type PaymentAccounts_GetPaymentSourcesForCustomerQueryVariables = Exact<{
	where: UserByIdUniqueInput;
	cursor?: InputMaybe<PaginationCursor>;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PaymentAccounts_GetPaymentSourcesForCustomerQuery = {
	__typename?: 'Query';
	getPaymentSourcesForCustomer: {
		__typename?: 'SourcesWithDefaultSource';
		default_source?: string | null;
		has_more?: boolean | null;
		data?: Array<{
			__typename?: 'Source';
			id: string;
			bank_name?: string | null;
			object: string;
			last4?: string | null;
			brand?: string | null;
			name?: string | null;
			status?: string | null;
			exp_year?: number | null;
			exp_month?: number | null;
			fingerprint?: string | null;
			legacy?: boolean | null;
			account_holder_type?: string | null;
			address_zip?: string | null;
			metadata?: Array<{
				__typename?: 'ReturningMetaData';
				key?: string | null;
				value?: string | null;
			} | null> | null;
			billing_details?: {
				__typename?: 'BillingDetails';
				name?: string | null;
				address?: {
					__typename?: 'StripeAddress';
					postal_code?: string | null;
				} | null;
			} | null;
		}> | null;
	};
};

export type ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryVariables =
	Exact<{
		where: UserWhereUniqueInput;
		data: ExportHistoryInput;
	}>;

export type ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery =
	{
		__typename?: 'Query';
		exportCustomerOfflineTransactionHistory: {
			__typename?: 'TransactionHistoryUrl';
			url: string;
		};
	};

export type ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		data: ExportHistoryInput;
	}>;

export type ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery =
	{
		__typename?: 'Query';
		exportOrgOfflineTransactionHistory: {
			__typename?: 'TransactionHistoryUrl';
			url: string;
		};
	};

export type ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryVariables =
	Exact<{
		where: UserByIdUniqueInput;
		data: ExportHistoryInput;
	}>;

export type ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery =
	{
		__typename?: 'Query';
		exportCustomerTransactionHistory: {
			__typename?: 'TransactionHistoryUrl';
			url: string;
		};
	};

export type ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		data: ExportHistoryInput;
	}>;

export type ExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery = {
	__typename?: 'Query';
	exportOrgTransactionHistory: boolean;
};

export type OfflinePaymentHistoryItemFragment = {
	__typename?: 'OfflinePaymentHistoryItem';
	id: string;
	type: OfflinePaymentHistoryItemType;
	amount?: number | null;
	name?: string | null;
	paymentType?: PaymentType | null;
	date?: Date | string | null;
	invoice: {
		__typename?: 'InvoiceForOfflinePaymentHistory';
		id: string;
		title?: string | null;
		gratuityAmount?: number | null;
		clientUser?: {
			__typename?: 'ClientForOfflineHistory';
			id: string;
			firstNameOne?: string | null;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
		} | null;
		organization: {
			__typename?: 'OrganizationForOfflinePaymentHistory';
			id: string;
			country: Country;
		};
	};
};

export type OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryVariables =
	Exact<{
		where: UserWhereUniqueInput;
		after?: InputMaybe<OfflinePaymentHistoryAfterInput>;
		take?: InputMaybe<Scalars['Int']['input']>;
	}>;

export type OfflineTransactions_GetCustomerOfflineTransactionHistoryQuery = {
	__typename?: 'Query';
	getCustomerOfflineTransactionHistory?: {
		__typename?: 'OfflinePaymentHistory';
		offlinePaymentHistoryItems: Array<{
			__typename?: 'OfflinePaymentHistoryItem';
			id: string;
			type: OfflinePaymentHistoryItemType;
			amount?: number | null;
			name?: string | null;
			paymentType?: PaymentType | null;
			date?: Date | string | null;
			invoice: {
				__typename?: 'InvoiceForOfflinePaymentHistory';
				id: string;
				title?: string | null;
				gratuityAmount?: number | null;
				clientUser?: {
					__typename?: 'ClientForOfflineHistory';
					id: string;
					firstNameOne?: string | null;
					lastNameOne?: string | null;
					firstNameTwo?: string | null;
					lastNameTwo?: string | null;
				} | null;
				organization: {
					__typename?: 'OrganizationForOfflinePaymentHistory';
					id: string;
					country: Country;
				};
			};
		} | null>;
	} | null;
};

export type OfflineTransactions_GetOrgOfflineTransactionHistoryQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		after?: InputMaybe<OfflinePaymentHistoryAfterInput>;
		take?: InputMaybe<Scalars['Int']['input']>;
	}>;

export type OfflineTransactions_GetOrgOfflineTransactionHistoryQuery = {
	__typename?: 'Query';
	getOrgOfflineTransactionHistory?: {
		__typename?: 'OfflinePaymentHistory';
		offlinePaymentHistoryItems: Array<{
			__typename?: 'OfflinePaymentHistoryItem';
			id: string;
			type: OfflinePaymentHistoryItemType;
			amount?: number | null;
			name?: string | null;
			paymentType?: PaymentType | null;
			date?: Date | string | null;
			invoice: {
				__typename?: 'InvoiceForOfflinePaymentHistory';
				id: string;
				title?: string | null;
				gratuityAmount?: number | null;
				clientUser?: {
					__typename?: 'ClientForOfflineHistory';
					id: string;
					firstNameOne?: string | null;
					lastNameOne?: string | null;
					firstNameTwo?: string | null;
					lastNameTwo?: string | null;
				} | null;
				organization: {
					__typename?: 'OrganizationForOfflinePaymentHistory';
					id: string;
					country: Country;
				};
			};
		} | null>;
	} | null;
};

export type ChargeAccountSourceFragment = {
	__typename?: 'Source';
	id: string;
	last4?: string | null;
	address_zip?: string | null;
	account_holder_name?: string | null;
	account_holder_type?: string | null;
	name?: string | null;
	object: string;
	brand?: string | null;
	bank_name?: string | null;
	exp_month?: number | null;
	exp_year?: number | null;
	status?: string | null;
	country?: Country | null;
};

export type ChargeAccount_GetPaymentMethodsForVendorCustomerQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type ChargeAccount_GetPaymentMethodsForVendorCustomerQuery = {
	__typename?: 'Query';
	getPaymentMethodsForVendorCustomer: {
		__typename?: 'SourcesWithDefaultSource';
		data?: Array<{
			__typename?: 'Source';
			id: string;
			last4?: string | null;
			address_zip?: string | null;
			account_holder_name?: string | null;
			account_holder_type?: string | null;
			name?: string | null;
			object: string;
			brand?: string | null;
			bank_name?: string | null;
			exp_month?: number | null;
			exp_year?: number | null;
			status?: string | null;
			country?: Country | null;
		}> | null;
	};
};

export type SourceForVendorPayToFragment = {
	__typename?: 'Source';
	id: string;
	object: string;
	account_holder_name?: string | null;
	account_holder_type?: string | null;
	bank_name?: string | null;
	country?: Country | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type PayTo_GetStripeConnectAccountQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type PayTo_GetStripeConnectAccountQuery = {
	__typename?: 'Query';
	getStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		external_accounts?: {
			__typename?: 'Sources';
			data?: Array<{
				__typename?: 'Source';
				id: string;
				object: string;
				account_holder_name?: string | null;
				account_holder_type?: string | null;
				bank_name?: string | null;
				country?: Country | null;
				name?: string | null;
				brand?: string | null;
				last4?: string | null;
				status?: string | null;
				exp_year?: number | null;
				exp_month?: number | null;
				fingerprint?: string | null;
				legacy?: boolean | null;
				metadata?: Array<{
					__typename?: 'ReturningMetaData';
					key?: string | null;
					value?: string | null;
				} | null> | null;
			} | null> | null;
		} | null;
	} | null;
};

export type QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryVariables =
	Exact<{
		where: ExportWalletQuickPaymentsWhereInput;
		data: ExportWalletQuickPaymentsDataInput;
	}>;

export type QuickPaymentsExportModal_ExportWalletQuickPaymentsQuery = {
	__typename?: 'Query';
	exportWalletQuickPayments: string;
};

export type QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationVariables =
	Exact<{
		where: QuickPaymentWhereUniqueInput;
	}>;

export type QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation = {
	__typename?: 'Mutation';
	deleteQuickPayment: { __typename?: 'QuickPayment'; id?: string | null };
};

export type QuickPaymentsTableInvoices_ExportInvoiceQueryVariables = Exact<{
	where: InvoiceWhereUniqueInput;
}>;

export type QuickPaymentsTableInvoices_ExportInvoiceQuery = {
	__typename?: 'Query';
	exportInvoice?: { __typename?: 'InvoiceUrl'; url?: string | null } | null;
};

export type QuickPaymentsTableInvoicesWalletQuickPaymentInvoiceFragment = {
	__typename?: 'WalletQuickPaymentInvoice';
	id: string;
	title: string;
	paymentDate: Date | string;
	amountPaid: string;
};

export type QuickPaymentsTableWalletQuickPaymentFragment = {
	__typename?: 'WalletQuickPayment';
	id: string;
	createdAt: Date | string;
	link?: string | null;
	name: string;
	amount?: string | null;
	reason?: string | null;
	payments: number;
	total: string;
	invoices?: Array<{
		__typename?: 'WalletQuickPaymentInvoice';
		id: string;
		title: string;
		paymentDate: Date | string;
		amountPaid: string;
	}> | null;
};

export type WalletQuickPayments_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type WalletQuickPayments_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		QuickPaySupportUrl?: string | null;
	};
};

export type WalletQuickPayments_GetStripeConnectAccountQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type WalletQuickPayments_GetStripeConnectAccountQuery = {
	__typename?: 'Query';
	getStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		external_accounts?: {
			__typename?: 'Sources';
			data?: Array<{ __typename?: 'Source'; id: string } | null> | null;
		} | null;
	} | null;
};

export type QuickPayments_GetWalletQuickPaymentsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	orderBy?: InputMaybe<
		Array<WalletQuickPaymentOrderByInput> | WalletQuickPaymentOrderByInput
	>;
}>;

export type QuickPayments_GetWalletQuickPaymentsQuery = {
	__typename?: 'Query';
	getWalletQuickPayments: Array<{
		__typename?: 'WalletQuickPayment';
		id: string;
		createdAt: Date | string;
		link?: string | null;
		name: string;
		amount?: string | null;
		reason?: string | null;
		payments: number;
		total: string;
		invoices?: Array<{
			__typename?: 'WalletQuickPaymentInvoice';
			id: string;
			title: string;
			paymentDate: Date | string;
			amountPaid: string;
		}> | null;
	}>;
};

export type QuickbooksContent_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type QuickbooksContent_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		QuickBooksHelpUrl?: string | null;
	};
};

export type Quickbooks_GetStripeConnectAccountQueryVariables = Exact<{
	where: OrganizationWhereUniqueInput;
}>;

export type Quickbooks_GetStripeConnectAccountQuery = {
	__typename?: 'Query';
	getStripeConnectAccount?: {
		__typename?: 'StripeConnectAccount';
		external_accounts?: {
			__typename?: 'Sources';
			data?: Array<{ __typename?: 'Source'; id: string } | null> | null;
		} | null;
	} | null;
};

export type Quickbooks_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type Quickbooks_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; name: string }>;
		} | null;
	} | null;
};

export type Quickbooks_CanAccessByFeatureFlagQueryVariables = Exact<{
	where: CanAccessByFeatureFlagWhereInput;
}>;

export type Quickbooks_CanAccessByFeatureFlagQuery = {
	__typename?: 'Query';
	canAccessByFeatureFlag: boolean;
};

export type StripeInvoiceListStripeInvoiceFragment = {
	__typename?: 'StripeInvoice';
	id?: string | null;
	status?: string | null;
	total?: number | null;
	period_start?: number | null;
	period_end?: number | null;
	invoice_pdf?: string | null;
};

export type StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryVariables =
	Exact<{ [key: string]: never }>;

export type StripeInvoiceListGetStripeInvoicesForVendorCustomerQuery = {
	__typename?: 'Query';
	getStripeInvoicesForVendorCustomer: {
		__typename?: 'StripeInvoicesList';
		data: Array<{
			__typename?: 'StripeInvoice';
			id?: string | null;
			status?: string | null;
			total?: number | null;
			period_start?: number | null;
			period_end?: number | null;
			invoice_pdf?: string | null;
		} | null>;
	};
};

export type SubscriptionPaymentMethodModalsSourceFragment = {
	__typename?: 'Source';
	id: string;
	last4?: string | null;
	exp_month?: number | null;
	exp_year?: number | null;
	address_zip?: string | null;
	name?: string | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type SubscriptionPaymentMethodModalsStripeUserFragment = {
	__typename?: 'StripeUser';
	id?: string | null;
	sources?: {
		__typename?: 'Sources';
		data?: Array<{
			__typename?: 'Source';
			id: string;
			last4?: string | null;
			exp_month?: number | null;
			exp_year?: number | null;
			address_zip?: string | null;
			name?: string | null;
			metadata?: Array<{
				__typename?: 'ReturningMetaData';
				key?: string | null;
				value?: string | null;
			} | null> | null;
		} | null> | null;
	} | null;
};

export type SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationVariables =
	Exact<{ [key: string]: never }>;

export type SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation =
	{ __typename?: 'Mutation'; payOpenSubscriptionInvoices: boolean };

export type TaxForms_CreateStripeAccountSessionMutationVariables = Exact<{
	[key: string]: never;
}>;

export type TaxForms_CreateStripeAccountSessionMutation = {
	__typename?: 'Mutation';
	createStripeAccountSession: string;
};

export type TaxForms_GetFeatureFlagsQueryVariables = Exact<{
	[key: string]: never;
}>;

export type TaxForms_GetFeatureFlagsQuery = {
	__typename?: 'Query';
	getFeatureFlags: Array<{
		__typename?: 'ReducedFeatureFlag';
		category: FeatureCategory;
		active: boolean;
	}>;
};

export type VendorTransactionChargeFragment = {
	__typename?: 'TransactionHistoryChargeOrRefund';
	id: string;
	type: string;
	status: string;
	date: number;
	amount: number;
	metadata?: Array<{
		__typename?: 'ReturningStripeMetadata';
		key: string;
		value: string;
	}> | null;
	contact?: {
		__typename?: 'ReducedContact';
		firstName?: string | null;
		lastName?: string | null;
		status: ContactStatus;
		customer: { __typename?: 'ReducedCustomer'; id: string; email: string };
	} | null;
	invoice?: { __typename?: 'ReducedInvoice'; id: string; title: string } | null;
};

export type VendorTransactionHistoryPayoutFragment = {
	__typename?: 'TransactionHistoryPayout';
	id: string;
	date?: number | null;
	amount?: number | null;
	type: string;
	status: string;
};

export type VendorTransactionHistoryItemFragment = {
	__typename?: 'TransactionHistoryItem';
	payout: {
		__typename?: 'TransactionHistoryPayout';
		id: string;
		date?: number | null;
		amount?: number | null;
		type: string;
		status: string;
	};
	transactions: Array<{
		__typename?: 'TransactionHistoryChargeOrRefund';
		id: string;
		type: string;
		status: string;
		date: number;
		amount: number;
		metadata?: Array<{
			__typename?: 'ReturningStripeMetadata';
			key: string;
			value: string;
		}> | null;
		contact?: {
			__typename?: 'ReducedContact';
			firstName?: string | null;
			lastName?: string | null;
			status: ContactStatus;
			customer: { __typename?: 'ReducedCustomer'; id: string; email: string };
		} | null;
		invoice?: {
			__typename?: 'ReducedInvoice';
			id: string;
			title: string;
		} | null;
	} | null>;
};

export type VendorTransactionHistory_GetOrgTransactionHistoryQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
		after?: InputMaybe<Scalars['String']['input']>;
	}>;

export type VendorTransactionHistory_GetOrgTransactionHistoryQuery = {
	__typename?: 'Query';
	getOrgTransactionHistory: {
		__typename?: 'TransactionHistory';
		hasMore: boolean;
		transactionHistoryItems: Array<{
			__typename?: 'TransactionHistoryItem';
			payout: {
				__typename?: 'TransactionHistoryPayout';
				id: string;
				date?: number | null;
				amount?: number | null;
				type: string;
				status: string;
			};
			transactions: Array<{
				__typename?: 'TransactionHistoryChargeOrRefund';
				id: string;
				type: string;
				status: string;
				date: number;
				amount: number;
				metadata?: Array<{
					__typename?: 'ReturningStripeMetadata';
					key: string;
					value: string;
				}> | null;
				contact?: {
					__typename?: 'ReducedContact';
					firstName?: string | null;
					lastName?: string | null;
					status: ContactStatus;
					customer: {
						__typename?: 'ReducedCustomer';
						id: string;
						email: string;
					};
				} | null;
				invoice?: {
					__typename?: 'ReducedInvoice';
					id: string;
					title: string;
				} | null;
			} | null>;
		}>;
	};
};

export type VendorWallet_CreateStripeAccountSessionMutationVariables = Exact<{
	[key: string]: never;
}>;

export type VendorWallet_CreateStripeAccountSessionMutation = {
	__typename?: 'Mutation';
	createStripeAccountSession: string;
};

export type VendorWallet_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type VendorWallet_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			isAdmin: boolean;
			isOwner: boolean;
			organization?: {
				__typename?: 'Organization';
				id: string;
				hasStripeVerificationNeeds: boolean;
			} | null;
		} | null;
	} | null;
};

export type WalletDrawerSourceFragment = {
	__typename?: 'Source';
	id: string;
	object: string;
	name?: string | null;
	brand?: string | null;
	last4?: string | null;
	status?: string | null;
	exp_year?: number | null;
	exp_month?: number | null;
	fingerprint?: string | null;
	legacy?: boolean | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type WalletDrawer_GetTotalForSourceQueryVariables = Exact<{
	where: PaymentMethodWhereInput;
}>;

export type WalletDrawer_GetTotalForSourceQuery = {
	__typename?: 'Query';
	getTotalForSource: number;
};

export type EventRow_DismissEventMutationVariables = Exact<{
	where: EventWhereUniqueInput;
}>;

export type EventRow_DismissEventMutation = {
	__typename?: 'Mutation';
	dismissEvent: boolean;
};

export type FinancialConnectionsAccountAccountNumbersUpdatedEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	metadata?: any | null;
};

export type GetContractSentEventPropsEventFragment = {
	__typename?: 'Event';
	contract?: {
		__typename?: 'CustomContract';
		vendor: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		};
	} | null;
};

export type EventFeed_ResendContractMutationVariables = Exact<{
	where: ContractWhereUniqueInput;
	data?: InputMaybe<ContractResendInput>;
}>;

export type EventFeed_ResendContractMutation = {
	__typename?: 'Mutation';
	resendContract: boolean;
};

export type InstallmentPaymentFailedEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	invoice?: { __typename?: 'Invoice'; id: string; title: string } | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
	clientUser?: {
		__typename?: 'ClientUser';
		id: string;
		user: { __typename?: 'User'; id: string };
		assignedPlanner?: {
			__typename?: 'OrgUser';
			id: string;
			organization?: { __typename?: 'Organization'; id: string } | null;
		} | null;
	} | null;
};

export type InvoiceAcceptedByPlannerEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	invoice?: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		eventDate?: Date | string | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			assignedMember: { __typename?: 'OrgUser'; id: string };
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						firstName: string;
						lastName: string;
						user?: { __typename?: 'User'; id: string } | null;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
		} | null;
		organization?: { __typename?: 'Organization'; id: string } | null;
	} | null;
	paymentInstallments?: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		name?: string | null;
	}> | null;
};

export type InstallmentPaymentRescheduledByVendorPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	invoice?: { __typename?: 'Invoice'; id: string; title: string } | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type GetInstallmentRefundRequestedEventPropsFragment = {
	__typename?: 'Event';
	id: string;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: {
						__typename?: 'Organization';
						id: string;
						users?: Array<{
							__typename?: 'OrgUser';
							id: string;
							role: TeamMemberRole;
						}> | null;
					} | null;
				} | null;
			} | null;
		};
	} | null;
	clientUser?: { __typename?: 'ClientUser'; id: string } | null;
	vendor?: { __typename?: 'Organization'; id: string; name: string } | null;
	invoice?: { __typename?: 'Invoice'; id: string; title: string } | null;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
};

export type InvoiceFullyPaidEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	invoice?: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		eventDate?: Date | string | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: {
				__typename?: 'User';
				id: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
								user?: { __typename?: 'User'; id: string } | null;
								organization?: {
									__typename?: 'Organization';
									id: string;
									users?: Array<{
										__typename?: 'OrgUser';
										id: string;
										role: TeamMemberRole;
										user?: { __typename?: 'User'; id: string } | null;
									}> | null;
								} | null;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			};
			vendor: {
				__typename?: 'Organization';
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
		} | null;
	} | null;
};

export type InvoiceSentOrResentByEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	resolvedAt?: Date | string | null;
	actingUser?: { __typename?: 'ActingUserForEvent'; id: string } | null;
	invoice?: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		organization?: { __typename?: 'Organization'; id: string } | null;
	} | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: {
			__typename?: 'User';
			id: string;
			email: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				plannerOrgCanPayInvoices: boolean;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
		};
	} | null;
	vendor?: { __typename?: 'Organization'; id: string; name: string } | null;
};

export type GetOfflinePaymentOrRefundUnrecordedEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	actingUser?: {
		__typename?: 'ActingUserForEvent';
		id: string;
		orgUser?: {
			__typename?: 'OrgUserForActingUserOnEvent';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	} | null;
	invoice?: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
		} | null;
	} | null;
};

export type PaymentMethodVerificationEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	message?: string | null;
	referenceID?: string | null;
	actingUser?: { __typename?: 'ActingUserForEvent'; id: string } | null;
};

export type GetInvoicePastDueEventProps_SendOrResendInvoiceMutationVariables =
	Exact<{
		data?: InputMaybe<SendOrResendInvoiceInput>;
		where: InvoiceWhereUniqueInput;
	}>;

export type GetInvoicePastDueEventProps_SendOrResendInvoiceMutation = {
	__typename?: 'Mutation';
	sendOrResendInvoice: { __typename?: 'Invoice'; id: string };
};

export type GetInvoicePastDueEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	resolvedAt?: Date | string | null;
	invoice?: {
		__typename?: 'Invoice';
		id: string;
		title: string;
		automatedRemindersEnabled: boolean;
		contact?: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						firstName: string;
						lastName: string;
						user?: { __typename?: 'User'; id: string } | null;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
			};
			vendor: { __typename?: 'Organization'; id: string; name: string };
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			};
		} | null;
		organization?: { __typename?: 'Organization'; id: string } | null;
	} | null;
};

export type ProposalAcceptedByPlannerEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	vendor?: { __typename?: 'Organization'; id: string; name: string } | null;
	proposal?: {
		__typename?: 'Proposal';
		id: string;
		title?: string | null;
		eventDate?: Date | string | null;
		contact: {
			__typename?: 'Contact';
			firstName: string;
			lastName: string;
			id: string;
			customer: {
				__typename?: 'User';
				email: string;
				id: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					plannerOrgCanPayInvoices: boolean;
					plannerOrgCanSignContracts: boolean;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: {
							__typename?: 'Organization';
							id: string;
							users?: Array<{
								__typename?: 'OrgUser';
								id: string;
								role: TeamMemberRole;
								user?: { __typename?: 'User'; id: string } | null;
								organization?: {
									__typename?: 'Organization';
									id: string;
									users?: Array<{
										__typename?: 'OrgUser';
										id: string;
										role: TeamMemberRole;
										user?: { __typename?: 'User'; id: string } | null;
									}> | null;
								} | null;
							}> | null;
						} | null;
					} | null;
				} | null;
			};
			vendor: {
				__typename?: 'Organization';
				name: string;
				id: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
					user?: { __typename?: 'User'; id: string } | null;
				}> | null;
			};
			assignedMember: {
				__typename?: 'OrgUser';
				id: string;
				user?: { __typename?: 'User'; id: string } | null;
			};
		};
	} | null;
};

export type GetProposalPastDueEventPropsEventFragment = {
	__typename?: 'Event';
	category: EventCategory;
	resolvedAt?: Date | string | null;
	proposal?: {
		__typename?: 'Proposal';
		id: string;
		title?: string | null;
		automatedRemindersEnabled: boolean;
		sentByUser?: { __typename?: 'OrgUser'; id: string } | null;
		contact: {
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			customer: {
				__typename?: 'User';
				id: string;
				email: string;
				clientUser?: {
					__typename?: 'ClientUser';
					id: string;
					assignedPlanner?: {
						__typename?: 'OrgUser';
						id: string;
						organization?: { __typename?: 'Organization'; id: string } | null;
					} | null;
				} | null;
			};
			assignedMember: { __typename?: 'OrgUser'; id: string };
			vendor: {
				__typename?: 'Organization';
				id: string;
				name: string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
			};
		};
	} | null;
};

export type GetProposalSentEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	proposal?: {
		__typename?: 'Proposal';
		id: string;
		title?: string | null;
	} | null;
	vendor?: { __typename?: 'Organization'; id: string } | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		customer: {
			__typename?: 'User';
			id: string;
			clientUser?: {
				__typename?: 'ClientUser';
				id: string;
				assignedPlanner?: {
					__typename?: 'OrgUser';
					id: string;
					organization?: { __typename?: 'Organization'; id: string } | null;
				} | null;
			} | null;
		};
	} | null;
};

export type GetUserEmailBlockedOrUnblockedEventPropsEventFragment = {
	__typename?: 'Event';
	id: string;
	category: EventCategory;
	message?: string | null;
	contact?: { __typename?: 'Contact'; id: string } | null;
	inquiry?: {
		__typename?: 'Inquiry';
		id: string;
		organization: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; name: string }>;
		};
	} | null;
	orgUser?: { __typename?: 'OrgUser'; id: string } | null;
};

export type DeletePaymentMethodSourceFragment = {
	__typename?: 'Source';
	id: string;
	last4?: string | null;
	object: string;
	status?: string | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type DeletePaymentMethodInvoiceFragment = {
	__typename?: 'Invoice';
	id: string;
	paymentInstallments: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
		scheduledPaymentDate?: Date | string | null;
		scheduledPaymentMethod?: string | null;
	}>;
};

export type DeletePaymentMethod_GetInvoicesForCustomerQueryVariables = Exact<{
	where: GetInvoicesForCustomerInput;
}>;

export type DeletePaymentMethod_GetInvoicesForCustomerQuery = {
	__typename?: 'Query';
	getInvoicesForCustomer: {
		__typename?: 'InvoicesForCustomer';
		invoices: Array<{
			__typename?: 'Invoice';
			id: string;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				status?: InstallmentStatus | null;
				scheduledPaymentDate?: Date | string | null;
				scheduledPaymentMethod?: string | null;
			}>;
		}>;
	};
};

export type UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationVariables =
	Exact<{
		where: StripeBankAccountDeletionInput;
	}>;

export type UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation = {
	__typename?: 'Mutation';
	deleteCustomerStripePaymentSource: {
		__typename?: 'StripeUser';
		id?: string | null;
		default_source?: string | null;
		sources?: {
			__typename?: 'Sources';
			data?: Array<{ __typename?: 'Source'; id: string } | null> | null;
		} | null;
	};
};

export type InviteForm_CreateInvitationMutationVariables = Exact<{
	data: InvitationCustomCreateInput;
}>;

export type InviteForm_CreateInvitationMutation = {
	__typename?: 'Mutation';
	createInvitation: {
		__typename?: 'Invitation';
		id: string;
		contact?: { __typename?: 'CustomContact'; id: string } | null;
	};
};

export type InviteForm_GetPendingInvitationsFragment = {
	__typename?: 'PendingInvitations';
	_count: number;
	pendingInvitations: Array<{
		__typename?: 'Invitation';
		createdAt: Date | string;
		id: string;
		recipientFirstName: string;
		recipientLastName?: string | null;
		invitationType: InviteEnum;
		emailAddress: string;
	}>;
};

export type InviteForm_GetPendingInvitationsQueryVariables = Exact<{
	where: InvitationsWhereCustomInput;
	take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type InviteForm_GetPendingInvitationsQuery = {
	__typename?: 'Query';
	getPendingInvitations: {
		__typename?: 'PendingInvitations';
		_count: number;
		pendingInvitations: Array<{
			__typename?: 'Invitation';
			createdAt: Date | string;
			id: string;
			recipientFirstName: string;
			recipientLastName?: string | null;
			invitationType: InviteEnum;
			emailAddress: string;
		}>;
	};
};

export type InviteForm_GetInviteUserQueryVariables = Exact<{
	email: Scalars['String']['input'];
}>;

export type InviteForm_GetInviteUserQuery = {
	__typename?: 'Query';
	getInviteUser?:
		| {
				__typename: 'InviteUserClientUser';
				id: string;
				firstNameOne: string;
				firstNameTwo?: string | null;
				lastNameOne: string;
				lastNameTwo?: string | null;
				weddingDate?: string | null;
				phone?: string | null;
				user: {
					__typename?: 'InviteUserUser';
					id: string;
					email: string;
					userType: UserType;
				};
		  }
		| {
				__typename: 'InviteUserOrgUser';
				id: string;
				firstName: string;
				lastName: string;
				phone?: string | null;
				user: {
					__typename?: 'InviteUserUser';
					id: string;
					email: string;
					userType: UserType;
				};
				organization: {
					__typename?: 'InviteUserOrganization';
					id: string;
					name: string;
					image?: string | null;
					updatedAt: string;
					services: Array<{
						__typename?: 'InviteUserOrganizationService';
						id: string;
						name: string;
					} | null>;
				};
		  }
		| null;
};

export type NewExternalAccount_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type NewExternalAccount_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			isAdmin: boolean;
			isOwner: boolean;
			organization?: {
				__typename?: 'Organization';
				id: string;
				hasStripeVerificationNeeds: boolean;
			} | null;
		} | null;
	} | null;
};

export type NewExternalAccount_CreateExternalAccountMutationVariables = Exact<{
	data: StripeBankAccountSourceInput;
	where: OrganizationWhereUniqueInput;
}>;

export type NewExternalAccount_CreateExternalAccountMutation = {
	__typename?: 'Mutation';
	createExternalAccount?: { __typename?: 'Source'; id: string } | null;
};

export type NewPaymentSourceFragment = {
	__typename?: 'Source';
	id: string;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type NewPaymentSource_CreateSetupIntentForPaymentMethodMutationVariables =
	Exact<{
		data: CreateSetupIntentForPaymentMethodInput;
	}>;

export type NewPaymentSource_CreateSetupIntentForPaymentMethodMutation = {
	__typename?: 'Mutation';
	createSetupIntentForPaymentMethod: {
		__typename?: 'CreateSetupIntentForPaymentMethodResponse';
		clientSecret: string;
	};
};

export type UpdateBankAccountSourceFragment = {
	__typename?: 'Source';
	id: string;
	object: string;
	account_holder_type?: string | null;
	billing_details?: {
		__typename?: 'BillingDetails';
		name?: string | null;
	} | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type UpdateBankAccount_UpdateCustomerStripeBankAccountMutationVariables =
	Exact<{
		where: StripeBankAccountDeletionInput;
		data: StripeBankAccountUpdateInput;
	}>;

export type UpdateBankAccount_UpdateCustomerStripeBankAccountMutation = {
	__typename?: 'Mutation';
	updateCustomerStripeBankAccount: {
		__typename?: 'StripeUser';
		id?: string | null;
		default_source?: string | null;
		sources?: {
			__typename?: 'Sources';
			data?: Array<{
				__typename?: 'Source';
				id: string;
				object: string;
				account_holder_type?: string | null;
				billing_details?: {
					__typename?: 'BillingDetails';
					name?: string | null;
				} | null;
				metadata?: Array<{
					__typename?: 'ReturningMetaData';
					key?: string | null;
					value?: string | null;
				} | null> | null;
			} | null> | null;
		} | null;
	};
};

export type UpdateCustomerStripeCardFragment = {
	__typename?: 'StripeUser';
	id?: string | null;
	default_source?: string | null;
	sources?: {
		__typename?: 'Sources';
		data?: Array<{
			__typename?: 'Source';
			id: string;
			metadata?: Array<{
				__typename?: 'ReturningMetaData';
				key?: string | null;
				value?: string | null;
			} | null> | null;
		} | null> | null;
	} | null;
};

export type UpdateCardSourceFragment = {
	__typename?: 'Source';
	id: string;
	name?: string | null;
	address_zip?: string | null;
	exp_month?: number | null;
	exp_year?: number | null;
	billing_details?: {
		__typename?: 'BillingDetails';
		name?: string | null;
		address?: {
			__typename?: 'StripeAddress';
			postal_code?: string | null;
		} | null;
	} | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type UpdateCard_UpdateCustomerStripeCardMutationVariables = Exact<{
	where: UpdateCustomerStripeCardWhereInput;
	data: CustomerStripeCardUpdateInput;
}>;

export type UpdateCard_UpdateCustomerStripeCardMutation = {
	__typename?: 'Mutation';
	updateCustomerStripeCard: {
		__typename?: 'StripeUser';
		id?: string | null;
		default_source?: string | null;
		sources?: {
			__typename?: 'Sources';
			data?: Array<{
				__typename?: 'Source';
				id: string;
				metadata?: Array<{
					__typename?: 'ReturningMetaData';
					key?: string | null;
					value?: string | null;
				} | null> | null;
			} | null> | null;
		} | null;
	};
};

export type UpdateCard_UpdateVendorStripeCardMutationVariables = Exact<{
	data: OrganizationStripeCardUpdateInput;
}>;

export type UpdateCard_UpdateVendorStripeCardMutation = {
	__typename?: 'Mutation';
	updateVendorStripeCard: {
		__typename?: 'StripeUser';
		id?: string | null;
		default_source?: string | null;
		sources?: {
			__typename?: 'Sources';
			data?: Array<{
				__typename?: 'Source';
				id: string;
				metadata?: Array<{
					__typename?: 'ReturningMetaData';
					key?: string | null;
					value?: string | null;
				} | null> | null;
			} | null> | null;
		} | null;
	};
};

export type UpdateCard_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type UpdateCard_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			isAdmin: boolean;
			isOwner: boolean;
			organization?: {
				__typename?: 'Organization';
				id: string;
				hasStripeVerificationNeeds: boolean;
			} | null;
		} | null;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			description?: string | null;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			facebook?: string | null;
			instagram?: string | null;
			twitter?: string | null;
			pinterest?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					updatedAt: Date | string;
					image?: string | null;
				} | null;
			} | null;
		} | null;
		superAdmin?: {
			__typename?: 'SuperAdminUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
			};
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type UpdateExternalAccountSourceFragment = {
	__typename?: 'Source';
	id: string;
	account_holder_name?: string | null;
	account_holder_type?: string | null;
	country?: Country | null;
	routing_number?: string | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type UpdateExternalAccount_UpdateExternalAccountMutationVariables =
	Exact<{
		data: StripeExternalAccountUpdateInput;
		where: OrganizationWhereUniqueInput;
	}>;

export type UpdateExternalAccount_UpdateExternalAccountMutation = {
	__typename?: 'Mutation';
	updateExternalAccount?: {
		__typename?: 'Source';
		id: string;
		account_holder_name?: string | null;
		account_holder_type?: string | null;
		country?: Country | null;
		routing_number?: string | null;
		metadata?: Array<{
			__typename?: 'ReturningMetaData';
			key?: string | null;
			value?: string | null;
		} | null> | null;
	} | null;
};

export type UpdatePaymentMethodSourceFragment = {
	__typename?: 'Source';
	id: string;
	last4?: string | null;
	object: string;
	status?: string | null;
	account_holder_type?: string | null;
	name?: string | null;
	address_zip?: string | null;
	exp_month?: number | null;
	exp_year?: number | null;
	billing_details?: {
		__typename?: 'BillingDetails';
		name?: string | null;
		address?: {
			__typename?: 'StripeAddress';
			postal_code?: string | null;
		} | null;
	} | null;
	metadata?: Array<{
		__typename?: 'ReturningMetaData';
		key?: string | null;
		value?: string | null;
	} | null> | null;
};

export type ProfileImagePicker_UpdateOrganizationMutationVariables = Exact<{
	where: OrganizationWhereUniqueInput;
	data: OrganizationCustomUpdateInput;
}>;

export type ProfileImagePicker_UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		image?: string | null;
		imageScale?: number | null;
		imageRotation?: number | null;
		imagePositionX?: number | null;
		imagePositionY?: number | null;
		updatedAt: Date | string;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
	} | null;
};

export type ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryVariables =
	Exact<{
		data: RequestImageUploadUrlInput;
	}>;

export type ProfileImagePicker_RequestOrgProfileImageUploadUrlQuery = {
	__typename?: 'Query';
	requestOrgProfileImageUploadUrl: {
		__typename?: 'UploadUrl';
		uploadURL?: string | null;
	};
};

export type GetNavigationItems_GetOrgUserWhereQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type GetNavigationItems_GetOrgUserWhereQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		organization?: {
			__typename?: 'Organization';
			id: string;
			createdAt: Date | string;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: { __typename?: 'Plan'; id: string; type: PlanType };
			} | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
		} | null;
	} | null;
};

export type UseProfileLinks_LogoutMutationVariables = Exact<{
	[key: string]: never;
}>;

export type UseProfileLinks_LogoutMutation = {
	__typename?: 'Mutation';
	logout: boolean;
};

export type ContactsContextContactFragment = {
	__typename?: 'Contact';
	id: string;
	status: ContactStatus;
	firstName: string;
	lastName: string;
	companyName?: string | null;
	customer: { __typename?: 'User'; id: string; email: string };
};

export type ProposalDesignEditorContextProvider_CreateProposalTemplateMutationVariables =
	Exact<{
		data: ProposalTemplateCreateInput;
	}>;

export type ProposalDesignEditorContextProvider_CreateProposalTemplateMutation =
	{
		__typename?: 'Mutation';
		createProposalTemplate: {
			__typename?: 'ProposalTemplate';
			id: string;
			title?: string | null;
			thumbnail?: string | null;
		};
	};

export type ButtonBarResendContractButtonContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	automatedRemindersEnabled: boolean;
	dueDate?: Date | string | null;
	sentByUser?: {
		__typename?: 'OrgUserForGetContractWhere';
		id: string;
		organization?: {
			__typename?: 'OrganizationForGetContractWhere';
			id: string;
		} | null;
	} | null;
	signatures: Array<{
		__typename?: 'SignatureForGetContractWhere';
		id: string;
		type?: SignatureType | null;
		signingDate?: Date | string | null;
		customerSignature?: {
			__typename?: 'CustomerSignatureForGetContractWhere';
			id: string;
			contact: {
				__typename?: 'ContactForGetContractWhere';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				customer: {
					__typename?: 'CustomerForGetContractWhere';
					id: string;
					email: string;
				};
				vendor: {
					__typename?: 'OrganizationForGetContractWhere';
					id: string;
					users?: Array<{
						__typename?: 'UsersForGetContractWhere';
						id: string;
						role: TeamMemberRole;
					}> | null;
				};
				assignedMember: {
					__typename?: 'OrgUserForGetContractWhere';
					id: string;
					user: { __typename?: 'BaseUserForGetContractWhere'; id: string };
				};
			};
		} | null;
	}>;
};

export type UseContractViewButtonBarResendButton_ResendContractMutationVariables =
	Exact<{
		where: ContractWhereUniqueInput;
		data?: InputMaybe<ContractResendInput>;
	}>;

export type UseContractViewButtonBarResendButton_ResendContractMutation = {
	__typename?: 'Mutation';
	resendContract: boolean;
};

export type UseButtonBarVoidContractButton_VoidContractMutationVariables =
	Exact<{
		where: ContractWhereUniqueInput;
	}>;

export type UseButtonBarVoidContractButton_VoidContractMutation = {
	__typename?: 'Mutation';
	voidContract: {
		__typename?: 'CustomContract';
		id: string;
		status?: ContractStatus | null;
	};
};

export type UseButtonBarVoidContractButtonContractFragment = {
	__typename?: 'ContractForGetContractWhere';
	id: string;
	status: ContractStatus;
	vendor: {
		__typename?: 'OrganizationForGetContractWhere';
		id: string;
		users?: Array<{
			__typename?: 'UsersForGetContractWhere';
			id: string;
			role: TeamMemberRole;
			user?: { __typename?: 'BaseUserForGetContractWhere'; id: string } | null;
		}> | null;
	};
};

export type ClientOnboardingModal_GetClientUserWhereQueryVariables = Exact<{
	where: ClientUserWhereUniqueInput;
}>;

export type ClientOnboardingModal_GetClientUserWhereQuery = {
	__typename?: 'Query';
	getClientUserWhere?: {
		__typename?: 'ClientUser';
		id: string;
		user: {
			__typename?: 'User';
			id: string;
			seenOnboardingModalAt?: Date | string | null;
		};
	} | null;
};

export type ClientOnboardingModal_UpdateSelfMutationVariables = Exact<{
	data: UserUpdateSelfInput;
}>;

export type ClientOnboardingModal_UpdateSelfMutation = {
	__typename?: 'Mutation';
	updateSelf: {
		__typename?: 'User';
		id: string;
		seenOnboardingModalAt?: Date | string | null;
	};
};

export type UseContacts_ContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	eventDate?: Date | string | null;
	venue?: string | null;
	phone?: string | null;
	note?: string | null;
	status: ContactStatus;
	companyName?: string | null;
	source?: string | null;
	hasCustomerIntent: boolean;
	customer: { __typename?: 'User'; id: string; email: string };
	assignedMember: { __typename?: 'OrgUser'; id: string };
	vendor: { __typename?: 'Organization'; id: string };
};

export type UseContacts_ContactOnSignatureFragment = {
	__typename?: 'CustomerSignatureContact';
	id: string;
	status: ContactStatus;
	firstName: string;
	lastName: string;
	eventDate?: Date | string | null;
	venue?: string | null;
	phone?: string | null;
	note?: string | null;
	companyName?: string | null;
	hasCustomerIntent: boolean;
	customer: {
		__typename?: 'CustomerSignatureContactCustomer';
		id: string;
		email: string;
	};
	assignedMember: { __typename?: 'CustomerSignatureOrgUser'; id: string };
	vendor: { __typename?: 'CustomerSignatureContactOrganization'; id: string };
};

export type UseContacts_GetContactsWhereQueryVariables = Exact<{
	orderBy?: InputMaybe<
		Array<InputMaybe<ContactOrderByInput>> | InputMaybe<ContactOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContactWhereInput;
}>;

export type UseContacts_GetContactsWhereQuery = {
	__typename?: 'Query';
	getContactsWhere: {
		__typename?: 'Contacts';
		contacts: Array<{
			__typename?: 'Contact';
			id: string;
			firstName: string;
			lastName: string;
			eventDate?: Date | string | null;
			venue?: string | null;
			phone?: string | null;
			note?: string | null;
			status: ContactStatus;
			companyName?: string | null;
			source?: string | null;
			hasCustomerIntent: boolean;
			customer: { __typename?: 'User'; id: string; email: string };
			assignedMember: { __typename?: 'OrgUser'; id: string };
			vendor: { __typename?: 'Organization'; id: string };
		}>;
	};
};

export type UseContacts_UpdateContactMutationVariables = Exact<{
	data: CustomContactUpdateInput;
	where: ContactWhereUniqueInput;
}>;

export type UseContacts_UpdateContactMutation = {
	__typename?: 'Mutation';
	updateContact: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		eventDate?: Date | string | null;
		venue?: string | null;
		phone?: string | null;
		note?: string | null;
		status: ContactStatus;
		companyName?: string | null;
		source?: string | null;
		hasCustomerIntent: boolean;
		customer: { __typename?: 'User'; id: string; email: string };
		assignedMember: { __typename?: 'OrgUser'; id: string };
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type UseContacts_CreateContactAsVendorMutationVariables = Exact<{
	data: CreateContactDataInput;
	where: UserByEmailUniqueInput;
}>;

export type UseContacts_CreateContactAsVendorMutation = {
	__typename?: 'Mutation';
	createContactAsVendor: {
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		eventDate?: Date | string | null;
		venue?: string | null;
		phone?: string | null;
		note?: string | null;
		status: ContactStatus;
		companyName?: string | null;
		source?: string | null;
		hasCustomerIntent: boolean;
		customer: { __typename?: 'User'; id: string; email: string };
		assignedMember: { __typename?: 'OrgUser'; id: string };
		vendor: { __typename?: 'Organization'; id: string };
	};
};

export type UseContactsCompareForDiffContactFragment = {
	__typename?: 'Contact';
	id: string;
	firstName: string;
	lastName: string;
	companyName?: string | null;
	customer: { __typename?: 'User'; id: string; email: string };
};

export type DocumentOrFolderBreadcrumbs_GetFolderContentsQueryVariables =
	Exact<{
		where: FolderWhereUniqueInput;
	}>;

export type DocumentOrFolderBreadcrumbs_GetFolderContentsQuery = {
	__typename?: 'Query';
	getFolderContents?: {
		__typename?: 'CustomFolder';
		id: string;
		name?: string | null;
		parentFolder?: { __typename?: 'CustomFolder'; id: string } | null;
	} | null;
};

export type DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryVariables = Exact<{
	where: DocumentWhereUniqueInput;
}>;

export type DocumentOrFolderBreadcrumbs_GetDocumentWhereQuery = {
	__typename?: 'Query';
	getDocumentWhere: {
		__typename?: 'Document';
		id: string;
		name: string;
		parentFolder?: { __typename?: 'Folder'; id: string } | null;
	};
};

export type UseExportClientIndex_GetContactsWhereQueryVariables = Exact<{
	orderBy?: InputMaybe<
		Array<InputMaybe<ContactOrderByInput>> | InputMaybe<ContactOrderByInput>
	>;
	skip?: InputMaybe<Scalars['Int']['input']>;
	take?: InputMaybe<Scalars['Int']['input']>;
	where: ContactWhereInput;
}>;

export type UseExportClientIndex_GetContactsWhereQuery = {
	__typename?: 'Query';
	getContactsWhere: {
		__typename?: 'Contacts';
		contacts: Array<{
			__typename?: 'Contact';
			createdAt: Date | string;
			status: ContactStatus;
			firstName: string;
			lastName: string;
			eventDate?: Date | string | null;
			note?: string | null;
			venue?: string | null;
			customer: { __typename?: 'User'; id: string; email: string };
		}>;
	};
};

export type FetchContactSuggestions_GetInquiriesForOrganizationInquiryFragment =
	{
		__typename?: 'Inquiry';
		id: string;
		firstName: string;
		lastName: string;
		companyName?: string | null;
		email: string;
		eventDate?: Date | string | null;
		source?: string | null;
		status: InquiryStatus;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
	};

export type FetchContactSuggestions_GetInquiriesForOrganizationQueryVariables =
	Exact<{
		where?: InputMaybe<InquiriesForOrganizationWhereInput>;
		orderBy?: InputMaybe<Array<InquiryOrderByInput> | InquiryOrderByInput>;
		take?: InputMaybe<Scalars['Int']['input']>;
	}>;

export type FetchContactSuggestions_GetInquiriesForOrganizationQuery = {
	__typename?: 'Query';
	getInquiriesForOrganization: {
		__typename?: 'InquiriesForOrganization';
		inquiries: Array<{
			__typename?: 'Inquiry';
			id: string;
			firstName: string;
			lastName: string;
			companyName?: string | null;
			email: string;
			eventDate?: Date | string | null;
			source?: string | null;
			status: InquiryStatus;
			contact?: {
				__typename?: 'Contact';
				id: string;
				customer: { __typename?: 'User'; id: string; email: string };
			} | null;
		}>;
	};
};

export type UseLeadsContactFragment = {
	__typename?: 'Contact';
	id: string;
	eventDate?: Date | string | null;
	customer: { __typename?: 'User'; id: string; email: string };
};

export type UseLeadsInquiryFragment = {
	__typename?: 'Inquiry';
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	companyName?: string | null;
	source?: string | null;
	eventDate?: Date | string | null;
	contact?: {
		__typename?: 'Contact';
		id: string;
		eventDate?: Date | string | null;
		customer: { __typename?: 'User'; id: string; email: string };
	} | null;
};

export type UseLeads_GetInquiriesForOrganizationQueryVariables = Exact<{
	[key: string]: never;
}>;

export type UseLeads_GetInquiriesForOrganizationQuery = {
	__typename?: 'Query';
	getInquiriesForOrganization: {
		__typename?: 'InquiriesForOrganization';
		inquiries: Array<{
			__typename?: 'Inquiry';
			id: string;
			firstName: string;
			lastName: string;
			email: string;
			companyName?: string | null;
			source?: string | null;
			eventDate?: Date | string | null;
			contact?: {
				__typename?: 'Contact';
				id: string;
				eventDate?: Date | string | null;
				customer: { __typename?: 'User'; id: string; email: string };
			} | null;
		}>;
	};
};

export type UseLeads_CreateInquiryMutationVariables = Exact<{
	data: InquiryCreateInput;
}>;

export type UseLeads_CreateInquiryMutation = {
	__typename?: 'Mutation';
	createInquiry: {
		__typename?: 'Inquiry';
		createdAt: Date | string;
		firstName: string;
		lastName: string;
		email: string;
		companyName?: string | null;
		eventDate?: Date | string | null;
		notes?: string | null;
		id: string;
		status: InquiryStatus;
		source?: string | null;
		organization: {
			__typename?: 'Organization';
			id: string;
			contacts?: Array<{
				__typename?: 'Contact';
				id: string;
				eventDate?: Date | string | null;
				customer: { __typename?: 'User'; id: string; email: string };
			}> | null;
		};
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
	};
};

export type UseLeads_UpdateContactMutationVariables = Exact<{
	where: ContactWhereUniqueInput;
	data: CustomContactUpdateInput;
}>;

export type UseLeads_UpdateContactMutation = {
	__typename?: 'Mutation';
	updateContact: {
		__typename?: 'Contact';
		id: string;
		eventDate?: Date | string | null;
		customer: { __typename?: 'User'; id: string; email: string };
	};
};

export type UseLeads_UpdateInquiryMutationVariables = Exact<{
	data: InquiryUpdateDataInput;
	where: InquiryWhereUniqueInput;
}>;

export type UseLeads_UpdateInquiryMutation = {
	__typename?: 'Mutation';
	updateInquiry: {
		__typename?: 'Inquiry';
		createdAt: Date | string;
		firstName: string;
		lastName: string;
		email: string;
		companyName?: string | null;
		eventDate?: Date | string | null;
		notes?: string | null;
		id: string;
		status: InquiryStatus;
		source?: string | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
	};
};

export type UseLeads_ConvertInquiryMutationVariables = Exact<{
	where: InquiryWhereUniqueInput;
}>;

export type UseLeads_ConvertInquiryMutation = {
	__typename?: 'Mutation';
	convertInquiry: {
		__typename?: 'Inquiry';
		createdAt: Date | string;
		firstName: string;
		lastName: string;
		email: string;
		companyName?: string | null;
		eventDate?: Date | string | null;
		notes?: string | null;
		id: string;
		status: InquiryStatus;
		source?: string | null;
		contact?: {
			__typename?: 'Contact';
			id: string;
			eventDate?: Date | string | null;
			customer: { __typename?: 'User'; id: string; email: string };
		} | null;
	};
};

export type UseLeads_MergeInquiryIntoContactMutationVariables = Exact<{
	where: InquiryMergeInput;
}>;

export type UseLeads_MergeInquiryIntoContactMutation = {
	__typename?: 'Mutation';
	mergeInquiryIntoContact: {
		__typename?: 'Contact';
		id: string;
		eventDate?: Date | string | null;
		customer: { __typename?: 'User'; id: string; email: string };
	};
};

export type NewEventsSubscription_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type NewEventsSubscription_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		id: string;
		userType: string;
		eventsLastViewedAt: Date | string;
	} | null;
};

export type NewEventsSubscription_UpdateSelfMutationVariables = Exact<{
	data: UserUpdateSelfInput;
}>;

export type NewEventsSubscription_UpdateSelfMutation = {
	__typename?: 'Mutation';
	updateSelf: {
		__typename?: 'User';
		id: string;
		eventsLastViewedAt: Date | string;
	};
};

export type NewEventsSubscription_GetEventsWhereQueryVariables = Exact<{
	where: EventWhereInput;
}>;

export type NewEventsSubscription_GetEventsWhereQuery = {
	__typename?: 'Query';
	getEventsWhere?: Array<{
		__typename?: 'Event';
		id: string;
		category: EventCategory;
		createdAt: Date | string;
		consumingUsers?: Array<{ __typename?: 'User'; id: string }> | null;
		dismissingUsers?: Array<{ __typename?: 'User'; id: string }> | null;
	}> | null;
};

export type NewEventsSubscription_EventCreatedSubscriptionVariables = Exact<{
	[key: string]: never;
}>;

export type NewEventsSubscription_EventCreatedSubscription = {
	__typename?: 'Subscription';
	eventCreated: {
		__typename?: 'Event';
		id: string;
		invoice?: {
			__typename?: 'Invoice';
			id: string;
			allowsGratuity: boolean;
			automatedRemindersEnabled: boolean;
			eventDate?: Date | string | null;
			uploadAttachment?: string | null;
			status: InvoiceStatus;
			isPastDue: boolean;
			title: string;
			sentAt?: Date | string | null;
			discountIsPercentage?: boolean | null;
			discountPercentage?: number | null;
			discountAmount?: number | null;
			gratuityAmount: number;
			approvedByPlanner?: boolean | null;
			notes?: string | null;
			attachmentUrl?: string | null;
			dueDate?: Date | string | null;
			totalAmount: number;
			contact?: {
				__typename?: 'Contact';
				id: string;
				firstName: string;
				lastName: string;
				companyName?: string | null;
				status: ContactStatus;
				customer: {
					__typename?: 'User';
					id: string;
					email: string;
					stripeCustomerId?: string | null;
					clientUser?: {
						__typename?: 'ClientUser';
						id: string;
						plannerOrgCanPayInvoices: boolean;
						plannerOrgCanSignContracts: boolean;
						assignedPlanner?: {
							__typename?: 'OrgUser';
							id: string;
							organization?: {
								__typename?: 'Organization';
								id: string;
								users?: Array<{
									__typename?: 'OrgUser';
									id: string;
									role: TeamMemberRole;
									user?: { __typename?: 'User'; id: string } | null;
									organization?: {
										__typename?: 'Organization';
										id: string;
										users?: Array<{
											__typename?: 'OrgUser';
											id: string;
											role: TeamMemberRole;
											user?: { __typename?: 'User'; id: string } | null;
										}> | null;
									} | null;
								}> | null;
							} | null;
						} | null;
					} | null;
				};
				assignedMember: {
					__typename?: 'OrgUser';
					id: string;
					user?: { __typename?: 'User'; id: string } | null;
					organization?: {
						__typename?: 'Organization';
						id: string;
						services: Array<{
							__typename?: 'Service';
							id: string;
							name: string;
						}>;
					} | null;
				};
				vendor: {
					__typename?: 'Organization';
					id: string;
					name: string;
					image?: string | null;
					users?: Array<{
						__typename?: 'OrgUser';
						id: string;
						role: TeamMemberRole;
						user?: { __typename?: 'User'; id: string } | null;
					}> | null;
					services: Array<{ __typename?: 'Service'; name: string; id: string }>;
				};
				customerSignatures?: Array<{
					__typename?: 'CustomerSignature';
					id: string;
					signature: {
						__typename?: 'Signature';
						id: string;
						signingDate?: Date | string | null;
						signer?: { __typename?: 'SignatureUser'; id: string } | null;
						contract?: {
							__typename?: 'SignatureContract';
							id: string;
							status: ContractStatus;
							dueDate: Date | string;
							title: string;
							guestToken?: string | null;
						} | null;
					};
				}> | null;
				invoices?: Array<{
					__typename?: 'Invoice';
					id: string;
					status: InvoiceStatus;
					title: string;
					guestToken?: string | null;
					paymentInstallments: Array<{
						__typename?: 'PaymentInstallment';
						id: string;
						status?: InstallmentStatus | null;
						dueDate?: Date | string | null;
						amountDue?: number | null;
						paymentDate?: Date | string | null;
					}>;
				}> | null;
				proposals?: Array<{
					__typename?: 'Proposal';
					id: string;
					status: ProposalStatus;
					title?: string | null;
					guestToken?: string | null;
					dueDate?: Date | string | null;
				}> | null;
			} | null;
			emailNotificationGroup?: {
				__typename?: 'EmailNotificationGroup';
				id: string;
				groupTitle: EmailNotificationGroupTitle;
				members: Array<{
					__typename?: 'ReducedUser';
					id?: string | null;
					email: string;
					userType: UserType;
					orgUser?: {
						__typename?: 'ReducedOrgUser';
						id: string;
						firstName: string;
						lastName: string;
						role: TeamMemberRole;
						organization?: {
							__typename?: 'ReducedOrganization';
							id?: string | null;
						} | null;
					} | null;
				}>;
			} | null;
			organization?: {
				__typename?: 'Organization';
				id: string;
				country?: Country | null;
				name: string;
				cardConvenienceFeePercentage: number;
				achConvenienceFeePercentage: number;
				image?: string | null;
				updatedAt: Date | string;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					firstName: string;
					lastName: string;
					role: TeamMemberRole;
					user?: {
						__typename?: 'User';
						id: string;
						email: string;
						userType: UserType;
					} | null;
					organization?: { __typename?: 'Organization'; id: string } | null;
				}> | null;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			} | null;
			lineItems: Array<{
				__typename?: 'LineItem';
				id: string;
				name: string;
				quantity: number;
				rate: number;
				taxPercentage: number;
				notes?: string | null;
			}>;
			paymentInstallments: Array<{
				__typename?: 'PaymentInstallment';
				id: string;
				dueDate?: Date | string | null;
				status?: InstallmentStatus | null;
				amountDue?: number | null;
				paymentDate?: Date | string | null;
				scheduledPaymentDate?: Date | string | null;
				name?: string | null;
				refundDate?: Date | string | null;
				convenienceFee?: number | null;
				amountPaid?: number | null;
				gratuityPaid?: number | null;
				amountRefunded?: number | null;
				scheduledPaymentMethod?: string | null;
				processor?: PaymentProcessor | null;
				percentageDue?: number | null;
				enteredAsPercentageAmount?: boolean | null;
				paymentNote?: string | null;
				refundNote?: string | null;
				paymentType?: PaymentType | null;
			}>;
			invoiceTemplate?: {
				__typename?: 'InvoiceTemplate';
				id: string;
				title: string;
				notes?: string | null;
				allowsGratuity: boolean;
				automatedRemindersEnabled: boolean;
				discountAmount: number;
				discountIsPercentage: boolean;
				discountPercentage: number;
				filename?: string | null;
				lineItems: Array<{
					__typename?: 'InvoiceTemplateLineItem';
					id: string;
					order: number;
					name: string;
					rate: number;
					quantity: number;
					taxPercentage: number;
					notes?: string | null;
				}>;
				paymentInstallments: Array<{
					__typename?: 'InvoiceTemplatePaymentInstallment';
					id: string;
					name?: string | null;
					amountDue: number;
					enteredAsPercentageAmount: boolean;
					percentageDue: number;
				}>;
			} | null;
		} | null;
	};
};

export type NewLeadsSubscription_GetInquiriesForOrganizationQueryVariables =
	Exact<{
		where?: InputMaybe<InquiriesForOrganizationWhereInput>;
	}>;

export type NewLeadsSubscription_GetInquiriesForOrganizationQuery = {
	__typename?: 'Query';
	getInquiriesForOrganization: {
		__typename?: 'InquiriesForOrganization';
		_count: number;
	};
};

export type NewLeadsSubscription_InquiryChangedSubscriptionVariables = Exact<{
	[key: string]: never;
}>;

export type NewLeadsSubscription_InquiryChangedSubscription = {
	__typename?: 'Subscription';
	inquiryChanged: {
		__typename?: 'Inquiry';
		id: string;
		organization: {
			__typename?: 'Organization';
			id: string;
			inquiries: Array<{
				__typename?: 'Inquiry';
				id: string;
				status: InquiryStatus;
			}>;
		};
	};
};

export type OrgOnboardingModal_GetOrgUserQueryVariables = Exact<{
	where: OrgUserWhereUniqueInput;
}>;

export type OrgOnboardingModal_GetOrgUserQuery = {
	__typename?: 'Query';
	getOrgUserWhere?: {
		__typename?: 'OrgUser';
		id: string;
		user?: {
			__typename?: 'User';
			id: string;
			seenOnboardingModalAt?: Date | string | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
		} | null;
	} | null;
};

export type OrgOnboardingModal_UpdateSelfMutationVariables = Exact<{
	data: UserUpdateSelfInput;
}>;

export type OrgOnboardingModal_UpdateSelfMutation = {
	__typename?: 'Mutation';
	updateSelf: {
		__typename?: 'User';
		id: string;
		seenOnboardingModalAt?: Date | string | null;
	};
};

export type GetAuthedUserForRedux_GetAuthedUserQueryVariables = Exact<{
	where: UserWhereUniqueInput;
}>;

export type GetAuthedUserForRedux_GetAuthedUserQuery = {
	__typename?: 'Query';
	getAuthedUser?: {
		__typename?: 'AuthedUser';
		userType: string;
		id: string;
		clientUser?: {
			__typename?: 'ClientUser';
			id: string;
			description?: string | null;
			firstNameOne: string;
			lastNameOne?: string | null;
			firstNameTwo?: string | null;
			lastNameTwo?: string | null;
			updatedAt: Date | string;
			facebook?: string | null;
			instagram?: string | null;
			twitter?: string | null;
			pinterest?: string | null;
			weddingDate?: Date | string | null;
			venue?: string | null;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			assignedPlanner?: {
				__typename?: 'OrgUser';
				id: string;
				firstName: string;
				lastName: string;
				updatedAt: Date | string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					updatedAt: Date | string;
				} | null;
			} | null;
		} | null;
		orgUser?: {
			__typename?: 'CalculatedOrgUser';
			id: string;
			role: TeamMemberRole;
			phone?: string | null;
			isAdmin: boolean;
			isOwner: boolean;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
				onboardingCompleted?: boolean | null;
				stripeCustomerId?: string | null;
			};
			organization?: {
				__typename?: 'Organization';
				id: string;
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				state?: State | null;
				country?: Country | null;
				postalCode?: string | null;
				createdAt: Date | string;
				name: string;
				website?: string | null;
				phone?: string | null;
				contactEmail?: string | null;
				description?: string | null;
				image?: string | null;
				imageScale?: number | null;
				imageRotation?: number | null;
				imagePositionX?: number | null;
				imagePositionY?: number | null;
				brandedEmails?: boolean | null;
				automatedRemindersEnabled: boolean;
				invoicesAllowGratuity: boolean;
				canReceivePayments: boolean;
				updatedAt: Date | string;
				facebook?: string | null;
				instagram?: string | null;
				twitter?: string | null;
				pinterest?: string | null;
				hasStripeVerificationNeeds: boolean;
				coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
				groups: Array<{
					__typename?: 'TestingGroup';
					id: string;
					name: string;
				}>;
				services: Array<{ __typename?: 'Service'; id: string; name: string }>;
				subscription?: {
					__typename?: 'AppSubscription';
					id: string;
					status?: SubscriptionStatus | null;
					subscriptionPlan: {
						__typename?: 'Plan';
						id: string;
						period: PlanPeriod;
						type: PlanType;
					};
				} | null;
				users?: Array<{
					__typename?: 'OrgUser';
					id: string;
					role: TeamMemberRole;
				}> | null;
				rootFolder?: { __typename?: 'Folder'; id: string } | null;
			} | null;
		} | null;
		superAdmin?: {
			__typename?: 'SuperAdminUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			user: {
				__typename?: 'User';
				id: string;
				userType: UserType;
				email: string;
			};
		} | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
	} | null;
};

export type HelpButton_GetGlobalVariablesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type HelpButton_GetGlobalVariablesQuery = {
	__typename?: 'Query';
	getGlobalVariables: {
		__typename?: 'FormattedGlobalVariables';
		HelpUrl?: string | null;
	};
};

export type MuiStripeVerificationModal_GetConnectOnboardingUrlQueryVariables =
	Exact<{
		data: StripeOnboardingInput;
	}>;

export type MuiStripeVerificationModal_GetConnectOnboardingUrlQuery = {
	__typename?: 'Query';
	getConnectOnboardingUrl?: {
		__typename?: 'StripeOnboardingURL';
		url: string;
	} | null;
};

export type PaymentElementContainerContactForGetQuickPaymentFragmentFragment = {
	__typename?: 'ContactForGetQuickPayment';
	id: string;
	firstName: string;
	lastName: string;
	customer: {
		__typename?: 'ContactCustomerForGetQuickPayment';
		id: string;
		email: string;
	};
};

export type PaymentElementContainerContactForCreateOrUpdateContactForCustomerFragmentFragment =
	{
		__typename?: 'Contact';
		id: string;
		firstName: string;
		lastName: string;
		customer: { __typename?: 'User'; id: string; email: string };
	};

export type PaymentElementContainer_GetStripePaymentCapabilitiesQueryVariables =
	Exact<{
		where: OrganizationWhereUniqueInput;
	}>;

export type PaymentElementContainer_GetStripePaymentCapabilitiesQuery = {
	__typename?: 'Query';
	getStripePaymentCapabilities?: {
		__typename?: 'AccountCapabilities';
		card_payments?: string | null;
		acss_debit_payments?: string | null;
	} | null;
};

export type PaymentElementContainer_ValidatePaymentQueryVariables = Exact<{
	where: ValidatePaymentInstallmentsInput;
}>;

export type PaymentElementContainer_ValidatePaymentQuery = {
	__typename?: 'Query';
	validatePayment: Array<{
		__typename?: 'PaymentInstallment';
		id: string;
		status?: InstallmentStatus | null;
	}>;
};

export type MuiSourceSelect_GetPaymentSourcesForCustomersQueryVariables =
	Exact<{
		where: UserByIdUniqueInput;
	}>;

export type MuiSourceSelect_GetPaymentSourcesForCustomersQuery = {
	__typename?: 'Query';
	getPaymentSourcesForCustomer: {
		__typename?: 'SourcesWithDefaultSource';
		default_source?: string | null;
		data?: Array<{
			__typename?: 'Source';
			id: string;
			bank_name?: string | null;
			object: string;
			last4?: string | null;
			brand?: string | null;
			metadata?: Array<{
				__typename?: 'ReturningMetaData';
				key?: string | null;
				value?: string | null;
			} | null> | null;
		}> | null;
	};
};

export type GetAuthedUserFlattenedUserFieldsCalculatedOrgUserFragment = {
	__typename?: 'CalculatedOrgUser';
	id: string;
	role: TeamMemberRole;
	phone?: string | null;
	isAdmin: boolean;
	isOwner: boolean;
	firstName: string;
	lastName: string;
	updatedAt: Date | string;
	user: {
		__typename?: 'User';
		id: string;
		userType: UserType;
		email: string;
		onboardingCompleted?: boolean | null;
		stripeCustomerId?: string | null;
	};
	organization?: {
		__typename?: 'Organization';
		id: string;
		addressLine1?: string | null;
		addressLine2?: string | null;
		city?: string | null;
		state?: State | null;
		country?: Country | null;
		postalCode?: string | null;
		createdAt: Date | string;
		name: string;
		website?: string | null;
		phone?: string | null;
		contactEmail?: string | null;
		description?: string | null;
		image?: string | null;
		imageScale?: number | null;
		imageRotation?: number | null;
		imagePositionX?: number | null;
		imagePositionY?: number | null;
		brandedEmails?: boolean | null;
		automatedRemindersEnabled: boolean;
		invoicesAllowGratuity: boolean;
		canReceivePayments: boolean;
		updatedAt: Date | string;
		facebook?: string | null;
		instagram?: string | null;
		twitter?: string | null;
		pinterest?: string | null;
		hasStripeVerificationNeeds: boolean;
		coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
		groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
		services: Array<{ __typename?: 'Service'; id: string; name: string }>;
		subscription?: {
			__typename?: 'AppSubscription';
			id: string;
			status?: SubscriptionStatus | null;
			subscriptionPlan: {
				__typename?: 'Plan';
				id: string;
				period: PlanPeriod;
				type: PlanType;
			};
		} | null;
		users?: Array<{
			__typename?: 'OrgUser';
			id: string;
			role: TeamMemberRole;
		}> | null;
		rootFolder?: { __typename?: 'Folder'; id: string } | null;
	} | null;
};

export type GetAuthedUserFlattenedUserFieldsFragment = {
	__typename?: 'AuthedUser';
	userType: string;
	id: string;
	clientUser?: {
		__typename?: 'ClientUser';
		id: string;
		description?: string | null;
		firstNameOne: string;
		lastNameOne?: string | null;
		firstNameTwo?: string | null;
		lastNameTwo?: string | null;
		updatedAt: Date | string;
		facebook?: string | null;
		instagram?: string | null;
		twitter?: string | null;
		pinterest?: string | null;
		weddingDate?: Date | string | null;
		venue?: string | null;
		user: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			email: string;
			onboardingCompleted?: boolean | null;
			stripeCustomerId?: string | null;
		};
		assignedPlanner?: {
			__typename?: 'OrgUser';
			id: string;
			firstName: string;
			lastName: string;
			updatedAt: Date | string;
			organization?: {
				__typename?: 'Organization';
				id: string;
				name: string;
				updatedAt: Date | string;
			} | null;
		} | null;
	} | null;
	orgUser?: {
		__typename?: 'CalculatedOrgUser';
		id: string;
		role: TeamMemberRole;
		phone?: string | null;
		isAdmin: boolean;
		isOwner: boolean;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		user: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			email: string;
			onboardingCompleted?: boolean | null;
			stripeCustomerId?: string | null;
		};
		organization?: {
			__typename?: 'Organization';
			id: string;
			addressLine1?: string | null;
			addressLine2?: string | null;
			city?: string | null;
			state?: State | null;
			country?: Country | null;
			postalCode?: string | null;
			createdAt: Date | string;
			name: string;
			website?: string | null;
			phone?: string | null;
			contactEmail?: string | null;
			description?: string | null;
			image?: string | null;
			imageScale?: number | null;
			imageRotation?: number | null;
			imagePositionX?: number | null;
			imagePositionY?: number | null;
			brandedEmails?: boolean | null;
			automatedRemindersEnabled: boolean;
			invoicesAllowGratuity: boolean;
			canReceivePayments: boolean;
			updatedAt: Date | string;
			facebook?: string | null;
			instagram?: string | null;
			twitter?: string | null;
			pinterest?: string | null;
			hasStripeVerificationNeeds: boolean;
			coupon?: { __typename?: 'Coupon'; id: string; name: string } | null;
			groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
			services: Array<{ __typename?: 'Service'; id: string; name: string }>;
			subscription?: {
				__typename?: 'AppSubscription';
				id: string;
				status?: SubscriptionStatus | null;
				subscriptionPlan: {
					__typename?: 'Plan';
					id: string;
					period: PlanPeriod;
					type: PlanType;
				};
			} | null;
			users?: Array<{
				__typename?: 'OrgUser';
				id: string;
				role: TeamMemberRole;
			}> | null;
			rootFolder?: { __typename?: 'Folder'; id: string } | null;
		} | null;
	} | null;
	superAdmin?: {
		__typename?: 'SuperAdminUser';
		id: string;
		firstName: string;
		lastName: string;
		updatedAt: Date | string;
		user: {
			__typename?: 'User';
			id: string;
			userType: UserType;
			email: string;
		};
	} | null;
	groups: Array<{ __typename?: 'TestingGroup'; id: string; name: string }>;
};

export const GetCustomerTypeContactFragmentDoc = gql`
	fragment getCustomerTypeContact on Contact {
		customer {
			userType
		}
	}
`;
export const GetCustomerNameContactFragmentDoc = gql`
	fragment getCustomerNameContact on Contact {
		firstName
		lastName
		customer {
			email
		}
	}
`;
export const IsAdminOrganizationFragmentDoc = gql`
	fragment isAdminOrganization on Organization {
		users {
			id
			role
		}
	}
`;
export const IsAdminOfVendorContactFragmentDoc = gql`
	fragment isAdminOfVendorContact on Contact {
		vendor {
			...isAdminOrganization
		}
	}
	${IsAdminOrganizationFragmentDoc}
`;
export const IsAdminOrManagerOfCustomersPlannerOrgContactFragmentDoc = gql`
	fragment isAdminOrManagerOfCustomersPlannerOrgContact on Contact {
		customer {
			clientUser {
				assignedPlanner {
					organization {
						id
					}
				}
			}
		}
	}
`;
export const IsAdminOrManagerOfCustomersPlannerOrgCustomerSignatureContactFragmentDoc = gql`
	fragment isAdminOrManagerOfCustomersPlannerOrgCustomerSignatureContact on CustomerSignatureContact {
		customer {
			clientUser {
				assignedPlanner {
					organization {
						id
					}
				}
			}
		}
	}
`;
export const IsAssignedPlannerContactFragmentDoc = gql`
	fragment isAssignedPlannerContact on Contact {
		customer {
			clientUser {
				assignedPlanner {
					id
				}
			}
		}
	}
`;
export const IsAssignedPlannerCustomerSignatureContactFragmentDoc = gql`
	fragment isAssignedPlannerCustomerSignatureContact on CustomerSignatureContact {
		customer {
			clientUser {
				assignedPlanner {
					id
				}
			}
		}
	}
`;
export const IsCustomerContactFragmentDoc = gql`
	fragment isCustomerContact on Contact {
		customer {
			id
		}
	}
`;
export const IsMemberOfVendorContactFragmentDoc = gql`
	fragment isMemberOfVendorContact on Contact {
		vendor {
			id
		}
	}
`;
export const IsMemberOfVendorOrgUserFragmentDoc = gql`
	fragment isMemberOfVendorOrgUser on OrgUser {
		organization {
			id
		}
	}
`;
export const GetAppaOrgUserByBaseUserOrgUserFragmentDoc = gql`
	fragment getAPPAOrgUserByBaseUserOrgUser on OrgUser {
		id
		role
		user {
			id
		}
	}
`;
export const GetAppaOrgUserByBaseUserUsersForGetContractWhereFragmentDoc = gql`
	fragment getAPPAOrgUserByBaseUserUsersForGetContractWhere on UsersForGetContractWhere {
		id
		role
		user {
			id
		}
	}
`;
export const GetAppaOrgUserByBaseUserCustomerSignatureContactOrganizationUsersFragmentDoc = gql`
	fragment getAPPAOrgUserByBaseUserCustomerSignatureContactOrganizationUsers on CustomerSignatureContactOrganizationUsers {
		id
		role
		user {
			id
		}
	}
`;
export const IsAdminOrganizationForGetContractWhereFragmentDoc = gql`
	fragment isAdminOrganizationForGetContractWhere on OrganizationForGetContractWhere {
		users {
			id
			role
		}
	}
`;
export const IsAdminOfVendorContactForGetContractWhereFragmentDoc = gql`
	fragment isAdminOfVendorContactForGetContractWhere on ContactForGetContractWhere {
		vendor {
			...isAdminOrganizationForGetContractWhere
		}
	}
	${IsAdminOrganizationForGetContractWhereFragmentDoc}
`;
export const IsAdminOfVendorContractFragmentDoc = gql`
	fragment isAdminOfVendorContract on ContractForGetContractWhere {
		signatures {
			customerSignature {
				contact {
					...isAdminOfVendorContactForGetContractWhere
				}
			}
		}
	}
	${IsAdminOfVendorContactForGetContractWhereFragmentDoc}
`;
export const IsAdminOrgUserFragmentDoc = gql`
	fragment isAdminOrgUser on OrgUser {
		id
	}
`;
export const IsAdminOfVendorOrgUserFragmentDoc = gql`
	fragment isAdminOfVendorOrgUser on OrgUser {
		...isAdminOrgUser
	}
	${IsAdminOrgUserFragmentDoc}
`;
export const IsAdminOfVendorContractOrgUserFragmentDoc = gql`
	fragment isAdminOfVendorContractOrgUser on OrgUser {
		...isAdminOfVendorOrgUser
	}
	${IsAdminOfVendorOrgUserFragmentDoc}
`;
export const IsAdminOrManagerOfVendorContactForGetContractWhereFragmentDoc = gql`
	fragment isAdminOrManagerOfVendorContactForGetContractWhere on ContactForGetContractWhere {
		vendor {
			...isAdminOrganizationForGetContractWhere
		}
	}
	${IsAdminOrganizationForGetContractWhereFragmentDoc}
`;
export const IsAdminOrManagerOfVendorContractFragmentDoc = gql`
	fragment isAdminOrManagerOfVendorContract on ContractForGetContractWhere {
		signatures {
			customerSignature {
				contact {
					...isAdminOrManagerOfVendorContactForGetContractWhere
				}
			}
		}
	}
	${IsAdminOrManagerOfVendorContactForGetContractWhereFragmentDoc}
`;
export const IsAdminOrManagerOfVendorOrgUserFragmentDoc = gql`
	fragment isAdminOrManagerOfVendorOrgUser on OrgUser {
		...isAdminOrgUser
	}
	${IsAdminOrgUserFragmentDoc}
`;
export const IsAdminOrManagerOfVendorContractOrgUserFragmentDoc = gql`
	fragment isAdminOrManagerOfVendorContractOrgUser on OrgUser {
		...isAdminOrManagerOfVendorOrgUser
	}
	${IsAdminOrManagerOfVendorOrgUserFragmentDoc}
`;
export const IsAdminOrManagerOfCustomersPlannerOrgContactForGetContractWhereFragmentDoc = gql`
	fragment isAdminOrManagerOfCustomersPlannerOrgContactForGetContractWhere on ContactForGetContractWhere {
		customer {
			clientUser {
				assignedPlanner {
					organization {
						id
					}
				}
			}
		}
	}
`;
export const IsAdminOrManagerOfCustomersPlannerOrgContractFragmentDoc = gql`
	fragment isAdminOrManagerOfCustomersPlannerOrgContract on ContractForGetContractWhere {
		signatures {
			customerSignature {
				contact {
					...isAdminOrManagerOfCustomersPlannerOrgContactForGetContractWhere
				}
			}
		}
	}
	${IsAdminOrManagerOfCustomersPlannerOrgContactForGetContractWhereFragmentDoc}
`;
export const IsAdminOrManagerOfCustomersPlannerOrgOrgUserFragmentDoc = gql`
	fragment isAdminOrManagerOfCustomersPlannerOrgOrgUser on OrgUser {
		id
		organization {
			id
			users {
				id
				role
			}
		}
	}
`;
export const IsAdminOrManagerOfCustomersPlannerOrgContractOrgUserFragmentDoc = gql`
	fragment isAdminOrManagerOfCustomersPlannerOrgContractOrgUser on OrgUser {
		...isAdminOrManagerOfCustomersPlannerOrgOrgUser
	}
	${IsAdminOrManagerOfCustomersPlannerOrgOrgUserFragmentDoc}
`;
export const IsAssignedMemberContactForGetContractWhereFragmentDoc = gql`
	fragment isAssignedMemberContactForGetContractWhere on ContactForGetContractWhere {
		assignedMember {
			id
		}
	}
`;
export const IsAssignedMemberContractFragmentDoc = gql`
	fragment isAssignedMemberContract on ContractForGetContractWhere {
		signatures {
			customerSignature {
				contact {
					...isAssignedMemberContactForGetContractWhere
				}
			}
		}
	}
	${IsAssignedMemberContactForGetContractWhereFragmentDoc}
`;
export const IsAssignedMemberOrgUserFragmentDoc = gql`
	fragment isAssignedMemberOrgUser on OrgUser {
		id
	}
`;
export const IsAssignedMemberContractOrgUserFragmentDoc = gql`
	fragment isAssignedMemberContractOrgUser on OrgUser {
		...isAssignedMemberOrgUser
	}
	${IsAssignedMemberOrgUserFragmentDoc}
`;
export const IsAssignedPlannerContactForGetContractWhereFragmentDoc = gql`
	fragment isAssignedPlannerContactForGetContractWhere on ContactForGetContractWhere {
		customer {
			clientUser {
				assignedPlanner {
					id
				}
			}
		}
	}
`;
export const IsAssignedPlannerContractForGetContractWhereFragmentDoc = gql`
	fragment isAssignedPlannerContractForGetContractWhere on ContractForGetContractWhere {
		signatures {
			customerSignature {
				contact {
					...isAssignedPlannerContactForGetContractWhere
				}
			}
		}
	}
	${IsAssignedPlannerContactForGetContractWhereFragmentDoc}
`;
export const IsAssignedPlannerOrgUserFragmentDoc = gql`
	fragment isAssignedPlannerOrgUser on OrgUser {
		id
	}
`;
export const IsAssignedPlannerContractOrgUserFragmentDoc = gql`
	fragment isAssignedPlannerContractOrgUser on OrgUser {
		...isAssignedPlannerOrgUser
	}
	${IsAssignedPlannerOrgUserFragmentDoc}
`;
export const IsSignerContractForGetContractWhereFragmentDoc = gql`
	fragment isSignerContractForGetContractWhere on ContractForGetContractWhere {
		signatures {
			signer {
				id
			}
		}
	}
`;
export const BasicCustomerSignatureForGetContractWhereFragmentDoc = gql`
	fragment BasicCustomerSignatureForGetContractWhere on CustomerSignatureForGetContractWhere {
		contact {
			customer {
				id
			}
		}
	}
`;
export const IsCustomerCustomerSignatureContactFragmentDoc = gql`
	fragment isCustomerCustomerSignatureContact on CustomerSignatureContact {
		customer {
			id
		}
	}
`;
export const BasicCustomerSignatureFragmentDoc = gql`
	fragment BasicCustomerSignature on CustomerSignature {
		contact {
			...isCustomerCustomerSignatureContact
		}
	}
	${IsCustomerCustomerSignatureContactFragmentDoc}
`;
export const SignatureWithContactPlannerFragmentDoc = gql`
	fragment SignatureWithContactPlanner on SignatureForGetContractWhere {
		customerSignature {
			contact {
				customer {
					clientUser {
						plannerOrgCanSignContracts
					}
				}
			}
		}
	}
`;
export const BasicSignatureFragmentDoc = gql`
	fragment BasicSignature on SignatureForGetContractWhere {
		type
		signer {
			id
		}
	}
`;
export const CannotSignDueToOverdueContractForGetContractWhereFragmentDoc = gql`
	fragment cannotSignDueToOverdueContractForGetContractWhere on ContractForGetContractWhere {
		dueDate
		signatures {
			signingDate
		}
	}
`;
export const GetSenderOrganizationFragmentDoc = gql`
	fragment getSenderOrganization on Organization {
		name
		brandedEmails
	}
`;
export const ConstructBundleEmailToCustomerContactFragmentDoc = gql`
	fragment constructBundleEmailToCustomerContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructContractResentEmailToCustomerContactFragmentDoc = gql`
	fragment constructContractResentEmailToCustomerContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructContractSentEmailToCustomerContactFragmentDoc = gql`
	fragment constructContractSentEmailToCustomerContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructInvoiceResentEmailToCustomerContactFragmentDoc = gql`
	fragment constructInvoiceResentEmailToCustomerContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructInvoiceSentEmailToCustomerContactFragmentDoc = gql`
	fragment constructInvoiceSentEmailToCustomerContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructMessageCustomerEmailInquiryFragmentDoc = gql`
	fragment constructMessageCustomerEmailInquiry on Inquiry {
		firstName
		organization {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructMessageCustomerEmailContactFragmentDoc = gql`
	fragment constructMessageCustomerEmailContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructProposalResentEmailToCustomerContactFragmentDoc = gql`
	fragment constructProposalResentEmailToCustomerContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const ConstructProposalSentEmailToCustomerContactFragmentDoc = gql`
	fragment constructProposalSentEmailToCustomerContact on Contact {
		firstName
		vendor {
			name
			...getSenderOrganization
		}
	}
	${GetSenderOrganizationFragmentDoc}
`;
export const GetValidEmailRecipientsEmailNotificationGroupFragmentDoc = gql`
	fragment getValidEmailRecipientsEmailNotificationGroup on EmailNotificationGroup {
		members {
			email
			blocked
		}
	}
`;
export const SortPaymentInstallmentsPaymentInstallmentFragmentDoc = gql`
	fragment sortPaymentInstallmentsPaymentInstallment on PaymentInstallment {
		dueDate
	}
`;
export const CalculateInstallmentTaxPaymentInstallmentFragmentDoc = gql`
	fragment calculateInstallmentTaxPaymentInstallment on PaymentInstallment {
		id
		amountDue
		...sortPaymentInstallmentsPaymentInstallment
	}
	${SortPaymentInstallmentsPaymentInstallmentFragmentDoc}
`;
export const CalculateInstallmentPaymentInstallmentFragmentDoc = gql`
	fragment calculateInstallmentPaymentInstallment on PaymentInstallment {
		name
		amountDue
		convenienceFee
		amountPaid
		gratuityPaid
		amountRefunded
		...calculateInstallmentTaxPaymentInstallment
	}
	${CalculateInstallmentTaxPaymentInstallmentFragmentDoc}
`;
export const CalculateInstallmentPaymentInstallmentToStringFragmentDoc = gql`
	fragment calculateInstallmentPaymentInstallmentToString on PaymentInstallment {
		dueDate
		paymentDate
		refundDate
		...calculateInstallmentPaymentInstallment
	}
	${CalculateInstallmentPaymentInstallmentFragmentDoc}
`;
export const CalculateLineTotalLineItemFragmentDoc = gql`
	fragment calculateLineTotalLineItem on LineItem {
		rate
		quantity
	}
`;
export const CalculateLineItemDiscountLineItemFragmentDoc = gql`
	fragment calculateLineItemDiscountLineItem on LineItem {
		...calculateLineTotalLineItem
	}
	${CalculateLineTotalLineItemFragmentDoc}
`;
export const CalculateLineItemTaxAmountLineItemFragmentDoc = gql`
	fragment calculateLineItemTaxAmountLineItem on LineItem {
		taxPercentage
		...calculateLineItemDiscountLineItem
	}
	${CalculateLineItemDiscountLineItemFragmentDoc}
`;
export const CalculateInvoiceTaxTotalLineItemFragmentDoc = gql`
	fragment calculateInvoiceTaxTotalLineItem on LineItem {
		...calculateLineItemTaxAmountLineItem
	}
	${CalculateLineItemTaxAmountLineItemFragmentDoc}
`;
export const CalculateLineItemDiscountInvoiceFragmentDoc = gql`
	fragment calculateLineItemDiscountInvoice on Invoice {
		discountAmount
		lineItems {
			...calculateLineItemDiscountLineItem
		}
	}
	${CalculateLineItemDiscountLineItemFragmentDoc}
`;
export const CalculateLineItemTaxAmountInvoiceFragmentDoc = gql`
	fragment calculateLineItemTaxAmountInvoice on Invoice {
		lineItems {
			...calculateLineItemTaxAmountLineItem
		}
		...calculateLineItemDiscountInvoice
	}
	${CalculateLineItemTaxAmountLineItemFragmentDoc}
	${CalculateLineItemDiscountInvoiceFragmentDoc}
`;
export const CalculateInvoiceTaxTotalInvoiceFragmentDoc = gql`
	fragment calculateInvoiceTaxTotalInvoice on Invoice {
		lineItems {
			...calculateInvoiceTaxTotalLineItem
		}
		...calculateLineItemTaxAmountInvoice
	}
	${CalculateInvoiceTaxTotalLineItemFragmentDoc}
	${CalculateLineItemTaxAmountInvoiceFragmentDoc}
`;
export const CalculateInvoiceSubtotalLineItemFragmentDoc = gql`
	fragment calculateInvoiceSubtotalLineItem on LineItem {
		...calculateLineTotalLineItem
	}
	${CalculateLineTotalLineItemFragmentDoc}
`;
export const CalculateInvoiceTotalInvoiceFragmentDoc = gql`
	fragment calculateInvoiceTotalInvoice on Invoice {
		discountAmount
		lineItems {
			...calculateInvoiceSubtotalLineItem
		}
		...calculateInvoiceTaxTotalInvoice
	}
	${CalculateInvoiceSubtotalLineItemFragmentDoc}
	${CalculateInvoiceTaxTotalInvoiceFragmentDoc}
`;
export const CalculateInstallmentTaxInvoiceFragmentDoc = gql`
	fragment calculateInstallmentTaxInvoice on Invoice {
		paymentInstallments {
			...calculateInstallmentTaxPaymentInstallment
		}
		...calculateInvoiceTaxTotalInvoice
		...calculateInvoiceTotalInvoice
	}
	${CalculateInstallmentTaxPaymentInstallmentFragmentDoc}
	${CalculateInvoiceTaxTotalInvoiceFragmentDoc}
	${CalculateInvoiceTotalInvoiceFragmentDoc}
`;
export const CalculateInstallmentInvoiceFragmentDoc = gql`
	fragment calculateInstallmentInvoice on Invoice {
		paymentInstallments {
			...calculateInstallmentPaymentInstallment
		}
		...calculateInstallmentTaxInvoice
	}
	${CalculateInstallmentPaymentInstallmentFragmentDoc}
	${CalculateInstallmentTaxInvoiceFragmentDoc}
`;
export const CalculateInstallmentInvoiceToStringFragmentDoc = gql`
	fragment calculateInstallmentInvoiceToString on Invoice {
		paymentInstallments {
			...calculateInstallmentPaymentInstallmentToString
		}
		...calculateInstallmentInvoice
	}
	${CalculateInstallmentPaymentInstallmentToStringFragmentDoc}
	${CalculateInstallmentInvoiceFragmentDoc}
`;
export const CalculateInvoicePaymentInstallmentFragmentDoc = gql`
	fragment calculateInvoicePaymentInstallment on PaymentInstallment {
		...calculateInstallmentPaymentInstallment
	}
	${CalculateInstallmentPaymentInstallmentFragmentDoc}
`;
export const CalculateLineItemLineItemFragmentDoc = gql`
	fragment calculateLineItemLineItem on LineItem {
		name
		rate
		quantity
		taxPercentage
		...calculateLineItemDiscountLineItem
		...calculateLineItemTaxAmountLineItem
	}
	${CalculateLineItemDiscountLineItemFragmentDoc}
	${CalculateLineItemTaxAmountLineItemFragmentDoc}
`;
export const CalculateInvoiceLineItemFragmentDoc = gql`
	fragment calculateInvoiceLineItem on LineItem {
		...calculateLineItemLineItem
		...calculateInvoiceSubtotalLineItem
	}
	${CalculateLineItemLineItemFragmentDoc}
	${CalculateInvoiceSubtotalLineItemFragmentDoc}
`;
export const InstallmentIsPaidInstallmentFragmentDoc = gql`
	fragment installmentIsPaidInstallment on PaymentInstallment {
		paymentDate
		status
	}
`;
export const CalculateTotalAmountPaidPaymentInstallmentFragmentDoc = gql`
	fragment calculateTotalAmountPaidPaymentInstallment on PaymentInstallment {
		amountPaid
		status
		...installmentIsPaidInstallment
	}
	${InstallmentIsPaidInstallmentFragmentDoc}
`;
export const CalculateTotalPaidOfDuePaymentInstallmentFragmentDoc = gql`
	fragment calculateTotalPaidOfDuePaymentInstallment on PaymentInstallment {
		amountDue
		status
		...installmentIsPaidInstallment
	}
	${InstallmentIsPaidInstallmentFragmentDoc}
`;
export const CalculateConvenienceChargeTotalPaymentInstallmentFragmentDoc = gql`
	fragment calculateConvenienceChargeTotalPaymentInstallment on PaymentInstallment {
		convenienceFee
		status
		...installmentIsPaidInstallment
	}
	${InstallmentIsPaidInstallmentFragmentDoc}
`;
export const CalculateGratuityPaidPaymentInstallmentFragmentDoc = gql`
	fragment calculateGratuityPaidPaymentInstallment on PaymentInstallment {
		gratuityPaid
		status
		...installmentIsPaidInstallment
	}
	${InstallmentIsPaidInstallmentFragmentDoc}
`;
export const CalculateUnpaidBalancePaymentInstallmentFragmentDoc = gql`
	fragment calculateUnpaidBalancePaymentInstallment on PaymentInstallment {
		amountDue
		status
		...installmentIsPaidInstallment
	}
	${InstallmentIsPaidInstallmentFragmentDoc}
`;
export const CalculateTotalRefundedPaymentInstallmentFragmentDoc = gql`
	fragment calculateTotalRefundedPaymentInstallment on PaymentInstallment {
		amountRefunded
	}
`;
export const CalculateTotalTaxPaidInvoiceFragmentDoc = gql`
	fragment calculateTotalTaxPaidInvoice on Invoice {
		paymentInstallments {
			...installmentIsPaidInstallment
		}
		...calculateInvoiceTaxTotalInvoice
	}
	${InstallmentIsPaidInstallmentFragmentDoc}
	${CalculateInvoiceTaxTotalInvoiceFragmentDoc}
`;
export const CalculatePaymentTotalsInvoiceFragmentDoc = gql`
	fragment calculatePaymentTotalsInvoice on Invoice {
		paymentInstallments {
			...calculateTotalAmountPaidPaymentInstallment
			...calculateTotalPaidOfDuePaymentInstallment
			...calculateConvenienceChargeTotalPaymentInstallment
			...calculateGratuityPaidPaymentInstallment
			...calculateUnpaidBalancePaymentInstallment
			...calculateTotalRefundedPaymentInstallment
		}
		...calculateTotalTaxPaidInvoice
	}
	${CalculateTotalAmountPaidPaymentInstallmentFragmentDoc}
	${CalculateTotalPaidOfDuePaymentInstallmentFragmentDoc}
	${CalculateConvenienceChargeTotalPaymentInstallmentFragmentDoc}
	${CalculateGratuityPaidPaymentInstallmentFragmentDoc}
	${CalculateUnpaidBalancePaymentInstallmentFragmentDoc}
	${CalculateTotalRefundedPaymentInstallmentFragmentDoc}
	${CalculateTotalTaxPaidInvoiceFragmentDoc}
`;
export const CalculateLineItemInvoiceFragmentDoc = gql`
	fragment calculateLineItemInvoice on Invoice {
		lineItems {
			...calculateLineItemLineItem
		}
		...calculateLineItemDiscountInvoice
		...calculateLineItemTaxAmountInvoice
	}
	${CalculateLineItemLineItemFragmentDoc}
	${CalculateLineItemDiscountInvoiceFragmentDoc}
	${CalculateLineItemTaxAmountInvoiceFragmentDoc}
`;
export const CalculateInvoiceInvoiceFragmentDoc = gql`
	fragment calculateInvoiceInvoice on Invoice {
		discountAmount
		discountPercentage
		paymentInstallments {
			...calculateInvoicePaymentInstallment
		}
		lineItems {
			...calculateInvoiceLineItem
		}
		...calculatePaymentTotalsInvoice
		...calculateLineItemInvoice
		...calculateInvoiceTaxTotalInvoice
		...calculateInvoiceTotalInvoice
	}
	${CalculateInvoicePaymentInstallmentFragmentDoc}
	${CalculateInvoiceLineItemFragmentDoc}
	${CalculatePaymentTotalsInvoiceFragmentDoc}
	${CalculateLineItemInvoiceFragmentDoc}
	${CalculateInvoiceTaxTotalInvoiceFragmentDoc}
	${CalculateInvoiceTotalInvoiceFragmentDoc}
`;
export const CalculateInvoiceDiscountToStringInvoiceFragmentDoc = gql`
	fragment calculateInvoiceDiscountToStringInvoice on Invoice {
		discountAmount
	}
`;
export const CalculateConvenienceFeeOrganizationFragmentDoc = gql`
	fragment calculateConvenienceFeeOrganization on Organization {
		cardConvenienceFeePercentage
		achConvenienceFeePercentage
	}
`;
export const CalculateInvoicePaymentInvoiceFragmentDoc = gql`
	fragment calculateInvoicePaymentInvoice on Invoice {
		paymentInstallments {
			id
			status
			amountDue
		}
		organization {
			...calculateConvenienceFeeOrganization
		}
	}
	${CalculateConvenienceFeeOrganizationFragmentDoc}
`;
export const CalculateInvoiceSubtotalToStringLineItemFragmentDoc = gql`
	fragment calculateInvoiceSubtotalToStringLineItem on LineItem {
		...calculateInvoiceSubtotalLineItem
	}
	${CalculateInvoiceSubtotalLineItemFragmentDoc}
`;
export const CalculateInvoiceTaxTotalToStringInvoiceFragmentDoc = gql`
	fragment calculateInvoiceTaxTotalToStringInvoice on Invoice {
		...calculateInvoiceTaxTotalInvoice
	}
	${CalculateInvoiceTaxTotalInvoiceFragmentDoc}
`;
export const CalculateInvoiceTotalToStringInvoiceFragmentDoc = gql`
	fragment calculateInvoiceTotalToStringInvoice on Invoice {
		...calculateInvoiceTotalInvoice
	}
	${CalculateInvoiceTotalInvoiceFragmentDoc}
`;
export const CalculateLineItemToStringInvoiceFragmentDoc = gql`
	fragment calculateLineItemToStringInvoice on Invoice {
		...calculateLineItemDiscountInvoice
		...calculateLineItemTaxAmountInvoice
	}
	${CalculateLineItemDiscountInvoiceFragmentDoc}
	${CalculateLineItemTaxAmountInvoiceFragmentDoc}
`;
export const CalculateLineItemToStringLineItemFragmentDoc = gql`
	fragment calculateLineItemToStringLineItem on LineItem {
		name
		rate
		quantity
		taxPercentage
		...calculateLineItemDiscountLineItem
		...calculateLineItemTaxAmountLineItem
	}
	${CalculateLineItemDiscountLineItemFragmentDoc}
	${CalculateLineItemTaxAmountLineItemFragmentDoc}
`;
export const CalculateMultipleInstallmentsAmountDueRegardlessOfStatusToStringFragmentDoc = gql`
	fragment calculateMultipleInstallmentsAmountDueRegardlessOfStatusToString on PaymentInstallment {
		amountDue
	}
`;
export const CalculatePaymentTotalsCalculatePaymentTotalsToStringInvoiceFragmentDoc = gql`
	fragment calculatePaymentTotalsCalculatePaymentTotalsToStringInvoice on Invoice {
		...calculatePaymentTotalsInvoice
	}
	${CalculatePaymentTotalsInvoiceFragmentDoc}
`;
export const CalculateTotalAmountPaidLessCcPaymentInstallmentFragmentDoc = gql`
	fragment calculateTotalAmountPaidLessCCPaymentInstallment on PaymentInstallment {
		...calculateTotalAmountPaidPaymentInstallment
		...calculateConvenienceChargeTotalPaymentInstallment
	}
	${CalculateTotalAmountPaidPaymentInstallmentFragmentDoc}
	${CalculateConvenienceChargeTotalPaymentInstallmentFragmentDoc}
`;
export const GetInvoiceDueDateInvoiceFragmentDoc = gql`
	fragment getInvoiceDueDateInvoice on Invoice {
		paymentInstallments {
			status
			dueDate
		}
	}
`;
export const GetUserFriendlyStatusInvoiceFragmentDoc = gql`
	fragment getUserFriendlyStatusInvoice on Invoice {
		status
		isPastDue
		paymentInstallments {
			status
		}
	}
`;
export const PaymentInstallmentAmountDueWithinRangePaymentInstallmentFragmentDoc = gql`
	fragment paymentInstallmentAmountDueWithinRangePaymentInstallment on PaymentInstallment {
		amountDue
	}
`;
export const IsAdminOfVendorInvoiceFragmentDoc = gql`
	fragment isAdminOfVendorInvoice on Invoice {
		organization {
			...isAdminOrganization
		}
	}
	${IsAdminOrganizationFragmentDoc}
`;
export const IsAdminOfVendorInvoiceOrgUserFragmentDoc = gql`
	fragment isAdminOfVendorInvoiceOrgUser on OrgUser {
		...isAdminOrgUser
	}
	${IsAdminOrgUserFragmentDoc}
`;
export const IsAdminOrManagerOfVendorInvoiceFragmentDoc = gql`
	fragment isAdminOrManagerOfVendorInvoice on Invoice {
		organization {
			...isAdminOrganization
		}
	}
	${IsAdminOrganizationFragmentDoc}
`;
export const IsAdminOrManagerOfVendorInvoiceOrgUserFragmentDoc = gql`
	fragment isAdminOrManagerOfVendorInvoiceOrgUser on OrgUser {
		...isAdminOrgUser
	}
	${IsAdminOrgUserFragmentDoc}
`;
export const IsMemberOfVendorInvoiceFragmentDoc = gql`
	fragment isMemberOfVendorInvoice on Invoice {
		organization {
			id
		}
	}
`;
export const IsMemberOfVendorInvoiceOrgUserFragmentDoc = gql`
	fragment isMemberOfVendorInvoiceOrgUser on OrgUser {
		organization {
			id
		}
	}
`;
export const OwnerIsBlockedOrganizationFragmentDoc = gql`
	fragment ownerIsBlockedOrganization on Organization {
		users {
			role
			user {
				blocked
			}
		}
	}
`;
export const GetAdminOrgUsersOrganizationFragmentDoc = gql`
	fragment getAdminOrgUsersOrganization on Organization {
		users {
			role
		}
	}
`;
export const IsAdminOrManagerOrganizationFragmentDoc = gql`
	fragment isAdminOrManagerOrganization on Organization {
		users {
			id
			role
		}
	}
`;
export const IsAdminOrManagerOrgUserFragmentDoc = gql`
	fragment isAdminOrManagerOrgUser on OrgUser {
		id
	}
`;
export const IsDisabledOrganizationFragmentDoc = gql`
	fragment isDisabledOrganization on Organization {
		users {
			id
			role
		}
	}
`;
export const IsDisabledOrgUserFragmentDoc = gql`
	fragment isDisabledOrgUser on OrgUser {
		id
	}
`;
export const IsOwnerOrganizationFragmentDoc = gql`
	fragment isOwnerOrganization on Organization {
		users {
			id
			role
		}
	}
`;
export const IsOwnerOrgUserFragmentDoc = gql`
	fragment isOwnerOrgUser on OrgUser {
		id
	}
`;
export const GetOwnerOrganizationFragmentDoc = gql`
	fragment getOwnerOrganization on Organization {
		users {
			role
		}
	}
`;
export const CanAccessPremiumOrganizationFragmentDoc = gql`
	fragment canAccessPremiumOrganization on Organization {
		id
		createdAt
		subscription {
			id
			status
			subscriptionPlan {
				id
				type
			}
		}
		groups {
			name
		}
	}
`;
export const CouponIsForeverFreeStripeCouponFragmentDoc = gql`
	fragment couponIsForeverFreeStripeCoupon on StripeCoupon {
		amount_off
		percent_off
		duration_in_months
		duration
	}
`;
export const CouponIsForeverFreePlanFragmentDoc = gql`
	fragment couponIsForeverFreePlan on Plan {
		price
	}
`;
export const CouponIsForeverFreeStripePlanFragmentDoc = gql`
	fragment couponIsForeverFreeStripePlan on StripePlan {
		amount
	}
`;
export const GetSubscriptionStatusStripeInvoiceFragmentDoc = gql`
	fragment getSubscriptionStatusStripeInvoice on StripeInvoice {
		id
		period_start
		period_end
		next_payment_attempt
		amount_due
	}
`;
export const SubscriptionHasActiveForeverFreeCouponStripeCouponFragmentDoc = gql`
	fragment subscriptionHasActiveForeverFreeCouponStripeCoupon on StripeCoupon {
		amount_off
		percent_off
		duration_in_months
		duration
	}
`;
export const SubscriptionHasActiveForeverFreeCouponPlanFragmentDoc = gql`
	fragment subscriptionHasActiveForeverFreeCouponPlan on Plan {
		price
	}
`;
export const SubscriptionHasActiveForeverFreeCouponStripePlanFragmentDoc = gql`
	fragment subscriptionHasActiveForeverFreeCouponStripePlan on StripePlan {
		amount
	}
`;
export const IsAdminOfOwnOrganizationFragmentDoc = gql`
	fragment isAdminOfOwnOrganization on User {
		orgUser {
			id
			organization {
				users {
					id
					role
				}
			}
		}
	}
`;
export const ContractViewPage_ContractFragmentDoc = gql`
	fragment contractViewPage_contract on ContractForGetContractWhere {
		id
		contractTemplate {
			id
			countOfCustomerSigners
		}
	}
`;
export const InvoiceViewPage_InvoiceFragmentDoc = gql`
	fragment invoiceViewPage_invoice on Invoice {
		id
		status
		organization {
			id
			users {
				id
				role
			}
		}
	}
`;
export const ActivateSubscriptionModal_OrganizationFragmentFragmentDoc = gql`
	fragment ActivateSubscriptionModal_OrganizationFragment on Organization {
		id
		coupon {
			id
			name
		}
	}
`;
export const InvoiceAcceptedByPlannerEventPropsEventFragmentDoc = gql`
	fragment invoiceAcceptedByPlannerEventPropsEvent on Event {
		id
		category
		invoice {
			id
			title
			eventDate
			contact {
				id
				firstName
				lastName
				assignedMember {
					id
				}
				customer {
					id
					email
					clientUser {
						id
						assignedPlanner {
							id
							firstName
							lastName
							user {
								id
							}
							organization {
								id
							}
						}
					}
				}
				vendor {
					id
					name
					users {
						id
						role
						user {
							id
						}
					}
				}
			}
			organization {
				id
			}
		}
		paymentInstallments {
			id
			name
		}
	}
`;
export const GetViewingUserDocumentRelationshipContactFragmentDoc = gql`
	fragment getViewingUserDocumentRelationshipContact on Contact {
		id
		customer {
			id
			clientUser {
				id
				plannerOrgCanPayInvoices
				plannerOrgCanSignContracts
				assignedPlanner {
					id
					organization {
						id
						users {
							id
							role
							user {
								id
							}
							organization {
								id
								users {
									id
									role
									user {
										id
									}
								}
							}
						}
					}
				}
			}
		}
		assignedMember {
			id
			user {
				id
			}
		}
		vendor {
			id
			users {
				id
				role
				user {
					id
				}
			}
		}
	}
`;
export const InvoiceFullyPaidEventPropsEventFragmentDoc = gql`
	fragment invoiceFullyPaidEventPropsEvent on Event {
		id
		category
		invoice {
			id
			title
			eventDate
			contact {
				...getViewingUserDocumentRelationshipContact
			}
		}
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
`;
export const GetContractSentEventPropsEventFragmentDoc = gql`
	fragment getContractSentEventPropsEvent on Event {
		contract {
			vendor {
				id
				users {
					id
					role
				}
			}
		}
	}
`;
export const ActivityTabEventFragmentDoc = gql`
	fragment activityTabEvent on Event {
		id
		category
		createdAt
		message
		metadata
		resolvedAt
		actingUser {
			id
			orgUser {
				id
				firstName
				lastName
				user {
					id
				}
				organization {
					id
					name
					services {
						id
						name
					}
				}
			}
		}
		clientUser {
			id
			firstNameOne
			lastNameOne
			firstNameTwo
			lastNameTwo
			plannerOrgCanPayInvoices
			plannerOrgCanSignContracts
			plannerOrgHasConnectionPermissions
			plannerOrgHasDocumentsPermissions
			user {
				id
				email
			}
			assignedPlanner {
				id
				organization {
					id
					name
					orgType
					services {
						id
						name
					}
					users {
						id
						role
					}
				}
			}
		}
		guestUser {
			id
			user {
				id
				email
			}
		}
		vendor {
			id
			name
			services {
				id
				name
			}
			users {
				id
				role
			}
		}
		orgUser {
			id
			role
			firstName
			lastName
			user {
				id
				email
			}
			organization {
				id
				name
				orgType
				services {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		plannerUser {
			id
			role
			firstName
			lastName
			user {
				id
			}
			organization {
				id
				name
				orgType
				services {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		contacts {
			id
			firstName
			lastName
			companyName
			customer {
				id
				userType
				email
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								role
							}
						}
					}
				}
			}
			vendor {
				id
				name
			}
		}
		contact {
			id
			firstName
			lastName
			companyName
			customer {
				id
				userType
				email
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								role
							}
						}
					}
				}
			}
			vendor {
				id
				name
			}
		}
		invitation {
			id
			emailAddress
			recipientFirstName
			recipientLastName
		}
		contract {
			id
			title
			eventDate
			automatedRemindersEnabled
			sentByUser {
				id
				user {
					id
				}
			}
			vendor {
				id
				users {
					id
					role
					user {
						id
					}
				}
			}
			signatures {
				id
				type
				signer {
					id
					orgUser {
						id
						firstName
						lastName
						user {
							id
						}
					}
				}
				customerSignature {
					id
					contact {
						id
						vendor {
							id
							name
							users {
								id
								role
							}
						}
						customer {
							id
							email
							userType
							clientUser {
								id
								plannerOrgCanSignContracts
								assignedPlanner {
									id
									organization {
										id
										users {
											id
											role
										}
									}
								}
							}
						}
						assignedMember {
							id
							user {
								id
							}
						}
					}
				}
			}
		}
		invoice {
			id
			title
			status
			gratuityAmount
			automatedRemindersEnabled
			paymentInstallments {
				id
				name
			}
			contact {
				id
				customer {
					id
				}
				vendor {
					id
					name
					orgType
					services {
						id
						name
					}
					users {
						id
						role
					}
				}
			}
		}
		document {
			id
			name
			fileSource
			fileType
			customer {
				id
				userType
				clientUser {
					id
					firstNameOne
					lastNameOne
					assignedPlanner {
						id
						organization {
							id
							services {
								id
								name
							}
							users {
								id
								role
							}
						}
					}
				}
				orgUser {
					id
					firstName
					lastName
				}
			}
			organization {
				id
				name
				services {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		paymentInstallments {
			id
			name
		}
		proposal {
			id
			title
			eventDate
			automatedRemindersEnabled
			proposalTemplate {
				id
			}
			contact {
				id
				firstName
				lastName
				customer {
					id
					email
					clientUser {
						id
						assignedPlanner {
							id
							organization {
								id
							}
						}
					}
				}
				vendor {
					id
					name
				}
			}
		}
		inquiry {
			id
			firstName
			lastName
			organization {
				id
				name
				createdAt
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		emailNotificationGroup {
			id
			groupTitle
		}
		...invoiceAcceptedByPlannerEventPropsEvent
		...invoiceFullyPaidEventPropsEvent
		...getContractSentEventPropsEvent
	}
	${InvoiceAcceptedByPlannerEventPropsEventFragmentDoc}
	${InvoiceFullyPaidEventPropsEventFragmentDoc}
	${GetContractSentEventPropsEventFragmentDoc}
`;
export const OrganizationNotificationPreferencesOrgUserFragmentDoc = gql`
	fragment organizationNotificationPreferencesOrgUser on OrgUser {
		id
		firstName
		lastName
		role
		user {
			id
			email
		}
		organization {
			id
		}
	}
`;
export const OrganizationNotificationPreferencesReducedUserFragmentDoc = gql`
	fragment organizationNotificationPreferencesReducedUser on ReducedUser {
		id
		email
		userType
		orgUser {
			id
			firstName
			lastName
			role
			organization {
				id
			}
		}
	}
`;
export const OrganizationNotificationPreferencesEmailNotificationGroupFragmentDoc = gql`
	fragment organizationNotificationPreferencesEmailNotificationGroup on EmailNotificationGroup {
		id
		groupTitle
		members {
			...organizationNotificationPreferencesReducedUser
		}
	}
	${OrganizationNotificationPreferencesReducedUserFragmentDoc}
`;
export const NotificationGroupEventFeedEventEventFragmentDoc = gql`
	fragment notificationGroupEventFeedEventEvent on Event {
		id
		createdAt
		category
		clientUser {
			id
			firstNameOne
			lastNameOne
			user {
				id
				email
				contacts {
					vendor {
						id
					}
				}
			}
		}
		orgUser {
			id
			firstName
			lastName
			organization {
				id
			}
			user {
				id
				email
				contacts {
					id
					vendor {
						id
					}
				}
			}
		}
		guestUser {
			id
			user {
				id
				email
				contacts {
					id
					vendor {
						id
					}
				}
			}
		}
		emailNotificationGroup {
			id
			groupTitle
		}
		actingUser {
			id
			orgUser {
				id
				firstName
				lastName
			}
		}
	}
`;
export const NotificationGroupEventFeedEventFragmentDoc = gql`
	fragment notificationGroupEventFeedEvent on Event {
		...notificationGroupEventFeedEventEvent
	}
	${NotificationGroupEventFeedEventEventFragmentDoc}
`;
export const EmailNotificationGroupEventsEventFragmentDoc = gql`
	fragment emailNotificationGroupEventsEvent on Event {
		...notificationGroupEventFeedEvent
	}
	${NotificationGroupEventFeedEventFragmentDoc}
`;
export const UseUpdateOrganizationContactInfoOrganizationFragmentDoc = gql`
	fragment useUpdateOrganizationContactInfoOrganization on Organization {
		id
		name
		description
		services {
			id
			name
		}
		contactEmail
		phone
		website
		addressLine1
		addressLine2
		city
		state
		country
		postalCode
		facebook
		twitter
		instagram
		pinterest
	}
`;
export const CurrentPlanPlanFragmentDoc = gql`
	fragment currentPlanPlan on Plan {
		id
		type
		period
		price
		stripePlanID
	}
`;
export const CurrentPlanReducedCouponFragmentDoc = gql`
	fragment currentPlanReducedCoupon on ReducedCoupon {
		percent_off
		amount_off
		duration
		duration_in_months
	}
`;
export const CurrentPlanSubscriptionObjectFragmentDoc = gql`
	fragment currentPlanSubscriptionObject on SubscriptionObject {
		plan {
			id
			interval
			amount
		}
		discounts {
			coupon {
				percent_off
				amount_off
				duration
				duration_in_months
			}
		}
	}
`;
export const GetNextChargeAmountReducedCouponFragmentDoc = gql`
	fragment getNextChargeAmountReducedCoupon on ReducedCoupon {
		percent_off
		duration_in_months
	}
`;
export const NextChargeReducedCouponFragmentDoc = gql`
	fragment nextChargeReducedCoupon on ReducedCoupon {
		percent_off
		duration_in_months
		...getNextChargeAmountReducedCoupon
	}
	${GetNextChargeAmountReducedCouponFragmentDoc}
`;
export const GetPlanStartDateSubscriptionObjectFragmentDoc = gql`
	fragment getPlanStartDateSubscriptionObject on SubscriptionObject {
		id
		items {
			data {
				current_period_end
			}
		}
	}
`;
export const GetNextChargeAmountSubscriptionObjectFragmentDoc = gql`
	fragment getNextChargeAmountSubscriptionObject on SubscriptionObject {
		id
		status
		items {
			data {
				current_period_end
			}
		}
		plan {
			amount
			interval
		}
		discounts {
			coupon {
				percent_off
				duration_in_months
			}
		}
	}
`;
export const NextChargeSubscriptionObjectFragmentDoc = gql`
	fragment nextChargeSubscriptionObject on SubscriptionObject {
		plan {
			amount
			interval
		}
		...getPlanStartDateSubscriptionObject
		...getNextChargeAmountSubscriptionObject
	}
	${GetPlanStartDateSubscriptionObjectFragmentDoc}
	${GetNextChargeAmountSubscriptionObjectFragmentDoc}
`;
export const GetPlanStartDateStripeInvoiceFragmentDoc = gql`
	fragment getPlanStartDateStripeInvoice on StripeInvoice {
		id
		amount_due
		next_payment_attempt
	}
`;
export const GetNextChargeAmountStripeInvoiceFragmentDoc = gql`
	fragment getNextChargeAmountStripeInvoice on StripeInvoice {
		id
		amount_due
	}
`;
export const NextChargeStripeInvoiceFragmentDoc = gql`
	fragment nextChargeStripeInvoice on StripeInvoice {
		id
		...getPlanStartDateStripeInvoice
		...getNextChargeAmountStripeInvoice
	}
	${GetPlanStartDateStripeInvoiceFragmentDoc}
	${GetNextChargeAmountStripeInvoiceFragmentDoc}
`;
export const GetPlanStartDateOrganizationFragmentDoc = gql`
	fragment getPlanStartDateOrganization on Organization {
		id
		createdAt
	}
`;
export const NextChargeOrganizationFragmentDoc = gql`
	fragment nextChargeOrganization on Organization {
		...getPlanStartDateOrganization
	}
	${GetPlanStartDateOrganizationFragmentDoc}
`;
export const PaymentMethodModalSubscriptionObjectFragmentDoc = gql`
	fragment paymentMethodModalSubscriptionObject on SubscriptionObject {
		status
	}
`;
export const PromotionalDiscountReducedCouponFragmentDoc = gql`
	fragment promotionalDiscountReducedCoupon on ReducedCoupon {
		id
		percent_off
		amount_off
		duration
		duration_in_months
	}
`;
export const PromotionalDiscountSubscriptionObjectFragmentDoc = gql`
	fragment promotionalDiscountSubscriptionObject on SubscriptionObject {
		discounts {
			coupon {
				id
				percent_off
				amount_off
				duration
				duration_in_months
			}
		}
	}
`;
export const SubscriptionCancellationModalSubscriptionObjectFragmentDoc = gql`
	fragment subscriptionCancellationModalSubscriptionObject on SubscriptionObject {
		id
		status
		items {
			data {
				current_period_end
			}
		}
		plan {
			amount
			interval
		}
	}
`;
export const SubscriptionCancellationModalOrganizationFragmentDoc = gql`
	fragment subscriptionCancellationModalOrganization on Organization {
		id
		createdAt
		subscription {
			id
			status
		}
	}
`;
export const PaidCopyCouponFragmentDoc = gql`
	fragment paidCopyCoupon on ReducedCoupon {
		name
		active
		percent_off
		amount_off
		duration
		duration_in_months
		id
		planCost {
			proration
			price
			amountDue
		}
	}
`;
export const SubscriptionOptionButtonReducedCouponWithPlanDataFragmentDoc = gql`
	fragment subscriptionOptionButtonReducedCouponWithPlanData on ReducedCoupon {
		name
		id
		percent_off
		duration_in_months
		active
		planCost {
			price
			proration
			amountDue
		}
	}
`;
export const SubscriptionOptionButtonReducedCouponFragmentDoc = gql`
	fragment subscriptionOptionButtonReducedCoupon on ReducedCoupon {
		name
	}
`;
export const SubscriptionSelectionModalReducedCouponFragmentDoc = gql`
	fragment subscriptionSelectionModalReducedCoupon on ReducedCoupon {
		id
		active
		percent_off
		...subscriptionOptionButtonReducedCoupon
	}
	${SubscriptionOptionButtonReducedCouponFragmentDoc}
`;
export const SubscriptionHasActiveForeverFreeCouponSubscriptionObjectFragmentDoc = gql`
	fragment subscriptionHasActiveForeverFreeCouponSubscriptionObject on SubscriptionObject {
		discounts {
			coupon {
				duration
				duration_in_months
				percent_off
				amount_off
			}
		}
	}
`;
export const GetSubscriptionStatusSubscriptionObjectFragmentDoc = gql`
	fragment getSubscriptionStatusSubscriptionObject on SubscriptionObject {
		id
		status
		items {
			data {
				current_period_start
				current_period_end
			}
		}
		cancel_at_period_end
	}
`;
export const ConfirmSubscriptionSelectionSubscriptionObjectFragmentDoc = gql`
	fragment confirmSubscriptionSelectionSubscriptionObject on SubscriptionObject {
		...subscriptionHasActiveForeverFreeCouponSubscriptionObject
		...getSubscriptionStatusSubscriptionObject
	}
	${SubscriptionHasActiveForeverFreeCouponSubscriptionObjectFragmentDoc}
	${GetSubscriptionStatusSubscriptionObjectFragmentDoc}
`;
export const SubscriptionOptionButtonSubscriptionObjectFragmentDoc = gql`
	fragment subscriptionOptionButtonSubscriptionObject on SubscriptionObject {
		status
		cancel_at_period_end
	}
`;
export const SubscriptionSelectionModalSubscriptionObjectFragmentDoc = gql`
	fragment subscriptionSelectionModalSubscriptionObject on SubscriptionObject {
		amount
		...confirmSubscriptionSelectionSubscriptionObject
		...subscriptionOptionButtonSubscriptionObject
	}
	${ConfirmSubscriptionSelectionSubscriptionObjectFragmentDoc}
	${SubscriptionOptionButtonSubscriptionObjectFragmentDoc}
`;
export const ConfirmSubscriptionSelectionOrganizationFragmentDoc = gql`
	fragment confirmSubscriptionSelectionOrganization on Organization {
		id
		createdAt
		hasForeverCoupon
		subscription {
			id
			status
			subscriptionPlan {
				id
				type
				period
			}
		}
	}
`;
export const SubscriptionSelectionModalOrganizationFragmentDoc = gql`
	fragment subscriptionSelectionModalOrganization on Organization {
		...confirmSubscriptionSelectionOrganization
	}
	${ConfirmSubscriptionSelectionOrganizationFragmentDoc}
`;
export const SubscriptionOptionButtonPlanFragmentDoc = gql`
	fragment subscriptionOptionButtonPlan on Plan {
		id
		type
		period
		price
		proration
		amountDue
		active
	}
`;
export const PaidCopyPlanFragmentDoc = gql`
	fragment paidCopyPlan on Plan {
		id
		type
		period
		proration
		price
		amountDue
	}
`;
export const ConfirmSubscriptionSelectionPlanFragmentDoc = gql`
	fragment confirmSubscriptionSelectionPlan on Plan {
		active
		...paidCopyPlan
	}
	${PaidCopyPlanFragmentDoc}
`;
export const SubscriptionSelectionModalPlanFragmentDoc = gql`
	fragment subscriptionSelectionModalPlan on Plan {
		...subscriptionOptionButtonPlan
		...confirmSubscriptionSelectionPlan
	}
	${SubscriptionOptionButtonPlanFragmentDoc}
	${ConfirmSubscriptionSelectionPlanFragmentDoc}
`;
export const SubscriptionPaymentMethodModalsSourceFragmentDoc = gql`
	fragment subscriptionPaymentMethodModalsSource on Source {
		id
		last4
		exp_month
		exp_year
		address_zip
		name
		metadata {
			key
			value
		}
	}
`;
export const CurrentPlanSourceFragmentDoc = gql`
	fragment currentPlanSource on Source {
		...subscriptionPaymentMethodModalsSource
	}
	${SubscriptionPaymentMethodModalsSourceFragmentDoc}
`;
export const UpdateVendorBillingSourceFragmentDoc = gql`
	fragment updateVendorBillingSource on Source {
		object
		...currentPlanSource
	}
	${CurrentPlanSourceFragmentDoc}
`;
export const AdminWebhookDeliveryHistory_WebhookDeliveryFragmentDoc = gql`
	fragment AdminWebhookDeliveryHistory_WebhookDelivery on WebhookDelivery {
		id
		eventId
		eventType
		status
		apiVersion
		destinationUrl
		payload
		responseStatus
		attemptCount
		lastAttemptAt
		nextAttemptAt
		deliveredAt
		exhaustedAt
		createdAt
	}
`;
export const AdminWebhooks_WebhookEndpointFragmentDoc = gql`
	fragment AdminWebhooks_WebhookEndpoint on WebhookEndpoint {
		id
		description
		destinationUrl
		enabled
		apiVersion
		secretSuffix
		subscribedEventTypes
		previousSecretExpiresAt
		pausedAt
		createdAt
		updatedAt
	}
`;
export const ClientDetailActionMenuDateChangeModalContactFragmentDoc = gql`
	fragment clientDetailActionMenuDateChangeModalContact on Contact {
		id
		firstName
		lastName
		customer {
			id
			userType
			email
			clientUser {
				id
				firstNameOne
				lastNameOne
				firstNameTwo
				lastNameTwo
			}
			orgUser {
				id
				firstName
				lastName
			}
		}
	}
`;
export const UseClientDetailOverviewTargetOrgUserFragmentDoc = gql`
	fragment useClientDetailOverviewTargetOrgUser on OrgUser {
		id
		organization {
			id
			updatedAt
			image
			name
		}
	}
`;
export const UpdateContactModal_OrganizationFragmentDoc = gql`
	fragment updateContactModal_Organization on Organization {
		id
		contacts {
			id
			customer {
				email
				id
			}
		}
	}
`;
export const ClientDetailHeaderTargetOrgUserFragmentDoc = gql`
	fragment clientDetailHeaderTargetOrgUser on OrgUser {
		id
		updatedAt
		firstName
		lastName
		role
		organization {
			id
			updatedAt
			image
			name
		}
		user {
			id
			email
			userType
		}
	}
`;
export const UseClientDetailTargetOrgUserFragmentDoc = gql`
	fragment useClientDetailTargetOrgUser on OrgUser {
		id
		phone
		firstName
		lastName
		role
		user {
			id
			blocked
		}
		organization {
			id
			users {
				id
				role
			}
		}
		...clientDetailHeaderTargetOrgUser
	}
	${ClientDetailHeaderTargetOrgUserFragmentDoc}
`;
export const UseClientDetailMembersFragmentDoc = gql`
	fragment useClientDetailMembers on OrgUser {
		id
		firstName
		lastName
		updatedAt
		role
	}
`;
export const UpdateContactModalContactFragmentDoc = gql`
	fragment updateContactModalContact on Contact {
		id
		firstName
		lastName
		phone
		venue
		eventDate
		status
		hasCustomerIntent
		companyName
		source
		assignedMember {
			id
			firstName
			lastName
		}
		vendor {
			id
		}
		customer {
			id
			email
			userType
			orgUser {
				id
				firstName
				lastName
				phone
			}
			clientUser {
				id
				firstNameOne
				lastNameOne
				phone
				weddingDate
				venue
				assignedPlanner {
					id
					firstName
					lastName
				}
			}
			guestUser {
				id
			}
		}
	}
`;
export const ClientDetailActionMenuContactFragmentDoc = gql`
	fragment clientDetailActionMenuContact on Contact {
		id
		firstName
		lastName
		status
		hasCustomerIntent
		customer {
			id
			email
			userType
			updatedAt
			clientUser {
				id
				assignedPlanner {
					id
				}
			}
			guestUser {
				id
			}
			orgUser {
				id
				firstName
				lastName
			}
		}
		vendor {
			id
		}
		assignedMember {
			id
		}
	}
`;
export const ActionMenuRequestPermissionsModalContactFragmentDoc = gql`
	fragment actionMenuRequestPermissionsModalContact on Contact {
		id
		customer {
			id
			userType
			clientUser {
				id
				updatedAt
			}
			orgUser {
				id
				updatedAt
			}
		}
	}
`;
export const SendDocumentsModalContactFragmentDoc = gql`
	fragment sendDocumentsModalContact on Contact {
		id
		firstName
		lastName
		eventDate
		customer {
			id
		}
	}
`;
export const ClientActionButtonContactFragmentDoc = gql`
	fragment clientActionButtonContact on Contact {
		id
		customer {
			id
			clientUser {
				id
				firstNameOne
				lastNameOne
				phone
			}
			orgUser {
				id
				firstName
				lastName
				phone
			}
		}
		...updateContactModalContact
		...clientDetailActionMenuContact
		...actionMenuRequestPermissionsModalContact
		...sendDocumentsModalContact
	}
	${UpdateContactModalContactFragmentDoc}
	${ClientDetailActionMenuContactFragmentDoc}
	${ActionMenuRequestPermissionsModalContactFragmentDoc}
	${SendDocumentsModalContactFragmentDoc}
`;
export const ClientContactInfoClientFragmentDoc = gql`
	fragment clientContactInfoClient on Contact {
		id
		status
		phone
		firstName
		hasCustomerIntent
		customer {
			id
			email
			clientUser {
				id
				phone
				addressLine1
				addressLine2
				city
				state
				postalCode
				twitter
				facebook
				pinterest
				instagram
			}
			orgUser {
				id
				phone
				organization {
					id
					website
					addressLine1
					addressLine2
					city
					state
					postalCode
					twitter
					facebook
					pinterest
					instagram
				}
			}
		}
		...clientActionButtonContact
	}
	${ClientActionButtonContactFragmentDoc}
`;
export const ClientPermissionsTooltipClientUserFragmentDoc = gql`
	fragment clientPermissionsTooltipClientUser on ClientUser {
		id
		plannerOrgHasConnectionPermissions
		plannerOrgCanSignContracts
		plannerOrgCanPayInvoices
		plannerOrgHasDocumentsPermissions
	}
`;
export const AssignedToMembersFragmentDoc = gql`
	fragment assignedToMembers on OrgUser {
		id
		firstName
		lastName
		updatedAt
		role
		user {
			id
			onboardingCompleted
		}
	}
`;
export const ClientDetailAssignedToContactFragmentDoc = gql`
	fragment clientDetailAssignedToContact on Contact {
		id
		status
		customer {
			id
			clientUser {
				id
				assignedPlanner {
					id
					organization {
						id
					}
					...assignedToMembers
				}
			}
		}
		assignedMember {
			id
			...assignedToMembers
		}
		vendor {
			users(orderBy: { firstName: desc }) {
				id
				role
				...assignedToMembers
			}
		}
	}
	${AssignedToMembersFragmentDoc}
`;
export const UseClientDetailOverviewContactFragmentDoc = gql`
	fragment useClientDetailOverviewContact on Contact {
		id
		status
		firstName
		lastName
		hasCustomerIntent
		companyName
		source
		createdAt
		venue
		eventDate
		customer {
			id
			email
			userType
			clientUser {
				id
				plannerOrgHasConnectionPermissions
				plannerOrgCanSignContracts
				plannerOrgCanPayInvoices
				plannerOrgHasDocumentsPermissions
				firstNameTwo
				lastNameTwo
				weddingDate
				venue
				...clientPermissionsTooltipClientUser
			}
		}
		...clientDetailAssignedToContact
	}
	${ClientPermissionsTooltipClientUserFragmentDoc}
	${ClientDetailAssignedToContactFragmentDoc}
`;
export const ClientDetailHeaderContactFragmentDoc = gql`
	fragment clientDetailHeaderContact on Contact {
		id
		hasCustomerIntent
		customer {
			id
			email
			userType
			orgUser {
				...clientDetailHeaderTargetOrgUser
			}
			clientUser {
				id
				plannerOrgHasConnectionPermissions
				plannerOrgCanSignContracts
				plannerOrgCanPayInvoices
				plannerOrgHasDocumentsPermissions
				firstNameOne
				lastNameOne
				firstNameTwo
				lastNameTwo
				updatedAt
			}
			guestUser {
				id
			}
		}
		...clientContactInfoClient
		...useClientDetailOverviewContact
	}
	${ClientDetailHeaderTargetOrgUserFragmentDoc}
	${ClientContactInfoClientFragmentDoc}
	${UseClientDetailOverviewContactFragmentDoc}
`;
export const ActivityTabContactFragmentDoc = gql`
	fragment activityTabContact on Contact {
		id
		customer {
			id
		}
		vendor {
			id
			users(orderBy: { firstName: desc }) {
				id
				role
			}
		}
		assignedMember {
			id
		}
	}
`;
export const NotesTabContactFragmentDoc = gql`
	fragment notesTabContact on Contact {
		id
		note
	}
`;
export const ClientDetailTabsContactFragmentDoc = gql`
	fragment clientDetailTabsContact on Contact {
		id
		hasCustomerIntent
		customer {
			id
			userType
			clientUser {
				id
				user {
					id
				}
				assignedPlanner {
					id
					organization {
						id
					}
					user {
						id
					}
				}
				plannerOrgHasDocumentsPermissions
			}
			orgUser {
				id
				user {
					id
				}
				organization {
					id
				}
			}
		}
		vendor {
			id
			users(orderBy: { firstName: desc }) {
				id
				role
			}
		}
		assignedMember {
			id
		}
		...activityTabContact
		...notesTabContact
	}
	${ActivityTabContactFragmentDoc}
	${NotesTabContactFragmentDoc}
`;
export const UseClientDetailContactFragmentDoc = gql`
	fragment useClientDetailContact on Contact {
		id
		status
		firstName
		lastName
		phone
		eventDate
		companyName
		customer {
			id
			userType
			email
			orgUser {
				...useClientDetailTargetOrgUser
			}
			clientUser {
				id
				firstNameOne
				lastNameOne
				phone
				weddingDate
				assignedPlanner {
					id
					organization {
						id
					}
				}
				plannerOrgCanPayInvoices
				plannerOrgCanSignContracts
				plannerOrgHasConnectionPermissions
				plannerOrgHasDocumentsPermissions
			}
			guestUser {
				id
				user {
					id
					email
				}
			}
		}
		assignedMember {
			id
		}
		vendor {
			id
			users(orderBy: { firstName: desc }) {
				...useClientDetailMembers
			}
		}
		...clientDetailHeaderContact
		...clientDetailTabsContact
	}
	${UseClientDetailTargetOrgUserFragmentDoc}
	${UseClientDetailMembersFragmentDoc}
	${ClientDetailHeaderContactFragmentDoc}
	${ClientDetailTabsContactFragmentDoc}
`;
export const ClientOnboardingFinishUpClientUserFragmentDoc = gql`
	fragment clientOnboardingFinishUpClientUser on ClientUser {
		id
		venue
		weddingDate
		phone
	}
`;
export const ClientOnboardingYourInfoAddressClientUserFragmentDoc = gql`
	fragment clientOnboardingYourInfoAddressClientUser on ClientUser {
		addressLine1
		addressLine2
		city
		postalCode
		state
		country
	}
`;
export const ClientOnboardingYourInfoClientUserFragmentDoc = gql`
	fragment clientOnboardingYourInfoClientUser on ClientUser {
		id
		firstNameOne
		lastNameOne
		firstNameTwo
		lastNameTwo
		...clientOnboardingYourInfoAddressClientUser
		user {
			id
			email
			userType
			acceptedTerms
			consentedToAgeAndMarketingEmails
		}
	}
	${ClientOnboardingYourInfoAddressClientUserFragmentDoc}
`;
export const ClientsTable_AssignedToContactFragmentDoc = gql`
	fragment clientsTable_assignedToContact on Contact {
		id
		assignedMember {
			id
			firstName
			lastName
		}
		vendor {
			id
		}
	}
`;
export const ClientsTable_NameContactFragmentDoc = gql`
	fragment clientsTable_nameContact on Contact {
		id
		status
		firstName
		lastName
		hasCustomerIntent
		customer {
			id
			updatedAt
			email
			clientUser {
				id
				updatedAt
				weddingDate
				assignedPlanner {
					id
					organization {
						id
					}
				}
				...clientPermissionsTooltipClientUser
			}
			orgUser {
				id
				updatedAt
			}
		}
	}
	${ClientPermissionsTooltipClientUserFragmentDoc}
`;
export const ClientsTableUpdateContactStatusLinkFragmentDoc = gql`
	fragment clientsTableUpdateContactStatusLink on Contact {
		id
		status
		customer {
			id
		}
	}
`;
export const ClientsTableSubMenuContactFragmentDoc = gql`
	fragment clientsTableSubMenuContact on Contact {
		id
		...clientsTableUpdateContactStatusLink
	}
	${ClientsTableUpdateContactStatusLinkFragmentDoc}
`;
export const DeleteContactConfirmationModalContactFragmentDoc = gql`
	fragment deleteContactConfirmationModalContact on Contact {
		id
		firstName
		lastName
		status
		customer {
			id
			email
		}
	}
`;
export const UseClientsTable_ContactFragmentDoc = gql`
	fragment useClientsTable_contact on Contact {
		id
		createdAt
		eventDate
		firstName
		lastName
		status
		hasCustomerIntent
		companyName
		customer {
			id
			email
			orgUser {
				id
				firstName
			}
			clientUser {
				id
				weddingDate
			}
		}
		vendor {
			id
			users {
				id
				role
			}
		}
		...clientsTable_assignedToContact
		...clientsTable_nameContact
		...clientsTableSubMenuContact
		...deleteContactConfirmationModalContact
		...sendDocumentsModalContact
	}
	${ClientsTable_AssignedToContactFragmentDoc}
	${ClientsTable_NameContactFragmentDoc}
	${ClientsTableSubMenuContactFragmentDoc}
	${DeleteContactConfirmationModalContactFragmentDoc}
	${SendDocumentsModalContactFragmentDoc}
`;
export const ClientsTable_AssignedToMemberFragmentDoc = gql`
	fragment clientsTable_assignedToMember on OrgUser {
		id
		firstName
		lastName
		user {
			id
			onboardingCompleted
		}
	}
`;
export const UseClientsTable_MemberFragmentDoc = gql`
	fragment useClientsTable_member on OrgUser {
		id
		firstName
		lastName
		role
		...clientsTable_assignedToMember
	}
	${ClientsTable_AssignedToMemberFragmentDoc}
`;
export const UseCompanyFoldersTable_CustomFolderFragmentDoc = gql`
	fragment useCompanyFoldersTable_customFolder on CustomFolder {
		id
		name
		createdAt
		parentFolder {
			id
			name
		}
	}
`;
export const UseCompanyFoldersTable_CustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment useCompanyFoldersTable_CustomDocumentWithDownloadUrl on Document {
		id
		type
		fileType
		name
		createdAt
		updatedAt
		ownerType
		orgUser {
			id
		}
		organization {
			id
			name
			updatedAt
			image
		}
		customer {
			id
			email
			clientUser {
				id
				firstNameOne
				lastNameOne
				updatedAt
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
			orgUser {
				id
				firstName
				lastName
				organization {
					id
				}
			}
		}
		sharedWithContacts {
			id
			vendor {
				id
				updatedAt
				image
			}
		}
		sharedWithCustomer
		parentFolder {
			id
			name
		}
	}
`;
export const ContactSnippetContactFragmentDoc = gql`
	fragment contactSnippetContact on Contact {
		id
		status
		eventDate
		customer {
			id
			email
			userType
			clientUser {
				id
				weddingDate
			}
		}
		vendor {
			id
		}
	}
`;
export const ContactSnippetInviteUserFragmentDoc = gql`
	fragment contactSnippetInviteUser on InviteUser {
		... on InviteUserClientUser {
			__typename
			id
			firstNameOne
			firstNameTwo
			lastNameOne
			lastNameTwo
			weddingDate
			phone
			user {
				id
				email
				userType
			}
		}
		... on InviteUserOrgUser {
			__typename
			id
			firstName
			lastName
			phone
			user {
				id
				email
				userType
			}
			organization {
				id
				name
				image
				updatedAt
				services {
					id
					name
				}
			}
		}
	}
`;
export const ContractViewContactForGetContractWhereFragmentDoc = gql`
	fragment contractViewContactForGetContractWhere on ContactForGetContractWhere {
		id
		customer {
			id
			email
			userType
			stripeCustomerId
			clientUser {
				id
				assignedPlanner {
					id
					organization {
						id
						users {
							id
							role
						}
					}
				}
			}
			guestUser {
				id
			}
		}
		vendor {
			id
			users {
				id
				role
			}
		}
	}
`;
export const PermissionsModalOrganizationForGetContractWhereFragmentDoc = gql`
	fragment permissionsModalOrganizationForGetContractWhere on OrganizationForGetContractWhere {
		id
		image
		name
		services {
			name
			id
		}
	}
`;
export const EmbeddedFileContractFragmentDoc = gql`
	fragment embeddedFileContract on ContractForGetContractWhere {
		id
		contractSourceFile
		unsignedContractFileUrl
		executedContractUrl
		contractTemplate {
			sourceFileUrl
		}
	}
`;
export const ContractViewSourceFileContractFragmentDoc = gql`
	fragment contractViewSourceFileContract on ContractForGetContractWhere {
		status
		contractSourceFile
		unsignedContractFileUrl
		executedContractUrl
		...embeddedFileContract
	}
	${EmbeddedFileContractFragmentDoc}
`;
export const ContractViewButtonBarExportButtonContractFragmentDoc = gql`
	fragment contractViewButtonBarExportButtonContract on ContractForGetContractWhere {
		id
		dueDate
		signatures {
			signingDate
		}
		contractSourceFile
		unsignedContractFileUrl
		executedContractUrl
		contractTemplate {
			id
			sourceFileUrl
		}
		vendor {
			id
			users {
				id
				role
				user {
					id
				}
			}
		}
	}
`;
export const PayInvoicesModalRowInvoiceForGetContractWhereFragmentDoc = gql`
	fragment payInvoicesModalRowInvoiceForGetContractWhere on InvoiceForGetContractWhere {
		id
		title
		guestToken
		paymentInstallments {
			id
			dueDate
			amountDue
			status
			paymentDate
		}
	}
`;
export const PayInvoicesModalInvoiceForGetContractWhereFragmentDoc = gql`
	fragment payInvoicesModalInvoiceForGetContractWhere on InvoiceForGetContractWhere {
		id
		status
		paymentInstallments {
			id
			status
		}
		...payInvoicesModalRowInvoiceForGetContractWhere
	}
	${PayInvoicesModalRowInvoiceForGetContractWhereFragmentDoc}
`;
export const DocumentFollowupActionsInvoiceForGetContractWhereFragmentDoc = gql`
	fragment documentFollowupActionsInvoiceForGetContractWhere on InvoiceForGetContractWhere {
		id
		status
		...payInvoicesModalInvoiceForGetContractWhere
	}
	${PayInvoicesModalInvoiceForGetContractWhereFragmentDoc}
`;
export const AcceptProposalModalRowProposalFragmentDoc = gql`
	fragment acceptProposalModalRowProposal on Proposal {
		id
		title
		guestToken
		dueDate
	}
`;
export const AcceptProposalsModalProposalFragmentDoc = gql`
	fragment acceptProposalsModalProposal on Proposal {
		id
		status
		...acceptProposalModalRowProposal
	}
	${AcceptProposalModalRowProposalFragmentDoc}
`;
export const AcceptProposalsModalContactForGetContractWhereFragmentDoc = gql`
	fragment acceptProposalsModalContactForGetContractWhere on ContactForGetContractWhere {
		id
		customer {
			id
		}
		proposals {
			...acceptProposalsModalProposal
		}
	}
	${AcceptProposalsModalProposalFragmentDoc}
`;
export const SignContractsModalRowContractFragmentDoc = gql`
	fragment signContractsModalRowContract on SignatureContract {
		id
		title
		guestToken
	}
`;
export const SignContractsModalContractFragmentDoc = gql`
	fragment signContractsModalContract on SignatureContract {
		id
		status
		...signContractsModalRowContract
	}
	${SignContractsModalRowContractFragmentDoc}
`;
export const SignContractsModalContactForGetContractWhereFragmentDoc = gql`
	fragment signContractsModalContactForGetContractWhere on ContactForGetContractWhere {
		id
		customerSignatures {
			id
			signature {
				id
				signingDate
				contract {
					...signContractsModalContract
				}
			}
		}
		vendor {
			id
			name
		}
	}
	${SignContractsModalContractFragmentDoc}
`;
export const DocumentFollowupActionsContactForGetContractWhereFragmentDoc = gql`
	fragment documentFollowupActionsContactForGetContractWhere on ContactForGetContractWhere {
		id
		customerSignatures {
			id
			signature {
				id
				signingDate
				signer {
					id
				}
				contract {
					id
					status
					dueDate
				}
			}
		}
		invoices {
			...documentFollowupActionsInvoiceForGetContractWhere
		}
		customer {
			id
			clientUser {
				id
				plannerOrgCanPayInvoices
				plannerOrgCanSignContracts
				assignedPlanner {
					id
					organization {
						id
						users {
							id
							role
							user {
								id
							}
						}
					}
				}
			}
		}
		vendor {
			...permissionsModalOrganizationForGetContractWhere
		}
		...acceptProposalsModalContactForGetContractWhere
		...signContractsModalContactForGetContractWhere
	}
	${DocumentFollowupActionsInvoiceForGetContractWhereFragmentDoc}
	${PermissionsModalOrganizationForGetContractWhereFragmentDoc}
	${AcceptProposalsModalContactForGetContractWhereFragmentDoc}
	${SignContractsModalContactForGetContractWhereFragmentDoc}
`;
export const AssignedPlannerSignsAsModalSignatureSignatureFragmentDoc = gql`
	fragment assignedPlannerSignsAsModalSignatureSignature on SignatureForGetContractWhere {
		id
		signer {
			id
		}
		signingDate
		customerSignature {
			id
			contact {
				id
				firstName
				lastName
				customer {
					id
					email
					clientUser {
						id
						plannerOrgCanSignContracts
						assignedPlanner {
							id
							organization {
								id
							}
						}
					}
				}
			}
		}
	}
`;
export const AssignedPlannerSignsAsModalSignaturesSignatureFragmentDoc = gql`
	fragment assignedPlannerSignsAsModalSignaturesSignature on SignatureForGetContractWhere {
		id
		...assignedPlannerSignsAsModalSignatureSignature
	}
	${AssignedPlannerSignsAsModalSignatureSignatureFragmentDoc}
`;
export const AssignedPlannerSignsAsModalSignatureFragmentDoc = gql`
	fragment assignedPlannerSignsAsModalSignature on SignatureForGetContractWhere {
		id
		...assignedPlannerSignsAsModalSignaturesSignature
	}
	${AssignedPlannerSignsAsModalSignaturesSignatureFragmentDoc}
`;
export const ContractViewButtonBarViewAndSignButtonContractCanSignFragmentDoc = gql`
	fragment contractViewButtonBarViewAndSignButtonContractCanSign on ContractForGetContractWhere {
		id
		status
		signatures {
			id
			type
			signingDate
			signer {
				id
			}
			customerSignature {
				id
				contact {
					id
					customer {
						id
						email
						clientUser {
							id
							plannerOrgCanSignContracts
							assignedPlanner {
								id
								organization {
									id
									users {
										id
										role
										user {
											id
										}
									}
								}
							}
						}
					}
					vendor {
						id
						users {
							id
							role
						}
					}
					assignedMember {
						id
					}
				}
			}
		}
		vendor {
			id
			helloSignID
		}
	}
`;
export const ContractMfaGuestModalContractFragmentDoc = gql`
	fragment contractMfaGuestModalContract on ContractForGetContractWhere {
		id
		signatures {
			id
			type
			signingDate
			customerSignature {
				id
				contact {
					id
					firstName
					lastName
					companyName
					customer {
						id
						email
					}
				}
			}
		}
	}
`;
export const ContractViewButtonBarViewAndSignButtonContractFragmentDoc = gql`
	fragment contractViewButtonBarViewAndSignButtonContract on ContractForGetContractWhere {
		id
		status
		dueDate
		signatures {
			id
			signingDate
			signer {
				id
			}
			customerSignature {
				id
				contact {
					id
					customer {
						id
						clientUser {
							id
							assignedPlanner {
								id
								user {
									id
								}
								organization {
									id
								}
							}
						}
					}
					invoices {
						id
						status
					}
					vendor {
						id
						users {
							id
							role
						}
					}
					assignedMember {
						id
					}
					...documentFollowupActionsContactForGetContractWhere
				}
			}
			...assignedPlannerSignsAsModalSignature
		}
		vendor {
			id
			helloSignID
		}
		...contractViewButtonBarViewAndSignButtonContractCanSign
		...contractMfaGuestModalContract
	}
	${DocumentFollowupActionsContactForGetContractWhereFragmentDoc}
	${AssignedPlannerSignsAsModalSignatureFragmentDoc}
	${ContractViewButtonBarViewAndSignButtonContractCanSignFragmentDoc}
	${ContractMfaGuestModalContractFragmentDoc}
`;
export const ContractViewButtonBarApproveButtonContractHelperFragmentDoc = gql`
	fragment contractViewButtonBarApproveButtonContractHelper on ContractForGetContractWhere {
		id
		status
		signatures {
			id
			signingDate
			signer {
				id
			}
			customerSignature {
				id
				approved
				contact {
					id
					customer {
						id
						clientUser {
							id
							assignedPlanner {
								id
								organization {
									id
									users {
										id
										role
										user {
											id
										}
										organization {
											id
										}
									}
								}
							}
						}
					}
					assignedMember {
						id
					}
					vendor {
						id
						users {
							id
							role
						}
					}
				}
			}
		}
		vendor {
			id
		}
	}
`;
export const ContractViewButtonBarApproveButtonContractFragmentDoc = gql`
	fragment contractViewButtonBarApproveButtonContract on ContractForGetContractWhere {
		id
		...contractViewButtonBarApproveButtonContractHelper
	}
	${ContractViewButtonBarApproveButtonContractHelperFragmentDoc}
`;
export const ButtonBarResendContractButtonContractFragmentDoc = gql`
	fragment buttonBarResendContractButtonContract on ContractForGetContractWhere {
		id
		status
		automatedRemindersEnabled
		dueDate
		sentByUser {
			id
			organization {
				id
			}
		}
		signatures {
			id
			type
			signingDate
			customerSignature {
				id
				contact {
					id
					firstName
					lastName
					companyName
					customer {
						id
						email
					}
					vendor {
						id
						users {
							id
							role
						}
					}
					assignedMember {
						id
						user {
							id
						}
					}
				}
			}
		}
	}
`;
export const UseButtonBarVoidContractButtonContractFragmentDoc = gql`
	fragment useButtonBarVoidContractButtonContract on ContractForGetContractWhere {
		id
		status
		vendor {
			id
			users {
				id
				role
				user {
					id
				}
			}
		}
	}
`;
export const ContractViewButtonBarContractFragmentDoc = gql`
	fragment contractViewButtonBarContract on ContractForGetContractWhere {
		id
		status
		signatures {
			id
			signingDate
			signer {
				id
			}
		}
		...contractViewButtonBarExportButtonContract
		...contractViewButtonBarViewAndSignButtonContract
		...contractViewButtonBarApproveButtonContract
		...buttonBarResendContractButtonContract
		...useButtonBarVoidContractButtonContract
	}
	${ContractViewButtonBarExportButtonContractFragmentDoc}
	${ContractViewButtonBarViewAndSignButtonContractFragmentDoc}
	${ContractViewButtonBarApproveButtonContractFragmentDoc}
	${ButtonBarResendContractButtonContractFragmentDoc}
	${UseButtonBarVoidContractButtonContractFragmentDoc}
`;
export const OrganizationAvatarOrganizationForGetContractWhereFragmentDoc = gql`
	fragment organizationAvatarOrganizationForGetContractWhere on OrganizationForGetContractWhere {
		id
		image
		name
		updatedAt
	}
`;
export const DocumentViewEmailNotificationGroupContractForGetContractWhereFragmentDoc = gql`
	fragment documentViewEmailNotificationGroupContractForGetContractWhere on ContractForGetContractWhere {
		id
		emailNotificationGroup {
			id
			groupTitle
			members {
				id
				email
				userType
				orgUser {
					id
					firstName
					lastName
					organization {
						id
					}
				}
			}
		}
	}
`;
export const ContractViewPresentationContractFragmentDoc = gql`
	fragment contractViewPresentationContract on ContractForGetContractWhere {
		id
		title
		status
		sentAt
		eventDate
		dueDate
		isPastDue
		signatures {
			id
			signingDate
			signer {
				id
			}
			customerSignature {
				id
				contact {
					id
					firstName
					lastName
					companyName
					customer {
						id
						email
						clientUser {
							id
							plannerOrgCanSignContracts
							plannerOrgCanPayInvoices
							assignedPlanner {
								id
								user {
									id
								}
								organization {
									id
									users {
										id
										role
										user {
											id
										}
										organization {
											id
											users {
												id
												role
												user {
													id
												}
											}
										}
									}
								}
							}
						}
					}
					assignedMember {
						id
						user {
							id
						}
					}
					vendor {
						id
						users {
							id
							role
							user {
								id
							}
						}
					}
				}
			}
		}
		vendor {
			...organizationAvatarOrganizationForGetContractWhere
			users {
				id
				role
				user {
					id
				}
			}
		}
		...documentViewEmailNotificationGroupContractForGetContractWhere
	}
	${OrganizationAvatarOrganizationForGetContractWhereFragmentDoc}
	${DocumentViewEmailNotificationGroupContractForGetContractWhereFragmentDoc}
`;
export const ContractViewSignersAndCounterSignersFragmentDoc = gql`
	fragment contractViewSignersAndCounterSigners on ContractForGetContractWhere {
		id
		signatures {
			id
			type
			signingDate
			signer {
				email
				id
				orgUser {
					firstName
					lastName
					id
				}
			}
			customerSignature {
				id
				contact {
					id
					firstName
					lastName
					companyName
					customer {
						id
						email
					}
					assignedMember {
						id
						user {
							id
						}
					}
				}
			}
		}
		vendor {
			id
			users {
				id
				role
				user {
					id
				}
			}
		}
	}
`;
export const UseContractContactsCompareForDiffContractViewContractForGetContractWhereFragmentDoc = gql`
	fragment useContractContactsCompareForDiffContractViewContractForGetContractWhere on ContractForGetContractWhere {
		id
		signatures {
			id
			type
			customerSignature {
				contact {
					id
					firstName
					lastName
					companyName
					customer {
						id
						email
					}
				}
			}
		}
	}
`;
export const ContractViewContractForGetContractWhereFragmentDoc = gql`
	fragment contractViewContractForGetContractWhere on ContractForGetContractWhere {
		id
		signatures {
			id
			type
			signer {
				id
			}
			customerSignature {
				id
				contact {
					...contractViewContactForGetContractWhere
				}
			}
		}
		vendor {
			id
			users {
				id
				role
			}
			...permissionsModalOrganizationForGetContractWhere
		}
		...contractViewSourceFileContract
		...contractViewButtonBarContract
		...contractViewPresentationContract
		...contractViewSignersAndCounterSigners
		...useContractContactsCompareForDiffContractViewContractForGetContractWhere
	}
	${ContractViewContactForGetContractWhereFragmentDoc}
	${PermissionsModalOrganizationForGetContractWhereFragmentDoc}
	${ContractViewSourceFileContractFragmentDoc}
	${ContractViewButtonBarContractFragmentDoc}
	${ContractViewPresentationContractFragmentDoc}
	${ContractViewSignersAndCounterSignersFragmentDoc}
	${UseContractContactsCompareForDiffContractViewContractForGetContractWhereFragmentDoc}
`;
export const ContractEditDatesContractFragmentDoc = gql`
	fragment contractEditDatesContract on ContractForGetContractWhere {
		id
		status
		eventDate
		dueDate
	}
`;
export const ContractEditSignaturesFieldsFragmentDoc = gql`
	fragment contractEditSignaturesFields on ContractForGetContractWhere {
		id
		status
		contractTemplate {
			id
			countOfCustomerSigners
			vendorWillSign
		}
		signatures {
			id
			type
			signingDate
			customerSignature {
				id
				contact {
					id
					status
					firstName
					lastName
					hasCustomerIntent
					companyName
					customer {
						id
						email
					}
				}
			}
		}
	}
`;
export const CounterSignerWidgetContractFragmentDoc = gql`
	fragment counterSignerWidgetContract on ContractForGetContractWhere {
		id
		status
		signatures {
			id
			type
			signingDate
			signer {
				id
			}
		}
	}
`;
export const ContractEditPresentationContractFragmentDoc = gql`
	fragment contractEditPresentationContract on ContractForGetContractWhere {
		id
		title
		contractTemplate {
			id
			vendorWillSign
		}
		vendor {
			...organizationAvatarOrganizationForGetContractWhere
		}
		...contractEditDatesContract
		...contractEditSignaturesFields
		...counterSignerWidgetContract
	}
	${OrganizationAvatarOrganizationForGetContractWhereFragmentDoc}
	${ContractEditDatesContractFragmentDoc}
	${ContractEditSignaturesFieldsFragmentDoc}
	${CounterSignerWidgetContractFragmentDoc}
`;
export const ContractEditSourceFileContractFragmentDoc = gql`
	fragment contractEditSourceFileContract on ContractForGetContractWhere {
		...embeddedFileContract
	}
	${EmbeddedFileContractFragmentDoc}
`;
export const UseContractEditButtonBarSaveButtonContractFragmentDoc = gql`
	fragment useContractEditButtonBarSaveButtonContract on ContractForGetContractWhere {
		id
		status
		isPastDue
		contractSourceFile
		signatures {
			id
			type
			signingDate
			customerSignature {
				id
				contact {
					id
					firstName
					lastName
					companyName
					customer {
						id
						email
					}
					vendor {
						id
						users {
							id
							role
						}
					}
					assignedMember {
						id
					}
				}
			}
		}
	}
`;
export const UseContractEditButtonBarPrepareButtonContractFragmentDoc = gql`
	fragment useContractEditButtonBarPrepareButtonContract on ContractForGetContractWhere {
		id
	}
`;
export const ContractEditButtonBarContractFragmentDoc = gql`
	fragment contractEditButtonBarContract on ContractForGetContractWhere {
		id
		status
		...buttonBarResendContractButtonContract
		...useContractEditButtonBarSaveButtonContract
		...useButtonBarVoidContractButtonContract
		...useContractEditButtonBarPrepareButtonContract
	}
	${ButtonBarResendContractButtonContractFragmentDoc}
	${UseContractEditButtonBarSaveButtonContractFragmentDoc}
	${UseButtonBarVoidContractButtonContractFragmentDoc}
	${UseContractEditButtonBarPrepareButtonContractFragmentDoc}
`;
export const ContractEditSettingsContractForGetContractWhereFragmentDoc = gql`
	fragment contractEditSettingsContractForGetContractWhere on ContractForGetContractWhere {
		id
		status
	}
`;
export const ContractEditContractForGetContractWhereFragmentDoc = gql`
	fragment contractEditContractForGetContractWhere on ContractForGetContractWhere {
		id
		title
		filename
		status
		automatedRemindersEnabled
		contractTemplate {
			id
			vendorWillSign
			title
		}
		signatures {
			id
			signer {
				id
			}
		}
		hsSignatureRequestId
		...contractEditPresentationContract
		...contractEditSourceFileContract
		...contractEditButtonBarContract
		...contractEditSettingsContractForGetContractWhere
	}
	${ContractEditPresentationContractFragmentDoc}
	${ContractEditSourceFileContractFragmentDoc}
	${ContractEditButtonBarContractFragmentDoc}
	${ContractEditSettingsContractForGetContractWhereFragmentDoc}
`;
export const UseNotificationGroupOrganizationForGetContractWhereFragmentDoc = gql`
	fragment useNotificationGroupOrganizationForGetContractWhere on OrganizationForGetContractWhere {
		id
		users {
			id
			firstName
			lastName
			role
			organization {
				id
			}
			user {
				id
				email
				userType
			}
		}
	}
`;
export const UseNotificationGroupEmailNotificationGroupFragmentDoc = gql`
	fragment useNotificationGroupEmailNotificationGroup on EmailNotificationGroup {
		id
		members {
			id
			email
			userType
			orgUser {
				id
				firstName
				lastName
				role
				organization {
					id
				}
			}
		}
	}
`;
export const ContractDetailContractFragmentDoc = gql`
	fragment contractDetailContract on ContractForGetContractWhere {
		...contractViewContractForGetContractWhere
		...contractEditContractForGetContractWhere
		vendor {
			...useNotificationGroupOrganizationForGetContractWhere
		}
		emailNotificationGroup {
			...useNotificationGroupEmailNotificationGroup
		}
	}
	${ContractViewContractForGetContractWhereFragmentDoc}
	${ContractEditContractForGetContractWhereFragmentDoc}
	${UseNotificationGroupOrganizationForGetContractWhereFragmentDoc}
	${UseNotificationGroupEmailNotificationGroupFragmentDoc}
`;
export const ContractEditFileOrTemplateSelectorDisplayTextButtonContractFragmentDoc = gql`
	fragment contractEditFileOrTemplateSelectorDisplayTextButtonContract on ContractForGetContractWhere {
		status
	}
`;
export const ContractEditFileOrTemplateSelectorTemplateButtonContactTemplateFragmentDoc = gql`
	fragment contractEditFileOrTemplateSelectorTemplateButtonContactTemplate on ContractTemplate {
		id
		title
		countOfCustomerSigners
		vendorWillSign
	}
`;
export const ContractEditFileOrTemplateSelectorContractFragmentDoc = gql`
	fragment contractEditFileOrTemplateSelectorContract on ContractForGetContractWhere {
		id
		status
	}
`;
export const ContractEditPresentationContractTemplateFragmentDoc = gql`
	fragment contractEditPresentationContractTemplate on ContractTemplate {
		id
		countOfCustomerSigners
		vendorWillSign
	}
`;
export const BuildMuiFriendlyOptionsOrganizationFragmentDoc = gql`
	fragment buildMuiFriendlyOptionsOrganization on Organization {
		id
		users {
			id
			role
			firstName
			lastName
			user {
				id
				email
			}
		}
	}
`;
export const ContractTemplateCountersignerFragmentDoc = gql`
	fragment contractTemplateCountersigner on ContractTemplate {
		vendorWillSign
	}
`;
export const ContractTemplateEditPresentationContractTemplateFragmentDoc = gql`
	fragment contractTemplateEditPresentationContractTemplate on ContractTemplate {
		status
		...contractTemplateCountersigner
	}
	${ContractTemplateCountersignerFragmentDoc}
`;
export const UseContractTemplateEditContractTemplateFragmentDoc = gql`
	fragment useContractTemplateEditContractTemplate on ContractTemplate {
		id
		title
		countOfCustomerSigners
		vendorWillSign
		status
		sourceFileUrl
	}
`;
export const UseContractTemplateEditButtonBarDeleteButtonContractTemplateFragmentDoc = gql`
	fragment useContractTemplateEditButtonBarDeleteButtonContractTemplate on ContractTemplate {
		id
		status
	}
`;
export const ContractTemplateEditButtonBarFragmentDoc = gql`
	fragment contractTemplateEditButtonBar on ContractTemplate {
		id
		status
		...useContractTemplateEditButtonBarDeleteButtonContractTemplate
	}
	${UseContractTemplateEditButtonBarDeleteButtonContractTemplateFragmentDoc}
`;
export const ContractTemplateEditFragmentDoc = gql`
	fragment contractTemplateEdit on ContractTemplate {
		id
		...useContractTemplateEditContractTemplate
		...contractTemplateEditButtonBar
	}
	${UseContractTemplateEditContractTemplateFragmentDoc}
	${ContractTemplateEditButtonBarFragmentDoc}
`;
export const ContractViewButtonBarApproveButtonCustomContractHelperFragmentDoc = gql`
	fragment contractViewButtonBarApproveButtonCustomContractHelper on CustomContract {
		id
		status
		signatures {
			id
			signingDate
			signer {
				id
			}
			customerSignature {
				id
				approved
				contact {
					id
					customer {
						id
						clientUser {
							id
							assignedPlanner {
								id
								organization {
									id
									users {
										id
										role
										user {
											id
										}
										organization {
											id
										}
									}
								}
							}
						}
					}
					assignedMember {
						id
					}
					vendor {
						id
						users {
							id
							role
						}
					}
				}
			}
		}
		vendor {
			id
		}
	}
`;
export const ContractViewButtonBarViewAndSignButtonCustomContractCanSignFragmentDoc = gql`
	fragment contractViewButtonBarViewAndSignButtonCustomContractCanSign on CustomContract {
		id
		status
		signatures {
			id
			type
			signingDate
			signer {
				id
			}
			customerSignature {
				id
				contact {
					id
					customer {
						id
						email
						clientUser {
							id
							plannerOrgCanSignContracts
							assignedPlanner {
								id
								organization {
									id
									users {
										id
										role
										user {
											id
										}
									}
								}
							}
						}
					}
					vendor {
						id
						users {
							id
							role
						}
					}
					assignedMember {
						id
					}
				}
			}
		}
		vendor {
			id
		}
	}
`;
export const ContractViewButtonBarViewAndSignButtonContractGetSignaturesForAssignedPlannerFragmentDoc = gql`
	fragment contractViewButtonBarViewAndSignButtonContractGetSignaturesForAssignedPlanner on ContractForGetContractWhere {
		signatures {
			id
			signer {
				id
			}
			signingDate
			customerSignature {
				id
				contact {
					id
					firstName
					lastName
					customer {
						id
						email
						clientUser {
							id
							plannerOrgCanSignContracts
							assignedPlanner {
								id
								organization {
									id
								}
							}
						}
					}
				}
			}
		}
	}
`;
export const ContractViewButtonBarViewAndSignButtonRequestingUserBaseIdFragmentDoc = gql`
	fragment contractViewButtonBarViewAndSignButtonRequestingUserBaseId on ResponseObjectForGetContractWhere {
		requestingUserBaseId
		requestingUserIsGuest
	}
`;
export const ContractViewButtonBarExportButtonRequestingUserBaseIdFragmentDoc = gql`
	fragment contractViewButtonBarExportButtonRequestingUserBaseId on ResponseObjectForGetContractWhere {
		requestingUserBaseId
	}
`;
export const ContractViewButtonBarBaseUserIdFragmentDoc = gql`
	fragment contractViewButtonBarBaseUserId on ResponseObjectForGetContractWhere {
		requestingUserBaseId
		...contractViewButtonBarViewAndSignButtonRequestingUserBaseId
		...contractViewButtonBarExportButtonRequestingUserBaseId
	}
	${ContractViewButtonBarViewAndSignButtonRequestingUserBaseIdFragmentDoc}
	${ContractViewButtonBarExportButtonRequestingUserBaseIdFragmentDoc}
`;
export const ContractViewSignersAndCounterBaseUserFragmentDoc = gql`
	fragment contractViewSignersAndCounterBaseUser on ResponseObjectForGetContractWhere {
		requestingUserBaseId
	}
`;
export const ContractViewBaseUserIdFragmentDoc = gql`
	fragment contractViewBaseUserId on ResponseObjectForGetContractWhere {
		...contractViewButtonBarBaseUserId
		...contractViewSignersAndCounterBaseUser
	}
	${ContractViewButtonBarBaseUserIdFragmentDoc}
	${ContractViewSignersAndCounterBaseUserFragmentDoc}
`;
export const OrganizationAvatarOrganizationFragmentDoc = gql`
	fragment organizationAvatarOrganization on Organization {
		id
		image
		name
		updatedAt
	}
`;
export const ContractViewPresentationOrganizationFragmentDoc = gql`
	fragment contractViewPresentationOrganization on Organization {
		...organizationAvatarOrganization
	}
	${OrganizationAvatarOrganizationFragmentDoc}
`;
export const ContractViewOrganizationFragmentDoc = gql`
	fragment contractViewOrganization on Organization {
		...contractViewPresentationOrganization
	}
	${ContractViewPresentationOrganizationFragmentDoc}
`;
export const ContractSubMenuFragmentDoc = gql`
	fragment contractSubMenu on CustomContract {
		id
		status
		automatedRemindersEnabled
		vendor {
			id
		}
		signatures {
			id
			signingDate
			type
			signer {
				id
			}
			customerSignature {
				id
				contact {
					id
					assignedMember {
						id
						organization {
							id
						}
					}
					vendor {
						id
						users {
							id
							role
						}
					}
					customer {
						id
						clientUser {
							id
							plannerOrgCanSignContracts
							assignedPlanner {
								id
							}
						}
					}
				}
			}
		}
	}
`;
export const ContractsTableFragmentDoc = gql`
	fragment contractsTable on CustomContract {
		id
		title
		createdAt
		updatedAt
		sentAt
		dueDate
		status
		isPastDue
		eventDate
		signatures {
			id
			customerSignature {
				id
				contact {
					id
					firstName
					lastName
					companyName
					customer {
						id
						email
					}
				}
			}
		}
		sentByUser {
			id
			firstName
			lastName
			updatedAt
			organization {
				id
				name
			}
			user {
				id
			}
		}
		vendor {
			id
			name
			image
			updatedAt
		}
		...contractSubMenu
	}
	${ContractSubMenuFragmentDoc}
`;
export const ContractTemplatesTableFragmentDoc = gql`
	fragment contractTemplatesTable on ContractTemplate {
		id
		createdAt
		title
		status
		sourceFileUrl
		contracts {
			id
		}
	}
`;
export const CreateBundleModalContactContactOnlyContactFragmentDoc = gql`
	fragment createBundleModalContactContactOnlyContact on Contact {
		id
		venue
		phone
	}
`;
export const CreateBundleModalContactFragmentDoc = gql`
	fragment createBundleModalContact on Contact {
		id
		firstName
		lastName
		eventDate
		note
		companyName
		source
		customer {
			id
			email
		}
		...createBundleModalContactContactOnlyContact
	}
	${CreateBundleModalContactContactOnlyContactFragmentDoc}
`;
export const UseCustomerFolderDocumentsTableContactFragmentDoc = gql`
	fragment useCustomerFolderDocumentsTableContact on Contact {
		id
		customer {
			id
			clientUser {
				id
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
		}
		vendor {
			id
		}
	}
`;
export const ContactCustomerAvatarContactFragmentDoc = gql`
	fragment contactCustomerAvatarContact on Contact {
		id
		firstName
		lastName
		status
		hasCustomerIntent
		customer {
			id
			email
			clientUser {
				id
				updatedAt
			}
			orgUser {
				id
				updatedAt
			}
		}
	}
`;
export const ShareWidgetContactFragmentDoc = gql`
	fragment shareWidgetContact on Contact {
		id
		firstName
		lastName
		customer {
			id
			email
		}
		vendor {
			id
			image
			updatedAt
			name
		}
		...contactCustomerAvatarContact
	}
	${ContactCustomerAvatarContactFragmentDoc}
`;
export const DocumentsUploadButtonContactFragmentDoc = gql`
	fragment documentsUploadButtonContact on Contact {
		id
	}
`;
export const CustomerFolderDocumentsTableContactFragmentDoc = gql`
	fragment customerFolderDocumentsTableContact on Contact {
		...useCustomerFolderDocumentsTableContact
		...shareWidgetContact
		...documentsUploadButtonContact
	}
	${UseCustomerFolderDocumentsTableContactFragmentDoc}
	${ShareWidgetContactFragmentDoc}
	${DocumentsUploadButtonContactFragmentDoc}
`;
export const ShareWidgetDocumentFragmentDoc = gql`
	fragment shareWidgetDocument on Document {
		id
		type
		ownerType
		sharedWithCustomer
		sharedWithContacts {
			...shareWidgetContact
		}
		customer {
			id
			clientUser {
				id
				updatedAt
				firstNameOne
				lastNameOne
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
			orgUser {
				id
				updatedAt
				firstName
				lastName
			}
		}
		orgUser {
			id
		}
		organization {
			id
		}
	}
	${ShareWidgetContactFragmentDoc}
`;
export const UseCustomerFolderDocumentsTable_DocumentFragmentDoc = gql`
	fragment useCustomerFolderDocumentsTable_document on Document {
		id
		fileType
		fileSource
		name
		updatedAt
		ownerType
		exportable
		organization {
			id
			name
			updatedAt
			image
			services {
				id
			}
		}
		customer {
			id
			email
			clientUser {
				id
				firstNameOne
				lastNameOne
				updatedAt
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
			orgUser {
				id
				firstName
				lastName
				organization {
					id
				}
			}
		}
		sharedWithContacts {
			id
			vendor {
				id
				updatedAt
				image
			}
		}
		sharedWithCustomer
		...shareWidgetDocument
	}
	${ShareWidgetDocumentFragmentDoc}
`;
export const CustomerFoldersTableNameContactFragmentDoc = gql`
	fragment customerFoldersTableNameContact on Contact {
		id
		firstName
		lastName
		status
		customer {
			id
			email
		}
		...contactCustomerAvatarContact
	}
	${ContactCustomerAvatarContactFragmentDoc}
`;
export const CustomerFoldersTableNumberOfFilesContactFragmentDoc = gql`
	fragment customerFoldersTableNumberOfFilesContact on Contact {
		id
		_countOfDocuments
	}
`;
export const CustomerFoldersTableUpdatedAtContactFragmentDoc = gql`
	fragment customerFoldersTableUpdatedAtContact on Contact {
		id
		updatedAt
	}
`;
export const UseCustomerFoldersTableContactFragmentDoc = gql`
	fragment useCustomerFoldersTableContact on Contact {
		id
		...customerFoldersTableNameContact
		...customerFoldersTableNumberOfFilesContact
		...customerFoldersTableUpdatedAtContact
	}
	${CustomerFoldersTableNameContactFragmentDoc}
	${CustomerFoldersTableNumberOfFilesContactFragmentDoc}
	${CustomerFoldersTableUpdatedAtContactFragmentDoc}
`;
export const DocumentDetailPresentationContactFragmentDoc = gql`
	fragment documentDetailPresentationContact on Contact {
		...shareWidgetContact
	}
	${ShareWidgetContactFragmentDoc}
`;
export const UseExportDocumentButtonCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment useExportDocumentButtonCustomDocumentWithDownloadUrl on Document {
		id
		exportable
	}
`;
export const UseDeleteDocumentButtonCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment useDeleteDocumentButtonCustomDocumentWithDownloadUrl on Document {
		id
		type
		ownerType
		customer {
			id
			clientUser {
				id
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
		}
		orgUser {
			id
		}
		organization {
			id
		}
		sharedWithCustomer
	}
`;
export const UseMoveFileModalCompanyFoldersDocumentFragmentDoc = gql`
	fragment useMoveFileModalCompanyFoldersDocument on Document {
		id
		name
		type
		fileType
		parentFolder {
			id
			name
		}
		customer {
			id
		}
	}
`;
export const MoveFileModalCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment moveFileModalCustomDocumentWithDownloadUrl on Document {
		...useMoveFileModalCompanyFoldersDocument
	}
	${UseMoveFileModalCompanyFoldersDocumentFragmentDoc}
`;
export const UseMoveDocumentButtonCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment useMoveDocumentButtonCustomDocumentWithDownloadUrl on Document {
		id
		type
		ownerType
		customer {
			id
			clientUser {
				id
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
		}
		orgUser {
			id
		}
		organization {
			id
		}
		...moveFileModalCustomDocumentWithDownloadUrl
		sharedWithCustomer
	}
	${MoveFileModalCustomDocumentWithDownloadUrlFragmentDoc}
`;
export const DocumentDetailButtonBarCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment documentDetailButtonBarCustomDocumentWithDownloadUrl on Document {
		id
		...useExportDocumentButtonCustomDocumentWithDownloadUrl
		...useDeleteDocumentButtonCustomDocumentWithDownloadUrl
		...useMoveDocumentButtonCustomDocumentWithDownloadUrl
	}
	${UseExportDocumentButtonCustomDocumentWithDownloadUrlFragmentDoc}
	${UseDeleteDocumentButtonCustomDocumentWithDownloadUrlFragmentDoc}
	${UseMoveDocumentButtonCustomDocumentWithDownloadUrlFragmentDoc}
`;
export const EmbeddedFileDocumentFragmentDoc = gql`
	fragment embeddedFileDocument on Document {
		id
		downloadUrl
	}
`;
export const DocumentDetailPresentationCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment documentDetailPresentationCustomDocumentWithDownloadUrl on Document {
		id
		name
		type
		fileType
		createdAt
		ownerType
		customer {
			id
			clientUser {
				id
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
		}
		orgUser {
			id
		}
		organization {
			id
			...organizationAvatarOrganization
		}
		...shareWidgetDocument
	}
	${OrganizationAvatarOrganizationFragmentDoc}
	${ShareWidgetDocumentFragmentDoc}
`;
export const DocumentDetailCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment documentDetailCustomDocumentWithDownloadUrl on Document {
		id
		type
		customer {
			id
			contacts {
				id
				customer {
					id
				}
				vendor {
					id
				}
				...documentDetailPresentationContact
			}
		}
		organization {
			id
		}
		parentFolder {
			id
			name
			folderType
		}
		...documentDetailButtonBarCustomDocumentWithDownloadUrl
		...embeddedFileDocument
		...documentDetailPresentationCustomDocumentWithDownloadUrl
	}
	${DocumentDetailPresentationContactFragmentDoc}
	${DocumentDetailButtonBarCustomDocumentWithDownloadUrlFragmentDoc}
	${EmbeddedFileDocumentFragmentDoc}
	${DocumentDetailPresentationCustomDocumentWithDownloadUrlFragmentDoc}
`;
export const PayInvoicesModalRowInvoiceFragmentDoc = gql`
	fragment payInvoicesModalRowInvoice on Invoice {
		id
		title
		guestToken
		paymentInstallments {
			id
			dueDate
			amountDue
			status
			paymentDate
		}
	}
`;
export const PayInvoicesModalInvoiceFragmentDoc = gql`
	fragment payInvoicesModalInvoice on Invoice {
		id
		status
		paymentInstallments {
			id
			status
		}
		...payInvoicesModalRowInvoice
	}
	${PayInvoicesModalRowInvoiceFragmentDoc}
`;
export const PayInvoicesModalContactFragmentDoc = gql`
	fragment payInvoicesModalContact on Contact {
		id
		invoices {
			...payInvoicesModalInvoice
		}
	}
	${PayInvoicesModalInvoiceFragmentDoc}
`;
export const PayInvoicesModalContactForGetContractWhereFragmentDoc = gql`
	fragment payInvoicesModalContactForGetContractWhere on ContactForGetContractWhere {
		id
		invoices {
			...payInvoicesModalInvoiceForGetContractWhere
		}
	}
	${PayInvoicesModalInvoiceForGetContractWhereFragmentDoc}
`;
export const UseDocumentSettingsModalShareListContactFragmentDoc = gql`
	fragment useDocumentSettingsModalShareListContact on Contact {
		id
		firstName
		lastName
		customer {
			id
			email
		}
		vendor {
			id
			image
			updatedAt
			name
		}
		...contactCustomerAvatarContact
	}
	${ContactCustomerAvatarContactFragmentDoc}
`;
export const UseDocumentSettingsModalShareListOrganizationFragmentDoc = gql`
	fragment useDocumentSettingsModalShareListOrganization on Organization {
		id
		contacts(where: $contactWhere) {
			...useDocumentSettingsModalShareListContact
		}
	}
	${UseDocumentSettingsModalShareListContactFragmentDoc}
`;
export const DocumentSettingsModalShareListContactFragmentDoc = gql`
	fragment documentSettingsModalShareListContact on Contact {
		...useDocumentSettingsModalShareListContact
	}
	${UseDocumentSettingsModalShareListContactFragmentDoc}
`;
export const DocumentSettingsModalShareListOrganizationFragmentDoc = gql`
	fragment documentSettingsModalShareListOrganization on Organization {
		id
		...useDocumentSettingsModalShareListOrganization
		contacts(where: $contactWhere) {
			...documentSettingsModalShareListContact
		}
	}
	${UseDocumentSettingsModalShareListOrganizationFragmentDoc}
	${DocumentSettingsModalShareListContactFragmentDoc}
`;
export const UseDocumentSettingsModalShareListCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment useDocumentSettingsModalShareListCustomDocumentWithDownloadUrl on Document {
		id
		type
		ownerType
		customer {
			id
			email
			clientUser {
				id
				updatedAt
				firstNameOne
				lastNameOne
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
			orgUser {
				id
				updatedAt
				firstName
				lastName
			}
		}
		organization {
			id
			name
		}
		sharedWithContacts {
			...useDocumentSettingsModalShareListContact
		}
		sharedWithCustomer
	}
	${UseDocumentSettingsModalShareListContactFragmentDoc}
`;
export const DocumentSettingsModalShareListCustomDocumentWithDownloadUrlFragmentDoc = gql`
	fragment documentSettingsModalShareListCustomDocumentWithDownloadUrl on Document {
		...useDocumentSettingsModalShareListCustomDocumentWithDownloadUrl
	}
	${UseDocumentSettingsModalShareListCustomDocumentWithDownloadUrlFragmentDoc}
`;
export const UseDocumentSettingsModalDocumentFragmentDoc = gql`
	fragment useDocumentSettingsModalDocument on Document {
		id
		name
		exportable
		...documentSettingsModalShareListCustomDocumentWithDownloadUrl
	}
	${DocumentSettingsModalShareListCustomDocumentWithDownloadUrlFragmentDoc}
`;
export const DocumentSettingsModalDocumentFragmentDoc = gql`
	fragment documentSettingsModalDocument on Document {
		id
		name
		exportable
		...documentSettingsModalShareListCustomDocumentWithDownloadUrl
		...useDocumentSettingsModalDocument
	}
	${DocumentSettingsModalShareListCustomDocumentWithDownloadUrlFragmentDoc}
	${UseDocumentSettingsModalDocumentFragmentDoc}
`;
export const UseDocumentSettingsModalContactFragmentDoc = gql`
	fragment useDocumentSettingsModalContact on Contact {
		...documentSettingsModalShareListContact
	}
	${DocumentSettingsModalShareListContactFragmentDoc}
`;
export const CreateFolderModalCustomFolderFragmentDoc = gql`
	fragment createFolderModalCustomFolder on CustomFolder {
		id
		name
		parentFolder {
			id
			name
		}
	}
`;
export const DocumentsUploadButtonCustomFolderFragmentDoc = gql`
	fragment documentsUploadButtonCustomFolder on CustomFolder {
		id
		...createFolderModalCustomFolder
	}
	${CreateFolderModalCustomFolderFragmentDoc}
`;
export const DocumentsUploadButtonCustomDocumentWithUploadUrlFragmentDoc = gql`
	fragment documentsUploadButtonCustomDocumentWithUploadUrl on Document {
		id
	}
`;
export const EmbeddedFileContractTemplateFragmentDoc = gql`
	fragment embeddedFileContractTemplate on ContractTemplate {
		id
		sourceFileUrl
	}
`;
export const EventsContactFragmentDoc = gql`
	fragment eventsContact on Contact {
		id
		status
		firstName
		lastName
		customer {
			id
			email
			userType
			clientUser {
				id
				assignedPlanner {
					id
					organization {
						id
						users {
							id
							role
						}
					}
				}
			}
		}
		vendor {
			id
			users {
				id
				role
			}
		}
		assignedMember {
			id
		}
	}
`;
export const ProposalAcceptedByPlannerEventPropsEventFragmentDoc = gql`
	fragment proposalAcceptedByPlannerEventPropsEvent on Event {
		id
		category
		vendor {
			id
			name
		}
		proposal {
			id
			title
			eventDate
			contact {
				firstName
				lastName
				customer {
					email
				}
				vendor {
					name
				}
				...getViewingUserDocumentRelationshipContact
			}
		}
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
`;
export const GetProposalPastDueEventPropsEventFragmentDoc = gql`
	fragment getProposalPastDueEventPropsEvent on Event {
		category
		resolvedAt
		proposal {
			id
			title
			automatedRemindersEnabled
			sentByUser {
				id
			}
			contact {
				id
				firstName
				lastName
				customer {
					id
					email
					clientUser {
						id
						assignedPlanner {
							id
							organization {
								id
							}
						}
					}
				}
				assignedMember {
					id
				}
				vendor {
					id
					name
					users {
						id
						role
					}
				}
			}
		}
	}
`;
export const GetInvoicePastDueEventPropsEventFragmentDoc = gql`
	fragment getInvoicePastDueEventPropsEvent on Event {
		id
		category
		invoice {
			id
			title
			automatedRemindersEnabled
			contact {
				id
				firstName
				lastName
				customer {
					id
					email
					clientUser {
						id
						assignedPlanner {
							id
							firstName
							lastName
							user {
								id
							}
							organization {
								id
							}
						}
					}
				}
				vendor {
					id
					name
				}
				assignedMember {
					id
					user {
						id
					}
				}
			}
			organization {
				id
			}
		}
		resolvedAt
	}
`;
export const InstallmentPaymentRescheduledByVendorPropsEventFragmentDoc = gql`
	fragment installmentPaymentRescheduledByVendorPropsEvent on Event {
		id
		category
		invoice {
			id
			title
		}
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
	}
`;
export const GetProposalSentEventPropsEventFragmentDoc = gql`
	fragment getProposalSentEventPropsEvent on Event {
		id
		category
		proposal {
			id
			title
		}
		vendor {
			id
		}
		contact {
			id
			customer {
				id
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
						}
					}
				}
			}
		}
	}
`;
export const GetOfflinePaymentOrRefundUnrecordedEventPropsEventFragmentDoc = gql`
	fragment getOfflinePaymentOrRefundUnrecordedEventPropsEvent on Event {
		id
		category
		actingUser {
			id
			orgUser {
				id
				firstName
				lastName
			}
		}
		invoice {
			id
			title
			organization {
				id
				name
			}
		}
	}
`;
export const InstallmentPaymentFailedEventPropsEventFragmentDoc = gql`
	fragment installmentPaymentFailedEventPropsEvent on Event {
		id
		invoice {
			id
			title
		}
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
		clientUser {
			id
			user {
				id
			}
			assignedPlanner {
				id
				organization {
					id
				}
			}
		}
	}
`;
export const EventsEventFragmentDoc = gql`
	fragment eventsEvent on Event {
		id
		category
		createdAt
		message
		metadata
		resolvedAt
		actingUser {
			id
			orgUser {
				id
				firstName
				lastName
				user {
					id
				}
				organization {
					id
					name
					services {
						id
						name
					}
				}
			}
		}
		clientUser {
			id
			firstNameOne
			lastNameOne
			firstNameTwo
			lastNameTwo
			plannerOrgCanPayInvoices
			plannerOrgCanSignContracts
			plannerOrgHasConnectionPermissions
			plannerOrgHasDocumentsPermissions
			user {
				id
				email
			}
			assignedPlanner {
				id
				organization {
					id
					name
					orgType
					services {
						id
						name
					}
					users {
						id
						role
					}
				}
			}
		}
		guestUser {
			id
			user {
				id
				email
			}
		}
		vendor {
			id
			name
			services {
				id
				name
			}
			users {
				id
				role
			}
		}
		orgUser {
			id
			role
			firstName
			lastName
			user {
				id
				email
			}
			organization {
				id
				name
				orgType
				services {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		plannerUser {
			id
			role
			firstName
			lastName
			user {
				id
			}
			organization {
				id
				name
				orgType
				services {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		contacts {
			...eventsContact
		}
		contact {
			...eventsContact
		}
		invitation {
			id
			emailAddress
			recipientFirstName
			recipientLastName
		}
		contract {
			id
			title
			eventDate
			automatedRemindersEnabled
			sentByUser {
				id
				user {
					id
				}
			}
			vendor {
				id
				users {
					id
					role
					user {
						id
					}
				}
			}
			signatures {
				id
				type
				id
				signer {
					id
					orgUser {
						id
						firstName
						lastName
						user {
							id
						}
					}
				}
				customerSignature {
					id
					contact {
						id
						vendor {
							id
							name
							users {
								id
								role
							}
						}
						customer {
							id
							clientUser {
								id
								plannerOrgCanSignContracts
								assignedPlanner {
									id
									organization {
										id
										users {
											id
											role
										}
									}
								}
							}
						}
						assignedMember {
							id
						}
					}
				}
			}
		}
		invoice {
			id
			title
			status
			gratuityAmount
			automatedRemindersEnabled
			paymentInstallments {
				id
				name
			}
			contact {
				id
				vendor {
					id
					name
					orgType
					services {
						id
						name
					}
					users {
						id
						role
					}
				}
			}
		}
		document {
			id
			name
			fileSource
			fileType
			customer {
				id
				userType
				clientUser {
					id
					firstNameOne
					lastNameOne
					assignedPlanner {
						id
						organization {
							id
							services {
								id
								name
							}
							users {
								id
								role
							}
						}
					}
				}
				orgUser {
					id
					firstName
					lastName
				}
			}
			organization {
				id
				name
				services {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		paymentInstallments {
			id
			name
		}
		proposal {
			id
			title
			automatedRemindersEnabled
			proposalTemplate {
				id
			}
		}
		inquiry {
			id
			firstName
			lastName
			organization {
				id
				name
				createdAt
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
				users {
					id
					role
				}
			}
		}
		emailNotificationGroup {
			id
			groupTitle
		}
		...proposalAcceptedByPlannerEventPropsEvent
		...getProposalPastDueEventPropsEvent
		...invoiceAcceptedByPlannerEventPropsEvent
		...invoiceFullyPaidEventPropsEvent
		...getInvoicePastDueEventPropsEvent
		...installmentPaymentRescheduledByVendorPropsEvent
		...getContractSentEventPropsEvent
		...getProposalSentEventPropsEvent
		...getOfflinePaymentOrRefundUnrecordedEventPropsEvent
		...installmentPaymentFailedEventPropsEvent
	}
	${EventsContactFragmentDoc}
	${ProposalAcceptedByPlannerEventPropsEventFragmentDoc}
	${GetProposalPastDueEventPropsEventFragmentDoc}
	${InvoiceAcceptedByPlannerEventPropsEventFragmentDoc}
	${InvoiceFullyPaidEventPropsEventFragmentDoc}
	${GetInvoicePastDueEventPropsEventFragmentDoc}
	${InstallmentPaymentRescheduledByVendorPropsEventFragmentDoc}
	${GetContractSentEventPropsEventFragmentDoc}
	${GetProposalSentEventPropsEventFragmentDoc}
	${GetOfflinePaymentOrRefundUnrecordedEventPropsEventFragmentDoc}
	${InstallmentPaymentFailedEventPropsEventFragmentDoc}
`;
export const InquiriesConfigurationFieldsInquiryFormFragmentDoc = gql`
	fragment inquiriesConfigurationFieldsInquiryForm on InquiryForm {
		fields {
			order
			type
			label
			required
			options
			multiple
		}
	}
`;
export const InquiriesConfigurationInquiryFormFragmentDoc = gql`
	fragment inquiriesConfigurationInquiryForm on InquiryForm {
		sendConfirmationEmail
		confirmationEmail
		redirectOnSuccessUrl
		fields {
			id
			order
			type
			label
			required
			options
			multiple
		}
		styles {
			type
			value
		}
	}
`;
export const InvoiceViewStatusInvoiceFragmentDoc = gql`
	fragment invoiceViewStatusInvoice on Invoice {
		id
		status
		isPastDue
		contact {
			customer {
				id
				clientUser {
					id
					plannerOrgCanPayInvoices
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								user {
									id
								}
							}
						}
					}
				}
			}
		}
		paymentInstallments {
			id
			dueDate
			status
		}
	}
`;
export const InvoiceViewBillToInvoiceFragmentDoc = gql`
	fragment invoiceViewBillToInvoice on Invoice {
		id
		contact {
			id
			firstName
			lastName
			companyName
			customer {
				id
				email
			}
			assignedMember {
				id
				user {
					id
				}
			}
			vendor {
				id
				users {
					id
					role
					user {
						id
					}
				}
			}
		}
	}
`;
export const DocumentViewEmailNotificationGroupInvoiceFragmentDoc = gql`
	fragment documentViewEmailNotificationGroupInvoice on Invoice {
		id
		emailNotificationGroup {
			id
			groupTitle
			members {
				id
				email
				userType
				orgUser {
					id
					firstName
					lastName
					organization {
						id
					}
				}
			}
		}
	}
`;
export const InvoiceViewPresentationInvoiceFragmentDoc = gql`
	fragment invoiceViewPresentationInvoice on Invoice {
		id
		status
		isPastDue
		title
		sentAt
		eventDate
		uploadAttachment
		discountIsPercentage
		discountPercentage
		discountAmount
		organization {
			...organizationAvatarOrganization
		}
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		...invoiceViewStatusInvoice
		...invoiceViewBillToInvoice
		...documentViewEmailNotificationGroupInvoice
	}
	${OrganizationAvatarOrganizationFragmentDoc}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${InvoiceViewStatusInvoiceFragmentDoc}
	${InvoiceViewBillToInvoiceFragmentDoc}
	${DocumentViewEmailNotificationGroupInvoiceFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentsLineItemsFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentsLineItems on LineItem {
		id
		name
		rate
		quantity
		taxPercentage
	}
`;
export const InvoiceViewPaymentInstallmentsSubMenuPaymentInstallmentsFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentsSubMenuPaymentInstallments on PaymentInstallment {
		id
		status
	}
`;
export const InvoiceViewPaymentMethodPaymentInstallmentFragmentDoc = gql`
	fragment invoiceViewPaymentMethodPaymentInstallment on PaymentInstallment {
		id
		status
		paymentType
		processor
	}
`;
export const InvoiceViewPaymentInstallmentStatusFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentStatus on PaymentInstallment {
		status
		scheduledPaymentDate
	}
`;
export const InvoiceViewPaymentInstallmentDetailsModalPaymentInstallmentFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentDetailsModalPaymentInstallment on PaymentInstallment {
		id
		name
		amountDue
		status
		dueDate
		paymentDate
		gratuityPaid
		paymentNote
		amountRefunded
		refundDate
		refundNote
		...invoiceViewPaymentMethodPaymentInstallment
		...invoiceViewPaymentInstallmentStatus
	}
	${InvoiceViewPaymentMethodPaymentInstallmentFragmentDoc}
	${InvoiceViewPaymentInstallmentStatusFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentRefundModalPaymentInstallmentFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentRefundModalPaymentInstallment on PaymentInstallment {
		id
		name
		amountDue
		status
		dueDate
		paymentDate
		processor
		amountRefunded
		refundDate
		refundNote
		...invoiceViewPaymentMethodPaymentInstallment
		...invoiceViewPaymentInstallmentStatus
	}
	${InvoiceViewPaymentMethodPaymentInstallmentFragmentDoc}
	${InvoiceViewPaymentInstallmentStatusFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentPaymentModalFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentPaymentModal on PaymentInstallment {
		id
		name
		amountDue
		status
		dueDate
		processor
		paymentDate
		paymentType
		paymentNote
		...invoiceViewPaymentInstallmentStatus
		...invoiceViewPaymentMethodPaymentInstallment
	}
	${InvoiceViewPaymentInstallmentStatusFragmentDoc}
	${InvoiceViewPaymentMethodPaymentInstallmentFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentsInstallmentsFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentsInstallments on PaymentInstallment {
		id
		name
		convenienceFee
		amountPaid
		amountRefunded
		status
		amountDue
		gratuityPaid
		dueDate
		paymentDate
		...invoiceViewPaymentInstallmentDetailsModalPaymentInstallment
		...invoiceViewPaymentInstallmentStatus
		...invoiceViewPaymentInstallmentRefundModalPaymentInstallment
		...invoiceViewPaymentInstallmentPaymentModal
	}
	${InvoiceViewPaymentInstallmentDetailsModalPaymentInstallmentFragmentDoc}
	${InvoiceViewPaymentInstallmentStatusFragmentDoc}
	${InvoiceViewPaymentInstallmentRefundModalPaymentInstallmentFragmentDoc}
	${InvoiceViewPaymentInstallmentPaymentModalFragmentDoc}
`;
export const GetViewingUserDocumentRelationshipOrganizationFragmentDoc = gql`
	fragment getViewingUserDocumentRelationshipOrganization on Organization {
		users {
			id
			role
			user {
				id
			}
		}
	}
`;
export const InvoiceViewPaymentInstallmentHeaderInvoiceFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentHeaderInvoice on Invoice {
		id
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		organization {
			...getViewingUserDocumentRelationshipOrganization
		}
		paymentInstallments {
			id
			status
			scheduledPaymentDate
		}
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${GetViewingUserDocumentRelationshipOrganizationFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentsSubMenuInvoiceFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentsSubMenuInvoice on Invoice {
		id
		organization {
			...getViewingUserDocumentRelationshipOrganization
		}
	}
	${GetViewingUserDocumentRelationshipOrganizationFragmentDoc}
`;
export const InvoiceViewInvoiceTotalsPaymentInstallmentFragmentDoc = gql`
	fragment invoiceViewInvoiceTotalsPaymentInstallment on PaymentInstallment {
		status
		amountDue
		amountPaid
		convenienceFee
		amountRefunded
		paymentDate
	}
`;
export const InvoiceViewTotalsInvoiceFragmentDoc = gql`
	fragment invoiceViewTotalsInvoice on Invoice {
		id
		contact {
			id
			customer {
				id
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								user {
									id
								}
							}
						}
					}
				}
			}
		}
		organization {
			id
			users {
				id
				user {
					id
				}
			}
		}
		lineItems {
			id
			quantity
			rate
			taxPercentage
		}
		paymentInstallments {
			...invoiceViewInvoiceTotalsPaymentInstallment
		}
	}
	${InvoiceViewInvoiceTotalsPaymentInstallmentFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentPaymentModalInvoiceFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentPaymentModalInvoice on Invoice {
		id
		discountAmount
		lineItems {
			id
			name
			taxPercentage
			rate
			quantity
		}
		paymentInstallments {
			id
			name
			amountDue
			dueDate
			paymentDate
			refundDate
			convenienceFee
			amountPaid
			gratuityPaid
			amountRefunded
		}
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		organization {
			id
			country
		}
		...invoiceViewTotalsInvoice
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${InvoiceViewTotalsInvoiceFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentsInvoiceFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentsInvoice on Invoice {
		id
		discountPercentage
		discountAmount
		lineItems {
			...invoiceViewPaymentInstallmentsLineItems
		}
		paymentInstallments {
			...invoiceViewPaymentInstallmentsSubMenuPaymentInstallments
			...invoiceViewPaymentInstallmentsInstallments
		}
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		organization {
			id
			country
			users {
				id
				user {
					id
				}
			}
		}
		...invoiceViewPaymentInstallmentHeaderInvoice
		...invoiceViewPaymentInstallmentsSubMenuInvoice
		...invoiceViewPaymentInstallmentPaymentModalInvoice
	}
	${InvoiceViewPaymentInstallmentsLineItemsFragmentDoc}
	${InvoiceViewPaymentInstallmentsSubMenuPaymentInstallmentsFragmentDoc}
	${InvoiceViewPaymentInstallmentsInstallmentsFragmentDoc}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${InvoiceViewPaymentInstallmentHeaderInvoiceFragmentDoc}
	${InvoiceViewPaymentInstallmentsSubMenuInvoiceFragmentDoc}
	${InvoiceViewPaymentInstallmentPaymentModalInvoiceFragmentDoc}
`;
export const InvoiceViewButtonBarExportButtonInvoiceFragmentDoc = gql`
	fragment invoiceViewButtonBarExportButtonInvoice on Invoice {
		id
	}
`;
export const InvoiceViewButtonBarApproveButtonInvoiceFragmentDoc = gql`
	fragment invoiceViewButtonBarApproveButtonInvoice on Invoice {
		id
		status
		approvedByPlanner
		contact {
			...getViewingUserDocumentRelationshipContact
		}
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
`;
export const InvoiceViewButtonBarSendResendButtonInvoiceFragmentDoc = gql`
	fragment invoiceViewButtonBarSendResendButtonInvoice on Invoice {
		id
		status
		automatedRemindersEnabled
		contact {
			id
			firstName
			...getViewingUserDocumentRelationshipContact
		}
		lineItems {
			id
			rate
			quantity
			taxPercentage
		}
		discountAmount
		paymentInstallments {
			id
			status
			dueDate
		}
		organization {
			...getViewingUserDocumentRelationshipOrganization
		}
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${GetViewingUserDocumentRelationshipOrganizationFragmentDoc}
`;
export const InvoiceViewButtonBarPayButtonPaymentInstallmentsFragmentDoc = gql`
	fragment invoiceViewButtonBarPayButtonPaymentInstallments on PaymentInstallment {
		id
		status
		scheduledPaymentDate
		dueDate
	}
`;
export const DocumentFollowupActionsInvoiceFragmentDoc = gql`
	fragment documentFollowupActionsInvoice on Invoice {
		id
		status
		...payInvoicesModalInvoice
	}
	${PayInvoicesModalInvoiceFragmentDoc}
`;
export const VendorProfileVendorFragmentDoc = gql`
	fragment vendorProfileVendor on Organization {
		id
		name
		image
		services {
			name
			id
		}
	}
`;
export const SetPermissionsModalVendorFragmentDoc = gql`
	fragment setPermissionsModalVendor on Organization {
		...vendorProfileVendor
	}
	${VendorProfileVendorFragmentDoc}
`;
export const PermissionsModalOrganizationFragmentDoc = gql`
	fragment permissionsModalOrganization on Organization {
		...setPermissionsModalVendor
	}
	${SetPermissionsModalVendorFragmentDoc}
`;
export const AcceptProposalsModalContactFragmentDoc = gql`
	fragment acceptProposalsModalContact on Contact {
		id
		customer {
			id
		}
		proposals {
			...acceptProposalsModalProposal
		}
	}
	${AcceptProposalsModalProposalFragmentDoc}
`;
export const SignContractsModalContactFragmentDoc = gql`
	fragment signContractsModalContact on Contact {
		id
		customerSignatures {
			id
			signature {
				id
				signingDate
				contract {
					...signContractsModalContract
				}
			}
		}
		vendor {
			id
			name
		}
	}
	${SignContractsModalContractFragmentDoc}
`;
export const DocumentFollowupActionsContactFragmentDoc = gql`
	fragment documentFollowupActionsContact on Contact {
		id
		customerSignatures {
			id
			signature {
				id
				signingDate
				signer {
					id
				}
				contract {
					id
					status
					dueDate
				}
			}
		}
		invoices {
			...documentFollowupActionsInvoice
		}
		customer {
			id
			clientUser {
				id
				plannerOrgCanPayInvoices
				plannerOrgCanSignContracts
				assignedPlanner {
					id
					organization {
						id
						users {
							id
							role
						}
					}
				}
			}
		}
		vendor {
			...permissionsModalOrganization
		}
		...acceptProposalsModalContact
		...signContractsModalContact
	}
	${DocumentFollowupActionsInvoiceFragmentDoc}
	${PermissionsModalOrganizationFragmentDoc}
	${AcceptProposalsModalContactFragmentDoc}
	${SignContractsModalContactFragmentDoc}
`;
export const UsePaymentSectionPaymentInstallmentFragmentDoc = gql`
	fragment usePaymentSectionPaymentInstallment on PaymentInstallment {
		id
		amountDue
		amountPaid
		gratuityPaid
		paymentDate
		status
		scheduledPaymentDate
	}
`;
export const UsePaymentSectionInvoiceFragmentDoc = gql`
	fragment usePaymentSectionInvoice on Invoice {
		id
		status
		isPastDue
		allowsGratuity
		discountAmount
		gratuityAmount
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
		organization {
			id
			name
			country
			cardConvenienceFeePercentage
			achConvenienceFeePercentage
		}
		lineItems {
			id
			name
			taxPercentage
			rate
			quantity
		}
		paymentInstallments {
			...usePaymentSectionPaymentInstallment
		}
	}
	${UsePaymentSectionPaymentInstallmentFragmentDoc}
`;
export const InvoiceViewPaymentModalContentInvoiceFragmentDoc = gql`
	fragment invoiceViewPaymentModalContentInvoice on Invoice {
		...usePaymentSectionInvoice
	}
	${UsePaymentSectionInvoiceFragmentDoc}
`;
export const InvoiceViewButtonBarPayButtonInvoiceFragmentDoc = gql`
	fragment invoiceViewButtonBarPayButtonInvoice on Invoice {
		id
		paymentInstallments {
			...invoiceViewButtonBarPayButtonPaymentInstallments
		}
		contact {
			id
			customer {
				id
				email
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								user {
									id
								}
							}
						}
					}
				}
			}
			assignedMember {
				id
				organization {
					id
					services {
						id
						name
					}
				}
			}
			...documentFollowupActionsContact
		}
		organization {
			id
			services {
				id
				name
			}
			users {
				id
				user {
					id
				}
			}
		}
		...invoiceViewPaymentModalContentInvoice
	}
	${InvoiceViewButtonBarPayButtonPaymentInstallmentsFragmentDoc}
	${DocumentFollowupActionsContactFragmentDoc}
	${InvoiceViewPaymentModalContentInvoiceFragmentDoc}
`;
export const InvoiceViewButtonBarVoidButtonInvoiceFragmentDoc = gql`
	fragment invoiceViewButtonBarVoidButtonInvoice on Invoice {
		id
		status
		organization {
			...getViewingUserDocumentRelationshipOrganization
		}
	}
	${GetViewingUserDocumentRelationshipOrganizationFragmentDoc}
`;
export const InvoiceViewButtonBarInvoiceFragmentDoc = gql`
	fragment invoiceViewButtonBarInvoice on Invoice {
		...invoiceViewButtonBarExportButtonInvoice
		...invoiceViewButtonBarApproveButtonInvoice
		...invoiceViewButtonBarSendResendButtonInvoice
		...invoiceViewButtonBarPayButtonInvoice
		...invoiceViewButtonBarVoidButtonInvoice
	}
	${InvoiceViewButtonBarExportButtonInvoiceFragmentDoc}
	${InvoiceViewButtonBarApproveButtonInvoiceFragmentDoc}
	${InvoiceViewButtonBarSendResendButtonInvoiceFragmentDoc}
	${InvoiceViewButtonBarPayButtonInvoiceFragmentDoc}
	${InvoiceViewButtonBarVoidButtonInvoiceFragmentDoc}
`;
export const InvoiceViewNotesInvoiceFragmentDoc = gql`
	fragment invoiceViewNotesInvoice on Invoice {
		id
		notes
	}
`;
export const InvoiceViewLineItemSummaryInvoiceFragmentDoc = gql`
	fragment invoiceViewLineItemSummaryInvoice on Invoice {
		id
		discountIsPercentage
		discountPercentage
		discountAmount
		lineItems {
			id
			name
			rate
			quantity
			taxPercentage
		}
		organization {
			id
			country
		}
	}
`;
export const InvoiceAttachmentInvoiceFragmentDoc = gql`
	fragment invoiceAttachmentInvoice on Invoice {
		id
		uploadAttachment
		attachmentUrl
	}
`;
export const InvoiceViewNotesAndLineItemSummaryInvoiceFragmentDoc = gql`
	fragment invoiceViewNotesAndLineItemSummaryInvoice on Invoice {
		...invoiceViewNotesInvoice
		...invoiceViewLineItemSummaryInvoice
		...invoiceAttachmentInvoice
	}
	${InvoiceViewNotesInvoiceFragmentDoc}
	${InvoiceViewLineItemSummaryInvoiceFragmentDoc}
	${InvoiceAttachmentInvoiceFragmentDoc}
`;
export const InvoiceViewLineItemsInvoiceFragmentDoc = gql`
	fragment invoiceViewLineItemsInvoice on Invoice {
		id
		organization {
			id
			country
		}
		lineItems {
			id
			name
			quantity
			rate
			taxPercentage
			notes
		}
	}
`;
export const InvoiceViewAutoPayFormOrganizationFragmentDoc = gql`
	fragment invoiceViewAutoPayFormOrganization on Organization {
		id
		name
		cardConvenienceFeePercentage
		achConvenienceFeePercentage
	}
`;
export const UseInvoiceAutoPayUpdateInvoiceFragmentDoc = gql`
	fragment useInvoiceAutoPayUpdateInvoice on Invoice {
		id
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
		organization {
			id
			country
		}
	}
`;
export const InvoiceViewAutoPayFormInvoiceFragmentDoc = gql`
	fragment invoiceViewAutoPayFormInvoice on Invoice {
		...useInvoiceAutoPayUpdateInvoice
	}
	${UseInvoiceAutoPayUpdateInvoiceFragmentDoc}
`;
export const UseInvoiceAutopayInvoiceFragmentDoc = gql`
	fragment useInvoiceAutopayInvoice on Invoice {
		id
		contact {
			id
			customer {
				id
				stripeCustomerId
				clientUser {
					id
					plannerOrgCanPayInvoices
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								user {
									id
								}
							}
						}
					}
				}
			}
		}
		paymentInstallments {
			id
			status
			scheduledPaymentDate
			scheduledPaymentMethod
		}
		organization {
			id
		}
	}
`;
export const InvoiceViewAutopayInvoiceFragmentDoc = gql`
	fragment invoiceViewAutopayInvoice on Invoice {
		id
		status
		paymentInstallments {
			id
			status
			scheduledPaymentDate
			scheduledPaymentMethod
		}
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		organization {
			...invoiceViewAutoPayFormOrganization
		}
		...invoiceViewAutoPayFormInvoice
		...useInvoiceAutopayInvoice
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${InvoiceViewAutoPayFormOrganizationFragmentDoc}
	${InvoiceViewAutoPayFormInvoiceFragmentDoc}
	${UseInvoiceAutopayInvoiceFragmentDoc}
`;
export const InvoiceViewTotalsAndAutopayInvoiceFragmentDoc = gql`
	fragment invoiceViewTotalsAndAutopayInvoice on Invoice {
		...invoiceViewAutopayInvoice
		...invoiceViewTotalsInvoice
	}
	${InvoiceViewAutopayInvoiceFragmentDoc}
	${InvoiceViewTotalsInvoiceFragmentDoc}
`;
export const InvoiceViewHistoryItemInvoiceOrganizationFragmentDoc = gql`
	fragment invoiceViewHistoryItemInvoiceOrganization on Organization {
		id
	}
`;
export const InvoiceViewHistoryItemInvoiceFragmentDoc = gql`
	fragment invoiceViewHistoryItemInvoice on Invoice {
		id
		lineItems {
			id
			quantity
			rate
			taxPercentage
		}
		contact {
			id
			customer {
				id
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								user {
									id
								}
							}
						}
					}
				}
			}
		}
		organization {
			id
			users {
				id
				user {
					id
				}
			}
		}
	}
`;
export const InvoiceViewHistoryInvoiceFragmentDoc = gql`
	fragment invoiceViewHistoryInvoice on Invoice {
		id
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		organization {
			...invoiceViewHistoryItemInvoiceOrganization
		}
		...invoiceViewHistoryItemInvoice
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${InvoiceViewHistoryItemInvoiceOrganizationFragmentDoc}
	${InvoiceViewHistoryItemInvoiceFragmentDoc}
`;
export const UseContactsCompareForDiffContactFragmentDoc = gql`
	fragment useContactsCompareForDiffContact on Contact {
		id
		firstName
		lastName
		companyName
		customer {
			id
			email
		}
	}
`;
export const InvoiceViewInvoiceFragmentDoc = gql`
	fragment invoiceViewInvoice on Invoice {
		...invoiceViewPresentationInvoice
		...invoiceViewPaymentInstallmentsInvoice
		...invoiceViewButtonBarInvoice
		...invoiceViewNotesAndLineItemSummaryInvoice
		...invoiceViewLineItemsInvoice
		...invoiceViewTotalsAndAutopayInvoice
		...invoiceViewHistoryInvoice
		...usePaymentSectionInvoice
		contact {
			id
			...useContactsCompareForDiffContact
		}
	}
	${InvoiceViewPresentationInvoiceFragmentDoc}
	${InvoiceViewPaymentInstallmentsInvoiceFragmentDoc}
	${InvoiceViewButtonBarInvoiceFragmentDoc}
	${InvoiceViewNotesAndLineItemSummaryInvoiceFragmentDoc}
	${InvoiceViewLineItemsInvoiceFragmentDoc}
	${InvoiceViewTotalsAndAutopayInvoiceFragmentDoc}
	${InvoiceViewHistoryInvoiceFragmentDoc}
	${UsePaymentSectionInvoiceFragmentDoc}
	${UseContactsCompareForDiffContactFragmentDoc}
`;
export const UseInvoiceEditButtonBarSaveButtonInvoiceFragmentDoc = gql`
	fragment useInvoiceEditButtonBarSaveButtonInvoice on Invoice {
		id
		status
		contact {
			id
		}
	}
`;
export const UseInvoiceEditButtonBarVoidButtonInvoiceFragmentDoc = gql`
	fragment useInvoiceEditButtonBarVoidButtonInvoice on Invoice {
		id
		status
	}
`;
export const UseInvoiceEditButtonBarSendButtonInvoiceFragmentDoc = gql`
	fragment useInvoiceEditButtonBarSendButtonInvoice on Invoice {
		id
		status
		automatedRemindersEnabled
		eventDate
		dueDate
		title
		totalAmount
		contact {
			id
		}
		lineItems {
			id
			rate
			quantity
			taxPercentage
		}
		discountAmount
		paymentInstallments {
			id
			status
			dueDate
			amountPaid
			amountDue
			gratuityPaid
			paymentDate
			convenienceFee
		}
	}
`;
export const InvoiceEditButtonBarInvoiceFragmentDoc = gql`
	fragment invoiceEditButtonBarInvoice on Invoice {
		id
		status
		...useInvoiceEditButtonBarSaveButtonInvoice
		...useInvoiceEditButtonBarVoidButtonInvoice
		...useInvoiceEditButtonBarSendButtonInvoice
	}
	${UseInvoiceEditButtonBarSaveButtonInvoiceFragmentDoc}
	${UseInvoiceEditButtonBarVoidButtonInvoiceFragmentDoc}
	${UseInvoiceEditButtonBarSendButtonInvoiceFragmentDoc}
`;
export const InvoiceEditApplyTemplateModalInvoiceTemplateFragmentDoc = gql`
	fragment invoiceEditApplyTemplateModalInvoiceTemplate on InvoiceTemplate {
		id
		title
		notes
		allowsGratuity
		automatedRemindersEnabled
		discountAmount
		discountIsPercentage
		discountPercentage
		filename
		lineItems {
			id
			order
			name
			rate
			quantity
			taxPercentage
			notes
		}
		paymentInstallments {
			id
			name
			amountDue
			enteredAsPercentageAmount
			percentageDue
		}
	}
`;
export const InvoiceEditApplyTemplateModalInvoiceFragmentDoc = gql`
	fragment invoiceEditApplyTemplateModalInvoice on Invoice {
		id
		invoiceTemplate {
			...invoiceEditApplyTemplateModalInvoiceTemplate
		}
	}
	${InvoiceEditApplyTemplateModalInvoiceTemplateFragmentDoc}
`;
export const InvoiceEditApplyTemplateInvoiceFragmentDoc = gql`
	fragment invoiceEditApplyTemplateInvoice on Invoice {
		id
		status
		paymentInstallments {
			id
			status
			processor
			scheduledPaymentDate
		}
		...invoiceEditApplyTemplateModalInvoice
	}
	${InvoiceEditApplyTemplateModalInvoiceFragmentDoc}
`;
export const InvoiceEditPresentationInvoiceFragmentDoc = gql`
	fragment invoiceEditPresentationInvoice on Invoice {
		id
		title
		eventDate
		...invoiceEditApplyTemplateInvoice
	}
	${InvoiceEditApplyTemplateInvoiceFragmentDoc}
`;
export const InvoiceEditLineItemLineItemFragmentDoc = gql`
	fragment invoiceEditLineItemLineItem on LineItem {
		id
		name
		rate
		quantity
		taxPercentage
		notes
	}
`;
export const InvoiceEditLineItemInvoiceFragmentDoc = gql`
	fragment invoiceEditLineItemInvoice on Invoice {
		id
		discountAmount
		discountPercentage
		lineItems {
			...invoiceEditLineItemLineItem
		}
	}
	${InvoiceEditLineItemLineItemFragmentDoc}
`;
export const UseLineItemsInvoiceEditLineItemFragmentDoc = gql`
	fragment useLineItemsInvoiceEditLineItem on LineItem {
		id
		name
		quantity
		rate
		taxPercentage
		notes
	}
`;
export const UseLineItemsInvoiceFragmentDoc = gql`
	fragment useLineItemsInvoice on Invoice {
		id
		status
		lineItems {
			...useLineItemsInvoiceEditLineItem
		}
	}
	${UseLineItemsInvoiceEditLineItemFragmentDoc}
`;
export const InvoiceEditLineItemsInvoiceFragmentDoc = gql`
	fragment invoiceEditLineItemsInvoice on Invoice {
		id
		status
		organization {
			country
		}
		...invoiceEditLineItemInvoice
		...useLineItemsInvoice
	}
	${InvoiceEditLineItemInvoiceFragmentDoc}
	${UseLineItemsInvoiceFragmentDoc}
`;
export const InvoiceEditRemainingBalanceInvoiceFragmentDoc = gql`
	fragment invoiceEditRemainingBalanceInvoice on Invoice {
		discountAmount
		lineItems {
			id
			name
			quantity
			rate
			taxPercentage
		}
		paymentInstallments {
			amountDue
			status
			paymentDate
		}
	}
`;
export const InvoiceEditPaymentInstallmentPaymentInstallmentFragmentDoc = gql`
	fragment invoiceEditPaymentInstallmentPaymentInstallment on PaymentInstallment {
		id
		status
		name
		dueDate
		amountDue
		percentageDue
		enteredAsPercentageAmount
	}
`;
export const InvoiceEditPaymentInstallmentInvoiceFragmentDoc = gql`
	fragment invoiceEditPaymentInstallmentInvoice on Invoice {
		id
		paymentInstallments {
			...invoiceEditPaymentInstallmentPaymentInstallment
		}
	}
	${InvoiceEditPaymentInstallmentPaymentInstallmentFragmentDoc}
`;
export const InvoiceEditPaymentInstallmentsInvoiceFragmentDoc = gql`
	fragment invoiceEditPaymentInstallmentsInvoice on Invoice {
		id
		status
		organization {
			country
		}
		...invoiceEditRemainingBalanceInvoice
		...invoiceEditPaymentInstallmentInvoice
		paymentInstallments {
			id
			dueDate
		}
	}
	${InvoiceEditRemainingBalanceInvoiceFragmentDoc}
	${InvoiceEditPaymentInstallmentInvoiceFragmentDoc}
`;
export const InvoiceEditNotesInvoiceFragmentDoc = gql`
	fragment invoiceEditNotesInvoice on Invoice {
		id
		notes
		status
	}
`;
export const InvoiceEditLineItemDiscountInvoiceFragmentDoc = gql`
	fragment invoiceEditLineItemDiscountInvoice on Invoice {
		discountAmount
		discountPercentage
		discountIsPercentage
		lineItems {
			id
			name
			quantity
			rate
			taxPercentage
		}
	}
`;
export const InvoiceEditLineItemSummaryInvoiceFragmentDoc = gql`
	fragment invoiceEditLineItemSummaryInvoice on Invoice {
		id
		status
		organization {
			country
		}
		...invoiceEditLineItemDiscountInvoice
		lineItems {
			id
			name
			quantity
			rate
			taxPercentage
		}
	}
	${InvoiceEditLineItemDiscountInvoiceFragmentDoc}
`;
export const InvoiceEditNotesAndLineItemSummaryInvoiceFragmentDoc = gql`
	fragment invoiceEditNotesAndLineItemSummaryInvoice on Invoice {
		...invoiceEditNotesInvoice
		...invoiceEditLineItemSummaryInvoice
	}
	${InvoiceEditNotesInvoiceFragmentDoc}
	${InvoiceEditLineItemSummaryInvoiceFragmentDoc}
`;
export const InvoiceEditSettingsInvoiceFragmentDoc = gql`
	fragment invoiceEditSettingsInvoice on Invoice {
		id
		status
		allowsGratuity
		automatedRemindersEnabled
		paymentInstallments {
			id
			status
			amountDue
			paymentDate
		}
	}
`;
export const ContactsContextContactFragmentDoc = gql`
	fragment contactsContextContact on Contact {
		id
		status
		firstName
		lastName
		companyName
		customer {
			id
			email
		}
	}
`;
export const UseNotificationGroupOrganizationFragmentDoc = gql`
	fragment useNotificationGroupOrganization on Organization {
		id
		users {
			id
			firstName
			lastName
			role
			organization {
				id
			}
			user {
				id
				email
				userType
			}
		}
	}
`;
export const InvoiceEditInvoiceFragmentDoc = gql`
	fragment invoiceEditInvoice on Invoice {
		id
		allowsGratuity
		automatedRemindersEnabled
		eventDate
		uploadAttachment
		...invoiceEditButtonBarInvoice
		...invoiceEditPresentationInvoice
		...invoiceEditLineItemsInvoice
		...invoiceEditPaymentInstallmentsInvoice
		...invoiceEditNotesAndLineItemSummaryInvoice
		...invoiceEditSettingsInvoice
		contact {
			...contactsContextContact
		}
		emailNotificationGroup {
			...useNotificationGroupEmailNotificationGroup
		}
		organization {
			...useNotificationGroupOrganization
		}
	}
	${InvoiceEditButtonBarInvoiceFragmentDoc}
	${InvoiceEditPresentationInvoiceFragmentDoc}
	${InvoiceEditLineItemsInvoiceFragmentDoc}
	${InvoiceEditPaymentInstallmentsInvoiceFragmentDoc}
	${InvoiceEditNotesAndLineItemSummaryInvoiceFragmentDoc}
	${InvoiceEditSettingsInvoiceFragmentDoc}
	${ContactsContextContactFragmentDoc}
	${UseNotificationGroupEmailNotificationGroupFragmentDoc}
	${UseNotificationGroupOrganizationFragmentDoc}
`;
export const InvoiceDetailInvoiceFragmentDoc = gql`
	fragment invoiceDetailInvoice on Invoice {
		...invoiceViewInvoice
		...invoiceEditInvoice
	}
	${InvoiceViewInvoiceFragmentDoc}
	${InvoiceEditInvoiceFragmentDoc}
`;
export const InvoiceEditFileSelectorDisplayTextInvoiceFragmentDoc = gql`
	fragment invoiceEditFileSelectorDisplayTextInvoice on Invoice {
		uploadAttachment
		status
	}
`;
export const InvoiceEditFileSelectorInvoiceFragmentDoc = gql`
	fragment invoiceEditFileSelectorInvoice on Invoice {
		...invoiceEditFileSelectorDisplayTextInvoice
	}
	${InvoiceEditFileSelectorDisplayTextInvoiceFragmentDoc}
`;
export const UsePaymentInstallmentsInvoiceEditLineItemFragmentDoc = gql`
	fragment usePaymentInstallmentsInvoiceEditLineItem on LineItem {
		id
		name
		rate
		quantity
		taxPercentage
	}
`;
export const UsePaymentInstallmentsInvoiceEditPaymentInstallmentFragmentDoc = gql`
	fragment usePaymentInstallmentsInvoiceEditPaymentInstallment on PaymentInstallment {
		id
		name
		status
		dueDate
		amountDue
		enteredAsPercentageAmount
		percentageDue
	}
`;
export const UsePaymentInstallmentsInvoiceEditInvoiceFragmentDoc = gql`
	fragment usePaymentInstallmentsInvoiceEditInvoice on Invoice {
		id
		status
		discountAmount
		discountPercentage
		lineItems {
			...usePaymentInstallmentsInvoiceEditLineItem
		}
		paymentInstallments {
			...usePaymentInstallmentsInvoiceEditPaymentInstallment
		}
	}
	${UsePaymentInstallmentsInvoiceEditLineItemFragmentDoc}
	${UsePaymentInstallmentsInvoiceEditPaymentInstallmentFragmentDoc}
`;
export const UseInvoiceTemplateEditButtonBarDeleteButtonFragmentDoc = gql`
	fragment useInvoiceTemplateEditButtonBarDeleteButton on InvoiceTemplate {
		id
	}
`;
export const UseInvoiceTemplateEditButtonBarSaveOrUseButtonFragmentDoc = gql`
	fragment useInvoiceTemplateEditButtonBarSaveOrUseButton on InvoiceTemplate {
		id
	}
`;
export const InvoiceTemplateEditButtonBarFragmentDoc = gql`
	fragment invoiceTemplateEditButtonBar on InvoiceTemplate {
		...useInvoiceTemplateEditButtonBarDeleteButton
		...useInvoiceTemplateEditButtonBarSaveOrUseButton
	}
	${UseInvoiceTemplateEditButtonBarDeleteButtonFragmentDoc}
	${UseInvoiceTemplateEditButtonBarSaveOrUseButtonFragmentDoc}
`;
export const InvoiceTemplateEditPresentationFragmentDoc = gql`
	fragment invoiceTemplateEditPresentation on InvoiceTemplate {
		id
		title
	}
`;
export const InvoiceTemplateEditUseLineItemsFragmentDoc = gql`
	fragment invoiceTemplateEditUseLineItems on InvoiceTemplateLineItem {
		id
		order
		name
		quantity
		rate
		taxPercentage
		notes
	}
`;
export const InvoiceTemplateEditUseLineItemsInvoiceTemplateFragmentDoc = gql`
	fragment invoiceTemplateEditUseLineItemsInvoiceTemplate on InvoiceTemplate {
		lineItems {
			...invoiceTemplateEditUseLineItems
		}
	}
	${InvoiceTemplateEditUseLineItemsFragmentDoc}
`;
export const InvoiceTemplateEditLineItemFragmentDoc = gql`
	fragment invoiceTemplateEditLineItem on InvoiceTemplateLineItem {
		id
		name
		rate
		quantity
		taxPercentage
	}
`;
export const InvoiceTemplateEditLineItemInvoiceTemplateFragmentDoc = gql`
	fragment invoiceTemplateEditLineItemInvoiceTemplate on InvoiceTemplate {
		id
		discountAmount
		lineItems {
			...invoiceTemplateEditLineItem
		}
	}
	${InvoiceTemplateEditLineItemFragmentDoc}
`;
export const InvoiceTemplateEditDraggableLineItemInvoiceTemplateFragmentDoc = gql`
	fragment invoiceTemplateEditDraggableLineItemInvoiceTemplate on InvoiceTemplate {
		id
		...invoiceTemplateEditLineItemInvoiceTemplate
	}
	${InvoiceTemplateEditLineItemInvoiceTemplateFragmentDoc}
`;
export const InvoiceTemplateEditLineItemsInvoiceTemplateFragmentDoc = gql`
	fragment invoiceTemplateEditLineItemsInvoiceTemplate on InvoiceTemplate {
		id
		organization {
			country
		}
		...invoiceTemplateEditDraggableLineItemInvoiceTemplate
	}
	${InvoiceTemplateEditDraggableLineItemInvoiceTemplateFragmentDoc}
`;
export const InvoiceTemplateEditLineItemDiscountFragmentDoc = gql`
	fragment invoiceTemplateEditLineItemDiscount on InvoiceTemplate {
		discountAmount
		discountPercentage
		discountIsPercentage
	}
`;
export const InvoiceTemplateEditLineItemSummaryFragmentDoc = gql`
	fragment invoiceTemplateEditLineItemSummary on InvoiceTemplate {
		...invoiceTemplateEditLineItemDiscount
	}
	${InvoiceTemplateEditLineItemDiscountFragmentDoc}
`;
export const InvoiceTemplateEditFileSelectorDisplayTextInvoiceFragmentDoc = gql`
	fragment invoiceTemplateEditFileSelectorDisplayTextInvoice on InvoiceTemplate {
		filename
		status
	}
`;
export const InvoiceTemplateEditFileSelectorInvoiceFragmentDoc = gql`
	fragment invoiceTemplateEditFileSelectorInvoice on InvoiceTemplate {
		...invoiceTemplateEditFileSelectorDisplayTextInvoice
	}
	${InvoiceTemplateEditFileSelectorDisplayTextInvoiceFragmentDoc}
`;
export const InvoiceTemplateEditNotesAndLineItemSummaryFragmentDoc = gql`
	fragment invoiceTemplateEditNotesAndLineItemSummary on InvoiceTemplate {
		notes
		...invoiceTemplateEditLineItemSummary
		...invoiceTemplateEditFileSelectorInvoice
	}
	${InvoiceTemplateEditLineItemSummaryFragmentDoc}
	${InvoiceTemplateEditFileSelectorInvoiceFragmentDoc}
`;
export const InvoiceTemplateEditRemainingBalanceFragmentDoc = gql`
	fragment invoiceTemplateEditRemainingBalance on InvoiceTemplatePaymentInstallment {
		amountDue
	}
`;
export const CalculateInstallmentInvoiceTemplatePaymentInstallmentFragmentDoc = gql`
	fragment calculateInstallmentInvoiceTemplatePaymentInstallment on InvoiceTemplatePaymentInstallment {
		id
		name
		amountDue
	}
`;
export const InvoiceTemplateEditPaymentInstallmentsInvoiceTemplatePaymentInstallmentFragmentDoc = gql`
	fragment invoiceTemplateEditPaymentInstallmentsInvoiceTemplatePaymentInstallment on InvoiceTemplatePaymentInstallment {
		id
		...invoiceTemplateEditRemainingBalance
		...calculateInstallmentInvoiceTemplatePaymentInstallment
	}
	${InvoiceTemplateEditRemainingBalanceFragmentDoc}
	${CalculateInstallmentInvoiceTemplatePaymentInstallmentFragmentDoc}
`;
export const InvoiceTemplateEditPaymentInstallmentInvoiceTemplateFragmentDoc = gql`
	fragment invoiceTemplateEditPaymentInstallmentInvoiceTemplate on InvoiceTemplate {
		id
		paymentInstallments {
			...calculateInstallmentInvoiceTemplatePaymentInstallment
		}
	}
	${CalculateInstallmentInvoiceTemplatePaymentInstallmentFragmentDoc}
`;
export const InvoiceTemplateEditPaymentInstallmentsFragmentDoc = gql`
	fragment invoiceTemplateEditPaymentInstallments on InvoiceTemplate {
		organization {
			id
			country
		}
		paymentInstallments {
			...invoiceTemplateEditPaymentInstallmentsInvoiceTemplatePaymentInstallment
		}
		...invoiceTemplateEditPaymentInstallmentInvoiceTemplate
	}
	${InvoiceTemplateEditPaymentInstallmentsInvoiceTemplatePaymentInstallmentFragmentDoc}
	${InvoiceTemplateEditPaymentInstallmentInvoiceTemplateFragmentDoc}
`;
export const UseInvoiceTemplatePaymentInstallmentsFragmentDoc = gql`
	fragment useInvoiceTemplatePaymentInstallments on InvoiceTemplatePaymentInstallment {
		id
		name
		amountDue
		enteredAsPercentageAmount
		percentageDue
	}
`;
export const UsePaymentInstallmentsInvoiceInvoiceTemplateFragmentDoc = gql`
	fragment usePaymentInstallmentsInvoiceInvoiceTemplate on InvoiceTemplate {
		discountAmount
		discountPercentage
		paymentInstallments {
			...useInvoiceTemplatePaymentInstallments
		}
	}
	${UseInvoiceTemplatePaymentInstallmentsFragmentDoc}
`;
export const InvoiceTemplateEditFragmentDoc = gql`
	fragment invoiceTemplateEdit on InvoiceTemplate {
		id
		allowsGratuity
		automatedRemindersEnabled
		notes
		filename
		...invoiceTemplateEditPresentation
		...invoiceTemplateEditUseLineItemsInvoiceTemplate
		...invoiceTemplateEditLineItemsInvoiceTemplate
		...invoiceTemplateEditNotesAndLineItemSummary
		...invoiceTemplateEditPaymentInstallments
		...usePaymentInstallmentsInvoiceInvoiceTemplate
	}
	${InvoiceTemplateEditPresentationFragmentDoc}
	${InvoiceTemplateEditUseLineItemsInvoiceTemplateFragmentDoc}
	${InvoiceTemplateEditLineItemsInvoiceTemplateFragmentDoc}
	${InvoiceTemplateEditNotesAndLineItemSummaryFragmentDoc}
	${InvoiceTemplateEditPaymentInstallmentsFragmentDoc}
	${UsePaymentInstallmentsInvoiceInvoiceTemplateFragmentDoc}
`;
export const InvoiceViewOrganizationFragmentDoc = gql`
	fragment invoiceViewOrganization on Organization {
		...organizationAvatarOrganization
	}
	${OrganizationAvatarOrganizationFragmentDoc}
`;
export const InvoiceViewHistoryItemEventFragmentDoc = gql`
	fragment invoiceViewHistoryItemEvent on Event {
		id
		category
		message
		createdAt
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
				clientUser {
					id
					plannerOrgCanPayInvoices
				}
			}
		}
		plannerUser {
			id
			firstName
			lastName
		}
		paymentInstallments {
			id
			name
			status
			convenienceFee
			amountPaid
			amountDue
			gratuityPaid
			paymentDate
		}
	}
`;
export const InvoiceViewPaymentInstallmentDetailsModalInvoiceFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentDetailsModalInvoice on Invoice {
		id
		discountAmount
		lineItems {
			id
			name
			taxPercentage
			rate
			quantity
		}
		paymentInstallments {
			...invoiceViewPaymentInstallmentDetailsModalPaymentInstallment
		}
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		organization {
			country
			...getViewingUserDocumentRelationshipOrganization
		}
	}
	${InvoiceViewPaymentInstallmentDetailsModalPaymentInstallmentFragmentDoc}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${GetViewingUserDocumentRelationshipOrganizationFragmentDoc}
`;
export const InvoiceViewPaymentInstallmentRefundModalInvoiceFragmentDoc = gql`
	fragment invoiceViewPaymentInstallmentRefundModalInvoice on Invoice {
		id
		discountAmount
		lineItems {
			id
			name
			taxPercentage
			rate
			quantity
		}
		paymentInstallments {
			...invoiceViewPaymentInstallmentRefundModalPaymentInstallment
		}
		contact {
			...getViewingUserDocumentRelationshipContact
		}
		organization {
			id
			country
		}
	}
	${InvoiceViewPaymentInstallmentRefundModalPaymentInstallmentFragmentDoc}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
`;
export const InvoiceViewPresentationOrganizationFragmentDoc = gql`
	fragment invoiceViewPresentationOrganization on Organization {
		...organizationAvatarOrganization
	}
	${OrganizationAvatarOrganizationFragmentDoc}
`;
export const UseInvoiceMetrics_PaymentsSummaryFragmentDoc = gql`
	fragment useInvoiceMetrics_paymentsSummary on PaymentsSummary {
		totalInvoicesPaid
		totalAmountUpcoming
		totalInvoicesOverdue
	}
`;
export const InvoicesTableFragmentDoc = gql`
	fragment invoicesTable on Invoice {
		id
		title
		sentAt
		status
		isPastDue
		totalAmount
		eventDate
		dueDate
		automatedRemindersEnabled
		sentByUser {
			id
			firstName
			lastName
			updatedAt
			user {
				id
			}
		}
		discountAmount
		lineItems {
			id
			rate
			quantity
			taxPercentage
		}
		paymentInstallments {
			id
			status
			dueDate
		}
		contact {
			id
			status
			firstName
			lastName
			companyName
			customer {
				id
				email
				clientUser {
					id
					plannerOrgCanPayInvoices
					assignedPlanner {
						id
						organization {
							id
						}
					}
				}
			}
		}
		quickPayment {
			id
		}
		organization {
			id
			name
			image
			updatedAt
			users {
				id
				role
			}
		}
	}
`;
export const InvoiceTemplatesTableFragmentDoc = gql`
	fragment invoiceTemplatesTable on InvoiceTemplate {
		id
		title
		createdAt
		status
		countOfConnectedInvoices
	}
`;
export const ActivityHistoryItemFragmentDoc = gql`
	fragment ActivityHistoryItem on Event {
		id
		category
		createdAt
		vendor {
			id
			name
		}
		inquiry {
			id
			firstName
			lastName
			contact {
				id
				customer {
					id
				}
			}
		}
		actingUser {
			id
			orgUser {
				id
				firstName
				lastName
			}
		}
	}
`;
export const ActivityHistoryEventFragmentDoc = gql`
	fragment ActivityHistoryEvent on Event {
		...ActivityHistoryItem
	}
	${ActivityHistoryItemFragmentDoc}
`;
export const LeadCreateOrViewModalFormInquiryFragmentDoc = gql`
	fragment leadCreateOrViewModalFormInquiry on Inquiry {
		createdAt
		firstName
		lastName
		email
		companyName
		eventDate
		notes
		id
		status
		source
		contact {
			id
			customer {
				id
				email
			}
		}
	}
`;
export const ActionMenuInquiryFragmentDoc = gql`
	fragment actionMenuInquiry on Inquiry {
		id
		firstName
		lastName
		email
		contact {
			id
			customer {
				id
			}
		}
		...leadCreateOrViewModalFormInquiry
	}
	${LeadCreateOrViewModalFormInquiryFragmentDoc}
`;
export const LeadDetailHeaderFragmentFragmentDoc = gql`
	fragment LeadDetailHeaderFragment on Inquiry {
		id
		status
		firstName
		lastName
		companyName
		email
		eventDate
		createdAt
		source
		organization {
			id
			name
			users {
				role
				id
			}
		}
		...actionMenuInquiry
	}
	${ActionMenuInquiryFragmentDoc}
`;
export const NotesTabInquiryFragmentDoc = gql`
	fragment notesTabInquiry on Inquiry {
		id
		notes
	}
`;
export const OrganizationLeadFormPresentationalDataOrganizationFragmentDoc = gql`
	fragment organizationLeadFormPresentationalDataOrganization on LeadFormPresentationalDataOrganization {
		id
		image
		name
		phone
		contactEmail
		updatedAt
	}
`;
export const LeadFormViewPageLeadFormPresentationalDataFragmentDoc = gql`
	fragment leadFormViewPageLeadFormPresentationalData on LeadFormPresentationalData {
		apiKey
		organization {
			id
			...organizationLeadFormPresentationalDataOrganization
		}
	}
	${OrganizationLeadFormPresentationalDataOrganizationFragmentDoc}
`;
export const LeadsTableUpdateLeadStatusLinkFragmentDoc = gql`
	fragment leadsTableUpdateLeadStatusLink on Inquiry {
		id
		status
	}
`;
export const LeadStatusInquiryFragmentDoc = gql`
	fragment leadStatusInquiry on Inquiry {
		id
		status
	}
`;
export const GetCustomRendererInquiryFragmentDoc = gql`
	fragment getCustomRendererInquiry on Inquiry {
		...leadStatusInquiry
	}
	${LeadStatusInquiryFragmentDoc}
`;
export const InquiriesTableFragmentDoc = gql`
	fragment inquiriesTable on Inquiry {
		id
		firstName
		lastName
		email
		eventDate
		createdAt
		status
		source
		contact {
			id
			customer {
				email
				id
			}
		}
		...leadCreateOrViewModalFormInquiry
		...getCustomRendererInquiry
	}
	${LeadCreateOrViewModalFormInquiryFragmentDoc}
	${GetCustomRendererInquiryFragmentDoc}
`;
export const MembersTableOrgUserFragmentDoc = gql`
	fragment membersTableOrgUser on OrgUser {
		id
		role
		firstName
		lastName
		updatedAt
		contacts {
			id
		}
		user {
			id
			blocked
			email
		}
		organization {
			id
			users {
				id
				role
			}
		}
	}
`;
export const MemberDetailHeaderMemberFragmentDoc = gql`
	fragment memberDetailHeaderMember on OrgUser {
		id
		updatedAt
		firstName
		lastName
		phone
		role
		organization {
			id
			updatedAt
			image
			name
			users {
				...membersTableOrgUser
			}
		}
		user {
			id
			email
			userType
		}
	}
	${MembersTableOrgUserFragmentDoc}
`;
export const MemberDetailAssignedClientsMemberFragmentDoc = gql`
	fragment memberDetailAssignedClientsMember on OrgUser {
		id
		firstName
		lastName
		contacts {
			id
		}
		user {
			id
		}
	}
`;
export const MemberDetailMemberFragmentDoc = gql`
	fragment memberDetailMember on OrgUser {
		id
		phone
		firstName
		lastName
		role
		user {
			id
			blocked
		}
		organization {
			id
			users {
				id
				role
			}
		}
		...memberDetailHeaderMember
		...memberDetailAssignedClientsMember
	}
	${MemberDetailHeaderMemberFragmentDoc}
	${MemberDetailAssignedClientsMemberFragmentDoc}
`;
export const MessageCustomerModalContactFragmentDoc = gql`
	fragment messageCustomerModalContact on Contact {
		id
		firstName
		customer {
			id
			email
		}
		vendor {
			id
			name
			brandedEmails
		}
	}
`;
export const MessageCustomerModalInquiryFragmentDoc = gql`
	fragment messageCustomerModalInquiry on Inquiry {
		id
		firstName
		contact {
			...messageCustomerModalContact
		}
		organization {
			id
			name
			brandedEmails
		}
	}
	${MessageCustomerModalContactFragmentDoc}
`;
export const UseMoveFileModalCustomerFoldersContactFragmentDoc = gql`
	fragment useMoveFileModalCustomerFoldersContact on Contact {
		id
		firstName
		lastName
		customer {
			id
			email
			clientUser {
				id
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
		}
	}
`;
export const UseMoveFileModalCustomerFoldersDocumentFragmentDoc = gql`
	fragment useMoveFileModalCustomerFoldersDocument on Document {
		id
		fileType
		name
	}
`;
export const UseMoveFileModalCompanyFoldersFolderFragmentDoc = gql`
	fragment useMoveFileModalCompanyFoldersFolder on Folder {
		id
		name
		parentFolder {
			id
			name
		}
	}
`;
export const MoveFileModalFolderFragmentDoc = gql`
	fragment moveFileModalFolder on Folder {
		...useMoveFileModalCompanyFoldersFolder
	}
	${UseMoveFileModalCompanyFoldersFolderFragmentDoc}
`;
export const UseMoveFileModalCompanyFoldersCustomFolderFragmentDoc = gql`
	fragment useMoveFileModalCompanyFoldersCustomFolder on CustomFolder {
		id
		name
		parentFolder {
			id
			name
		}
	}
`;
export const MoveFileModalCustomFolderFragmentDoc = gql`
	fragment moveFileModalCustomFolder on CustomFolder {
		...useMoveFileModalCompanyFoldersCustomFolder
	}
	${UseMoveFileModalCompanyFoldersCustomFolderFragmentDoc}
`;
export const MoveFileModalDocumentFragmentDoc = gql`
	fragment moveFileModalDocument on Document {
		...useMoveFileModalCompanyFoldersDocument
	}
	${UseMoveFileModalCompanyFoldersDocumentFragmentDoc}
`;
export const OrgMemberSignUp_OrgUserFieldsFragmentDoc = gql`
	fragment OrgMemberSignUp_OrgUserFields on OrgUser {
		id
		firstName
		lastName
		phone
		user {
			id
			email
			userType
		}
		organization {
			id
			image
			services {
				id
				name
			}
		}
	}
`;
export const OrgOnboarding_ReducedCouponFragmentDoc = gql`
	fragment OrgOnboarding_ReducedCoupon on ReducedCoupon {
		id
		name
		active
		amount_off
		percent_off
		duration_in_months
		duration
		planCost {
			price
			proration
			amountDue
		}
	}
`;
export const OrgOnboardingAddressOrganizationFragmentDoc = gql`
	fragment orgOnboardingAddressOrganization on Organization {
		addressLine1
		addressLine2
		city
		state
		postalCode
		country
	}
`;
export const OrgOnboardingOrganizationFragmentDoc = gql`
	fragment orgOnboardingOrganization on Organization {
		id
		name
		phone
		image
		imageScale
		imageRotation
		imagePositionX
		imagePositionY
		canReceivePayments
		services {
			id
			name
		}
		...orgOnboardingAddressOrganization
	}
	${OrgOnboardingAddressOrganizationFragmentDoc}
`;
export const OrganizationAvatarOnOrganizationForGetQuickPaymentWhereFragmentDoc = gql`
	fragment organizationAvatarOnOrganizationForGetQuickPaymentWhere on OrganizationForGetQuickPayment {
		id
		image
		name
		updatedAt
	}
`;
export const OrganizationDetailHeaderOrganizationFragmentDoc = gql`
	fragment organizationDetailHeaderOrganization on Organization {
		id
		name
		description
		website
		phone
		contactEmail
		facebook
		twitter
		instagram
		pinterest
		updatedAt
		image
		services {
			id
			name
		}
	}
`;
export const PermissionsTogglesPermissionsFragmentDoc = gql`
	fragment permissionsTogglesPermissions on ClientUser {
		plannerOrgHasConnectionPermissions
		plannerOrgCanSignContracts
		plannerOrgCanPayInvoices
		plannerOrgHasDocumentsPermissions
	}
`;
export const PermissionsModalContactFragmentDoc = gql`
	fragment permissionsModalContact on Contact {
		id
		vendor {
			...setPermissionsModalVendor
		}
		customer {
			clientUser {
				id
				...permissionsTogglesPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
			}
		}
	}
	${SetPermissionsModalVendorFragmentDoc}
	${PermissionsTogglesPermissionsFragmentDoc}
`;
export const OrganizationDetailHeaderContactActionButtonContactFragmentDoc = gql`
	fragment organizationDetailHeaderContactActionButtonContact on Contact {
		id
		firstName
		lastName
		...permissionsModalContact
	}
	${PermissionsModalContactFragmentDoc}
`;
export const OrganizationDetailHeaderContactFragmentDoc = gql`
	fragment organizationDetailHeaderContact on Contact {
		id
		firstName
		lastName
		...organizationDetailHeaderContactActionButtonContact
	}
	${OrganizationDetailHeaderContactActionButtonContactFragmentDoc}
`;
export const OrganizationDetailTabsClientPermissionsFragmentDoc = gql`
	fragment organizationDetailTabsClientPermissions on ClientUser {
		id
		plannerOrgHasConnectionPermissions
		plannerOrgCanSignContracts
		plannerOrgCanPayInvoices
		plannerOrgHasDocumentsPermissions
	}
`;
export const OrganizationDetailTabsContactFragmentDoc = gql`
	fragment organizationDetailTabsContact on Contact {
		id
		status
		hasCustomerIntent
		firstName
		lastName
		customer {
			id
			clientUser {
				id
				user {
					id
				}
				assignedPlanner {
					id
					organization {
						id
					}
					user {
						id
					}
				}
			}
			orgUser {
				id
				user {
					id
				}
				organization {
					id
				}
			}
		}
		vendor {
			id
		}
		assignedMember {
			id
		}
	}
`;
export const OrganizationDetailContactFragmentDoc = gql`
	fragment organizationDetailContact on Contact {
		id
		firstName
		lastName
		...organizationDetailTabsContact
		...organizationDetailHeaderContactActionButtonContact
	}
	${OrganizationDetailTabsContactFragmentDoc}
	${OrganizationDetailHeaderContactActionButtonContactFragmentDoc}
`;
export const ConfirmPermissionsChangeModalVendorFragmentDoc = gql`
	fragment confirmPermissionsChangeModalVendor on Organization {
		...vendorProfileVendor
	}
	${VendorProfileVendorFragmentDoc}
`;
export const SetPermissionsModalPermissionsFragmentDoc = gql`
	fragment setPermissionsModalPermissions on ClientUser {
		...permissionsTogglesPermissions
	}
	${PermissionsTogglesPermissionsFragmentDoc}
`;
export const ProposalViewSentToProposalFragmentDoc = gql`
	fragment proposalViewSentToProposal on Proposal {
		id
		contact {
			id
			firstName
			lastName
			companyName
			customer {
				id
				email
			}
			assignedMember {
				id
			}
			vendor {
				id
				users {
					id
					role
					user {
						id
					}
				}
			}
		}
	}
`;
export const DocumentViewEmailNotificationGroupFragmentDoc = gql`
	fragment documentViewEmailNotificationGroup on Proposal {
		id
		emailNotificationGroup {
			id
			groupTitle
			members {
				id
				email
				userType
				orgUser {
					id
					firstName
					lastName
					organization {
						id
					}
				}
			}
		}
	}
`;
export const ProposalViewPresentationProposalFragmentDoc = gql`
	fragment proposalViewPresentationProposal on Proposal {
		id
		status
		isPastDue
		title
		sentAt
		eventDate
		dueDate
		contact {
			id
			customer {
				id
				clientUser {
					id
					plannerOrgCanPayInvoices
					plannerOrgCanSignContracts
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								role
								user {
									id
								}
								organization {
									id
									users {
										id
										role
										user {
											id
										}
									}
								}
							}
						}
					}
				}
			}
			assignedMember {
				user {
					id
				}
			}
			vendor {
				...organizationAvatarOrganization
				users {
					id
					role
					user {
						id
					}
				}
			}
			...getViewingUserDocumentRelationshipContact
		}
		...proposalViewSentToProposal
		...documentViewEmailNotificationGroup
	}
	${OrganizationAvatarOrganizationFragmentDoc}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${ProposalViewSentToProposalFragmentDoc}
	${DocumentViewEmailNotificationGroupFragmentDoc}
`;
export const ProposalViewButtonBarAcceptButtonProposalFragmentDoc = gql`
	fragment proposalViewButtonBarAcceptButtonProposal on Proposal {
		id
		status
		isPastDue
		isReadOnly
		contact {
			...getViewingUserDocumentRelationshipContact
			invoices {
				id
				status
			}
			...documentFollowupActionsContact
		}
	}
	${GetViewingUserDocumentRelationshipContactFragmentDoc}
	${DocumentFollowupActionsContactFragmentDoc}
`;
export const IsAssignedMemberContactFragmentDoc = gql`
	fragment isAssignedMemberContact on Contact {
		assignedMember {
			id
		}
	}
`;
export const IsAdminOrManagerOfVendorContactFragmentDoc = gql`
	fragment isAdminOrManagerOfVendorContact on Contact {
		vendor {
			...isAdminOrganization
		}
	}
	${IsAdminOrganizationFragmentDoc}
`;
export const ProposalViewButtonBarSendButtonFragmentDoc = gql`
	fragment proposalViewButtonBarSendButton on Proposal {
		id
		status
		automatedRemindersEnabled
		sentAt
		source
		imageUrl
		canvaDesign {
			id
		}
		dueDate
		contact {
			id
			firstName
			vendor {
				id
			}
			...isAssignedMemberContact
			...isAdminOrManagerOfVendorContact
		}
	}
	${IsAssignedMemberContactFragmentDoc}
	${IsAdminOrManagerOfVendorContactFragmentDoc}
`;
export const UseProposalViewButtonBarVoidButtonFragmentDoc = gql`
	fragment useProposalViewButtonBarVoidButton on Proposal {
		id
		status
		contact {
			id
			vendor {
				id
			}
		}
	}
`;
export const ProposalViewButtonBarProposalFragmentDoc = gql`
	fragment proposalViewButtonBarProposal on Proposal {
		...proposalViewButtonBarAcceptButtonProposal
		...proposalViewButtonBarSendButton
		...useProposalViewButtonBarVoidButton
	}
	${ProposalViewButtonBarAcceptButtonProposalFragmentDoc}
	${ProposalViewButtonBarSendButtonFragmentDoc}
	${UseProposalViewButtonBarVoidButtonFragmentDoc}
`;
export const EmbeddedFileProposalFragmentDoc = gql`
	fragment embeddedFileProposal on Proposal {
		id
		imageUrl
		filename
	}
`;
export const ProposalPreviewProposalFragmentDoc = gql`
	fragment proposalPreviewProposal on Proposal {
		id
		source
		canvaDesign {
			id
			designId
			editUrl
			viewUrl
			exportedImageUrl
		}
		...embeddedFileProposal
	}
	${EmbeddedFileProposalFragmentDoc}
`;
export const ProposalViewProposalFragmentDoc = gql`
	fragment proposalViewProposal on Proposal {
		...proposalViewPresentationProposal
		...proposalViewButtonBarProposal
		...proposalPreviewProposal
		contact {
			id
			customer {
				id
				clientUser {
					id
					assignedPlanner {
						id
						user {
							id
						}
					}
				}
			}
			...useContactsCompareForDiffContact
		}
	}
	${ProposalViewPresentationProposalFragmentDoc}
	${ProposalViewButtonBarProposalFragmentDoc}
	${ProposalPreviewProposalFragmentDoc}
	${UseContactsCompareForDiffContactFragmentDoc}
`;
export const UseProposalEditButtonBarVoidButtonFragmentDoc = gql`
	fragment useProposalEditButtonBarVoidButton on Proposal {
		id
		status
	}
`;
export const UseProposalEditButtonBarSaveButtonFragmentDoc = gql`
	fragment useProposalEditButtonBarSaveButton on Proposal {
		id
		status
		contact {
			id
		}
	}
`;
export const UseProposalEditButtonBarSendButtonFragmentDoc = gql`
	fragment useProposalEditButtonBarSendButton on Proposal {
		id
		status
		automatedRemindersEnabled
		sentAt
		source
		imageUrl
		canvaDesign {
			id
		}
		eventDate
		dueDate
		title
		contact {
			id
			firstName
		}
	}
`;
export const ProposalEditButtonBarFragmentDoc = gql`
	fragment proposalEditButtonBar on Proposal {
		...useProposalEditButtonBarVoidButton
		...useProposalEditButtonBarSaveButton
		...useProposalEditButtonBarSendButton
	}
	${UseProposalEditButtonBarVoidButtonFragmentDoc}
	${UseProposalEditButtonBarSaveButtonFragmentDoc}
	${UseProposalEditButtonBarSendButtonFragmentDoc}
`;
export const ProposalEditPresentationFragmentDoc = gql`
	fragment proposalEditPresentation on Proposal {
		id
		title
		status
		dueDate
		eventDate
	}
`;
export const UseProposalDesignProposalFragmentDoc = gql`
	fragment useProposalDesignProposal on Proposal {
		id
		source
		filename
		thumbnail
		imageUrl
		canvaDesign {
			id
			editUrl
			viewUrl
			exportedImageUrl
			designId
		}
	}
`;
export const ProposalEditProposalFragmentDoc = gql`
	fragment proposalEditProposal on Proposal {
		id
		eventDate
		source
		isPastDue
		automatedRemindersEnabled
		...proposalEditButtonBar
		...proposalEditPresentation
		...proposalPreviewProposal
		...useProposalDesignProposal
		contact {
			...contactsContextContact
		}
		emailNotificationGroup {
			...useNotificationGroupEmailNotificationGroup
		}
	}
	${ProposalEditButtonBarFragmentDoc}
	${ProposalEditPresentationFragmentDoc}
	${ProposalPreviewProposalFragmentDoc}
	${UseProposalDesignProposalFragmentDoc}
	${ContactsContextContactFragmentDoc}
	${UseNotificationGroupEmailNotificationGroupFragmentDoc}
`;
export const ProposalDetailProposalFragmentDoc = gql`
	fragment proposalDetailProposal on Proposal {
		...proposalViewProposal
		...proposalEditProposal
		contact {
			vendor {
				...useNotificationGroupOrganization
			}
		}
		emailNotificationGroup {
			...useNotificationGroupEmailNotificationGroup
		}
	}
	${ProposalViewProposalFragmentDoc}
	${ProposalEditProposalFragmentDoc}
	${UseNotificationGroupOrganizationFragmentDoc}
	${UseNotificationGroupEmailNotificationGroupFragmentDoc}
`;
export const ProposalEditPreviewOrCreateDesignProposalFragmentDoc = gql`
	fragment proposalEditPreviewOrCreateDesignProposal on Proposal {
		id
		status
		source
		imageUrl
		...proposalPreviewProposal
	}
	${ProposalPreviewProposalFragmentDoc}
`;
export const TemplateGridItemProposalTemplateFragmentDoc = gql`
	fragment templateGridItemProposalTemplate on ProposalTemplate {
		id
		source
		thumbnail
		filename
		title
		canvaDesign {
			id
			exportedImageUrl
			thumbnailUrl
		}
	}
`;
export const TemplatesTabProposalTemplateFragmentDoc = gql`
	fragment templatesTabProposalTemplate on ProposalTemplate {
		id
		...templateGridItemProposalTemplate
	}
	${TemplateGridItemProposalTemplateFragmentDoc}
`;
export const UseProposalTemplateEditButtonBarDeleteButtonFragmentDoc = gql`
	fragment useProposalTemplateEditButtonBarDeleteButton on ProposalTemplate {
		id
	}
`;
export const ProposalTemplateEditButtonBarFragmentDoc = gql`
	fragment proposalTemplateEditButtonBar on ProposalTemplate {
		...useProposalTemplateEditButtonBarDeleteButton
	}
	${UseProposalTemplateEditButtonBarDeleteButtonFragmentDoc}
`;
export const ProposalTemplateEditPresentationFragmentDoc = gql`
	fragment proposalTemplateEditPresentation on ProposalTemplate {
		id
		title
	}
`;
export const EmbeddedFileProposalTemplateFragmentDoc = gql`
	fragment embeddedFileProposalTemplate on ProposalTemplate {
		id
		imageUrl
		filename
	}
`;
export const ProposalPreviewProposalTemplateFragmentDoc = gql`
	fragment proposalPreviewProposalTemplate on ProposalTemplate {
		id
		source
		canvaDesign {
			id
			designId
			viewUrl
			exportedImageUrl
		}
		...embeddedFileProposalTemplate
	}
	${EmbeddedFileProposalTemplateFragmentDoc}
`;
export const UseProposalDesignProposalTemplateFragmentDoc = gql`
	fragment useProposalDesignProposalTemplate on ProposalTemplate {
		id
		source
		filename
		thumbnail
		imageUrl
		canvaDesign {
			id
			editUrl
			viewUrl
			exportedImageUrl
			designId
		}
	}
`;
export const ProposalTemplateEditPreviewOrCreateDesignProposalTemplateFragmentDoc = gql`
	fragment proposalTemplateEditPreviewOrCreateDesignProposalTemplate on ProposalTemplate {
		id
		source
		imageUrl
		canvaDesign {
			id
			editUrl
			viewUrl
			exportedImageUrl
		}
		...proposalPreviewProposalTemplate
	}
	${ProposalPreviewProposalTemplateFragmentDoc}
`;
export const ProposalTemplateEditFragmentDoc = gql`
	fragment proposalTemplateEdit on ProposalTemplate {
		id
		source
		thumbnail
		canvaDesign {
			id
			editUrl
			viewUrl
			exportedImageUrl
		}
		...proposalTemplateEditButtonBar
		...proposalTemplateEditPresentation
		...proposalPreviewProposalTemplate
		...useProposalDesignProposalTemplate
		...proposalTemplateEditPreviewOrCreateDesignProposalTemplate
	}
	${ProposalTemplateEditButtonBarFragmentDoc}
	${ProposalTemplateEditPresentationFragmentDoc}
	${ProposalPreviewProposalTemplateFragmentDoc}
	${UseProposalDesignProposalTemplateFragmentDoc}
	${ProposalTemplateEditPreviewOrCreateDesignProposalTemplateFragmentDoc}
`;
export const ProposalViewButtonBarExportButtonFragmentDoc = gql`
	fragment proposalViewButtonBarExportButton on Proposal {
		id
		source
		imageUrl
		canvaDesign {
			id
			exportedImageUrl
		}
	}
`;
export const ProposalViewPresentationOrganizationFragmentDoc = gql`
	fragment proposalViewPresentationOrganization on Organization {
		...organizationAvatarOrganization
	}
	${OrganizationAvatarOrganizationFragmentDoc}
`;
export const ProposalViewOrganizationFragmentDoc = gql`
	fragment proposalViewOrganization on Organization {
		...proposalViewPresentationOrganization
	}
	${ProposalViewPresentationOrganizationFragmentDoc}
`;
export const ProposalsTableFragmentDoc = gql`
	fragment proposalsTable on Proposal {
		id
		createdAt
		updatedAt
		dueDate
		eventDate
		isPastDue
		status
		imageUrl
		source
		sentAt
		automatedRemindersEnabled
		sentByUser {
			id
			firstName
			lastName
			updatedAt
			user {
				id
			}
		}
		thumbnail
		title
		contact {
			id
			firstName
			lastName
			eventDate
			companyName
			assignedMember {
				id
				organization {
					id
					name
					services {
						id
						name
					}
				}
			}
			customer {
				id
				email
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								role
							}
						}
					}
				}
			}
			vendor {
				id
				name
				image
				updatedAt
				users {
					id
					role
				}
			}
		}
	}
`;
export const ProposalsTableProposalTemplatesFragmentDoc = gql`
	fragment proposalsTableProposalTemplates on ProposalTemplate {
		id
		createdAt
		title
		status
		thumbnail
		proposals {
			id
		}
	}
`;
export const OrganizationAvatarOnGetQuickPaymentFragmentDoc = gql`
	fragment organizationAvatarOnGetQuickPayment on OrganizationForGetQuickPayment {
		id
		image
		name
		phone
		contactEmail
		updatedAt
	}
`;
export const UsePaymentSectionQuickPaymentFragmentDoc = gql`
	fragment usePaymentSectionQuickPayment on QuickPaymentForGetQuickPayment {
		id
		amount
		reason
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
				userType
			}
		}
		organization {
			id
			country
			users {
				id
				user {
					id
					email
				}
			}
		}
	}
`;
export const PaymentSectionOnGetQuickPaymentFragmentDoc = gql`
	fragment paymentSectionOnGetQuickPayment on QuickPaymentForGetQuickPayment {
		id
		amount
		reason
		organization {
			id
			cardConvenienceFeePercentage
			achConvenienceFeePercentage
			name
		}
		...usePaymentSectionQuickPayment
	}
	${UsePaymentSectionQuickPaymentFragmentDoc}
`;
export const UsePaymentSectionContactFragmentDoc = gql`
	fragment usePaymentSectionContact on Contact {
		id
		firstName
		lastName
		customer {
			id
			email
			userType
		}
	}
`;
export const ResourceDetailHeaderResourceFragmentDoc = gql`
	fragment resourceDetailHeaderResource on CustomResource {
		id
		description
		category
		sponsor {
			id
			name
			logo
			sponsorLink
		}
	}
`;
export const ResourceDetailFileViewerResourceFragmentDoc = gql`
	fragment resourceDetailFileViewerResource on CustomResource {
		id
		previewDownloadUrl
	}
`;
export const ResourceDetailButtonBarDownloadButtonResourceFragmentDoc = gql`
	fragment resourceDetailButtonBarDownloadButtonResource on CustomResource {
		id
		description
	}
`;
export const ResourceDetailButtonBarResourceFragmentDoc = gql`
	fragment resourceDetailButtonBarResource on CustomResource {
		...resourceDetailButtonBarDownloadButtonResource
	}
	${ResourceDetailButtonBarDownloadButtonResourceFragmentDoc}
`;
export const ResourceDetailFragmentDoc = gql`
	fragment resourceDetail on CustomResource {
		...resourceDetailHeaderResource
		...resourceDetailFileViewerResource
		...resourceDetailButtonBarResource
	}
	${ResourceDetailHeaderResourceFragmentDoc}
	${ResourceDetailFileViewerResourceFragmentDoc}
	${ResourceDetailButtonBarResourceFragmentDoc}
`;
export const ResourcesTableFragmentDoc = gql`
	fragment resourcesTable on CustomResource {
		id
		fileType
		category
		description
		status
		createdAt
		updatedAt
		sponsor {
			id
			logo
			name
			description
			sponsorLink
		}
	}
`;
export const DocumentContactFragmentFragmentDoc = gql`
	fragment DocumentContactFragment on Contact {
		id
		customer {
			id
		}
	}
`;
export const UseVendorDashboard_DashboardStatsForOrgFragmentDoc = gql`
	fragment useVendorDashboard_dashboardStatsForOrg on OrgDashboardStats {
		leads {
			id
			firstName
			lastName
			email
		}
		clients {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
		newClients {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
		proposalsAccepted {
			id
			title
			contact {
				id
				customer {
					id
					email
				}
			}
		}
		proposalsOutstanding {
			id
			title
			contact {
				id
				customer {
					id
					email
				}
			}
		}
		paymentsReceived {
			totalAmountReceived
			invoices {
				id
				title
				amount
				clientEmail
			}
		}
		proposalsStatusSummary {
			totalProposalsAccepted
			totalProposalsDrafts
			totalProposalsOverdue
			totalProposalsSent
		}
		contractsOutstanding {
			id
			title
			signatures {
				id
				customerSignature {
					id
					contact {
						id
						customer {
							id
							email
						}
					}
				}
			}
		}
		contractsCompleted {
			id
			title
			signatures {
				id
				customerSignature {
					id
					contact {
						id
						customer {
							id
							email
						}
					}
				}
			}
		}
		contractsSummary {
			totalContractsSigned
			totalContractsAwaitingSignature
			totalContractsDrafts
			totalContractsOverdue
		}
		failedPayments {
			totalAmountFailed
			invoices {
				id
				title
				amount
				clientEmail
			}
		}
		paymentsSummary {
			totalInvoicesPaid
			totalAmountUpcoming
			totalInvoicesDrafts
			totalInvoicesOverdue
			totalAmountRefunded
		}
		upcomingPayments {
			totalAmountUpcoming
			invoices {
				id
				title
				amount
				clientEmail
			}
		}
		overduePayments {
			totalAmountOverdue
			invoices {
				id
				title
				amount
				clientEmail
			}
		}
		leadsGraph {
			labels
			current {
				x
				y
			}
			previous {
				x
				y
			}
		}
		clientsGraph {
			labels
			current {
				x
				y
			}
			previous {
				x
				y
			}
		}
		contractsCompletedGraph {
			labels
			current {
				x
				y
			}
			previous {
				x
				y
			}
		}
		proposalsAcceptedGraph {
			labels
			current {
				x
				y
			}
			previous {
				x
				y
			}
		}
		paymentsReceivedGraph {
			labels
			current {
				x
				y
			}
			previous {
				x
				y
			}
		}
		topCustomersBySpend {
			contactEmail
			contactName
			customerId
			totalLifetimeSpend
		}
	}
`;
export const UseDashboardConfigurationVendorDashboardItemFragmentDoc = gql`
	fragment useDashboardConfigurationVendorDashboardItem on VendorDashboardItem {
		id
		order
		enabled
		type
	}
`;
export const UseDashboardConfigurationUserFragmentDoc = gql`
	fragment useDashboardConfigurationUser on User {
		id
		vendorDashboardConfigurationItems {
			...useDashboardConfigurationVendorDashboardItem
		}
	}
	${UseDashboardConfigurationVendorDashboardItemFragmentDoc}
`;
export const InvitationSubMenuInvitationFragmentDoc = gql`
	fragment invitationSubMenuInvitation on Invitation {
		id
		createdAt
		recipientFirstName
		recipientLastName
		emailAddress
		invitationType
	}
`;
export const UseVendorsTableContactFragmentDoc = gql`
	fragment useVendorsTableContact on Contact {
		id
		createdAt
		eventDate
		firstName
		lastName
		phone
		status
		updatedAt
		hasCustomerIntent
		customer {
			id
			email
			blocked
			createdAt
			updatedAt
			userType
			eventsLastViewedAt
			clientUser {
				id
				updatedAt
				createdAt
				updatedAt
				firstNameOne
				lastNameOne
				firstNameTwo
				lastNameTwo
				phone
				weddingDate
				addressLine1
				addressLine2
				city
				country
				postalCode
				phone
				plannerOrgCanPayInvoices
				plannerOrgCanSignContracts
				plannerOrgHasConnectionPermissions
				plannerOrgHasDocumentsPermissions
				assignedPlanner {
					id
					organization {
						id
					}
				}
				user {
					id
					email
					userType
				}
			}
			orgUser {
				id
				firstName
				lastName
				user {
					id
					email
					userType
				}
			}
			guestUser {
				id
				user {
					id
					email
				}
			}
		}
		assignedMember {
			id
			firstName
			lastName
			role
			createdAt
			updatedAt
			user {
				id
				email
				blocked
				createdAt
				updatedAt
				userType
				eventsLastViewedAt
			}
		}
		vendor {
			id
			name
			updatedAt
			image
			contactEmail
			services {
				id
				name
			}
		}
	}
`;
export const UseVendorsTableInvitationFragmentDoc = gql`
	fragment useVendorsTableInvitation on Invitation {
		id
		createdAt
		recipientFirstName
		recipientLastName
		emailAddress
		invitationType
	}
`;
export const PaymentMethodHistoryTable_HistoryFragmentDoc = gql`
	fragment paymentMethodHistoryTable_history on PaymentHistoryItem {
		amount
		date
		type
		organization {
			id
			name
		}
		id
		invoice {
			id
			title
		}
		currency
	}
`;
export const WalletDrawerSourceFragmentDoc = gql`
	fragment walletDrawerSource on Source {
		id
		object
		name
		brand
		last4
		status
		exp_year
		exp_month
		fingerprint
		metadata {
			key
			value
		}
		legacy
	}
`;
export const UpdateBankAccountSourceFragmentDoc = gql`
	fragment updateBankAccountSource on Source {
		id
		object
		billing_details {
			name
		}
		account_holder_type
		metadata {
			key
			value
		}
	}
`;
export const UpdateCardSourceFragmentDoc = gql`
	fragment updateCardSource on Source {
		id
		name
		address_zip
		exp_month
		exp_year
		billing_details {
			name
			address {
				postal_code
			}
		}
		metadata {
			key
			value
		}
	}
`;
export const UpdatePaymentMethodSourceFragmentDoc = gql`
	fragment updatePaymentMethodSource on Source {
		id
		last4
		object
		status
		billing_details {
			name
			address {
				postal_code
			}
		}
		metadata {
			key
			value
		}
		...updateBankAccountSource
		...updateCardSource
	}
	${UpdateBankAccountSourceFragmentDoc}
	${UpdateCardSourceFragmentDoc}
`;
export const DeletePaymentMethodSourceFragmentDoc = gql`
	fragment deletePaymentMethodSource on Source {
		id
		last4
		object
		status
		metadata {
			key
			value
		}
	}
`;
export const SourceForCustomerWalletDrawerFragmentDoc = gql`
	fragment sourceForCustomerWalletDrawer on Source {
		...walletDrawerSource
		...updatePaymentMethodSource
		...deletePaymentMethodSource
	}
	${WalletDrawerSourceFragmentDoc}
	${UpdatePaymentMethodSourceFragmentDoc}
	${DeletePaymentMethodSourceFragmentDoc}
`;
export const GetPaymentSourcesForCustomerSourceFragmentDoc = gql`
	fragment getPaymentSourcesForCustomerSource on Source {
		id
		bank_name
		object
		last4
		brand
		metadata {
			key
			value
		}
		...sourceForCustomerWalletDrawer
	}
	${SourceForCustomerWalletDrawerFragmentDoc}
`;
export const OfflinePaymentHistoryItemFragmentDoc = gql`
	fragment OfflinePaymentHistoryItem on OfflinePaymentHistoryItem {
		id
		type
		amount
		name
		paymentType
		date
		invoice {
			id
			title
			gratuityAmount
			clientUser {
				id
				firstNameOne
				lastNameOne
				firstNameTwo
				lastNameTwo
			}
			organization {
				id
				country
			}
		}
	}
`;
export const ChargeAccountSourceFragmentDoc = gql`
	fragment chargeAccountSource on Source {
		id
		last4
		address_zip
		account_holder_name
		account_holder_type
		name
		object
		brand
		bank_name
		exp_month
		exp_year
		status
		country
	}
`;
export const SourceForVendorPayToFragmentDoc = gql`
	fragment sourceForVendorPayTo on Source {
		id
		object
		account_holder_name
		account_holder_type
		bank_name
		country
		metadata {
			key
			value
		}
	}
`;
export const QuickPaymentsTableInvoicesWalletQuickPaymentInvoiceFragmentDoc = gql`
	fragment quickPaymentsTableInvoicesWalletQuickPaymentInvoice on WalletQuickPaymentInvoice {
		id
		title
		paymentDate
		amountPaid
	}
`;
export const QuickPaymentsTableWalletQuickPaymentFragmentDoc = gql`
	fragment quickPaymentsTableWalletQuickPayment on WalletQuickPayment {
		id
		createdAt
		link
		name
		amount
		reason
		payments
		total
		invoices {
			id
			title
			paymentDate
			amountPaid
		}
	}
`;
export const StripeInvoiceListStripeInvoiceFragmentDoc = gql`
	fragment stripeInvoiceListStripeInvoice on StripeInvoice {
		id
		status
		total
		period_start
		period_end
		invoice_pdf
	}
`;
export const SubscriptionPaymentMethodModalsStripeUserFragmentDoc = gql`
	fragment subscriptionPaymentMethodModalsStripeUser on StripeUser {
		id
		sources {
			data {
				...subscriptionPaymentMethodModalsSource
			}
		}
	}
	${SubscriptionPaymentMethodModalsSourceFragmentDoc}
`;
export const VendorTransactionHistoryPayoutFragmentDoc = gql`
	fragment vendorTransactionHistoryPayout on TransactionHistoryPayout {
		id
		date
		amount
		type
		status
	}
`;
export const VendorTransactionChargeFragmentDoc = gql`
	fragment vendorTransactionCharge on TransactionHistoryChargeOrRefund {
		id
		type
		status
		date
		amount
		metadata {
			key
			value
		}
		contact {
			firstName
			lastName
			status
			customer {
				id
				email
			}
		}
		invoice {
			id
			title
		}
	}
`;
export const VendorTransactionHistoryItemFragmentDoc = gql`
	fragment VendorTransactionHistoryItem on TransactionHistoryItem {
		payout {
			...vendorTransactionHistoryPayout
		}
		transactions {
			...vendorTransactionCharge
		}
	}
	${VendorTransactionHistoryPayoutFragmentDoc}
	${VendorTransactionChargeFragmentDoc}
`;
export const FinancialConnectionsAccountAccountNumbersUpdatedEventFragmentDoc = gql`
	fragment financialConnectionsAccountAccountNumbersUpdatedEvent on Event {
		id
		category
		metadata
	}
`;
export const GetInstallmentRefundRequestedEventPropsFragmentDoc = gql`
	fragment getInstallmentRefundRequestedEventProps on Event {
		id
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
				clientUser {
					id
					assignedPlanner {
						id
						organization {
							id
							users {
								id
								role
							}
						}
					}
				}
			}
		}
		clientUser {
			id
		}
		vendor {
			id
			name
		}
		invoice {
			id
			title
		}
		actingUser {
			id
			orgUser {
				id
				firstName
				lastName
			}
		}
	}
`;
export const InvoiceSentOrResentByEventPropsEventFragmentDoc = gql`
	fragment invoiceSentOrResentByEventPropsEvent on Event {
		id
		category
		actingUser {
			id
		}
		resolvedAt
		invoice {
			id
			title
			organization {
				id
			}
		}
		contact {
			id
			firstName
			lastName
			customer {
				id
				email
				clientUser {
					id
					plannerOrgCanPayInvoices
					assignedPlanner {
						id
						organization {
							id
						}
					}
				}
			}
		}
		vendor {
			id
			name
		}
	}
`;
export const PaymentMethodVerificationEventPropsEventFragmentDoc = gql`
	fragment paymentMethodVerificationEventPropsEvent on Event {
		id
		category
		message
		referenceID
		actingUser {
			id
		}
	}
`;
export const GetUserEmailBlockedOrUnblockedEventPropsEventFragmentDoc = gql`
	fragment getUserEmailBlockedOrUnblockedEventPropsEvent on Event {
		id
		category
		message
		contact {
			id
		}
		inquiry {
			id
			organization {
				id
				createdAt
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					name
				}
			}
		}
		orgUser {
			id
		}
	}
`;
export const DeletePaymentMethodInvoiceFragmentDoc = gql`
	fragment deletePaymentMethodInvoice on Invoice {
		id
		paymentInstallments {
			id
			status
			scheduledPaymentDate
			scheduledPaymentMethod
		}
	}
`;
export const InviteForm_GetPendingInvitationsFragmentDoc = gql`
	fragment inviteForm_getPendingInvitations on PendingInvitations {
		_count
		pendingInvitations {
			createdAt
			id
			recipientFirstName
			recipientLastName
			invitationType
			emailAddress
		}
	}
`;
export const NewPaymentSourceFragmentDoc = gql`
	fragment newPaymentSource on Source {
		id
		metadata {
			key
			value
		}
	}
`;
export const UpdateCustomerStripeCardFragmentDoc = gql`
	fragment updateCustomerStripeCard on StripeUser {
		id
		default_source
		sources {
			data {
				id
				metadata {
					key
					value
				}
			}
		}
	}
`;
export const UpdateExternalAccountSourceFragmentDoc = gql`
	fragment updateExternalAccountSource on Source {
		id
		account_holder_name
		account_holder_type
		country
		metadata {
			key
			value
		}
		routing_number
	}
`;
export const UseContacts_ContactFragmentDoc = gql`
	fragment useContacts_contact on Contact {
		id
		firstName
		lastName
		eventDate
		venue
		phone
		note
		status
		companyName
		source
		hasCustomerIntent
		customer {
			id
			email
		}
		assignedMember {
			id
		}
		vendor {
			id
		}
	}
`;
export const UseContacts_ContactOnSignatureFragmentDoc = gql`
	fragment useContacts_contactOnSignature on CustomerSignatureContact {
		id
		status
		firstName
		lastName
		eventDate
		venue
		phone
		note
		companyName
		hasCustomerIntent
		customer {
			id
			email
		}
		assignedMember {
			id
		}
		vendor {
			id
		}
	}
`;
export const FetchContactSuggestions_GetInquiriesForOrganizationInquiryFragmentDoc = gql`
	fragment fetchContactSuggestions_GetInquiriesForOrganizationInquiry on Inquiry {
		id
		firstName
		lastName
		companyName
		email
		eventDate
		source
		status
		contact {
			id
			customer {
				id
				email
			}
		}
	}
`;
export const UseLeadsContactFragmentDoc = gql`
	fragment useLeadsContact on Contact {
		id
		eventDate
		customer {
			id
			email
		}
	}
`;
export const UseLeadsInquiryFragmentDoc = gql`
	fragment useLeadsInquiry on Inquiry {
		id
		firstName
		lastName
		email
		companyName
		source
		eventDate
		contact {
			...useLeadsContact
		}
	}
	${UseLeadsContactFragmentDoc}
`;
export const PaymentElementContainerContactForGetQuickPaymentFragmentFragmentDoc = gql`
	fragment paymentElementContainerContactForGetQuickPaymentFragment on ContactForGetQuickPayment {
		id
		firstName
		lastName
		customer {
			id
			email
		}
	}
`;
export const PaymentElementContainerContactForCreateOrUpdateContactForCustomerFragmentFragmentDoc = gql`
	fragment paymentElementContainerContactForCreateOrUpdateContactForCustomerFragment on Contact {
		id
		firstName
		lastName
		customer {
			id
			email
		}
	}
`;
export const GetAuthedUserFlattenedUserFieldsCalculatedOrgUserFragmentDoc = gql`
	fragment getAuthedUserFlattenedUserFieldsCalculatedOrgUser on CalculatedOrgUser {
		id
		role
		phone
		isAdmin
		isOwner
		firstName
		lastName
		updatedAt
		user {
			id
			userType
			email
			onboardingCompleted
			stripeCustomerId
		}
		organization {
			id
			addressLine1
			addressLine2
			city
			state
			country
			postalCode
			createdAt
			name
			website
			phone
			contactEmail
			description
			image
			imageScale
			imageRotation
			imagePositionX
			imagePositionY
			brandedEmails
			automatedRemindersEnabled
			invoicesAllowGratuity
			canReceivePayments
			updatedAt
			facebook
			instagram
			twitter
			pinterest
			coupon {
				id
				name
			}
			groups {
				id
				name
			}
			services {
				id
				name
			}
			subscription {
				id
				status
				subscriptionPlan {
					id
					period
					type
				}
			}
			users {
				id
				role
			}
			hasStripeVerificationNeeds
			rootFolder {
				id
			}
		}
	}
`;
export const GetAuthedUserFlattenedUserFieldsFragmentDoc = gql`
	fragment getAuthedUserFlattenedUserFields on AuthedUser {
		userType
		id
		clientUser {
			id
			description
			firstNameOne
			lastNameOne
			firstNameTwo
			lastNameTwo
			updatedAt
			facebook
			instagram
			twitter
			pinterest
			weddingDate
			venue
			user {
				id
				userType
				email
				onboardingCompleted
				stripeCustomerId
			}
			assignedPlanner {
				id
				firstName
				lastName
				updatedAt
				organization {
					id
					name
					updatedAt
				}
			}
		}
		orgUser {
			...getAuthedUserFlattenedUserFieldsCalculatedOrgUser
		}
		superAdmin {
			id
			firstName
			lastName
			updatedAt
			user {
				id
				userType
				email
			}
		}
		groups {
			id
			name
		}
	}
	${GetAuthedUserFlattenedUserFieldsCalculatedOrgUserFragmentDoc}
`;
export const OrgMemberSignUpPage_GetOrgUserWhereDocument = gql`
	query OrgMemberSignUpPage_GetOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			phone
			firstName
			lastName
			user {
				id
				email
				acceptedTerms
			}
		}
	}
`;

/**
 * __useOrgMemberSignUpPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useOrgMemberSignUpPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgMemberSignUpPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgMemberSignUpPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgMemberSignUpPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgMemberSignUpPage_GetOrgUserWhereQuery,
		OrgMemberSignUpPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgMemberSignUpPage_GetOrgUserWhereQuery,
		OrgMemberSignUpPage_GetOrgUserWhereQueryVariables
	>(OrgMemberSignUpPage_GetOrgUserWhereDocument, options);
}
export function useOrgMemberSignUpPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgMemberSignUpPage_GetOrgUserWhereQuery,
		OrgMemberSignUpPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgMemberSignUpPage_GetOrgUserWhereQuery,
		OrgMemberSignUpPage_GetOrgUserWhereQueryVariables
	>(OrgMemberSignUpPage_GetOrgUserWhereDocument, options);
}
export type OrgMemberSignUpPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useOrgMemberSignUpPage_GetOrgUserWhereQuery
>;
export type OrgMemberSignUpPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useOrgMemberSignUpPage_GetOrgUserWhereLazyQuery
>;
export type OrgMemberSignUpPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	OrgMemberSignUpPage_GetOrgUserWhereQuery,
	OrgMemberSignUpPage_GetOrgUserWhereQueryVariables
>;
export const SignUpPage_GetInvitationWhereDocument = gql`
	query SignUpPage_getInvitationWhere($where: InvitationWhereCustomInput!) {
		getInvitationWhere(where: $where) {
			createdAt
			id
			recipientFirstName
			recipientLastName
			emailAddress
			invitationType
		}
	}
`;

/**
 * __useSignUpPage_GetInvitationWhereQuery__
 *
 * To run a query within a React component, call `useSignUpPage_GetInvitationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpPage_GetInvitationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpPage_GetInvitationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSignUpPage_GetInvitationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		SignUpPage_GetInvitationWhereQuery,
		SignUpPage_GetInvitationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SignUpPage_GetInvitationWhereQuery,
		SignUpPage_GetInvitationWhereQueryVariables
	>(SignUpPage_GetInvitationWhereDocument, options);
}
export function useSignUpPage_GetInvitationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SignUpPage_GetInvitationWhereQuery,
		SignUpPage_GetInvitationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SignUpPage_GetInvitationWhereQuery,
		SignUpPage_GetInvitationWhereQueryVariables
	>(SignUpPage_GetInvitationWhereDocument, options);
}
export type SignUpPage_GetInvitationWhereQueryHookResult = ReturnType<
	typeof useSignUpPage_GetInvitationWhereQuery
>;
export type SignUpPage_GetInvitationWhereLazyQueryHookResult = ReturnType<
	typeof useSignUpPage_GetInvitationWhereLazyQuery
>;
export type SignUpPage_GetInvitationWhereQueryResult = Apollo.QueryResult<
	SignUpPage_GetInvitationWhereQuery,
	SignUpPage_GetInvitationWhereQueryVariables
>;
export const SignUpPage_GetVerificationTokenDocument = gql`
	query signUpPage_getVerificationToken(
		$where: VerificationTokenWhereUniqueInput!
	) {
		getVerificationToken(where: $where) {
			email
			id
		}
	}
`;

/**
 * __useSignUpPage_GetVerificationTokenQuery__
 *
 * To run a query within a React component, call `useSignUpPage_GetVerificationTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpPage_GetVerificationTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpPage_GetVerificationTokenQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSignUpPage_GetVerificationTokenQuery(
	baseOptions: Apollo.QueryHookOptions<
		SignUpPage_GetVerificationTokenQuery,
		SignUpPage_GetVerificationTokenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SignUpPage_GetVerificationTokenQuery,
		SignUpPage_GetVerificationTokenQueryVariables
	>(SignUpPage_GetVerificationTokenDocument, options);
}
export function useSignUpPage_GetVerificationTokenLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SignUpPage_GetVerificationTokenQuery,
		SignUpPage_GetVerificationTokenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SignUpPage_GetVerificationTokenQuery,
		SignUpPage_GetVerificationTokenQueryVariables
	>(SignUpPage_GetVerificationTokenDocument, options);
}
export type SignUpPage_GetVerificationTokenQueryHookResult = ReturnType<
	typeof useSignUpPage_GetVerificationTokenQuery
>;
export type SignUpPage_GetVerificationTokenLazyQueryHookResult = ReturnType<
	typeof useSignUpPage_GetVerificationTokenLazyQuery
>;
export type SignUpPage_GetVerificationTokenQueryResult = Apollo.QueryResult<
	SignUpPage_GetVerificationTokenQuery,
	SignUpPage_GetVerificationTokenQueryVariables
>;
export const SignUpPage_IsEmailAvailableDocument = gql`
	query signUpPage_isEmailAvailable($email: String!) {
		isEmailAvailable(email: $email)
	}
`;

/**
 * __useSignUpPage_IsEmailAvailableQuery__
 *
 * To run a query within a React component, call `useSignUpPage_IsEmailAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpPage_IsEmailAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpPage_IsEmailAvailableQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSignUpPage_IsEmailAvailableQuery(
	baseOptions: Apollo.QueryHookOptions<
		SignUpPage_IsEmailAvailableQuery,
		SignUpPage_IsEmailAvailableQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SignUpPage_IsEmailAvailableQuery,
		SignUpPage_IsEmailAvailableQueryVariables
	>(SignUpPage_IsEmailAvailableDocument, options);
}
export function useSignUpPage_IsEmailAvailableLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SignUpPage_IsEmailAvailableQuery,
		SignUpPage_IsEmailAvailableQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SignUpPage_IsEmailAvailableQuery,
		SignUpPage_IsEmailAvailableQueryVariables
	>(SignUpPage_IsEmailAvailableDocument, options);
}
export type SignUpPage_IsEmailAvailableQueryHookResult = ReturnType<
	typeof useSignUpPage_IsEmailAvailableQuery
>;
export type SignUpPage_IsEmailAvailableLazyQueryHookResult = ReturnType<
	typeof useSignUpPage_IsEmailAvailableLazyQuery
>;
export type SignUpPage_IsEmailAvailableQueryResult = Apollo.QueryResult<
	SignUpPage_IsEmailAvailableQuery,
	SignUpPage_IsEmailAvailableQueryVariables
>;
export const SignUpPage_GetOrganizationFromInvitationDocument = gql`
	query SignUpPage_getOrganizationFromInvitation(
		$where: InvitationWhereCustomInput!
	) {
		getOrganizationFromInvitation(where: $where) {
			id
			name
		}
	}
`;

/**
 * __useSignUpPage_GetOrganizationFromInvitationQuery__
 *
 * To run a query within a React component, call `useSignUpPage_GetOrganizationFromInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpPage_GetOrganizationFromInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpPage_GetOrganizationFromInvitationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSignUpPage_GetOrganizationFromInvitationQuery(
	baseOptions: Apollo.QueryHookOptions<
		SignUpPage_GetOrganizationFromInvitationQuery,
		SignUpPage_GetOrganizationFromInvitationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SignUpPage_GetOrganizationFromInvitationQuery,
		SignUpPage_GetOrganizationFromInvitationQueryVariables
	>(SignUpPage_GetOrganizationFromInvitationDocument, options);
}
export function useSignUpPage_GetOrganizationFromInvitationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SignUpPage_GetOrganizationFromInvitationQuery,
		SignUpPage_GetOrganizationFromInvitationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SignUpPage_GetOrganizationFromInvitationQuery,
		SignUpPage_GetOrganizationFromInvitationQueryVariables
	>(SignUpPage_GetOrganizationFromInvitationDocument, options);
}
export type SignUpPage_GetOrganizationFromInvitationQueryHookResult =
	ReturnType<typeof useSignUpPage_GetOrganizationFromInvitationQuery>;
export type SignUpPage_GetOrganizationFromInvitationLazyQueryHookResult =
	ReturnType<typeof useSignUpPage_GetOrganizationFromInvitationLazyQuery>;
export type SignUpPage_GetOrganizationFromInvitationQueryResult =
	Apollo.QueryResult<
		SignUpPage_GetOrganizationFromInvitationQuery,
		SignUpPage_GetOrganizationFromInvitationQueryVariables
	>;
export const AdminPage_GetOrgUserWhereDocument = gql`
	query AdminPage_GetOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			role
			user {
				id
				blocked
			}
			organization {
				id
				name
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useAdminPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useAdminPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		AdminPage_GetOrgUserWhereQuery,
		AdminPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		AdminPage_GetOrgUserWhereQuery,
		AdminPage_GetOrgUserWhereQueryVariables
	>(AdminPage_GetOrgUserWhereDocument, options);
}
export function useAdminPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AdminPage_GetOrgUserWhereQuery,
		AdminPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AdminPage_GetOrgUserWhereQuery,
		AdminPage_GetOrgUserWhereQueryVariables
	>(AdminPage_GetOrgUserWhereDocument, options);
}
export type AdminPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useAdminPage_GetOrgUserWhereQuery
>;
export type AdminPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useAdminPage_GetOrgUserWhereLazyQuery
>;
export type AdminPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	AdminPage_GetOrgUserWhereQuery,
	AdminPage_GetOrgUserWhereQueryVariables
>;
export const ClientDetailPage_GetContactWhereDocument = gql`
	query clientDetailPage_getContactWhere($where: ContactWhereInput!) {
		getContactWhere(where: $where) {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
	}
`;

/**
 * __useClientDetailPage_GetContactWhereQuery__
 *
 * To run a query within a React component, call `useClientDetailPage_GetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDetailPage_GetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDetailPage_GetContactWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientDetailPage_GetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientDetailPage_GetContactWhereQuery,
		ClientDetailPage_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientDetailPage_GetContactWhereQuery,
		ClientDetailPage_GetContactWhereQueryVariables
	>(ClientDetailPage_GetContactWhereDocument, options);
}
export function useClientDetailPage_GetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientDetailPage_GetContactWhereQuery,
		ClientDetailPage_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientDetailPage_GetContactWhereQuery,
		ClientDetailPage_GetContactWhereQueryVariables
	>(ClientDetailPage_GetContactWhereDocument, options);
}
export type ClientDetailPage_GetContactWhereQueryHookResult = ReturnType<
	typeof useClientDetailPage_GetContactWhereQuery
>;
export type ClientDetailPage_GetContactWhereLazyQueryHookResult = ReturnType<
	typeof useClientDetailPage_GetContactWhereLazyQuery
>;
export type ClientDetailPage_GetContactWhereQueryResult = Apollo.QueryResult<
	ClientDetailPage_GetContactWhereQuery,
	ClientDetailPage_GetContactWhereQueryVariables
>;
export const ContractViewPage_GetOrgUserWhereDocument = gql`
	query ContractViewPage_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				createdAt
				users {
					id
					role
				}
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
				helloSignID
			}
		}
	}
`;

/**
 * __useContractViewPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useContractViewPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractViewPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractViewPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractViewPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractViewPage_GetOrgUserWhereQuery,
		ContractViewPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractViewPage_GetOrgUserWhereQuery,
		ContractViewPage_GetOrgUserWhereQueryVariables
	>(ContractViewPage_GetOrgUserWhereDocument, options);
}
export function useContractViewPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractViewPage_GetOrgUserWhereQuery,
		ContractViewPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractViewPage_GetOrgUserWhereQuery,
		ContractViewPage_GetOrgUserWhereQueryVariables
	>(ContractViewPage_GetOrgUserWhereDocument, options);
}
export type ContractViewPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useContractViewPage_GetOrgUserWhereQuery
>;
export type ContractViewPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useContractViewPage_GetOrgUserWhereLazyQuery
>;
export type ContractViewPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	ContractViewPage_GetOrgUserWhereQuery,
	ContractViewPage_GetOrgUserWhereQueryVariables
>;
export const ContractViewPage_GetContractWhereDocument = gql`
	query contractViewPage_getContractWhere(
		$where: ContractWhereInputWithMFAToken!
	) {
		getContractWhere(where: $where) {
			contract {
				id
				title
				status
				signatures {
					id
					customerSignature {
						id
						contact {
							id
							customer {
								id
							}
						}
					}
				}
				vendor {
					id
					helloSignID
				}
				...contractViewPage_contract
			}
			requestingUserBaseId
		}
	}
	${ContractViewPage_ContractFragmentDoc}
`;

/**
 * __useContractViewPage_GetContractWhereQuery__
 *
 * To run a query within a React component, call `useContractViewPage_GetContractWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractViewPage_GetContractWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractViewPage_GetContractWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractViewPage_GetContractWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractViewPage_GetContractWhereQuery,
		ContractViewPage_GetContractWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractViewPage_GetContractWhereQuery,
		ContractViewPage_GetContractWhereQueryVariables
	>(ContractViewPage_GetContractWhereDocument, options);
}
export function useContractViewPage_GetContractWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractViewPage_GetContractWhereQuery,
		ContractViewPage_GetContractWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractViewPage_GetContractWhereQuery,
		ContractViewPage_GetContractWhereQueryVariables
	>(ContractViewPage_GetContractWhereDocument, options);
}
export type ContractViewPage_GetContractWhereQueryHookResult = ReturnType<
	typeof useContractViewPage_GetContractWhereQuery
>;
export type ContractViewPage_GetContractWhereLazyQueryHookResult = ReturnType<
	typeof useContractViewPage_GetContractWhereLazyQuery
>;
export type ContractViewPage_GetContractWhereQueryResult = Apollo.QueryResult<
	ContractViewPage_GetContractWhereQuery,
	ContractViewPage_GetContractWhereQueryVariables
>;
export const ContractTemplateEditPage_GetOrgUserWhereDocument = gql`
	query contractTemplateEditPage_getOrgUserWhere(
		$where: OrgUserWhereUniqueInput!
	) {
		getOrgUserWhere(where: $where) {
			id
			role
			organization {
				id
				helloSignID
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useContractTemplateEditPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useContractTemplateEditPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEditPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateEditPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractTemplateEditPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractTemplateEditPage_GetOrgUserWhereQuery,
		ContractTemplateEditPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractTemplateEditPage_GetOrgUserWhereQuery,
		ContractTemplateEditPage_GetOrgUserWhereQueryVariables
	>(ContractTemplateEditPage_GetOrgUserWhereDocument, options);
}
export function useContractTemplateEditPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractTemplateEditPage_GetOrgUserWhereQuery,
		ContractTemplateEditPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractTemplateEditPage_GetOrgUserWhereQuery,
		ContractTemplateEditPage_GetOrgUserWhereQueryVariables
	>(ContractTemplateEditPage_GetOrgUserWhereDocument, options);
}
export type ContractTemplateEditPage_GetOrgUserWhereQueryHookResult =
	ReturnType<typeof useContractTemplateEditPage_GetOrgUserWhereQuery>;
export type ContractTemplateEditPage_GetOrgUserWhereLazyQueryHookResult =
	ReturnType<typeof useContractTemplateEditPage_GetOrgUserWhereLazyQuery>;
export type ContractTemplateEditPage_GetOrgUserWhereQueryResult =
	Apollo.QueryResult<
		ContractTemplateEditPage_GetOrgUserWhereQuery,
		ContractTemplateEditPage_GetOrgUserWhereQueryVariables
	>;
export const ContractTemplateEditPage_GetOrganizationContractTemplateDocument = gql`
	query contractTemplateEditPage_getOrganizationContractTemplate(
		$where: ContractTemplateWhereUniqueInput!
	) {
		getOrganizationContractTemplate(where: $where) {
			id
			title
		}
	}
`;

/**
 * __useContractTemplateEditPage_GetOrganizationContractTemplateQuery__
 *
 * To run a query within a React component, call `useContractTemplateEditPage_GetOrganizationContractTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEditPage_GetOrganizationContractTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateEditPage_GetOrganizationContractTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractTemplateEditPage_GetOrganizationContractTemplateQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractTemplateEditPage_GetOrganizationContractTemplateQuery,
		ContractTemplateEditPage_GetOrganizationContractTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractTemplateEditPage_GetOrganizationContractTemplateQuery,
		ContractTemplateEditPage_GetOrganizationContractTemplateQueryVariables
	>(ContractTemplateEditPage_GetOrganizationContractTemplateDocument, options);
}
export function useContractTemplateEditPage_GetOrganizationContractTemplateLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractTemplateEditPage_GetOrganizationContractTemplateQuery,
		ContractTemplateEditPage_GetOrganizationContractTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractTemplateEditPage_GetOrganizationContractTemplateQuery,
		ContractTemplateEditPage_GetOrganizationContractTemplateQueryVariables
	>(ContractTemplateEditPage_GetOrganizationContractTemplateDocument, options);
}
export type ContractTemplateEditPage_GetOrganizationContractTemplateQueryHookResult =
	ReturnType<
		typeof useContractTemplateEditPage_GetOrganizationContractTemplateQuery
	>;
export type ContractTemplateEditPage_GetOrganizationContractTemplateLazyQueryHookResult =
	ReturnType<
		typeof useContractTemplateEditPage_GetOrganizationContractTemplateLazyQuery
	>;
export type ContractTemplateEditPage_GetOrganizationContractTemplateQueryResult =
	Apollo.QueryResult<
		ContractTemplateEditPage_GetOrganizationContractTemplateQuery,
		ContractTemplateEditPage_GetOrganizationContractTemplateQueryVariables
	>;
export const DocumentDetailPage_GetDocumentWhereDocument = gql`
	query documentDetailPage_getDocumentWhere($where: DocumentWhereUniqueInput!) {
		getDocumentWhere(where: $where) {
			id
			type
			name
			customer {
				id
				contacts {
					id
					firstName
					lastName
					customer {
						id
						email
					}
					vendor {
						id
					}
				}
			}
			parentFolder {
				id
				folderType
			}
			organization {
				id
			}
		}
	}
`;

/**
 * __useDocumentDetailPage_GetDocumentWhereQuery__
 *
 * To run a query within a React component, call `useDocumentDetailPage_GetDocumentWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailPage_GetDocumentWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetailPage_GetDocumentWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentDetailPage_GetDocumentWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentDetailPage_GetDocumentWhereQuery,
		DocumentDetailPage_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentDetailPage_GetDocumentWhereQuery,
		DocumentDetailPage_GetDocumentWhereQueryVariables
	>(DocumentDetailPage_GetDocumentWhereDocument, options);
}
export function useDocumentDetailPage_GetDocumentWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentDetailPage_GetDocumentWhereQuery,
		DocumentDetailPage_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentDetailPage_GetDocumentWhereQuery,
		DocumentDetailPage_GetDocumentWhereQueryVariables
	>(DocumentDetailPage_GetDocumentWhereDocument, options);
}
export type DocumentDetailPage_GetDocumentWhereQueryHookResult = ReturnType<
	typeof useDocumentDetailPage_GetDocumentWhereQuery
>;
export type DocumentDetailPage_GetDocumentWhereLazyQueryHookResult = ReturnType<
	typeof useDocumentDetailPage_GetDocumentWhereLazyQuery
>;
export type DocumentDetailPage_GetDocumentWhereQueryResult = Apollo.QueryResult<
	DocumentDetailPage_GetDocumentWhereQuery,
	DocumentDetailPage_GetDocumentWhereQueryVariables
>;
export const DocumentDetailPage_GetOrgUserWhereDocument = gql`
	query documentDetailPage_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			user {
				id
			}
			organization {
				id
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useDocumentDetailPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useDocumentDetailPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetailPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentDetailPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentDetailPage_GetOrgUserWhereQuery,
		DocumentDetailPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentDetailPage_GetOrgUserWhereQuery,
		DocumentDetailPage_GetOrgUserWhereQueryVariables
	>(DocumentDetailPage_GetOrgUserWhereDocument, options);
}
export function useDocumentDetailPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentDetailPage_GetOrgUserWhereQuery,
		DocumentDetailPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentDetailPage_GetOrgUserWhereQuery,
		DocumentDetailPage_GetOrgUserWhereQueryVariables
	>(DocumentDetailPage_GetOrgUserWhereDocument, options);
}
export type DocumentDetailPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useDocumentDetailPage_GetOrgUserWhereQuery
>;
export type DocumentDetailPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useDocumentDetailPage_GetOrgUserWhereLazyQuery
>;
export type DocumentDetailPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	DocumentDetailPage_GetOrgUserWhereQuery,
	DocumentDetailPage_GetOrgUserWhereQueryVariables
>;
export const DocumentDetailPage_ViewDocumentDocument = gql`
	mutation documentDetailPage_viewDocument($where: DocumentWhereUniqueInput!) {
		viewDocument(where: $where) {
			id
		}
	}
`;
export type DocumentDetailPage_ViewDocumentMutationFn = Apollo.MutationFunction<
	DocumentDetailPage_ViewDocumentMutation,
	DocumentDetailPage_ViewDocumentMutationVariables
>;

/**
 * __useDocumentDetailPage_ViewDocumentMutation__
 *
 * To run a mutation, you first call `useDocumentDetailPage_ViewDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailPage_ViewDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentDetailPageViewDocumentMutation, { data, loading, error }] = useDocumentDetailPage_ViewDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentDetailPage_ViewDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DocumentDetailPage_ViewDocumentMutation,
		DocumentDetailPage_ViewDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DocumentDetailPage_ViewDocumentMutation,
		DocumentDetailPage_ViewDocumentMutationVariables
	>(DocumentDetailPage_ViewDocumentDocument, options);
}
export type DocumentDetailPage_ViewDocumentMutationHookResult = ReturnType<
	typeof useDocumentDetailPage_ViewDocumentMutation
>;
export type DocumentDetailPage_ViewDocumentMutationResult =
	Apollo.MutationResult<DocumentDetailPage_ViewDocumentMutation>;
export type DocumentDetailPage_ViewDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		DocumentDetailPage_ViewDocumentMutation,
		DocumentDetailPage_ViewDocumentMutationVariables
	>;
export const DocumentDetailPage_GetFolderContentsDocument = gql`
	query DocumentDetailPage_getFolderContents($where: FolderWhereUniqueInput!) {
		getFolderContents(where: $where) {
			id
			name
			parentFolder {
				id
			}
		}
	}
`;

/**
 * __useDocumentDetailPage_GetFolderContentsQuery__
 *
 * To run a query within a React component, call `useDocumentDetailPage_GetFolderContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailPage_GetFolderContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetailPage_GetFolderContentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentDetailPage_GetFolderContentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentDetailPage_GetFolderContentsQuery,
		DocumentDetailPage_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentDetailPage_GetFolderContentsQuery,
		DocumentDetailPage_GetFolderContentsQueryVariables
	>(DocumentDetailPage_GetFolderContentsDocument, options);
}
export function useDocumentDetailPage_GetFolderContentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentDetailPage_GetFolderContentsQuery,
		DocumentDetailPage_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentDetailPage_GetFolderContentsQuery,
		DocumentDetailPage_GetFolderContentsQueryVariables
	>(DocumentDetailPage_GetFolderContentsDocument, options);
}
export type DocumentDetailPage_GetFolderContentsQueryHookResult = ReturnType<
	typeof useDocumentDetailPage_GetFolderContentsQuery
>;
export type DocumentDetailPage_GetFolderContentsLazyQueryHookResult =
	ReturnType<typeof useDocumentDetailPage_GetFolderContentsLazyQuery>;
export type DocumentDetailPage_GetFolderContentsQueryResult =
	Apollo.QueryResult<
		DocumentDetailPage_GetFolderContentsQuery,
		DocumentDetailPage_GetFolderContentsQueryVariables
	>;
export const InvoiceViewPage_GetOrgUserWhereDocument = gql`
	query invoiceViewPage_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useInvoiceViewPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceViewPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceViewPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceViewPage_GetOrgUserWhereQuery,
		InvoiceViewPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceViewPage_GetOrgUserWhereQuery,
		InvoiceViewPage_GetOrgUserWhereQueryVariables
	>(InvoiceViewPage_GetOrgUserWhereDocument, options);
}
export function useInvoiceViewPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceViewPage_GetOrgUserWhereQuery,
		InvoiceViewPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceViewPage_GetOrgUserWhereQuery,
		InvoiceViewPage_GetOrgUserWhereQueryVariables
	>(InvoiceViewPage_GetOrgUserWhereDocument, options);
}
export type InvoiceViewPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useInvoiceViewPage_GetOrgUserWhereQuery
>;
export type InvoiceViewPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useInvoiceViewPage_GetOrgUserWhereLazyQuery
>;
export type InvoiceViewPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	InvoiceViewPage_GetOrgUserWhereQuery,
	InvoiceViewPage_GetOrgUserWhereQueryVariables
>;
export const InvoiceViewPage_GetInvoiceWhereDocument = gql`
	query invoiceViewPage_getInvoiceWhere(
		$where: InvoiceWhereUniqueInput!
		$data: InvoiceTokenInput
	) {
		getInvoiceWhere(where: $where, data: $data) {
			invoice {
				id
				title
				status
				contact {
					id
					customer {
						id
					}
				}
				...invoiceViewPage_invoice
			}
			requestingUserBaseId
			requestingUserIsGuest
		}
	}
	${InvoiceViewPage_InvoiceFragmentDoc}
`;

/**
 * __useInvoiceViewPage_GetInvoiceWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceViewPage_GetInvoiceWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPage_GetInvoiceWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceViewPage_GetInvoiceWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceViewPage_GetInvoiceWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceViewPage_GetInvoiceWhereQuery,
		InvoiceViewPage_GetInvoiceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceViewPage_GetInvoiceWhereQuery,
		InvoiceViewPage_GetInvoiceWhereQueryVariables
	>(InvoiceViewPage_GetInvoiceWhereDocument, options);
}
export function useInvoiceViewPage_GetInvoiceWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceViewPage_GetInvoiceWhereQuery,
		InvoiceViewPage_GetInvoiceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceViewPage_GetInvoiceWhereQuery,
		InvoiceViewPage_GetInvoiceWhereQueryVariables
	>(InvoiceViewPage_GetInvoiceWhereDocument, options);
}
export type InvoiceViewPage_GetInvoiceWhereQueryHookResult = ReturnType<
	typeof useInvoiceViewPage_GetInvoiceWhereQuery
>;
export type InvoiceViewPage_GetInvoiceWhereLazyQueryHookResult = ReturnType<
	typeof useInvoiceViewPage_GetInvoiceWhereLazyQuery
>;
export type InvoiceViewPage_GetInvoiceWhereQueryResult = Apollo.QueryResult<
	InvoiceViewPage_GetInvoiceWhereQuery,
	InvoiceViewPage_GetInvoiceWhereQueryVariables
>;
export const InvoiceTemplateEditPage_GetInvoiceTemplateWhereDocument = gql`
	query invoiceTemplateEditPage_getInvoiceTemplateWhere(
		$where: InvoiceTemplateWhereUniqueInput!
	) {
		getInvoiceTemplateWhere(where: $where) {
			id
			title
			organization {
				id
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useInvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryVariables
	>(InvoiceTemplateEditPage_GetInvoiceTemplateWhereDocument, options);
}
export function useInvoiceTemplateEditPage_GetInvoiceTemplateWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryVariables
	>(InvoiceTemplateEditPage_GetInvoiceTemplateWhereDocument, options);
}
export type InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryHookResult =
	ReturnType<typeof useInvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery>;
export type InvoiceTemplateEditPage_GetInvoiceTemplateWhereLazyQueryHookResult =
	ReturnType<
		typeof useInvoiceTemplateEditPage_GetInvoiceTemplateWhereLazyQuery
	>;
export type InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryResult =
	Apollo.QueryResult<
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEditPage_GetInvoiceTemplateWhereQueryVariables
	>;
export const InvoiceTemplateEditPage_GetOrgUserWhereDocument = gql`
	query invoiceTemplateEditPage_getOrgUserWhere(
		$where: OrgUserWhereUniqueInput!
	) {
		getOrgUserWhere(where: $where) {
			id
			role
			organization {
				id
				invoicesAllowGratuity
				automatedRemindersEnabled
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useInvoiceTemplateEditPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplateEditPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEditPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplateEditPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplateEditPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceTemplateEditPage_GetOrgUserWhereQuery,
		InvoiceTemplateEditPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceTemplateEditPage_GetOrgUserWhereQuery,
		InvoiceTemplateEditPage_GetOrgUserWhereQueryVariables
	>(InvoiceTemplateEditPage_GetOrgUserWhereDocument, options);
}
export function useInvoiceTemplateEditPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceTemplateEditPage_GetOrgUserWhereQuery,
		InvoiceTemplateEditPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceTemplateEditPage_GetOrgUserWhereQuery,
		InvoiceTemplateEditPage_GetOrgUserWhereQueryVariables
	>(InvoiceTemplateEditPage_GetOrgUserWhereDocument, options);
}
export type InvoiceTemplateEditPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useInvoiceTemplateEditPage_GetOrgUserWhereQuery
>;
export type InvoiceTemplateEditPage_GetOrgUserWhereLazyQueryHookResult =
	ReturnType<typeof useInvoiceTemplateEditPage_GetOrgUserWhereLazyQuery>;
export type InvoiceTemplateEditPage_GetOrgUserWhereQueryResult =
	Apollo.QueryResult<
		InvoiceTemplateEditPage_GetOrgUserWhereQuery,
		InvoiceTemplateEditPage_GetOrgUserWhereQueryVariables
	>;
export const LeadDetailPage_GetInquiryWhereDocument = gql`
	query LeadDetailPage_getInquiryWhere($where: InquiryDetailWhereInput!) {
		getInquiryWhere(where: $where) {
			id
			firstName
			lastName
			email
			organization {
				id
			}
			contact {
				id
				customer {
					id
				}
				assignedMember {
					id
				}
				vendor {
					id
					users {
						id
						role
					}
				}
			}
		}
	}
`;

/**
 * __useLeadDetailPage_GetInquiryWhereQuery__
 *
 * To run a query within a React component, call `useLeadDetailPage_GetInquiryWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadDetailPage_GetInquiryWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadDetailPage_GetInquiryWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLeadDetailPage_GetInquiryWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		LeadDetailPage_GetInquiryWhereQuery,
		LeadDetailPage_GetInquiryWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		LeadDetailPage_GetInquiryWhereQuery,
		LeadDetailPage_GetInquiryWhereQueryVariables
	>(LeadDetailPage_GetInquiryWhereDocument, options);
}
export function useLeadDetailPage_GetInquiryWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LeadDetailPage_GetInquiryWhereQuery,
		LeadDetailPage_GetInquiryWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LeadDetailPage_GetInquiryWhereQuery,
		LeadDetailPage_GetInquiryWhereQueryVariables
	>(LeadDetailPage_GetInquiryWhereDocument, options);
}
export type LeadDetailPage_GetInquiryWhereQueryHookResult = ReturnType<
	typeof useLeadDetailPage_GetInquiryWhereQuery
>;
export type LeadDetailPage_GetInquiryWhereLazyQueryHookResult = ReturnType<
	typeof useLeadDetailPage_GetInquiryWhereLazyQuery
>;
export type LeadDetailPage_GetInquiryWhereQueryResult = Apollo.QueryResult<
	LeadDetailPage_GetInquiryWhereQuery,
	LeadDetailPage_GetInquiryWhereQueryVariables
>;
export const InquiriesPage_GetOrgUserWhereDocument = gql`
	query inquiriesPage_GetOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				createdAt
				users {
					id
					role
				}
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useInquiriesPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useInquiriesPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInquiriesPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInquiriesPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInquiriesPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InquiriesPage_GetOrgUserWhereQuery,
		InquiriesPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InquiriesPage_GetOrgUserWhereQuery,
		InquiriesPage_GetOrgUserWhereQueryVariables
	>(InquiriesPage_GetOrgUserWhereDocument, options);
}
export function useInquiriesPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InquiriesPage_GetOrgUserWhereQuery,
		InquiriesPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InquiriesPage_GetOrgUserWhereQuery,
		InquiriesPage_GetOrgUserWhereQueryVariables
	>(InquiriesPage_GetOrgUserWhereDocument, options);
}
export type InquiriesPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useInquiriesPage_GetOrgUserWhereQuery
>;
export type InquiriesPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useInquiriesPage_GetOrgUserWhereLazyQuery
>;
export type InquiriesPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	InquiriesPage_GetOrgUserWhereQuery,
	InquiriesPage_GetOrgUserWhereQueryVariables
>;
export const LeadFormViewPage_GetLeadFormApiKeyDocument = gql`
	query LeadFormViewPage_getLeadFormApiKey(
		$where: OrganizationWhereUniqueInput!
	) {
		getLeadFormApiKey(where: $where) {
			...leadFormViewPageLeadFormPresentationalData
		}
	}
	${LeadFormViewPageLeadFormPresentationalDataFragmentDoc}
`;

/**
 * __useLeadFormViewPage_GetLeadFormApiKeyQuery__
 *
 * To run a query within a React component, call `useLeadFormViewPage_GetLeadFormApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadFormViewPage_GetLeadFormApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadFormViewPage_GetLeadFormApiKeyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLeadFormViewPage_GetLeadFormApiKeyQuery(
	baseOptions: Apollo.QueryHookOptions<
		LeadFormViewPage_GetLeadFormApiKeyQuery,
		LeadFormViewPage_GetLeadFormApiKeyQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		LeadFormViewPage_GetLeadFormApiKeyQuery,
		LeadFormViewPage_GetLeadFormApiKeyQueryVariables
	>(LeadFormViewPage_GetLeadFormApiKeyDocument, options);
}
export function useLeadFormViewPage_GetLeadFormApiKeyLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LeadFormViewPage_GetLeadFormApiKeyQuery,
		LeadFormViewPage_GetLeadFormApiKeyQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LeadFormViewPage_GetLeadFormApiKeyQuery,
		LeadFormViewPage_GetLeadFormApiKeyQueryVariables
	>(LeadFormViewPage_GetLeadFormApiKeyDocument, options);
}
export type LeadFormViewPage_GetLeadFormApiKeyQueryHookResult = ReturnType<
	typeof useLeadFormViewPage_GetLeadFormApiKeyQuery
>;
export type LeadFormViewPage_GetLeadFormApiKeyLazyQueryHookResult = ReturnType<
	typeof useLeadFormViewPage_GetLeadFormApiKeyLazyQuery
>;
export type LeadFormViewPage_GetLeadFormApiKeyQueryResult = Apollo.QueryResult<
	LeadFormViewPage_GetLeadFormApiKeyQuery,
	LeadFormViewPage_GetLeadFormApiKeyQueryVariables
>;
export const MemberDetailPage_GetOrgUserWhereDocument = gql`
	query MemberDetailPage_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			firstName
			lastName
			organization {
				id
				users {
					id
				}
			}
		}
	}
`;

/**
 * __useMemberDetailPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useMemberDetailPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDetailPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDetailPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMemberDetailPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		MemberDetailPage_GetOrgUserWhereQuery,
		MemberDetailPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MemberDetailPage_GetOrgUserWhereQuery,
		MemberDetailPage_GetOrgUserWhereQueryVariables
	>(MemberDetailPage_GetOrgUserWhereDocument, options);
}
export function useMemberDetailPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MemberDetailPage_GetOrgUserWhereQuery,
		MemberDetailPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MemberDetailPage_GetOrgUserWhereQuery,
		MemberDetailPage_GetOrgUserWhereQueryVariables
	>(MemberDetailPage_GetOrgUserWhereDocument, options);
}
export type MemberDetailPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useMemberDetailPage_GetOrgUserWhereQuery
>;
export type MemberDetailPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useMemberDetailPage_GetOrgUserWhereLazyQuery
>;
export type MemberDetailPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	MemberDetailPage_GetOrgUserWhereQuery,
	MemberDetailPage_GetOrgUserWhereQueryVariables
>;
export const OrganizationViewPage_GetOrganizationWhereDocument = gql`
	query OrganizationViewPage_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			id
			name
		}
	}
`;

/**
 * __useOrganizationViewPage_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useOrganizationViewPage_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationViewPage_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationViewPage_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrganizationViewPage_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrganizationViewPage_GetOrganizationWhereQuery,
		OrganizationViewPage_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrganizationViewPage_GetOrganizationWhereQuery,
		OrganizationViewPage_GetOrganizationWhereQueryVariables
	>(OrganizationViewPage_GetOrganizationWhereDocument, options);
}
export function useOrganizationViewPage_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrganizationViewPage_GetOrganizationWhereQuery,
		OrganizationViewPage_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrganizationViewPage_GetOrganizationWhereQuery,
		OrganizationViewPage_GetOrganizationWhereQueryVariables
	>(OrganizationViewPage_GetOrganizationWhereDocument, options);
}
export type OrganizationViewPage_GetOrganizationWhereQueryHookResult =
	ReturnType<typeof useOrganizationViewPage_GetOrganizationWhereQuery>;
export type OrganizationViewPage_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<typeof useOrganizationViewPage_GetOrganizationWhereLazyQuery>;
export type OrganizationViewPage_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		OrganizationViewPage_GetOrganizationWhereQuery,
		OrganizationViewPage_GetOrganizationWhereQueryVariables
	>;
export const DashboardPage_GetOrgUserWhereDocument = gql`
	query dashboardPage_GetOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				createdAt
				users {
					id
					role
				}
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useDashboardPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useDashboardPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDashboardPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		DashboardPage_GetOrgUserWhereQuery,
		DashboardPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DashboardPage_GetOrgUserWhereQuery,
		DashboardPage_GetOrgUserWhereQueryVariables
	>(DashboardPage_GetOrgUserWhereDocument, options);
}
export function useDashboardPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DashboardPage_GetOrgUserWhereQuery,
		DashboardPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DashboardPage_GetOrgUserWhereQuery,
		DashboardPage_GetOrgUserWhereQueryVariables
	>(DashboardPage_GetOrgUserWhereDocument, options);
}
export type DashboardPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useDashboardPage_GetOrgUserWhereQuery
>;
export type DashboardPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useDashboardPage_GetOrgUserWhereLazyQuery
>;
export type DashboardPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	DashboardPage_GetOrgUserWhereQuery,
	DashboardPage_GetOrgUserWhereQueryVariables
>;
export const ProposalViewPage_GetOrgUserWhereDocument = gql`
	query ProposalViewPage_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				createdAt
				users {
					id
					role
				}
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useProposalViewPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useProposalViewPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalViewPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalViewPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalViewPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalViewPage_GetOrgUserWhereQuery,
		ProposalViewPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalViewPage_GetOrgUserWhereQuery,
		ProposalViewPage_GetOrgUserWhereQueryVariables
	>(ProposalViewPage_GetOrgUserWhereDocument, options);
}
export function useProposalViewPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalViewPage_GetOrgUserWhereQuery,
		ProposalViewPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalViewPage_GetOrgUserWhereQuery,
		ProposalViewPage_GetOrgUserWhereQueryVariables
	>(ProposalViewPage_GetOrgUserWhereDocument, options);
}
export type ProposalViewPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useProposalViewPage_GetOrgUserWhereQuery
>;
export type ProposalViewPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useProposalViewPage_GetOrgUserWhereLazyQuery
>;
export type ProposalViewPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	ProposalViewPage_GetOrgUserWhereQuery,
	ProposalViewPage_GetOrgUserWhereQueryVariables
>;
export const ProposalViewPage_GetProposalWhereDocument = gql`
	query ProposalViewPage_getProposalWhere($where: ProposalWhereInput!) {
		getProposalWhere(where: $where) {
			requestingUserBaseId
			requestingUserIsGuest
			proposal {
				id
				title
				status
				contact {
					id
					customer {
						id
						clientUser {
							id
							assignedPlanner {
								id
								organization {
									id
								}
							}
						}
					}
					assignedMember {
						id
						organization {
							id
						}
					}
					vendor {
						id
						users {
							id
							role
						}
					}
				}
			}
		}
	}
`;

/**
 * __useProposalViewPage_GetProposalWhereQuery__
 *
 * To run a query within a React component, call `useProposalViewPage_GetProposalWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalViewPage_GetProposalWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalViewPage_GetProposalWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalViewPage_GetProposalWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalViewPage_GetProposalWhereQuery,
		ProposalViewPage_GetProposalWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalViewPage_GetProposalWhereQuery,
		ProposalViewPage_GetProposalWhereQueryVariables
	>(ProposalViewPage_GetProposalWhereDocument, options);
}
export function useProposalViewPage_GetProposalWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalViewPage_GetProposalWhereQuery,
		ProposalViewPage_GetProposalWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalViewPage_GetProposalWhereQuery,
		ProposalViewPage_GetProposalWhereQueryVariables
	>(ProposalViewPage_GetProposalWhereDocument, options);
}
export type ProposalViewPage_GetProposalWhereQueryHookResult = ReturnType<
	typeof useProposalViewPage_GetProposalWhereQuery
>;
export type ProposalViewPage_GetProposalWhereLazyQueryHookResult = ReturnType<
	typeof useProposalViewPage_GetProposalWhereLazyQuery
>;
export type ProposalViewPage_GetProposalWhereQueryResult = Apollo.QueryResult<
	ProposalViewPage_GetProposalWhereQuery,
	ProposalViewPage_GetProposalWhereQueryVariables
>;
export const ProposalTemplateEditPage_GetOrgUserWhereDocument = gql`
	query proposalTemplateEditPage_getOrgUserWhere(
		$where: OrgUserWhereUniqueInput!
	) {
		getOrgUserWhere(where: $where) {
			id
			user {
				id
				canvaToken {
					accessToken
					expires
				}
			}
			organization {
				id
				createdAt
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useProposalTemplateEditPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useProposalTemplateEditPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEditPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalTemplateEditPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateEditPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalTemplateEditPage_GetOrgUserWhereQuery,
		ProposalTemplateEditPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalTemplateEditPage_GetOrgUserWhereQuery,
		ProposalTemplateEditPage_GetOrgUserWhereQueryVariables
	>(ProposalTemplateEditPage_GetOrgUserWhereDocument, options);
}
export function useProposalTemplateEditPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalTemplateEditPage_GetOrgUserWhereQuery,
		ProposalTemplateEditPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalTemplateEditPage_GetOrgUserWhereQuery,
		ProposalTemplateEditPage_GetOrgUserWhereQueryVariables
	>(ProposalTemplateEditPage_GetOrgUserWhereDocument, options);
}
export type ProposalTemplateEditPage_GetOrgUserWhereQueryHookResult =
	ReturnType<typeof useProposalTemplateEditPage_GetOrgUserWhereQuery>;
export type ProposalTemplateEditPage_GetOrgUserWhereLazyQueryHookResult =
	ReturnType<typeof useProposalTemplateEditPage_GetOrgUserWhereLazyQuery>;
export type ProposalTemplateEditPage_GetOrgUserWhereQueryResult =
	Apollo.QueryResult<
		ProposalTemplateEditPage_GetOrgUserWhereQuery,
		ProposalTemplateEditPage_GetOrgUserWhereQueryVariables
	>;
export const ProposalTemplateEditPage_GetProposalTemplateWhereDocument = gql`
	query proposalTemplateEditPage_getProposalTemplateWhere(
		$where: ProposalTemplateWhereUniqueInput!
	) {
		getProposalTemplateWhere(where: $where) {
			id
			title
		}
	}
`;

/**
 * __useProposalTemplateEditPage_GetProposalTemplateWhereQuery__
 *
 * To run a query within a React component, call `useProposalTemplateEditPage_GetProposalTemplateWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEditPage_GetProposalTemplateWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalTemplateEditPage_GetProposalTemplateWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateEditPage_GetProposalTemplateWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalTemplateEditPage_GetProposalTemplateWhereQuery,
		ProposalTemplateEditPage_GetProposalTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalTemplateEditPage_GetProposalTemplateWhereQuery,
		ProposalTemplateEditPage_GetProposalTemplateWhereQueryVariables
	>(ProposalTemplateEditPage_GetProposalTemplateWhereDocument, options);
}
export function useProposalTemplateEditPage_GetProposalTemplateWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalTemplateEditPage_GetProposalTemplateWhereQuery,
		ProposalTemplateEditPage_GetProposalTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalTemplateEditPage_GetProposalTemplateWhereQuery,
		ProposalTemplateEditPage_GetProposalTemplateWhereQueryVariables
	>(ProposalTemplateEditPage_GetProposalTemplateWhereDocument, options);
}
export type ProposalTemplateEditPage_GetProposalTemplateWhereQueryHookResult =
	ReturnType<typeof useProposalTemplateEditPage_GetProposalTemplateWhereQuery>;
export type ProposalTemplateEditPage_GetProposalTemplateWhereLazyQueryHookResult =
	ReturnType<
		typeof useProposalTemplateEditPage_GetProposalTemplateWhereLazyQuery
	>;
export type ProposalTemplateEditPage_GetProposalTemplateWhereQueryResult =
	Apollo.QueryResult<
		ProposalTemplateEditPage_GetProposalTemplateWhereQuery,
		ProposalTemplateEditPage_GetProposalTemplateWhereQueryVariables
	>;
export const QuickPaymentPage_GetQuickPaymentDocument = gql`
	query QuickPaymentPage_getQuickPayment($where: QuickPaymentUniqueInput!) {
		getQuickPayment(where: $where) {
			id
			organization {
				name
				id
				image
				updatedAt
			}
		}
	}
`;

/**
 * __useQuickPaymentPage_GetQuickPaymentQuery__
 *
 * To run a query within a React component, call `useQuickPaymentPage_GetQuickPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickPaymentPage_GetQuickPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickPaymentPage_GetQuickPaymentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuickPaymentPage_GetQuickPaymentQuery(
	baseOptions: Apollo.QueryHookOptions<
		QuickPaymentPage_GetQuickPaymentQuery,
		QuickPaymentPage_GetQuickPaymentQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		QuickPaymentPage_GetQuickPaymentQuery,
		QuickPaymentPage_GetQuickPaymentQueryVariables
	>(QuickPaymentPage_GetQuickPaymentDocument, options);
}
export function useQuickPaymentPage_GetQuickPaymentLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		QuickPaymentPage_GetQuickPaymentQuery,
		QuickPaymentPage_GetQuickPaymentQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		QuickPaymentPage_GetQuickPaymentQuery,
		QuickPaymentPage_GetQuickPaymentQueryVariables
	>(QuickPaymentPage_GetQuickPaymentDocument, options);
}
export type QuickPaymentPage_GetQuickPaymentQueryHookResult = ReturnType<
	typeof useQuickPaymentPage_GetQuickPaymentQuery
>;
export type QuickPaymentPage_GetQuickPaymentLazyQueryHookResult = ReturnType<
	typeof useQuickPaymentPage_GetQuickPaymentLazyQuery
>;
export type QuickPaymentPage_GetQuickPaymentQueryResult = Apollo.QueryResult<
	QuickPaymentPage_GetQuickPaymentQuery,
	QuickPaymentPage_GetQuickPaymentQueryVariables
>;
export const ResourceViewPage_GetResourceWhereDocument = gql`
	query resourceViewPage_getResourceWhere($where: ResourceWhereUniqueInput!) {
		getResourceWhere(where: $where) {
			id
			description
		}
	}
`;

/**
 * __useResourceViewPage_GetResourceWhereQuery__
 *
 * To run a query within a React component, call `useResourceViewPage_GetResourceWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewPage_GetResourceWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewPage_GetResourceWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useResourceViewPage_GetResourceWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ResourceViewPage_GetResourceWhereQuery,
		ResourceViewPage_GetResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ResourceViewPage_GetResourceWhereQuery,
		ResourceViewPage_GetResourceWhereQueryVariables
	>(ResourceViewPage_GetResourceWhereDocument, options);
}
export function useResourceViewPage_GetResourceWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ResourceViewPage_GetResourceWhereQuery,
		ResourceViewPage_GetResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ResourceViewPage_GetResourceWhereQuery,
		ResourceViewPage_GetResourceWhereQueryVariables
	>(ResourceViewPage_GetResourceWhereDocument, options);
}
export type ResourceViewPage_GetResourceWhereQueryHookResult = ReturnType<
	typeof useResourceViewPage_GetResourceWhereQuery
>;
export type ResourceViewPage_GetResourceWhereLazyQueryHookResult = ReturnType<
	typeof useResourceViewPage_GetResourceWhereLazyQuery
>;
export type ResourceViewPage_GetResourceWhereQueryResult = Apollo.QueryResult<
	ResourceViewPage_GetResourceWhereQuery,
	ResourceViewPage_GetResourceWhereQueryVariables
>;
export const TimelineGeniusPage_GetOrgUserWhereDocument = gql`
	query timelineGeniusPage_GetOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
			}
		}
	}
`;

/**
 * __useTimelineGeniusPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useTimelineGeniusPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineGeniusPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineGeniusPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTimelineGeniusPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		TimelineGeniusPage_GetOrgUserWhereQuery,
		TimelineGeniusPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TimelineGeniusPage_GetOrgUserWhereQuery,
		TimelineGeniusPage_GetOrgUserWhereQueryVariables
	>(TimelineGeniusPage_GetOrgUserWhereDocument, options);
}
export function useTimelineGeniusPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TimelineGeniusPage_GetOrgUserWhereQuery,
		TimelineGeniusPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TimelineGeniusPage_GetOrgUserWhereQuery,
		TimelineGeniusPage_GetOrgUserWhereQueryVariables
	>(TimelineGeniusPage_GetOrgUserWhereDocument, options);
}
export type TimelineGeniusPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useTimelineGeniusPage_GetOrgUserWhereQuery
>;
export type TimelineGeniusPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useTimelineGeniusPage_GetOrgUserWhereLazyQuery
>;
export type TimelineGeniusPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	TimelineGeniusPage_GetOrgUserWhereQuery,
	TimelineGeniusPage_GetOrgUserWhereQueryVariables
>;
export const TimelineGeniusPage_GetGlobalVariablesDocument = gql`
	query timelineGeniusPage_getGlobalVariables {
		getGlobalVariables {
			TGIntegrationURL
		}
	}
`;

/**
 * __useTimelineGeniusPage_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useTimelineGeniusPage_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineGeniusPage_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineGeniusPage_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimelineGeniusPage_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TimelineGeniusPage_GetGlobalVariablesQuery,
		TimelineGeniusPage_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TimelineGeniusPage_GetGlobalVariablesQuery,
		TimelineGeniusPage_GetGlobalVariablesQueryVariables
	>(TimelineGeniusPage_GetGlobalVariablesDocument, options);
}
export function useTimelineGeniusPage_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TimelineGeniusPage_GetGlobalVariablesQuery,
		TimelineGeniusPage_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TimelineGeniusPage_GetGlobalVariablesQuery,
		TimelineGeniusPage_GetGlobalVariablesQueryVariables
	>(TimelineGeniusPage_GetGlobalVariablesDocument, options);
}
export type TimelineGeniusPage_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useTimelineGeniusPage_GetGlobalVariablesQuery
>;
export type TimelineGeniusPage_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useTimelineGeniusPage_GetGlobalVariablesLazyQuery>;
export type TimelineGeniusPage_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		TimelineGeniusPage_GetGlobalVariablesQuery,
		TimelineGeniusPage_GetGlobalVariablesQueryVariables
	>;
export const VersionPage_GetApiVersionDocument = gql`
	query versionPage_getApiVersion {
		getApiVersion {
			version
			env
			commitId
			branch
		}
	}
`;

/**
 * __useVersionPage_GetApiVersionQuery__
 *
 * To run a query within a React component, call `useVersionPage_GetApiVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVersionPage_GetApiVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionPage_GetApiVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useVersionPage_GetApiVersionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		VersionPage_GetApiVersionQuery,
		VersionPage_GetApiVersionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		VersionPage_GetApiVersionQuery,
		VersionPage_GetApiVersionQueryVariables
	>(VersionPage_GetApiVersionDocument, options);
}
export function useVersionPage_GetApiVersionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		VersionPage_GetApiVersionQuery,
		VersionPage_GetApiVersionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		VersionPage_GetApiVersionQuery,
		VersionPage_GetApiVersionQueryVariables
	>(VersionPage_GetApiVersionDocument, options);
}
export type VersionPage_GetApiVersionQueryHookResult = ReturnType<
	typeof useVersionPage_GetApiVersionQuery
>;
export type VersionPage_GetApiVersionLazyQueryHookResult = ReturnType<
	typeof useVersionPage_GetApiVersionLazyQuery
>;
export type VersionPage_GetApiVersionQueryResult = Apollo.QueryResult<
	VersionPage_GetApiVersionQuery,
	VersionPage_GetApiVersionQueryVariables
>;
export const WalletPage_GetOrgUserWhereDocument = gql`
	query WalletPage_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			firstName
			lastName
			organization {
				id
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useWalletPage_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useWalletPage_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletPage_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletPage_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWalletPage_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		WalletPage_GetOrgUserWhereQuery,
		WalletPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		WalletPage_GetOrgUserWhereQuery,
		WalletPage_GetOrgUserWhereQueryVariables
	>(WalletPage_GetOrgUserWhereDocument, options);
}
export function useWalletPage_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		WalletPage_GetOrgUserWhereQuery,
		WalletPage_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		WalletPage_GetOrgUserWhereQuery,
		WalletPage_GetOrgUserWhereQueryVariables
	>(WalletPage_GetOrgUserWhereDocument, options);
}
export type WalletPage_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useWalletPage_GetOrgUserWhereQuery
>;
export type WalletPage_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useWalletPage_GetOrgUserWhereLazyQuery
>;
export type WalletPage_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	WalletPage_GetOrgUserWhereQuery,
	WalletPage_GetOrgUserWhereQueryVariables
>;
export const ActivateSubscriptionModal_GetCouponDetailsDocument = gql`
	query ActivateSubscriptionModal_getCouponDetails($where: CouponByNameInput!) {
		getCouponDetails(where: $where) {
			id
			percent_off
			duration_in_months
		}
	}
`;

/**
 * __useActivateSubscriptionModal_GetCouponDetailsQuery__
 *
 * To run a query within a React component, call `useActivateSubscriptionModal_GetCouponDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivateSubscriptionModal_GetCouponDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivateSubscriptionModal_GetCouponDetailsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useActivateSubscriptionModal_GetCouponDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		ActivateSubscriptionModal_GetCouponDetailsQuery,
		ActivateSubscriptionModal_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ActivateSubscriptionModal_GetCouponDetailsQuery,
		ActivateSubscriptionModal_GetCouponDetailsQueryVariables
	>(ActivateSubscriptionModal_GetCouponDetailsDocument, options);
}
export function useActivateSubscriptionModal_GetCouponDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ActivateSubscriptionModal_GetCouponDetailsQuery,
		ActivateSubscriptionModal_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ActivateSubscriptionModal_GetCouponDetailsQuery,
		ActivateSubscriptionModal_GetCouponDetailsQueryVariables
	>(ActivateSubscriptionModal_GetCouponDetailsDocument, options);
}
export type ActivateSubscriptionModal_GetCouponDetailsQueryHookResult =
	ReturnType<typeof useActivateSubscriptionModal_GetCouponDetailsQuery>;
export type ActivateSubscriptionModal_GetCouponDetailsLazyQueryHookResult =
	ReturnType<typeof useActivateSubscriptionModal_GetCouponDetailsLazyQuery>;
export type ActivateSubscriptionModal_GetCouponDetailsQueryResult =
	Apollo.QueryResult<
		ActivateSubscriptionModal_GetCouponDetailsQuery,
		ActivateSubscriptionModal_GetCouponDetailsQueryVariables
	>;
export const ActivityTab_GetEventsWhereDocument = gql`
	query ActivityTab_GetEventsWhere(
		$where: EventWhereInput!
		$orderBy: [EventOrderByInput]
		$skip: Int
		$take: Int
	) {
		getEventsWhere(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			...activityTabEvent
		}
	}
	${ActivityTabEventFragmentDoc}
`;

/**
 * __useActivityTab_GetEventsWhereQuery__
 *
 * To run a query within a React component, call `useActivityTab_GetEventsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTab_GetEventsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTab_GetEventsWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useActivityTab_GetEventsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ActivityTab_GetEventsWhereQuery,
		ActivityTab_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ActivityTab_GetEventsWhereQuery,
		ActivityTab_GetEventsWhereQueryVariables
	>(ActivityTab_GetEventsWhereDocument, options);
}
export function useActivityTab_GetEventsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ActivityTab_GetEventsWhereQuery,
		ActivityTab_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ActivityTab_GetEventsWhereQuery,
		ActivityTab_GetEventsWhereQueryVariables
	>(ActivityTab_GetEventsWhereDocument, options);
}
export type ActivityTab_GetEventsWhereQueryHookResult = ReturnType<
	typeof useActivityTab_GetEventsWhereQuery
>;
export type ActivityTab_GetEventsWhereLazyQueryHookResult = ReturnType<
	typeof useActivityTab_GetEventsWhereLazyQuery
>;
export type ActivityTab_GetEventsWhereQueryResult = Apollo.QueryResult<
	ActivityTab_GetEventsWhereQuery,
	ActivityTab_GetEventsWhereQueryVariables
>;
export const MembersTable_GetOrganizationWhereDocument = gql`
	query membersTable_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
		$orderBy: [OrgUserOrderByInput]
	) {
		getOrganizationWhere(where: $where) {
			id
			users(orderBy: $orderBy) {
				...membersTableOrgUser
			}
		}
	}
	${MembersTableOrgUserFragmentDoc}
`;

/**
 * __useMembersTable_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useMembersTable_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersTable_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersTable_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMembersTable_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		MembersTable_GetOrganizationWhereQuery,
		MembersTable_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MembersTable_GetOrganizationWhereQuery,
		MembersTable_GetOrganizationWhereQueryVariables
	>(MembersTable_GetOrganizationWhereDocument, options);
}
export function useMembersTable_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MembersTable_GetOrganizationWhereQuery,
		MembersTable_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MembersTable_GetOrganizationWhereQuery,
		MembersTable_GetOrganizationWhereQueryVariables
	>(MembersTable_GetOrganizationWhereDocument, options);
}
export type MembersTable_GetOrganizationWhereQueryHookResult = ReturnType<
	typeof useMembersTable_GetOrganizationWhereQuery
>;
export type MembersTable_GetOrganizationWhereLazyQueryHookResult = ReturnType<
	typeof useMembersTable_GetOrganizationWhereLazyQuery
>;
export type MembersTable_GetOrganizationWhereQueryResult = Apollo.QueryResult<
	MembersTable_GetOrganizationWhereQuery,
	MembersTable_GetOrganizationWhereQueryVariables
>;
export const MembersTable_DisableOrgMemberDocument = gql`
	mutation membersTable_disableOrgMember(
		$where: OrgUserWhereUniqueInput!
		$orderBy: [OrgUserOrderByInput]
	) {
		disableOrgMember(where: $where) {
			id
			users(orderBy: $orderBy) {
				...membersTableOrgUser
			}
		}
	}
	${MembersTableOrgUserFragmentDoc}
`;
export type MembersTable_DisableOrgMemberMutationFn = Apollo.MutationFunction<
	MembersTable_DisableOrgMemberMutation,
	MembersTable_DisableOrgMemberMutationVariables
>;

/**
 * __useMembersTable_DisableOrgMemberMutation__
 *
 * To run a mutation, you first call `useMembersTable_DisableOrgMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembersTable_DisableOrgMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membersTableDisableOrgMemberMutation, { data, loading, error }] = useMembersTable_DisableOrgMemberMutation({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMembersTable_DisableOrgMemberMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MembersTable_DisableOrgMemberMutation,
		MembersTable_DisableOrgMemberMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MembersTable_DisableOrgMemberMutation,
		MembersTable_DisableOrgMemberMutationVariables
	>(MembersTable_DisableOrgMemberDocument, options);
}
export type MembersTable_DisableOrgMemberMutationHookResult = ReturnType<
	typeof useMembersTable_DisableOrgMemberMutation
>;
export type MembersTable_DisableOrgMemberMutationResult =
	Apollo.MutationResult<MembersTable_DisableOrgMemberMutation>;
export type MembersTable_DisableOrgMemberMutationOptions =
	Apollo.BaseMutationOptions<
		MembersTable_DisableOrgMemberMutation,
		MembersTable_DisableOrgMemberMutationVariables
	>;
export const MembersTable_ReactivateOrgMemberDocument = gql`
	mutation membersTable_reactivateOrgMember(
		$where: OrgUserWhereUniqueInput!
		$orderBy: [OrgUserOrderByInput]
	) {
		reactivateOrgMember(where: $where) {
			id
			users(orderBy: $orderBy) {
				...membersTableOrgUser
			}
		}
	}
	${MembersTableOrgUserFragmentDoc}
`;
export type MembersTable_ReactivateOrgMemberMutationFn =
	Apollo.MutationFunction<
		MembersTable_ReactivateOrgMemberMutation,
		MembersTable_ReactivateOrgMemberMutationVariables
	>;

/**
 * __useMembersTable_ReactivateOrgMemberMutation__
 *
 * To run a mutation, you first call `useMembersTable_ReactivateOrgMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembersTable_ReactivateOrgMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membersTableReactivateOrgMemberMutation, { data, loading, error }] = useMembersTable_ReactivateOrgMemberMutation({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMembersTable_ReactivateOrgMemberMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MembersTable_ReactivateOrgMemberMutation,
		MembersTable_ReactivateOrgMemberMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MembersTable_ReactivateOrgMemberMutation,
		MembersTable_ReactivateOrgMemberMutationVariables
	>(MembersTable_ReactivateOrgMemberDocument, options);
}
export type MembersTable_ReactivateOrgMemberMutationHookResult = ReturnType<
	typeof useMembersTable_ReactivateOrgMemberMutation
>;
export type MembersTable_ReactivateOrgMemberMutationResult =
	Apollo.MutationResult<MembersTable_ReactivateOrgMemberMutation>;
export type MembersTable_ReactivateOrgMemberMutationOptions =
	Apollo.BaseMutationOptions<
		MembersTable_ReactivateOrgMemberMutation,
		MembersTable_ReactivateOrgMemberMutationVariables
	>;
export const OrganizationNotificationPreferences_GetOrganizationWhereDocument = gql`
	query organizationNotificationPreferences_GetOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			id
			users {
				...organizationNotificationPreferencesOrgUser
			}
		}
	}
	${OrganizationNotificationPreferencesOrgUserFragmentDoc}
`;

/**
 * __useOrganizationNotificationPreferences_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useOrganizationNotificationPreferences_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNotificationPreferences_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNotificationPreferences_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrganizationNotificationPreferences_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrganizationNotificationPreferences_GetOrganizationWhereQuery,
		OrganizationNotificationPreferences_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrganizationNotificationPreferences_GetOrganizationWhereQuery,
		OrganizationNotificationPreferences_GetOrganizationWhereQueryVariables
	>(OrganizationNotificationPreferences_GetOrganizationWhereDocument, options);
}
export function useOrganizationNotificationPreferences_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrganizationNotificationPreferences_GetOrganizationWhereQuery,
		OrganizationNotificationPreferences_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrganizationNotificationPreferences_GetOrganizationWhereQuery,
		OrganizationNotificationPreferences_GetOrganizationWhereQueryVariables
	>(OrganizationNotificationPreferences_GetOrganizationWhereDocument, options);
}
export type OrganizationNotificationPreferences_GetOrganizationWhereQueryHookResult =
	ReturnType<
		typeof useOrganizationNotificationPreferences_GetOrganizationWhereQuery
	>;
export type OrganizationNotificationPreferences_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<
		typeof useOrganizationNotificationPreferences_GetOrganizationWhereLazyQuery
	>;
export type OrganizationNotificationPreferences_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		OrganizationNotificationPreferences_GetOrganizationWhereQuery,
		OrganizationNotificationPreferences_GetOrganizationWhereQueryVariables
	>;
export const OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationDocument = gql`
	query organizationNotificationPreferences_getNotificationGroupsForOrganization {
		getNotificationGroupsForOrganization {
			...organizationNotificationPreferencesEmailNotificationGroup
		}
	}
	${OrganizationNotificationPreferencesEmailNotificationGroupFragmentDoc}
`;

/**
 * __useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery,
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery,
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryVariables
	>(
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationDocument,
		options
	);
}
export function useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery,
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery,
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryVariables
	>(
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationDocument,
		options
	);
}
export type OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryHookResult =
	ReturnType<
		typeof useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery
	>;
export type OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationLazyQueryHookResult =
	ReturnType<
		typeof useOrganizationNotificationPreferences_GetNotificationGroupsForOrganizationLazyQuery
	>;
export type OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryResult =
	Apollo.QueryResult<
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQuery,
		OrganizationNotificationPreferences_GetNotificationGroupsForOrganizationQueryVariables
	>;
export const OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsDocument = gql`
	mutation organizationNotificationPreferences_UpdateOrganizationNotificationGroups(
		$data: EmailNotificationGroupsInput!
	) {
		updateOrganizationNotificationGroups(data: $data) {
			...organizationNotificationPreferencesEmailNotificationGroup
		}
	}
	${OrganizationNotificationPreferencesEmailNotificationGroupFragmentDoc}
`;
export type OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationFn =
	Apollo.MutationFunction<
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation,
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationVariables
	>;

/**
 * __useOrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation__
 *
 * To run a mutation, you first call `useOrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationNotificationPreferencesUpdateOrganizationNotificationGroupsMutation, { data, loading, error }] = useOrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation,
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation,
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationVariables
	>(
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsDocument,
		options
	);
}
export type OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationHookResult =
	ReturnType<
		typeof useOrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation
	>;
export type OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationResult =
	Apollo.MutationResult<OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation>;
export type OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationOptions =
	Apollo.BaseMutationOptions<
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutation,
		OrganizationNotificationPreferences_UpdateOrganizationNotificationGroupsMutationVariables
	>;
export const EmailNotificationGroupEvents_GetEventsWhereDocument = gql`
	query EmailNotificationGroupEvents_GetEventsWhere(
		$where: EventWhereInput!
		$orderBy: [EventOrderByInput]
		$skip: Int!
		$take: Int!
	) {
		getEventsWhere(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			...emailNotificationGroupEventsEvent
		}
	}
	${EmailNotificationGroupEventsEventFragmentDoc}
`;

/**
 * __useEmailNotificationGroupEvents_GetEventsWhereQuery__
 *
 * To run a query within a React component, call `useEmailNotificationGroupEvents_GetEventsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailNotificationGroupEvents_GetEventsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailNotificationGroupEvents_GetEventsWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useEmailNotificationGroupEvents_GetEventsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		EmailNotificationGroupEvents_GetEventsWhereQuery,
		EmailNotificationGroupEvents_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EmailNotificationGroupEvents_GetEventsWhereQuery,
		EmailNotificationGroupEvents_GetEventsWhereQueryVariables
	>(EmailNotificationGroupEvents_GetEventsWhereDocument, options);
}
export function useEmailNotificationGroupEvents_GetEventsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EmailNotificationGroupEvents_GetEventsWhereQuery,
		EmailNotificationGroupEvents_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EmailNotificationGroupEvents_GetEventsWhereQuery,
		EmailNotificationGroupEvents_GetEventsWhereQueryVariables
	>(EmailNotificationGroupEvents_GetEventsWhereDocument, options);
}
export type EmailNotificationGroupEvents_GetEventsWhereQueryHookResult =
	ReturnType<typeof useEmailNotificationGroupEvents_GetEventsWhereQuery>;
export type EmailNotificationGroupEvents_GetEventsWhereLazyQueryHookResult =
	ReturnType<typeof useEmailNotificationGroupEvents_GetEventsWhereLazyQuery>;
export type EmailNotificationGroupEvents_GetEventsWhereQueryResult =
	Apollo.QueryResult<
		EmailNotificationGroupEvents_GetEventsWhereQuery,
		EmailNotificationGroupEvents_GetEventsWhereQueryVariables
	>;
export const AutomatedNotificationsPreferencesForm_UpdateOrganizationDocument = gql`
	mutation AutomatedNotificationsPreferencesForm_updateOrganization(
		$where: OrganizationWhereUniqueInput!
		$data: OrganizationCustomUpdateInput!
	) {
		updateOrganization(where: $where, data: $data) {
			id
			automatedRemindersEnabled
		}
	}
`;
export type AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationFn =
	Apollo.MutationFunction<
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutation,
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationVariables
	>;

/**
 * __useAutomatedNotificationsPreferencesForm_UpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useAutomatedNotificationsPreferencesForm_UpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutomatedNotificationsPreferencesForm_UpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [automatedNotificationsPreferencesFormUpdateOrganizationMutation, { data, loading, error }] = useAutomatedNotificationsPreferencesForm_UpdateOrganizationMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAutomatedNotificationsPreferencesForm_UpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutation,
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutation,
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationVariables
	>(AutomatedNotificationsPreferencesForm_UpdateOrganizationDocument, options);
}
export type AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationHookResult =
	ReturnType<
		typeof useAutomatedNotificationsPreferencesForm_UpdateOrganizationMutation
	>;
export type AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationResult =
	Apollo.MutationResult<AutomatedNotificationsPreferencesForm_UpdateOrganizationMutation>;
export type AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationOptions =
	Apollo.BaseMutationOptions<
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutation,
		AutomatedNotificationsPreferencesForm_UpdateOrganizationMutationVariables
	>;
export const BrandedEmailPreferencesForm_UpdateOrganizationDocument = gql`
	mutation BrandedEmailPreferencesForm_updateOrganization(
		$where: OrganizationWhereUniqueInput!
		$data: OrganizationCustomUpdateInput!
	) {
		updateOrganization(where: $where, data: $data) {
			id
			brandedEmails
		}
	}
`;
export type BrandedEmailPreferencesForm_UpdateOrganizationMutationFn =
	Apollo.MutationFunction<
		BrandedEmailPreferencesForm_UpdateOrganizationMutation,
		BrandedEmailPreferencesForm_UpdateOrganizationMutationVariables
	>;

/**
 * __useBrandedEmailPreferencesForm_UpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useBrandedEmailPreferencesForm_UpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandedEmailPreferencesForm_UpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandedEmailPreferencesFormUpdateOrganizationMutation, { data, loading, error }] = useBrandedEmailPreferencesForm_UpdateOrganizationMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBrandedEmailPreferencesForm_UpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		BrandedEmailPreferencesForm_UpdateOrganizationMutation,
		BrandedEmailPreferencesForm_UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		BrandedEmailPreferencesForm_UpdateOrganizationMutation,
		BrandedEmailPreferencesForm_UpdateOrganizationMutationVariables
	>(BrandedEmailPreferencesForm_UpdateOrganizationDocument, options);
}
export type BrandedEmailPreferencesForm_UpdateOrganizationMutationHookResult =
	ReturnType<typeof useBrandedEmailPreferencesForm_UpdateOrganizationMutation>;
export type BrandedEmailPreferencesForm_UpdateOrganizationMutationResult =
	Apollo.MutationResult<BrandedEmailPreferencesForm_UpdateOrganizationMutation>;
export type BrandedEmailPreferencesForm_UpdateOrganizationMutationOptions =
	Apollo.BaseMutationOptions<
		BrandedEmailPreferencesForm_UpdateOrganizationMutation,
		BrandedEmailPreferencesForm_UpdateOrganizationMutationVariables
	>;
export const GratuityPreferencesForm_UpdateOrganizationDocument = gql`
	mutation GratuityPreferencesForm_updateOrganization(
		$where: OrganizationWhereUniqueInput!
		$data: OrganizationCustomUpdateInput!
	) {
		updateOrganization(where: $where, data: $data) {
			id
			invoicesAllowGratuity
		}
	}
`;
export type GratuityPreferencesForm_UpdateOrganizationMutationFn =
	Apollo.MutationFunction<
		GratuityPreferencesForm_UpdateOrganizationMutation,
		GratuityPreferencesForm_UpdateOrganizationMutationVariables
	>;

/**
 * __useGratuityPreferencesForm_UpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useGratuityPreferencesForm_UpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGratuityPreferencesForm_UpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gratuityPreferencesFormUpdateOrganizationMutation, { data, loading, error }] = useGratuityPreferencesForm_UpdateOrganizationMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGratuityPreferencesForm_UpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GratuityPreferencesForm_UpdateOrganizationMutation,
		GratuityPreferencesForm_UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GratuityPreferencesForm_UpdateOrganizationMutation,
		GratuityPreferencesForm_UpdateOrganizationMutationVariables
	>(GratuityPreferencesForm_UpdateOrganizationDocument, options);
}
export type GratuityPreferencesForm_UpdateOrganizationMutationHookResult =
	ReturnType<typeof useGratuityPreferencesForm_UpdateOrganizationMutation>;
export type GratuityPreferencesForm_UpdateOrganizationMutationResult =
	Apollo.MutationResult<GratuityPreferencesForm_UpdateOrganizationMutation>;
export type GratuityPreferencesForm_UpdateOrganizationMutationOptions =
	Apollo.BaseMutationOptions<
		GratuityPreferencesForm_UpdateOrganizationMutation,
		GratuityPreferencesForm_UpdateOrganizationMutationVariables
	>;
export const InternationalPaymentsPreferences_GetOrganizationWhereDocument = gql`
	query InternationalPaymentsPreferences_GetOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			id
			users {
				id
				role
			}
		}
	}
`;

/**
 * __useInternationalPaymentsPreferences_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useInternationalPaymentsPreferences_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternationalPaymentsPreferences_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternationalPaymentsPreferences_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInternationalPaymentsPreferences_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InternationalPaymentsPreferences_GetOrganizationWhereQuery,
		InternationalPaymentsPreferences_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InternationalPaymentsPreferences_GetOrganizationWhereQuery,
		InternationalPaymentsPreferences_GetOrganizationWhereQueryVariables
	>(InternationalPaymentsPreferences_GetOrganizationWhereDocument, options);
}
export function useInternationalPaymentsPreferences_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InternationalPaymentsPreferences_GetOrganizationWhereQuery,
		InternationalPaymentsPreferences_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InternationalPaymentsPreferences_GetOrganizationWhereQuery,
		InternationalPaymentsPreferences_GetOrganizationWhereQueryVariables
	>(InternationalPaymentsPreferences_GetOrganizationWhereDocument, options);
}
export type InternationalPaymentsPreferences_GetOrganizationWhereQueryHookResult =
	ReturnType<
		typeof useInternationalPaymentsPreferences_GetOrganizationWhereQuery
	>;
export type InternationalPaymentsPreferences_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<
		typeof useInternationalPaymentsPreferences_GetOrganizationWhereLazyQuery
	>;
export type InternationalPaymentsPreferences_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		InternationalPaymentsPreferences_GetOrganizationWhereQuery,
		InternationalPaymentsPreferences_GetOrganizationWhereQueryVariables
	>;
export const InternationalPaymentsPreferences_GetStripePaymentCapabilitiesDocument = gql`
	query InternationalPaymentsPreferences_GetStripePaymentCapabilities(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripePaymentCapabilities(where: $where) {
			card_payments
			acss_debit_payments
		}
	}
`;

/**
 * __useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery__
 *
 * To run a query within a React component, call `useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery(
	baseOptions: Apollo.QueryHookOptions<
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery,
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery,
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryVariables
	>(
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesDocument,
		options
	);
}
export function useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery,
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery,
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryVariables
	>(
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesDocument,
		options
	);
}
export type InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryHookResult =
	ReturnType<
		typeof useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery
	>;
export type InternationalPaymentsPreferences_GetStripePaymentCapabilitiesLazyQueryHookResult =
	ReturnType<
		typeof useInternationalPaymentsPreferences_GetStripePaymentCapabilitiesLazyQuery
	>;
export type InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryResult =
	Apollo.QueryResult<
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQuery,
		InternationalPaymentsPreferences_GetStripePaymentCapabilitiesQueryVariables
	>;
export const InternationalPaymentsPreferences_RequestStripeCapabilitiesDocument = gql`
	mutation InternationalPaymentsPreferences_RequestStripeCapabilities(
		$where: OrganizationWhereUniqueInput!
	) {
		requestStripeCapabilities(where: $where)
	}
`;
export type InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationFn =
	Apollo.MutationFunction<
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutation,
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationVariables
	>;

/**
 * __useInternationalPaymentsPreferences_RequestStripeCapabilitiesMutation__
 *
 * To run a mutation, you first call `useInternationalPaymentsPreferences_RequestStripeCapabilitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternationalPaymentsPreferences_RequestStripeCapabilitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internationalPaymentsPreferencesRequestStripeCapabilitiesMutation, { data, loading, error }] = useInternationalPaymentsPreferences_RequestStripeCapabilitiesMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInternationalPaymentsPreferences_RequestStripeCapabilitiesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutation,
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutation,
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationVariables
	>(
		InternationalPaymentsPreferences_RequestStripeCapabilitiesDocument,
		options
	);
}
export type InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationHookResult =
	ReturnType<
		typeof useInternationalPaymentsPreferences_RequestStripeCapabilitiesMutation
	>;
export type InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationResult =
	Apollo.MutationResult<InternationalPaymentsPreferences_RequestStripeCapabilitiesMutation>;
export type InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationOptions =
	Apollo.BaseMutationOptions<
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutation,
		InternationalPaymentsPreferences_RequestStripeCapabilitiesMutationVariables
	>;
export const LeadsConfiguration_GetInquiryFormApiKeyDocument = gql`
	query LeadsConfiguration_GetInquiryFormApiKey {
		getInquiryFormApiKey
	}
`;

/**
 * __useLeadsConfiguration_GetInquiryFormApiKeyQuery__
 *
 * To run a query within a React component, call `useLeadsConfiguration_GetInquiryFormApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsConfiguration_GetInquiryFormApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsConfiguration_GetInquiryFormApiKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeadsConfiguration_GetInquiryFormApiKeyQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LeadsConfiguration_GetInquiryFormApiKeyQuery,
		LeadsConfiguration_GetInquiryFormApiKeyQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		LeadsConfiguration_GetInquiryFormApiKeyQuery,
		LeadsConfiguration_GetInquiryFormApiKeyQueryVariables
	>(LeadsConfiguration_GetInquiryFormApiKeyDocument, options);
}
export function useLeadsConfiguration_GetInquiryFormApiKeyLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LeadsConfiguration_GetInquiryFormApiKeyQuery,
		LeadsConfiguration_GetInquiryFormApiKeyQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LeadsConfiguration_GetInquiryFormApiKeyQuery,
		LeadsConfiguration_GetInquiryFormApiKeyQueryVariables
	>(LeadsConfiguration_GetInquiryFormApiKeyDocument, options);
}
export type LeadsConfiguration_GetInquiryFormApiKeyQueryHookResult = ReturnType<
	typeof useLeadsConfiguration_GetInquiryFormApiKeyQuery
>;
export type LeadsConfiguration_GetInquiryFormApiKeyLazyQueryHookResult =
	ReturnType<typeof useLeadsConfiguration_GetInquiryFormApiKeyLazyQuery>;
export type LeadsConfiguration_GetInquiryFormApiKeyQueryResult =
	Apollo.QueryResult<
		LeadsConfiguration_GetInquiryFormApiKeyQuery,
		LeadsConfiguration_GetInquiryFormApiKeyQueryVariables
	>;
export const LeadsConfiguration_GetOrgUserWhereDocument = gql`
	query LeadsConfiguration_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				...canAccessPremiumOrganization
			}
		}
	}
	${CanAccessPremiumOrganizationFragmentDoc}
`;

/**
 * __useLeadsConfiguration_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useLeadsConfiguration_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsConfiguration_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsConfiguration_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLeadsConfiguration_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		LeadsConfiguration_GetOrgUserWhereQuery,
		LeadsConfiguration_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		LeadsConfiguration_GetOrgUserWhereQuery,
		LeadsConfiguration_GetOrgUserWhereQueryVariables
	>(LeadsConfiguration_GetOrgUserWhereDocument, options);
}
export function useLeadsConfiguration_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LeadsConfiguration_GetOrgUserWhereQuery,
		LeadsConfiguration_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LeadsConfiguration_GetOrgUserWhereQuery,
		LeadsConfiguration_GetOrgUserWhereQueryVariables
	>(LeadsConfiguration_GetOrgUserWhereDocument, options);
}
export type LeadsConfiguration_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useLeadsConfiguration_GetOrgUserWhereQuery
>;
export type LeadsConfiguration_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useLeadsConfiguration_GetOrgUserWhereLazyQuery
>;
export type LeadsConfiguration_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	LeadsConfiguration_GetOrgUserWhereQuery,
	LeadsConfiguration_GetOrgUserWhereQueryVariables
>;
export const ReferralCode_GetOrganizationReferralCodeDocument = gql`
	query ReferralCode_getOrganizationReferralCode(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationReferralCode(where: $where) {
			id
			name
			onboardingLink
			onboardedOrgs {
				id
				name
				contactEmail
				createdAt
			}
		}
	}
`;

/**
 * __useReferralCode_GetOrganizationReferralCodeQuery__
 *
 * To run a query within a React component, call `useReferralCode_GetOrganizationReferralCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralCode_GetOrganizationReferralCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralCode_GetOrganizationReferralCodeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReferralCode_GetOrganizationReferralCodeQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReferralCode_GetOrganizationReferralCodeQuery,
		ReferralCode_GetOrganizationReferralCodeQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReferralCode_GetOrganizationReferralCodeQuery,
		ReferralCode_GetOrganizationReferralCodeQueryVariables
	>(ReferralCode_GetOrganizationReferralCodeDocument, options);
}
export function useReferralCode_GetOrganizationReferralCodeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReferralCode_GetOrganizationReferralCodeQuery,
		ReferralCode_GetOrganizationReferralCodeQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReferralCode_GetOrganizationReferralCodeQuery,
		ReferralCode_GetOrganizationReferralCodeQueryVariables
	>(ReferralCode_GetOrganizationReferralCodeDocument, options);
}
export type ReferralCode_GetOrganizationReferralCodeQueryHookResult =
	ReturnType<typeof useReferralCode_GetOrganizationReferralCodeQuery>;
export type ReferralCode_GetOrganizationReferralCodeLazyQueryHookResult =
	ReturnType<typeof useReferralCode_GetOrganizationReferralCodeLazyQuery>;
export type ReferralCode_GetOrganizationReferralCodeQueryResult =
	Apollo.QueryResult<
		ReferralCode_GetOrganizationReferralCodeQuery,
		ReferralCode_GetOrganizationReferralCodeQueryVariables
	>;
export const UseUpdateOrganizationContactInfo_GetOrganizationWhereDocument = gql`
	query useUpdateOrganizationContactInfo_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			...useUpdateOrganizationContactInfoOrganization
		}
	}
	${UseUpdateOrganizationContactInfoOrganizationFragmentDoc}
`;

/**
 * __useUseUpdateOrganizationContactInfo_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useUseUpdateOrganizationContactInfo_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseUpdateOrganizationContactInfo_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseUpdateOrganizationContactInfo_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseUpdateOrganizationContactInfo_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQuery,
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQuery,
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryVariables
	>(UseUpdateOrganizationContactInfo_GetOrganizationWhereDocument, options);
}
export function useUseUpdateOrganizationContactInfo_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQuery,
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQuery,
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryVariables
	>(UseUpdateOrganizationContactInfo_GetOrganizationWhereDocument, options);
}
export type UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryHookResult =
	ReturnType<
		typeof useUseUpdateOrganizationContactInfo_GetOrganizationWhereQuery
	>;
export type UseUpdateOrganizationContactInfo_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<
		typeof useUseUpdateOrganizationContactInfo_GetOrganizationWhereLazyQuery
	>;
export type UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQuery,
		UseUpdateOrganizationContactInfo_GetOrganizationWhereQueryVariables
	>;
export const UseUpdateOrganizationContactInfoForm_UpdateOrganizationDocument = gql`
	mutation useUpdateOrganizationContactInfoForm_updateOrganization(
		$where: OrganizationWhereUniqueInput!
		$data: OrganizationCustomUpdateInput!
	) {
		updateOrganization(where: $where, data: $data) {
			...useUpdateOrganizationContactInfoOrganization
		}
	}
	${UseUpdateOrganizationContactInfoOrganizationFragmentDoc}
`;
export type UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationFn =
	Apollo.MutationFunction<
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation,
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationVariables
	>;

/**
 * __useUseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useUpdateOrganizationContactInfoFormUpdateOrganizationMutation, { data, loading, error }] = useUseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation,
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation,
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationVariables
	>(UseUpdateOrganizationContactInfoForm_UpdateOrganizationDocument, options);
}
export type UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationHookResult =
	ReturnType<
		typeof useUseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation
	>;
export type UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationResult =
	Apollo.MutationResult<UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation>;
export type UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationOptions =
	Apollo.BaseMutationOptions<
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutation,
		UseUpdateOrganizationContactInfoForm_UpdateOrganizationMutationVariables
	>;
export const SubscriptionCancellationModal_CancelVendorStripeSubscriptionDocument = gql`
	mutation subscriptionCancellationModal_cancelVendorStripeSubscription {
		cancelVendorStripeSubscription {
			...subscriptionCancellationModalSubscriptionObject
		}
	}
	${SubscriptionCancellationModalSubscriptionObjectFragmentDoc}
`;
export type SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationFn =
	Apollo.MutationFunction<
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation,
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationVariables
	>;

/**
 * __useSubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useSubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCancellationModalCancelVendorStripeSubscriptionMutation, { data, loading, error }] = useSubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation,
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation,
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationVariables
	>(
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionDocument,
		options
	);
}
export type SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationHookResult =
	ReturnType<
		typeof useSubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation
	>;
export type SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationResult =
	Apollo.MutationResult<SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation>;
export type SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationOptions =
	Apollo.BaseMutationOptions<
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutation,
		SubscriptionCancellationModal_CancelVendorStripeSubscriptionMutationVariables
	>;
export const ConfirmSubscriptionSelection_ChangeVendorSubscriptionDocument = gql`
	mutation confirmSubscriptionSelection_changeVendorSubscription(
		$data: StripeVendorSubscriptionChangeInput!
	) {
		changeVendorSubscription(data: $data) {
			... on SubscriptionObject {
				...confirmSubscriptionSelectionSubscriptionObject
			}
		}
	}
	${ConfirmSubscriptionSelectionSubscriptionObjectFragmentDoc}
`;
export type ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationFn =
	Apollo.MutationFunction<
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation,
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationVariables
	>;

/**
 * __useConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation__
 *
 * To run a mutation, you first call `useConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSubscriptionSelectionChangeVendorSubscriptionMutation, { data, loading, error }] = useConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation,
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation,
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationVariables
	>(ConfirmSubscriptionSelection_ChangeVendorSubscriptionDocument, options);
}
export type ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationHookResult =
	ReturnType<
		typeof useConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation
	>;
export type ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationResult =
	Apollo.MutationResult<ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation>;
export type ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationOptions =
	Apollo.BaseMutationOptions<
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutation,
		ConfirmSubscriptionSelection_ChangeVendorSubscriptionMutationVariables
	>;
export const ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionDocument = gql`
	mutation confirmSubscriptionSelection_createVendorStripeSubscription(
		$data: StripeVendorSubscriptionCreationInput!
	) {
		createVendorStripeSubscription(data: $data) {
			... on SubscriptionObject {
				...confirmSubscriptionSelectionSubscriptionObject
			}
			... on RedirectUrl {
				redirect
			}
		}
	}
	${ConfirmSubscriptionSelectionSubscriptionObjectFragmentDoc}
`;
export type ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationFn =
	Apollo.MutationFunction<
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationVariables
	>;

/**
 * __useConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSubscriptionSelectionCreateVendorStripeSubscriptionMutation, { data, loading, error }] = useConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationVariables
	>(
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionDocument,
		options
	);
}
export type ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationHookResult =
	ReturnType<
		typeof useConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation
	>;
export type ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationResult =
	Apollo.MutationResult<ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation>;
export type ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationOptions =
	Apollo.BaseMutationOptions<
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CreateVendorStripeSubscriptionMutationVariables
	>;
export const ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionDocument = gql`
	mutation confirmSubscriptionSelection_cancelVendorStripeSubscription {
		cancelVendorStripeSubscription {
			...confirmSubscriptionSelectionSubscriptionObject
		}
	}
	${ConfirmSubscriptionSelectionSubscriptionObjectFragmentDoc}
`;
export type ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationFn =
	Apollo.MutationFunction<
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationVariables
	>;

/**
 * __useConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSubscriptionSelectionCancelVendorStripeSubscriptionMutation, { data, loading, error }] = useConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationVariables
	>(
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionDocument,
		options
	);
}
export type ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationHookResult =
	ReturnType<
		typeof useConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation
	>;
export type ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationResult =
	Apollo.MutationResult<ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation>;
export type ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationOptions =
	Apollo.BaseMutationOptions<
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutation,
		ConfirmSubscriptionSelection_CancelVendorStripeSubscriptionMutationVariables
	>;
export const ConfirmSubscriptionSelection_RegisterCouponUsageDocument = gql`
	mutation confirmSubscriptionSelection_registerCouponUsage(
		$data: RegisterCouponUsageWhere!
		$where: OrganizationWhereUniqueInput!
	) {
		registerCouponUsage(data: $data, where: $where) {
			id
		}
	}
`;
export type ConfirmSubscriptionSelection_RegisterCouponUsageMutationFn =
	Apollo.MutationFunction<
		ConfirmSubscriptionSelection_RegisterCouponUsageMutation,
		ConfirmSubscriptionSelection_RegisterCouponUsageMutationVariables
	>;

/**
 * __useConfirmSubscriptionSelection_RegisterCouponUsageMutation__
 *
 * To run a mutation, you first call `useConfirmSubscriptionSelection_RegisterCouponUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSubscriptionSelection_RegisterCouponUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSubscriptionSelectionRegisterCouponUsageMutation, { data, loading, error }] = useConfirmSubscriptionSelection_RegisterCouponUsageMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useConfirmSubscriptionSelection_RegisterCouponUsageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmSubscriptionSelection_RegisterCouponUsageMutation,
		ConfirmSubscriptionSelection_RegisterCouponUsageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmSubscriptionSelection_RegisterCouponUsageMutation,
		ConfirmSubscriptionSelection_RegisterCouponUsageMutationVariables
	>(ConfirmSubscriptionSelection_RegisterCouponUsageDocument, options);
}
export type ConfirmSubscriptionSelection_RegisterCouponUsageMutationHookResult =
	ReturnType<
		typeof useConfirmSubscriptionSelection_RegisterCouponUsageMutation
	>;
export type ConfirmSubscriptionSelection_RegisterCouponUsageMutationResult =
	Apollo.MutationResult<ConfirmSubscriptionSelection_RegisterCouponUsageMutation>;
export type ConfirmSubscriptionSelection_RegisterCouponUsageMutationOptions =
	Apollo.BaseMutationOptions<
		ConfirmSubscriptionSelection_RegisterCouponUsageMutation,
		ConfirmSubscriptionSelection_RegisterCouponUsageMutationVariables
	>;
export const SubscriptionOptionButton_GetCouponDetailsDocument = gql`
	query SubscriptionOptionButton_getCouponDetails($where: CouponByNameInput!) {
		getCouponDetails(where: $where) {
			...subscriptionOptionButtonReducedCouponWithPlanData
		}
	}
	${SubscriptionOptionButtonReducedCouponWithPlanDataFragmentDoc}
`;

/**
 * __useSubscriptionOptionButton_GetCouponDetailsQuery__
 *
 * To run a query within a React component, call `useSubscriptionOptionButton_GetCouponDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionOptionButton_GetCouponDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionOptionButton_GetCouponDetailsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscriptionOptionButton_GetCouponDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		SubscriptionOptionButton_GetCouponDetailsQuery,
		SubscriptionOptionButton_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SubscriptionOptionButton_GetCouponDetailsQuery,
		SubscriptionOptionButton_GetCouponDetailsQueryVariables
	>(SubscriptionOptionButton_GetCouponDetailsDocument, options);
}
export function useSubscriptionOptionButton_GetCouponDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SubscriptionOptionButton_GetCouponDetailsQuery,
		SubscriptionOptionButton_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SubscriptionOptionButton_GetCouponDetailsQuery,
		SubscriptionOptionButton_GetCouponDetailsQueryVariables
	>(SubscriptionOptionButton_GetCouponDetailsDocument, options);
}
export type SubscriptionOptionButton_GetCouponDetailsQueryHookResult =
	ReturnType<typeof useSubscriptionOptionButton_GetCouponDetailsQuery>;
export type SubscriptionOptionButton_GetCouponDetailsLazyQueryHookResult =
	ReturnType<typeof useSubscriptionOptionButton_GetCouponDetailsLazyQuery>;
export type SubscriptionOptionButton_GetCouponDetailsQueryResult =
	Apollo.QueryResult<
		SubscriptionOptionButton_GetCouponDetailsQuery,
		SubscriptionOptionButton_GetCouponDetailsQueryVariables
	>;
export const SubscriptionSelectionModal_GetGlobalVariablesDocument = gql`
	query SubscriptionSelectionModal_getGlobalVariables {
		getGlobalVariables {
			SubscriptionPlanUrl
		}
	}
`;

/**
 * __useSubscriptionSelectionModal_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useSubscriptionSelectionModal_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionSelectionModal_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionSelectionModal_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionSelectionModal_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		SubscriptionSelectionModal_GetGlobalVariablesQuery,
		SubscriptionSelectionModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SubscriptionSelectionModal_GetGlobalVariablesQuery,
		SubscriptionSelectionModal_GetGlobalVariablesQueryVariables
	>(SubscriptionSelectionModal_GetGlobalVariablesDocument, options);
}
export function useSubscriptionSelectionModal_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SubscriptionSelectionModal_GetGlobalVariablesQuery,
		SubscriptionSelectionModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SubscriptionSelectionModal_GetGlobalVariablesQuery,
		SubscriptionSelectionModal_GetGlobalVariablesQueryVariables
	>(SubscriptionSelectionModal_GetGlobalVariablesDocument, options);
}
export type SubscriptionSelectionModal_GetGlobalVariablesQueryHookResult =
	ReturnType<typeof useSubscriptionSelectionModal_GetGlobalVariablesQuery>;
export type SubscriptionSelectionModal_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useSubscriptionSelectionModal_GetGlobalVariablesLazyQuery>;
export type SubscriptionSelectionModal_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		SubscriptionSelectionModal_GetGlobalVariablesQuery,
		SubscriptionSelectionModal_GetGlobalVariablesQueryVariables
	>;
export const UpdateVendorBilling_GetOrganizationWhereDocument = gql`
	query UpdateVendorBilling_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			id
			createdAt
			coupon {
				id
				name
			}
			...subscriptionSelectionModalOrganization
		}
	}
	${SubscriptionSelectionModalOrganizationFragmentDoc}
`;

/**
 * __useUpdateVendorBilling_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useUpdateVendorBilling_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorBilling_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateVendorBilling_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateVendorBilling_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UpdateVendorBilling_GetOrganizationWhereQuery,
		UpdateVendorBilling_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UpdateVendorBilling_GetOrganizationWhereQuery,
		UpdateVendorBilling_GetOrganizationWhereQueryVariables
	>(UpdateVendorBilling_GetOrganizationWhereDocument, options);
}
export function useUpdateVendorBilling_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UpdateVendorBilling_GetOrganizationWhereQuery,
		UpdateVendorBilling_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UpdateVendorBilling_GetOrganizationWhereQuery,
		UpdateVendorBilling_GetOrganizationWhereQueryVariables
	>(UpdateVendorBilling_GetOrganizationWhereDocument, options);
}
export type UpdateVendorBilling_GetOrganizationWhereQueryHookResult =
	ReturnType<typeof useUpdateVendorBilling_GetOrganizationWhereQuery>;
export type UpdateVendorBilling_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<typeof useUpdateVendorBilling_GetOrganizationWhereLazyQuery>;
export type UpdateVendorBilling_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		UpdateVendorBilling_GetOrganizationWhereQuery,
		UpdateVendorBilling_GetOrganizationWhereQueryVariables
	>;
export const UpdateVendorBilling_GetStripeSubscriptionDocument = gql`
	query UpdateVendorBilling_getStripeSubscription {
		getStripeVendorSubscription {
			id
			...promotionalDiscountSubscriptionObject
			...currentPlanSubscriptionObject
			...subscriptionSelectionModalSubscriptionObject
			...subscriptionCancellationModalSubscriptionObject
			...getSubscriptionStatusSubscriptionObject
		}
		getNextStripeInvoice {
			period_start
			period_end
			starting_balance
			...nextChargeStripeInvoice
			...getSubscriptionStatusStripeInvoice
		}
	}
	${PromotionalDiscountSubscriptionObjectFragmentDoc}
	${CurrentPlanSubscriptionObjectFragmentDoc}
	${SubscriptionSelectionModalSubscriptionObjectFragmentDoc}
	${SubscriptionCancellationModalSubscriptionObjectFragmentDoc}
	${GetSubscriptionStatusSubscriptionObjectFragmentDoc}
	${NextChargeStripeInvoiceFragmentDoc}
	${GetSubscriptionStatusStripeInvoiceFragmentDoc}
`;

/**
 * __useUpdateVendorBilling_GetStripeSubscriptionQuery__
 *
 * To run a query within a React component, call `useUpdateVendorBilling_GetStripeSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorBilling_GetStripeSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateVendorBilling_GetStripeSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateVendorBilling_GetStripeSubscriptionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UpdateVendorBilling_GetStripeSubscriptionQuery,
		UpdateVendorBilling_GetStripeSubscriptionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UpdateVendorBilling_GetStripeSubscriptionQuery,
		UpdateVendorBilling_GetStripeSubscriptionQueryVariables
	>(UpdateVendorBilling_GetStripeSubscriptionDocument, options);
}
export function useUpdateVendorBilling_GetStripeSubscriptionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UpdateVendorBilling_GetStripeSubscriptionQuery,
		UpdateVendorBilling_GetStripeSubscriptionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UpdateVendorBilling_GetStripeSubscriptionQuery,
		UpdateVendorBilling_GetStripeSubscriptionQueryVariables
	>(UpdateVendorBilling_GetStripeSubscriptionDocument, options);
}
export type UpdateVendorBilling_GetStripeSubscriptionQueryHookResult =
	ReturnType<typeof useUpdateVendorBilling_GetStripeSubscriptionQuery>;
export type UpdateVendorBilling_GetStripeSubscriptionLazyQueryHookResult =
	ReturnType<typeof useUpdateVendorBilling_GetStripeSubscriptionLazyQuery>;
export type UpdateVendorBilling_GetStripeSubscriptionQueryResult =
	Apollo.QueryResult<
		UpdateVendorBilling_GetStripeSubscriptionQuery,
		UpdateVendorBilling_GetStripeSubscriptionQueryVariables
	>;
export const UpdateVendorBilling_GetPaymentMethodsForVendorCustomerDocument = gql`
	query UpdateVendorBilling_getPaymentMethodsForVendorCustomer(
		$where: OrganizationWhereUniqueInput!
	) {
		getPaymentMethodsForVendorCustomer(where: $where) {
			data {
				...updateVendorBillingSource
			}
		}
	}
	${UpdateVendorBillingSourceFragmentDoc}
`;

/**
 * __useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery__
 *
 * To run a query within a React component, call `useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery,
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery,
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryVariables
	>(UpdateVendorBilling_GetPaymentMethodsForVendorCustomerDocument, options);
}
export function useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery,
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery,
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryVariables
	>(UpdateVendorBilling_GetPaymentMethodsForVendorCustomerDocument, options);
}
export type UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryHookResult =
	ReturnType<
		typeof useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery
	>;
export type UpdateVendorBilling_GetPaymentMethodsForVendorCustomerLazyQueryHookResult =
	ReturnType<
		typeof useUpdateVendorBilling_GetPaymentMethodsForVendorCustomerLazyQuery
	>;
export type UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryResult =
	Apollo.QueryResult<
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQuery,
		UpdateVendorBilling_GetPaymentMethodsForVendorCustomerQueryVariables
	>;
export const UpdateVendorBilling_GetStripeConnectAccountDocument = gql`
	query UpdateVendorBilling_getStripeConnectAccount(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripeConnectAccount(where: $where) {
			external_accounts {
				data {
					id
				}
			}
		}
	}
`;

/**
 * __useUpdateVendorBilling_GetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `useUpdateVendorBilling_GetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorBilling_GetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateVendorBilling_GetStripeConnectAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateVendorBilling_GetStripeConnectAccountQuery(
	baseOptions: Apollo.QueryHookOptions<
		UpdateVendorBilling_GetStripeConnectAccountQuery,
		UpdateVendorBilling_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UpdateVendorBilling_GetStripeConnectAccountQuery,
		UpdateVendorBilling_GetStripeConnectAccountQueryVariables
	>(UpdateVendorBilling_GetStripeConnectAccountDocument, options);
}
export function useUpdateVendorBilling_GetStripeConnectAccountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UpdateVendorBilling_GetStripeConnectAccountQuery,
		UpdateVendorBilling_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UpdateVendorBilling_GetStripeConnectAccountQuery,
		UpdateVendorBilling_GetStripeConnectAccountQueryVariables
	>(UpdateVendorBilling_GetStripeConnectAccountDocument, options);
}
export type UpdateVendorBilling_GetStripeConnectAccountQueryHookResult =
	ReturnType<typeof useUpdateVendorBilling_GetStripeConnectAccountQuery>;
export type UpdateVendorBilling_GetStripeConnectAccountLazyQueryHookResult =
	ReturnType<typeof useUpdateVendorBilling_GetStripeConnectAccountLazyQuery>;
export type UpdateVendorBilling_GetStripeConnectAccountQueryResult =
	Apollo.QueryResult<
		UpdateVendorBilling_GetStripeConnectAccountQuery,
		UpdateVendorBilling_GetStripeConnectAccountQueryVariables
	>;
export const UpdateVendorBilling_GetCouponDetailsDocument = gql`
	query UpdateVendorBilling_getCouponDetails($where: CouponByNameInput!) {
		getCouponDetails(where: $where) {
			percent_off
			duration_in_months
			...promotionalDiscountReducedCoupon
			...currentPlanReducedCoupon
			...nextChargeReducedCoupon
			...subscriptionSelectionModalReducedCoupon
		}
	}
	${PromotionalDiscountReducedCouponFragmentDoc}
	${CurrentPlanReducedCouponFragmentDoc}
	${NextChargeReducedCouponFragmentDoc}
	${SubscriptionSelectionModalReducedCouponFragmentDoc}
`;

/**
 * __useUpdateVendorBilling_GetCouponDetailsQuery__
 *
 * To run a query within a React component, call `useUpdateVendorBilling_GetCouponDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorBilling_GetCouponDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateVendorBilling_GetCouponDetailsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateVendorBilling_GetCouponDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		UpdateVendorBilling_GetCouponDetailsQuery,
		UpdateVendorBilling_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UpdateVendorBilling_GetCouponDetailsQuery,
		UpdateVendorBilling_GetCouponDetailsQueryVariables
	>(UpdateVendorBilling_GetCouponDetailsDocument, options);
}
export function useUpdateVendorBilling_GetCouponDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UpdateVendorBilling_GetCouponDetailsQuery,
		UpdateVendorBilling_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UpdateVendorBilling_GetCouponDetailsQuery,
		UpdateVendorBilling_GetCouponDetailsQueryVariables
	>(UpdateVendorBilling_GetCouponDetailsDocument, options);
}
export type UpdateVendorBilling_GetCouponDetailsQueryHookResult = ReturnType<
	typeof useUpdateVendorBilling_GetCouponDetailsQuery
>;
export type UpdateVendorBilling_GetCouponDetailsLazyQueryHookResult =
	ReturnType<typeof useUpdateVendorBilling_GetCouponDetailsLazyQuery>;
export type UpdateVendorBilling_GetCouponDetailsQueryResult =
	Apollo.QueryResult<
		UpdateVendorBilling_GetCouponDetailsQuery,
		UpdateVendorBilling_GetCouponDetailsQueryVariables
	>;
export const CurrentPlan_GetPlansDocument = gql`
	query CurrentPlan_getPlans {
		getPlans {
			...currentPlanPlan
			...subscriptionSelectionModalPlan
		}
	}
	${CurrentPlanPlanFragmentDoc}
	${SubscriptionSelectionModalPlanFragmentDoc}
`;

/**
 * __useCurrentPlan_GetPlansQuery__
 *
 * To run a query within a React component, call `useCurrentPlan_GetPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPlan_GetPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPlan_GetPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentPlan_GetPlansQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CurrentPlan_GetPlansQuery,
		CurrentPlan_GetPlansQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CurrentPlan_GetPlansQuery,
		CurrentPlan_GetPlansQueryVariables
	>(CurrentPlan_GetPlansDocument, options);
}
export function useCurrentPlan_GetPlansLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CurrentPlan_GetPlansQuery,
		CurrentPlan_GetPlansQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CurrentPlan_GetPlansQuery,
		CurrentPlan_GetPlansQueryVariables
	>(CurrentPlan_GetPlansDocument, options);
}
export type CurrentPlan_GetPlansQueryHookResult = ReturnType<
	typeof useCurrentPlan_GetPlansQuery
>;
export type CurrentPlan_GetPlansLazyQueryHookResult = ReturnType<
	typeof useCurrentPlan_GetPlansLazyQuery
>;
export type CurrentPlan_GetPlansQueryResult = Apollo.QueryResult<
	CurrentPlan_GetPlansQuery,
	CurrentPlan_GetPlansQueryVariables
>;
export const UpdateVendorBilling_PayOpenSubscriptionInvoicesDocument = gql`
	mutation UpdateVendorBilling_payOpenSubscriptionInvoices {
		payOpenSubscriptionInvoices
	}
`;
export type UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationFn =
	Apollo.MutationFunction<
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutation,
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationVariables
	>;

/**
 * __useUpdateVendorBilling_PayOpenSubscriptionInvoicesMutation__
 *
 * To run a mutation, you first call `useUpdateVendorBilling_PayOpenSubscriptionInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorBilling_PayOpenSubscriptionInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorBillingPayOpenSubscriptionInvoicesMutation, { data, loading, error }] = useUpdateVendorBilling_PayOpenSubscriptionInvoicesMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateVendorBilling_PayOpenSubscriptionInvoicesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutation,
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutation,
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationVariables
	>(UpdateVendorBilling_PayOpenSubscriptionInvoicesDocument, options);
}
export type UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationHookResult =
	ReturnType<typeof useUpdateVendorBilling_PayOpenSubscriptionInvoicesMutation>;
export type UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationResult =
	Apollo.MutationResult<UpdateVendorBilling_PayOpenSubscriptionInvoicesMutation>;
export type UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationOptions =
	Apollo.BaseMutationOptions<
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutation,
		UpdateVendorBilling_PayOpenSubscriptionInvoicesMutationVariables
	>;
export const Webhooks_GetGlobalVariablesDocument = gql`
	query Webhooks_getGlobalVariables {
		getGlobalVariables {
			WebhookHelpUrl
			WebhookOpenApiUrl
		}
	}
`;

/**
 * __useWebhooks_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useWebhooks_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhooks_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhooks_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebhooks_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		Webhooks_GetGlobalVariablesQuery,
		Webhooks_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		Webhooks_GetGlobalVariablesQuery,
		Webhooks_GetGlobalVariablesQueryVariables
	>(Webhooks_GetGlobalVariablesDocument, options);
}
export function useWebhooks_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Webhooks_GetGlobalVariablesQuery,
		Webhooks_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		Webhooks_GetGlobalVariablesQuery,
		Webhooks_GetGlobalVariablesQueryVariables
	>(Webhooks_GetGlobalVariablesDocument, options);
}
export type Webhooks_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useWebhooks_GetGlobalVariablesQuery
>;
export type Webhooks_GetGlobalVariablesLazyQueryHookResult = ReturnType<
	typeof useWebhooks_GetGlobalVariablesLazyQuery
>;
export type Webhooks_GetGlobalVariablesQueryResult = Apollo.QueryResult<
	Webhooks_GetGlobalVariablesQuery,
	Webhooks_GetGlobalVariablesQueryVariables
>;
export const AdminWebhookDeliveryHistory_GetDeliveriesDocument = gql`
	query AdminWebhookDeliveryHistory_GetDeliveries(
		$endpointId: ID!
		$take: Int!
		$createdAt: DateTimeFilter
	) {
		getWebhookDeliveries(
			endpointId: $endpointId
			take: $take
			createdAt: $createdAt
		) {
			...AdminWebhookDeliveryHistory_WebhookDelivery
		}
	}
	${AdminWebhookDeliveryHistory_WebhookDeliveryFragmentDoc}
`;

/**
 * __useAdminWebhookDeliveryHistory_GetDeliveriesQuery__
 *
 * To run a query within a React component, call `useAdminWebhookDeliveryHistory_GetDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminWebhookDeliveryHistory_GetDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminWebhookDeliveryHistory_GetDeliveriesQuery({
 *   variables: {
 *      endpointId: // value for 'endpointId'
 *      take: // value for 'take'
 *      createdAt: // value for 'createdAt'
 *   },
 * });
 */
export function useAdminWebhookDeliveryHistory_GetDeliveriesQuery(
	baseOptions: Apollo.QueryHookOptions<
		AdminWebhookDeliveryHistory_GetDeliveriesQuery,
		AdminWebhookDeliveryHistory_GetDeliveriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		AdminWebhookDeliveryHistory_GetDeliveriesQuery,
		AdminWebhookDeliveryHistory_GetDeliveriesQueryVariables
	>(AdminWebhookDeliveryHistory_GetDeliveriesDocument, options);
}
export function useAdminWebhookDeliveryHistory_GetDeliveriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AdminWebhookDeliveryHistory_GetDeliveriesQuery,
		AdminWebhookDeliveryHistory_GetDeliveriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AdminWebhookDeliveryHistory_GetDeliveriesQuery,
		AdminWebhookDeliveryHistory_GetDeliveriesQueryVariables
	>(AdminWebhookDeliveryHistory_GetDeliveriesDocument, options);
}
export type AdminWebhookDeliveryHistory_GetDeliveriesQueryHookResult =
	ReturnType<typeof useAdminWebhookDeliveryHistory_GetDeliveriesQuery>;
export type AdminWebhookDeliveryHistory_GetDeliveriesLazyQueryHookResult =
	ReturnType<typeof useAdminWebhookDeliveryHistory_GetDeliveriesLazyQuery>;
export type AdminWebhookDeliveryHistory_GetDeliveriesQueryResult =
	Apollo.QueryResult<
		AdminWebhookDeliveryHistory_GetDeliveriesQuery,
		AdminWebhookDeliveryHistory_GetDeliveriesQueryVariables
	>;
export const AdminWebhookDeliveryHistory_ResendDeliveryDocument = gql`
	mutation AdminWebhookDeliveryHistory_ResendDelivery($deliveryId: ID!) {
		resendWebhookDelivery(deliveryId: $deliveryId)
	}
`;
export type AdminWebhookDeliveryHistory_ResendDeliveryMutationFn =
	Apollo.MutationFunction<
		AdminWebhookDeliveryHistory_ResendDeliveryMutation,
		AdminWebhookDeliveryHistory_ResendDeliveryMutationVariables
	>;

/**
 * __useAdminWebhookDeliveryHistory_ResendDeliveryMutation__
 *
 * To run a mutation, you first call `useAdminWebhookDeliveryHistory_ResendDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminWebhookDeliveryHistory_ResendDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminWebhookDeliveryHistoryResendDeliveryMutation, { data, loading, error }] = useAdminWebhookDeliveryHistory_ResendDeliveryMutation({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useAdminWebhookDeliveryHistory_ResendDeliveryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AdminWebhookDeliveryHistory_ResendDeliveryMutation,
		AdminWebhookDeliveryHistory_ResendDeliveryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AdminWebhookDeliveryHistory_ResendDeliveryMutation,
		AdminWebhookDeliveryHistory_ResendDeliveryMutationVariables
	>(AdminWebhookDeliveryHistory_ResendDeliveryDocument, options);
}
export type AdminWebhookDeliveryHistory_ResendDeliveryMutationHookResult =
	ReturnType<typeof useAdminWebhookDeliveryHistory_ResendDeliveryMutation>;
export type AdminWebhookDeliveryHistory_ResendDeliveryMutationResult =
	Apollo.MutationResult<AdminWebhookDeliveryHistory_ResendDeliveryMutation>;
export type AdminWebhookDeliveryHistory_ResendDeliveryMutationOptions =
	Apollo.BaseMutationOptions<
		AdminWebhookDeliveryHistory_ResendDeliveryMutation,
		AdminWebhookDeliveryHistory_ResendDeliveryMutationVariables
	>;
export const AdminWebhooks_GetDataDocument = gql`
	query AdminWebhooks_GetData {
		getWebhookEndpoints {
			...AdminWebhooks_WebhookEndpoint
		}
		getApiVersions
	}
	${AdminWebhooks_WebhookEndpointFragmentDoc}
`;

/**
 * __useAdminWebhooks_GetDataQuery__
 *
 * To run a query within a React component, call `useAdminWebhooks_GetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminWebhooks_GetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminWebhooks_GetDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminWebhooks_GetDataQuery(
	baseOptions?: Apollo.QueryHookOptions<
		AdminWebhooks_GetDataQuery,
		AdminWebhooks_GetDataQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		AdminWebhooks_GetDataQuery,
		AdminWebhooks_GetDataQueryVariables
	>(AdminWebhooks_GetDataDocument, options);
}
export function useAdminWebhooks_GetDataLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AdminWebhooks_GetDataQuery,
		AdminWebhooks_GetDataQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AdminWebhooks_GetDataQuery,
		AdminWebhooks_GetDataQueryVariables
	>(AdminWebhooks_GetDataDocument, options);
}
export type AdminWebhooks_GetDataQueryHookResult = ReturnType<
	typeof useAdminWebhooks_GetDataQuery
>;
export type AdminWebhooks_GetDataLazyQueryHookResult = ReturnType<
	typeof useAdminWebhooks_GetDataLazyQuery
>;
export type AdminWebhooks_GetDataQueryResult = Apollo.QueryResult<
	AdminWebhooks_GetDataQuery,
	AdminWebhooks_GetDataQueryVariables
>;
export const AdminWebhooks_ConfigureWebhookEndpointDocument = gql`
	mutation AdminWebhooks_ConfigureWebhookEndpoint(
		$data: WebhookEndpointInput!
	) {
		configureWebhookEndpoint(data: $data) {
			endpoint {
				...AdminWebhooks_WebhookEndpoint
			}
			signingSecret
		}
	}
	${AdminWebhooks_WebhookEndpointFragmentDoc}
`;
export type AdminWebhooks_ConfigureWebhookEndpointMutationFn =
	Apollo.MutationFunction<
		AdminWebhooks_ConfigureWebhookEndpointMutation,
		AdminWebhooks_ConfigureWebhookEndpointMutationVariables
	>;

/**
 * __useAdminWebhooks_ConfigureWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useAdminWebhooks_ConfigureWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminWebhooks_ConfigureWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminWebhooksConfigureWebhookEndpointMutation, { data, loading, error }] = useAdminWebhooks_ConfigureWebhookEndpointMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminWebhooks_ConfigureWebhookEndpointMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AdminWebhooks_ConfigureWebhookEndpointMutation,
		AdminWebhooks_ConfigureWebhookEndpointMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AdminWebhooks_ConfigureWebhookEndpointMutation,
		AdminWebhooks_ConfigureWebhookEndpointMutationVariables
	>(AdminWebhooks_ConfigureWebhookEndpointDocument, options);
}
export type AdminWebhooks_ConfigureWebhookEndpointMutationHookResult =
	ReturnType<typeof useAdminWebhooks_ConfigureWebhookEndpointMutation>;
export type AdminWebhooks_ConfigureWebhookEndpointMutationResult =
	Apollo.MutationResult<AdminWebhooks_ConfigureWebhookEndpointMutation>;
export type AdminWebhooks_ConfigureWebhookEndpointMutationOptions =
	Apollo.BaseMutationOptions<
		AdminWebhooks_ConfigureWebhookEndpointMutation,
		AdminWebhooks_ConfigureWebhookEndpointMutationVariables
	>;
export const AdminWebhooks_RotateWebhookSecretDocument = gql`
	mutation AdminWebhooks_RotateWebhookSecret($endpointId: ID!) {
		rotateWebhookSecret(endpointId: $endpointId) {
			endpoint {
				...AdminWebhooks_WebhookEndpoint
			}
			signingSecret
		}
	}
	${AdminWebhooks_WebhookEndpointFragmentDoc}
`;
export type AdminWebhooks_RotateWebhookSecretMutationFn =
	Apollo.MutationFunction<
		AdminWebhooks_RotateWebhookSecretMutation,
		AdminWebhooks_RotateWebhookSecretMutationVariables
	>;

/**
 * __useAdminWebhooks_RotateWebhookSecretMutation__
 *
 * To run a mutation, you first call `useAdminWebhooks_RotateWebhookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminWebhooks_RotateWebhookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminWebhooksRotateWebhookSecretMutation, { data, loading, error }] = useAdminWebhooks_RotateWebhookSecretMutation({
 *   variables: {
 *      endpointId: // value for 'endpointId'
 *   },
 * });
 */
export function useAdminWebhooks_RotateWebhookSecretMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AdminWebhooks_RotateWebhookSecretMutation,
		AdminWebhooks_RotateWebhookSecretMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AdminWebhooks_RotateWebhookSecretMutation,
		AdminWebhooks_RotateWebhookSecretMutationVariables
	>(AdminWebhooks_RotateWebhookSecretDocument, options);
}
export type AdminWebhooks_RotateWebhookSecretMutationHookResult = ReturnType<
	typeof useAdminWebhooks_RotateWebhookSecretMutation
>;
export type AdminWebhooks_RotateWebhookSecretMutationResult =
	Apollo.MutationResult<AdminWebhooks_RotateWebhookSecretMutation>;
export type AdminWebhooks_RotateWebhookSecretMutationOptions =
	Apollo.BaseMutationOptions<
		AdminWebhooks_RotateWebhookSecretMutation,
		AdminWebhooks_RotateWebhookSecretMutationVariables
	>;
export const AdminWebhooks_DeleteWebhookEndpointDocument = gql`
	mutation AdminWebhooks_DeleteWebhookEndpoint($endpointId: ID!) {
		deleteWebhookEndpoint(endpointId: $endpointId)
	}
`;
export type AdminWebhooks_DeleteWebhookEndpointMutationFn =
	Apollo.MutationFunction<
		AdminWebhooks_DeleteWebhookEndpointMutation,
		AdminWebhooks_DeleteWebhookEndpointMutationVariables
	>;

/**
 * __useAdminWebhooks_DeleteWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useAdminWebhooks_DeleteWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminWebhooks_DeleteWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminWebhooksDeleteWebhookEndpointMutation, { data, loading, error }] = useAdminWebhooks_DeleteWebhookEndpointMutation({
 *   variables: {
 *      endpointId: // value for 'endpointId'
 *   },
 * });
 */
export function useAdminWebhooks_DeleteWebhookEndpointMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AdminWebhooks_DeleteWebhookEndpointMutation,
		AdminWebhooks_DeleteWebhookEndpointMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AdminWebhooks_DeleteWebhookEndpointMutation,
		AdminWebhooks_DeleteWebhookEndpointMutationVariables
	>(AdminWebhooks_DeleteWebhookEndpointDocument, options);
}
export type AdminWebhooks_DeleteWebhookEndpointMutationHookResult = ReturnType<
	typeof useAdminWebhooks_DeleteWebhookEndpointMutation
>;
export type AdminWebhooks_DeleteWebhookEndpointMutationResult =
	Apollo.MutationResult<AdminWebhooks_DeleteWebhookEndpointMutation>;
export type AdminWebhooks_DeleteWebhookEndpointMutationOptions =
	Apollo.BaseMutationOptions<
		AdminWebhooks_DeleteWebhookEndpointMutation,
		AdminWebhooks_DeleteWebhookEndpointMutationVariables
	>;
export const Admin_GetAuthedUserDocument = gql`
	query Admin_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			...getAuthedUserFlattenedUserFields
		}
	}
	${GetAuthedUserFlattenedUserFieldsFragmentDoc}
`;

/**
 * __useAdmin_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useAdmin_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmin_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdmin_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdmin_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		Admin_GetAuthedUserQuery,
		Admin_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		Admin_GetAuthedUserQuery,
		Admin_GetAuthedUserQueryVariables
	>(Admin_GetAuthedUserDocument, options);
}
export function useAdmin_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Admin_GetAuthedUserQuery,
		Admin_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		Admin_GetAuthedUserQuery,
		Admin_GetAuthedUserQueryVariables
	>(Admin_GetAuthedUserDocument, options);
}
export type Admin_GetAuthedUserQueryHookResult = ReturnType<
	typeof useAdmin_GetAuthedUserQuery
>;
export type Admin_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useAdmin_GetAuthedUserLazyQuery
>;
export type Admin_GetAuthedUserQueryResult = Apollo.QueryResult<
	Admin_GetAuthedUserQuery,
	Admin_GetAuthedUserQueryVariables
>;
export const AutomatedNotificationsToggle_GetGlobalVariablesDocument = gql`
	query AutomatedNotificationsToggle_getGlobalVariables {
		getGlobalVariables {
			AutomatedNotificationsSupportUrl
		}
	}
`;

/**
 * __useAutomatedNotificationsToggle_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useAutomatedNotificationsToggle_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomatedNotificationsToggle_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomatedNotificationsToggle_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutomatedNotificationsToggle_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		AutomatedNotificationsToggle_GetGlobalVariablesQuery,
		AutomatedNotificationsToggle_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		AutomatedNotificationsToggle_GetGlobalVariablesQuery,
		AutomatedNotificationsToggle_GetGlobalVariablesQueryVariables
	>(AutomatedNotificationsToggle_GetGlobalVariablesDocument, options);
}
export function useAutomatedNotificationsToggle_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AutomatedNotificationsToggle_GetGlobalVariablesQuery,
		AutomatedNotificationsToggle_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AutomatedNotificationsToggle_GetGlobalVariablesQuery,
		AutomatedNotificationsToggle_GetGlobalVariablesQueryVariables
	>(AutomatedNotificationsToggle_GetGlobalVariablesDocument, options);
}
export type AutomatedNotificationsToggle_GetGlobalVariablesQueryHookResult =
	ReturnType<typeof useAutomatedNotificationsToggle_GetGlobalVariablesQuery>;
export type AutomatedNotificationsToggle_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<
		typeof useAutomatedNotificationsToggle_GetGlobalVariablesLazyQuery
	>;
export type AutomatedNotificationsToggle_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		AutomatedNotificationsToggle_GetGlobalVariablesQuery,
		AutomatedNotificationsToggle_GetGlobalVariablesQueryVariables
	>;
export const CalendarLinks_GetCalendarLinksDocument = gql`
	query calendarLinks_getCalendarLinks(
		$sourceType: CalendarSourceType!
		$sourceId: String!
	) {
		getCalendarLinks(sourceType: $sourceType, sourceId: $sourceId) {
			googleUrl
			outlookUrl
			webcalUrl
			downloadUrl
		}
	}
`;

/**
 * __useCalendarLinks_GetCalendarLinksQuery__
 *
 * To run a query within a React component, call `useCalendarLinks_GetCalendarLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarLinks_GetCalendarLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarLinks_GetCalendarLinksQuery({
 *   variables: {
 *      sourceType: // value for 'sourceType'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useCalendarLinks_GetCalendarLinksQuery(
	baseOptions: Apollo.QueryHookOptions<
		CalendarLinks_GetCalendarLinksQuery,
		CalendarLinks_GetCalendarLinksQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CalendarLinks_GetCalendarLinksQuery,
		CalendarLinks_GetCalendarLinksQueryVariables
	>(CalendarLinks_GetCalendarLinksDocument, options);
}
export function useCalendarLinks_GetCalendarLinksLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarLinks_GetCalendarLinksQuery,
		CalendarLinks_GetCalendarLinksQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CalendarLinks_GetCalendarLinksQuery,
		CalendarLinks_GetCalendarLinksQueryVariables
	>(CalendarLinks_GetCalendarLinksDocument, options);
}
export type CalendarLinks_GetCalendarLinksQueryHookResult = ReturnType<
	typeof useCalendarLinks_GetCalendarLinksQuery
>;
export type CalendarLinks_GetCalendarLinksLazyQueryHookResult = ReturnType<
	typeof useCalendarLinks_GetCalendarLinksLazyQuery
>;
export type CalendarLinks_GetCalendarLinksQueryResult = Apollo.QueryResult<
	CalendarLinks_GetCalendarLinksQuery,
	CalendarLinks_GetCalendarLinksQueryVariables
>;
export const CalendarLinks_SendCalendarInviteDocument = gql`
	mutation calendarLinks_sendCalendarInvite(
		$sourceType: CalendarSourceType!
		$sourceId: String!
		$recipientEmails: [String!]!
		$customizedEmail: CalendarInviteCustomizedEmailInput
	) {
		sendCalendarInvite(
			sourceType: $sourceType
			sourceId: $sourceId
			recipientEmails: $recipientEmails
			customizedEmail: $customizedEmail
		)
	}
`;
export type CalendarLinks_SendCalendarInviteMutationFn =
	Apollo.MutationFunction<
		CalendarLinks_SendCalendarInviteMutation,
		CalendarLinks_SendCalendarInviteMutationVariables
	>;

/**
 * __useCalendarLinks_SendCalendarInviteMutation__
 *
 * To run a mutation, you first call `useCalendarLinks_SendCalendarInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarLinks_SendCalendarInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarLinksSendCalendarInviteMutation, { data, loading, error }] = useCalendarLinks_SendCalendarInviteMutation({
 *   variables: {
 *      sourceType: // value for 'sourceType'
 *      sourceId: // value for 'sourceId'
 *      recipientEmails: // value for 'recipientEmails'
 *      customizedEmail: // value for 'customizedEmail'
 *   },
 * });
 */
export function useCalendarLinks_SendCalendarInviteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CalendarLinks_SendCalendarInviteMutation,
		CalendarLinks_SendCalendarInviteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CalendarLinks_SendCalendarInviteMutation,
		CalendarLinks_SendCalendarInviteMutationVariables
	>(CalendarLinks_SendCalendarInviteDocument, options);
}
export type CalendarLinks_SendCalendarInviteMutationHookResult = ReturnType<
	typeof useCalendarLinks_SendCalendarInviteMutation
>;
export type CalendarLinks_SendCalendarInviteMutationResult =
	Apollo.MutationResult<CalendarLinks_SendCalendarInviteMutation>;
export type CalendarLinks_SendCalendarInviteMutationOptions =
	Apollo.BaseMutationOptions<
		CalendarLinks_SendCalendarInviteMutation,
		CalendarLinks_SendCalendarInviteMutationVariables
	>;
export const ConnectToCanva_SaveCanvaAuthorizationTokensDocument = gql`
	mutation ConnectToCanva_SaveCanvaAuthorizationTokens(
		$data: CanvaTokenResponseInput!
	) {
		saveCanvaAuthorizationTokens(data: $data) {
			id
			accessToken
			expires
		}
	}
`;
export type ConnectToCanva_SaveCanvaAuthorizationTokensMutationFn =
	Apollo.MutationFunction<
		ConnectToCanva_SaveCanvaAuthorizationTokensMutation,
		ConnectToCanva_SaveCanvaAuthorizationTokensMutationVariables
	>;

/**
 * __useConnectToCanva_SaveCanvaAuthorizationTokensMutation__
 *
 * To run a mutation, you first call `useConnectToCanva_SaveCanvaAuthorizationTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectToCanva_SaveCanvaAuthorizationTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectToCanvaSaveCanvaAuthorizationTokensMutation, { data, loading, error }] = useConnectToCanva_SaveCanvaAuthorizationTokensMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConnectToCanva_SaveCanvaAuthorizationTokensMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConnectToCanva_SaveCanvaAuthorizationTokensMutation,
		ConnectToCanva_SaveCanvaAuthorizationTokensMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConnectToCanva_SaveCanvaAuthorizationTokensMutation,
		ConnectToCanva_SaveCanvaAuthorizationTokensMutationVariables
	>(ConnectToCanva_SaveCanvaAuthorizationTokensDocument, options);
}
export type ConnectToCanva_SaveCanvaAuthorizationTokensMutationHookResult =
	ReturnType<typeof useConnectToCanva_SaveCanvaAuthorizationTokensMutation>;
export type ConnectToCanva_SaveCanvaAuthorizationTokensMutationResult =
	Apollo.MutationResult<ConnectToCanva_SaveCanvaAuthorizationTokensMutation>;
export type ConnectToCanva_SaveCanvaAuthorizationTokensMutationOptions =
	Apollo.BaseMutationOptions<
		ConnectToCanva_SaveCanvaAuthorizationTokensMutation,
		ConnectToCanva_SaveCanvaAuthorizationTokensMutationVariables
	>;
export const CanvaEdit_RefreshCanvaExportDocument = gql`
	mutation CanvaEdit_RefreshCanvaExport($where: CanvaDesignWhereUniqueInput!) {
		refreshCanvaExportForProposal(where: $where) {
			id
			canvaDesign {
				id
				designId
				viewUrl
				exportedImageUrl
			}
		}
	}
`;
export type CanvaEdit_RefreshCanvaExportMutationFn = Apollo.MutationFunction<
	CanvaEdit_RefreshCanvaExportMutation,
	CanvaEdit_RefreshCanvaExportMutationVariables
>;

/**
 * __useCanvaEdit_RefreshCanvaExportMutation__
 *
 * To run a mutation, you first call `useCanvaEdit_RefreshCanvaExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCanvaEdit_RefreshCanvaExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [canvaEditRefreshCanvaExportMutation, { data, loading, error }] = useCanvaEdit_RefreshCanvaExportMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCanvaEdit_RefreshCanvaExportMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CanvaEdit_RefreshCanvaExportMutation,
		CanvaEdit_RefreshCanvaExportMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CanvaEdit_RefreshCanvaExportMutation,
		CanvaEdit_RefreshCanvaExportMutationVariables
	>(CanvaEdit_RefreshCanvaExportDocument, options);
}
export type CanvaEdit_RefreshCanvaExportMutationHookResult = ReturnType<
	typeof useCanvaEdit_RefreshCanvaExportMutation
>;
export type CanvaEdit_RefreshCanvaExportMutationResult =
	Apollo.MutationResult<CanvaEdit_RefreshCanvaExportMutation>;
export type CanvaEdit_RefreshCanvaExportMutationOptions =
	Apollo.BaseMutationOptions<
		CanvaEdit_RefreshCanvaExportMutation,
		CanvaEdit_RefreshCanvaExportMutationVariables
	>;
export const CanvaEdit_RefreshCanvaExportForProposalTemplateDocument = gql`
	mutation CanvaEdit_RefreshCanvaExportForProposalTemplate(
		$where: CanvaDesignWhereUniqueInput!
	) {
		refreshCanvaExportForProposalTemplate(where: $where) {
			id
			canvaDesign {
				id
				designId
				viewUrl
				exportedImageUrl
			}
		}
	}
`;
export type CanvaEdit_RefreshCanvaExportForProposalTemplateMutationFn =
	Apollo.MutationFunction<
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutation,
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutationVariables
	>;

/**
 * __useCanvaEdit_RefreshCanvaExportForProposalTemplateMutation__
 *
 * To run a mutation, you first call `useCanvaEdit_RefreshCanvaExportForProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCanvaEdit_RefreshCanvaExportForProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [canvaEditRefreshCanvaExportForProposalTemplateMutation, { data, loading, error }] = useCanvaEdit_RefreshCanvaExportForProposalTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCanvaEdit_RefreshCanvaExportForProposalTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutation,
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutation,
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutationVariables
	>(CanvaEdit_RefreshCanvaExportForProposalTemplateDocument, options);
}
export type CanvaEdit_RefreshCanvaExportForProposalTemplateMutationHookResult =
	ReturnType<typeof useCanvaEdit_RefreshCanvaExportForProposalTemplateMutation>;
export type CanvaEdit_RefreshCanvaExportForProposalTemplateMutationResult =
	Apollo.MutationResult<CanvaEdit_RefreshCanvaExportForProposalTemplateMutation>;
export type CanvaEdit_RefreshCanvaExportForProposalTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutation,
		CanvaEdit_RefreshCanvaExportForProposalTemplateMutationVariables
	>;
export const ClientDashboard_GetDashboardStatsForClientDocument = gql`
	query ClientDashboard_GetDashboardStatsForClient(
		$where: ClientUserWhereUniqueInput!
	) {
		getDashboardStatsForClient(where: $where) {
			daysToEvent
			totalPaid
			totalBilled
			totalOutstanding
			nextDueInstallment {
				id
				amountDue
				dueDate
			}
			documentsNeedingAttention {
				total
				contracts
				proposals
				invoices
			}
		}
	}
`;

/**
 * __useClientDashboard_GetDashboardStatsForClientQuery__
 *
 * To run a query within a React component, call `useClientDashboard_GetDashboardStatsForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDashboard_GetDashboardStatsForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDashboard_GetDashboardStatsForClientQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientDashboard_GetDashboardStatsForClientQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientDashboard_GetDashboardStatsForClientQuery,
		ClientDashboard_GetDashboardStatsForClientQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientDashboard_GetDashboardStatsForClientQuery,
		ClientDashboard_GetDashboardStatsForClientQueryVariables
	>(ClientDashboard_GetDashboardStatsForClientDocument, options);
}
export function useClientDashboard_GetDashboardStatsForClientLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientDashboard_GetDashboardStatsForClientQuery,
		ClientDashboard_GetDashboardStatsForClientQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientDashboard_GetDashboardStatsForClientQuery,
		ClientDashboard_GetDashboardStatsForClientQueryVariables
	>(ClientDashboard_GetDashboardStatsForClientDocument, options);
}
export type ClientDashboard_GetDashboardStatsForClientQueryHookResult =
	ReturnType<typeof useClientDashboard_GetDashboardStatsForClientQuery>;
export type ClientDashboard_GetDashboardStatsForClientLazyQueryHookResult =
	ReturnType<typeof useClientDashboard_GetDashboardStatsForClientLazyQuery>;
export type ClientDashboard_GetDashboardStatsForClientQueryResult =
	Apollo.QueryResult<
		ClientDashboard_GetDashboardStatsForClientQuery,
		ClientDashboard_GetDashboardStatsForClientQueryVariables
	>;
export const ClientDashboard_GetActionableItemsForClientDocument = gql`
	query ClientDashboard_GetActionableItemsForClient {
		getActionableItemsForClient {
			itemId
			itemType
			itemDescription
			dueDate
			amountDue
			vendor {
				id
				name
			}
		}
	}
`;

/**
 * __useClientDashboard_GetActionableItemsForClientQuery__
 *
 * To run a query within a React component, call `useClientDashboard_GetActionableItemsForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDashboard_GetActionableItemsForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDashboard_GetActionableItemsForClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientDashboard_GetActionableItemsForClientQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ClientDashboard_GetActionableItemsForClientQuery,
		ClientDashboard_GetActionableItemsForClientQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientDashboard_GetActionableItemsForClientQuery,
		ClientDashboard_GetActionableItemsForClientQueryVariables
	>(ClientDashboard_GetActionableItemsForClientDocument, options);
}
export function useClientDashboard_GetActionableItemsForClientLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientDashboard_GetActionableItemsForClientQuery,
		ClientDashboard_GetActionableItemsForClientQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientDashboard_GetActionableItemsForClientQuery,
		ClientDashboard_GetActionableItemsForClientQueryVariables
	>(ClientDashboard_GetActionableItemsForClientDocument, options);
}
export type ClientDashboard_GetActionableItemsForClientQueryHookResult =
	ReturnType<typeof useClientDashboard_GetActionableItemsForClientQuery>;
export type ClientDashboard_GetActionableItemsForClientLazyQueryHookResult =
	ReturnType<typeof useClientDashboard_GetActionableItemsForClientLazyQuery>;
export type ClientDashboard_GetActionableItemsForClientQueryResult =
	Apollo.QueryResult<
		ClientDashboard_GetActionableItemsForClientQuery,
		ClientDashboard_GetActionableItemsForClientQueryVariables
	>;
export const ClientDashboard_UpdateClientUserDocument = gql`
	mutation ClientDashboard_UpdateClientUser(
		$where: ClientUserWhereUniqueInput!
		$data: ClientUserUpdateCustomInput!
	) {
		updateClientUser(where: $where, data: $data) {
			id
			weddingDate
		}
	}
`;
export type ClientDashboard_UpdateClientUserMutationFn =
	Apollo.MutationFunction<
		ClientDashboard_UpdateClientUserMutation,
		ClientDashboard_UpdateClientUserMutationVariables
	>;

/**
 * __useClientDashboard_UpdateClientUserMutation__
 *
 * To run a mutation, you first call `useClientDashboard_UpdateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientDashboard_UpdateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientDashboardUpdateClientUserMutation, { data, loading, error }] = useClientDashboard_UpdateClientUserMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClientDashboard_UpdateClientUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientDashboard_UpdateClientUserMutation,
		ClientDashboard_UpdateClientUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientDashboard_UpdateClientUserMutation,
		ClientDashboard_UpdateClientUserMutationVariables
	>(ClientDashboard_UpdateClientUserDocument, options);
}
export type ClientDashboard_UpdateClientUserMutationHookResult = ReturnType<
	typeof useClientDashboard_UpdateClientUserMutation
>;
export type ClientDashboard_UpdateClientUserMutationResult =
	Apollo.MutationResult<ClientDashboard_UpdateClientUserMutation>;
export type ClientDashboard_UpdateClientUserMutationOptions =
	Apollo.BaseMutationOptions<
		ClientDashboard_UpdateClientUserMutation,
		ClientDashboard_UpdateClientUserMutationVariables
	>;
export const ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsDocument = gql`
	mutation clientDetailActionMenuRequestPermissionsModal_requestPlannerPermissions(
		$where: ContactWhereUniqueInput!
	) {
		requestPlannerPermissions(where: $where)
	}
`;
export type ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationFn =
	Apollo.MutationFunction<
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation,
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationVariables
	>;

/**
 * __useClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation__
 *
 * To run a mutation, you first call `useClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientDetailActionMenuRequestPermissionsModalRequestPlannerPermissionsMutation, { data, loading, error }] = useClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation,
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation,
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationVariables
	>(
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsDocument,
		options
	);
}
export type ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationHookResult =
	ReturnType<
		typeof useClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation
	>;
export type ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationResult =
	Apollo.MutationResult<ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation>;
export type ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationOptions =
	Apollo.BaseMutationOptions<
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutation,
		ClientDetailActionMenuRequestPermissionsModal_RequestPlannerPermissionsMutationVariables
	>;
export const ClientActionMenu_RequestClientEventDateChangeDocument = gql`
	mutation clientActionMenu_requestClientEventDateChange(
		$where: ClientUserWhereUniqueInput!
	) {
		requestClientEventDateChange(where: $where)
	}
`;
export type ClientActionMenu_RequestClientEventDateChangeMutationFn =
	Apollo.MutationFunction<
		ClientActionMenu_RequestClientEventDateChangeMutation,
		ClientActionMenu_RequestClientEventDateChangeMutationVariables
	>;

/**
 * __useClientActionMenu_RequestClientEventDateChangeMutation__
 *
 * To run a mutation, you first call `useClientActionMenu_RequestClientEventDateChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientActionMenu_RequestClientEventDateChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientActionMenuRequestClientEventDateChangeMutation, { data, loading, error }] = useClientActionMenu_RequestClientEventDateChangeMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientActionMenu_RequestClientEventDateChangeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientActionMenu_RequestClientEventDateChangeMutation,
		ClientActionMenu_RequestClientEventDateChangeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientActionMenu_RequestClientEventDateChangeMutation,
		ClientActionMenu_RequestClientEventDateChangeMutationVariables
	>(ClientActionMenu_RequestClientEventDateChangeDocument, options);
}
export type ClientActionMenu_RequestClientEventDateChangeMutationHookResult =
	ReturnType<typeof useClientActionMenu_RequestClientEventDateChangeMutation>;
export type ClientActionMenu_RequestClientEventDateChangeMutationResult =
	Apollo.MutationResult<ClientActionMenu_RequestClientEventDateChangeMutation>;
export type ClientActionMenu_RequestClientEventDateChangeMutationOptions =
	Apollo.BaseMutationOptions<
		ClientActionMenu_RequestClientEventDateChangeMutation,
		ClientActionMenu_RequestClientEventDateChangeMutationVariables
	>;
export const ClientActionButton_GetStripeConnectAccountDocument = gql`
	query clientActionButton_getStripeConnectAccount(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripeConnectAccount(where: $where) {
			external_accounts {
				data {
					id
				}
			}
		}
	}
`;

/**
 * __useClientActionButton_GetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `useClientActionButton_GetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientActionButton_GetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientActionButton_GetStripeConnectAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientActionButton_GetStripeConnectAccountQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientActionButton_GetStripeConnectAccountQuery,
		ClientActionButton_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientActionButton_GetStripeConnectAccountQuery,
		ClientActionButton_GetStripeConnectAccountQueryVariables
	>(ClientActionButton_GetStripeConnectAccountDocument, options);
}
export function useClientActionButton_GetStripeConnectAccountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientActionButton_GetStripeConnectAccountQuery,
		ClientActionButton_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientActionButton_GetStripeConnectAccountQuery,
		ClientActionButton_GetStripeConnectAccountQueryVariables
	>(ClientActionButton_GetStripeConnectAccountDocument, options);
}
export type ClientActionButton_GetStripeConnectAccountQueryHookResult =
	ReturnType<typeof useClientActionButton_GetStripeConnectAccountQuery>;
export type ClientActionButton_GetStripeConnectAccountLazyQueryHookResult =
	ReturnType<typeof useClientActionButton_GetStripeConnectAccountLazyQuery>;
export type ClientActionButton_GetStripeConnectAccountQueryResult =
	Apollo.QueryResult<
		ClientActionButton_GetStripeConnectAccountQuery,
		ClientActionButton_GetStripeConnectAccountQueryVariables
	>;
export const ClientActionButton_GetAuthedUserDocument = gql`
	query clientActionButton_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			userType
			orgUser {
				id
				isAdmin
				isOwner
				organization {
					id
					hasStripeVerificationNeeds
				}
			}
		}
	}
`;

/**
 * __useClientActionButton_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useClientActionButton_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientActionButton_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientActionButton_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientActionButton_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientActionButton_GetAuthedUserQuery,
		ClientActionButton_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientActionButton_GetAuthedUserQuery,
		ClientActionButton_GetAuthedUserQueryVariables
	>(ClientActionButton_GetAuthedUserDocument, options);
}
export function useClientActionButton_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientActionButton_GetAuthedUserQuery,
		ClientActionButton_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientActionButton_GetAuthedUserQuery,
		ClientActionButton_GetAuthedUserQueryVariables
	>(ClientActionButton_GetAuthedUserDocument, options);
}
export type ClientActionButton_GetAuthedUserQueryHookResult = ReturnType<
	typeof useClientActionButton_GetAuthedUserQuery
>;
export type ClientActionButton_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useClientActionButton_GetAuthedUserLazyQuery
>;
export type ClientActionButton_GetAuthedUserQueryResult = Apollo.QueryResult<
	ClientActionButton_GetAuthedUserQuery,
	ClientActionButton_GetAuthedUserQueryVariables
>;
export const UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsDocument = gql`
	query useGetContactMenuItemsViewingCustomerAsOrgUser_getFeatureFlags {
		getFeatureFlags {
			category
			active
		}
	}
`;

/**
 * __useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery,
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery,
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryVariables
	>(
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsDocument,
		options
	);
}
export function useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery,
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery,
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryVariables
	>(
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsDocument,
		options
	);
}
export type UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryHookResult =
	ReturnType<
		typeof useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery
	>;
export type UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsLazyQueryHookResult =
	ReturnType<
		typeof useUseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsLazyQuery
	>;
export type UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryResult =
	Apollo.QueryResult<
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQuery,
		UseGetContactMenuItemsViewingCustomerAsOrgUser_GetFeatureFlagsQueryVariables
	>;
export const ClientDetailActionMenu_RequestContactActivationDocument = gql`
	mutation clientDetailActionMenu_requestContactActivation(
		$where: ContactWhereUniqueInput!
	) {
		requestContactActivation(where: $where) {
			...clientDetailActionMenuContact
		}
	}
	${ClientDetailActionMenuContactFragmentDoc}
`;
export type ClientDetailActionMenu_RequestContactActivationMutationFn =
	Apollo.MutationFunction<
		ClientDetailActionMenu_RequestContactActivationMutation,
		ClientDetailActionMenu_RequestContactActivationMutationVariables
	>;

/**
 * __useClientDetailActionMenu_RequestContactActivationMutation__
 *
 * To run a mutation, you first call `useClientDetailActionMenu_RequestContactActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientDetailActionMenu_RequestContactActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientDetailActionMenuRequestContactActivationMutation, { data, loading, error }] = useClientDetailActionMenu_RequestContactActivationMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientDetailActionMenu_RequestContactActivationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientDetailActionMenu_RequestContactActivationMutation,
		ClientDetailActionMenu_RequestContactActivationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientDetailActionMenu_RequestContactActivationMutation,
		ClientDetailActionMenu_RequestContactActivationMutationVariables
	>(ClientDetailActionMenu_RequestContactActivationDocument, options);
}
export type ClientDetailActionMenu_RequestContactActivationMutationHookResult =
	ReturnType<typeof useClientDetailActionMenu_RequestContactActivationMutation>;
export type ClientDetailActionMenu_RequestContactActivationMutationResult =
	Apollo.MutationResult<ClientDetailActionMenu_RequestContactActivationMutation>;
export type ClientDetailActionMenu_RequestContactActivationMutationOptions =
	Apollo.BaseMutationOptions<
		ClientDetailActionMenu_RequestContactActivationMutation,
		ClientDetailActionMenu_RequestContactActivationMutationVariables
	>;
export const AssignedWidget_AssignMemberToContactDocument = gql`
	mutation AssignedWidget_AssignMemberToContact(
		$where: ContactWhereUniqueInput!
		$data: OrgUserWhereUniqueInput!
	) {
		assignMemberToContact(where: $where, data: $data) {
			id
			assignedMember {
				id
			}
		}
	}
`;
export type AssignedWidget_AssignMemberToContactMutationFn =
	Apollo.MutationFunction<
		AssignedWidget_AssignMemberToContactMutation,
		AssignedWidget_AssignMemberToContactMutationVariables
	>;

/**
 * __useAssignedWidget_AssignMemberToContactMutation__
 *
 * To run a mutation, you first call `useAssignedWidget_AssignMemberToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignedWidget_AssignMemberToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignedWidgetAssignMemberToContactMutation, { data, loading, error }] = useAssignedWidget_AssignMemberToContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignedWidget_AssignMemberToContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AssignedWidget_AssignMemberToContactMutation,
		AssignedWidget_AssignMemberToContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AssignedWidget_AssignMemberToContactMutation,
		AssignedWidget_AssignMemberToContactMutationVariables
	>(AssignedWidget_AssignMemberToContactDocument, options);
}
export type AssignedWidget_AssignMemberToContactMutationHookResult = ReturnType<
	typeof useAssignedWidget_AssignMemberToContactMutation
>;
export type AssignedWidget_AssignMemberToContactMutationResult =
	Apollo.MutationResult<AssignedWidget_AssignMemberToContactMutation>;
export type AssignedWidget_AssignMemberToContactMutationOptions =
	Apollo.BaseMutationOptions<
		AssignedWidget_AssignMemberToContactMutation,
		AssignedWidget_AssignMemberToContactMutationVariables
	>;
export const UseClientDetailOverview_UpdateContactStatusDocument = gql`
	mutation useClientDetailOverview_updateContactStatus(
		$data: UpdateContactStatusDataInput!
		$where: ContactWhereUniqueInput!
	) {
		updateContactStatus(data: $data, where: $where) {
			id
			status
		}
	}
`;
export type UseClientDetailOverview_UpdateContactStatusMutationFn =
	Apollo.MutationFunction<
		UseClientDetailOverview_UpdateContactStatusMutation,
		UseClientDetailOverview_UpdateContactStatusMutationVariables
	>;

/**
 * __useUseClientDetailOverview_UpdateContactStatusMutation__
 *
 * To run a mutation, you first call `useUseClientDetailOverview_UpdateContactStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseClientDetailOverview_UpdateContactStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useClientDetailOverviewUpdateContactStatusMutation, { data, loading, error }] = useUseClientDetailOverview_UpdateContactStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseClientDetailOverview_UpdateContactStatusMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseClientDetailOverview_UpdateContactStatusMutation,
		UseClientDetailOverview_UpdateContactStatusMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseClientDetailOverview_UpdateContactStatusMutation,
		UseClientDetailOverview_UpdateContactStatusMutationVariables
	>(UseClientDetailOverview_UpdateContactStatusDocument, options);
}
export type UseClientDetailOverview_UpdateContactStatusMutationHookResult =
	ReturnType<typeof useUseClientDetailOverview_UpdateContactStatusMutation>;
export type UseClientDetailOverview_UpdateContactStatusMutationResult =
	Apollo.MutationResult<UseClientDetailOverview_UpdateContactStatusMutation>;
export type UseClientDetailOverview_UpdateContactStatusMutationOptions =
	Apollo.BaseMutationOptions<
		UseClientDetailOverview_UpdateContactStatusMutation,
		UseClientDetailOverview_UpdateContactStatusMutationVariables
	>;
export const NotesTab_UpdateNoteOnContactDocument = gql`
	mutation NotesTab_UpdateNoteOnContact(
		$where: ContactWhereUniqueInput!
		$data: NoteInput!
	) {
		updateNoteOnContact(where: $where, data: $data) {
			id
			note
		}
	}
`;
export type NotesTab_UpdateNoteOnContactMutationFn = Apollo.MutationFunction<
	NotesTab_UpdateNoteOnContactMutation,
	NotesTab_UpdateNoteOnContactMutationVariables
>;

/**
 * __useNotesTab_UpdateNoteOnContactMutation__
 *
 * To run a mutation, you first call `useNotesTab_UpdateNoteOnContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesTab_UpdateNoteOnContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesTabUpdateNoteOnContactMutation, { data, loading, error }] = useNotesTab_UpdateNoteOnContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNotesTab_UpdateNoteOnContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		NotesTab_UpdateNoteOnContactMutation,
		NotesTab_UpdateNoteOnContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		NotesTab_UpdateNoteOnContactMutation,
		NotesTab_UpdateNoteOnContactMutationVariables
	>(NotesTab_UpdateNoteOnContactDocument, options);
}
export type NotesTab_UpdateNoteOnContactMutationHookResult = ReturnType<
	typeof useNotesTab_UpdateNoteOnContactMutation
>;
export type NotesTab_UpdateNoteOnContactMutationResult =
	Apollo.MutationResult<NotesTab_UpdateNoteOnContactMutation>;
export type NotesTab_UpdateNoteOnContactMutationOptions =
	Apollo.BaseMutationOptions<
		NotesTab_UpdateNoteOnContactMutation,
		NotesTab_UpdateNoteOnContactMutationVariables
	>;
export const UpdateContactModal_GetOrganizationWhereDocument = gql`
	query updateContactModal_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			...updateContactModal_Organization
		}
	}
	${UpdateContactModal_OrganizationFragmentDoc}
`;

/**
 * __useUpdateContactModal_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useUpdateContactModal_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactModal_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateContactModal_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateContactModal_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UpdateContactModal_GetOrganizationWhereQuery,
		UpdateContactModal_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UpdateContactModal_GetOrganizationWhereQuery,
		UpdateContactModal_GetOrganizationWhereQueryVariables
	>(UpdateContactModal_GetOrganizationWhereDocument, options);
}
export function useUpdateContactModal_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UpdateContactModal_GetOrganizationWhereQuery,
		UpdateContactModal_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UpdateContactModal_GetOrganizationWhereQuery,
		UpdateContactModal_GetOrganizationWhereQueryVariables
	>(UpdateContactModal_GetOrganizationWhereDocument, options);
}
export type UpdateContactModal_GetOrganizationWhereQueryHookResult = ReturnType<
	typeof useUpdateContactModal_GetOrganizationWhereQuery
>;
export type UpdateContactModal_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<typeof useUpdateContactModal_GetOrganizationWhereLazyQuery>;
export type UpdateContactModal_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		UpdateContactModal_GetOrganizationWhereQuery,
		UpdateContactModal_GetOrganizationWhereQueryVariables
	>;
export const UpdateContactModal_UpdateContactDocument = gql`
	mutation updateContactModal_updateContact(
		$where: ContactWhereUniqueInput!
		$data: CustomContactUpdateInput!
	) {
		updateContact(where: $where, data: $data) {
			...updateContactModalContact
		}
	}
	${UpdateContactModalContactFragmentDoc}
`;
export type UpdateContactModal_UpdateContactMutationFn =
	Apollo.MutationFunction<
		UpdateContactModal_UpdateContactMutation,
		UpdateContactModal_UpdateContactMutationVariables
	>;

/**
 * __useUpdateContactModal_UpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactModal_UpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactModal_UpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactModalUpdateContactMutation, { data, loading, error }] = useUpdateContactModal_UpdateContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactModal_UpdateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateContactModal_UpdateContactMutation,
		UpdateContactModal_UpdateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateContactModal_UpdateContactMutation,
		UpdateContactModal_UpdateContactMutationVariables
	>(UpdateContactModal_UpdateContactDocument, options);
}
export type UpdateContactModal_UpdateContactMutationHookResult = ReturnType<
	typeof useUpdateContactModal_UpdateContactMutation
>;
export type UpdateContactModal_UpdateContactMutationResult =
	Apollo.MutationResult<UpdateContactModal_UpdateContactMutation>;
export type UpdateContactModal_UpdateContactMutationOptions =
	Apollo.BaseMutationOptions<
		UpdateContactModal_UpdateContactMutation,
		UpdateContactModal_UpdateContactMutationVariables
	>;
export const ClientDetail_GetContactWhereDocument = gql`
	query clientDetail_getContactWhere($where: ContactWhereInput!) {
		getContactWhere(where: $where) {
			...useClientDetailContact
		}
	}
	${UseClientDetailContactFragmentDoc}
`;

/**
 * __useClientDetail_GetContactWhereQuery__
 *
 * To run a query within a React component, call `useClientDetail_GetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDetail_GetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDetail_GetContactWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientDetail_GetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientDetail_GetContactWhereQuery,
		ClientDetail_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientDetail_GetContactWhereQuery,
		ClientDetail_GetContactWhereQueryVariables
	>(ClientDetail_GetContactWhereDocument, options);
}
export function useClientDetail_GetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientDetail_GetContactWhereQuery,
		ClientDetail_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientDetail_GetContactWhereQuery,
		ClientDetail_GetContactWhereQueryVariables
	>(ClientDetail_GetContactWhereDocument, options);
}
export type ClientDetail_GetContactWhereQueryHookResult = ReturnType<
	typeof useClientDetail_GetContactWhereQuery
>;
export type ClientDetail_GetContactWhereLazyQueryHookResult = ReturnType<
	typeof useClientDetail_GetContactWhereLazyQuery
>;
export type ClientDetail_GetContactWhereQueryResult = Apollo.QueryResult<
	ClientDetail_GetContactWhereQuery,
	ClientDetail_GetContactWhereQueryVariables
>;
export const ClientOnboardingUseFinishUp_GetClientUserWhereDocument = gql`
	query ClientOnboardingUseFinishUp_getClientUserWhere(
		$where: ClientUserWhereUniqueInput!
	) {
		getClientUserWhere(where: $where) {
			...clientOnboardingFinishUpClientUser
		}
	}
	${ClientOnboardingFinishUpClientUserFragmentDoc}
`;

/**
 * __useClientOnboardingUseFinishUp_GetClientUserWhereQuery__
 *
 * To run a query within a React component, call `useClientOnboardingUseFinishUp_GetClientUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingUseFinishUp_GetClientUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOnboardingUseFinishUp_GetClientUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientOnboardingUseFinishUp_GetClientUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientOnboardingUseFinishUp_GetClientUserWhereQuery,
		ClientOnboardingUseFinishUp_GetClientUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientOnboardingUseFinishUp_GetClientUserWhereQuery,
		ClientOnboardingUseFinishUp_GetClientUserWhereQueryVariables
	>(ClientOnboardingUseFinishUp_GetClientUserWhereDocument, options);
}
export function useClientOnboardingUseFinishUp_GetClientUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientOnboardingUseFinishUp_GetClientUserWhereQuery,
		ClientOnboardingUseFinishUp_GetClientUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientOnboardingUseFinishUp_GetClientUserWhereQuery,
		ClientOnboardingUseFinishUp_GetClientUserWhereQueryVariables
	>(ClientOnboardingUseFinishUp_GetClientUserWhereDocument, options);
}
export type ClientOnboardingUseFinishUp_GetClientUserWhereQueryHookResult =
	ReturnType<typeof useClientOnboardingUseFinishUp_GetClientUserWhereQuery>;
export type ClientOnboardingUseFinishUp_GetClientUserWhereLazyQueryHookResult =
	ReturnType<typeof useClientOnboardingUseFinishUp_GetClientUserWhereLazyQuery>;
export type ClientOnboardingUseFinishUp_GetClientUserWhereQueryResult =
	Apollo.QueryResult<
		ClientOnboardingUseFinishUp_GetClientUserWhereQuery,
		ClientOnboardingUseFinishUp_GetClientUserWhereQueryVariables
	>;
export const ClientOnboardingFinishUp_UpdateClientUserDocument = gql`
	mutation clientOnboardingFinishUp_updateClientUser(
		$data: ClientUserUpdateCustomInput!
		$where: ClientUserWhereUniqueInput!
	) {
		updateClientUser(data: $data, where: $where) {
			...clientOnboardingFinishUpClientUser
		}
	}
	${ClientOnboardingFinishUpClientUserFragmentDoc}
`;
export type ClientOnboardingFinishUp_UpdateClientUserMutationFn =
	Apollo.MutationFunction<
		ClientOnboardingFinishUp_UpdateClientUserMutation,
		ClientOnboardingFinishUp_UpdateClientUserMutationVariables
	>;

/**
 * __useClientOnboardingFinishUp_UpdateClientUserMutation__
 *
 * To run a mutation, you first call `useClientOnboardingFinishUp_UpdateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingFinishUp_UpdateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientOnboardingFinishUpUpdateClientUserMutation, { data, loading, error }] = useClientOnboardingFinishUp_UpdateClientUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientOnboardingFinishUp_UpdateClientUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientOnboardingFinishUp_UpdateClientUserMutation,
		ClientOnboardingFinishUp_UpdateClientUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientOnboardingFinishUp_UpdateClientUserMutation,
		ClientOnboardingFinishUp_UpdateClientUserMutationVariables
	>(ClientOnboardingFinishUp_UpdateClientUserDocument, options);
}
export type ClientOnboardingFinishUp_UpdateClientUserMutationHookResult =
	ReturnType<typeof useClientOnboardingFinishUp_UpdateClientUserMutation>;
export type ClientOnboardingFinishUp_UpdateClientUserMutationResult =
	Apollo.MutationResult<ClientOnboardingFinishUp_UpdateClientUserMutation>;
export type ClientOnboardingFinishUp_UpdateClientUserMutationOptions =
	Apollo.BaseMutationOptions<
		ClientOnboardingFinishUp_UpdateClientUserMutation,
		ClientOnboardingFinishUp_UpdateClientUserMutationVariables
	>;
export const ClientOnboardingFinishUp_MarkUserOnboardingCompleteDocument = gql`
	mutation clientOnboardingFinishUp_markUserOnboardingComplete {
		markUserOnboardingComplete
	}
`;
export type ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationFn =
	Apollo.MutationFunction<
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation,
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationVariables
	>;

/**
 * __useClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation__
 *
 * To run a mutation, you first call `useClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientOnboardingFinishUpMarkUserOnboardingCompleteMutation, { data, loading, error }] = useClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation,
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation,
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationVariables
	>(ClientOnboardingFinishUp_MarkUserOnboardingCompleteDocument, options);
}
export type ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationHookResult =
	ReturnType<
		typeof useClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation
	>;
export type ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationResult =
	Apollo.MutationResult<ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation>;
export type ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationOptions =
	Apollo.BaseMutationOptions<
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutation,
		ClientOnboardingFinishUp_MarkUserOnboardingCompleteMutationVariables
	>;
export const ClientOnboardingYourInfo_GetClientUserDocument = gql`
	query clientOnboardingYourInfo_getClientUser(
		$where: ClientUserWhereUniqueInput!
	) {
		getClientUserWhere(where: $where) {
			...clientOnboardingYourInfoClientUser
		}
	}
	${ClientOnboardingYourInfoClientUserFragmentDoc}
`;

/**
 * __useClientOnboardingYourInfo_GetClientUserQuery__
 *
 * To run a query within a React component, call `useClientOnboardingYourInfo_GetClientUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingYourInfo_GetClientUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOnboardingYourInfo_GetClientUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientOnboardingYourInfo_GetClientUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientOnboardingYourInfo_GetClientUserQuery,
		ClientOnboardingYourInfo_GetClientUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientOnboardingYourInfo_GetClientUserQuery,
		ClientOnboardingYourInfo_GetClientUserQueryVariables
	>(ClientOnboardingYourInfo_GetClientUserDocument, options);
}
export function useClientOnboardingYourInfo_GetClientUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientOnboardingYourInfo_GetClientUserQuery,
		ClientOnboardingYourInfo_GetClientUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientOnboardingYourInfo_GetClientUserQuery,
		ClientOnboardingYourInfo_GetClientUserQueryVariables
	>(ClientOnboardingYourInfo_GetClientUserDocument, options);
}
export type ClientOnboardingYourInfo_GetClientUserQueryHookResult = ReturnType<
	typeof useClientOnboardingYourInfo_GetClientUserQuery
>;
export type ClientOnboardingYourInfo_GetClientUserLazyQueryHookResult =
	ReturnType<typeof useClientOnboardingYourInfo_GetClientUserLazyQuery>;
export type ClientOnboardingYourInfo_GetClientUserQueryResult =
	Apollo.QueryResult<
		ClientOnboardingYourInfo_GetClientUserQuery,
		ClientOnboardingYourInfo_GetClientUserQueryVariables
	>;
export const ClientOnboardingYourInfo_CreateClientUserDocument = gql`
	mutation clientOnboardingYourInfo_createClientUser(
		$data: ClientUserCreateInput!
	) {
		createClientUser(data: $data) {
			...clientOnboardingYourInfoClientUser
		}
	}
	${ClientOnboardingYourInfoClientUserFragmentDoc}
`;
export type ClientOnboardingYourInfo_CreateClientUserMutationFn =
	Apollo.MutationFunction<
		ClientOnboardingYourInfo_CreateClientUserMutation,
		ClientOnboardingYourInfo_CreateClientUserMutationVariables
	>;

/**
 * __useClientOnboardingYourInfo_CreateClientUserMutation__
 *
 * To run a mutation, you first call `useClientOnboardingYourInfo_CreateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingYourInfo_CreateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientOnboardingYourInfoCreateClientUserMutation, { data, loading, error }] = useClientOnboardingYourInfo_CreateClientUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClientOnboardingYourInfo_CreateClientUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientOnboardingYourInfo_CreateClientUserMutation,
		ClientOnboardingYourInfo_CreateClientUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientOnboardingYourInfo_CreateClientUserMutation,
		ClientOnboardingYourInfo_CreateClientUserMutationVariables
	>(ClientOnboardingYourInfo_CreateClientUserDocument, options);
}
export type ClientOnboardingYourInfo_CreateClientUserMutationHookResult =
	ReturnType<typeof useClientOnboardingYourInfo_CreateClientUserMutation>;
export type ClientOnboardingYourInfo_CreateClientUserMutationResult =
	Apollo.MutationResult<ClientOnboardingYourInfo_CreateClientUserMutation>;
export type ClientOnboardingYourInfo_CreateClientUserMutationOptions =
	Apollo.BaseMutationOptions<
		ClientOnboardingYourInfo_CreateClientUserMutation,
		ClientOnboardingYourInfo_CreateClientUserMutationVariables
	>;
export const ClientOnboardingYourInfo_UpdateClientUserDocument = gql`
	mutation clientOnboardingYourInfo_updateClientUser(
		$data: ClientUserUpdateCustomInput!
		$where: ClientUserWhereUniqueInput!
	) {
		updateClientUser(data: $data, where: $where) {
			...clientOnboardingYourInfoClientUser
		}
	}
	${ClientOnboardingYourInfoClientUserFragmentDoc}
`;
export type ClientOnboardingYourInfo_UpdateClientUserMutationFn =
	Apollo.MutationFunction<
		ClientOnboardingYourInfo_UpdateClientUserMutation,
		ClientOnboardingYourInfo_UpdateClientUserMutationVariables
	>;

/**
 * __useClientOnboardingYourInfo_UpdateClientUserMutation__
 *
 * To run a mutation, you first call `useClientOnboardingYourInfo_UpdateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingYourInfo_UpdateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientOnboardingYourInfoUpdateClientUserMutation, { data, loading, error }] = useClientOnboardingYourInfo_UpdateClientUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientOnboardingYourInfo_UpdateClientUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientOnboardingYourInfo_UpdateClientUserMutation,
		ClientOnboardingYourInfo_UpdateClientUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientOnboardingYourInfo_UpdateClientUserMutation,
		ClientOnboardingYourInfo_UpdateClientUserMutationVariables
	>(ClientOnboardingYourInfo_UpdateClientUserDocument, options);
}
export type ClientOnboardingYourInfo_UpdateClientUserMutationHookResult =
	ReturnType<typeof useClientOnboardingYourInfo_UpdateClientUserMutation>;
export type ClientOnboardingYourInfo_UpdateClientUserMutationResult =
	Apollo.MutationResult<ClientOnboardingYourInfo_UpdateClientUserMutation>;
export type ClientOnboardingYourInfo_UpdateClientUserMutationOptions =
	Apollo.BaseMutationOptions<
		ClientOnboardingYourInfo_UpdateClientUserMutation,
		ClientOnboardingYourInfo_UpdateClientUserMutationVariables
	>;
export const ClientOnboardingYourInfo_LoginDocument = gql`
	query clientOnboardingYourInfo_login($data: UserLoginInput!) {
		login(data: $data) {
			token
		}
	}
`;

/**
 * __useClientOnboardingYourInfo_LoginQuery__
 *
 * To run a query within a React component, call `useClientOnboardingYourInfo_LoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingYourInfo_LoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOnboardingYourInfo_LoginQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClientOnboardingYourInfo_LoginQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientOnboardingYourInfo_LoginQuery,
		ClientOnboardingYourInfo_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientOnboardingYourInfo_LoginQuery,
		ClientOnboardingYourInfo_LoginQueryVariables
	>(ClientOnboardingYourInfo_LoginDocument, options);
}
export function useClientOnboardingYourInfo_LoginLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientOnboardingYourInfo_LoginQuery,
		ClientOnboardingYourInfo_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientOnboardingYourInfo_LoginQuery,
		ClientOnboardingYourInfo_LoginQueryVariables
	>(ClientOnboardingYourInfo_LoginDocument, options);
}
export type ClientOnboardingYourInfo_LoginQueryHookResult = ReturnType<
	typeof useClientOnboardingYourInfo_LoginQuery
>;
export type ClientOnboardingYourInfo_LoginLazyQueryHookResult = ReturnType<
	typeof useClientOnboardingYourInfo_LoginLazyQuery
>;
export type ClientOnboardingYourInfo_LoginQueryResult = Apollo.QueryResult<
	ClientOnboardingYourInfo_LoginQuery,
	ClientOnboardingYourInfo_LoginQueryVariables
>;
export const ClientOnboardingYourInfo_GetAuthedUserDocument = gql`
	query ClientOnboardingYourInfo_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			...getAuthedUserFlattenedUserFields
		}
	}
	${GetAuthedUserFlattenedUserFieldsFragmentDoc}
`;

/**
 * __useClientOnboardingYourInfo_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useClientOnboardingYourInfo_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingYourInfo_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOnboardingYourInfo_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientOnboardingYourInfo_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientOnboardingYourInfo_GetAuthedUserQuery,
		ClientOnboardingYourInfo_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientOnboardingYourInfo_GetAuthedUserQuery,
		ClientOnboardingYourInfo_GetAuthedUserQueryVariables
	>(ClientOnboardingYourInfo_GetAuthedUserDocument, options);
}
export function useClientOnboardingYourInfo_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientOnboardingYourInfo_GetAuthedUserQuery,
		ClientOnboardingYourInfo_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientOnboardingYourInfo_GetAuthedUserQuery,
		ClientOnboardingYourInfo_GetAuthedUserQueryVariables
	>(ClientOnboardingYourInfo_GetAuthedUserDocument, options);
}
export type ClientOnboardingYourInfo_GetAuthedUserQueryHookResult = ReturnType<
	typeof useClientOnboardingYourInfo_GetAuthedUserQuery
>;
export type ClientOnboardingYourInfo_GetAuthedUserLazyQueryHookResult =
	ReturnType<typeof useClientOnboardingYourInfo_GetAuthedUserLazyQuery>;
export type ClientOnboardingYourInfo_GetAuthedUserQueryResult =
	Apollo.QueryResult<
		ClientOnboardingYourInfo_GetAuthedUserQuery,
		ClientOnboardingYourInfo_GetAuthedUserQueryVariables
	>;
export const ClientOnboardingModal_GetGlobalVariablesDocument = gql`
	query ClientOnboardingModal_getGlobalVariables {
		getGlobalVariables {
			ClientHelpURL
			ClientDemoVideoUrl
		}
	}
`;

/**
 * __useClientOnboardingModal_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useClientOnboardingModal_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingModal_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOnboardingModal_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientOnboardingModal_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ClientOnboardingModal_GetGlobalVariablesQuery,
		ClientOnboardingModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientOnboardingModal_GetGlobalVariablesQuery,
		ClientOnboardingModal_GetGlobalVariablesQueryVariables
	>(ClientOnboardingModal_GetGlobalVariablesDocument, options);
}
export function useClientOnboardingModal_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientOnboardingModal_GetGlobalVariablesQuery,
		ClientOnboardingModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientOnboardingModal_GetGlobalVariablesQuery,
		ClientOnboardingModal_GetGlobalVariablesQueryVariables
	>(ClientOnboardingModal_GetGlobalVariablesDocument, options);
}
export type ClientOnboardingModal_GetGlobalVariablesQueryHookResult =
	ReturnType<typeof useClientOnboardingModal_GetGlobalVariablesQuery>;
export type ClientOnboardingModal_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useClientOnboardingModal_GetGlobalVariablesLazyQuery>;
export type ClientOnboardingModal_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		ClientOnboardingModal_GetGlobalVariablesQuery,
		ClientOnboardingModal_GetGlobalVariablesQueryVariables
	>;
export const ExportContactsDataDocument = gql`
	query exportContactsData($where: ExportContactsDataWhereInput!) {
		exportContactsData(where: $where)
	}
`;

/**
 * __useExportContactsDataQuery__
 *
 * To run a query within a React component, call `useExportContactsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportContactsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportContactsDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportContactsDataQuery(
	baseOptions: Apollo.QueryHookOptions<
		ExportContactsDataQuery,
		ExportContactsDataQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ExportContactsDataQuery,
		ExportContactsDataQueryVariables
	>(ExportContactsDataDocument, options);
}
export function useExportContactsDataLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportContactsDataQuery,
		ExportContactsDataQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ExportContactsDataQuery,
		ExportContactsDataQueryVariables
	>(ExportContactsDataDocument, options);
}
export type ExportContactsDataQueryHookResult = ReturnType<
	typeof useExportContactsDataQuery
>;
export type ExportContactsDataLazyQueryHookResult = ReturnType<
	typeof useExportContactsDataLazyQuery
>;
export type ExportContactsDataQueryResult = Apollo.QueryResult<
	ExportContactsDataQuery,
	ExportContactsDataQueryVariables
>;
export const DeleteContactConfirmationModal_DeleteContactDocument = gql`
	mutation DeleteContactConfirmationModal_deleteContact(
		$where: ContactWhereUniqueInput!
	) {
		deleteContact(where: $where)
	}
`;
export type DeleteContactConfirmationModal_DeleteContactMutationFn =
	Apollo.MutationFunction<
		DeleteContactConfirmationModal_DeleteContactMutation,
		DeleteContactConfirmationModal_DeleteContactMutationVariables
	>;

/**
 * __useDeleteContactConfirmationModal_DeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactConfirmationModal_DeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactConfirmationModal_DeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactConfirmationModalDeleteContactMutation, { data, loading, error }] = useDeleteContactConfirmationModal_DeleteContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteContactConfirmationModal_DeleteContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteContactConfirmationModal_DeleteContactMutation,
		DeleteContactConfirmationModal_DeleteContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteContactConfirmationModal_DeleteContactMutation,
		DeleteContactConfirmationModal_DeleteContactMutationVariables
	>(DeleteContactConfirmationModal_DeleteContactDocument, options);
}
export type DeleteContactConfirmationModal_DeleteContactMutationHookResult =
	ReturnType<typeof useDeleteContactConfirmationModal_DeleteContactMutation>;
export type DeleteContactConfirmationModal_DeleteContactMutationResult =
	Apollo.MutationResult<DeleteContactConfirmationModal_DeleteContactMutation>;
export type DeleteContactConfirmationModal_DeleteContactMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteContactConfirmationModal_DeleteContactMutation,
		DeleteContactConfirmationModal_DeleteContactMutationVariables
	>;
export const DeleteContactConfirmationModal_UpdateContactStatusDocument = gql`
	mutation DeleteContactConfirmationModal_updateContactStatus(
		$data: UpdateContactStatusDataInput!
		$where: ContactWhereUniqueInput!
	) {
		updateContactStatus(data: $data, where: $where) {
			id
		}
	}
`;
export type DeleteContactConfirmationModal_UpdateContactStatusMutationFn =
	Apollo.MutationFunction<
		DeleteContactConfirmationModal_UpdateContactStatusMutation,
		DeleteContactConfirmationModal_UpdateContactStatusMutationVariables
	>;

/**
 * __useDeleteContactConfirmationModal_UpdateContactStatusMutation__
 *
 * To run a mutation, you first call `useDeleteContactConfirmationModal_UpdateContactStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactConfirmationModal_UpdateContactStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactConfirmationModalUpdateContactStatusMutation, { data, loading, error }] = useDeleteContactConfirmationModal_UpdateContactStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteContactConfirmationModal_UpdateContactStatusMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteContactConfirmationModal_UpdateContactStatusMutation,
		DeleteContactConfirmationModal_UpdateContactStatusMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteContactConfirmationModal_UpdateContactStatusMutation,
		DeleteContactConfirmationModal_UpdateContactStatusMutationVariables
	>(DeleteContactConfirmationModal_UpdateContactStatusDocument, options);
}
export type DeleteContactConfirmationModal_UpdateContactStatusMutationHookResult =
	ReturnType<
		typeof useDeleteContactConfirmationModal_UpdateContactStatusMutation
	>;
export type DeleteContactConfirmationModal_UpdateContactStatusMutationResult =
	Apollo.MutationResult<DeleteContactConfirmationModal_UpdateContactStatusMutation>;
export type DeleteContactConfirmationModal_UpdateContactStatusMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteContactConfirmationModal_UpdateContactStatusMutation,
		DeleteContactConfirmationModal_UpdateContactStatusMutationVariables
	>;
export const UseClientsTable_GetContactsWhereDocument = gql`
	query useClientsTable_getContactsWhere(
		$orderBy: [ContactOrderByInput]
		$skip: Int
		$take: Int
		$where: ContactWhereInput!
	) {
		getContactsWhere(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			contacts {
				...useClientsTable_contact
			}
		}
	}
	${UseClientsTable_ContactFragmentDoc}
`;

/**
 * __useUseClientsTable_GetContactsWhereQuery__
 *
 * To run a query within a React component, call `useUseClientsTable_GetContactsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseClientsTable_GetContactsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseClientsTable_GetContactsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseClientsTable_GetContactsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseClientsTable_GetContactsWhereQuery,
		UseClientsTable_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseClientsTable_GetContactsWhereQuery,
		UseClientsTable_GetContactsWhereQueryVariables
	>(UseClientsTable_GetContactsWhereDocument, options);
}
export function useUseClientsTable_GetContactsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseClientsTable_GetContactsWhereQuery,
		UseClientsTable_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseClientsTable_GetContactsWhereQuery,
		UseClientsTable_GetContactsWhereQueryVariables
	>(UseClientsTable_GetContactsWhereDocument, options);
}
export type UseClientsTable_GetContactsWhereQueryHookResult = ReturnType<
	typeof useUseClientsTable_GetContactsWhereQuery
>;
export type UseClientsTable_GetContactsWhereLazyQueryHookResult = ReturnType<
	typeof useUseClientsTable_GetContactsWhereLazyQuery
>;
export type UseClientsTable_GetContactsWhereQueryResult = Apollo.QueryResult<
	UseClientsTable_GetContactsWhereQuery,
	UseClientsTable_GetContactsWhereQueryVariables
>;
export const UseClientsTable_GetOrganizationWhereDocument = gql`
	query useClientsTable_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			id
			users(orderBy: { firstName: asc }) {
				...useClientsTable_member
			}
		}
	}
	${UseClientsTable_MemberFragmentDoc}
`;

/**
 * __useUseClientsTable_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useUseClientsTable_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseClientsTable_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseClientsTable_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseClientsTable_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseClientsTable_GetOrganizationWhereQuery,
		UseClientsTable_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseClientsTable_GetOrganizationWhereQuery,
		UseClientsTable_GetOrganizationWhereQueryVariables
	>(UseClientsTable_GetOrganizationWhereDocument, options);
}
export function useUseClientsTable_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseClientsTable_GetOrganizationWhereQuery,
		UseClientsTable_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseClientsTable_GetOrganizationWhereQuery,
		UseClientsTable_GetOrganizationWhereQueryVariables
	>(UseClientsTable_GetOrganizationWhereDocument, options);
}
export type UseClientsTable_GetOrganizationWhereQueryHookResult = ReturnType<
	typeof useUseClientsTable_GetOrganizationWhereQuery
>;
export type UseClientsTable_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<typeof useUseClientsTable_GetOrganizationWhereLazyQuery>;
export type UseClientsTable_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		UseClientsTable_GetOrganizationWhereQuery,
		UseClientsTable_GetOrganizationWhereQueryVariables
	>;
export const UseClientsTable_AssignMemberToContactDocument = gql`
	mutation useClientsTable_assignMemberToContact(
		$data: OrgUserWhereUniqueInput!
		$where: ContactWhereUniqueInput!
	) {
		assignMemberToContact(where: $where, data: $data) {
			...useClientsTable_contact
		}
	}
	${UseClientsTable_ContactFragmentDoc}
`;
export type UseClientsTable_AssignMemberToContactMutationFn =
	Apollo.MutationFunction<
		UseClientsTable_AssignMemberToContactMutation,
		UseClientsTable_AssignMemberToContactMutationVariables
	>;

/**
 * __useUseClientsTable_AssignMemberToContactMutation__
 *
 * To run a mutation, you first call `useUseClientsTable_AssignMemberToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseClientsTable_AssignMemberToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useClientsTableAssignMemberToContactMutation, { data, loading, error }] = useUseClientsTable_AssignMemberToContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseClientsTable_AssignMemberToContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseClientsTable_AssignMemberToContactMutation,
		UseClientsTable_AssignMemberToContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseClientsTable_AssignMemberToContactMutation,
		UseClientsTable_AssignMemberToContactMutationVariables
	>(UseClientsTable_AssignMemberToContactDocument, options);
}
export type UseClientsTable_AssignMemberToContactMutationHookResult =
	ReturnType<typeof useUseClientsTable_AssignMemberToContactMutation>;
export type UseClientsTable_AssignMemberToContactMutationResult =
	Apollo.MutationResult<UseClientsTable_AssignMemberToContactMutation>;
export type UseClientsTable_AssignMemberToContactMutationOptions =
	Apollo.BaseMutationOptions<
		UseClientsTable_AssignMemberToContactMutation,
		UseClientsTable_AssignMemberToContactMutationVariables
	>;
export const UseClientsTable_UpdateContactStatusDocument = gql`
	mutation useClientsTable_updateContactStatus(
		$data: UpdateContactStatusDataInput!
		$where: ContactWhereUniqueInput!
	) {
		updateContactStatus(data: $data, where: $where) {
			id
			status
		}
	}
`;
export type UseClientsTable_UpdateContactStatusMutationFn =
	Apollo.MutationFunction<
		UseClientsTable_UpdateContactStatusMutation,
		UseClientsTable_UpdateContactStatusMutationVariables
	>;

/**
 * __useUseClientsTable_UpdateContactStatusMutation__
 *
 * To run a mutation, you first call `useUseClientsTable_UpdateContactStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseClientsTable_UpdateContactStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useClientsTableUpdateContactStatusMutation, { data, loading, error }] = useUseClientsTable_UpdateContactStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseClientsTable_UpdateContactStatusMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseClientsTable_UpdateContactStatusMutation,
		UseClientsTable_UpdateContactStatusMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseClientsTable_UpdateContactStatusMutation,
		UseClientsTable_UpdateContactStatusMutationVariables
	>(UseClientsTable_UpdateContactStatusDocument, options);
}
export type UseClientsTable_UpdateContactStatusMutationHookResult = ReturnType<
	typeof useUseClientsTable_UpdateContactStatusMutation
>;
export type UseClientsTable_UpdateContactStatusMutationResult =
	Apollo.MutationResult<UseClientsTable_UpdateContactStatusMutation>;
export type UseClientsTable_UpdateContactStatusMutationOptions =
	Apollo.BaseMutationOptions<
		UseClientsTable_UpdateContactStatusMutation,
		UseClientsTable_UpdateContactStatusMutationVariables
	>;
export const CompanyFoldersTable_GetFolderContentsDocument = gql`
	query CompanyFoldersTable_getFolderContents(
		$where: FolderWhereUniqueInput!
		$skip: Int
		$take: Int
		$orderBy: FolderContentsOrderByInput
	) {
		getFolderContents(
			where: $where
			skip: $skip
			take: $take
			orderBy: $orderBy
		) {
			id
			_count {
				documents
				childFolders
			}
			childFolders {
				...useCompanyFoldersTable_customFolder
			}
			documents {
				...useCompanyFoldersTable_CustomDocumentWithDownloadUrl
			}
		}
	}
	${UseCompanyFoldersTable_CustomFolderFragmentDoc}
	${UseCompanyFoldersTable_CustomDocumentWithDownloadUrlFragmentDoc}
`;

/**
 * __useCompanyFoldersTable_GetFolderContentsQuery__
 *
 * To run a query within a React component, call `useCompanyFoldersTable_GetFolderContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFoldersTable_GetFolderContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFoldersTable_GetFolderContentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCompanyFoldersTable_GetFolderContentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		CompanyFoldersTable_GetFolderContentsQuery,
		CompanyFoldersTable_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CompanyFoldersTable_GetFolderContentsQuery,
		CompanyFoldersTable_GetFolderContentsQueryVariables
	>(CompanyFoldersTable_GetFolderContentsDocument, options);
}
export function useCompanyFoldersTable_GetFolderContentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CompanyFoldersTable_GetFolderContentsQuery,
		CompanyFoldersTable_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CompanyFoldersTable_GetFolderContentsQuery,
		CompanyFoldersTable_GetFolderContentsQueryVariables
	>(CompanyFoldersTable_GetFolderContentsDocument, options);
}
export type CompanyFoldersTable_GetFolderContentsQueryHookResult = ReturnType<
	typeof useCompanyFoldersTable_GetFolderContentsQuery
>;
export type CompanyFoldersTable_GetFolderContentsLazyQueryHookResult =
	ReturnType<typeof useCompanyFoldersTable_GetFolderContentsLazyQuery>;
export type CompanyFoldersTable_GetFolderContentsQueryResult =
	Apollo.QueryResult<
		CompanyFoldersTable_GetFolderContentsQuery,
		CompanyFoldersTable_GetFolderContentsQueryVariables
	>;
export const CompanyFoldersTable_RenameFolderDocument = gql`
	mutation CompanyFoldersTable_renameFolder(
		$data: UpdateFolderNameInput!
		$where: FolderWhereUniqueInput!
	) {
		renameFolder(where: $where, data: $data) {
			id
			name
		}
	}
`;
export type CompanyFoldersTable_RenameFolderMutationFn =
	Apollo.MutationFunction<
		CompanyFoldersTable_RenameFolderMutation,
		CompanyFoldersTable_RenameFolderMutationVariables
	>;

/**
 * __useCompanyFoldersTable_RenameFolderMutation__
 *
 * To run a mutation, you first call `useCompanyFoldersTable_RenameFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyFoldersTable_RenameFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyFoldersTableRenameFolderMutation, { data, loading, error }] = useCompanyFoldersTable_RenameFolderMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompanyFoldersTable_RenameFolderMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompanyFoldersTable_RenameFolderMutation,
		CompanyFoldersTable_RenameFolderMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompanyFoldersTable_RenameFolderMutation,
		CompanyFoldersTable_RenameFolderMutationVariables
	>(CompanyFoldersTable_RenameFolderDocument, options);
}
export type CompanyFoldersTable_RenameFolderMutationHookResult = ReturnType<
	typeof useCompanyFoldersTable_RenameFolderMutation
>;
export type CompanyFoldersTable_RenameFolderMutationResult =
	Apollo.MutationResult<CompanyFoldersTable_RenameFolderMutation>;
export type CompanyFoldersTable_RenameFolderMutationOptions =
	Apollo.BaseMutationOptions<
		CompanyFoldersTable_RenameFolderMutation,
		CompanyFoldersTable_RenameFolderMutationVariables
	>;
export const CompanyFoldersTable_DeleteDocumentDocument = gql`
	mutation CompanyFoldersTable_deleteDocument(
		$where: DocumentWhereUniqueInput!
	) {
		deleteDocument(where: $where)
	}
`;
export type CompanyFoldersTable_DeleteDocumentMutationFn =
	Apollo.MutationFunction<
		CompanyFoldersTable_DeleteDocumentMutation,
		CompanyFoldersTable_DeleteDocumentMutationVariables
	>;

/**
 * __useCompanyFoldersTable_DeleteDocumentMutation__
 *
 * To run a mutation, you first call `useCompanyFoldersTable_DeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyFoldersTable_DeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyFoldersTableDeleteDocumentMutation, { data, loading, error }] = useCompanyFoldersTable_DeleteDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompanyFoldersTable_DeleteDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompanyFoldersTable_DeleteDocumentMutation,
		CompanyFoldersTable_DeleteDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompanyFoldersTable_DeleteDocumentMutation,
		CompanyFoldersTable_DeleteDocumentMutationVariables
	>(CompanyFoldersTable_DeleteDocumentDocument, options);
}
export type CompanyFoldersTable_DeleteDocumentMutationHookResult = ReturnType<
	typeof useCompanyFoldersTable_DeleteDocumentMutation
>;
export type CompanyFoldersTable_DeleteDocumentMutationResult =
	Apollo.MutationResult<CompanyFoldersTable_DeleteDocumentMutation>;
export type CompanyFoldersTable_DeleteDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		CompanyFoldersTable_DeleteDocumentMutation,
		CompanyFoldersTable_DeleteDocumentMutationVariables
	>;
export const CompanyFoldersTable_DeleteFoldersDocument = gql`
	mutation CompanyFoldersTable_deleteFolders($where: FoldersWhereCustomInput!) {
		deleteFolders(where: $where)
	}
`;
export type CompanyFoldersTable_DeleteFoldersMutationFn =
	Apollo.MutationFunction<
		CompanyFoldersTable_DeleteFoldersMutation,
		CompanyFoldersTable_DeleteFoldersMutationVariables
	>;

/**
 * __useCompanyFoldersTable_DeleteFoldersMutation__
 *
 * To run a mutation, you first call `useCompanyFoldersTable_DeleteFoldersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyFoldersTable_DeleteFoldersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyFoldersTableDeleteFoldersMutation, { data, loading, error }] = useCompanyFoldersTable_DeleteFoldersMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompanyFoldersTable_DeleteFoldersMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompanyFoldersTable_DeleteFoldersMutation,
		CompanyFoldersTable_DeleteFoldersMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompanyFoldersTable_DeleteFoldersMutation,
		CompanyFoldersTable_DeleteFoldersMutationVariables
	>(CompanyFoldersTable_DeleteFoldersDocument, options);
}
export type CompanyFoldersTable_DeleteFoldersMutationHookResult = ReturnType<
	typeof useCompanyFoldersTable_DeleteFoldersMutation
>;
export type CompanyFoldersTable_DeleteFoldersMutationResult =
	Apollo.MutationResult<CompanyFoldersTable_DeleteFoldersMutation>;
export type CompanyFoldersTable_DeleteFoldersMutationOptions =
	Apollo.BaseMutationOptions<
		CompanyFoldersTable_DeleteFoldersMutation,
		CompanyFoldersTable_DeleteFoldersMutationVariables
	>;
export const UseContactSnippet_GetContactsWhereDocument = gql`
	query useContactSnippet_getContactsWhere($where: ContactWhereInput!) {
		getContactsWhere(where: $where) {
			contacts {
				...contactSnippetContact
			}
		}
	}
	${ContactSnippetContactFragmentDoc}
`;

/**
 * __useUseContactSnippet_GetContactsWhereQuery__
 *
 * To run a query within a React component, call `useUseContactSnippet_GetContactsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseContactSnippet_GetContactsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseContactSnippet_GetContactsWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContactSnippet_GetContactsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseContactSnippet_GetContactsWhereQuery,
		UseContactSnippet_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseContactSnippet_GetContactsWhereQuery,
		UseContactSnippet_GetContactsWhereQueryVariables
	>(UseContactSnippet_GetContactsWhereDocument, options);
}
export function useUseContactSnippet_GetContactsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseContactSnippet_GetContactsWhereQuery,
		UseContactSnippet_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseContactSnippet_GetContactsWhereQuery,
		UseContactSnippet_GetContactsWhereQueryVariables
	>(UseContactSnippet_GetContactsWhereDocument, options);
}
export type UseContactSnippet_GetContactsWhereQueryHookResult = ReturnType<
	typeof useUseContactSnippet_GetContactsWhereQuery
>;
export type UseContactSnippet_GetContactsWhereLazyQueryHookResult = ReturnType<
	typeof useUseContactSnippet_GetContactsWhereLazyQuery
>;
export type UseContactSnippet_GetContactsWhereQueryResult = Apollo.QueryResult<
	UseContactSnippet_GetContactsWhereQuery,
	UseContactSnippet_GetContactsWhereQueryVariables
>;
export const UseContactSnippet_CreateContactAsVendorDocument = gql`
	mutation useContactSnippet_createContactAsVendor(
		$data: CreateContactDataInput!
		$where: UserByEmailUniqueInput!
	) {
		createContactAsVendor(data: $data, where: $where) {
			...contactSnippetContact
		}
	}
	${ContactSnippetContactFragmentDoc}
`;
export type UseContactSnippet_CreateContactAsVendorMutationFn =
	Apollo.MutationFunction<
		UseContactSnippet_CreateContactAsVendorMutation,
		UseContactSnippet_CreateContactAsVendorMutationVariables
	>;

/**
 * __useUseContactSnippet_CreateContactAsVendorMutation__
 *
 * To run a mutation, you first call `useUseContactSnippet_CreateContactAsVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContactSnippet_CreateContactAsVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContactSnippetCreateContactAsVendorMutation, { data, loading, error }] = useUseContactSnippet_CreateContactAsVendorMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContactSnippet_CreateContactAsVendorMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContactSnippet_CreateContactAsVendorMutation,
		UseContactSnippet_CreateContactAsVendorMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContactSnippet_CreateContactAsVendorMutation,
		UseContactSnippet_CreateContactAsVendorMutationVariables
	>(UseContactSnippet_CreateContactAsVendorDocument, options);
}
export type UseContactSnippet_CreateContactAsVendorMutationHookResult =
	ReturnType<typeof useUseContactSnippet_CreateContactAsVendorMutation>;
export type UseContactSnippet_CreateContactAsVendorMutationResult =
	Apollo.MutationResult<UseContactSnippet_CreateContactAsVendorMutation>;
export type UseContactSnippet_CreateContactAsVendorMutationOptions =
	Apollo.BaseMutationOptions<
		UseContactSnippet_CreateContactAsVendorMutation,
		UseContactSnippet_CreateContactAsVendorMutationVariables
	>;
export const UseContactSnippet_CreateContactAsClientDocument = gql`
	mutation useContactSnippet_createContactAsClient(
		$where: UserByIdUniqueInput!
		$data: OrganizationWhereUniqueInput!
	) {
		createContactAsClient(where: $where, data: $data) {
			...contactSnippetContact
		}
	}
	${ContactSnippetContactFragmentDoc}
`;
export type UseContactSnippet_CreateContactAsClientMutationFn =
	Apollo.MutationFunction<
		UseContactSnippet_CreateContactAsClientMutation,
		UseContactSnippet_CreateContactAsClientMutationVariables
	>;

/**
 * __useUseContactSnippet_CreateContactAsClientMutation__
 *
 * To run a mutation, you first call `useUseContactSnippet_CreateContactAsClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContactSnippet_CreateContactAsClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContactSnippetCreateContactAsClientMutation, { data, loading, error }] = useUseContactSnippet_CreateContactAsClientMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseContactSnippet_CreateContactAsClientMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContactSnippet_CreateContactAsClientMutation,
		UseContactSnippet_CreateContactAsClientMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContactSnippet_CreateContactAsClientMutation,
		UseContactSnippet_CreateContactAsClientMutationVariables
	>(UseContactSnippet_CreateContactAsClientDocument, options);
}
export type UseContactSnippet_CreateContactAsClientMutationHookResult =
	ReturnType<typeof useUseContactSnippet_CreateContactAsClientMutation>;
export type UseContactSnippet_CreateContactAsClientMutationResult =
	Apollo.MutationResult<UseContactSnippet_CreateContactAsClientMutation>;
export type UseContactSnippet_CreateContactAsClientMutationOptions =
	Apollo.BaseMutationOptions<
		UseContactSnippet_CreateContactAsClientMutation,
		UseContactSnippet_CreateContactAsClientMutationVariables
	>;
export const UseContactSnippet_ActivateContactDocument = gql`
	mutation useContactSnippet_activateContact(
		$where: ContactWhereUniqueInput!
		$data: ActivateContactCustomInput
	) {
		activateContact(where: $where, data: $data) {
			...contactSnippetContact
		}
	}
	${ContactSnippetContactFragmentDoc}
`;
export type UseContactSnippet_ActivateContactMutationFn =
	Apollo.MutationFunction<
		UseContactSnippet_ActivateContactMutation,
		UseContactSnippet_ActivateContactMutationVariables
	>;

/**
 * __useUseContactSnippet_ActivateContactMutation__
 *
 * To run a mutation, you first call `useUseContactSnippet_ActivateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContactSnippet_ActivateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContactSnippetActivateContactMutation, { data, loading, error }] = useUseContactSnippet_ActivateContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseContactSnippet_ActivateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContactSnippet_ActivateContactMutation,
		UseContactSnippet_ActivateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContactSnippet_ActivateContactMutation,
		UseContactSnippet_ActivateContactMutationVariables
	>(UseContactSnippet_ActivateContactDocument, options);
}
export type UseContactSnippet_ActivateContactMutationHookResult = ReturnType<
	typeof useUseContactSnippet_ActivateContactMutation
>;
export type UseContactSnippet_ActivateContactMutationResult =
	Apollo.MutationResult<UseContactSnippet_ActivateContactMutation>;
export type UseContactSnippet_ActivateContactMutationOptions =
	Apollo.BaseMutationOptions<
		UseContactSnippet_ActivateContactMutation,
		UseContactSnippet_ActivateContactMutationVariables
	>;
export const UseContactSnippet_RequestContactActivationDocument = gql`
	mutation useContactSnippet_requestContactActivation(
		$where: ContactWhereUniqueInput!
	) {
		requestContactActivation(where: $where) {
			...contactSnippetContact
		}
	}
	${ContactSnippetContactFragmentDoc}
`;
export type UseContactSnippet_RequestContactActivationMutationFn =
	Apollo.MutationFunction<
		UseContactSnippet_RequestContactActivationMutation,
		UseContactSnippet_RequestContactActivationMutationVariables
	>;

/**
 * __useUseContactSnippet_RequestContactActivationMutation__
 *
 * To run a mutation, you first call `useUseContactSnippet_RequestContactActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContactSnippet_RequestContactActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContactSnippetRequestContactActivationMutation, { data, loading, error }] = useUseContactSnippet_RequestContactActivationMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContactSnippet_RequestContactActivationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContactSnippet_RequestContactActivationMutation,
		UseContactSnippet_RequestContactActivationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContactSnippet_RequestContactActivationMutation,
		UseContactSnippet_RequestContactActivationMutationVariables
	>(UseContactSnippet_RequestContactActivationDocument, options);
}
export type UseContactSnippet_RequestContactActivationMutationHookResult =
	ReturnType<typeof useUseContactSnippet_RequestContactActivationMutation>;
export type UseContactSnippet_RequestContactActivationMutationResult =
	Apollo.MutationResult<UseContactSnippet_RequestContactActivationMutation>;
export type UseContactSnippet_RequestContactActivationMutationOptions =
	Apollo.BaseMutationOptions<
		UseContactSnippet_RequestContactActivationMutation,
		UseContactSnippet_RequestContactActivationMutationVariables
	>;
export const ContractDetail_GetOrgUserWhereDocument = gql`
	query contractDetail_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				...contractViewOrganization
				users {
					id
					role
					firstName
					lastName
					organization {
						id
					}
					user {
						id
						email
						userType
					}
				}
				services {
					id
					name
				}
			}
		}
	}
	${ContractViewOrganizationFragmentDoc}
`;

/**
 * __useContractDetail_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useContractDetail_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetail_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetail_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractDetail_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractDetail_GetOrgUserWhereQuery,
		ContractDetail_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractDetail_GetOrgUserWhereQuery,
		ContractDetail_GetOrgUserWhereQueryVariables
	>(ContractDetail_GetOrgUserWhereDocument, options);
}
export function useContractDetail_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractDetail_GetOrgUserWhereQuery,
		ContractDetail_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractDetail_GetOrgUserWhereQuery,
		ContractDetail_GetOrgUserWhereQueryVariables
	>(ContractDetail_GetOrgUserWhereDocument, options);
}
export type ContractDetail_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useContractDetail_GetOrgUserWhereQuery
>;
export type ContractDetail_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useContractDetail_GetOrgUserWhereLazyQuery
>;
export type ContractDetail_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	ContractDetail_GetOrgUserWhereQuery,
	ContractDetail_GetOrgUserWhereQueryVariables
>;
export const ContractDetail_GetContractWhereDocument = gql`
	query contractDetail_getContractWhere(
		$where: ContractWhereInputWithMFAToken!
	) {
		getContractWhere(where: $where) {
			contract {
				id
				vendor {
					id
				}
				...contractDetailContract
			}
			requestingUserBaseId
			requestingUserIsGuest
		}
	}
	${ContractDetailContractFragmentDoc}
`;

/**
 * __useContractDetail_GetContractWhereQuery__
 *
 * To run a query within a React component, call `useContractDetail_GetContractWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetail_GetContractWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetail_GetContractWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractDetail_GetContractWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractDetail_GetContractWhereQuery,
		ContractDetail_GetContractWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractDetail_GetContractWhereQuery,
		ContractDetail_GetContractWhereQueryVariables
	>(ContractDetail_GetContractWhereDocument, options);
}
export function useContractDetail_GetContractWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractDetail_GetContractWhereQuery,
		ContractDetail_GetContractWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractDetail_GetContractWhereQuery,
		ContractDetail_GetContractWhereQueryVariables
	>(ContractDetail_GetContractWhereDocument, options);
}
export type ContractDetail_GetContractWhereQueryHookResult = ReturnType<
	typeof useContractDetail_GetContractWhereQuery
>;
export type ContractDetail_GetContractWhereLazyQueryHookResult = ReturnType<
	typeof useContractDetail_GetContractWhereLazyQuery
>;
export type ContractDetail_GetContractWhereQueryResult = Apollo.QueryResult<
	ContractDetail_GetContractWhereQuery,
	ContractDetail_GetContractWhereQueryVariables
>;
export const ContractDetail_GetOrganizationContractTemplateDocument = gql`
	query contractDetail_getOrganizationContractTemplate(
		$where: ContractTemplateWhereUniqueInput!
	) {
		getOrganizationContractTemplate(where: $where) {
			id
			title
			countOfCustomerSigners
			vendorWillSign
			sourceFileUrl
		}
	}
`;

/**
 * __useContractDetail_GetOrganizationContractTemplateQuery__
 *
 * To run a query within a React component, call `useContractDetail_GetOrganizationContractTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetail_GetOrganizationContractTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetail_GetOrganizationContractTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractDetail_GetOrganizationContractTemplateQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractDetail_GetOrganizationContractTemplateQuery,
		ContractDetail_GetOrganizationContractTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractDetail_GetOrganizationContractTemplateQuery,
		ContractDetail_GetOrganizationContractTemplateQueryVariables
	>(ContractDetail_GetOrganizationContractTemplateDocument, options);
}
export function useContractDetail_GetOrganizationContractTemplateLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractDetail_GetOrganizationContractTemplateQuery,
		ContractDetail_GetOrganizationContractTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractDetail_GetOrganizationContractTemplateQuery,
		ContractDetail_GetOrganizationContractTemplateQueryVariables
	>(ContractDetail_GetOrganizationContractTemplateDocument, options);
}
export type ContractDetail_GetOrganizationContractTemplateQueryHookResult =
	ReturnType<typeof useContractDetail_GetOrganizationContractTemplateQuery>;
export type ContractDetail_GetOrganizationContractTemplateLazyQueryHookResult =
	ReturnType<typeof useContractDetail_GetOrganizationContractTemplateLazyQuery>;
export type ContractDetail_GetOrganizationContractTemplateQueryResult =
	Apollo.QueryResult<
		ContractDetail_GetOrganizationContractTemplateQuery,
		ContractDetail_GetOrganizationContractTemplateQueryVariables
	>;
export const ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesDocument = gql`
	query ContractEditFileOrTemplateSelectorTemplateButton_getOrganizationContractTemplates(
		$where: CustomContractTemplateWhereWithoutOrganizationInput
		$orderBy: [ContractTemplateOrderByInput]
	) {
		getOrganizationContractTemplates(where: $where, orderBy: $orderBy) {
			contractTemplates {
				...contractEditFileOrTemplateSelectorTemplateButtonContactTemplate
			}
		}
	}
	${ContractEditFileOrTemplateSelectorTemplateButtonContactTemplateFragmentDoc}
`;

/**
 * __useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery__
 *
 * To run a query within a React component, call `useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery,
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery,
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryVariables
	>(
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesDocument,
		options
	);
}
export function useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery,
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery,
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryVariables
	>(
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesDocument,
		options
	);
}
export type ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryHookResult =
	ReturnType<
		typeof useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery
	>;
export type ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesLazyQueryHookResult =
	ReturnType<
		typeof useContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesLazyQuery
	>;
export type ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryResult =
	Apollo.QueryResult<
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQuery,
		ContractEditFileOrTemplateSelectorTemplateButton_GetOrganizationContractTemplatesQueryVariables
	>;
export const ContractEditFileOrTemplateSelector_VoidAndPortContractDocument = gql`
	mutation contractEditFileOrTemplateSelector_voidAndPortContract(
		$where: ContractWhereUniqueInput!
	) {
		voidAndPortContract(where: $where) {
			id
			status
		}
	}
`;
export type ContractEditFileOrTemplateSelector_VoidAndPortContractMutationFn =
	Apollo.MutationFunction<
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutation,
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutationVariables
	>;

/**
 * __useContractEditFileOrTemplateSelector_VoidAndPortContractMutation__
 *
 * To run a mutation, you first call `useContractEditFileOrTemplateSelector_VoidAndPortContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractEditFileOrTemplateSelector_VoidAndPortContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractEditFileOrTemplateSelectorVoidAndPortContractMutation, { data, loading, error }] = useContractEditFileOrTemplateSelector_VoidAndPortContractMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractEditFileOrTemplateSelector_VoidAndPortContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutation,
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutation,
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutationVariables
	>(ContractEditFileOrTemplateSelector_VoidAndPortContractDocument, options);
}
export type ContractEditFileOrTemplateSelector_VoidAndPortContractMutationHookResult =
	ReturnType<
		typeof useContractEditFileOrTemplateSelector_VoidAndPortContractMutation
	>;
export type ContractEditFileOrTemplateSelector_VoidAndPortContractMutationResult =
	Apollo.MutationResult<ContractEditFileOrTemplateSelector_VoidAndPortContractMutation>;
export type ContractEditFileOrTemplateSelector_VoidAndPortContractMutationOptions =
	Apollo.BaseMutationOptions<
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutation,
		ContractEditFileOrTemplateSelector_VoidAndPortContractMutationVariables
	>;
export const CounterSignerWidget_GetOrganizationWhereDocument = gql`
	query counterSignerWidget_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			...buildMuiFriendlyOptionsOrganization
		}
	}
	${BuildMuiFriendlyOptionsOrganizationFragmentDoc}
`;

/**
 * __useCounterSignerWidget_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useCounterSignerWidget_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useCounterSignerWidget_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCounterSignerWidget_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCounterSignerWidget_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		CounterSignerWidget_GetOrganizationWhereQuery,
		CounterSignerWidget_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CounterSignerWidget_GetOrganizationWhereQuery,
		CounterSignerWidget_GetOrganizationWhereQueryVariables
	>(CounterSignerWidget_GetOrganizationWhereDocument, options);
}
export function useCounterSignerWidget_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CounterSignerWidget_GetOrganizationWhereQuery,
		CounterSignerWidget_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CounterSignerWidget_GetOrganizationWhereQuery,
		CounterSignerWidget_GetOrganizationWhereQueryVariables
	>(CounterSignerWidget_GetOrganizationWhereDocument, options);
}
export type CounterSignerWidget_GetOrganizationWhereQueryHookResult =
	ReturnType<typeof useCounterSignerWidget_GetOrganizationWhereQuery>;
export type CounterSignerWidget_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<typeof useCounterSignerWidget_GetOrganizationWhereLazyQuery>;
export type CounterSignerWidget_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		CounterSignerWidget_GetOrganizationWhereQuery,
		CounterSignerWidget_GetOrganizationWhereQueryVariables
	>;
export const ContractEdit_CreateContractDocument = gql`
	mutation contractEdit_createContract($data: ContractCreateCustomInput!) {
		createContract(data: $data) {
			id
		}
	}
`;
export type ContractEdit_CreateContractMutationFn = Apollo.MutationFunction<
	ContractEdit_CreateContractMutation,
	ContractEdit_CreateContractMutationVariables
>;

/**
 * __useContractEdit_CreateContractMutation__
 *
 * To run a mutation, you first call `useContractEdit_CreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractEdit_CreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractEditCreateContractMutation, { data, loading, error }] = useContractEdit_CreateContractMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useContractEdit_CreateContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractEdit_CreateContractMutation,
		ContractEdit_CreateContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractEdit_CreateContractMutation,
		ContractEdit_CreateContractMutationVariables
	>(ContractEdit_CreateContractDocument, options);
}
export type ContractEdit_CreateContractMutationHookResult = ReturnType<
	typeof useContractEdit_CreateContractMutation
>;
export type ContractEdit_CreateContractMutationResult =
	Apollo.MutationResult<ContractEdit_CreateContractMutation>;
export type ContractEdit_CreateContractMutationOptions =
	Apollo.BaseMutationOptions<
		ContractEdit_CreateContractMutation,
		ContractEdit_CreateContractMutationVariables
	>;
export const ContractEdit_UpdateContractDocument = gql`
	mutation contractEdit_updateContract(
		$data: ContractUpdateInput!
		$where: ContractWhereUniqueInput!
	) {
		updateContract(data: $data, where: $where) {
			...contractEditContractForGetContractWhere
		}
	}
	${ContractEditContractForGetContractWhereFragmentDoc}
`;
export type ContractEdit_UpdateContractMutationFn = Apollo.MutationFunction<
	ContractEdit_UpdateContractMutation,
	ContractEdit_UpdateContractMutationVariables
>;

/**
 * __useContractEdit_UpdateContractMutation__
 *
 * To run a mutation, you first call `useContractEdit_UpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractEdit_UpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractEditUpdateContractMutation, { data, loading, error }] = useContractEdit_UpdateContractMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractEdit_UpdateContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractEdit_UpdateContractMutation,
		ContractEdit_UpdateContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractEdit_UpdateContractMutation,
		ContractEdit_UpdateContractMutationVariables
	>(ContractEdit_UpdateContractDocument, options);
}
export type ContractEdit_UpdateContractMutationHookResult = ReturnType<
	typeof useContractEdit_UpdateContractMutation
>;
export type ContractEdit_UpdateContractMutationResult =
	Apollo.MutationResult<ContractEdit_UpdateContractMutation>;
export type ContractEdit_UpdateContractMutationOptions =
	Apollo.BaseMutationOptions<
		ContractEdit_UpdateContractMutation,
		ContractEdit_UpdateContractMutationVariables
	>;
export const ContractEdit_CreateContractMarkupUrlDocument = gql`
	mutation contractEdit_createContractMarkupUrl(
		$where: ContractWhereUniqueInput!
	) {
		createContractMarkupUrl(where: $where) {
			url
		}
	}
`;
export type ContractEdit_CreateContractMarkupUrlMutationFn =
	Apollo.MutationFunction<
		ContractEdit_CreateContractMarkupUrlMutation,
		ContractEdit_CreateContractMarkupUrlMutationVariables
	>;

/**
 * __useContractEdit_CreateContractMarkupUrlMutation__
 *
 * To run a mutation, you first call `useContractEdit_CreateContractMarkupUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractEdit_CreateContractMarkupUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractEditCreateContractMarkupUrlMutation, { data, loading, error }] = useContractEdit_CreateContractMarkupUrlMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractEdit_CreateContractMarkupUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractEdit_CreateContractMarkupUrlMutation,
		ContractEdit_CreateContractMarkupUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractEdit_CreateContractMarkupUrlMutation,
		ContractEdit_CreateContractMarkupUrlMutationVariables
	>(ContractEdit_CreateContractMarkupUrlDocument, options);
}
export type ContractEdit_CreateContractMarkupUrlMutationHookResult = ReturnType<
	typeof useContractEdit_CreateContractMarkupUrlMutation
>;
export type ContractEdit_CreateContractMarkupUrlMutationResult =
	Apollo.MutationResult<ContractEdit_CreateContractMarkupUrlMutation>;
export type ContractEdit_CreateContractMarkupUrlMutationOptions =
	Apollo.BaseMutationOptions<
		ContractEdit_CreateContractMarkupUrlMutation,
		ContractEdit_CreateContractMarkupUrlMutationVariables
	>;
export const ContractEdit_ReportContractMarkupDocument = gql`
	mutation contractEdit_reportContractMarkup(
		$data: ReportInput!
		$where: ContractWhereUniqueInput!
	) {
		reportContractMarkup(where: $where, data: $data) {
			id
			title
			sentAt
			status
			eventDate
			dueDate
			contractSourceFile
		}
	}
`;
export type ContractEdit_ReportContractMarkupMutationFn =
	Apollo.MutationFunction<
		ContractEdit_ReportContractMarkupMutation,
		ContractEdit_ReportContractMarkupMutationVariables
	>;

/**
 * __useContractEdit_ReportContractMarkupMutation__
 *
 * To run a mutation, you first call `useContractEdit_ReportContractMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractEdit_ReportContractMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractEditReportContractMarkupMutation, { data, loading, error }] = useContractEdit_ReportContractMarkupMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractEdit_ReportContractMarkupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractEdit_ReportContractMarkupMutation,
		ContractEdit_ReportContractMarkupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractEdit_ReportContractMarkupMutation,
		ContractEdit_ReportContractMarkupMutationVariables
	>(ContractEdit_ReportContractMarkupDocument, options);
}
export type ContractEdit_ReportContractMarkupMutationHookResult = ReturnType<
	typeof useContractEdit_ReportContractMarkupMutation
>;
export type ContractEdit_ReportContractMarkupMutationResult =
	Apollo.MutationResult<ContractEdit_ReportContractMarkupMutation>;
export type ContractEdit_ReportContractMarkupMutationOptions =
	Apollo.BaseMutationOptions<
		ContractEdit_ReportContractMarkupMutation,
		ContractEdit_ReportContractMarkupMutationVariables
	>;
export const ContractEdit_GetInvoicesForOrganizationDocument = gql`
	query contractEdit_getInvoicesForOrganization($where: InvoiceWhereInput) {
		getInvoicesForOrganization(where: $where) {
			_count
		}
	}
`;

/**
 * __useContractEdit_GetInvoicesForOrganizationQuery__
 *
 * To run a query within a React component, call `useContractEdit_GetInvoicesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractEdit_GetInvoicesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractEdit_GetInvoicesForOrganizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractEdit_GetInvoicesForOrganizationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ContractEdit_GetInvoicesForOrganizationQuery,
		ContractEdit_GetInvoicesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractEdit_GetInvoicesForOrganizationQuery,
		ContractEdit_GetInvoicesForOrganizationQueryVariables
	>(ContractEdit_GetInvoicesForOrganizationDocument, options);
}
export function useContractEdit_GetInvoicesForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractEdit_GetInvoicesForOrganizationQuery,
		ContractEdit_GetInvoicesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractEdit_GetInvoicesForOrganizationQuery,
		ContractEdit_GetInvoicesForOrganizationQueryVariables
	>(ContractEdit_GetInvoicesForOrganizationDocument, options);
}
export type ContractEdit_GetInvoicesForOrganizationQueryHookResult = ReturnType<
	typeof useContractEdit_GetInvoicesForOrganizationQuery
>;
export type ContractEdit_GetInvoicesForOrganizationLazyQueryHookResult =
	ReturnType<typeof useContractEdit_GetInvoicesForOrganizationLazyQuery>;
export type ContractEdit_GetInvoicesForOrganizationQueryResult =
	Apollo.QueryResult<
		ContractEdit_GetInvoicesForOrganizationQuery,
		ContractEdit_GetInvoicesForOrganizationQueryVariables
	>;
export const ContractEdit_GetFeatureFlagsDocument = gql`
	query ContractEdit_getFeatureFlags {
		getFeatureFlags {
			category
			active
		}
	}
`;

/**
 * __useContractEdit_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useContractEdit_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractEdit_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractEdit_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractEdit_GetFeatureFlagsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ContractEdit_GetFeatureFlagsQuery,
		ContractEdit_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractEdit_GetFeatureFlagsQuery,
		ContractEdit_GetFeatureFlagsQueryVariables
	>(ContractEdit_GetFeatureFlagsDocument, options);
}
export function useContractEdit_GetFeatureFlagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractEdit_GetFeatureFlagsQuery,
		ContractEdit_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractEdit_GetFeatureFlagsQuery,
		ContractEdit_GetFeatureFlagsQueryVariables
	>(ContractEdit_GetFeatureFlagsDocument, options);
}
export type ContractEdit_GetFeatureFlagsQueryHookResult = ReturnType<
	typeof useContractEdit_GetFeatureFlagsQuery
>;
export type ContractEdit_GetFeatureFlagsLazyQueryHookResult = ReturnType<
	typeof useContractEdit_GetFeatureFlagsLazyQuery
>;
export type ContractEdit_GetFeatureFlagsQueryResult = Apollo.QueryResult<
	ContractEdit_GetFeatureFlagsQuery,
	ContractEdit_GetFeatureFlagsQueryVariables
>;
export const ContractEdit_RequestContractFileImageUploadUrlDocument = gql`
	query ContractEdit_requestContractFileImageUploadUrl(
		$data: RequestImageUploadUrlInput!
		$where: ContractWhereUniqueInput!
	) {
		requestContractFileImageUploadUrl(where: $where, data: $data) {
			uploadURL
		}
	}
`;

/**
 * __useContractEdit_RequestContractFileImageUploadUrlQuery__
 *
 * To run a query within a React component, call `useContractEdit_RequestContractFileImageUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractEdit_RequestContractFileImageUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractEdit_RequestContractFileImageUploadUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractEdit_RequestContractFileImageUploadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractEdit_RequestContractFileImageUploadUrlQuery,
		ContractEdit_RequestContractFileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractEdit_RequestContractFileImageUploadUrlQuery,
		ContractEdit_RequestContractFileImageUploadUrlQueryVariables
	>(ContractEdit_RequestContractFileImageUploadUrlDocument, options);
}
export function useContractEdit_RequestContractFileImageUploadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractEdit_RequestContractFileImageUploadUrlQuery,
		ContractEdit_RequestContractFileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractEdit_RequestContractFileImageUploadUrlQuery,
		ContractEdit_RequestContractFileImageUploadUrlQueryVariables
	>(ContractEdit_RequestContractFileImageUploadUrlDocument, options);
}
export type ContractEdit_RequestContractFileImageUploadUrlQueryHookResult =
	ReturnType<typeof useContractEdit_RequestContractFileImageUploadUrlQuery>;
export type ContractEdit_RequestContractFileImageUploadUrlLazyQueryHookResult =
	ReturnType<typeof useContractEdit_RequestContractFileImageUploadUrlLazyQuery>;
export type ContractEdit_RequestContractFileImageUploadUrlQueryResult =
	Apollo.QueryResult<
		ContractEdit_RequestContractFileImageUploadUrlQuery,
		ContractEdit_RequestContractFileImageUploadUrlQueryVariables
	>;
export const UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateDocument = gql`
	mutation useContractTemplateEditButtonBarDeleteButton_deleteContractTemplate(
		$where: ContractTemplateWhereUniqueInput!
	) {
		deleteContractTemplate(where: $where) {
			...useContractTemplateEditButtonBarDeleteButtonContractTemplate
		}
	}
	${UseContractTemplateEditButtonBarDeleteButtonContractTemplateFragmentDoc}
`;
export type UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationFn =
	Apollo.MutationFunction<
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation,
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationVariables
	>;

/**
 * __useUseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation__
 *
 * To run a mutation, you first call `useUseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractTemplateEditButtonBarDeleteButtonDeleteContractTemplateMutation, { data, loading, error }] = useUseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation,
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation,
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationVariables
	>(
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateDocument,
		options
	);
}
export type UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationHookResult =
	ReturnType<
		typeof useUseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation
	>;
export type UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationResult =
	Apollo.MutationResult<UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation>;
export type UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutation,
		UseContractTemplateEditButtonBarDeleteButton_DeleteContractTemplateMutationVariables
	>;
export const ContractTemplateEdit_GetOrganizationContractTemplateDocument = gql`
	query contractTemplateEdit_getOrganizationContractTemplate(
		$where: ContractTemplateWhereUniqueInput!
	) {
		getOrganizationContractTemplate(where: $where) {
			...contractTemplateEdit
			...contractTemplateEditPresentationContractTemplate
			...embeddedFileContractTemplate
		}
	}
	${ContractTemplateEditFragmentDoc}
	${ContractTemplateEditPresentationContractTemplateFragmentDoc}
	${EmbeddedFileContractTemplateFragmentDoc}
`;

/**
 * __useContractTemplateEdit_GetOrganizationContractTemplateQuery__
 *
 * To run a query within a React component, call `useContractTemplateEdit_GetOrganizationContractTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEdit_GetOrganizationContractTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateEdit_GetOrganizationContractTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractTemplateEdit_GetOrganizationContractTemplateQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractTemplateEdit_GetOrganizationContractTemplateQuery,
		ContractTemplateEdit_GetOrganizationContractTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractTemplateEdit_GetOrganizationContractTemplateQuery,
		ContractTemplateEdit_GetOrganizationContractTemplateQueryVariables
	>(ContractTemplateEdit_GetOrganizationContractTemplateDocument, options);
}
export function useContractTemplateEdit_GetOrganizationContractTemplateLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractTemplateEdit_GetOrganizationContractTemplateQuery,
		ContractTemplateEdit_GetOrganizationContractTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractTemplateEdit_GetOrganizationContractTemplateQuery,
		ContractTemplateEdit_GetOrganizationContractTemplateQueryVariables
	>(ContractTemplateEdit_GetOrganizationContractTemplateDocument, options);
}
export type ContractTemplateEdit_GetOrganizationContractTemplateQueryHookResult =
	ReturnType<
		typeof useContractTemplateEdit_GetOrganizationContractTemplateQuery
	>;
export type ContractTemplateEdit_GetOrganizationContractTemplateLazyQueryHookResult =
	ReturnType<
		typeof useContractTemplateEdit_GetOrganizationContractTemplateLazyQuery
	>;
export type ContractTemplateEdit_GetOrganizationContractTemplateQueryResult =
	Apollo.QueryResult<
		ContractTemplateEdit_GetOrganizationContractTemplateQuery,
		ContractTemplateEdit_GetOrganizationContractTemplateQueryVariables
	>;
export const ContractTemplateEdit_CreateContractTemplateMutationDocument = gql`
	mutation ContractTemplateEdit_createContractTemplateMutation(
		$data: ContractTemplateCreateInput!
	) {
		createContractTemplate(data: $data) {
			...contractTemplateEdit
		}
	}
	${ContractTemplateEditFragmentDoc}
`;
export type ContractTemplateEdit_CreateContractTemplateMutationMutationFn =
	Apollo.MutationFunction<
		ContractTemplateEdit_CreateContractTemplateMutationMutation,
		ContractTemplateEdit_CreateContractTemplateMutationMutationVariables
	>;

/**
 * __useContractTemplateEdit_CreateContractTemplateMutationMutation__
 *
 * To run a mutation, you first call `useContractTemplateEdit_CreateContractTemplateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEdit_CreateContractTemplateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractTemplateEditCreateContractTemplateMutationMutation, { data, loading, error }] = useContractTemplateEdit_CreateContractTemplateMutationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useContractTemplateEdit_CreateContractTemplateMutationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractTemplateEdit_CreateContractTemplateMutationMutation,
		ContractTemplateEdit_CreateContractTemplateMutationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractTemplateEdit_CreateContractTemplateMutationMutation,
		ContractTemplateEdit_CreateContractTemplateMutationMutationVariables
	>(ContractTemplateEdit_CreateContractTemplateMutationDocument, options);
}
export type ContractTemplateEdit_CreateContractTemplateMutationMutationHookResult =
	ReturnType<
		typeof useContractTemplateEdit_CreateContractTemplateMutationMutation
	>;
export type ContractTemplateEdit_CreateContractTemplateMutationMutationResult =
	Apollo.MutationResult<ContractTemplateEdit_CreateContractTemplateMutationMutation>;
export type ContractTemplateEdit_CreateContractTemplateMutationMutationOptions =
	Apollo.BaseMutationOptions<
		ContractTemplateEdit_CreateContractTemplateMutationMutation,
		ContractTemplateEdit_CreateContractTemplateMutationMutationVariables
	>;
export const ContractTemplateEdit_CreateContractTemplateMarkupUrlDocument = gql`
	mutation ContractTemplateEdit_createContractTemplateMarkupUrl(
		$data: CreateContractTemplateMarkupUrlInput!
		$where: ContractTemplateWhereUniqueInput!
	) {
		createContractTemplateMarkupUrl(data: $data, where: $where)
	}
`;
export type ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationFn =
	Apollo.MutationFunction<
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutation,
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationVariables
	>;

/**
 * __useContractTemplateEdit_CreateContractTemplateMarkupUrlMutation__
 *
 * To run a mutation, you first call `useContractTemplateEdit_CreateContractTemplateMarkupUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEdit_CreateContractTemplateMarkupUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractTemplateEditCreateContractTemplateMarkupUrlMutation, { data, loading, error }] = useContractTemplateEdit_CreateContractTemplateMarkupUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractTemplateEdit_CreateContractTemplateMarkupUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutation,
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutation,
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationVariables
	>(ContractTemplateEdit_CreateContractTemplateMarkupUrlDocument, options);
}
export type ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationHookResult =
	ReturnType<
		typeof useContractTemplateEdit_CreateContractTemplateMarkupUrlMutation
	>;
export type ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationResult =
	Apollo.MutationResult<ContractTemplateEdit_CreateContractTemplateMarkupUrlMutation>;
export type ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationOptions =
	Apollo.BaseMutationOptions<
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutation,
		ContractTemplateEdit_CreateContractTemplateMarkupUrlMutationVariables
	>;
export const ContractTemplateEdit_ReportTemplateMarkupDocument = gql`
	mutation ContractTemplateEdit_reportTemplateMarkup(
		$where: ContractTemplateWhereUniqueInput!
	) {
		reportTemplateMarkup(where: $where) {
			...contractTemplateEdit
		}
	}
	${ContractTemplateEditFragmentDoc}
`;
export type ContractTemplateEdit_ReportTemplateMarkupMutationFn =
	Apollo.MutationFunction<
		ContractTemplateEdit_ReportTemplateMarkupMutation,
		ContractTemplateEdit_ReportTemplateMarkupMutationVariables
	>;

/**
 * __useContractTemplateEdit_ReportTemplateMarkupMutation__
 *
 * To run a mutation, you first call `useContractTemplateEdit_ReportTemplateMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEdit_ReportTemplateMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractTemplateEditReportTemplateMarkupMutation, { data, loading, error }] = useContractTemplateEdit_ReportTemplateMarkupMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractTemplateEdit_ReportTemplateMarkupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractTemplateEdit_ReportTemplateMarkupMutation,
		ContractTemplateEdit_ReportTemplateMarkupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractTemplateEdit_ReportTemplateMarkupMutation,
		ContractTemplateEdit_ReportTemplateMarkupMutationVariables
	>(ContractTemplateEdit_ReportTemplateMarkupDocument, options);
}
export type ContractTemplateEdit_ReportTemplateMarkupMutationHookResult =
	ReturnType<typeof useContractTemplateEdit_ReportTemplateMarkupMutation>;
export type ContractTemplateEdit_ReportTemplateMarkupMutationResult =
	Apollo.MutationResult<ContractTemplateEdit_ReportTemplateMarkupMutation>;
export type ContractTemplateEdit_ReportTemplateMarkupMutationOptions =
	Apollo.BaseMutationOptions<
		ContractTemplateEdit_ReportTemplateMarkupMutation,
		ContractTemplateEdit_ReportTemplateMarkupMutationVariables
	>;
export const ContractTemplateEdit_UpdateContractTemplateDocument = gql`
	mutation contractTemplateEdit_updateContractTemplate(
		$data: ContractTemplateCustomUpdateInput!
		$where: ContractTemplateWhereUniqueInput!
	) {
		updateContractTemplate(data: $data, where: $where) {
			id
		}
	}
`;
export type ContractTemplateEdit_UpdateContractTemplateMutationFn =
	Apollo.MutationFunction<
		ContractTemplateEdit_UpdateContractTemplateMutation,
		ContractTemplateEdit_UpdateContractTemplateMutationVariables
	>;

/**
 * __useContractTemplateEdit_UpdateContractTemplateMutation__
 *
 * To run a mutation, you first call `useContractTemplateEdit_UpdateContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEdit_UpdateContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractTemplateEditUpdateContractTemplateMutation, { data, loading, error }] = useContractTemplateEdit_UpdateContractTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractTemplateEdit_UpdateContractTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractTemplateEdit_UpdateContractTemplateMutation,
		ContractTemplateEdit_UpdateContractTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractTemplateEdit_UpdateContractTemplateMutation,
		ContractTemplateEdit_UpdateContractTemplateMutationVariables
	>(ContractTemplateEdit_UpdateContractTemplateDocument, options);
}
export type ContractTemplateEdit_UpdateContractTemplateMutationHookResult =
	ReturnType<typeof useContractTemplateEdit_UpdateContractTemplateMutation>;
export type ContractTemplateEdit_UpdateContractTemplateMutationResult =
	Apollo.MutationResult<ContractTemplateEdit_UpdateContractTemplateMutation>;
export type ContractTemplateEdit_UpdateContractTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		ContractTemplateEdit_UpdateContractTemplateMutation,
		ContractTemplateEdit_UpdateContractTemplateMutationVariables
	>;
export const ContractTemplateEdit_GetFeatureFlagsDocument = gql`
	query ContractTemplateEdit_getFeatureFlags {
		getFeatureFlags {
			category
			active
		}
	}
`;

/**
 * __useContractTemplateEdit_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useContractTemplateEdit_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEdit_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateEdit_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractTemplateEdit_GetFeatureFlagsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ContractTemplateEdit_GetFeatureFlagsQuery,
		ContractTemplateEdit_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractTemplateEdit_GetFeatureFlagsQuery,
		ContractTemplateEdit_GetFeatureFlagsQueryVariables
	>(ContractTemplateEdit_GetFeatureFlagsDocument, options);
}
export function useContractTemplateEdit_GetFeatureFlagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractTemplateEdit_GetFeatureFlagsQuery,
		ContractTemplateEdit_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractTemplateEdit_GetFeatureFlagsQuery,
		ContractTemplateEdit_GetFeatureFlagsQueryVariables
	>(ContractTemplateEdit_GetFeatureFlagsDocument, options);
}
export type ContractTemplateEdit_GetFeatureFlagsQueryHookResult = ReturnType<
	typeof useContractTemplateEdit_GetFeatureFlagsQuery
>;
export type ContractTemplateEdit_GetFeatureFlagsLazyQueryHookResult =
	ReturnType<typeof useContractTemplateEdit_GetFeatureFlagsLazyQuery>;
export type ContractTemplateEdit_GetFeatureFlagsQueryResult =
	Apollo.QueryResult<
		ContractTemplateEdit_GetFeatureFlagsQuery,
		ContractTemplateEdit_GetFeatureFlagsQueryVariables
	>;
export const ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlDocument = gql`
	query ContractTemplateEdit_requestContractTemplateFileImageUploadUrl(
		$data: RequestImageUploadUrlInput!
		$where: ContractTemplateWhereUniqueInput!
	) {
		requestContractTemplateFileImageUploadUrl(where: $where, data: $data) {
			uploadURL
		}
	}
`;

/**
 * __useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery__
 *
 * To run a query within a React component, call `useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery,
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery,
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryVariables
	>(
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlDocument,
		options
	);
}
export function useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery,
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery,
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryVariables
	>(
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlDocument,
		options
	);
}
export type ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryHookResult =
	ReturnType<
		typeof useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery
	>;
export type ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlLazyQueryHookResult =
	ReturnType<
		typeof useContractTemplateEdit_RequestContractTemplateFileImageUploadUrlLazyQuery
	>;
export type ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryResult =
	Apollo.QueryResult<
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQuery,
		ContractTemplateEdit_RequestContractTemplateFileImageUploadUrlQueryVariables
	>;
export const ContractMfaGuestModal_CreateMfaTokenDocument = gql`
	mutation contractMfaGuestModal_createMfaToken($data: MfaTokenInput!) {
		createMfaToken(data: $data)
	}
`;
export type ContractMfaGuestModal_CreateMfaTokenMutationFn =
	Apollo.MutationFunction<
		ContractMfaGuestModal_CreateMfaTokenMutation,
		ContractMfaGuestModal_CreateMfaTokenMutationVariables
	>;

/**
 * __useContractMfaGuestModal_CreateMfaTokenMutation__
 *
 * To run a mutation, you first call `useContractMfaGuestModal_CreateMfaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractMfaGuestModal_CreateMfaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractMfaGuestModalCreateMfaTokenMutation, { data, loading, error }] = useContractMfaGuestModal_CreateMfaTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useContractMfaGuestModal_CreateMfaTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractMfaGuestModal_CreateMfaTokenMutation,
		ContractMfaGuestModal_CreateMfaTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ContractMfaGuestModal_CreateMfaTokenMutation,
		ContractMfaGuestModal_CreateMfaTokenMutationVariables
	>(ContractMfaGuestModal_CreateMfaTokenDocument, options);
}
export type ContractMfaGuestModal_CreateMfaTokenMutationHookResult = ReturnType<
	typeof useContractMfaGuestModal_CreateMfaTokenMutation
>;
export type ContractMfaGuestModal_CreateMfaTokenMutationResult =
	Apollo.MutationResult<ContractMfaGuestModal_CreateMfaTokenMutation>;
export type ContractMfaGuestModal_CreateMfaTokenMutationOptions =
	Apollo.BaseMutationOptions<
		ContractMfaGuestModal_CreateMfaTokenMutation,
		ContractMfaGuestModal_CreateMfaTokenMutationVariables
	>;
export const UseContractViewButtonBarApproveButton_ApproveContractDocument = gql`
	mutation useContractViewButtonBarApproveButton_approveContract(
		$where: ContractWhereUniqueInput!
	) {
		approveContract(where: $where) {
			id
			...contractViewButtonBarApproveButtonCustomContractHelper
		}
	}
	${ContractViewButtonBarApproveButtonCustomContractHelperFragmentDoc}
`;
export type UseContractViewButtonBarApproveButton_ApproveContractMutationFn =
	Apollo.MutationFunction<
		UseContractViewButtonBarApproveButton_ApproveContractMutation,
		UseContractViewButtonBarApproveButton_ApproveContractMutationVariables
	>;

/**
 * __useUseContractViewButtonBarApproveButton_ApproveContractMutation__
 *
 * To run a mutation, you first call `useUseContractViewButtonBarApproveButton_ApproveContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractViewButtonBarApproveButton_ApproveContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractViewButtonBarApproveButtonApproveContractMutation, { data, loading, error }] = useUseContractViewButtonBarApproveButton_ApproveContractMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractViewButtonBarApproveButton_ApproveContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractViewButtonBarApproveButton_ApproveContractMutation,
		UseContractViewButtonBarApproveButton_ApproveContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractViewButtonBarApproveButton_ApproveContractMutation,
		UseContractViewButtonBarApproveButton_ApproveContractMutationVariables
	>(UseContractViewButtonBarApproveButton_ApproveContractDocument, options);
}
export type UseContractViewButtonBarApproveButton_ApproveContractMutationHookResult =
	ReturnType<
		typeof useUseContractViewButtonBarApproveButton_ApproveContractMutation
	>;
export type UseContractViewButtonBarApproveButton_ApproveContractMutationResult =
	Apollo.MutationResult<UseContractViewButtonBarApproveButton_ApproveContractMutation>;
export type UseContractViewButtonBarApproveButton_ApproveContractMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractViewButtonBarApproveButton_ApproveContractMutation,
		UseContractViewButtonBarApproveButton_ApproveContractMutationVariables
	>;
export const ContractViewButtonBar_GetContractWhereDocument = gql`
	query ContractViewButtonBar_getContractWhere(
		$where: ContractWhereInputWithMFAToken!
	) {
		getContractWhere(where: $where) {
			contract {
				...contractViewButtonBarExportButtonContract
			}
		}
	}
	${ContractViewButtonBarExportButtonContractFragmentDoc}
`;

/**
 * __useContractViewButtonBar_GetContractWhereQuery__
 *
 * To run a query within a React component, call `useContractViewButtonBar_GetContractWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractViewButtonBar_GetContractWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractViewButtonBar_GetContractWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContractViewButtonBar_GetContractWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ContractViewButtonBar_GetContractWhereQuery,
		ContractViewButtonBar_GetContractWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ContractViewButtonBar_GetContractWhereQuery,
		ContractViewButtonBar_GetContractWhereQueryVariables
	>(ContractViewButtonBar_GetContractWhereDocument, options);
}
export function useContractViewButtonBar_GetContractWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractViewButtonBar_GetContractWhereQuery,
		ContractViewButtonBar_GetContractWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ContractViewButtonBar_GetContractWhereQuery,
		ContractViewButtonBar_GetContractWhereQueryVariables
	>(ContractViewButtonBar_GetContractWhereDocument, options);
}
export type ContractViewButtonBar_GetContractWhereQueryHookResult = ReturnType<
	typeof useContractViewButtonBar_GetContractWhereQuery
>;
export type ContractViewButtonBar_GetContractWhereLazyQueryHookResult =
	ReturnType<typeof useContractViewButtonBar_GetContractWhereLazyQuery>;
export type ContractViewButtonBar_GetContractWhereQueryResult =
	Apollo.QueryResult<
		ContractViewButtonBar_GetContractWhereQuery,
		ContractViewButtonBar_GetContractWhereQueryVariables
	>;
export const UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlDocument = gql`
	mutation useContractViewButtonBarViewAndSignButton_createContractSigningUrl(
		$where: CreateContractSigningUrlInput!
	) {
		createContractSigningUrl(where: $where) {
			url
		}
	}
`;
export type UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationFn =
	Apollo.MutationFunction<
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation,
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationVariables
	>;

/**
 * __useUseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation__
 *
 * To run a mutation, you first call `useUseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractViewButtonBarViewAndSignButtonCreateContractSigningUrlMutation, { data, loading, error }] = useUseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation,
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation,
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationVariables
	>(
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlDocument,
		options
	);
}
export type UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationHookResult =
	ReturnType<
		typeof useUseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation
	>;
export type UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationResult =
	Apollo.MutationResult<UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation>;
export type UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutation,
		UseContractViewButtonBarViewAndSignButton_CreateContractSigningUrlMutationVariables
	>;
export const UseContractViewButtonBarViewAndSignButton_ReportContractSigningDocument = gql`
	mutation useContractViewButtonBarViewAndSignButton_reportContractSigning(
		$data: ReportContractSigningInput!
		$where: ContractWhereInputWithMFAToken!
	) {
		reportContractSigning(data: $data, where: $where) {
			...contractViewButtonBarViewAndSignButtonContractCanSign
		}
	}
	${ContractViewButtonBarViewAndSignButtonContractCanSignFragmentDoc}
`;
export type UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationFn =
	Apollo.MutationFunction<
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation,
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationVariables
	>;

/**
 * __useUseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation__
 *
 * To run a mutation, you first call `useUseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractViewButtonBarViewAndSignButtonReportContractSigningMutation, { data, loading, error }] = useUseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation,
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation,
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationVariables
	>(
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningDocument,
		options
	);
}
export type UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationHookResult =
	ReturnType<
		typeof useUseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation
	>;
export type UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationResult =
	Apollo.MutationResult<UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation>;
export type UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutation,
		UseContractViewButtonBarViewAndSignButton_ReportContractSigningMutationVariables
	>;
export const UseContractMetrics_GetDashboardStatsForOrgDocument = gql`
	query useContractMetrics_getDashboardStatsForOrg(
		$where: DashboardWhereInput!
	) {
		getDashboardStatsForOrg(where: $where) {
			contractsSummary {
				totalContractsAwaitingSignature
				totalContractsSigned
				totalContractsOverdue
			}
		}
	}
`;

/**
 * __useUseContractMetrics_GetDashboardStatsForOrgQuery__
 *
 * To run a query within a React component, call `useUseContractMetrics_GetDashboardStatsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseContractMetrics_GetDashboardStatsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseContractMetrics_GetDashboardStatsForOrgQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractMetrics_GetDashboardStatsForOrgQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseContractMetrics_GetDashboardStatsForOrgQuery,
		UseContractMetrics_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseContractMetrics_GetDashboardStatsForOrgQuery,
		UseContractMetrics_GetDashboardStatsForOrgQueryVariables
	>(UseContractMetrics_GetDashboardStatsForOrgDocument, options);
}
export function useUseContractMetrics_GetDashboardStatsForOrgLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseContractMetrics_GetDashboardStatsForOrgQuery,
		UseContractMetrics_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseContractMetrics_GetDashboardStatsForOrgQuery,
		UseContractMetrics_GetDashboardStatsForOrgQueryVariables
	>(UseContractMetrics_GetDashboardStatsForOrgDocument, options);
}
export type UseContractMetrics_GetDashboardStatsForOrgQueryHookResult =
	ReturnType<typeof useUseContractMetrics_GetDashboardStatsForOrgQuery>;
export type UseContractMetrics_GetDashboardStatsForOrgLazyQueryHookResult =
	ReturnType<typeof useUseContractMetrics_GetDashboardStatsForOrgLazyQuery>;
export type UseContractMetrics_GetDashboardStatsForOrgQueryResult =
	Apollo.QueryResult<
		UseContractMetrics_GetDashboardStatsForOrgQuery,
		UseContractMetrics_GetDashboardStatsForOrgQueryVariables
	>;
export const UseContractsTable_GetContractsForVendorDocument = gql`
	query useContractsTable_getContractsForVendor(
		$where: ContractsForVendorInput!
		$orderBy: [ContractOrderByInput]
		$skip: Int
		$take: Int
	) {
		getContractsForVendor(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			contracts {
				...contractsTable
			}
		}
	}
	${ContractsTableFragmentDoc}
`;

/**
 * __useUseContractsTable_GetContractsForVendorQuery__
 *
 * To run a query within a React component, call `useUseContractsTable_GetContractsForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseContractsTable_GetContractsForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseContractsTable_GetContractsForVendorQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useUseContractsTable_GetContractsForVendorQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseContractsTable_GetContractsForVendorQuery,
		UseContractsTable_GetContractsForVendorQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseContractsTable_GetContractsForVendorQuery,
		UseContractsTable_GetContractsForVendorQueryVariables
	>(UseContractsTable_GetContractsForVendorDocument, options);
}
export function useUseContractsTable_GetContractsForVendorLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseContractsTable_GetContractsForVendorQuery,
		UseContractsTable_GetContractsForVendorQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseContractsTable_GetContractsForVendorQuery,
		UseContractsTable_GetContractsForVendorQueryVariables
	>(UseContractsTable_GetContractsForVendorDocument, options);
}
export type UseContractsTable_GetContractsForVendorQueryHookResult = ReturnType<
	typeof useUseContractsTable_GetContractsForVendorQuery
>;
export type UseContractsTable_GetContractsForVendorLazyQueryHookResult =
	ReturnType<typeof useUseContractsTable_GetContractsForVendorLazyQuery>;
export type UseContractsTable_GetContractsForVendorQueryResult =
	Apollo.QueryResult<
		UseContractsTable_GetContractsForVendorQuery,
		UseContractsTable_GetContractsForVendorQueryVariables
	>;
export const UseContractsTable_GetContractsForCustomerDocument = gql`
	query useContractsTable_getContractsForCustomer(
		$where: ContractsForCustomerInput!
		$orderBy: [ContractOrderByInput]
		$skip: Int
		$take: Int
	) {
		getContractsForCustomer(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			contracts {
				...contractsTable
			}
		}
	}
	${ContractsTableFragmentDoc}
`;

/**
 * __useUseContractsTable_GetContractsForCustomerQuery__
 *
 * To run a query within a React component, call `useUseContractsTable_GetContractsForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseContractsTable_GetContractsForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseContractsTable_GetContractsForCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useUseContractsTable_GetContractsForCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseContractsTable_GetContractsForCustomerQuery,
		UseContractsTable_GetContractsForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseContractsTable_GetContractsForCustomerQuery,
		UseContractsTable_GetContractsForCustomerQueryVariables
	>(UseContractsTable_GetContractsForCustomerDocument, options);
}
export function useUseContractsTable_GetContractsForCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseContractsTable_GetContractsForCustomerQuery,
		UseContractsTable_GetContractsForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseContractsTable_GetContractsForCustomerQuery,
		UseContractsTable_GetContractsForCustomerQueryVariables
	>(UseContractsTable_GetContractsForCustomerDocument, options);
}
export type UseContractsTable_GetContractsForCustomerQueryHookResult =
	ReturnType<typeof useUseContractsTable_GetContractsForCustomerQuery>;
export type UseContractsTable_GetContractsForCustomerLazyQueryHookResult =
	ReturnType<typeof useUseContractsTable_GetContractsForCustomerLazyQuery>;
export type UseContractsTable_GetContractsForCustomerQueryResult =
	Apollo.QueryResult<
		UseContractsTable_GetContractsForCustomerQuery,
		UseContractsTable_GetContractsForCustomerQueryVariables
	>;
export const UseContractsTable_ResendContractDocument = gql`
	mutation useContractsTable_resendContract($where: ContractWhereUniqueInput!) {
		resendContract(where: $where)
	}
`;
export type UseContractsTable_ResendContractMutationFn =
	Apollo.MutationFunction<
		UseContractsTable_ResendContractMutation,
		UseContractsTable_ResendContractMutationVariables
	>;

/**
 * __useUseContractsTable_ResendContractMutation__
 *
 * To run a mutation, you first call `useUseContractsTable_ResendContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractsTable_ResendContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractsTableResendContractMutation, { data, loading, error }] = useUseContractsTable_ResendContractMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractsTable_ResendContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractsTable_ResendContractMutation,
		UseContractsTable_ResendContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractsTable_ResendContractMutation,
		UseContractsTable_ResendContractMutationVariables
	>(UseContractsTable_ResendContractDocument, options);
}
export type UseContractsTable_ResendContractMutationHookResult = ReturnType<
	typeof useUseContractsTable_ResendContractMutation
>;
export type UseContractsTable_ResendContractMutationResult =
	Apollo.MutationResult<UseContractsTable_ResendContractMutation>;
export type UseContractsTable_ResendContractMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractsTable_ResendContractMutation,
		UseContractsTable_ResendContractMutationVariables
	>;
export const UseContractsTable_GetOrganizationContractTemplatesDocument = gql`
	query useContractsTable_getOrganizationContractTemplates(
		$skip: Int
		$take: Int
		$where: CustomContractTemplateWhereWithoutOrganizationInput
		$orderBy: [ContractTemplateOrderByInput]
	) {
		getOrganizationContractTemplates(
			skip: $skip
			take: $take
			where: $where
			orderBy: $orderBy
		) {
			_count
			contractTemplates {
				...contractTemplatesTable
			}
		}
	}
	${ContractTemplatesTableFragmentDoc}
`;

/**
 * __useUseContractsTable_GetOrganizationContractTemplatesQuery__
 *
 * To run a query within a React component, call `useUseContractsTable_GetOrganizationContractTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseContractsTable_GetOrganizationContractTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseContractsTable_GetOrganizationContractTemplatesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUseContractsTable_GetOrganizationContractTemplatesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UseContractsTable_GetOrganizationContractTemplatesQuery,
		UseContractsTable_GetOrganizationContractTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseContractsTable_GetOrganizationContractTemplatesQuery,
		UseContractsTable_GetOrganizationContractTemplatesQueryVariables
	>(UseContractsTable_GetOrganizationContractTemplatesDocument, options);
}
export function useUseContractsTable_GetOrganizationContractTemplatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseContractsTable_GetOrganizationContractTemplatesQuery,
		UseContractsTable_GetOrganizationContractTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseContractsTable_GetOrganizationContractTemplatesQuery,
		UseContractsTable_GetOrganizationContractTemplatesQueryVariables
	>(UseContractsTable_GetOrganizationContractTemplatesDocument, options);
}
export type UseContractsTable_GetOrganizationContractTemplatesQueryHookResult =
	ReturnType<typeof useUseContractsTable_GetOrganizationContractTemplatesQuery>;
export type UseContractsTable_GetOrganizationContractTemplatesLazyQueryHookResult =
	ReturnType<
		typeof useUseContractsTable_GetOrganizationContractTemplatesLazyQuery
	>;
export type UseContractsTable_GetOrganizationContractTemplatesQueryResult =
	Apollo.QueryResult<
		UseContractsTable_GetOrganizationContractTemplatesQuery,
		UseContractsTable_GetOrganizationContractTemplatesQueryVariables
	>;
export const UseContractsTable_DeleteContractTemplateDocument = gql`
	mutation useContractsTable_deleteContractTemplate(
		$where: ContractTemplateWhereUniqueInput!
	) {
		deleteContractTemplate(where: $where) {
			id
		}
	}
`;
export type UseContractsTable_DeleteContractTemplateMutationFn =
	Apollo.MutationFunction<
		UseContractsTable_DeleteContractTemplateMutation,
		UseContractsTable_DeleteContractTemplateMutationVariables
	>;

/**
 * __useUseContractsTable_DeleteContractTemplateMutation__
 *
 * To run a mutation, you first call `useUseContractsTable_DeleteContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractsTable_DeleteContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractsTableDeleteContractTemplateMutation, { data, loading, error }] = useUseContractsTable_DeleteContractTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractsTable_DeleteContractTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractsTable_DeleteContractTemplateMutation,
		UseContractsTable_DeleteContractTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractsTable_DeleteContractTemplateMutation,
		UseContractsTable_DeleteContractTemplateMutationVariables
	>(UseContractsTable_DeleteContractTemplateDocument, options);
}
export type UseContractsTable_DeleteContractTemplateMutationHookResult =
	ReturnType<typeof useUseContractsTable_DeleteContractTemplateMutation>;
export type UseContractsTable_DeleteContractTemplateMutationResult =
	Apollo.MutationResult<UseContractsTable_DeleteContractTemplateMutation>;
export type UseContractsTable_DeleteContractTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractsTable_DeleteContractTemplateMutation,
		UseContractsTable_DeleteContractTemplateMutationVariables
	>;
export const UseContractsTable_DuplicateContractTemplateDocument = gql`
	mutation useContractsTable_duplicateContractTemplate(
		$where: ContractTemplateWhereUniqueInput!
	) {
		duplicateContractTemplate(where: $where) {
			id
		}
	}
`;
export type UseContractsTable_DuplicateContractTemplateMutationFn =
	Apollo.MutationFunction<
		UseContractsTable_DuplicateContractTemplateMutation,
		UseContractsTable_DuplicateContractTemplateMutationVariables
	>;

/**
 * __useUseContractsTable_DuplicateContractTemplateMutation__
 *
 * To run a mutation, you first call `useUseContractsTable_DuplicateContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractsTable_DuplicateContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractsTableDuplicateContractTemplateMutation, { data, loading, error }] = useUseContractsTable_DuplicateContractTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContractsTable_DuplicateContractTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractsTable_DuplicateContractTemplateMutation,
		UseContractsTable_DuplicateContractTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractsTable_DuplicateContractTemplateMutation,
		UseContractsTable_DuplicateContractTemplateMutationVariables
	>(UseContractsTable_DuplicateContractTemplateDocument, options);
}
export type UseContractsTable_DuplicateContractTemplateMutationHookResult =
	ReturnType<typeof useUseContractsTable_DuplicateContractTemplateMutation>;
export type UseContractsTable_DuplicateContractTemplateMutationResult =
	Apollo.MutationResult<UseContractsTable_DuplicateContractTemplateMutation>;
export type UseContractsTable_DuplicateContractTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractsTable_DuplicateContractTemplateMutation,
		UseContractsTable_DuplicateContractTemplateMutationVariables
	>;
export const CreateBundleModal_CreateContactAsVendorDocument = gql`
	mutation CreateBundleModal_createContactAsVendor(
		$data: CreateContactDataInput!
		$where: UserByEmailUniqueInput!
	) {
		createContactAsVendor(data: $data, where: $where) {
			...createBundleModalContact
		}
	}
	${CreateBundleModalContactFragmentDoc}
`;
export type CreateBundleModal_CreateContactAsVendorMutationFn =
	Apollo.MutationFunction<
		CreateBundleModal_CreateContactAsVendorMutation,
		CreateBundleModal_CreateContactAsVendorMutationVariables
	>;

/**
 * __useCreateBundleModal_CreateContactAsVendorMutation__
 *
 * To run a mutation, you first call `useCreateBundleModal_CreateContactAsVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBundleModal_CreateContactAsVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBundleModalCreateContactAsVendorMutation, { data, loading, error }] = useCreateBundleModal_CreateContactAsVendorMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCreateBundleModal_CreateContactAsVendorMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateBundleModal_CreateContactAsVendorMutation,
		CreateBundleModal_CreateContactAsVendorMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateBundleModal_CreateContactAsVendorMutation,
		CreateBundleModal_CreateContactAsVendorMutationVariables
	>(CreateBundleModal_CreateContactAsVendorDocument, options);
}
export type CreateBundleModal_CreateContactAsVendorMutationHookResult =
	ReturnType<typeof useCreateBundleModal_CreateContactAsVendorMutation>;
export type CreateBundleModal_CreateContactAsVendorMutationResult =
	Apollo.MutationResult<CreateBundleModal_CreateContactAsVendorMutation>;
export type CreateBundleModal_CreateContactAsVendorMutationOptions =
	Apollo.BaseMutationOptions<
		CreateBundleModal_CreateContactAsVendorMutation,
		CreateBundleModal_CreateContactAsVendorMutationVariables
	>;
export const CreateBundleModal_UpdateContactDocument = gql`
	mutation CreateBundleModal_updateContact(
		$where: ContactWhereUniqueInput!
		$data: CustomContactUpdateInput!
	) {
		updateContact(where: $where, data: $data) {
			...createBundleModalContact
		}
	}
	${CreateBundleModalContactFragmentDoc}
`;
export type CreateBundleModal_UpdateContactMutationFn = Apollo.MutationFunction<
	CreateBundleModal_UpdateContactMutation,
	CreateBundleModal_UpdateContactMutationVariables
>;

/**
 * __useCreateBundleModal_UpdateContactMutation__
 *
 * To run a mutation, you first call `useCreateBundleModal_UpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBundleModal_UpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBundleModalUpdateContactMutation, { data, loading, error }] = useCreateBundleModal_UpdateContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBundleModal_UpdateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateBundleModal_UpdateContactMutation,
		CreateBundleModal_UpdateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateBundleModal_UpdateContactMutation,
		CreateBundleModal_UpdateContactMutationVariables
	>(CreateBundleModal_UpdateContactDocument, options);
}
export type CreateBundleModal_UpdateContactMutationHookResult = ReturnType<
	typeof useCreateBundleModal_UpdateContactMutation
>;
export type CreateBundleModal_UpdateContactMutationResult =
	Apollo.MutationResult<CreateBundleModal_UpdateContactMutation>;
export type CreateBundleModal_UpdateContactMutationOptions =
	Apollo.BaseMutationOptions<
		CreateBundleModal_UpdateContactMutation,
		CreateBundleModal_UpdateContactMutationVariables
	>;
export const CreateFolderModal_CreateFolderDocument = gql`
	mutation CreateFolderModal_createFolder($data: FolderCreateCustomInput!) {
		createFolder(data: $data) {
			...createFolderModalCustomFolder
		}
	}
	${CreateFolderModalCustomFolderFragmentDoc}
`;
export type CreateFolderModal_CreateFolderMutationFn = Apollo.MutationFunction<
	CreateFolderModal_CreateFolderMutation,
	CreateFolderModal_CreateFolderMutationVariables
>;

/**
 * __useCreateFolderModal_CreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderModal_CreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderModal_CreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderModalCreateFolderMutation, { data, loading, error }] = useCreateFolderModal_CreateFolderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFolderModal_CreateFolderMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateFolderModal_CreateFolderMutation,
		CreateFolderModal_CreateFolderMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateFolderModal_CreateFolderMutation,
		CreateFolderModal_CreateFolderMutationVariables
	>(CreateFolderModal_CreateFolderDocument, options);
}
export type CreateFolderModal_CreateFolderMutationHookResult = ReturnType<
	typeof useCreateFolderModal_CreateFolderMutation
>;
export type CreateFolderModal_CreateFolderMutationResult =
	Apollo.MutationResult<CreateFolderModal_CreateFolderMutation>;
export type CreateFolderModal_CreateFolderMutationOptions =
	Apollo.BaseMutationOptions<
		CreateFolderModal_CreateFolderMutation,
		CreateFolderModal_CreateFolderMutationVariables
	>;
export const CustomerFolderDocumentsTable_GetContactWhereDocument = gql`
	query CustomerFolderDocumentsTable_getContactWhere(
		$where: ContactWhereInput!
	) {
		getContactWhere(where: $where) {
			...shareWidgetContact
		}
	}
	${ShareWidgetContactFragmentDoc}
`;

/**
 * __useCustomerFolderDocumentsTable_GetContactWhereQuery__
 *
 * To run a query within a React component, call `useCustomerFolderDocumentsTable_GetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFolderDocumentsTable_GetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFolderDocumentsTable_GetContactWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCustomerFolderDocumentsTable_GetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		CustomerFolderDocumentsTable_GetContactWhereQuery,
		CustomerFolderDocumentsTable_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CustomerFolderDocumentsTable_GetContactWhereQuery,
		CustomerFolderDocumentsTable_GetContactWhereQueryVariables
	>(CustomerFolderDocumentsTable_GetContactWhereDocument, options);
}
export function useCustomerFolderDocumentsTable_GetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CustomerFolderDocumentsTable_GetContactWhereQuery,
		CustomerFolderDocumentsTable_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CustomerFolderDocumentsTable_GetContactWhereQuery,
		CustomerFolderDocumentsTable_GetContactWhereQueryVariables
	>(CustomerFolderDocumentsTable_GetContactWhereDocument, options);
}
export type CustomerFolderDocumentsTable_GetContactWhereQueryHookResult =
	ReturnType<typeof useCustomerFolderDocumentsTable_GetContactWhereQuery>;
export type CustomerFolderDocumentsTable_GetContactWhereLazyQueryHookResult =
	ReturnType<typeof useCustomerFolderDocumentsTable_GetContactWhereLazyQuery>;
export type CustomerFolderDocumentsTable_GetContactWhereQueryResult =
	Apollo.QueryResult<
		CustomerFolderDocumentsTable_GetContactWhereQuery,
		CustomerFolderDocumentsTable_GetContactWhereQueryVariables
	>;
export const UseCustomerFolderDocumentsTable_GetDocumentsWhereDocument = gql`
	query useCustomerFolderDocumentsTable_getDocumentsWhere(
		$orderBy: [DocumentOrderByInput]
		$skip: Int
		$take: Int
		$where: CustomDocumentWhereInput!
	) {
		getDocumentsWhere(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			documents {
				...useCustomerFolderDocumentsTable_document
			}
		}
	}
	${UseCustomerFolderDocumentsTable_DocumentFragmentDoc}
`;

/**
 * __useUseCustomerFolderDocumentsTable_GetDocumentsWhereQuery__
 *
 * To run a query within a React component, call `useUseCustomerFolderDocumentsTable_GetDocumentsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseCustomerFolderDocumentsTable_GetDocumentsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseCustomerFolderDocumentsTable_GetDocumentsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseCustomerFolderDocumentsTable_GetDocumentsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQuery,
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQuery,
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryVariables
	>(UseCustomerFolderDocumentsTable_GetDocumentsWhereDocument, options);
}
export function useUseCustomerFolderDocumentsTable_GetDocumentsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQuery,
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQuery,
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryVariables
	>(UseCustomerFolderDocumentsTable_GetDocumentsWhereDocument, options);
}
export type UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryHookResult =
	ReturnType<typeof useUseCustomerFolderDocumentsTable_GetDocumentsWhereQuery>;
export type UseCustomerFolderDocumentsTable_GetDocumentsWhereLazyQueryHookResult =
	ReturnType<
		typeof useUseCustomerFolderDocumentsTable_GetDocumentsWhereLazyQuery
	>;
export type UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryResult =
	Apollo.QueryResult<
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQuery,
		UseCustomerFolderDocumentsTable_GetDocumentsWhereQueryVariables
	>;
export const CustomerFolderDocumentsTable_DeleteDocumentDocument = gql`
	mutation CustomerFolderDocumentsTable_deleteDocument(
		$where: DocumentWhereUniqueInput!
	) {
		deleteDocument(where: $where)
	}
`;
export type CustomerFolderDocumentsTable_DeleteDocumentMutationFn =
	Apollo.MutationFunction<
		CustomerFolderDocumentsTable_DeleteDocumentMutation,
		CustomerFolderDocumentsTable_DeleteDocumentMutationVariables
	>;

/**
 * __useCustomerFolderDocumentsTable_DeleteDocumentMutation__
 *
 * To run a mutation, you first call `useCustomerFolderDocumentsTable_DeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerFolderDocumentsTable_DeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerFolderDocumentsTableDeleteDocumentMutation, { data, loading, error }] = useCustomerFolderDocumentsTable_DeleteDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCustomerFolderDocumentsTable_DeleteDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CustomerFolderDocumentsTable_DeleteDocumentMutation,
		CustomerFolderDocumentsTable_DeleteDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CustomerFolderDocumentsTable_DeleteDocumentMutation,
		CustomerFolderDocumentsTable_DeleteDocumentMutationVariables
	>(CustomerFolderDocumentsTable_DeleteDocumentDocument, options);
}
export type CustomerFolderDocumentsTable_DeleteDocumentMutationHookResult =
	ReturnType<typeof useCustomerFolderDocumentsTable_DeleteDocumentMutation>;
export type CustomerFolderDocumentsTable_DeleteDocumentMutationResult =
	Apollo.MutationResult<CustomerFolderDocumentsTable_DeleteDocumentMutation>;
export type CustomerFolderDocumentsTable_DeleteDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		CustomerFolderDocumentsTable_DeleteDocumentMutation,
		CustomerFolderDocumentsTable_DeleteDocumentMutationVariables
	>;
export const UseCustomerFolderDocumentsTable_GetContactDocument = gql`
	query useCustomerFolderDocumentsTable_getContact($where: ContactWhereInput!) {
		getContactWhere(where: $where) {
			id
			customer {
				id
				clientUser {
					id
					plannerOrgHasDocumentsPermissions
					assignedPlanner {
						id
						organization {
							id
						}
					}
				}
			}
		}
	}
`;

/**
 * __useUseCustomerFolderDocumentsTable_GetContactQuery__
 *
 * To run a query within a React component, call `useUseCustomerFolderDocumentsTable_GetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseCustomerFolderDocumentsTable_GetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseCustomerFolderDocumentsTable_GetContactQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseCustomerFolderDocumentsTable_GetContactQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseCustomerFolderDocumentsTable_GetContactQuery,
		UseCustomerFolderDocumentsTable_GetContactQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseCustomerFolderDocumentsTable_GetContactQuery,
		UseCustomerFolderDocumentsTable_GetContactQueryVariables
	>(UseCustomerFolderDocumentsTable_GetContactDocument, options);
}
export function useUseCustomerFolderDocumentsTable_GetContactLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseCustomerFolderDocumentsTable_GetContactQuery,
		UseCustomerFolderDocumentsTable_GetContactQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseCustomerFolderDocumentsTable_GetContactQuery,
		UseCustomerFolderDocumentsTable_GetContactQueryVariables
	>(UseCustomerFolderDocumentsTable_GetContactDocument, options);
}
export type UseCustomerFolderDocumentsTable_GetContactQueryHookResult =
	ReturnType<typeof useUseCustomerFolderDocumentsTable_GetContactQuery>;
export type UseCustomerFolderDocumentsTable_GetContactLazyQueryHookResult =
	ReturnType<typeof useUseCustomerFolderDocumentsTable_GetContactLazyQuery>;
export type UseCustomerFolderDocumentsTable_GetContactQueryResult =
	Apollo.QueryResult<
		UseCustomerFolderDocumentsTable_GetContactQuery,
		UseCustomerFolderDocumentsTable_GetContactQueryVariables
	>;
export const CustomerFoldersTable_GetContactsWhereDocument = gql`
	query CustomerFoldersTable_getContactsWhere(
		$orderBy: [ContactOrderByInput]
		$skip: Int
		$take: Int
		$where: ContactWhereInput!
	) {
		getContactsWhere(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			contacts {
				...useCustomerFoldersTableContact
			}
		}
	}
	${UseCustomerFoldersTableContactFragmentDoc}
`;

/**
 * __useCustomerFoldersTable_GetContactsWhereQuery__
 *
 * To run a query within a React component, call `useCustomerFoldersTable_GetContactsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFoldersTable_GetContactsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFoldersTable_GetContactsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCustomerFoldersTable_GetContactsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		CustomerFoldersTable_GetContactsWhereQuery,
		CustomerFoldersTable_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CustomerFoldersTable_GetContactsWhereQuery,
		CustomerFoldersTable_GetContactsWhereQueryVariables
	>(CustomerFoldersTable_GetContactsWhereDocument, options);
}
export function useCustomerFoldersTable_GetContactsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CustomerFoldersTable_GetContactsWhereQuery,
		CustomerFoldersTable_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CustomerFoldersTable_GetContactsWhereQuery,
		CustomerFoldersTable_GetContactsWhereQueryVariables
	>(CustomerFoldersTable_GetContactsWhereDocument, options);
}
export type CustomerFoldersTable_GetContactsWhereQueryHookResult = ReturnType<
	typeof useCustomerFoldersTable_GetContactsWhereQuery
>;
export type CustomerFoldersTable_GetContactsWhereLazyQueryHookResult =
	ReturnType<typeof useCustomerFoldersTable_GetContactsWhereLazyQuery>;
export type CustomerFoldersTable_GetContactsWhereQueryResult =
	Apollo.QueryResult<
		CustomerFoldersTable_GetContactsWhereQuery,
		CustomerFoldersTable_GetContactsWhereQueryVariables
	>;
export const DeleteFolderModal_GetFolderContentsDocument = gql`
	query DeleteFolderModal_getFolderContents(
		$where: FolderWhereUniqueInput!
		$take: Int
		$orderBy: FolderContentsOrderByInput
	) {
		getFolderContents(where: $where, take: $take, orderBy: $orderBy) {
			id
			childFolders {
				id
			}
			documents {
				id
			}
		}
	}
`;

/**
 * __useDeleteFolderModal_GetFolderContentsQuery__
 *
 * To run a query within a React component, call `useDeleteFolderModal_GetFolderContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderModal_GetFolderContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteFolderModal_GetFolderContentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDeleteFolderModal_GetFolderContentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		DeleteFolderModal_GetFolderContentsQuery,
		DeleteFolderModal_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DeleteFolderModal_GetFolderContentsQuery,
		DeleteFolderModal_GetFolderContentsQueryVariables
	>(DeleteFolderModal_GetFolderContentsDocument, options);
}
export function useDeleteFolderModal_GetFolderContentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DeleteFolderModal_GetFolderContentsQuery,
		DeleteFolderModal_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DeleteFolderModal_GetFolderContentsQuery,
		DeleteFolderModal_GetFolderContentsQueryVariables
	>(DeleteFolderModal_GetFolderContentsDocument, options);
}
export type DeleteFolderModal_GetFolderContentsQueryHookResult = ReturnType<
	typeof useDeleteFolderModal_GetFolderContentsQuery
>;
export type DeleteFolderModal_GetFolderContentsLazyQueryHookResult = ReturnType<
	typeof useDeleteFolderModal_GetFolderContentsLazyQuery
>;
export type DeleteFolderModal_GetFolderContentsQueryResult = Apollo.QueryResult<
	DeleteFolderModal_GetFolderContentsQuery,
	DeleteFolderModal_GetFolderContentsQueryVariables
>;
export const DocumentAccessTokenExpired_RefreshDocumentAccessTokenDocument = gql`
	mutation documentAccessTokenExpired_refreshDocumentAccessToken(
		$where: DocumentAccessTokenUniqueWhere!
	) {
		refreshDocumentAccessToken(where: $where)
	}
`;
export type DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationFn =
	Apollo.MutationFunction<
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation,
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationVariables
	>;

/**
 * __useDocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation__
 *
 * To run a mutation, you first call `useDocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentAccessTokenExpiredRefreshDocumentAccessTokenMutation, { data, loading, error }] = useDocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation,
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation,
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationVariables
	>(DocumentAccessTokenExpired_RefreshDocumentAccessTokenDocument, options);
}
export type DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationHookResult =
	ReturnType<
		typeof useDocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation
	>;
export type DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationResult =
	Apollo.MutationResult<DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation>;
export type DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationOptions =
	Apollo.BaseMutationOptions<
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutation,
		DocumentAccessTokenExpired_RefreshDocumentAccessTokenMutationVariables
	>;
export const DeleteDocumentButton_DeleteDocumentDocument = gql`
	mutation DeleteDocumentButton_deleteDocument(
		$where: DocumentWhereUniqueInput!
	) {
		deleteDocument(where: $where)
	}
`;
export type DeleteDocumentButton_DeleteDocumentMutationFn =
	Apollo.MutationFunction<
		DeleteDocumentButton_DeleteDocumentMutation,
		DeleteDocumentButton_DeleteDocumentMutationVariables
	>;

/**
 * __useDeleteDocumentButton_DeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentButton_DeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentButton_DeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentButtonDeleteDocumentMutation, { data, loading, error }] = useDeleteDocumentButton_DeleteDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteDocumentButton_DeleteDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteDocumentButton_DeleteDocumentMutation,
		DeleteDocumentButton_DeleteDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteDocumentButton_DeleteDocumentMutation,
		DeleteDocumentButton_DeleteDocumentMutationVariables
	>(DeleteDocumentButton_DeleteDocumentDocument, options);
}
export type DeleteDocumentButton_DeleteDocumentMutationHookResult = ReturnType<
	typeof useDeleteDocumentButton_DeleteDocumentMutation
>;
export type DeleteDocumentButton_DeleteDocumentMutationResult =
	Apollo.MutationResult<DeleteDocumentButton_DeleteDocumentMutation>;
export type DeleteDocumentButton_DeleteDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteDocumentButton_DeleteDocumentMutation,
		DeleteDocumentButton_DeleteDocumentMutationVariables
	>;
export const ExportDocumentButton_GetDocumentWhereDocument = gql`
	query ExportDocumentButton_getDocumentWhere(
		$where: DocumentWhereUniqueInput!
	) {
		getDocumentWhere(where: $where) {
			id
			downloadUrl
		}
	}
`;

/**
 * __useExportDocumentButton_GetDocumentWhereQuery__
 *
 * To run a query within a React component, call `useExportDocumentButton_GetDocumentWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDocumentButton_GetDocumentWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDocumentButton_GetDocumentWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportDocumentButton_GetDocumentWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ExportDocumentButton_GetDocumentWhereQuery,
		ExportDocumentButton_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ExportDocumentButton_GetDocumentWhereQuery,
		ExportDocumentButton_GetDocumentWhereQueryVariables
	>(ExportDocumentButton_GetDocumentWhereDocument, options);
}
export function useExportDocumentButton_GetDocumentWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportDocumentButton_GetDocumentWhereQuery,
		ExportDocumentButton_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ExportDocumentButton_GetDocumentWhereQuery,
		ExportDocumentButton_GetDocumentWhereQueryVariables
	>(ExportDocumentButton_GetDocumentWhereDocument, options);
}
export type ExportDocumentButton_GetDocumentWhereQueryHookResult = ReturnType<
	typeof useExportDocumentButton_GetDocumentWhereQuery
>;
export type ExportDocumentButton_GetDocumentWhereLazyQueryHookResult =
	ReturnType<typeof useExportDocumentButton_GetDocumentWhereLazyQuery>;
export type ExportDocumentButton_GetDocumentWhereQueryResult =
	Apollo.QueryResult<
		ExportDocumentButton_GetDocumentWhereQuery,
		ExportDocumentButton_GetDocumentWhereQueryVariables
	>;
export const DocumentDetailPresentation_UpdateDocumentNameDocument = gql`
	mutation documentDetailPresentation_updateDocumentName(
		$where: DocumentWhereUniqueInput!
		$data: UpdateDocumentNameInput!
	) {
		updateDocumentName(where: $where, data: $data) {
			id
			name
		}
	}
`;
export type DocumentDetailPresentation_UpdateDocumentNameMutationFn =
	Apollo.MutationFunction<
		DocumentDetailPresentation_UpdateDocumentNameMutation,
		DocumentDetailPresentation_UpdateDocumentNameMutationVariables
	>;

/**
 * __useDocumentDetailPresentation_UpdateDocumentNameMutation__
 *
 * To run a mutation, you first call `useDocumentDetailPresentation_UpdateDocumentNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailPresentation_UpdateDocumentNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentDetailPresentationUpdateDocumentNameMutation, { data, loading, error }] = useDocumentDetailPresentation_UpdateDocumentNameMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDocumentDetailPresentation_UpdateDocumentNameMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DocumentDetailPresentation_UpdateDocumentNameMutation,
		DocumentDetailPresentation_UpdateDocumentNameMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DocumentDetailPresentation_UpdateDocumentNameMutation,
		DocumentDetailPresentation_UpdateDocumentNameMutationVariables
	>(DocumentDetailPresentation_UpdateDocumentNameDocument, options);
}
export type DocumentDetailPresentation_UpdateDocumentNameMutationHookResult =
	ReturnType<typeof useDocumentDetailPresentation_UpdateDocumentNameMutation>;
export type DocumentDetailPresentation_UpdateDocumentNameMutationResult =
	Apollo.MutationResult<DocumentDetailPresentation_UpdateDocumentNameMutation>;
export type DocumentDetailPresentation_UpdateDocumentNameMutationOptions =
	Apollo.BaseMutationOptions<
		DocumentDetailPresentation_UpdateDocumentNameMutation,
		DocumentDetailPresentation_UpdateDocumentNameMutationVariables
	>;
export const DocumentDetail_GetDocumentWhereDocument = gql`
	query DocumentDetail_getDocumentWhere($where: DocumentWhereUniqueInput!) {
		getDocumentWhere(where: $where) {
			...documentDetailCustomDocumentWithDownloadUrl
		}
	}
	${DocumentDetailCustomDocumentWithDownloadUrlFragmentDoc}
`;

/**
 * __useDocumentDetail_GetDocumentWhereQuery__
 *
 * To run a query within a React component, call `useDocumentDetail_GetDocumentWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetail_GetDocumentWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetail_GetDocumentWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentDetail_GetDocumentWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentDetail_GetDocumentWhereQuery,
		DocumentDetail_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentDetail_GetDocumentWhereQuery,
		DocumentDetail_GetDocumentWhereQueryVariables
	>(DocumentDetail_GetDocumentWhereDocument, options);
}
export function useDocumentDetail_GetDocumentWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentDetail_GetDocumentWhereQuery,
		DocumentDetail_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentDetail_GetDocumentWhereQuery,
		DocumentDetail_GetDocumentWhereQueryVariables
	>(DocumentDetail_GetDocumentWhereDocument, options);
}
export type DocumentDetail_GetDocumentWhereQueryHookResult = ReturnType<
	typeof useDocumentDetail_GetDocumentWhereQuery
>;
export type DocumentDetail_GetDocumentWhereLazyQueryHookResult = ReturnType<
	typeof useDocumentDetail_GetDocumentWhereLazyQuery
>;
export type DocumentDetail_GetDocumentWhereQueryResult = Apollo.QueryResult<
	DocumentDetail_GetDocumentWhereQuery,
	DocumentDetail_GetDocumentWhereQueryVariables
>;
export const DocumentSettingsModalShareList_GetOrganizationsForUserDocument = gql`
	query DocumentSettingsModalShareList_getOrganizationsForUser(
		$where: UserByIdUniqueInput!
		$take: Int
		$contactWhere: ContactWhereInput
	) {
		getOrganizationsForUser(where: $where, take: $take) {
			organizations {
				...documentSettingsModalShareListOrganization
			}
		}
	}
	${DocumentSettingsModalShareListOrganizationFragmentDoc}
`;

/**
 * __useDocumentSettingsModalShareList_GetOrganizationsForUserQuery__
 *
 * To run a query within a React component, call `useDocumentSettingsModalShareList_GetOrganizationsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSettingsModalShareList_GetOrganizationsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSettingsModalShareList_GetOrganizationsForUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      contactWhere: // value for 'contactWhere'
 *   },
 * });
 */
export function useDocumentSettingsModalShareList_GetOrganizationsForUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentSettingsModalShareList_GetOrganizationsForUserQuery,
		DocumentSettingsModalShareList_GetOrganizationsForUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentSettingsModalShareList_GetOrganizationsForUserQuery,
		DocumentSettingsModalShareList_GetOrganizationsForUserQueryVariables
	>(DocumentSettingsModalShareList_GetOrganizationsForUserDocument, options);
}
export function useDocumentSettingsModalShareList_GetOrganizationsForUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentSettingsModalShareList_GetOrganizationsForUserQuery,
		DocumentSettingsModalShareList_GetOrganizationsForUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentSettingsModalShareList_GetOrganizationsForUserQuery,
		DocumentSettingsModalShareList_GetOrganizationsForUserQueryVariables
	>(DocumentSettingsModalShareList_GetOrganizationsForUserDocument, options);
}
export type DocumentSettingsModalShareList_GetOrganizationsForUserQueryHookResult =
	ReturnType<
		typeof useDocumentSettingsModalShareList_GetOrganizationsForUserQuery
	>;
export type DocumentSettingsModalShareList_GetOrganizationsForUserLazyQueryHookResult =
	ReturnType<
		typeof useDocumentSettingsModalShareList_GetOrganizationsForUserLazyQuery
	>;
export type DocumentSettingsModalShareList_GetOrganizationsForUserQueryResult =
	Apollo.QueryResult<
		DocumentSettingsModalShareList_GetOrganizationsForUserQuery,
		DocumentSettingsModalShareList_GetOrganizationsForUserQueryVariables
	>;
export const DocumentSettingsModal_GetDocumentWhereDocument = gql`
	query DocumentSettingsModal_getDocumentWhere(
		$where: DocumentWhereUniqueInput!
	) {
		getDocumentWhere(where: $where) {
			...documentSettingsModalDocument
		}
	}
	${DocumentSettingsModalDocumentFragmentDoc}
`;

/**
 * __useDocumentSettingsModal_GetDocumentWhereQuery__
 *
 * To run a query within a React component, call `useDocumentSettingsModal_GetDocumentWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSettingsModal_GetDocumentWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSettingsModal_GetDocumentWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentSettingsModal_GetDocumentWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentSettingsModal_GetDocumentWhereQuery,
		DocumentSettingsModal_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentSettingsModal_GetDocumentWhereQuery,
		DocumentSettingsModal_GetDocumentWhereQueryVariables
	>(DocumentSettingsModal_GetDocumentWhereDocument, options);
}
export function useDocumentSettingsModal_GetDocumentWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentSettingsModal_GetDocumentWhereQuery,
		DocumentSettingsModal_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentSettingsModal_GetDocumentWhereQuery,
		DocumentSettingsModal_GetDocumentWhereQueryVariables
	>(DocumentSettingsModal_GetDocumentWhereDocument, options);
}
export type DocumentSettingsModal_GetDocumentWhereQueryHookResult = ReturnType<
	typeof useDocumentSettingsModal_GetDocumentWhereQuery
>;
export type DocumentSettingsModal_GetDocumentWhereLazyQueryHookResult =
	ReturnType<typeof useDocumentSettingsModal_GetDocumentWhereLazyQuery>;
export type DocumentSettingsModal_GetDocumentWhereQueryResult =
	Apollo.QueryResult<
		DocumentSettingsModal_GetDocumentWhereQuery,
		DocumentSettingsModal_GetDocumentWhereQueryVariables
	>;
export const DocumentSettingsModal_ShareDocumentDocument = gql`
	mutation DocumentSettingsModal_shareDocument(
		$where: DocumentWhereUniqueInput!
		$data: CustomShareDocumentInput!
	) {
		shareDocument(where: $where, data: $data) {
			...documentSettingsModalDocument
		}
	}
	${DocumentSettingsModalDocumentFragmentDoc}
`;
export type DocumentSettingsModal_ShareDocumentMutationFn =
	Apollo.MutationFunction<
		DocumentSettingsModal_ShareDocumentMutation,
		DocumentSettingsModal_ShareDocumentMutationVariables
	>;

/**
 * __useDocumentSettingsModal_ShareDocumentMutation__
 *
 * To run a mutation, you first call `useDocumentSettingsModal_ShareDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentSettingsModal_ShareDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentSettingsModalShareDocumentMutation, { data, loading, error }] = useDocumentSettingsModal_ShareDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDocumentSettingsModal_ShareDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DocumentSettingsModal_ShareDocumentMutation,
		DocumentSettingsModal_ShareDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DocumentSettingsModal_ShareDocumentMutation,
		DocumentSettingsModal_ShareDocumentMutationVariables
	>(DocumentSettingsModal_ShareDocumentDocument, options);
}
export type DocumentSettingsModal_ShareDocumentMutationHookResult = ReturnType<
	typeof useDocumentSettingsModal_ShareDocumentMutation
>;
export type DocumentSettingsModal_ShareDocumentMutationResult =
	Apollo.MutationResult<DocumentSettingsModal_ShareDocumentMutation>;
export type DocumentSettingsModal_ShareDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		DocumentSettingsModal_ShareDocumentMutation,
		DocumentSettingsModal_ShareDocumentMutationVariables
	>;
export const DocumentSettingsModal_UpdateDocumentDocument = gql`
	mutation DocumentSettingsModal_updateDocument(
		$where: DocumentWhereUniqueInput!
		$data: UpdateDocumentInput!
	) {
		updateDocument(where: $where, data: $data) {
			...documentSettingsModalDocument
		}
	}
	${DocumentSettingsModalDocumentFragmentDoc}
`;
export type DocumentSettingsModal_UpdateDocumentMutationFn =
	Apollo.MutationFunction<
		DocumentSettingsModal_UpdateDocumentMutation,
		DocumentSettingsModal_UpdateDocumentMutationVariables
	>;

/**
 * __useDocumentSettingsModal_UpdateDocumentMutation__
 *
 * To run a mutation, you first call `useDocumentSettingsModal_UpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentSettingsModal_UpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentSettingsModalUpdateDocumentMutation, { data, loading, error }] = useDocumentSettingsModal_UpdateDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDocumentSettingsModal_UpdateDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DocumentSettingsModal_UpdateDocumentMutation,
		DocumentSettingsModal_UpdateDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DocumentSettingsModal_UpdateDocumentMutation,
		DocumentSettingsModal_UpdateDocumentMutationVariables
	>(DocumentSettingsModal_UpdateDocumentDocument, options);
}
export type DocumentSettingsModal_UpdateDocumentMutationHookResult = ReturnType<
	typeof useDocumentSettingsModal_UpdateDocumentMutation
>;
export type DocumentSettingsModal_UpdateDocumentMutationResult =
	Apollo.MutationResult<DocumentSettingsModal_UpdateDocumentMutation>;
export type DocumentSettingsModal_UpdateDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		DocumentSettingsModal_UpdateDocumentMutation,
		DocumentSettingsModal_UpdateDocumentMutationVariables
	>;
export const DocumentsUploadButton_CreateDocumentDocument = gql`
	mutation DocumentsUploadButton_createDocument(
		$data: DocumentCreateCustomInput!
	) {
		createDocument(data: $data) {
			id
			status
			uploadURL
			...documentsUploadButtonCustomDocumentWithUploadUrl
		}
	}
	${DocumentsUploadButtonCustomDocumentWithUploadUrlFragmentDoc}
`;
export type DocumentsUploadButton_CreateDocumentMutationFn =
	Apollo.MutationFunction<
		DocumentsUploadButton_CreateDocumentMutation,
		DocumentsUploadButton_CreateDocumentMutationVariables
	>;

/**
 * __useDocumentsUploadButton_CreateDocumentMutation__
 *
 * To run a mutation, you first call `useDocumentsUploadButton_CreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentsUploadButton_CreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentsUploadButtonCreateDocumentMutation, { data, loading, error }] = useDocumentsUploadButton_CreateDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDocumentsUploadButton_CreateDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DocumentsUploadButton_CreateDocumentMutation,
		DocumentsUploadButton_CreateDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DocumentsUploadButton_CreateDocumentMutation,
		DocumentsUploadButton_CreateDocumentMutationVariables
	>(DocumentsUploadButton_CreateDocumentDocument, options);
}
export type DocumentsUploadButton_CreateDocumentMutationHookResult = ReturnType<
	typeof useDocumentsUploadButton_CreateDocumentMutation
>;
export type DocumentsUploadButton_CreateDocumentMutationResult =
	Apollo.MutationResult<DocumentsUploadButton_CreateDocumentMutation>;
export type DocumentsUploadButton_CreateDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		DocumentsUploadButton_CreateDocumentMutation,
		DocumentsUploadButton_CreateDocumentMutationVariables
	>;
export const DocumentsUploadButton_RecordDocumentUploadedDocument = gql`
	mutation DocumentsUploadButton_recordDocumentUploaded(
		$where: DocumentWhereUniqueInput!
	) {
		recordDocumentUploaded(where: $where) {
			id
			status
		}
	}
`;
export type DocumentsUploadButton_RecordDocumentUploadedMutationFn =
	Apollo.MutationFunction<
		DocumentsUploadButton_RecordDocumentUploadedMutation,
		DocumentsUploadButton_RecordDocumentUploadedMutationVariables
	>;

/**
 * __useDocumentsUploadButton_RecordDocumentUploadedMutation__
 *
 * To run a mutation, you first call `useDocumentsUploadButton_RecordDocumentUploadedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentsUploadButton_RecordDocumentUploadedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentsUploadButtonRecordDocumentUploadedMutation, { data, loading, error }] = useDocumentsUploadButton_RecordDocumentUploadedMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentsUploadButton_RecordDocumentUploadedMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DocumentsUploadButton_RecordDocumentUploadedMutation,
		DocumentsUploadButton_RecordDocumentUploadedMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DocumentsUploadButton_RecordDocumentUploadedMutation,
		DocumentsUploadButton_RecordDocumentUploadedMutationVariables
	>(DocumentsUploadButton_RecordDocumentUploadedDocument, options);
}
export type DocumentsUploadButton_RecordDocumentUploadedMutationHookResult =
	ReturnType<typeof useDocumentsUploadButton_RecordDocumentUploadedMutation>;
export type DocumentsUploadButton_RecordDocumentUploadedMutationResult =
	Apollo.MutationResult<DocumentsUploadButton_RecordDocumentUploadedMutation>;
export type DocumentsUploadButton_RecordDocumentUploadedMutationOptions =
	Apollo.BaseMutationOptions<
		DocumentsUploadButton_RecordDocumentUploadedMutation,
		DocumentsUploadButton_RecordDocumentUploadedMutationVariables
	>;
export const DocumentsUploadButton_GetFeatureFlagsDocument = gql`
	query DocumentsUploadButton_getFeatureFlags {
		getFeatureFlags {
			category
			active
		}
	}
`;

/**
 * __useDocumentsUploadButton_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useDocumentsUploadButton_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsUploadButton_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsUploadButton_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentsUploadButton_GetFeatureFlagsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		DocumentsUploadButton_GetFeatureFlagsQuery,
		DocumentsUploadButton_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentsUploadButton_GetFeatureFlagsQuery,
		DocumentsUploadButton_GetFeatureFlagsQueryVariables
	>(DocumentsUploadButton_GetFeatureFlagsDocument, options);
}
export function useDocumentsUploadButton_GetFeatureFlagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentsUploadButton_GetFeatureFlagsQuery,
		DocumentsUploadButton_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentsUploadButton_GetFeatureFlagsQuery,
		DocumentsUploadButton_GetFeatureFlagsQueryVariables
	>(DocumentsUploadButton_GetFeatureFlagsDocument, options);
}
export type DocumentsUploadButton_GetFeatureFlagsQueryHookResult = ReturnType<
	typeof useDocumentsUploadButton_GetFeatureFlagsQuery
>;
export type DocumentsUploadButton_GetFeatureFlagsLazyQueryHookResult =
	ReturnType<typeof useDocumentsUploadButton_GetFeatureFlagsLazyQuery>;
export type DocumentsUploadButton_GetFeatureFlagsQueryResult =
	Apollo.QueryResult<
		DocumentsUploadButton_GetFeatureFlagsQuery,
		DocumentsUploadButton_GetFeatureFlagsQueryVariables
	>;
export const DocumentsUploadButton_GetContactWhereDocument = gql`
	query DocumentsUploadButton_getContactWhere($where: ContactWhereInput!) {
		getContactWhere(where: $where) {
			id
		}
	}
`;

/**
 * __useDocumentsUploadButton_GetContactWhereQuery__
 *
 * To run a query within a React component, call `useDocumentsUploadButton_GetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsUploadButton_GetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsUploadButton_GetContactWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentsUploadButton_GetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentsUploadButton_GetContactWhereQuery,
		DocumentsUploadButton_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentsUploadButton_GetContactWhereQuery,
		DocumentsUploadButton_GetContactWhereQueryVariables
	>(DocumentsUploadButton_GetContactWhereDocument, options);
}
export function useDocumentsUploadButton_GetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentsUploadButton_GetContactWhereQuery,
		DocumentsUploadButton_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentsUploadButton_GetContactWhereQuery,
		DocumentsUploadButton_GetContactWhereQueryVariables
	>(DocumentsUploadButton_GetContactWhereDocument, options);
}
export type DocumentsUploadButton_GetContactWhereQueryHookResult = ReturnType<
	typeof useDocumentsUploadButton_GetContactWhereQuery
>;
export type DocumentsUploadButton_GetContactWhereLazyQueryHookResult =
	ReturnType<typeof useDocumentsUploadButton_GetContactWhereLazyQuery>;
export type DocumentsUploadButton_GetContactWhereQueryResult =
	Apollo.QueryResult<
		DocumentsUploadButton_GetContactWhereQuery,
		DocumentsUploadButton_GetContactWhereQueryVariables
	>;
export const UpdatePasswordForm_ChangePasswordDocument = gql`
	mutation UpdatePasswordForm_changePassword($data: PasswordChangeInput!) {
		changePassword(data: $data)
	}
`;
export type UpdatePasswordForm_ChangePasswordMutationFn =
	Apollo.MutationFunction<
		UpdatePasswordForm_ChangePasswordMutation,
		UpdatePasswordForm_ChangePasswordMutationVariables
	>;

/**
 * __useUpdatePasswordForm_ChangePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordForm_ChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordForm_ChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordFormChangePasswordMutation, { data, loading, error }] = useUpdatePasswordForm_ChangePasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePasswordForm_ChangePasswordMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdatePasswordForm_ChangePasswordMutation,
		UpdatePasswordForm_ChangePasswordMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdatePasswordForm_ChangePasswordMutation,
		UpdatePasswordForm_ChangePasswordMutationVariables
	>(UpdatePasswordForm_ChangePasswordDocument, options);
}
export type UpdatePasswordForm_ChangePasswordMutationHookResult = ReturnType<
	typeof useUpdatePasswordForm_ChangePasswordMutation
>;
export type UpdatePasswordForm_ChangePasswordMutationResult =
	Apollo.MutationResult<UpdatePasswordForm_ChangePasswordMutation>;
export type UpdatePasswordForm_ChangePasswordMutationOptions =
	Apollo.BaseMutationOptions<
		UpdatePasswordForm_ChangePasswordMutation,
		UpdatePasswordForm_ChangePasswordMutationVariables
	>;
export const UserInformationForm_UpdateClientUserDocument = gql`
	mutation UserInformationForm_updateClientUser(
		$data: ClientUserUpdateCustomInput!
		$where: ClientUserWhereUniqueInput!
	) {
		updateClientUser(where: $where, data: $data) {
			id
			updatedAt
			phone
			addressLine1
			addressLine2
			city
			state
			country
			postalCode
			facebook
			twitter
			instagram
			pinterest
		}
	}
`;
export type UserInformationForm_UpdateClientUserMutationFn =
	Apollo.MutationFunction<
		UserInformationForm_UpdateClientUserMutation,
		UserInformationForm_UpdateClientUserMutationVariables
	>;

/**
 * __useUserInformationForm_UpdateClientUserMutation__
 *
 * To run a mutation, you first call `useUserInformationForm_UpdateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInformationForm_UpdateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInformationFormUpdateClientUserMutation, { data, loading, error }] = useUserInformationForm_UpdateClientUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserInformationForm_UpdateClientUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UserInformationForm_UpdateClientUserMutation,
		UserInformationForm_UpdateClientUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UserInformationForm_UpdateClientUserMutation,
		UserInformationForm_UpdateClientUserMutationVariables
	>(UserInformationForm_UpdateClientUserDocument, options);
}
export type UserInformationForm_UpdateClientUserMutationHookResult = ReturnType<
	typeof useUserInformationForm_UpdateClientUserMutation
>;
export type UserInformationForm_UpdateClientUserMutationResult =
	Apollo.MutationResult<UserInformationForm_UpdateClientUserMutation>;
export type UserInformationForm_UpdateClientUserMutationOptions =
	Apollo.BaseMutationOptions<
		UserInformationForm_UpdateClientUserMutation,
		UserInformationForm_UpdateClientUserMutationVariables
	>;
export const UserInformationForm_UpdateOrgUserDocument = gql`
	mutation UserInformationForm_updateOrgUser(
		$data: OrgUserUpdateCustomInput!
		$where: OrgUserWhereUniqueInput!
	) {
		updateOrgUser(where: $where, data: $data) {
			id
			updatedAt
			phone
		}
	}
`;
export type UserInformationForm_UpdateOrgUserMutationFn =
	Apollo.MutationFunction<
		UserInformationForm_UpdateOrgUserMutation,
		UserInformationForm_UpdateOrgUserMutationVariables
	>;

/**
 * __useUserInformationForm_UpdateOrgUserMutation__
 *
 * To run a mutation, you first call `useUserInformationForm_UpdateOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInformationForm_UpdateOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInformationFormUpdateOrgUserMutation, { data, loading, error }] = useUserInformationForm_UpdateOrgUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserInformationForm_UpdateOrgUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UserInformationForm_UpdateOrgUserMutation,
		UserInformationForm_UpdateOrgUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UserInformationForm_UpdateOrgUserMutation,
		UserInformationForm_UpdateOrgUserMutationVariables
	>(UserInformationForm_UpdateOrgUserDocument, options);
}
export type UserInformationForm_UpdateOrgUserMutationHookResult = ReturnType<
	typeof useUserInformationForm_UpdateOrgUserMutation
>;
export type UserInformationForm_UpdateOrgUserMutationResult =
	Apollo.MutationResult<UserInformationForm_UpdateOrgUserMutation>;
export type UserInformationForm_UpdateOrgUserMutationOptions =
	Apollo.BaseMutationOptions<
		UserInformationForm_UpdateOrgUserMutation,
		UserInformationForm_UpdateOrgUserMutationVariables
	>;
export const UserInformationForm_UpdateEmailAddressDocument = gql`
	mutation UserInformationForm_updateEmailAddress(
		$data: EmailAddressUpdateInput!
		$where: EmailAddressInput!
	) {
		updateEmailAddress(where: $where, data: $data)
	}
`;
export type UserInformationForm_UpdateEmailAddressMutationFn =
	Apollo.MutationFunction<
		UserInformationForm_UpdateEmailAddressMutation,
		UserInformationForm_UpdateEmailAddressMutationVariables
	>;

/**
 * __useUserInformationForm_UpdateEmailAddressMutation__
 *
 * To run a mutation, you first call `useUserInformationForm_UpdateEmailAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInformationForm_UpdateEmailAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInformationFormUpdateEmailAddressMutation, { data, loading, error }] = useUserInformationForm_UpdateEmailAddressMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserInformationForm_UpdateEmailAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UserInformationForm_UpdateEmailAddressMutation,
		UserInformationForm_UpdateEmailAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UserInformationForm_UpdateEmailAddressMutation,
		UserInformationForm_UpdateEmailAddressMutationVariables
	>(UserInformationForm_UpdateEmailAddressDocument, options);
}
export type UserInformationForm_UpdateEmailAddressMutationHookResult =
	ReturnType<typeof useUserInformationForm_UpdateEmailAddressMutation>;
export type UserInformationForm_UpdateEmailAddressMutationResult =
	Apollo.MutationResult<UserInformationForm_UpdateEmailAddressMutation>;
export type UserInformationForm_UpdateEmailAddressMutationOptions =
	Apollo.BaseMutationOptions<
		UserInformationForm_UpdateEmailAddressMutation,
		UserInformationForm_UpdateEmailAddressMutationVariables
	>;
export const UserInformationForm_GetFeatureFlagsDocument = gql`
	query UserInformationForm_getFeatureFlags {
		getFeatureFlags {
			category
			active
		}
	}
`;

/**
 * __useUserInformationForm_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useUserInformationForm_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInformationForm_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInformationForm_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInformationForm_GetFeatureFlagsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserInformationForm_GetFeatureFlagsQuery,
		UserInformationForm_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UserInformationForm_GetFeatureFlagsQuery,
		UserInformationForm_GetFeatureFlagsQueryVariables
	>(UserInformationForm_GetFeatureFlagsDocument, options);
}
export function useUserInformationForm_GetFeatureFlagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserInformationForm_GetFeatureFlagsQuery,
		UserInformationForm_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UserInformationForm_GetFeatureFlagsQuery,
		UserInformationForm_GetFeatureFlagsQueryVariables
	>(UserInformationForm_GetFeatureFlagsDocument, options);
}
export type UserInformationForm_GetFeatureFlagsQueryHookResult = ReturnType<
	typeof useUserInformationForm_GetFeatureFlagsQuery
>;
export type UserInformationForm_GetFeatureFlagsLazyQueryHookResult = ReturnType<
	typeof useUserInformationForm_GetFeatureFlagsLazyQuery
>;
export type UserInformationForm_GetFeatureFlagsQueryResult = Apollo.QueryResult<
	UserInformationForm_GetFeatureFlagsQuery,
	UserInformationForm_GetFeatureFlagsQueryVariables
>;
export const UserInformationForm_GetAuthedUserDocument = gql`
	query UserInformationForm_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			...getAuthedUserFlattenedUserFields
		}
	}
	${GetAuthedUserFlattenedUserFieldsFragmentDoc}
`;

/**
 * __useUserInformationForm_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useUserInformationForm_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInformationForm_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInformationForm_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserInformationForm_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		UserInformationForm_GetAuthedUserQuery,
		UserInformationForm_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UserInformationForm_GetAuthedUserQuery,
		UserInformationForm_GetAuthedUserQueryVariables
	>(UserInformationForm_GetAuthedUserDocument, options);
}
export function useUserInformationForm_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserInformationForm_GetAuthedUserQuery,
		UserInformationForm_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UserInformationForm_GetAuthedUserQuery,
		UserInformationForm_GetAuthedUserQueryVariables
	>(UserInformationForm_GetAuthedUserDocument, options);
}
export type UserInformationForm_GetAuthedUserQueryHookResult = ReturnType<
	typeof useUserInformationForm_GetAuthedUserQuery
>;
export type UserInformationForm_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useUserInformationForm_GetAuthedUserLazyQuery
>;
export type UserInformationForm_GetAuthedUserQueryResult = Apollo.QueryResult<
	UserInformationForm_GetAuthedUserQuery,
	UserInformationForm_GetAuthedUserQueryVariables
>;
export const UserInformationForm_GetClientUserWhereDocument = gql`
	query UserInformationForm_getClientUserWhere(
		$where: ClientUserWhereUniqueInput!
	) {
		getClientUserWhere(where: $where) {
			id
			firstNameOne
			lastNameOne
			firstNameTwo
			lastNameTwo
			weddingDate
			venue
			description
			phone
			addressLine1
			addressLine2
			city
			state
			country
			postalCode
			facebook
			twitter
			instagram
			pinterest
			user {
				id
				email
			}
		}
	}
`;

/**
 * __useUserInformationForm_GetClientUserWhereQuery__
 *
 * To run a query within a React component, call `useUserInformationForm_GetClientUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInformationForm_GetClientUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInformationForm_GetClientUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserInformationForm_GetClientUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UserInformationForm_GetClientUserWhereQuery,
		UserInformationForm_GetClientUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UserInformationForm_GetClientUserWhereQuery,
		UserInformationForm_GetClientUserWhereQueryVariables
	>(UserInformationForm_GetClientUserWhereDocument, options);
}
export function useUserInformationForm_GetClientUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserInformationForm_GetClientUserWhereQuery,
		UserInformationForm_GetClientUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UserInformationForm_GetClientUserWhereQuery,
		UserInformationForm_GetClientUserWhereQueryVariables
	>(UserInformationForm_GetClientUserWhereDocument, options);
}
export type UserInformationForm_GetClientUserWhereQueryHookResult = ReturnType<
	typeof useUserInformationForm_GetClientUserWhereQuery
>;
export type UserInformationForm_GetClientUserWhereLazyQueryHookResult =
	ReturnType<typeof useUserInformationForm_GetClientUserWhereLazyQuery>;
export type UserInformationForm_GetClientUserWhereQueryResult =
	Apollo.QueryResult<
		UserInformationForm_GetClientUserWhereQuery,
		UserInformationForm_GetClientUserWhereQueryVariables
	>;
export const UserInformationForm_GetOrgUserWhereDocument = gql`
	query UserInformationForm_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			firstName
			lastName
			phone
			role
			user {
				id
				email
			}
			organization {
				id
				description
				country
			}
		}
	}
`;

/**
 * __useUserInformationForm_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useUserInformationForm_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInformationForm_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInformationForm_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserInformationForm_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UserInformationForm_GetOrgUserWhereQuery,
		UserInformationForm_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UserInformationForm_GetOrgUserWhereQuery,
		UserInformationForm_GetOrgUserWhereQueryVariables
	>(UserInformationForm_GetOrgUserWhereDocument, options);
}
export function useUserInformationForm_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserInformationForm_GetOrgUserWhereQuery,
		UserInformationForm_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UserInformationForm_GetOrgUserWhereQuery,
		UserInformationForm_GetOrgUserWhereQueryVariables
	>(UserInformationForm_GetOrgUserWhereDocument, options);
}
export type UserInformationForm_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useUserInformationForm_GetOrgUserWhereQuery
>;
export type UserInformationForm_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useUserInformationForm_GetOrgUserWhereLazyQuery
>;
export type UserInformationForm_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	UserInformationForm_GetOrgUserWhereQuery,
	UserInformationForm_GetOrgUserWhereQueryVariables
>;
export const Events_GetEventsWhereDocument = gql`
	query Events_GetEventsWhere(
		$where: EventWhereInput!
		$orderBy: [EventOrderByInput]
		$skip: Int
		$take: Int
	) {
		getEventsWhere(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			...eventsEvent
		}
	}
	${EventsEventFragmentDoc}
`;

/**
 * __useEvents_GetEventsWhereQuery__
 *
 * To run a query within a React component, call `useEvents_GetEventsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvents_GetEventsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvents_GetEventsWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useEvents_GetEventsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		Events_GetEventsWhereQuery,
		Events_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		Events_GetEventsWhereQuery,
		Events_GetEventsWhereQueryVariables
	>(Events_GetEventsWhereDocument, options);
}
export function useEvents_GetEventsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Events_GetEventsWhereQuery,
		Events_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		Events_GetEventsWhereQuery,
		Events_GetEventsWhereQueryVariables
	>(Events_GetEventsWhereDocument, options);
}
export type Events_GetEventsWhereQueryHookResult = ReturnType<
	typeof useEvents_GetEventsWhereQuery
>;
export type Events_GetEventsWhereLazyQueryHookResult = ReturnType<
	typeof useEvents_GetEventsWhereLazyQuery
>;
export type Events_GetEventsWhereQueryResult = Apollo.QueryResult<
	Events_GetEventsWhereQuery,
	Events_GetEventsWhereQueryVariables
>;
export const InquiriesPublishForm_GetGlobalVariablesDocument = gql`
	query InquiriesPublishForm_getGlobalVariables {
		getGlobalVariables {
			InquiryFormSupportUrl
		}
	}
`;

/**
 * __useInquiriesPublishForm_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useInquiriesPublishForm_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInquiriesPublishForm_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInquiriesPublishForm_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInquiriesPublishForm_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		InquiriesPublishForm_GetGlobalVariablesQuery,
		InquiriesPublishForm_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InquiriesPublishForm_GetGlobalVariablesQuery,
		InquiriesPublishForm_GetGlobalVariablesQueryVariables
	>(InquiriesPublishForm_GetGlobalVariablesDocument, options);
}
export function useInquiriesPublishForm_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InquiriesPublishForm_GetGlobalVariablesQuery,
		InquiriesPublishForm_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InquiriesPublishForm_GetGlobalVariablesQuery,
		InquiriesPublishForm_GetGlobalVariablesQueryVariables
	>(InquiriesPublishForm_GetGlobalVariablesDocument, options);
}
export type InquiriesPublishForm_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useInquiriesPublishForm_GetGlobalVariablesQuery
>;
export type InquiriesPublishForm_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useInquiriesPublishForm_GetGlobalVariablesLazyQuery>;
export type InquiriesPublishForm_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		InquiriesPublishForm_GetGlobalVariablesQuery,
		InquiriesPublishForm_GetGlobalVariablesQueryVariables
	>;
export const InquiriesPublish_GetInquiryFormApiKeyDocument = gql`
	query InquiriesPublish_GetInquiryFormApiKey {
		getInquiryFormApiKey
	}
`;

/**
 * __useInquiriesPublish_GetInquiryFormApiKeyQuery__
 *
 * To run a query within a React component, call `useInquiriesPublish_GetInquiryFormApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useInquiriesPublish_GetInquiryFormApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInquiriesPublish_GetInquiryFormApiKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useInquiriesPublish_GetInquiryFormApiKeyQuery(
	baseOptions?: Apollo.QueryHookOptions<
		InquiriesPublish_GetInquiryFormApiKeyQuery,
		InquiriesPublish_GetInquiryFormApiKeyQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InquiriesPublish_GetInquiryFormApiKeyQuery,
		InquiriesPublish_GetInquiryFormApiKeyQueryVariables
	>(InquiriesPublish_GetInquiryFormApiKeyDocument, options);
}
export function useInquiriesPublish_GetInquiryFormApiKeyLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InquiriesPublish_GetInquiryFormApiKeyQuery,
		InquiriesPublish_GetInquiryFormApiKeyQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InquiriesPublish_GetInquiryFormApiKeyQuery,
		InquiriesPublish_GetInquiryFormApiKeyQueryVariables
	>(InquiriesPublish_GetInquiryFormApiKeyDocument, options);
}
export type InquiriesPublish_GetInquiryFormApiKeyQueryHookResult = ReturnType<
	typeof useInquiriesPublish_GetInquiryFormApiKeyQuery
>;
export type InquiriesPublish_GetInquiryFormApiKeyLazyQueryHookResult =
	ReturnType<typeof useInquiriesPublish_GetInquiryFormApiKeyLazyQuery>;
export type InquiriesPublish_GetInquiryFormApiKeyQueryResult =
	Apollo.QueryResult<
		InquiriesPublish_GetInquiryFormApiKeyQuery,
		InquiriesPublish_GetInquiryFormApiKeyQueryVariables
	>;
export const InquiriesConfiguration_GetInquiryFormDocument = gql`
	query InquiriesConfiguration_GetInquiryForm(
		$where: OrganizationWhereUniqueInput!
	) {
		getInquiryForm(where: $where) {
			...inquiriesConfigurationInquiryForm
		}
	}
	${InquiriesConfigurationInquiryFormFragmentDoc}
`;

/**
 * __useInquiriesConfiguration_GetInquiryFormQuery__
 *
 * To run a query within a React component, call `useInquiriesConfiguration_GetInquiryFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useInquiriesConfiguration_GetInquiryFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInquiriesConfiguration_GetInquiryFormQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInquiriesConfiguration_GetInquiryFormQuery(
	baseOptions: Apollo.QueryHookOptions<
		InquiriesConfiguration_GetInquiryFormQuery,
		InquiriesConfiguration_GetInquiryFormQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InquiriesConfiguration_GetInquiryFormQuery,
		InquiriesConfiguration_GetInquiryFormQueryVariables
	>(InquiriesConfiguration_GetInquiryFormDocument, options);
}
export function useInquiriesConfiguration_GetInquiryFormLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InquiriesConfiguration_GetInquiryFormQuery,
		InquiriesConfiguration_GetInquiryFormQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InquiriesConfiguration_GetInquiryFormQuery,
		InquiriesConfiguration_GetInquiryFormQueryVariables
	>(InquiriesConfiguration_GetInquiryFormDocument, options);
}
export type InquiriesConfiguration_GetInquiryFormQueryHookResult = ReturnType<
	typeof useInquiriesConfiguration_GetInquiryFormQuery
>;
export type InquiriesConfiguration_GetInquiryFormLazyQueryHookResult =
	ReturnType<typeof useInquiriesConfiguration_GetInquiryFormLazyQuery>;
export type InquiriesConfiguration_GetInquiryFormQueryResult =
	Apollo.QueryResult<
		InquiriesConfiguration_GetInquiryFormQuery,
		InquiriesConfiguration_GetInquiryFormQueryVariables
	>;
export const InquiriesConfiguration_CreateInquiryFormDocument = gql`
	mutation InquiriesConfiguration_CreateInquiryForm(
		$data: InquiryFormDataInput!
	) {
		createInquiryForm(data: $data) {
			...inquiriesConfigurationInquiryForm
		}
	}
	${InquiriesConfigurationInquiryFormFragmentDoc}
`;
export type InquiriesConfiguration_CreateInquiryFormMutationFn =
	Apollo.MutationFunction<
		InquiriesConfiguration_CreateInquiryFormMutation,
		InquiriesConfiguration_CreateInquiryFormMutationVariables
	>;

/**
 * __useInquiriesConfiguration_CreateInquiryFormMutation__
 *
 * To run a mutation, you first call `useInquiriesConfiguration_CreateInquiryFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInquiriesConfiguration_CreateInquiryFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inquiriesConfigurationCreateInquiryFormMutation, { data, loading, error }] = useInquiriesConfiguration_CreateInquiryFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInquiriesConfiguration_CreateInquiryFormMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InquiriesConfiguration_CreateInquiryFormMutation,
		InquiriesConfiguration_CreateInquiryFormMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InquiriesConfiguration_CreateInquiryFormMutation,
		InquiriesConfiguration_CreateInquiryFormMutationVariables
	>(InquiriesConfiguration_CreateInquiryFormDocument, options);
}
export type InquiriesConfiguration_CreateInquiryFormMutationHookResult =
	ReturnType<typeof useInquiriesConfiguration_CreateInquiryFormMutation>;
export type InquiriesConfiguration_CreateInquiryFormMutationResult =
	Apollo.MutationResult<InquiriesConfiguration_CreateInquiryFormMutation>;
export type InquiriesConfiguration_CreateInquiryFormMutationOptions =
	Apollo.BaseMutationOptions<
		InquiriesConfiguration_CreateInquiryFormMutation,
		InquiriesConfiguration_CreateInquiryFormMutationVariables
	>;
export const InquiriesConfiguration_UpdateInquiryFormDocument = gql`
	mutation InquiriesConfiguration_UpdateInquiryForm(
		$data: InquiryFormDataInput!
	) {
		updateInquiryForm(data: $data) {
			...inquiriesConfigurationInquiryForm
		}
	}
	${InquiriesConfigurationInquiryFormFragmentDoc}
`;
export type InquiriesConfiguration_UpdateInquiryFormMutationFn =
	Apollo.MutationFunction<
		InquiriesConfiguration_UpdateInquiryFormMutation,
		InquiriesConfiguration_UpdateInquiryFormMutationVariables
	>;

/**
 * __useInquiriesConfiguration_UpdateInquiryFormMutation__
 *
 * To run a mutation, you first call `useInquiriesConfiguration_UpdateInquiryFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInquiriesConfiguration_UpdateInquiryFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inquiriesConfigurationUpdateInquiryFormMutation, { data, loading, error }] = useInquiriesConfiguration_UpdateInquiryFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInquiriesConfiguration_UpdateInquiryFormMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InquiriesConfiguration_UpdateInquiryFormMutation,
		InquiriesConfiguration_UpdateInquiryFormMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InquiriesConfiguration_UpdateInquiryFormMutation,
		InquiriesConfiguration_UpdateInquiryFormMutationVariables
	>(InquiriesConfiguration_UpdateInquiryFormDocument, options);
}
export type InquiriesConfiguration_UpdateInquiryFormMutationHookResult =
	ReturnType<typeof useInquiriesConfiguration_UpdateInquiryFormMutation>;
export type InquiriesConfiguration_UpdateInquiryFormMutationResult =
	Apollo.MutationResult<InquiriesConfiguration_UpdateInquiryFormMutation>;
export type InquiriesConfiguration_UpdateInquiryFormMutationOptions =
	Apollo.BaseMutationOptions<
		InquiriesConfiguration_UpdateInquiryFormMutation,
		InquiriesConfiguration_UpdateInquiryFormMutationVariables
	>;
export const CanvaSection_GetOrgUserWhereDocument = gql`
	query CanvaSection_GetOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			user {
				id
				canvaToken {
					accessToken
					expires
				}
			}
		}
	}
`;

/**
 * __useCanvaSection_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useCanvaSection_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvaSection_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvaSection_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCanvaSection_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		CanvaSection_GetOrgUserWhereQuery,
		CanvaSection_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CanvaSection_GetOrgUserWhereQuery,
		CanvaSection_GetOrgUserWhereQueryVariables
	>(CanvaSection_GetOrgUserWhereDocument, options);
}
export function useCanvaSection_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CanvaSection_GetOrgUserWhereQuery,
		CanvaSection_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CanvaSection_GetOrgUserWhereQuery,
		CanvaSection_GetOrgUserWhereQueryVariables
	>(CanvaSection_GetOrgUserWhereDocument, options);
}
export type CanvaSection_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useCanvaSection_GetOrgUserWhereQuery
>;
export type CanvaSection_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useCanvaSection_GetOrgUserWhereLazyQuery
>;
export type CanvaSection_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	CanvaSection_GetOrgUserWhereQuery,
	CanvaSection_GetOrgUserWhereQueryVariables
>;
export const CanvaSection_RevokeCanvaTokenDocument = gql`
	mutation CanvaSection_RevokeCanvaToken {
		revokeCanvaToken
	}
`;
export type CanvaSection_RevokeCanvaTokenMutationFn = Apollo.MutationFunction<
	CanvaSection_RevokeCanvaTokenMutation,
	CanvaSection_RevokeCanvaTokenMutationVariables
>;

/**
 * __useCanvaSection_RevokeCanvaTokenMutation__
 *
 * To run a mutation, you first call `useCanvaSection_RevokeCanvaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCanvaSection_RevokeCanvaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [canvaSectionRevokeCanvaTokenMutation, { data, loading, error }] = useCanvaSection_RevokeCanvaTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCanvaSection_RevokeCanvaTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CanvaSection_RevokeCanvaTokenMutation,
		CanvaSection_RevokeCanvaTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CanvaSection_RevokeCanvaTokenMutation,
		CanvaSection_RevokeCanvaTokenMutationVariables
	>(CanvaSection_RevokeCanvaTokenDocument, options);
}
export type CanvaSection_RevokeCanvaTokenMutationHookResult = ReturnType<
	typeof useCanvaSection_RevokeCanvaTokenMutation
>;
export type CanvaSection_RevokeCanvaTokenMutationResult =
	Apollo.MutationResult<CanvaSection_RevokeCanvaTokenMutation>;
export type CanvaSection_RevokeCanvaTokenMutationOptions =
	Apollo.BaseMutationOptions<
		CanvaSection_RevokeCanvaTokenMutation,
		CanvaSection_RevokeCanvaTokenMutationVariables
	>;
export const CanvaSection_GetCanvaAuthorizationUrlDocument = gql`
	query CanvaSection_GetCanvaAuthorizationUrl {
		getCanvaAuthorizationUrl {
			url
			state
			codeVerifier
		}
	}
`;

/**
 * __useCanvaSection_GetCanvaAuthorizationUrlQuery__
 *
 * To run a query within a React component, call `useCanvaSection_GetCanvaAuthorizationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvaSection_GetCanvaAuthorizationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvaSection_GetCanvaAuthorizationUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanvaSection_GetCanvaAuthorizationUrlQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CanvaSection_GetCanvaAuthorizationUrlQuery,
		CanvaSection_GetCanvaAuthorizationUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CanvaSection_GetCanvaAuthorizationUrlQuery,
		CanvaSection_GetCanvaAuthorizationUrlQueryVariables
	>(CanvaSection_GetCanvaAuthorizationUrlDocument, options);
}
export function useCanvaSection_GetCanvaAuthorizationUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CanvaSection_GetCanvaAuthorizationUrlQuery,
		CanvaSection_GetCanvaAuthorizationUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CanvaSection_GetCanvaAuthorizationUrlQuery,
		CanvaSection_GetCanvaAuthorizationUrlQueryVariables
	>(CanvaSection_GetCanvaAuthorizationUrlDocument, options);
}
export type CanvaSection_GetCanvaAuthorizationUrlQueryHookResult = ReturnType<
	typeof useCanvaSection_GetCanvaAuthorizationUrlQuery
>;
export type CanvaSection_GetCanvaAuthorizationUrlLazyQueryHookResult =
	ReturnType<typeof useCanvaSection_GetCanvaAuthorizationUrlLazyQuery>;
export type CanvaSection_GetCanvaAuthorizationUrlQueryResult =
	Apollo.QueryResult<
		CanvaSection_GetCanvaAuthorizationUrlQuery,
		CanvaSection_GetCanvaAuthorizationUrlQueryVariables
	>;
export const ZapierSection_GetGlobalVariablesDocument = gql`
	query ZapierSection_getGlobalVariables {
		getGlobalVariables {
			RPCZapierUrl
		}
	}
`;

/**
 * __useZapierSection_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useZapierSection_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZapierSection_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZapierSection_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useZapierSection_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ZapierSection_GetGlobalVariablesQuery,
		ZapierSection_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ZapierSection_GetGlobalVariablesQuery,
		ZapierSection_GetGlobalVariablesQueryVariables
	>(ZapierSection_GetGlobalVariablesDocument, options);
}
export function useZapierSection_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ZapierSection_GetGlobalVariablesQuery,
		ZapierSection_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ZapierSection_GetGlobalVariablesQuery,
		ZapierSection_GetGlobalVariablesQueryVariables
	>(ZapierSection_GetGlobalVariablesDocument, options);
}
export type ZapierSection_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useZapierSection_GetGlobalVariablesQuery
>;
export type ZapierSection_GetGlobalVariablesLazyQueryHookResult = ReturnType<
	typeof useZapierSection_GetGlobalVariablesLazyQuery
>;
export type ZapierSection_GetGlobalVariablesQueryResult = Apollo.QueryResult<
	ZapierSection_GetGlobalVariablesQuery,
	ZapierSection_GetGlobalVariablesQueryVariables
>;
export const InviteModal_GetContactWhereDocument = gql`
	query inviteModal_getContactWhere($where: ContactWhereInput!) {
		getContactWhere(where: $where) {
			id
			firstName
			lastName
			customer {
				id
				email
			}
		}
	}
`;

/**
 * __useInviteModal_GetContactWhereQuery__
 *
 * To run a query within a React component, call `useInviteModal_GetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteModal_GetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteModal_GetContactWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInviteModal_GetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InviteModal_GetContactWhereQuery,
		InviteModal_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InviteModal_GetContactWhereQuery,
		InviteModal_GetContactWhereQueryVariables
	>(InviteModal_GetContactWhereDocument, options);
}
export function useInviteModal_GetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InviteModal_GetContactWhereQuery,
		InviteModal_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InviteModal_GetContactWhereQuery,
		InviteModal_GetContactWhereQueryVariables
	>(InviteModal_GetContactWhereDocument, options);
}
export type InviteModal_GetContactWhereQueryHookResult = ReturnType<
	typeof useInviteModal_GetContactWhereQuery
>;
export type InviteModal_GetContactWhereLazyQueryHookResult = ReturnType<
	typeof useInviteModal_GetContactWhereLazyQuery
>;
export type InviteModal_GetContactWhereQueryResult = Apollo.QueryResult<
	InviteModal_GetContactWhereQuery,
	InviteModal_GetContactWhereQueryVariables
>;
export const InvoiceDetail_GetInvoiceWhereDocument = gql`
	query invoiceDetail_getInvoiceWhere(
		$where: InvoiceWhereUniqueInput!
		$data: InvoiceTokenInput
	) {
		getInvoiceWhere(where: $where, data: $data) {
			invoice {
				contact {
					id
					vendor {
						id
					}
				}
				...invoiceDetailInvoice
			}
		}
	}
	${InvoiceDetailInvoiceFragmentDoc}
`;

/**
 * __useInvoiceDetail_GetInvoiceWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceDetail_GetInvoiceWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDetail_GetInvoiceWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDetail_GetInvoiceWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceDetail_GetInvoiceWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceDetail_GetInvoiceWhereQuery,
		InvoiceDetail_GetInvoiceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceDetail_GetInvoiceWhereQuery,
		InvoiceDetail_GetInvoiceWhereQueryVariables
	>(InvoiceDetail_GetInvoiceWhereDocument, options);
}
export function useInvoiceDetail_GetInvoiceWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceDetail_GetInvoiceWhereQuery,
		InvoiceDetail_GetInvoiceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceDetail_GetInvoiceWhereQuery,
		InvoiceDetail_GetInvoiceWhereQueryVariables
	>(InvoiceDetail_GetInvoiceWhereDocument, options);
}
export type InvoiceDetail_GetInvoiceWhereQueryHookResult = ReturnType<
	typeof useInvoiceDetail_GetInvoiceWhereQuery
>;
export type InvoiceDetail_GetInvoiceWhereLazyQueryHookResult = ReturnType<
	typeof useInvoiceDetail_GetInvoiceWhereLazyQuery
>;
export type InvoiceDetail_GetInvoiceWhereQueryResult = Apollo.QueryResult<
	InvoiceDetail_GetInvoiceWhereQuery,
	InvoiceDetail_GetInvoiceWhereQueryVariables
>;
export const InvoiceDetail_GetOrgUserWhereDocument = gql`
	query invoiceDetail_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				country
				automatedRemindersEnabled
				cardConvenienceFeePercentage
				achConvenienceFeePercentage
				...invoiceViewOrganization
				users {
					id
					role
					firstName
					lastName
					user {
						id
						email
						userType
					}
				}
				services {
					id
					name
				}
			}
		}
	}
	${InvoiceViewOrganizationFragmentDoc}
`;

/**
 * __useInvoiceDetail_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceDetail_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDetail_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDetail_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceDetail_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceDetail_GetOrgUserWhereQuery,
		InvoiceDetail_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceDetail_GetOrgUserWhereQuery,
		InvoiceDetail_GetOrgUserWhereQueryVariables
	>(InvoiceDetail_GetOrgUserWhereDocument, options);
}
export function useInvoiceDetail_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceDetail_GetOrgUserWhereQuery,
		InvoiceDetail_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceDetail_GetOrgUserWhereQuery,
		InvoiceDetail_GetOrgUserWhereQueryVariables
	>(InvoiceDetail_GetOrgUserWhereDocument, options);
}
export type InvoiceDetail_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useInvoiceDetail_GetOrgUserWhereQuery
>;
export type InvoiceDetail_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useInvoiceDetail_GetOrgUserWhereLazyQuery
>;
export type InvoiceDetail_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	InvoiceDetail_GetOrgUserWhereQuery,
	InvoiceDetail_GetOrgUserWhereQueryVariables
>;
export const InvoiceEditButtonBarSendButton_SendOrResendInvoiceDocument = gql`
	mutation InvoiceEditButtonBarSendButton_sendOrResendInvoice(
		$data: SendOrResendInvoiceInput
		$where: InvoiceWhereUniqueInput!
	) {
		sendOrResendInvoice(data: $data, where: $where) {
			id
			sentAt
			...useInvoiceEditButtonBarSendButtonInvoice
		}
	}
	${UseInvoiceEditButtonBarSendButtonInvoiceFragmentDoc}
`;
export type InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationFn =
	Apollo.MutationFunction<
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation,
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationVariables
	>;

/**
 * __useInvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation__
 *
 * To run a mutation, you first call `useInvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceEditButtonBarSendButtonSendOrResendInvoiceMutation, { data, loading, error }] = useInvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation,
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation,
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationVariables
	>(InvoiceEditButtonBarSendButton_SendOrResendInvoiceDocument, options);
}
export type InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationHookResult =
	ReturnType<
		typeof useInvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation
	>;
export type InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationResult =
	Apollo.MutationResult<InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation>;
export type InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutation,
		InvoiceEditButtonBarSendButton_SendOrResendInvoiceMutationVariables
	>;
export const InvoiceEditButtonBarVoidButton_MarkInvoiceVoidDocument = gql`
	mutation InvoiceEditButtonBarVoidButton_markInvoiceVoid(
		$where: InvoiceWhereUniqueInput!
	) {
		markInvoiceVoid(where: $where) {
			id
			status
		}
	}
`;
export type InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationFn =
	Apollo.MutationFunction<
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>;

/**
 * __useInvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation__
 *
 * To run a mutation, you first call `useInvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceEditButtonBarVoidButtonMarkInvoiceVoidMutation, { data, loading, error }] = useInvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>(InvoiceEditButtonBarVoidButton_MarkInvoiceVoidDocument, options);
}
export type InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationHookResult =
	ReturnType<typeof useInvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation>;
export type InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationResult =
	Apollo.MutationResult<InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation>;
export type InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceEditButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>;
export const InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereDocument = gql`
	query InvoiceEditApplyTemplateModal_getInvoiceTemplatesWhere(
		$orderBy: [InvoiceTemplateOrderByInput]
	) {
		getInvoiceTemplatesWhere(orderBy: $orderBy) {
			invoiceTemplates {
				...invoiceEditApplyTemplateModalInvoiceTemplate
			}
		}
	}
	${InvoiceEditApplyTemplateModalInvoiceTemplateFragmentDoc}
`;

/**
 * __useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery(
	baseOptions?: Apollo.QueryHookOptions<
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery,
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery,
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryVariables
	>(InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereDocument, options);
}
export function useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery,
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery,
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryVariables
	>(InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereDocument, options);
}
export type InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryHookResult =
	ReturnType<
		typeof useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery
	>;
export type InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereLazyQueryHookResult =
	ReturnType<
		typeof useInvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereLazyQuery
	>;
export type InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryResult =
	Apollo.QueryResult<
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQuery,
		InvoiceEditApplyTemplateModal_GetInvoiceTemplatesWhereQueryVariables
	>;
export const InvoiceEdit_CreateDraftInvoiceDocument = gql`
	mutation invoiceEdit_createDraftInvoice($data: InvoiceCreateInput!) {
		createDraftInvoice(data: $data) {
			id
			status
			eventDate
			...invoiceEditInvoice
		}
	}
	${InvoiceEditInvoiceFragmentDoc}
`;
export type InvoiceEdit_CreateDraftInvoiceMutationFn = Apollo.MutationFunction<
	InvoiceEdit_CreateDraftInvoiceMutation,
	InvoiceEdit_CreateDraftInvoiceMutationVariables
>;

/**
 * __useInvoiceEdit_CreateDraftInvoiceMutation__
 *
 * To run a mutation, you first call `useInvoiceEdit_CreateDraftInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEdit_CreateDraftInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceEditCreateDraftInvoiceMutation, { data, loading, error }] = useInvoiceEdit_CreateDraftInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceEdit_CreateDraftInvoiceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceEdit_CreateDraftInvoiceMutation,
		InvoiceEdit_CreateDraftInvoiceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceEdit_CreateDraftInvoiceMutation,
		InvoiceEdit_CreateDraftInvoiceMutationVariables
	>(InvoiceEdit_CreateDraftInvoiceDocument, options);
}
export type InvoiceEdit_CreateDraftInvoiceMutationHookResult = ReturnType<
	typeof useInvoiceEdit_CreateDraftInvoiceMutation
>;
export type InvoiceEdit_CreateDraftInvoiceMutationResult =
	Apollo.MutationResult<InvoiceEdit_CreateDraftInvoiceMutation>;
export type InvoiceEdit_CreateDraftInvoiceMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceEdit_CreateDraftInvoiceMutation,
		InvoiceEdit_CreateDraftInvoiceMutationVariables
	>;
export const InvoiceEdit_UpdateInvoiceDocument = gql`
	mutation invoiceEdit_updateInvoice(
		$data: InvoiceUpdateInput!
		$where: InvoiceWhereUniqueInput!
	) {
		updateInvoice(data: $data, where: $where) {
			...invoiceEditInvoice
		}
	}
	${InvoiceEditInvoiceFragmentDoc}
`;
export type InvoiceEdit_UpdateInvoiceMutationFn = Apollo.MutationFunction<
	InvoiceEdit_UpdateInvoiceMutation,
	InvoiceEdit_UpdateInvoiceMutationVariables
>;

/**
 * __useInvoiceEdit_UpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useInvoiceEdit_UpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEdit_UpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceEditUpdateInvoiceMutation, { data, loading, error }] = useInvoiceEdit_UpdateInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceEdit_UpdateInvoiceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceEdit_UpdateInvoiceMutation,
		InvoiceEdit_UpdateInvoiceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceEdit_UpdateInvoiceMutation,
		InvoiceEdit_UpdateInvoiceMutationVariables
	>(InvoiceEdit_UpdateInvoiceDocument, options);
}
export type InvoiceEdit_UpdateInvoiceMutationHookResult = ReturnType<
	typeof useInvoiceEdit_UpdateInvoiceMutation
>;
export type InvoiceEdit_UpdateInvoiceMutationResult =
	Apollo.MutationResult<InvoiceEdit_UpdateInvoiceMutation>;
export type InvoiceEdit_UpdateInvoiceMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceEdit_UpdateInvoiceMutation,
		InvoiceEdit_UpdateInvoiceMutationVariables
	>;
export const InvoiceEdit_RequestInvoiceAttachmentUploadUrlDocument = gql`
	query InvoiceEdit_requestInvoiceAttachmentUploadUrl(
		$data: RequestAttachmentUploadUrlInput!
		$where: InvoiceWhereUniqueInput!
	) {
		requestInvoiceAttachmentUploadUrl(data: $data, where: $where) {
			uploadURL
		}
	}
`;

/**
 * __useInvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery__
 *
 * To run a query within a React component, call `useInvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery,
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery,
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryVariables
	>(InvoiceEdit_RequestInvoiceAttachmentUploadUrlDocument, options);
}
export function useInvoiceEdit_RequestInvoiceAttachmentUploadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery,
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery,
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryVariables
	>(InvoiceEdit_RequestInvoiceAttachmentUploadUrlDocument, options);
}
export type InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryHookResult =
	ReturnType<typeof useInvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery>;
export type InvoiceEdit_RequestInvoiceAttachmentUploadUrlLazyQueryHookResult =
	ReturnType<typeof useInvoiceEdit_RequestInvoiceAttachmentUploadUrlLazyQuery>;
export type InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryResult =
	Apollo.QueryResult<
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQuery,
		InvoiceEdit_RequestInvoiceAttachmentUploadUrlQueryVariables
	>;
export const InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereDocument = gql`
	query InvoiceTemplateFromUrlParamIfProvided_getInvoiceTemplateWhere(
		$where: InvoiceTemplateWhereUniqueInput!
	) {
		getInvoiceTemplateWhere(where: $where) {
			...invoiceEditApplyTemplateModalInvoiceTemplate
		}
	}
	${InvoiceEditApplyTemplateModalInvoiceTemplateFragmentDoc}
`;

/**
 * __useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryVariables
	>(
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereDocument,
		options
	);
}
export function useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryVariables
	>(
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereDocument,
		options
	);
}
export type InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryHookResult =
	ReturnType<
		typeof useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery
	>;
export type InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereLazyQueryHookResult =
	ReturnType<
		typeof useInvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereLazyQuery
	>;
export type InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryResult =
	Apollo.QueryResult<
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateFromUrlParamIfProvided_GetInvoiceTemplateWhereQueryVariables
	>;
export const InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateDocument = gql`
	mutation InvoiceTemplateEditButtonBarDeleteButton_deleteInvoiceTemplate(
		$where: InvoiceTemplateWhereUniqueInput!
	) {
		deleteInvoiceTemplate(where: $where) {
			...useInvoiceTemplateEditButtonBarDeleteButton
		}
	}
	${UseInvoiceTemplateEditButtonBarDeleteButtonFragmentDoc}
`;
export type InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationFn =
	Apollo.MutationFunction<
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation,
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationVariables
	>;

/**
 * __useInvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useInvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceTemplateEditButtonBarDeleteButtonDeleteInvoiceTemplateMutation, { data, loading, error }] = useInvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation,
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation,
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationVariables
	>(
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateDocument,
		options
	);
}
export type InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationHookResult =
	ReturnType<
		typeof useInvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation
	>;
export type InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationResult =
	Apollo.MutationResult<InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation>;
export type InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutation,
		InvoiceTemplateEditButtonBarDeleteButton_DeleteInvoiceTemplateMutationVariables
	>;
export const InvoiceTemplateEditPresentation_GetGlobalVariablesDocument = gql`
	query InvoiceTemplateEditPresentation_getGlobalVariables {
		getGlobalVariables {
			AutomatedNotificationsSupportUrl
		}
	}
`;

/**
 * __useInvoiceTemplateEditPresentation_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplateEditPresentation_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEditPresentation_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplateEditPresentation_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoiceTemplateEditPresentation_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		InvoiceTemplateEditPresentation_GetGlobalVariablesQuery,
		InvoiceTemplateEditPresentation_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceTemplateEditPresentation_GetGlobalVariablesQuery,
		InvoiceTemplateEditPresentation_GetGlobalVariablesQueryVariables
	>(InvoiceTemplateEditPresentation_GetGlobalVariablesDocument, options);
}
export function useInvoiceTemplateEditPresentation_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceTemplateEditPresentation_GetGlobalVariablesQuery,
		InvoiceTemplateEditPresentation_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceTemplateEditPresentation_GetGlobalVariablesQuery,
		InvoiceTemplateEditPresentation_GetGlobalVariablesQueryVariables
	>(InvoiceTemplateEditPresentation_GetGlobalVariablesDocument, options);
}
export type InvoiceTemplateEditPresentation_GetGlobalVariablesQueryHookResult =
	ReturnType<typeof useInvoiceTemplateEditPresentation_GetGlobalVariablesQuery>;
export type InvoiceTemplateEditPresentation_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<
		typeof useInvoiceTemplateEditPresentation_GetGlobalVariablesLazyQuery
	>;
export type InvoiceTemplateEditPresentation_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		InvoiceTemplateEditPresentation_GetGlobalVariablesQuery,
		InvoiceTemplateEditPresentation_GetGlobalVariablesQueryVariables
	>;
export const InvoiceTemplateEdit_GetInvoiceTemplateWhereDocument = gql`
	query invoiceTemplateEdit_getInvoiceTemplateWhere(
		$where: InvoiceTemplateWhereUniqueInput!
	) {
		getInvoiceTemplateWhere(where: $where) {
			...invoiceTemplateEdit
		}
	}
	${InvoiceTemplateEditFragmentDoc}
`;

/**
 * __useInvoiceTemplateEdit_GetInvoiceTemplateWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplateEdit_GetInvoiceTemplateWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEdit_GetInvoiceTemplateWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplateEdit_GetInvoiceTemplateWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplateEdit_GetInvoiceTemplateWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryVariables
	>(InvoiceTemplateEdit_GetInvoiceTemplateWhereDocument, options);
}
export function useInvoiceTemplateEdit_GetInvoiceTemplateWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryVariables
	>(InvoiceTemplateEdit_GetInvoiceTemplateWhereDocument, options);
}
export type InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryHookResult =
	ReturnType<typeof useInvoiceTemplateEdit_GetInvoiceTemplateWhereQuery>;
export type InvoiceTemplateEdit_GetInvoiceTemplateWhereLazyQueryHookResult =
	ReturnType<typeof useInvoiceTemplateEdit_GetInvoiceTemplateWhereLazyQuery>;
export type InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryResult =
	Apollo.QueryResult<
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQuery,
		InvoiceTemplateEdit_GetInvoiceTemplateWhereQueryVariables
	>;
export const InvoiceTemplateEdit_CreateInvoiceTemplateDocument = gql`
	mutation invoiceTemplateEdit_createInvoiceTemplate(
		$data: InvoiceTemplateCreateInput!
	) {
		createInvoiceTemplate(data: $data) {
			id
			...invoiceTemplateEdit
		}
	}
	${InvoiceTemplateEditFragmentDoc}
`;
export type InvoiceTemplateEdit_CreateInvoiceTemplateMutationFn =
	Apollo.MutationFunction<
		InvoiceTemplateEdit_CreateInvoiceTemplateMutation,
		InvoiceTemplateEdit_CreateInvoiceTemplateMutationVariables
	>;

/**
 * __useInvoiceTemplateEdit_CreateInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useInvoiceTemplateEdit_CreateInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEdit_CreateInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceTemplateEditCreateInvoiceTemplateMutation, { data, loading, error }] = useInvoiceTemplateEdit_CreateInvoiceTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceTemplateEdit_CreateInvoiceTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceTemplateEdit_CreateInvoiceTemplateMutation,
		InvoiceTemplateEdit_CreateInvoiceTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceTemplateEdit_CreateInvoiceTemplateMutation,
		InvoiceTemplateEdit_CreateInvoiceTemplateMutationVariables
	>(InvoiceTemplateEdit_CreateInvoiceTemplateDocument, options);
}
export type InvoiceTemplateEdit_CreateInvoiceTemplateMutationHookResult =
	ReturnType<typeof useInvoiceTemplateEdit_CreateInvoiceTemplateMutation>;
export type InvoiceTemplateEdit_CreateInvoiceTemplateMutationResult =
	Apollo.MutationResult<InvoiceTemplateEdit_CreateInvoiceTemplateMutation>;
export type InvoiceTemplateEdit_CreateInvoiceTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceTemplateEdit_CreateInvoiceTemplateMutation,
		InvoiceTemplateEdit_CreateInvoiceTemplateMutationVariables
	>;
export const InvoiceTemplateEdit_UpdateInvoiceTemplateDocument = gql`
	mutation invoiceTemplateEdit_updateInvoiceTemplate(
		$data: InvoiceTemplateUpdateInput!
		$where: InvoiceTemplateWhereUniqueInput!
	) {
		updateInvoiceTemplate(data: $data, where: $where) {
			id
			...invoiceTemplateEdit
		}
	}
	${InvoiceTemplateEditFragmentDoc}
`;
export type InvoiceTemplateEdit_UpdateInvoiceTemplateMutationFn =
	Apollo.MutationFunction<
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutation,
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutationVariables
	>;

/**
 * __useInvoiceTemplateEdit_UpdateInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useInvoiceTemplateEdit_UpdateInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEdit_UpdateInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceTemplateEditUpdateInvoiceTemplateMutation, { data, loading, error }] = useInvoiceTemplateEdit_UpdateInvoiceTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplateEdit_UpdateInvoiceTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutation,
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutation,
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutationVariables
	>(InvoiceTemplateEdit_UpdateInvoiceTemplateDocument, options);
}
export type InvoiceTemplateEdit_UpdateInvoiceTemplateMutationHookResult =
	ReturnType<typeof useInvoiceTemplateEdit_UpdateInvoiceTemplateMutation>;
export type InvoiceTemplateEdit_UpdateInvoiceTemplateMutationResult =
	Apollo.MutationResult<InvoiceTemplateEdit_UpdateInvoiceTemplateMutation>;
export type InvoiceTemplateEdit_UpdateInvoiceTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutation,
		InvoiceTemplateEdit_UpdateInvoiceTemplateMutationVariables
	>;
export const InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlDocument = gql`
	mutation invoiceTemplateEdit_requestInvoiceTemplateAttachmentUploadUrl(
		$data: RequestAttachmentUploadUrlInput!
		$where: InvoiceTemplateWhereUniqueInput!
	) {
		requestInvoiceTemplateAttachmentUploadUrl(where: $where, data: $data) {
			uploadURL
		}
	}
`;
export type InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationFn =
	Apollo.MutationFunction<
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation,
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationVariables
	>;

/**
 * __useInvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useInvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceTemplateEditRequestInvoiceTemplateAttachmentUploadUrlMutation, { data, loading, error }] = useInvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation,
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation,
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationVariables
	>(
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlDocument,
		options
	);
}
export type InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationHookResult =
	ReturnType<
		typeof useInvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation
	>;
export type InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationResult =
	Apollo.MutationResult<InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation>;
export type InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutation,
		InvoiceTemplateEdit_RequestInvoiceTemplateAttachmentUploadUrlMutationVariables
	>;
export const PaymentSection_CreateSecretsForInvoicePaymentDocument = gql`
	mutation paymentSection_createSecretsForInvoicePayment(
		$data: CreateSecretsForInvoicePaymentInput!
	) {
		createSecretsForInvoicePayment(data: $data) {
			customerSecret
			invoiceId
			currency
			onBehalfOf
			excludedPaymentMethodTypes
		}
	}
`;
export type PaymentSection_CreateSecretsForInvoicePaymentMutationFn =
	Apollo.MutationFunction<
		PaymentSection_CreateSecretsForInvoicePaymentMutation,
		PaymentSection_CreateSecretsForInvoicePaymentMutationVariables
	>;

/**
 * __usePaymentSection_CreateSecretsForInvoicePaymentMutation__
 *
 * To run a mutation, you first call `usePaymentSection_CreateSecretsForInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentSection_CreateSecretsForInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentSectionCreateSecretsForInvoicePaymentMutation, { data, loading, error }] = usePaymentSection_CreateSecretsForInvoicePaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentSection_CreateSecretsForInvoicePaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PaymentSection_CreateSecretsForInvoicePaymentMutation,
		PaymentSection_CreateSecretsForInvoicePaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PaymentSection_CreateSecretsForInvoicePaymentMutation,
		PaymentSection_CreateSecretsForInvoicePaymentMutationVariables
	>(PaymentSection_CreateSecretsForInvoicePaymentDocument, options);
}
export type PaymentSection_CreateSecretsForInvoicePaymentMutationHookResult =
	ReturnType<typeof usePaymentSection_CreateSecretsForInvoicePaymentMutation>;
export type PaymentSection_CreateSecretsForInvoicePaymentMutationResult =
	Apollo.MutationResult<PaymentSection_CreateSecretsForInvoicePaymentMutation>;
export type PaymentSection_CreateSecretsForInvoicePaymentMutationOptions =
	Apollo.BaseMutationOptions<
		PaymentSection_CreateSecretsForInvoicePaymentMutation,
		PaymentSection_CreateSecretsForInvoicePaymentMutationVariables
	>;
export const PaymentSection_CreateIntentForInvoicePaymentDocument = gql`
	mutation paymentSection_createIntentForInvoicePayment(
		$data: CreateIntentForInvoicePaymentInput!
	) {
		createIntentForInvoicePayment(data: $data) {
			id
			clientSecret
			amount
		}
	}
`;
export type PaymentSection_CreateIntentForInvoicePaymentMutationFn =
	Apollo.MutationFunction<
		PaymentSection_CreateIntentForInvoicePaymentMutation,
		PaymentSection_CreateIntentForInvoicePaymentMutationVariables
	>;

/**
 * __usePaymentSection_CreateIntentForInvoicePaymentMutation__
 *
 * To run a mutation, you first call `usePaymentSection_CreateIntentForInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentSection_CreateIntentForInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentSectionCreateIntentForInvoicePaymentMutation, { data, loading, error }] = usePaymentSection_CreateIntentForInvoicePaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentSection_CreateIntentForInvoicePaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PaymentSection_CreateIntentForInvoicePaymentMutation,
		PaymentSection_CreateIntentForInvoicePaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PaymentSection_CreateIntentForInvoicePaymentMutation,
		PaymentSection_CreateIntentForInvoicePaymentMutationVariables
	>(PaymentSection_CreateIntentForInvoicePaymentDocument, options);
}
export type PaymentSection_CreateIntentForInvoicePaymentMutationHookResult =
	ReturnType<typeof usePaymentSection_CreateIntentForInvoicePaymentMutation>;
export type PaymentSection_CreateIntentForInvoicePaymentMutationResult =
	Apollo.MutationResult<PaymentSection_CreateIntentForInvoicePaymentMutation>;
export type PaymentSection_CreateIntentForInvoicePaymentMutationOptions =
	Apollo.BaseMutationOptions<
		PaymentSection_CreateIntentForInvoicePaymentMutation,
		PaymentSection_CreateIntentForInvoicePaymentMutationVariables
	>;
export const PaymentSection_GetPaymentSourcesForCustomerDocument = gql`
	query paymentSection_getPaymentSourcesForCustomer(
		$where: UserByIdUniqueInput!
	) {
		getPaymentSourcesForCustomer(where: $where) {
			data {
				id
				bank_name
				object
				last4
				brand
				metadata {
					key
					value
				}
			}
			default_source
		}
	}
`;

/**
 * __usePaymentSection_GetPaymentSourcesForCustomerQuery__
 *
 * To run a query within a React component, call `usePaymentSection_GetPaymentSourcesForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentSection_GetPaymentSourcesForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentSection_GetPaymentSourcesForCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePaymentSection_GetPaymentSourcesForCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		PaymentSection_GetPaymentSourcesForCustomerQuery,
		PaymentSection_GetPaymentSourcesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PaymentSection_GetPaymentSourcesForCustomerQuery,
		PaymentSection_GetPaymentSourcesForCustomerQueryVariables
	>(PaymentSection_GetPaymentSourcesForCustomerDocument, options);
}
export function usePaymentSection_GetPaymentSourcesForCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PaymentSection_GetPaymentSourcesForCustomerQuery,
		PaymentSection_GetPaymentSourcesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PaymentSection_GetPaymentSourcesForCustomerQuery,
		PaymentSection_GetPaymentSourcesForCustomerQueryVariables
	>(PaymentSection_GetPaymentSourcesForCustomerDocument, options);
}
export type PaymentSection_GetPaymentSourcesForCustomerQueryHookResult =
	ReturnType<typeof usePaymentSection_GetPaymentSourcesForCustomerQuery>;
export type PaymentSection_GetPaymentSourcesForCustomerLazyQueryHookResult =
	ReturnType<typeof usePaymentSection_GetPaymentSourcesForCustomerLazyQuery>;
export type PaymentSection_GetPaymentSourcesForCustomerQueryResult =
	Apollo.QueryResult<
		PaymentSection_GetPaymentSourcesForCustomerQuery,
		PaymentSection_GetPaymentSourcesForCustomerQueryVariables
	>;
export const PaymentSection_UpdateInvoiceFromPaymentSessionDocument = gql`
	mutation paymentSection_updateInvoiceFromPaymentSession(
		$data: UpdateInvoiceFromPaymentSessionInput!
	) {
		updateInvoiceFromPaymentSession(data: $data) {
			...usePaymentSectionInvoice
		}
	}
	${UsePaymentSectionInvoiceFragmentDoc}
`;
export type PaymentSection_UpdateInvoiceFromPaymentSessionMutationFn =
	Apollo.MutationFunction<
		PaymentSection_UpdateInvoiceFromPaymentSessionMutation,
		PaymentSection_UpdateInvoiceFromPaymentSessionMutationVariables
	>;

/**
 * __usePaymentSection_UpdateInvoiceFromPaymentSessionMutation__
 *
 * To run a mutation, you first call `usePaymentSection_UpdateInvoiceFromPaymentSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentSection_UpdateInvoiceFromPaymentSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentSectionUpdateInvoiceFromPaymentSessionMutation, { data, loading, error }] = usePaymentSection_UpdateInvoiceFromPaymentSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentSection_UpdateInvoiceFromPaymentSessionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PaymentSection_UpdateInvoiceFromPaymentSessionMutation,
		PaymentSection_UpdateInvoiceFromPaymentSessionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PaymentSection_UpdateInvoiceFromPaymentSessionMutation,
		PaymentSection_UpdateInvoiceFromPaymentSessionMutationVariables
	>(PaymentSection_UpdateInvoiceFromPaymentSessionDocument, options);
}
export type PaymentSection_UpdateInvoiceFromPaymentSessionMutationHookResult =
	ReturnType<typeof usePaymentSection_UpdateInvoiceFromPaymentSessionMutation>;
export type PaymentSection_UpdateInvoiceFromPaymentSessionMutationResult =
	Apollo.MutationResult<PaymentSection_UpdateInvoiceFromPaymentSessionMutation>;
export type PaymentSection_UpdateInvoiceFromPaymentSessionMutationOptions =
	Apollo.BaseMutationOptions<
		PaymentSection_UpdateInvoiceFromPaymentSessionMutation,
		PaymentSection_UpdateInvoiceFromPaymentSessionMutationVariables
	>;
export const PaymentSection_UpdateInvoiceAutoPayDocument = gql`
	mutation paymentSection_updateInvoiceAutoPay(
		$where: InvoiceWhereUniqueInput!
		$data: InvoiceAutoPayUpdateCustomInput!
	) {
		updateInvoiceAutoPay(where: $where, data: $data) {
			id
			paymentInstallments {
				id
				status
				scheduledPaymentDate
			}
			...usePaymentSectionInvoice
		}
	}
	${UsePaymentSectionInvoiceFragmentDoc}
`;
export type PaymentSection_UpdateInvoiceAutoPayMutationFn =
	Apollo.MutationFunction<
		PaymentSection_UpdateInvoiceAutoPayMutation,
		PaymentSection_UpdateInvoiceAutoPayMutationVariables
	>;

/**
 * __usePaymentSection_UpdateInvoiceAutoPayMutation__
 *
 * To run a mutation, you first call `usePaymentSection_UpdateInvoiceAutoPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentSection_UpdateInvoiceAutoPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentSectionUpdateInvoiceAutoPayMutation, { data, loading, error }] = usePaymentSection_UpdateInvoiceAutoPayMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentSection_UpdateInvoiceAutoPayMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PaymentSection_UpdateInvoiceAutoPayMutation,
		PaymentSection_UpdateInvoiceAutoPayMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PaymentSection_UpdateInvoiceAutoPayMutation,
		PaymentSection_UpdateInvoiceAutoPayMutationVariables
	>(PaymentSection_UpdateInvoiceAutoPayDocument, options);
}
export type PaymentSection_UpdateInvoiceAutoPayMutationHookResult = ReturnType<
	typeof usePaymentSection_UpdateInvoiceAutoPayMutation
>;
export type PaymentSection_UpdateInvoiceAutoPayMutationResult =
	Apollo.MutationResult<PaymentSection_UpdateInvoiceAutoPayMutation>;
export type PaymentSection_UpdateInvoiceAutoPayMutationOptions =
	Apollo.BaseMutationOptions<
		PaymentSection_UpdateInvoiceAutoPayMutation,
		PaymentSection_UpdateInvoiceAutoPayMutationVariables
	>;
export const InvoiceViewButtonBar_ApproveInvoiceDocument = gql`
	mutation invoiceViewButtonBar_approveInvoice(
		$where: InvoiceWhereInputWithGuestToken!
	) {
		approveInvoice(where: $where) {
			id
			approvedByPlanner
		}
	}
`;
export type InvoiceViewButtonBar_ApproveInvoiceMutationFn =
	Apollo.MutationFunction<
		InvoiceViewButtonBar_ApproveInvoiceMutation,
		InvoiceViewButtonBar_ApproveInvoiceMutationVariables
	>;

/**
 * __useInvoiceViewButtonBar_ApproveInvoiceMutation__
 *
 * To run a mutation, you first call `useInvoiceViewButtonBar_ApproveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewButtonBar_ApproveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewButtonBarApproveInvoiceMutation, { data, loading, error }] = useInvoiceViewButtonBar_ApproveInvoiceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewButtonBar_ApproveInvoiceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewButtonBar_ApproveInvoiceMutation,
		InvoiceViewButtonBar_ApproveInvoiceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewButtonBar_ApproveInvoiceMutation,
		InvoiceViewButtonBar_ApproveInvoiceMutationVariables
	>(InvoiceViewButtonBar_ApproveInvoiceDocument, options);
}
export type InvoiceViewButtonBar_ApproveInvoiceMutationHookResult = ReturnType<
	typeof useInvoiceViewButtonBar_ApproveInvoiceMutation
>;
export type InvoiceViewButtonBar_ApproveInvoiceMutationResult =
	Apollo.MutationResult<InvoiceViewButtonBar_ApproveInvoiceMutation>;
export type InvoiceViewButtonBar_ApproveInvoiceMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewButtonBar_ApproveInvoiceMutation,
		InvoiceViewButtonBar_ApproveInvoiceMutationVariables
	>;
export const InvoiceViewButtonBar_ExportInvoiceDocument = gql`
	query invoiceViewButtonBar_exportInvoice(
		$where: InvoiceWhereUniqueInput!
		$data: InvoiceExportInput!
	) {
		exportInvoice(where: $where, data: $data) {
			url
		}
	}
`;

/**
 * __useInvoiceViewButtonBar_ExportInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceViewButtonBar_ExportInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewButtonBar_ExportInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceViewButtonBar_ExportInvoiceQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceViewButtonBar_ExportInvoiceQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceViewButtonBar_ExportInvoiceQuery,
		InvoiceViewButtonBar_ExportInvoiceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceViewButtonBar_ExportInvoiceQuery,
		InvoiceViewButtonBar_ExportInvoiceQueryVariables
	>(InvoiceViewButtonBar_ExportInvoiceDocument, options);
}
export function useInvoiceViewButtonBar_ExportInvoiceLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceViewButtonBar_ExportInvoiceQuery,
		InvoiceViewButtonBar_ExportInvoiceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceViewButtonBar_ExportInvoiceQuery,
		InvoiceViewButtonBar_ExportInvoiceQueryVariables
	>(InvoiceViewButtonBar_ExportInvoiceDocument, options);
}
export type InvoiceViewButtonBar_ExportInvoiceQueryHookResult = ReturnType<
	typeof useInvoiceViewButtonBar_ExportInvoiceQuery
>;
export type InvoiceViewButtonBar_ExportInvoiceLazyQueryHookResult = ReturnType<
	typeof useInvoiceViewButtonBar_ExportInvoiceLazyQuery
>;
export type InvoiceViewButtonBar_ExportInvoiceQueryResult = Apollo.QueryResult<
	InvoiceViewButtonBar_ExportInvoiceQuery,
	InvoiceViewButtonBar_ExportInvoiceQueryVariables
>;
export const InvoiceViewButtonBar_SendOrResendInvoiceDocument = gql`
	mutation invoiceViewButtonBar_sendOrResendInvoice(
		$where: InvoiceWhereUniqueInput!
		$data: SendOrResendInvoiceInput
	) {
		sendOrResendInvoice(where: $where, data: $data) {
			id
			status
			title
			totalAmount
			lineItems {
				id
				rate
				quantity
				taxPercentage
			}
			discountAmount
			paymentInstallments {
				id
				status
				dueDate
			}
		}
	}
`;
export type InvoiceViewButtonBar_SendOrResendInvoiceMutationFn =
	Apollo.MutationFunction<
		InvoiceViewButtonBar_SendOrResendInvoiceMutation,
		InvoiceViewButtonBar_SendOrResendInvoiceMutationVariables
	>;

/**
 * __useInvoiceViewButtonBar_SendOrResendInvoiceMutation__
 *
 * To run a mutation, you first call `useInvoiceViewButtonBar_SendOrResendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewButtonBar_SendOrResendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewButtonBarSendOrResendInvoiceMutation, { data, loading, error }] = useInvoiceViewButtonBar_SendOrResendInvoiceMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceViewButtonBar_SendOrResendInvoiceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewButtonBar_SendOrResendInvoiceMutation,
		InvoiceViewButtonBar_SendOrResendInvoiceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewButtonBar_SendOrResendInvoiceMutation,
		InvoiceViewButtonBar_SendOrResendInvoiceMutationVariables
	>(InvoiceViewButtonBar_SendOrResendInvoiceDocument, options);
}
export type InvoiceViewButtonBar_SendOrResendInvoiceMutationHookResult =
	ReturnType<typeof useInvoiceViewButtonBar_SendOrResendInvoiceMutation>;
export type InvoiceViewButtonBar_SendOrResendInvoiceMutationResult =
	Apollo.MutationResult<InvoiceViewButtonBar_SendOrResendInvoiceMutation>;
export type InvoiceViewButtonBar_SendOrResendInvoiceMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewButtonBar_SendOrResendInvoiceMutation,
		InvoiceViewButtonBar_SendOrResendInvoiceMutationVariables
	>;
export const InvoiceViewButtonBarVoidButton_MarkInvoiceVoidDocument = gql`
	mutation InvoiceViewButtonBarVoidButton_markInvoiceVoid(
		$where: InvoiceWhereUniqueInput!
	) {
		markInvoiceVoid(where: $where) {
			id
			status
		}
	}
`;
export type InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationFn =
	Apollo.MutationFunction<
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>;

/**
 * __useInvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation__
 *
 * To run a mutation, you first call `useInvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewButtonBarVoidButtonMarkInvoiceVoidMutation, { data, loading, error }] = useInvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>(InvoiceViewButtonBarVoidButton_MarkInvoiceVoidDocument, options);
}
export type InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationHookResult =
	ReturnType<typeof useInvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation>;
export type InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationResult =
	Apollo.MutationResult<InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation>;
export type InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutation,
		InvoiceViewButtonBarVoidButton_MarkInvoiceVoidMutationVariables
	>;
export const InvoiceViewInvoice_GetInvoiceHistoryDocument = gql`
	query invoiceViewInvoice_getInvoiceHistory(
		$where: EventWhereInput
		$orderBy: [EventOrderByInput]
	) {
		getEventsWhere(where: $where, orderBy: $orderBy) {
			...invoiceViewHistoryItemEvent
		}
	}
	${InvoiceViewHistoryItemEventFragmentDoc}
`;

/**
 * __useInvoiceViewInvoice_GetInvoiceHistoryQuery__
 *
 * To run a query within a React component, call `useInvoiceViewInvoice_GetInvoiceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewInvoice_GetInvoiceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceViewInvoice_GetInvoiceHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInvoiceViewInvoice_GetInvoiceHistoryQuery(
	baseOptions?: Apollo.QueryHookOptions<
		InvoiceViewInvoice_GetInvoiceHistoryQuery,
		InvoiceViewInvoice_GetInvoiceHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceViewInvoice_GetInvoiceHistoryQuery,
		InvoiceViewInvoice_GetInvoiceHistoryQueryVariables
	>(InvoiceViewInvoice_GetInvoiceHistoryDocument, options);
}
export function useInvoiceViewInvoice_GetInvoiceHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceViewInvoice_GetInvoiceHistoryQuery,
		InvoiceViewInvoice_GetInvoiceHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceViewInvoice_GetInvoiceHistoryQuery,
		InvoiceViewInvoice_GetInvoiceHistoryQueryVariables
	>(InvoiceViewInvoice_GetInvoiceHistoryDocument, options);
}
export type InvoiceViewInvoice_GetInvoiceHistoryQueryHookResult = ReturnType<
	typeof useInvoiceViewInvoice_GetInvoiceHistoryQuery
>;
export type InvoiceViewInvoice_GetInvoiceHistoryLazyQueryHookResult =
	ReturnType<typeof useInvoiceViewInvoice_GetInvoiceHistoryLazyQuery>;
export type InvoiceViewInvoice_GetInvoiceHistoryQueryResult =
	Apollo.QueryResult<
		InvoiceViewInvoice_GetInvoiceHistoryQuery,
		InvoiceViewInvoice_GetInvoiceHistoryQueryVariables
	>;
export const InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentDocument = gql`
	mutation invoiceViewPaymentInstallmentPaymentModal_updatePaidInstallment(
		$data: UpdatePaidInstallmentInput!
		$where: PaymentInstallmentWhereUniqueInput!
	) {
		updatePaidInstallment(data: $data, where: $where) {
			id
			status
			paymentInstallments {
				...invoiceViewPaymentInstallmentPaymentModal
			}
		}
	}
	${InvoiceViewPaymentInstallmentPaymentModalFragmentDoc}
`;
export type InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationFn =
	Apollo.MutationFunction<
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationVariables
	>;

/**
 * __useInvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation__
 *
 * To run a mutation, you first call `useInvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewPaymentInstallmentPaymentModalUpdatePaidInstallmentMutation, { data, loading, error }] = useInvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationVariables
	>(
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentDocument,
		options
	);
}
export type InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation
	>;
export type InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationResult =
	Apollo.MutationResult<InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation>;
export type InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UpdatePaidInstallmentMutationVariables
	>;
export const InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentDocument = gql`
	mutation invoiceViewPaymentInstallmentPaymentModal_recordOfflinePayment(
		$data: RecordOfflinePaymentInput!
		$where: PaymentInstallmentWhereUniqueInput!
	) {
		recordOfflinePayment(data: $data, where: $where) {
			id
			status
			isPastDue
			paymentInstallments {
				...invoiceViewPaymentInstallmentPaymentModal
			}
		}
	}
	${InvoiceViewPaymentInstallmentPaymentModalFragmentDoc}
`;
export type InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationFn =
	Apollo.MutationFunction<
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationVariables
	>;

/**
 * __useInvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation__
 *
 * To run a mutation, you first call `useInvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewPaymentInstallmentPaymentModalRecordOfflinePaymentMutation, { data, loading, error }] = useInvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationVariables
	>(
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentDocument,
		options
	);
}
export type InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation
	>;
export type InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationResult =
	Apollo.MutationResult<InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation>;
export type InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentPaymentModal_RecordOfflinePaymentMutationVariables
	>;
export const InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundDocument = gql`
	mutation invoiceViewPaymentInstallmentPaymentModal_unrecordOfflinePaymentOrRefund(
		$data: RecordOfflinePaymentOrRefundInput!
		$where: PaymentInstallmentWhereUniqueInput!
	) {
		unrecordOfflinePaymentOrRefund(data: $data, where: $where) {
			id
			status
			isPastDue
		}
	}
`;
export type InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationFn =
	Apollo.MutationFunction<
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>;

/**
 * __useInvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation__
 *
 * To run a mutation, you first call `useInvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewPaymentInstallmentPaymentModalUnrecordOfflinePaymentOrRefundMutation, { data, loading, error }] = useInvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>(
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundDocument,
		options
	);
}
export type InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation
	>;
export type InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationResult =
	Apollo.MutationResult<InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation>;
export type InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentPaymentModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>;
export const InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentDocument = gql`
	mutation invoiceViewPaymentInstallmentRefundModal_refundInstallment(
		$data: RefundInstallmentInput!
	) {
		refundInstallment(data: $data) {
			id
			status
			paymentInstallments {
				...invoiceViewPaymentInstallmentRefundModalPaymentInstallment
			}
		}
	}
	${InvoiceViewPaymentInstallmentRefundModalPaymentInstallmentFragmentDoc}
`;
export type InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationFn =
	Apollo.MutationFunction<
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationVariables
	>;

/**
 * __useInvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation__
 *
 * To run a mutation, you first call `useInvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewPaymentInstallmentRefundModalRefundInstallmentMutation, { data, loading, error }] = useInvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationVariables
	>(
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentDocument,
		options
	);
}
export type InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation
	>;
export type InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationResult =
	Apollo.MutationResult<InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation>;
export type InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundInstallmentMutationVariables
	>;
export const InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentDocument = gql`
	mutation invoiceViewPaymentInstallmentRefundModal_updateRefundedInstallment(
		$data: UpdateRefundedInstallmentInput!
		$where: PaymentInstallmentWhereUniqueInput!
	) {
		updateRefundedInstallment(data: $data, where: $where) {
			id
			status
			paymentInstallments {
				...invoiceViewPaymentInstallmentRefundModalPaymentInstallment
			}
		}
	}
	${InvoiceViewPaymentInstallmentRefundModalPaymentInstallmentFragmentDoc}
`;
export type InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationFn =
	Apollo.MutationFunction<
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationVariables
	>;

/**
 * __useInvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation__
 *
 * To run a mutation, you first call `useInvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewPaymentInstallmentRefundModalUpdateRefundedInstallmentMutation, { data, loading, error }] = useInvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationVariables
	>(
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentDocument,
		options
	);
}
export type InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation
	>;
export type InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationResult =
	Apollo.MutationResult<InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation>;
export type InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutation,
		InvoiceViewPaymentInstallmentRefundModal_UpdateRefundedInstallmentMutationVariables
	>;
export const InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentDocument = gql`
	mutation invoiceViewPaymentInstallmentRefundModal_refundOfflinePayment(
		$data: RecordOfflineRefundInput!
		$where: PaymentInstallmentWhereUniqueInput!
	) {
		refundOfflinePayment(data: $data, where: $where) {
			id
			status
			paymentInstallments {
				...invoiceViewPaymentInstallmentRefundModalPaymentInstallment
			}
		}
	}
	${InvoiceViewPaymentInstallmentRefundModalPaymentInstallmentFragmentDoc}
`;
export type InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationFn =
	Apollo.MutationFunction<
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationVariables
	>;

/**
 * __useInvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation__
 *
 * To run a mutation, you first call `useInvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewPaymentInstallmentRefundModalRefundOfflinePaymentMutation, { data, loading, error }] = useInvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationVariables
	>(
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentDocument,
		options
	);
}
export type InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation
	>;
export type InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationResult =
	Apollo.MutationResult<InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation>;
export type InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutation,
		InvoiceViewPaymentInstallmentRefundModal_RefundOfflinePaymentMutationVariables
	>;
export const InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundDocument = gql`
	mutation invoiceViewPaymentInstallmentRefundModal_unrecordOfflinePaymentOrRefund(
		$data: RecordOfflinePaymentOrRefundInput!
		$where: PaymentInstallmentWhereUniqueInput!
	) {
		unrecordOfflinePaymentOrRefund(data: $data, where: $where) {
			id
			status
			isPastDue
		}
	}
`;
export type InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationFn =
	Apollo.MutationFunction<
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>;

/**
 * __useInvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation__
 *
 * To run a mutation, you first call `useInvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceViewPaymentInstallmentRefundModalUnrecordOfflinePaymentOrRefundMutation, { data, loading, error }] = useInvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>(
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundDocument,
		options
	);
}
export type InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation
	>;
export type InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationResult =
	Apollo.MutationResult<InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation>;
export type InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutation,
		InvoiceViewPaymentInstallmentRefundModal_UnrecordOfflinePaymentOrRefundMutationVariables
	>;
export const InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsDocument = gql`
	query invoiceViewPaymentMethod_getPaymentInstallmentDetails(
		$where: PaymentInstallmentWhereUniqueInput!
		$data: InvoiceTokenInput
	) {
		getPaymentInstallmentDetails(where: $where, data: $data) {
			type
			last4
		}
	}
`;

/**
 * __useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery__
 *
 * To run a query within a React component, call `useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery,
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery,
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryVariables
	>(InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsDocument, options);
}
export function useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery,
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery,
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryVariables
	>(InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsDocument, options);
}
export type InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery
	>;
export type InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsLazyQueryHookResult =
	ReturnType<
		typeof useInvoiceViewPaymentMethod_GetPaymentInstallmentDetailsLazyQuery
	>;
export type InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryResult =
	Apollo.QueryResult<
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQuery,
		InvoiceViewPaymentMethod_GetPaymentInstallmentDetailsQueryVariables
	>;
export const InvoiceAttachment_GetInvoiceWhereDocument = gql`
	query invoiceAttachment_getInvoiceWhere(
		$where: InvoiceWhereUniqueInput!
		$data: InvoiceTokenInput
	) {
		getInvoiceWhere(where: $where, data: $data) {
			invoice {
				...invoiceAttachmentInvoice
			}
		}
	}
	${InvoiceAttachmentInvoiceFragmentDoc}
`;

/**
 * __useInvoiceAttachment_GetInvoiceWhereQuery__
 *
 * To run a query within a React component, call `useInvoiceAttachment_GetInvoiceWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceAttachment_GetInvoiceWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceAttachment_GetInvoiceWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceAttachment_GetInvoiceWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceAttachment_GetInvoiceWhereQuery,
		InvoiceAttachment_GetInvoiceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceAttachment_GetInvoiceWhereQuery,
		InvoiceAttachment_GetInvoiceWhereQueryVariables
	>(InvoiceAttachment_GetInvoiceWhereDocument, options);
}
export function useInvoiceAttachment_GetInvoiceWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceAttachment_GetInvoiceWhereQuery,
		InvoiceAttachment_GetInvoiceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceAttachment_GetInvoiceWhereQuery,
		InvoiceAttachment_GetInvoiceWhereQueryVariables
	>(InvoiceAttachment_GetInvoiceWhereDocument, options);
}
export type InvoiceAttachment_GetInvoiceWhereQueryHookResult = ReturnType<
	typeof useInvoiceAttachment_GetInvoiceWhereQuery
>;
export type InvoiceAttachment_GetInvoiceWhereLazyQueryHookResult = ReturnType<
	typeof useInvoiceAttachment_GetInvoiceWhereLazyQuery
>;
export type InvoiceAttachment_GetInvoiceWhereQueryResult = Apollo.QueryResult<
	InvoiceAttachment_GetInvoiceWhereQuery,
	InvoiceAttachment_GetInvoiceWhereQueryVariables
>;
export const InvoiceViewPresentation_GetSharableInvoiceLinkDocument = gql`
	query invoiceViewPresentation_GetSharableInvoiceLink(
		$where: InvoiceWhereUniqueInput!
	) {
		getSharableInvoiceLink(where: $where)
	}
`;

/**
 * __useInvoiceViewPresentation_GetSharableInvoiceLinkQuery__
 *
 * To run a query within a React component, call `useInvoiceViewPresentation_GetSharableInvoiceLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewPresentation_GetSharableInvoiceLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceViewPresentation_GetSharableInvoiceLinkQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewPresentation_GetSharableInvoiceLinkQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceViewPresentation_GetSharableInvoiceLinkQuery,
		InvoiceViewPresentation_GetSharableInvoiceLinkQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceViewPresentation_GetSharableInvoiceLinkQuery,
		InvoiceViewPresentation_GetSharableInvoiceLinkQueryVariables
	>(InvoiceViewPresentation_GetSharableInvoiceLinkDocument, options);
}
export function useInvoiceViewPresentation_GetSharableInvoiceLinkLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceViewPresentation_GetSharableInvoiceLinkQuery,
		InvoiceViewPresentation_GetSharableInvoiceLinkQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceViewPresentation_GetSharableInvoiceLinkQuery,
		InvoiceViewPresentation_GetSharableInvoiceLinkQueryVariables
	>(InvoiceViewPresentation_GetSharableInvoiceLinkDocument, options);
}
export type InvoiceViewPresentation_GetSharableInvoiceLinkQueryHookResult =
	ReturnType<typeof useInvoiceViewPresentation_GetSharableInvoiceLinkQuery>;
export type InvoiceViewPresentation_GetSharableInvoiceLinkLazyQueryHookResult =
	ReturnType<typeof useInvoiceViewPresentation_GetSharableInvoiceLinkLazyQuery>;
export type InvoiceViewPresentation_GetSharableInvoiceLinkQueryResult =
	Apollo.QueryResult<
		InvoiceViewPresentation_GetSharableInvoiceLinkQuery,
		InvoiceViewPresentation_GetSharableInvoiceLinkQueryVariables
	>;
export const InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesDocument = gql`
	query InvoiceViewAutoPayForm_GetStripePaymentCapabilities(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripePaymentCapabilities(where: $where) {
			card_payments
			acss_debit_payments
		}
	}
`;

/**
 * __useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery__
 *
 * To run a query within a React component, call `useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery,
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery,
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryVariables
	>(InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesDocument, options);
}
export function useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery,
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery,
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryVariables
	>(InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesDocument, options);
}
export type InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryHookResult =
	ReturnType<
		typeof useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery
	>;
export type InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesLazyQueryHookResult =
	ReturnType<
		typeof useInvoiceViewAutoPayForm_GetStripePaymentCapabilitiesLazyQuery
	>;
export type InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryResult =
	Apollo.QueryResult<
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQuery,
		InvoiceViewAutoPayForm_GetStripePaymentCapabilitiesQueryVariables
	>;
export const InvoiceAutopay_UpdateInvoiceAutopayDocument = gql`
	mutation InvoiceAutopay_updateInvoiceAutopay(
		$where: InvoiceWhereUniqueInput!
		$data: InvoiceAutoPayUpdateCustomInput!
	) {
		updateInvoiceAutoPay(where: $where, data: $data) {
			...useInvoiceAutopayInvoice
		}
	}
	${UseInvoiceAutopayInvoiceFragmentDoc}
`;
export type InvoiceAutopay_UpdateInvoiceAutopayMutationFn =
	Apollo.MutationFunction<
		InvoiceAutopay_UpdateInvoiceAutopayMutation,
		InvoiceAutopay_UpdateInvoiceAutopayMutationVariables
	>;

/**
 * __useInvoiceAutopay_UpdateInvoiceAutopayMutation__
 *
 * To run a mutation, you first call `useInvoiceAutopay_UpdateInvoiceAutopayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceAutopay_UpdateInvoiceAutopayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceAutopayUpdateInvoiceAutopayMutation, { data, loading, error }] = useInvoiceAutopay_UpdateInvoiceAutopayMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoiceAutopay_UpdateInvoiceAutopayMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceAutopay_UpdateInvoiceAutopayMutation,
		InvoiceAutopay_UpdateInvoiceAutopayMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceAutopay_UpdateInvoiceAutopayMutation,
		InvoiceAutopay_UpdateInvoiceAutopayMutationVariables
	>(InvoiceAutopay_UpdateInvoiceAutopayDocument, options);
}
export type InvoiceAutopay_UpdateInvoiceAutopayMutationHookResult = ReturnType<
	typeof useInvoiceAutopay_UpdateInvoiceAutopayMutation
>;
export type InvoiceAutopay_UpdateInvoiceAutopayMutationResult =
	Apollo.MutationResult<InvoiceAutopay_UpdateInvoiceAutopayMutation>;
export type InvoiceAutopay_UpdateInvoiceAutopayMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceAutopay_UpdateInvoiceAutopayMutation,
		InvoiceAutopay_UpdateInvoiceAutopayMutationVariables
	>;
export const UseInvoiceAutopay_GetPaymentMethodSessionSecretsDocument = gql`
	query useInvoiceAutopay_getPaymentMethodSessionSecrets(
		$where: PaymentMethodSessionSecretsInput
	) {
		getPaymentMethodSessionSecrets(where: $where) {
			clientSecret
			customerSessionClientSecret
		}
	}
`;

/**
 * __useUseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery__
 *
 * To run a query within a React component, call `useUseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery,
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery,
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryVariables
	>(UseInvoiceAutopay_GetPaymentMethodSessionSecretsDocument, options);
}
export function useUseInvoiceAutopay_GetPaymentMethodSessionSecretsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery,
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery,
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryVariables
	>(UseInvoiceAutopay_GetPaymentMethodSessionSecretsDocument, options);
}
export type UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryHookResult =
	ReturnType<typeof useUseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery>;
export type UseInvoiceAutopay_GetPaymentMethodSessionSecretsLazyQueryHookResult =
	ReturnType<
		typeof useUseInvoiceAutopay_GetPaymentMethodSessionSecretsLazyQuery
	>;
export type UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryResult =
	Apollo.QueryResult<
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQuery,
		UseInvoiceAutopay_GetPaymentMethodSessionSecretsQueryVariables
	>;
export const UseInvoiceMetrics_GetDashboardStatsForOrgDocument = gql`
	query useInvoiceMetrics_getDashboardStatsForOrg(
		$where: DashboardWhereInput!
	) {
		getDashboardStatsForOrg(where: $where) {
			paymentsSummary {
				...useInvoiceMetrics_paymentsSummary
			}
		}
	}
	${UseInvoiceMetrics_PaymentsSummaryFragmentDoc}
`;

/**
 * __useUseInvoiceMetrics_GetDashboardStatsForOrgQuery__
 *
 * To run a query within a React component, call `useUseInvoiceMetrics_GetDashboardStatsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseInvoiceMetrics_GetDashboardStatsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseInvoiceMetrics_GetDashboardStatsForOrgQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseInvoiceMetrics_GetDashboardStatsForOrgQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseInvoiceMetrics_GetDashboardStatsForOrgQuery,
		UseInvoiceMetrics_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseInvoiceMetrics_GetDashboardStatsForOrgQuery,
		UseInvoiceMetrics_GetDashboardStatsForOrgQueryVariables
	>(UseInvoiceMetrics_GetDashboardStatsForOrgDocument, options);
}
export function useUseInvoiceMetrics_GetDashboardStatsForOrgLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseInvoiceMetrics_GetDashboardStatsForOrgQuery,
		UseInvoiceMetrics_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseInvoiceMetrics_GetDashboardStatsForOrgQuery,
		UseInvoiceMetrics_GetDashboardStatsForOrgQueryVariables
	>(UseInvoiceMetrics_GetDashboardStatsForOrgDocument, options);
}
export type UseInvoiceMetrics_GetDashboardStatsForOrgQueryHookResult =
	ReturnType<typeof useUseInvoiceMetrics_GetDashboardStatsForOrgQuery>;
export type UseInvoiceMetrics_GetDashboardStatsForOrgLazyQueryHookResult =
	ReturnType<typeof useUseInvoiceMetrics_GetDashboardStatsForOrgLazyQuery>;
export type UseInvoiceMetrics_GetDashboardStatsForOrgQueryResult =
	Apollo.QueryResult<
		UseInvoiceMetrics_GetDashboardStatsForOrgQuery,
		UseInvoiceMetrics_GetDashboardStatsForOrgQueryVariables
	>;
export const InvoiceTableSubmenu_GetSharableInvoiceLinkDocument = gql`
	query invoiceTableSubmenu_getSharableInvoiceLink(
		$where: InvoiceWhereUniqueInput!
	) {
		getSharableInvoiceLink(where: $where)
	}
`;

/**
 * __useInvoiceTableSubmenu_GetSharableInvoiceLinkQuery__
 *
 * To run a query within a React component, call `useInvoiceTableSubmenu_GetSharableInvoiceLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTableSubmenu_GetSharableInvoiceLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTableSubmenu_GetSharableInvoiceLinkQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTableSubmenu_GetSharableInvoiceLinkQuery(
	baseOptions: Apollo.QueryHookOptions<
		InvoiceTableSubmenu_GetSharableInvoiceLinkQuery,
		InvoiceTableSubmenu_GetSharableInvoiceLinkQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceTableSubmenu_GetSharableInvoiceLinkQuery,
		InvoiceTableSubmenu_GetSharableInvoiceLinkQueryVariables
	>(InvoiceTableSubmenu_GetSharableInvoiceLinkDocument, options);
}
export function useInvoiceTableSubmenu_GetSharableInvoiceLinkLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceTableSubmenu_GetSharableInvoiceLinkQuery,
		InvoiceTableSubmenu_GetSharableInvoiceLinkQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceTableSubmenu_GetSharableInvoiceLinkQuery,
		InvoiceTableSubmenu_GetSharableInvoiceLinkQueryVariables
	>(InvoiceTableSubmenu_GetSharableInvoiceLinkDocument, options);
}
export type InvoiceTableSubmenu_GetSharableInvoiceLinkQueryHookResult =
	ReturnType<typeof useInvoiceTableSubmenu_GetSharableInvoiceLinkQuery>;
export type InvoiceTableSubmenu_GetSharableInvoiceLinkLazyQueryHookResult =
	ReturnType<typeof useInvoiceTableSubmenu_GetSharableInvoiceLinkLazyQuery>;
export type InvoiceTableSubmenu_GetSharableInvoiceLinkQueryResult =
	Apollo.QueryResult<
		InvoiceTableSubmenu_GetSharableInvoiceLinkQuery,
		InvoiceTableSubmenu_GetSharableInvoiceLinkQueryVariables
	>;
export const UseMuiInvoicesTable_ExportInvoicesDocument = gql`
	query useMuiInvoicesTable_exportInvoices($data: ExportInvoicesDataInput!) {
		exportInvoices(data: $data)
	}
`;

/**
 * __useUseMuiInvoicesTable_ExportInvoicesQuery__
 *
 * To run a query within a React component, call `useUseMuiInvoicesTable_ExportInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMuiInvoicesTable_ExportInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMuiInvoicesTable_ExportInvoicesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseMuiInvoicesTable_ExportInvoicesQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseMuiInvoicesTable_ExportInvoicesQuery,
		UseMuiInvoicesTable_ExportInvoicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseMuiInvoicesTable_ExportInvoicesQuery,
		UseMuiInvoicesTable_ExportInvoicesQueryVariables
	>(UseMuiInvoicesTable_ExportInvoicesDocument, options);
}
export function useUseMuiInvoicesTable_ExportInvoicesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseMuiInvoicesTable_ExportInvoicesQuery,
		UseMuiInvoicesTable_ExportInvoicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseMuiInvoicesTable_ExportInvoicesQuery,
		UseMuiInvoicesTable_ExportInvoicesQueryVariables
	>(UseMuiInvoicesTable_ExportInvoicesDocument, options);
}
export type UseMuiInvoicesTable_ExportInvoicesQueryHookResult = ReturnType<
	typeof useUseMuiInvoicesTable_ExportInvoicesQuery
>;
export type UseMuiInvoicesTable_ExportInvoicesLazyQueryHookResult = ReturnType<
	typeof useUseMuiInvoicesTable_ExportInvoicesLazyQuery
>;
export type UseMuiInvoicesTable_ExportInvoicesQueryResult = Apollo.QueryResult<
	UseMuiInvoicesTable_ExportInvoicesQuery,
	UseMuiInvoicesTable_ExportInvoicesQueryVariables
>;
export const UseMuiInvoicesTable_SendOrResendInvoiceDocument = gql`
	mutation useMuiInvoicesTable_sendOrResendInvoice(
		$where: InvoiceWhereUniqueInput!
	) {
		sendOrResendInvoice(where: $where) {
			...invoicesTable
		}
	}
	${InvoicesTableFragmentDoc}
`;
export type UseMuiInvoicesTable_SendOrResendInvoiceMutationFn =
	Apollo.MutationFunction<
		UseMuiInvoicesTable_SendOrResendInvoiceMutation,
		UseMuiInvoicesTable_SendOrResendInvoiceMutationVariables
	>;

/**
 * __useUseMuiInvoicesTable_SendOrResendInvoiceMutation__
 *
 * To run a mutation, you first call `useUseMuiInvoicesTable_SendOrResendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseMuiInvoicesTable_SendOrResendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useMuiInvoicesTableSendOrResendInvoiceMutation, { data, loading, error }] = useUseMuiInvoicesTable_SendOrResendInvoiceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseMuiInvoicesTable_SendOrResendInvoiceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseMuiInvoicesTable_SendOrResendInvoiceMutation,
		UseMuiInvoicesTable_SendOrResendInvoiceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseMuiInvoicesTable_SendOrResendInvoiceMutation,
		UseMuiInvoicesTable_SendOrResendInvoiceMutationVariables
	>(UseMuiInvoicesTable_SendOrResendInvoiceDocument, options);
}
export type UseMuiInvoicesTable_SendOrResendInvoiceMutationHookResult =
	ReturnType<typeof useUseMuiInvoicesTable_SendOrResendInvoiceMutation>;
export type UseMuiInvoicesTable_SendOrResendInvoiceMutationResult =
	Apollo.MutationResult<UseMuiInvoicesTable_SendOrResendInvoiceMutation>;
export type UseMuiInvoicesTable_SendOrResendInvoiceMutationOptions =
	Apollo.BaseMutationOptions<
		UseMuiInvoicesTable_SendOrResendInvoiceMutation,
		UseMuiInvoicesTable_SendOrResendInvoiceMutationVariables
	>;
export const UseMuiInvoicesTable_GetInvoicesForCustomerDocument = gql`
	query useMuiInvoicesTable_getInvoicesForCustomer(
		$where: GetInvoicesForCustomerInput!
		$orderBy: [InvoiceOrderByInput]
		$skip: Int
		$take: Int
	) {
		getInvoicesForCustomer(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			invoices {
				...invoicesTable
			}
		}
	}
	${InvoicesTableFragmentDoc}
`;

/**
 * __useUseMuiInvoicesTable_GetInvoicesForCustomerQuery__
 *
 * To run a query within a React component, call `useUseMuiInvoicesTable_GetInvoicesForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMuiInvoicesTable_GetInvoicesForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMuiInvoicesTable_GetInvoicesForCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useUseMuiInvoicesTable_GetInvoicesForCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseMuiInvoicesTable_GetInvoicesForCustomerQuery,
		UseMuiInvoicesTable_GetInvoicesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseMuiInvoicesTable_GetInvoicesForCustomerQuery,
		UseMuiInvoicesTable_GetInvoicesForCustomerQueryVariables
	>(UseMuiInvoicesTable_GetInvoicesForCustomerDocument, options);
}
export function useUseMuiInvoicesTable_GetInvoicesForCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseMuiInvoicesTable_GetInvoicesForCustomerQuery,
		UseMuiInvoicesTable_GetInvoicesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseMuiInvoicesTable_GetInvoicesForCustomerQuery,
		UseMuiInvoicesTable_GetInvoicesForCustomerQueryVariables
	>(UseMuiInvoicesTable_GetInvoicesForCustomerDocument, options);
}
export type UseMuiInvoicesTable_GetInvoicesForCustomerQueryHookResult =
	ReturnType<typeof useUseMuiInvoicesTable_GetInvoicesForCustomerQuery>;
export type UseMuiInvoicesTable_GetInvoicesForCustomerLazyQueryHookResult =
	ReturnType<typeof useUseMuiInvoicesTable_GetInvoicesForCustomerLazyQuery>;
export type UseMuiInvoicesTable_GetInvoicesForCustomerQueryResult =
	Apollo.QueryResult<
		UseMuiInvoicesTable_GetInvoicesForCustomerQuery,
		UseMuiInvoicesTable_GetInvoicesForCustomerQueryVariables
	>;
export const UseMuiInvoicesTable_GetInvoicesForVendorDocument = gql`
	query useMuiInvoicesTable_getInvoicesForVendor(
		$where: InvoiceWhereInput!
		$orderBy: [InvoiceOrderByInput]
		$skip: Int
		$take: Int
	) {
		getInvoicesForOrganization(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			invoices {
				...invoicesTable
			}
		}
	}
	${InvoicesTableFragmentDoc}
`;

/**
 * __useUseMuiInvoicesTable_GetInvoicesForVendorQuery__
 *
 * To run a query within a React component, call `useUseMuiInvoicesTable_GetInvoicesForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMuiInvoicesTable_GetInvoicesForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMuiInvoicesTable_GetInvoicesForVendorQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useUseMuiInvoicesTable_GetInvoicesForVendorQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseMuiInvoicesTable_GetInvoicesForVendorQuery,
		UseMuiInvoicesTable_GetInvoicesForVendorQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseMuiInvoicesTable_GetInvoicesForVendorQuery,
		UseMuiInvoicesTable_GetInvoicesForVendorQueryVariables
	>(UseMuiInvoicesTable_GetInvoicesForVendorDocument, options);
}
export function useUseMuiInvoicesTable_GetInvoicesForVendorLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseMuiInvoicesTable_GetInvoicesForVendorQuery,
		UseMuiInvoicesTable_GetInvoicesForVendorQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseMuiInvoicesTable_GetInvoicesForVendorQuery,
		UseMuiInvoicesTable_GetInvoicesForVendorQueryVariables
	>(UseMuiInvoicesTable_GetInvoicesForVendorDocument, options);
}
export type UseMuiInvoicesTable_GetInvoicesForVendorQueryHookResult =
	ReturnType<typeof useUseMuiInvoicesTable_GetInvoicesForVendorQuery>;
export type UseMuiInvoicesTable_GetInvoicesForVendorLazyQueryHookResult =
	ReturnType<typeof useUseMuiInvoicesTable_GetInvoicesForVendorLazyQuery>;
export type UseMuiInvoicesTable_GetInvoicesForVendorQueryResult =
	Apollo.QueryResult<
		UseMuiInvoicesTable_GetInvoicesForVendorQuery,
		UseMuiInvoicesTable_GetInvoicesForVendorQueryVariables
	>;
export const InvoiceTemplatesTable_GetInvoiceTemplatesDocument = gql`
	query invoiceTemplatesTable_getInvoiceTemplates(
		$skip: Int
		$take: Int
		$orderBy: [InvoiceTemplateOrderByInput]
		$where: InvoiceTemplatesWhereInput
	) {
		getInvoiceTemplatesWhere(
			skip: $skip
			take: $take
			orderBy: $orderBy
			where: $where
		) {
			_count
			invoiceTemplates {
				...invoiceTemplatesTable
			}
		}
	}
	${InvoiceTemplatesTableFragmentDoc}
`;

/**
 * __useInvoiceTemplatesTable_GetInvoiceTemplatesQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplatesTable_GetInvoiceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplatesTable_GetInvoiceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplatesTable_GetInvoiceTemplatesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvoiceTemplatesTable_GetInvoiceTemplatesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		InvoiceTemplatesTable_GetInvoiceTemplatesQuery,
		InvoiceTemplatesTable_GetInvoiceTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InvoiceTemplatesTable_GetInvoiceTemplatesQuery,
		InvoiceTemplatesTable_GetInvoiceTemplatesQueryVariables
	>(InvoiceTemplatesTable_GetInvoiceTemplatesDocument, options);
}
export function useInvoiceTemplatesTable_GetInvoiceTemplatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoiceTemplatesTable_GetInvoiceTemplatesQuery,
		InvoiceTemplatesTable_GetInvoiceTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InvoiceTemplatesTable_GetInvoiceTemplatesQuery,
		InvoiceTemplatesTable_GetInvoiceTemplatesQueryVariables
	>(InvoiceTemplatesTable_GetInvoiceTemplatesDocument, options);
}
export type InvoiceTemplatesTable_GetInvoiceTemplatesQueryHookResult =
	ReturnType<typeof useInvoiceTemplatesTable_GetInvoiceTemplatesQuery>;
export type InvoiceTemplatesTable_GetInvoiceTemplatesLazyQueryHookResult =
	ReturnType<typeof useInvoiceTemplatesTable_GetInvoiceTemplatesLazyQuery>;
export type InvoiceTemplatesTable_GetInvoiceTemplatesQueryResult =
	Apollo.QueryResult<
		InvoiceTemplatesTable_GetInvoiceTemplatesQuery,
		InvoiceTemplatesTable_GetInvoiceTemplatesQueryVariables
	>;
export const InvoiceTemplatesTable_DeleteInvoiceTemplateDocument = gql`
	mutation invoiceTemplatesTable_deleteInvoiceTemplate($id: ID!) {
		deleteInvoiceTemplate(where: { id: $id }) {
			id
		}
	}
`;
export type InvoiceTemplatesTable_DeleteInvoiceTemplateMutationFn =
	Apollo.MutationFunction<
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutation,
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutationVariables
	>;

/**
 * __useInvoiceTemplatesTable_DeleteInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useInvoiceTemplatesTable_DeleteInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplatesTable_DeleteInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceTemplatesTableDeleteInvoiceTemplateMutation, { data, loading, error }] = useInvoiceTemplatesTable_DeleteInvoiceTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceTemplatesTable_DeleteInvoiceTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutation,
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutation,
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutationVariables
	>(InvoiceTemplatesTable_DeleteInvoiceTemplateDocument, options);
}
export type InvoiceTemplatesTable_DeleteInvoiceTemplateMutationHookResult =
	ReturnType<typeof useInvoiceTemplatesTable_DeleteInvoiceTemplateMutation>;
export type InvoiceTemplatesTable_DeleteInvoiceTemplateMutationResult =
	Apollo.MutationResult<InvoiceTemplatesTable_DeleteInvoiceTemplateMutation>;
export type InvoiceTemplatesTable_DeleteInvoiceTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutation,
		InvoiceTemplatesTable_DeleteInvoiceTemplateMutationVariables
	>;
export const ActionMenuGetContactWhereDocument = gql`
	query actionMenuGetContactWhere($where: ContactWhereInput!) {
		getContactWhere(where: $where) {
			id
		}
	}
`;

/**
 * __useActionMenuGetContactWhereQuery__
 *
 * To run a query within a React component, call `useActionMenuGetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionMenuGetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionMenuGetContactWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useActionMenuGetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ActionMenuGetContactWhereQuery,
		ActionMenuGetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ActionMenuGetContactWhereQuery,
		ActionMenuGetContactWhereQueryVariables
	>(ActionMenuGetContactWhereDocument, options);
}
export function useActionMenuGetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ActionMenuGetContactWhereQuery,
		ActionMenuGetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ActionMenuGetContactWhereQuery,
		ActionMenuGetContactWhereQueryVariables
	>(ActionMenuGetContactWhereDocument, options);
}
export type ActionMenuGetContactWhereQueryHookResult = ReturnType<
	typeof useActionMenuGetContactWhereQuery
>;
export type ActionMenuGetContactWhereLazyQueryHookResult = ReturnType<
	typeof useActionMenuGetContactWhereLazyQuery
>;
export type ActionMenuGetContactWhereQueryResult = Apollo.QueryResult<
	ActionMenuGetContactWhereQuery,
	ActionMenuGetContactWhereQueryVariables
>;
export const ActionMenuConvertInquiryDocument = gql`
	mutation actionMenuConvertInquiry($where: InquiryWhereUniqueInput!) {
		convertInquiry(where: $where) {
			...actionMenuInquiry
		}
	}
	${ActionMenuInquiryFragmentDoc}
`;
export type ActionMenuConvertInquiryMutationFn = Apollo.MutationFunction<
	ActionMenuConvertInquiryMutation,
	ActionMenuConvertInquiryMutationVariables
>;

/**
 * __useActionMenuConvertInquiryMutation__
 *
 * To run a mutation, you first call `useActionMenuConvertInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionMenuConvertInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionMenuConvertInquiryMutation, { data, loading, error }] = useActionMenuConvertInquiryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useActionMenuConvertInquiryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ActionMenuConvertInquiryMutation,
		ActionMenuConvertInquiryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ActionMenuConvertInquiryMutation,
		ActionMenuConvertInquiryMutationVariables
	>(ActionMenuConvertInquiryDocument, options);
}
export type ActionMenuConvertInquiryMutationHookResult = ReturnType<
	typeof useActionMenuConvertInquiryMutation
>;
export type ActionMenuConvertInquiryMutationResult =
	Apollo.MutationResult<ActionMenuConvertInquiryMutation>;
export type ActionMenuConvertInquiryMutationOptions =
	Apollo.BaseMutationOptions<
		ActionMenuConvertInquiryMutation,
		ActionMenuConvertInquiryMutationVariables
	>;
export const ActionMenuDeleteInquiryDocument = gql`
	mutation actionMenuDeleteInquiry($where: InquiryWhereUniqueInput!) {
		deleteInquiry(where: $where)
	}
`;
export type ActionMenuDeleteInquiryMutationFn = Apollo.MutationFunction<
	ActionMenuDeleteInquiryMutation,
	ActionMenuDeleteInquiryMutationVariables
>;

/**
 * __useActionMenuDeleteInquiryMutation__
 *
 * To run a mutation, you first call `useActionMenuDeleteInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionMenuDeleteInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionMenuDeleteInquiryMutation, { data, loading, error }] = useActionMenuDeleteInquiryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useActionMenuDeleteInquiryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ActionMenuDeleteInquiryMutation,
		ActionMenuDeleteInquiryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ActionMenuDeleteInquiryMutation,
		ActionMenuDeleteInquiryMutationVariables
	>(ActionMenuDeleteInquiryDocument, options);
}
export type ActionMenuDeleteInquiryMutationHookResult = ReturnType<
	typeof useActionMenuDeleteInquiryMutation
>;
export type ActionMenuDeleteInquiryMutationResult =
	Apollo.MutationResult<ActionMenuDeleteInquiryMutation>;
export type ActionMenuDeleteInquiryMutationOptions = Apollo.BaseMutationOptions<
	ActionMenuDeleteInquiryMutation,
	ActionMenuDeleteInquiryMutationVariables
>;
export const ActivityHistoryGetEventsForInquiryDocument = gql`
	query ActivityHistoryGetEventsForInquiry($where: InquiryDetailWhereInput!) {
		getEventsForInquiry(where: $where) {
			...ActivityHistoryEvent
		}
	}
	${ActivityHistoryEventFragmentDoc}
`;

/**
 * __useActivityHistoryGetEventsForInquiryQuery__
 *
 * To run a query within a React component, call `useActivityHistoryGetEventsForInquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityHistoryGetEventsForInquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityHistoryGetEventsForInquiryQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useActivityHistoryGetEventsForInquiryQuery(
	baseOptions: Apollo.QueryHookOptions<
		ActivityHistoryGetEventsForInquiryQuery,
		ActivityHistoryGetEventsForInquiryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ActivityHistoryGetEventsForInquiryQuery,
		ActivityHistoryGetEventsForInquiryQueryVariables
	>(ActivityHistoryGetEventsForInquiryDocument, options);
}
export function useActivityHistoryGetEventsForInquiryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ActivityHistoryGetEventsForInquiryQuery,
		ActivityHistoryGetEventsForInquiryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ActivityHistoryGetEventsForInquiryQuery,
		ActivityHistoryGetEventsForInquiryQueryVariables
	>(ActivityHistoryGetEventsForInquiryDocument, options);
}
export type ActivityHistoryGetEventsForInquiryQueryHookResult = ReturnType<
	typeof useActivityHistoryGetEventsForInquiryQuery
>;
export type ActivityHistoryGetEventsForInquiryLazyQueryHookResult = ReturnType<
	typeof useActivityHistoryGetEventsForInquiryLazyQuery
>;
export type ActivityHistoryGetEventsForInquiryQueryResult = Apollo.QueryResult<
	ActivityHistoryGetEventsForInquiryQuery,
	ActivityHistoryGetEventsForInquiryQueryVariables
>;
export const UseLeadDetailHeader_UpdateInquiryStatusDocument = gql`
	mutation useLeadDetailHeader_updateInquiryStatus(
		$data: InquiryUpdateDataInput!
		$where: InquiryWhereUniqueInput!
	) {
		updateInquiry(data: $data, where: $where) {
			id
			status
		}
	}
`;
export type UseLeadDetailHeader_UpdateInquiryStatusMutationFn =
	Apollo.MutationFunction<
		UseLeadDetailHeader_UpdateInquiryStatusMutation,
		UseLeadDetailHeader_UpdateInquiryStatusMutationVariables
	>;

/**
 * __useUseLeadDetailHeader_UpdateInquiryStatusMutation__
 *
 * To run a mutation, you first call `useUseLeadDetailHeader_UpdateInquiryStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLeadDetailHeader_UpdateInquiryStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLeadDetailHeaderUpdateInquiryStatusMutation, { data, loading, error }] = useUseLeadDetailHeader_UpdateInquiryStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseLeadDetailHeader_UpdateInquiryStatusMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseLeadDetailHeader_UpdateInquiryStatusMutation,
		UseLeadDetailHeader_UpdateInquiryStatusMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseLeadDetailHeader_UpdateInquiryStatusMutation,
		UseLeadDetailHeader_UpdateInquiryStatusMutationVariables
	>(UseLeadDetailHeader_UpdateInquiryStatusDocument, options);
}
export type UseLeadDetailHeader_UpdateInquiryStatusMutationHookResult =
	ReturnType<typeof useUseLeadDetailHeader_UpdateInquiryStatusMutation>;
export type UseLeadDetailHeader_UpdateInquiryStatusMutationResult =
	Apollo.MutationResult<UseLeadDetailHeader_UpdateInquiryStatusMutation>;
export type UseLeadDetailHeader_UpdateInquiryStatusMutationOptions =
	Apollo.BaseMutationOptions<
		UseLeadDetailHeader_UpdateInquiryStatusMutation,
		UseLeadDetailHeader_UpdateInquiryStatusMutationVariables
	>;
export const NotesTab_UpdateInquiryNotesDocument = gql`
	mutation NotesTab_UpdateInquiryNotes(
		$where: InquiryWhereUniqueInput!
		$data: InquiryUpdateDataInput!
	) {
		updateInquiry(where: $where, data: $data) {
			id
			notes
		}
	}
`;
export type NotesTab_UpdateInquiryNotesMutationFn = Apollo.MutationFunction<
	NotesTab_UpdateInquiryNotesMutation,
	NotesTab_UpdateInquiryNotesMutationVariables
>;

/**
 * __useNotesTab_UpdateInquiryNotesMutation__
 *
 * To run a mutation, you first call `useNotesTab_UpdateInquiryNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesTab_UpdateInquiryNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesTabUpdateInquiryNotesMutation, { data, loading, error }] = useNotesTab_UpdateInquiryNotesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNotesTab_UpdateInquiryNotesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		NotesTab_UpdateInquiryNotesMutation,
		NotesTab_UpdateInquiryNotesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		NotesTab_UpdateInquiryNotesMutation,
		NotesTab_UpdateInquiryNotesMutationVariables
	>(NotesTab_UpdateInquiryNotesDocument, options);
}
export type NotesTab_UpdateInquiryNotesMutationHookResult = ReturnType<
	typeof useNotesTab_UpdateInquiryNotesMutation
>;
export type NotesTab_UpdateInquiryNotesMutationResult =
	Apollo.MutationResult<NotesTab_UpdateInquiryNotesMutation>;
export type NotesTab_UpdateInquiryNotesMutationOptions =
	Apollo.BaseMutationOptions<
		NotesTab_UpdateInquiryNotesMutation,
		NotesTab_UpdateInquiryNotesMutationVariables
	>;
export const LeadDetail_GetInquiryWhereDocument = gql`
	query LeadDetail_getInquiryWhere($where: InquiryDetailWhereInput!) {
		getInquiryWhere(where: $where) {
			id
			organization {
				id
				createdAt
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
				users {
					role
					id
				}
			}
			...LeadDetailHeaderFragment
			...notesTabInquiry
		}
	}
	${LeadDetailHeaderFragmentFragmentDoc}
	${NotesTabInquiryFragmentDoc}
`;

/**
 * __useLeadDetail_GetInquiryWhereQuery__
 *
 * To run a query within a React component, call `useLeadDetail_GetInquiryWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadDetail_GetInquiryWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadDetail_GetInquiryWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLeadDetail_GetInquiryWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		LeadDetail_GetInquiryWhereQuery,
		LeadDetail_GetInquiryWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		LeadDetail_GetInquiryWhereQuery,
		LeadDetail_GetInquiryWhereQueryVariables
	>(LeadDetail_GetInquiryWhereDocument, options);
}
export function useLeadDetail_GetInquiryWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LeadDetail_GetInquiryWhereQuery,
		LeadDetail_GetInquiryWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LeadDetail_GetInquiryWhereQuery,
		LeadDetail_GetInquiryWhereQueryVariables
	>(LeadDetail_GetInquiryWhereDocument, options);
}
export type LeadDetail_GetInquiryWhereQueryHookResult = ReturnType<
	typeof useLeadDetail_GetInquiryWhereQuery
>;
export type LeadDetail_GetInquiryWhereLazyQueryHookResult = ReturnType<
	typeof useLeadDetail_GetInquiryWhereLazyQuery
>;
export type LeadDetail_GetInquiryWhereQueryResult = Apollo.QueryResult<
	LeadDetail_GetInquiryWhereQuery,
	LeadDetail_GetInquiryWhereQueryVariables
>;
export const LeadDetail_UpdateInquiryDocument = gql`
	mutation LeadDetail_updateInquiry(
		$data: InquiryUpdateDataInput!
		$where: InquiryWhereUniqueInput!
	) {
		updateInquiry(data: $data, where: $where) {
			id
			status
		}
	}
`;
export type LeadDetail_UpdateInquiryMutationFn = Apollo.MutationFunction<
	LeadDetail_UpdateInquiryMutation,
	LeadDetail_UpdateInquiryMutationVariables
>;

/**
 * __useLeadDetail_UpdateInquiryMutation__
 *
 * To run a mutation, you first call `useLeadDetail_UpdateInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadDetail_UpdateInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadDetailUpdateInquiryMutation, { data, loading, error }] = useLeadDetail_UpdateInquiryMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLeadDetail_UpdateInquiryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		LeadDetail_UpdateInquiryMutation,
		LeadDetail_UpdateInquiryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		LeadDetail_UpdateInquiryMutation,
		LeadDetail_UpdateInquiryMutationVariables
	>(LeadDetail_UpdateInquiryDocument, options);
}
export type LeadDetail_UpdateInquiryMutationHookResult = ReturnType<
	typeof useLeadDetail_UpdateInquiryMutation
>;
export type LeadDetail_UpdateInquiryMutationResult =
	Apollo.MutationResult<LeadDetail_UpdateInquiryMutation>;
export type LeadDetail_UpdateInquiryMutationOptions =
	Apollo.BaseMutationOptions<
		LeadDetail_UpdateInquiryMutation,
		LeadDetail_UpdateInquiryMutationVariables
	>;
export const ExportLeadsDataDocument = gql`
	query exportLeadsData($where: ExportInquiriesDataWhereInput!) {
		exportInquiryData(where: $where)
	}
`;

/**
 * __useExportLeadsDataQuery__
 *
 * To run a query within a React component, call `useExportLeadsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLeadsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLeadsDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportLeadsDataQuery(
	baseOptions: Apollo.QueryHookOptions<
		ExportLeadsDataQuery,
		ExportLeadsDataQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ExportLeadsDataQuery, ExportLeadsDataQueryVariables>(
		ExportLeadsDataDocument,
		options
	);
}
export function useExportLeadsDataLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportLeadsDataQuery,
		ExportLeadsDataQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ExportLeadsDataQuery,
		ExportLeadsDataQueryVariables
	>(ExportLeadsDataDocument, options);
}
export type ExportLeadsDataQueryHookResult = ReturnType<
	typeof useExportLeadsDataQuery
>;
export type ExportLeadsDataLazyQueryHookResult = ReturnType<
	typeof useExportLeadsDataLazyQuery
>;
export type ExportLeadsDataQueryResult = Apollo.QueryResult<
	ExportLeadsDataQuery,
	ExportLeadsDataQueryVariables
>;
export const InquiriesTableSubMenu_DeleteInquiryDocument = gql`
	mutation InquiriesTableSubMenu_deleteInquiry(
		$where: InquiryWhereUniqueInput!
	) {
		deleteInquiry(where: $where)
	}
`;
export type InquiriesTableSubMenu_DeleteInquiryMutationFn =
	Apollo.MutationFunction<
		InquiriesTableSubMenu_DeleteInquiryMutation,
		InquiriesTableSubMenu_DeleteInquiryMutationVariables
	>;

/**
 * __useInquiriesTableSubMenu_DeleteInquiryMutation__
 *
 * To run a mutation, you first call `useInquiriesTableSubMenu_DeleteInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInquiriesTableSubMenu_DeleteInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inquiriesTableSubMenuDeleteInquiryMutation, { data, loading, error }] = useInquiriesTableSubMenu_DeleteInquiryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInquiriesTableSubMenu_DeleteInquiryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InquiriesTableSubMenu_DeleteInquiryMutation,
		InquiriesTableSubMenu_DeleteInquiryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InquiriesTableSubMenu_DeleteInquiryMutation,
		InquiriesTableSubMenu_DeleteInquiryMutationVariables
	>(InquiriesTableSubMenu_DeleteInquiryDocument, options);
}
export type InquiriesTableSubMenu_DeleteInquiryMutationHookResult = ReturnType<
	typeof useInquiriesTableSubMenu_DeleteInquiryMutation
>;
export type InquiriesTableSubMenu_DeleteInquiryMutationResult =
	Apollo.MutationResult<InquiriesTableSubMenu_DeleteInquiryMutation>;
export type InquiriesTableSubMenu_DeleteInquiryMutationOptions =
	Apollo.BaseMutationOptions<
		InquiriesTableSubMenu_DeleteInquiryMutation,
		InquiriesTableSubMenu_DeleteInquiryMutationVariables
	>;
export const UseInquiriesTable_GetInquiriesForOrganizationDocument = gql`
	query useInquiriesTable_getInquiriesForOrganization(
		$where: InquiriesForOrganizationWhereInput
		$orderBy: [InquiryOrderByInput!]
		$skip: Int
		$take: Int
	) {
		getInquiriesForOrganization(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			inquiries {
				...inquiriesTable
			}
		}
	}
	${InquiriesTableFragmentDoc}
`;

/**
 * __useUseInquiriesTable_GetInquiriesForOrganizationQuery__
 *
 * To run a query within a React component, call `useUseInquiriesTable_GetInquiriesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseInquiriesTable_GetInquiriesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseInquiriesTable_GetInquiriesForOrganizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useUseInquiriesTable_GetInquiriesForOrganizationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UseInquiriesTable_GetInquiriesForOrganizationQuery,
		UseInquiriesTable_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseInquiriesTable_GetInquiriesForOrganizationQuery,
		UseInquiriesTable_GetInquiriesForOrganizationQueryVariables
	>(UseInquiriesTable_GetInquiriesForOrganizationDocument, options);
}
export function useUseInquiriesTable_GetInquiriesForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseInquiriesTable_GetInquiriesForOrganizationQuery,
		UseInquiriesTable_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseInquiriesTable_GetInquiriesForOrganizationQuery,
		UseInquiriesTable_GetInquiriesForOrganizationQueryVariables
	>(UseInquiriesTable_GetInquiriesForOrganizationDocument, options);
}
export type UseInquiriesTable_GetInquiriesForOrganizationQueryHookResult =
	ReturnType<typeof useUseInquiriesTable_GetInquiriesForOrganizationQuery>;
export type UseInquiriesTable_GetInquiriesForOrganizationLazyQueryHookResult =
	ReturnType<typeof useUseInquiriesTable_GetInquiriesForOrganizationLazyQuery>;
export type UseInquiriesTable_GetInquiriesForOrganizationQueryResult =
	Apollo.QueryResult<
		UseInquiriesTable_GetInquiriesForOrganizationQuery,
		UseInquiriesTable_GetInquiriesForOrganizationQueryVariables
	>;
export const UseLeadsTable_UpdateInquiryStatusDocument = gql`
	mutation useLeadsTable_updateInquiryStatus(
		$where: InquiryWhereUniqueInput!
		$data: InquiryUpdateDataInput!
	) {
		updateInquiry(where: $where, data: $data) {
			...inquiriesTable
		}
	}
	${InquiriesTableFragmentDoc}
`;
export type UseLeadsTable_UpdateInquiryStatusMutationFn =
	Apollo.MutationFunction<
		UseLeadsTable_UpdateInquiryStatusMutation,
		UseLeadsTable_UpdateInquiryStatusMutationVariables
	>;

/**
 * __useUseLeadsTable_UpdateInquiryStatusMutation__
 *
 * To run a mutation, you first call `useUseLeadsTable_UpdateInquiryStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLeadsTable_UpdateInquiryStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLeadsTableUpdateInquiryStatusMutation, { data, loading, error }] = useUseLeadsTable_UpdateInquiryStatusMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseLeadsTable_UpdateInquiryStatusMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseLeadsTable_UpdateInquiryStatusMutation,
		UseLeadsTable_UpdateInquiryStatusMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseLeadsTable_UpdateInquiryStatusMutation,
		UseLeadsTable_UpdateInquiryStatusMutationVariables
	>(UseLeadsTable_UpdateInquiryStatusDocument, options);
}
export type UseLeadsTable_UpdateInquiryStatusMutationHookResult = ReturnType<
	typeof useUseLeadsTable_UpdateInquiryStatusMutation
>;
export type UseLeadsTable_UpdateInquiryStatusMutationResult =
	Apollo.MutationResult<UseLeadsTable_UpdateInquiryStatusMutation>;
export type UseLeadsTable_UpdateInquiryStatusMutationOptions =
	Apollo.BaseMutationOptions<
		UseLeadsTable_UpdateInquiryStatusMutation,
		UseLeadsTable_UpdateInquiryStatusMutationVariables
	>;
export const UseLeadMetrics_GetInquiriesForOrganizationDocument = gql`
	query useLeadMetrics_getInquiriesForOrganization(
		$where: InquiriesForOrganizationWhereInput
	) {
		getInquiriesForOrganization(where: $where, take: 0) {
			_count
		}
	}
`;

/**
 * __useUseLeadMetrics_GetInquiriesForOrganizationQuery__
 *
 * To run a query within a React component, call `useUseLeadMetrics_GetInquiriesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLeadMetrics_GetInquiriesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLeadMetrics_GetInquiriesForOrganizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseLeadMetrics_GetInquiriesForOrganizationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UseLeadMetrics_GetInquiriesForOrganizationQuery,
		UseLeadMetrics_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseLeadMetrics_GetInquiriesForOrganizationQuery,
		UseLeadMetrics_GetInquiriesForOrganizationQueryVariables
	>(UseLeadMetrics_GetInquiriesForOrganizationDocument, options);
}
export function useUseLeadMetrics_GetInquiriesForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseLeadMetrics_GetInquiriesForOrganizationQuery,
		UseLeadMetrics_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseLeadMetrics_GetInquiriesForOrganizationQuery,
		UseLeadMetrics_GetInquiriesForOrganizationQueryVariables
	>(UseLeadMetrics_GetInquiriesForOrganizationDocument, options);
}
export type UseLeadMetrics_GetInquiriesForOrganizationQueryHookResult =
	ReturnType<typeof useUseLeadMetrics_GetInquiriesForOrganizationQuery>;
export type UseLeadMetrics_GetInquiriesForOrganizationLazyQueryHookResult =
	ReturnType<typeof useUseLeadMetrics_GetInquiriesForOrganizationLazyQuery>;
export type UseLeadMetrics_GetInquiriesForOrganizationQueryResult =
	Apollo.QueryResult<
		UseLeadMetrics_GetInquiriesForOrganizationQuery,
		UseLeadMetrics_GetInquiriesForOrganizationQueryVariables
	>;
export const LoginPage_LoginDocument = gql`
	query loginPage_login($data: UserLoginInput!) {
		login(data: $data) {
			token
		}
	}
`;

/**
 * __useLoginPage_LoginQuery__
 *
 * To run a query within a React component, call `useLoginPage_LoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginPage_LoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginPage_LoginQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginPage_LoginQuery(
	baseOptions: Apollo.QueryHookOptions<
		LoginPage_LoginQuery,
		LoginPage_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginPage_LoginQuery, LoginPage_LoginQueryVariables>(
		LoginPage_LoginDocument,
		options
	);
}
export function useLoginPage_LoginLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LoginPage_LoginQuery,
		LoginPage_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LoginPage_LoginQuery,
		LoginPage_LoginQueryVariables
	>(LoginPage_LoginDocument, options);
}
export type LoginPage_LoginQueryHookResult = ReturnType<
	typeof useLoginPage_LoginQuery
>;
export type LoginPage_LoginLazyQueryHookResult = ReturnType<
	typeof useLoginPage_LoginLazyQuery
>;
export type LoginPage_LoginQueryResult = Apollo.QueryResult<
	LoginPage_LoginQuery,
	LoginPage_LoginQueryVariables
>;
export const LoginPage_CreateMfaTokenDocument = gql`
	mutation loginPage_createMfaToken($data: MfaTokenInput!) {
		createMfaToken(data: $data)
	}
`;
export type LoginPage_CreateMfaTokenMutationFn = Apollo.MutationFunction<
	LoginPage_CreateMfaTokenMutation,
	LoginPage_CreateMfaTokenMutationVariables
>;

/**
 * __useLoginPage_CreateMfaTokenMutation__
 *
 * To run a mutation, you first call `useLoginPage_CreateMfaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginPage_CreateMfaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginPageCreateMfaTokenMutation, { data, loading, error }] = useLoginPage_CreateMfaTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginPage_CreateMfaTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		LoginPage_CreateMfaTokenMutation,
		LoginPage_CreateMfaTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		LoginPage_CreateMfaTokenMutation,
		LoginPage_CreateMfaTokenMutationVariables
	>(LoginPage_CreateMfaTokenDocument, options);
}
export type LoginPage_CreateMfaTokenMutationHookResult = ReturnType<
	typeof useLoginPage_CreateMfaTokenMutation
>;
export type LoginPage_CreateMfaTokenMutationResult =
	Apollo.MutationResult<LoginPage_CreateMfaTokenMutation>;
export type LoginPage_CreateMfaTokenMutationOptions =
	Apollo.BaseMutationOptions<
		LoginPage_CreateMfaTokenMutation,
		LoginPage_CreateMfaTokenMutationVariables
	>;
export const LoginPage_RequestResetDocument = gql`
	mutation loginPage_requestReset($data: PasswordResetRequestInput!) {
		requestReset(data: $data)
	}
`;
export type LoginPage_RequestResetMutationFn = Apollo.MutationFunction<
	LoginPage_RequestResetMutation,
	LoginPage_RequestResetMutationVariables
>;

/**
 * __useLoginPage_RequestResetMutation__
 *
 * To run a mutation, you first call `useLoginPage_RequestResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginPage_RequestResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginPageRequestResetMutation, { data, loading, error }] = useLoginPage_RequestResetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginPage_RequestResetMutation(
	baseOptions?: Apollo.MutationHookOptions<
		LoginPage_RequestResetMutation,
		LoginPage_RequestResetMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		LoginPage_RequestResetMutation,
		LoginPage_RequestResetMutationVariables
	>(LoginPage_RequestResetDocument, options);
}
export type LoginPage_RequestResetMutationHookResult = ReturnType<
	typeof useLoginPage_RequestResetMutation
>;
export type LoginPage_RequestResetMutationResult =
	Apollo.MutationResult<LoginPage_RequestResetMutation>;
export type LoginPage_RequestResetMutationOptions = Apollo.BaseMutationOptions<
	LoginPage_RequestResetMutation,
	LoginPage_RequestResetMutationVariables
>;
export const MemberDetail_GetOrganizationWhereDocument = gql`
	query memberDetail_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			id
			users(orderBy: { firstName: desc }) {
				...memberDetailMember
			}
		}
	}
	${MemberDetailMemberFragmentDoc}
`;

/**
 * __useMemberDetail_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useMemberDetail_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDetail_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDetail_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMemberDetail_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		MemberDetail_GetOrganizationWhereQuery,
		MemberDetail_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MemberDetail_GetOrganizationWhereQuery,
		MemberDetail_GetOrganizationWhereQueryVariables
	>(MemberDetail_GetOrganizationWhereDocument, options);
}
export function useMemberDetail_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MemberDetail_GetOrganizationWhereQuery,
		MemberDetail_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MemberDetail_GetOrganizationWhereQuery,
		MemberDetail_GetOrganizationWhereQueryVariables
	>(MemberDetail_GetOrganizationWhereDocument, options);
}
export type MemberDetail_GetOrganizationWhereQueryHookResult = ReturnType<
	typeof useMemberDetail_GetOrganizationWhereQuery
>;
export type MemberDetail_GetOrganizationWhereLazyQueryHookResult = ReturnType<
	typeof useMemberDetail_GetOrganizationWhereLazyQuery
>;
export type MemberDetail_GetOrganizationWhereQueryResult = Apollo.QueryResult<
	MemberDetail_GetOrganizationWhereQuery,
	MemberDetail_GetOrganizationWhereQueryVariables
>;
export const MessageCustomerModal_GetInquiryWhereDocument = gql`
	query MessageCustomerModal_GetInquiryWhere($where: InquiryDetailWhereInput!) {
		getInquiryWhere(where: $where) {
			...messageCustomerModalInquiry
		}
	}
	${MessageCustomerModalInquiryFragmentDoc}
`;

/**
 * __useMessageCustomerModal_GetInquiryWhereQuery__
 *
 * To run a query within a React component, call `useMessageCustomerModal_GetInquiryWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageCustomerModal_GetInquiryWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageCustomerModal_GetInquiryWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMessageCustomerModal_GetInquiryWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		MessageCustomerModal_GetInquiryWhereQuery,
		MessageCustomerModal_GetInquiryWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MessageCustomerModal_GetInquiryWhereQuery,
		MessageCustomerModal_GetInquiryWhereQueryVariables
	>(MessageCustomerModal_GetInquiryWhereDocument, options);
}
export function useMessageCustomerModal_GetInquiryWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageCustomerModal_GetInquiryWhereQuery,
		MessageCustomerModal_GetInquiryWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MessageCustomerModal_GetInquiryWhereQuery,
		MessageCustomerModal_GetInquiryWhereQueryVariables
	>(MessageCustomerModal_GetInquiryWhereDocument, options);
}
export type MessageCustomerModal_GetInquiryWhereQueryHookResult = ReturnType<
	typeof useMessageCustomerModal_GetInquiryWhereQuery
>;
export type MessageCustomerModal_GetInquiryWhereLazyQueryHookResult =
	ReturnType<typeof useMessageCustomerModal_GetInquiryWhereLazyQuery>;
export type MessageCustomerModal_GetInquiryWhereQueryResult =
	Apollo.QueryResult<
		MessageCustomerModal_GetInquiryWhereQuery,
		MessageCustomerModal_GetInquiryWhereQueryVariables
	>;
export const MessageCustomerModal_GetContactWhereDocument = gql`
	query MessageCustomerModal_GetContactWhere($where: ContactWhereInput!) {
		getContactWhere(where: $where) {
			...messageCustomerModalContact
		}
	}
	${MessageCustomerModalContactFragmentDoc}
`;

/**
 * __useMessageCustomerModal_GetContactWhereQuery__
 *
 * To run a query within a React component, call `useMessageCustomerModal_GetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageCustomerModal_GetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageCustomerModal_GetContactWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMessageCustomerModal_GetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		MessageCustomerModal_GetContactWhereQuery,
		MessageCustomerModal_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MessageCustomerModal_GetContactWhereQuery,
		MessageCustomerModal_GetContactWhereQueryVariables
	>(MessageCustomerModal_GetContactWhereDocument, options);
}
export function useMessageCustomerModal_GetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageCustomerModal_GetContactWhereQuery,
		MessageCustomerModal_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MessageCustomerModal_GetContactWhereQuery,
		MessageCustomerModal_GetContactWhereQueryVariables
	>(MessageCustomerModal_GetContactWhereDocument, options);
}
export type MessageCustomerModal_GetContactWhereQueryHookResult = ReturnType<
	typeof useMessageCustomerModal_GetContactWhereQuery
>;
export type MessageCustomerModal_GetContactWhereLazyQueryHookResult =
	ReturnType<typeof useMessageCustomerModal_GetContactWhereLazyQuery>;
export type MessageCustomerModal_GetContactWhereQueryResult =
	Apollo.QueryResult<
		MessageCustomerModal_GetContactWhereQuery,
		MessageCustomerModal_GetContactWhereQueryVariables
	>;
export const MessageCustomerModal_UpdateContactDocument = gql`
	mutation MessageCustomerModal_UpdateContact(
		$where: ContactWhereUniqueInput!
		$data: CustomContactUpdateInput!
	) {
		updateContact(where: $where, data: $data) {
			...messageCustomerModalContact
		}
	}
	${MessageCustomerModalContactFragmentDoc}
`;
export type MessageCustomerModal_UpdateContactMutationFn =
	Apollo.MutationFunction<
		MessageCustomerModal_UpdateContactMutation,
		MessageCustomerModal_UpdateContactMutationVariables
	>;

/**
 * __useMessageCustomerModal_UpdateContactMutation__
 *
 * To run a mutation, you first call `useMessageCustomerModal_UpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageCustomerModal_UpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageCustomerModalUpdateContactMutation, { data, loading, error }] = useMessageCustomerModal_UpdateContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMessageCustomerModal_UpdateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageCustomerModal_UpdateContactMutation,
		MessageCustomerModal_UpdateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MessageCustomerModal_UpdateContactMutation,
		MessageCustomerModal_UpdateContactMutationVariables
	>(MessageCustomerModal_UpdateContactDocument, options);
}
export type MessageCustomerModal_UpdateContactMutationHookResult = ReturnType<
	typeof useMessageCustomerModal_UpdateContactMutation
>;
export type MessageCustomerModal_UpdateContactMutationResult =
	Apollo.MutationResult<MessageCustomerModal_UpdateContactMutation>;
export type MessageCustomerModal_UpdateContactMutationOptions =
	Apollo.BaseMutationOptions<
		MessageCustomerModal_UpdateContactMutation,
		MessageCustomerModal_UpdateContactMutationVariables
	>;
export const MessageCustomerModal_MessageContactOrLeadDocument = gql`
	mutation MessageCustomerModal_MessageContactOrLead(
		$where: ContactOrLeadInput!
		$data: MessageContactOrgLeadInput!
	) {
		messageContactOrLead(where: $where, data: $data)
	}
`;
export type MessageCustomerModal_MessageContactOrLeadMutationFn =
	Apollo.MutationFunction<
		MessageCustomerModal_MessageContactOrLeadMutation,
		MessageCustomerModal_MessageContactOrLeadMutationVariables
	>;

/**
 * __useMessageCustomerModal_MessageContactOrLeadMutation__
 *
 * To run a mutation, you first call `useMessageCustomerModal_MessageContactOrLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageCustomerModal_MessageContactOrLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageCustomerModalMessageContactOrLeadMutation, { data, loading, error }] = useMessageCustomerModal_MessageContactOrLeadMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMessageCustomerModal_MessageContactOrLeadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageCustomerModal_MessageContactOrLeadMutation,
		MessageCustomerModal_MessageContactOrLeadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MessageCustomerModal_MessageContactOrLeadMutation,
		MessageCustomerModal_MessageContactOrLeadMutationVariables
	>(MessageCustomerModal_MessageContactOrLeadDocument, options);
}
export type MessageCustomerModal_MessageContactOrLeadMutationHookResult =
	ReturnType<typeof useMessageCustomerModal_MessageContactOrLeadMutation>;
export type MessageCustomerModal_MessageContactOrLeadMutationResult =
	Apollo.MutationResult<MessageCustomerModal_MessageContactOrLeadMutation>;
export type MessageCustomerModal_MessageContactOrLeadMutationOptions =
	Apollo.BaseMutationOptions<
		MessageCustomerModal_MessageContactOrLeadMutation,
		MessageCustomerModal_MessageContactOrLeadMutationVariables
	>;
export const MoveFileModalCompanyFolders_GetFolderContentsDocument = gql`
	query MoveFileModalCompanyFolders_getFolderContents(
		$where: FolderWhereUniqueInput!
	) {
		getFolderContents(where: $where, take: 1000, orderBy: { createdAt: desc }) {
			id
			name
			parentFolder {
				id
				name
			}
			childFolders {
				...useMoveFileModalCompanyFoldersCustomFolder
			}
			documents {
				...useMoveFileModalCompanyFoldersDocument
			}
		}
	}
	${UseMoveFileModalCompanyFoldersCustomFolderFragmentDoc}
	${UseMoveFileModalCompanyFoldersDocumentFragmentDoc}
`;

/**
 * __useMoveFileModalCompanyFolders_GetFolderContentsQuery__
 *
 * To run a query within a React component, call `useMoveFileModalCompanyFolders_GetFolderContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoveFileModalCompanyFolders_GetFolderContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoveFileModalCompanyFolders_GetFolderContentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMoveFileModalCompanyFolders_GetFolderContentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		MoveFileModalCompanyFolders_GetFolderContentsQuery,
		MoveFileModalCompanyFolders_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MoveFileModalCompanyFolders_GetFolderContentsQuery,
		MoveFileModalCompanyFolders_GetFolderContentsQueryVariables
	>(MoveFileModalCompanyFolders_GetFolderContentsDocument, options);
}
export function useMoveFileModalCompanyFolders_GetFolderContentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MoveFileModalCompanyFolders_GetFolderContentsQuery,
		MoveFileModalCompanyFolders_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MoveFileModalCompanyFolders_GetFolderContentsQuery,
		MoveFileModalCompanyFolders_GetFolderContentsQueryVariables
	>(MoveFileModalCompanyFolders_GetFolderContentsDocument, options);
}
export type MoveFileModalCompanyFolders_GetFolderContentsQueryHookResult =
	ReturnType<typeof useMoveFileModalCompanyFolders_GetFolderContentsQuery>;
export type MoveFileModalCompanyFolders_GetFolderContentsLazyQueryHookResult =
	ReturnType<typeof useMoveFileModalCompanyFolders_GetFolderContentsLazyQuery>;
export type MoveFileModalCompanyFolders_GetFolderContentsQueryResult =
	Apollo.QueryResult<
		MoveFileModalCompanyFolders_GetFolderContentsQuery,
		MoveFileModalCompanyFolders_GetFolderContentsQueryVariables
	>;
export const MoveFileModalCompanyFolders_MoveFoldersDocument = gql`
	mutation MoveFileModalCompanyFolders_moveFolders(
		$where: FoldersWhereCustomInput!
		$data: MoveFolderCustomInput!
	) {
		moveFolders(where: $where, data: $data) {
			...useMoveFileModalCompanyFoldersCustomFolder
		}
	}
	${UseMoveFileModalCompanyFoldersCustomFolderFragmentDoc}
`;
export type MoveFileModalCompanyFolders_MoveFoldersMutationFn =
	Apollo.MutationFunction<
		MoveFileModalCompanyFolders_MoveFoldersMutation,
		MoveFileModalCompanyFolders_MoveFoldersMutationVariables
	>;

/**
 * __useMoveFileModalCompanyFolders_MoveFoldersMutation__
 *
 * To run a mutation, you first call `useMoveFileModalCompanyFolders_MoveFoldersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFileModalCompanyFolders_MoveFoldersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFileModalCompanyFoldersMoveFoldersMutation, { data, loading, error }] = useMoveFileModalCompanyFolders_MoveFoldersMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMoveFileModalCompanyFolders_MoveFoldersMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MoveFileModalCompanyFolders_MoveFoldersMutation,
		MoveFileModalCompanyFolders_MoveFoldersMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MoveFileModalCompanyFolders_MoveFoldersMutation,
		MoveFileModalCompanyFolders_MoveFoldersMutationVariables
	>(MoveFileModalCompanyFolders_MoveFoldersDocument, options);
}
export type MoveFileModalCompanyFolders_MoveFoldersMutationHookResult =
	ReturnType<typeof useMoveFileModalCompanyFolders_MoveFoldersMutation>;
export type MoveFileModalCompanyFolders_MoveFoldersMutationResult =
	Apollo.MutationResult<MoveFileModalCompanyFolders_MoveFoldersMutation>;
export type MoveFileModalCompanyFolders_MoveFoldersMutationOptions =
	Apollo.BaseMutationOptions<
		MoveFileModalCompanyFolders_MoveFoldersMutation,
		MoveFileModalCompanyFolders_MoveFoldersMutationVariables
	>;
export const MoveFileModalCompanyFolders_MoveDocumentsDocument = gql`
	mutation MoveFileModalCompanyFolders_moveDocuments(
		$where: DocumentsWhereCustomInput!
		$data: FolderWhereUniqueInput!
	) {
		moveDocuments(where: $where, data: $data) {
			...useMoveFileModalCompanyFoldersDocument
		}
	}
	${UseMoveFileModalCompanyFoldersDocumentFragmentDoc}
`;
export type MoveFileModalCompanyFolders_MoveDocumentsMutationFn =
	Apollo.MutationFunction<
		MoveFileModalCompanyFolders_MoveDocumentsMutation,
		MoveFileModalCompanyFolders_MoveDocumentsMutationVariables
	>;

/**
 * __useMoveFileModalCompanyFolders_MoveDocumentsMutation__
 *
 * To run a mutation, you first call `useMoveFileModalCompanyFolders_MoveDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFileModalCompanyFolders_MoveDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFileModalCompanyFoldersMoveDocumentsMutation, { data, loading, error }] = useMoveFileModalCompanyFolders_MoveDocumentsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMoveFileModalCompanyFolders_MoveDocumentsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MoveFileModalCompanyFolders_MoveDocumentsMutation,
		MoveFileModalCompanyFolders_MoveDocumentsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MoveFileModalCompanyFolders_MoveDocumentsMutation,
		MoveFileModalCompanyFolders_MoveDocumentsMutationVariables
	>(MoveFileModalCompanyFolders_MoveDocumentsDocument, options);
}
export type MoveFileModalCompanyFolders_MoveDocumentsMutationHookResult =
	ReturnType<typeof useMoveFileModalCompanyFolders_MoveDocumentsMutation>;
export type MoveFileModalCompanyFolders_MoveDocumentsMutationResult =
	Apollo.MutationResult<MoveFileModalCompanyFolders_MoveDocumentsMutation>;
export type MoveFileModalCompanyFolders_MoveDocumentsMutationOptions =
	Apollo.BaseMutationOptions<
		MoveFileModalCompanyFolders_MoveDocumentsMutation,
		MoveFileModalCompanyFolders_MoveDocumentsMutationVariables
	>;
export const MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderDocument = gql`
	mutation MoveFileModalCompanyFolders_copyDocumentFromCompanyFolderToCustomerFolder(
		$where: DocumentWhereUniqueInput!
		$data: ContactWhereUniqueInput!
	) {
		copyDocumentFromCompanyFolderToCustomerFolder(where: $where, data: $data) {
			...useMoveFileModalCompanyFoldersDocument
		}
	}
	${UseMoveFileModalCompanyFoldersDocumentFragmentDoc}
`;
export type MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationFn =
	Apollo.MutationFunction<
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation,
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationVariables
	>;

/**
 * __useMoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation__
 *
 * To run a mutation, you first call `useMoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFileModalCompanyFoldersCopyDocumentFromCompanyFolderToCustomerFolderMutation, { data, loading, error }] = useMoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation,
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation,
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationVariables
	>(
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderDocument,
		options
	);
}
export type MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationHookResult =
	ReturnType<
		typeof useMoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation
	>;
export type MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationResult =
	Apollo.MutationResult<MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation>;
export type MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationOptions =
	Apollo.BaseMutationOptions<
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutation,
		MoveFileModalCompanyFolders_CopyDocumentFromCompanyFolderToCustomerFolderMutationVariables
	>;
export const MoveFileModalCustomerFolders_GetContactsWhereDocument = gql`
	query MoveFileModalCustomerFolders_getContactsWhere(
		$orderBy: [ContactOrderByInput]
		$where: ContactWhereInput!
	) {
		getContactsWhere(where: $where, orderBy: $orderBy) {
			_count
			contacts {
				...useMoveFileModalCustomerFoldersContact
			}
		}
	}
	${UseMoveFileModalCustomerFoldersContactFragmentDoc}
`;

/**
 * __useMoveFileModalCustomerFolders_GetContactsWhereQuery__
 *
 * To run a query within a React component, call `useMoveFileModalCustomerFolders_GetContactsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoveFileModalCustomerFolders_GetContactsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoveFileModalCustomerFolders_GetContactsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMoveFileModalCustomerFolders_GetContactsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		MoveFileModalCustomerFolders_GetContactsWhereQuery,
		MoveFileModalCustomerFolders_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MoveFileModalCustomerFolders_GetContactsWhereQuery,
		MoveFileModalCustomerFolders_GetContactsWhereQueryVariables
	>(MoveFileModalCustomerFolders_GetContactsWhereDocument, options);
}
export function useMoveFileModalCustomerFolders_GetContactsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MoveFileModalCustomerFolders_GetContactsWhereQuery,
		MoveFileModalCustomerFolders_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MoveFileModalCustomerFolders_GetContactsWhereQuery,
		MoveFileModalCustomerFolders_GetContactsWhereQueryVariables
	>(MoveFileModalCustomerFolders_GetContactsWhereDocument, options);
}
export type MoveFileModalCustomerFolders_GetContactsWhereQueryHookResult =
	ReturnType<typeof useMoveFileModalCustomerFolders_GetContactsWhereQuery>;
export type MoveFileModalCustomerFolders_GetContactsWhereLazyQueryHookResult =
	ReturnType<typeof useMoveFileModalCustomerFolders_GetContactsWhereLazyQuery>;
export type MoveFileModalCustomerFolders_GetContactsWhereQueryResult =
	Apollo.QueryResult<
		MoveFileModalCustomerFolders_GetContactsWhereQuery,
		MoveFileModalCustomerFolders_GetContactsWhereQueryVariables
	>;
export const MoveFileModalCustomerFolders_GetDocumentsWhereDocument = gql`
	query MoveFileModalCustomerFolders_getDocumentsWhere(
		$orderBy: [DocumentOrderByInput]
		$where: CustomDocumentWhereInput!
	) {
		getDocumentsWhere(where: $where, orderBy: $orderBy) {
			_count
			documents {
				...useMoveFileModalCustomerFoldersDocument
			}
		}
	}
	${UseMoveFileModalCustomerFoldersDocumentFragmentDoc}
`;

/**
 * __useMoveFileModalCustomerFolders_GetDocumentsWhereQuery__
 *
 * To run a query within a React component, call `useMoveFileModalCustomerFolders_GetDocumentsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoveFileModalCustomerFolders_GetDocumentsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoveFileModalCustomerFolders_GetDocumentsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMoveFileModalCustomerFolders_GetDocumentsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		MoveFileModalCustomerFolders_GetDocumentsWhereQuery,
		MoveFileModalCustomerFolders_GetDocumentsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MoveFileModalCustomerFolders_GetDocumentsWhereQuery,
		MoveFileModalCustomerFolders_GetDocumentsWhereQueryVariables
	>(MoveFileModalCustomerFolders_GetDocumentsWhereDocument, options);
}
export function useMoveFileModalCustomerFolders_GetDocumentsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MoveFileModalCustomerFolders_GetDocumentsWhereQuery,
		MoveFileModalCustomerFolders_GetDocumentsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MoveFileModalCustomerFolders_GetDocumentsWhereQuery,
		MoveFileModalCustomerFolders_GetDocumentsWhereQueryVariables
	>(MoveFileModalCustomerFolders_GetDocumentsWhereDocument, options);
}
export type MoveFileModalCustomerFolders_GetDocumentsWhereQueryHookResult =
	ReturnType<typeof useMoveFileModalCustomerFolders_GetDocumentsWhereQuery>;
export type MoveFileModalCustomerFolders_GetDocumentsWhereLazyQueryHookResult =
	ReturnType<typeof useMoveFileModalCustomerFolders_GetDocumentsWhereLazyQuery>;
export type MoveFileModalCustomerFolders_GetDocumentsWhereQueryResult =
	Apollo.QueryResult<
		MoveFileModalCustomerFolders_GetDocumentsWhereQuery,
		MoveFileModalCustomerFolders_GetDocumentsWhereQueryVariables
	>;
export const MoveFileModal_GetFolderContentsDocument = gql`
	query MoveFileModal_getFolderContents($where: FolderWhereUniqueInput!) {
		getFolderContents(where: $where, take: 1000, orderBy: { createdAt: desc }) {
			id
			name
			parentFolder {
				id
				name
			}
			childFolders {
				...moveFileModalCustomFolder
			}
			documents {
				...moveFileModalCustomDocumentWithDownloadUrl
			}
		}
	}
	${MoveFileModalCustomFolderFragmentDoc}
	${MoveFileModalCustomDocumentWithDownloadUrlFragmentDoc}
`;

/**
 * __useMoveFileModal_GetFolderContentsQuery__
 *
 * To run a query within a React component, call `useMoveFileModal_GetFolderContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoveFileModal_GetFolderContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoveFileModal_GetFolderContentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMoveFileModal_GetFolderContentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		MoveFileModal_GetFolderContentsQuery,
		MoveFileModal_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MoveFileModal_GetFolderContentsQuery,
		MoveFileModal_GetFolderContentsQueryVariables
	>(MoveFileModal_GetFolderContentsDocument, options);
}
export function useMoveFileModal_GetFolderContentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MoveFileModal_GetFolderContentsQuery,
		MoveFileModal_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MoveFileModal_GetFolderContentsQuery,
		MoveFileModal_GetFolderContentsQueryVariables
	>(MoveFileModal_GetFolderContentsDocument, options);
}
export type MoveFileModal_GetFolderContentsQueryHookResult = ReturnType<
	typeof useMoveFileModal_GetFolderContentsQuery
>;
export type MoveFileModal_GetFolderContentsLazyQueryHookResult = ReturnType<
	typeof useMoveFileModal_GetFolderContentsLazyQuery
>;
export type MoveFileModal_GetFolderContentsQueryResult = Apollo.QueryResult<
	MoveFileModal_GetFolderContentsQuery,
	MoveFileModal_GetFolderContentsQueryVariables
>;
export const OrgMemberSignUp_CreateOrgUserDocument = gql`
	mutation OrgMemberSignUp_createOrgUser($data: OrgUserCreationInput!) {
		createOrgUser(data: $data) {
			...OrgMemberSignUp_OrgUserFields
		}
	}
	${OrgMemberSignUp_OrgUserFieldsFragmentDoc}
`;
export type OrgMemberSignUp_CreateOrgUserMutationFn = Apollo.MutationFunction<
	OrgMemberSignUp_CreateOrgUserMutation,
	OrgMemberSignUp_CreateOrgUserMutationVariables
>;

/**
 * __useOrgMemberSignUp_CreateOrgUserMutation__
 *
 * To run a mutation, you first call `useOrgMemberSignUp_CreateOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgMemberSignUp_CreateOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgMemberSignUpCreateOrgUserMutation, { data, loading, error }] = useOrgMemberSignUp_CreateOrgUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrgMemberSignUp_CreateOrgUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgMemberSignUp_CreateOrgUserMutation,
		OrgMemberSignUp_CreateOrgUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgMemberSignUp_CreateOrgUserMutation,
		OrgMemberSignUp_CreateOrgUserMutationVariables
	>(OrgMemberSignUp_CreateOrgUserDocument, options);
}
export type OrgMemberSignUp_CreateOrgUserMutationHookResult = ReturnType<
	typeof useOrgMemberSignUp_CreateOrgUserMutation
>;
export type OrgMemberSignUp_CreateOrgUserMutationResult =
	Apollo.MutationResult<OrgMemberSignUp_CreateOrgUserMutation>;
export type OrgMemberSignUp_CreateOrgUserMutationOptions =
	Apollo.BaseMutationOptions<
		OrgMemberSignUp_CreateOrgUserMutation,
		OrgMemberSignUp_CreateOrgUserMutationVariables
	>;
export const OrgMemberSignUp_LoginDocument = gql`
	query OrgMemberSignUp_login($data: UserLoginInput!) {
		login(data: $data) {
			token
		}
	}
`;

/**
 * __useOrgMemberSignUp_LoginQuery__
 *
 * To run a query within a React component, call `useOrgMemberSignUp_LoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgMemberSignUp_LoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgMemberSignUp_LoginQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrgMemberSignUp_LoginQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgMemberSignUp_LoginQuery,
		OrgMemberSignUp_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgMemberSignUp_LoginQuery,
		OrgMemberSignUp_LoginQueryVariables
	>(OrgMemberSignUp_LoginDocument, options);
}
export function useOrgMemberSignUp_LoginLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgMemberSignUp_LoginQuery,
		OrgMemberSignUp_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgMemberSignUp_LoginQuery,
		OrgMemberSignUp_LoginQueryVariables
	>(OrgMemberSignUp_LoginDocument, options);
}
export type OrgMemberSignUp_LoginQueryHookResult = ReturnType<
	typeof useOrgMemberSignUp_LoginQuery
>;
export type OrgMemberSignUp_LoginLazyQueryHookResult = ReturnType<
	typeof useOrgMemberSignUp_LoginLazyQuery
>;
export type OrgMemberSignUp_LoginQueryResult = Apollo.QueryResult<
	OrgMemberSignUp_LoginQuery,
	OrgMemberSignUp_LoginQueryVariables
>;
export const OrgMemberSignUp_GetAuthedUserDocument = gql`
	query OrgMemberSignUp_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			userType
			orgUser {
				...getAuthedUserFlattenedUserFieldsCalculatedOrgUser
			}
			groups {
				id
				name
			}
		}
	}
	${GetAuthedUserFlattenedUserFieldsCalculatedOrgUserFragmentDoc}
`;

/**
 * __useOrgMemberSignUp_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useOrgMemberSignUp_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgMemberSignUp_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgMemberSignUp_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgMemberSignUp_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgMemberSignUp_GetAuthedUserQuery,
		OrgMemberSignUp_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgMemberSignUp_GetAuthedUserQuery,
		OrgMemberSignUp_GetAuthedUserQueryVariables
	>(OrgMemberSignUp_GetAuthedUserDocument, options);
}
export function useOrgMemberSignUp_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgMemberSignUp_GetAuthedUserQuery,
		OrgMemberSignUp_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgMemberSignUp_GetAuthedUserQuery,
		OrgMemberSignUp_GetAuthedUserQueryVariables
	>(OrgMemberSignUp_GetAuthedUserDocument, options);
}
export type OrgMemberSignUp_GetAuthedUserQueryHookResult = ReturnType<
	typeof useOrgMemberSignUp_GetAuthedUserQuery
>;
export type OrgMemberSignUp_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useOrgMemberSignUp_GetAuthedUserLazyQuery
>;
export type OrgMemberSignUp_GetAuthedUserQueryResult = Apollo.QueryResult<
	OrgMemberSignUp_GetAuthedUserQuery,
	OrgMemberSignUp_GetAuthedUserQueryVariables
>;
export const OrgMemberSignUp_MarkUserOnboardingCompleteDocument = gql`
	mutation OrgMemberSignUp_markUserOnboardingComplete {
		markUserOnboardingComplete
	}
`;
export type OrgMemberSignUp_MarkUserOnboardingCompleteMutationFn =
	Apollo.MutationFunction<
		OrgMemberSignUp_MarkUserOnboardingCompleteMutation,
		OrgMemberSignUp_MarkUserOnboardingCompleteMutationVariables
	>;

/**
 * __useOrgMemberSignUp_MarkUserOnboardingCompleteMutation__
 *
 * To run a mutation, you first call `useOrgMemberSignUp_MarkUserOnboardingCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgMemberSignUp_MarkUserOnboardingCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgMemberSignUpMarkUserOnboardingCompleteMutation, { data, loading, error }] = useOrgMemberSignUp_MarkUserOnboardingCompleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useOrgMemberSignUp_MarkUserOnboardingCompleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgMemberSignUp_MarkUserOnboardingCompleteMutation,
		OrgMemberSignUp_MarkUserOnboardingCompleteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgMemberSignUp_MarkUserOnboardingCompleteMutation,
		OrgMemberSignUp_MarkUserOnboardingCompleteMutationVariables
	>(OrgMemberSignUp_MarkUserOnboardingCompleteDocument, options);
}
export type OrgMemberSignUp_MarkUserOnboardingCompleteMutationHookResult =
	ReturnType<typeof useOrgMemberSignUp_MarkUserOnboardingCompleteMutation>;
export type OrgMemberSignUp_MarkUserOnboardingCompleteMutationResult =
	Apollo.MutationResult<OrgMemberSignUp_MarkUserOnboardingCompleteMutation>;
export type OrgMemberSignUp_MarkUserOnboardingCompleteMutationOptions =
	Apollo.BaseMutationOptions<
		OrgMemberSignUp_MarkUserOnboardingCompleteMutation,
		OrgMemberSignUp_MarkUserOnboardingCompleteMutationVariables
	>;
export const OrgOnboarding_GetCouponDetailsDocument = gql`
	query OrgOnboarding_getCouponDetails($where: CouponByNameInput!) {
		getCouponDetails(where: $where) {
			...OrgOnboarding_ReducedCoupon
		}
	}
	${OrgOnboarding_ReducedCouponFragmentDoc}
`;

/**
 * __useOrgOnboarding_GetCouponDetailsQuery__
 *
 * To run a query within a React component, call `useOrgOnboarding_GetCouponDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_GetCouponDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboarding_GetCouponDetailsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_GetCouponDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboarding_GetCouponDetailsQuery,
		OrgOnboarding_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboarding_GetCouponDetailsQuery,
		OrgOnboarding_GetCouponDetailsQueryVariables
	>(OrgOnboarding_GetCouponDetailsDocument, options);
}
export function useOrgOnboarding_GetCouponDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboarding_GetCouponDetailsQuery,
		OrgOnboarding_GetCouponDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboarding_GetCouponDetailsQuery,
		OrgOnboarding_GetCouponDetailsQueryVariables
	>(OrgOnboarding_GetCouponDetailsDocument, options);
}
export type OrgOnboarding_GetCouponDetailsQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetCouponDetailsQuery
>;
export type OrgOnboarding_GetCouponDetailsLazyQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetCouponDetailsLazyQuery
>;
export type OrgOnboarding_GetCouponDetailsQueryResult = Apollo.QueryResult<
	OrgOnboarding_GetCouponDetailsQuery,
	OrgOnboarding_GetCouponDetailsQueryVariables
>;
export const OrgOnboarding_RegisterCouponUsageDocument = gql`
	mutation OrgOnboarding_registerCouponUsage(
		$data: RegisterCouponUsageWhere!
		$where: OrganizationWhereUniqueInput!
	) {
		registerCouponUsage(data: $data, where: $where) {
			id
		}
	}
`;
export type OrgOnboarding_RegisterCouponUsageMutationFn =
	Apollo.MutationFunction<
		OrgOnboarding_RegisterCouponUsageMutation,
		OrgOnboarding_RegisterCouponUsageMutationVariables
	>;

/**
 * __useOrgOnboarding_RegisterCouponUsageMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_RegisterCouponUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_RegisterCouponUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingRegisterCouponUsageMutation, { data, loading, error }] = useOrgOnboarding_RegisterCouponUsageMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_RegisterCouponUsageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_RegisterCouponUsageMutation,
		OrgOnboarding_RegisterCouponUsageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_RegisterCouponUsageMutation,
		OrgOnboarding_RegisterCouponUsageMutationVariables
	>(OrgOnboarding_RegisterCouponUsageDocument, options);
}
export type OrgOnboarding_RegisterCouponUsageMutationHookResult = ReturnType<
	typeof useOrgOnboarding_RegisterCouponUsageMutation
>;
export type OrgOnboarding_RegisterCouponUsageMutationResult =
	Apollo.MutationResult<OrgOnboarding_RegisterCouponUsageMutation>;
export type OrgOnboarding_RegisterCouponUsageMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_RegisterCouponUsageMutation,
		OrgOnboarding_RegisterCouponUsageMutationVariables
	>;
export const OrgOnboarding_UpdateOrgUserExposureDocument = gql`
	mutation OrgOnboarding_updateOrgUserExposure(
		$data: OrgUserUpdateCustomInput!
		$where: OrgUserWhereUniqueInput!
	) {
		updateOrgUser(data: $data, where: $where) {
			id
		}
	}
`;
export type OrgOnboarding_UpdateOrgUserExposureMutationFn =
	Apollo.MutationFunction<
		OrgOnboarding_UpdateOrgUserExposureMutation,
		OrgOnboarding_UpdateOrgUserExposureMutationVariables
	>;

/**
 * __useOrgOnboarding_UpdateOrgUserExposureMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_UpdateOrgUserExposureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_UpdateOrgUserExposureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingUpdateOrgUserExposureMutation, { data, loading, error }] = useOrgOnboarding_UpdateOrgUserExposureMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_UpdateOrgUserExposureMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_UpdateOrgUserExposureMutation,
		OrgOnboarding_UpdateOrgUserExposureMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_UpdateOrgUserExposureMutation,
		OrgOnboarding_UpdateOrgUserExposureMutationVariables
	>(OrgOnboarding_UpdateOrgUserExposureDocument, options);
}
export type OrgOnboarding_UpdateOrgUserExposureMutationHookResult = ReturnType<
	typeof useOrgOnboarding_UpdateOrgUserExposureMutation
>;
export type OrgOnboarding_UpdateOrgUserExposureMutationResult =
	Apollo.MutationResult<OrgOnboarding_UpdateOrgUserExposureMutation>;
export type OrgOnboarding_UpdateOrgUserExposureMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_UpdateOrgUserExposureMutation,
		OrgOnboarding_UpdateOrgUserExposureMutationVariables
	>;
export const OrgOnboarding_MarkUserOnboardingCompleteDocument = gql`
	mutation OrgOnboarding_markUserOnboardingComplete {
		markUserOnboardingComplete
	}
`;
export type OrgOnboarding_MarkUserOnboardingCompleteMutationFn =
	Apollo.MutationFunction<
		OrgOnboarding_MarkUserOnboardingCompleteMutation,
		OrgOnboarding_MarkUserOnboardingCompleteMutationVariables
	>;

/**
 * __useOrgOnboarding_MarkUserOnboardingCompleteMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_MarkUserOnboardingCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_MarkUserOnboardingCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingMarkUserOnboardingCompleteMutation, { data, loading, error }] = useOrgOnboarding_MarkUserOnboardingCompleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useOrgOnboarding_MarkUserOnboardingCompleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_MarkUserOnboardingCompleteMutation,
		OrgOnboarding_MarkUserOnboardingCompleteMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_MarkUserOnboardingCompleteMutation,
		OrgOnboarding_MarkUserOnboardingCompleteMutationVariables
	>(OrgOnboarding_MarkUserOnboardingCompleteDocument, options);
}
export type OrgOnboarding_MarkUserOnboardingCompleteMutationHookResult =
	ReturnType<typeof useOrgOnboarding_MarkUserOnboardingCompleteMutation>;
export type OrgOnboarding_MarkUserOnboardingCompleteMutationResult =
	Apollo.MutationResult<OrgOnboarding_MarkUserOnboardingCompleteMutation>;
export type OrgOnboarding_MarkUserOnboardingCompleteMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_MarkUserOnboardingCompleteMutation,
		OrgOnboarding_MarkUserOnboardingCompleteMutationVariables
	>;
export const OrgOnboarding_LoginDocument = gql`
	query OrgOnboarding_login($data: UserLoginInput!) {
		login(data: $data) {
			token
		}
	}
`;

/**
 * __useOrgOnboarding_LoginQuery__
 *
 * To run a query within a React component, call `useOrgOnboarding_LoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_LoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboarding_LoginQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrgOnboarding_LoginQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboarding_LoginQuery,
		OrgOnboarding_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboarding_LoginQuery,
		OrgOnboarding_LoginQueryVariables
	>(OrgOnboarding_LoginDocument, options);
}
export function useOrgOnboarding_LoginLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboarding_LoginQuery,
		OrgOnboarding_LoginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboarding_LoginQuery,
		OrgOnboarding_LoginQueryVariables
	>(OrgOnboarding_LoginDocument, options);
}
export type OrgOnboarding_LoginQueryHookResult = ReturnType<
	typeof useOrgOnboarding_LoginQuery
>;
export type OrgOnboarding_LoginLazyQueryHookResult = ReturnType<
	typeof useOrgOnboarding_LoginLazyQuery
>;
export type OrgOnboarding_LoginQueryResult = Apollo.QueryResult<
	OrgOnboarding_LoginQuery,
	OrgOnboarding_LoginQueryVariables
>;
export const OrgOnboarding_GetAuthedUserDocument = gql`
	query OrgOnboarding_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			userType
			orgUser {
				...getAuthedUserFlattenedUserFieldsCalculatedOrgUser
			}
			groups {
				id
				name
			}
		}
	}
	${GetAuthedUserFlattenedUserFieldsCalculatedOrgUserFragmentDoc}
`;

/**
 * __useOrgOnboarding_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useOrgOnboarding_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboarding_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboarding_GetAuthedUserQuery,
		OrgOnboarding_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboarding_GetAuthedUserQuery,
		OrgOnboarding_GetAuthedUserQueryVariables
	>(OrgOnboarding_GetAuthedUserDocument, options);
}
export function useOrgOnboarding_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboarding_GetAuthedUserQuery,
		OrgOnboarding_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboarding_GetAuthedUserQuery,
		OrgOnboarding_GetAuthedUserQueryVariables
	>(OrgOnboarding_GetAuthedUserDocument, options);
}
export type OrgOnboarding_GetAuthedUserQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetAuthedUserQuery
>;
export type OrgOnboarding_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetAuthedUserLazyQuery
>;
export type OrgOnboarding_GetAuthedUserQueryResult = Apollo.QueryResult<
	OrgOnboarding_GetAuthedUserQuery,
	OrgOnboarding_GetAuthedUserQueryVariables
>;
export const OrgOnboarding_GetServicesWhereDocument = gql`
	query OrgOnboarding_getServicesWhere {
		getServicesWhere {
			id
			name
		}
	}
`;

/**
 * __useOrgOnboarding_GetServicesWhereQuery__
 *
 * To run a query within a React component, call `useOrgOnboarding_GetServicesWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_GetServicesWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboarding_GetServicesWhereQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgOnboarding_GetServicesWhereQuery(
	baseOptions?: Apollo.QueryHookOptions<
		OrgOnboarding_GetServicesWhereQuery,
		OrgOnboarding_GetServicesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboarding_GetServicesWhereQuery,
		OrgOnboarding_GetServicesWhereQueryVariables
	>(OrgOnboarding_GetServicesWhereDocument, options);
}
export function useOrgOnboarding_GetServicesWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboarding_GetServicesWhereQuery,
		OrgOnboarding_GetServicesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboarding_GetServicesWhereQuery,
		OrgOnboarding_GetServicesWhereQueryVariables
	>(OrgOnboarding_GetServicesWhereDocument, options);
}
export type OrgOnboarding_GetServicesWhereQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetServicesWhereQuery
>;
export type OrgOnboarding_GetServicesWhereLazyQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetServicesWhereLazyQuery
>;
export type OrgOnboarding_GetServicesWhereQueryResult = Apollo.QueryResult<
	OrgOnboarding_GetServicesWhereQuery,
	OrgOnboarding_GetServicesWhereQueryVariables
>;
export const OrgOnboarding_RequestOrgProfileImageUploadUrlDocument = gql`
	query OrgOnboarding_requestOrgProfileImageUploadUrl(
		$data: RequestImageUploadUrlInput!
	) {
		requestOrgProfileImageUploadUrl(data: $data) {
			uploadURL
		}
	}
`;

/**
 * __useOrgOnboarding_RequestOrgProfileImageUploadUrlQuery__
 *
 * To run a query within a React component, call `useOrgOnboarding_RequestOrgProfileImageUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_RequestOrgProfileImageUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboarding_RequestOrgProfileImageUploadUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrgOnboarding_RequestOrgProfileImageUploadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboarding_RequestOrgProfileImageUploadUrlQuery,
		OrgOnboarding_RequestOrgProfileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboarding_RequestOrgProfileImageUploadUrlQuery,
		OrgOnboarding_RequestOrgProfileImageUploadUrlQueryVariables
	>(OrgOnboarding_RequestOrgProfileImageUploadUrlDocument, options);
}
export function useOrgOnboarding_RequestOrgProfileImageUploadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboarding_RequestOrgProfileImageUploadUrlQuery,
		OrgOnboarding_RequestOrgProfileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboarding_RequestOrgProfileImageUploadUrlQuery,
		OrgOnboarding_RequestOrgProfileImageUploadUrlQueryVariables
	>(OrgOnboarding_RequestOrgProfileImageUploadUrlDocument, options);
}
export type OrgOnboarding_RequestOrgProfileImageUploadUrlQueryHookResult =
	ReturnType<typeof useOrgOnboarding_RequestOrgProfileImageUploadUrlQuery>;
export type OrgOnboarding_RequestOrgProfileImageUploadUrlLazyQueryHookResult =
	ReturnType<typeof useOrgOnboarding_RequestOrgProfileImageUploadUrlLazyQuery>;
export type OrgOnboarding_RequestOrgProfileImageUploadUrlQueryResult =
	Apollo.QueryResult<
		OrgOnboarding_RequestOrgProfileImageUploadUrlQuery,
		OrgOnboarding_RequestOrgProfileImageUploadUrlQueryVariables
	>;
export const OrgOnboarding_CreateOrganizationDocument = gql`
	mutation OrgOnboarding_createOrganization(
		$data: OrganizationCustomCreateInput!
	) {
		createOrganization(data: $data) {
			...orgOnboardingOrganization
		}
	}
	${OrgOnboardingOrganizationFragmentDoc}
`;
export type OrgOnboarding_CreateOrganizationMutationFn =
	Apollo.MutationFunction<
		OrgOnboarding_CreateOrganizationMutation,
		OrgOnboarding_CreateOrganizationMutationVariables
	>;

/**
 * __useOrgOnboarding_CreateOrganizationMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_CreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_CreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingCreateOrganizationMutation, { data, loading, error }] = useOrgOnboarding_CreateOrganizationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrgOnboarding_CreateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_CreateOrganizationMutation,
		OrgOnboarding_CreateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_CreateOrganizationMutation,
		OrgOnboarding_CreateOrganizationMutationVariables
	>(OrgOnboarding_CreateOrganizationDocument, options);
}
export type OrgOnboarding_CreateOrganizationMutationHookResult = ReturnType<
	typeof useOrgOnboarding_CreateOrganizationMutation
>;
export type OrgOnboarding_CreateOrganizationMutationResult =
	Apollo.MutationResult<OrgOnboarding_CreateOrganizationMutation>;
export type OrgOnboarding_CreateOrganizationMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_CreateOrganizationMutation,
		OrgOnboarding_CreateOrganizationMutationVariables
	>;
export const OrgOnboarding_UpdateOrganizationDocument = gql`
	mutation OrgOnboarding_updateOrganization(
		$data: OrganizationCustomUpdateInput!
		$where: OrganizationWhereUniqueInput!
	) {
		updateOrganization(data: $data, where: $where) {
			...orgOnboardingOrganization
		}
	}
	${OrgOnboardingOrganizationFragmentDoc}
`;
export type OrgOnboarding_UpdateOrganizationMutationFn =
	Apollo.MutationFunction<
		OrgOnboarding_UpdateOrganizationMutation,
		OrgOnboarding_UpdateOrganizationMutationVariables
	>;

/**
 * __useOrgOnboarding_UpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_UpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_UpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingUpdateOrganizationMutation, { data, loading, error }] = useOrgOnboarding_UpdateOrganizationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_UpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_UpdateOrganizationMutation,
		OrgOnboarding_UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_UpdateOrganizationMutation,
		OrgOnboarding_UpdateOrganizationMutationVariables
	>(OrgOnboarding_UpdateOrganizationDocument, options);
}
export type OrgOnboarding_UpdateOrganizationMutationHookResult = ReturnType<
	typeof useOrgOnboarding_UpdateOrganizationMutation
>;
export type OrgOnboarding_UpdateOrganizationMutationResult =
	Apollo.MutationResult<OrgOnboarding_UpdateOrganizationMutation>;
export type OrgOnboarding_UpdateOrganizationMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_UpdateOrganizationMutation,
		OrgOnboarding_UpdateOrganizationMutationVariables
	>;
export const OrgOnboarding_GetOrgUserWhereDocument = gql`
	query OrgOnboarding_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				image
				imageScale
				imageRotation
				imagePositionX
				imagePositionY
			}
			user {
				id
				acceptedTerms
				consentedToAgeAndMarketingEmails
			}
		}
	}
`;

/**
 * __useOrgOnboarding_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useOrgOnboarding_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboarding_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboarding_GetOrgUserWhereQuery,
		OrgOnboarding_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboarding_GetOrgUserWhereQuery,
		OrgOnboarding_GetOrgUserWhereQueryVariables
	>(OrgOnboarding_GetOrgUserWhereDocument, options);
}
export function useOrgOnboarding_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboarding_GetOrgUserWhereQuery,
		OrgOnboarding_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboarding_GetOrgUserWhereQuery,
		OrgOnboarding_GetOrgUserWhereQueryVariables
	>(OrgOnboarding_GetOrgUserWhereDocument, options);
}
export type OrgOnboarding_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetOrgUserWhereQuery
>;
export type OrgOnboarding_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetOrgUserWhereLazyQuery
>;
export type OrgOnboarding_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	OrgOnboarding_GetOrgUserWhereQuery,
	OrgOnboarding_GetOrgUserWhereQueryVariables
>;
export const OrgOnboarding_UpdateOrgUserTermsOfAcceptanceDocument = gql`
	mutation OrgOnboarding_updateOrgUserTermsOfAcceptance(
		$data: OrgUserUpdateCustomInput!
		$where: OrgUserWhereUniqueInput!
	) {
		updateOrgUser(data: $data, where: $where) {
			id
		}
	}
`;
export type OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationFn =
	Apollo.MutationFunction<
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation,
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationVariables
	>;

/**
 * __useOrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingUpdateOrgUserTermsOfAcceptanceMutation, { data, loading, error }] = useOrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation,
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation,
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationVariables
	>(OrgOnboarding_UpdateOrgUserTermsOfAcceptanceDocument, options);
}
export type OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationHookResult =
	ReturnType<typeof useOrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation>;
export type OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationResult =
	Apollo.MutationResult<OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation>;
export type OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutation,
		OrgOnboarding_UpdateOrgUserTermsOfAcceptanceMutationVariables
	>;
export const OrgOnboarding_GetStripeConnectAccountDocument = gql`
	query OrgOnboarding_getStripeConnectAccount(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripeConnectAccount(where: $where) {
			id
		}
	}
`;

/**
 * __useOrgOnboarding_GetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `useOrgOnboarding_GetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_GetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboarding_GetStripeConnectAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_GetStripeConnectAccountQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboarding_GetStripeConnectAccountQuery,
		OrgOnboarding_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboarding_GetStripeConnectAccountQuery,
		OrgOnboarding_GetStripeConnectAccountQueryVariables
	>(OrgOnboarding_GetStripeConnectAccountDocument, options);
}
export function useOrgOnboarding_GetStripeConnectAccountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboarding_GetStripeConnectAccountQuery,
		OrgOnboarding_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboarding_GetStripeConnectAccountQuery,
		OrgOnboarding_GetStripeConnectAccountQueryVariables
	>(OrgOnboarding_GetStripeConnectAccountDocument, options);
}
export type OrgOnboarding_GetStripeConnectAccountQueryHookResult = ReturnType<
	typeof useOrgOnboarding_GetStripeConnectAccountQuery
>;
export type OrgOnboarding_GetStripeConnectAccountLazyQueryHookResult =
	ReturnType<typeof useOrgOnboarding_GetStripeConnectAccountLazyQuery>;
export type OrgOnboarding_GetStripeConnectAccountQueryResult =
	Apollo.QueryResult<
		OrgOnboarding_GetStripeConnectAccountQuery,
		OrgOnboarding_GetStripeConnectAccountQueryVariables
	>;
export const OrgOnboarding_CreateStripeConnectAccountDocument = gql`
	mutation OrgOnboarding_createStripeConnectAccount(
		$data: StripeConnectAccountCreationInput!
		$where: OrganizationWhereUniqueInput!
	) {
		createStripeConnectAccount(data: $data, where: $where) {
			id
		}
	}
`;
export type OrgOnboarding_CreateStripeConnectAccountMutationFn =
	Apollo.MutationFunction<
		OrgOnboarding_CreateStripeConnectAccountMutation,
		OrgOnboarding_CreateStripeConnectAccountMutationVariables
	>;

/**
 * __useOrgOnboarding_CreateStripeConnectAccountMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_CreateStripeConnectAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_CreateStripeConnectAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingCreateStripeConnectAccountMutation, { data, loading, error }] = useOrgOnboarding_CreateStripeConnectAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_CreateStripeConnectAccountMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_CreateStripeConnectAccountMutation,
		OrgOnboarding_CreateStripeConnectAccountMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_CreateStripeConnectAccountMutation,
		OrgOnboarding_CreateStripeConnectAccountMutationVariables
	>(OrgOnboarding_CreateStripeConnectAccountDocument, options);
}
export type OrgOnboarding_CreateStripeConnectAccountMutationHookResult =
	ReturnType<typeof useOrgOnboarding_CreateStripeConnectAccountMutation>;
export type OrgOnboarding_CreateStripeConnectAccountMutationResult =
	Apollo.MutationResult<OrgOnboarding_CreateStripeConnectAccountMutation>;
export type OrgOnboarding_CreateStripeConnectAccountMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_CreateStripeConnectAccountMutation,
		OrgOnboarding_CreateStripeConnectAccountMutationVariables
	>;
export const OrgOnboarding_CreateOrgUserDocument = gql`
	mutation OrgOnboarding_createOrgUser($data: OrgUserCreationInput!) {
		createOrgUser(data: $data) {
			id
			firstName
			lastName
			user {
				id
				email
				userType
			}
		}
	}
`;
export type OrgOnboarding_CreateOrgUserMutationFn = Apollo.MutationFunction<
	OrgOnboarding_CreateOrgUserMutation,
	OrgOnboarding_CreateOrgUserMutationVariables
>;

/**
 * __useOrgOnboarding_CreateOrgUserMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_CreateOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_CreateOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingCreateOrgUserMutation, { data, loading, error }] = useOrgOnboarding_CreateOrgUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrgOnboarding_CreateOrgUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_CreateOrgUserMutation,
		OrgOnboarding_CreateOrgUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_CreateOrgUserMutation,
		OrgOnboarding_CreateOrgUserMutationVariables
	>(OrgOnboarding_CreateOrgUserDocument, options);
}
export type OrgOnboarding_CreateOrgUserMutationHookResult = ReturnType<
	typeof useOrgOnboarding_CreateOrgUserMutation
>;
export type OrgOnboarding_CreateOrgUserMutationResult =
	Apollo.MutationResult<OrgOnboarding_CreateOrgUserMutation>;
export type OrgOnboarding_CreateOrgUserMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_CreateOrgUserMutation,
		OrgOnboarding_CreateOrgUserMutationVariables
	>;
export const OrgOnboarding_UpdateOrgUserDocument = gql`
	mutation OrgOnboarding_updateOrgUser(
		$data: OrgUserUpdateCustomInput!
		$where: OrgUserWhereUniqueInput!
	) {
		updateOrgUser(data: $data, where: $where) {
			id
			firstName
			lastName
			user {
				id
				email
				userType
			}
		}
	}
`;
export type OrgOnboarding_UpdateOrgUserMutationFn = Apollo.MutationFunction<
	OrgOnboarding_UpdateOrgUserMutation,
	OrgOnboarding_UpdateOrgUserMutationVariables
>;

/**
 * __useOrgOnboarding_UpdateOrgUserMutation__
 *
 * To run a mutation, you first call `useOrgOnboarding_UpdateOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboarding_UpdateOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingUpdateOrgUserMutation, { data, loading, error }] = useOrgOnboarding_UpdateOrgUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboarding_UpdateOrgUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboarding_UpdateOrgUserMutation,
		OrgOnboarding_UpdateOrgUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboarding_UpdateOrgUserMutation,
		OrgOnboarding_UpdateOrgUserMutationVariables
	>(OrgOnboarding_UpdateOrgUserDocument, options);
}
export type OrgOnboarding_UpdateOrgUserMutationHookResult = ReturnType<
	typeof useOrgOnboarding_UpdateOrgUserMutation
>;
export type OrgOnboarding_UpdateOrgUserMutationResult =
	Apollo.MutationResult<OrgOnboarding_UpdateOrgUserMutation>;
export type OrgOnboarding_UpdateOrgUserMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboarding_UpdateOrgUserMutation,
		OrgOnboarding_UpdateOrgUserMutationVariables
	>;
export const OrgOnboardingModal_GetGlobalVariablesDocument = gql`
	query OrgOnboardingModal_getGlobalVariables {
		getGlobalVariables {
			WhiteGloveUrl
			WatchDemoUrl
			DemoCalendarUrl
		}
	}
`;

/**
 * __useOrgOnboardingModal_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useOrgOnboardingModal_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboardingModal_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboardingModal_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgOnboardingModal_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		OrgOnboardingModal_GetGlobalVariablesQuery,
		OrgOnboardingModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboardingModal_GetGlobalVariablesQuery,
		OrgOnboardingModal_GetGlobalVariablesQueryVariables
	>(OrgOnboardingModal_GetGlobalVariablesDocument, options);
}
export function useOrgOnboardingModal_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboardingModal_GetGlobalVariablesQuery,
		OrgOnboardingModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboardingModal_GetGlobalVariablesQuery,
		OrgOnboardingModal_GetGlobalVariablesQueryVariables
	>(OrgOnboardingModal_GetGlobalVariablesDocument, options);
}
export type OrgOnboardingModal_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useOrgOnboardingModal_GetGlobalVariablesQuery
>;
export type OrgOnboardingModal_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useOrgOnboardingModal_GetGlobalVariablesLazyQuery>;
export type OrgOnboardingModal_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		OrgOnboardingModal_GetGlobalVariablesQuery,
		OrgOnboardingModal_GetGlobalVariablesQueryVariables
	>;
export const OrgOnboardingModal_GetStripeConnectAccountDocument = gql`
	query OrgOnboardingModal_getStripeConnectAccount(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripeConnectAccount(where: $where) {
			external_accounts {
				data {
					id
				}
			}
		}
	}
`;

/**
 * __useOrgOnboardingModal_GetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `useOrgOnboardingModal_GetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboardingModal_GetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboardingModal_GetStripeConnectAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboardingModal_GetStripeConnectAccountQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboardingModal_GetStripeConnectAccountQuery,
		OrgOnboardingModal_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboardingModal_GetStripeConnectAccountQuery,
		OrgOnboardingModal_GetStripeConnectAccountQueryVariables
	>(OrgOnboardingModal_GetStripeConnectAccountDocument, options);
}
export function useOrgOnboardingModal_GetStripeConnectAccountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboardingModal_GetStripeConnectAccountQuery,
		OrgOnboardingModal_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboardingModal_GetStripeConnectAccountQuery,
		OrgOnboardingModal_GetStripeConnectAccountQueryVariables
	>(OrgOnboardingModal_GetStripeConnectAccountDocument, options);
}
export type OrgOnboardingModal_GetStripeConnectAccountQueryHookResult =
	ReturnType<typeof useOrgOnboardingModal_GetStripeConnectAccountQuery>;
export type OrgOnboardingModal_GetStripeConnectAccountLazyQueryHookResult =
	ReturnType<typeof useOrgOnboardingModal_GetStripeConnectAccountLazyQuery>;
export type OrgOnboardingModal_GetStripeConnectAccountQueryResult =
	Apollo.QueryResult<
		OrgOnboardingModal_GetStripeConnectAccountQuery,
		OrgOnboardingModal_GetStripeConnectAccountQueryVariables
	>;
export const OrganizationDetail_GetOrganizationWhereDocument = gql`
	query organizationDetail_getOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			...organizationDetailHeaderOrganization
		}
	}
	${OrganizationDetailHeaderOrganizationFragmentDoc}
`;

/**
 * __useOrganizationDetail_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useOrganizationDetail_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetail_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDetail_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrganizationDetail_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrganizationDetail_GetOrganizationWhereQuery,
		OrganizationDetail_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrganizationDetail_GetOrganizationWhereQuery,
		OrganizationDetail_GetOrganizationWhereQueryVariables
	>(OrganizationDetail_GetOrganizationWhereDocument, options);
}
export function useOrganizationDetail_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrganizationDetail_GetOrganizationWhereQuery,
		OrganizationDetail_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrganizationDetail_GetOrganizationWhereQuery,
		OrganizationDetail_GetOrganizationWhereQueryVariables
	>(OrganizationDetail_GetOrganizationWhereDocument, options);
}
export type OrganizationDetail_GetOrganizationWhereQueryHookResult = ReturnType<
	typeof useOrganizationDetail_GetOrganizationWhereQuery
>;
export type OrganizationDetail_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<typeof useOrganizationDetail_GetOrganizationWhereLazyQuery>;
export type OrganizationDetail_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		OrganizationDetail_GetOrganizationWhereQuery,
		OrganizationDetail_GetOrganizationWhereQueryVariables
	>;
export const OrganizationDetail_GetContactWhereDocument = gql`
	query organizationDetail_getContactWhere($customerId: ID!, $orgId: ID!) {
		getContactWhere(
			where: { vendor: { id: $orgId }, customer: { id: $customerId } }
		) {
			...organizationDetailContact
		}
	}
	${OrganizationDetailContactFragmentDoc}
`;

/**
 * __useOrganizationDetail_GetContactWhereQuery__
 *
 * To run a query within a React component, call `useOrganizationDetail_GetContactWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetail_GetContactWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDetail_GetContactWhereQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useOrganizationDetail_GetContactWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrganizationDetail_GetContactWhereQuery,
		OrganizationDetail_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrganizationDetail_GetContactWhereQuery,
		OrganizationDetail_GetContactWhereQueryVariables
	>(OrganizationDetail_GetContactWhereDocument, options);
}
export function useOrganizationDetail_GetContactWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrganizationDetail_GetContactWhereQuery,
		OrganizationDetail_GetContactWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrganizationDetail_GetContactWhereQuery,
		OrganizationDetail_GetContactWhereQueryVariables
	>(OrganizationDetail_GetContactWhereDocument, options);
}
export type OrganizationDetail_GetContactWhereQueryHookResult = ReturnType<
	typeof useOrganizationDetail_GetContactWhereQuery
>;
export type OrganizationDetail_GetContactWhereLazyQueryHookResult = ReturnType<
	typeof useOrganizationDetail_GetContactWhereLazyQuery
>;
export type OrganizationDetail_GetContactWhereQueryResult = Apollo.QueryResult<
	OrganizationDetail_GetContactWhereQuery,
	OrganizationDetail_GetContactWhereQueryVariables
>;
export const OrganizationDetail_ActivateContactDocument = gql`
	mutation organizationDetail_activateContact(
		$where: ContactWhereUniqueInput!
		$data: ActivateContactCustomInput
	) {
		activateContact(where: $where, data: $data) {
			...organizationDetailContact
		}
	}
	${OrganizationDetailContactFragmentDoc}
`;
export type OrganizationDetail_ActivateContactMutationFn =
	Apollo.MutationFunction<
		OrganizationDetail_ActivateContactMutation,
		OrganizationDetail_ActivateContactMutationVariables
	>;

/**
 * __useOrganizationDetail_ActivateContactMutation__
 *
 * To run a mutation, you first call `useOrganizationDetail_ActivateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetail_ActivateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationDetailActivateContactMutation, { data, loading, error }] = useOrganizationDetail_ActivateContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrganizationDetail_ActivateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrganizationDetail_ActivateContactMutation,
		OrganizationDetail_ActivateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrganizationDetail_ActivateContactMutation,
		OrganizationDetail_ActivateContactMutationVariables
	>(OrganizationDetail_ActivateContactDocument, options);
}
export type OrganizationDetail_ActivateContactMutationHookResult = ReturnType<
	typeof useOrganizationDetail_ActivateContactMutation
>;
export type OrganizationDetail_ActivateContactMutationResult =
	Apollo.MutationResult<OrganizationDetail_ActivateContactMutation>;
export type OrganizationDetail_ActivateContactMutationOptions =
	Apollo.BaseMutationOptions<
		OrganizationDetail_ActivateContactMutation,
		OrganizationDetail_ActivateContactMutationVariables
	>;
export const OrganizationDetail_CreateContactAsClientDocument = gql`
	mutation organizationDetail_createContactAsClient(
		$where: UserByIdUniqueInput!
		$data: OrganizationWhereUniqueInput!
	) {
		createContactAsClient(where: $where, data: $data) {
			...organizationDetailContact
		}
	}
	${OrganizationDetailContactFragmentDoc}
`;
export type OrganizationDetail_CreateContactAsClientMutationFn =
	Apollo.MutationFunction<
		OrganizationDetail_CreateContactAsClientMutation,
		OrganizationDetail_CreateContactAsClientMutationVariables
	>;

/**
 * __useOrganizationDetail_CreateContactAsClientMutation__
 *
 * To run a mutation, you first call `useOrganizationDetail_CreateContactAsClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetail_CreateContactAsClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationDetailCreateContactAsClientMutation, { data, loading, error }] = useOrganizationDetail_CreateContactAsClientMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrganizationDetail_CreateContactAsClientMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrganizationDetail_CreateContactAsClientMutation,
		OrganizationDetail_CreateContactAsClientMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrganizationDetail_CreateContactAsClientMutation,
		OrganizationDetail_CreateContactAsClientMutationVariables
	>(OrganizationDetail_CreateContactAsClientDocument, options);
}
export type OrganizationDetail_CreateContactAsClientMutationHookResult =
	ReturnType<typeof useOrganizationDetail_CreateContactAsClientMutation>;
export type OrganizationDetail_CreateContactAsClientMutationResult =
	Apollo.MutationResult<OrganizationDetail_CreateContactAsClientMutation>;
export type OrganizationDetail_CreateContactAsClientMutationOptions =
	Apollo.BaseMutationOptions<
		OrganizationDetail_CreateContactAsClientMutation,
		OrganizationDetail_CreateContactAsClientMutationVariables
	>;
export const OrganizationDetail_DeclineContactDocument = gql`
	mutation organizationDetail_declineContact($where: ContactWhereUniqueInput!) {
		declineContact(where: $where) {
			...organizationDetailContact
		}
	}
	${OrganizationDetailContactFragmentDoc}
`;
export type OrganizationDetail_DeclineContactMutationFn =
	Apollo.MutationFunction<
		OrganizationDetail_DeclineContactMutation,
		OrganizationDetail_DeclineContactMutationVariables
	>;

/**
 * __useOrganizationDetail_DeclineContactMutation__
 *
 * To run a mutation, you first call `useOrganizationDetail_DeclineContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetail_DeclineContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationDetailDeclineContactMutation, { data, loading, error }] = useOrganizationDetail_DeclineContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrganizationDetail_DeclineContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrganizationDetail_DeclineContactMutation,
		OrganizationDetail_DeclineContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrganizationDetail_DeclineContactMutation,
		OrganizationDetail_DeclineContactMutationVariables
	>(OrganizationDetail_DeclineContactDocument, options);
}
export type OrganizationDetail_DeclineContactMutationHookResult = ReturnType<
	typeof useOrganizationDetail_DeclineContactMutation
>;
export type OrganizationDetail_DeclineContactMutationResult =
	Apollo.MutationResult<OrganizationDetail_DeclineContactMutation>;
export type OrganizationDetail_DeclineContactMutationOptions =
	Apollo.BaseMutationOptions<
		OrganizationDetail_DeclineContactMutation,
		OrganizationDetail_DeclineContactMutationVariables
	>;
export const OrganizationDetail_CancelContactDocument = gql`
	mutation organizationDetail_cancelContact($where: ContactWhereUniqueInput!) {
		cancelContact(where: $where) {
			...organizationDetailContact
		}
	}
	${OrganizationDetailContactFragmentDoc}
`;
export type OrganizationDetail_CancelContactMutationFn =
	Apollo.MutationFunction<
		OrganizationDetail_CancelContactMutation,
		OrganizationDetail_CancelContactMutationVariables
	>;

/**
 * __useOrganizationDetail_CancelContactMutation__
 *
 * To run a mutation, you first call `useOrganizationDetail_CancelContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetail_CancelContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationDetailCancelContactMutation, { data, loading, error }] = useOrganizationDetail_CancelContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrganizationDetail_CancelContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrganizationDetail_CancelContactMutation,
		OrganizationDetail_CancelContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrganizationDetail_CancelContactMutation,
		OrganizationDetail_CancelContactMutationVariables
	>(OrganizationDetail_CancelContactDocument, options);
}
export type OrganizationDetail_CancelContactMutationHookResult = ReturnType<
	typeof useOrganizationDetail_CancelContactMutation
>;
export type OrganizationDetail_CancelContactMutationResult =
	Apollo.MutationResult<OrganizationDetail_CancelContactMutation>;
export type OrganizationDetail_CancelContactMutationOptions =
	Apollo.BaseMutationOptions<
		OrganizationDetail_CancelContactMutation,
		OrganizationDetail_CancelContactMutationVariables
	>;
export const EventNotifications_DismissAllEventsDocument = gql`
	mutation EventNotifications_DismissAllEvents {
		dismissAllEvents
	}
`;
export type EventNotifications_DismissAllEventsMutationFn =
	Apollo.MutationFunction<
		EventNotifications_DismissAllEventsMutation,
		EventNotifications_DismissAllEventsMutationVariables
	>;

/**
 * __useEventNotifications_DismissAllEventsMutation__
 *
 * To run a mutation, you first call `useEventNotifications_DismissAllEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventNotifications_DismissAllEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventNotificationsDismissAllEventsMutation, { data, loading, error }] = useEventNotifications_DismissAllEventsMutation({
 *   variables: {
 *   },
 * });
 */
export function useEventNotifications_DismissAllEventsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EventNotifications_DismissAllEventsMutation,
		EventNotifications_DismissAllEventsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EventNotifications_DismissAllEventsMutation,
		EventNotifications_DismissAllEventsMutationVariables
	>(EventNotifications_DismissAllEventsDocument, options);
}
export type EventNotifications_DismissAllEventsMutationHookResult = ReturnType<
	typeof useEventNotifications_DismissAllEventsMutation
>;
export type EventNotifications_DismissAllEventsMutationResult =
	Apollo.MutationResult<EventNotifications_DismissAllEventsMutation>;
export type EventNotifications_DismissAllEventsMutationOptions =
	Apollo.BaseMutationOptions<
		EventNotifications_DismissAllEventsMutation,
		EventNotifications_DismissAllEventsMutationVariables
	>;
export const MobileMenuHelpAccordion_GetGlobalVariablesDocument = gql`
	query MobileMenuHelpAccordion_getGlobalVariables {
		getGlobalVariables {
			HelpUrl
		}
	}
`;

/**
 * __useMobileMenuHelpAccordion_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useMobileMenuHelpAccordion_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobileMenuHelpAccordion_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobileMenuHelpAccordion_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMobileMenuHelpAccordion_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MobileMenuHelpAccordion_GetGlobalVariablesQuery,
		MobileMenuHelpAccordion_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MobileMenuHelpAccordion_GetGlobalVariablesQuery,
		MobileMenuHelpAccordion_GetGlobalVariablesQueryVariables
	>(MobileMenuHelpAccordion_GetGlobalVariablesDocument, options);
}
export function useMobileMenuHelpAccordion_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MobileMenuHelpAccordion_GetGlobalVariablesQuery,
		MobileMenuHelpAccordion_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MobileMenuHelpAccordion_GetGlobalVariablesQuery,
		MobileMenuHelpAccordion_GetGlobalVariablesQueryVariables
	>(MobileMenuHelpAccordion_GetGlobalVariablesDocument, options);
}
export type MobileMenuHelpAccordion_GetGlobalVariablesQueryHookResult =
	ReturnType<typeof useMobileMenuHelpAccordion_GetGlobalVariablesQuery>;
export type MobileMenuHelpAccordion_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useMobileMenuHelpAccordion_GetGlobalVariablesLazyQuery>;
export type MobileMenuHelpAccordion_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		MobileMenuHelpAccordion_GetGlobalVariablesQuery,
		MobileMenuHelpAccordion_GetGlobalVariablesQueryVariables
	>;
export const SetPermissionsModal_GetGlobalVariablesDocument = gql`
	query SetPermissionsModal_getGlobalVariables {
		getGlobalVariables {
			PlannerPermissionsHelpUrl
		}
	}
`;

/**
 * __useSetPermissionsModal_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useSetPermissionsModal_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetPermissionsModal_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetPermissionsModal_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSetPermissionsModal_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		SetPermissionsModal_GetGlobalVariablesQuery,
		SetPermissionsModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SetPermissionsModal_GetGlobalVariablesQuery,
		SetPermissionsModal_GetGlobalVariablesQueryVariables
	>(SetPermissionsModal_GetGlobalVariablesDocument, options);
}
export function useSetPermissionsModal_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SetPermissionsModal_GetGlobalVariablesQuery,
		SetPermissionsModal_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SetPermissionsModal_GetGlobalVariablesQuery,
		SetPermissionsModal_GetGlobalVariablesQueryVariables
	>(SetPermissionsModal_GetGlobalVariablesDocument, options);
}
export type SetPermissionsModal_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useSetPermissionsModal_GetGlobalVariablesQuery
>;
export type SetPermissionsModal_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useSetPermissionsModal_GetGlobalVariablesLazyQuery>;
export type SetPermissionsModal_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		SetPermissionsModal_GetGlobalVariablesQuery,
		SetPermissionsModal_GetGlobalVariablesQueryVariables
	>;
export const PermissionsModal_AssignPlannerPermissionsDocument = gql`
	mutation PermissionsModal_assignPlannerPermissions(
		$where: ContactWhereUniqueInput!
		$data: PermissionInput!
	) {
		assignPlannerPermissions(where: $where, data: $data) {
			id
		}
	}
`;
export type PermissionsModal_AssignPlannerPermissionsMutationFn =
	Apollo.MutationFunction<
		PermissionsModal_AssignPlannerPermissionsMutation,
		PermissionsModal_AssignPlannerPermissionsMutationVariables
	>;

/**
 * __usePermissionsModal_AssignPlannerPermissionsMutation__
 *
 * To run a mutation, you first call `usePermissionsModal_AssignPlannerPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionsModal_AssignPlannerPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionsModalAssignPlannerPermissionsMutation, { data, loading, error }] = usePermissionsModal_AssignPlannerPermissionsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePermissionsModal_AssignPlannerPermissionsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PermissionsModal_AssignPlannerPermissionsMutation,
		PermissionsModal_AssignPlannerPermissionsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PermissionsModal_AssignPlannerPermissionsMutation,
		PermissionsModal_AssignPlannerPermissionsMutationVariables
	>(PermissionsModal_AssignPlannerPermissionsDocument, options);
}
export type PermissionsModal_AssignPlannerPermissionsMutationHookResult =
	ReturnType<typeof usePermissionsModal_AssignPlannerPermissionsMutation>;
export type PermissionsModal_AssignPlannerPermissionsMutationResult =
	Apollo.MutationResult<PermissionsModal_AssignPlannerPermissionsMutation>;
export type PermissionsModal_AssignPlannerPermissionsMutationOptions =
	Apollo.BaseMutationOptions<
		PermissionsModal_AssignPlannerPermissionsMutation,
		PermissionsModal_AssignPlannerPermissionsMutationVariables
	>;
export const PermissionsModal_RemoveAllPlannerPermissionsDocument = gql`
	mutation PermissionsModal_removeAllPlannerPermissions(
		$where: ClientUserWhereUniqueInput!
	) {
		removeAllPlannerPermissions(where: $where)
	}
`;
export type PermissionsModal_RemoveAllPlannerPermissionsMutationFn =
	Apollo.MutationFunction<
		PermissionsModal_RemoveAllPlannerPermissionsMutation,
		PermissionsModal_RemoveAllPlannerPermissionsMutationVariables
	>;

/**
 * __usePermissionsModal_RemoveAllPlannerPermissionsMutation__
 *
 * To run a mutation, you first call `usePermissionsModal_RemoveAllPlannerPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionsModal_RemoveAllPlannerPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionsModalRemoveAllPlannerPermissionsMutation, { data, loading, error }] = usePermissionsModal_RemoveAllPlannerPermissionsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePermissionsModal_RemoveAllPlannerPermissionsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PermissionsModal_RemoveAllPlannerPermissionsMutation,
		PermissionsModal_RemoveAllPlannerPermissionsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PermissionsModal_RemoveAllPlannerPermissionsMutation,
		PermissionsModal_RemoveAllPlannerPermissionsMutationVariables
	>(PermissionsModal_RemoveAllPlannerPermissionsDocument, options);
}
export type PermissionsModal_RemoveAllPlannerPermissionsMutationHookResult =
	ReturnType<typeof usePermissionsModal_RemoveAllPlannerPermissionsMutation>;
export type PermissionsModal_RemoveAllPlannerPermissionsMutationResult =
	Apollo.MutationResult<PermissionsModal_RemoveAllPlannerPermissionsMutation>;
export type PermissionsModal_RemoveAllPlannerPermissionsMutationOptions =
	Apollo.BaseMutationOptions<
		PermissionsModal_RemoveAllPlannerPermissionsMutation,
		PermissionsModal_RemoveAllPlannerPermissionsMutationVariables
	>;
export const PermissionsModal_GetAuthedUserDocument = gql`
	query PermissionsModal_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			...getAuthedUserFlattenedUserFields
		}
	}
	${GetAuthedUserFlattenedUserFieldsFragmentDoc}
`;

/**
 * __usePermissionsModal_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `usePermissionsModal_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsModal_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsModal_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePermissionsModal_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		PermissionsModal_GetAuthedUserQuery,
		PermissionsModal_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PermissionsModal_GetAuthedUserQuery,
		PermissionsModal_GetAuthedUserQueryVariables
	>(PermissionsModal_GetAuthedUserDocument, options);
}
export function usePermissionsModal_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PermissionsModal_GetAuthedUserQuery,
		PermissionsModal_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PermissionsModal_GetAuthedUserQuery,
		PermissionsModal_GetAuthedUserQueryVariables
	>(PermissionsModal_GetAuthedUserDocument, options);
}
export type PermissionsModal_GetAuthedUserQueryHookResult = ReturnType<
	typeof usePermissionsModal_GetAuthedUserQuery
>;
export type PermissionsModal_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof usePermissionsModal_GetAuthedUserLazyQuery
>;
export type PermissionsModal_GetAuthedUserQueryResult = Apollo.QueryResult<
	PermissionsModal_GetAuthedUserQuery,
	PermissionsModal_GetAuthedUserQueryVariables
>;
export const ProposalDetail_GetProposalWhereDocument = gql`
	query proposalDetail_getProposalWhere($where: ProposalWhereInput!) {
		getProposalWhere(where: $where) {
			proposal {
				contact {
					id
					vendor {
						id
					}
				}
				...proposalDetailProposal
			}
		}
	}
	${ProposalDetailProposalFragmentDoc}
`;

/**
 * __useProposalDetail_GetProposalWhereQuery__
 *
 * To run a query within a React component, call `useProposalDetail_GetProposalWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalDetail_GetProposalWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalDetail_GetProposalWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalDetail_GetProposalWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalDetail_GetProposalWhereQuery,
		ProposalDetail_GetProposalWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalDetail_GetProposalWhereQuery,
		ProposalDetail_GetProposalWhereQueryVariables
	>(ProposalDetail_GetProposalWhereDocument, options);
}
export function useProposalDetail_GetProposalWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalDetail_GetProposalWhereQuery,
		ProposalDetail_GetProposalWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalDetail_GetProposalWhereQuery,
		ProposalDetail_GetProposalWhereQueryVariables
	>(ProposalDetail_GetProposalWhereDocument, options);
}
export type ProposalDetail_GetProposalWhereQueryHookResult = ReturnType<
	typeof useProposalDetail_GetProposalWhereQuery
>;
export type ProposalDetail_GetProposalWhereLazyQueryHookResult = ReturnType<
	typeof useProposalDetail_GetProposalWhereLazyQuery
>;
export type ProposalDetail_GetProposalWhereQueryResult = Apollo.QueryResult<
	ProposalDetail_GetProposalWhereQuery,
	ProposalDetail_GetProposalWhereQueryVariables
>;
export const ProposalDetail_GetOrgUserWhereDocument = gql`
	query proposalDetail_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			user {
				id
				canvaToken {
					accessToken
					expires
				}
			}
			organization {
				id
				automatedRemindersEnabled
				...proposalViewOrganization
				users {
					id
					role
					firstName
					lastName
					user {
						id
						email
						userType
					}
				}
				services {
					id
					name
				}
			}
		}
	}
	${ProposalViewOrganizationFragmentDoc}
`;

/**
 * __useProposalDetail_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useProposalDetail_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalDetail_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalDetail_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalDetail_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalDetail_GetOrgUserWhereQuery,
		ProposalDetail_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalDetail_GetOrgUserWhereQuery,
		ProposalDetail_GetOrgUserWhereQueryVariables
	>(ProposalDetail_GetOrgUserWhereDocument, options);
}
export function useProposalDetail_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalDetail_GetOrgUserWhereQuery,
		ProposalDetail_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalDetail_GetOrgUserWhereQuery,
		ProposalDetail_GetOrgUserWhereQueryVariables
	>(ProposalDetail_GetOrgUserWhereDocument, options);
}
export type ProposalDetail_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useProposalDetail_GetOrgUserWhereQuery
>;
export type ProposalDetail_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useProposalDetail_GetOrgUserWhereLazyQuery
>;
export type ProposalDetail_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	ProposalDetail_GetOrgUserWhereQuery,
	ProposalDetail_GetOrgUserWhereQueryVariables
>;
export const ProposalEditButtonBarSendButton_SendProposalDocument = gql`
	mutation ProposalEditButtonBarSendButton_sendProposal(
		$data: SendProposalInput
		$where: ProposalWhereUniqueInput!
	) {
		sendProposal(data: $data, where: $where) {
			id
			eventDate
			dueDate
			title
			...useProposalEditButtonBarSendButton
		}
	}
	${UseProposalEditButtonBarSendButtonFragmentDoc}
`;
export type ProposalEditButtonBarSendButton_SendProposalMutationFn =
	Apollo.MutationFunction<
		ProposalEditButtonBarSendButton_SendProposalMutation,
		ProposalEditButtonBarSendButton_SendProposalMutationVariables
	>;

/**
 * __useProposalEditButtonBarSendButton_SendProposalMutation__
 *
 * To run a mutation, you first call `useProposalEditButtonBarSendButton_SendProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEditButtonBarSendButton_SendProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditButtonBarSendButtonSendProposalMutation, { data, loading, error }] = useProposalEditButtonBarSendButton_SendProposalMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalEditButtonBarSendButton_SendProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalEditButtonBarSendButton_SendProposalMutation,
		ProposalEditButtonBarSendButton_SendProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalEditButtonBarSendButton_SendProposalMutation,
		ProposalEditButtonBarSendButton_SendProposalMutationVariables
	>(ProposalEditButtonBarSendButton_SendProposalDocument, options);
}
export type ProposalEditButtonBarSendButton_SendProposalMutationHookResult =
	ReturnType<typeof useProposalEditButtonBarSendButton_SendProposalMutation>;
export type ProposalEditButtonBarSendButton_SendProposalMutationResult =
	Apollo.MutationResult<ProposalEditButtonBarSendButton_SendProposalMutation>;
export type ProposalEditButtonBarSendButton_SendProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalEditButtonBarSendButton_SendProposalMutation,
		ProposalEditButtonBarSendButton_SendProposalMutationVariables
	>;
export const ProposalEditButtonBarVoidButton_VoidProposalDocument = gql`
	mutation ProposalEditButtonBarVoidButton_voidProposal(
		$where: ProposalWhereUniqueInput!
	) {
		voidProposal(where: $where) {
			...useProposalEditButtonBarVoidButton
		}
	}
	${UseProposalEditButtonBarVoidButtonFragmentDoc}
`;
export type ProposalEditButtonBarVoidButton_VoidProposalMutationFn =
	Apollo.MutationFunction<
		ProposalEditButtonBarVoidButton_VoidProposalMutation,
		ProposalEditButtonBarVoidButton_VoidProposalMutationVariables
	>;

/**
 * __useProposalEditButtonBarVoidButton_VoidProposalMutation__
 *
 * To run a mutation, you first call `useProposalEditButtonBarVoidButton_VoidProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEditButtonBarVoidButton_VoidProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditButtonBarVoidButtonVoidProposalMutation, { data, loading, error }] = useProposalEditButtonBarVoidButton_VoidProposalMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalEditButtonBarVoidButton_VoidProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalEditButtonBarVoidButton_VoidProposalMutation,
		ProposalEditButtonBarVoidButton_VoidProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalEditButtonBarVoidButton_VoidProposalMutation,
		ProposalEditButtonBarVoidButton_VoidProposalMutationVariables
	>(ProposalEditButtonBarVoidButton_VoidProposalDocument, options);
}
export type ProposalEditButtonBarVoidButton_VoidProposalMutationHookResult =
	ReturnType<typeof useProposalEditButtonBarVoidButton_VoidProposalMutation>;
export type ProposalEditButtonBarVoidButton_VoidProposalMutationResult =
	Apollo.MutationResult<ProposalEditButtonBarVoidButton_VoidProposalMutation>;
export type ProposalEditButtonBarVoidButton_VoidProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalEditButtonBarVoidButton_VoidProposalMutation,
		ProposalEditButtonBarVoidButton_VoidProposalMutationVariables
	>;
export const ProposalEdit_CreateProposalDocument = gql`
	mutation proposalEdit_createProposal($data: ProposalCreateInput!) {
		createProposal(data: $data) {
			id
			status
			eventDate
			source
			...proposalEditProposal
			...proposalPreviewProposal
		}
	}
	${ProposalEditProposalFragmentDoc}
	${ProposalPreviewProposalFragmentDoc}
`;
export type ProposalEdit_CreateProposalMutationFn = Apollo.MutationFunction<
	ProposalEdit_CreateProposalMutation,
	ProposalEdit_CreateProposalMutationVariables
>;

/**
 * __useProposalEdit_CreateProposalMutation__
 *
 * To run a mutation, you first call `useProposalEdit_CreateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEdit_CreateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditCreateProposalMutation, { data, loading, error }] = useProposalEdit_CreateProposalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProposalEdit_CreateProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalEdit_CreateProposalMutation,
		ProposalEdit_CreateProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalEdit_CreateProposalMutation,
		ProposalEdit_CreateProposalMutationVariables
	>(ProposalEdit_CreateProposalDocument, options);
}
export type ProposalEdit_CreateProposalMutationHookResult = ReturnType<
	typeof useProposalEdit_CreateProposalMutation
>;
export type ProposalEdit_CreateProposalMutationResult =
	Apollo.MutationResult<ProposalEdit_CreateProposalMutation>;
export type ProposalEdit_CreateProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalEdit_CreateProposalMutation,
		ProposalEdit_CreateProposalMutationVariables
	>;
export const ProposalEdit_UpdateProposalDocument = gql`
	mutation proposalEdit_updateProposal(
		$data: ProposalUpdateInput!
		$where: ProposalWhereUniqueInput!
	) {
		updateProposal(data: $data, where: $where) {
			source
			...proposalEditProposal
			...proposalPreviewProposal
		}
	}
	${ProposalEditProposalFragmentDoc}
	${ProposalPreviewProposalFragmentDoc}
`;
export type ProposalEdit_UpdateProposalMutationFn = Apollo.MutationFunction<
	ProposalEdit_UpdateProposalMutation,
	ProposalEdit_UpdateProposalMutationVariables
>;

/**
 * __useProposalEdit_UpdateProposalMutation__
 *
 * To run a mutation, you first call `useProposalEdit_UpdateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEdit_UpdateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditUpdateProposalMutation, { data, loading, error }] = useProposalEdit_UpdateProposalMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalEdit_UpdateProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalEdit_UpdateProposalMutation,
		ProposalEdit_UpdateProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalEdit_UpdateProposalMutation,
		ProposalEdit_UpdateProposalMutationVariables
	>(ProposalEdit_UpdateProposalDocument, options);
}
export type ProposalEdit_UpdateProposalMutationHookResult = ReturnType<
	typeof useProposalEdit_UpdateProposalMutation
>;
export type ProposalEdit_UpdateProposalMutationResult =
	Apollo.MutationResult<ProposalEdit_UpdateProposalMutation>;
export type ProposalEdit_UpdateProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalEdit_UpdateProposalMutation,
		ProposalEdit_UpdateProposalMutationVariables
	>;
export const ProposalEdit_RequestProposalFileUploadUrlDocument = gql`
	mutation proposalEdit_requestProposalFileUploadUrl(
		$data: RequestAttachmentUploadUrlInput!
		$where: ProposalWhereUniqueInput!
	) {
		requestProposalFileUploadUrl(where: $where, data: $data) {
			uploadURL
		}
	}
`;
export type ProposalEdit_RequestProposalFileUploadUrlMutationFn =
	Apollo.MutationFunction<
		ProposalEdit_RequestProposalFileUploadUrlMutation,
		ProposalEdit_RequestProposalFileUploadUrlMutationVariables
	>;

/**
 * __useProposalEdit_RequestProposalFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useProposalEdit_RequestProposalFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEdit_RequestProposalFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditRequestProposalFileUploadUrlMutation, { data, loading, error }] = useProposalEdit_RequestProposalFileUploadUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalEdit_RequestProposalFileUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalEdit_RequestProposalFileUploadUrlMutation,
		ProposalEdit_RequestProposalFileUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalEdit_RequestProposalFileUploadUrlMutation,
		ProposalEdit_RequestProposalFileUploadUrlMutationVariables
	>(ProposalEdit_RequestProposalFileUploadUrlDocument, options);
}
export type ProposalEdit_RequestProposalFileUploadUrlMutationHookResult =
	ReturnType<typeof useProposalEdit_RequestProposalFileUploadUrlMutation>;
export type ProposalEdit_RequestProposalFileUploadUrlMutationResult =
	Apollo.MutationResult<ProposalEdit_RequestProposalFileUploadUrlMutation>;
export type ProposalEdit_RequestProposalFileUploadUrlMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalEdit_RequestProposalFileUploadUrlMutation,
		ProposalEdit_RequestProposalFileUploadUrlMutationVariables
	>;
export const ProposalEdit_CreateCanvaDesignForProposalDocument = gql`
	mutation proposalEdit_createCanvaDesignForProposal($data: CanvaDesignInput!) {
		createCanvaDesignForProposal(data: $data) {
			id
			canvaDesign {
				id
				designId
				editUrl
				viewUrl
				exportedImageUrl
			}
		}
	}
`;
export type ProposalEdit_CreateCanvaDesignForProposalMutationFn =
	Apollo.MutationFunction<
		ProposalEdit_CreateCanvaDesignForProposalMutation,
		ProposalEdit_CreateCanvaDesignForProposalMutationVariables
	>;

/**
 * __useProposalEdit_CreateCanvaDesignForProposalMutation__
 *
 * To run a mutation, you first call `useProposalEdit_CreateCanvaDesignForProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEdit_CreateCanvaDesignForProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditCreateCanvaDesignForProposalMutation, { data, loading, error }] = useProposalEdit_CreateCanvaDesignForProposalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProposalEdit_CreateCanvaDesignForProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalEdit_CreateCanvaDesignForProposalMutation,
		ProposalEdit_CreateCanvaDesignForProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalEdit_CreateCanvaDesignForProposalMutation,
		ProposalEdit_CreateCanvaDesignForProposalMutationVariables
	>(ProposalEdit_CreateCanvaDesignForProposalDocument, options);
}
export type ProposalEdit_CreateCanvaDesignForProposalMutationHookResult =
	ReturnType<typeof useProposalEdit_CreateCanvaDesignForProposalMutation>;
export type ProposalEdit_CreateCanvaDesignForProposalMutationResult =
	Apollo.MutationResult<ProposalEdit_CreateCanvaDesignForProposalMutation>;
export type ProposalEdit_CreateCanvaDesignForProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalEdit_CreateCanvaDesignForProposalMutation,
		ProposalEdit_CreateCanvaDesignForProposalMutationVariables
	>;
export const CanvaDesignTitles_ListCanvaDesignsDocument = gql`
	query CanvaDesignTitles_ListCanvaDesigns($where: CanvaDesignWhereInput) {
		listCanvaDesigns(where: $where) {
			hasMore
			items {
				id
				title
				thumbnail {
					url
					width
					height
				}
				urls {
					viewUrl
				}
			}
		}
	}
`;

/**
 * __useCanvaDesignTitles_ListCanvaDesignsQuery__
 *
 * To run a query within a React component, call `useCanvaDesignTitles_ListCanvaDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvaDesignTitles_ListCanvaDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvaDesignTitles_ListCanvaDesignsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCanvaDesignTitles_ListCanvaDesignsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CanvaDesignTitles_ListCanvaDesignsQuery,
		CanvaDesignTitles_ListCanvaDesignsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CanvaDesignTitles_ListCanvaDesignsQuery,
		CanvaDesignTitles_ListCanvaDesignsQueryVariables
	>(CanvaDesignTitles_ListCanvaDesignsDocument, options);
}
export function useCanvaDesignTitles_ListCanvaDesignsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CanvaDesignTitles_ListCanvaDesignsQuery,
		CanvaDesignTitles_ListCanvaDesignsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CanvaDesignTitles_ListCanvaDesignsQuery,
		CanvaDesignTitles_ListCanvaDesignsQueryVariables
	>(CanvaDesignTitles_ListCanvaDesignsDocument, options);
}
export type CanvaDesignTitles_ListCanvaDesignsQueryHookResult = ReturnType<
	typeof useCanvaDesignTitles_ListCanvaDesignsQuery
>;
export type CanvaDesignTitles_ListCanvaDesignsLazyQueryHookResult = ReturnType<
	typeof useCanvaDesignTitles_ListCanvaDesignsLazyQuery
>;
export type CanvaDesignTitles_ListCanvaDesignsQueryResult = Apollo.QueryResult<
	CanvaDesignTitles_ListCanvaDesignsQuery,
	CanvaDesignTitles_ListCanvaDesignsQueryVariables
>;
export const ConnectToCanva_GetCanvaAuthorizationUrlDocument = gql`
	query ConnectToCanva_GetCanvaAuthorizationUrl {
		getCanvaAuthorizationUrl {
			url
			state
			codeVerifier
		}
	}
`;

/**
 * __useConnectToCanva_GetCanvaAuthorizationUrlQuery__
 *
 * To run a query within a React component, call `useConnectToCanva_GetCanvaAuthorizationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectToCanva_GetCanvaAuthorizationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectToCanva_GetCanvaAuthorizationUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectToCanva_GetCanvaAuthorizationUrlQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ConnectToCanva_GetCanvaAuthorizationUrlQuery,
		ConnectToCanva_GetCanvaAuthorizationUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ConnectToCanva_GetCanvaAuthorizationUrlQuery,
		ConnectToCanva_GetCanvaAuthorizationUrlQueryVariables
	>(ConnectToCanva_GetCanvaAuthorizationUrlDocument, options);
}
export function useConnectToCanva_GetCanvaAuthorizationUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ConnectToCanva_GetCanvaAuthorizationUrlQuery,
		ConnectToCanva_GetCanvaAuthorizationUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ConnectToCanva_GetCanvaAuthorizationUrlQuery,
		ConnectToCanva_GetCanvaAuthorizationUrlQueryVariables
	>(ConnectToCanva_GetCanvaAuthorizationUrlDocument, options);
}
export type ConnectToCanva_GetCanvaAuthorizationUrlQueryHookResult = ReturnType<
	typeof useConnectToCanva_GetCanvaAuthorizationUrlQuery
>;
export type ConnectToCanva_GetCanvaAuthorizationUrlLazyQueryHookResult =
	ReturnType<typeof useConnectToCanva_GetCanvaAuthorizationUrlLazyQuery>;
export type ConnectToCanva_GetCanvaAuthorizationUrlQueryResult =
	Apollo.QueryResult<
		ConnectToCanva_GetCanvaAuthorizationUrlQuery,
		ConnectToCanva_GetCanvaAuthorizationUrlQueryVariables
	>;
export const RevokeCanvaToken_RevokeCanvaTokenDocument = gql`
	mutation RevokeCanvaToken_RevokeCanvaToken {
		revokeCanvaToken
	}
`;
export type RevokeCanvaToken_RevokeCanvaTokenMutationFn =
	Apollo.MutationFunction<
		RevokeCanvaToken_RevokeCanvaTokenMutation,
		RevokeCanvaToken_RevokeCanvaTokenMutationVariables
	>;

/**
 * __useRevokeCanvaToken_RevokeCanvaTokenMutation__
 *
 * To run a mutation, you first call `useRevokeCanvaToken_RevokeCanvaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCanvaToken_RevokeCanvaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCanvaTokenRevokeCanvaTokenMutation, { data, loading, error }] = useRevokeCanvaToken_RevokeCanvaTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeCanvaToken_RevokeCanvaTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RevokeCanvaToken_RevokeCanvaTokenMutation,
		RevokeCanvaToken_RevokeCanvaTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RevokeCanvaToken_RevokeCanvaTokenMutation,
		RevokeCanvaToken_RevokeCanvaTokenMutationVariables
	>(RevokeCanvaToken_RevokeCanvaTokenDocument, options);
}
export type RevokeCanvaToken_RevokeCanvaTokenMutationHookResult = ReturnType<
	typeof useRevokeCanvaToken_RevokeCanvaTokenMutation
>;
export type RevokeCanvaToken_RevokeCanvaTokenMutationResult =
	Apollo.MutationResult<RevokeCanvaToken_RevokeCanvaTokenMutation>;
export type RevokeCanvaToken_RevokeCanvaTokenMutationOptions =
	Apollo.BaseMutationOptions<
		RevokeCanvaToken_RevokeCanvaTokenMutation,
		RevokeCanvaToken_RevokeCanvaTokenMutationVariables
	>;
export const YourDesignsGetProposalTemplatesDocument = gql`
	query yourDesignsGetProposalTemplates(
		$skip: Int
		$take: Int
		$where: ProposalTemplatesWhereInput
		$orderBy: [ProposalTemplateWhereOrderByInput]
	) {
		getProposalTemplatesWhere(
			skip: $skip
			take: $take
			where: $where
			orderBy: $orderBy
		) {
			_count
			proposalTemplates {
				...templatesTabProposalTemplate
			}
		}
	}
	${TemplatesTabProposalTemplateFragmentDoc}
`;

/**
 * __useYourDesignsGetProposalTemplatesQuery__
 *
 * To run a query within a React component, call `useYourDesignsGetProposalTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useYourDesignsGetProposalTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYourDesignsGetProposalTemplatesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useYourDesignsGetProposalTemplatesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		YourDesignsGetProposalTemplatesQuery,
		YourDesignsGetProposalTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		YourDesignsGetProposalTemplatesQuery,
		YourDesignsGetProposalTemplatesQueryVariables
	>(YourDesignsGetProposalTemplatesDocument, options);
}
export function useYourDesignsGetProposalTemplatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		YourDesignsGetProposalTemplatesQuery,
		YourDesignsGetProposalTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		YourDesignsGetProposalTemplatesQuery,
		YourDesignsGetProposalTemplatesQueryVariables
	>(YourDesignsGetProposalTemplatesDocument, options);
}
export type YourDesignsGetProposalTemplatesQueryHookResult = ReturnType<
	typeof useYourDesignsGetProposalTemplatesQuery
>;
export type YourDesignsGetProposalTemplatesLazyQueryHookResult = ReturnType<
	typeof useYourDesignsGetProposalTemplatesLazyQuery
>;
export type YourDesignsGetProposalTemplatesQueryResult = Apollo.QueryResult<
	YourDesignsGetProposalTemplatesQuery,
	YourDesignsGetProposalTemplatesQueryVariables
>;
export const ProposalPreview_RefreshCanvaExportDocument = gql`
	mutation ProposalPreview_RefreshCanvaExport(
		$where: CanvaDesignWhereUniqueInput!
	) {
		refreshCanvaExportForProposal(where: $where) {
			id
			canvaDesign {
				id
				designId
				viewUrl
				exportedImageUrl
			}
		}
	}
`;
export type ProposalPreview_RefreshCanvaExportMutationFn =
	Apollo.MutationFunction<
		ProposalPreview_RefreshCanvaExportMutation,
		ProposalPreview_RefreshCanvaExportMutationVariables
	>;

/**
 * __useProposalPreview_RefreshCanvaExportMutation__
 *
 * To run a mutation, you first call `useProposalPreview_RefreshCanvaExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalPreview_RefreshCanvaExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalPreviewRefreshCanvaExportMutation, { data, loading, error }] = useProposalPreview_RefreshCanvaExportMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalPreview_RefreshCanvaExportMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalPreview_RefreshCanvaExportMutation,
		ProposalPreview_RefreshCanvaExportMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalPreview_RefreshCanvaExportMutation,
		ProposalPreview_RefreshCanvaExportMutationVariables
	>(ProposalPreview_RefreshCanvaExportDocument, options);
}
export type ProposalPreview_RefreshCanvaExportMutationHookResult = ReturnType<
	typeof useProposalPreview_RefreshCanvaExportMutation
>;
export type ProposalPreview_RefreshCanvaExportMutationResult =
	Apollo.MutationResult<ProposalPreview_RefreshCanvaExportMutation>;
export type ProposalPreview_RefreshCanvaExportMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalPreview_RefreshCanvaExportMutation,
		ProposalPreview_RefreshCanvaExportMutationVariables
	>;
export const ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateDocument = gql`
	mutation ProposalTemplateEditButtonBarDeleteButton_deleteProposalTemplate(
		$where: ProposalTemplateWhereUniqueInput!
	) {
		deleteProposalTemplate(where: $where) {
			...useProposalTemplateEditButtonBarDeleteButton
		}
	}
	${UseProposalTemplateEditButtonBarDeleteButtonFragmentDoc}
`;
export type ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationFn =
	Apollo.MutationFunction<
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation,
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationVariables
	>;

/**
 * __useProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation__
 *
 * To run a mutation, you first call `useProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalTemplateEditButtonBarDeleteButtonDeleteProposalTemplateMutation, { data, loading, error }] = useProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation,
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation,
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationVariables
	>(
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateDocument,
		options
	);
}
export type ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationHookResult =
	ReturnType<
		typeof useProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation
	>;
export type ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationResult =
	Apollo.MutationResult<ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation>;
export type ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutation,
		ProposalTemplateEditButtonBarDeleteButton_DeleteProposalTemplateMutationVariables
	>;
export const ProposalTemplateEdit_GetProposalTemplateWhereDocument = gql`
	query proposalTemplateEdit_getProposalTemplateWhere(
		$where: ProposalTemplateWhereUniqueInput!
	) {
		getProposalTemplateWhere(where: $where) {
			...proposalTemplateEdit
		}
	}
	${ProposalTemplateEditFragmentDoc}
`;

/**
 * __useProposalTemplateEdit_GetProposalTemplateWhereQuery__
 *
 * To run a query within a React component, call `useProposalTemplateEdit_GetProposalTemplateWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEdit_GetProposalTemplateWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalTemplateEdit_GetProposalTemplateWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateEdit_GetProposalTemplateWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalTemplateEdit_GetProposalTemplateWhereQuery,
		ProposalTemplateEdit_GetProposalTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalTemplateEdit_GetProposalTemplateWhereQuery,
		ProposalTemplateEdit_GetProposalTemplateWhereQueryVariables
	>(ProposalTemplateEdit_GetProposalTemplateWhereDocument, options);
}
export function useProposalTemplateEdit_GetProposalTemplateWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalTemplateEdit_GetProposalTemplateWhereQuery,
		ProposalTemplateEdit_GetProposalTemplateWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalTemplateEdit_GetProposalTemplateWhereQuery,
		ProposalTemplateEdit_GetProposalTemplateWhereQueryVariables
	>(ProposalTemplateEdit_GetProposalTemplateWhereDocument, options);
}
export type ProposalTemplateEdit_GetProposalTemplateWhereQueryHookResult =
	ReturnType<typeof useProposalTemplateEdit_GetProposalTemplateWhereQuery>;
export type ProposalTemplateEdit_GetProposalTemplateWhereLazyQueryHookResult =
	ReturnType<typeof useProposalTemplateEdit_GetProposalTemplateWhereLazyQuery>;
export type ProposalTemplateEdit_GetProposalTemplateWhereQueryResult =
	Apollo.QueryResult<
		ProposalTemplateEdit_GetProposalTemplateWhereQuery,
		ProposalTemplateEdit_GetProposalTemplateWhereQueryVariables
	>;
export const ProposalTemplateEdit_CreateProposalTemplateDocument = gql`
	mutation proposalTemplateEdit_createProposalTemplate(
		$data: ProposalTemplateCreateInput!
	) {
		createProposalTemplate(data: $data) {
			id
			source
			...proposalTemplateEdit
		}
	}
	${ProposalTemplateEditFragmentDoc}
`;
export type ProposalTemplateEdit_CreateProposalTemplateMutationFn =
	Apollo.MutationFunction<
		ProposalTemplateEdit_CreateProposalTemplateMutation,
		ProposalTemplateEdit_CreateProposalTemplateMutationVariables
	>;

/**
 * __useProposalTemplateEdit_CreateProposalTemplateMutation__
 *
 * To run a mutation, you first call `useProposalTemplateEdit_CreateProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEdit_CreateProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalTemplateEditCreateProposalTemplateMutation, { data, loading, error }] = useProposalTemplateEdit_CreateProposalTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProposalTemplateEdit_CreateProposalTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalTemplateEdit_CreateProposalTemplateMutation,
		ProposalTemplateEdit_CreateProposalTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalTemplateEdit_CreateProposalTemplateMutation,
		ProposalTemplateEdit_CreateProposalTemplateMutationVariables
	>(ProposalTemplateEdit_CreateProposalTemplateDocument, options);
}
export type ProposalTemplateEdit_CreateProposalTemplateMutationHookResult =
	ReturnType<typeof useProposalTemplateEdit_CreateProposalTemplateMutation>;
export type ProposalTemplateEdit_CreateProposalTemplateMutationResult =
	Apollo.MutationResult<ProposalTemplateEdit_CreateProposalTemplateMutation>;
export type ProposalTemplateEdit_CreateProposalTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalTemplateEdit_CreateProposalTemplateMutation,
		ProposalTemplateEdit_CreateProposalTemplateMutationVariables
	>;
export const ProposalTemplateEdit_UpdateProposalTemplateDocument = gql`
	mutation proposalTemplateEdit_updateProposalTemplate(
		$data: ProposalTemplateUpdateInput!
		$where: ProposalTemplateWhereUniqueInput!
	) {
		updateProposalTemplate(data: $data, where: $where) {
			id
			source
			...proposalTemplateEdit
		}
	}
	${ProposalTemplateEditFragmentDoc}
`;
export type ProposalTemplateEdit_UpdateProposalTemplateMutationFn =
	Apollo.MutationFunction<
		ProposalTemplateEdit_UpdateProposalTemplateMutation,
		ProposalTemplateEdit_UpdateProposalTemplateMutationVariables
	>;

/**
 * __useProposalTemplateEdit_UpdateProposalTemplateMutation__
 *
 * To run a mutation, you first call `useProposalTemplateEdit_UpdateProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEdit_UpdateProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalTemplateEditUpdateProposalTemplateMutation, { data, loading, error }] = useProposalTemplateEdit_UpdateProposalTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateEdit_UpdateProposalTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalTemplateEdit_UpdateProposalTemplateMutation,
		ProposalTemplateEdit_UpdateProposalTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalTemplateEdit_UpdateProposalTemplateMutation,
		ProposalTemplateEdit_UpdateProposalTemplateMutationVariables
	>(ProposalTemplateEdit_UpdateProposalTemplateDocument, options);
}
export type ProposalTemplateEdit_UpdateProposalTemplateMutationHookResult =
	ReturnType<typeof useProposalTemplateEdit_UpdateProposalTemplateMutation>;
export type ProposalTemplateEdit_UpdateProposalTemplateMutationResult =
	Apollo.MutationResult<ProposalTemplateEdit_UpdateProposalTemplateMutation>;
export type ProposalTemplateEdit_UpdateProposalTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalTemplateEdit_UpdateProposalTemplateMutation,
		ProposalTemplateEdit_UpdateProposalTemplateMutationVariables
	>;
export const ProposalTemplateEdit_GetOrgUserWhereDocument = gql`
	query proposalTemplateEdit_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			user {
				id
				canvaToken {
					accessToken
					expires
				}
			}
		}
	}
`;

/**
 * __useProposalTemplateEdit_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useProposalTemplateEdit_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEdit_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalTemplateEdit_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateEdit_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalTemplateEdit_GetOrgUserWhereQuery,
		ProposalTemplateEdit_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalTemplateEdit_GetOrgUserWhereQuery,
		ProposalTemplateEdit_GetOrgUserWhereQueryVariables
	>(ProposalTemplateEdit_GetOrgUserWhereDocument, options);
}
export function useProposalTemplateEdit_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalTemplateEdit_GetOrgUserWhereQuery,
		ProposalTemplateEdit_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalTemplateEdit_GetOrgUserWhereQuery,
		ProposalTemplateEdit_GetOrgUserWhereQueryVariables
	>(ProposalTemplateEdit_GetOrgUserWhereDocument, options);
}
export type ProposalTemplateEdit_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useProposalTemplateEdit_GetOrgUserWhereQuery
>;
export type ProposalTemplateEdit_GetOrgUserWhereLazyQueryHookResult =
	ReturnType<typeof useProposalTemplateEdit_GetOrgUserWhereLazyQuery>;
export type ProposalTemplateEdit_GetOrgUserWhereQueryResult =
	Apollo.QueryResult<
		ProposalTemplateEdit_GetOrgUserWhereQuery,
		ProposalTemplateEdit_GetOrgUserWhereQueryVariables
	>;
export const ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlDocument = gql`
	mutation proposalTemplateEdit_requestProposalTemplateFileUploadUrl(
		$data: RequestAttachmentUploadUrlInput!
		$where: ProposalTemplateWhereUniqueInput!
	) {
		requestProposalTemplateFileUploadUrl(where: $where, data: $data) {
			uploadURL
		}
	}
`;
export type ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationFn =
	Apollo.MutationFunction<
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation,
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationVariables
	>;

/**
 * __useProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalTemplateEditRequestProposalTemplateFileUploadUrlMutation, { data, loading, error }] = useProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation,
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation,
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationVariables
	>(ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlDocument, options);
}
export type ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationHookResult =
	ReturnType<
		typeof useProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation
	>;
export type ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationResult =
	Apollo.MutationResult<ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation>;
export type ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutation,
		ProposalTemplateEdit_RequestProposalTemplateFileUploadUrlMutationVariables
	>;
export const ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateDocument = gql`
	mutation proposalTemplateEdit_createCanvaDesignForProposalTemplate(
		$data: CanvaDesignForProposalTemplateInput!
	) {
		createCanvaDesignForProposalTemplate(data: $data) {
			id
			canvaDesign {
				id
				designId
				editUrl
				viewUrl
				exportedImageUrl
			}
		}
	}
`;
export type ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationFn =
	Apollo.MutationFunction<
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation,
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationVariables
	>;

/**
 * __useProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation__
 *
 * To run a mutation, you first call `useProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalTemplateEditCreateCanvaDesignForProposalTemplateMutation, { data, loading, error }] = useProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation,
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation,
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationVariables
	>(ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateDocument, options);
}
export type ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationHookResult =
	ReturnType<
		typeof useProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation
	>;
export type ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationResult =
	Apollo.MutationResult<ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation>;
export type ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutation,
		ProposalTemplateEdit_CreateCanvaDesignForProposalTemplateMutationVariables
	>;
export const ProposalViewButtonBar_AcceptProposalDocument = gql`
	mutation proposalViewButtonBar_acceptProposal($where: ProposalWhereInput!) {
		acceptProposal(where: $where) {
			...proposalViewButtonBarAcceptButtonProposal
		}
	}
	${ProposalViewButtonBarAcceptButtonProposalFragmentDoc}
`;
export type ProposalViewButtonBar_AcceptProposalMutationFn =
	Apollo.MutationFunction<
		ProposalViewButtonBar_AcceptProposalMutation,
		ProposalViewButtonBar_AcceptProposalMutationVariables
	>;

/**
 * __useProposalViewButtonBar_AcceptProposalMutation__
 *
 * To run a mutation, you first call `useProposalViewButtonBar_AcceptProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalViewButtonBar_AcceptProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalViewButtonBarAcceptProposalMutation, { data, loading, error }] = useProposalViewButtonBar_AcceptProposalMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalViewButtonBar_AcceptProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalViewButtonBar_AcceptProposalMutation,
		ProposalViewButtonBar_AcceptProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalViewButtonBar_AcceptProposalMutation,
		ProposalViewButtonBar_AcceptProposalMutationVariables
	>(ProposalViewButtonBar_AcceptProposalDocument, options);
}
export type ProposalViewButtonBar_AcceptProposalMutationHookResult = ReturnType<
	typeof useProposalViewButtonBar_AcceptProposalMutation
>;
export type ProposalViewButtonBar_AcceptProposalMutationResult =
	Apollo.MutationResult<ProposalViewButtonBar_AcceptProposalMutation>;
export type ProposalViewButtonBar_AcceptProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalViewButtonBar_AcceptProposalMutation,
		ProposalViewButtonBar_AcceptProposalMutationVariables
	>;
export const ProposalViewButtonBarExportButton_GetProposalWhereDocument = gql`
	query ProposalViewButtonBarExportButton_getProposalWhere(
		$where: ProposalWhereInput!
	) {
		getProposalWhere(where: $where) {
			proposal {
				...proposalViewButtonBarExportButton
			}
		}
	}
	${ProposalViewButtonBarExportButtonFragmentDoc}
`;

/**
 * __useProposalViewButtonBarExportButton_GetProposalWhereQuery__
 *
 * To run a query within a React component, call `useProposalViewButtonBarExportButton_GetProposalWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalViewButtonBarExportButton_GetProposalWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalViewButtonBarExportButton_GetProposalWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalViewButtonBarExportButton_GetProposalWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalViewButtonBarExportButton_GetProposalWhereQuery,
		ProposalViewButtonBarExportButton_GetProposalWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalViewButtonBarExportButton_GetProposalWhereQuery,
		ProposalViewButtonBarExportButton_GetProposalWhereQueryVariables
	>(ProposalViewButtonBarExportButton_GetProposalWhereDocument, options);
}
export function useProposalViewButtonBarExportButton_GetProposalWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalViewButtonBarExportButton_GetProposalWhereQuery,
		ProposalViewButtonBarExportButton_GetProposalWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalViewButtonBarExportButton_GetProposalWhereQuery,
		ProposalViewButtonBarExportButton_GetProposalWhereQueryVariables
	>(ProposalViewButtonBarExportButton_GetProposalWhereDocument, options);
}
export type ProposalViewButtonBarExportButton_GetProposalWhereQueryHookResult =
	ReturnType<typeof useProposalViewButtonBarExportButton_GetProposalWhereQuery>;
export type ProposalViewButtonBarExportButton_GetProposalWhereLazyQueryHookResult =
	ReturnType<
		typeof useProposalViewButtonBarExportButton_GetProposalWhereLazyQuery
	>;
export type ProposalViewButtonBarExportButton_GetProposalWhereQueryResult =
	Apollo.QueryResult<
		ProposalViewButtonBarExportButton_GetProposalWhereQuery,
		ProposalViewButtonBarExportButton_GetProposalWhereQueryVariables
	>;
export const ProposalViewButtonBar_SendProposalDocument = gql`
	mutation proposalViewButtonBar_sendProposal(
		$where: ProposalWhereUniqueInput!
		$data: SendProposalInput
	) {
		sendProposal(where: $where, data: $data) {
			...proposalViewButtonBarSendButton
		}
	}
	${ProposalViewButtonBarSendButtonFragmentDoc}
`;
export type ProposalViewButtonBar_SendProposalMutationFn =
	Apollo.MutationFunction<
		ProposalViewButtonBar_SendProposalMutation,
		ProposalViewButtonBar_SendProposalMutationVariables
	>;

/**
 * __useProposalViewButtonBar_SendProposalMutation__
 *
 * To run a mutation, you first call `useProposalViewButtonBar_SendProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalViewButtonBar_SendProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalViewButtonBarSendProposalMutation, { data, loading, error }] = useProposalViewButtonBar_SendProposalMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProposalViewButtonBar_SendProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalViewButtonBar_SendProposalMutation,
		ProposalViewButtonBar_SendProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalViewButtonBar_SendProposalMutation,
		ProposalViewButtonBar_SendProposalMutationVariables
	>(ProposalViewButtonBar_SendProposalDocument, options);
}
export type ProposalViewButtonBar_SendProposalMutationHookResult = ReturnType<
	typeof useProposalViewButtonBar_SendProposalMutation
>;
export type ProposalViewButtonBar_SendProposalMutationResult =
	Apollo.MutationResult<ProposalViewButtonBar_SendProposalMutation>;
export type ProposalViewButtonBar_SendProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalViewButtonBar_SendProposalMutation,
		ProposalViewButtonBar_SendProposalMutationVariables
	>;
export const ProposalViewButtonBarVoidButton_VoidProposalDocument = gql`
	mutation proposalViewButtonBarVoidButton_voidProposal(
		$where: ProposalWhereUniqueInput!
	) {
		voidProposal(where: $where) {
			...useProposalViewButtonBarVoidButton
		}
	}
	${UseProposalViewButtonBarVoidButtonFragmentDoc}
`;
export type ProposalViewButtonBarVoidButton_VoidProposalMutationFn =
	Apollo.MutationFunction<
		ProposalViewButtonBarVoidButton_VoidProposalMutation,
		ProposalViewButtonBarVoidButton_VoidProposalMutationVariables
	>;

/**
 * __useProposalViewButtonBarVoidButton_VoidProposalMutation__
 *
 * To run a mutation, you first call `useProposalViewButtonBarVoidButton_VoidProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalViewButtonBarVoidButton_VoidProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalViewButtonBarVoidButtonVoidProposalMutation, { data, loading, error }] = useProposalViewButtonBarVoidButton_VoidProposalMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalViewButtonBarVoidButton_VoidProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalViewButtonBarVoidButton_VoidProposalMutation,
		ProposalViewButtonBarVoidButton_VoidProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalViewButtonBarVoidButton_VoidProposalMutation,
		ProposalViewButtonBarVoidButton_VoidProposalMutationVariables
	>(ProposalViewButtonBarVoidButton_VoidProposalDocument, options);
}
export type ProposalViewButtonBarVoidButton_VoidProposalMutationHookResult =
	ReturnType<typeof useProposalViewButtonBarVoidButton_VoidProposalMutation>;
export type ProposalViewButtonBarVoidButton_VoidProposalMutationResult =
	Apollo.MutationResult<ProposalViewButtonBarVoidButton_VoidProposalMutation>;
export type ProposalViewButtonBarVoidButton_VoidProposalMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalViewButtonBarVoidButton_VoidProposalMutation,
		ProposalViewButtonBarVoidButton_VoidProposalMutationVariables
	>;
export const ProposalViewPresentation_GetSharableProposalLinkDocument = gql`
	query proposalViewPresentation_GetSharableProposalLink(
		$where: ProposalWhereUniqueInput!
	) {
		getSharableProposalLink(where: $where)
	}
`;

/**
 * __useProposalViewPresentation_GetSharableProposalLinkQuery__
 *
 * To run a query within a React component, call `useProposalViewPresentation_GetSharableProposalLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalViewPresentation_GetSharableProposalLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalViewPresentation_GetSharableProposalLinkQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalViewPresentation_GetSharableProposalLinkQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProposalViewPresentation_GetSharableProposalLinkQuery,
		ProposalViewPresentation_GetSharableProposalLinkQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProposalViewPresentation_GetSharableProposalLinkQuery,
		ProposalViewPresentation_GetSharableProposalLinkQueryVariables
	>(ProposalViewPresentation_GetSharableProposalLinkDocument, options);
}
export function useProposalViewPresentation_GetSharableProposalLinkLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProposalViewPresentation_GetSharableProposalLinkQuery,
		ProposalViewPresentation_GetSharableProposalLinkQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProposalViewPresentation_GetSharableProposalLinkQuery,
		ProposalViewPresentation_GetSharableProposalLinkQueryVariables
	>(ProposalViewPresentation_GetSharableProposalLinkDocument, options);
}
export type ProposalViewPresentation_GetSharableProposalLinkQueryHookResult =
	ReturnType<typeof useProposalViewPresentation_GetSharableProposalLinkQuery>;
export type ProposalViewPresentation_GetSharableProposalLinkLazyQueryHookResult =
	ReturnType<
		typeof useProposalViewPresentation_GetSharableProposalLinkLazyQuery
	>;
export type ProposalViewPresentation_GetSharableProposalLinkQueryResult =
	Apollo.QueryResult<
		ProposalViewPresentation_GetSharableProposalLinkQuery,
		ProposalViewPresentation_GetSharableProposalLinkQueryVariables
	>;
export const UseProposalMetrics_GetDashboardStatsForOrgDocument = gql`
	query useProposalMetrics_getDashboardStatsForOrg(
		$where: DashboardWhereInput!
	) {
		getDashboardStatsForOrg(where: $where) {
			proposalsStatusSummary {
				totalProposalsSent
				totalProposalsAccepted
				totalProposalsOverdue
			}
		}
	}
`;

/**
 * __useUseProposalMetrics_GetDashboardStatsForOrgQuery__
 *
 * To run a query within a React component, call `useUseProposalMetrics_GetDashboardStatsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProposalMetrics_GetDashboardStatsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProposalMetrics_GetDashboardStatsForOrgQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseProposalMetrics_GetDashboardStatsForOrgQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseProposalMetrics_GetDashboardStatsForOrgQuery,
		UseProposalMetrics_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseProposalMetrics_GetDashboardStatsForOrgQuery,
		UseProposalMetrics_GetDashboardStatsForOrgQueryVariables
	>(UseProposalMetrics_GetDashboardStatsForOrgDocument, options);
}
export function useUseProposalMetrics_GetDashboardStatsForOrgLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseProposalMetrics_GetDashboardStatsForOrgQuery,
		UseProposalMetrics_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseProposalMetrics_GetDashboardStatsForOrgQuery,
		UseProposalMetrics_GetDashboardStatsForOrgQueryVariables
	>(UseProposalMetrics_GetDashboardStatsForOrgDocument, options);
}
export type UseProposalMetrics_GetDashboardStatsForOrgQueryHookResult =
	ReturnType<typeof useUseProposalMetrics_GetDashboardStatsForOrgQuery>;
export type UseProposalMetrics_GetDashboardStatsForOrgLazyQueryHookResult =
	ReturnType<typeof useUseProposalMetrics_GetDashboardStatsForOrgLazyQuery>;
export type UseProposalMetrics_GetDashboardStatsForOrgQueryResult =
	Apollo.QueryResult<
		UseProposalMetrics_GetDashboardStatsForOrgQuery,
		UseProposalMetrics_GetDashboardStatsForOrgQueryVariables
	>;
export const UseProposalsTable_GetProposalsForOrganizationDocument = gql`
	query useProposalsTable_getProposalsForOrganization(
		$where: ProposalsForOrganizationInput!
		$orderBy: [ProposalsOrderByInput]
		$skip: Int
		$take: Int
	) {
		getProposalsForOrganization(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			proposals {
				...proposalsTable
			}
		}
	}
	${ProposalsTableFragmentDoc}
`;

/**
 * __useUseProposalsTable_GetProposalsForOrganizationQuery__
 *
 * To run a query within a React component, call `useUseProposalsTable_GetProposalsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProposalsTable_GetProposalsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProposalsTable_GetProposalsForOrganizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useUseProposalsTable_GetProposalsForOrganizationQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseProposalsTable_GetProposalsForOrganizationQuery,
		UseProposalsTable_GetProposalsForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseProposalsTable_GetProposalsForOrganizationQuery,
		UseProposalsTable_GetProposalsForOrganizationQueryVariables
	>(UseProposalsTable_GetProposalsForOrganizationDocument, options);
}
export function useUseProposalsTable_GetProposalsForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseProposalsTable_GetProposalsForOrganizationQuery,
		UseProposalsTable_GetProposalsForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseProposalsTable_GetProposalsForOrganizationQuery,
		UseProposalsTable_GetProposalsForOrganizationQueryVariables
	>(UseProposalsTable_GetProposalsForOrganizationDocument, options);
}
export type UseProposalsTable_GetProposalsForOrganizationQueryHookResult =
	ReturnType<typeof useUseProposalsTable_GetProposalsForOrganizationQuery>;
export type UseProposalsTable_GetProposalsForOrganizationLazyQueryHookResult =
	ReturnType<typeof useUseProposalsTable_GetProposalsForOrganizationLazyQuery>;
export type UseProposalsTable_GetProposalsForOrganizationQueryResult =
	Apollo.QueryResult<
		UseProposalsTable_GetProposalsForOrganizationQuery,
		UseProposalsTable_GetProposalsForOrganizationQueryVariables
	>;
export const UseProposalsTable_GetProposalsForCustomerDocument = gql`
	query useProposalsTable_getProposalsForCustomer(
		$where: ProposalsForCustomerInput!
		$orderBy: [ProposalsOrderByInput]
		$skip: Int
		$take: Int
	) {
		getProposalsForCustomer(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			proposals {
				...proposalsTable
			}
		}
	}
	${ProposalsTableFragmentDoc}
`;

/**
 * __useUseProposalsTable_GetProposalsForCustomerQuery__
 *
 * To run a query within a React component, call `useUseProposalsTable_GetProposalsForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProposalsTable_GetProposalsForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProposalsTable_GetProposalsForCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useUseProposalsTable_GetProposalsForCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseProposalsTable_GetProposalsForCustomerQuery,
		UseProposalsTable_GetProposalsForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseProposalsTable_GetProposalsForCustomerQuery,
		UseProposalsTable_GetProposalsForCustomerQueryVariables
	>(UseProposalsTable_GetProposalsForCustomerDocument, options);
}
export function useUseProposalsTable_GetProposalsForCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseProposalsTable_GetProposalsForCustomerQuery,
		UseProposalsTable_GetProposalsForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseProposalsTable_GetProposalsForCustomerQuery,
		UseProposalsTable_GetProposalsForCustomerQueryVariables
	>(UseProposalsTable_GetProposalsForCustomerDocument, options);
}
export type UseProposalsTable_GetProposalsForCustomerQueryHookResult =
	ReturnType<typeof useUseProposalsTable_GetProposalsForCustomerQuery>;
export type UseProposalsTable_GetProposalsForCustomerLazyQueryHookResult =
	ReturnType<typeof useUseProposalsTable_GetProposalsForCustomerLazyQuery>;
export type UseProposalsTable_GetProposalsForCustomerQueryResult =
	Apollo.QueryResult<
		UseProposalsTable_GetProposalsForCustomerQuery,
		UseProposalsTable_GetProposalsForCustomerQueryVariables
	>;
export const UseProposalsTable_SendProposalDocument = gql`
	mutation useProposalsTable_sendProposal(
		$where: ProposalWhereUniqueInput!
		$data: SendProposalInput
	) {
		sendProposal(where: $where, data: $data) {
			...proposalsTable
		}
	}
	${ProposalsTableFragmentDoc}
`;
export type UseProposalsTable_SendProposalMutationFn = Apollo.MutationFunction<
	UseProposalsTable_SendProposalMutation,
	UseProposalsTable_SendProposalMutationVariables
>;

/**
 * __useUseProposalsTable_SendProposalMutation__
 *
 * To run a mutation, you first call `useUseProposalsTable_SendProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseProposalsTable_SendProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useProposalsTableSendProposalMutation, { data, loading, error }] = useUseProposalsTable_SendProposalMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseProposalsTable_SendProposalMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseProposalsTable_SendProposalMutation,
		UseProposalsTable_SendProposalMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseProposalsTable_SendProposalMutation,
		UseProposalsTable_SendProposalMutationVariables
	>(UseProposalsTable_SendProposalDocument, options);
}
export type UseProposalsTable_SendProposalMutationHookResult = ReturnType<
	typeof useUseProposalsTable_SendProposalMutation
>;
export type UseProposalsTable_SendProposalMutationResult =
	Apollo.MutationResult<UseProposalsTable_SendProposalMutation>;
export type UseProposalsTable_SendProposalMutationOptions =
	Apollo.BaseMutationOptions<
		UseProposalsTable_SendProposalMutation,
		UseProposalsTable_SendProposalMutationVariables
	>;
export const UseProposalsTable_GetProposalTemplatesWhereDocument = gql`
	query useProposalsTable_getProposalTemplatesWhere(
		$skip: Int
		$take: Int
		$where: ProposalTemplatesWhereInput
		$orderBy: [ProposalTemplateWhereOrderByInput]
	) {
		getProposalTemplatesWhere(
			skip: $skip
			take: $take
			where: $where
			orderBy: $orderBy
		) {
			_count
			proposalTemplates {
				...proposalsTableProposalTemplates
			}
		}
	}
	${ProposalsTableProposalTemplatesFragmentDoc}
`;

/**
 * __useUseProposalsTable_GetProposalTemplatesWhereQuery__
 *
 * To run a query within a React component, call `useUseProposalsTable_GetProposalTemplatesWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProposalsTable_GetProposalTemplatesWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProposalsTable_GetProposalTemplatesWhereQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUseProposalsTable_GetProposalTemplatesWhereQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UseProposalsTable_GetProposalTemplatesWhereQuery,
		UseProposalsTable_GetProposalTemplatesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseProposalsTable_GetProposalTemplatesWhereQuery,
		UseProposalsTable_GetProposalTemplatesWhereQueryVariables
	>(UseProposalsTable_GetProposalTemplatesWhereDocument, options);
}
export function useUseProposalsTable_GetProposalTemplatesWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseProposalsTable_GetProposalTemplatesWhereQuery,
		UseProposalsTable_GetProposalTemplatesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseProposalsTable_GetProposalTemplatesWhereQuery,
		UseProposalsTable_GetProposalTemplatesWhereQueryVariables
	>(UseProposalsTable_GetProposalTemplatesWhereDocument, options);
}
export type UseProposalsTable_GetProposalTemplatesWhereQueryHookResult =
	ReturnType<typeof useUseProposalsTable_GetProposalTemplatesWhereQuery>;
export type UseProposalsTable_GetProposalTemplatesWhereLazyQueryHookResult =
	ReturnType<typeof useUseProposalsTable_GetProposalTemplatesWhereLazyQuery>;
export type UseProposalsTable_GetProposalTemplatesWhereQueryResult =
	Apollo.QueryResult<
		UseProposalsTable_GetProposalTemplatesWhereQuery,
		UseProposalsTable_GetProposalTemplatesWhereQueryVariables
	>;
export const UseProposalsTable_DeleteProposalTemplateDocument = gql`
	mutation useProposalsTable_deleteProposalTemplate(
		$where: ProposalTemplateWhereUniqueInput!
	) {
		deleteProposalTemplate(where: $where) {
			id
		}
	}
`;
export type UseProposalsTable_DeleteProposalTemplateMutationFn =
	Apollo.MutationFunction<
		UseProposalsTable_DeleteProposalTemplateMutation,
		UseProposalsTable_DeleteProposalTemplateMutationVariables
	>;

/**
 * __useUseProposalsTable_DeleteProposalTemplateMutation__
 *
 * To run a mutation, you first call `useUseProposalsTable_DeleteProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseProposalsTable_DeleteProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useProposalsTableDeleteProposalTemplateMutation, { data, loading, error }] = useUseProposalsTable_DeleteProposalTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseProposalsTable_DeleteProposalTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseProposalsTable_DeleteProposalTemplateMutation,
		UseProposalsTable_DeleteProposalTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseProposalsTable_DeleteProposalTemplateMutation,
		UseProposalsTable_DeleteProposalTemplateMutationVariables
	>(UseProposalsTable_DeleteProposalTemplateDocument, options);
}
export type UseProposalsTable_DeleteProposalTemplateMutationHookResult =
	ReturnType<typeof useUseProposalsTable_DeleteProposalTemplateMutation>;
export type UseProposalsTable_DeleteProposalTemplateMutationResult =
	Apollo.MutationResult<UseProposalsTable_DeleteProposalTemplateMutation>;
export type UseProposalsTable_DeleteProposalTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		UseProposalsTable_DeleteProposalTemplateMutation,
		UseProposalsTable_DeleteProposalTemplateMutationVariables
	>;
export const UsePaymentSection_CreateOrUpdateContactForCustomerDocument = gql`
	mutation usePaymentSection_createOrUpdateContactForCustomer(
		$data: CreateOrUpdateContactForCustomerDataInput!
		$where: CreateOrUpdateContactForCustomerWhereInput!
	) {
		createOrUpdateContactForCustomer(data: $data, where: $where) {
			...usePaymentSectionContact
		}
	}
	${UsePaymentSectionContactFragmentDoc}
`;
export type UsePaymentSection_CreateOrUpdateContactForCustomerMutationFn =
	Apollo.MutationFunction<
		UsePaymentSection_CreateOrUpdateContactForCustomerMutation,
		UsePaymentSection_CreateOrUpdateContactForCustomerMutationVariables
	>;

/**
 * __useUsePaymentSection_CreateOrUpdateContactForCustomerMutation__
 *
 * To run a mutation, you first call `useUsePaymentSection_CreateOrUpdateContactForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsePaymentSection_CreateOrUpdateContactForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usePaymentSectionCreateOrUpdateContactForCustomerMutation, { data, loading, error }] = useUsePaymentSection_CreateOrUpdateContactForCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsePaymentSection_CreateOrUpdateContactForCustomerMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UsePaymentSection_CreateOrUpdateContactForCustomerMutation,
		UsePaymentSection_CreateOrUpdateContactForCustomerMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UsePaymentSection_CreateOrUpdateContactForCustomerMutation,
		UsePaymentSection_CreateOrUpdateContactForCustomerMutationVariables
	>(UsePaymentSection_CreateOrUpdateContactForCustomerDocument, options);
}
export type UsePaymentSection_CreateOrUpdateContactForCustomerMutationHookResult =
	ReturnType<
		typeof useUsePaymentSection_CreateOrUpdateContactForCustomerMutation
	>;
export type UsePaymentSection_CreateOrUpdateContactForCustomerMutationResult =
	Apollo.MutationResult<UsePaymentSection_CreateOrUpdateContactForCustomerMutation>;
export type UsePaymentSection_CreateOrUpdateContactForCustomerMutationOptions =
	Apollo.BaseMutationOptions<
		UsePaymentSection_CreateOrUpdateContactForCustomerMutation,
		UsePaymentSection_CreateOrUpdateContactForCustomerMutationVariables
	>;
export const PaymentSection_CreateSecretsForQuickPaymentDocument = gql`
	mutation paymentSection_createSecretsForQuickPayment(
		$data: CreateSecretsForQuickPaymentInput!
	) {
		createSecretsForQuickPayment(data: $data) {
			customerSecret
			invoiceId
			currency
			onBehalfOf
			excludedPaymentMethodTypes
		}
	}
`;
export type PaymentSection_CreateSecretsForQuickPaymentMutationFn =
	Apollo.MutationFunction<
		PaymentSection_CreateSecretsForQuickPaymentMutation,
		PaymentSection_CreateSecretsForQuickPaymentMutationVariables
	>;

/**
 * __usePaymentSection_CreateSecretsForQuickPaymentMutation__
 *
 * To run a mutation, you first call `usePaymentSection_CreateSecretsForQuickPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentSection_CreateSecretsForQuickPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentSectionCreateSecretsForQuickPaymentMutation, { data, loading, error }] = usePaymentSection_CreateSecretsForQuickPaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentSection_CreateSecretsForQuickPaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PaymentSection_CreateSecretsForQuickPaymentMutation,
		PaymentSection_CreateSecretsForQuickPaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PaymentSection_CreateSecretsForQuickPaymentMutation,
		PaymentSection_CreateSecretsForQuickPaymentMutationVariables
	>(PaymentSection_CreateSecretsForQuickPaymentDocument, options);
}
export type PaymentSection_CreateSecretsForQuickPaymentMutationHookResult =
	ReturnType<typeof usePaymentSection_CreateSecretsForQuickPaymentMutation>;
export type PaymentSection_CreateSecretsForQuickPaymentMutationResult =
	Apollo.MutationResult<PaymentSection_CreateSecretsForQuickPaymentMutation>;
export type PaymentSection_CreateSecretsForQuickPaymentMutationOptions =
	Apollo.BaseMutationOptions<
		PaymentSection_CreateSecretsForQuickPaymentMutation,
		PaymentSection_CreateSecretsForQuickPaymentMutationVariables
	>;
export const PaymentSection_CreateIntentForQuickPaymentDocument = gql`
	mutation paymentSection_createIntentForQuickPayment(
		$data: CreateIntentForQuickPaymentInput!
	) {
		createIntentForQuickPayment(data: $data) {
			id
			clientSecret
			amount
		}
	}
`;
export type PaymentSection_CreateIntentForQuickPaymentMutationFn =
	Apollo.MutationFunction<
		PaymentSection_CreateIntentForQuickPaymentMutation,
		PaymentSection_CreateIntentForQuickPaymentMutationVariables
	>;

/**
 * __usePaymentSection_CreateIntentForQuickPaymentMutation__
 *
 * To run a mutation, you first call `usePaymentSection_CreateIntentForQuickPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentSection_CreateIntentForQuickPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentSectionCreateIntentForQuickPaymentMutation, { data, loading, error }] = usePaymentSection_CreateIntentForQuickPaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentSection_CreateIntentForQuickPaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PaymentSection_CreateIntentForQuickPaymentMutation,
		PaymentSection_CreateIntentForQuickPaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PaymentSection_CreateIntentForQuickPaymentMutation,
		PaymentSection_CreateIntentForQuickPaymentMutationVariables
	>(PaymentSection_CreateIntentForQuickPaymentDocument, options);
}
export type PaymentSection_CreateIntentForQuickPaymentMutationHookResult =
	ReturnType<typeof usePaymentSection_CreateIntentForQuickPaymentMutation>;
export type PaymentSection_CreateIntentForQuickPaymentMutationResult =
	Apollo.MutationResult<PaymentSection_CreateIntentForQuickPaymentMutation>;
export type PaymentSection_CreateIntentForQuickPaymentMutationOptions =
	Apollo.BaseMutationOptions<
		PaymentSection_CreateIntentForQuickPaymentMutation,
		PaymentSection_CreateIntentForQuickPaymentMutationVariables
	>;
export const UsePaymentSection_ReportQuickPaymentFromCustomerSessionDocument = gql`
	mutation usePaymentSection_reportQuickPaymentFromCustomerSession(
		$data: ReportQuickPaymentFromCustomerSessionInput!
	) {
		reportQuickPaymentFromCustomerSession(data: $data) {
			id
			guestToken
		}
	}
`;
export type UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationFn =
	Apollo.MutationFunction<
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation,
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationVariables
	>;

/**
 * __useUsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation__
 *
 * To run a mutation, you first call `useUsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usePaymentSectionReportQuickPaymentFromCustomerSessionMutation, { data, loading, error }] = useUsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation,
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation,
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationVariables
	>(UsePaymentSection_ReportQuickPaymentFromCustomerSessionDocument, options);
}
export type UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationHookResult =
	ReturnType<
		typeof useUsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation
	>;
export type UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationResult =
	Apollo.MutationResult<UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation>;
export type UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationOptions =
	Apollo.BaseMutationOptions<
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutation,
		UsePaymentSection_ReportQuickPaymentFromCustomerSessionMutationVariables
	>;
export const QuickPaymentDetail_GetQuickPaymentDocument = gql`
	query QuickPaymentDetail_getQuickPayment($where: QuickPaymentUniqueInput!) {
		getQuickPayment(where: $where) {
			id
			organization {
				id
				name
				...organizationAvatarOnGetQuickPayment
			}
			...paymentSectionOnGetQuickPayment
		}
	}
	${OrganizationAvatarOnGetQuickPaymentFragmentDoc}
	${PaymentSectionOnGetQuickPaymentFragmentDoc}
`;

/**
 * __useQuickPaymentDetail_GetQuickPaymentQuery__
 *
 * To run a query within a React component, call `useQuickPaymentDetail_GetQuickPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickPaymentDetail_GetQuickPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickPaymentDetail_GetQuickPaymentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuickPaymentDetail_GetQuickPaymentQuery(
	baseOptions: Apollo.QueryHookOptions<
		QuickPaymentDetail_GetQuickPaymentQuery,
		QuickPaymentDetail_GetQuickPaymentQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		QuickPaymentDetail_GetQuickPaymentQuery,
		QuickPaymentDetail_GetQuickPaymentQueryVariables
	>(QuickPaymentDetail_GetQuickPaymentDocument, options);
}
export function useQuickPaymentDetail_GetQuickPaymentLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		QuickPaymentDetail_GetQuickPaymentQuery,
		QuickPaymentDetail_GetQuickPaymentQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		QuickPaymentDetail_GetQuickPaymentQuery,
		QuickPaymentDetail_GetQuickPaymentQueryVariables
	>(QuickPaymentDetail_GetQuickPaymentDocument, options);
}
export type QuickPaymentDetail_GetQuickPaymentQueryHookResult = ReturnType<
	typeof useQuickPaymentDetail_GetQuickPaymentQuery
>;
export type QuickPaymentDetail_GetQuickPaymentLazyQueryHookResult = ReturnType<
	typeof useQuickPaymentDetail_GetQuickPaymentLazyQuery
>;
export type QuickPaymentDetail_GetQuickPaymentQueryResult = Apollo.QueryResult<
	QuickPaymentDetail_GetQuickPaymentQuery,
	QuickPaymentDetail_GetQuickPaymentQueryVariables
>;
export const UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkDocument = gql`
	mutation useQuickPaymentsModal_createOrGetQuickPaymentLink(
		$data: QuickPaymentLinkCreateInput!
	) {
		createOrGetQuickPaymentLink(data: $data) {
			url
		}
	}
`;
export type UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationFn =
	Apollo.MutationFunction<
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation,
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationVariables
	>;

/**
 * __useUseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation__
 *
 * To run a mutation, you first call `useUseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useQuickPaymentsModalCreateOrGetQuickPaymentLinkMutation, { data, loading, error }] = useUseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation,
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation,
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationVariables
	>(UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkDocument, options);
}
export type UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationHookResult =
	ReturnType<
		typeof useUseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation
	>;
export type UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationResult =
	Apollo.MutationResult<UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation>;
export type UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationOptions =
	Apollo.BaseMutationOptions<
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutation,
		UseQuickPaymentsModal_CreateOrGetQuickPaymentLinkMutationVariables
	>;
export const RecaptchaInterstitial_GetGlobalVariablesDocument = gql`
	query RecaptchaInterstitial_getGlobalVariables {
		getGlobalVariables {
			CaptchaURL
		}
	}
`;

/**
 * __useRecaptchaInterstitial_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useRecaptchaInterstitial_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecaptchaInterstitial_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecaptchaInterstitial_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecaptchaInterstitial_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		RecaptchaInterstitial_GetGlobalVariablesQuery,
		RecaptchaInterstitial_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		RecaptchaInterstitial_GetGlobalVariablesQuery,
		RecaptchaInterstitial_GetGlobalVariablesQueryVariables
	>(RecaptchaInterstitial_GetGlobalVariablesDocument, options);
}
export function useRecaptchaInterstitial_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		RecaptchaInterstitial_GetGlobalVariablesQuery,
		RecaptchaInterstitial_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		RecaptchaInterstitial_GetGlobalVariablesQuery,
		RecaptchaInterstitial_GetGlobalVariablesQueryVariables
	>(RecaptchaInterstitial_GetGlobalVariablesDocument, options);
}
export type RecaptchaInterstitial_GetGlobalVariablesQueryHookResult =
	ReturnType<typeof useRecaptchaInterstitial_GetGlobalVariablesQuery>;
export type RecaptchaInterstitial_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useRecaptchaInterstitial_GetGlobalVariablesLazyQuery>;
export type RecaptchaInterstitial_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		RecaptchaInterstitial_GetGlobalVariablesQuery,
		RecaptchaInterstitial_GetGlobalVariablesQueryVariables
	>;
export const RecaptchaInterstitial_ValidateRecaptchaDocument = gql`
	mutation RecaptchaInterstitial_ValidateRecaptcha($token: String!) {
		validateRecaptcha(token: $token)
	}
`;
export type RecaptchaInterstitial_ValidateRecaptchaMutationFn =
	Apollo.MutationFunction<
		RecaptchaInterstitial_ValidateRecaptchaMutation,
		RecaptchaInterstitial_ValidateRecaptchaMutationVariables
	>;

/**
 * __useRecaptchaInterstitial_ValidateRecaptchaMutation__
 *
 * To run a mutation, you first call `useRecaptchaInterstitial_ValidateRecaptchaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecaptchaInterstitial_ValidateRecaptchaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recaptchaInterstitialValidateRecaptchaMutation, { data, loading, error }] = useRecaptchaInterstitial_ValidateRecaptchaMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRecaptchaInterstitial_ValidateRecaptchaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RecaptchaInterstitial_ValidateRecaptchaMutation,
		RecaptchaInterstitial_ValidateRecaptchaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RecaptchaInterstitial_ValidateRecaptchaMutation,
		RecaptchaInterstitial_ValidateRecaptchaMutationVariables
	>(RecaptchaInterstitial_ValidateRecaptchaDocument, options);
}
export type RecaptchaInterstitial_ValidateRecaptchaMutationHookResult =
	ReturnType<typeof useRecaptchaInterstitial_ValidateRecaptchaMutation>;
export type RecaptchaInterstitial_ValidateRecaptchaMutationResult =
	Apollo.MutationResult<RecaptchaInterstitial_ValidateRecaptchaMutation>;
export type RecaptchaInterstitial_ValidateRecaptchaMutationOptions =
	Apollo.BaseMutationOptions<
		RecaptchaInterstitial_ValidateRecaptchaMutation,
		RecaptchaInterstitial_ValidateRecaptchaMutationVariables
	>;
export const RecaptchaInterstitial_GetFeatureFlagsDocument = gql`
	query RecaptchaInterstitial_GetFeatureFlags {
		getFeatureFlags {
			category
			active
		}
	}
`;

/**
 * __useRecaptchaInterstitial_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useRecaptchaInterstitial_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecaptchaInterstitial_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecaptchaInterstitial_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecaptchaInterstitial_GetFeatureFlagsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		RecaptchaInterstitial_GetFeatureFlagsQuery,
		RecaptchaInterstitial_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		RecaptchaInterstitial_GetFeatureFlagsQuery,
		RecaptchaInterstitial_GetFeatureFlagsQueryVariables
	>(RecaptchaInterstitial_GetFeatureFlagsDocument, options);
}
export function useRecaptchaInterstitial_GetFeatureFlagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		RecaptchaInterstitial_GetFeatureFlagsQuery,
		RecaptchaInterstitial_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		RecaptchaInterstitial_GetFeatureFlagsQuery,
		RecaptchaInterstitial_GetFeatureFlagsQueryVariables
	>(RecaptchaInterstitial_GetFeatureFlagsDocument, options);
}
export type RecaptchaInterstitial_GetFeatureFlagsQueryHookResult = ReturnType<
	typeof useRecaptchaInterstitial_GetFeatureFlagsQuery
>;
export type RecaptchaInterstitial_GetFeatureFlagsLazyQueryHookResult =
	ReturnType<typeof useRecaptchaInterstitial_GetFeatureFlagsLazyQuery>;
export type RecaptchaInterstitial_GetFeatureFlagsQueryResult =
	Apollo.QueryResult<
		RecaptchaInterstitial_GetFeatureFlagsQuery,
		RecaptchaInterstitial_GetFeatureFlagsQueryVariables
	>;
export const ReportsIndex_GetOrgUserWhereDocument = gql`
	query reportsIndex_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				createdAt
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useReportsIndex_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useReportsIndex_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsIndex_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsIndex_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportsIndex_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportsIndex_GetOrgUserWhereQuery,
		ReportsIndex_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportsIndex_GetOrgUserWhereQuery,
		ReportsIndex_GetOrgUserWhereQueryVariables
	>(ReportsIndex_GetOrgUserWhereDocument, options);
}
export function useReportsIndex_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportsIndex_GetOrgUserWhereQuery,
		ReportsIndex_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportsIndex_GetOrgUserWhereQuery,
		ReportsIndex_GetOrgUserWhereQueryVariables
	>(ReportsIndex_GetOrgUserWhereDocument, options);
}
export type ReportsIndex_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useReportsIndex_GetOrgUserWhereQuery
>;
export type ReportsIndex_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useReportsIndex_GetOrgUserWhereLazyQuery
>;
export type ReportsIndex_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	ReportsIndex_GetOrgUserWhereQuery,
	ReportsIndex_GetOrgUserWhereQueryVariables
>;
export const ReportsIndex_ExportInvoicesDocument = gql`
	query reportsIndex_exportInvoices($data: ExportInvoicesDataInput!) {
		exportInvoices(data: $data)
	}
`;

/**
 * __useReportsIndex_ExportInvoicesQuery__
 *
 * To run a query within a React component, call `useReportsIndex_ExportInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsIndex_ExportInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsIndex_ExportInvoicesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReportsIndex_ExportInvoicesQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportsIndex_ExportInvoicesQuery,
		ReportsIndex_ExportInvoicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportsIndex_ExportInvoicesQuery,
		ReportsIndex_ExportInvoicesQueryVariables
	>(ReportsIndex_ExportInvoicesDocument, options);
}
export function useReportsIndex_ExportInvoicesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportsIndex_ExportInvoicesQuery,
		ReportsIndex_ExportInvoicesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportsIndex_ExportInvoicesQuery,
		ReportsIndex_ExportInvoicesQueryVariables
	>(ReportsIndex_ExportInvoicesDocument, options);
}
export type ReportsIndex_ExportInvoicesQueryHookResult = ReturnType<
	typeof useReportsIndex_ExportInvoicesQuery
>;
export type ReportsIndex_ExportInvoicesLazyQueryHookResult = ReturnType<
	typeof useReportsIndex_ExportInvoicesLazyQuery
>;
export type ReportsIndex_ExportInvoicesQueryResult = Apollo.QueryResult<
	ReportsIndex_ExportInvoicesQuery,
	ReportsIndex_ExportInvoicesQueryVariables
>;
export const ReportsIndex_ExportOrgOfflineTransactionHistoryDocument = gql`
	query reportsIndex_exportOrgOfflineTransactionHistory(
		$where: OrganizationWhereUniqueInput!
		$data: ExportHistoryInput!
	) {
		exportOrgOfflineTransactionHistory(where: $where, data: $data) {
			url
		}
	}
`;

/**
 * __useReportsIndex_ExportOrgOfflineTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useReportsIndex_ExportOrgOfflineTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsIndex_ExportOrgOfflineTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsIndex_ExportOrgOfflineTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReportsIndex_ExportOrgOfflineTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportsIndex_ExportOrgOfflineTransactionHistoryQuery,
		ReportsIndex_ExportOrgOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportsIndex_ExportOrgOfflineTransactionHistoryQuery,
		ReportsIndex_ExportOrgOfflineTransactionHistoryQueryVariables
	>(ReportsIndex_ExportOrgOfflineTransactionHistoryDocument, options);
}
export function useReportsIndex_ExportOrgOfflineTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportsIndex_ExportOrgOfflineTransactionHistoryQuery,
		ReportsIndex_ExportOrgOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportsIndex_ExportOrgOfflineTransactionHistoryQuery,
		ReportsIndex_ExportOrgOfflineTransactionHistoryQueryVariables
	>(ReportsIndex_ExportOrgOfflineTransactionHistoryDocument, options);
}
export type ReportsIndex_ExportOrgOfflineTransactionHistoryQueryHookResult =
	ReturnType<typeof useReportsIndex_ExportOrgOfflineTransactionHistoryQuery>;
export type ReportsIndex_ExportOrgOfflineTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useReportsIndex_ExportOrgOfflineTransactionHistoryLazyQuery
	>;
export type ReportsIndex_ExportOrgOfflineTransactionHistoryQueryResult =
	Apollo.QueryResult<
		ReportsIndex_ExportOrgOfflineTransactionHistoryQuery,
		ReportsIndex_ExportOrgOfflineTransactionHistoryQueryVariables
	>;
export const ReportsIndex_ExportOrgTransactionHistoryDocument = gql`
	query reportsIndex_exportOrgTransactionHistory(
		$where: OrganizationWhereUniqueInput!
		$data: ExportHistoryInput!
	) {
		exportOrgTransactionHistory(where: $where, data: $data)
	}
`;

/**
 * __useReportsIndex_ExportOrgTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useReportsIndex_ExportOrgTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsIndex_ExportOrgTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsIndex_ExportOrgTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReportsIndex_ExportOrgTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportsIndex_ExportOrgTransactionHistoryQuery,
		ReportsIndex_ExportOrgTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportsIndex_ExportOrgTransactionHistoryQuery,
		ReportsIndex_ExportOrgTransactionHistoryQueryVariables
	>(ReportsIndex_ExportOrgTransactionHistoryDocument, options);
}
export function useReportsIndex_ExportOrgTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportsIndex_ExportOrgTransactionHistoryQuery,
		ReportsIndex_ExportOrgTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportsIndex_ExportOrgTransactionHistoryQuery,
		ReportsIndex_ExportOrgTransactionHistoryQueryVariables
	>(ReportsIndex_ExportOrgTransactionHistoryDocument, options);
}
export type ReportsIndex_ExportOrgTransactionHistoryQueryHookResult =
	ReturnType<typeof useReportsIndex_ExportOrgTransactionHistoryQuery>;
export type ReportsIndex_ExportOrgTransactionHistoryLazyQueryHookResult =
	ReturnType<typeof useReportsIndex_ExportOrgTransactionHistoryLazyQuery>;
export type ReportsIndex_ExportOrgTransactionHistoryQueryResult =
	Apollo.QueryResult<
		ReportsIndex_ExportOrgTransactionHistoryQuery,
		ReportsIndex_ExportOrgTransactionHistoryQueryVariables
	>;
export const ReportsIndex_ExportWalletQuickPaymentsDocument = gql`
	query reportsIndex_exportWalletQuickPayments(
		$where: ExportWalletQuickPaymentsWhereInput!
		$data: ExportWalletQuickPaymentsDataInput!
	) {
		exportWalletQuickPayments(where: $where, data: $data)
	}
`;

/**
 * __useReportsIndex_ExportWalletQuickPaymentsQuery__
 *
 * To run a query within a React component, call `useReportsIndex_ExportWalletQuickPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsIndex_ExportWalletQuickPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsIndex_ExportWalletQuickPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReportsIndex_ExportWalletQuickPaymentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportsIndex_ExportWalletQuickPaymentsQuery,
		ReportsIndex_ExportWalletQuickPaymentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportsIndex_ExportWalletQuickPaymentsQuery,
		ReportsIndex_ExportWalletQuickPaymentsQueryVariables
	>(ReportsIndex_ExportWalletQuickPaymentsDocument, options);
}
export function useReportsIndex_ExportWalletQuickPaymentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportsIndex_ExportWalletQuickPaymentsQuery,
		ReportsIndex_ExportWalletQuickPaymentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportsIndex_ExportWalletQuickPaymentsQuery,
		ReportsIndex_ExportWalletQuickPaymentsQueryVariables
	>(ReportsIndex_ExportWalletQuickPaymentsDocument, options);
}
export type ReportsIndex_ExportWalletQuickPaymentsQueryHookResult = ReturnType<
	typeof useReportsIndex_ExportWalletQuickPaymentsQuery
>;
export type ReportsIndex_ExportWalletQuickPaymentsLazyQueryHookResult =
	ReturnType<typeof useReportsIndex_ExportWalletQuickPaymentsLazyQuery>;
export type ReportsIndex_ExportWalletQuickPaymentsQueryResult =
	Apollo.QueryResult<
		ReportsIndex_ExportWalletQuickPaymentsQuery,
		ReportsIndex_ExportWalletQuickPaymentsQueryVariables
	>;
export const ReportsIndex_ExportDashboardStatsForOrgDocument = gql`
	query reportsIndex_exportDashboardStatsForOrg($where: DashboardExportInput!) {
		exportDashboardStatsForOrg(where: $where)
	}
`;

/**
 * __useReportsIndex_ExportDashboardStatsForOrgQuery__
 *
 * To run a query within a React component, call `useReportsIndex_ExportDashboardStatsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsIndex_ExportDashboardStatsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsIndex_ExportDashboardStatsForOrgQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportsIndex_ExportDashboardStatsForOrgQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportsIndex_ExportDashboardStatsForOrgQuery,
		ReportsIndex_ExportDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportsIndex_ExportDashboardStatsForOrgQuery,
		ReportsIndex_ExportDashboardStatsForOrgQueryVariables
	>(ReportsIndex_ExportDashboardStatsForOrgDocument, options);
}
export function useReportsIndex_ExportDashboardStatsForOrgLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportsIndex_ExportDashboardStatsForOrgQuery,
		ReportsIndex_ExportDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportsIndex_ExportDashboardStatsForOrgQuery,
		ReportsIndex_ExportDashboardStatsForOrgQueryVariables
	>(ReportsIndex_ExportDashboardStatsForOrgDocument, options);
}
export type ReportsIndex_ExportDashboardStatsForOrgQueryHookResult = ReturnType<
	typeof useReportsIndex_ExportDashboardStatsForOrgQuery
>;
export type ReportsIndex_ExportDashboardStatsForOrgLazyQueryHookResult =
	ReturnType<typeof useReportsIndex_ExportDashboardStatsForOrgLazyQuery>;
export type ReportsIndex_ExportDashboardStatsForOrgQueryResult =
	Apollo.QueryResult<
		ReportsIndex_ExportDashboardStatsForOrgQuery,
		ReportsIndex_ExportDashboardStatsForOrgQueryVariables
	>;
export const ReportsIndex_GetStripeInvoicesForVendorCustomerDocument = gql`
	query reportsIndex_getStripeInvoicesForVendorCustomer {
		getStripeInvoicesForVendorCustomer {
			data {
				id
				invoice_pdf
				date
				period_start
			}
		}
	}
`;

/**
 * __useReportsIndex_GetStripeInvoicesForVendorCustomerQuery__
 *
 * To run a query within a React component, call `useReportsIndex_GetStripeInvoicesForVendorCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsIndex_GetStripeInvoicesForVendorCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsIndex_GetStripeInvoicesForVendorCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportsIndex_GetStripeInvoicesForVendorCustomerQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportsIndex_GetStripeInvoicesForVendorCustomerQuery,
		ReportsIndex_GetStripeInvoicesForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportsIndex_GetStripeInvoicesForVendorCustomerQuery,
		ReportsIndex_GetStripeInvoicesForVendorCustomerQueryVariables
	>(ReportsIndex_GetStripeInvoicesForVendorCustomerDocument, options);
}
export function useReportsIndex_GetStripeInvoicesForVendorCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportsIndex_GetStripeInvoicesForVendorCustomerQuery,
		ReportsIndex_GetStripeInvoicesForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportsIndex_GetStripeInvoicesForVendorCustomerQuery,
		ReportsIndex_GetStripeInvoicesForVendorCustomerQueryVariables
	>(ReportsIndex_GetStripeInvoicesForVendorCustomerDocument, options);
}
export type ReportsIndex_GetStripeInvoicesForVendorCustomerQueryHookResult =
	ReturnType<typeof useReportsIndex_GetStripeInvoicesForVendorCustomerQuery>;
export type ReportsIndex_GetStripeInvoicesForVendorCustomerLazyQueryHookResult =
	ReturnType<
		typeof useReportsIndex_GetStripeInvoicesForVendorCustomerLazyQuery
	>;
export type ReportsIndex_GetStripeInvoicesForVendorCustomerQueryResult =
	Apollo.QueryResult<
		ReportsIndex_GetStripeInvoicesForVendorCustomerQuery,
		ReportsIndex_GetStripeInvoicesForVendorCustomerQueryVariables
	>;
export const ResourceDetailButtonBarDownloadButton_DownloadResourceWhereDocument = gql`
	query resourceDetailButtonBarDownloadButton_downloadResourceWhere(
		$where: ResourceWhereUniqueInput!
	) {
		downloadResourceWhere(where: $where) {
			id
			downloadUrl
		}
	}
`;

/**
 * __useResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery__
 *
 * To run a query within a React component, call `useResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery,
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery,
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryVariables
	>(
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereDocument,
		options
	);
}
export function useResourceDetailButtonBarDownloadButton_DownloadResourceWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery,
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery,
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryVariables
	>(
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereDocument,
		options
	);
}
export type ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryHookResult =
	ReturnType<
		typeof useResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery
	>;
export type ResourceDetailButtonBarDownloadButton_DownloadResourceWhereLazyQueryHookResult =
	ReturnType<
		typeof useResourceDetailButtonBarDownloadButton_DownloadResourceWhereLazyQuery
	>;
export type ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryResult =
	Apollo.QueryResult<
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQuery,
		ResourceDetailButtonBarDownloadButton_DownloadResourceWhereQueryVariables
	>;
export const ResourceDetail_GetResourceWhereDocument = gql`
	query resourceDetail_getResourceWhere($where: ResourceWhereUniqueInput!) {
		getResourceWhere(where: $where) {
			id
			...resourceDetail
		}
	}
	${ResourceDetailFragmentDoc}
`;

/**
 * __useResourceDetail_GetResourceWhereQuery__
 *
 * To run a query within a React component, call `useResourceDetail_GetResourceWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceDetail_GetResourceWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceDetail_GetResourceWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useResourceDetail_GetResourceWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ResourceDetail_GetResourceWhereQuery,
		ResourceDetail_GetResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ResourceDetail_GetResourceWhereQuery,
		ResourceDetail_GetResourceWhereQueryVariables
	>(ResourceDetail_GetResourceWhereDocument, options);
}
export function useResourceDetail_GetResourceWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ResourceDetail_GetResourceWhereQuery,
		ResourceDetail_GetResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ResourceDetail_GetResourceWhereQuery,
		ResourceDetail_GetResourceWhereQueryVariables
	>(ResourceDetail_GetResourceWhereDocument, options);
}
export type ResourceDetail_GetResourceWhereQueryHookResult = ReturnType<
	typeof useResourceDetail_GetResourceWhereQuery
>;
export type ResourceDetail_GetResourceWhereLazyQueryHookResult = ReturnType<
	typeof useResourceDetail_GetResourceWhereLazyQuery
>;
export type ResourceDetail_GetResourceWhereQueryResult = Apollo.QueryResult<
	ResourceDetail_GetResourceWhereQuery,
	ResourceDetail_GetResourceWhereQueryVariables
>;
export const ResourcesTable_DownloadResourceWhereDocument = gql`
	query resourcesTable_downloadResourceWhere(
		$where: ResourceWhereUniqueInput!
	) {
		downloadResourceWhere(where: $where) {
			id
			downloadUrl
		}
	}
`;

/**
 * __useResourcesTable_DownloadResourceWhereQuery__
 *
 * To run a query within a React component, call `useResourcesTable_DownloadResourceWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesTable_DownloadResourceWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesTable_DownloadResourceWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useResourcesTable_DownloadResourceWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ResourcesTable_DownloadResourceWhereQuery,
		ResourcesTable_DownloadResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ResourcesTable_DownloadResourceWhereQuery,
		ResourcesTable_DownloadResourceWhereQueryVariables
	>(ResourcesTable_DownloadResourceWhereDocument, options);
}
export function useResourcesTable_DownloadResourceWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ResourcesTable_DownloadResourceWhereQuery,
		ResourcesTable_DownloadResourceWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ResourcesTable_DownloadResourceWhereQuery,
		ResourcesTable_DownloadResourceWhereQueryVariables
	>(ResourcesTable_DownloadResourceWhereDocument, options);
}
export type ResourcesTable_DownloadResourceWhereQueryHookResult = ReturnType<
	typeof useResourcesTable_DownloadResourceWhereQuery
>;
export type ResourcesTable_DownloadResourceWhereLazyQueryHookResult =
	ReturnType<typeof useResourcesTable_DownloadResourceWhereLazyQuery>;
export type ResourcesTable_DownloadResourceWhereQueryResult =
	Apollo.QueryResult<
		ResourcesTable_DownloadResourceWhereQuery,
		ResourcesTable_DownloadResourceWhereQueryVariables
	>;
export const ResourcesTable_GetResourcesWhereDocument = gql`
	query resourcesTable_getResourcesWhere(
		$where: ResourceWhereInput!
		$orderBy: [ResourceOrderByInput!]
		$skip: Int
		$take: Int
	) {
		getResourcesWhere(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			resources {
				...resourcesTable
			}
		}
	}
	${ResourcesTableFragmentDoc}
`;

/**
 * __useResourcesTable_GetResourcesWhereQuery__
 *
 * To run a query within a React component, call `useResourcesTable_GetResourcesWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesTable_GetResourcesWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesTable_GetResourcesWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useResourcesTable_GetResourcesWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ResourcesTable_GetResourcesWhereQuery,
		ResourcesTable_GetResourcesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ResourcesTable_GetResourcesWhereQuery,
		ResourcesTable_GetResourcesWhereQueryVariables
	>(ResourcesTable_GetResourcesWhereDocument, options);
}
export function useResourcesTable_GetResourcesWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ResourcesTable_GetResourcesWhereQuery,
		ResourcesTable_GetResourcesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ResourcesTable_GetResourcesWhereQuery,
		ResourcesTable_GetResourcesWhereQueryVariables
	>(ResourcesTable_GetResourcesWhereDocument, options);
}
export type ResourcesTable_GetResourcesWhereQueryHookResult = ReturnType<
	typeof useResourcesTable_GetResourcesWhereQuery
>;
export type ResourcesTable_GetResourcesWhereLazyQueryHookResult = ReturnType<
	typeof useResourcesTable_GetResourcesWhereLazyQuery
>;
export type ResourcesTable_GetResourcesWhereQueryResult = Apollo.QueryResult<
	ResourcesTable_GetResourcesWhereQuery,
	ResourcesTable_GetResourcesWhereQueryVariables
>;
export const Role_SetTeamMemberRoleDocument = gql`
	mutation role_setTeamMemberRole(
		$where: OrgUserWhereUniqueInput!
		$data: TeamMemberRole!
	) {
		setTeamMemberRole(where: $where, data: $data) {
			id
			users {
				id
				role
			}
		}
	}
`;
export type Role_SetTeamMemberRoleMutationFn = Apollo.MutationFunction<
	Role_SetTeamMemberRoleMutation,
	Role_SetTeamMemberRoleMutationVariables
>;

/**
 * __useRole_SetTeamMemberRoleMutation__
 *
 * To run a mutation, you first call `useRole_SetTeamMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRole_SetTeamMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleSetTeamMemberRoleMutation, { data, loading, error }] = useRole_SetTeamMemberRoleMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRole_SetTeamMemberRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		Role_SetTeamMemberRoleMutation,
		Role_SetTeamMemberRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		Role_SetTeamMemberRoleMutation,
		Role_SetTeamMemberRoleMutationVariables
	>(Role_SetTeamMemberRoleDocument, options);
}
export type Role_SetTeamMemberRoleMutationHookResult = ReturnType<
	typeof useRole_SetTeamMemberRoleMutation
>;
export type Role_SetTeamMemberRoleMutationResult =
	Apollo.MutationResult<Role_SetTeamMemberRoleMutation>;
export type Role_SetTeamMemberRoleMutationOptions = Apollo.BaseMutationOptions<
	Role_SetTeamMemberRoleMutation,
	Role_SetTeamMemberRoleMutationVariables
>;
export const Role_DisableOrgMemberDocument = gql`
	mutation role_disableOrgMember($where: OrgUserWhereUniqueInput!) {
		disableOrgMember(where: $where) {
			id
			users {
				id
				role
			}
		}
	}
`;
export type Role_DisableOrgMemberMutationFn = Apollo.MutationFunction<
	Role_DisableOrgMemberMutation,
	Role_DisableOrgMemberMutationVariables
>;

/**
 * __useRole_DisableOrgMemberMutation__
 *
 * To run a mutation, you first call `useRole_DisableOrgMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRole_DisableOrgMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleDisableOrgMemberMutation, { data, loading, error }] = useRole_DisableOrgMemberMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRole_DisableOrgMemberMutation(
	baseOptions?: Apollo.MutationHookOptions<
		Role_DisableOrgMemberMutation,
		Role_DisableOrgMemberMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		Role_DisableOrgMemberMutation,
		Role_DisableOrgMemberMutationVariables
	>(Role_DisableOrgMemberDocument, options);
}
export type Role_DisableOrgMemberMutationHookResult = ReturnType<
	typeof useRole_DisableOrgMemberMutation
>;
export type Role_DisableOrgMemberMutationResult =
	Apollo.MutationResult<Role_DisableOrgMemberMutation>;
export type Role_DisableOrgMemberMutationOptions = Apollo.BaseMutationOptions<
	Role_DisableOrgMemberMutation,
	Role_DisableOrgMemberMutationVariables
>;
export const Role_ReactivateOrgMemberDocument = gql`
	mutation role_reactivateOrgMember($where: OrgUserWhereUniqueInput!) {
		reactivateOrgMember(where: $where) {
			id
			users {
				id
				role
			}
		}
	}
`;
export type Role_ReactivateOrgMemberMutationFn = Apollo.MutationFunction<
	Role_ReactivateOrgMemberMutation,
	Role_ReactivateOrgMemberMutationVariables
>;

/**
 * __useRole_ReactivateOrgMemberMutation__
 *
 * To run a mutation, you first call `useRole_ReactivateOrgMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRole_ReactivateOrgMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleReactivateOrgMemberMutation, { data, loading, error }] = useRole_ReactivateOrgMemberMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRole_ReactivateOrgMemberMutation(
	baseOptions?: Apollo.MutationHookOptions<
		Role_ReactivateOrgMemberMutation,
		Role_ReactivateOrgMemberMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		Role_ReactivateOrgMemberMutation,
		Role_ReactivateOrgMemberMutationVariables
	>(Role_ReactivateOrgMemberDocument, options);
}
export type Role_ReactivateOrgMemberMutationHookResult = ReturnType<
	typeof useRole_ReactivateOrgMemberMutation
>;
export type Role_ReactivateOrgMemberMutationResult =
	Apollo.MutationResult<Role_ReactivateOrgMemberMutation>;
export type Role_ReactivateOrgMemberMutationOptions =
	Apollo.BaseMutationOptions<
		Role_ReactivateOrgMemberMutation,
		Role_ReactivateOrgMemberMutationVariables
	>;
export const SelectServices_GetServicesWhereDocument = gql`
	query SelectServices_GetServicesWhere {
		getServicesWhere {
			id
			name
		}
	}
`;

/**
 * __useSelectServices_GetServicesWhereQuery__
 *
 * To run a query within a React component, call `useSelectServices_GetServicesWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectServices_GetServicesWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectServices_GetServicesWhereQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectServices_GetServicesWhereQuery(
	baseOptions?: Apollo.QueryHookOptions<
		SelectServices_GetServicesWhereQuery,
		SelectServices_GetServicesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SelectServices_GetServicesWhereQuery,
		SelectServices_GetServicesWhereQueryVariables
	>(SelectServices_GetServicesWhereDocument, options);
}
export function useSelectServices_GetServicesWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SelectServices_GetServicesWhereQuery,
		SelectServices_GetServicesWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SelectServices_GetServicesWhereQuery,
		SelectServices_GetServicesWhereQueryVariables
	>(SelectServices_GetServicesWhereDocument, options);
}
export type SelectServices_GetServicesWhereQueryHookResult = ReturnType<
	typeof useSelectServices_GetServicesWhereQuery
>;
export type SelectServices_GetServicesWhereLazyQueryHookResult = ReturnType<
	typeof useSelectServices_GetServicesWhereLazyQuery
>;
export type SelectServices_GetServicesWhereQueryResult = Apollo.QueryResult<
	SelectServices_GetServicesWhereQuery,
	SelectServices_GetServicesWhereQueryVariables
>;
export const ShareWidget_ShareDocumentDocument = gql`
	mutation ShareWidget_shareDocument(
		$where: DocumentWhereUniqueInput!
		$data: CustomShareDocumentInput!
	) {
		shareDocument(where: $where, data: $data) {
			...shareWidgetDocument
		}
	}
	${ShareWidgetDocumentFragmentDoc}
`;
export type ShareWidget_ShareDocumentMutationFn = Apollo.MutationFunction<
	ShareWidget_ShareDocumentMutation,
	ShareWidget_ShareDocumentMutationVariables
>;

/**
 * __useShareWidget_ShareDocumentMutation__
 *
 * To run a mutation, you first call `useShareWidget_ShareDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareWidget_ShareDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareWidgetShareDocumentMutation, { data, loading, error }] = useShareWidget_ShareDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useShareWidget_ShareDocumentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ShareWidget_ShareDocumentMutation,
		ShareWidget_ShareDocumentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ShareWidget_ShareDocumentMutation,
		ShareWidget_ShareDocumentMutationVariables
	>(ShareWidget_ShareDocumentDocument, options);
}
export type ShareWidget_ShareDocumentMutationHookResult = ReturnType<
	typeof useShareWidget_ShareDocumentMutation
>;
export type ShareWidget_ShareDocumentMutationResult =
	Apollo.MutationResult<ShareWidget_ShareDocumentMutation>;
export type ShareWidget_ShareDocumentMutationOptions =
	Apollo.BaseMutationOptions<
		ShareWidget_ShareDocumentMutation,
		ShareWidget_ShareDocumentMutationVariables
	>;
export const RequestVerificationEmail_CreateVerificationTokenDocument = gql`
	mutation requestVerificationEmail_createVerificationToken(
		$data: CreateVerificationTokenInput!
	) {
		createVerificationToken(data: $data)
	}
`;
export type RequestVerificationEmail_CreateVerificationTokenMutationFn =
	Apollo.MutationFunction<
		RequestVerificationEmail_CreateVerificationTokenMutation,
		RequestVerificationEmail_CreateVerificationTokenMutationVariables
	>;

/**
 * __useRequestVerificationEmail_CreateVerificationTokenMutation__
 *
 * To run a mutation, you first call `useRequestVerificationEmail_CreateVerificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVerificationEmail_CreateVerificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVerificationEmailCreateVerificationTokenMutation, { data, loading, error }] = useRequestVerificationEmail_CreateVerificationTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestVerificationEmail_CreateVerificationTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestVerificationEmail_CreateVerificationTokenMutation,
		RequestVerificationEmail_CreateVerificationTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RequestVerificationEmail_CreateVerificationTokenMutation,
		RequestVerificationEmail_CreateVerificationTokenMutationVariables
	>(RequestVerificationEmail_CreateVerificationTokenDocument, options);
}
export type RequestVerificationEmail_CreateVerificationTokenMutationHookResult =
	ReturnType<
		typeof useRequestVerificationEmail_CreateVerificationTokenMutation
	>;
export type RequestVerificationEmail_CreateVerificationTokenMutationResult =
	Apollo.MutationResult<RequestVerificationEmail_CreateVerificationTokenMutation>;
export type RequestVerificationEmail_CreateVerificationTokenMutationOptions =
	Apollo.BaseMutationOptions<
		RequestVerificationEmail_CreateVerificationTokenMutation,
		RequestVerificationEmail_CreateVerificationTokenMutationVariables
	>;
export const SignUpPage_LogoutDocument = gql`
	mutation SignUpPage_logout {
		logout
	}
`;
export type SignUpPage_LogoutMutationFn = Apollo.MutationFunction<
	SignUpPage_LogoutMutation,
	SignUpPage_LogoutMutationVariables
>;

/**
 * __useSignUpPage_LogoutMutation__
 *
 * To run a mutation, you first call `useSignUpPage_LogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpPage_LogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpPageLogoutMutation, { data, loading, error }] = useSignUpPage_LogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignUpPage_LogoutMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SignUpPage_LogoutMutation,
		SignUpPage_LogoutMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SignUpPage_LogoutMutation,
		SignUpPage_LogoutMutationVariables
	>(SignUpPage_LogoutDocument, options);
}
export type SignUpPage_LogoutMutationHookResult = ReturnType<
	typeof useSignUpPage_LogoutMutation
>;
export type SignUpPage_LogoutMutationResult =
	Apollo.MutationResult<SignUpPage_LogoutMutation>;
export type SignUpPage_LogoutMutationOptions = Apollo.BaseMutationOptions<
	SignUpPage_LogoutMutation,
	SignUpPage_LogoutMutationVariables
>;
export const SitewideSearch_SitewideSearchDocument = gql`
	query sitewideSearch_sitewideSearch(
		$where: SearchWhereInput!
		$data: SearchDataInput!
	) {
		sitewideSearch(where: $where, data: $data) {
			title
			path
			subtitle
			type
		}
	}
`;

/**
 * __useSitewideSearch_SitewideSearchQuery__
 *
 * To run a query within a React component, call `useSitewideSearch_SitewideSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitewideSearch_SitewideSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitewideSearch_SitewideSearchQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSitewideSearch_SitewideSearchQuery(
	baseOptions: Apollo.QueryHookOptions<
		SitewideSearch_SitewideSearchQuery,
		SitewideSearch_SitewideSearchQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SitewideSearch_SitewideSearchQuery,
		SitewideSearch_SitewideSearchQueryVariables
	>(SitewideSearch_SitewideSearchDocument, options);
}
export function useSitewideSearch_SitewideSearchLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SitewideSearch_SitewideSearchQuery,
		SitewideSearch_SitewideSearchQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SitewideSearch_SitewideSearchQuery,
		SitewideSearch_SitewideSearchQueryVariables
	>(SitewideSearch_SitewideSearchDocument, options);
}
export type SitewideSearch_SitewideSearchQueryHookResult = ReturnType<
	typeof useSitewideSearch_SitewideSearchQuery
>;
export type SitewideSearch_SitewideSearchLazyQueryHookResult = ReturnType<
	typeof useSitewideSearch_SitewideSearchLazyQuery
>;
export type SitewideSearch_SitewideSearchQueryResult = Apollo.QueryResult<
	SitewideSearch_SitewideSearchQuery,
	SitewideSearch_SitewideSearchQueryVariables
>;
export const SourceInput_GetOrganizationSourcesDocument = gql`
	query SourceInput_getOrganizationSources {
		getOrganizationSources {
			id
			source
		}
	}
`;

/**
 * __useSourceInput_GetOrganizationSourcesQuery__
 *
 * To run a query within a React component, call `useSourceInput_GetOrganizationSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceInput_GetOrganizationSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceInput_GetOrganizationSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSourceInput_GetOrganizationSourcesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		SourceInput_GetOrganizationSourcesQuery,
		SourceInput_GetOrganizationSourcesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SourceInput_GetOrganizationSourcesQuery,
		SourceInput_GetOrganizationSourcesQueryVariables
	>(SourceInput_GetOrganizationSourcesDocument, options);
}
export function useSourceInput_GetOrganizationSourcesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SourceInput_GetOrganizationSourcesQuery,
		SourceInput_GetOrganizationSourcesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SourceInput_GetOrganizationSourcesQuery,
		SourceInput_GetOrganizationSourcesQueryVariables
	>(SourceInput_GetOrganizationSourcesDocument, options);
}
export type SourceInput_GetOrganizationSourcesQueryHookResult = ReturnType<
	typeof useSourceInput_GetOrganizationSourcesQuery
>;
export type SourceInput_GetOrganizationSourcesLazyQueryHookResult = ReturnType<
	typeof useSourceInput_GetOrganizationSourcesLazyQuery
>;
export type SourceInput_GetOrganizationSourcesQueryResult = Apollo.QueryResult<
	SourceInput_GetOrganizationSourcesQuery,
	SourceInput_GetOrganizationSourcesQueryVariables
>;
export const SubscriptionTrialEnding_GetOrganizationWhereDocument = gql`
	query SubscriptionTrialEnding_GetOrganizationWhere(
		$where: OrganizationWhereUniqueInput!
	) {
		getOrganizationWhere(where: $where) {
			id
			subscription {
				id
				status
				subscriptionPlan {
					id
					type
					period
				}
			}
		}
	}
`;

/**
 * __useSubscriptionTrialEnding_GetOrganizationWhereQuery__
 *
 * To run a query within a React component, call `useSubscriptionTrialEnding_GetOrganizationWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionTrialEnding_GetOrganizationWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionTrialEnding_GetOrganizationWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscriptionTrialEnding_GetOrganizationWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		SubscriptionTrialEnding_GetOrganizationWhereQuery,
		SubscriptionTrialEnding_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SubscriptionTrialEnding_GetOrganizationWhereQuery,
		SubscriptionTrialEnding_GetOrganizationWhereQueryVariables
	>(SubscriptionTrialEnding_GetOrganizationWhereDocument, options);
}
export function useSubscriptionTrialEnding_GetOrganizationWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SubscriptionTrialEnding_GetOrganizationWhereQuery,
		SubscriptionTrialEnding_GetOrganizationWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SubscriptionTrialEnding_GetOrganizationWhereQuery,
		SubscriptionTrialEnding_GetOrganizationWhereQueryVariables
	>(SubscriptionTrialEnding_GetOrganizationWhereDocument, options);
}
export type SubscriptionTrialEnding_GetOrganizationWhereQueryHookResult =
	ReturnType<typeof useSubscriptionTrialEnding_GetOrganizationWhereQuery>;
export type SubscriptionTrialEnding_GetOrganizationWhereLazyQueryHookResult =
	ReturnType<typeof useSubscriptionTrialEnding_GetOrganizationWhereLazyQuery>;
export type SubscriptionTrialEnding_GetOrganizationWhereQueryResult =
	Apollo.QueryResult<
		SubscriptionTrialEnding_GetOrganizationWhereQuery,
		SubscriptionTrialEnding_GetOrganizationWhereQueryVariables
	>;
export const SubscriptionTrialEnding_GetEventsWhereDocument = gql`
	query SubscriptionTrialEnding_GetEventsWhere($where: EventWhereInput!) {
		getEventsWhere(where: $where) {
			id
			dismissingUsers {
				id
			}
		}
	}
`;

/**
 * __useSubscriptionTrialEnding_GetEventsWhereQuery__
 *
 * To run a query within a React component, call `useSubscriptionTrialEnding_GetEventsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionTrialEnding_GetEventsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionTrialEnding_GetEventsWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscriptionTrialEnding_GetEventsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		SubscriptionTrialEnding_GetEventsWhereQuery,
		SubscriptionTrialEnding_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SubscriptionTrialEnding_GetEventsWhereQuery,
		SubscriptionTrialEnding_GetEventsWhereQueryVariables
	>(SubscriptionTrialEnding_GetEventsWhereDocument, options);
}
export function useSubscriptionTrialEnding_GetEventsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SubscriptionTrialEnding_GetEventsWhereQuery,
		SubscriptionTrialEnding_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SubscriptionTrialEnding_GetEventsWhereQuery,
		SubscriptionTrialEnding_GetEventsWhereQueryVariables
	>(SubscriptionTrialEnding_GetEventsWhereDocument, options);
}
export type SubscriptionTrialEnding_GetEventsWhereQueryHookResult = ReturnType<
	typeof useSubscriptionTrialEnding_GetEventsWhereQuery
>;
export type SubscriptionTrialEnding_GetEventsWhereLazyQueryHookResult =
	ReturnType<typeof useSubscriptionTrialEnding_GetEventsWhereLazyQuery>;
export type SubscriptionTrialEnding_GetEventsWhereQueryResult =
	Apollo.QueryResult<
		SubscriptionTrialEnding_GetEventsWhereQuery,
		SubscriptionTrialEnding_GetEventsWhereQueryVariables
	>;
export const SubscriptionTrialEnding_DismissEventDocument = gql`
	mutation SubscriptionTrialEnding_DismissEvent(
		$where: EventWhereUniqueInput!
	) {
		dismissEvent(where: $where)
	}
`;
export type SubscriptionTrialEnding_DismissEventMutationFn =
	Apollo.MutationFunction<
		SubscriptionTrialEnding_DismissEventMutation,
		SubscriptionTrialEnding_DismissEventMutationVariables
	>;

/**
 * __useSubscriptionTrialEnding_DismissEventMutation__
 *
 * To run a mutation, you first call `useSubscriptionTrialEnding_DismissEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionTrialEnding_DismissEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionTrialEndingDismissEventMutation, { data, loading, error }] = useSubscriptionTrialEnding_DismissEventMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscriptionTrialEnding_DismissEventMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubscriptionTrialEnding_DismissEventMutation,
		SubscriptionTrialEnding_DismissEventMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SubscriptionTrialEnding_DismissEventMutation,
		SubscriptionTrialEnding_DismissEventMutationVariables
	>(SubscriptionTrialEnding_DismissEventDocument, options);
}
export type SubscriptionTrialEnding_DismissEventMutationHookResult = ReturnType<
	typeof useSubscriptionTrialEnding_DismissEventMutation
>;
export type SubscriptionTrialEnding_DismissEventMutationResult =
	Apollo.MutationResult<SubscriptionTrialEnding_DismissEventMutation>;
export type SubscriptionTrialEnding_DismissEventMutationOptions =
	Apollo.BaseMutationOptions<
		SubscriptionTrialEnding_DismissEventMutation,
		SubscriptionTrialEnding_DismissEventMutationVariables
	>;
export const SubscriptionTrialEnding_EventCreatedDocument = gql`
	subscription SubscriptionTrialEnding_EventCreated {
		eventCreated {
			id
			category
		}
	}
`;

/**
 * __useSubscriptionTrialEnding_EventCreatedSubscription__
 *
 * To run a query within a React component, call `useSubscriptionTrialEnding_EventCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionTrialEnding_EventCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionTrialEnding_EventCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionTrialEnding_EventCreatedSubscription(
	baseOptions?: Apollo.SubscriptionHookOptions<
		SubscriptionTrialEnding_EventCreatedSubscription,
		SubscriptionTrialEnding_EventCreatedSubscriptionVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		SubscriptionTrialEnding_EventCreatedSubscription,
		SubscriptionTrialEnding_EventCreatedSubscriptionVariables
	>(SubscriptionTrialEnding_EventCreatedDocument, options);
}
export type SubscriptionTrialEnding_EventCreatedSubscriptionHookResult =
	ReturnType<typeof useSubscriptionTrialEnding_EventCreatedSubscription>;
export type SubscriptionTrialEnding_EventCreatedSubscriptionResult =
	Apollo.SubscriptionResult<SubscriptionTrialEnding_EventCreatedSubscription>;
export const TermsOfService_GetGlobalVariablesDocument = gql`
	query TermsOfService_getGlobalVariables {
		getGlobalVariables {
			StripeLegalUrl
			TermsOfServiceUrl
		}
	}
`;

/**
 * __useTermsOfService_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useTermsOfService_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsOfService_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsOfService_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTermsOfService_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TermsOfService_GetGlobalVariablesQuery,
		TermsOfService_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TermsOfService_GetGlobalVariablesQuery,
		TermsOfService_GetGlobalVariablesQueryVariables
	>(TermsOfService_GetGlobalVariablesDocument, options);
}
export function useTermsOfService_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TermsOfService_GetGlobalVariablesQuery,
		TermsOfService_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TermsOfService_GetGlobalVariablesQuery,
		TermsOfService_GetGlobalVariablesQueryVariables
	>(TermsOfService_GetGlobalVariablesDocument, options);
}
export type TermsOfService_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useTermsOfService_GetGlobalVariablesQuery
>;
export type TermsOfService_GetGlobalVariablesLazyQueryHookResult = ReturnType<
	typeof useTermsOfService_GetGlobalVariablesLazyQuery
>;
export type TermsOfService_GetGlobalVariablesQueryResult = Apollo.QueryResult<
	TermsOfService_GetGlobalVariablesQuery,
	TermsOfService_GetGlobalVariablesQueryVariables
>;
export const UseVendorDashboard_GetDashboardStatsForOrgDocument = gql`
	query useVendorDashboard_getDashboardStatsForOrg(
		$where: DashboardWhereInput!
	) {
		getDashboardStatsForOrg(where: $where) {
			...useVendorDashboard_dashboardStatsForOrg
		}
	}
	${UseVendorDashboard_DashboardStatsForOrgFragmentDoc}
`;

/**
 * __useUseVendorDashboard_GetDashboardStatsForOrgQuery__
 *
 * To run a query within a React component, call `useUseVendorDashboard_GetDashboardStatsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseVendorDashboard_GetDashboardStatsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseVendorDashboard_GetDashboardStatsForOrgQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseVendorDashboard_GetDashboardStatsForOrgQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseVendorDashboard_GetDashboardStatsForOrgQuery,
		UseVendorDashboard_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseVendorDashboard_GetDashboardStatsForOrgQuery,
		UseVendorDashboard_GetDashboardStatsForOrgQueryVariables
	>(UseVendorDashboard_GetDashboardStatsForOrgDocument, options);
}
export function useUseVendorDashboard_GetDashboardStatsForOrgLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseVendorDashboard_GetDashboardStatsForOrgQuery,
		UseVendorDashboard_GetDashboardStatsForOrgQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseVendorDashboard_GetDashboardStatsForOrgQuery,
		UseVendorDashboard_GetDashboardStatsForOrgQueryVariables
	>(UseVendorDashboard_GetDashboardStatsForOrgDocument, options);
}
export type UseVendorDashboard_GetDashboardStatsForOrgQueryHookResult =
	ReturnType<typeof useUseVendorDashboard_GetDashboardStatsForOrgQuery>;
export type UseVendorDashboard_GetDashboardStatsForOrgLazyQueryHookResult =
	ReturnType<typeof useUseVendorDashboard_GetDashboardStatsForOrgLazyQuery>;
export type UseVendorDashboard_GetDashboardStatsForOrgQueryResult =
	Apollo.QueryResult<
		UseVendorDashboard_GetDashboardStatsForOrgQuery,
		UseVendorDashboard_GetDashboardStatsForOrgQueryVariables
	>;
export const VendorDashboardConfiguration_GetOrgUserWhereDocument = gql`
	query VendorDashboardConfiguration_GetOrgUserWhere(
		$where: OrgUserWhereUniqueInput!
	) {
		getOrgUserWhere(where: $where) {
			id
			user {
				id
				vendorDashboardConfigurationItems {
					id
					order
					enabled
					type
				}
			}
		}
	}
`;

/**
 * __useVendorDashboardConfiguration_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useVendorDashboardConfiguration_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorDashboardConfiguration_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorDashboardConfiguration_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVendorDashboardConfiguration_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		VendorDashboardConfiguration_GetOrgUserWhereQuery,
		VendorDashboardConfiguration_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		VendorDashboardConfiguration_GetOrgUserWhereQuery,
		VendorDashboardConfiguration_GetOrgUserWhereQueryVariables
	>(VendorDashboardConfiguration_GetOrgUserWhereDocument, options);
}
export function useVendorDashboardConfiguration_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		VendorDashboardConfiguration_GetOrgUserWhereQuery,
		VendorDashboardConfiguration_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		VendorDashboardConfiguration_GetOrgUserWhereQuery,
		VendorDashboardConfiguration_GetOrgUserWhereQueryVariables
	>(VendorDashboardConfiguration_GetOrgUserWhereDocument, options);
}
export type VendorDashboardConfiguration_GetOrgUserWhereQueryHookResult =
	ReturnType<typeof useVendorDashboardConfiguration_GetOrgUserWhereQuery>;
export type VendorDashboardConfiguration_GetOrgUserWhereLazyQueryHookResult =
	ReturnType<typeof useVendorDashboardConfiguration_GetOrgUserWhereLazyQuery>;
export type VendorDashboardConfiguration_GetOrgUserWhereQueryResult =
	Apollo.QueryResult<
		VendorDashboardConfiguration_GetOrgUserWhereQuery,
		VendorDashboardConfiguration_GetOrgUserWhereQueryVariables
	>;
export const DashboardConfiguration_UpdateVendorDashboardConfigurationDocument = gql`
	mutation DashboardConfiguration_UpdateVendorDashboardConfiguration(
		$data: VendorDashboardConfigurationInput!
	) {
		updateVendorDashboardConfiguration(data: $data) {
			...useDashboardConfigurationUser
		}
	}
	${UseDashboardConfigurationUserFragmentDoc}
`;
export type DashboardConfiguration_UpdateVendorDashboardConfigurationMutationFn =
	Apollo.MutationFunction<
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutation,
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutationVariables
	>;

/**
 * __useDashboardConfiguration_UpdateVendorDashboardConfigurationMutation__
 *
 * To run a mutation, you first call `useDashboardConfiguration_UpdateVendorDashboardConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDashboardConfiguration_UpdateVendorDashboardConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dashboardConfigurationUpdateVendorDashboardConfigurationMutation, { data, loading, error }] = useDashboardConfiguration_UpdateVendorDashboardConfigurationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDashboardConfiguration_UpdateVendorDashboardConfigurationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutation,
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutation,
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutationVariables
	>(DashboardConfiguration_UpdateVendorDashboardConfigurationDocument, options);
}
export type DashboardConfiguration_UpdateVendorDashboardConfigurationMutationHookResult =
	ReturnType<
		typeof useDashboardConfiguration_UpdateVendorDashboardConfigurationMutation
	>;
export type DashboardConfiguration_UpdateVendorDashboardConfigurationMutationResult =
	Apollo.MutationResult<DashboardConfiguration_UpdateVendorDashboardConfigurationMutation>;
export type DashboardConfiguration_UpdateVendorDashboardConfigurationMutationOptions =
	Apollo.BaseMutationOptions<
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutation,
		DashboardConfiguration_UpdateVendorDashboardConfigurationMutationVariables
	>;
export const InvitationSubMenu_DeleteInvitationDocument = gql`
	mutation InvitationSubMenu_deleteInvitation(
		$where: InvitationWhereCustomInput!
	) {
		deleteInvitation(where: $where) {
			_count
			pendingInvitations {
				...invitationSubMenuInvitation
			}
		}
	}
	${InvitationSubMenuInvitationFragmentDoc}
`;
export type InvitationSubMenu_DeleteInvitationMutationFn =
	Apollo.MutationFunction<
		InvitationSubMenu_DeleteInvitationMutation,
		InvitationSubMenu_DeleteInvitationMutationVariables
	>;

/**
 * __useInvitationSubMenu_DeleteInvitationMutation__
 *
 * To run a mutation, you first call `useInvitationSubMenu_DeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationSubMenu_DeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationSubMenuDeleteInvitationMutation, { data, loading, error }] = useInvitationSubMenu_DeleteInvitationMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvitationSubMenu_DeleteInvitationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InvitationSubMenu_DeleteInvitationMutation,
		InvitationSubMenu_DeleteInvitationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InvitationSubMenu_DeleteInvitationMutation,
		InvitationSubMenu_DeleteInvitationMutationVariables
	>(InvitationSubMenu_DeleteInvitationDocument, options);
}
export type InvitationSubMenu_DeleteInvitationMutationHookResult = ReturnType<
	typeof useInvitationSubMenu_DeleteInvitationMutation
>;
export type InvitationSubMenu_DeleteInvitationMutationResult =
	Apollo.MutationResult<InvitationSubMenu_DeleteInvitationMutation>;
export type InvitationSubMenu_DeleteInvitationMutationOptions =
	Apollo.BaseMutationOptions<
		InvitationSubMenu_DeleteInvitationMutation,
		InvitationSubMenu_DeleteInvitationMutationVariables
	>;
export const VendorsTable_GetContactsWhereDocument = gql`
	query VendorsTable_getContactsWhere(
		$orderBy: [ContactOrderByInput]
		$skip: Int
		$take: Int
		$where: ContactWhereInput!
	) {
		getContactsWhere(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
		) {
			_count
			contacts {
				...useVendorsTableContact
			}
		}
	}
	${UseVendorsTableContactFragmentDoc}
`;

/**
 * __useVendorsTable_GetContactsWhereQuery__
 *
 * To run a query within a React component, call `useVendorsTable_GetContactsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsTable_GetContactsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsTable_GetContactsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVendorsTable_GetContactsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		VendorsTable_GetContactsWhereQuery,
		VendorsTable_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		VendorsTable_GetContactsWhereQuery,
		VendorsTable_GetContactsWhereQueryVariables
	>(VendorsTable_GetContactsWhereDocument, options);
}
export function useVendorsTable_GetContactsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		VendorsTable_GetContactsWhereQuery,
		VendorsTable_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		VendorsTable_GetContactsWhereQuery,
		VendorsTable_GetContactsWhereQueryVariables
	>(VendorsTable_GetContactsWhereDocument, options);
}
export type VendorsTable_GetContactsWhereQueryHookResult = ReturnType<
	typeof useVendorsTable_GetContactsWhereQuery
>;
export type VendorsTable_GetContactsWhereLazyQueryHookResult = ReturnType<
	typeof useVendorsTable_GetContactsWhereLazyQuery
>;
export type VendorsTable_GetContactsWhereQueryResult = Apollo.QueryResult<
	VendorsTable_GetContactsWhereQuery,
	VendorsTable_GetContactsWhereQueryVariables
>;
export const VendorsTable_ActivateContactDocument = gql`
	mutation VendorsTable_activateContact(
		$where: ContactWhereUniqueInput!
		$data: ActivateContactCustomInput
	) {
		activateContact(where: $where, data: $data) {
			...useVendorsTableContact
		}
	}
	${UseVendorsTableContactFragmentDoc}
`;
export type VendorsTable_ActivateContactMutationFn = Apollo.MutationFunction<
	VendorsTable_ActivateContactMutation,
	VendorsTable_ActivateContactMutationVariables
>;

/**
 * __useVendorsTable_ActivateContactMutation__
 *
 * To run a mutation, you first call `useVendorsTable_ActivateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorsTable_ActivateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorsTableActivateContactMutation, { data, loading, error }] = useVendorsTable_ActivateContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVendorsTable_ActivateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VendorsTable_ActivateContactMutation,
		VendorsTable_ActivateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VendorsTable_ActivateContactMutation,
		VendorsTable_ActivateContactMutationVariables
	>(VendorsTable_ActivateContactDocument, options);
}
export type VendorsTable_ActivateContactMutationHookResult = ReturnType<
	typeof useVendorsTable_ActivateContactMutation
>;
export type VendorsTable_ActivateContactMutationResult =
	Apollo.MutationResult<VendorsTable_ActivateContactMutation>;
export type VendorsTable_ActivateContactMutationOptions =
	Apollo.BaseMutationOptions<
		VendorsTable_ActivateContactMutation,
		VendorsTable_ActivateContactMutationVariables
	>;
export const VendorsTable_GetPendingInvitationsDocument = gql`
	query VendorsTable_getPendingInvitations(
		$where: InvitationsWhereCustomInput!
		$take: Int
		$skip: Int
	) {
		getPendingInvitations(where: $where, take: $take, skip: $skip) {
			_count
			pendingInvitations {
				...useVendorsTableInvitation
			}
		}
	}
	${UseVendorsTableInvitationFragmentDoc}
`;

/**
 * __useVendorsTable_GetPendingInvitationsQuery__
 *
 * To run a query within a React component, call `useVendorsTable_GetPendingInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsTable_GetPendingInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsTable_GetPendingInvitationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useVendorsTable_GetPendingInvitationsQuery(
	baseOptions: Apollo.QueryHookOptions<
		VendorsTable_GetPendingInvitationsQuery,
		VendorsTable_GetPendingInvitationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		VendorsTable_GetPendingInvitationsQuery,
		VendorsTable_GetPendingInvitationsQueryVariables
	>(VendorsTable_GetPendingInvitationsDocument, options);
}
export function useVendorsTable_GetPendingInvitationsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		VendorsTable_GetPendingInvitationsQuery,
		VendorsTable_GetPendingInvitationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		VendorsTable_GetPendingInvitationsQuery,
		VendorsTable_GetPendingInvitationsQueryVariables
	>(VendorsTable_GetPendingInvitationsDocument, options);
}
export type VendorsTable_GetPendingInvitationsQueryHookResult = ReturnType<
	typeof useVendorsTable_GetPendingInvitationsQuery
>;
export type VendorsTable_GetPendingInvitationsLazyQueryHookResult = ReturnType<
	typeof useVendorsTable_GetPendingInvitationsLazyQuery
>;
export type VendorsTable_GetPendingInvitationsQueryResult = Apollo.QueryResult<
	VendorsTable_GetPendingInvitationsQuery,
	VendorsTable_GetPendingInvitationsQueryVariables
>;
export const PaymentMethodHistoryTable_GetHistoryForPaymentMethodDocument = gql`
	query paymentMethodHistoryTable_getHistoryForPaymentMethod(
		$where: PaymentMethodWhereInput!
		$take: Int
		$cursor: String
	) {
		getHistoryForPaymentMethod(where: $where, take: $take, cursor: $cursor) {
			data {
				...paymentMethodHistoryTable_history
			}
			hasMore
			nextCursor
		}
	}
	${PaymentMethodHistoryTable_HistoryFragmentDoc}
`;

/**
 * __usePaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery__
 *
 * To run a query within a React component, call `usePaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery(
	baseOptions: Apollo.QueryHookOptions<
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery,
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery,
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryVariables
	>(PaymentMethodHistoryTable_GetHistoryForPaymentMethodDocument, options);
}
export function usePaymentMethodHistoryTable_GetHistoryForPaymentMethodLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery,
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery,
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryVariables
	>(PaymentMethodHistoryTable_GetHistoryForPaymentMethodDocument, options);
}
export type PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryHookResult =
	ReturnType<
		typeof usePaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery
	>;
export type PaymentMethodHistoryTable_GetHistoryForPaymentMethodLazyQueryHookResult =
	ReturnType<
		typeof usePaymentMethodHistoryTable_GetHistoryForPaymentMethodLazyQuery
	>;
export type PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryResult =
	Apollo.QueryResult<
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQuery,
		PaymentMethodHistoryTable_GetHistoryForPaymentMethodQueryVariables
	>;
export const PaymentAccounts_GetPaymentSourcesForCustomerDocument = gql`
	query paymentAccounts_getPaymentSourcesForCustomer(
		$where: UserByIdUniqueInput!
		$cursor: PaginationCursor
		$take: Int
	) {
		getPaymentSourcesForCustomer(where: $where, cursor: $cursor, take: $take) {
			data {
				...getPaymentSourcesForCustomerSource
			}
			default_source
			has_more
		}
	}
	${GetPaymentSourcesForCustomerSourceFragmentDoc}
`;

/**
 * __usePaymentAccounts_GetPaymentSourcesForCustomerQuery__
 *
 * To run a query within a React component, call `usePaymentAccounts_GetPaymentSourcesForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAccounts_GetPaymentSourcesForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAccounts_GetPaymentSourcesForCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePaymentAccounts_GetPaymentSourcesForCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		PaymentAccounts_GetPaymentSourcesForCustomerQuery,
		PaymentAccounts_GetPaymentSourcesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PaymentAccounts_GetPaymentSourcesForCustomerQuery,
		PaymentAccounts_GetPaymentSourcesForCustomerQueryVariables
	>(PaymentAccounts_GetPaymentSourcesForCustomerDocument, options);
}
export function usePaymentAccounts_GetPaymentSourcesForCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PaymentAccounts_GetPaymentSourcesForCustomerQuery,
		PaymentAccounts_GetPaymentSourcesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PaymentAccounts_GetPaymentSourcesForCustomerQuery,
		PaymentAccounts_GetPaymentSourcesForCustomerQueryVariables
	>(PaymentAccounts_GetPaymentSourcesForCustomerDocument, options);
}
export type PaymentAccounts_GetPaymentSourcesForCustomerQueryHookResult =
	ReturnType<typeof usePaymentAccounts_GetPaymentSourcesForCustomerQuery>;
export type PaymentAccounts_GetPaymentSourcesForCustomerLazyQueryHookResult =
	ReturnType<typeof usePaymentAccounts_GetPaymentSourcesForCustomerLazyQuery>;
export type PaymentAccounts_GetPaymentSourcesForCustomerQueryResult =
	Apollo.QueryResult<
		PaymentAccounts_GetPaymentSourcesForCustomerQuery,
		PaymentAccounts_GetPaymentSourcesForCustomerQueryVariables
	>;
export const ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryDocument = gql`
	query exportTransactionHistoryForm_exportCustomerOfflineTransactionHistory(
		$where: UserWhereUniqueInput!
		$data: ExportHistoryInput!
	) {
		exportCustomerOfflineTransactionHistory(where: $where, data: $data) {
			url
		}
	}
`;

/**
 * __useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryVariables
	>(
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryDocument,
		options
	);
}
export function useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryVariables
	>(
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryDocument,
		options
	);
}
export type ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery
	>;
export type ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryLazyQuery
	>;
export type ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryResult =
	Apollo.QueryResult<
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerOfflineTransactionHistoryQueryVariables
	>;
export const ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryDocument = gql`
	query exportTransactionHistoryForm_exportOrgOfflineTransactionHistory(
		$where: OrganizationWhereUniqueInput!
		$data: ExportHistoryInput!
	) {
		exportOrgOfflineTransactionHistory(where: $where, data: $data) {
			url
		}
	}
`;

/**
 * __useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryVariables
	>(
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryDocument,
		options
	);
}
export function useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryVariables
	>(
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryDocument,
		options
	);
}
export type ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery
	>;
export type ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryLazyQuery
	>;
export type ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryResult =
	Apollo.QueryResult<
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgOfflineTransactionHistoryQueryVariables
	>;
export const ExportTransactionHistoryForm_ExportCustomerTransactionHistoryDocument = gql`
	query exportTransactionHistoryForm_exportCustomerTransactionHistory(
		$where: UserByIdUniqueInput!
		$data: ExportHistoryInput!
	) {
		exportCustomerTransactionHistory(where: $where, data: $data) {
			url
		}
	}
`;

/**
 * __useExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryVariables
	>(
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryDocument,
		options
	);
}
export function useExportTransactionHistoryForm_ExportCustomerTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryVariables
	>(
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryDocument,
		options
	);
}
export type ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery
	>;
export type ExportTransactionHistoryForm_ExportCustomerTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportCustomerTransactionHistoryLazyQuery
	>;
export type ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryResult =
	Apollo.QueryResult<
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportCustomerTransactionHistoryQueryVariables
	>;
export const ExportTransactionHistoryForm_ExportOrgTransactionHistoryDocument = gql`
	query exportTransactionHistoryForm_exportOrgTransactionHistory(
		$where: OrganizationWhereUniqueInput!
		$data: ExportHistoryInput!
	) {
		exportOrgTransactionHistory(where: $where, data: $data)
	}
`;

/**
 * __useExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryVariables
	>(ExportTransactionHistoryForm_ExportOrgTransactionHistoryDocument, options);
}
export function useExportTransactionHistoryForm_ExportOrgTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryVariables
	>(ExportTransactionHistoryForm_ExportOrgTransactionHistoryDocument, options);
}
export type ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery
	>;
export type ExportTransactionHistoryForm_ExportOrgTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useExportTransactionHistoryForm_ExportOrgTransactionHistoryLazyQuery
	>;
export type ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryResult =
	Apollo.QueryResult<
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQuery,
		ExportTransactionHistoryForm_ExportOrgTransactionHistoryQueryVariables
	>;
export const OfflineTransactions_GetCustomerOfflineTransactionHistoryDocument = gql`
	query offlineTransactions_getCustomerOfflineTransactionHistory(
		$where: UserWhereUniqueInput!
		$after: OfflinePaymentHistoryAfterInput
		$take: Int
	) {
		getCustomerOfflineTransactionHistory(
			where: $where
			after: $after
			take: $take
		) {
			offlinePaymentHistoryItems {
				...OfflinePaymentHistoryItem
			}
		}
	}
	${OfflinePaymentHistoryItemFragmentDoc}
`;

/**
 * __useOfflineTransactions_GetCustomerOfflineTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useOfflineTransactions_GetCustomerOfflineTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfflineTransactions_GetCustomerOfflineTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfflineTransactions_GetCustomerOfflineTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useOfflineTransactions_GetCustomerOfflineTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQuery,
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQuery,
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryVariables
	>(OfflineTransactions_GetCustomerOfflineTransactionHistoryDocument, options);
}
export function useOfflineTransactions_GetCustomerOfflineTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQuery,
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQuery,
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryVariables
	>(OfflineTransactions_GetCustomerOfflineTransactionHistoryDocument, options);
}
export type OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryHookResult =
	ReturnType<
		typeof useOfflineTransactions_GetCustomerOfflineTransactionHistoryQuery
	>;
export type OfflineTransactions_GetCustomerOfflineTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useOfflineTransactions_GetCustomerOfflineTransactionHistoryLazyQuery
	>;
export type OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryResult =
	Apollo.QueryResult<
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQuery,
		OfflineTransactions_GetCustomerOfflineTransactionHistoryQueryVariables
	>;
export const OfflineTransactions_GetOrgOfflineTransactionHistoryDocument = gql`
	query offlineTransactions_getOrgOfflineTransactionHistory(
		$where: OrganizationWhereUniqueInput!
		$after: OfflinePaymentHistoryAfterInput
		$take: Int
	) {
		getOrgOfflineTransactionHistory(where: $where, after: $after, take: $take) {
			offlinePaymentHistoryItems {
				...OfflinePaymentHistoryItem
			}
		}
	}
	${OfflinePaymentHistoryItemFragmentDoc}
`;

/**
 * __useOfflineTransactions_GetOrgOfflineTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useOfflineTransactions_GetOrgOfflineTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfflineTransactions_GetOrgOfflineTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfflineTransactions_GetOrgOfflineTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      after: // value for 'after'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useOfflineTransactions_GetOrgOfflineTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		OfflineTransactions_GetOrgOfflineTransactionHistoryQuery,
		OfflineTransactions_GetOrgOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OfflineTransactions_GetOrgOfflineTransactionHistoryQuery,
		OfflineTransactions_GetOrgOfflineTransactionHistoryQueryVariables
	>(OfflineTransactions_GetOrgOfflineTransactionHistoryDocument, options);
}
export function useOfflineTransactions_GetOrgOfflineTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OfflineTransactions_GetOrgOfflineTransactionHistoryQuery,
		OfflineTransactions_GetOrgOfflineTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OfflineTransactions_GetOrgOfflineTransactionHistoryQuery,
		OfflineTransactions_GetOrgOfflineTransactionHistoryQueryVariables
	>(OfflineTransactions_GetOrgOfflineTransactionHistoryDocument, options);
}
export type OfflineTransactions_GetOrgOfflineTransactionHistoryQueryHookResult =
	ReturnType<
		typeof useOfflineTransactions_GetOrgOfflineTransactionHistoryQuery
	>;
export type OfflineTransactions_GetOrgOfflineTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useOfflineTransactions_GetOrgOfflineTransactionHistoryLazyQuery
	>;
export type OfflineTransactions_GetOrgOfflineTransactionHistoryQueryResult =
	Apollo.QueryResult<
		OfflineTransactions_GetOrgOfflineTransactionHistoryQuery,
		OfflineTransactions_GetOrgOfflineTransactionHistoryQueryVariables
	>;
export const ChargeAccount_GetPaymentMethodsForVendorCustomerDocument = gql`
	query ChargeAccount_getPaymentMethodsForVendorCustomer(
		$where: OrganizationWhereUniqueInput!
	) {
		getPaymentMethodsForVendorCustomer(where: $where) {
			data {
				...chargeAccountSource
			}
		}
	}
	${ChargeAccountSourceFragmentDoc}
`;

/**
 * __useChargeAccount_GetPaymentMethodsForVendorCustomerQuery__
 *
 * To run a query within a React component, call `useChargeAccount_GetPaymentMethodsForVendorCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeAccount_GetPaymentMethodsForVendorCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeAccount_GetPaymentMethodsForVendorCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useChargeAccount_GetPaymentMethodsForVendorCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		ChargeAccount_GetPaymentMethodsForVendorCustomerQuery,
		ChargeAccount_GetPaymentMethodsForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ChargeAccount_GetPaymentMethodsForVendorCustomerQuery,
		ChargeAccount_GetPaymentMethodsForVendorCustomerQueryVariables
	>(ChargeAccount_GetPaymentMethodsForVendorCustomerDocument, options);
}
export function useChargeAccount_GetPaymentMethodsForVendorCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ChargeAccount_GetPaymentMethodsForVendorCustomerQuery,
		ChargeAccount_GetPaymentMethodsForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ChargeAccount_GetPaymentMethodsForVendorCustomerQuery,
		ChargeAccount_GetPaymentMethodsForVendorCustomerQueryVariables
	>(ChargeAccount_GetPaymentMethodsForVendorCustomerDocument, options);
}
export type ChargeAccount_GetPaymentMethodsForVendorCustomerQueryHookResult =
	ReturnType<typeof useChargeAccount_GetPaymentMethodsForVendorCustomerQuery>;
export type ChargeAccount_GetPaymentMethodsForVendorCustomerLazyQueryHookResult =
	ReturnType<
		typeof useChargeAccount_GetPaymentMethodsForVendorCustomerLazyQuery
	>;
export type ChargeAccount_GetPaymentMethodsForVendorCustomerQueryResult =
	Apollo.QueryResult<
		ChargeAccount_GetPaymentMethodsForVendorCustomerQuery,
		ChargeAccount_GetPaymentMethodsForVendorCustomerQueryVariables
	>;
export const PayTo_GetStripeConnectAccountDocument = gql`
	query payTo_getStripeConnectAccount($where: OrganizationWhereUniqueInput!) {
		getStripeConnectAccount(where: $where) {
			external_accounts {
				data {
					...sourceForVendorPayTo
					...walletDrawerSource
				}
			}
		}
	}
	${SourceForVendorPayToFragmentDoc}
	${WalletDrawerSourceFragmentDoc}
`;

/**
 * __usePayTo_GetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `usePayTo_GetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayTo_GetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayTo_GetStripeConnectAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePayTo_GetStripeConnectAccountQuery(
	baseOptions: Apollo.QueryHookOptions<
		PayTo_GetStripeConnectAccountQuery,
		PayTo_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PayTo_GetStripeConnectAccountQuery,
		PayTo_GetStripeConnectAccountQueryVariables
	>(PayTo_GetStripeConnectAccountDocument, options);
}
export function usePayTo_GetStripeConnectAccountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PayTo_GetStripeConnectAccountQuery,
		PayTo_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PayTo_GetStripeConnectAccountQuery,
		PayTo_GetStripeConnectAccountQueryVariables
	>(PayTo_GetStripeConnectAccountDocument, options);
}
export type PayTo_GetStripeConnectAccountQueryHookResult = ReturnType<
	typeof usePayTo_GetStripeConnectAccountQuery
>;
export type PayTo_GetStripeConnectAccountLazyQueryHookResult = ReturnType<
	typeof usePayTo_GetStripeConnectAccountLazyQuery
>;
export type PayTo_GetStripeConnectAccountQueryResult = Apollo.QueryResult<
	PayTo_GetStripeConnectAccountQuery,
	PayTo_GetStripeConnectAccountQueryVariables
>;
export const QuickPaymentsExportModal_ExportWalletQuickPaymentsDocument = gql`
	query QuickPaymentsExportModal_exportWalletQuickPayments(
		$where: ExportWalletQuickPaymentsWhereInput!
		$data: ExportWalletQuickPaymentsDataInput!
	) {
		exportWalletQuickPayments(where: $where, data: $data)
	}
`;

/**
 * __useQuickPaymentsExportModal_ExportWalletQuickPaymentsQuery__
 *
 * To run a query within a React component, call `useQuickPaymentsExportModal_ExportWalletQuickPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickPaymentsExportModal_ExportWalletQuickPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickPaymentsExportModal_ExportWalletQuickPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useQuickPaymentsExportModal_ExportWalletQuickPaymentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQuery,
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQuery,
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryVariables
	>(QuickPaymentsExportModal_ExportWalletQuickPaymentsDocument, options);
}
export function useQuickPaymentsExportModal_ExportWalletQuickPaymentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQuery,
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQuery,
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryVariables
	>(QuickPaymentsExportModal_ExportWalletQuickPaymentsDocument, options);
}
export type QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryHookResult =
	ReturnType<typeof useQuickPaymentsExportModal_ExportWalletQuickPaymentsQuery>;
export type QuickPaymentsExportModal_ExportWalletQuickPaymentsLazyQueryHookResult =
	ReturnType<
		typeof useQuickPaymentsExportModal_ExportWalletQuickPaymentsLazyQuery
	>;
export type QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryResult =
	Apollo.QueryResult<
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQuery,
		QuickPaymentsExportModal_ExportWalletQuickPaymentsQueryVariables
	>;
export const QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentDocument = gql`
	mutation QuickPaymentsTableEllipsisMenu_DeleteQuickPayment(
		$where: QuickPaymentWhereUniqueInput!
	) {
		deleteQuickPayment(where: $where) {
			id
		}
	}
`;
export type QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationFn =
	Apollo.MutationFunction<
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation,
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationVariables
	>;

/**
 * __useQuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation__
 *
 * To run a mutation, you first call `useQuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quickPaymentsTableEllipsisMenuDeleteQuickPaymentMutation, { data, loading, error }] = useQuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation,
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation,
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationVariables
	>(QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentDocument, options);
}
export type QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationHookResult =
	ReturnType<
		typeof useQuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation
	>;
export type QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationResult =
	Apollo.MutationResult<QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation>;
export type QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationOptions =
	Apollo.BaseMutationOptions<
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutation,
		QuickPaymentsTableEllipsisMenu_DeleteQuickPaymentMutationVariables
	>;
export const QuickPaymentsTableInvoices_ExportInvoiceDocument = gql`
	query QuickPaymentsTableInvoices_exportInvoice(
		$where: InvoiceWhereUniqueInput!
	) {
		exportInvoice(where: $where) {
			url
		}
	}
`;

/**
 * __useQuickPaymentsTableInvoices_ExportInvoiceQuery__
 *
 * To run a query within a React component, call `useQuickPaymentsTableInvoices_ExportInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickPaymentsTableInvoices_ExportInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickPaymentsTableInvoices_ExportInvoiceQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuickPaymentsTableInvoices_ExportInvoiceQuery(
	baseOptions: Apollo.QueryHookOptions<
		QuickPaymentsTableInvoices_ExportInvoiceQuery,
		QuickPaymentsTableInvoices_ExportInvoiceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		QuickPaymentsTableInvoices_ExportInvoiceQuery,
		QuickPaymentsTableInvoices_ExportInvoiceQueryVariables
	>(QuickPaymentsTableInvoices_ExportInvoiceDocument, options);
}
export function useQuickPaymentsTableInvoices_ExportInvoiceLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		QuickPaymentsTableInvoices_ExportInvoiceQuery,
		QuickPaymentsTableInvoices_ExportInvoiceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		QuickPaymentsTableInvoices_ExportInvoiceQuery,
		QuickPaymentsTableInvoices_ExportInvoiceQueryVariables
	>(QuickPaymentsTableInvoices_ExportInvoiceDocument, options);
}
export type QuickPaymentsTableInvoices_ExportInvoiceQueryHookResult =
	ReturnType<typeof useQuickPaymentsTableInvoices_ExportInvoiceQuery>;
export type QuickPaymentsTableInvoices_ExportInvoiceLazyQueryHookResult =
	ReturnType<typeof useQuickPaymentsTableInvoices_ExportInvoiceLazyQuery>;
export type QuickPaymentsTableInvoices_ExportInvoiceQueryResult =
	Apollo.QueryResult<
		QuickPaymentsTableInvoices_ExportInvoiceQuery,
		QuickPaymentsTableInvoices_ExportInvoiceQueryVariables
	>;
export const WalletQuickPayments_GetGlobalVariablesDocument = gql`
	query WalletQuickPayments_getGlobalVariables {
		getGlobalVariables {
			QuickPaySupportUrl
		}
	}
`;

/**
 * __useWalletQuickPayments_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useWalletQuickPayments_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletQuickPayments_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletQuickPayments_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletQuickPayments_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		WalletQuickPayments_GetGlobalVariablesQuery,
		WalletQuickPayments_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		WalletQuickPayments_GetGlobalVariablesQuery,
		WalletQuickPayments_GetGlobalVariablesQueryVariables
	>(WalletQuickPayments_GetGlobalVariablesDocument, options);
}
export function useWalletQuickPayments_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		WalletQuickPayments_GetGlobalVariablesQuery,
		WalletQuickPayments_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		WalletQuickPayments_GetGlobalVariablesQuery,
		WalletQuickPayments_GetGlobalVariablesQueryVariables
	>(WalletQuickPayments_GetGlobalVariablesDocument, options);
}
export type WalletQuickPayments_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useWalletQuickPayments_GetGlobalVariablesQuery
>;
export type WalletQuickPayments_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useWalletQuickPayments_GetGlobalVariablesLazyQuery>;
export type WalletQuickPayments_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		WalletQuickPayments_GetGlobalVariablesQuery,
		WalletQuickPayments_GetGlobalVariablesQueryVariables
	>;
export const WalletQuickPayments_GetStripeConnectAccountDocument = gql`
	query WalletQuickPayments_getStripeConnectAccount(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripeConnectAccount(where: $where) {
			external_accounts {
				data {
					id
				}
			}
		}
	}
`;

/**
 * __useWalletQuickPayments_GetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `useWalletQuickPayments_GetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletQuickPayments_GetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletQuickPayments_GetStripeConnectAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWalletQuickPayments_GetStripeConnectAccountQuery(
	baseOptions: Apollo.QueryHookOptions<
		WalletQuickPayments_GetStripeConnectAccountQuery,
		WalletQuickPayments_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		WalletQuickPayments_GetStripeConnectAccountQuery,
		WalletQuickPayments_GetStripeConnectAccountQueryVariables
	>(WalletQuickPayments_GetStripeConnectAccountDocument, options);
}
export function useWalletQuickPayments_GetStripeConnectAccountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		WalletQuickPayments_GetStripeConnectAccountQuery,
		WalletQuickPayments_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		WalletQuickPayments_GetStripeConnectAccountQuery,
		WalletQuickPayments_GetStripeConnectAccountQueryVariables
	>(WalletQuickPayments_GetStripeConnectAccountDocument, options);
}
export type WalletQuickPayments_GetStripeConnectAccountQueryHookResult =
	ReturnType<typeof useWalletQuickPayments_GetStripeConnectAccountQuery>;
export type WalletQuickPayments_GetStripeConnectAccountLazyQueryHookResult =
	ReturnType<typeof useWalletQuickPayments_GetStripeConnectAccountLazyQuery>;
export type WalletQuickPayments_GetStripeConnectAccountQueryResult =
	Apollo.QueryResult<
		WalletQuickPayments_GetStripeConnectAccountQuery,
		WalletQuickPayments_GetStripeConnectAccountQueryVariables
	>;
export const QuickPayments_GetWalletQuickPaymentsDocument = gql`
	query QuickPayments_getWalletQuickPayments(
		$skip: Int
		$take: Int
		$orderBy: [WalletQuickPaymentOrderByInput!]
	) {
		getWalletQuickPayments(skip: $skip, take: $take, orderBy: $orderBy) {
			...quickPaymentsTableWalletQuickPayment
		}
	}
	${QuickPaymentsTableWalletQuickPaymentFragmentDoc}
`;

/**
 * __useQuickPayments_GetWalletQuickPaymentsQuery__
 *
 * To run a query within a React component, call `useQuickPayments_GetWalletQuickPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickPayments_GetWalletQuickPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickPayments_GetWalletQuickPaymentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQuickPayments_GetWalletQuickPaymentsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		QuickPayments_GetWalletQuickPaymentsQuery,
		QuickPayments_GetWalletQuickPaymentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		QuickPayments_GetWalletQuickPaymentsQuery,
		QuickPayments_GetWalletQuickPaymentsQueryVariables
	>(QuickPayments_GetWalletQuickPaymentsDocument, options);
}
export function useQuickPayments_GetWalletQuickPaymentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		QuickPayments_GetWalletQuickPaymentsQuery,
		QuickPayments_GetWalletQuickPaymentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		QuickPayments_GetWalletQuickPaymentsQuery,
		QuickPayments_GetWalletQuickPaymentsQueryVariables
	>(QuickPayments_GetWalletQuickPaymentsDocument, options);
}
export type QuickPayments_GetWalletQuickPaymentsQueryHookResult = ReturnType<
	typeof useQuickPayments_GetWalletQuickPaymentsQuery
>;
export type QuickPayments_GetWalletQuickPaymentsLazyQueryHookResult =
	ReturnType<typeof useQuickPayments_GetWalletQuickPaymentsLazyQuery>;
export type QuickPayments_GetWalletQuickPaymentsQueryResult =
	Apollo.QueryResult<
		QuickPayments_GetWalletQuickPaymentsQuery,
		QuickPayments_GetWalletQuickPaymentsQueryVariables
	>;
export const QuickbooksContent_GetGlobalVariablesDocument = gql`
	query QuickbooksContent_getGlobalVariables {
		getGlobalVariables {
			QuickBooksHelpUrl
		}
	}
`;

/**
 * __useQuickbooksContent_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useQuickbooksContent_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbooksContent_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbooksContent_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuickbooksContent_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		QuickbooksContent_GetGlobalVariablesQuery,
		QuickbooksContent_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		QuickbooksContent_GetGlobalVariablesQuery,
		QuickbooksContent_GetGlobalVariablesQueryVariables
	>(QuickbooksContent_GetGlobalVariablesDocument, options);
}
export function useQuickbooksContent_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		QuickbooksContent_GetGlobalVariablesQuery,
		QuickbooksContent_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		QuickbooksContent_GetGlobalVariablesQuery,
		QuickbooksContent_GetGlobalVariablesQueryVariables
	>(QuickbooksContent_GetGlobalVariablesDocument, options);
}
export type QuickbooksContent_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useQuickbooksContent_GetGlobalVariablesQuery
>;
export type QuickbooksContent_GetGlobalVariablesLazyQueryHookResult =
	ReturnType<typeof useQuickbooksContent_GetGlobalVariablesLazyQuery>;
export type QuickbooksContent_GetGlobalVariablesQueryResult =
	Apollo.QueryResult<
		QuickbooksContent_GetGlobalVariablesQuery,
		QuickbooksContent_GetGlobalVariablesQueryVariables
	>;
export const Quickbooks_GetStripeConnectAccountDocument = gql`
	query quickbooks_getStripeConnectAccount(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripeConnectAccount(where: $where) {
			external_accounts {
				data {
					id
				}
			}
		}
	}
`;

/**
 * __useQuickbooks_GetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `useQuickbooks_GetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbooks_GetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbooks_GetStripeConnectAccountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuickbooks_GetStripeConnectAccountQuery(
	baseOptions: Apollo.QueryHookOptions<
		Quickbooks_GetStripeConnectAccountQuery,
		Quickbooks_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		Quickbooks_GetStripeConnectAccountQuery,
		Quickbooks_GetStripeConnectAccountQueryVariables
	>(Quickbooks_GetStripeConnectAccountDocument, options);
}
export function useQuickbooks_GetStripeConnectAccountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Quickbooks_GetStripeConnectAccountQuery,
		Quickbooks_GetStripeConnectAccountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		Quickbooks_GetStripeConnectAccountQuery,
		Quickbooks_GetStripeConnectAccountQueryVariables
	>(Quickbooks_GetStripeConnectAccountDocument, options);
}
export type Quickbooks_GetStripeConnectAccountQueryHookResult = ReturnType<
	typeof useQuickbooks_GetStripeConnectAccountQuery
>;
export type Quickbooks_GetStripeConnectAccountLazyQueryHookResult = ReturnType<
	typeof useQuickbooks_GetStripeConnectAccountLazyQuery
>;
export type Quickbooks_GetStripeConnectAccountQueryResult = Apollo.QueryResult<
	Quickbooks_GetStripeConnectAccountQuery,
	Quickbooks_GetStripeConnectAccountQueryVariables
>;
export const Quickbooks_GetOrgUserWhereDocument = gql`
	query quickbooks_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				...canAccessPremiumOrganization
			}
		}
	}
	${CanAccessPremiumOrganizationFragmentDoc}
`;

/**
 * __useQuickbooks_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useQuickbooks_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbooks_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbooks_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuickbooks_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		Quickbooks_GetOrgUserWhereQuery,
		Quickbooks_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		Quickbooks_GetOrgUserWhereQuery,
		Quickbooks_GetOrgUserWhereQueryVariables
	>(Quickbooks_GetOrgUserWhereDocument, options);
}
export function useQuickbooks_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Quickbooks_GetOrgUserWhereQuery,
		Quickbooks_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		Quickbooks_GetOrgUserWhereQuery,
		Quickbooks_GetOrgUserWhereQueryVariables
	>(Quickbooks_GetOrgUserWhereDocument, options);
}
export type Quickbooks_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useQuickbooks_GetOrgUserWhereQuery
>;
export type Quickbooks_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useQuickbooks_GetOrgUserWhereLazyQuery
>;
export type Quickbooks_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	Quickbooks_GetOrgUserWhereQuery,
	Quickbooks_GetOrgUserWhereQueryVariables
>;
export const Quickbooks_CanAccessByFeatureFlagDocument = gql`
	query quickbooks_canAccessByFeatureFlag(
		$where: CanAccessByFeatureFlagWhereInput!
	) {
		canAccessByFeatureFlag(where: $where)
	}
`;

/**
 * __useQuickbooks_CanAccessByFeatureFlagQuery__
 *
 * To run a query within a React component, call `useQuickbooks_CanAccessByFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbooks_CanAccessByFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbooks_CanAccessByFeatureFlagQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuickbooks_CanAccessByFeatureFlagQuery(
	baseOptions: Apollo.QueryHookOptions<
		Quickbooks_CanAccessByFeatureFlagQuery,
		Quickbooks_CanAccessByFeatureFlagQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		Quickbooks_CanAccessByFeatureFlagQuery,
		Quickbooks_CanAccessByFeatureFlagQueryVariables
	>(Quickbooks_CanAccessByFeatureFlagDocument, options);
}
export function useQuickbooks_CanAccessByFeatureFlagLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Quickbooks_CanAccessByFeatureFlagQuery,
		Quickbooks_CanAccessByFeatureFlagQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		Quickbooks_CanAccessByFeatureFlagQuery,
		Quickbooks_CanAccessByFeatureFlagQueryVariables
	>(Quickbooks_CanAccessByFeatureFlagDocument, options);
}
export type Quickbooks_CanAccessByFeatureFlagQueryHookResult = ReturnType<
	typeof useQuickbooks_CanAccessByFeatureFlagQuery
>;
export type Quickbooks_CanAccessByFeatureFlagLazyQueryHookResult = ReturnType<
	typeof useQuickbooks_CanAccessByFeatureFlagLazyQuery
>;
export type Quickbooks_CanAccessByFeatureFlagQueryResult = Apollo.QueryResult<
	Quickbooks_CanAccessByFeatureFlagQuery,
	Quickbooks_CanAccessByFeatureFlagQueryVariables
>;
export const StripeInvoiceListGetStripeInvoicesForVendorCustomerDocument = gql`
	query stripeInvoiceListGetStripeInvoicesForVendorCustomer {
		getStripeInvoicesForVendorCustomer {
			data {
				...stripeInvoiceListStripeInvoice
			}
		}
	}
	${StripeInvoiceListStripeInvoiceFragmentDoc}
`;

/**
 * __useStripeInvoiceListGetStripeInvoicesForVendorCustomerQuery__
 *
 * To run a query within a React component, call `useStripeInvoiceListGetStripeInvoicesForVendorCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeInvoiceListGetStripeInvoicesForVendorCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeInvoiceListGetStripeInvoicesForVendorCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripeInvoiceListGetStripeInvoicesForVendorCustomerQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQuery,
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQuery,
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryVariables
	>(StripeInvoiceListGetStripeInvoicesForVendorCustomerDocument, options);
}
export function useStripeInvoiceListGetStripeInvoicesForVendorCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQuery,
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQuery,
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryVariables
	>(StripeInvoiceListGetStripeInvoicesForVendorCustomerDocument, options);
}
export type StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryHookResult =
	ReturnType<
		typeof useStripeInvoiceListGetStripeInvoicesForVendorCustomerQuery
	>;
export type StripeInvoiceListGetStripeInvoicesForVendorCustomerLazyQueryHookResult =
	ReturnType<
		typeof useStripeInvoiceListGetStripeInvoicesForVendorCustomerLazyQuery
	>;
export type StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryResult =
	Apollo.QueryResult<
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQuery,
		StripeInvoiceListGetStripeInvoicesForVendorCustomerQueryVariables
	>;
export const SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesDocument = gql`
	mutation subscriptionPaymentMethodModals_payOpenSubscriptionInvoices {
		payOpenSubscriptionInvoices
	}
`;
export type SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationFn =
	Apollo.MutationFunction<
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation,
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationVariables
	>;

/**
 * __useSubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation__
 *
 * To run a mutation, you first call `useSubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionPaymentMethodModalsPayOpenSubscriptionInvoicesMutation, { data, loading, error }] = useSubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation,
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation,
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationVariables
	>(
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesDocument,
		options
	);
}
export type SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationHookResult =
	ReturnType<
		typeof useSubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation
	>;
export type SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationResult =
	Apollo.MutationResult<SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation>;
export type SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationOptions =
	Apollo.BaseMutationOptions<
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutation,
		SubscriptionPaymentMethodModals_PayOpenSubscriptionInvoicesMutationVariables
	>;
export const TaxForms_CreateStripeAccountSessionDocument = gql`
	mutation taxForms_createStripeAccountSession {
		createStripeAccountSession
	}
`;
export type TaxForms_CreateStripeAccountSessionMutationFn =
	Apollo.MutationFunction<
		TaxForms_CreateStripeAccountSessionMutation,
		TaxForms_CreateStripeAccountSessionMutationVariables
	>;

/**
 * __useTaxForms_CreateStripeAccountSessionMutation__
 *
 * To run a mutation, you first call `useTaxForms_CreateStripeAccountSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxForms_CreateStripeAccountSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxFormsCreateStripeAccountSessionMutation, { data, loading, error }] = useTaxForms_CreateStripeAccountSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useTaxForms_CreateStripeAccountSessionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TaxForms_CreateStripeAccountSessionMutation,
		TaxForms_CreateStripeAccountSessionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TaxForms_CreateStripeAccountSessionMutation,
		TaxForms_CreateStripeAccountSessionMutationVariables
	>(TaxForms_CreateStripeAccountSessionDocument, options);
}
export type TaxForms_CreateStripeAccountSessionMutationHookResult = ReturnType<
	typeof useTaxForms_CreateStripeAccountSessionMutation
>;
export type TaxForms_CreateStripeAccountSessionMutationResult =
	Apollo.MutationResult<TaxForms_CreateStripeAccountSessionMutation>;
export type TaxForms_CreateStripeAccountSessionMutationOptions =
	Apollo.BaseMutationOptions<
		TaxForms_CreateStripeAccountSessionMutation,
		TaxForms_CreateStripeAccountSessionMutationVariables
	>;
export const TaxForms_GetFeatureFlagsDocument = gql`
	query taxForms_getFeatureFlags {
		getFeatureFlags {
			category
			active
		}
	}
`;

/**
 * __useTaxForms_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useTaxForms_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxForms_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxForms_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaxForms_GetFeatureFlagsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TaxForms_GetFeatureFlagsQuery,
		TaxForms_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TaxForms_GetFeatureFlagsQuery,
		TaxForms_GetFeatureFlagsQueryVariables
	>(TaxForms_GetFeatureFlagsDocument, options);
}
export function useTaxForms_GetFeatureFlagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TaxForms_GetFeatureFlagsQuery,
		TaxForms_GetFeatureFlagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TaxForms_GetFeatureFlagsQuery,
		TaxForms_GetFeatureFlagsQueryVariables
	>(TaxForms_GetFeatureFlagsDocument, options);
}
export type TaxForms_GetFeatureFlagsQueryHookResult = ReturnType<
	typeof useTaxForms_GetFeatureFlagsQuery
>;
export type TaxForms_GetFeatureFlagsLazyQueryHookResult = ReturnType<
	typeof useTaxForms_GetFeatureFlagsLazyQuery
>;
export type TaxForms_GetFeatureFlagsQueryResult = Apollo.QueryResult<
	TaxForms_GetFeatureFlagsQuery,
	TaxForms_GetFeatureFlagsQueryVariables
>;
export const VendorTransactionHistory_GetOrgTransactionHistoryDocument = gql`
	query vendorTransactionHistory_getOrgTransactionHistory(
		$where: OrganizationWhereUniqueInput!
		$after: String
	) {
		getOrgTransactionHistory(where: $where, after: $after) {
			transactionHistoryItems {
				...VendorTransactionHistoryItem
			}
			hasMore
		}
	}
	${VendorTransactionHistoryItemFragmentDoc}
`;

/**
 * __useVendorTransactionHistory_GetOrgTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useVendorTransactionHistory_GetOrgTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorTransactionHistory_GetOrgTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorTransactionHistory_GetOrgTransactionHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useVendorTransactionHistory_GetOrgTransactionHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		VendorTransactionHistory_GetOrgTransactionHistoryQuery,
		VendorTransactionHistory_GetOrgTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		VendorTransactionHistory_GetOrgTransactionHistoryQuery,
		VendorTransactionHistory_GetOrgTransactionHistoryQueryVariables
	>(VendorTransactionHistory_GetOrgTransactionHistoryDocument, options);
}
export function useVendorTransactionHistory_GetOrgTransactionHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		VendorTransactionHistory_GetOrgTransactionHistoryQuery,
		VendorTransactionHistory_GetOrgTransactionHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		VendorTransactionHistory_GetOrgTransactionHistoryQuery,
		VendorTransactionHistory_GetOrgTransactionHistoryQueryVariables
	>(VendorTransactionHistory_GetOrgTransactionHistoryDocument, options);
}
export type VendorTransactionHistory_GetOrgTransactionHistoryQueryHookResult =
	ReturnType<typeof useVendorTransactionHistory_GetOrgTransactionHistoryQuery>;
export type VendorTransactionHistory_GetOrgTransactionHistoryLazyQueryHookResult =
	ReturnType<
		typeof useVendorTransactionHistory_GetOrgTransactionHistoryLazyQuery
	>;
export type VendorTransactionHistory_GetOrgTransactionHistoryQueryResult =
	Apollo.QueryResult<
		VendorTransactionHistory_GetOrgTransactionHistoryQuery,
		VendorTransactionHistory_GetOrgTransactionHistoryQueryVariables
	>;
export const VendorWallet_CreateStripeAccountSessionDocument = gql`
	mutation vendorWallet_createStripeAccountSession {
		createStripeAccountSession
	}
`;
export type VendorWallet_CreateStripeAccountSessionMutationFn =
	Apollo.MutationFunction<
		VendorWallet_CreateStripeAccountSessionMutation,
		VendorWallet_CreateStripeAccountSessionMutationVariables
	>;

/**
 * __useVendorWallet_CreateStripeAccountSessionMutation__
 *
 * To run a mutation, you first call `useVendorWallet_CreateStripeAccountSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorWallet_CreateStripeAccountSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorWalletCreateStripeAccountSessionMutation, { data, loading, error }] = useVendorWallet_CreateStripeAccountSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useVendorWallet_CreateStripeAccountSessionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VendorWallet_CreateStripeAccountSessionMutation,
		VendorWallet_CreateStripeAccountSessionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VendorWallet_CreateStripeAccountSessionMutation,
		VendorWallet_CreateStripeAccountSessionMutationVariables
	>(VendorWallet_CreateStripeAccountSessionDocument, options);
}
export type VendorWallet_CreateStripeAccountSessionMutationHookResult =
	ReturnType<typeof useVendorWallet_CreateStripeAccountSessionMutation>;
export type VendorWallet_CreateStripeAccountSessionMutationResult =
	Apollo.MutationResult<VendorWallet_CreateStripeAccountSessionMutation>;
export type VendorWallet_CreateStripeAccountSessionMutationOptions =
	Apollo.BaseMutationOptions<
		VendorWallet_CreateStripeAccountSessionMutation,
		VendorWallet_CreateStripeAccountSessionMutationVariables
	>;
export const VendorWallet_GetAuthedUserDocument = gql`
	query VendorWallet_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			userType
			orgUser {
				id
				isAdmin
				isOwner
				organization {
					id
					hasStripeVerificationNeeds
				}
			}
		}
	}
`;

/**
 * __useVendorWallet_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useVendorWallet_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorWallet_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorWallet_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVendorWallet_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		VendorWallet_GetAuthedUserQuery,
		VendorWallet_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		VendorWallet_GetAuthedUserQuery,
		VendorWallet_GetAuthedUserQueryVariables
	>(VendorWallet_GetAuthedUserDocument, options);
}
export function useVendorWallet_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		VendorWallet_GetAuthedUserQuery,
		VendorWallet_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		VendorWallet_GetAuthedUserQuery,
		VendorWallet_GetAuthedUserQueryVariables
	>(VendorWallet_GetAuthedUserDocument, options);
}
export type VendorWallet_GetAuthedUserQueryHookResult = ReturnType<
	typeof useVendorWallet_GetAuthedUserQuery
>;
export type VendorWallet_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useVendorWallet_GetAuthedUserLazyQuery
>;
export type VendorWallet_GetAuthedUserQueryResult = Apollo.QueryResult<
	VendorWallet_GetAuthedUserQuery,
	VendorWallet_GetAuthedUserQueryVariables
>;
export const WalletDrawer_GetTotalForSourceDocument = gql`
	query walletDrawer_getTotalForSource($where: PaymentMethodWhereInput!) {
		getTotalForSource(where: $where)
	}
`;

/**
 * __useWalletDrawer_GetTotalForSourceQuery__
 *
 * To run a query within a React component, call `useWalletDrawer_GetTotalForSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletDrawer_GetTotalForSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletDrawer_GetTotalForSourceQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWalletDrawer_GetTotalForSourceQuery(
	baseOptions: Apollo.QueryHookOptions<
		WalletDrawer_GetTotalForSourceQuery,
		WalletDrawer_GetTotalForSourceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		WalletDrawer_GetTotalForSourceQuery,
		WalletDrawer_GetTotalForSourceQueryVariables
	>(WalletDrawer_GetTotalForSourceDocument, options);
}
export function useWalletDrawer_GetTotalForSourceLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		WalletDrawer_GetTotalForSourceQuery,
		WalletDrawer_GetTotalForSourceQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		WalletDrawer_GetTotalForSourceQuery,
		WalletDrawer_GetTotalForSourceQueryVariables
	>(WalletDrawer_GetTotalForSourceDocument, options);
}
export type WalletDrawer_GetTotalForSourceQueryHookResult = ReturnType<
	typeof useWalletDrawer_GetTotalForSourceQuery
>;
export type WalletDrawer_GetTotalForSourceLazyQueryHookResult = ReturnType<
	typeof useWalletDrawer_GetTotalForSourceLazyQuery
>;
export type WalletDrawer_GetTotalForSourceQueryResult = Apollo.QueryResult<
	WalletDrawer_GetTotalForSourceQuery,
	WalletDrawer_GetTotalForSourceQueryVariables
>;
export const EventRow_DismissEventDocument = gql`
	mutation EventRow_DismissEvent($where: EventWhereUniqueInput!) {
		dismissEvent(where: $where)
	}
`;
export type EventRow_DismissEventMutationFn = Apollo.MutationFunction<
	EventRow_DismissEventMutation,
	EventRow_DismissEventMutationVariables
>;

/**
 * __useEventRow_DismissEventMutation__
 *
 * To run a mutation, you first call `useEventRow_DismissEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventRow_DismissEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventRowDismissEventMutation, { data, loading, error }] = useEventRow_DismissEventMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEventRow_DismissEventMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EventRow_DismissEventMutation,
		EventRow_DismissEventMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EventRow_DismissEventMutation,
		EventRow_DismissEventMutationVariables
	>(EventRow_DismissEventDocument, options);
}
export type EventRow_DismissEventMutationHookResult = ReturnType<
	typeof useEventRow_DismissEventMutation
>;
export type EventRow_DismissEventMutationResult =
	Apollo.MutationResult<EventRow_DismissEventMutation>;
export type EventRow_DismissEventMutationOptions = Apollo.BaseMutationOptions<
	EventRow_DismissEventMutation,
	EventRow_DismissEventMutationVariables
>;
export const EventFeed_ResendContractDocument = gql`
	mutation EventFeed_ResendContract(
		$where: ContractWhereUniqueInput!
		$data: ContractResendInput
	) {
		resendContract(where: $where, data: $data)
	}
`;
export type EventFeed_ResendContractMutationFn = Apollo.MutationFunction<
	EventFeed_ResendContractMutation,
	EventFeed_ResendContractMutationVariables
>;

/**
 * __useEventFeed_ResendContractMutation__
 *
 * To run a mutation, you first call `useEventFeed_ResendContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventFeed_ResendContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventFeedResendContractMutation, { data, loading, error }] = useEventFeed_ResendContractMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEventFeed_ResendContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EventFeed_ResendContractMutation,
		EventFeed_ResendContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EventFeed_ResendContractMutation,
		EventFeed_ResendContractMutationVariables
	>(EventFeed_ResendContractDocument, options);
}
export type EventFeed_ResendContractMutationHookResult = ReturnType<
	typeof useEventFeed_ResendContractMutation
>;
export type EventFeed_ResendContractMutationResult =
	Apollo.MutationResult<EventFeed_ResendContractMutation>;
export type EventFeed_ResendContractMutationOptions =
	Apollo.BaseMutationOptions<
		EventFeed_ResendContractMutation,
		EventFeed_ResendContractMutationVariables
	>;
export const GetInvoicePastDueEventProps_SendOrResendInvoiceDocument = gql`
	mutation GetInvoicePastDueEventProps_SendOrResendInvoice(
		$data: SendOrResendInvoiceInput
		$where: InvoiceWhereUniqueInput!
	) {
		sendOrResendInvoice(data: $data, where: $where) {
			id
		}
	}
`;
export type GetInvoicePastDueEventProps_SendOrResendInvoiceMutationFn =
	Apollo.MutationFunction<
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutation,
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutationVariables
	>;

/**
 * __useGetInvoicePastDueEventProps_SendOrResendInvoiceMutation__
 *
 * To run a mutation, you first call `useGetInvoicePastDueEventProps_SendOrResendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePastDueEventProps_SendOrResendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getInvoicePastDueEventPropsSendOrResendInvoiceMutation, { data, loading, error }] = useGetInvoicePastDueEventProps_SendOrResendInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetInvoicePastDueEventProps_SendOrResendInvoiceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutation,
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutation,
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutationVariables
	>(GetInvoicePastDueEventProps_SendOrResendInvoiceDocument, options);
}
export type GetInvoicePastDueEventProps_SendOrResendInvoiceMutationHookResult =
	ReturnType<typeof useGetInvoicePastDueEventProps_SendOrResendInvoiceMutation>;
export type GetInvoicePastDueEventProps_SendOrResendInvoiceMutationResult =
	Apollo.MutationResult<GetInvoicePastDueEventProps_SendOrResendInvoiceMutation>;
export type GetInvoicePastDueEventProps_SendOrResendInvoiceMutationOptions =
	Apollo.BaseMutationOptions<
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutation,
		GetInvoicePastDueEventProps_SendOrResendInvoiceMutationVariables
	>;
export const DeletePaymentMethod_GetInvoicesForCustomerDocument = gql`
	query deletePaymentMethod_getInvoicesForCustomer(
		$where: GetInvoicesForCustomerInput!
	) {
		getInvoicesForCustomer(where: $where) {
			invoices {
				...deletePaymentMethodInvoice
			}
		}
	}
	${DeletePaymentMethodInvoiceFragmentDoc}
`;

/**
 * __useDeletePaymentMethod_GetInvoicesForCustomerQuery__
 *
 * To run a query within a React component, call `useDeletePaymentMethod_GetInvoicesForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethod_GetInvoicesForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletePaymentMethod_GetInvoicesForCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePaymentMethod_GetInvoicesForCustomerQuery(
	baseOptions: Apollo.QueryHookOptions<
		DeletePaymentMethod_GetInvoicesForCustomerQuery,
		DeletePaymentMethod_GetInvoicesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DeletePaymentMethod_GetInvoicesForCustomerQuery,
		DeletePaymentMethod_GetInvoicesForCustomerQueryVariables
	>(DeletePaymentMethod_GetInvoicesForCustomerDocument, options);
}
export function useDeletePaymentMethod_GetInvoicesForCustomerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DeletePaymentMethod_GetInvoicesForCustomerQuery,
		DeletePaymentMethod_GetInvoicesForCustomerQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DeletePaymentMethod_GetInvoicesForCustomerQuery,
		DeletePaymentMethod_GetInvoicesForCustomerQueryVariables
	>(DeletePaymentMethod_GetInvoicesForCustomerDocument, options);
}
export type DeletePaymentMethod_GetInvoicesForCustomerQueryHookResult =
	ReturnType<typeof useDeletePaymentMethod_GetInvoicesForCustomerQuery>;
export type DeletePaymentMethod_GetInvoicesForCustomerLazyQueryHookResult =
	ReturnType<typeof useDeletePaymentMethod_GetInvoicesForCustomerLazyQuery>;
export type DeletePaymentMethod_GetInvoicesForCustomerQueryResult =
	Apollo.QueryResult<
		DeletePaymentMethod_GetInvoicesForCustomerQuery,
		DeletePaymentMethod_GetInvoicesForCustomerQueryVariables
	>;
export const UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceDocument = gql`
	mutation useUpdatePaymentMethod_deleteCustomerStripePaymentSource(
		$where: StripeBankAccountDeletionInput!
	) {
		deleteCustomerStripePaymentSource(where: $where) {
			id
			default_source
			sources {
				data {
					id
				}
			}
		}
	}
`;
export type UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationFn =
	Apollo.MutationFunction<
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation,
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationVariables
	>;

/**
 * __useUseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation__
 *
 * To run a mutation, you first call `useUseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useUpdatePaymentMethodDeleteCustomerStripePaymentSourceMutation, { data, loading, error }] = useUseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation,
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation,
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationVariables
	>(UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceDocument, options);
}
export type UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationHookResult =
	ReturnType<
		typeof useUseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation
	>;
export type UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationResult =
	Apollo.MutationResult<UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation>;
export type UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationOptions =
	Apollo.BaseMutationOptions<
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutation,
		UseUpdatePaymentMethod_DeleteCustomerStripePaymentSourceMutationVariables
	>;
export const InviteForm_CreateInvitationDocument = gql`
	mutation inviteForm_createInvitation($data: InvitationCustomCreateInput!) {
		createInvitation(data: $data) {
			id
			contact {
				id
			}
		}
	}
`;
export type InviteForm_CreateInvitationMutationFn = Apollo.MutationFunction<
	InviteForm_CreateInvitationMutation,
	InviteForm_CreateInvitationMutationVariables
>;

/**
 * __useInviteForm_CreateInvitationMutation__
 *
 * To run a mutation, you first call `useInviteForm_CreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteForm_CreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteFormCreateInvitationMutation, { data, loading, error }] = useInviteForm_CreateInvitationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteForm_CreateInvitationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InviteForm_CreateInvitationMutation,
		InviteForm_CreateInvitationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		InviteForm_CreateInvitationMutation,
		InviteForm_CreateInvitationMutationVariables
	>(InviteForm_CreateInvitationDocument, options);
}
export type InviteForm_CreateInvitationMutationHookResult = ReturnType<
	typeof useInviteForm_CreateInvitationMutation
>;
export type InviteForm_CreateInvitationMutationResult =
	Apollo.MutationResult<InviteForm_CreateInvitationMutation>;
export type InviteForm_CreateInvitationMutationOptions =
	Apollo.BaseMutationOptions<
		InviteForm_CreateInvitationMutation,
		InviteForm_CreateInvitationMutationVariables
	>;
export const InviteForm_GetPendingInvitationsDocument = gql`
	query inviteForm_getPendingInvitations(
		$where: InvitationsWhereCustomInput!
		$take: Int
	) {
		getPendingInvitations(where: $where, take: $take) {
			...inviteForm_getPendingInvitations
		}
	}
	${InviteForm_GetPendingInvitationsFragmentDoc}
`;

/**
 * __useInviteForm_GetPendingInvitationsQuery__
 *
 * To run a query within a React component, call `useInviteForm_GetPendingInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteForm_GetPendingInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteForm_GetPendingInvitationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useInviteForm_GetPendingInvitationsQuery(
	baseOptions: Apollo.QueryHookOptions<
		InviteForm_GetPendingInvitationsQuery,
		InviteForm_GetPendingInvitationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InviteForm_GetPendingInvitationsQuery,
		InviteForm_GetPendingInvitationsQueryVariables
	>(InviteForm_GetPendingInvitationsDocument, options);
}
export function useInviteForm_GetPendingInvitationsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InviteForm_GetPendingInvitationsQuery,
		InviteForm_GetPendingInvitationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InviteForm_GetPendingInvitationsQuery,
		InviteForm_GetPendingInvitationsQueryVariables
	>(InviteForm_GetPendingInvitationsDocument, options);
}
export type InviteForm_GetPendingInvitationsQueryHookResult = ReturnType<
	typeof useInviteForm_GetPendingInvitationsQuery
>;
export type InviteForm_GetPendingInvitationsLazyQueryHookResult = ReturnType<
	typeof useInviteForm_GetPendingInvitationsLazyQuery
>;
export type InviteForm_GetPendingInvitationsQueryResult = Apollo.QueryResult<
	InviteForm_GetPendingInvitationsQuery,
	InviteForm_GetPendingInvitationsQueryVariables
>;
export const InviteForm_GetInviteUserDocument = gql`
	query inviteForm_getInviteUser($email: String!) {
		getInviteUser(email: $email) {
			...contactSnippetInviteUser
		}
	}
	${ContactSnippetInviteUserFragmentDoc}
`;

/**
 * __useInviteForm_GetInviteUserQuery__
 *
 * To run a query within a React component, call `useInviteForm_GetInviteUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteForm_GetInviteUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteForm_GetInviteUserQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteForm_GetInviteUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		InviteForm_GetInviteUserQuery,
		InviteForm_GetInviteUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		InviteForm_GetInviteUserQuery,
		InviteForm_GetInviteUserQueryVariables
	>(InviteForm_GetInviteUserDocument, options);
}
export function useInviteForm_GetInviteUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InviteForm_GetInviteUserQuery,
		InviteForm_GetInviteUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		InviteForm_GetInviteUserQuery,
		InviteForm_GetInviteUserQueryVariables
	>(InviteForm_GetInviteUserDocument, options);
}
export type InviteForm_GetInviteUserQueryHookResult = ReturnType<
	typeof useInviteForm_GetInviteUserQuery
>;
export type InviteForm_GetInviteUserLazyQueryHookResult = ReturnType<
	typeof useInviteForm_GetInviteUserLazyQuery
>;
export type InviteForm_GetInviteUserQueryResult = Apollo.QueryResult<
	InviteForm_GetInviteUserQuery,
	InviteForm_GetInviteUserQueryVariables
>;
export const NewExternalAccount_GetAuthedUserDocument = gql`
	query NewExternalAccount_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			userType
			orgUser {
				id
				isAdmin
				isOwner
				organization {
					id
					hasStripeVerificationNeeds
				}
			}
		}
	}
`;

/**
 * __useNewExternalAccount_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useNewExternalAccount_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewExternalAccount_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewExternalAccount_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNewExternalAccount_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		NewExternalAccount_GetAuthedUserQuery,
		NewExternalAccount_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		NewExternalAccount_GetAuthedUserQuery,
		NewExternalAccount_GetAuthedUserQueryVariables
	>(NewExternalAccount_GetAuthedUserDocument, options);
}
export function useNewExternalAccount_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		NewExternalAccount_GetAuthedUserQuery,
		NewExternalAccount_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		NewExternalAccount_GetAuthedUserQuery,
		NewExternalAccount_GetAuthedUserQueryVariables
	>(NewExternalAccount_GetAuthedUserDocument, options);
}
export type NewExternalAccount_GetAuthedUserQueryHookResult = ReturnType<
	typeof useNewExternalAccount_GetAuthedUserQuery
>;
export type NewExternalAccount_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useNewExternalAccount_GetAuthedUserLazyQuery
>;
export type NewExternalAccount_GetAuthedUserQueryResult = Apollo.QueryResult<
	NewExternalAccount_GetAuthedUserQuery,
	NewExternalAccount_GetAuthedUserQueryVariables
>;
export const NewExternalAccount_CreateExternalAccountDocument = gql`
	mutation NewExternalAccount_createExternalAccount(
		$data: StripeBankAccountSourceInput!
		$where: OrganizationWhereUniqueInput!
	) {
		createExternalAccount(data: $data, where: $where) {
			id
		}
	}
`;
export type NewExternalAccount_CreateExternalAccountMutationFn =
	Apollo.MutationFunction<
		NewExternalAccount_CreateExternalAccountMutation,
		NewExternalAccount_CreateExternalAccountMutationVariables
	>;

/**
 * __useNewExternalAccount_CreateExternalAccountMutation__
 *
 * To run a mutation, you first call `useNewExternalAccount_CreateExternalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewExternalAccount_CreateExternalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newExternalAccountCreateExternalAccountMutation, { data, loading, error }] = useNewExternalAccount_CreateExternalAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNewExternalAccount_CreateExternalAccountMutation(
	baseOptions?: Apollo.MutationHookOptions<
		NewExternalAccount_CreateExternalAccountMutation,
		NewExternalAccount_CreateExternalAccountMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		NewExternalAccount_CreateExternalAccountMutation,
		NewExternalAccount_CreateExternalAccountMutationVariables
	>(NewExternalAccount_CreateExternalAccountDocument, options);
}
export type NewExternalAccount_CreateExternalAccountMutationHookResult =
	ReturnType<typeof useNewExternalAccount_CreateExternalAccountMutation>;
export type NewExternalAccount_CreateExternalAccountMutationResult =
	Apollo.MutationResult<NewExternalAccount_CreateExternalAccountMutation>;
export type NewExternalAccount_CreateExternalAccountMutationOptions =
	Apollo.BaseMutationOptions<
		NewExternalAccount_CreateExternalAccountMutation,
		NewExternalAccount_CreateExternalAccountMutationVariables
	>;
export const NewPaymentSource_CreateSetupIntentForPaymentMethodDocument = gql`
	mutation newPaymentSource_createSetupIntentForPaymentMethod(
		$data: CreateSetupIntentForPaymentMethodInput!
	) {
		createSetupIntentForPaymentMethod(data: $data) {
			clientSecret
		}
	}
`;
export type NewPaymentSource_CreateSetupIntentForPaymentMethodMutationFn =
	Apollo.MutationFunction<
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutation,
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutationVariables
	>;

/**
 * __useNewPaymentSource_CreateSetupIntentForPaymentMethodMutation__
 *
 * To run a mutation, you first call `useNewPaymentSource_CreateSetupIntentForPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewPaymentSource_CreateSetupIntentForPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newPaymentSourceCreateSetupIntentForPaymentMethodMutation, { data, loading, error }] = useNewPaymentSource_CreateSetupIntentForPaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNewPaymentSource_CreateSetupIntentForPaymentMethodMutation(
	baseOptions?: Apollo.MutationHookOptions<
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutation,
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutation,
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutationVariables
	>(NewPaymentSource_CreateSetupIntentForPaymentMethodDocument, options);
}
export type NewPaymentSource_CreateSetupIntentForPaymentMethodMutationHookResult =
	ReturnType<
		typeof useNewPaymentSource_CreateSetupIntentForPaymentMethodMutation
	>;
export type NewPaymentSource_CreateSetupIntentForPaymentMethodMutationResult =
	Apollo.MutationResult<NewPaymentSource_CreateSetupIntentForPaymentMethodMutation>;
export type NewPaymentSource_CreateSetupIntentForPaymentMethodMutationOptions =
	Apollo.BaseMutationOptions<
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutation,
		NewPaymentSource_CreateSetupIntentForPaymentMethodMutationVariables
	>;
export const UpdateBankAccount_UpdateCustomerStripeBankAccountDocument = gql`
	mutation UpdateBankAccount_updateCustomerStripeBankAccount(
		$where: StripeBankAccountDeletionInput!
		$data: StripeBankAccountUpdateInput!
	) {
		updateCustomerStripeBankAccount(where: $where, data: $data) {
			id
			default_source
			sources {
				data {
					...updateBankAccountSource
				}
			}
		}
	}
	${UpdateBankAccountSourceFragmentDoc}
`;
export type UpdateBankAccount_UpdateCustomerStripeBankAccountMutationFn =
	Apollo.MutationFunction<
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutation,
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutationVariables
	>;

/**
 * __useUpdateBankAccount_UpdateCustomerStripeBankAccountMutation__
 *
 * To run a mutation, you first call `useUpdateBankAccount_UpdateCustomerStripeBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankAccount_UpdateCustomerStripeBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankAccountUpdateCustomerStripeBankAccountMutation, { data, loading, error }] = useUpdateBankAccount_UpdateCustomerStripeBankAccountMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBankAccount_UpdateCustomerStripeBankAccountMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutation,
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutation,
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutationVariables
	>(UpdateBankAccount_UpdateCustomerStripeBankAccountDocument, options);
}
export type UpdateBankAccount_UpdateCustomerStripeBankAccountMutationHookResult =
	ReturnType<
		typeof useUpdateBankAccount_UpdateCustomerStripeBankAccountMutation
	>;
export type UpdateBankAccount_UpdateCustomerStripeBankAccountMutationResult =
	Apollo.MutationResult<UpdateBankAccount_UpdateCustomerStripeBankAccountMutation>;
export type UpdateBankAccount_UpdateCustomerStripeBankAccountMutationOptions =
	Apollo.BaseMutationOptions<
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutation,
		UpdateBankAccount_UpdateCustomerStripeBankAccountMutationVariables
	>;
export const UpdateCard_UpdateCustomerStripeCardDocument = gql`
	mutation UpdateCard_updateCustomerStripeCard(
		$where: UpdateCustomerStripeCardWhereInput!
		$data: CustomerStripeCardUpdateInput!
	) {
		updateCustomerStripeCard(where: $where, data: $data) {
			...updateCustomerStripeCard
		}
	}
	${UpdateCustomerStripeCardFragmentDoc}
`;
export type UpdateCard_UpdateCustomerStripeCardMutationFn =
	Apollo.MutationFunction<
		UpdateCard_UpdateCustomerStripeCardMutation,
		UpdateCard_UpdateCustomerStripeCardMutationVariables
	>;

/**
 * __useUpdateCard_UpdateCustomerStripeCardMutation__
 *
 * To run a mutation, you first call `useUpdateCard_UpdateCustomerStripeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCard_UpdateCustomerStripeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardUpdateCustomerStripeCardMutation, { data, loading, error }] = useUpdateCard_UpdateCustomerStripeCardMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCard_UpdateCustomerStripeCardMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateCard_UpdateCustomerStripeCardMutation,
		UpdateCard_UpdateCustomerStripeCardMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateCard_UpdateCustomerStripeCardMutation,
		UpdateCard_UpdateCustomerStripeCardMutationVariables
	>(UpdateCard_UpdateCustomerStripeCardDocument, options);
}
export type UpdateCard_UpdateCustomerStripeCardMutationHookResult = ReturnType<
	typeof useUpdateCard_UpdateCustomerStripeCardMutation
>;
export type UpdateCard_UpdateCustomerStripeCardMutationResult =
	Apollo.MutationResult<UpdateCard_UpdateCustomerStripeCardMutation>;
export type UpdateCard_UpdateCustomerStripeCardMutationOptions =
	Apollo.BaseMutationOptions<
		UpdateCard_UpdateCustomerStripeCardMutation,
		UpdateCard_UpdateCustomerStripeCardMutationVariables
	>;
export const UpdateCard_UpdateVendorStripeCardDocument = gql`
	mutation UpdateCard_updateVendorStripeCard(
		$data: OrganizationStripeCardUpdateInput!
	) {
		updateVendorStripeCard(data: $data) {
			id
			default_source
			sources {
				data {
					id
					metadata {
						key
						value
					}
				}
			}
		}
	}
`;
export type UpdateCard_UpdateVendorStripeCardMutationFn =
	Apollo.MutationFunction<
		UpdateCard_UpdateVendorStripeCardMutation,
		UpdateCard_UpdateVendorStripeCardMutationVariables
	>;

/**
 * __useUpdateCard_UpdateVendorStripeCardMutation__
 *
 * To run a mutation, you first call `useUpdateCard_UpdateVendorStripeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCard_UpdateVendorStripeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardUpdateVendorStripeCardMutation, { data, loading, error }] = useUpdateCard_UpdateVendorStripeCardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCard_UpdateVendorStripeCardMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateCard_UpdateVendorStripeCardMutation,
		UpdateCard_UpdateVendorStripeCardMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateCard_UpdateVendorStripeCardMutation,
		UpdateCard_UpdateVendorStripeCardMutationVariables
	>(UpdateCard_UpdateVendorStripeCardDocument, options);
}
export type UpdateCard_UpdateVendorStripeCardMutationHookResult = ReturnType<
	typeof useUpdateCard_UpdateVendorStripeCardMutation
>;
export type UpdateCard_UpdateVendorStripeCardMutationResult =
	Apollo.MutationResult<UpdateCard_UpdateVendorStripeCardMutation>;
export type UpdateCard_UpdateVendorStripeCardMutationOptions =
	Apollo.BaseMutationOptions<
		UpdateCard_UpdateVendorStripeCardMutation,
		UpdateCard_UpdateVendorStripeCardMutationVariables
	>;
export const UpdateCard_GetAuthedUserDocument = gql`
	query UpdateCard_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			userType
			orgUser {
				id
				isAdmin
				isOwner
				organization {
					id
					hasStripeVerificationNeeds
				}
			}
			clientUser {
				id
				description
				firstNameOne
				lastNameOne
				firstNameTwo
				lastNameTwo
				updatedAt
				facebook
				instagram
				twitter
				pinterest
				weddingDate
				venue
				user {
					id
					userType
					email
					onboardingCompleted
					stripeCustomerId
				}
				assignedPlanner {
					id
					firstName
					lastName
					updatedAt
					organization {
						id
						name
						updatedAt
						image
					}
				}
			}
			superAdmin {
				id
				firstName
				lastName
				updatedAt
				user {
					id
					userType
					email
				}
			}
			groups {
				id
				name
			}
		}
	}
`;

/**
 * __useUpdateCard_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useUpdateCard_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCard_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCard_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateCard_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		UpdateCard_GetAuthedUserQuery,
		UpdateCard_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UpdateCard_GetAuthedUserQuery,
		UpdateCard_GetAuthedUserQueryVariables
	>(UpdateCard_GetAuthedUserDocument, options);
}
export function useUpdateCard_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UpdateCard_GetAuthedUserQuery,
		UpdateCard_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UpdateCard_GetAuthedUserQuery,
		UpdateCard_GetAuthedUserQueryVariables
	>(UpdateCard_GetAuthedUserDocument, options);
}
export type UpdateCard_GetAuthedUserQueryHookResult = ReturnType<
	typeof useUpdateCard_GetAuthedUserQuery
>;
export type UpdateCard_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useUpdateCard_GetAuthedUserLazyQuery
>;
export type UpdateCard_GetAuthedUserQueryResult = Apollo.QueryResult<
	UpdateCard_GetAuthedUserQuery,
	UpdateCard_GetAuthedUserQueryVariables
>;
export const UpdateExternalAccount_UpdateExternalAccountDocument = gql`
	mutation UpdateExternalAccount_updateExternalAccount(
		$data: StripeExternalAccountUpdateInput!
		$where: OrganizationWhereUniqueInput!
	) {
		updateExternalAccount(data: $data, where: $where) {
			...updateExternalAccountSource
		}
	}
	${UpdateExternalAccountSourceFragmentDoc}
`;
export type UpdateExternalAccount_UpdateExternalAccountMutationFn =
	Apollo.MutationFunction<
		UpdateExternalAccount_UpdateExternalAccountMutation,
		UpdateExternalAccount_UpdateExternalAccountMutationVariables
	>;

/**
 * __useUpdateExternalAccount_UpdateExternalAccountMutation__
 *
 * To run a mutation, you first call `useUpdateExternalAccount_UpdateExternalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalAccount_UpdateExternalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalAccountUpdateExternalAccountMutation, { data, loading, error }] = useUpdateExternalAccount_UpdateExternalAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateExternalAccount_UpdateExternalAccountMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateExternalAccount_UpdateExternalAccountMutation,
		UpdateExternalAccount_UpdateExternalAccountMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateExternalAccount_UpdateExternalAccountMutation,
		UpdateExternalAccount_UpdateExternalAccountMutationVariables
	>(UpdateExternalAccount_UpdateExternalAccountDocument, options);
}
export type UpdateExternalAccount_UpdateExternalAccountMutationHookResult =
	ReturnType<typeof useUpdateExternalAccount_UpdateExternalAccountMutation>;
export type UpdateExternalAccount_UpdateExternalAccountMutationResult =
	Apollo.MutationResult<UpdateExternalAccount_UpdateExternalAccountMutation>;
export type UpdateExternalAccount_UpdateExternalAccountMutationOptions =
	Apollo.BaseMutationOptions<
		UpdateExternalAccount_UpdateExternalAccountMutation,
		UpdateExternalAccount_UpdateExternalAccountMutationVariables
	>;
export const ProfileImagePicker_UpdateOrganizationDocument = gql`
	mutation ProfileImagePicker_updateOrganization(
		$where: OrganizationWhereUniqueInput!
		$data: OrganizationCustomUpdateInput!
	) {
		updateOrganization(where: $where, data: $data) {
			id
			name
			services {
				id
				name
			}
			image
			imageScale
			imageRotation
			imagePositionX
			imagePositionY
			updatedAt
		}
	}
`;
export type ProfileImagePicker_UpdateOrganizationMutationFn =
	Apollo.MutationFunction<
		ProfileImagePicker_UpdateOrganizationMutation,
		ProfileImagePicker_UpdateOrganizationMutationVariables
	>;

/**
 * __useProfileImagePicker_UpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useProfileImagePicker_UpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileImagePicker_UpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileImagePickerUpdateOrganizationMutation, { data, loading, error }] = useProfileImagePicker_UpdateOrganizationMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProfileImagePicker_UpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProfileImagePicker_UpdateOrganizationMutation,
		ProfileImagePicker_UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProfileImagePicker_UpdateOrganizationMutation,
		ProfileImagePicker_UpdateOrganizationMutationVariables
	>(ProfileImagePicker_UpdateOrganizationDocument, options);
}
export type ProfileImagePicker_UpdateOrganizationMutationHookResult =
	ReturnType<typeof useProfileImagePicker_UpdateOrganizationMutation>;
export type ProfileImagePicker_UpdateOrganizationMutationResult =
	Apollo.MutationResult<ProfileImagePicker_UpdateOrganizationMutation>;
export type ProfileImagePicker_UpdateOrganizationMutationOptions =
	Apollo.BaseMutationOptions<
		ProfileImagePicker_UpdateOrganizationMutation,
		ProfileImagePicker_UpdateOrganizationMutationVariables
	>;
export const ProfileImagePicker_RequestOrgProfileImageUploadUrlDocument = gql`
	query ProfileImagePicker_requestOrgProfileImageUploadUrl(
		$data: RequestImageUploadUrlInput!
	) {
		requestOrgProfileImageUploadUrl(data: $data) {
			uploadURL
		}
	}
`;

/**
 * __useProfileImagePicker_RequestOrgProfileImageUploadUrlQuery__
 *
 * To run a query within a React component, call `useProfileImagePicker_RequestOrgProfileImageUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileImagePicker_RequestOrgProfileImageUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileImagePicker_RequestOrgProfileImageUploadUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProfileImagePicker_RequestOrgProfileImageUploadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQuery,
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQuery,
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryVariables
	>(ProfileImagePicker_RequestOrgProfileImageUploadUrlDocument, options);
}
export function useProfileImagePicker_RequestOrgProfileImageUploadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQuery,
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQuery,
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryVariables
	>(ProfileImagePicker_RequestOrgProfileImageUploadUrlDocument, options);
}
export type ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryHookResult =
	ReturnType<typeof useProfileImagePicker_RequestOrgProfileImageUploadUrlQuery>;
export type ProfileImagePicker_RequestOrgProfileImageUploadUrlLazyQueryHookResult =
	ReturnType<
		typeof useProfileImagePicker_RequestOrgProfileImageUploadUrlLazyQuery
	>;
export type ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryResult =
	Apollo.QueryResult<
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQuery,
		ProfileImagePicker_RequestOrgProfileImageUploadUrlQueryVariables
	>;
export const GetNavigationItems_GetOrgUserWhereDocument = gql`
	query getNavigationItems_getOrgUserWhere($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			organization {
				id
				createdAt
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useGetNavigationItems_GetOrgUserWhereQuery__
 *
 * To run a query within a React component, call `useGetNavigationItems_GetOrgUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationItems_GetOrgUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationItems_GetOrgUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetNavigationItems_GetOrgUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetNavigationItems_GetOrgUserWhereQuery,
		GetNavigationItems_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetNavigationItems_GetOrgUserWhereQuery,
		GetNavigationItems_GetOrgUserWhereQueryVariables
	>(GetNavigationItems_GetOrgUserWhereDocument, options);
}
export function useGetNavigationItems_GetOrgUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetNavigationItems_GetOrgUserWhereQuery,
		GetNavigationItems_GetOrgUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetNavigationItems_GetOrgUserWhereQuery,
		GetNavigationItems_GetOrgUserWhereQueryVariables
	>(GetNavigationItems_GetOrgUserWhereDocument, options);
}
export type GetNavigationItems_GetOrgUserWhereQueryHookResult = ReturnType<
	typeof useGetNavigationItems_GetOrgUserWhereQuery
>;
export type GetNavigationItems_GetOrgUserWhereLazyQueryHookResult = ReturnType<
	typeof useGetNavigationItems_GetOrgUserWhereLazyQuery
>;
export type GetNavigationItems_GetOrgUserWhereQueryResult = Apollo.QueryResult<
	GetNavigationItems_GetOrgUserWhereQuery,
	GetNavigationItems_GetOrgUserWhereQueryVariables
>;
export const UseProfileLinks_LogoutDocument = gql`
	mutation useProfileLinks_logout {
		logout
	}
`;
export type UseProfileLinks_LogoutMutationFn = Apollo.MutationFunction<
	UseProfileLinks_LogoutMutation,
	UseProfileLinks_LogoutMutationVariables
>;

/**
 * __useUseProfileLinks_LogoutMutation__
 *
 * To run a mutation, you first call `useUseProfileLinks_LogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseProfileLinks_LogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useProfileLinksLogoutMutation, { data, loading, error }] = useUseProfileLinks_LogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useUseProfileLinks_LogoutMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseProfileLinks_LogoutMutation,
		UseProfileLinks_LogoutMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseProfileLinks_LogoutMutation,
		UseProfileLinks_LogoutMutationVariables
	>(UseProfileLinks_LogoutDocument, options);
}
export type UseProfileLinks_LogoutMutationHookResult = ReturnType<
	typeof useUseProfileLinks_LogoutMutation
>;
export type UseProfileLinks_LogoutMutationResult =
	Apollo.MutationResult<UseProfileLinks_LogoutMutation>;
export type UseProfileLinks_LogoutMutationOptions = Apollo.BaseMutationOptions<
	UseProfileLinks_LogoutMutation,
	UseProfileLinks_LogoutMutationVariables
>;
export const ProposalDesignEditorContextProvider_CreateProposalTemplateDocument = gql`
	mutation proposalDesignEditorContextProvider_createProposalTemplate(
		$data: ProposalTemplateCreateInput!
	) {
		createProposalTemplate(data: $data) {
			id
			title
			thumbnail
		}
	}
`;
export type ProposalDesignEditorContextProvider_CreateProposalTemplateMutationFn =
	Apollo.MutationFunction<
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutation,
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutationVariables
	>;

/**
 * __useProposalDesignEditorContextProvider_CreateProposalTemplateMutation__
 *
 * To run a mutation, you first call `useProposalDesignEditorContextProvider_CreateProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalDesignEditorContextProvider_CreateProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalDesignEditorContextProviderCreateProposalTemplateMutation, { data, loading, error }] = useProposalDesignEditorContextProvider_CreateProposalTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProposalDesignEditorContextProvider_CreateProposalTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutation,
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutation,
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutationVariables
	>(
		ProposalDesignEditorContextProvider_CreateProposalTemplateDocument,
		options
	);
}
export type ProposalDesignEditorContextProvider_CreateProposalTemplateMutationHookResult =
	ReturnType<
		typeof useProposalDesignEditorContextProvider_CreateProposalTemplateMutation
	>;
export type ProposalDesignEditorContextProvider_CreateProposalTemplateMutationResult =
	Apollo.MutationResult<ProposalDesignEditorContextProvider_CreateProposalTemplateMutation>;
export type ProposalDesignEditorContextProvider_CreateProposalTemplateMutationOptions =
	Apollo.BaseMutationOptions<
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutation,
		ProposalDesignEditorContextProvider_CreateProposalTemplateMutationVariables
	>;
export const UseContractViewButtonBarResendButton_ResendContractDocument = gql`
	mutation useContractViewButtonBarResendButton_resendContract(
		$where: ContractWhereUniqueInput!
		$data: ContractResendInput
	) {
		resendContract(where: $where, data: $data)
	}
`;
export type UseContractViewButtonBarResendButton_ResendContractMutationFn =
	Apollo.MutationFunction<
		UseContractViewButtonBarResendButton_ResendContractMutation,
		UseContractViewButtonBarResendButton_ResendContractMutationVariables
	>;

/**
 * __useUseContractViewButtonBarResendButton_ResendContractMutation__
 *
 * To run a mutation, you first call `useUseContractViewButtonBarResendButton_ResendContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContractViewButtonBarResendButton_ResendContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContractViewButtonBarResendButtonResendContractMutation, { data, loading, error }] = useUseContractViewButtonBarResendButton_ResendContractMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseContractViewButtonBarResendButton_ResendContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContractViewButtonBarResendButton_ResendContractMutation,
		UseContractViewButtonBarResendButton_ResendContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContractViewButtonBarResendButton_ResendContractMutation,
		UseContractViewButtonBarResendButton_ResendContractMutationVariables
	>(UseContractViewButtonBarResendButton_ResendContractDocument, options);
}
export type UseContractViewButtonBarResendButton_ResendContractMutationHookResult =
	ReturnType<
		typeof useUseContractViewButtonBarResendButton_ResendContractMutation
	>;
export type UseContractViewButtonBarResendButton_ResendContractMutationResult =
	Apollo.MutationResult<UseContractViewButtonBarResendButton_ResendContractMutation>;
export type UseContractViewButtonBarResendButton_ResendContractMutationOptions =
	Apollo.BaseMutationOptions<
		UseContractViewButtonBarResendButton_ResendContractMutation,
		UseContractViewButtonBarResendButton_ResendContractMutationVariables
	>;
export const UseButtonBarVoidContractButton_VoidContractDocument = gql`
	mutation useButtonBarVoidContractButton_voidContract(
		$where: ContractWhereUniqueInput!
	) {
		voidContract(where: $where) {
			id
			status
		}
	}
`;
export type UseButtonBarVoidContractButton_VoidContractMutationFn =
	Apollo.MutationFunction<
		UseButtonBarVoidContractButton_VoidContractMutation,
		UseButtonBarVoidContractButton_VoidContractMutationVariables
	>;

/**
 * __useUseButtonBarVoidContractButton_VoidContractMutation__
 *
 * To run a mutation, you first call `useUseButtonBarVoidContractButton_VoidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseButtonBarVoidContractButton_VoidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useButtonBarVoidContractButtonVoidContractMutation, { data, loading, error }] = useUseButtonBarVoidContractButton_VoidContractMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseButtonBarVoidContractButton_VoidContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseButtonBarVoidContractButton_VoidContractMutation,
		UseButtonBarVoidContractButton_VoidContractMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseButtonBarVoidContractButton_VoidContractMutation,
		UseButtonBarVoidContractButton_VoidContractMutationVariables
	>(UseButtonBarVoidContractButton_VoidContractDocument, options);
}
export type UseButtonBarVoidContractButton_VoidContractMutationHookResult =
	ReturnType<typeof useUseButtonBarVoidContractButton_VoidContractMutation>;
export type UseButtonBarVoidContractButton_VoidContractMutationResult =
	Apollo.MutationResult<UseButtonBarVoidContractButton_VoidContractMutation>;
export type UseButtonBarVoidContractButton_VoidContractMutationOptions =
	Apollo.BaseMutationOptions<
		UseButtonBarVoidContractButton_VoidContractMutation,
		UseButtonBarVoidContractButton_VoidContractMutationVariables
	>;
export const ClientOnboardingModal_GetClientUserWhereDocument = gql`
	query clientOnboardingModal_GetClientUserWhere(
		$where: ClientUserWhereUniqueInput!
	) {
		getClientUserWhere(where: $where) {
			id
			user {
				id
				seenOnboardingModalAt
			}
		}
	}
`;

/**
 * __useClientOnboardingModal_GetClientUserWhereQuery__
 *
 * To run a query within a React component, call `useClientOnboardingModal_GetClientUserWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingModal_GetClientUserWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOnboardingModal_GetClientUserWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientOnboardingModal_GetClientUserWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		ClientOnboardingModal_GetClientUserWhereQuery,
		ClientOnboardingModal_GetClientUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ClientOnboardingModal_GetClientUserWhereQuery,
		ClientOnboardingModal_GetClientUserWhereQueryVariables
	>(ClientOnboardingModal_GetClientUserWhereDocument, options);
}
export function useClientOnboardingModal_GetClientUserWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClientOnboardingModal_GetClientUserWhereQuery,
		ClientOnboardingModal_GetClientUserWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ClientOnboardingModal_GetClientUserWhereQuery,
		ClientOnboardingModal_GetClientUserWhereQueryVariables
	>(ClientOnboardingModal_GetClientUserWhereDocument, options);
}
export type ClientOnboardingModal_GetClientUserWhereQueryHookResult =
	ReturnType<typeof useClientOnboardingModal_GetClientUserWhereQuery>;
export type ClientOnboardingModal_GetClientUserWhereLazyQueryHookResult =
	ReturnType<typeof useClientOnboardingModal_GetClientUserWhereLazyQuery>;
export type ClientOnboardingModal_GetClientUserWhereQueryResult =
	Apollo.QueryResult<
		ClientOnboardingModal_GetClientUserWhereQuery,
		ClientOnboardingModal_GetClientUserWhereQueryVariables
	>;
export const ClientOnboardingModal_UpdateSelfDocument = gql`
	mutation clientOnboardingModal_UpdateSelf($data: UserUpdateSelfInput!) {
		updateSelf(data: $data) {
			id
			seenOnboardingModalAt
		}
	}
`;
export type ClientOnboardingModal_UpdateSelfMutationFn =
	Apollo.MutationFunction<
		ClientOnboardingModal_UpdateSelfMutation,
		ClientOnboardingModal_UpdateSelfMutationVariables
	>;

/**
 * __useClientOnboardingModal_UpdateSelfMutation__
 *
 * To run a mutation, you first call `useClientOnboardingModal_UpdateSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientOnboardingModal_UpdateSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientOnboardingModalUpdateSelfMutation, { data, loading, error }] = useClientOnboardingModal_UpdateSelfMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClientOnboardingModal_UpdateSelfMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClientOnboardingModal_UpdateSelfMutation,
		ClientOnboardingModal_UpdateSelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClientOnboardingModal_UpdateSelfMutation,
		ClientOnboardingModal_UpdateSelfMutationVariables
	>(ClientOnboardingModal_UpdateSelfDocument, options);
}
export type ClientOnboardingModal_UpdateSelfMutationHookResult = ReturnType<
	typeof useClientOnboardingModal_UpdateSelfMutation
>;
export type ClientOnboardingModal_UpdateSelfMutationResult =
	Apollo.MutationResult<ClientOnboardingModal_UpdateSelfMutation>;
export type ClientOnboardingModal_UpdateSelfMutationOptions =
	Apollo.BaseMutationOptions<
		ClientOnboardingModal_UpdateSelfMutation,
		ClientOnboardingModal_UpdateSelfMutationVariables
	>;
export const UseContacts_GetContactsWhereDocument = gql`
	query useContacts_getContactsWhere(
		$orderBy: [ContactOrderByInput]
		$skip: Int
		$take: Int
		$where: ContactWhereInput!
	) {
		getContactsWhere(
			orderBy: $orderBy
			skip: $skip
			take: $take
			where: $where
		) {
			contacts {
				...useContacts_contact
			}
		}
	}
	${UseContacts_ContactFragmentDoc}
`;

/**
 * __useUseContacts_GetContactsWhereQuery__
 *
 * To run a query within a React component, call `useUseContacts_GetContactsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseContacts_GetContactsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseContacts_GetContactsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContacts_GetContactsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseContacts_GetContactsWhereQuery,
		UseContacts_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseContacts_GetContactsWhereQuery,
		UseContacts_GetContactsWhereQueryVariables
	>(UseContacts_GetContactsWhereDocument, options);
}
export function useUseContacts_GetContactsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseContacts_GetContactsWhereQuery,
		UseContacts_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseContacts_GetContactsWhereQuery,
		UseContacts_GetContactsWhereQueryVariables
	>(UseContacts_GetContactsWhereDocument, options);
}
export type UseContacts_GetContactsWhereQueryHookResult = ReturnType<
	typeof useUseContacts_GetContactsWhereQuery
>;
export type UseContacts_GetContactsWhereLazyQueryHookResult = ReturnType<
	typeof useUseContacts_GetContactsWhereLazyQuery
>;
export type UseContacts_GetContactsWhereQueryResult = Apollo.QueryResult<
	UseContacts_GetContactsWhereQuery,
	UseContacts_GetContactsWhereQueryVariables
>;
export const UseContacts_UpdateContactDocument = gql`
	mutation useContacts_updateContact(
		$data: CustomContactUpdateInput!
		$where: ContactWhereUniqueInput!
	) {
		updateContact(data: $data, where: $where) {
			...useContacts_contact
		}
	}
	${UseContacts_ContactFragmentDoc}
`;
export type UseContacts_UpdateContactMutationFn = Apollo.MutationFunction<
	UseContacts_UpdateContactMutation,
	UseContacts_UpdateContactMutationVariables
>;

/**
 * __useUseContacts_UpdateContactMutation__
 *
 * To run a mutation, you first call `useUseContacts_UpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContacts_UpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContactsUpdateContactMutation, { data, loading, error }] = useUseContacts_UpdateContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContacts_UpdateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContacts_UpdateContactMutation,
		UseContacts_UpdateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContacts_UpdateContactMutation,
		UseContacts_UpdateContactMutationVariables
	>(UseContacts_UpdateContactDocument, options);
}
export type UseContacts_UpdateContactMutationHookResult = ReturnType<
	typeof useUseContacts_UpdateContactMutation
>;
export type UseContacts_UpdateContactMutationResult =
	Apollo.MutationResult<UseContacts_UpdateContactMutation>;
export type UseContacts_UpdateContactMutationOptions =
	Apollo.BaseMutationOptions<
		UseContacts_UpdateContactMutation,
		UseContacts_UpdateContactMutationVariables
	>;
export const UseContacts_CreateContactAsVendorDocument = gql`
	mutation useContacts_createContactAsVendor(
		$data: CreateContactDataInput!
		$where: UserByEmailUniqueInput!
	) {
		createContactAsVendor(data: $data, where: $where) {
			...useContacts_contact
		}
	}
	${UseContacts_ContactFragmentDoc}
`;
export type UseContacts_CreateContactAsVendorMutationFn =
	Apollo.MutationFunction<
		UseContacts_CreateContactAsVendorMutation,
		UseContacts_CreateContactAsVendorMutationVariables
	>;

/**
 * __useUseContacts_CreateContactAsVendorMutation__
 *
 * To run a mutation, you first call `useUseContacts_CreateContactAsVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseContacts_CreateContactAsVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useContactsCreateContactAsVendorMutation, { data, loading, error }] = useUseContacts_CreateContactAsVendorMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseContacts_CreateContactAsVendorMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseContacts_CreateContactAsVendorMutation,
		UseContacts_CreateContactAsVendorMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseContacts_CreateContactAsVendorMutation,
		UseContacts_CreateContactAsVendorMutationVariables
	>(UseContacts_CreateContactAsVendorDocument, options);
}
export type UseContacts_CreateContactAsVendorMutationHookResult = ReturnType<
	typeof useUseContacts_CreateContactAsVendorMutation
>;
export type UseContacts_CreateContactAsVendorMutationResult =
	Apollo.MutationResult<UseContacts_CreateContactAsVendorMutation>;
export type UseContacts_CreateContactAsVendorMutationOptions =
	Apollo.BaseMutationOptions<
		UseContacts_CreateContactAsVendorMutation,
		UseContacts_CreateContactAsVendorMutationVariables
	>;
export const DocumentOrFolderBreadcrumbs_GetFolderContentsDocument = gql`
	query DocumentOrFolderBreadcrumbs_getFolderContents(
		$where: FolderWhereUniqueInput!
	) {
		getFolderContents(where: $where) {
			id
			name
			parentFolder {
				id
			}
		}
	}
`;

/**
 * __useDocumentOrFolderBreadcrumbs_GetFolderContentsQuery__
 *
 * To run a query within a React component, call `useDocumentOrFolderBreadcrumbs_GetFolderContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentOrFolderBreadcrumbs_GetFolderContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentOrFolderBreadcrumbs_GetFolderContentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentOrFolderBreadcrumbs_GetFolderContentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentOrFolderBreadcrumbs_GetFolderContentsQuery,
		DocumentOrFolderBreadcrumbs_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentOrFolderBreadcrumbs_GetFolderContentsQuery,
		DocumentOrFolderBreadcrumbs_GetFolderContentsQueryVariables
	>(DocumentOrFolderBreadcrumbs_GetFolderContentsDocument, options);
}
export function useDocumentOrFolderBreadcrumbs_GetFolderContentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentOrFolderBreadcrumbs_GetFolderContentsQuery,
		DocumentOrFolderBreadcrumbs_GetFolderContentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentOrFolderBreadcrumbs_GetFolderContentsQuery,
		DocumentOrFolderBreadcrumbs_GetFolderContentsQueryVariables
	>(DocumentOrFolderBreadcrumbs_GetFolderContentsDocument, options);
}
export type DocumentOrFolderBreadcrumbs_GetFolderContentsQueryHookResult =
	ReturnType<typeof useDocumentOrFolderBreadcrumbs_GetFolderContentsQuery>;
export type DocumentOrFolderBreadcrumbs_GetFolderContentsLazyQueryHookResult =
	ReturnType<typeof useDocumentOrFolderBreadcrumbs_GetFolderContentsLazyQuery>;
export type DocumentOrFolderBreadcrumbs_GetFolderContentsQueryResult =
	Apollo.QueryResult<
		DocumentOrFolderBreadcrumbs_GetFolderContentsQuery,
		DocumentOrFolderBreadcrumbs_GetFolderContentsQueryVariables
	>;
export const DocumentOrFolderBreadcrumbs_GetDocumentWhereDocument = gql`
	query DocumentOrFolderBreadcrumbs_getDocumentWhere(
		$where: DocumentWhereUniqueInput!
	) {
		getDocumentWhere(where: $where) {
			id
			name
			parentFolder {
				id
			}
		}
	}
`;

/**
 * __useDocumentOrFolderBreadcrumbs_GetDocumentWhereQuery__
 *
 * To run a query within a React component, call `useDocumentOrFolderBreadcrumbs_GetDocumentWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentOrFolderBreadcrumbs_GetDocumentWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentOrFolderBreadcrumbs_GetDocumentWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentOrFolderBreadcrumbs_GetDocumentWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQuery,
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQuery,
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryVariables
	>(DocumentOrFolderBreadcrumbs_GetDocumentWhereDocument, options);
}
export function useDocumentOrFolderBreadcrumbs_GetDocumentWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQuery,
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQuery,
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryVariables
	>(DocumentOrFolderBreadcrumbs_GetDocumentWhereDocument, options);
}
export type DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryHookResult =
	ReturnType<typeof useDocumentOrFolderBreadcrumbs_GetDocumentWhereQuery>;
export type DocumentOrFolderBreadcrumbs_GetDocumentWhereLazyQueryHookResult =
	ReturnType<typeof useDocumentOrFolderBreadcrumbs_GetDocumentWhereLazyQuery>;
export type DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryResult =
	Apollo.QueryResult<
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQuery,
		DocumentOrFolderBreadcrumbs_GetDocumentWhereQueryVariables
	>;
export const UseExportClientIndex_GetContactsWhereDocument = gql`
	query useExportClientIndex_getContactsWhere(
		$orderBy: [ContactOrderByInput]
		$skip: Int
		$take: Int
		$where: ContactWhereInput!
	) {
		getContactsWhere(
			orderBy: $orderBy
			skip: $skip
			take: $take
			where: $where
		) {
			contacts {
				createdAt
				status
				firstName
				lastName
				eventDate
				note
				venue
				customer {
					id
					email
				}
			}
		}
	}
`;

/**
 * __useUseExportClientIndex_GetContactsWhereQuery__
 *
 * To run a query within a React component, call `useUseExportClientIndex_GetContactsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseExportClientIndex_GetContactsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseExportClientIndex_GetContactsWhereQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseExportClientIndex_GetContactsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		UseExportClientIndex_GetContactsWhereQuery,
		UseExportClientIndex_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseExportClientIndex_GetContactsWhereQuery,
		UseExportClientIndex_GetContactsWhereQueryVariables
	>(UseExportClientIndex_GetContactsWhereDocument, options);
}
export function useUseExportClientIndex_GetContactsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseExportClientIndex_GetContactsWhereQuery,
		UseExportClientIndex_GetContactsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseExportClientIndex_GetContactsWhereQuery,
		UseExportClientIndex_GetContactsWhereQueryVariables
	>(UseExportClientIndex_GetContactsWhereDocument, options);
}
export type UseExportClientIndex_GetContactsWhereQueryHookResult = ReturnType<
	typeof useUseExportClientIndex_GetContactsWhereQuery
>;
export type UseExportClientIndex_GetContactsWhereLazyQueryHookResult =
	ReturnType<typeof useUseExportClientIndex_GetContactsWhereLazyQuery>;
export type UseExportClientIndex_GetContactsWhereQueryResult =
	Apollo.QueryResult<
		UseExportClientIndex_GetContactsWhereQuery,
		UseExportClientIndex_GetContactsWhereQueryVariables
	>;
export const FetchContactSuggestions_GetInquiriesForOrganizationDocument = gql`
	query fetchContactSuggestions_getInquiriesForOrganization(
		$where: InquiriesForOrganizationWhereInput
		$orderBy: [InquiryOrderByInput!]
		$take: Int
	) {
		getInquiriesForOrganization(where: $where, orderBy: $orderBy, take: $take) {
			inquiries {
				...fetchContactSuggestions_GetInquiriesForOrganizationInquiry
			}
		}
	}
	${FetchContactSuggestions_GetInquiriesForOrganizationInquiryFragmentDoc}
`;

/**
 * __useFetchContactSuggestions_GetInquiriesForOrganizationQuery__
 *
 * To run a query within a React component, call `useFetchContactSuggestions_GetInquiriesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContactSuggestions_GetInquiriesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContactSuggestions_GetInquiriesForOrganizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useFetchContactSuggestions_GetInquiriesForOrganizationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		FetchContactSuggestions_GetInquiriesForOrganizationQuery,
		FetchContactSuggestions_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		FetchContactSuggestions_GetInquiriesForOrganizationQuery,
		FetchContactSuggestions_GetInquiriesForOrganizationQueryVariables
	>(FetchContactSuggestions_GetInquiriesForOrganizationDocument, options);
}
export function useFetchContactSuggestions_GetInquiriesForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FetchContactSuggestions_GetInquiriesForOrganizationQuery,
		FetchContactSuggestions_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		FetchContactSuggestions_GetInquiriesForOrganizationQuery,
		FetchContactSuggestions_GetInquiriesForOrganizationQueryVariables
	>(FetchContactSuggestions_GetInquiriesForOrganizationDocument, options);
}
export type FetchContactSuggestions_GetInquiriesForOrganizationQueryHookResult =
	ReturnType<
		typeof useFetchContactSuggestions_GetInquiriesForOrganizationQuery
	>;
export type FetchContactSuggestions_GetInquiriesForOrganizationLazyQueryHookResult =
	ReturnType<
		typeof useFetchContactSuggestions_GetInquiriesForOrganizationLazyQuery
	>;
export type FetchContactSuggestions_GetInquiriesForOrganizationQueryResult =
	Apollo.QueryResult<
		FetchContactSuggestions_GetInquiriesForOrganizationQuery,
		FetchContactSuggestions_GetInquiriesForOrganizationQueryVariables
	>;
export const UseLeads_GetInquiriesForOrganizationDocument = gql`
	query useLeads_getInquiriesForOrganization {
		getInquiriesForOrganization {
			inquiries {
				...useLeadsInquiry
			}
		}
	}
	${UseLeadsInquiryFragmentDoc}
`;

/**
 * __useUseLeads_GetInquiriesForOrganizationQuery__
 *
 * To run a query within a React component, call `useUseLeads_GetInquiriesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLeads_GetInquiriesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLeads_GetInquiriesForOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseLeads_GetInquiriesForOrganizationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UseLeads_GetInquiriesForOrganizationQuery,
		UseLeads_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		UseLeads_GetInquiriesForOrganizationQuery,
		UseLeads_GetInquiriesForOrganizationQueryVariables
	>(UseLeads_GetInquiriesForOrganizationDocument, options);
}
export function useUseLeads_GetInquiriesForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UseLeads_GetInquiriesForOrganizationQuery,
		UseLeads_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UseLeads_GetInquiriesForOrganizationQuery,
		UseLeads_GetInquiriesForOrganizationQueryVariables
	>(UseLeads_GetInquiriesForOrganizationDocument, options);
}
export type UseLeads_GetInquiriesForOrganizationQueryHookResult = ReturnType<
	typeof useUseLeads_GetInquiriesForOrganizationQuery
>;
export type UseLeads_GetInquiriesForOrganizationLazyQueryHookResult =
	ReturnType<typeof useUseLeads_GetInquiriesForOrganizationLazyQuery>;
export type UseLeads_GetInquiriesForOrganizationQueryResult =
	Apollo.QueryResult<
		UseLeads_GetInquiriesForOrganizationQuery,
		UseLeads_GetInquiriesForOrganizationQueryVariables
	>;
export const UseLeads_CreateInquiryDocument = gql`
	mutation useLeads_createInquiry($data: InquiryCreateInput!) {
		createInquiry(data: $data) {
			organization {
				id
				contacts {
					...useLeadsContact
				}
			}
			...leadCreateOrViewModalFormInquiry
		}
	}
	${UseLeadsContactFragmentDoc}
	${LeadCreateOrViewModalFormInquiryFragmentDoc}
`;
export type UseLeads_CreateInquiryMutationFn = Apollo.MutationFunction<
	UseLeads_CreateInquiryMutation,
	UseLeads_CreateInquiryMutationVariables
>;

/**
 * __useUseLeads_CreateInquiryMutation__
 *
 * To run a mutation, you first call `useUseLeads_CreateInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLeads_CreateInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLeadsCreateInquiryMutation, { data, loading, error }] = useUseLeads_CreateInquiryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseLeads_CreateInquiryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseLeads_CreateInquiryMutation,
		UseLeads_CreateInquiryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseLeads_CreateInquiryMutation,
		UseLeads_CreateInquiryMutationVariables
	>(UseLeads_CreateInquiryDocument, options);
}
export type UseLeads_CreateInquiryMutationHookResult = ReturnType<
	typeof useUseLeads_CreateInquiryMutation
>;
export type UseLeads_CreateInquiryMutationResult =
	Apollo.MutationResult<UseLeads_CreateInquiryMutation>;
export type UseLeads_CreateInquiryMutationOptions = Apollo.BaseMutationOptions<
	UseLeads_CreateInquiryMutation,
	UseLeads_CreateInquiryMutationVariables
>;
export const UseLeads_UpdateContactDocument = gql`
	mutation useLeads_updateContact(
		$where: ContactWhereUniqueInput!
		$data: CustomContactUpdateInput!
	) {
		updateContact(where: $where, data: $data) {
			...useLeadsContact
		}
	}
	${UseLeadsContactFragmentDoc}
`;
export type UseLeads_UpdateContactMutationFn = Apollo.MutationFunction<
	UseLeads_UpdateContactMutation,
	UseLeads_UpdateContactMutationVariables
>;

/**
 * __useUseLeads_UpdateContactMutation__
 *
 * To run a mutation, you first call `useUseLeads_UpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLeads_UpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLeadsUpdateContactMutation, { data, loading, error }] = useUseLeads_UpdateContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseLeads_UpdateContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseLeads_UpdateContactMutation,
		UseLeads_UpdateContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseLeads_UpdateContactMutation,
		UseLeads_UpdateContactMutationVariables
	>(UseLeads_UpdateContactDocument, options);
}
export type UseLeads_UpdateContactMutationHookResult = ReturnType<
	typeof useUseLeads_UpdateContactMutation
>;
export type UseLeads_UpdateContactMutationResult =
	Apollo.MutationResult<UseLeads_UpdateContactMutation>;
export type UseLeads_UpdateContactMutationOptions = Apollo.BaseMutationOptions<
	UseLeads_UpdateContactMutation,
	UseLeads_UpdateContactMutationVariables
>;
export const UseLeads_UpdateInquiryDocument = gql`
	mutation useLeads_updateInquiry(
		$data: InquiryUpdateDataInput!
		$where: InquiryWhereUniqueInput!
	) {
		updateInquiry(data: $data, where: $where) {
			...leadCreateOrViewModalFormInquiry
		}
	}
	${LeadCreateOrViewModalFormInquiryFragmentDoc}
`;
export type UseLeads_UpdateInquiryMutationFn = Apollo.MutationFunction<
	UseLeads_UpdateInquiryMutation,
	UseLeads_UpdateInquiryMutationVariables
>;

/**
 * __useUseLeads_UpdateInquiryMutation__
 *
 * To run a mutation, you first call `useUseLeads_UpdateInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLeads_UpdateInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLeadsUpdateInquiryMutation, { data, loading, error }] = useUseLeads_UpdateInquiryMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseLeads_UpdateInquiryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseLeads_UpdateInquiryMutation,
		UseLeads_UpdateInquiryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseLeads_UpdateInquiryMutation,
		UseLeads_UpdateInquiryMutationVariables
	>(UseLeads_UpdateInquiryDocument, options);
}
export type UseLeads_UpdateInquiryMutationHookResult = ReturnType<
	typeof useUseLeads_UpdateInquiryMutation
>;
export type UseLeads_UpdateInquiryMutationResult =
	Apollo.MutationResult<UseLeads_UpdateInquiryMutation>;
export type UseLeads_UpdateInquiryMutationOptions = Apollo.BaseMutationOptions<
	UseLeads_UpdateInquiryMutation,
	UseLeads_UpdateInquiryMutationVariables
>;
export const UseLeads_ConvertInquiryDocument = gql`
	mutation useLeads_convertInquiry($where: InquiryWhereUniqueInput!) {
		convertInquiry(where: $where) {
			contact {
				...useLeadsContact
			}
			...leadCreateOrViewModalFormInquiry
		}
	}
	${UseLeadsContactFragmentDoc}
	${LeadCreateOrViewModalFormInquiryFragmentDoc}
`;
export type UseLeads_ConvertInquiryMutationFn = Apollo.MutationFunction<
	UseLeads_ConvertInquiryMutation,
	UseLeads_ConvertInquiryMutationVariables
>;

/**
 * __useUseLeads_ConvertInquiryMutation__
 *
 * To run a mutation, you first call `useUseLeads_ConvertInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLeads_ConvertInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLeadsConvertInquiryMutation, { data, loading, error }] = useUseLeads_ConvertInquiryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseLeads_ConvertInquiryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseLeads_ConvertInquiryMutation,
		UseLeads_ConvertInquiryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseLeads_ConvertInquiryMutation,
		UseLeads_ConvertInquiryMutationVariables
	>(UseLeads_ConvertInquiryDocument, options);
}
export type UseLeads_ConvertInquiryMutationHookResult = ReturnType<
	typeof useUseLeads_ConvertInquiryMutation
>;
export type UseLeads_ConvertInquiryMutationResult =
	Apollo.MutationResult<UseLeads_ConvertInquiryMutation>;
export type UseLeads_ConvertInquiryMutationOptions = Apollo.BaseMutationOptions<
	UseLeads_ConvertInquiryMutation,
	UseLeads_ConvertInquiryMutationVariables
>;
export const UseLeads_MergeInquiryIntoContactDocument = gql`
	mutation useLeads_mergeInquiryIntoContact($where: InquiryMergeInput!) {
		mergeInquiryIntoContact(where: $where) {
			id
			eventDate
			customer {
				id
				email
			}
		}
	}
`;
export type UseLeads_MergeInquiryIntoContactMutationFn =
	Apollo.MutationFunction<
		UseLeads_MergeInquiryIntoContactMutation,
		UseLeads_MergeInquiryIntoContactMutationVariables
	>;

/**
 * __useUseLeads_MergeInquiryIntoContactMutation__
 *
 * To run a mutation, you first call `useUseLeads_MergeInquiryIntoContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLeads_MergeInquiryIntoContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLeadsMergeInquiryIntoContactMutation, { data, loading, error }] = useUseLeads_MergeInquiryIntoContactMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUseLeads_MergeInquiryIntoContactMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UseLeads_MergeInquiryIntoContactMutation,
		UseLeads_MergeInquiryIntoContactMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UseLeads_MergeInquiryIntoContactMutation,
		UseLeads_MergeInquiryIntoContactMutationVariables
	>(UseLeads_MergeInquiryIntoContactDocument, options);
}
export type UseLeads_MergeInquiryIntoContactMutationHookResult = ReturnType<
	typeof useUseLeads_MergeInquiryIntoContactMutation
>;
export type UseLeads_MergeInquiryIntoContactMutationResult =
	Apollo.MutationResult<UseLeads_MergeInquiryIntoContactMutation>;
export type UseLeads_MergeInquiryIntoContactMutationOptions =
	Apollo.BaseMutationOptions<
		UseLeads_MergeInquiryIntoContactMutation,
		UseLeads_MergeInquiryIntoContactMutationVariables
	>;
export const NewEventsSubscription_GetAuthedUserDocument = gql`
	query newEventsSubscription_GetAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			id
			userType
			eventsLastViewedAt
		}
	}
`;

/**
 * __useNewEventsSubscription_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useNewEventsSubscription_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewEventsSubscription_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewEventsSubscription_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNewEventsSubscription_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		NewEventsSubscription_GetAuthedUserQuery,
		NewEventsSubscription_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		NewEventsSubscription_GetAuthedUserQuery,
		NewEventsSubscription_GetAuthedUserQueryVariables
	>(NewEventsSubscription_GetAuthedUserDocument, options);
}
export function useNewEventsSubscription_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		NewEventsSubscription_GetAuthedUserQuery,
		NewEventsSubscription_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		NewEventsSubscription_GetAuthedUserQuery,
		NewEventsSubscription_GetAuthedUserQueryVariables
	>(NewEventsSubscription_GetAuthedUserDocument, options);
}
export type NewEventsSubscription_GetAuthedUserQueryHookResult = ReturnType<
	typeof useNewEventsSubscription_GetAuthedUserQuery
>;
export type NewEventsSubscription_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useNewEventsSubscription_GetAuthedUserLazyQuery
>;
export type NewEventsSubscription_GetAuthedUserQueryResult = Apollo.QueryResult<
	NewEventsSubscription_GetAuthedUserQuery,
	NewEventsSubscription_GetAuthedUserQueryVariables
>;
export const NewEventsSubscription_UpdateSelfDocument = gql`
	mutation newEventsSubscription_UpdateSelf($data: UserUpdateSelfInput!) {
		updateSelf(data: $data) {
			id
			eventsLastViewedAt
		}
	}
`;
export type NewEventsSubscription_UpdateSelfMutationFn =
	Apollo.MutationFunction<
		NewEventsSubscription_UpdateSelfMutation,
		NewEventsSubscription_UpdateSelfMutationVariables
	>;

/**
 * __useNewEventsSubscription_UpdateSelfMutation__
 *
 * To run a mutation, you first call `useNewEventsSubscription_UpdateSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewEventsSubscription_UpdateSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newEventsSubscriptionUpdateSelfMutation, { data, loading, error }] = useNewEventsSubscription_UpdateSelfMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNewEventsSubscription_UpdateSelfMutation(
	baseOptions?: Apollo.MutationHookOptions<
		NewEventsSubscription_UpdateSelfMutation,
		NewEventsSubscription_UpdateSelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		NewEventsSubscription_UpdateSelfMutation,
		NewEventsSubscription_UpdateSelfMutationVariables
	>(NewEventsSubscription_UpdateSelfDocument, options);
}
export type NewEventsSubscription_UpdateSelfMutationHookResult = ReturnType<
	typeof useNewEventsSubscription_UpdateSelfMutation
>;
export type NewEventsSubscription_UpdateSelfMutationResult =
	Apollo.MutationResult<NewEventsSubscription_UpdateSelfMutation>;
export type NewEventsSubscription_UpdateSelfMutationOptions =
	Apollo.BaseMutationOptions<
		NewEventsSubscription_UpdateSelfMutation,
		NewEventsSubscription_UpdateSelfMutationVariables
	>;
export const NewEventsSubscription_GetEventsWhereDocument = gql`
	query newEventsSubscription_GetEventsWhere($where: EventWhereInput!) {
		getEventsWhere(where: $where) {
			id
			category
			createdAt
			consumingUsers {
				id
			}
			dismissingUsers {
				id
			}
		}
	}
`;

/**
 * __useNewEventsSubscription_GetEventsWhereQuery__
 *
 * To run a query within a React component, call `useNewEventsSubscription_GetEventsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewEventsSubscription_GetEventsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewEventsSubscription_GetEventsWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNewEventsSubscription_GetEventsWhereQuery(
	baseOptions: Apollo.QueryHookOptions<
		NewEventsSubscription_GetEventsWhereQuery,
		NewEventsSubscription_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		NewEventsSubscription_GetEventsWhereQuery,
		NewEventsSubscription_GetEventsWhereQueryVariables
	>(NewEventsSubscription_GetEventsWhereDocument, options);
}
export function useNewEventsSubscription_GetEventsWhereLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		NewEventsSubscription_GetEventsWhereQuery,
		NewEventsSubscription_GetEventsWhereQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		NewEventsSubscription_GetEventsWhereQuery,
		NewEventsSubscription_GetEventsWhereQueryVariables
	>(NewEventsSubscription_GetEventsWhereDocument, options);
}
export type NewEventsSubscription_GetEventsWhereQueryHookResult = ReturnType<
	typeof useNewEventsSubscription_GetEventsWhereQuery
>;
export type NewEventsSubscription_GetEventsWhereLazyQueryHookResult =
	ReturnType<typeof useNewEventsSubscription_GetEventsWhereLazyQuery>;
export type NewEventsSubscription_GetEventsWhereQueryResult =
	Apollo.QueryResult<
		NewEventsSubscription_GetEventsWhereQuery,
		NewEventsSubscription_GetEventsWhereQueryVariables
	>;
export const NewEventsSubscription_EventCreatedDocument = gql`
	subscription newEventsSubscription_EventCreated {
		eventCreated {
			id
			invoice {
				...invoiceDetailInvoice
			}
		}
	}
	${InvoiceDetailInvoiceFragmentDoc}
`;

/**
 * __useNewEventsSubscription_EventCreatedSubscription__
 *
 * To run a query within a React component, call `useNewEventsSubscription_EventCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewEventsSubscription_EventCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewEventsSubscription_EventCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewEventsSubscription_EventCreatedSubscription(
	baseOptions?: Apollo.SubscriptionHookOptions<
		NewEventsSubscription_EventCreatedSubscription,
		NewEventsSubscription_EventCreatedSubscriptionVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		NewEventsSubscription_EventCreatedSubscription,
		NewEventsSubscription_EventCreatedSubscriptionVariables
	>(NewEventsSubscription_EventCreatedDocument, options);
}
export type NewEventsSubscription_EventCreatedSubscriptionHookResult =
	ReturnType<typeof useNewEventsSubscription_EventCreatedSubscription>;
export type NewEventsSubscription_EventCreatedSubscriptionResult =
	Apollo.SubscriptionResult<NewEventsSubscription_EventCreatedSubscription>;
export const NewLeadsSubscription_GetInquiriesForOrganizationDocument = gql`
	query newLeadsSubscription_GetInquiriesForOrganization(
		$where: InquiriesForOrganizationWhereInput
	) {
		getInquiriesForOrganization(where: $where) {
			_count
		}
	}
`;

/**
 * __useNewLeadsSubscription_GetInquiriesForOrganizationQuery__
 *
 * To run a query within a React component, call `useNewLeadsSubscription_GetInquiriesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewLeadsSubscription_GetInquiriesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewLeadsSubscription_GetInquiriesForOrganizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNewLeadsSubscription_GetInquiriesForOrganizationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		NewLeadsSubscription_GetInquiriesForOrganizationQuery,
		NewLeadsSubscription_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		NewLeadsSubscription_GetInquiriesForOrganizationQuery,
		NewLeadsSubscription_GetInquiriesForOrganizationQueryVariables
	>(NewLeadsSubscription_GetInquiriesForOrganizationDocument, options);
}
export function useNewLeadsSubscription_GetInquiriesForOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		NewLeadsSubscription_GetInquiriesForOrganizationQuery,
		NewLeadsSubscription_GetInquiriesForOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		NewLeadsSubscription_GetInquiriesForOrganizationQuery,
		NewLeadsSubscription_GetInquiriesForOrganizationQueryVariables
	>(NewLeadsSubscription_GetInquiriesForOrganizationDocument, options);
}
export type NewLeadsSubscription_GetInquiriesForOrganizationQueryHookResult =
	ReturnType<typeof useNewLeadsSubscription_GetInquiriesForOrganizationQuery>;
export type NewLeadsSubscription_GetInquiriesForOrganizationLazyQueryHookResult =
	ReturnType<
		typeof useNewLeadsSubscription_GetInquiriesForOrganizationLazyQuery
	>;
export type NewLeadsSubscription_GetInquiriesForOrganizationQueryResult =
	Apollo.QueryResult<
		NewLeadsSubscription_GetInquiriesForOrganizationQuery,
		NewLeadsSubscription_GetInquiriesForOrganizationQueryVariables
	>;
export const NewLeadsSubscription_InquiryChangedDocument = gql`
	subscription newLeadsSubscription_InquiryChanged {
		inquiryChanged {
			id
			organization {
				id
				inquiries {
					id
					status
				}
			}
		}
	}
`;

/**
 * __useNewLeadsSubscription_InquiryChangedSubscription__
 *
 * To run a query within a React component, call `useNewLeadsSubscription_InquiryChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewLeadsSubscription_InquiryChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewLeadsSubscription_InquiryChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewLeadsSubscription_InquiryChangedSubscription(
	baseOptions?: Apollo.SubscriptionHookOptions<
		NewLeadsSubscription_InquiryChangedSubscription,
		NewLeadsSubscription_InquiryChangedSubscriptionVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		NewLeadsSubscription_InquiryChangedSubscription,
		NewLeadsSubscription_InquiryChangedSubscriptionVariables
	>(NewLeadsSubscription_InquiryChangedDocument, options);
}
export type NewLeadsSubscription_InquiryChangedSubscriptionHookResult =
	ReturnType<typeof useNewLeadsSubscription_InquiryChangedSubscription>;
export type NewLeadsSubscription_InquiryChangedSubscriptionResult =
	Apollo.SubscriptionResult<NewLeadsSubscription_InquiryChangedSubscription>;
export const OrgOnboardingModal_GetOrgUserDocument = gql`
	query orgOnboardingModal_GetOrgUser($where: OrgUserWhereUniqueInput!) {
		getOrgUserWhere(where: $where) {
			id
			user {
				id
				seenOnboardingModalAt
			}
			organization {
				id
				users {
					id
					role
				}
			}
		}
	}
`;

/**
 * __useOrgOnboardingModal_GetOrgUserQuery__
 *
 * To run a query within a React component, call `useOrgOnboardingModal_GetOrgUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboardingModal_GetOrgUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOnboardingModal_GetOrgUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrgOnboardingModal_GetOrgUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		OrgOnboardingModal_GetOrgUserQuery,
		OrgOnboardingModal_GetOrgUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OrgOnboardingModal_GetOrgUserQuery,
		OrgOnboardingModal_GetOrgUserQueryVariables
	>(OrgOnboardingModal_GetOrgUserDocument, options);
}
export function useOrgOnboardingModal_GetOrgUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OrgOnboardingModal_GetOrgUserQuery,
		OrgOnboardingModal_GetOrgUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OrgOnboardingModal_GetOrgUserQuery,
		OrgOnboardingModal_GetOrgUserQueryVariables
	>(OrgOnboardingModal_GetOrgUserDocument, options);
}
export type OrgOnboardingModal_GetOrgUserQueryHookResult = ReturnType<
	typeof useOrgOnboardingModal_GetOrgUserQuery
>;
export type OrgOnboardingModal_GetOrgUserLazyQueryHookResult = ReturnType<
	typeof useOrgOnboardingModal_GetOrgUserLazyQuery
>;
export type OrgOnboardingModal_GetOrgUserQueryResult = Apollo.QueryResult<
	OrgOnboardingModal_GetOrgUserQuery,
	OrgOnboardingModal_GetOrgUserQueryVariables
>;
export const OrgOnboardingModal_UpdateSelfDocument = gql`
	mutation orgOnboardingModal_UpdateSelf($data: UserUpdateSelfInput!) {
		updateSelf(data: $data) {
			id
			seenOnboardingModalAt
		}
	}
`;
export type OrgOnboardingModal_UpdateSelfMutationFn = Apollo.MutationFunction<
	OrgOnboardingModal_UpdateSelfMutation,
	OrgOnboardingModal_UpdateSelfMutationVariables
>;

/**
 * __useOrgOnboardingModal_UpdateSelfMutation__
 *
 * To run a mutation, you first call `useOrgOnboardingModal_UpdateSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOnboardingModal_UpdateSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOnboardingModalUpdateSelfMutation, { data, loading, error }] = useOrgOnboardingModal_UpdateSelfMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOrgOnboardingModal_UpdateSelfMutation(
	baseOptions?: Apollo.MutationHookOptions<
		OrgOnboardingModal_UpdateSelfMutation,
		OrgOnboardingModal_UpdateSelfMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		OrgOnboardingModal_UpdateSelfMutation,
		OrgOnboardingModal_UpdateSelfMutationVariables
	>(OrgOnboardingModal_UpdateSelfDocument, options);
}
export type OrgOnboardingModal_UpdateSelfMutationHookResult = ReturnType<
	typeof useOrgOnboardingModal_UpdateSelfMutation
>;
export type OrgOnboardingModal_UpdateSelfMutationResult =
	Apollo.MutationResult<OrgOnboardingModal_UpdateSelfMutation>;
export type OrgOnboardingModal_UpdateSelfMutationOptions =
	Apollo.BaseMutationOptions<
		OrgOnboardingModal_UpdateSelfMutation,
		OrgOnboardingModal_UpdateSelfMutationVariables
	>;
export const GetAuthedUserForRedux_GetAuthedUserDocument = gql`
	query getAuthedUserForRedux_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			...getAuthedUserFlattenedUserFields
		}
	}
	${GetAuthedUserFlattenedUserFieldsFragmentDoc}
`;

/**
 * __useGetAuthedUserForRedux_GetAuthedUserQuery__
 *
 * To run a query within a React component, call `useGetAuthedUserForRedux_GetAuthedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthedUserForRedux_GetAuthedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthedUserForRedux_GetAuthedUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAuthedUserForRedux_GetAuthedUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAuthedUserForRedux_GetAuthedUserQuery,
		GetAuthedUserForRedux_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAuthedUserForRedux_GetAuthedUserQuery,
		GetAuthedUserForRedux_GetAuthedUserQueryVariables
	>(GetAuthedUserForRedux_GetAuthedUserDocument, options);
}
export function useGetAuthedUserForRedux_GetAuthedUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAuthedUserForRedux_GetAuthedUserQuery,
		GetAuthedUserForRedux_GetAuthedUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAuthedUserForRedux_GetAuthedUserQuery,
		GetAuthedUserForRedux_GetAuthedUserQueryVariables
	>(GetAuthedUserForRedux_GetAuthedUserDocument, options);
}
export type GetAuthedUserForRedux_GetAuthedUserQueryHookResult = ReturnType<
	typeof useGetAuthedUserForRedux_GetAuthedUserQuery
>;
export type GetAuthedUserForRedux_GetAuthedUserLazyQueryHookResult = ReturnType<
	typeof useGetAuthedUserForRedux_GetAuthedUserLazyQuery
>;
export type GetAuthedUserForRedux_GetAuthedUserQueryResult = Apollo.QueryResult<
	GetAuthedUserForRedux_GetAuthedUserQuery,
	GetAuthedUserForRedux_GetAuthedUserQueryVariables
>;
export const HelpButton_GetGlobalVariablesDocument = gql`
	query HelpButton_getGlobalVariables {
		getGlobalVariables {
			HelpUrl
		}
	}
`;

/**
 * __useHelpButton_GetGlobalVariablesQuery__
 *
 * To run a query within a React component, call `useHelpButton_GetGlobalVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpButton_GetGlobalVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpButton_GetGlobalVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelpButton_GetGlobalVariablesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		HelpButton_GetGlobalVariablesQuery,
		HelpButton_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		HelpButton_GetGlobalVariablesQuery,
		HelpButton_GetGlobalVariablesQueryVariables
	>(HelpButton_GetGlobalVariablesDocument, options);
}
export function useHelpButton_GetGlobalVariablesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		HelpButton_GetGlobalVariablesQuery,
		HelpButton_GetGlobalVariablesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		HelpButton_GetGlobalVariablesQuery,
		HelpButton_GetGlobalVariablesQueryVariables
	>(HelpButton_GetGlobalVariablesDocument, options);
}
export type HelpButton_GetGlobalVariablesQueryHookResult = ReturnType<
	typeof useHelpButton_GetGlobalVariablesQuery
>;
export type HelpButton_GetGlobalVariablesLazyQueryHookResult = ReturnType<
	typeof useHelpButton_GetGlobalVariablesLazyQuery
>;
export type HelpButton_GetGlobalVariablesQueryResult = Apollo.QueryResult<
	HelpButton_GetGlobalVariablesQuery,
	HelpButton_GetGlobalVariablesQueryVariables
>;
export const MuiStripeVerificationModal_GetConnectOnboardingUrlDocument = gql`
	query muiStripeVerificationModal_getConnectOnboardingUrl(
		$data: StripeOnboardingInput!
	) {
		getConnectOnboardingUrl(data: $data) {
			url
		}
	}
`;

/**
 * __useMuiStripeVerificationModal_GetConnectOnboardingUrlQuery__
 *
 * To run a query within a React component, call `useMuiStripeVerificationModal_GetConnectOnboardingUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMuiStripeVerificationModal_GetConnectOnboardingUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMuiStripeVerificationModal_GetConnectOnboardingUrlQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMuiStripeVerificationModal_GetConnectOnboardingUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		MuiStripeVerificationModal_GetConnectOnboardingUrlQuery,
		MuiStripeVerificationModal_GetConnectOnboardingUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MuiStripeVerificationModal_GetConnectOnboardingUrlQuery,
		MuiStripeVerificationModal_GetConnectOnboardingUrlQueryVariables
	>(MuiStripeVerificationModal_GetConnectOnboardingUrlDocument, options);
}
export function useMuiStripeVerificationModal_GetConnectOnboardingUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MuiStripeVerificationModal_GetConnectOnboardingUrlQuery,
		MuiStripeVerificationModal_GetConnectOnboardingUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MuiStripeVerificationModal_GetConnectOnboardingUrlQuery,
		MuiStripeVerificationModal_GetConnectOnboardingUrlQueryVariables
	>(MuiStripeVerificationModal_GetConnectOnboardingUrlDocument, options);
}
export type MuiStripeVerificationModal_GetConnectOnboardingUrlQueryHookResult =
	ReturnType<typeof useMuiStripeVerificationModal_GetConnectOnboardingUrlQuery>;
export type MuiStripeVerificationModal_GetConnectOnboardingUrlLazyQueryHookResult =
	ReturnType<
		typeof useMuiStripeVerificationModal_GetConnectOnboardingUrlLazyQuery
	>;
export type MuiStripeVerificationModal_GetConnectOnboardingUrlQueryResult =
	Apollo.QueryResult<
		MuiStripeVerificationModal_GetConnectOnboardingUrlQuery,
		MuiStripeVerificationModal_GetConnectOnboardingUrlQueryVariables
	>;
export const PaymentElementContainer_GetStripePaymentCapabilitiesDocument = gql`
	query paymentElementContainer_GetStripePaymentCapabilities(
		$where: OrganizationWhereUniqueInput!
	) {
		getStripePaymentCapabilities(where: $where) {
			card_payments
			acss_debit_payments
		}
	}
`;

/**
 * __usePaymentElementContainer_GetStripePaymentCapabilitiesQuery__
 *
 * To run a query within a React component, call `usePaymentElementContainer_GetStripePaymentCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentElementContainer_GetStripePaymentCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentElementContainer_GetStripePaymentCapabilitiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePaymentElementContainer_GetStripePaymentCapabilitiesQuery(
	baseOptions: Apollo.QueryHookOptions<
		PaymentElementContainer_GetStripePaymentCapabilitiesQuery,
		PaymentElementContainer_GetStripePaymentCapabilitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PaymentElementContainer_GetStripePaymentCapabilitiesQuery,
		PaymentElementContainer_GetStripePaymentCapabilitiesQueryVariables
	>(PaymentElementContainer_GetStripePaymentCapabilitiesDocument, options);
}
export function usePaymentElementContainer_GetStripePaymentCapabilitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PaymentElementContainer_GetStripePaymentCapabilitiesQuery,
		PaymentElementContainer_GetStripePaymentCapabilitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PaymentElementContainer_GetStripePaymentCapabilitiesQuery,
		PaymentElementContainer_GetStripePaymentCapabilitiesQueryVariables
	>(PaymentElementContainer_GetStripePaymentCapabilitiesDocument, options);
}
export type PaymentElementContainer_GetStripePaymentCapabilitiesQueryHookResult =
	ReturnType<
		typeof usePaymentElementContainer_GetStripePaymentCapabilitiesQuery
	>;
export type PaymentElementContainer_GetStripePaymentCapabilitiesLazyQueryHookResult =
	ReturnType<
		typeof usePaymentElementContainer_GetStripePaymentCapabilitiesLazyQuery
	>;
export type PaymentElementContainer_GetStripePaymentCapabilitiesQueryResult =
	Apollo.QueryResult<
		PaymentElementContainer_GetStripePaymentCapabilitiesQuery,
		PaymentElementContainer_GetStripePaymentCapabilitiesQueryVariables
	>;
export const PaymentElementContainer_ValidatePaymentDocument = gql`
	query paymentElementContainer_validatePayment(
		$where: ValidatePaymentInstallmentsInput!
	) {
		validatePayment(where: $where) {
			id
			status
		}
	}
`;

/**
 * __usePaymentElementContainer_ValidatePaymentQuery__
 *
 * To run a query within a React component, call `usePaymentElementContainer_ValidatePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentElementContainer_ValidatePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentElementContainer_ValidatePaymentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePaymentElementContainer_ValidatePaymentQuery(
	baseOptions: Apollo.QueryHookOptions<
		PaymentElementContainer_ValidatePaymentQuery,
		PaymentElementContainer_ValidatePaymentQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PaymentElementContainer_ValidatePaymentQuery,
		PaymentElementContainer_ValidatePaymentQueryVariables
	>(PaymentElementContainer_ValidatePaymentDocument, options);
}
export function usePaymentElementContainer_ValidatePaymentLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PaymentElementContainer_ValidatePaymentQuery,
		PaymentElementContainer_ValidatePaymentQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PaymentElementContainer_ValidatePaymentQuery,
		PaymentElementContainer_ValidatePaymentQueryVariables
	>(PaymentElementContainer_ValidatePaymentDocument, options);
}
export type PaymentElementContainer_ValidatePaymentQueryHookResult = ReturnType<
	typeof usePaymentElementContainer_ValidatePaymentQuery
>;
export type PaymentElementContainer_ValidatePaymentLazyQueryHookResult =
	ReturnType<typeof usePaymentElementContainer_ValidatePaymentLazyQuery>;
export type PaymentElementContainer_ValidatePaymentQueryResult =
	Apollo.QueryResult<
		PaymentElementContainer_ValidatePaymentQuery,
		PaymentElementContainer_ValidatePaymentQueryVariables
	>;
export const MuiSourceSelect_GetPaymentSourcesForCustomersDocument = gql`
	query muiSourceSelect_GetPaymentSourcesForCustomers(
		$where: UserByIdUniqueInput!
	) {
		getPaymentSourcesForCustomer(where: $where) {
			data {
				id
				bank_name
				object
				last4
				brand
				metadata {
					key
					value
				}
			}
			default_source
		}
	}
`;

/**
 * __useMuiSourceSelect_GetPaymentSourcesForCustomersQuery__
 *
 * To run a query within a React component, call `useMuiSourceSelect_GetPaymentSourcesForCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMuiSourceSelect_GetPaymentSourcesForCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMuiSourceSelect_GetPaymentSourcesForCustomersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMuiSourceSelect_GetPaymentSourcesForCustomersQuery(
	baseOptions: Apollo.QueryHookOptions<
		MuiSourceSelect_GetPaymentSourcesForCustomersQuery,
		MuiSourceSelect_GetPaymentSourcesForCustomersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MuiSourceSelect_GetPaymentSourcesForCustomersQuery,
		MuiSourceSelect_GetPaymentSourcesForCustomersQueryVariables
	>(MuiSourceSelect_GetPaymentSourcesForCustomersDocument, options);
}
export function useMuiSourceSelect_GetPaymentSourcesForCustomersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MuiSourceSelect_GetPaymentSourcesForCustomersQuery,
		MuiSourceSelect_GetPaymentSourcesForCustomersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MuiSourceSelect_GetPaymentSourcesForCustomersQuery,
		MuiSourceSelect_GetPaymentSourcesForCustomersQueryVariables
	>(MuiSourceSelect_GetPaymentSourcesForCustomersDocument, options);
}
export type MuiSourceSelect_GetPaymentSourcesForCustomersQueryHookResult =
	ReturnType<typeof useMuiSourceSelect_GetPaymentSourcesForCustomersQuery>;
export type MuiSourceSelect_GetPaymentSourcesForCustomersLazyQueryHookResult =
	ReturnType<typeof useMuiSourceSelect_GetPaymentSourcesForCustomersLazyQuery>;
export type MuiSourceSelect_GetPaymentSourcesForCustomersQueryResult =
	Apollo.QueryResult<
		MuiSourceSelect_GetPaymentSourcesForCustomersQuery,
		MuiSourceSelect_GetPaymentSourcesForCustomersQueryVariables
	>;

export interface PossibleTypesResultData {
	possibleTypes: {
		[key: string]: string[];
	};
}
const result: PossibleTypesResultData = {
	possibleTypes: {
		InviteUser: ['InviteUserClientUser', 'InviteUserOrgUser'],
		InvoiceOrStripeUser: ['Invoice', 'StripeUser'],
		SourceOrRedirect: ['RedirectUrl', 'Source'],
		SubscriptionObjectOrRedirect: ['RedirectUrl', 'SubscriptionObject'],
	},
};
export default result;
